/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"cc314ba9"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 453);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(485);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(505)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedDate; });
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(507);
/*
 * Copyright 2018, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(2);
var localizedStrings=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({ABOUT:{id:'ABOUT',defaultMessage:'About'},ABOUT_API_TAB:{id:'ABOUT_API_TAB',defaultMessage:'API'},ABOUT_VERSION:{id:'ABOUT_VERSION',defaultMessage:'Version'},ABOUT_EXTENSIS_URL:{id:'ABOUT_EXTENSIS_URL',defaultMessage:'www.portfoliodam.com'},ABOUT_PORTFOLIO_SERVER:{id:'ABOUT_PORTFOLIO_SERVER',defaultMessage:'Portfolio Server'},ABOUT_PORTFOLIO_VERSION:{id:'ABOUT_PORTFOLIO_VERSION',defaultMessage:'Version 9.0'},ABOUT_SERVER_TAB:{id:'ABOUT_SERVER_TAB',defaultMessage:'Server'},accessOriginals:{id:'accessOriginals',defaultMessage:'Access and Process Originals'},ACCOUNT_TYPE:{id:'ACCOUNT_TYPE',defaultMessage:'Authentication'},ACCOUNT_TYPE_LDAP:{id:'ACCOUNT_TYPE_LDAP',defaultMessage:'Directory Service'},ACCOUNT_TYPE_MANUAL:{id:'ACCOUNT_TYPE_MANUAL',defaultMessage:'Native (Built-in)'},ACTIVE_DIRECTORY:{id:'ACTIVE_DIRECTORY',defaultMessage:'Active Directory'},ADD:{id:'ADD',defaultMessage:'Add'},addAsset:{id:'addAsset',defaultMessage:'Add Assets'},ALL_CATALOGS_GROUP:{id:'ALL_CATALOGS_GROUP',defaultMessage:'All Catalogs'},API_CODE_REFERENCE:{id:'API_CODE_REFERENCE',defaultMessage:'API Code Reference (English)'},API_CODE_REFERENCE_URL:{id:'API_CODE_REFERENCE_URL',defaultMessage:'https://doc.portfoliodam.com/api/portfolio/index.html'},API_DEVELOPER_COMMUNITY:{id:'API_DEVELOPER_COMMUNITY',defaultMessage:'Developer Community'},API_DEVELOPER_COMMUNITY_URL:{id:'API_DEVELOPER_COMMUNITY_URL',defaultMessage:'https://forums.portfolio.com/c/digital-asset-management/portfolio-api-developer-community'},API_PORTFOLIO_HELP:{id:'API_PORTFOLIO_HELP',defaultMessage:'Portfolio Administration Help'},API_PORTFOLIO_HELP_URL:{id:'API_PORTFOLIO_HELP_URL',defaultMessage:'https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm'},API_SECTION_1:{id:'API_SECTION_1',defaultMessage:'The Portfolio API provides a common interface for developers to integrate Portfolio catalogs, asset metadata, and media processing into business systems, custom workflows, and web infrastructures.'},API_SECTION_2_PART_1:{id:'API_SECTION_2_PART_1',defaultMessage:'Use of the API requires licenses, as described in the '},API_SECTION_2_PART_2:{id:'API_SECTION_2_PART_2',defaultMessage:". To view or edit license information, click 'Licenses' in the Portfolio Administration application."},API_SECTION_2_EULA:{id:'API_SECTION_2_EULA',defaultMessage:'Portfolio EULA'},API_SECTION_2_EULA_URL:{id:'API_SECTION_2_EULA_URL',defaultMessage:'https://helpdocs.portfolio.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm'},API_SECTION_2_PART_3:{id:'API_SECTION_2_PART_3',defaultMessage:'Learn more:'},API_TOKEN_CREATE:{id:'API_TOKEN_CREATE',defaultMessage:'Add New API Token'},APPLY:{id:'APPLY',defaultMessage:'Apply'},APP_PAGE_TITLE:{id:'APP_PAGE_TITLE',defaultMessage:'Portfolio Admin'},ASSETS:{id:'ASSETS',defaultMessage:'Assets'},AT_TIME:{id:'AT_TIME',defaultMessage:'at'},AUTHENTICATION_ERROR:{id:'AUTHENTICATION_ERROR',defaultMessage:'Directory service authentication failed. Please check your username and password.'},BACKUP_BACKUP_BUTTON:{id:'BACKUP_BACKUP_BUTTON',defaultMessage:'Backup'},BACKUP_BACKUP_LABEL:{id:'BACKUP_BACKUP_LABEL',defaultMessage:'Backup'},BACKUP_BACKUP_NOW_BUTTON:{id:'BACKUP_BACKUP_NOW_BUTTON',defaultMessage:'Backup Now'},BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE:{id:'BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE',defaultMessage:'To change the backup location, first shut down Portfolio server.'},BACKUP_CONFIRMATION_VERBIAGE:{id:'BACKUP_CONFIRMATION_VERBIAGE',defaultMessage:' Backup now? Portfolio will be offline until backup is complete.'},BACKUP_DIRECTORY_LABEL:{id:'BACKUP_DIRECTORY_LABEL',defaultMessage:'Store in Directory'},BACKUP_DIRECTORY_ERROR_MSG:{id:'BACKUP_DIRECTORY_ERROR_MSG',defaultMessage:'The selected backup directory is not valid.'},BACKUP_EXPLANATION_TEXT_1:{id:'BACKUP_EXPLANATION_TEXT_1',defaultMessage:'Backups capture and safely store the server database and settings.\nIt does not backup your original asset files!'},BACKUP_EXPLANATION_TEXT_2:{id:'BACKUP_EXPLANATION_TEXT_2',defaultMessage:'The server will be inaccessible during backups.'},BACKUP_FILES_LABEL:{id:'BACKUP_FILES_LABEL',defaultMessage:'Backup Files'},BACKUP_FRIDAY_LABEL:{id:'BACKUP_FRIDAY_LABEL',defaultMessage:'Friday'},BACKUP_MONDAY_LABEL:{id:'BACKUP_MONDAY_LABEL',defaultMessage:'Monday'},BACKUP_MOST_RECENT_LABEL:{id:'BACKUP_MOST_RECENT_LABEL',defaultMessage:'Most Recent Backup'},BACKUP_NEXT_SCHEDULED_LABEL:{id:'BACKUP_NEXT_SCHEDULED_LABEL',defaultMessage:'Next Scheduled Backup'},BACKUP_NOTIFICATIONS:{id:'BACKUP_NOTIFICATIONS',defaultMessage:'Send email notifications after backups and restores'},BACKUP_NOTIFICATIONS_DISABLED_MSG:{id:'BACKUP_NOTIFICATIONS_DISABLED_MSG',defaultMessage:'Email notifications must be enabled in Global Settings > Email Notifications'},BACKUP_PROGRESS_BACKING_UP:{id:'BACKUP_PROGRESS_BACKING_UP',defaultMessage:'Backing Up'},BACKUP_PROGRESS_BACKING_UP_DATA:{id:'BACKUP_PROGRESS_BACKING_UP_DATA',defaultMessage:'Backing up data...'},BACKUP_PROGRESS_BACKUP_CANCELLED:{id:'BACKUP_PROGRESS_BACKUP_CANCELLED',defaultMessage:'Backup Cancelled'},BACKUP_PROGRESS_BACKUP_FAILED:{id:'BACKUP_PROGRESS_BACKUP_FAILED',defaultMessage:'Backup Failed'},BACKUP_PROGRESS_BACKUP_SUCCESSFUL:{id:'BACKUP_PROGRESS_BACKUP_SUCCESSFUL',defaultMessage:'Backup Successful'},BACKUP_PROGRESS_PREFLIGHT:{id:'BACKUP_PROGRESS_PREFLIGHT',defaultMessage:'Checking for available space...'},BACKUP_PROGRESS_RESTARTING:{id:'BACKUP_PROGRESS_RESTARTING',defaultMessage:'Restarting server...'},BACKUP_PROGRESS_RESTORE_FAILED:{id:'BACKUP_PROGRESS_RESTORE_FAILED',defaultMessage:'Restore Failed'},BACKUP_PROGRESS_RESTORE_SUCCESSFUL:{id:'BACKUP_PROGRESS_RESTORE_SUCCESSFUL',defaultMessage:'Restore Successful'},BACKUP_PROGRESS_RESTORING:{id:'BACKUP_PROGRESS_RESTORING',defaultMessage:'Restoring'},BACKUP_PROGRESS_RESTORING_DATA:{id:'BACKUP_PROGRESS_RESTORING_DATA',defaultMessage:'Restoring data...'},BACKUP_PROGRESS_SHUTTING_DOWN:{id:'BACKUP_PROGRESS_SHUTTING_DOWN',defaultMessage:'Shutting down server...'},BACKUP_PROGRESS_SUMMARY:{id:'BACKUP_PROGRESS_SUMMARY',defaultMessage:'Step {stepNum} of {totalSteps}'},BACKUP_RESTORE_BUTTON:{id:'BACKUP_RESTORE_BUTTON',defaultMessage:'Restore From Backup'},BACKUP_RESTORE_CONFIRMATION_VERBIAGE:{id:'BACKUP_RESTORE_CONFIRMATION_VERBIAGE',defaultMessage:'Restore backup now? Portfolio will be offline until restore is complete. This will overwrite your current database and settings.'},BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE:{id:'BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE',defaultMessage:'The backup archive is corrupt.\nChoose another backup to restore from.'},BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE:{id:'BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE',defaultMessage:'The backup disk has insufficient space\nto complete.\n\n{requiredSpace} required, {availableSpace} available.'},BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY:{id:'BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY',defaultMessage:'The currently configured backup location does not exist. The backup location is used to unzip the archive when a backup is being restored. Please reset the backup location to a valid directory.'},BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP:{id:'BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP',defaultMessage:'There was a problem with the backup.\nSee admin logs for details.'},BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE:{id:'BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE',defaultMessage:'There was a problem with the restore.\nSee admin logs for details.'},BACKUP_RESTORE_LABEL:{id:'BACKUP_RESTORE_LABEL',defaultMessage:'Restore'},BACKUP_RESTORE_TITLE:{id:'BACKUP_RESTORE_TITLE',defaultMessage:'Backup/Restore'},BACKUP_RETAIN_LABEL:{id:'BACKUP_RETAIN_LABEL',defaultMessage:'Retain'},BACKUP_RETAIN_VALUE:{id:'BACKUP_RETAIN_VALUE',defaultMessage:'Keep only the {numBackups} most recent backups'},BACKUP_SATURDAY_LABEL:{id:'BACKUP_SATURDAY_LABEL',defaultMessage:'Saturday'},BACKUP_SCHEDULE_LABEL:{id:'BACKUP_SCHEDULE_LABEL',defaultMessage:'Schedule Backups'},BACKUP_SCHEDULE_VALUE:{id:'BACKUP_SCHEDULE_VALUE',defaultMessage:'on'},BACKUP_SUNDAY_LABEL:{id:'BACKUP_SUNDAY_LABEL',defaultMessage:'Sunday'},BACKUP_THURSDAY_LABEL:{id:'BACKUP_THURSDAY_LABEL',defaultMessage:'Thursday'},BACKUP_TUESDAY_LABEL:{id:'BACKUP_TUESDAY_LABEL',defaultMessage:'Tuesday'},BACKUP_WEDNESDAY_LABEL:{id:'BACKUP_WEDNESDAY_LABEL',defaultMessage:'Wednesday'},BROWSE:{id:'BROWSE',defaultMessage:'Browse'},BROWSE_FOLDERS_TITLE:{id:'BROWSE_FOLDERS_TITLE',defaultMessage:'Browse Server Folders'},BROWSE_RECENT_FOLDERS_LABEL:{id:'BROWSE_RECENT_FOLDERS_LABEL',defaultMessage:'Recent Folders'},BROWSE_REFRESH:{id:'BROWSE_REFRESH',defaultMessage:'Synchronize items'},CALL_ATT_BUTTON_BUY_NOW:{id:'CALL_ATT_BUTTON_BUY_NOW',defaultMessage:'Buy Now'},CALL_ATT_BUTTON_SECONDARY:{id:'CALL_ATT_BUTTON_SECONDARY',defaultMessage:'Contact Sales for a Quote'},CALL_ATT_FADEL_BUTTON_MAIN:{id:'CALL_ATT_FADEL_BUTTON_MAIN',defaultMessage:'Contact Sales for More Information'},CALL_ATT_FADEL_MAIN:{id:'CALL_ATT_FADEL_MAIN',defaultMessage:'Ensure proper usage of your licensed content, from images to videos and everything in between. Portfolio seamlessly connects with FADEL Rights Cloud software so you can see and easily understand the usage rights associated with your assets—helping you to remove workflow bottlenecks and reduce the risk of expensive copyright violations.'},CALL_ATT_FADEL_SUBTITLE:{id:'CALL_ATT_FADEL_SUBTITLE',defaultMessage:'Know your asset usage rights'},CALL_ATT_FADEL_TITLE:{id:'CALL_ATT_FADEL_TITLE',defaultMessage:'FADEL RIGHTS CLOUD'},CALL_ATT_ME_SUBTITLE:{id:'CALL_ATT_ME_SUBTITLE',defaultMessage:'High-Performance Processing and Conversion'},CALL_ATT_ME_MAIN:{id:'CALL_ATT_ME_MAIN',defaultMessage:'Are you pushing the performance limits of your Portfolio server? With Media Engine, avoid slowdowns and improve overall productivity by eliminating the bottlenecks caused by busy production environments.\n\n\t• Increases capacity and throughput\n\t• Unlocks additional output formats\n\t• Accelerates video preview creation\n\t• Add multiple Media Engines as needed\n\t• Watermarking (requires NetPublish)'},CALL_ATT_ME_BUTTON_MAIN:{id:'CALL_ATT_ME_BUTTON_MAIN',defaultMessage:'Get Media Engine'},CALL_ATT_NP_SUBTITLE:{id:'CALL_ATT_NP_SUBTITLE',defaultMessage:'Self-Service Portals to Access Assets Instantly'},CALL_ATT_NP_MAIN:{id:'CALL_ATT_NP_MAIN',defaultMessage:"Tired of those last minute requests every time someone needs an asset? With NetPublish, it's easy to post self-serve websites that allow anyone to locate and download the assets they need from any browser on any device.\n\n\t• One-click site creation - no HTML or CSS required\n\t• Mobile-friendly, responsive design\n\t• Flexible user access control\n\t• Deactivate sites automatically\n\t• Set resolution, size and format on download\n\t• Watermarking (requires Media Engine)\n\t• Usage reporting"},CALL_ATT_NP_BUTTON_MAIN:{id:'CALL_ATT_NP_BUTTON_MAIN',defaultMessage:'Get NetPublish'},CALL_ATT_REPORT_TITLE:{id:'CALL_ATT_REPORT_TITLE',defaultMessage:'Reporting for NetPublish'},CALL_ATT_REPORT_SUBTITLE:{id:'CALL_ATT_REPORT_SUBTITLE',defaultMessage:'Relevant Usage Insight'},CALL_ATT_REPORT_MAIN:{id:'CALL_ATT_REPORT_MAIN',defaultMessage:'Want to know which sites are most active, what assets are getting used and by whom? With NetPublish reporting, get the insight you need to make informed decisions based on how Portfolio is being used at your organization.\n\nUsage breakdown by:\n\t• NetPublish site name\n\t• Username\n\t• Asset name and ID\n\t• Date and time'},CALL_ATT_REPORT_BUTTON_MAIN:{id:'CALL_ATT_REPORT_BUTTON_MAIN',defaultMessage:'Get NetPublish'},CALL_ATT_SK_BUTTON_MAIN:{id:'CALL_ATT_SK_BUTTON_MAIN',defaultMessage:'Try it for Free'},CALL_ATT_SK_BUTTON_TRY_NOW:{id:'CALL_ATT_SK_BUTTON_TRY_NOW',defaultMessage:'http://extens.is/wqqb'},CALL_ATT_SK_MAIN:{id:'CALL_ATT_SK_MAIN',defaultMessage:'Looking for a way to accelerate your process for assigning keywords to images? With Portfolio Smart Keywords, you can automatically assign “smart” keywords to your images with just one click. Powered by Clarifai, an innovative artificial intelligence company that excels in visual recognition technology, a list of suggested keywords is delivered in seconds.\n\n\t• Delivers a list of smart keywords in seconds\n\t• Saves time and resources by reducing manual keywording\n\t• Establishes a consistent taxonomy for your organization\n\t• Makes it easy to find your digital assets quickly'},CALL_ATT_SK_SUBTITLE:{id:'CALL_ATT_SK_SUBTITLE',defaultMessage:'Automate Your Image Keywording'},CALL_ATT_SK_TITLE:{id:'CALL_ATT_SK_TITLE',defaultMessage:'Portfolio Smart Keywords'},CALL_ATT_SSO_SUBTITLE:{id:'CALL_ATT_SSO_SUBTITLE',defaultMessage:'Seamless User Experience Across Platforms'},CALL_ATT_SSO_TITLE:{id:'CALL_ATT_SSO_TITLE',defaultMessage:'Single Sign-On'},CALL_ATT_SSO_MAIN:{id:'CALL_ATT_SSO_MAIN',defaultMessage:'Are people in your organization having a hard time keeping their login credentials straight? Typically, with new solutions come extra overhead in managing user accounts, both for you and for the users.\n\nFortunately, Portfolio supports Single Sign-On with Active Directory. Using Single Sign-On, users can login to Portfolio automatically from your intranet site giving them a continuous user experience.\n\n\t• Supports Windows Server Active Directory\n\t• Improves overall security\n\t• Simplifies user management\n\t• Improves user experience'},CALL_ATT_SSO_BUTTON_MAIN:{id:'CALL_ATT_SSO_BUTTON_MAIN',defaultMessage:'Get Single Sign-On'},CALL_ATT_URL_BUY_NOW:{id:'CALL_ATT_URL_BUY_NOW',defaultMessage:'https://secure.portfolios.com/portfolio-options'},CALL_ATT_URL_CONTACT_SALES:{id:'CALL_ATT_URL_CONTACT_SALES',defaultMessage:'https://portfoliodam.com/portfolio/contact-me'},canEmbedMetadata:{id:'canEmbedMetadata',defaultMessage:'Embed Metadata'},canImportMetadata:{id:'canImportMetadata',defaultMessage:'Import/Export Metadata'},canManageFieldLists:{id:'canManageFieldLists',defaultMessage:'Manage Public Field Lists'},canManagePublicGallery:{id:'canManagePublicGallery',defaultMessage:'Manage Public Galleries'},canModifyFolderStructure:{id:'canModifyFolderStructure',defaultMessage:'Modify Folder Structures'},canMoveAssets:{id:'canMoveAssets',defaultMessage:'Move Assets'},canPublishNetPublishSites:{id:'canPublishNetPublishSites',defaultMessage:'Publish NetPublish Sites'},canSmartKeyword:{id:'canSmartKeyword',defaultMessage:'Can Smart Keyword'},CANCEL:{id:'CANCEL',defaultMessage:'Cancel'},CATALOG:{id:'CATALOG',defaultMessage:'Catalog'},CATALOG_ADD_SELECTED_USERS_TO_CATALOG:{id:'CATALOG_ADD_SELECTED_USERS_TO_CATALOG',defaultMessage:'Grant Membership'},CATALOG_BACKUP:{id:'CATALOG_BACKUP',defaultMessage:'Backup Selected Catalog'},CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS:{id:'CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS',defaultMessage:'Change { affectedUsersCount, plural, one {Role} other {Roles} }'},CATALOG_CREATE:{id:'CATALOG_CREATE',defaultMessage:'Add New Catalog'},CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG:{id:'CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG',defaultMessage:'Catalog Administrators can add AutoSync folders from the Desktop Client.'},CATALOG_CREATE_AUTOSYNC_FOLDER:{id:'CATALOG_CREATE_AUTOSYNC_FOLDER',defaultMessage:'Create an AutoSync folder'},CATALOG_CREATE_CATALOG_TEMPLATE:{id:'CATALOG_CREATE_CATALOG_TEMPLATE',defaultMessage:'Save Catalog Template'},CATALOG_TYPE_GENERAL:{id:'CATALOG_TYPE_GENERAL',defaultMessage:'General Use'},CATALOG_TYPE_SIMPLE:{id:'CATALOG_TYPE_SIMPLE',defaultMessage:'Simple'},CATALOG_CREATE_DATABASES_LIST_LABEL:{id:'CATALOG_CREATE_DATABASES_LIST_LABEL',defaultMessage:'Databases'},CATALOG_CREATE_ERROR_CREATING_FOLDERS:{id:'CATALOG_CREATE_ERROR_CREATING_FOLDERS',defaultMessage:'An error was encountered when creating the {folder} folder.'},CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG:{id:'CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG',defaultMessage:'Default folders for AutoSync and Previews can be configured in Global Settings.'},CATALOG_CREATE_NAME:{id:'CATALOG_CREATE_NAME',defaultMessage:'Name'},CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG:{id:'CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG',defaultMessage:'Previews can be configured in Catalog Details.'},CATALOG_CREATE_PREVIEW_FOLDER:{id:'CATALOG_CREATE_PREVIEW_FOLDER',defaultMessage:'Save Previews for faster previewing'},CATALOG_CREATE_SHOW_DATABASES:{id:'CATALOG_CREATE_SHOW_DATABASES',defaultMessage:'Show Databases'},CATALOG_CREATE_USE_VERSIONING:{id:'CATALOG_CREATE_USE_VERSIONING',defaultMessage:'Use Asset Versioning'},CATALOG_DELETE:{id:'CATALOG_DELETE',defaultMessage:'Delete Catalog'},CATALOG_DELETE_CONFIRM:{id:'CATALOG_DELETE_CONFIRM',defaultMessage:'Do you want to delete the selected catalog?'},CATALOG_DETAILS:{id:'CATALOG_DETAILS',defaultMessage:'Catalog Details'},CATALOG_DETAILS_CHANGE_NAME_PROMPT:{id:'CATALOG_DETAILS_CHANGE_NAME_PROMPT',defaultMessage:'To rename this catalog we must temporarily take it offline, do you want to continue?'},CATALOG_DETAILS_COLLATION:{id:'CATALOG_DETAILS_COLLATION',defaultMessage:'Collation'},CATALOG_DETAILS_COLLATION_NA:{id:'CATALOG_DETAILS_COLLATION_NA',defaultMessage:'N/A'},CATALOG_DETAILS_CREATION_DATE:{id:'CATALOG_DETAILS_CREATION_DATE',defaultMessage:'Creation Date'},CATALOG_DETAILS_DATABASE_TAB:{id:'CATALOG_DETAILS_DATABASE_TAB',defaultMessage:'General'},CATALOG_DETAILS_FILETYPES_TAB:{id:'CATALOG_DETAILS_FILETYPES_TAB',defaultMessage:'File Types'},CATALOG_DETAILS_LAST_MODIFIED:{id:'CATALOG_DETAILS_LAST_MODIFIED',defaultMessage:'Last Modified'},CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS:{id:'CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS',defaultMessage:'Connected Users'},CATALOG_DETAILS_NUMBER_OF_RECORDS:{id:'CATALOG_DETAILS_NUMBER_OF_RECORDS',defaultMessage:'Records'},CATALOG_DETAILS_NUMBER_OF_USERS:{id:'CATALOG_DETAILS_NUMBER_OF_USERS',defaultMessage:'Members'},CATALOG_DETAILS_SIZE_ON_DISK:{id:'CATALOG_DETAILS_SIZE_ON_DISK',defaultMessage:'Size on disk'},CATALOG_DETAILS_WARN_DISCONNECT_ADMIN:{id:'CATALOG_DETAILS_WARN_DISCONNECT_ADMIN',defaultMessage:'The administrator user will be disconnected. Proceed?'},CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION:{id:'CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION',defaultMessage:'Locked for administration'},CATALOG_DETAILS_UNLOCK:{id:'CATALOG_DETAILS_UNLOCK',defaultMessage:'Unlock'},CATALOG_EXPLANATION_VAULT_1:{id:'CATALOG_EXPLANATION_VAULT_1',defaultMessage:'Vault catalogs store assets in a secure repository.'},CATALOG_EXPLANATION_VAULT_2:{id:'CATALOG_EXPLANATION_VAULT_2',defaultMessage:'Vault catalogs support locking, versioning, check-out and check-in.'},CATALOG_EXPLANATION_WF_1:{id:'CATALOG_EXPLANATION_WF_1',defaultMessage:'Watch Folder catalogs track assets in place in your file system.'},CATALOG_EXPLANATION_WF_2:{id:'CATALOG_EXPLANATION_WF_2',defaultMessage:'Watch Folder catalogs support AutoSync.'},CATALOG_FILES_TAB_TITLE:{id:'CATALOG_FILES_TAB_TITLE',defaultMessage:'Ingest'},CATALOG_INGEST_DRAG_HINT_TEXT:{id:'CATALOG_INGEST_DRAG_HINT_TEXT',defaultMessage:'To add fields to the Upload Form, drag them over from the Fields list.'},CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL:{id:'CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL',defaultMessage:'Fields for Upload Form'},CATALOG_INGEST_FIELDS_LABEL:{id:'CATALOG_INGEST_FIELDS_LABEL',defaultMessage:'Fields'},CATALOG_INGEST_FORM_HEADER_LABEL:{id:'CATALOG_INGEST_FORM_HEADER_LABEL',defaultMessage:'Form Header'},CATALOG_INGEST_HEADER_HINT_TEXT:{id:'CATALOG_INGEST_HEADER_HINT_TEXT',defaultMessage:'The form header is optional and appears at the top of the form.'},CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE:{id:'CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE',defaultMessage:'The maximum number of fields to add to a form is {maxFields}.'},CATALOG_INGEST_TAB_TITLE:{id:'CATALOG_INGEST_TAB_TITLE',defaultMessage:'Managed Upload'},CATALOG_INGEST_USE_INGEST_LABEL:{id:'CATALOG_INGEST_USE_INGEST_LABEL',defaultMessage:'Use Managed Upload'},CATALOG_INGEST_REQUIRED_LABEL:{id:'CATALOG_INGEST_REQUIRED_LABEL',defaultMessage:'Required'},CATALOG_IS_CONNECTED:{id:'CATALOG_IS_CONNECTED',defaultMessage:'Connected'},CATALOG_IS_DEFAULT:{id:'CATALOG_IS_DEFAULT',defaultMessage:'Default'},CATALOG_MANAGE_USERS:{id:'CATALOG_MANAGE_USERS',defaultMessage:'Manage Catalog Membership'},CATALOG_MANAGE_FIELDS:{id:'CATALOG_MANAGE_FIELDS',defaultMessage:'Manage Catalog Fields'},CATALOG_MANAGE_TEMPLATES_MENU_LABEL:{id:'CATALOG_MANAGE_TEMPLATES_MENU_LABEL',defaultMessage:'Manage Catalog Templates...'},CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE:{id:'CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE',defaultMessage:'Manage Custom Catalog Templates'},CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER:{id:'CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER',defaultMessage:'Catalog Template Name'},CATALOG_MEMBER:{id:'CATALOG_MEMBER',defaultMessage:'Member'},CATALOG_NEW_CATALOG_DETAILS:{id:'CATALOG_NEW_CATALOG_DETAILS',defaultMessage:'New Catalog Details'},CATALOG_OFFLINE:{id:'CATALOG_OFFLINE',defaultMessage:'Offline'},CATALOG_ONLINE:{id:'CATALOG_ONLINE',defaultMessage:'Online'},CATALOG_OPTIONS_ALL_FILE_TYPES:{id:'CATALOG_OPTIONS_ALL_FILE_TYPES',defaultMessage:'Catalog All File Types'},CATALOG_OPTIONS_ONLY_FILE_TYPES:{id:'CATALOG_OPTIONS_ONLY_FILE_TYPES',defaultMessage:'Catalog Only'},CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL:{id:'CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL',defaultMessage:'Create Keywords from Path'},CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME:{id:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME',defaultMessage:'Filename'},CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT:{id:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT',defaultMessage:'Parent Folder'},CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER:{id:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER',defaultMessage:'Server Name'},CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE:{id:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE',defaultMessage:'Folder Tree'},CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME:{id:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME',defaultMessage:'Volume'},CATALOG_OPTIONS_EXCLUSION_LABEL:{id:'CATALOG_OPTIONS_EXCLUSION_LABEL',defaultMessage:'File and Folder Exclusions'},CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION:{id:'CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION',defaultMessage:'Remove the selected file type(s)?'},CATALOG_TEMPLATES_TITLE:{id:'CATALOG_TEMPLATES_TITLE',defaultMessage:'Catalog Templates'},endsWith:{id:'endsWith',defaultMessage:'Ends with'},contains:{id:'contains',defaultMessage:'Contains'},startsWith:{id:'startsWith',defaultMessage:'Starts with'},CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION:{id:'CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION',defaultMessage:'Remove the selected exclusion(s)?'},CATALOG_OPTIONS_TAB_TITLE:{id:'CATALOG_OPTIONS_TAB_TITLE',defaultMessage:'Cataloging Options'},CATALOG_PREVIEWS_DEFAULT_LOCATION_IS:{id:'CATALOG_PREVIEWS_DEFAULT_LOCATION_IS',defaultMessage:'The default location is'},CATALOG_PREVIEWS_DIMENSIONS_LABEL:{id:'CATALOG_PREVIEWS_DIMENSIONS_LABEL',defaultMessage:'Minimum size 300 pixels, maximum size 4000 pixel (longest dimension)'},CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES:{id:'CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES',defaultMessage:'Generate clips for audio/video files'},CATALOG_PREVIEWS_GENERATE_PREVIEWS:{id:'CATALOG_PREVIEWS_GENERATE_PREVIEWS',defaultMessage:'Create Previews'},CATALOG_PREVIEWS_FOLDER_LOCATION:{id:'CATALOG_PREVIEWS_FOLDER_LOCATION',defaultMessage:'Save previews and clips in this folder'},CATALOG_PREVIEWS_LOCATION_WARNING_INFO:{id:'CATALOG_PREVIEWS_LOCATION_WARNING_INFO',defaultMessage:'This location must be accessible to the server.'},CATALOG_PREVIEWS_MAX_PIXELS:{id:'CATALOG_PREVIEWS_MAX_PIXELS',defaultMessage:'Maximum image size'},CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION:{id:'CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION',defaultMessage:'Maximum video resolution'},CATALOG_PREVIEWS_MINUTES:{id:'CATALOG_PREVIEWS_MINUTES',defaultMessage:'minutes'},CATALOG_PREVIEWS_PIXELS:{id:'CATALOG_PREVIEWS_PIXELS',defaultMessage:'pixels'},CATALOG_PREVIEWS_SHORT:{id:'CATALOG_PREVIEWS_SHORT',defaultMessage:'Previews'},CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION:{id:'CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION',defaultMessage:'Limit duration to'},CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT:{id:'CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT',defaultMessage:'Generating clips can take a while to process.\nTo shorten the processing time, choose a lower resolution and duration.'},CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG:{id:'CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG',defaultMessage:'Revoke Membership'},CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION:{id:'CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION',defaultMessage:"Remove the user from the catalog?\nThe user's Checked Out items in this catalog will be reverted and made accessible."},CATALOG_SAVE_TEMPLATE:{id:'CATALOG_SAVE_TEMPLATE',defaultMessage:'Save Catalog Template...'},CATALOG_SAVE_TEMPLATE_TITLE:{id:'CATALOG_SAVE_TEMPLATE_TITLE',defaultMessage:'Save Catalog Template'},CATALOG_SAVE_TEMPLATE_DETAILS_TEXT:{id:'CATALOG_SAVE_TEMPLATE_DETAILS_TEXT',defaultMessage:'Catalog templates include all fields, metadata mappings, and cataloging options.'},CATALOG_SELECT_MESSAGE:{id:'CATALOG_SELECT_MESSAGE',defaultMessage:'No Catalog Selected'},CATALOG_SET_AS_DEFAULT:{id:'CATALOG_SET_AS_DEFAULT',defaultMessage:'Set Default Catalog'},CATALOG_SK_DEFAULT_SETTINGS:{id:'CATALOG_SK_DEFAULT_SETTINGS',defaultMessage:'Default Settings'},CATALOG_SK_CONFIDENCE_LEVEL_LABEL:{id:'CATALOG_SK_CONFIDENCE_LEVEL_LABEL',defaultMessage:'Confidence Level'},CATALOG_SK_DEFAULT_LABEL:{id:'CATALOG_SK_DEFAULT_LABEL',defaultMessage:'Recommended: {recommended}'},CATALOG_SK_ENGINES_LABEL:{id:'CATALOG_SK_ENGINES_LABEL',defaultMessage:'Smart Keyword Engines'},CATALOG_SK_LANGUAGES_LABEL:{id:'CATALOG_SK_LANGUAGES_LABEL',defaultMessage:'Languages for General Engine'},CATALOG_SK_NUM_KEYWORDS_LABEL:{id:'CATALOG_SK_NUM_KEYWORDS_LABEL',defaultMessage:'Number of Keywords'},CATALOG_SK_SETTINGS_LABEL:{id:'CATALOG_SK_SETTINGS_LABEL',defaultMessage:'Settings'},CATALOG_SK_TAB_TITLE:{id:'CATALOG_SK_TAB_TITLE',defaultMessage:'Smart Keywords'},CATALOG_SK_USE_SK_LABEL:{id:'CATALOG_SK_USE_SK_LABEL',defaultMessage:'Use Smart Keywords in this Catalog'},CATALOG_SK_ON_CATALOGING_LABEL:{id:'CATALOG_SK_KEYWORD_ON_CATALOG_LABEL',defaultMessage:'Smart Keyword newly cataloged assets'},CATALOG_STATUS:{id:'CATALOG_STATUS',defaultMessage:'Catalog Status'},CATALOG_STORAGE_TYPE_LABEL:{id:'CATALOG_STORAGE_TYPE_LABEL',defaultMessage:'Storage Type'},CATALOG_STORAGE_TYPE_WATCHFOLDERS:{id:'CATALOG_STORAGE_TYPE_WATCHFOLDERS',defaultMessage:'Watch Folders'},CATALOG_STORAGE_TYPE_VAULT:{id:'CATALOG_STORAGE_TYPE_VAULT',defaultMessage:'Vault'},CATALOG_STORAGE_TYPE_S3:{id:'CATALOG_STORAGE_TYPE_S3',defaultMessage:'S3'},CATALOG_TAKE_OFFLINE_SHORT:{id:'CATALOG_TAKE_OFFLINE_SHORT',defaultMessage:'Take Offline'},CATALOG_TAKE_ONLINE_SHORT:{id:'CATALOG_TAKE_ONLINE_SHORT',defaultMessage:'Take Online'},CATALOG_TEMPLATE:{id:'CATALOG_TEMPLATE',defaultMessage:'template'},CATALOG_TEMPLATE_NAME:{id:'CATALOG_TEMPLATE_NAME',defaultMessage:'Template Name'},CATALOG_TEMPLATE_REMOVE_CONFIRMATION:{id:'CATALOG_TEMPLATE_REMOVE_CONFIRMATION',defaultMessage:'Remove the selected catalog template?'},CATALOG_VIEW_DETAILS:{id:'CATALOG_VIEW_DETAILS',defaultMessage:'View/Edit Catalog Details'},CERT_CREATE_REQUEST:{id:'CERT_CREATE_REQUEST',defaultMessage:'Create Certificate Request'},CERT_DELETE_CONFIRMATION:{id:'CERT_DELETE_CONFIRMATION',defaultMessage:'Are you sure you want to delete the certificate request? This cannot be undone.'},CERT_DOWNLOAD:{id:'CERT_DOWNLOAD',defaultMessage:'Download'},CERT_EXPIRATION_DATE:{id:'CERT_EXPIRATION_DATE',defaultMessage:'Expiration Date'},CERT_FILE:{id:'CERT_FILE',defaultMessage:'Certificate File'},CERT_FILE_INT_1:{id:'CERT_FILE_INT_1',defaultMessage:'Intermediate Certificate 1'},CERT_FILE_INT_2:{id:'CERT_FILE_INT_2',defaultMessage:'Intermediate Certificate 2'},CERT_FILE_PASSWORD:{id:'CERT_FILE_PASSWORD',defaultMessage:'Certificate Password'},CERT_FILE_PASSWORD_HELP:{id:'CERT_FILE_PASSWORD_HELP',defaultMessage:'If your certificate has a password, enter it here'},CERT_FILE_PROMPT:{id:'CERT_FILE_PROMPT',defaultMessage:'Select...'},CERT_FILE_ROOT:{id:'CERT_FILE_ROOT',defaultMessage:'Root Certificate'},CERT_IMPORT:{id:'CERT_IMPORT',defaultMessage:'Import Certificate'},CERT_ISSUER:{id:'CERT_ISSUER',defaultMessage:'Issuer'},CERT_OWNER:{id:'CERT_OWNER',defaultMessage:'Owner'},CERT_PENDING_REQUEST:{id:'CERT_PENDING_REQUEST',defaultMessage:'Pending Certificate Request'},CERT_REQUEST_ALREADY_CREATED_WARNING:{id:'CERT_REQUEST_ALREADY_CREATED_WARNING',defaultMessage:'You have already created a certificate request. If you continue, the existing request will be deleted.'},CERT_IMPORT_SUCCEEDED:{id:'CERT_IMPORT_SUCCEEDED',defaultMessage:'The certificate was successfully imported. Please restart the Portfolio server and Portfolio admin services to begin using the certificate.'},CERT_IMPORT_FAILED_READING_PKCS12:{id:'CERT_IMPORT_FAILED_READING_PKCS12',defaultMessage:'The server could not read the PKCS12 certificate. Check the password.'},CERT_IMPORT_FAILED_INTERMEDIATE1:{id:'CERT_IMPORT_FAILED_INTERMEDIATE1',defaultMessage:'The Intermediate 1 certificate could not be imported.'},CERT_IMPORT_FAILED_INTERMEDIATE2:{id:'CERT_IMPORT_FAILED_INTERMEDIATE2',defaultMessage:'The Intermediate 2 certificate could not be imported.'},CERT_IMPORT_FAILED_ROOT:{id:'CERT_IMPORT_FAILED_ROOT',defaultMessage:'The root certificate could not be imported.'},CERTIFICATE_FILE_FILTER:{id:'CERTIFICATE_FILE_FILTER',defaultMessage:'Certificates (p7b, cer, crt, der, pfx, p12)'},CERTIFICATE_STATUS_INVALID:{id:'CERTIFICATE_STATUS_INVALID',defaultMessage:'Invalid Certificate'},CERTIFICATE_STATUS_SELF_SIGNED:{id:'CERTIFICATE_STATUS_SELF_SIGNED',defaultMessage:'Invalid Certificate: Self-Signed'},CERTIFICATE_STATUS_EXPIRED:{id:'CERTIFICATE_STATUS_EXPIRED',defaultMessage:'Certificate Expired'},CERTIFICATE_STATUS_IMPORTED:{id:'CERTIFICATE_STATUS_IMPORTED',defaultMessage:'Certificate Imported'},CERTS_TITLE:{id:'CERTS_TITLE',defaultMessage:'SSL Certificate'},CHANGE:{id:'CHANGE',defaultMessage:'Change'},CITY_OR_LOCALITY:{id:'CITY_OR_LOCALITY',defaultMessage:'City or Locality'},CLEAR_BUTTON_LABEL:{id:'CLEAR_BUTTON_LABEL',defaultMessage:'Clear'},COMMUNICATION_AT_INITILIZATION_ERROR:{id:'COMMUNICATION_AT_INITILIZATION_ERROR',defaultMessage:'There was an error communicating with the server. This is usually caused by stale data in the browser cache but it could also indicate a problem with the server. Contact your administrator for more information.'},CONFIGURE_DIRECTORY_SERVICE:{id:'CONFIGURE_DIRECTORY_SERVICE',defaultMessage:'Configure Directory Service'},CONFIGURE_EMAIL_LINK:{id:'CONFIGURE_EMAIL_LINK',defaultMessage:'Configure email notifications...'},CONFIRM_DELETE_PDL:{id:'CONFIRM_DELETE_PDL',defaultMessage:'Delete all predefined values for this field?'},CONFIRM_DELETE_SERVICE:{id:'CONFIRM_DELETE_SERVICE',defaultMessage:'Remove Directory Service?\nUsers imported from the service will remain. Their passwords will revert to values set previously in Portfolio, or will be disabled if not set previously.'},CONFIRM_TRUNCATE_VALUES:{id:'CONFIRM_TRUNCATE_VALUES',defaultMessage:'Max Length exceeds one or more default or predefined values for this field. Truncate values?'},CONNECTION_REFUSED_ERROR:{id:'CONNECTION_REFUSED_ERROR',defaultMessage:'The connection to the directory service was refused. Please check your hostname and port settings.'},CONTAINS:{id:'CONTAINS',defaultMessage:'contains'},CONTINUE:{id:'CONTINUE',defaultMessage:'Continue'},CREATE:{id:'CREATE',defaultMessage:'Create'},CREATE_A_CERTIFICATE_REQUEST:{id:'CREATE_A_CERTIFICATE_REQUEST',defaultMessage:'Create a certificate signing request'},CREATE_CATALOG:{id:'CREATE_CATALOG',defaultMessage:'Create Catalog'},createContactSheet:{id:'createContactSheet',defaultMessage:'Make PDF'},CREATE_USER:{id:'CREATE_USER',defaultMessage:'Create User'},CREATED_BY:{id:'CREATED_BY',defaultMessage:'Created By'},CREATE_MAPPING:{id:'CREATE_MAPPING',defaultMessage:'Create Mapping'},CREATE_USER_EXCLUSION_MAPPING:{id:'CREATE_USER_EXCLUSION_MAPPING',defaultMessage:'Exclude User'},CREATED_ON_DATE:{id:'CREATED_ON_DATE',defaultMessage:'Date Created'},DATE_FORMAT:{id:'DATE_FORMAT',defaultMessage:'MM/DD/YYYY'},DATE_FORMAT_ERROR:{id:'DATE_FORMAT_ERROR',defaultMessage:'Configuration error: Incorrect formatting string.'},DATE_INVALID_CHAR_ERROR:{id:'DATE_INVALID_CHAR_ERROR',defaultMessage:'The date contains invalid characters.'},DATE_TIME_FORMAT:{id:'DATE_TIME_FORMAT',defaultMessage:'MM/DD/YYYY L:NN A'},DATE_TIME_SECONDS_FORMAT:{id:'DATE_TIME_SECONDS_FORMAT',defaultMessage:'MM/DD/YYYY L:NN:SS A'},DATE_WRONG_DAY_ERROR:{id:'DATE_WRONG_DAY_ERROR',defaultMessage:'Enter a valid day for the month.'},DATE_WRONG_LENGTH_ERROR:{id:'DATE_WRONG_LENGTH_ERROR',defaultMessage:'Type the date in the format:'},DATE_WRONG_MONTH_ERROR:{id:'DATE_WRONG_MONTH_ERROR',defaultMessage:'Enter a month between 1 and 12.'},DATE_WRONG_YEAR_ERROR:{id:'DATE_WRONG_YEAR_ERROR',defaultMessage:'Enter a year between 0 and 9999.'},DEFAULT_ACCESS_LEVEL:{id:'DEFAULT_ACCESS_LEVEL',defaultMessage:'Default Role'},DEFAULT_CATALOG:{id:'DEFAULT_CATALOG',defaultMessage:'Default Catalog'},DEFAULT_CATALOG_NONE:{id:'DEFAULT_CATALOG_NONE',defaultMessage:'None'},DEFAULT_PORT_NON_SSL:{id:'DEFAULT_PORT_NON_SSL',defaultMessage:'Default port for non-SSL:'},DEFAULT_PORT_SSL:{id:'DEFAULT_PORT_SSL',defaultMessage:'Default port for SSL:'},DELETE:{id:'DELETE',defaultMessage:'Delete'},deleteAssetContents:{id:'deleteAssetContents',defaultMessage:'Delete Original Assets'},deleteAssetFromCatalog:{id:'deleteAssetFromCatalog',defaultMessage:'Delete Asset from Catalog'},DELETE_SOURCE:{id:'DELETE_SOURCE',defaultMessage:'Delete Source'},DELETE_ALL_NESTED_VALUES_CONFIRMATION:{id:'DELETE_ALL_NESTED_VALUES_CONFIRMATION',defaultMessage:'Delete all values?\nThis will delete all values including nested values.'},DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION:{id:'DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION',defaultMessage:"Delete the value '{value}'?\nIt contains nested values which will also be deleted."},DELETE_NESTED_VALUE_CONFIRMATION:{id:'DELETE_NESTED_VALUE_CONFIRMATION',defaultMessage:'Delete the selected values?\nThey contain nested values which will also be deleted.'},DELETE_WARNING_BOX_MSG:{id:'DELETE_WARNING_BOX_MSG',defaultMessage:'Warning! Deleting cannot be undone!'},DELETE_WARNING_CATALOG_VAULT:{id:'DELETE_WARNING_CATALOG_VAULT',defaultMessage:'All files in the catalog will be destroyed.'},DIAGNOSTICS_TITLE:{id:'DIAGNOSTICS_TITLE',defaultMessage:'Diagnostics'},DIAGNOSTICS_NO_PROBLEMS:{id:'DIAGNOSTICS_NO_PROBLEMS',defaultMessage:'No problems found'},DIAGNOSTIC_DATA_TITLE:{id:'DIAGNOSTIC_DATA_TITLE',defaultMessage:'Send Diagnostic Report to Extensis'},DIAGNOSTIC_DATA_ACCOUNT_NAME:{id:'DIAGNOSTIC_DATA_ACCOUNT_NAME',defaultMessage:'Company or Account Name (Required)'},DIAGNOSTIC_DATA_CONTACT_NAME:{id:'DIAGNOSTIC_DATA_CONTACT_NAME',defaultMessage:'Contact Name'},DIAGNOSTIC_DATA_TS_TICKET_NUMBER:{id:'DIAGNOSTIC_DATA_TS_TICKET_NUMBER',defaultMessage:'Tech Support Ticket Number'},DIAGNOSTIC_DATA_SEND_REPORT_BUTTON:{id:'DIAGNOSTIC_DATA_SEND_REPORT_BUTTON',defaultMessage:'Send Report'},DIAGNOSTIC_STATUS_ERROR:{id:'DIAGNOSTIC_STATUS_ERROR',defaultMessage:'There was a problem uploading the diagnostic report on {date}'},DIAGNOSTIC_STATUS_SENDING:{id:'DIAGNOSTIC_STATUS_SENDING',defaultMessage:'Sending...'},DIAGNOSTIC_STATUS_SUCCESS:{id:'DIAGNOSTIC_STATUS_SUCCESS',defaultMessage:'Diagnostic report successfully sent to Extensis on {date}'},DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE:{id:'DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE',defaultMessage:'Querying\nThis may take a few minutes...'},DIRECTORY_SERVICE_CONNECT_ERROR:{id:'DIRECTORY_SERVICE_CONNECT_ERROR',defaultMessage:'Unable to connect to the directory service. Please check the hostname and port settings.'},DIRECTORY_SERVICE_BROWSE_FILTER_LABEL:{id:'DIRECTORY_SERVICE_BROWSE_FILTER_LABEL',defaultMessage:'Filter'},DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL:{id:'DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL',defaultMessage:'AD Users and Groups'},DIRECTORY_SERVICE_CONFIG_TITLE:{id:'DIRECTORY_SERVICE_CONFIG_TITLE',defaultMessage:'Active Directory Configuration'},DIRECTORY_SERVICES_TITLE:{id:'DIRECTORY_SERVICES_TITLE',defaultMessage:'Directory Services'},DIRECTORY_SERVICE_SAVE_MAPPINGS:{id:'DIRECTORY_SERVICE_SAVE_MAPPINGS',defaultMessage:'Save and Sync'},DIRECTORY_SERVICE_REMOVE_MAPPING:{id:'DIRECTORY_SERVICE_REMOVE_MAPPING',defaultMessage:'Remove Mapping'},DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL:{id:'DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL',defaultMessage:'Portfolio User Imports'},DIRECTORY_SERVICE_MAPIINGS:{id:'DIRECTORY_SERVICE_MAPIINGS',defaultMessage:'Directory Items to Portfolio Mappings'},DIRECTORY_SERVICE_MAPIINGS_TITLE:{id:'DIRECTORY_SERVICE_MAPIINGS_TITLE',defaultMessage:'Mappings'},DIRECTORY_SERVICE_NO_MAPPINGS_LABEL:{id:'DIRECTORY_SERVICE_NO_MAPPINGS_LABEL',defaultMessage:"No Mappings\n\nTo create a mapping, select a user or group to the left, and click 'Create Mapping'"},DIRECTORY_SERVICES:{id:'DIRECTORY_SERVICES',defaultMessage:'Directory Services'},DIRECTORY_USERS_CANNOT_BE_DELETED:{id:'DIRECTORY_USERS_CANNOT_BE_DELETED',defaultMessage:'Directory Service users cannot be deleted!'},DISTRIBUTION_GROUPS:{id:'DISTRIBUTION_GROUPS',defaultMessage:'Distribution Groups'},DOWNLOAD_CERT_PROMPT:{id:'DOWNLOAD_CERT_PROMPT',defaultMessage:'Download certificate request file?'},DOWNLOAD_COMPLETE_STRING:{id:'DOWNLOAD_COMPLETE_STRING',defaultMessage:'Download complete.'},downloadPreviews:{id:'downloadPreviews',defaultMessage:'Download Previews'},EMAIL_ADDRESS:{id:'EMAIL_ADDRESS',defaultMessage:'Email Address'},EMAIL_CONFIG_AUTH_PASSWORD:{id:'EMAIL_CONFIG_AUTH_PASSWORD',defaultMessage:'Password'},EMAIL_CONFIG_AUTH_USERNAME:{id:'EMAIL_CONFIG_AUTH_USERNAME',defaultMessage:'User Name'},EMAIL_CONFIG_ENABLED:{id:'EMAIL_CONFIG_ENABLED',defaultMessage:'Enable Email Notifications'},EMAIL_CONFIG_FROM_ADDRESS:{id:'EMAIL_CONFIG_FROM_ADDRESS',defaultMessage:'Email From Address'},EMAIL_CONFIG_INVALID_GENERIC:{id:'EMAIL_CONFIG_INVALID_GENERIC',defaultMessage:'Email Server Configuration Invalid'},EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND:{id:'EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND',defaultMessage:'Email Server Not Found'},EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED:{id:'EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED',defaultMessage:'Email Server Authentication Failed'},EMAIL_CONFIG_MESSAGE:{id:'EMAIL_CONFIG_MESSAGE',defaultMessage:'Each user who wishes to receive notifications must have an email address assigned in the Users pane.'},EMAIL_CONFIG_SERVER_ADDRESS:{id:'EMAIL_CONFIG_SERVER_ADDRESS',defaultMessage:'SMTP Server Address'},EMAIL_CONFIG_SERVER_PORT:{id:'EMAIL_CONFIG_SERVER_PORT',defaultMessage:'SMTP Server Port'},EMAIL_CONFIG_SUCCESS_MESSAGE:{id:'EMAIL_CONFIG_SUCCESS_MESSAGE',defaultMessage:'SMTP Server Validated'},EMAIL_CONFIG_USE_SSL_TLS:{id:'EMAIL_CONFIG_USE_SSL_TLS',defaultMessage:'Use SSL / TLS'},EMAIL_CONFIG_USE_SMTP_AUTH:{id:'EMAIL_CONFIG_USE_SMTP_AUTH',defaultMessage:'Use SMTP Authentication'},EMAIL_CONFIG_VALIDATE:{id:'EMAIL_CONFIG_VALIDATE',defaultMessage:'Test Connection'},EMAIL_CONFIG_VALIDATED:{id:'EMAIL_CONFIG_VALIDATED',defaultMessage:'Email Server Validated'},english:{id:'english',defaultMessage:'English'},ENTIRE_TREE_UNDER_SEARCH_BASE:{id:'ENTIRE_TREE_UNDER_SEARCH_BASE',defaultMessage:'Entire tree'},EQUALS:{id:'EQUALS',defaultMessage:'equals'},ESP_PORT_ADMIN_WEB_APP:{id:'esp.port.admin-web-app',defaultMessage:'Portfolio Admin HTTP Port'},ESP_PORT_ADMIN_WEB_APP_SSL:{id:'esp.port.admin-web-app-ssl',defaultMessage:'Portfolio Admin SSL Port'},ESP_PORT_HTTP:{id:'esp.port.http',defaultMessage:'Portfolio Server HTTP Port'},ESP_PORT_SSL:{id:'esp.port.ssl',defaultMessage:'Portfolio Server SSL Port'},EXPORT_MENU_STRING:{id:'EXPORT_MENU_STRING',defaultMessage:'Export Values'},FADEL_HOWTO:{id:'FADEL_HOWTO',defaultMessage:'Login to your FADEL account:'},FALSE_LABEL:{id:'FALSE_LABEL',defaultMessage:'False'},FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR:{id:'FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR',defaultMessage:'Please check that the admin server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload this application.'},FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS:{id:'FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS',defaultMessage:'This operation cannot be performed while a backup or restore is in progress.'},FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE:{id:'FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE',defaultMessage:'That operation failed because the catalog is in admin mode.'},FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME:{id:'FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME',defaultMessage:'A catalog already exists with this name.'},FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME:{id:'FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME',defaultMessage:'A user already exists with this account name.'},FAULT_MSG_DB_IN_USE:{id:'FAULT_MSG_DB_IN_USE',defaultMessage:'The operation could not be completed because the catalog is currently in use by an administrator.'},FAULT_MSG_DELETE_ADMIN:{id:'FAULT_MSG_DELETE_ADMIN',defaultMessage:'You cannot delete the administrator account.'},FAULT_MSG_DELETE_SELF:{id:'FAULT_MSG_DELETE_SELF',defaultMessage:'You cannot delete your user account.'},FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR:{id:'FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR',defaultMessage:'An unexpected error occurred when deleting the catalog template.'},FAULT_MSG_DUPE_NAME:{id:'FAULT_MSG_DUPE_NAME',defaultMessage:'An object with that name already exists.  Please use another name.'},FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS:{id:'FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS',defaultMessage:'There is already a Media Engine with that address and port.'},FAULT_MSG_ENTITY_VERSION_MISMATCH:{id:'FAULT_MSG_ENTITY_VERSION_MISMATCH',defaultMessage:" That operation failed because the client's information was out of date."},FAULT_MSG_IDENT_SERVICE_CREATION_ERROR:{id:'FAULT_MSG_IDENT_SERVICE_CREATION_ERROR',defaultMessage:'Please check that the server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload the application.'},FAULT_MSG_INVALID_SESSION_ID:{id:'FAULT_MSG_INVALID_SESSION_ID',defaultMessage:'Your session has expired. You must log into the server again.'},FAULT_MSG_IS_NOT_LICENSED:{id:'FAULT_MSG_IS_NOT_LICENSED',defaultMessage:'Server not licensed for that operation.'},FAULT_MSG_LEGACY_21000:{id:'FAULT_MSG_LEGACY_21000',defaultMessage:'The operation failed because of an unknown internal error.'},FAULT_MSG_LOGGING_ERR_UPDATE:{id:'FAULT_MSG_LOGGING_ERR_UPDATE',defaultMessage:'There has been an error updating the logging configuration'},FAULT_MSG_LOG_DIR_NOT_VALID:{id:'FAULT_MSG_LOG_DIR_NOT_VALID',defaultMessage:'The specified log directory does not exist, is not writeable or the path specified is not a directory.'},FAULT_MSG_NO_DIRECTORY:{id:'FAULT_MSG_NO_DIRECTORY',defaultMessage:'The specified location does not exist or it is not a directory.'},FAULT_MSG_NULL_DESCRIPTION:{id:'FAULT_MSG_NULL_DESCRIPTION',defaultMessage:'An unexpected error occurred, but there is no description to report.'},FAULT_MSG_NULL_FAULTEVENT:{id:'FAULT_MSG_NULL_FAULTEVENT',defaultMessage:'An unexpected error occurred, but there are no details to report.'},FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES:{id:'FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES',defaultMessage:'That operation failed because you do not have sufficient privileges.'},FAULT_MSG_OPERATION_IS_INVALID:{id:'FAULT_MSG_OPERATION_IS_INVALID',defaultMessage:'That operation was not valid.'},FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR:{id:'FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR',defaultMessage:'An unexpected error occurred when renaming the catalog template.'},FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR:{id:'FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR',defaultMessage:'An unexpected error occurred when saving the catalog template.'},FAULT_MSG_SERVER_NOT_RUNNING:{id:'FAULT_MSG_SERVER_NOT_RUNNING',defaultMessage:'The server is not running.'},FAULT_MSG_ENTERPRISE_NOT_LICENSED:{id:'FAULT_MSG_ENTERPRISE_NOT_LICENSED',defaultMessage:'The operation failed because the server does not have an Enterprise Module license.'},FAULT_MSG_REMOVE_METADATA_DEF:{id:'FAULT_MSG_REMOVE_METADATA_DEF',defaultMessage:'Removing the metadata definition failed.  It may be in use by other catalogs.'},FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT:{id:'FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT',defaultMessage:'The server returned a fault with this message: '},FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE:{id:'FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE',defaultMessage:'The server returned a fault with no error message. '},FAULT_MSG_UNHANDLED_UNKNOWN_FAULT:{id:'FAULT_MSG_UNHANDLED_UNKNOWN_FAULT',defaultMessage:'The server returned a fault with an unknown type and this message:'},FAULT_MSG_UNKNOWN_SMTP_SERVER:{id:'FAULT_MSG_UNKNOWN_SMTP_SERVER',defaultMessage:'Unable to connect to the specified mail server.'},FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING:{id:'FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING',defaultMessage:'That operation failed because a service was not in the expected state.'},FAULT_MSG_INVALID_LOGINID_OR_PASSWORD:{id:'FAULT_MSG_INVALID_LOGINID_OR_PASSWORD',defaultMessage:'The username or password supplied for the database is not valid.'},FAULT_MSG_BAD_DB_PORT:{id:'FAULT_MSG_BAD_DB_PORT',defaultMessage:'The database port specified is not valid.'},FAULT_MSG_BAD_DB_HOST:{id:'FAULT_MSG_BAD_DB_HOST',defaultMessage:'The database hostname or port specified is invalid.'},FIELD_ACTION_ADD:{id:'FIELD_ACTION_ADD',defaultMessage:'Add New Custom Field'},FIELD_ACTION_DELETE:{id:'FIELD_ACTION_DELETE',defaultMessage:'Delete Selected Field'},FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES:{id:'FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES',defaultMessage:'XMP Namespaces'},FIELD_ACTION_MANAGE_METADATA:{id:'FIELD_ACTION_MANAGE_METADATA',defaultMessage:'Manage Metadata'},FIELD_ADD_EXTRACT_METADATA:{id:'FIELD_ADD_EXTRACT_METADATA',defaultMessage:'Add Extract Metadata'},FIELD_CATEGORY_ALL:{id:'FIELD_CATEGORY_ALL',defaultMessage:'All Active Fields'},FIELD_CATEGORY_CUSTOM:{id:'FIELD_CATEGORY_CUSTOM',defaultMessage:'Custom Fields'},FIELD_CATEGORY_SYSTEM:{id:'FIELD_CATEGORY_SYSTEM',defaultMessage:'System Fields'},FIELD_CATEGORY_EXIF:{id:'FIELD_CATEGORY_EXIF',defaultMessage:'EXIF'},FIELD_CATEGORY_IPTC:{id:'FIELD_CATEGORY_IPTC',defaultMessage:'IPTC'},FIELD_CATEGORY_XMP:{id:'FIELD_CATEGORY_XMP',defaultMessage:'XMP'},FIELD_CATEGORY_MOVIE:{id:'FIELD_CATEGORY_MOVIE',defaultMessage:'Movie'},FIELD_CATEGORY_OFFICE:{id:'FIELD_CATEGORY_OFFICE',defaultMessage:'MS Office'},FIELD_CATEGORY_GEO:{id:'FIELD_CATEGORY_GEO',defaultMessage:'GEO'},FIELD_CATEGORY_LABEL:{id:'FIELD_CATEGORY_LABEL',defaultMessage:'Field Category'},FIELD_CATEGORY_FONTSENSE:{id:'FIELD_CATEGORY_FONTSENSE',defaultMessage:'Extensis Font Sense'},FIELD_DELETE_CONFIRM_MSG:{id:'FIELD_DELETE_CONFIRM_MSG',defaultMessage:'Do you want to delete the selected field?'},FIELD_DISABLE_CONFIRM_MSG:{id:'FIELD_DISABLE_CONFIRM_MSG',defaultMessage:'Do you want to disable the selected field?'},FIELD_ENABLE_ALL_CATEGORIES_LABEL:{id:'FIELD_ENABLE_ALL_CATEGORIES_LABEL',defaultMessage:'Enable All'},FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING:{id:'FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING',defaultMessage:'Add Extract Mapping'},FIELD_FORM_LABEL_DEFAULT_VALUE:{id:'FIELD_FORM_LABEL_DEFAULT_VALUE',defaultMessage:'Default Value'},FIELD_FORM_LABEL_DISABLED:{id:'FIELD_FORM_LABEL_DISABLED',defaultMessage:'(Disabled)'},FIELD_FORM_LABEL_EMBED:{id:'FIELD_FORM_LABEL_EMBED',defaultMessage:'Embed in Metadata'},FIELD_FORM_LABEL_EXTRACT:{id:'FIELD_FORM_LABEL_EXTRACT',defaultMessage:'Extract from Metadata'},FIELD_FORM_LABEL_FIELD_NAME:{id:'FIELD_FORM_LABEL_FIELD_NAME',defaultMessage:'Field Name'},FIELD_FORM_LABEL_FIELD_TYPE:{id:'FIELD_FORM_LABEL_FIELD_TYPE',defaultMessage:'Field Type'},FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES:{id:'FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES',defaultMessage:'Allow Multiple Values'},FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES:{id:'FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES',defaultMessage:'Has Predefined Values'},FIELD_FORM_LABEL_HELP_TEXT:{id:'FIELD_FORM_LABEL_HELP_TEXT',defaultMessage:'Help Text'},FIELD_FORM_LABEL_MAX:{id:'FIELD_FORM_LABEL_MAX',defaultMessage:'Max: {max}'},FIELD_FORM_LABEL_MAX_LENGTH:{id:'FIELD_FORM_LABEL_MAX_LENGTH',defaultMessage:'Max Length'},FIELD_FORM_LABEL_METADATA_TAG:{id:'FIELD_FORM_LABEL_METADATA_TAG',defaultMessage:'Metadata Name'},FIELD_FORM_LABEL_METADATA_TYPE:{id:'FIELD_FORM_LABEL_METADATA_TYPE',defaultMessage:'Metadata Type'},FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES:{id:'FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES',defaultMessage:'Allow Only Predefined Values'},FIELD_FORM_LABEL_PRECISION:{id:'FIELD_FORM_LABEL_PRECISION',defaultMessage:'Precision'},FIELD_FORM_LABEL_PRECISION_MAX:{id:'FIELD_FORM_LABEL_PRECISION_MAX',defaultMessage:'Max'},FIELD_FORM_LABEL_PREDEFINED_VALUES:{id:'FIELD_FORM_LABEL_PREDEFINED_VALUES',defaultMessage:'Predefined Values'},FIELD_FORM_LABEL_SHOW_TIME:{id:'FIELD_FORM_LABEL_SHOW_TIME',defaultMessage:'Show Time'},FIELD_FORM_LABEL_USE_METADATA:{id:'FIELD_FORM_LABEL_USE_METADATA',defaultMessage:'Extract and Embed Metadata'},FIELD_FORM_WARNING_DUPE_EMBEDS:{id:'FIELD_FORM_WARNING_DUPE_EMBEDS',defaultMessage:"Warning: More than one field embeds to '{metadata}'"},FIELD_METADATA_DATA_TYPE_LABEL:{id:'FIELD_METADATA_DATA_TYPE_LABEL',defaultMessage:'Data Type'},FIELD_METADATA_DEFINITION_IS_CUSTOM:{id:'FIELD_METADATA_DEFINITION_IS_CUSTOM',defaultMessage:'Is Custom'},FIELD_METADATA_DEFINITIONS_TITLE:{id:'FIELD_METADATA_DEFINITIONS_TITLE',defaultMessage:'Metadata Definitions'},FIELD_METADATA_DELETE_CONFIRM_MSG:{id:'FIELD_METADATA_DELETE_CONFIRM_MSG',defaultMessage:'Confirm: Delete the Metadata Definition?'},FIELD_METADATA_MULTIVALUED_TYPE_LABEL:{id:'FIELD_METADATA_MULTIVALUED_TYPE_LABEL',defaultMessage:'Multivalued Type'},FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL:{id:'FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL',defaultMessage:'Not Multivalued'},FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL:{id:'FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL',defaultMessage:'Ordered'},FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL:{id:'FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL',defaultMessage:'Unordered'},FIELD_METADATA_NAME_LABEL:{id:'FIELD_METADATA_NAME_LABEL',defaultMessage:'Name'},FIELD_METADATA_NAMESPACE_LABEL:{id:'FIELD_METADATA_NAMESPACE_LABEL',defaultMessage:'Namespace'},FIELD_METADATA_NEW_NAMESPACE_TOOLTIP:{id:'FIELD_METADATA_NEW_NAMESPACE_TOOLTIP',defaultMessage:'Add a Custom XMP Namespace...'},FIELD_METADATA_TAG_LABEL:{id:'FIELD_METADATA_TAG_LABEL',defaultMessage:'Tag'},FIELD_METADATA_TYPE_LABEL:{id:'FIELD_METADATA_TYPE_LABEL',defaultMessage:'Type'},FIELD_MULTIPLE_EMBED_WARNING:{id:'FIELD_MULTIPLE_EMBED_WARNING',defaultMessage:'More than one field embeds to'},FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE:{id:'FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE',defaultMessage:'Multiple Fields Selected'},FIELD_NAMESPACE_ABBREVIATION:{id:'FIELD_NAMESPACE_ABBREVIATION',defaultMessage:'Abbreviation'},FIELD_NAMESPACE_REMOVE_CONFIRMATION:{id:'FIELD_NAMESPACE_REMOVE_CONFIRMATION',defaultMessage:'Delete the Custom XMP Namespace?\nThere may be Field Definitions using the namespace.'},FIELD_NAMESPACE_URI:{id:'FIELD_NAMESPACE_URI',defaultMessage:'Namespace URI'},FIELD_NEW_FIELD_NAME:{id:'FIELD_NEW_FIELD_NAME',defaultMessage:'New Field'},FIELD_NEW_METADATA_TITLE:{id:'FIELD_NEW_METADATA_TITLE',defaultMessage:'New Metadata Definition'},FIELD_NEW_NAMESPACE_TITLE:{id:'FIELD_NEW_NAMESPACE_TITLE',defaultMessage:'New Custom XMP Namespace'},FIELD_NO_FIELD_SELECTED_MESSAGE:{id:'FIELD_NO_FIELD_SELECTED_MESSAGE',defaultMessage:'No Field Selected'},FIELD_PAGE_TITLE:{id:'FIELD_PAGE_TITLE',defaultMessage:"Manage Fields for Catalog '{catalogName}'"},FIELD_REVERT_CONFIRM_MSG:{id:'FIELD_REVERT_CONFIRM_MSG',defaultMessage:'Confirm: Revert the field?'},FIELD_TYPE_BLOB:{id:'FIELD_TYPE_BLOB',defaultMessage:'Blob'},FIELD_TYPE_BOOLEAN:{id:'FIELD_TYPE_BOOLEAN',defaultMessage:'Boolean'},FIELD_TYPE_DATETIME:{id:'FIELD_TYPE_DATETIME',defaultMessage:'Date/Time'},FIELD_TYPE_DECIMAL:{id:'FIELD_TYPE_DECIMAL',defaultMessage:'Decimal'},FIELD_TYPE_LANG_ALT:{id:'FIELD_TYPE_LANG_ALT',defaultMessage:'Lang Alt'},FIELD_TYPE_NUMBER:{id:'FIELD_TYPE_NUMBER',defaultMessage:'Number'},FIELD_TYPE_PICTURE:{id:'FIELD_TYPE_PICTURE',defaultMessage:'Picture'},FIELD_TYPE_STRING:{id:'FIELD_TYPE_STRING',defaultMessage:'String'},FIELD_TYPE_STRUCTURE:{id:'FIELD_TYPE_STRUCTURE',defaultMessage:'Structure'},FIELD_TYPE_TEXTBLOCK:{id:'FIELD_TYPE_TEXTBLOCK',defaultMessage:'Text Block'},FIELD_TYPE_UNKNOWN:{id:'FIELD_TYPE_UNKNOWN',defaultMessage:'Unknown'},FIELD_TYPE_URL:{id:'FIELD_TYPE_URL',defaultMessage:'URL'},FILE_IO_ERROR_MSG:{id:'FILE_IO_ERROR_MSG',defaultMessage:'There was an error uploading the file to the server.'},FILE_TYPES_SECTION_TITLE:{id:'FILE_TYPES_SECTION_TITLE',defaultMessage:'File Types'},FILE_TYPES_ERROR_NAME_EXISTS:{id:'FILE_TYPES_ERROR_NAME_EXISTS',defaultMessage:"The name '{name}' matches the name of an existing file type."},FILE_TYPES_LABEL_RESTORE_DEFAULTS:{id:'FILE_TYPES_LABEL_RESTORE_DEFAULTS',defaultMessage:'Reset Defaults'},FILE_TYPES_PROMPT_DISCARD_CHANGES:{id:'FILE_TYPES_PROMPT_DISCARD_CHANGES',defaultMessage:'Discard pending changes?'},FILE_TYPES_PROMPT_RESTORE_DEFAULTS:{id:'FILE_TYPES_PROMPT_RESTORE_DEFAULTS',defaultMessage:'Reset all FileTypes to their default values?'},FILE_TYPES_ADD_FILE_TYPE:{id:'FILE_TYPES_ADD_FILE_TYPE',defaultMessage:'Add File Type'},FILE_TYPES_UPDATE_FILE_TYPE:{id:'FILE_TYPES_UPDATE_FILE_TYPE',defaultMessage:'Update File Type'},FILE_TYPES_EXTENSIONS:{id:'FILE_TYPES_EXTENSIONS',defaultMessage:'Extensions'},FILE_WRONG_TYPE_ERROR_MSG:{id:'FILE_WRONG_TYPE_ERROR_MSG',defaultMessage:'This file is not a supported file type.\nPlease select a jpeg, gif or png file.'},FOLDER_PATH_AUTOSYNC_FILES_STRING:{id:'FOLDER_PATH_AUTOSYNC_FILES_STRING',defaultMessage:'Files'},FOLDER_PATH_ALREADY_EXIST_AS_FILE:{id:'FOLDER_PATH_ALREADY_EXIST_AS_FILE',defaultMessage:'A file exists with this name.'},FOLDER_PATH_DOES_NOT_EXIST:{id:'FOLDER_PATH_DOES_NOT_EXIST',defaultMessage:'Path does not exist.'},FOLDER_PATH_ERROR:{id:'FOLDER_PATH_ERROR',defaultMessage:'Error'},FOLDER_PATH_NOT_VERIFIED:{id:'FOLDER_PATH_NOT_VERIFIED',defaultMessage:'The folder path has not been verified.'},FOLDER_PATH_PATH:{id:'FOLDER_PATH_PATH',defaultMessage:'Path'},FOLDER_PATH_OPERATION_INVALID:{id:'FOLDER_PATH_OPERATION_INVALID',defaultMessage:'An invalid operation'},FOLDER_PATH_SUCCESS:{id:'FOLDER_PATH_SUCCESS',defaultMessage:'Success'},FOLDER_PATH_TYPE_AUTOSYNC:{id:'FOLDER_PATH_TYPE_AUTOSYNC',defaultMessage:'autosync'},FOLDER_PATH_TYPE_PREVIEW:{id:'FOLDER_PATH_TYPE_PREVIEW',defaultMessage:'preview'},FOLDER_PATH_UNKNOWN_FAULT:{id:'FOLDER_PATH_UNKNOWN_FAULT',defaultMessage:'An unknown fault'},french:{id:'french',defaultMessage:'French'},FULL_NAME:{id:'FULL_NAME',defaultMessage:'Full Name'},FULLY_QUALIFIED_DOMAIN_NAME:{id:'FULLY_QUALIFIED_DOMAIN_NAME',defaultMessage:'Fully Qualified Domain Name'},german:{id:'german',defaultMessage:'German'},DATA_COLLECTION_HELP_URL:{id:'DATA_COLLECTION_HELP_URL',defaultMessage:'https://help.portfoliosam.com/hc/en-us/articles/1260804371029'},DATA_COLLECTION_RTI_OPT_OUT_LABEL:{id:'DATA_COLLECTION_RTI_OPT_OUT_LABEL',defaultMessage:'I agree to share application usage data.'},DATA_COLLECTION_RTI_OPT_OUT_TEXT:{id:'DATA_COLLECTION_RTI_OPT_OUT_TEXT',defaultMessage:"Help us deliver the best solutions by sharing application usage with us.\n\nBy accepting, you'll help us gather important information that will guide us toward future quality and feature improvements. The information gathered helps us greatly understand your solution needs.\n\nYou can always change your mind at any time and discontinue sharing information.\n\nFor more information about how we use your information and to opt-out in the future please visit our help article page:"},DATA_COLLECTION_TITLE:{id:'DATA_COLLECTION_TITLE',defaultMessage:'Analytics'},GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL:{id:'GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL',defaultMessage:'Create AutoSync folders for new catalogs in this folder'},GLOBAL_SETTINGS_BACKGROUND_COLOR:{id:'GLOBAL_SETTINGS_BACKGROUND_COLOR',defaultMessage:'Background Color'},GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP:{id:'GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP',defaultMessage:'Background color of the login screen.'},GLOBAL_SETTINGS_CATALOG_DEFAULTS:{id:'GLOBAL_SETTINGS_CATALOG_DEFAULTS',defaultMessage:'Catalog Defaults'},GLOBAL_SETTINGS_CHOOSE_FILE:{id:'GLOBAL_SETTINGS_CHOOSE_FILE',defaultMessage:'Choose File'},GLOBAL_SETTINGS_CUSTOM_IMAGE:{id:'GLOBAL_SETTINGS_CUSTOM_IMAGE',defaultMessage:'Custom Image'},GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT:{id:'GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT',defaultMessage:'Approximate size should fit within 2400 x 1350 pixels.'},GLOBAL_SETTINGS_CUSTOM_TITLE:{id:'GLOBAL_SETTINGS_CUSTOM_TITLE',defaultMessage:'Custom Title'},GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP:{id:'GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP',defaultMessage:'The title that appears on the browser tab or bookmark.'},GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN:{id:'GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN',defaultMessage:'Customized Login Screen'},GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL:{id:'GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL',defaultMessage:'Default Role'},GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN:{id:'GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN',defaultMessage:'Default Login Screen'},GLOBAL_SETTINGS_EMAIL_CONFIGURATION:{id:'GLOBAL_SETTINGS_EMAIL_CONFIGURATION',defaultMessage:'Email Notifications'},GLOBAL_SETTINGS_FADEL:{id:'GLOBAL_SETTINGS_FADEL',defaultMessage:'FADEL Rights Cloud'},GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG:{id:'GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG',defaultMessage:'The location of AutoSync and Preview folders must be accessible to the server.'},GLOBAL_SETTINGS_IMAGE_URL:{id:'GLOBAL_SETTINGS_IMAGE_URL',defaultMessage:'Link'},GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP:{id:'GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP',defaultMessage:'Clicking the image will launch this URL in another browser window.'},GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG:{id:'GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG',defaultMessage:'To make changes, start the server or check for an expired server license.'},GLOBAL_SETTINGS_PREVIEW_PATH_LABEL:{id:'GLOBAL_SETTINGS_PREVIEW_PATH_LABEL',defaultMessage:'Save Previews for new catalogs in this folder'},GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS:{id:'GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS',defaultMessage:'Server Data Locations'},GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION:{id:'GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION',defaultMessage:'Portfolio Login Customization'},GLOBAL_SETTINGS_SSO_CREDENTIALS:{id:'GLOBAL_SETTINGS_SSO_CREDENTIALS',defaultMessage:'Single Sign-on Credentials'},GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP:{id:'GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP',defaultMessage:'Enter the user account that is associated with the Portfolio Server service for Kerberos authentication.'},GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL:{id:'GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL',defaultMessage:'Temporary Work folder'},GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG:{id:'GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG',defaultMessage:'The work folder will be changed the next time the server is restarted. The new folder will be located at: '},GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG:{id:'GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG',defaultMessage:'You must restart the server for this change to take effect.'},GLOBAL_SETTINGS_VAULT_CONFIGURATION:{id:'GLOBAL_SETTINGS_VAULT_CONFIGURATION',defaultMessage:'Portfolio Vault Configuration'},GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL:{id:'GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL',defaultMessage:'Portfolio Vault folder'},SERVER_DATA_DEFAULT_VAULT_LOCATION_IS:{id:'SERVER_DATA_DEFAULT_VAULT_LOCATION_IS',defaultMessage:'Default:'},GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE:{id:'GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE',defaultMessage:'To change this folder, first shut down Portfolio server'},GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE:{id:'GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE',defaultMessage:'To move Portfolio Vault folder, first shut down Portfolio server.'},HELP_URL:{id:'HELP_URL',defaultMessage:'https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm'},HELP_URL_FADEL:{id:'HELP_URL_FADEL',defaultMessage:'https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/03_Catalogs/05_FADEL.htm'},HOSTNAME:{id:'HOSTNAME',defaultMessage:'Hostname'},IDENTITY_SERVICE_DEFAULT_ROLE_STRING:{id:'IDENTITY_SERVICE_DEFAULT_ROLE_STRING',defaultMessage:'(default)'},IDENTITY_SERVICE_SUCCESSFUL_CREATION:{id:'IDENTITY_SERVICE_SUCCESSFUL_CREATION',defaultMessage:'Directory Service connection succeeded. Configuration saved.'},IMAGE_FILE_FILTER:{id:'IMAGE_FILE_FILTER',defaultMessage:'Images (jpg, gif, png)'},IMPORT_LDAP:{id:'IMPORT_LDAP',defaultMessage:'Import users from LDAP/AD server'},IMPORT_LDAP_SPECIFY_SERVER:{id:'IMPORT_LDAP_SPECIFY_SERVER',defaultMessage:'Specify LDAP/AD Server'},IMPORT_MENU_STRING:{id:'IMPORT_MENU_STRING',defaultMessage:'Import Values'},IMPORT_SOURCE:{id:'IMPORT_SOURCE',defaultMessage:'Import Source'},INVALID_DN_SYNTAX_ERROR:{id:'INVALID_DN_SYNTAX_ERROR',defaultMessage:'Unable to connect to the directory service due to invalid DN syntax error. Please check the username.'},japanese:{id:'japanese',defaultMessage:'Japanese'},LAST_CERTIFICATE_REQUEST_LABEL:{id:'LAST_CERTIFICATE_REQUEST_LABEL',defaultMessage:'Last Certificate Request'},LAST_MODIFIED_BY:{id:'LAST_MODIFIED_BY',defaultMessage:'Last Modified By'},LAST_MODIFIED_DATE:{id:'LAST_MODIFIED_DATE',defaultMessage:'Date Last Modified'},LDAP_ADDRESS:{id:'LDAP_ADDRESS',defaultMessage:'LDAP/AD Server address'},LDAP_BIND_USERNAME:{id:'LDAP_BIND_USERNAME',defaultMessage:'LDAP Bind Username'},LDAP_SYNC_NOTIFICATION:{id:'LDAP_SYNC_NOTIFICATION',defaultMessage:'The server has received the sync request.'},LIC_ACTIVATE:{id:'LIC_ACTIVATE',defaultMessage:'Activate Portfolio'},LIC_ADD_MESSAGE:{id:'LIC_ADD_MESSAGE',defaultMessage:'Copy and Paste Licenses or enter individually one per row.'},LIC_ADD_SN:{id:'LIC_ADD_SN',defaultMessage:'Add New License'},LIC_ADD_SN_SHORT:{id:'LIC_ADD_SN_SHORT',defaultMessage:'Add Licenses'},LIC_ASSET_CAP_DISPLAY:{id:'LIC_ASSET_CAP_DISPLAY',defaultMessage:'Assets'},LIC_CLICK_TO_ACTIVATE:{id:'LIC_CLICK_TO_ACTIVATE',defaultMessage:'Activate Portfolio with your Extensis credentials'},LIC_CLICK_TO_UPGRADE:{id:'LIC_CLICK_TO_UPGRADE',defaultMessage:'Click to upgrade Portfolio Server'},LIC_CLICK_TO_USE:{id:'LIC_CLICK_TO_USE',defaultMessage:'Try Portfolio for a limited time with a Demo Serial Number'},LIC_DAYS_REMAINING:{id:'LIC_DAYS_REMAINING',defaultMessage:'({days} Days Remaining)'},LIC_DEMO_PERIOD:{id:'LIC_DEMO_PERIOD',defaultMessage:'Demo Period'},LIC_ERROR_MSG:{id:'LIC_ERROR_MSG',defaultMessage:'Invalid serial number, please re-try. If the problem persists check your server log or contact your administrator.'},LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG:{id:'LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG',defaultMessage:'The serial number cannot be added to Portfolio Studio.'},LIC_MAINTENANCE_END_DATE:{id:'LIC_MAINTENANCE_END_DATE',defaultMessage:'Maintenance/Subscription End Date'},LIC_SEAT_DISPLAY:{id:'LIC_SEAT_DISPLAY',defaultMessage:'User Seats'},LIC_TRIAL:{id:'LIC_TRIAL',defaultMessage:'Try Portfolio'},LITE_CANNOT_CREATE_FDB_CATALOG:{id:'LITE_CANNOT_CREATE_FDB_CATALOG',defaultMessage:'Your Portfolio license does not allow more than one catalog. Please consider upgrading your Portfolio license to perform this action.'},LITE_CANNOT_SERVE_FDB_CATALOG:{id:'LITE_CANNOT_SERVE_FDB_CATALOG',defaultMessage:'Your Portfolio Server license does not allow further catalogs to be taken online.'},LITE_THIS_FEATURE_NOT_SUPPORTED:{id:'LITE_THIS_FEATURE_NOT_SUPPORTED',defaultMessage:'Your Portfolio Server license does not support this action.'},LOGGING_CONFIGURATION:{id:'LOGGING_CONFIGURATION',defaultMessage:'Logging Configuration'},LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE:{id:'LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE',defaultMessage:'To move Logs folder, first shut down Portfolio server.'},LOGGING_DEFAULT_LOCATION_MSG:{id:'LOGGING_DEFAULT_LOCATION_MSG',defaultMessage:'The default log location is'},LOGGING_DIR_MUST_EXIST:{id:'LOGGING_DIR_MUST_EXIST',defaultMessage:'NOTE: In order to successfully change the log directory, the newly specified directory must already exist and be writeable by the user under which the Portfolio Server is running.'},LOGGING_LOG_DIR:{id:'LOGGING_LOG_DIR',defaultMessage:'Logs folder'},LOGGING_LOG_LEVEL:{id:'LOGGING_LOG_LEVEL',defaultMessage:'Log level'},LOGGING_NUM_LOGS_TO_RETAIN:{id:'LOGGING_NUM_LOGS_TO_RETAIN',defaultMessage:'Number of logs to retain'},LOGIN:{id:'LOGIN',defaultMessage:'Login'},MAPPING_HEADER:{id:'MAPPING_HEADER',defaultMessage:'User/Group Mapping to Portfolio'},MAPPINGS_HAVE_BEEN_MODIFIED_ALERT:{id:'MAPPINGS_HAVE_BEEN_MODIFIED_ALERT',defaultMessage:'The mappings have been modified, would you like to save them?'},MEDIA_ENGINE_NOT_OPERATIONAL:{id:'MEDIA_ENGINE_NOT_OPERATIONAL',defaultMessage:'The media engine could not be accessed.'},MEDIA_ENGINE_OPERATIONAL:{id:'MEDIA_ENGINE_OPERATIONAL',defaultMessage:'The media engine is operational.'},MEDIA_ENGINES_ACTION_ADD:{id:'MEDIA_ENGINES_ACTION_ADD',defaultMessage:'Add New Media Engine'},MEDIA_ENGINES_ACTION_DELETE:{id:'MEDIA_ENGINES_ACTION_DELETE',defaultMessage:'Delete Media Engine'},MEDIA_ENGINES_ACTION_EDIT:{id:'MEDIA_ENGINES_ACTION_EDIT',defaultMessage:'View/Edit Media Engine Details'},MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE:{id:'MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE',defaultMessage:'You can not add another active Media Engine because the server is already using the maximum number of active media engines allowed by your Portfolio Media Engine license.'},MEDIA_ENGINES_CANT_ADD_NO_LICENSES:{id:'MEDIA_ENGINES_CANT_ADD_NO_LICENSES',defaultMessage:"You can not add a Media Engine because the server doesn't have any available Portfolio Media Engine licenses."},MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER:{id:'MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER',defaultMessage:'You can not remove the built in Media Engine.'},MEDIA_ENGINES_COLUMN_ACTIVE:{id:'MEDIA_ENGINES_COLUMN_ACTIVE',defaultMessage:'Active'},MEDIA_ENGINES_COLUMN_ADDRESS:{id:'MEDIA_ENGINES_COLUMN_ADDRESS',defaultMessage:'Address'},MEDIA_ENGINES_COLUMN_PORT:{id:'MEDIA_ENGINES_COLUMN_PORT',defaultMessage:'Port'},MEDIA_ENGINES_COLUMN_TEST:{id:'MEDIA_ENGINES_COLUMN_TEST',defaultMessage:'Test'},MEDIA_ENGINES_CONFIRM_DELETE:{id:'MEDIA_ENGINES_CONFIRM_DELETE',defaultMessage:'Do you want to delete the selected Media Engine?'},MEDIA_ENGINES_EDIT_DETAILS_HEADER:{id:'MEDIA_ENGINES_EDIT_DETAILS_HEADER',defaultMessage:'Media Engine Details'},MEDIA_ENGINES_LICENSES_LABEL:{id:'MEDIA_ENGINES_LICENSES_LABEL',defaultMessage:'Media Engine seats available for activation'},MEDIA_ENGINES_NEW_DETAILS_HEADER:{id:'MEDIA_ENGINES_NEW_DETAILS_HEADER',defaultMessage:'New Media Engine Details'},MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE:{id:'MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE',defaultMessage:'No Media Engines are active. You should activate a Media Engine before clients need to use Portfolio Media services.'},MOBILE_TITLE:{id:'MOBILE',defaultMessage:'Mobile'},MOBILE_ENABLED:{id:'MOBILE_ENABLED',defaultMessage:'Enable Mobile Uploading'},MOBILE_FOLDER_VERBIAGE:{id:'MOBILE_FOLDER_VERBIAGE',defaultMessage:'Save mobile uploads to this folder:'},MOBILE_CREATE_CATALOG_VERBIAGE:{id:'MOBILE_CREATE_CATALOG_VERBIAGE',defaultMessage:"Create new catalog 'Mobile Uploads' to automatically watch this folder (recommended)"},MOBILE_CATALOG_NAME:{id:'MOBILE_CATALOG_NAME',defaultMessage:'Mobile Uploads'},modifyAssetContents:{id:'modifyAssetContents',defaultMessage:'Check Out Assets'},modifyAssetProperties:{id:'modifyAssetProperties',defaultMessage:'Update Asset Fields'},MODIFY_LDAP:{id:'MODIFY_LDAP',defaultMessage:'Modify LDAP query'},NAME:{id:'NAME',defaultMessage:'Name'},NAME_TOO_LONG_ERROR:{id:'NAME_TOO_LONG_ERROR',defaultMessage:'Name must be less than 256 characters.'},NAV_ABOUT:{id:'NAV_ABOUT',defaultMessage:'About'},NAV_ACCESS_LEVELS:{id:'NAV_ACCESS_LEVELS',defaultMessage:'Roles'},NAV_AUTOSYNC:{id:'NAV_AUTOSYNC',defaultMessage:'Autosync'},NAV_BACKUPS:{id:'NAV_BACKUPS',defaultMessage:'Backup/Restore'},NAV_CATALOGS:{id:'NAV_CATALOGS',defaultMessage:'Catalogs'},NAV_GLOBAL_SETTINGS:{id:'NAV_GLOBAL_SETTINGS',defaultMessage:'Global Settings'},NAV_HELP:{id:'NAV_HELP',defaultMessage:'Help'},NAV_LICENSES:{id:'NAV_LICENSES',defaultMessage:'Licenses'},NAV_LOGOUT:{id:'NAV_LOGOUT',defaultMessage:'Logout'},NAV_MEDIA_ENGINES:{id:'NAV_MEDIA_ENGINES',defaultMessage:'Media Engines'},NAV_NETPUBLISH_SETTINGS:{id:'NAV_NETPUBLISH_SETTINGS',defaultMessage:'NetPublish'},NAV_PORTS:{id:'NAV_PORTS',defaultMessage:'Ports'},NAV_REPORTING:{id:'NAV_REPORTING',defaultMessage:'Reports'},NAV_SETTINGS:{id:'NAV_SETTINGS',defaultMessage:'Settings'},NAV_STATUS:{id:'NAV_STATUS',defaultMessage:'Status'},NAV_USERS:{id:'NAV_USERS',defaultMessage:'Users'},NP_SITES:{id:'NP_SITES',defaultMessage:'NetPublish Sites'},NP_SITE_DELETE_LABEL:{id:'NP_SITE_DELETE_LABEL',defaultMessage:'Delete Site'},NP_SITE_ENABLED_LABEL:{id:'NP_SITE_ENABLED_LABEL',defaultMessage:'Site Enabled'},NO_CATALOGS:{id:'NO_CATALOGS',defaultMessage:'None'},NO_CATALOGS_EXIST:{id:'NO_CATALOGS_EXIST',defaultMessage:'No Catalogs exist.\n\nClick the + button to create a Catalog.'},NO_FILE_SELECTED:{id:'NO_FILE_SELECTED',defaultMessage:'No File Selected'},NO_SITES_EXIST_1:{id:'NO_SITES_EXIST_1',defaultMessage:'No NetPublish Sites exist.'},NO_SITES_EXIST_2:{id:'NO_SITES_EXIST_2',defaultMessage:'Use the Publish option found within Portfolio to create and publish Sites.'},VaultFolderNotFound:{id:'VaultFolderNotFound',defaultMessage:'The Portfolio Vault folder was not found at {path}.'},NO_VAULT_FOLDER:{id:'NO_VAULT_FOLDER',defaultMessage:'The Portfolio Vault folder was not found at {path}.\n\nPlease check the location of the folder on your file system, and in the Global Settings -> Server Data page of this application.'},NOTES:{id:'NOTES',defaultMessage:'Notes'},NOTIFICATION_FAILURE_ADD:{id:'NOTIFICATION_FAILURE_ADD',defaultMessage:'Add Unsuccessful'},NOTIFICATION_SUCCESS_UPDATE:{id:'NOTIFICATION_SUCCESS_UPDATE',defaultMessage:'Update Successful'},NOTIFICATION_FAILURE_UPDATE:{id:'NOTIFICATION_FAILURE_UPDATE',defaultMessage:'Update Unsuccessful'},NP_DELETE_SITE_CONFIRMATION:{id:'NP_DELETE_SITE_CONFIRMATION',defaultMessage:'Do you want to permanently delete the Site?'},NP_SOURCE:{id:'NP_SOURCE',defaultMessage:'Source'},NUMBER_DECIMAL_POINT_COUNT_ERROR:{id:'NUMBER_DECIMAL_POINT_COUNT_ERROR',defaultMessage:'The decimal separator can only occur once.'},NUMBER_EXCEEDS_MAX_ERROR:{id:'NUMBER_EXCEEDS_MAX_ERROR',defaultMessage:'The number entered is too large.'},NUMBER_INTEGER_ERROR:{id:'NUMBER_INTEGER_ERROR',defaultMessage:'The number must be an integer.'},NUMBER_INVALID_CHAR_ERROR:{id:'NUMBER_INVALID_CHAR_ERROR',defaultMessage:'The input contains invalid characters.'},NUMBER_INVALID_FORMAT_CHARS_ERROR:{id:'NUMBER_INVALID_FORMAT_CHARS_ERROR',defaultMessage:'One of the formatting parameters is invalid.'},NUMBER_LOWER_THAN_MIN_ERROR:{id:'NUMBER_LOWER_THAN_MIN_ERROR',defaultMessage:'The amount entered is too small.'},NUMBER_NEGATIVE_ERROR:{id:'NUMBER_NEGATIVE_ERROR',defaultMessage:'The amount may not be negative.'},NUMBER_PRECISION_ERROR:{id:'NUMBER_PRECISION_ERROR',defaultMessage:'The amount entered has too many digits beyond the decimal point.'},NUMBER_SEPARATION_ERROR:{id:'NUMBER_SEPARATION_ERROR',defaultMessage:'The thousands separator must be followed by three digits.'},OK:{id:'OK',defaultMessage:'OK'},ON_DATE:{id:'ON_DATE',defaultMessage:'on'},OPEN_DIRECTORY:{id:'OPEN_DIRECTORY',defaultMessage:'Open Directory'},OPEN_DIRECTORY_GROUPS:{id:'OPEN_DIRECTORY_GROUPS',defaultMessage:'Groups'},ORGANIZATION_NAME:{id:'ORGANIZATION_NAME',defaultMessage:'Organization Name'},ORGANIZATIONAL_UNIT:{id:'ORGANIZATIONAL_UNIT',defaultMessage:'Organizational Unit'},PASSWORD:{id:'PASSWORD',defaultMessage:'Password'},PASSWORD_CONFIRM:{id:'PASSWORD_CONFIRM',defaultMessage:'Confirm Password'},PASSWORD_TOO_LONG_ERROR:{id:'PASSWORD_TOO_LONG_ERROR',defaultMessage:'Password must be less than 256 characters.'},PORT:{id:'PORT',defaultMessage:'Port'},PORT_VALUE_TOO_HIGH_ERROR:{id:'PORT_VALUE_TOO_HIGH_ERROR',defaultMessage:'Port value must be less than 65536.'},PortfolioAssetCap:{id:'PortfolioAssetCap',defaultMessage:'Portfolio Asset Cap'},PortfolioAPI:{id:'PortfolioAPI',defaultMessage:'Portfolio API'},PortfolioDemo:{id:'PortfolioDemo',defaultMessage:'Demo'},PortfolioDirServices:{id:'PortfolioDirServices',defaultMessage:'Portfolio Directory Services'},PortfolioServer:{id:'PortfolioServer',defaultMessage:'Portfolio Server'},PortfolioStudio:{id:'PortfolioStudio',defaultMessage:'Portfolio Studio Edition'},PortfolioProfessional:{id:'PortfolioProfessional',defaultMessage:'Portfolio Professional Edition'},PortfolioEnterprise:{id:'PortfolioEnterprise',defaultMessage:'Portfolio Enterprise Edition'},PortfolioMediaEngine:{id:'PortfolioMediaEngine',defaultMessage:'Portfolio Media Engine'},NetPublish:{id:'NetPublish',defaultMessage:'Portfolio NetPublish'},PortfolioMobile:{id:'PortfolioMobile',defaultMessage:'Portfolio Flow'},PortfolioSmartKeywords:{id:'PortfolioSmartKeywords',defaultMessage:'Portfolio Smart Keywords'},PortfolioUserConnection:{id:'PortfolioUserConnection',defaultMessage:'Portfolio User Connection'},PortfolioSingleSignOn:{id:'PortfolioSingleSignOn',defaultMessage:'Single Sign On (SSO)'},PORT_TITLE:{id:'PORT_TITLE',defaultMessage:'Ports'},PORT_DEFAULT:{id:'PORT_DEFAULT',defaultMessage:'Default:'},PORT_CURRENT_VALUE:{id:'PORT_CURRENT_VALUE',defaultMessage:'Current Value'},PORT_ERROR_MSG_BAD_PORT_VALUE:{id:'PORT_ERROR_MSG_BAD_PORT_VALUE',defaultMessage:'The new port value must be a number between 1 and 65535.'},PORT_ERROR_MSG_CONFLICT:{id:'PORT_ERROR_MSG_CONFLICT',defaultMessage:'Can not update port values because one or more of the new port values is already in use on the server.'},PORT_FIND_PORT:{id:'PORT_FIND_PORT',defaultMessage:'Find Port'},PORT_NAME:{id:'PORT_NAME',defaultMessage:'Name'},PORT_NEW_VALUE:{id:'PORT_NEW_VALUE',defaultMessage:'New Value'},PORT_RESTART_NOTICE:{id:'PORT_RESTART_NOTICE',defaultMessage:'Note: port updates do not take effect until the server is restarted.'},PORT_RESTART_SERVER:{id:'PORT_RESTART_SERVER',defaultMessage:'Restart Server'},PORT_UPDATE_PORTS:{id:'PORT_UPDATE_PORTS',defaultMessage:'Update Ports'},PORT_WARNING_ADMIN_RESTART:{id:'PORT_WARNING_ADMIN_RESTART',defaultMessage:'The admin port was changed. The browser will be redirected to the new location in {numSecs} seconds.'},PREVIEW_MAX_VIDEO_RESOLUTION_360:{id:'PREVIEW_MAX_VIDEO_RESOLUTION_360',defaultMessage:'360p'},PREVIEW_MAX_VIDEO_RESOLUTION_480:{id:'PREVIEW_MAX_VIDEO_RESOLUTION_480',defaultMessage:'480p'},PREVIEW_MAX_VIDEO_RESOLUTION_540:{id:'PREVIEW_MAX_VIDEO_RESOLUTION_540',defaultMessage:'540p HD'},PREVIEW_MAX_VIDEO_RESOLUTION_720:{id:'PREVIEW_MAX_VIDEO_RESOLUTION_720',defaultMessage:'720p HD'},PREVIEW_MAX_VIDEO_RESOLUTION_1080:{id:'PREVIEW_MAX_VIDEO_RESOLUTION_1080',defaultMessage:'1080p HD'},PROMPT_ARE_YOU_SURE:{id:'PROMPT_ARE_YOU_SURE',defaultMessage:'Are you sure?'},PROMPT_COULD_NOT_CREATE_FOLDER:{id:'PROMPT_COULD_NOT_CREATE_FOLDER',defaultMessage:'That folder could not be created. Please enter another path.'},PROMPT_COULD_NOT_CREATE_FOLDERS:{id:'PROMPT_COULD_NOT_CREATE_FOLDERS',defaultMessage:'Please enter another folder path because the following paths could not be created:'},PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT:{id:'PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT',defaultMessage:"That folder could not be created because there's already a file with that name. Please enter another path."},PROMPT_CREATE_THAT_FOLDER:{id:'PROMPT_CREATE_THAT_FOLDER',defaultMessage:'That folder does not exist. Create it?'},PROMPT_CREATE_THESE_FOLDERS:{id:'PROMPT_CREATE_THESE_FOLDERS',defaultMessage:'These folders do not exist. Do you want to create them?'},PROMPT_DELETE_LICENSE_CONFIRM:{id:'PROMPT_DELETE_LICENSE_CONFIRM',defaultMessage:'Do you want to delete the selected license?'},QUERY:{id:'QUERY',defaultMessage:'Query'},REMOVE:{id:'REMOVE',defaultMessage:'Remove'},REMOVE_DIRECTORY_SERVICE:{id:'REMOVE_DIRECTORY_SERVICE',defaultMessage:'Remove Service'},REPLACE_USER_MAPPING_CONFIRMATION:{id:'REPLACE_USER_MAPPING_CONFIRMATION',defaultMessage:'A regular user mapping already exists for this user. Replace it with an exclude user mapping?'},REPLACE_USER_EXCLUSION_CONFIRMATION:{id:'REPLACE_USER_EXCLUSION_CONFIRMATION',defaultMessage:'An exclude user mapping already exists for this user. Replace it with a regular user mapping?'},REQUIRED_FIELD_ERROR:{id:'REQUIRED_FIELD_ERROR',defaultMessage:'This field is required.'},REVERT:{id:'REVERT',defaultMessage:'Revert'},REVERT_CHANGES:{id:'REVERT_CHANGES',defaultMessage:'Revert Changes'},ROLES_CREATE_ROLE_TITLE:{id:'ROLES_CREATE_ROLE_TITLE',defaultMessage:'Create Role'},ROLES_DELETE_CONFIRM:{id:'ROLES_DELETE_CONFIRM',defaultMessage:'Do you want to delete the selected Role?\nUsers with this Role will be demoted to Readers.'},ROLE_FOR_IMPORT:{id:'ROLE_FOR_IMPORT',defaultMessage:'Role for Import'},ROLES_PERMISSIONS:{id:'ROLES_PERMISSIONS',defaultMessage:'Permissions'},ROLES_PERMISSION_ENABLED_HEADER:{id:'ROLES_PERMISSION_ENABLED_HEADER',defaultMessage:'Enabled'},ROLES_PERMISSION_NAME_HEADER:{id:'ROLES_PERMISSION_NAME_HEADER',defaultMessage:'Operation'},SAVE:{id:'SAVE',defaultMessage:'Save'},SAVE_MAPPING:{id:'SAVE_MAPPING',defaultMessage:'Save Mapping'},saveOutputSetting:{id:'saveOutputSetting',defaultMessage:'Manage Presets (Convert and Make PDF)'},SEARCH:{id:'SEARCH',defaultMessage:'Search'},SEARCH_BASE:{id:'SEARCH_BASE',defaultMessage:'Search Base'},SEARCH_RESULTS:{id:'SEARCH_RESULTS',defaultMessage:'Search Results'},SECURITY_GROUPS:{id:'SECURITY_GROUPS',defaultMessage:'Security Groups'},SELECT:{id:'SELECT',defaultMessage:'Select'},SEND_DIAGNOSTIC_DATA:{id:'SEND_DIAGNOSTIC_DATA',defaultMessage:'Send diagnostic report to Extensis'},SERVER_DATA_DEFAULT_WORK_LOCATION_IS:{id:'SERVER_DATA_DEFAULT_WORK_LOCATION_IS',defaultMessage:'Default work location: '},SERVER_RESTART_REQUIRED:{id:'SERVER_RESTART_REQUIRED',defaultMessage:'The server must be restarted for changes to take effect.'},SERVER_STATE_ERROR:{id:'SERVER_STATE_ERROR',defaultMessage:'Error: See Admin Log for Details'},SERVER_STATE_STARTED:{id:'SERVER_STATE_STARTED',defaultMessage:'Running'},SERVER_STATE_STARTING:{id:'SERVER_STATE_STARTING',defaultMessage:'Starting'},SERVER_STATE_STOPPED:{id:'SERVER_STATE_STOPPED',defaultMessage:'Stopped'},SERVER_STATE_STOPPING:{id:'SERVER_STATE_STOPPING',defaultMessage:'Stopping'},SERVER_STATE_UNKNOWN:{id:'SERVER_STATE_UNKNOWN',defaultMessage:'Unknown'},SERVICE_BROWSER:{id:'SERVICE_BROWSER',defaultMessage:'Service Browser'},SK_ENGINE_APPAREL:{id:'SK_ENGINE_APPAREL',defaultMessage:'Apparel'},SK_ENGINE_ART_STYLE:{id:'SK_ENGINE_ART_STYLE',defaultMessage:'Art Style'},SK_ENGINE_ART_SUBJECT:{id:'SK_ENGINE_ART_SUBJECT',defaultMessage:'Art Subject'},SK_ENGINE_ART_MOVEMENT:{id:'SK_ENGINE_ART_MOVEMENT',defaultMessage:'Art Movement'},SK_ENGINE_CELEBRITIES:{id:'SK_ENGINE_CELEBRITIES',defaultMessage:'Celebrities'},SK_ENGINE_FOOD:{id:'SK_ENGINE_FOOD',defaultMessage:'Food'},SK_ENGINE_GENERAL:{id:'SK_ENGINE_GENERAL',defaultMessage:'General'},SK_ENGINE_LOGO:{id:'SK_ENGINE_LOGO',defaultMessage:'Logo'},SK_ENGINE_MODERATION:{id:'SK_ENGINE_MODERATION',defaultMessage:'Moderation'},SK_ENGINE_NSFW:{id:'SK_ENGINE_NSFW',defaultMessage:'NSFW'},SK_ENGINE_TRAVEL:{id:'SK_ENGINE_TRAVEL',defaultMessage:'Travel'},SK_ENGINE_WEDDINGS:{id:'SK_ENGINE_WEDDINGS',defaultMessage:'Weddings'},SSL_HANDSHAKE_ERROR:{id:'SSL_HANDSHAKE_ERROR',defaultMessage:'SSL handshake failed; please verify that the port and SSL settings are correct.'},STARTS_WITH:{id:'STARTS_WITH',defaultMessage:'starts with'},STATE_OR_PROVINCE:{id:'STATE_OR_PROVINCE',defaultMessage:'State or Province'},STATUS:{id:'STATUS',defaultMessage:'Status'},STATUS_ADMIN_LOG:{id:'STATUS_ADMIN_LOG',defaultMessage:'Admin Log'},STATUS_API_VERSION_LABEL:{id:'STATUS_API_VERSION_LABEL',defaultMessage:'API'},STATUS_API_STATE_LICENSED:{id:'STATUS_API_STATE_LICENSED',defaultMessage:'Licensed'},STATUS_API_STATE_UNLICENSED:{id:'STATUS_API_STATE_UNLICENSED',defaultMessage:'Not licensed'},STATUS_CLEAR_ADMIN_LOG:{id:'STATUS_CLEAR_ADMIN_LOG',defaultMessage:'Clear Admin Log'},STATUS_CONNECTED_USERS:{id:'STATUS_CONNECTED_USERS',defaultMessage:'Connected Users'},STATUS_MAX_ALLOWED_CONNECTIONS:{id:'STATUS_MAX_ALLOWED_CONNECTIONS',defaultMessage:'Maximum Connections'},STATUS_MEDIA_ENGINE_VERSION_LABEL:{id:'STATUS_MEDIA_ENGINE_VERSION_LABEL',defaultMessage:'Media Engine'},STATUS_MEDIA_ENGINES_ACTIVE:{id:'STATUS_MEDIA_ENGINES_ACTIVE',defaultMessage:'Active'},STATUS_MEDIA_ENGINES_LABEL:{id:'STATUS_MEDIA_ENGINES_LABEL',defaultMessage:'Media Engines'},STATUS_RESTART_SERVER:{id:'STATUS_RESTART_SERVER',defaultMessage:'Restart Portfolio'},STATUS_SEAT_USAGE:{id:'STATUS_SEAT_USAGE',defaultMessage:'Seat Usage'},STATUS_SERVER_STATE:{id:'STATUS_SERVER_STATE',defaultMessage:'Portfolio State'},STATUS_SERVER_VERSION_LABEL:{id:'STATUS_SERVER_VERSION_LABEL',defaultMessage:'Portfolio'},STATUS_START_SERVER:{id:'STATUS_START_SERVER',defaultMessage:'Start Portfolio'},STATUS_STOP_SERVER:{id:'STATUS_STOP_SERVER',defaultMessage:'Stop Portfolio'},STATUS_PROBLEMS_DETECTED:{id:'STATUS_PROBLEMS_DETECTED',defaultMessage:'Problems detected:'},STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM:{id:'STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM',defaultMessage:'Remaining startup disk space is under {minSpace}GB.'},STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS:{id:'STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS',defaultMessage:'The system memory is {value}GB which is below the {minGB}GB minimum requirements.'},STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE:{id:'STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE',defaultMessage:'The system memory computed by Portfolio is {value}GB which may be inaccurate.'},STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST:{id:'STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST',defaultMessage:'The work folder does not exist or is inaccessible.'},STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE:{id:'STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE',defaultMessage:'The Portfolio server cannot write to the work folder.'},STATUS_MSG_WORK_FOLDER_NOT_READABLE:{id:'STATUS_MSG_WORK_FOLDER_NOT_READABLE',defaultMessage:'The Portfolio server cannot read from the work folder.'},STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE:{id:'STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE',defaultMessage:'The Portfolio server cannot create symlinks in the work folder.'},STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW:{id:'STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW',defaultMessage:'Remaining work folder disk space is under {minSpace}GB.'},STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS:{id:'STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS',defaultMessage:'Unable to get work folder status.'},STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED:{id:'STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED',defaultMessage:'The status for elasticsearch index {index} is red.'},STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS:{id:'STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS',defaultMessage:'The elasticsearch index {index} has uninitialized shards.'},STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE:{id:'STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE',defaultMessage:'Not all shards are active for the elasticsearch index {index}.'},STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS:{id:'STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS',defaultMessage:'Unable to retrieve elasticsearch status.'},STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER:{id:'STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER',defaultMessage:'Unable to retrieve errors from the Portfolio server.'},STATUS_MSG_STARTUP_FAILED:{id:'STATUS_MSG_STARTUP_FAILED',defaultMessage:'Startup failed'},STATUS_MSG_CANT_GET_SERVER_HEALTH:{id:'STATUS_MSG_CANT_GET_SERVER_HEALTH',defaultMessage:'Unable to update server health.'},STATUS_MSG_NATIVE_AGENT_NOT_RUNNING:{id:'STATUS_MSG_NATIVE_AGENT_NOT_RUNNING',defaultMessage:'The native-agent server component is not running.'},SUBJECT_ALTERNATIVE_NAMES:{id:'SUBJECT_ALTERNATIVE_NAMES',defaultMessage:'Subject Alternative Names'},SUBMIT:{id:'SUBMIT',defaultMessage:'Submit'},swedish:{id:'swedish',defaultMessage:'Swedish'},SYNC_DAILY:{id:'SYNC_DAILY',defaultMessage:'Synchronize Daily'},synchronizeAutoSyncFolder:{id:'synchronizeAutoSyncFolder',defaultMessage:'Sync Autosync Folders'},SYNCHRONIZE_NOW:{id:'SYNCHRONIZE_NOW',defaultMessage:'Synchronize Now'},TARGET_CATALOG:{id:'TARGET_CATALOG',defaultMessage:'Target Catalog'},THIS_LOCALE:{id:'THIS_LOCALE',defaultMessage:'en'},TRUE_LABEL:{id:'TRUE_LABEL',defaultMessage:'True'},TOKEN:{id:'TOKEN',defaultMessage:'Token'},TOTAL_ASSETS:{id:'TOTAL_ASSETS',defaultMessage:'Total Assets'},TWO_LETTER_COUNTRY_CODE:{id:'TWO_LETTER_COUNTRY_CODE',defaultMessage:'Two-letter Country Code'},TYPE:{id:'TYPE',defaultMessage:'Type'},UNABLE_CONNECT_LDAP:{id:'UNABLE_CONNECT_LDAP',defaultMessage:'Unable to connect to LDAP/AD server.'},UNABLE_CONNECT_SERVER:{id:'UNABLE_CONNECT_SERVER',defaultMessage:'Unable to connect to server.'},UNKNOWN_HOST_ERROR:{id:'UNKNOWN_HOST_ERROR',defaultMessage:'Unable to connect to directory service due to an unknown host exception. Please check the hostname.'},UNKNOWN_LDAP_USER_ERROR:{id:'UNKNOWN_LDAP_USER_ERROR',defaultMessage:"No user was found in the Identity Service with the account name '{accountName}'."},useCustomPresets:{id:'useCustomPresets',defaultMessage:'Use Convert Presets'},USE_SSL:{id:'USE_SSL',defaultMessage:'Use SSL'},USER_ACCOUNT:{id:'USER_ACCOUNT',defaultMessage:'Account'},USER_CREATE:{id:'USER_CREATE',defaultMessage:'Add New User'},USER_DELETE:{id:'USER_DELETE',defaultMessage:'Delete Users'},USER_DELETE_CONFIRM:{id:'USER_DELETE_CONFIRM',defaultMessage:'Delete Selected Users?'},USER_DELETE__DELETE_PRIVATE:{id:'USER_DELETE__DELETE_PRIVATE',defaultMessage:'Permanently Deleted'},USER_DELETE__GALLERY_PROMPT:{id:'USER_DELETE__GALLERY_PROMPT',defaultMessage:'Make Public makes all private and read-only galleries that belong to this user, public galleries. "Delete All Private Galleries" permanently removes private galleries, and makes read-only galleries public.'},USER_DELETE__GALLERY_PROMPT_1:{id:'USER_DELETE__GALLERY_PROMPT_1',defaultMessage:"The users' Checked Out items will be reverted and made accessible."},USER_DELETE__GALLERY_PROMPT_2:{id:'USER_DELETE__GALLERY_PROMPT_2',defaultMessage:"The users' Read-Only Galleries will be made Public."},USER_DELETE__GALLERY_PROMPT_3:{id:'USER_DELETE__GALLERY_PROMPT_3',defaultMessage:"The users' Private Galleries should be:"},USER_DELETE__MAKE_PUBLIC:{id:'USER_DELETE__MAKE_PUBLIC',defaultMessage:'Made Public'},USER_DETAILS:{id:'USER_DETAILS',defaultMessage:'User Details'},USER_IMPORT:{id:'USER_IMPORT',defaultMessage:'Import Users'},USER_IMPORT_ACCOUNT:{id:'USER_IMPORT_ACCOUNT',defaultMessage:'Account Name'},USER_IMPORT_ACCOUNT_ATTR:{id:'USER_IMPORT_ACCOUNT_ATTR',defaultMessage:'Account Attribute'},USER_IMPORT_EMAIL_ATTR:{id:'USER_IMPORT_EMAIL_ATTR',defaultMessage:'Email Attribute'},USER_IMPORT_IMPORT:{id:'USER_IMPORT_IMPORT',defaultMessage:'Import'},USER_IMPORT_IMPORT_SELECTED_USERS:{id:'USER_IMPORT_IMPORT_SELECTED_USERS',defaultMessage:'Import Selected Users'},USER_IMPORT_MODIFY_SEARCH:{id:'USER_IMPORT_MODIFY_SEARCH',defaultMessage:'Modify Search'},USER_IMPORT_NAME_ATTR:{id:'USER_IMPORT_NAME_ATTR',defaultMessage:'Account Name Attribute'},USER_IMPORT_NOTES_ATTR:{id:'USER_IMPORT_NOTES_ATTR',defaultMessage:'Notes Attribute'},USER_IMPORT_PASSWORD:{id:'USER_IMPORT_PASSWORD',defaultMessage:'Account Password'},USER_IMPORT_PASSWORD_ATTR:{id:'USER_IMPORT_PASSWORD_ATTR',defaultMessage:'Password Attribute'},USER_IMPORT_SEARCH:{id:'USER_IMPORT_SEARCH',defaultMessage:'Search'},USER_IMPORT_SEARCH_BASE:{id:'USER_IMPORT_SEARCH_BASE',defaultMessage:'Search Base'},USER_IMPORT_SEARCH_FILTER:{id:'USER_IMPORT_SEARCH_FILTER',defaultMessage:'Search Filter'},USER_IMPORT_SERVER_ADDRESS:{id:'USER_IMPORT_SERVER_ADDRESS',defaultMessage:'Server Address'},USER_IMPORT_SPECIFY_LDAP_SERVER:{id:'USER_IMPORT_SPECIFY_LDAP_SERVER',defaultMessage:'Specify LDAP Server'},USER_LEVEL_ADMINISTRATOR:{id:'USER_LEVEL_ADMINISTRATOR',defaultMessage:'Catalog Administrator'},USER_LEVEL_EDITOR:{id:'USER_LEVEL_EDITOR',defaultMessage:'Editor'},USER_LEVEL_NON_MEMBER:{id:'USER_LEVEL_NON_MEMBER',defaultMessage:'--'},USER_LEVEL_PUBLISHER:{id:'USER_LEVEL_PUBLISHER',defaultMessage:'Publisher'},USER_LEVEL_READER:{id:'USER_LEVEL_READER',defaultMessage:'Reader'},USER_MANAGE_CATALOGS:{id:'USER_MANAGE_CATALOGS',defaultMessage:'Manage Catalogs for Selected Users'},USER_MULT_USERS_SELECTED:{id:'USER_MULT_USERS_SELECTED',defaultMessage:'Multiple Users Selected'},USER_NAME:{id:'USER_NAME',defaultMessage:'User Name'},USER_NEW_USER_DETAILS:{id:'USER_NEW_USER_DETAILS',defaultMessage:'New User Details'},USER_NEW_USER_INFO_MSG:{id:'USER_NEW_USER_INFO_MSG',defaultMessage:'To add a user to specific catalogs, use Catalogs > Users.'},USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS:{id:'USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS',defaultMessage:'Add user to all catalogs as:'},USER_NO_USERS_SELECTED:{id:'USER_NO_USERS_SELECTED',defaultMessage:'No Users Selected'},USER_ONLINE:{id:'USER_ONLINE',defaultMessage:'Online'},USER_PASSWORD_TOO_SHORT:{id:'USER_PASSWORD_TOO_SHORT',defaultMessage:'Password must contain at least one character.'},USER_PASSWORDS_DO_NOT_MATCH:{id:'USER_PASSWORDS_DO_NOT_MATCH',defaultMessage:'The password confirmation field needs to match the password field.'},USER_ROLE:{id:'USER_ROLE',defaultMessage:'Role'},USER_VIEW_DETAILS:{id:'USER_VIEW_DETAILS',defaultMessage:'View/Edit User Details'},USERS:{id:'USERS',defaultMessage:'Users'},VALIDATION_FIELD_LENGTH_EXCEEDED:{id:'VALIDATION_FIELD_LENGTH_EXCEEDED',defaultMessage:'This field cannot exceed 255 characters.'},VALIDATION_MUST_BE_NONEMPTY:{id:'VALIDATION_MUST_BE_NONEMPTY',defaultMessage:'This field is required.'},VIEW_EDIT_MAPPINGS:{id:'VIEW_EDIT_MAPPINGS',defaultMessage:'View / Edit Mappings'},couldNotConnect:{id:'AUTH.couldNotConnect',defaultMessage:'Could not connect to the server. Please check the address.'},serverUnavailable:{id:'ERROR.serverUnavailable',defaultMessage:'The Portfolio server is not available.'},sessionExpired:{id:'ERROR.sessionExpired',defaultMessage:'Your session has expired.'},fileNotFound:{id:'fileNotFound',defaultMessage:'The file was not found on disk.'},invalidSearchFailed:{id:'ERROR.invalidSearchFailed',defaultMessage:'The search failed because there was a problem with the query.'},loginFailed:{id:'AUTH.loginFailed',defaultMessage:'The username and password were incorrect.'},insufficientPrivileges:{id:'FAULT_CODE.InsufficientPrivileges',defaultMessage:'You have insufficient privileges to perform this operation.'},unexpectedError:{id:'unexpectedError',defaultMessage:'An unexpected error occurred.'},refresh:{id:'REFRESH',defaultMessage:'Refresh'},// Reports
ALL_CATALOGS:{id:'ALL_CATALOGS',defaultMessage:'All Catalogs'},ALL_SITES:{id:'ALL_SITES',defaultMessage:'All Sites'},ASSET_DOWNLOADS:{id:'ASSET_DOWNLOADS',defaultMessage:'Assets - Most Downloaded'},ASSET_PREVIEWS:{id:'ASSET_PREVIEWS',defaultMessage:'Assets - Most Previewed'},ASSET_UPLOADS:{id:'ASSET_UPLOADS',defaultMessage:'Assets - Uploads'},DOWNLOAD_REPORT:{id:'DOWNLOAD_REPORT',defaultMessage:'Download Report'},FILE_TYPES:{id:'FILE_TYPES',defaultMessage:'File Types'},FROM:{id:'FROM',defaultMessage:'From'},SITE:{id:'SITE',defaultMessage:'Site'},KEYWORD_STATISTICS:{id:'KEYWORD_STATISTICS',defaultMessage:'Keyword Statistics'},NETPUBLISH_MOST_DOWNLOADED:{id:'NETPUBLISH_MOST_DOWNLOADED',defaultMessage:'NetPublish - Most Downloaded'},NETPUBLISH_USAGE:{id:'NETPUBLISH_USAGE',defaultMessage:'NetPublish - Usage'},REPORT_NAME_DELETED_BY:{id:'REPORT_NAME_DELETED_BY',defaultMessage:'Assets - Deletions'},REPORT_NAME_DOWNLOADED_BY:{id:'REPORT_NAME_DOWNLOADED_BY',defaultMessage:'Assets - Downloads'},REPORT_DESCRIPTION_ASSET_PREVIEWS:{id:'REPORT_DESCRIPTION_ASSET_PREVIEWS',defaultMessage:'This report identifies which assets were previewed and how many times each was previewed.'},REPORT_DESCRIPTION_ASSET_UPLOADS:{id:'REPORT_DESCRIPTION_ASSET_UPLOADS',defaultMessage:'This report identifies uploaded assets, which users uploaded them, and when.'},REPORT_DESCRIPTION_DELETED_BY:{id:'REPORT_DESCRIPTION_DELETED_BY',defaultMessage:'This report identifies deleted assets, which users deleted them, and when.'},REPORT_DESCRIPTION_DOWNLOADED_BY:{id:'REPORT_DESCRIPTION_DOWNLOADED_BY',defaultMessage:'This report identifies downloaded assets, which users downloaded them, and when.'},REPORT_DESCRIPTION_DOWNLOADED:{id:'REPORT_DESCRIPTION_DOWNLOADED',defaultMessage:'This report identifies which assets were downloaded and how many times each was downloaded.'},REPORT_DESCRIPTION_KEYWORD:{id:'REPORT_DESCRIPTION_KEYWORD',defaultMessage:'This report identifies all the keywords in a catalog and how many assets they are applied to.'},REPORT_DESCRIPTION_USAGE:{id:'REPORT_DESCRIPTION_USAGE',defaultMessage:'This report identifies which users downloaded which assets, and when.'},REPORT_DESCRIPTION_FILE_TYPES:{id:'REPORT_DESCRIPTION_FILE_TYPES',defaultMessage:'This report identifies your most common file types and how much disk space they occupy.'},REPORT_DESCRIPTION_SEARCH_TERMS:{id:'REPORT_DESCRIPTION_SEARCH_TERMS',defaultMessage:'This report identifies the most common words and phrases for which your users are searching in QuickFind.'},SEARCH_TERMS:{id:'SEARCH_TERMS',defaultMessage:'Search Terms'},TO:{id:'TO',defaultMessage:'To'},VIEW_REPORT:{id:'VIEW_REPORT',defaultMessage:'View Report'},REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE:{id:'REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE',defaultMessage:'Remove { affectedUsersCount, plural, one {User} other {{affectedUsersCount} Users} } from Catalog'},REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG:{id:'REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG',defaultMessage:"Are you sure you want to remove the { affectedUsersCount, plural, one {user} other {selected users} } from the catalog?\n\nThe { affectedUsersCount, plural, one {user's} other {selected users'} } Checked Out items in this catalog will be reverted and made accessible."},CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG:{id:'CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG',defaultMessage:"Are you sure you want to change the { affectedUsersCount, plural, one {user's role} other {selected users' roles} } in the catalog?\n\nThis action can be destructive to the { affectedUsersCount, plural, one {user's} other {selected users'} } data if the new role has reduced access or permissions."},DUPLICATE_FIELD_NAME_ERROR:{id:'DUPLICATE_FIELD_NAME_ERROR',defaultMessage:'Duplicate Field Name'},EXTENSIS_CONTACT_US_URL:{id:'EXTENSIS_CONTACT_US_URL',defaultMessage:'https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option'},EXTENSIS_SUPPORT_URL:{id:'EXTENSIS_SUPPORT_URL',defaultMessage:'https://help.portfoliodam.com/hc/en-us/requests/new'},LIC_CONTACT_CUSTOMER_SUCCESS_1:{id:'LIC_CONTACT_CUSTOMER_SUCCESS_1',defaultMessage:'For assistance with renewing your account, please contact us at'},LIC_CONTACT_CUSTOMER_SUCCESS_2:{id:'LIC_CONTACT_CUSTOMER_SUCCESS_2',defaultMessage:'and your Customer Success Manager will contact you within 1 business day.'},LIC_ERROR_GET_ACCOUNT:{id:'LIC_ERROR_GET_ACCOUNT',defaultMessage:'There was a problem getting your Extensis Account.'},LIC_ERROR_GET_LICENSES:{id:'LIC_ERROR_GET_LICENSES',defaultMessage:'There was a problem retrieving your licenses from Extensis.'},LIC_SET_EXTENSIS_ACCOUNT:{id:'LIC_SET_EXTENSIS_ACCOUNT',defaultMessage:'Set Extensis Account'},LIC_SET_ACCOUNT:{id:'LIC_SET_ACCOUNT',defaultMessage:'Set Account'},LIC_REMOVE_ACCOUNT:{id:'LIC_REMOVE_ACCOUNT',defaultMessage:'Remove Account'},LIC_ACCOUNT:{id:'LIC_ACCOUNT',defaultMessage:'Email'},LIC_PASSWORD:{id:'LIC_PASSWORD',defaultMessage:'Password'},LIC_SYSTEM_ID:{id:'LIC_SYSTEM_ID',defaultMessage:'System ID'},LIC_SET_ACCOUNT_ERROR:{id:'LIC_SET_ACCOUNT_ERROR',defaultMessage:'There was a problem setting your Extensis Account. Please check the credentials and try again.'},LIC_SET_SYSTEM_TITLE:{id:'LIC_SET_SYSTEM_TITLE',defaultMessage:'Select Your Extensis System'},PDL_noPredefinedValues:{id:'PDL_noPredefinedValues',defaultMessage:'No Predefined Values'},PDL_editPredefinedListPlaceholder:{id:'PDL_editPredefinedListPlaceholder',defaultMessage:'Edit Predefined List'},PDL_importPredefinedValues:{id:'PDL_importPredefinedValues',defaultMessage:'Import Predefined Values'},PDL_exportPredefinedValues:{id:'PDL_exportPredefinedValues',defaultMessage:'Export Predefined Values'},PDL_removeNestedValueConfirmation:{id:'PDL_removeNestedValueConfirmation',defaultMessage:'Delete the selected values?\nThey contain nested values which will also be deleted.'},PDL_wrongPdlImportFormat:{id:'PDL_wrongPdlImportFormat',defaultMessage:'The selected file did not contain text data. Please select a text file.'}});/* harmony default export */ __webpack_exports__["a"] = (localizedStrings);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADMIN_USER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SN_TYPE_STUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SN_TYPE_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SN_TYPE_NETPUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SN_TYPE_SINGLESIGNON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SN_TYPE_USERCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SN_TYPE_MEDIAENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SN_TYPE_ASSETCAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SN_TYPE_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SN_TYPE_DEMO; });
/* unused harmony export SN_TYPE_SMART_KEYWORDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PRODUCT_TYPE_DEMO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PRODUCT_TYPE_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PRODUCT_TYPE_STUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PRODUCT_TYPE_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ASSET_CAP_QUANTUM; });
/* unused harmony export SMART_KEYWORDS_ASSET_CAP_QUANTUM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MAX_NUM_ASSETS; });
/* unused harmony export MAX_NUM_CATALOGS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MAX_NUM_MEDIAENGINES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return MAX_NUM_SEATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MAX_NUM_ASSETS_STUDIO; });
/* unused harmony export MAX_NUM_CATALOGS_STUDIO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return MAX_NUM_MEDIAENGINES_STUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return MAX_NUM_SEATS_STUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return MEDIA_ENGINE_TYPE_BUILT_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return MEDIA_ENGINE_DEFAULT_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SERVER_STATE_STARTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SERVER_STATE_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SERVER_STATE_STOPPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SERVER_STATE_STOPPING; });
/* unused harmony export SERVER_STATE_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CATALOG_PROPERTY_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CATALOG_STORAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CATALOG_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DEFAULT_CATALOG_TYPE_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABOUT_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_EXTRACT_MAPPING_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_LICENSE_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BACKUP_RESTORE_PROGRESS_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CATALOG_TEMPLATES_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BROWSE_SERVER_FOLDERS_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CERT_UPLOAD_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CONFIRM_USER_ROLE_CHANGE_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CREATE_CATALOG_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CREATE_CERT_REQUEST_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CREATE_FIELD_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CREATE_MEDIA_ENGINE_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CREATE_METADATA_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CREATE_METADATA_FORM_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CREATE_USER_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CREATE_XMP_NAMESPACE_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DELETE_USER_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DELETE_VAULT_CATALOG_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DIAGNOSTIC_DATA_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DIR_SVC_MAPPINGS_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return METADATA_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_ACCOUNT_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SET_SYSTEM_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return XMP_NAMESPACE_PANEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CREATE_USER_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return USER_DETAILS_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CREATE_FIELD_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BRANDING_SETTINGS_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return EMAIL_CONFIG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return appVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return buildVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLEANUP_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONFIDENCE_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return NUM_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_BRANDING_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BRANDING_UPLOAD_FILENAME; });
var API='/api/v1';var STORAGE_KEY='portfolioAdmin';var ADMIN_USER_NAME='administrator';// Product Ids
var SN_TYPE_STUDIO='PS';var SN_TYPE_SERVER='PP';var SN_TYPE_NETPUBLISH='NP';var SN_TYPE_SINGLESIGNON='SO';var SN_TYPE_USERCOUNT='PC';var SN_TYPE_MEDIAENGINE='ME';var SN_TYPE_ASSETCAP='AS';var SN_TYPE_API='PA';var SN_TYPE_DEMO='PD';var SN_TYPE_SMART_KEYWORDS='SK';var SN_LENGTH=29;// Product Types
var PRODUCT_TYPE_DEMO='Demo';var PRODUCT_TYPE_SERVER='Server';var PRODUCT_TYPE_STUDIO='Studio';var PRODUCT_TYPE_NONE='None';// Feature Constraints
var ASSET_CAP_QUANTUM=250000;var SMART_KEYWORDS_ASSET_CAP_QUANTUM=250000;var MAX_NUM_ASSETS=10000000;var MAX_NUM_CATALOGS=9999;var MAX_NUM_MEDIAENGINES=5;var MAX_NUM_SEATS=1000;var MAX_NUM_ASSETS_STUDIO=100000;var MAX_NUM_CATALOGS_STUDIO=1;var MAX_NUM_MEDIAENGINES_STUDIO=1;var MAX_NUM_SEATS_STUDIO=3;// Media Engine Constants
var MEDIA_ENGINE_TYPE_BUILT_IN='BuiltIn';var MEDIA_ENGINE_DEFAULT_PORT=9877;// Server Running States
var SERVER_STATE_STARTING='starting';var SERVER_STATE_STARTED='started';var SERVER_STATE_STOPPED='stopped';var SERVER_STATE_STOPPING='stopping';var SERVER_STATE_UNKNOWN='unknown';// Catalog Properties
var CATALOG_PROPERTY_KEY={CATALOG_DETAILS:'catalogDetails',CATALOGING_OPTIONS:'catalogingOptions',DISK_PREVIEW_INFO:'diskPreviewInfo',EXCLUSION_INFO:'exclusionInfo',SMART_KEYWORDS_SETTINGS:'smartKeywordsSettings',INGEST_CONFIG:'ingestConfig',INGEST_CONFIG_PREDEF:'ingestConfig_predef'};var CATALOG_STORAGE_TYPE={FILESYSTEM:'Filesystem',VAULT:'Vault',S3:'S3'};var CATALOG_STATUS={OFFLINE:'offline',ONLINE:'online'};var DEFAULT_CATALOG_TYPE_NAMES=['Allgemeine Verwendung','General Use','Utilisation générale','汎用'];// Dialog Ids
var ABOUT_PANEL_ID='ABOUT_PANEL_ID';var ADD_EXTRACT_MAPPING_PANEL_ID='ADD_EXTRACT_MAPPING_PANEL_ID';var ADD_LICENSE_PANEL_ID='ADD_LICENSE_PANEL_ID';var BACKUP_RESTORE_PROGRESS_PANEL_ID='BACKUP_RESTORE_PROGRESS_PANEL_ID';var CATALOG_TEMPLATES_PANEL_ID='CATALOG_TEMPLATES_PANEL_ID';var BROWSE_SERVER_FOLDERS_PANEL_ID='BROWSE_SERVER_FOLDERS_PANEL_ID';var CERT_UPLOAD_PANEL_ID='CERT_UPLOAD_PANEL_ID';var CONFIRM_USER_ROLE_CHANGE_PANEL_ID='CONFIRM_USER_ROLE_CHANGE_PANEL_ID';var CREATE_CATALOG_PANEL_ID='CREATE_CATALOG_PANEL_ID';var CREATE_CERT_REQUEST_PANEL_ID='CREATE_CERT_REQUEST_PANEL_ID';var CREATE_FIELD_PANEL_ID='CREATE_FIELD_PANEL_ID';var CREATE_MEDIA_ENGINE_PANEL_ID='CREATE_MEDIA_ENGINE_PANEL_ID';var CREATE_METADATA_PANEL_ID='CREATE_METADATA_PANEL_ID';var CREATE_METADATA_FORM_ID='CREATE_METADATA_FORM_ID';var CREATE_USER_PANEL_ID='CREATE_USER_PANEL_ID';var CREATE_XMP_NAMESPACE_PANEL_ID='CREATE_XMP_NAMESPACE_PANEL_ID';var DELETE_USER_PANEL_ID='DELETE_USER_PANEL_ID';var DELETE_VAULT_CATALOG_PANEL_ID='DELETE_VAULT_CATALOG_PANEL_ID';var DIAGNOSTIC_DATA_PANEL_ID='DIAGNOSTIC_DATA_PANEL_ID';var DIR_SVC_MAPPINGS_PANEL_ID='DIR_SVC_MAPPINGS_PANEL_ID';var METADATA_PANEL_ID='METADATA_PANEL_ID';var SET_ACCOUNT_PANEL_ID='SET_ACCOUNT_PANEL_ID';var SET_SYSTEM_PANEL_ID='SET_SYSTEM_PANEL_ID';var XMP_NAMESPACE_PANEL_ID='XMP_NAMESPACE_PANEL_ID';// Form Ids
var CREATE_USER_FORM='CREATE_USER_FORM';var USER_DETAILS_FORM='USER_DETAILS_FORM';var CREATE_FIELD_FORM='CREATE_FIELD_FORM';var BRANDING_SETTINGS_FORM='BRANDING_SETTINGS_FORM';var EMAIL_CONFIG_FORM='EMAIL_CONFIG_FORM';// Versions
var appVersion="4.1.1"||'0.0.0';var buildVersion="20260306-35161b9d6"||'00000000-0000000';var version=appVersion+' ('+buildVersion+')';// Users
var CLEANUP_TOKEN={makePrivateGalleriesPublic:'make private galleries public',deletePrivateGalleries:'delete private galleries'};// Keys of persisted data
var USER_DATA={LOCALE:'locale'};// Smart Keyword Settings
var CONFIDENCE_LEVEL='confidenceLevel';var NUM_KEYWORDS='numKeywords';// AdminFileTransferServlet upload
var ACTION_BRANDING_UPLOAD='brandingUpload';var BRANDING_UPLOAD_FILENAME='web_client_login_screen_image';

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveDirectoryServiceMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActivePanelData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getActivePanelId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdminSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getApiVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAssetCapCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBackupConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBackupRestoreStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBrandingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCatalogExclusionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCatalogingOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCatalogProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCatalogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCatalogTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCertInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCertRequestData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getCreateAutosyncFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getCustomCatalogTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getCustomXMPNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getDefaultRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getDiagnosticDataStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getDirectoryServiceDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getDirectoryServiceDestination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getDirectoryServiceMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getDirectoryServiceQueryResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getDirectoryServiceQueryType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getDiskPreviewInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getDismissedMessageIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getEmailServerConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getEnabledMediaEnginesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getExtensisAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getExtensisSystems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getFieldNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getGlobalSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getHasIdentityService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getIdentityEncryptedPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getIdentitySession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getIngestConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getIsAdminServerRestarting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getIsCommunicatingWithDirectoryService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getIsDirectoryServiceMappingsDirty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getIsDirectoryServiceQueryPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getIsEmailServerConfigPendingValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getIsFullAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getIsLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getIsMediaEngineTestPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getIsPendingResponseFromBonfire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getIsRestarting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getIsSendingDiagnosticData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getIsServerPlatformWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getLastActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getLicensedFeatures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getLicenseMaintenanceEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getLicenses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getLoggingConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getMaxSeatCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getMediaEngines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getMediaEngineTotalSeatCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getMetadataDefinitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getMetadataMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getNPServerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getPorts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getReachoutMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getRoles; });
/* unused harmony export getRTIEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getSeatCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getSelectedDirectoryServiceNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getSelectedField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getSelectedFieldCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getSelectedFieldsListItemName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getSelectedRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getServerErrorStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getServerFolderRoot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getServerFolders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getServerRunState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getServerStartupFailureReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getServerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getSites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getSmartKeywordsSettings; });
/* unused harmony export getSmartKeywordsRemainingCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getTotalAssetCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getUseConstrainedIngest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getUserCatalogInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getUsername; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getUsers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_sharedConstants__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_serverUtils__ = __webpack_require__(37);
//
// Intl
//
var getIntl=function getIntl(state){return state.intl;};var getLocale=function getLocale(state){return state.intl.locale||'en';};//
// Analytics
//
var getRTIEnabled=function getRTIEnabled(state){return state.rti.rtiEnabled;};//
// Auth
//
var getIsFullAdmin=function getIsFullAdmin(state){return!!state.auth.adminSessionId;};var getHasIdentityService=function getHasIdentityService(state){return!!state.auth.identitySessionId;};var getIsLoggedIn=function getIsLoggedIn(state){return!!(state.auth.adminSessionId||state.auth.identitySessionId);};var getLastActivity=function getLastActivity(state){return state.auth.lastActivity;};var getUsername=function getUsername(state){return state.auth.username;};var getIdentityEncryptedPassword=function getIdentityEncryptedPassword(state){return state.auth.identityEncryptedPassword;};var getAdminSession=function getAdminSession(state){return state.auth.adminSessionId;};var getIdentitySession=function getIdentitySession(state){return state.auth.identitySessionId;};//
// Server
//
var getServerStatus=function getServerStatus(state){return state.server.serverStatus||null;};var getIsServerPlatformWindows=function getIsServerPlatformWindows(state){return state.server.serverOsPlatform===__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_sharedConstants__["a" /* PLATFORM_WINDOWS */];};var getServerFolderRoot=function getServerFolderRoot(state){return state.server.serverFolderRoot;};var getBackupConfig=function getBackupConfig(state){return state.server.backupConfig||null;};var getBackupRestoreStatus=function getBackupRestoreStatus(state){return state.server.backupRestoreStatus;};var getServerFolders=function getServerFolders(state){return state.server.serverFolders;};var getPorts=function getPorts(state){return state.server.ports||{};};var getGlobalSettings=function getGlobalSettings(state){return state.server.globalSettings;};var getLoggingConfig=function getLoggingConfig(state){return state.server.loggingConfig;};var getEmailServerConfiguration=function getEmailServerConfiguration(state){return state.server.emailServerConfiguration;};var getBrandingSettings=function getBrandingSettings(state){return state.server.brandingSettings;};var getIsEmailServerConfigPendingValidation=function getIsEmailServerConfigPendingValidation(state){return state.server.emailConfigValidationPending;};var getCreateAutosyncFolder=function getCreateAutosyncFolder(state){return!!state.server.globalSettings&&state.server.globalSettings[__WEBPACK_IMPORTED_MODULE_5_util_serverUtils__["a" /* GLOBAL_SETTING */].CREATE_AUTOSYNC_FOLDER]==='true';};// Admin Properties - errorMessages
var kStartupFailureId='startupFailure';function _getStartupFailureMessage(serverStatus){var message=null;if(serverStatus){var errorMessage=serverStatus.errorMessages.find(function(em){return em.id===kStartupFailureId;});if(errorMessage){message=errorMessage.parameters.reason;}}return message;}var getServerStartupFailureReason=function getServerStartupFailureReason(state){return _getStartupFailureMessage(state.server.serverStatus);};var getServerErrorStatuses=function getServerErrorStatuses(state){var serverStatus=state.server.serverStatus;return serverStatus?serverStatus.errorMessages.filter(function(em){return em.id!==kStartupFailureId;}):[];};var getDiagnosticDataStatus=function getDiagnosticDataStatus(state){return state.server.diagnosticDataStatus||'';};var getServerRunState=function getServerRunState(state){return state.server&&state.server.serverStatus&&state.server.serverStatus.runState||'';};var getProductVersions=function getProductVersions(state){return state.server&&state.server.serverStatus&&state.server.serverStatus.versions||[];};var getMediaEngines=function getMediaEngines(state){return state.server&&state.server.mediaEngines||[];};var getIsMediaEngineTestPending=function getIsMediaEngineTestPending(state){return state.server&&state.server.mediaEngineTestPending;};var getTotalAssetCount=function getTotalAssetCount(state){return state.server&&state.server.globalStatistics&&parseInt(state.server.globalStatistics.totalAssetCount,10)||0;};var getSeatCount=function getSeatCount(state){return state.server&&state.server.globalStatistics&&parseInt(state.server.globalStatistics.seatCount,10)||0;};var getSmartKeywordsRemainingCount=function getSmartKeywordsRemainingCount(state){return state.server&&state.server.globalStatistics&&parseInt(state.server.globalStatistics.smartKeywordsRemainingCount,10)||0;};var getApiVersion=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getProductVersions,function(productVersions){var server=productVersions.find(function(version){return version.componentName==='Server API';});return server&&server.versionNumber;});var getIsCommunicatingWithDirectoryService=function getIsCommunicatingWithDirectoryService(state){return state.server.isCommunicatingWithDirectoryService;};var getDirectoryServiceDescription=function getDirectoryServiceDescription(state){return state.server&&state.server.directoryServiceDescription;};//
// Directory Services
//
var getDirectoryServiceMappings=function getDirectoryServiceMappings(state){return state.dirSvc.mappings;};// TODO: more specific type
var getDirectoryServiceQueryResults=function getDirectoryServiceQueryResults(state){return state.dirSvc.queryResults;};var getIsDirectoryServiceQueryPending=function getIsDirectoryServiceQueryPending(state){return state.dirSvc.queryIsPending;};var getDirectoryServiceDestination=function getDirectoryServiceDestination(state){return state.dirSvc.destination;};var getDirectoryServiceQueryType=function getDirectoryServiceQueryType(state){return state.dirSvc.queryType;};var getSelectedDirectoryServiceNode=function getSelectedDirectoryServiceNode(state){return state.dirSvc.selectedNode;};var getActiveDirectoryServiceMapping=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getDirectoryServiceMappings,getDirectoryServiceDestination,function(mappings,destination){return mappings&&mappings.find(function(m){return m.targetGroupGuid===destination;});});var getIsDirectoryServiceMappingsDirty=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getDirectoryServiceMappings,function(mappings){return mappings.some(function(mapping){return mapping.entries.some(function(entry){return entry.unsaved;});});});//
// Reachout Messages
//
var getReachoutMessages=function getReachoutMessages(state){return state.server&&state.server.reachoutMessages;};var getDismissedMessageIds=function getDismissedMessageIds(state){return state.reachout&&state.reachout.dismissedMessageIds;};//
// Licenses
//
var getLicenses=function getLicenses(state){return state.server&&state.server.licenses||[];};var getExtensisAccount=function getExtensisAccount(state){return state.license.extensisAccount;};var getExtensisSystems=function getExtensisSystems(state){return state.license.extensisSystems;};var getLicenseMaintenanceEndDate=function getLicenseMaintenanceEndDate(state){return state.license.licenseMaintenanceEndDate;};var getIsPendingResponseFromBonfire=function getIsPendingResponseFromBonfire(state){return state.license.isPendingResponse;};function _getIsMainProduct(licenses,productId){var matchingLicense=licenses&&licenses.find(function(license){return license.productId===productId;});return!!(matchingLicense&&!matchingLicense.isExpiredLicense);}function _getMainProductType(licenses){if(_getIsMainProduct(licenses,__WEBPACK_IMPORTED_MODULE_1_util_constants__["_6" /* SN_TYPE_DEMO */])){return __WEBPACK_IMPORTED_MODULE_1_util_constants__["T" /* PRODUCT_TYPE_DEMO */];}else if(_getIsMainProduct(licenses,__WEBPACK_IMPORTED_MODULE_1_util_constants__["_11" /* SN_TYPE_STUDIO */])){return __WEBPACK_IMPORTED_MODULE_1_util_constants__["W" /* PRODUCT_TYPE_STUDIO */];}else if(_getIsMainProduct(licenses,__WEBPACK_IMPORTED_MODULE_1_util_constants__["_9" /* SN_TYPE_SERVER */])){return __WEBPACK_IMPORTED_MODULE_1_util_constants__["V" /* PRODUCT_TYPE_SERVER */];}else{return __WEBPACK_IMPORTED_MODULE_1_util_constants__["U" /* PRODUCT_TYPE_NONE */];}}function _hasLicenseForProductId(productId,licenses,isDemoMode,demoEnablesFeature){if(licenses){var match=licenses.find(function(license){return license.productId===productId;});return match&&!match.isExpiredLicense||demoEnablesFeature&&isDemoMode;}return false;}var getLicensedFeatures=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getLicenses,getLicenseMaintenanceEndDate,function(licenses,maintenanceEndDate){var productType=_getMainProductType(licenses);var isDemo=productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["T" /* PRODUCT_TYPE_DEMO */];var isServer=productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["V" /* PRODUCT_TYPE_SERVER */];return{api:_hasLicenseForProductId(__WEBPACK_IMPORTED_MODULE_1_util_constants__["_4" /* SN_TYPE_API */],licenses,isDemo,true),dirSvc:isDemo||isServer,main:_hasLicenseForProductId(__WEBPACK_IMPORTED_MODULE_1_util_constants__["_9" /* SN_TYPE_SERVER */],licenses,isDemo,true)||_hasLicenseForProductId(__WEBPACK_IMPORTED_MODULE_1_util_constants__["_11" /* SN_TYPE_STUDIO */],licenses,isDemo,false),me:_hasLicenseForProductId(__WEBPACK_IMPORTED_MODULE_1_util_constants__["_7" /* SN_TYPE_MEDIAENGINE */],licenses,isDemo,true),np:_hasLicenseForProductId(__WEBPACK_IMPORTED_MODULE_1_util_constants__["_8" /* SN_TYPE_NETPUBLISH */],licenses,isDemo,true),sk:!!(maintenanceEndDate&&new Date(maintenanceEndDate)>=Date.now())||isDemo,sso:_hasLicenseForProductId(__WEBPACK_IMPORTED_MODULE_1_util_constants__["_10" /* SN_TYPE_SINGLESIGNON */],licenses,isDemo,true)};});var getMediaEngineTotalSeatCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getLicenses,function(licenses){var me=licenses.find(function(license){return license.productId===__WEBPACK_IMPORTED_MODULE_1_util_constants__["_7" /* SN_TYPE_MEDIAENGINE */];});var productType=_getMainProductType(licenses);return productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["T" /* PRODUCT_TYPE_DEMO */]&&__WEBPACK_IMPORTED_MODULE_1_util_constants__["L" /* MAX_NUM_MEDIAENGINES */]||productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["W" /* PRODUCT_TYPE_STUDIO */]&&__WEBPACK_IMPORTED_MODULE_1_util_constants__["M" /* MAX_NUM_MEDIAENGINES_STUDIO */]||me&&me.numSeats||1// always return internal ME
;});var getEnabledMediaEnginesCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getMediaEngines,function(mediaEngines){var enabled=mediaEngines.filter(function(mediaEngine){return mediaEngine.enabled;});return enabled.length;});var getAssetCapCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getLicenses,function(licenses){var productType=_getMainProductType(licenses);var ac=licenses.find(function(license){return license.productId===__WEBPACK_IMPORTED_MODULE_1_util_constants__["_5" /* SN_TYPE_ASSETCAP */];});return productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["T" /* PRODUCT_TYPE_DEMO */]&&__WEBPACK_IMPORTED_MODULE_1_util_constants__["J" /* MAX_NUM_ASSETS */]||productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["W" /* PRODUCT_TYPE_STUDIO */]&&__WEBPACK_IMPORTED_MODULE_1_util_constants__["K" /* MAX_NUM_ASSETS_STUDIO */]||ac&&ac.numSeats*__WEBPACK_IMPORTED_MODULE_1_util_constants__["g" /* ASSET_CAP_QUANTUM */]||0;});var getMaxSeatCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getLicenses,function(licenses){var productType=_getMainProductType(licenses);var uc=licenses.find(function(license){return license.productId===__WEBPACK_IMPORTED_MODULE_1_util_constants__["_12" /* SN_TYPE_USERCOUNT */];});return productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["T" /* PRODUCT_TYPE_DEMO */]&&__WEBPACK_IMPORTED_MODULE_1_util_constants__["N" /* MAX_NUM_SEATS */]||productType===__WEBPACK_IMPORTED_MODULE_1_util_constants__["W" /* PRODUCT_TYPE_STUDIO */]&&__WEBPACK_IMPORTED_MODULE_1_util_constants__["O" /* MAX_NUM_SEATS_STUDIO */]||uc&&uc.numSeats||0;});var getIsRestarting=function getIsRestarting(state){return state.server.isRestarting;};var getIsAdminServerRestarting=function getIsAdminServerRestarting(state){return state.server.isAdminServerRestarting;};var getIsSendingDiagnosticData=function getIsSendingDiagnosticData(state){return state.server.isSendingDiagnosticData;};// Dialog Panel
var getActivePanelId=function getActivePanelId(_ref){var activeIds=_ref.dialogPanel.activeIds;return activeIds[activeIds.length-1];};var getActivePanelData=function getActivePanelData(_ref2){var _ref2$dialogPanel=_ref2.dialogPanel,activeIds=_ref2$dialogPanel.activeIds,data=_ref2$dialogPanel.data;return data[activeIds[activeIds.length-1]];};//
// Catalogs
//
var getCatalogs=function getCatalogs(state){return state.catalog.catalogs;};var getCatalogTypes=function getCatalogTypes(state){return state.catalog.catalogTypes;};var getCustomCatalogTemplates=function getCustomCatalogTemplates(state){return state.catalog.catalogTypes.filter(function(t){return t.guid;}).sort(function(a,b){return a.name.localeCompare(b.name);});};var getCatalogProperties=function getCatalogProperties(state){return state.catalog.catalogProperties;};var getCatalogingOptions=function getCatalogingOptions(state){return state.catalog.catalogProperties&&state.catalog.catalogProperties.catalogingOptions;};var getUseConstrainedIngest=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCatalogingOptions,function(catalogingOptions){return!!(catalogingOptions&&catalogingOptions.useConstrainedIngest);});var getCatalogExclusionInfo=function getCatalogExclusionInfo(state){return state.catalog.catalogProperties&&state.catalog.catalogProperties.exclusionInfo;};var getDiskPreviewInfo=function getDiskPreviewInfo(state){return state.catalog.catalogProperties&&state.catalog.catalogProperties.diskPreviewInfo;};var getFields=function getFields(state){return state.catalog.fields;};var getIngestConfig=function getIngestConfig(state){return state.catalog.catalogProperties&&state.catalog.catalogProperties.ingestConfig||{headerText:'',fields:[]};};var getSmartKeywordsSettings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCatalogProperties,function(catalogProperties){return catalogProperties&&catalogProperties.smartKeywordsSettings;});var getMetadataDefinitions=function getMetadataDefinitions(state){return state.catalog.metadataDefinitions;};var getMetadataMappings=function getMetadataMappings(state){return state.catalog.metadataMappings;};var getSelectedFieldCategory=function getSelectedFieldCategory(state){return state.catalog.selectedFieldCategory;};var getSelectedFieldsListItemName=function getSelectedFieldsListItemName(state){return state.catalog.selectedFieldsListItemName;};var getUserCatalogInfo=function getUserCatalogInfo(state){return state.catalog.userCatalogInfo;};var getSelectedField=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFields,getMetadataDefinitions,getSelectedFieldsListItemName,function(fields,mds,name){if(name){return Object(__WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__["r" /* fieldDefForFieldsListItemName */])(name,mds,fields);}return null;});var getFieldNames=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFields,function(fields){return fields.map(function(field){return field.systemName;});});var getCustomXMPNamespaces=function getCustomXMPNamespaces(state){return state.catalog.customXMPNamespaces;};//
// Roles
//
var getRoles=function getRoles(state){return state.roles.roles;};var getSelectedRole=function getSelectedRole(state){return state.roles.roles.find(function(role){return role.uuid===state.roles.selectedRoleId;});};var getDefaultRole=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getGlobalSettings,getRoles,function(globalSettings,roles){var defaultRoleName=globalSettings&&globalSettings[__WEBPACK_IMPORTED_MODULE_5_util_serverUtils__["a" /* GLOBAL_SETTING */].DEFAULT_USER_ACCESS_LEVEL];var foundRole=defaultRoleName&&roles.find(function(r){return r.name===defaultRoleName;});return foundRole||roles.find(function(r){return r.name===__WEBPACK_IMPORTED_MODULE_4_util_roleUtils__["c" /* NAME_PUBLISHER */];});});//
// Users
//
var getUsers=function getUsers(state){return state.user.users;};//
// NetPublish
//
var getSites=function getSites(state){return state.np.sites;};var getNPServerStatus=function getNPServerStatus(state){return state.np.status;};//
// Misc View Settings
//
var getNotifications=function getNotifications(state){return state.globalNotifications.notifications;};//
// Certs
//
var getCertInfo=function getCertInfo(state){return state.cert.certificate;};var getCertRequestData=function getCertRequestData(state){return state.cert.request;};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = bindActionCreatorsSafe;
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreatorsForm;
/* unused harmony export bindSafeDispatch */
/* harmony export (immutable) */ __webpack_exports__["c"] = handleError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_localizedError__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_authCommands__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_util_PortfolioError__ = __webpack_require__(194);
function bindActionCreatorsSafe(actionCreators){var optErrorMessages=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var isForm=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(dispatch){return Object.assign({// Always provide safe `dispatch` action
unsafeDispatch:dispatch,dispatch:bindSafeDispatch(dispatch,optErrorMessages,isForm)},Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(actionCreators,function(){return bindSafeDispatch(dispatch,optErrorMessages,isForm).apply(undefined,arguments);}));};}/*
 * Only use bindActionCreatorsForm() if you're using an action creator from within the
 * submit method of a redux-form.
 *
 * The redux-form submit method won't be invoked again while there are unresolved
 * promises, so bindSafeDispatch's practice of returning a forever-unresolved
 * promise to prevent the .then handler from being invoked won't work for this
 * case.
 */function bindActionCreatorsForm(actionCreators,optErrorMessages){return bindActionCreatorsSafe(actionCreators,optErrorMessages,true);}function bindSafeDispatch(dispatch,optErrorMessages,isForm){return function(){var r=dispatch.apply(undefined,arguments);// $FlowFixMe
if(r&&typeof r.catch==='function'){return r.catch(function(error){handleError(error,dispatch,optErrorMessages);if(isForm){throw new __WEBPACK_IMPORTED_MODULE_1_redux_form__["c" /* SubmissionError */]({_error:error.message});}else{// Return an empty promise that's never resolved. This way, .then() on
// callers will not get triggered.
// This might be a minor memory leak, but probably not.
return new Promise(function(){});}});}return r;};}function handleError(error,dispatch,optErrorMessages){var localizedMessage=void 0;var rawMessage=error.message||error;var faultCode=error.faultCode;if(optErrorMessages&&optErrorMessages.hasOwnProperty(faultCode)){localizedMessage=optErrorMessages[faultCode];}else if(faultCode===__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["b" /* FC_INSUFFICIENT_PRIVILEGES */]){localizedMessage=__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].insufficientPrivileges;}else if(faultCode===__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["a" /* FC_FILE_NOT_FOUND */]){localizedMessage=__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].fileNotFound;}else if(faultCode===__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["e" /* FC_SERVER_UNREACHABLE */]){localizedMessage=__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].serverUnavailable;dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_state_commands_authCommands__["b" /* logout */])());}else if(faultCode===__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["c" /* FC_INVALID_CREDENTIALS */]){localizedMessage=__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].sessionExpired;dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_state_commands_authCommands__["b" /* logout */])());}else if(faultCode===__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["d" /* FC_MALFORMED_QUERY_STRING */]){localizedMessage=__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].invalidSearchFailed;}else if(faultCode){// Log the error and present a bland 'unexpected error occurred' message to the user.
__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__["a" /* default */].error('faultCode: '+faultCode+' ',rawMessage);localizedMessage=__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].unexpectedError;}var notification=Object(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(localizedMessage?new __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_localizedError__["a" /* LocalizedError */](localizedMessage):rawMessage,__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]);dispatch(notification);}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(1012);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(1088);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(1114);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(1115);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(1116);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(1117);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(460);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(647);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellPosition */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_CellRenderer */
/* unused harmony export bpfrpt_proptype_CellCache */
/* unused harmony export bpfrpt_proptype_StyleCache */
/* unused harmony export bpfrpt_proptype_CellRangeRendererParams */
/* unused harmony export bpfrpt_proptype_CellRangeRenderer */
/* unused harmony export bpfrpt_proptype_CellSizeGetter */
/* unused harmony export bpfrpt_proptype_CellSize */
/* unused harmony export bpfrpt_proptype_NoContentRenderer */
/* unused harmony export bpfrpt_proptype_Scroll */
/* unused harmony export bpfrpt_proptype_ScrollbarPresenceChange */
/* unused harmony export bpfrpt_proptype_RenderedSection */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetterParams */
/* unused harmony export bpfrpt_proptype_OverscanIndices */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony export bpfrpt_proptype_Alignment */
/* unused harmony export bpfrpt_proptype_VisibleCellRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_CellPosition =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellCache =  true ? null : PropTypes.objectOf(PropTypes.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : PropTypes.objectOf(PropTypes.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: PropTypes.objectOf(PropTypes.node.isRequired).isRequired,
  cellRenderer: PropTypes.func.isRequired,
  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  deferredMeasurementCache: PropTypes.object,
  horizontalOffsetAdjustment: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isScrollingOptOut: PropTypes.bool.isRequired,
  parent: PropTypes.object.isRequired,
  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  styleCache: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
  verticalOffsetAdjustment: PropTypes.number.isRequired,
  visibleColumnIndices: PropTypes.object.isRequired,
  visibleRowIndices: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSize =  true ? null : PropTypes.oneOfType([PropTypes.func, PropTypes.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  clientWidth: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  scrollWidth: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: PropTypes.bool.isRequired,
  vertical: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: PropTypes.number.isRequired,
  columnOverscanStopIndex: PropTypes.number.isRequired,
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  rowOverscanStartIndex: PropTypes.number.isRequired,
  rowOverscanStopIndex: PropTypes.number.isRequired,
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: PropTypes.oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: PropTypes.number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: PropTypes.number.isRequired,


  // Begin of range of visible cells
  startIndex: PropTypes.number.isRequired,


  // End of range of visible cells
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_Alignment =  true ? null : PropTypes.oneOf(['auto', 'end', 'start', 'center']);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  start: PropTypes.number,
  stop: PropTypes.number
};




















/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showDialogPanel;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideDialogPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var showDialogPanelAction=__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel,hideDialogPanelAction=__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel;function showDialogPanel(panelId,data){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return dispatch(showDialogPanelAction(panelId,data));case 2:return _context.abrupt('return',_context.sent);case 3:case'end':return _context.stop();}}},_callee,this);}));function showDialogPanel(_x,_x2){return _ref.apply(this,arguments);}return showDialogPanel;}();}function hideDialogPanel(){return hideDialogPanelAction();}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return change; });
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* unused harmony export reset */
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return submit; });
/* unused harmony export touch */
/* unused harmony export unregisterField */
/* unused harmony export untouch */
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(286);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(287);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(288);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(289);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(575);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(576);
/* unused harmony reexport FormSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__SubmissionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["a"]; });
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(648);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(651);
/* unused harmony reexport FieldArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_14__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(669);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(673);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(675);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(677);
/* unused harmony reexport getFormValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(679);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_21__getFormMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(685);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(687);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(689);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(691);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(693);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(695);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(698);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_29__isValid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(700);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(702);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(704);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(740);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alpha__ = __webpack_require__(1118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Alpha__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkboard__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Checkboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditableInput__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__EditableInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Hue__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__Hue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Raised__ = __webpack_require__(1124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__Raised__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Saturation__ = __webpack_require__(1125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__Saturation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ColorWrap__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__ColorWrap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Swatch__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__Swatch__["a"]; });









/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIALOG_PANEL_SAVE_BUTTON_ID */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_localizedStrings__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_view_DialogPanel_DialogPanel_css__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_view_DialogPanel_DialogPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_view_DialogPanel_DialogPanel_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DIALOG_PANEL_SAVE_BUTTON_ID='dialog-panel-save-button';var DialogPanel=function(_Component){_inherits(DialogPanel,_Component);function DialogPanel(){_classCallCheck(this,DialogPanel);var _this=_possibleConstructorReturn(this,(DialogPanel.__proto__||Object.getPrototypeOf(DialogPanel)).call(this));_this.onRequestClose=_this.onRequestClose.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.onAfterOpen=_this.onAfterOpen.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}// this is called when the esc key is clicked
_createClass(DialogPanel,[{key:'onRequestClose',value:function onRequestClose(){this.onClose();}},{key:'onClose',value:function onClose(){this.props.onClose();this.props.hideDialogPanel();}},{key:'onSave',value:function onSave(){if(this.props.isOkEnabled()){this.props.onSave();if(this.props.closeAfterSave!==false){this.onClose();}}}},{key:'isOkEnabled',value:function isOkEnabled(){if(this.props&&this.props.isOkEnabled){return this.props.isOkEnabled();}else{return true;}}},{key:'handleKeyDown',value:function handleKeyDown(e){var wasHandled=false;if(this.props.handleKeyDown){wasHandled=this.props.handleKeyDown(e);}if(!wasHandled&&e.keyCode===13){this.onSave();}}},{key:'onAfterOpen',value:function onAfterOpen(){if(this.props.dialogFocusId){var target=document.getElementById(this.props.dialogFocusId);if(target){target.focus();if(target.select){target.select();}}}if(this.props.afterOpen){this.props.afterOpen();}}},{key:'render',value:function render(){var _this2=this;var modalStyles={overlay:{backgroundColor:'rgba(127, 127, 127, 0.65)',zIndex:4},content:{width:'800px',height:'700px',backgroundColor:'#fff',position:'absolute',top:'50%',left:'50%',right:'auto',bottom:'auto',overflow:'hidden'}};if(this.props.contentStyle){modalStyles.content=Object.assign({},modalStyles.content,this.props.contentStyle);}var isPanelOpen=this.props.panelId===this.props.activePanelId;var customButtonText=this.props.customButtonText?this.props.customButtonText:this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_localizedStrings__["a" /* default */].Save);var showCancel=this.props.showCancel!==false;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{contentLabel:'Modal Dialog',style:modalStyles,className:'dialog-panel',onRequestClose:this.onRequestClose,shouldCloseOnOverlayClick:false,closeTimeoutMS:150,isOpen:isPanelOpen,onAfterOpen:this.onAfterOpen,shouldReturnFocusAfterClose:false},this.props.panelHeader,!this.props.panelHeader&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dialog-panel-header','data-test-name':this.props.dataTestName||'dialog-panel-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'dialog-panel-title'},this.props.panelTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:this.props.panelSubtitle?'dialog-panel-subtitle':'dialog-panel-hidden'},this.props.panelSubtitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dialog-panel-body',onKeyDown:this.handleKeyDown},this.props.children),this.props.showFooter&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dialog-panel-buttons-container buttons'},this.props.lowerLeftButtonText&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',onClick:this.props.onClickLowerLeftButton,'data-test-name':'reset-defaults'},this.props.lowerLeftButtonText),function(){if(showCancel){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',onClick:_this2.onRequestClose,'data-test-name':'cancel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_localizedStrings__["a" /* default */].Cancel));}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:!this.isOkEnabled(),id:DIALOG_PANEL_SAVE_BUTTON_ID,className:'button is-primary',onClick:this.onSave,'data-test-name':'save'},customButtonText)));}}]);return DialogPanel;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);DialogPanel.propTypes={activePanelId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,afterOpen:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,children:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,closeAfterSave:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,contentStyle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,customButtonText:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,dataTestName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,dialogFocusId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,handleKeyDown:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,hideDialogPanel:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* intlShape */].isRequired,isOkEnabled:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onSave:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,panelHeader:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,// override the entire panel header (title & subtitle)
panelId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,panelSubtitle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,panelTitle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,showCancel:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,showFooter:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,lowerLeftButtonText:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,onClickLowerLeftButton:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};DialogPanel.defaultProps={panelTitle:'Default Panel Title',isOkEnabled:function isOkEnabled(){return true;},onClose:function onClose(){},onSave:function onSave(){},showFooter:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(DialogPanel));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(335);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["n"] = getCatalogs;
/* harmony export (immutable) */ __webpack_exports__["m"] = getCatalogTypes;
/* harmony export (immutable) */ __webpack_exports__["l"] = getCatalogProperties;
/* harmony export (immutable) */ __webpack_exports__["e"] = createCatalogTemplate;
/* harmony export (immutable) */ __webpack_exports__["y"] = restoreFileTypesDefault;
/* harmony export (immutable) */ __webpack_exports__["d"] = createCatalog;
/* harmony export (immutable) */ __webpack_exports__["h"] = deleteCatalog;
/* harmony export (immutable) */ __webpack_exports__["w"] = renameCatalog;
/* harmony export (immutable) */ __webpack_exports__["i"] = deleteCatalogTemplate;
/* harmony export (immutable) */ __webpack_exports__["x"] = renameCatalogTemplate;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateDiskPreviewInfo;
/* harmony export (immutable) */ __webpack_exports__["p"] = getFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = addFields;
/* harmony export (immutable) */ __webpack_exports__["E"] = updateFields;
/* harmony export (immutable) */ __webpack_exports__["u"] = removeFields;
/* harmony export (immutable) */ __webpack_exports__["s"] = removeAllPredefinedValues;
/* harmony export (immutable) */ __webpack_exports__["F"] = updatePredefinedList;
/* harmony export (immutable) */ __webpack_exports__["q"] = getMetadataDefinitions;
/* harmony export (immutable) */ __webpack_exports__["f"] = createMetadataDefinitions;
/* harmony export (immutable) */ __webpack_exports__["j"] = deleteMetadataDefinition;
/* harmony export (immutable) */ __webpack_exports__["r"] = getMetadataMappings;
/* harmony export (immutable) */ __webpack_exports__["g"] = createMetadataMappings;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteMetadataMappings;
/* harmony export (immutable) */ __webpack_exports__["z"] = setEmbedMetadataMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = addOrUpdateUserCatalogInfo;
/* harmony export (immutable) */ __webpack_exports__["v"] = removeUsersFromCatalog;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateCatalogingOptions;
/* harmony export (immutable) */ __webpack_exports__["A"] = setExclusionInfo;
/* harmony export (immutable) */ __webpack_exports__["B"] = setIngestConfig;
/* harmony export (immutable) */ __webpack_exports__["G"] = updateSmartKeywordsSettings;
/* harmony export (immutable) */ __webpack_exports__["o"] = getCustomXmpNamespaces;
/* harmony export (immutable) */ __webpack_exports__["t"] = removeCustomXmpNamespaces;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCustomXmpNamespaces;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_routeUtils__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_util_logging__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var showDialogPanel=__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel;var addCustomXmpNamespacesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].addCustomXmpNamespaces,addFieldsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].addFields,addNestedValuesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].addNestedValues,addOrUpdateUserCatalogInfoAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].addOrUpdateUserCatalogInfo,createCatalogAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].createCatalog,createCatalogTemplateAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].createCatalogTemplate,createMetadataDefinitionsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].createMetadataDefinitions,deleteMetadataDefinitionAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].deleteMetadataDefinition,createMetadataMappingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].createMetadataMappings,deleteCatalogAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].deleteCatalog,deleteCatalogTemplateAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].deleteCatalogTemplate,deleteMetadataMappingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].deleteMetadataMappings,deleteNestedValuesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].deleteNestedValues,getCatalogsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getCatalogs,getCatalogPropertiesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getCatalogProperties,getCatalogTypesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getCatalogTypes,getCustomXmpNamespacesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getCustomXmpNamespaces,getFieldsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getFields,getMetadataDefinitionsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getMetadataDefinitions,getMetadataMappingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getMetadataMappings,getUserCatalogInfoAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].getUserCatalogInfo,removeAllPredefinedValuesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].removeAllPredefinedValues,removeCustomXmpNamespacesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].removeCustomXmpNamespaces,removeFieldsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].removeFields,removeUsersFromCatalogAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].removeUsersFromCatalog,renameCatalogAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].renameCatalog,renameCatalogTemplateAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].renameCatalogTemplate,restoreFileTypesDefaultAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].restoreFileTypesDefault,setExclusionInfoAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].setExclusionInfo,setIngestConfigAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].setIngestConfig,updateCatalogingOptionsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].updateCatalogingOptions,updateDiskPreviewInfoAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].updateDiskPreviewInfo,updateFieldsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].updateFields,updatePredefinedListAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].updatePredefinedList,updateSmartKeywordsSettingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_catalogReducer__["a" /* actions */].updateSmartKeywordsSettings;var showModalPrompt=__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;function getCatalogs(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context.next=4;break;}_context.next=4;return dispatch(getCatalogsAction(session));case 4:case'end':return _context.stop();}}},_callee,this);}));function getCatalogs(_x,_x2){return _ref.apply(this,arguments);}return getCatalogs;}();}function getCatalogTypes(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var session,locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());locale=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_4" /* getLocale */])(getState());if(!session){_context2.next=5;break;}_context2.next=5;return dispatch(getCatalogTypesAction(session,locale));case 5:case'end':return _context2.stop();}}},_callee2,this);}));function getCatalogTypes(_x3,_x4){return _ref2.apply(this,arguments);}return getCatalogTypes;}();}function getCatalogProperties(catalogId,properties){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context3.next=4;break;}_context3.next=4;return dispatch(getCatalogPropertiesAction(session,catalogId,properties));case 4:case'end':return _context3.stop();}}},_callee3,this);}));function getCatalogProperties(_x5,_x6){return _ref3.apply(this,arguments);}return getCatalogProperties;}();}function createCatalogTemplate(catalogId,templateName,successMessage){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context4.next=7;break;}_context4.next=4;return dispatch(createCatalogTemplateAction(session,catalogId,templateName));case 4:dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(successMessage,__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));_context4.next=7;return dispatch(getCatalogTypesAction(session,catalogId));case 7:case'end':return _context4.stop();}}},_callee4,this);}));function createCatalogTemplate(_x7,_x8){return _ref4.apply(this,arguments);}return createCatalogTemplate;}();}function restoreFileTypesDefault(catalogId){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context5.next=6;break;}_context5.next=4;return dispatch(restoreFileTypesDefaultAction(session,catalogId));case 4:_context5.next=6;return dispatch(getCatalogPropertiesAction(session,catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOGING_OPTIONS,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].EXCLUSION_INFO,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]));case 6:case'end':return _context5.stop();}}},_callee5,this);}));function restoreFileTypesDefault(_x9,_x10){return _ref5.apply(this,arguments);}return restoreFileTypesDefault;}();}function createCatalog(catalog,createWatchFolder,watchFolderNamePartFiles){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch,getState){var session,catalogs,catalogToSelect;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context6.next=9;break;}_context6.next=4;return dispatch(createCatalogAction(session,catalog,createWatchFolder,watchFolderNamePartFiles));case 4:_context6.next=6;return dispatch(getCatalogsAction(session));case 6:catalogs=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["n" /* getCatalogs */])(getState());catalogToSelect=catalogs.find(function(cat){return cat.name===catalog.name;});if(catalogToSelect){Object(__WEBPACK_IMPORTED_MODULE_3_util_routeUtils__["a" /* goToRoute */])('catalogs/'+catalogToSelect.catalogId+'/general');}case 9:case'end':return _context6.stop();}}},_callee6,this);}));function createCatalog(_x11,_x12){return _ref6.apply(this,arguments);}return createCatalog;}();}function deleteCatalog(catalog){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch,getState){var doDelete=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!session){_context7.next=5;break;}_context7.next=3;return dispatch(deleteCatalogAction(session,catalog));case 3:_context7.next=5;return dispatch(getCatalogsAction(session));case 5:case'end':return _context7.stop();}}},_callee7,this);}));return function doDelete(){return _ref8.apply(this,arguments);};}();var session,catProperties,storageType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());catProperties=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["k" /* getCatalogProperties */])(getState());storageType=catProperties&&catProperties.catalogDetails&&catProperties.catalogDetails.storageType;_context8.t0=storageType;_context8.next=_context8.t0===__WEBPACK_IMPORTED_MODULE_7_util_constants__["n" /* CATALOG_STORAGE_TYPE */].FILESYSTEM?6:_context8.t0===__WEBPACK_IMPORTED_MODULE_7_util_constants__["n" /* CATALOG_STORAGE_TYPE */].VAULT?8:10;break;case 6:dispatch(showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CATALOG_DELETE_CONFIRM,onButton2:doDelete,dataTestName:'delete-catalog-modal'}));return _context8.abrupt('break',11);case 8:dispatch(showDialogPanel(__WEBPACK_IMPORTED_MODULE_7_util_constants__["F" /* DELETE_VAULT_CATALOG_PANEL_ID */],{doDelete:doDelete}));return _context8.abrupt('break',11);case 10:__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_util_logging__["a" /* default */].error('Attempted to delete catalog with unknown type: ',storageType);case 11:case'end':return _context8.stop();}}},_callee8,this);}));function deleteCatalog(_x13,_x14){return _ref7.apply(this,arguments);}return deleteCatalog;}();}function renameCatalog(catalog,successMessage){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch,getState){var session,_ref10,name;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context9.next=9;break;}_context9.next=4;return dispatch(renameCatalogAction(session,catalog));case 4:_ref10=_context9.sent;name=_ref10.payload.name;dispatch(getCatalogsAction(session));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(successMessage,__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));return _context9.abrupt('return',name);case 9:case'end':return _context9.stop();}}},_callee9,this);}));function renameCatalog(_x15,_x16){return _ref9.apply(this,arguments);}return renameCatalog;}();}function deleteCatalogTemplate(templateId){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context10.next=5;break;}_context10.next=4;return dispatch(deleteCatalogTemplateAction(session,templateId));case 4:dispatch(getCatalogTypesAction(session,Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_4" /* getLocale */])(getState())));case 5:case'end':return _context10.stop();}}},_callee10,this);}));function deleteCatalogTemplate(_x17,_x18){return _ref11.apply(this,arguments);}return deleteCatalogTemplate;}();}function renameCatalogTemplate(templateId,name){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context11.next=5;break;}_context11.next=4;return dispatch(renameCatalogTemplateAction(session,templateId,name));case 4:dispatch(getCatalogTypesAction(session,Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_4" /* getLocale */])(getState())));case 5:case'end':return _context11.stop();}}},_callee11,this);}));function renameCatalogTemplate(_x19,_x20){return _ref12.apply(this,arguments);}return renameCatalogTemplate;}();}function updateDiskPreviewInfo(catalogId,dpi,successMessage){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context12.next=7;break;}_context12.next=4;return dispatch(updateDiskPreviewInfoAction(session,catalogId,dpi));case 4:_context12.next=6;return dispatch(getCatalogProperties(catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].DISK_PREVIEW_INFO]));case 6:dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(successMessage,__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));case 7:case'end':return _context12.stop();}}},_callee12,this);}));function updateDiskPreviewInfo(_x21,_x22){return _ref13.apply(this,arguments);}return updateDiskPreviewInfo;}();}function getFields(catalogId){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context13.next=4;break;}_context13.next=4;return dispatch(getFieldsAction(session,catalogId));case 4:case'end':return _context13.stop();}}},_callee13,this);}));function getFields(_x23,_x24){return _ref14.apply(this,arguments);}return getFields;}();}function addFields(catalogId,fields,metadataDefIdToMap){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch,getState){var session,_ref16,_ref16$payload,newFieldDef,mappings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(session){_context14.next=3;break;}return _context14.abrupt('return',undefined);case 3:_context14.next=5;return dispatch(addFieldsAction(session,catalogId,fields));case 5:_ref16=_context14.sent;_ref16$payload=_slicedToArray(_ref16.payload,1);newFieldDef=_ref16$payload[0];_context14.next=10;return dispatch(getFields(catalogId));case 10:if(!metadataDefIdToMap){_context14.next=14;break;}mappings=Object(__WEBPACK_IMPORTED_MODULE_4_util_fieldsPageUtils__["G" /* makeDefaultMappingsForFieldDef */])(newFieldDef,metadataDefIdToMap);_context14.next=14;return dispatch(createMetadataMappings(catalogId,mappings));case 14:case'end':return _context14.stop();}}},_callee14,this);}));function addFields(_x25,_x26){return _ref15.apply(this,arguments);}return addFields;}();}function updateFields(catalogId,fields){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatch,getState){var session,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context15.next=8;break;}error=void 0;_context15.next=5;return dispatch(updateFieldsAction(session,catalogId,fields)).catch(function(e){error=e;});case 5:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}_context15.next=8;return dispatch(getFields(catalogId));case 8:case'end':return _context15.stop();}}},_callee15,this);}));function udpateFields(_x27,_x28){return _ref17.apply(this,arguments);}return udpateFields;}();}function removeFields(catalogId,fieldIds){var isDisable=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context17.next=4;break;}_context17.next=4;return dispatch(showModalPrompt({message:isDisable?__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_DISABLE_CONFIRM_MSG:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_DELETE_CONFIRM_MSG,dataTestName:'delete-field-modal',onButton2:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return dispatch(removeFieldsAction(session,catalogId,fieldIds));case 2:_context16.next=4;return dispatch(getFields(catalogId));case 4:case'end':return _context16.stop();}}},_callee16,this);}));function doDelete(){return _ref19.apply(this,arguments);}return doDelete;}()}));case 4:case'end':return _context17.stop();}}},_callee17,this);}));function removeFields(_x30,_x31){return _ref18.apply(this,arguments);}return removeFields;}();}function removeAllPredefinedValues(catalogId,fieldIds){return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(dispatch,getState){var session,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context18.next=8;break;}error=void 0;_context18.next=5;return dispatch(removeAllPredefinedValuesAction(session,catalogId,fieldIds)).catch(function(e){error=e;});case 5:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}_context18.next=8;return dispatch(getFields(catalogId));case 8:case'end':return _context18.stop();}}},_callee18,this);}));function removeAllPredefinedValues(_x32,_x33){return _ref20.apply(this,arguments);}return removeAllPredefinedValues;}();}function updatePredefinedList(catalogId,fieldDef,valuesToAdd,valuesToRemove,parentNestedValueId){return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context19.next=15;break;}if(!fieldDef.isHierarchical){_context19.next=11;break;}if(!valuesToAdd){_context19.next=6;break;}_context19.next=6;return dispatch(addNestedValuesAction(session,catalogId,fieldDef.id,valuesToAdd,parentNestedValueId));case 6:if(!valuesToRemove){_context19.next=9;break;}_context19.next=9;return dispatch(deleteNestedValuesAction(session,catalogId,fieldDef.id,valuesToRemove));case 9:_context19.next=13;break;case 11:_context19.next=13;return dispatch(updatePredefinedListAction(session,catalogId,fieldDef.id,valuesToAdd,valuesToRemove));case 13:_context19.next=15;return dispatch(getFieldsAction(session,catalogId));case 15:case'end':return _context19.stop();}}},_callee19,this);}));function updatePredefinedList(_x34,_x35){return _ref21.apply(this,arguments);}return updatePredefinedList;}();}function getMetadataDefinitions(){return function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context20.next=4;break;}_context20.next=4;return dispatch(getMetadataDefinitionsAction(session));case 4:case'end':return _context20.stop();}}},_callee20,this);}));function getMetadataDefinitions(_x36,_x37){return _ref22.apply(this,arguments);}return getMetadataDefinitions;}();}function createMetadataDefinitions(metadataDefinitions){return function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context21.next=6;break;}_context21.next=4;return dispatch(createMetadataDefinitionsAction(session,metadataDefinitions));case 4:_context21.next=6;return dispatch(getMetadataDefinitionsAction(session));case 6:case'end':return _context21.stop();}}},_callee21,this);}));function createMetadataDefinitions(_x38,_x39){return _ref23.apply(this,arguments);}return createMetadataDefinitions;}();}function deleteMetadataDefinition(metadataDefinitionId){return function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(dispatch,getState){var _this=this;var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(session){dispatch(showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_METADATA_DELETE_CONFIRM_MSG,onButton2:function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return dispatch(deleteMetadataDefinitionAction(session,metadataDefinitionId));case 2:_context22.next=4;return dispatch(getMetadataDefinitionsAction(session));case 4:case'end':return _context22.stop();}}},_callee22,_this);}));function onButton2(){return _ref25.apply(this,arguments);}return onButton2;}(),dataTestName:'delete-metadata-modal'}));}case 2:case'end':return _context23.stop();}}},_callee23,this);}));function deleteMetadataDefinition(_x40,_x41){return _ref24.apply(this,arguments);}return deleteMetadataDefinition;}();}function getMetadataMappings(catalogId){return function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context24.next=4;break;}_context24.next=4;return dispatch(getMetadataMappingsAction(session,catalogId));case 4:case'end':return _context24.stop();}}},_callee24,this);}));function getMetadataMappings(_x42,_x43){return _ref26.apply(this,arguments);}return getMetadataMappings;}();}function createMetadataMappings(catalogId,mappings){return function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context25.next=6;break;}_context25.next=4;return dispatch(createMetadataMappingsAction(session,catalogId,mappings));case 4:_context25.next=6;return dispatch(getMetadataMappingsAction(session,catalogId));case 6:case'end':return _context25.stop();}}},_callee25,this);}));function createMetadataMappings(_x44,_x45){return _ref27.apply(this,arguments);}return createMetadataMappings;}();}function deleteMetadataMappings(catalogId,mappings){return function(){var _ref28=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context26.next=6;break;}_context26.next=4;return dispatch(deleteMetadataMappingsAction(session,catalogId,mappings));case 4:_context26.next=6;return dispatch(getMetadataMappingsAction(session,catalogId));case 6:case'end':return _context26.stop();}}},_callee26,this);}));function deleteMetadataMappings(_x46,_x47){return _ref28.apply(this,arguments);}return deleteMetadataMappings;}();}function setEmbedMetadataMapping(catalogId,fieldId,mapping){return function(){var _ref29=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(dispatch,getState){var session,allMappings,oldMapping;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());allMappings=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_10" /* getMetadataMappings */])(getState());oldMapping=Object(__WEBPACK_IMPORTED_MODULE_4_util_fieldsPageUtils__["t" /* getEmbedMappingForField */])(fieldId,allMappings);if(!session){_context27.next=12;break;}_context27.t0=oldMapping;if(!_context27.t0){_context27.next=8;break;}_context27.next=8;return dispatch(deleteMetadataMappingsAction(session,catalogId,[oldMapping]));case 8:_context27.next=10;return dispatch(createMetadataMappingsAction(session,catalogId,[mapping]));case 10:_context27.next=12;return dispatch(getMetadataMappingsAction(session,catalogId));case 12:case'end':return _context27.stop();}}},_callee27,this);}));function setEmbedMetadataMapping(_x48,_x49){return _ref29.apply(this,arguments);}return setEmbedMetadataMapping;}();}function addOrUpdateUserCatalogInfo(infos,catalogName){return function(){var _ref30=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee28(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context28.next=6;break;}_context28.next=4;return dispatch(addOrUpdateUserCatalogInfoAction(session,infos));case 4:_context28.next=6;return dispatch(getUserCatalogInfoAction(session,catalogName));case 6:case'end':return _context28.stop();}}},_callee28,this);}));function addOrUpdateUserCatalogInfo(_x50,_x51){return _ref30.apply(this,arguments);}return addOrUpdateUserCatalogInfo;}();}function removeUsersFromCatalog(catalogName,userNames){return function(){var _ref31=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee29(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29){while(1){switch(_context29.prev=_context29.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context29.next=6;break;}_context29.next=4;return dispatch(removeUsersFromCatalogAction(session,catalogName,userNames));case 4:_context29.next=6;return dispatch(getUserCatalogInfoAction(session,catalogName));case 6:case'end':return _context29.stop();}}},_callee29,this);}));function removeUsersFromCatalog(_x52,_x53){return _ref31.apply(this,arguments);}return removeUsersFromCatalog;}();}function updateCatalogingOptions(catalogId,catOptions){return function(){var _ref32=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee30(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30){while(1){switch(_context30.prev=_context30.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context30.next=6;break;}_context30.next=4;return dispatch(updateCatalogingOptionsAction(session,catalogId,catOptions));case 4:_context30.next=6;return dispatch(getCatalogProperties(catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOGING_OPTIONS,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].EXCLUSION_INFO,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]));case 6:case'end':return _context30.stop();}}},_callee30,this);}));function updateCatalogingOptions(_x54,_x55){return _ref32.apply(this,arguments);}return updateCatalogingOptions;}();}function setExclusionInfo(catalogId,exclusionInfo){return function(){var _ref33=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee31(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31){while(1){switch(_context31.prev=_context31.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context31.next=6;break;}_context31.next=4;return dispatch(setExclusionInfoAction(session,catalogId,exclusionInfo));case 4:_context31.next=6;return dispatch(getCatalogPropertiesAction(session,catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOGING_OPTIONS,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].EXCLUSION_INFO,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]));case 6:case'end':return _context31.stop();}}},_callee31,this);}));function setExclusionInfo(_x56,_x57){return _ref33.apply(this,arguments);}return setExclusionInfo;}();}function setIngestConfig(catalogId,catOptions,ingestConfig){return function(){var _ref34=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee32(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32){while(1){switch(_context32.prev=_context32.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context32.next=6;break;}_context32.next=4;return Promise.all([dispatch(setIngestConfigAction(session,catalogId,ingestConfig)),dispatch(updateCatalogingOptionsAction(session,catalogId,catOptions))]);case 4:_context32.next=6;return dispatch(getCatalogPropertiesAction(session,catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOGING_OPTIONS,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].INGEST_CONFIG,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]));case 6:case'end':return _context32.stop();}}},_callee32,this);}));function setIngestConfig(_x58,_x59){return _ref34.apply(this,arguments);}return setIngestConfig;}();}function updateSmartKeywordsSettings(catalogId,smartKeywordsSettings){return function(){var _ref35=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee33(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33){while(1){switch(_context33.prev=_context33.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context33.next=6;break;}_context33.next=4;return dispatch(updateSmartKeywordsSettingsAction(session,catalogId,smartKeywordsSettings));case 4:_context33.next=6;return dispatch(getCatalogPropertiesAction(session,catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].SMART_KEYWORDS_SETTINGS]));case 6:case'end':return _context33.stop();}}},_callee33,this);}));function updateSmartKeywordsSettings(_x60,_x61){return _ref35.apply(this,arguments);}return updateSmartKeywordsSettings;}();}function getCustomXmpNamespaces(){return function(){var _ref36=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee34(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34){while(1){switch(_context34.prev=_context34.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context34.next=5;break;}_context34.next=4;return dispatch(getCustomXmpNamespacesAction(session));case 4:return _context34.abrupt('return',_context34.sent);case 5:case'end':return _context34.stop();}}},_callee34,this);}));function getCustomXmpNamespaces(_x62,_x63){return _ref36.apply(this,arguments);}return getCustomXmpNamespaces;}();}function removeCustomXmpNamespaces(namespaceIds){return function(){var _ref37=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee36(dispatch,getState){var _this2=this;var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36){while(1){switch(_context36.prev=_context36.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(session){dispatch(showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_NAMESPACE_REMOVE_CONFIRMATION,onButton2:function(){var _ref38=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee35(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35){while(1){switch(_context35.prev=_context35.next){case 0:_context35.next=2;return dispatch(removeCustomXmpNamespacesAction(session,namespaceIds));case 2:_context35.next=4;return dispatch(getCustomXmpNamespacesAction(session));case 4:case'end':return _context35.stop();}}},_callee35,_this2);}));function onButton2(){return _ref38.apply(this,arguments);}return onButton2;}(),dataTestName:'delete-namespace-modal'}));}case 2:case'end':return _context36.stop();}}},_callee36,this);}));function removeCustomXmpNamespaces(_x64,_x65){return _ref37.apply(this,arguments);}return removeCustomXmpNamespaces;}();}function addCustomXmpNamespaces(namespaces){return function(){var _ref39=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee37(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37){while(1){switch(_context37.prev=_context37.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context37.next=7;break;}_context37.next=4;return dispatch(addCustomXmpNamespacesAction(session,namespaces));case 4:_context37.next=6;return dispatch(getCustomXmpNamespacesAction(session));case 6:return _context37.abrupt('return',_context37.sent);case 7:case'end':return _context37.stop();}}},_callee37,this);}));function addCustomXmpNamespaces(_x66,_x67){return _ref39.apply(this,arguments);}return addCustomXmpNamespaces;}();}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loggingLevels */
/* unused harmony export loggerForLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sharedCodeDependencies__ = __webpack_require__(745);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var logger={trace:trace,debug:debug,info:info,warn:warn,error:error,fatal:fatal};/* harmony default export */ __webpack_exports__["a"] = (logger);var loggingLevels=Object.keys(logger);function loggerForLevel(logger,level){var log=function log(){};if(logger){switch(level){case'trace':log=logger.trace.bind(logger);break;case'debug':log=logger.debug.bind(logger);break;case'warn':log=logger.warn.bind(logger);break;case'error':log=logger.error.bind(logger);break;case'fatal':log=logger.fatal.bind(logger);break;case'info':default:log=logger.info.bind(logger);break;}}return log;}function trace(){for(var _len=arguments.length,msg=Array(_len),_key=0;_key<_len;_key++){msg[_key]=arguments[_key];}_log('trace',msg);}function debug(){for(var _len2=arguments.length,msg=Array(_len2),_key2=0;_key2<_len2;_key2++){msg[_key2]=arguments[_key2];}_log('debug',msg);}function info(){for(var _len3=arguments.length,msg=Array(_len3),_key3=0;_key3<_len3;_key3++){msg[_key3]=arguments[_key3];}_log('info',msg);}function warn(){for(var _len4=arguments.length,msg=Array(_len4),_key4=0;_key4<_len4;_key4++){msg[_key4]=arguments[_key4];}_log('warn',msg);}function error(){for(var _len5=arguments.length,msg=Array(_len5),_key5=0;_key5<_len5;_key5++){msg[_key5]=arguments[_key5];}_log('error',msg);}function fatal(){for(var _len6=arguments.length,msg=Array(_len6),_key6=0;_key6<_len6;_key6++){msg[_key6]=arguments[_key6];}_log('fatal',msg);}var levelFromName={'trace':10,'debug':20,'info':30,'warn':40,'error':50,'fatal':60};function _log(level,msg){if(__WEBPACK_IMPORTED_MODULE_0_sharedCodeDependencies__["a" /* electronModule */]){// eslint-disable-line no-undef
__WEBPACK_IMPORTED_MODULE_0_sharedCodeDependencies__["a" /* electronModule */].ipcRenderer.send('log',{level:level,msg:msg});}else{// No Node logging package available in the browser, so just output to JS console.
var clientLogLevel=window&&window.LOGLEVEL||'info';if(levelFromName[level]>=levelFromName[clientLogLevel]){var args=msg.map(function(s){return(typeof s==='undefined'?'undefined':_typeof(s))==='object'?JSON.stringify(s):s;}).join('');/* eslint-disable no-console */var errStr='['+new Date().toISOString()+'] '+level.toUpperCase()+': '+args;if(levelFromName[level]===levelFromName['warn']){console.warn(errStr);}else if(levelFromName[level]>=levelFromName['error']){console.error(errStr);}else{console.log(errStr);}}}}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = showSingleButtonAlert;
/* harmony export (immutable) */ __webpack_exports__["c"] = propsForSingleButtonAlert;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
var SHOW_MODAL_PROMPT='client/modalPrompt/SHOW_MODAL_PROMPT';var HIDE_MODAL_PROMPT='client/modalPrompt/HIDE_MODAL_PROMPT';var initialState={isVisible:false,properties:{closeOnEscape:true,isButton1Default:false,isButton2Default:false}};function modalPromptReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SHOW_MODAL_PROMPT:return Object.assign({},state,{isVisible:true,properties:action.payload});case HIDE_MODAL_PROMPT:return Object.assign({},state,{isVisible:false});default:return state;}}function showModalPrompt(properties){return{type:SHOW_MODAL_PROMPT,payload:properties};}function hideModalPrompt(){return{type:HIDE_MODAL_PROMPT};}var actions={showModalPrompt:showModalPrompt,hideModalPrompt:hideModalPrompt};// Convenience utility
function showSingleButtonAlert(message,args){return showModalPrompt(propsForSingleButtonAlert(message,args));}function propsForSingleButtonAlert(message,args){return{message:message,messageArguments:args,button1text:null,isButton2Default:true,closeOnEscape:true};}/* harmony default export */ __webpack_exports__["b"] = (modalPromptReducer);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getAdminProperties;
/* harmony export (immutable) */ __webpack_exports__["p"] = startServer;
/* harmony export (immutable) */ __webpack_exports__["q"] = stopServer;
/* harmony export (immutable) */ __webpack_exports__["f"] = restartServer;
/* harmony export (immutable) */ __webpack_exports__["h"] = sendDiagnosticData;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDirectoryServiceDescription;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteDirectoryServiceDescription;
/* harmony export (immutable) */ __webpack_exports__["l"] = setGlobalSettings;
/* harmony export (immutable) */ __webpack_exports__["j"] = setBrandingSettings;
/* harmony export (immutable) */ __webpack_exports__["n"] = setMobileUploadSettings;
/* harmony export (immutable) */ __webpack_exports__["o"] = setPorts;
/* harmony export (immutable) */ __webpack_exports__["k"] = setEmailServerConfig;
/* harmony export (immutable) */ __webpack_exports__["s"] = validateEmailServerConfig;
/* harmony export (immutable) */ __webpack_exports__["m"] = setLoggingConfig;
/* harmony export (immutable) */ __webpack_exports__["i"] = setBackupConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = backup;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelBackup;
/* harmony export (immutable) */ __webpack_exports__["g"] = restore;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateDirectoryServiceDescription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_commands_authCommands__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_backupUtils__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_serverUtils__ = __webpack_require__(37);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var backupAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].backup,cancelBackupAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].cancelBackup,clearEmailServerConfigValidating=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].clearEmailServerConfigValidating,createDirectoryServiceDescriptionAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].createDirectoryServiceDescription,deleteDirectoryServiceDescriptionAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].deleteDirectoryServiceDescription,getAdminPropertiesAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].getAdminProperties,restartServerAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].restartServer,restoreAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].restore,sendDiagnosticDataAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].sendDiagnosticData,setBackupConfigAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setBackupConfig,setBrandingCustomImageAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setBrandingCustomImage,setBrandingSettingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setBrandingSettings,setEmailServerConfigAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setEmailServerConfig,setEmailServerConfigValidating=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setEmailServerConfigValidating,setGlobalSettingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setGlobalSettings,setPortsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setPorts,setMobileUploadSettingsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setMobileUploadSettings,setIsCommunicatingWithDirectoryService=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setIsCommunicatingWithDirectoryService,setIsRestarting=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setIsRestarting,setIsAdminServerRestarting=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setIsAdminServerRestarting,setLoggingConfigAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setLoggingConfig,setServerStatus=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setServerStatus,startServerAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].startServer,stopServerAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].stopServer,updateDirectoryServiceDescriptionAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].updateDirectoryServiceDescription,validateEmailServerConfigAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].validateEmailServerConfig;var clearIdentitySession=__WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__["a" /* actions */].clearIdentitySession,identityLogin=__WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__["a" /* actions */].identityLogin;var showModalPrompt=__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;function getAdminProperties(properties){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var _getState,_getState$auth,adminSessionId,identitySessionId,isAdminServerRestarting,oldRunState,newRunState,backupRestoreStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_getState=getState(),_getState$auth=_getState.auth,adminSessionId=_getState$auth.adminSessionId,identitySessionId=_getState$auth.identitySessionId;isAdminServerRestarting=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["O" /* getIsAdminServerRestarting */])(getState());if(!isAdminServerRestarting){_context.next=6;break;}__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('admin server restarting, skipping getting admin properties');_context.next=25;break;case 6:if(!(properties.length>0)){_context.next=24;break;}oldRunState=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_25" /* getServerRunState */])(getState());_context.next=10;return dispatch(getAdminPropertiesAction(adminSessionId,identitySessionId,properties)).catch(function(e){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_commands_authCommands__["b" /* logout */])());__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('failed to get admin properties');});case 10:if(!properties.includes(__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].serverStatus)){_context.next=19;break;}newRunState=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_25" /* getServerRunState */])(getState());if(!(newRunState!==__WEBPACK_IMPORTED_MODULE_8_util_constants__["X" /* SERVER_STATE_STARTED */]&&oldRunState===__WEBPACK_IMPORTED_MODULE_8_util_constants__["X" /* SERVER_STATE_STARTED */])){_context.next=16;break;}// The server switched from started to not-started.
dispatch(clearIdentitySession());_context.next=19;break;case 16:if(!(newRunState===__WEBPACK_IMPORTED_MODULE_8_util_constants__["X" /* SERVER_STATE_STARTED */]&&oldRunState!==__WEBPACK_IMPORTED_MODULE_8_util_constants__["X" /* SERVER_STATE_STARTED */])){_context.next=19;break;}_context.next=19;return dispatch(identityLogin(Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_33" /* getUsername */])(getState()),Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["K" /* getIdentityEncryptedPassword */])(getState())));case 19:backupRestoreStatus=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["h" /* getBackupRestoreStatus */])(getState());__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].debug({backupRestoreStatus:backupRestoreStatus});if(Object(__WEBPACK_IMPORTED_MODULE_11_util_backupUtils__["d" /* isBackupRestoreBusy */])(backupRestoreStatus)){Object(__WEBPACK_IMPORTED_MODULE_11_util_backupUtils__["i" /* showBackupRestoreProgress */])(dispatch,getState);}else if(Object(__WEBPACK_IMPORTED_MODULE_11_util_backupUtils__["e" /* isBackupRestoreCancelled */])(backupRestoreStatus)){Object(__WEBPACK_IMPORTED_MODULE_11_util_backupUtils__["b" /* hideBackupRestoreProgress */])(dispatch,getState);}_context.next=25;break;case 24:__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('failed to get admin properties, no properties provided');case 25:case'end':return _context.stop();}}},_callee,this);}));function getAdminProperties(_x,_x2){return _ref.apply(this,arguments);}return getAdminProperties;}();}function startServer(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var adminSessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:adminSessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!adminSessionId){_context2.next=6;break;}_context2.next=4;return dispatch(setServerStatus(__WEBPACK_IMPORTED_MODULE_8_util_constants__["Y" /* SERVER_STATE_STARTING */]));case 4:_context2.next=6;return dispatch(startServerAction(adminSessionId));case 6:case'end':return _context2.stop();}}},_callee2,this);}));function startServer(_x3,_x4){return _ref2.apply(this,arguments);}return startServer;}();}function stopServer(){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var adminSessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:adminSessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!adminSessionId){_context3.next=8;break;}_context3.next=4;return dispatch(setServerStatus(__WEBPACK_IMPORTED_MODULE_8_util_constants__["_0" /* SERVER_STATE_STOPPING */]));case 4:_context3.next=6;return dispatch(clearIdentitySession());case 6:_context3.next=8;return dispatch(stopServerAction(adminSessionId));case 8:case'end':return _context3.stop();}}},_callee3,this);}));function stopServer(_x5,_x6){return _ref3.apply(this,arguments);}return stopServer;}();}function restartServer(){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var adminSessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:adminSessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!adminSessionId){_context4.next=10;break;}_context4.next=4;return dispatch(setServerStatus(__WEBPACK_IMPORTED_MODULE_8_util_constants__["_0" /* SERVER_STATE_STOPPING */]));case 4:_context4.next=6;return dispatch(setIsRestarting(true));case 6:_context4.next=8;return dispatch(clearIdentitySession());case 8:_context4.next=10;return dispatch(restartServerAction(adminSessionId));case 10:case'end':return _context4.stop();}}},_callee4,this);}));function restartServer(_x7,_x8){return _ref4.apply(this,arguments);}return restartServer;}();}function sendDiagnosticData(accountName,contactName,techSupportTicketNum){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var sessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context5.next=6;break;}_context5.next=4;return dispatch(sendDiagnosticDataAction(sessionId,accountName,contactName,techSupportTicketNum));case 4:_context5.next=6;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].diagnosticDataStatus]));case 6:case'end':return _context5.stop();}}},_callee5,this);}));function sendDiagnosticData(_x9,_x10){return _ref5.apply(this,arguments);}return sendDiagnosticData;}();}function createDirectoryServiceDescription(description){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch,getState){var sessionId,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(getState());if(!sessionId){_context6.next=14;break;}error=void 0;dispatch(setIsCommunicatingWithDirectoryService(true));_context6.next=6;return dispatch(createDirectoryServiceDescriptionAction(sessionId,description)).catch(function(e){error=e;});case 6:dispatch(setIsCommunicatingWithDirectoryService(false));if(!error){_context6.next=11;break;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_CONNECT_ERROR,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));_context6.next=14;break;case 11:dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].IDENTITY_SERVICE_SUCCESSFUL_CREATION,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));_context6.next=14;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].directoryServiceDescription]));case 14:case'end':return _context6.stop();}}},_callee6,this);}));function createDirectoryServiceDescription(_x11,_x12){return _ref6.apply(this,arguments);}return createDirectoryServiceDescription;}();}function deleteDirectoryServiceDescription(uuid){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch,getState){var doDelete=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!sessionId){_context7.next=5;break;}_context7.next=3;return dispatch(deleteDirectoryServiceDescriptionAction(sessionId,uuid));case 3:_context7.next=5;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].directoryServiceDescription]));case 5:case'end':return _context7.stop();}}},_callee7,this);}));return function doDelete(){return _ref8.apply(this,arguments);};}();var sessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(getState());dispatch(showModalPrompt({dataTestName:'confirm-delete-directory-service',message:__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].CONFIRM_DELETE_SERVICE,onButton2:doDelete}));case 2:case'end':return _context8.stop();}}},_callee8,this);}));function deleteDirectoryServiceDescription(_x13,_x14){return _ref7.apply(this,arguments);}return deleteDirectoryServiceDescription;}();}function setGlobalSettings(settings){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch,getState){var sessionId,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context9.next=7;break;}error=void 0;_context9.next=5;return dispatch(setGlobalSettingsAction(sessionId,settings)).catch(function(e){error=e;});case 5:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].globalSettings]));case 7:case'end':return _context9.stop();}}},_callee9,this);}));function setGlobalSettings(_x15,_x16){return _ref9.apply(this,arguments);}return setGlobalSettings;}();}function setBrandingSettings(config,imageData){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch,getState){var adminSession,errorImageUpload,errorSetConfig,formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:adminSession=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!adminSession){_context10.next=19;break;}errorImageUpload=void 0;errorSetConfig=void 0;// handle image upload first
formData={};if(!imageData.file){_context10.next=9;break;}formData.file=imageData.file;_context10.next=9;return dispatch(setBrandingCustomImageAction(formData,adminSession)).catch(function(e){errorImageUpload=e;});case 9:if(!errorImageUpload){_context10.next=13;break;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));_context10.next=19;break;case 13:// handle config next
if(imageData.file){config.useCustomImage=true;}_context10.next=16;return dispatch(setBrandingSettingsAction(adminSession,config)).catch(function(e){errorSetConfig=e;});case 16:if(errorSetConfig){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}_context10.next=19;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].brandingSettings]));case 19:case'end':return _context10.stop();}}},_callee10,this);}));function setBrandingSettings(_x17,_x18){return _ref10.apply(this,arguments);}return setBrandingSettings;}();}function setMobileUploadSettings(settings){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch,getState){var adminSession,identSession,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:adminSession=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());identSession=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(getState());if(!(adminSession&&identSession)){_context11.next=8;break;}error=void 0;_context11.next=6;return dispatch(setMobileUploadSettingsAction(adminSession,identSession,settings)).catch(function(e){error=e;});case 6:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].globalSettings]));case 8:case'end':return _context11.stop();}}},_callee11,this);}));function setMobileUploadSettings(_x19,_x20){return _ref11.apply(this,arguments);}return setMobileUploadSettings;}();}function setPorts(ports){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch,getState){var sessionId,updatedAdminPort,error,curr,address;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context12.next=18;break;}updatedAdminPort=ports['esp.port.admin-web-app']||ports['esp.port.admin-web-app-ssl'];error=void 0;_context12.next=6;return dispatch(setPortsAction(sessionId,ports)).catch(function(e){error=e;});case 6:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}if(!updatedAdminPort){_context12.next=16;break;}dispatch(setIsAdminServerRestarting(true));dispatch(showModalPrompt({button1text:null,button2text:null,message:__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].PORT_WARNING_ADMIN_RESTART,messageArguments:{numSecs:30}}));// redirect to new location
curr=new URL(window.location.href);address=Object(__WEBPACK_IMPORTED_MODULE_12_util_serverUtils__["d" /* getAdminAddressAfterPortChange */])(curr,ports);__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('Will redirect to '+JSON.stringify(address));setTimeout(function(){window.location.replace(address);},30000);_context12.next=18;break;case 16:_context12.next=18;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].ports]));case 18:case'end':return _context12.stop();}}},_callee12,this);}));function setPorts(_x21,_x22){return _ref12.apply(this,arguments);}return setPorts;}();}function setEmailServerConfig(config){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch,getState){var sessionId,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context13.next=8;break;}error=void 0;_context13.next=5;return dispatch(setEmailServerConfigAction(sessionId,config)).catch(function(e){error=e;});case 5:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}_context13.next=8;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].emailServerConfiguration]));case 8:case'end':return _context13.stop();}}},_callee13,this);}));function setEmailServerConfig(_x23,_x24){return _ref13.apply(this,arguments);}return setEmailServerConfig;}();}var FAULT_EMAIL_NOT_FOUND='No SMTP server found';var FAULT_EMAIL_AUTH_FAILED='Authentication failed';function validateEmailServerConfig(config){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch,getState){var sessionId,error,msg;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context14.next=8;break;}dispatch(setEmailServerConfigValidating());error=void 0;_context14.next=6;return dispatch(validateEmailServerConfigAction(sessionId,config)).catch(function(e){error=e;});case 6:dispatch(clearEmailServerConfigValidating());if(error){if(error.message&&error.message.includes(FAULT_EMAIL_NOT_FOUND)){msg=__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND;}else if(error.message&&error.message.includes(FAULT_EMAIL_AUTH_FAILED)){msg=__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED;}else{msg=__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_INVALID_GENERIC;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(msg,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_SUCCESS_MESSAGE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}case 8:case'end':return _context14.stop();}}},_callee14,this);}));function setEmailServerConfig(_x25,_x26){return _ref14.apply(this,arguments);}return setEmailServerConfig;}();}function setLoggingConfig(config){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatch,getState){var sessionId,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context15.next=7;break;}error=void 0;_context15.next=5;return dispatch(setLoggingConfigAction(sessionId,config)).catch(function(e){error=e;});case 5:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].loggingConfig]));case 7:case'end':return _context15.stop();}}},_callee15,this);}));function setLoggingConfig(_x27,_x28){return _ref15.apply(this,arguments);}return setLoggingConfig;}();}function setBackupConfig(config){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(dispatch,getState){var sessionId,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context16.next=8;break;}error=void 0;_context16.next=5;return dispatch(setBackupConfigAction(sessionId,config)).catch(function(e){error=e;});case 5:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}_context16.next=8;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].backupConfig]));case 8:case'end':return _context16.stop();}}},_callee16,this);}));function setBackupConfig(_x29,_x30){return _ref16.apply(this,arguments);}return setBackupConfig;}();}function delayedGetBackupRestoreStatus(dispatch){// Give the backup a little time to start before showing progress dialog
setTimeout(function(){return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].backupRestoreStatus]));},1000);}function backup(){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(dispatch,getState){var doBackup=function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){var sessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context17.next=5;break;}_context17.next=4;return dispatch(backupAction(sessionId));case 4:delayedGetBackupRestoreStatus(dispatch);case 5:case'end':return _context17.stop();}}},_callee17,this);}));return function doBackup(){return _ref18.apply(this,arguments);};}();return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:dispatch(showModalPrompt({isButton2Default:true,message:__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].BACKUP_CONFIRMATION_VERBIAGE,onButton2:doBackup,dataTestName:'backup-confirm'}));case 1:case'end':return _context18.stop();}}},_callee18,this);}));function backup(_x31,_x32){return _ref17.apply(this,arguments);}return backup;}();}function cancelBackup(){return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(dispatch,getState){var sessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(sessionId){dispatch(cancelBackupAction(sessionId));}case 2:case'end':return _context19.stop();}}},_callee19,this);}));function cancelBackup(_x33,_x34){return _ref19.apply(this,arguments);}return cancelBackup;}();}function restore(restoreArchivePath){return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(dispatch,getState){var sessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState());if(!sessionId){_context20.next=5;break;}_context20.next=4;return dispatch(restoreAction(sessionId,restoreArchivePath));case 4:delayedGetBackupRestoreStatus(dispatch);case 5:case'end':return _context20.stop();}}},_callee20,this);}));function restore(_x35,_x36){return _ref20.apply(this,arguments);}return restore;}();}function updateDirectoryServiceDescription(description){return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(dispatch,getState){var sessionId,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:sessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(getState());if(!sessionId){_context21.next=14;break;}error=void 0;dispatch(setIsCommunicatingWithDirectoryService(true));_context21.next=6;return dispatch(updateDirectoryServiceDescriptionAction(sessionId,description)).catch(function(e){error=e;});case 6:dispatch(setIsCommunicatingWithDirectoryService(false));if(!error){_context21.next=11;break;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_CONNECT_ERROR,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));_context21.next=14;break;case 11:dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].IDENTITY_SERVICE_SUCCESSFUL_CREATION,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));_context21.next=14;return dispatch(getAdminProperties([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].directoryServiceDescription]));case 14:case'end':return _context21.stop();}}},_callee21,this);}));function updateDirectoryServiceDescription(_x37,_x38){return _ref21.apply(this,arguments);}return updateDirectoryServiceDescription;}();}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(722);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(777), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(336);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(800);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(804);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(336);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LabeledField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function LabeledField(_ref){var children=_ref.children,label=_ref.label,labelClassName=_ref.labelClassName,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal',style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal '+(labelClassName||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},children))));}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(199)('wks');
var uid = __webpack_require__(138);
var Symbol = __webpack_require__(29).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(834);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(348);
/* unused harmony reexport defaultCellRangeRenderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(347);
/* unused harmony reexport defaultOverscanIndicesGetter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(11);
/* unused harmony reexport bpfrpt_proptype_NoContentRenderer */
/* unused harmony reexport bpfrpt_proptype_Alignment */
/* unused harmony reexport bpfrpt_proptype_CellPosition */
/* unused harmony reexport bpfrpt_proptype_CellSize */
/* unused harmony reexport bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony reexport bpfrpt_proptype_RenderedSection */
/* unused harmony reexport bpfrpt_proptype_CellRendererParams */
/* unused harmony reexport bpfrpt_proptype_Scroll */

























/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ID_NEW_FIELD_DEF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_DISABLED_FIELD_DEF; });
/* unused harmony export DEFAULT_STRING_MAX_LENGTH */
/* unused harmony export DEFAULT_DECIMAL_PRECISION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MAX_STRING_MAX_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAX_DECIMAL_PRECISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MAX_SYSTEM_NAME_FIELD_LEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MD_MAPPING_TYPE_EMBED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MD_MAPPING_TYPE_EXTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOT_FOUND; });
/* unused harmony export HIDDEN_FIELD_NAMES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIELDS_CATEGORY_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIELDS_CATEGORY_CUSTOM; });
/* unused harmony export FIELDS_CATEGORY_SYSTEM */
/* unused harmony export FIELDS_CATEGORY_EXIF */
/* unused harmony export FIELDS_CATEGORY_IPTC */
/* unused harmony export FIELDS_CATEGORY_MOVIE */
/* unused harmony export FIELDS_CATEGORY_MSOFFICE */
/* unused harmony export FIELDS_CATEGORY_GEO */
/* unused harmony export FIELDS_CATEGORY_FONTSENSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIELDS_CATEGORY_XMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIELDS_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MD_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MD_MULTIVALUED_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MD_DATATYPES; });
/* harmony export (immutable) */ __webpack_exports__["A"] = getMetadataNamespaces;
/* harmony export (immutable) */ __webpack_exports__["r"] = fieldDefForFieldsListItemName;
/* harmony export (immutable) */ __webpack_exports__["D"] = isFieldDefInSystemCategory;
/* harmony export (immutable) */ __webpack_exports__["F"] = isFieldRemovable;
/* harmony export (immutable) */ __webpack_exports__["s"] = fieldsListItemsForCategory;
/* harmony export (immutable) */ __webpack_exports__["E"] = isFieldDisabled;
/* harmony export (immutable) */ __webpack_exports__["o"] = canHaveMultipleValues;
/* harmony export (immutable) */ __webpack_exports__["p"] = canHavePredefinedValues;
/* harmony export (immutable) */ __webpack_exports__["C"] = isDateField;
/* harmony export (immutable) */ __webpack_exports__["z"] = getMetadataDef;
/* harmony export (immutable) */ __webpack_exports__["G"] = makeDefaultMappingsForFieldDef;
/* harmony export (immutable) */ __webpack_exports__["y"] = getFieldsThatEmbedToMetadata;
/* harmony export (immutable) */ __webpack_exports__["t"] = getEmbedMappingForField;
/* harmony export (immutable) */ __webpack_exports__["u"] = getEmbedMappingMetadataDef;
/* harmony export (immutable) */ __webpack_exports__["v"] = getEmbedMappingMetadataDefId;
/* harmony export (immutable) */ __webpack_exports__["w"] = getEmbeddableMetadataOptions;
/* harmony export (immutable) */ __webpack_exports__["x"] = getExtractMetadataForField;
/* harmony export (immutable) */ __webpack_exports__["q"] = displayNameForField;
/* harmony export (immutable) */ __webpack_exports__["H"] = metadataTypeToLocalizedString;
/* harmony export (immutable) */ __webpack_exports__["I"] = normalizeValue;
/* harmony export (immutable) */ __webpack_exports__["B"] = isCharacterLegal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__ = __webpack_require__(74);
// special flags that live in the id field of metadata defs
var ID_NEW_FIELD_DEF='new';var ID_DISABLED_FIELD_DEF='disabled';var DEFAULT_STRING_MAX_LENGTH=249;var DEFAULT_DECIMAL_PRECISION=2;var MAX_STRING_MAX_LENGTH=2000;var MAX_DECIMAL_PRECISION=8;var MAX_SYSTEM_NAME_FIELD_LEN=255;// this is the length enforced on the server
var MD_MAPPING_TYPE_EMBED='embed';var MD_MAPPING_TYPE_EXTRACT='extract';var NOT_FOUND='-1';var HIDDEN_FIELD_NAMES=['Bit Depth','Cataloged','Cataloged By','Centroid','Color Mode','com.extensis.portfolio.isPanoramic','CorruptFile','Created','Directory Path','Extension Win','Filename','File Size','Flags','FullyCataloged','Geometry','Height','Horizontal Resolution','Last Modified','Last Updated','Mac Alias','Mac Creator','Mac File Type','Mac Zone','MultipageCount','Number of Bands','Path','PlaceHolder','RID','Short Filename Win','SuggestedKeywords','Thumbnail','Thumbnail Size','Updated By','Vertical Resolution','Volume','Watermarked','WatermarkURL','Width'];var FIELDS_CATEGORY_ALL='All';var FIELDS_CATEGORY_CUSTOM='Custom';var FIELDS_CATEGORY_SYSTEM='System';var FIELDS_CATEGORY_EXIF='EXIF';var FIELDS_CATEGORY_IPTC='IPTC';var FIELDS_CATEGORY_MOVIE='Movie';var FIELDS_CATEGORY_MSOFFICE='MSOffice';var FIELDS_CATEGORY_GEO='GEO';var FIELDS_CATEGORY_FONTSENSE='FontSense';var FIELDS_CATEGORY_XMP='XMP';var FIELDS_CATEGORIES=[{id:FIELDS_CATEGORY_ALL,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_ALL},{id:FIELDS_CATEGORY_CUSTOM,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_CUSTOM},{id:FIELDS_CATEGORY_SYSTEM,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_SYSTEM},{id:FIELDS_CATEGORY_EXIF,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_EXIF},{id:FIELDS_CATEGORY_IPTC,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_IPTC},{id:FIELDS_CATEGORY_MOVIE,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_MOVIE},{id:FIELDS_CATEGORY_MSOFFICE,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_OFFICE},{id:FIELDS_CATEGORY_GEO,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_GEO},{id:FIELDS_CATEGORY_FONTSENSE,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_FONTSENSE},{id:FIELDS_CATEGORY_XMP,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_XMP}];var MD_TYPES=[{id:FIELDS_CATEGORY_XMP,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_XMP},{id:FIELDS_CATEGORY_EXIF,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_EXIF},{id:FIELDS_CATEGORY_IPTC,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_IPTC},{id:FIELDS_CATEGORY_MSOFFICE,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_OFFICE},{id:FIELDS_CATEGORY_MOVIE,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_MOVIE},{id:FIELDS_CATEGORY_GEO,label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_CATEGORY_GEO}];var MD_MULTIVALUED_TYPES=[{id:'NotMultiValued',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL},{id:'Ordered',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL},{id:'Unordered',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL}];var MD_DATATYPES=[{id:'String',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_STRING},{id:'Number',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_NUMBER},{id:'Decimal',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_DECIMAL},{id:'DateTime',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_DATETIME},{id:'URL',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_URL},{id:'TextBlock',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_TEXTBLOCK},{id:'Blob',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_BLOB},{id:'Boolean',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_BOOLEAN},{id:'Structure',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_STRUCTURE},{id:'LangAlt',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_LANG_ALT}];function getMetadataNamespaces(customXMPNamespaces,metadata){var result=new Set();// add custom namespace tags
customXMPNamespaces.forEach(function(namespace){result.add(namespace.namespace);});// get all tags from all metadata defs
metadata.forEach(function(md){var ns=getNamespaceAbbreviation(md.tag);ns&&result.add(ns);});return Array.from(result).sort(function(a,b){return a.localeCompare(b);});}function getNamespaceAbbreviation(tag){if(tag&&tag.indexOf(':')!==-1){return tag.substring(0,tag.indexOf(':'));}}function isFieldDefMultivaluedForMetadataDef(md){// multivalued and font sense metadatas make multivalued fields
return md.multivalueType!=='NotMultiValued'||isFontSenseMetadataDef(md);}// Get or create a FieldDef based on the name
// Could be a "real" and enabled FieldDef
// Could be a disabled metadata-based FieldDef
// Can return null
function fieldDefForFieldsListItemName(name,mds,fds){if(!name){return null;}if(fds){var fd=fds.find(function(fd){return fd.systemName===name;});if(fd){return fd;}}if(mds){var md=mds.find(function(m){return m.displayName===name;});if(!md){return null;}var result={defaultValues:[],hasPredefinedValues:false,id:ID_DISABLED_FIELD_DEF,isEmbeddable:md.canEmbed,isExtractable:false,isHierarchical:false,isMultivalued:isFieldDefMultivaluedForMetadataDef(md),isSearchable:true,isSortable:true,isSystem:false,localizedName:md.displayName,nestedPredefinedValues:[],predefinedValues:[],systemName:md.displayName,type:fieldDefTypeForMetadataDefType(md.dataType)};if(result.type===__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING){result.maxLength=DEFAULT_STRING_MAX_LENGTH;}else if(result.type===__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL){result.precision=DEFAULT_DECIMAL_PRECISION;}return result;}return null;}var mapMetadataDefTypeToFieldDefType={String:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING,Number:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER,Decimal:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL,DateTime:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DATETIME,URL:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].URL,TextBlock:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].TEXTBLOCK,Blob:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING,Boolean:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].BOOLEAN,Structure:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING,LangAlt:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING};var CANT_DISABLE_CATEGORIES=[FIELDS_CATEGORY_ALL,FIELDS_CATEGORY_CUSTOM,FIELDS_CATEGORY_SYSTEM];function fieldDefTypeForMetadataDefType(type){return mapMetadataDefTypeToFieldDefType[type];}function fieldsListItemForFieldDefCanBeDisabled(fieldDef,metadataDefs,category){var hasCorrespondingMetadataDef=!!metadataDefs.find(function(md){return md.displayName===fieldDef.systemName;});return hasCorrespondingMetadataDef&&!CANT_DISABLE_CATEGORIES.includes(category);}function fieldsListItemForFieldDef(fieldDef,metadataDefs,category){return{canBeDisabled:fieldsListItemForFieldDefCanBeDisabled(fieldDef,metadataDefs,category),fieldDef:fieldDef,hasCheckbox:!CANT_DISABLE_CATEGORIES.includes(category),isEnabled:true,name:fieldDef.systemName,internalName:fieldDef.systemName,type:'fd'};}function fieldsListItemForMetadataDef(metadataDef,fds){var hasFieldDefForMetadataDef=!!fds.find(function(fd){return fd.systemName===metadataDef.displayName;});return{canBeDisabled:true,// TODO
hasCheckbox:true,// TODO
isEnabled:hasFieldDefForMetadataDef,metadataDefinition:metadataDef,name:metadataDef.displayName,internalName:metadataDef.displayName,type:'md'};}var knownVisibleSystemFieldDefNames=['Color Profile','Profil de couleur','Farbprofil','カラープロファイル','Copyright','Droits d’auteur','著作権','Creator Application','Application du créateur','Autorenanwendung','作成アプリケーション','Description Writer','Rédacteur de description','Autor der Beschreibung','説明作成者','Photoshop Label','Étiquette Photoshop','Photoshop-Beschreibung','Photoshop ラベル','Photoshop Rating','Classement Photoshop','Photoshop-Bewertung','Photoshop レート','Website','Site Web','Web サイト'];function isFieldDefInSystemCategory(fd){return fd.isSystem||knownVisibleSystemFieldDefNames.includes(fd.systemName);}function isNameInFontSenseCategory(name){return name.startsWith('Extensis Font Sense');}function isFontSenseMetadataDef(md){return md.tag.startsWith('ExtensisFontSense:')&&FIELDS_CATEGORY_XMP===md.type;}function isFieldDefInCustomCategory(fd,mds){return!isFieldDefInSystemCategory(fd)&&!isNameInFontSenseCategory(fd.systemName)&&!mds.find(function(md){return md.displayName===fd.systemName;});}function isFieldRemovable(fd,mds){return isFieldDefInCustomCategory(fd,mds)||!isFieldDefInSystemCategory(fd)&&!mds.find(function(md){return md.displayName===fd.systemName;});}function fieldsListItemsForCategory(fieldDefs,metadataDefs,category){var filteredFieldDefs=fieldDefs.filter(function(fd){return!HIDDEN_FIELD_NAMES.includes(fd.systemName);});if(category===FIELDS_CATEGORY_ALL){return filteredFieldDefs.map(function(fd){return fieldsListItemForFieldDef(fd,metadataDefs,category);});}else if(category===FIELDS_CATEGORY_CUSTOM){return filteredFieldDefs.filter(function(fd){return isFieldDefInCustomCategory(fd,metadataDefs)&&!HIDDEN_FIELD_NAMES.includes(fd.systemName)&&!fd.systemName.startsWith('EXIF -')&&!fd.systemName.startsWith('IPTC -');}).map(function(fd){return fieldsListItemForFieldDef(fd,metadataDefs,category);});}else if(category===FIELDS_CATEGORY_FONTSENSE){return metadataDefs.filter(function(md){return isFontSenseMetadataDef(md);}).map(function(md){return fieldsListItemForMetadataDef(md,filteredFieldDefs);});}else if(category===FIELDS_CATEGORY_SYSTEM){return filteredFieldDefs.filter(function(fd){return!HIDDEN_FIELD_NAMES.includes(fd.systemName)&&isFieldDefInSystemCategory(fd);}).map(function(fd){return fieldsListItemForFieldDef(fd,metadataDefs,category);});}else if(category===FIELDS_CATEGORY_XMP){return metadataDefs.filter(function(md){return md.type===category&&!isFontSenseMetadataDef(md);}).map(function(md){return fieldsListItemForMetadataDef(md,fieldDefs);});}else if(category===FIELDS_CATEGORY_IPTC||category===FIELDS_CATEGORY_EXIF){var mdItems=metadataDefs.filter(function(md){return md.type===category&&!isFontSenseMetadataDef(md);}).map(function(md){return fieldsListItemForMetadataDef(md,fieldDefs);});var fdItems=fieldDefs.filter(function(fd){return fd.systemName.startsWith(category+' -')&&!mdItems.find(function(md){return md.name===fd.systemName;});}).map(function(fd){return fieldsListItemForFieldDef(fd,metadataDefs,category);});return mdItems.concat(fdItems);}else{return metadataDefs.filter(function(md){return md.type===category;}).map(function(md){return fieldsListItemForMetadataDef(md,fieldDefs);});}}function isFieldDisabled(field){return!field||field.id==='disabled';}function canHaveMultipleValues(field){switch(field.type){case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING:case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER:case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL:case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DATETIME:return true;default:return false;}}function canHavePredefinedValues(field){switch(field.type){case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING:case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER:case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL:return true;default:return false;}}function isDateField(field){return field&&field.type===__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DATETIME;}function getMetadataDef(metadataDefId,metadataDefs){return metadataDefs&&metadataDefs.find(function(md){return md.id===metadataDefId;});}function makeDefaultMappingsForFieldDef(fd,mdId){var mappings=[];if(fd.isEmbeddable){mappings.push({fieldDefId:fd.id,metadataDefId:mdId,priority:0,type:MD_MAPPING_TYPE_EMBED});}mappings.push({fieldDefId:fd.id,metadataDefId:mdId,priority:0,type:MD_MAPPING_TYPE_EXTRACT});return mappings;}function getMappingsForMetadata(metadataDefId,metadataMappings){return metadataMappings&&metadataMappings.filter(function(mm){return mm.metadataDefId===metadataDefId;});}function getMappingsForField(fieldDefId,metadataMappings){return metadataMappings&&metadataMappings.filter(function(mm){return mm.fieldDefId===fieldDefId;});}function getMappingsForFieldAndType(fieldDefId,type,metadataMappings){var mappings=getMappingsForField(fieldDefId,metadataMappings);return mappings&&mappings.filter(function(m){return m.type===type;});}function getFieldsThatEmbedToMetadata(metadataDefId,metadataMappings,fieldDefinitions){var mms=getMappingsForMetadata(metadataDefId,metadataMappings);var mms_embeds=mms&&mms.filter(function(m){return m.type===MD_MAPPING_TYPE_EMBED;});var fd_ids=mms_embeds&&mms_embeds.map(function(mm){return mm.fieldDefId;});var ret=fieldDefinitions&&fd_ids&&fieldDefinitions.filter(function(fd){return fd_ids.includes(fd.id);});return ret;}function getEmbedMappingForField(fieldDefId,metadataMappings){var mappings=getMappingsForFieldAndType(fieldDefId,MD_MAPPING_TYPE_EMBED,metadataMappings);return mappings&&mappings[0];}function getExtractMappingsForField(fieldDefId,metadataMappings){return getMappingsForFieldAndType(fieldDefId,MD_MAPPING_TYPE_EXTRACT,metadataMappings);}function getEmbedMappingMetadataDef(fieldDefId,metadataDefinitions,metadataMappings){var embedMapping=getEmbedMappingForField(fieldDefId,metadataMappings);var embedMetadata=embedMapping&&getMetadataDef(embedMapping.metadataDefId,metadataDefinitions);return embedMetadata;}function getEmbedMappingMetadataDefId(fieldDefId,metadataDefinitions,metadataMappings){var embedMetadata=getEmbedMappingMetadataDef(fieldDefId,metadataDefinitions,metadataMappings);return embedMetadata&&embedMetadata.id||NOT_FOUND;}function getEmbeddableMetadataOptions(metadataDefs){return[{id:NOT_FOUND,label:'-'}].concat(!metadataDefs?[]:metadataDefs.filter(function(md){return md.canEmbed;}).map(function(md){return{id:md.id,label:md.displayName};}));}function getExtractMetadataForField(fieldDefId,metadataMappings,metadataDefs){var extractMappings=getExtractMappingsForField(fieldDefId,metadataMappings);var result=extractMappings?extractMappings.reduce(function(result,mm){var md=getMetadataDef(mm.metadataDefId,metadataDefs);md&&result.push(md);return result;},[]):[];return result.sort(function(a,b){return a.displayName.localeCompare(b.displayName);});}function displayNameForField(intl,fieldName){return __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["c" /* Messages */][fieldName]?intl.formatMessage(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["c" /* Messages */][fieldName]):fieldName;}function metadataTypeToLocalizedString(type){switch(type){case'Number':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_NUMBER;case'Decimal':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_DECIMAL;case'DateTime':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_DATETIME;case'String':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_STRING;case'Boolean':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_BOOLEAN;case'LangAlt':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_LANG_ALT;case'Blob':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_BLOB;case'URL':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_URL;case'Structure':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_STRUCTURE;case'TextBlock':return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_TEXTBLOCK;default:return __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FIELD_TYPE_UNKNOWN;}}/** Predefined List utils ported from client */function normalizeValue(fieldDef,value,previousValue){switch(fieldDef.type){case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER:// remove any illegal chars
value=value.replace(/[^-\d]/g,'');// if it doesn't match the pattern return the previous value
// TODO: this is not the best behavior but we will revisit it later
return value.match(INTEGER_REGEXP)?value:previousValue;case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL:// remove any illegal chars
value=value.replace(/[^-.\d]/g,'');// if it doesn't match the pattern return the previous value
return value.match(getDecimalRegExp(fieldDef.precision||DEFAULT_DECIMAL_PRECISION))?value:previousValue;case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].TEXTBLOCK:// Remove all control characters except for tab, newline, CR.
return value.replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g,'');default:return value;}}function getDecimalRegExp(precision){return new RegExp('^-?\\d*\\.?\\d{0,'+precision+'}$');}var INTEGER_REGEXP=new RegExp('^-?\\d*$');/**
 * Used to reject character input before a field value is changed as opposed to normalizing
 * input after the value has changed.
 */function isCharacterLegal(c,fieldDef,target){// We're only filtering actual characters here, not things like Tab, Enter, Arrow, etc.
if(c.length!==1){return true;}// Based on the current value and selection/cursor position, compute the expected new value.
var newValue=target.value.substring(0,target.selectionStart)+c+target.value.substring(target.selectionEnd);switch(fieldDef.type){case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER:return INTEGER_REGEXP.test(newValue);case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL:return getDecimalRegExp(fieldDef.precision||DEFAULT_DECIMAL_PRECISION).test(newValue);case __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING:// fall through
default:return true;}}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NAME_READER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAME_EDITOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAME_PUBLISHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME_ADMIN; });
/* harmony export (immutable) */ __webpack_exports__["g"] = isRoleCustom;
/* harmony export (immutable) */ __webpack_exports__["h"] = roleOrder;
/* harmony export (immutable) */ __webpack_exports__["i"] = sortRoles;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLocalizedRoleName;
/* harmony export (immutable) */ __webpack_exports__["f"] = getRoleForUUID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__ = __webpack_require__(3);
var NAME_READER='Reader';var NAME_EDITOR='Editor';var NAME_PUBLISHER='Publisher';var NAME_ADMIN='Catalog Administrator';var BUILTIN_ROLE_NAMES=[NAME_ADMIN,NAME_EDITOR,NAME_READER,NAME_PUBLISHER];function isRoleCustom(role){return role&&!BUILTIN_ROLE_NAMES.includes(role.name);}function roleOrder(roleName){switch(roleName){case NAME_READER:return 1;case NAME_EDITOR:return 2;case NAME_PUBLISHER:return 3;case NAME_ADMIN:return 4;case'':// Users without a role get assigned empty string
return 10;default:return 9;}}function sortRoles(inputRoles){return inputRoles.sort(function(a,b){var sortOrder=roleOrder(a.name)-roleOrder(b.name);return sortOrder===0?a.name.localeCompare(b.name):sortOrder;});}function getLocalizedRoleName(intl,roleName){var formatMessage=intl.formatMessage;switch(roleName){case NAME_ADMIN:return formatMessage(__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].USER_LEVEL_ADMINISTRATOR);case NAME_PUBLISHER:return formatMessage(__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].USER_LEVEL_PUBLISHER);case NAME_EDITOR:return formatMessage(__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].USER_LEVEL_EDITOR);case NAME_READER:return formatMessage(__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].USER_LEVEL_READER);default:return roleName;}}function getRoleForUUID(roles,uuid){return roles.find(function(r){return r.uuid===uuid;});}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BACKUP_OPERATION_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BACKUP_RESTORE_FAULT_CODE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = calculateDiagnosticDataSendingStatus;
/* harmony export (immutable) */ __webpack_exports__["e"] = calculateIsRestarting;
/* harmony export (immutable) */ __webpack_exports__["f"] = sortMediaEngines;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(4);
var ADMIN_PROPERTIES={backupConfig:'backupsConfiguration',backupRestoreStatus:'backupRestoreStatus',brandingSettings:'brandingSettings',diagnosticDataStatus:'diagnosticDataStatus',directoryServiceDescription:'directoryServiceDescription',emailServerConfiguration:'emailServerConfiguration',globalSettings:'globalSettings',globalStatistics:'globalStatistics',licenses:'licenses',loggingConfig:'loggingConfig',mediaEngines:'mediaEngines',ports:'ports',reachoutMessages:'reachoutMessages',serverStatus:'serverStatus'};var BACKUP_OPERATION_STATE={BACKUP_PREFLIGHT:'BACKUP_PREFLIGHT',BACKUP_SHUTTING_DOWN_SERVER:'BACKUP_SHUTTING_DOWN_SERVER',BACKUP_BACKING_UP_DATA:'BACKUP_BACKING_UP_DATA',BACKUP_RESTARTING_SERVER:'BACKUP_RESTARTING_SERVER',BACKUP_COMPLETE:'BACKUP_COMPLETE',BACKUP_FAILED:'BACKUP_FAILED',BACKUP_CANCELLED:'BACKUP_CANCELLED',RESTORE_SHUTTING_DOWN_SERVER:'RESTORE_SHUTTING_DOWN_SERVER',RESTORE_RESTORE_DATA:'RESTORE_RESTORE_DATA',RESTORE_RESTARTING_SERVER:'RESTORE_RESTARTING_SERVER',RESTORE_COMPLETE:'RESTORE_COMPLETE',RESTORE_FAILED:'RESTORE_FAILED',NONE:'NONE'};var BACKUP_RESTORE_FAULT_CODE={INTERNAL_ERROR:1,LIFECYCLE_ERROR:2,BAD_ARCHIVE:3,INSUFFICIENT_SPACE:4,INVALID_BACKUP_DIRECTORY:5};function calculateDiagnosticDataSendingStatus(newState,oldState,isSendingDiagnosticData){if(isSendingDiagnosticData&&oldState!==newState){return false;}return isSendingDiagnosticData;}function calculateIsRestarting(newState,oldState,isRestarting){if(newState&&oldState){if(isRestarting&&oldState.runState===__WEBPACK_IMPORTED_MODULE_0__constants__["Z" /* SERVER_STATE_STOPPED */]&&(newState.runState===__WEBPACK_IMPORTED_MODULE_0__constants__["Y" /* SERVER_STATE_STARTING */]||newState.runState===__WEBPACK_IMPORTED_MODULE_0__constants__["X" /* SERVER_STATE_STARTED */])){return false;}}return isRestarting;}function sortMediaEngines(mes){// sort built-in first, then by address
return mes&&mes.sort(function(a,b){if(a.type===__WEBPACK_IMPORTED_MODULE_0__constants__["Q" /* MEDIA_ENGINE_TYPE_BUILT_IN */]){return-1;}else if(b.type===__WEBPACK_IMPORTED_MODULE_0__constants__["Q" /* MEDIA_ENGINE_TYPE_BUILT_IN */]){return 1;}else if(a.address&&b.address){return a.address.localeCompare(b.address);}else return-1;});}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_PORT_DEV */
/* unused harmony export DEFAULT_PORT_SERVER */
/* unused harmony export DEFAULT_PORT_ADMIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GLOBAL_SETTING; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getAdminAddress;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAdminAddressAfterPortChange;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMainServerPort;
/* harmony export (immutable) */ __webpack_exports__["b"] = encrypt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_lib_encrypt__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_lib_encrypt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_lib_encrypt__);
var DEFAULT_PORT_DEV='3000';var DEFAULT_PORT_SERVER='8090';var DEFAULT_PORT_ADMIN='8091';var GLOBAL_SETTING={CREATE_AUTOSYNC_FOLDER:'server.create.autosync.folder',DEFAULT_USER_ACCESS_LEVEL:'client.default.user.access.level',FOLDER_AUTOSYNC:'server.default.autosync.folder',FOLDER_LOGS_DEFAULT:'server.default.logging.dir',FOLDER_PREVIEWS:'server.default.previews.folder',FOLDER_PREVIEWS_DEFAULT:'server.default.default.previews.folder',FOLDER_VAULT:'server.vault.home',FOLDER_VAULT_DEFAULT:'server.vault.home.default',FOLDER_WORK:'server.work.folder',FOLDER_WORK_DEFAULT:'server.default.work.folder',FOLDER_WORK_TRANSITIONAL:'server.work.folder.transitional',MOBILE_UPLOADS_ENABLED:'mobile.uploads.enabled',MOBILE_UPLOADS_FOLDER:'default.upload.folder',MOBILE_UPLOADS_CATALOG:'mobile.uploads.catalog',SAVE_PREVIEWS:'server.save.previews',SSO_PRINCIPAL:'server.sso.principal',SSO_KEY:'server.sso.key'};function getAdminAddress(ports){// TODO: this should be a selector
var serverAddress=window.location.protocol+'//'+window.location.host;// handle dev mode
var segments=serverAddress.split(':');if(segments[segments.length-1]===DEFAULT_PORT_DEV){var addressWithoutPort=segments.slice(0,segments.length-1).join(':');var port=ports&&ports[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["D" /* PORT_KEY_ADMIN */]]||DEFAULT_PORT_ADMIN;serverAddress=addressWithoutPort+':'+port;}return serverAddress;}function getAdminAddressAfterPortChange(url,ports){var result=url;if(url.protocol==='https:'&&ports[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["E" /* PORT_KEY_ADMIN_SSL */]]){result.port=String(ports[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["E" /* PORT_KEY_ADMIN_SSL */]]);}if(url.protocol==='http:'&&ports[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["D" /* PORT_KEY_ADMIN */]]){result.port=String(ports[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["D" /* PORT_KEY_ADMIN */]]);}return result.protocol+'//'+result.hostname+':'+result.port+'/';}function getMainServerPort(ports){return ports&&ports[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["F" /* PORT_KEY_SERVER */]]||DEFAULT_PORT_SERVER;}function encrypt(password,publicKeyInfo){var rsakey=new __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_lib_encrypt___default.a();var exponent=Number(publicKeyInfo&&publicKeyInfo.exponent).toString(16);rsakey.setPublic(publicKeyInfo&&publicKeyInfo.modulusBase16,exponent);return rsakey.encrypt_b64(password);}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(546);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(278);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(551);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(555);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(176);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(559);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(563);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(564);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(296);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var SHOW_DIALOG_PANEL='client/dialogPanel/SHOW_DIALOG_PANEL';var HIDE_DIALOG_PANEL='client/dialogPanel/HIDE_DIALOG_PANEL';var initialState={activeIds:[],data:{}};function dialogReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SHOW_DIALOG_PANEL:return Object.assign({},state,{activeIds:state.activeIds.concat(action.payload.panelId),data:Object.assign({},state.data,_defineProperty({},action.payload.panelId,action.payload.data))});case HIDE_DIALOG_PANEL:var newData=Object.assign({},state.data);delete newData[state.activeIds[state.activeIds.length-1]];return Object.assign({},state,{activeIds:state.activeIds.slice(0,-1),data:newData});default:return state;}}function showDialogPanel(panelId,data){return{type:SHOW_DIALOG_PANEL,payload:{panelId:panelId,data:data}};}function hideDialogPanel(){return{type:HIDE_DIALOG_PANEL};}var actions={showDialogPanel:showDialogPanel,hideDialogPanel:hideDialogPanel};/* harmony default export */ __webpack_exports__["b"] = (dialogReducer);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CheckRadio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// This is meant to be used as the component prop for a redux-form Field.
function CheckRadio(_ref){var children=_ref.children,className=_ref.className,disabled=_ref.disabled,fieldValue=_ref.fieldValue,id=_ref.id,input=_ref.input,label=_ref.label,type=_ref.type;var style=type==='checkbox'?{marginTop:'5px'}:{marginBottom:'5px'};var checked=type==='checkbox'?input.checked:input.value===fieldValue;className=className||'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({},input,{checked:checked,className:'is-checkradio '+(className?className:''),disabled:disabled,id:id,type:type})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),children);}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return simpleCheckForValidColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContrastingColor; });
/* unused harmony export red */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isvalidColorString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_each__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinycolor2__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tinycolor2__);



var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_each__["a" /* default */])(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = function toState(data, oldHue) {
  var color = data.hex ? __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(data.hex) : __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(hex).isValid();
};

var getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

var isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(type + ' (' + stringWithoutDegree + ')')._ok;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(486);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_LEVEL; });
/* unused harmony export WARNING_LEVEL */
/* unused harmony export INFO_LEVEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUCCESS_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addNotification; });
/* unused harmony export addNotificationNoAutoDismiss */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portfolio_shared_state_reducers_globalNotificationsReducer__ = __webpack_require__(322);
var addNotificationAction=__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_state_reducers_globalNotificationsReducer__["a" /* actions */].addNotification,removeNotificationAction=__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_state_reducers_globalNotificationsReducer__["a" /* actions */].removeNotification;var ERROR_LEVEL='error';var WARNING_LEVEL='warning';var INFO_LEVEL='info';var SUCCESS_LEVEL='success';function addNotification(notification){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:INFO_LEVEL;var dataTestName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'notification';return addNotificationAction(notification,type,dataTestName);}function removeNotification(uid){return removeNotificationAction(uid);}function addNotificationNoAutoDismiss(localizedMessage,type){var dataTestName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'notification';var notification={message:localizedMessage,action:{label:'OK'},autoDismiss:0,dismissible:false};return addNotification(notification,type,dataTestName);}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(21);
var ctx = __webpack_require__(102);
var hide = __webpack_require__(66);
var has = __webpack_require__(65);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(346);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(405);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(539);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_sharedConstants__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_pathUtils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_folderUtils__ = __webpack_require__(134);
var initialState={backupConfig:{},backupRestoreStatus:{currentOperationState:__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].NONE},brandingSettings:{},emailServerConfiguration:{},emailConfigValidationPending:false,globalSettings:{},isCommunicatingWithDirectoryService:false,isRestarting:false,isAdminServerRestarting:false,isSendingDiagnosticData:false,loggingConfig:{},mediaEngineTestPending:false,ports:{},reachoutMessages:[],serverFolders:[],serverFolderRoot:'',serverOsPlatform:__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_sharedConstants__["a" /* PLATFORM_WINDOWS */]};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["c" /* ADMIN_PROPERTIES_SUCCESS */]:return Object.assign({},state,{isRestarting:Object(__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["e" /* calculateIsRestarting */])(action.payload.serverStatus,state.serverStatus,state.isRestarting),serverStatus:action.payload.serverStatus||state.serverStatus,licenses:action.payload.licenses||state.licenses,loggingConfig:action.payload.loggingConfig||state.loggingConfig,mediaEngines:Object(__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["f" /* sortMediaEngines */])(action.payload.mediaEngines)||state.mediaEngines,globalStatistics:action.payload.globalStatistics||state.globalStatistics,globalSettings:action.payload.globalSettings||state.globalSettings,isSendingDiagnosticData:Object(__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["d" /* calculateDiagnosticDataSendingStatus */])(action.payload.diagnosticDataStatus,state.diagnosticDataStatus,state.isSendingDiagnosticData),diagnosticDataStatus:action.payload.diagnosticDataStatus||state.diagnosticDataStatus,directoryServiceDescription:action.payload.directoryServiceDescription||state.directoryServiceDescription,ports:action.payload.ports||state.ports,backupConfig:action.payload.backupConfig||state.backupConfig,backupRestoreStatus:action.payload.backupRestoreStatus||state.backupRestoreStatus,reachoutMessages:action.payload.reachoutMessages||state.reachoutMessages,serverOsPlatform:action.payload.serverOsPlatform,emailServerConfiguration:action.payload.emailServerConfiguration||state.emailServerConfiguration,brandingSettings:action.payload.brandingSettings||state.brandingSettings});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_19" /* SET_SERVER_STATUS */]:return Object.assign({},state,{serverStatus:Object.assign({},state.serverStatus,{runState:action.payload})});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_7" /* SET_IS_RESTARTING */]:return Object.assign({},state,{isRestarting:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_5" /* SET_IS_ADMIN_SERVER_RESTARTING */]:return Object.assign({},state,{isAdminServerRestarting:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_8" /* SET_IS_SENDING_DIAGNOSTIC_DATA */]:return Object.assign({},state,{isSendingDiagnosticData:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["C" /* GET_SERVER_SYSTEM_INFORMATION_SUCCESS */]:return Object.assign({},state,{serverOsPlatform:action.payload.platform});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_39" /* UPDATE_SERVER_FOLDER_ROOT */]:return Object.assign({},state,{serverFolderRoot:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["z" /* GET_SERVER_FOLDERS_SUCCESS */]:return Object.assign({},state,{serverFolders:Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_folderUtils__["d" /* mergeServerFoldersResult */])(action.payload,action.meta.path,state)});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_38" /* UPDATE_SERVER_FOLDERS */]:return Object.assign({},state,{serverFolders:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_6" /* SET_IS_COMMUNICATING_WITH_DIR_SVC */]:return Object.assign({},state,{isCommunicatingWithDirectoryService:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_1" /* SET_EMAIL_SERVER_CONFIG_VALIDATING */]:return Object.assign({},state,{emailConfigValidationPending:true});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["j" /* CLEAR_EMAIL_SERVER_CONFIG_VALIDATING */]:return Object.assign({},state,{emailConfigValidationPending:false});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_12" /* SET_MEDIA_ENGINE_TEST_PENDING */]:return Object.assign({},state,{mediaEngineTestPending:true});case __WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["k" /* CLEAR_MEDIA_ENGINE_TEST_PENDING */]:return Object.assign({},state,{mediaEngineTestPending:false});default:return state;}}function getAdminProperties(adminSession,identitySession,properties){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["a" /* ADMIN_PROPERTIES */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["c" /* ADMIN_PROPERTIES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["b" /* ADMIN_PROPERTIES_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/admin-properties/'+properties.join(),{params:{adminSession:adminSession,identitySession:identitySession}});}};}function setServerStatus(status){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_19" /* SET_SERVER_STATUS */],payload:status};}function setIsRestarting(isRestarting){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_7" /* SET_IS_RESTARTING */],payload:isRestarting};}function setIsAdminServerRestarting(isRestarting){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_5" /* SET_IS_ADMIN_SERVER_RESTARTING */],payload:isRestarting};}function setIsSendingDiagnosticData(isSending){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_8" /* SET_IS_SENDING_DIAGNOSTIC_DATA */],payload:isSending};}function startServer(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_23" /* START_SERVER */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_25" /* START_SERVER_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_24" /* START_SERVER_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/startServer',{params:{session:session}});}};}function stopServer(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_26" /* STOP_SERVER */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_28" /* STOP_SERVER_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_27" /* STOP_SERVER_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/stopServer',{params:{session:session}});}};}function restartServer(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["G" /* RESTART_SERVER */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["I" /* RESTART_SERVER_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["H" /* RESTART_SERVER_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/restartServer',{params:{session:session}});}};}function sendDiagnosticData(session,accountName,contactName,techSupportTicketNum){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["M" /* SEND_DIAGNOSTIC_DATA */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["O" /* SEND_DIAGNOSTIC_DATA_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["N" /* SEND_DIAGNOSTIC_DATA_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/diagnosticData',{params:{session:session},data:{accountName:accountName,contactName:contactName,techSupportTicketNum:techSupportTicketNum}});}};}function getServerSystemInformation(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["A" /* GET_SERVER_SYSTEM_INFORMATION */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["C" /* GET_SERVER_SYSTEM_INFORMATION_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["B" /* GET_SERVER_SYSTEM_INFORMATION_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/server/system-information',{params:{session:session}});}};}function updateServerFolders(serverFolders){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_38" /* UPDATE_SERVER_FOLDERS */],payload:serverFolders};}function updateServerFolderRoot(rootPath){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_39" /* UPDATE_SERVER_FOLDER_ROOT */],payload:rootPath};}function getServerFolders(session,path,replace){var showFiles=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["x" /* GET_SERVER_FOLDERS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["z" /* GET_SERVER_FOLDERS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["y" /* GET_SERVER_FOLDERS_FAIL */]],meta:{path:replace?'':path},promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/folder/_contents',{params:{session:session},data:{path:Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_pathUtils__["a" /* appendToPath */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_23" /* getServerFolderRoot */])(getState()),path,Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_pathUtils__["b" /* getPathSeparator */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["Z" /* getIsServerPlatformWindows */])(getState()))),showFiles:showFiles}});}};}function createDirectoryServiceDescription(session,description){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["l" /* CREATE_DIR_SVC_DESC */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["n" /* CREATE_DIR_SVC_DESC_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["m" /* CREATE_DIR_SVC_DESC_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service',{params:{session:session},data:description});}};}function deleteDirectoryServiceDescription(session,uuid){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["r" /* DELETE_DIR_SVC_DESC */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["t" /* DELETE_DIR_SVC_DESC_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["s" /* DELETE_DIR_SVC_DESC_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service/'+uuid,{params:{session:session}});}};}function updateDirectoryServiceDescription(session,description){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_32" /* UPDATE_DIR_SVC_DESC */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_34" /* UPDATE_DIR_SVC_DESC_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_33" /* UPDATE_DIR_SVC_DESC_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service',{params:{session:session},data:description});}};}function setBrandingCustomImage(formData,adminSession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["S" /* SET_BRANDING_IMAGE */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["U" /* SET_BRANDING_IMAGE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["T" /* SET_BRANDING_IMAGE_FAIL */]],promise:function promise(client,getState){return client.post('/FileTransfer/upload',{params:{sessionId:adminSession,action:__WEBPACK_IMPORTED_MODULE_1_util_constants__["b" /* ACTION_BRANDING_UPLOAD */],filename:__WEBPACK_IMPORTED_MODULE_1_util_constants__["j" /* BRANDING_UPLOAD_FILENAME */]},formData:formData});}};}function setGlobalSettings(session,settings){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_2" /* SET_GLOBAL_SETTINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_4" /* SET_GLOBAL_SETTINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_3" /* SET_GLOBAL_SETTINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/global-settings',{params:{session:session},data:settings});}};}function setMobileUploadSettings(adminSession,identSession,settings){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_13" /* SET_MOBILE_UPLOAD_SETTINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_15" /* SET_MOBILE_UPLOAD_SETTINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_14" /* SET_MOBILE_UPLOAD_SETTINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/global-settings/mobile-uploads',{params:{adminSession:adminSession,identSession:identSession},data:settings});}};}function setLoggingConfig(adminSession,config){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_9" /* SET_LOGGING_CONFIG */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_11" /* SET_LOGGING_CONFIG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_10" /* SET_LOGGING_CONFIG_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/logging-configuration',{params:{adminSession:adminSession},data:config});}};}function setIsCommunicatingWithDirectoryService(isCommunicating){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_6" /* SET_IS_COMMUNICATING_WITH_DIR_SVC */],payload:isCommunicating};}function setSingleSignOnCredentials(identitySession,username,encryptedPassword){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_20" /* SET_SSO_CREDENTIALS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_22" /* SET_SSO_CREDENTIALS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_21" /* SET_SSO_CREDENTIALS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/sso',{params:{identitySession:identitySession},data:{accountName:username,encryptedPassword:encryptedPassword}});}};}function setEmailServerConfig(adminSession,config){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["Y" /* SET_EMAIL_CONFIG */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_0" /* SET_EMAIL_CONFIG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["Z" /* SET_EMAIL_CONFIG_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/email-server-configuration',{params:{adminSession:adminSession},data:config});}};}function setPorts(adminSession,ports){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_16" /* SET_PORTS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_18" /* SET_PORTS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_17" /* SET_PORTS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/ports',{params:{adminSession:adminSession},data:ports});}};}function setBackupConfig(session,config){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["P" /* SET_BACKUP_CONFIG */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["R" /* SET_BACKUP_CONFIG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["Q" /* SET_BACKUP_CONFIG_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/backup/config',{params:{session:session},data:config});}};}function setBrandingSettings(adminSession,config){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["V" /* SET_BRANDING_SETTINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["X" /* SET_BRANDING_SETTINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["W" /* SET_BRANDING_SETTINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/branding-settings',{params:{adminSession:adminSession},data:config});}};}function backup(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["d" /* BACKUP */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["f" /* BACKUP_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["e" /* BACKUP_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/backup/_backup',{params:{session:session}});}};}function cancelBackup(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["g" /* CANCEL_BACKUP */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["i" /* CANCEL_BACKUP_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["h" /* CANCEL_BACKUP_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/backup/_cancel',{params:{session:session}});}};}function restore(session,restoreArchivePath){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["J" /* RESTORE */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["L" /* RESTORE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["K" /* RESTORE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/backup/_restore',{params:{session:session},data:{restoreArchivePath:restoreArchivePath}});}};}function createMediaEngine(identitySession,mediaEngine){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["o" /* CREATE_MEDIA_ENGINE */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["q" /* CREATE_MEDIA_ENGINE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["p" /* CREATE_MEDIA_ENGINE_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/media-engine',{params:{identitySession:identitySession},data:mediaEngine});}};}function deleteMediaEngine(identitySession,mediaEngineId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["u" /* DELETE_MEDIA_ENGINE */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["w" /* DELETE_MEDIA_ENGINE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["v" /* DELETE_MEDIA_ENGINE_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/media-engine',{params:{identitySession:identitySession,id:mediaEngineId}});}};}function testMediaEngine(session,mediaEngine){var address=mediaEngine.address,port=mediaEngine.port;return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_29" /* TEST_MEDIA_ENGINE */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_31" /* TEST_MEDIA_ENGINE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_30" /* TEST_MEDIA_ENGINE_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/media-engine/get-information',{params:{session:session,address:address,port:port}});}};}function updateMediaEngine(identitySession,mediaEngine){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_35" /* UPDATE_MEDIA_ENGINE */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_37" /* UPDATE_MEDIA_ENGINE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_36" /* UPDATE_MEDIA_ENGINE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/media-engine',{params:{identitySession:identitySession},data:mediaEngine});}};}function validateEmailServerConfig(adminSession,emailServerConfig){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_40" /* VALIDATE_EMAIL_SERVER_CONFIG */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_42" /* VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_41" /* VALIDATE_EMAIL_SERVER_CONFIG_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/email-server-configuration/_validate',{params:{adminSession:adminSession},data:emailServerConfig});}};}function setEmailServerConfigValidating(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_1" /* SET_EMAIL_SERVER_CONFIG_VALIDATING */]};}function clearEmailServerConfigValidating(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["j" /* CLEAR_EMAIL_SERVER_CONFIG_VALIDATING */]};}function setMediaEngineTestPending(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["_12" /* SET_MEDIA_ENGINE_TEST_PENDING */]};}function clearMediaEngineTestPending(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_serverTypes__["k" /* CLEAR_MEDIA_ENGINE_TEST_PENDING */]};}var actions={backup:backup,cancelBackup:cancelBackup,clearEmailServerConfigValidating:clearEmailServerConfigValidating,clearMediaEngineTestPending:clearMediaEngineTestPending,createDirectoryServiceDescription:createDirectoryServiceDescription,createMediaEngine:createMediaEngine,deleteDirectoryServiceDescription:deleteDirectoryServiceDescription,deleteMediaEngine:deleteMediaEngine,getAdminProperties:getAdminProperties,getServerFolders:getServerFolders,getServerSystemInformation:getServerSystemInformation,setSingleSignOnCredentials:setSingleSignOnCredentials,restartServer:restartServer,restore:restore,sendDiagnosticData:sendDiagnosticData,setBackupConfig:setBackupConfig,setBrandingCustomImage:setBrandingCustomImage,setBrandingSettings:setBrandingSettings,setEmailServerConfig:setEmailServerConfig,setEmailServerConfigValidating:setEmailServerConfigValidating,setGlobalSettings:setGlobalSettings,setMobileUploadSettings:setMobileUploadSettings,setIsCommunicatingWithDirectoryService:setIsCommunicatingWithDirectoryService,setIsRestarting:setIsRestarting,setIsAdminServerRestarting:setIsAdminServerRestarting,setIsSendingDiagnosticData:setIsSendingDiagnosticData,setLoggingConfig:setLoggingConfig,setMediaEngineTestPending:setMediaEngineTestPending,setPorts:setPorts,setServerStatus:setServerStatus,startServer:startServer,stopServer:stopServer,testMediaEngine:testMediaEngine,updateDirectoryServiceDescription:updateDirectoryServiceDescription,updateMediaEngine:updateMediaEngine,updateServerFolders:updateServerFolders,updateServerFolderRoot:updateServerFolderRoot,validateEmailServerConfig:validateEmailServerConfig};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(835);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(838);
/* unused harmony reexport Collection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(845);
/* unused harmony reexport ColumnSizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(31);
/* unused harmony reexport accessibilityOverscanIndicesGetter */
/* unused harmony reexport defaultCellRangeRenderer */
/* unused harmony reexport defaultOverscanIndicesGetter */
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(847);
/* unused harmony reexport InfiniteLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(853);
/* unused harmony reexport createMasonryCellPositioner */
/* unused harmony reexport Masonry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(866);
/* unused harmony reexport MultiGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(869);
/* unused harmony reexport ScrollSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(871);
/* unused harmony reexport createTableMultiSort */
/* unused harmony reexport defaultTableCellDataGetter */
/* unused harmony reexport defaultTableCellRenderer */
/* unused harmony reexport defaultTableHeaderRenderer */
/* unused harmony reexport defaultTableHeaderRowRenderer */
/* unused harmony reexport defaultTableRowRenderer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["b"]; });
/* unused harmony reexport SortIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(874);
/* unused harmony reexport WindowScroller */














/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(49);
var IE8_DOM_DEFINE = __webpack_require__(334);
var toPrimitive = __webpack_require__(202);
var dP = Object.defineProperty;

exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(83)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(596);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(188);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_constants__ = __webpack_require__(4);
var initialState={catalogs:[],// global
catalogTypes:[],// global
catalogProperties:{},// for selected catalog
customXMPNamespaces:[],// global
fields:[],// for selected catalog
metadataDefinitions:[],// global
metadataMappings:[],// global
selectedFieldCategory:'All',// global
selectedFieldsListItemName:null,// for selected catalog
userCatalogInfo:[]// for selected catalog
};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["P" /* GET_CATALOGS_SUCCESS */]:return Object.assign({},state,{catalogs:action.payload.sort(function(a,b){return a.name.localeCompare(b.name);})});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["S" /* GET_CATALOG_PROPERTIES_SUCCESS */]:return Object.assign({},state,{catalogProperties:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["R" /* GET_CATALOG_PROPERTIES_FAIL */]:return Object.assign({},state,{catalogProperties:{}});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["V" /* GET_CATALOG_TYPES_SUCCESS */]:return Object.assign({},state,{catalogTypes:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["U" /* GET_CATALOG_TYPES_FAIL */]:return Object.assign({},state,{catalogTypes:[]});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["Y" /* GET_CUSTOM_XMP_NAMESPACES_SUCCESS */]:return Object.assign({},state,{customXMPNamespaces:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_1" /* GET_FIELDS_SUCCESS */]:return Object.assign({},state,{fields:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_0" /* GET_FIELDS_FAIL */]:return Object.assign({},state,{fields:[]});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_7" /* GET_METADATA_SUCCESS */]:return Object.assign({},state,{metadataDefinitions:action.payload.sort(function(a,b){return a.displayName.localeCompare(b.displayName);})});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_3" /* GET_METADATA_FAIL */]:return Object.assign({},state,{metadataDefinitions:[]});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_6" /* GET_METADATA_MAPPINGS_SUCCESS */]:return Object.assign({},state,{metadataMappings:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_5" /* GET_METADATA_MAPPINGS_FAIL */]:return Object.assign({},state,{metadataMappings:[]});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_10" /* GET_USER_CATALOG_INFO_SUCCESS */]:return Object.assign({},state,{userCatalogInfo:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_39" /* SET_SELECTED_FIELD_CATEGORY */]:return Object.assign({},state,{selectedFieldCategory:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_38" /* SET_SELECTED_FIELDS_LIST_ITEM_NAME */]:return Object.assign({},state,{selectedFieldsListItemName:action.payload});default:return state;}}function getCatalogs(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["N" /* GET_CATALOGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["P" /* GET_CATALOGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["O" /* GET_CATALOGS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog',{params:{session:identitySession}});}};}function getCatalogProperties(identitySession,catalogId,properties){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["Q" /* GET_CATALOG_PROPERTIES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["S" /* GET_CATALOG_PROPERTIES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["R" /* GET_CATALOG_PROPERTIES_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/properties/'+properties.join(),{params:{session:identitySession}});}};}function getCatalogTypes(identitySession,locale){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["T" /* GET_CATALOG_TYPES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["V" /* GET_CATALOG_TYPES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["U" /* GET_CATALOG_TYPES_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog-template',{params:{session:identitySession,locale:locale}});}};}function createCatalogTemplate(identitySession,catalogId,templateName){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["p" /* CREATE_CATALOG_TEMPLATE */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["r" /* CREATE_CATALOG_TEMPLATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["q" /* CREATE_CATALOG_TEMPLATE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog-template',{params:{session:identitySession,catalog_id:catalogId,name:templateName}});}};}function createCatalog(adminSession,catalog,createWatchFolder,watchFolderNamePartFiles){__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__["a" /* default */].debug('Create catalog: ',catalog);return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["m" /* CREATE_CATALOG */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["o" /* CREATE_CATALOG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["n" /* CREATE_CATALOG_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog',{data:catalog,params:{session:adminSession,addAdminUser:true,createDiskPreviewSettings:true,createWatchFolder:catalog.storageType&&catalog.storageType===__WEBPACK_IMPORTED_MODULE_2_util_constants__["n" /* CATALOG_STORAGE_TYPE */].FILESYSTEM&&createWatchFolder,watchFolderNamePartFiles:watchFolderNamePartFiles}});}};}function deleteCatalog(identitySession,catalog){__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__["a" /* default */].debug('Delete catalog: ',catalog);return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["y" /* DELETE_CATALOG */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["A" /* DELETE_CATALOG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["z" /* DELETE_CATALOG_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalog.name,{params:{session:identitySession}});}};}function deleteCatalogTemplate(identitySession,templateGuid){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["B" /* DELETE_CATALOG_TEMPLATE */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["D" /* DELETE_CATALOG_TEMPLATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["C" /* DELETE_CATALOG_TEMPLATE_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog-template/'+templateGuid,{params:{session:identitySession}});}};}function renameCatalogTemplate(identitySession,templateGuid,name){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_26" /* RENAME_CATALOG_TEMPLATE */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_28" /* RENAME_CATALOG_TEMPLATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_27" /* RENAME_CATALOG_TEMPLATE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog-template/rename/'+templateGuid,{params:{newName:name,session:identitySession}});}};}function renameCatalog(identitySession,catalog){__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__["a" /* default */].debug('Rename catalog: ',catalog);return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_23" /* RENAME_CATALOG */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_25" /* RENAME_CATALOG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_24" /* RENAME_CATALOG_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalog.catalogId,{data:catalog,params:{session:identitySession}});}};}function updateDiskPreviewInfo(identitySession,catalogId,dpi){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_43" /* UPDATE_DISK_PREVIEW_INFO */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_45" /* UPDATE_DISK_PREVIEW_INFO_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_44" /* UPDATE_DISK_PREVIEW_INFO_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/disk-preview-info',{data:dpi,params:{session:identitySession}});}};}function getFields(identitySession,catalogId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["Z" /* GET_FIELDS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_1" /* GET_FIELDS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_0" /* GET_FIELDS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition',{params:{session:identitySession,predefined_values:true}});}};}function addFields(identitySession,catalogId,fields){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["d" /* ADD_FIELDS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["f" /* ADD_FIELDS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["e" /* ADD_FIELDS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition',{data:fields,params:{session:identitySession}});}};}function updateFields(identitySession,catalogId,fields){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_46" /* UPDATE_FIELDS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_48" /* UPDATE_FIELDS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_47" /* UPDATE_FIELDS_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition',{data:fields,params:{session:identitySession}});}};}function removeFields(identitySession,catalogId,fieldIds){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_17" /* REMOVE_FIELDS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_19" /* REMOVE_FIELDS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_18" /* REMOVE_FIELDS_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition/'+fieldIds.join(),{params:{session:identitySession}});}};}function removeAllPredefinedValues(identitySession,catalogId,fieldIds){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_11" /* REMOVE_ALL_PREDEFINED_VALUES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_13" /* REMOVE_ALL_PREDEFINED_VALUES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_12" /* REMOVE_ALL_PREDEFINED_VALUES_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition/predefined-values/'+fieldIds.join(),{params:{session:identitySession}});}};}function createMetadataDefinitions(identitySession,metadataDefinitions){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["s" /* CREATE_METADATA_DEFINITIONS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["u" /* CREATE_METADATA_DEFINITIONS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["t" /* CREATE_METADATA_DEFINITIONS_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/metadata-definition',{params:{session:identitySession},data:metadataDefinitions});}};}function deleteMetadataDefinition(identitySession,metadataDefinitionId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["E" /* DELETE_METADATA_DEFINITION */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["G" /* DELETE_METADATA_DEFINITION_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["F" /* DELETE_METADATA_DEFINITION_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/metadata-definition/'+metadataDefinitionId,{params:{session:identitySession}});}};}function getMetadataDefinitions(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_2" /* GET_METADATA */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_7" /* GET_METADATA_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_3" /* GET_METADATA_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/metadata-definition',{params:{session:identitySession}});}};}function getMetadataMappings(identitySession,catalogId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_4" /* GET_METADATA_MAPPINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_6" /* GET_METADATA_MAPPINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_5" /* GET_METADATA_MAPPINGS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/metadata-mapping',{params:{session:identitySession}});}};}function createMetadataMappings(identitySession,catalogId,mappings){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["v" /* CREATE_METADATA_MAPPINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["x" /* CREATE_METADATA_MAPPINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["w" /* CREATE_METADATA_MAPPINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/metadata-mapping',{data:mappings,params:{session:identitySession}});}};}function deleteMetadataMappings(identitySession,catalogId,mappings){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["H" /* DELETE_METADATA_MAPPINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["J" /* DELETE_METADATA_MAPPINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["I" /* DELETE_METADATA_MAPPINGS_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/metadata-mapping',{data:mappings,params:{session:identitySession}});}};}function setSelectedFieldCategory(category){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_39" /* SET_SELECTED_FIELD_CATEGORY */],payload:category};}function setSelectedFieldsListItemName(name){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_38" /* SET_SELECTED_FIELDS_LIST_ITEM_NAME */],payload:name};}function getUserCatalogInfo(identitySession,catalogName){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_8" /* GET_USER_CATALOG_INFO */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_10" /* GET_USER_CATALOG_INFO_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_9" /* GET_USER_CATALOG_INFO_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/membership',{params:{session:identitySession,catalog_names:catalogName}});}};}function addOrUpdateUserCatalogInfo(identitySession,infos){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["j" /* ADD_OR_UPDATE_USER_CATALOG_INFO */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["l" /* ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["k" /* ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/membership',{data:infos,params:{session:identitySession}});}};}function removeUsersFromCatalog(identitySession,catalogName,userNames){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_20" /* REMOVE_USERS_FROM_CATALOG */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_22" /* REMOVE_USERS_FROM_CATALOG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_21" /* REMOVE_USERS_FROM_CATALOG_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogName+'/membership',{data:userNames,params:{session:identitySession}});}};}function updateCatalogingOptions(identitySession,catalogId,catOptions){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_40" /* UPDATE_CATALOGING_OPTIONS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_42" /* UPDATE_CATALOGING_OPTIONS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_41" /* UPDATE_CATALOGING_OPTIONS_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/cataloging-options',{data:catOptions,params:{session:identitySession}});}};}function setExclusionInfo(identitySession,catalogId,exclusionInfo){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_32" /* SET_EXCLUSION_INFO */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_34" /* SET_EXCLUSION_INFO_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_33" /* SET_EXCLUSION_INFO_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/exclusion-info',{data:exclusionInfo,params:{session:identitySession}});}};}function restoreFileTypesDefault(identitySession,catalogId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_29" /* RESTORE_FILE_TYPES_DEFAULT */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_31" /* RESTORE_FILE_TYPES_DEFAULT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_30" /* RESTORE_FILE_TYPES_DEFAULT_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/fileTypes/_restoreDefaults',{params:{session:identitySession}});}};}function setIngestConfig(identitySession,catalogId,ingestConfig){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_35" /* SET_INGEST_CONFIG */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_37" /* SET_INGEST_CONFIG_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_36" /* SET_INGEST_CONFIG_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/ingest-config',{data:ingestConfig,params:{session:identitySession}});}};}function updateSmartKeywordsSettings(identitySession,catalogId,smartKeywordsSettings){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_52" /* UPDATE_SMART_KEYWORDS_SETTINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_54" /* UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_53" /* UPDATE_SMART_KEYWORDS_SETTINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/smart-keywords-settings',{data:smartKeywordsSettings,params:{session:identitySession}});}};}function addCustomXmpNamespaces(identitySession,namespaces){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["a" /* ADD_CUSTOM_XMP_NAMESPACES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["c" /* ADD_CUSTOM_XMP_NAMESPACES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["b" /* ADD_CUSTOM_XMP_NAMESPACES_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/namespace',{data:namespaces,params:{session:identitySession}});}};}function getCustomXmpNamespaces(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["W" /* GET_CUSTOM_XMP_NAMESPACES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["Y" /* GET_CUSTOM_XMP_NAMESPACES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["X" /* GET_CUSTOM_XMP_NAMESPACES_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/namespace/_custom',{params:{session:identitySession}});}};}function removeCustomXmpNamespaces(identitySession,namespaceIds){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_14" /* REMOVE_CUSTOM_XMP_NAMESPACES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_16" /* REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_15" /* REMOVE_CUSTOM_XMP_NAMESPACES_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/namespace',{params:{session:identitySession,nsIds:namespaceIds}});}};}function updatePredefinedList(identitySession,catalogId,fieldDefId,valuesToAdd,valuesToRemove){var data={};if(valuesToAdd){data.addPredefinedValues=valuesToAdd;}if(valuesToRemove){data.removePredefinedValues=valuesToRemove;}return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_49" /* UPDATE_PREDEFINED_LIST */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_51" /* UPDATE_PREDEFINED_LIST_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["_50" /* UPDATE_PREDEFINED_LIST_FAIL */]],meta:{catalogId:catalogId},promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition/'+fieldDefId+'/predefined-value/',{params:{session:identitySession},data:data});}};}function addNestedValues(identitySession,catalogId,fieldDefId,valuesToAdd,parentNestedValueId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["g" /* ADD_NESTED_VALUES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["i" /* ADD_NESTED_VALUES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["h" /* ADD_NESTED_VALUES_FAIL */]],meta:{catalogId:catalogId},promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition/'+fieldDefId+'/nested-value',{params:{session:identitySession,parentId:parentNestedValueId},data:valuesToAdd});}};}function deleteNestedValues(identitySession,catalogId,fieldDefId,idsToRemove){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["K" /* DELETE_NESTED_VALUES */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["M" /* DELETE_NESTED_VALUES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_catalogTypes__["L" /* DELETE_NESTED_VALUES_FAIL */]],meta:{catalogId:catalogId,idsToRemove:idsToRemove},promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_2_util_constants__["f" /* API */]+'/catalog/'+catalogId+'/field-definition/'+fieldDefId+'/nested-value',{params:{session:identitySession},data:idsToRemove});}};}var actions={addCustomXmpNamespaces:addCustomXmpNamespaces,addFields:addFields,addNestedValues:addNestedValues,addOrUpdateUserCatalogInfo:addOrUpdateUserCatalogInfo,createCatalog:createCatalog,createCatalogTemplate:createCatalogTemplate,createMetadataDefinitions:createMetadataDefinitions,createMetadataMappings:createMetadataMappings,deleteMetadataDefinition:deleteMetadataDefinition,deleteCatalog:deleteCatalog,deleteCatalogTemplate:deleteCatalogTemplate,deleteMetadataMappings:deleteMetadataMappings,deleteNestedValues:deleteNestedValues,getCatalogs:getCatalogs,getCatalogProperties:getCatalogProperties,getCatalogTypes:getCatalogTypes,getCustomXmpNamespaces:getCustomXmpNamespaces,getFields:getFields,getMetadataDefinitions:getMetadataDefinitions,getMetadataMappings:getMetadataMappings,getUserCatalogInfo:getUserCatalogInfo,removeAllPredefinedValues:removeAllPredefinedValues,removeCustomXmpNamespaces:removeCustomXmpNamespaces,removeFields:removeFields,removeUsersFromCatalog:removeUsersFromCatalog,renameCatalog:renameCatalog,renameCatalogTemplate:renameCatalogTemplate,restoreFileTypesDefault:restoreFileTypesDefault,setExclusionInfo:setExclusionInfo,setIngestConfig:setIngestConfig,setSelectedFieldCategory:setSelectedFieldCategory,setSelectedFieldsListItemName:setSelectedFieldsListItemName,updateCatalogingOptions:updateCatalogingOptions,updateDiskPreviewInfo:updateDiskPreviewInfo,updateFields:updateFields,updateSmartKeywordsSettings:updateSmartKeywordsSettings,updatePredefinedList:updatePredefinedList};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(57);
var createDesc = __webpack_require__(140);
module.exports = __webpack_require__(59) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(340);
var defined = __webpack_require__(197);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TABLE_HEADER_STYLE; });
/* unused harmony export createMockSelectionState */
/* harmony export (immutable) */ __webpack_exports__["d"] = getNewSelectionState;
/* harmony export (immutable) */ __webpack_exports__["c"] = getIndexOfFirstSelectedItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSelectedIndices;
/* harmony export (immutable) */ __webpack_exports__["g"] = isItemWithIdSelected;
/* harmony export (immutable) */ __webpack_exports__["f"] = isItemAtIndexSelected;
/* unused harmony export findItemIndex */
/* harmony export (immutable) */ __webpack_exports__["h"] = reindexSelectedItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeNewSelection;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var TABLE_HEADER_STYLE={outline:'none',display:'flex',lineHeight:1};// Must contain an id or uuid or catalogId
// opaque means you can't see the structure of the type from outside this file.
function createMockSelectionState(selectedItems,lastSelectedItem){return{selectedItems:selectedItems,lastSelectedItem:lastSelectedItem};}function getNewSelectionState(){return{lastSelectedItem:undefined,selectedItems:[]};}function getItemId(item){return item.id||item.uuid||item.catalogId;// Any other id types?
}function getIndexOfFirstSelectedItem(selectionState){return selectionState.selectedItems[0]&&selectionState.selectedItems[0].index;}function getSelectedIndices(selectionState){return selectionState.selectedItems.map(function(item){return item.index;});}function isItemWithIdSelected(id,selectionState){return selectionState.selectedItems.findIndex(function(el){return getItemId(el)===id;})!==-1;}function isItemAtIndexSelected(index,selectionState){return selectionState.selectedItems.findIndex(function(el){return el.index===index;})!==-1;}function findItemIndex(id,sortedItems){var selectedIndex=void 0;if(id){selectedIndex=sortedItems.findIndex(function(item){return getItemId(item)===id;});}return selectedIndex;}function reindexSelectedItems(sortedItems,selectionState){return Object.assign({},selectionState,{selectedItems:selectionState.selectedItems.reduce(function(acc,item){var index=findItemIndex(getItemId(item),sortedItems);if(index!==undefined&&index>-1){acc.push(sortedItems[index]);}return acc;},[])});}function getNewSelectedItemForItem(src,index){if(src.id){return{id:src.id,index:index};}else if(src.uuid){return{uuid:src.uuid,index:index};}else if(src.catalogId){return{catalogId:src.catalogId,index:index};}else{return{id:0,index:index};}}function computeNewSelection(index,sortedItems,selectionState,event){var singleSelectionOnly=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;if(!singleSelectionOnly&&event&&(event.metaKey||event.ctrlKey)){// Command/Ctrl click on a selected item deselects it.
if(isItemAtIndexSelected(index,selectionState)){return Object.assign({},selectionState,{selectedItems:selectionState.selectedItems.filter(function(el){return el.index!==index;})});}else{// Otherwise select it
var selectedItem=getNewSelectedItemForItem(sortedItems[index],index);if(selectedItem){return{lastSelectedItem:selectedItem,selectedItems:[].concat(_toConsumableArray(selectionState.selectedItems),[selectedItem])};}}}else if(!singleSelectionOnly&&event&&event.shiftKey){var makeRange=function makeRange(size){var startAt=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return[].concat(_toConsumableArray(Array(size).keys())).map(function(i){return i+startAt;});};var _lastSelectedItem=selectionState.lastSelectedItem,_selectedItems=selectionState.selectedItems;var newLastSelectedItem=_lastSelectedItem&&isItemAtIndexSelected(_lastSelectedItem.index,selectionState)?_lastSelectedItem:getNewSelectedItemForItem(sortedItems[0],0);if(newLastSelectedItem&&newLastSelectedItem.index!==undefined){return Object.assign({},selectionState,{selectedItems:_selectedItems.concat(makeRange(Math.abs(newLastSelectedItem.index-index)+1,Math.min(newLastSelectedItem.index,index)).map(function(i){return getNewSelectedItemForItem(sortedItems[i],i);}).filter(function(i){return!isItemAtIndexSelected(i.index,selectionState);}))});// Remove dups
}}else{// Normal selection, deselect everything else
if(sortedItems[index]){var newSelectedItem=getNewSelectedItemForItem(sortedItems[index],index);if(newSelectedItem){return{selectedItems:[newSelectedItem],lastSelectedItem:newSelectedItem};}}}return selectionState;}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    getRawTag = __webpack_require__(1014),
    objectToString = __webpack_require__(1015);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1040),
    getValue = __webpack_require__(1043);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseMap_js__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(35);





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseMap_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(iteratee, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export APPROVED_ATTRIBUTE_NAME */
/* unused harmony export APPROVED_BY_ATTRIBUTE_NAME */
/* unused harmony export ASSET_ID_ATTRIBUTE_NAME */
/* unused harmony export AV_PREVIEW_STATUS_ATTRIBUTE_NAME */
/* unused harmony export BIT_DEPTH_ATTRIBUTE_NAME */
/* unused harmony export CATALOGED_ATTRIBUTE_NAME */
/* unused harmony export CATALOGED_BY_ATTRIBUTE_NAME */
/* unused harmony export CHECK_OUT_STATUS_ATTRIBUTE_NAME */
/* unused harmony export CHECK_OUT_USER_ATTRIBUTE_NAME */
/* unused harmony export CLIENT_NAME_ATTRIBUTE_NAME */
/* unused harmony export COLOR_MODE_ATTRIBUTE_NAME */
/* unused harmony export COLOR_PROFILE_ATTRIBUTE_NAME */
/* unused harmony export COPYRIGHT_ATTRIBUTE_NAME */
/* unused harmony export CORRUPT_FILE_ATTRIBUTE_NAME */
/* unused harmony export CREATED_ATTRIBUTE_NAME */
/* unused harmony export CREATOR_APP_ATTRIBUTE_NAME */
/* unused harmony export CUSTOM_THUMBNAIL_ATTRIBUTE_NAME */
/* unused harmony export DESCRIPTION_WRITER_ATTRIBUTE_NAME */
/* unused harmony export DIR_PATH_ATTRIBUTE_NAME */
/* unused harmony export DOC_TITLE_ATTRIBUTE_NAME */
/* unused harmony export DOCUMENT_TEXT_ATTRIBUTE_NAME */
/* unused harmony export EXIF_APERTURE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_CAMERA_MAKE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_CAMERA_MODEL_ATTRIBUTE_NAME */
/* unused harmony export EXIF_DATE_DIGITIZED_ATTRIBUTE_NAME */
/* unused harmony export EXIF_DATE_TAKEN_ATTRIBUTE_NAME */
/* unused harmony export EXIF_EXPOSURE_BIAS_ATTRIBUTE_NAME */
/* unused harmony export EXIF_EXPOSURE_TIME_ATTRIBUTE_NAME */
/* unused harmony export EXIF_F_NUMBER_ATTRIBUTE_NAME */
/* unused harmony export EXIF_FLASH_ATTRIBUTE_NAME */
/* unused harmony export EXIF_FOCAL_LENGTH_ATTRIBUTE_NAME */
/* unused harmony export EXIF_GPS_ALTITIUDE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_GPS_LATITUDE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_GPS_LONGITUDE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_ISO_SPEED_ATTRIBUTE_NAME */
/* unused harmony export EXIF_LIGHT_SOURCE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_METERING_MODE_ATTRIBUTE_NAME */
/* unused harmony export EXIF_SHUTTER_SPEED_ATTRIBUTE_NAME */
/* unused harmony export EXIF_WHITE_BALANCE_ATTRIBUTE_NAME */
/* unused harmony export EXTENSION_WIN_ATTRIBUTE_NAME */
/* unused harmony export FILE_DESCRIPTION_ATTRIBUTE_NAME */
/* unused harmony export FILE_SIZE_ATTRIBUTE_NAME */
/* unused harmony export FILENAME_ATTRIBUTE_NAME */
/* unused harmony export FLAGS_ATTRIBUTE_NAME */
/* unused harmony export FONTSENSE_FAMILY_ATTRIBUTE_NAME */
/* unused harmony export FONTSENSE_FONT_KIND_ATTRIBUTE_NAME */
/* unused harmony export FONTSENSE_CHECKSUM_ATTRIBUTE_NAME */
/* unused harmony export FONTSENSE_FOUNDRY_ATTRIBUTE_NAME */
/* unused harmony export FONTSENSE_POSTSCRIPT_NAME_ATTRIBUTE_NAME */
/* unused harmony export FONTSENSE_VERSION_ATTRIBUTE_NAME */
/* unused harmony export FULLY_CATALOGED_ATTRIBUTE_NAME */
/* unused harmony export GEOMETRY_ATTRIBUTE_NAME */
/* unused harmony export GEO_COORDINATE_REF_ATTRIBUTE_NAME */
/* unused harmony export GEO_TYPE_ATTRIBUTE_NAME */
/* unused harmony export GEO_X_ORIGIN_ATTRIBUTE_NAME */
/* unused harmony export GEO_Y_ORIGIN_ATTRIBUTE_NAME */
/* unused harmony export GEO_X_RES_ATTRIBUTE_NAME */
/* unused harmony export GEO_Y_RES_ATTRIBUTE_NAME */
/* unused harmony export GEO_X_ROT_ATTRIBUTE_NAME */
/* unused harmony export GEO_Y_ROT_ATTRIBUTE_NAME */
/* unused harmony export GEO_NATIVE_BOUNDS_ATTRIBUTE_NAME */
/* unused harmony export GEO_WGS84_BOUNDS_ATTRIBUTE_NAME */
/* unused harmony export GEO_EPGS_CODE_ATTRIBUTE_NAME */
/* unused harmony export HEIGHT_ATTRIBUTE_NAME */
/* unused harmony export HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME */
/* unused harmony export IPTC_AUTHOR_TITLE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CATEGORY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CATEGORIES_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CITY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_COPYRIGHT_INFO_URL_ATTRIBUTE_NAME */
/* unused harmony export IPTC_COPYRIGHT_NOTICE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_COUNTRY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_COUNTRY_CODE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREDIT_ATTRIBUTE_NAME */
/* unused harmony export IPTC_DATE_CREATED_ATTRIBUTE_NAME */
/* unused harmony export IPTC_EVENT_ATTRIBUTE_NAME */
/* unused harmony export IPTC_HEADLINE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_INSTRUCTIONS_ATTRIBUTE_NAME */
/* unused harmony export IPTC_SOURCE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_STATE_PROVINCE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_SUPPLEMENTAL_CATEGORIES_ATTRIBUTE_NAME */
/* unused harmony export IPTC_SUPPLEMENTAL_CATEGORY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_TITLE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_TRANSMISSION_REFERENCE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_URGENCY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_ADDRESS_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_ADDRESS_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_CITY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_CITY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_COUNTRY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_COUNTRY_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_EMAIL_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_EMAIL_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_JOB_TITLE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_PHONE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_PHONE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_POSTAL_CODE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_POSTAL_CODE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_STATE_PROVINCE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_STATE_PROVINCE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CREATOR_WEB_URL_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_CREATOR_WEB_URL_ATTRIBUTE_NAME */
/* unused harmony export IPTC_INTELLECTUAL_GENRE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_INTELLECTUAL_GENRE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_LOCATION_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_LOCATION_ATTRIBUTE_NAME */
/* unused harmony export IPTC_RIGHTS_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_RIGHTS_ATTRIBUTE_NAME */
/* unused harmony export IPTC_SCENE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_SCENE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_SUBJECT_CODE_ATTRIBUTE_NAME */
/* unused harmony export IPTC_CORE_SUBJECT_CODE_ATTRIBUTE_NAME */
/* unused harmony export IS_PANORAMIC_ATTRIBUTE_NAME */
/* unused harmony export JOB_NAME_ATTRIBUTE_NAME */
/* unused harmony export JOB_STATUS_ATTRIBUTE_NAME */
/* unused harmony export KEYWORDS_ATTRIBUTE_NAME */
/* unused harmony export LAST_MODIFIED_ATTRIBUTE_NAME */
/* unused harmony export LAST_UPDATED_ATTRIBUTE_NAME */
/* unused harmony export LOCK_STATUS_ATTRIBUTE_NAME */
/* unused harmony export MAC_CREATOR_ATTRIBUTE_NAME */
/* unused harmony export MAC_FILE_TYPE_ATTRIBUTE_NAME */
/* unused harmony export MAC_ZONE_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_AUDIO_CODEC_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_CHANNELS_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_COLOR_DEPTH_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_DURATION_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_FPS_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_SAMPLE_RATE_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_SAMPLE_SIZE_ATTRIBUTE_NAME */
/* unused harmony export MOVIE_VIDEO_CODEC_ATTRIBUTE_NAME */
/* unused harmony export MS_AUTHOR_ATTRIBUTE_NAME */
/* unused harmony export MS_COMPANY_ATTRIBUTE_NAME */
/* unused harmony export MS_LAST_SAVED_BY_ATTRIBUTE_NAME */
/* unused harmony export MS_MANAGER_ATTRIBUTE_NAME */
/* unused harmony export MS_SUBJECT_ATTRIBUTE_NAME */
/* unused harmony export MS_TEMPLATE_ATTRIBUTE_NAME */
/* unused harmony export MS_TITLE_ATTRIBUTE_NAME */
/* unused harmony export MULTIPAGE_COUNT_ATTRIBUTE_NAME */
/* unused harmony export NUMBER_OF_BANDS_ATTRIBUTE_NAME */
/* unused harmony export PATH_ATTRIBUTE_NAME */
/* unused harmony export PHOTOSHOP_LABEL_ATTRIBUTE_NAME */
/* unused harmony export PHOTOSHOP_RATING_ATTRIBUTE_NAME */
/* unused harmony export PIXELLIVE_AUTHOR_ATTRIBUTE_NAME */
/* unused harmony export PIXELLIVE_COMMENTS_ATTRIBUTE_NAME */
/* unused harmony export PIXELLIVE_COPYRIGHT_ATTRIBUTE_NAME */
/* unused harmony export PIXELLIVE_DATE_ATTRIBUTE_NAME */
/* unused harmony export PIXELLIVE_GENRE_ATTRIBUTE_NAME */
/* unused harmony export PIXELLIVE_TITLE_ATTRIBUTE_NAME */
/* unused harmony export PLACEHOLDER_ATTRIBUTE_NAME */
/* unused harmony export PREVIEW_ATTRIBUTE_NAME */
/* unused harmony export PREVIEW_ERROR_ATTRIBUTE_NAME */
/* unused harmony export RID_ATTRIBUTE_NAME */
/* unused harmony export ROUTED_TO_ATTRIBUTE_NAME */
/* unused harmony export ROUTING_NOTES_ATTRIBUTE_NAME */
/* unused harmony export SHORT_FILENAME_WIN_ATTRIBUTE_NAME */
/* unused harmony export SUGGESTED_KEYWORDS_ATTRIBUTE_NAME */
/* unused harmony export THUMBNAIL_ATTRIBUTE_NAME */
/* unused harmony export THUMBNAIL_SIZE_ATTRIBUTE_NAME */
/* unused harmony export UPDATED_BY_ATTRIBUTE_NAME */
/* unused harmony export VERTICAL_RESOLUTION_ATTRIBUTE_NAME */
/* unused harmony export VOLUME_ATTRIBUTE_NAME */
/* unused harmony export WATERMARKED_ATTRIBUTE_NAME */
/* unused harmony export WATERMARK_URL_ATTRIBUTE_NAME */
/* unused harmony export WEBSITE_ATTRIBUTE_NAME */
/* unused harmony export WIDTH_ATTRIBUTE_NAME */
/* unused harmony export WORK_NEEDED_ATTRIBUTE_NAME */
/* unused harmony export XMP_ATTRIBUTE_NAME */
/* unused harmony export RID_ATTRIBUTE_NAME_FOR_SERVER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Messages; });
/* unused harmony export EXCLUDED_FIELDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIELD_TYPE; });
/* unused harmony export ITEM_ID */
/* unused harmony export SYSTEM_FIELDS */
/* unused harmony export AV_PREVIEW_STATUS_NONE */
/* unused harmony export AV_PREVIEW_STATUS_PENDING */
/* unused harmony export AV_PREVIEW_STATUS_READY */
/* unused harmony export STANDARD_FIELDS_TO_RETRIEVE */
/* unused harmony export SYSTEM_DATE_FIELDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_KNOWN_READ_ONLY_FIELD_DEF_NAMES; });
/* unused harmony export DEFAULT_SORT_FIELD */
/* harmony export (immutable) */ __webpack_exports__["d"] = getAllDisplayableFields;
/* unused harmony export getAdvancedFindFields */
/* unused harmony export CHECKOUT_STATUS_INDEXES */
/* unused harmony export getCheckoutStatus */
/* unused harmony export getCheckoutStatusUserShortName */
/* unused harmony export getCheckoutStatusDateTime */
/* unused harmony export caseInsensitiveContains */
/* unused harmony export findFieldIndex */
/* unused harmony export getFieldDefByName */
/* unused harmony export getFieldDefById */
/* unused harmony export getIdsForFieldDefs */
/* unused harmony export isSystemField */
/* unused harmony export getFieldTypeName */
/* unused harmony export getPredefinedValuesForFieldDef */
/* harmony export (immutable) */ __webpack_exports__["e"] = multivalueCompareFn;
/* harmony export (immutable) */ __webpack_exports__["f"] = sortValuesForFieldDef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(2);
// All known field names
var APPROVED_ATTRIBUTE_NAME='Approved';var APPROVED_BY_ATTRIBUTE_NAME='Approved By';var ASSET_ID_ATTRIBUTE_NAME='asset_id';var AV_PREVIEW_STATUS_ATTRIBUTE_NAME='com.extensis.portfolio.AVPreviewStatus';var BIT_DEPTH_ATTRIBUTE_NAME='Bit Depth';var CATALOGED_ATTRIBUTE_NAME='Cataloged';var CATALOGED_BY_ATTRIBUTE_NAME='Cataloged By';var CHECK_OUT_STATUS_ATTRIBUTE_NAME='com.extensis.portfolio.checkoutStatus';var CHECK_OUT_USER_ATTRIBUTE_NAME='com.extensis.portfolio.checkedOutBy';var CLIENT_NAME_ATTRIBUTE_NAME='Client Name';var COLOR_MODE_ATTRIBUTE_NAME='Color Mode';var COLOR_PROFILE_ATTRIBUTE_NAME='Color Profile';var COPYRIGHT_ATTRIBUTE_NAME='Copyright';var CORRUPT_FILE_ATTRIBUTE_NAME='CorruptFile';var CREATED_ATTRIBUTE_NAME='Created';var CREATOR_APP_ATTRIBUTE_NAME='Creator Application';var CUSTOM_THUMBNAIL_ATTRIBUTE_NAME='Custom Thumbnail';var DESCRIPTION_WRITER_ATTRIBUTE_NAME='Description Writer';var DIR_PATH_ATTRIBUTE_NAME='Directory Path';var DOC_TITLE_ATTRIBUTE_NAME='Document Title';var DOCUMENT_TEXT_ATTRIBUTE_NAME='Document Text';var EXIF_APERTURE_ATTRIBUTE_NAME='EXIF - Aperture';var EXIF_CAMERA_MAKE_ATTRIBUTE_NAME='EXIF - Camera Make';var EXIF_CAMERA_MODEL_ATTRIBUTE_NAME='EXIF - Camera Model';var EXIF_DATE_DIGITIZED_ATTRIBUTE_NAME='EXIF - Date Digitized';var EXIF_DATE_TAKEN_ATTRIBUTE_NAME='EXIF - Date Taken';var EXIF_EXPOSURE_BIAS_ATTRIBUTE_NAME='EXIF - Exposure Bias';var EXIF_EXPOSURE_TIME_ATTRIBUTE_NAME='EXIF - Exposure Time';var EXIF_F_NUMBER_ATTRIBUTE_NAME='EXIF - F-Number';var EXIF_FLASH_ATTRIBUTE_NAME='EXIF - Flash';var EXIF_FOCAL_LENGTH_ATTRIBUTE_NAME='EXIF - Focal Length';var EXIF_GPS_ALTITIUDE_ATTRIBUTE_NAME='EXIF - GPS Altitude';var EXIF_GPS_LATITUDE_ATTRIBUTE_NAME='EXIF - GPS Latitude';var EXIF_GPS_LONGITUDE_ATTRIBUTE_NAME='EXIF - GPS Longitude';var EXIF_ISO_SPEED_ATTRIBUTE_NAME='EXIF - ISO Speed';var EXIF_LIGHT_SOURCE_ATTRIBUTE_NAME='EXIF - Light Source';var EXIF_METERING_MODE_ATTRIBUTE_NAME='EXIF - Metering Mode';var EXIF_SHUTTER_SPEED_ATTRIBUTE_NAME='EXIF - Shutter Speed';var EXIF_WHITE_BALANCE_ATTRIBUTE_NAME='EXIF - White Balance';var EXTENSION_WIN_ATTRIBUTE_NAME='Extension Win';var FILE_DESCRIPTION_ATTRIBUTE_NAME='File Description';var FILE_SIZE_ATTRIBUTE_NAME='File Size';var FILENAME_ATTRIBUTE_NAME='Filename';var FLAGS_ATTRIBUTE_NAME='Flags';var FONTSENSE_FAMILY_ATTRIBUTE_NAME='Extensis Font Sense - Family';var FONTSENSE_FONT_KIND_ATTRIBUTE_NAME='Extensis Font Sense - Font Type';var FONTSENSE_CHECKSUM_ATTRIBUTE_NAME='Extensis Font Sense - Font Sense ID';var FONTSENSE_FOUNDRY_ATTRIBUTE_NAME='Extensis Font Sense - Foundry';var FONTSENSE_POSTSCRIPT_NAME_ATTRIBUTE_NAME='Extensis Font Sense - PostScript Name';var FONTSENSE_VERSION_ATTRIBUTE_NAME='Extensis Font Sense - Version';var FULLY_CATALOGED_ATTRIBUTE_NAME='FullyCataloged';var GEOMETRY_ATTRIBUTE_NAME='Geometry';var GEO_COORDINATE_REF_ATTRIBUTE_NAME='Geo - Coordinate Reference System';var GEO_TYPE_ATTRIBUTE_NAME='Geo - Type';var GEO_X_ORIGIN_ATTRIBUTE_NAME='Geo - X-Origin';var GEO_Y_ORIGIN_ATTRIBUTE_NAME='Geo - Y-Origin';var GEO_X_RES_ATTRIBUTE_NAME='Geo - X-Resolution';var GEO_Y_RES_ATTRIBUTE_NAME='Geo - Y-Resolution';var GEO_X_ROT_ATTRIBUTE_NAME='Geo - X-Rotation';var GEO_Y_ROT_ATTRIBUTE_NAME='Geo - Y-Rotation';var GEO_NATIVE_BOUNDS_ATTRIBUTE_NAME='Geo - Native Bounds';var GEO_WGS84_BOUNDS_ATTRIBUTE_NAME='Geo - WGS 84 Bounds';var GEO_EPGS_CODE_ATTRIBUTE_NAME='Geo - EPSG Code';var HEIGHT_ATTRIBUTE_NAME='Height';var HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME='Horizontal Resolution';var IPTC_AUTHOR_TITLE_ATTRIBUTE_NAME='IPTC - Author Title';var IPTC_CATEGORY_ATTRIBUTE_NAME='IPTC - Category';var IPTC_CATEGORIES_ATTRIBUTE_NAME='IPTC - Categories';var IPTC_CITY_ATTRIBUTE_NAME='IPTC - City';var IPTC_COPYRIGHT_INFO_URL_ATTRIBUTE_NAME='IPTC - Copyright Info URL';var IPTC_COPYRIGHT_NOTICE_ATTRIBUTE_NAME='IPTC - Copyright Notice';var IPTC_COUNTRY_ATTRIBUTE_NAME='IPTC - Country';var IPTC_COUNTRY_CODE_ATTRIBUTE_NAME='IPTC - Country Code';var IPTC_CREATOR_ATTRIBUTE_NAME='IPTC - Creator';var IPTC_CREDIT_ATTRIBUTE_NAME='IPTC - Credit';var IPTC_DATE_CREATED_ATTRIBUTE_NAME='IPTC - Date Created';var IPTC_EVENT_ATTRIBUTE_NAME='IPTC - Event';var IPTC_HEADLINE_ATTRIBUTE_NAME='IPTC - Headline';var IPTC_INSTRUCTIONS_ATTRIBUTE_NAME='IPTC - Instructions';var IPTC_SOURCE_ATTRIBUTE_NAME='IPTC - Source';var IPTC_STATE_PROVINCE_ATTRIBUTE_NAME='IPTC - State/Province';var IPTC_SUPPLEMENTAL_CATEGORIES_ATTRIBUTE_NAME='IPTC - Supplemental Categories';var IPTC_SUPPLEMENTAL_CATEGORY_ATTRIBUTE_NAME='IPTC - Supplemental Category';var IPTC_TITLE_ATTRIBUTE_NAME='IPTC - Title';var IPTC_TRANSMISSION_REFERENCE_ATTRIBUTE_NAME='IPTC - Transmission Reference';var IPTC_URGENCY_ATTRIBUTE_NAME='IPTC - Urgency';var IPTC_CREATOR_ADDRESS_ATTRIBUTE_NAME='IPTC - Creator Address';var IPTC_CORE_CREATOR_ADDRESS_ATTRIBUTE_NAME='IPTC:Core - Creator Address';var IPTC_CREATOR_CITY_ATTRIBUTE_NAME='IPTC - Creator City';var IPTC_CORE_CREATOR_CITY_ATTRIBUTE_NAME='IPTC:Core - Creator City';var IPTC_CREATOR_COUNTRY_ATTRIBUTE_NAME='IPTC - Creator Country';var IPTC_CORE_CREATOR_COUNTRY_ATTRIBUTE_NAME='IPTC:Core - Creator Country';var IPTC_CREATOR_EMAIL_ATTRIBUTE_NAME='IPTC - Creator Email';var IPTC_CORE_CREATOR_EMAIL_ATTRIBUTE_NAME='IPTC:Core - Creator Email';var IPTC_CREATOR_JOB_TITLE_ATTRIBUTE_NAME='IPTC - Creator Job Title';var IPTC_CREATOR_PHONE_ATTRIBUTE_NAME='IPTC - Creator Phone';var IPTC_CORE_CREATOR_PHONE_ATTRIBUTE_NAME='IPTC:Core - Creator Phone';var IPTC_CREATOR_POSTAL_CODE_ATTRIBUTE_NAME='IPTC - Creator Postal Code';var IPTC_CORE_CREATOR_POSTAL_CODE_ATTRIBUTE_NAME='IPTC:Core - Creator Postal Code';var IPTC_CREATOR_STATE_PROVINCE_ATTRIBUTE_NAME='IPTC - Creator State/Province';var IPTC_CORE_CREATOR_STATE_PROVINCE_ATTRIBUTE_NAME='IPTC:Core - Creator State/Province';var IPTC_CREATOR_WEB_URL_ATTRIBUTE_NAME='IPTC - Creator Web URL';var IPTC_CORE_CREATOR_WEB_URL_ATTRIBUTE_NAME='IPTC:Core - Creator Web URL';var IPTC_INTELLECTUAL_GENRE_ATTRIBUTE_NAME='IPTC - Intellectual Genre';var IPTC_CORE_INTELLECTUAL_GENRE_ATTRIBUTE_NAME='IPTC:Core - Intellectual Genre';var IPTC_LOCATION_ATTRIBUTE_NAME='IPTC - Location';var IPTC_CORE_LOCATION_ATTRIBUTE_NAME='IPTC:Core - Location';var IPTC_RIGHTS_ATTRIBUTE_NAME='IPTC - Rights Usage Terms';var IPTC_CORE_RIGHTS_ATTRIBUTE_NAME='IPTC:Core - Rights Usage Terms';var IPTC_SCENE_ATTRIBUTE_NAME='IPTC - Scene';var IPTC_CORE_SCENE_ATTRIBUTE_NAME='IPTC:Core - Scene';var IPTC_SUBJECT_CODE_ATTRIBUTE_NAME='IPTC - Subject Code';var IPTC_CORE_SUBJECT_CODE_ATTRIBUTE_NAME='IPTC:Core - Subject Code';var IS_PANORAMIC_ATTRIBUTE_NAME='com.extensis.portfolio.isPanoramic';var JOB_NAME_ATTRIBUTE_NAME='Job Name';var JOB_STATUS_ATTRIBUTE_NAME='Job Status';var KEYWORDS_ATTRIBUTE_NAME='Keywords';var LAST_MODIFIED_ATTRIBUTE_NAME='Last Modified';var LAST_UPDATED_ATTRIBUTE_NAME='Last Updated';var LOCK_STATUS_ATTRIBUTE_NAME='com.extensis.portfolio.lockStatus';var MAC_CREATOR_ATTRIBUTE_NAME='Mac Creator';var MAC_FILE_TYPE_ATTRIBUTE_NAME='Mac File Type';var MAC_ZONE_ATTRIBUTE_NAME='Mac Zone';var MOVIE_AUDIO_CODEC_ATTRIBUTE_NAME='Movie - Audio Codec';var MOVIE_CHANNELS_ATTRIBUTE_NAME='Movie - Channels';var MOVIE_COLOR_DEPTH_ATTRIBUTE_NAME='Movie - Color Depth';var MOVIE_DURATION_ATTRIBUTE_NAME='Movie - Duration';var MOVIE_FPS_ATTRIBUTE_NAME='Movie - FPS';var MOVIE_SAMPLE_RATE_ATTRIBUTE_NAME='Movie - Sample Rate';var MOVIE_SAMPLE_SIZE_ATTRIBUTE_NAME='Movie - Sample Size';var MOVIE_VIDEO_CODEC_ATTRIBUTE_NAME='Movie - Video Codec';var MS_AUTHOR_ATTRIBUTE_NAME='MS - Author';var MS_COMPANY_ATTRIBUTE_NAME='MS - Company';var MS_LAST_SAVED_BY_ATTRIBUTE_NAME='MS - Last Saved By';var MS_MANAGER_ATTRIBUTE_NAME='MS - Manager';var MS_SUBJECT_ATTRIBUTE_NAME='MS - Subject';var MS_TEMPLATE_ATTRIBUTE_NAME='MS - Template';var MS_TITLE_ATTRIBUTE_NAME='MS - Title';var MULTIPAGE_COUNT_ATTRIBUTE_NAME='MultipageCount';var NUMBER_OF_BANDS_ATTRIBUTE_NAME='Number of Bands';var PATH_ATTRIBUTE_NAME='Path';var PHOTOSHOP_LABEL_ATTRIBUTE_NAME='Photoshop Label';var PHOTOSHOP_RATING_ATTRIBUTE_NAME='Photoshop Rating';var PIXELLIVE_AUTHOR_ATTRIBUTE_NAME='PixelLive - Author';var PIXELLIVE_COMMENTS_ATTRIBUTE_NAME='PixelLive - Comments';var PIXELLIVE_COPYRIGHT_ATTRIBUTE_NAME='PixelLive - Copyright';var PIXELLIVE_DATE_ATTRIBUTE_NAME='PixelLive - Date';var PIXELLIVE_GENRE_ATTRIBUTE_NAME='PixelLive - Genre';var PIXELLIVE_TITLE_ATTRIBUTE_NAME='PixelLive - Title';var PLACEHOLDER_ATTRIBUTE_NAME='PlaceHolder';var PREVIEW_ATTRIBUTE_NAME='com.extensis.portfolio.Preview';var PREVIEW_ERROR_ATTRIBUTE_NAME='com.extensis.portfolio.PreviewError';var RID_ATTRIBUTE_NAME='Item ID';var ROUTED_TO_ATTRIBUTE_NAME='Routed To';var ROUTING_NOTES_ATTRIBUTE_NAME='Routing Notes';var SHORT_FILENAME_WIN_ATTRIBUTE_NAME='Short Filename Win';var SUGGESTED_KEYWORDS_ATTRIBUTE_NAME='SuggestedKeywords';var THUMBNAIL_ATTRIBUTE_NAME='Thumbnail';var THUMBNAIL_SIZE_ATTRIBUTE_NAME='Thumbnail Size';var UPDATED_BY_ATTRIBUTE_NAME='Updated By';var VERTICAL_RESOLUTION_ATTRIBUTE_NAME='Vertical Resolution';var VOLUME_ATTRIBUTE_NAME='Volume';var WATERMARKED_ATTRIBUTE_NAME='Watermarked';var WATERMARK_URL_ATTRIBUTE_NAME='WatermarkURL';var WEBSITE_ATTRIBUTE_NAME='Website';var WIDTH_ATTRIBUTE_NAME='Width';var WORK_NEEDED_ATTRIBUTE_NAME='Work Needed';var XMP_ATTRIBUTE_NAME='XMP';// Use this instead of 'Asset ID' when talking to the server
var RID_ATTRIBUTE_NAME_FOR_SERVER='RID';// These fields are taken from the express app
// not sure if all of them are still used
var Messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({Cataloged:{id:'FIELD_DEF.cataloged',defaultMessage:'Cataloged'},'Cataloged By':{id:'FIELD_DEF.catalogedBy',defaultMessage:'Cataloged By'},'Color Mode':{id:'FIELD_DEF.colorMode',defaultMessage:'Color Mode'},'com.extensis.portfolio.isPanoramic':{id:'FIELD_DEF.isPanoramic',defaultMessage:'Panoramic'},Created:{id:'FIELD_DEF.created',defaultMessage:'Created'},'Directory Path':{id:'FIELD_DEF.directoryPath',defaultMessage:'Directory Path'},'Document Text':{id:'FIELD_DEF.documentText',defaultMessage:'Document Text'},'Extension Win':{id:'FIELD_DEF.ExtensionWin',defaultMessage:'Extension'},Filename:{id:'FIELD_DEF.filename',defaultMessage:'Filename'},'File Description':{id:'FIELD_DEF.fileDescription',defaultMessage:'Description'},'File Size':{id:'FIELD_DEF.fileSize',defaultMessage:'File Size'},'Geometry':{id:'FIELD_DEF.geometry',defaultMessage:'Geo - Map'},Height:{id:'FIELD_DEF.height',defaultMessage:'Height'},'Horizontal Resolution':{id:'FIELD_DEF.horizontalResolution',defaultMessage:'Horizontal Resolution'},Keywords:{id:'FIELD_DEF.keywords',defaultMessage:'Keywords'},'Last Modified':{id:'FIELD_DEF.lastModified',defaultMessage:'Modified'},'Last Updated':{id:'FIELD_DEF.lastUpdated',defaultMessage:'Changed'},'Alias Mac':{id:'FIELD_DEF.aliasMac',defaultMessage:'Alias Mac'},'Creator Mac':{id:'FIELD_DEF.creatorMac',defaultMessage:'Creator Mac'},'File Type Mac':{id:'FIELD_DEF.fileTypeMac',defaultMessage:'File Type Mac'},'Zone Mac':{id:'FIELD_DEF.zoneMac',defaultMessage:'Zone Mac'},MultipageCount:{id:'FIELD_DEF.multipageCount',defaultMessage:'Number of Pages'},'Number of Bands':{id:'FIELD_DEF.numBands',defaultMessage:'Number of Bands'},Path:{id:'FIELD_DEF.path',defaultMessage:'Path'},'Item ID':{id:'FIELD_DEF.ItemID',defaultMessage:'Asset ID'},'Short Filename Win':{id:'FIELD_DEF.shortFilenameWin',defaultMessage:'Short Filename Win'},'Thumbnail Size':{id:'FIELD_DEF.thumbnailSize',defaultMessage:'Thumbnail Size'},'Updated By':{id:'FIELD_DEF.updatedBy',defaultMessage:'Changed By'},'Vertical Resolution':{id:'FIELD_DEF.verticalResolution',defaultMessage:'Vertical Resolution'},Volume:{id:'FIELD_DEF.volume',defaultMessage:'Volume'},Watermarked:{id:'FIELD_DEF.watermarked',defaultMessage:'Watermarked'},'Watermark URL':{id:'FIELD_DEF.watermarkURL',defaultMessage:'Watermark URL'},Width:{id:'FIELD_DEF.width',defaultMessage:'Width'},SuggestedKeywords:{id:'FIELD_DEF.SuggestedKeywords',defaultMessage:'Smart Keywords'}});// Non "Displayable" Fields, e.g. not in asset grid/list or fields panel
var EXCLUDED_FIELDS=['CorruptFile','Document Text','Flags','FullyCataloged','PlaceHolder','RID','SuggestedKeywords','Thumbnail','Centroid'];var FIELD_TYPE={STRING:0,NUMBER:1,DECIMAL:2,DATETIME:3,URL:4,TEXTBLOCK:5,BINARY:6,BOOLEAN:7,GEOJSON:8,UNKNOWN:99};// synthetic Item ID field (refers to asset id)
var ITEM_ID={'systemName':RID_ATTRIBUTE_NAME,'type':FIELD_TYPE.STRING,'isSystem':true,'isMultivalued':false,'isSortable':true,'isSearchable':true};var SYSTEM_FIELDS={Cataloged:CATALOGED_ATTRIBUTE_NAME,ColorMode:COLOR_MODE_ATTRIBUTE_NAME,DirectoryPath:DIR_PATH_ATTRIBUTE_NAME,FileSize:FILE_SIZE_ATTRIBUTE_NAME,Filename:FILENAME_ATTRIBUTE_NAME,Height:HEIGHT_ATTRIBUTE_NAME,HorizontalResolution:HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME,ItemID:RID_ATTRIBUTE_NAME,Keywords:KEYWORDS_ATTRIBUTE_NAME,NumberOfBands:NUMBER_OF_BANDS_ATTRIBUTE_NAME,Path:PATH_ATTRIBUTE_NAME,Thumbnail:THUMBNAIL_ATTRIBUTE_NAME,ThumbnailSize:THUMBNAIL_SIZE_ATTRIBUTE_NAME,VerticalResolution:VERTICAL_RESOLUTION_ATTRIBUTE_NAME,Width:WIDTH_ATTRIBUTE_NAME,LastUpdated:LAST_UPDATED_ATTRIBUTE_NAME,Geometry:GEOMETRY_ATTRIBUTE_NAME,SuggestedKeywords:SUGGESTED_KEYWORDS_ATTRIBUTE_NAME,// Special pseudo fields
LockStatus:LOCK_STATUS_ATTRIBUTE_NAME,CheckOutStatus:CHECK_OUT_STATUS_ATTRIBUTE_NAME,PreviewStatus:'com.extensis.portfolio.stillPreviewStatus',isPanoramic:IS_PANORAMIC_ATTRIBUTE_NAME,AVPreviewStatus:AV_PREVIEW_STATUS_ATTRIBUTE_NAME};// values for avPreviewStatus
var AV_PREVIEW_STATUS_NONE='none';var AV_PREVIEW_STATUS_PENDING='pending';var AV_PREVIEW_STATUS_READY='ready';// Fields which most asset views want, even if the user does not explicitly choose them
var STANDARD_FIELDS_TO_RETRIEVE=[SYSTEM_FIELDS.Path,SYSTEM_FIELDS.LockStatus,SYSTEM_FIELDS.CheckOutStatus,SYSTEM_FIELDS.Filename,SYSTEM_FIELDS.LastUpdated,SYSTEM_FIELDS.Geometry,SYSTEM_FIELDS.isPanoramic,SYSTEM_FIELDS.Width,SYSTEM_FIELDS.Height,SYSTEM_FIELDS.AVPreviewStatus,SYSTEM_FIELDS.SuggestedKeywords];var SYSTEM_DATE_FIELDS=[CATALOGED_ATTRIBUTE_NAME,CREATED_ATTRIBUTE_NAME,LAST_MODIFIED_ATTRIBUTE_NAME,LAST_UPDATED_ATTRIBUTE_NAME];var ALL_KNOWN_READ_ONLY_FIELD_DEF_NAMES=[BIT_DEPTH_ATTRIBUTE_NAME,CATALOGED_ATTRIBUTE_NAME,CATALOGED_BY_ATTRIBUTE_NAME,COLOR_MODE_ATTRIBUTE_NAME,COLOR_PROFILE_ATTRIBUTE_NAME,CREATED_ATTRIBUTE_NAME,CUSTOM_THUMBNAIL_ATTRIBUTE_NAME,DIR_PATH_ATTRIBUTE_NAME,EXTENSION_WIN_ATTRIBUTE_NAME,FILE_SIZE_ATTRIBUTE_NAME,GEOMETRY_ATTRIBUTE_NAME,GEO_COORDINATE_REF_ATTRIBUTE_NAME,GEO_X_ORIGIN_ATTRIBUTE_NAME,GEO_Y_ORIGIN_ATTRIBUTE_NAME,GEO_X_RES_ATTRIBUTE_NAME,GEO_Y_RES_ATTRIBUTE_NAME,GEO_X_ROT_ATTRIBUTE_NAME,GEO_Y_ROT_ATTRIBUTE_NAME,GEO_NATIVE_BOUNDS_ATTRIBUTE_NAME,GEO_WGS84_BOUNDS_ATTRIBUTE_NAME,GEO_EPGS_CODE_ATTRIBUTE_NAME,GEO_TYPE_ATTRIBUTE_NAME,HEIGHT_ATTRIBUTE_NAME,HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME,IS_PANORAMIC_ATTRIBUTE_NAME,LAST_MODIFIED_ATTRIBUTE_NAME,LAST_UPDATED_ATTRIBUTE_NAME,MAC_CREATOR_ATTRIBUTE_NAME,MAC_FILE_TYPE_ATTRIBUTE_NAME,MAC_ZONE_ATTRIBUTE_NAME,MULTIPAGE_COUNT_ATTRIBUTE_NAME,NUMBER_OF_BANDS_ATTRIBUTE_NAME,PATH_ATTRIBUTE_NAME,RID_ATTRIBUTE_NAME,SHORT_FILENAME_WIN_ATTRIBUTE_NAME,THUMBNAIL_ATTRIBUTE_NAME,THUMBNAIL_SIZE_ATTRIBUTE_NAME,UPDATED_BY_ATTRIBUTE_NAME,VERTICAL_RESOLUTION_ATTRIBUTE_NAME,VOLUME_ATTRIBUTE_NAME,WATERMARKED_ATTRIBUTE_NAME,WATERMARK_URL_ATTRIBUTE_NAME,WIDTH_ATTRIBUTE_NAME,XMP_ATTRIBUTE_NAME];var DEFAULT_SORT_FIELD=CATALOGED_ATTRIBUTE_NAME;/*
*  Returns an array of user facing field defs for display in the UI
*/function getAllDisplayableFields(fieldDefs){if(fieldDefs){// remove the excluded fields
var displayableFields=fieldDefs.filter(function(fieldDef){return!EXCLUDED_FIELDS.includes(fieldDef.systemName);});// add in the item id field
displayableFields.push(ITEM_ID);return displayableFields;}}function getAdvancedFindFields(fieldDefs){if(fieldDefs){var exclusions=[CORRUPT_FILE_ATTRIBUTE_NAME,FLAGS_ATTRIBUTE_NAME,FULLY_CATALOGED_ATTRIBUTE_NAME,PLACEHOLDER_ATTRIBUTE_NAME,RID_ATTRIBUTE_NAME_FOR_SERVER];fieldDefs=fieldDefs.filter(function(fieldDef){return fieldDef.isSearchable&&!exclusions.includes(fieldDef.systemName);});fieldDefs.push(ITEM_ID);return fieldDefs;}}var CHECKOUT_STATUS_INDEXES={CHECKOUT_STATUS_INDEX_USER_SHORT_NAME:1,CHECKOUT_STATUS_INDEX_DATETIME:3};function getCheckoutStatus(asset){if(asset&&asset.attributes){return asset.attributes[SYSTEM_FIELDS.CheckOutStatus];}}function getCheckoutStatusUserShortName(checkoutStatus){if(checkoutStatus){return checkoutStatus[CHECKOUT_STATUS_INDEXES.CHECKOUT_STATUS_INDEX_USER_SHORT_NAME];}}function getCheckoutStatusDateTime(checkoutStatus){if(checkoutStatus){return checkoutStatus[CHECKOUT_STATUS_INDEXES.CHECKOUT_STATUS_INDEX_DATETIME];}}function caseInsensitiveContains(predicate,subject){if(!predicate){return true;}var a=subject.toLowerCase();var b=predicate.toLowerCase();var noMatch=a.indexOf(b)===-1;if(noMatch){return false;}return true;};function findFieldIndex(haystack,needle){return haystack?haystack.findIndex(function(el){return el.systemName===needle.systemName;}):-1;}function getFieldDefByName(fieldDefs,fieldName){if(fieldName===SYSTEM_FIELDS.ItemID){return ITEM_ID;}else{return fieldDefs.find(function(e){return e.systemName===fieldName;});}}function getFieldDefById(fieldDefs,id){var fd=fieldDefs.find(function(e){return e.id===id;});if(fd&&fd.systemName===RID_ATTRIBUTE_NAME_FOR_SERVER){return ITEM_ID;}return fd;}function getIdsForFieldDefs(fieldDefs,fds){return fds.map(function(fd){return fd.systemName===RID_ATTRIBUTE_NAME?getFieldDefByName(fieldDefs,RID_ATTRIBUTE_NAME_FOR_SERVER).id:fd.id;});}function isSystemField(fieldName,fieldDefs){var result=false;if(fieldName&&fieldDefs){var field=fieldDefs.find(function(fieldDef){return fieldDef.systemName===fieldName;});result=field?field.isSystem:false;}return result;}function getFieldTypeName(fieldType){return Object.keys(FIELD_TYPE).find(function(k){return FIELD_TYPE[k]===fieldType;});}function getPredefinedValuesForFieldDef(fieldDef){var flattenNestedValues=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var predefinedValues=null;if(fieldDef&&fieldDef.hasPredefinedValues){if(fieldDef.isHierarchical){predefinedValues=fieldDef.nestedPredefinedValues&&fieldDef.nestedPredefinedValues.length>0?fieldDef.nestedPredefinedValues:null;if(predefinedValues&&flattenNestedValues){predefinedValues=_getArrayFromNestedValues(predefinedValues);}}else{predefinedValues=fieldDef.predefinedValues&&fieldDef.predefinedValues.length>0?fieldDef.predefinedValues:null;}}if(predefinedValues&&(!fieldDef.isHierarchical||fieldDef.isHierarchical&&flattenNestedValues)){predefinedValues.sort(function(a,b){return a.localeCompare(b);});}return predefinedValues;}function multivalueCompareFn(fieldDef,sampleValue){switch(fieldDef.type){case FIELD_TYPE.STRING:return function(a,b){return a.localeCompare(b);};case FIELD_TYPE.DATETIME:return function(a,b){return new Date(a)-new Date(b);};case FIELD_TYPE.URL:return function(a,b){return 0;};// don't sort at all
case FIELD_TYPE.NUMBER:case FIELD_TYPE.DECIMAL:if(typeof sampleValue==='string'){return function(a,b){return Number(a)-Number(b);};}// fall through
case FIELD_TYPE.TEXTBLOCK:case FIELD_TYPE.BINARY:default:return function(a,b){return a-b;};}}function sortValuesForFieldDef(fieldDef,values){if(!fieldDef||!values||values.length===0){return;}switch(fieldDef.type){case FIELD_TYPE.STRING:case FIELD_TYPE.NUMBER:case FIELD_TYPE.DECIMAL:case FIELD_TYPE.DATE:default:values.sort(multivalueCompareFn(fieldDef,values[0]));break;// Not interested in sorting other types.
}}function _getArrayFromNestedValues(nestedValues){var values=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];nestedValues.forEach(function(nestedValue){values.push(nestedValue.value);if(nestedValue.children&&nestedValue.children.length>0){_getArrayFromNestedValues(nestedValue.children,values);}});return values;}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(175);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(567);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(587);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getClientInactivityTimeout;
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
var DEFAULT_CLIENT_INACTIVITY_TIMEOUT=1000*60*15;// In electron, for testing, we support an environment variable that will override
// the production inactivity timeout of 1 hour.
function getClientInactivityTimeout(){if(window.CLIENT_INACTIVITY_TIMEOUT){return window.CLIENT_INACTIVITY_TIMEOUT*1000;}if(Object({"NODE_ENV":"production","PUBLIC_URL":".","REACT_APP_APPVERSION":"4.1.1","REACT_APP_BUILDVERSION":"20260306-35161b9d6","REACT_APP_PRODUCT":"admin"}).CLIENT_INACTIVITY_TIMEOUT){return Number(Object({"NODE_ENV":"production","PUBLIC_URL":".","REACT_APP_APPVERSION":"4.1.1","REACT_APP_BUILDVERSION":"20260306-35161b9d6","REACT_APP_PRODUCT":"admin"}).CLIENT_INACTIVITY_TIMEOUT)*1000;}return DEFAULT_CLIENT_INACTIVITY_TIMEOUT;}var initialState={adminSessionId:null,identitySessionId:null,username:null,lastActivity:Date.now(),identityEncryptedPassword:null,publicKeyInfo:null};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["a" /* ADMIN_LOGIN */]:return Object.assign({},state,{username:action.payload.username});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["c" /* ADMIN_LOGIN_SUCCESS */]:return Object.assign({},state,{adminSessionId:action.payload.session});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["b" /* ADMIN_LOGIN_FAIL */]:return Object.assign({},state,{adminSessionId:null});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["f" /* ADMIN_LOGOUT_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["e" /* ADMIN_LOGOUT_FAIL */]:return Object.assign({},state,{adminSessionId:null,username:null});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["h" /* CLEAR_IDENTITY_SESSION */]:return Object.assign({},state,{identitySessionId:null});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["l" /* IDENTITY_LOGIN */]:return Object.assign({},state,{username:action.payload.username,identityEncryptedPassword:action.payload.encryptedPassword});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["n" /* IDENTITY_LOGIN_SUCCESS */]:return Object.assign({},state,{identitySessionId:action.payload.session});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["m" /* IDENTITY_LOGIN_FAIL */]:return Object.assign({},state,{identitySessionId:null});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["q" /* IDENTITY_LOGOUT_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["p" /* IDENTITY_LOGOUT_FAIL */]:return Object.assign({},state,{identitySessionId:null});case __WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["s" /* SET_LAST_ACTIVITY */]:return Object.assign({},state,{lastActivity:action.payload.lastActivity});default:return state;}}function setAdminPropertiesPollInterval(payload){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["r" /* RESOURCE_ADMIN_PROPERTIES_INTERVAL */],resource:__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["g" /* ADMIN_PROPERTIES_INTERVAL_RESOURCE */],payload:payload};}function adminLogin(username,encryptedPassword){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["a" /* ADMIN_LOGIN */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["c" /* ADMIN_LOGIN_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["b" /* ADMIN_LOGIN_FAIL */]],payload:{username:username},promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/auth/login',{data:{username:username,encryptedPassword:encryptedPassword}});}};}function adminLogout(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["d" /* ADMIN_LOGOUT */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["f" /* ADMIN_LOGOUT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["e" /* ADMIN_LOGOUT_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/auth/logout',{params:{session:session}});}};}function clearIdentitySession(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["h" /* CLEAR_IDENTITY_SESSION */]};}function identityLogin(username,encryptedPassword){var isRsaEncryption=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["l" /* IDENTITY_LOGIN */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["n" /* IDENTITY_LOGIN_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["m" /* IDENTITY_LOGIN_FAIL */]],payload:{username:username||'',encryptedPassword:encryptedPassword},promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/auth/identity-login',{data:{username:username,encryptedPassword:encryptedPassword,isRsaEncryption:isRsaEncryption}});}};}function identityLogout(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["o" /* IDENTITY_LOGOUT */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["q" /* IDENTITY_LOGOUT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["p" /* IDENTITY_LOGOUT_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/auth/identity-logout',{params:{session:session}});}};}function updateLastActivity(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["s" /* SET_LAST_ACTIVITY */],payload:{lastActivity:Date.now()}};}function getPublicKeyInfo(){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["i" /* GET_PUBLIC_KEY */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["k" /* GET_PUBLIC_KEY_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_authTypes__["j" /* GET_PUBLIC_KEY_FAIL */]],promise:function promise(client){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/public-key');}};}var actions={adminLogin:adminLogin,adminLogout:adminLogout,getPublicKeyInfo:getPublicKeyInfo,identityLogin:identityLogin,identityLogout:identityLogout,clearIdentitySession:clearIdentitySession,setAdminPropertiesPollInterval:setAdminPropertiesPollInterval,updateLastActivity:updateLastActivity};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mainPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return catalogPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ingestForms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return globalSettingsPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pageRouteRequiresIdentityService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pageRouteRequiresLicense; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GlobalSettingsPage__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_Pages_BackupsPage__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_Pages_CertsPage_CertsPage__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_Pages_DirectoryServicesPage__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_view_Pages_StatusPage_StatusPage__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_view_Pages_RolesPage__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_view_Pages_UsersPage__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_Pages_ReportsPage__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Pages_NetPublishPage__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_Pages_GlobalSettingsPages_MobilePage__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_Pages_GlobalSettingsPages_ServerLocationsPage__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_view_Pages_GlobalSettingsPages_SingleSignOnCredsPage__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_view_Pages_GlobalSettingsPages_EmailNotificationsPage__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_view_Pages_GlobalSettingsPages_MediaEnginesPage__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_view_Pages_GlobalSettingsPages_LoginCustomizationPage__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_view_Pages_GlobalSettingsPages_PortsPage__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_view_Pages_StatusPage_LoggingControls__ = __webpack_require__(1183);
// import AnalyticsPage from 'view/Pages/AnalyticsPage';
var mainPages=[{component:__WEBPACK_IMPORTED_MODULE_6_view_Pages_StatusPage_StatusPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_STATUS,route:'/status',dataTestName:'status'},{component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["i" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_CATALOGS,route:'/catalogs',visibleForCatalogAdmin:true,dataTestName:'catalogs'},{component:__WEBPACK_IMPORTED_MODULE_8_view_Pages_UsersPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_USERS,route:'/users',dataTestName:'users'},{component:__WEBPACK_IMPORTED_MODULE_7_view_Pages_RolesPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_ACCESS_LEVELS,route:'/roles',dataTestName:'roles'},{component:__WEBPACK_IMPORTED_MODULE_5_view_Pages_DirectoryServicesPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICES,route:'/directoryServices',dataTestName:'directory-services'},{component:__WEBPACK_IMPORTED_MODULE_9_view_Pages_ReportsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_REPORTING,route:'/reports',visibleForCatalogAdmin:true,dataTestName:'reports'},{component:__WEBPACK_IMPORTED_MODULE_10_view_Pages_NetPublishPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_NETPUBLISH_SETTINGS,route:'/NetPublish',visibleForCatalogAdmin:true,dataTestName:'netpublish'},{component:__WEBPACK_IMPORTED_MODULE_2_view_Pages_BackupsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_BACKUPS,route:'/backups',dataTestName:'backups'},{component:__WEBPACK_IMPORTED_MODULE_0__GlobalSettingsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_GLOBAL_SETTINGS,route:'/globalSettings',dataTestName:'global-settings'}];var catalogPages=[{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_DETAILS_DATABASE_TAB,subroute:'general',contents:{component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["a" /* CatalogDetailsPage */]},dataTestName:'catalog-details-general'},{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_USERS,subroute:'userMembership',contents:{component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["f" /* CatalogUsersPage */]},dataTestName:'catalog-details-users'},{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_INGEST_FIELDS_LABEL,subroute:'fields',contents:{component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["h" /* FieldsPage */]},dataTestName:'catalog-details-fields'},{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_FILES_TAB_TITLE,subroute:'ingest',contents:{component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["b" /* CatalogIngestPage */]},dataTestName:'catalog-details-ingest'},{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_SK_TAB_TITLE,subroute:'smartKeywords',contents:{component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["e" /* CatalogSmartKeywordsPage */]},dataTestName:'catalog-details-smart-keywords'}];var ingestForms=[{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_TAB_TITLE,route:'catalogingOptions',component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["g" /* CatalogingOptionsForm */],dataTestName:'catalog-details-ingest-cataloging-options'},{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_INGEST_TAB_TITLE,route:'managedUploads',component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["c" /* CatalogManagedUploadForm */],dataTestName:'catalog-details-ingest-cataloging-managed-uploads'},{label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_SHORT,route:'previews',component:__WEBPACK_IMPORTED_MODULE_3_view_Pages_CatalogsPage__["d" /* CatalogPreviewsForm */],dataTestName:'catalog-details-ingest-cataloging-previews'}];var globalSettingsPages=[{component:__WEBPACK_IMPORTED_MODULE_12_view_Pages_GlobalSettingsPages_ServerLocationsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS,route:'/globalSettings/dataLocations',dataTestName:'global-settings-data-locations'},{component:__WEBPACK_IMPORTED_MODULE_18_view_Pages_StatusPage_LoggingControls__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].LOGGING_CONFIGURATION,route:'/globalSettings/logging',dataTestName:'global-settings-logging'},{component:__WEBPACK_IMPORTED_MODULE_16_view_Pages_GlobalSettingsPages_LoginCustomizationPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION,route:'/globalSettings/customization',dataTestName:'global-settings-customization'},{component:__WEBPACK_IMPORTED_MODULE_11_view_Pages_GlobalSettingsPages_MobilePage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].MOBILE_TITLE,route:'/globalSettings/mobile',dataTestName:'global-settings-mobile'},{component:__WEBPACK_IMPORTED_MODULE_13_view_Pages_GlobalSettingsPages_SingleSignOnCredsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_SSO_CREDENTIALS,route:'/globalSettings/sso',dataTestName:'global-settings-sso'},{component:__WEBPACK_IMPORTED_MODULE_14_view_Pages_GlobalSettingsPages_EmailNotificationsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_EMAIL_CONFIGURATION,route:'/globalSettings/email',dataTestName:'global-settings-email'},{component:__WEBPACK_IMPORTED_MODULE_15_view_Pages_GlobalSettingsPages_MediaEnginesPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_MEDIA_ENGINES,route:'/globalSettings/mediaEngines',dataTestName:'global-settings-media-engines'},{component:__WEBPACK_IMPORTED_MODULE_4_view_Pages_CertsPage_CertsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].CERTS_TITLE,route:'/globalSettings/cert',dataTestName:'global-settings-cert'},{component:__WEBPACK_IMPORTED_MODULE_17_view_Pages_GlobalSettingsPages_PortsPage__["a" /* default */],label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NAV_PORTS,route:'/globalSettings/ports',dataTestName:'global-settings-ports'}];var pageRouteRequiresIdentityService=['/catalogs','/users','/roles','/directoryServices','/mobile','/reports','/NetPublish'];var pageRouteRequiresLicense=['/catalogs','/users','/roles','/directoryServices','/mobile','/reports','/NetPublish','/backups','/globalSettings'];

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRole;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteRole;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateRole;
/* harmony export (immutable) */ __webpack_exports__["d"] = setSelectedRole;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_roleReducer__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var createRoleAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_roleReducer__["a" /* actions */].createRole,deleteRoleAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_roleReducer__["a" /* actions */].deleteRole,getRolesAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_roleReducer__["a" /* actions */].getRoles,setSelectedRoleAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_roleReducer__["a" /* actions */].setSelectedRole,updateRoleAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_roleReducer__["a" /* actions */].updateRole;var showModalPrompt=__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;function getRoles(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context.next=4;break;}_context.next=4;return dispatch(getRolesAction(session));case 4:case'end':return _context.stop();}}},_callee,this);}));function getRoles(_x,_x2){return _ref.apply(this,arguments);}return getRoles;}();}function _findRole(roleName,roles){return roles.find(function(role){return role.name===roleName;});}function createRole(roleName){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var session,roleToSelect;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context2.next=10;break;}_context2.next=4;return dispatch(createRoleAction(session,roleName));case 4:_context2.next=6;return dispatch(getRolesAction(session));case 6:roleToSelect=_findRole(roleName,Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["_15" /* getRoles */])(getState()));if(!roleToSelect){_context2.next=10;break;}_context2.next=10;return dispatch(setSelectedRole(roleToSelect));case 10:case'end':return _context2.stop();}}},_callee2,this);}));function createRole(_x3,_x4){return _ref2.apply(this,arguments);}return createRole;}();}function deleteRole(roleName){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context4.next=4;break;}_context4.next=4;return dispatch(showModalPrompt({isButton2Default:true,message:__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].ROLES_DELETE_CONFIRM,dataTestName:'delete-role-modal',onButton2:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var roleToSelect;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return dispatch(deleteRoleAction(session,roleName));case 2:_context3.next=4;return dispatch(getRolesAction(session));case 4:roleToSelect=_findRole('Reader',Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["_15" /* getRoles */])(getState()));if(!roleToSelect){_context3.next=8;break;}_context3.next=8;return dispatch(setSelectedRole(roleToSelect));case 8:case'end':return _context3.stop();}}},_callee3,this);}));function doDelete(){return _ref4.apply(this,arguments);}return doDelete;}()}));case 4:case'end':return _context4.stop();}}},_callee4,this);}));function deleteRole(_x5,_x6){return _ref3.apply(this,arguments);}return deleteRole;}();}function updateRole(roleName,grant,revoke){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context5.next=6;break;}_context5.next=4;return dispatch(updateRoleAction(session,roleName,grant,revoke));case 4:_context5.next=6;return dispatch(getRolesAction(session));case 6:case'end':return _context5.stop();}}},_callee5,this);}));function updateRole(_x7,_x8){return _ref5.apply(this,arguments);}return updateRole;}();}function setSelectedRole(role){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return dispatch(setSelectedRoleAction(role));case 2:case'end':return _context6.stop();}}},_callee6,this);}));function setSelectedRole(_x9,_x10){return _ref6.apply(this,arguments);}return setSelectedRole;}();}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Index */
/* unused harmony export bpfrpt_proptype_PositionInfo */
/* unused harmony export bpfrpt_proptype_ScrollPosition */
/* unused harmony export bpfrpt_proptype_SizeAndPositionInfo */
/* unused harmony export bpfrpt_proptype_SizeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_Index =  true ? null : {
  index: PropTypes.number.isRequired
};
var bpfrpt_proptype_PositionInfo =  true ? null : {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollPosition =  true ? null : {
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};







/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(151)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageHeader=function(_Component){_inherits(PageHeader,_Component);function PageHeader(){_classCallCheck(this,PageHeader);return _possibleConstructorReturn(this,(PageHeader.__proto__||Object.getPrototypeOf(PageHeader)).apply(this,arguments));}_createClass(PageHeader,[{key:'render',value:function render(){var _props=this.props,addDisabled=_props.addDisabled,deleteDisabled=_props.deleteDisabled,isSecondary=_props.isSecondary,onClickAdd=_props.onClickAdd,onClickDelete=_props.onClickDelete,title=_props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header '+(isSecondary?'page-header-secondary':'page-header-primary'),'data-test-name':'header-text'},title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-outlined '+(isSecondary?'':'is-white'),disabled:addDisabled,onClick:onClickAdd,'data-test-name':'add'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-plus-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-outlined '+(isSecondary?'':'is-white'),disabled:deleteDisabled,onClick:!deleteDisabled?onClickDelete:undefined,'data-test-name':'remove'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-minus-circle'})))));}}]);return PageHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageHeader.defaultProps={addDisabled:false,deleteDisabled:true,isSecondary:false,onClickAdd:function onClickAdd(){},onClickDelete:function onClickDelete(){},title:''};/* harmony default export */ __webpack_exports__["a"] = (PageHeader);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_CATALOGS_GUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_CATALOGS_GUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return QUERY_TYPE_SECURITY_GROUPS; });
/* unused harmony export QUERY_TYPE_DISTRIBUTION_GROUPS */
/* unused harmony export QUERY_TYPE_USERS */
/* unused harmony export QUERY_TYPE_ENTIRE_TREE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return QUERY_TYPE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AD_MAPPING_QUERIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAME_QUERY_OP; });
/* harmony export (immutable) */ __webpack_exports__["h"] = getMappingEntriesForDestination;
/* harmony export (immutable) */ __webpack_exports__["i"] = getUserName;
/* unused harmony export getNodeType */
/* harmony export (immutable) */ __webpack_exports__["k"] = isNodeUser;
/* harmony export (immutable) */ __webpack_exports__["j"] = isNodeGroup;
/* harmony export (immutable) */ __webpack_exports__["l"] = ldapSourceToNumber;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SOURCE_TYPE_USER_EXCLUSION; });
var ALL_CATALOGS_GUID='9ED0794C-5DA9-4dd4-8D9C-7BF6D954E8B0';var NO_CATALOGS_GUID='8B63F84B-5139-4a33-841B-5CAA6052743E';var QUERY_TYPE_SECURITY_GROUPS='QUERY_TYPE_SECURITY_GROUPS';var QUERY_TYPE_DISTRIBUTION_GROUPS='QUERY_TYPE_DISTRIBUTION_GROUPS';var QUERY_TYPE_USERS='QUERY_TYPE_USERS';var QUERY_TYPE_ENTIRE_TREE='QUERY_TYPE_ENTIRE_TREE';var QUERY_TYPE_NAME='QUERY_TYPE_NAME';var AD_MAPPING_QUERIES={QUERY_TYPE_SECURITY_GROUPS:{name:'SECURITY_GROUPS',query:'(&(objectClass=group)(groupType<=-2147483640))'},QUERY_TYPE_DISTRIBUTION_GROUPS:{name:'DISTRIBUTION_GROUPS',query:'(&(objectClass=group)(groupType>=0))'},QUERY_TYPE_USERS:{name:'USERS',query:'(&(&(objectClass=person)(sAMAccountName=*))(!(objectClass=computer)))'},QUERY_TYPE_ENTIRE_TREE:{name:'ENTIRE_TREE_UNDER_SEARCH_BASE',query:'(objectClass=*)'},QUERY_TYPE_NAME:{name:'NAME',query:'name='}};var NAME_QUERY_OP={EQUALS:'EQUALS',CONTAINS:'CONTAINS',STARTS_WITH:'STARTS_WITH'};function getMappingEntriesForDestination(dsMappings,destination){var found=dsMappings.find(function(m){return m.targetGroupGuid===destination;});return found&&found.entries||[];}// Some user names, such as many of those on extnsis.com, have an escaped comma
// this method removes the backslash escape character from the name
function getUserName(dnName){var formattedName='';var token='\r\n';// first, replace any escaped commas with a token (to handle
// cases such as the extnsis.com domain where some users have
// escaped commas in their user name)
formattedName=dnName.replace('\\,',token);// next extract the name by splitting the line on the equals sign and comma
formattedName=formattedName.split('=')[1];formattedName=formattedName.split(',')[0];// and finally, replace the escaped comma (if it ever existed) with an unescaped comma
formattedName=formattedName.replace(token,',');return formattedName;}function getNodeType(node){return node&&node.attributes&&node.attributes.objectClass;}// TODO - look at the logic in IdentityServiceModel.as in old admin.
function isNodeUser(node){return getNodeType(node)==='user';}function isNodeGroup(node){return getNodeType(node)==='group';}function ldapSourceToNumber(sourceType){// TODO - other sourceTypes.
switch(sourceType){case'user':return 3;case'group':return 2;default:return 0;}}var SOURCE_TYPE_USER_EXCLUSION=4;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 92 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(60);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(94);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDevEnv;
/* harmony export (immutable) */ __webpack_exports__["a"] = getHelpVersion;
/* unused harmony export getLocalizedHelpLink */
/* harmony export (immutable) */ __webpack_exports__["c"] = openHelpLink;
/* harmony export (immutable) */ __webpack_exports__["d"] = openLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
function isDevEnv(){return "production"==='development';}function getHelpVersion(){var parts=__WEBPACK_IMPORTED_MODULE_1_util_constants__["_17" /* appVersion */].split('.');parts.pop();return parts.join('.');}function getLocalizedHelpLink(_ref){var formatMessage=_ref.formatMessage;return formatMessage(__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].HELP_URL,{version:getHelpVersion()});}function openHelpLink(intl){var url=getLocalizedHelpLink(intl);openLink(url);}function openLink(url){window.open(url,'_blank');}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StaticTextField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabeledField__ = __webpack_require__(28);
function StaticTextField(_ref){var label=_ref.label,labelClassName=_ref.labelClassName,value=_ref.value,valueClassName=_ref.valueClassName,dataTestName=_ref.dataTestName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LabeledField__["a" /* default */],{label:label,labelClassName:labelClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input is-static '+(valueClassName||''),'data-test-name':dataTestName||label},value));}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isLegalCatalogName;
/* harmony export (immutable) */ __webpack_exports__["a"] = catalogNameExists;
/* harmony export (immutable) */ __webpack_exports__["d"] = isVaultCatalog;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeFileTypeName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_constants__ = __webpack_require__(4);
function isLegalCatalogName(catalogName){return!/[?[\]/\\=+:<>";,*|^]/.test(catalogName);}function catalogNameExists(catalogs,catalogName){return!!catalogs.find(function(c){return c.name.toLowerCase()===catalogName.trim().toLowerCase();});}function isVaultCatalog(catalogProperties){return catalogProperties.catalogDetails&&catalogProperties.catalogDetails.storageType===__WEBPACK_IMPORTED_MODULE_0_util_constants__["n" /* CATALOG_STORAGE_TYPE */].VAULT;}function computeFileTypeName(ft){return ft.title?ft.title:ft.extensions[0].toUpperCase();}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(139);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(339);
var enumBugKeys = __webpack_require__(205);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAnimationTimeout; });
/* unused harmony export bpfrpt_proptype_AnimationTimeoutId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animationFrame__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  id: PropTypes.number.isRequired
};


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = void 0;
  // wait for end of processing current event handler, because event handler may be long
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};



/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellDataGetterParams */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRowRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRendererParams */
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  cellData: PropTypes.any,
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  disableSort: PropTypes.bool,
  label: PropTypes.any,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string
};
var bpfrpt_proptype_RowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onRowMouseOut: PropTypes.func,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};







/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_tableUtils__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MultipleSelectionTable=function(_Component){_inherits(MultipleSelectionTable,_Component);function MultipleSelectionTable(){_classCallCheck(this,MultipleSelectionTable);var _this=_possibleConstructorReturn(this,(MultipleSelectionTable.__proto__||Object.getPrototypeOf(MultipleSelectionTable)).call(this));_this.handleScrollToChange=_this.handleScrollToChange.bind(_this);_this.onRowClick=_this.onRowClick.bind(_this);_this.rowClassName=_this.rowClassName.bind(_this);_this.rowGetter=_this.rowGetter.bind(_this);return _this;}_createClass(MultipleSelectionTable,[{key:'onRowClick',value:function onRowClick(_ref){var event=_ref.event,index=_ref.index,rowData=_ref.rowData;var _props=this.props,onSelectionChanged=_props.onSelectionChanged,sortedItems=_props.sortedItems,selectionState=_props.selectionState,singleSelectionOnly=_props.singleSelectionOnly;onSelectionChanged(Object(__WEBPACK_IMPORTED_MODULE_3_util_tableUtils__["b" /* computeNewSelection */])(index,sortedItems,selectionState,event,singleSelectionOnly));this.focusTable();}},{key:'handleScrollToChange',value:function handleScrollToChange(_ref2){var scrollToRow=_ref2.scrollToRow;var _props2=this.props,onSelectionChanged=_props2.onSelectionChanged,sortedItems=_props2.sortedItems,selectionState=_props2.selectionState,singleSelectionOnly=_props2.singleSelectionOnly;onSelectionChanged(Object(__WEBPACK_IMPORTED_MODULE_3_util_tableUtils__["b" /* computeNewSelection */])(scrollToRow,sortedItems,selectionState,{},singleSelectionOnly));this.focusTable();}},{key:'focusTable',value:function focusTable(){if(this.tableRef){var gridElement=Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.tableRef.Grid);gridElement instanceof HTMLElement&&gridElement.focus();}}},{key:'rowGetter',value:function rowGetter(_ref3){var index=_ref3.index;return this.props.sortedItems[index];}},{key:'rowClassName',value:function rowClassName(_ref4){var index=_ref4.index;var selectionState=this.props.selectionState;return(index%2===0?'pseudo-table-row-striped':'')+' '+(index<0?'pseudo-table-header':'pseudo-table-row')+' '+(Object(__WEBPACK_IMPORTED_MODULE_3_util_tableUtils__["f" /* isItemAtIndexSelected */])(index,selectionState)?'pseudo-table-row-selected':'')+' pseudo-table';}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,children=_props3.children,headerHeight=_props3.headerHeight,height=_props3.height,rowHeight=_props3.rowHeight,selectionState=_props3.selectionState,singleSelectionOnly=_props3.singleSelectionOnly,sortedItems=_props3.sortedItems,width=_props3.width,rest=_objectWithoutProperties(_props3,['children','headerHeight','height','rowHeight','selectionState','singleSelectionOnly','sortedItems','width']);var scrollToRow=Object(__WEBPACK_IMPORTED_MODULE_3_util_tableUtils__["c" /* getIndexOfFirstSelectedItem */])(selectionState);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_virtualized__["a" /* ArrowKeyStepper */],{columnCount:1,mode:'cells',rowCount:sortedItems.length,onScrollToChange:this.handleScrollToChange,scrollToRow:scrollToRow},function(_ref5){var onSectionRendered=_ref5.onSectionRendered,scrollToRow=_ref5.scrollToRow;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_virtualized__["h" /* Table */],Object.assign({className:'hideFocus',headerHeight:headerHeight,headerStyle:__WEBPACK_IMPORTED_MODULE_3_util_tableUtils__["a" /* TABLE_HEADER_STYLE */],height:height,onRowClick:_this2.onRowClick,onSectionRendered:onSectionRendered,ref:function ref(_ref6){return _this2.tableRef=_ref6;},rowClassName:_this2.rowClassName,rowCount:sortedItems.length,rowGetter:_this2.rowGetter,rowHeight:rowHeight,scrollToIndex:scrollToRow,width:width},rest),children);});}}]);return MultipleSelectionTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MultipleSelectionTable.defaultProps={singleSelectionOnly:false};/* harmony default export */ __webpack_exports__["a"] = (MultipleSelectionTable);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__ = __webpack_require__(88);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={destination:__WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__["b" /* ALL_CATALOGS_GUID */],mappings:[],queryIsPending:false,queryResults:[],queryType:__WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__["f" /* QUERY_TYPE_SECURITY_GROUPS */],selectedNode:null};function addOrUpdateMapping(mapping,mappings){if(mappings.find(function(m){return m.targetGroupGuid===mapping.targetGroupGuid;})){return mappings.map(function(m){return m.targetGroupGuid===mapping.targetGroupGuid?mapping:m;});}else{return[].concat(_toConsumableArray(mappings),[mapping]);}}function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["f" /* GET_DIR_SVC_MAPPINGS_SUCCESS */]:return Object.assign({},state,{mappings:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["i" /* QUERY_DIR_SVC_SUCCESS */]:var queryResults=action.payload.sort(function(a,b){return a.attributes.name.localeCompare(b.attributes.name);}).map(function(item){return Object.assign({id:item.dn,state:{expanded:true}},item);});var selectedNode=state.selectedNode;if(selectedNode){var oldQueryResultsCopy=state.queryResults.slice();var oldQueryParentNode=oldQueryResultsCopy.find(function(node){return node.dn===selectedNode.dn;});// TODO: needs to be recursive
oldQueryParentNode.children=queryResults;queryResults=oldQueryResultsCopy;}return Object.assign({},state,{queryResults:queryResults});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["k" /* SET_DESTINATION */]:return Object.assign({},state,{destination:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["l" /* SET_DIR_SVC_MAPPING */]:return Object.assign({},state,{mappings:addOrUpdateMapping(action.payload,state.mappings)});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["m" /* SET_QUERY_PENDING */]:return Object.assign({},state,{queryIsPending:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["n" /* SET_QUERY_TYPE */]:return Object.assign({},state,{queryType:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["o" /* SET_SELECTED_NODE */]:return Object.assign({},state,{selectedNode:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["j" /* RESET_STATE */]:return Object.assign({},initialState);default:return state;}}function queryDirectoryService(identitySession,dirSvcUuid,searchBase,searchScope,query){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["g" /* QUERY_DIR_SVC */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["i" /* QUERY_DIR_SVC_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["h" /* QUERY_DIR_SVC_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service/'+dirSvcUuid+'/items',{params:{session:identitySession,searchBase:searchBase,searchFilter:query,searchScope:searchScope}});}};}function getDirectoryServiceMappings(identitySession,dirSvcUuid){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["d" /* GET_DIR_SVC_MAPPINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["f" /* GET_DIR_SVC_MAPPINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["e" /* GET_DIR_SVC_MAPPINGS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service/'+dirSvcUuid+'/mappings',{params:{session:identitySession}});}};}function setDestination(destination){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["k" /* SET_DESTINATION */],payload:destination};}function setSelectedNode(node){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["o" /* SET_SELECTED_NODE */],payload:node};}function setQueryPending(isPending){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["m" /* SET_QUERY_PENDING */],payload:isPending};}function setDirectoryServiceQueryType(queryType){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["n" /* SET_QUERY_TYPE */],payload:queryType};}function setMapping(mapping){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["l" /* SET_DIR_SVC_MAPPING */],payload:mapping};}function resetState(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["j" /* RESET_STATE */]};}function syncMappings(identitySession,dirSvcUuid){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["p" /* SYNC_MAPPINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["r" /* SYNC_MAPPINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["q" /* SYNC_MAPPINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service/'+dirSvcUuid+'/mappings/_sync',{params:{session:identitySession}});}};}function addMappings(identitySession,dirSvcUuid,mappings){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["a" /* ADD_DIR_SVC_MAPPINGS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["c" /* ADD_DIR_SVC_MAPPINGS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["b" /* ADD_DIR_SVC_MAPPINGS_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service/'+dirSvcUuid+'/mappings',{params:{session:identitySession},data:mappings});}};}function updateMapping(identitySession,dirSvcUuid,mapping){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["s" /* UPDATE_DIR_SVC_MAPPING */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["u" /* UPDATE_DIR_SVC_MAPPING_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_dirSvcTypes__["t" /* UPDATE_DIR_SVC_MAPPING_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/directory-service/'+dirSvcUuid+'/mappings/'+mapping.uuid,{params:{session:identitySession},data:mapping});}};}var actions={addMappings:addMappings,getDirectoryServiceMappings:getDirectoryServiceMappings,queryDirectoryService:queryDirectoryService,resetState:resetState,setDestination:setDestination,setDirectoryServiceQueryType:setDirectoryServiceQueryType,setMapping:setMapping,setQueryPending:setQueryPending,setSelectedNode:setSelectedNode,syncMappings:syncMappings,updateMapping:updateMapping};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNodeRenderOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return replaceNodeFromTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteNodeFromTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteNode; });
/* unused harmony export addNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRowIndexFromId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findindex__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getFlattenedTree__ = __webpack_require__(395);
/* unused harmony reexport getFlattenedTree */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var getNodeRenderOptions = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (node) {
  return (node.state || {}).expanded;
}, function (node) {
  return (node.state || {}).favorite;
}, function (node) {
  return (node.state || {}).deletable;
}, function (node) {
  return node.children;
}, function (expanded, favorite, deletable) {
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return {
    hasChildren: !!children.length,
    isExpanded: !!expanded,
    isFavorite: !!favorite,
    isDeletable: !!deletable
  };
});

var FLATTEN_TREE_PROPERTIES = ['deepness', 'parents'];

var NODE_OPERATION_TYPES = {
  CHANGE_NODE: 'CHANGE_NODE',
  DELETE_NODE: 'DELETE_NODE'
};

var NODE_CHANGE_OPERATIONS = {
  CHANGE_NODE: function CHANGE_NODE(nodes, updatedNode) {
    return nodes.map(function (n) {
      return n.id === updatedNode.id ? __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(_extends({}, updatedNode, n.children && { children: [].concat(n.children) }), FLATTEN_TREE_PROPERTIES) : n;
    });
  },
  DELETE_NODE: function DELETE_NODE(nodes, updatedNode) {
    return nodes.filter(function (n) {
      return n.id !== updatedNode.id;
    });
  }
};

var replaceNodeFromTree = function replaceNodeFromTree(nodes, updatedNode) {
  var operation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NODE_OPERATION_TYPES.CHANGE_NODE;

  if (!NODE_CHANGE_OPERATIONS[operation]) {
    return nodes;
  }

  var parents = updatedNode.parents;


  if (!parents.length) {
    return NODE_CHANGE_OPERATIONS[operation](nodes, updatedNode);
  }

  var parentIndex = __WEBPACK_IMPORTED_MODULE_2_lodash_findindex___default()(nodes, function (n) {
    return n.id === parents[0];
  });
  var preSiblings = nodes.slice(0, parentIndex);
  var postSiblings = nodes.slice(parentIndex + 1);

  return [].concat(preSiblings, [_extends({}, nodes[parentIndex], nodes[parentIndex].children ? {
    children: replaceNodeFromTree(nodes[parentIndex].children, _extends({}, updatedNode, { parents: parents.slice(1) }), operation)
  } : {})], postSiblings);
};

var deleteNodeFromTree = function deleteNodeFromTree(nodes, deletedNode) {
  return replaceNodeFromTree(nodes, deletedNode, NODE_OPERATION_TYPES.DELETE_NODE);
};

var updateNode = function updateNode(originalNode, newState) {
  return {
    node: _extends({}, originalNode, {
      state: _extends({}, originalNode.state, newState)
    }),
    type: __WEBPACK_IMPORTED_MODULE_3__contants__["a" /* UPDATE_TYPE */].UPDATE
  };
};

var deleteNode = function deleteNode(node) {
  return {
    node: node,
    type: __WEBPACK_IMPORTED_MODULE_3__contants__["a" /* UPDATE_TYPE */].DELETE
  };
};

var addNode = function addNode(node) {
  return {
    node: node,
    type: __WEBPACK_IMPORTED_MODULE_3__contants__["a" /* UPDATE_TYPE */].ADD
  };
};

var getRowIndexFromId = function getRowIndexFromId(flattenedTree, id) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_findindex___default()(flattenedTree, function (node) {
    return node.id === id;
  });
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SN_TYPE_DEMO; });
/* harmony export (immutable) */ __webpack_exports__["c"] = daysUntilExpiration;
/* harmony export (immutable) */ __webpack_exports__["b"] = containsValidLicenses;
/* harmony export (immutable) */ __webpack_exports__["f"] = isMainProductCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasMainProductLicense;
/* harmony export (immutable) */ __webpack_exports__["e"] = isDemoMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_constants__ = __webpack_require__(4);
// Product Ids
var SN_TYPE_STUDIO='PS';var SN_TYPE_SERVER='PP';var SN_TYPE_DEMO='PD';function daysUntilExpiration(license){var daysRemaining=0;if(license.dateExpires){daysRemaining=Math.trunc((new Date(license.dateExpires)-Date.now())/1000/60/60/24);if(daysRemaining<0){daysRemaining=0;}}return daysRemaining;}function parseLicenses(rawText){return rawText.trim().split(/[\s]+/);}function containsValidLicenses(rawText){// (?:x) = non-capturing group. Faster than a capturing group.
// x{n} matches exactly n occurrences of the preceding item x.
// So ^(?:[a-zA-Z0-9]{4}-){5} matches XXXX-XXXX-XXXX-XXXX-XXXX- followed by XXXX.
var validFormat=/^(?:[a-zA-Z0-9]{4}-){5}[a-zA-Z0-9]{4}$/;if(rawText&&rawText.length>=__WEBPACK_IMPORTED_MODULE_0_util_constants__["_3" /* SN_LENGTH */]){return parseLicenses(rawText).every(function(sn){return validFormat.test(sn);});}return false;}function isMainProductCode(productId){var serverLicenseIds=[SN_TYPE_STUDIO,SN_TYPE_SERVER,SN_TYPE_DEMO];return serverLicenseIds.includes(productId);}function isMainProductLicense(license){return isMainProductCode(license.productId);}function hasMainProductLicense(licenses){return licenses.some(function(lic){return isMainProductLicense(lic);});}function isDemoMode(licenses){return licenses.some(function(license){return license.productId===SN_TYPE_DEMO;});}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getExtensisAccountInfo;
/* harmony export (immutable) */ __webpack_exports__["a"] = addLicenses;
/* unused harmony export addLicense */
/* harmony export (immutable) */ __webpack_exports__["c"] = setExtensisAccount;
/* harmony export (immutable) */ __webpack_exports__["d"] = setExtensisSystem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_licenseUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_serverUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_dialogPanelCommands__ = __webpack_require__(12);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var addLicenseAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].addLicense,clearIsPendingResponse=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].clearIsPendingResponse,getExtensisAccount=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].getExtensisAccount,getExtensisSystemsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].getExtensisSystems,getLicensingInfo=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].getLicensingInfo,setExtensisAccountAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].setExtensisAccount,setExtensisSystemAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].setExtensisSystem,setIsPendingResponse=__WEBPACK_IMPORTED_MODULE_1_state_reducers_licenseReducer__["a" /* actions */].setIsPendingResponse;var getPublicKeyInfo=__WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__["a" /* actions */].getPublicKeyInfo;function getExtensisAccountInfo(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var adminSessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:adminSessionId=Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["d" /* getAdminSession */])(getState());dispatch(setIsPendingResponse());_context.next=4;return dispatch(getExtensisAccount(adminSessionId)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].error(e);dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */])(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].LIC_ERROR_GET_ACCOUNT));});case 4:_context.next=6;return dispatch(getLicensingInfo(adminSessionId)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].error(e);});case 6:dispatch(clearIsPendingResponse());case 7:case'end':return _context.stop();}}},_callee,this);}));function getExtensisAccountInfo(_x,_x2){return _ref.apply(this,arguments);}return getExtensisAccountInfo;}();}function addLicenses(rawText,intl){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var serialNumbers,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,sn;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:serialNumbers=rawText.trim().split(/[\s]/).filter(function(sn){return sn.length>=__WEBPACK_IMPORTED_MODULE_4_util_constants__["_3" /* SN_LENGTH */];}).filter(function(sn){return sn.startsWith(__WEBPACK_IMPORTED_MODULE_5_util_licenseUtils__["a" /* SN_TYPE_DEMO */]);}).sort(function(a,b){if(Object(__WEBPACK_IMPORTED_MODULE_5_util_licenseUtils__["f" /* isMainProductCode */])(a)){return-1;}else if(Object(__WEBPACK_IMPORTED_MODULE_5_util_licenseUtils__["f" /* isMainProductCode */])(b)){return 1;}else return 0;});dispatch(setIsPendingResponse());_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=5;_iterator=serialNumbers[Symbol.iterator]();case 7:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=14;break;}sn=_step.value;_context2.next=11;return dispatch(addLicenseAction(Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["d" /* getAdminSession */])(getState()),sn)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].error(e);if(e.message&&e.message.includes('This license is not supported by the main product license')){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */])(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */])(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].LIC_ERROR_MSG));}});case 11:_iteratorNormalCompletion=true;_context2.next=7;break;case 14:_context2.next=20;break;case 16:_context2.prev=16;_context2.t0=_context2['catch'](5);_didIteratorError=true;_iteratorError=_context2.t0;case 20:_context2.prev=20;_context2.prev=21;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 23:_context2.prev=23;if(!_didIteratorError){_context2.next=26;break;}throw _iteratorError;case 26:return _context2.finish(23);case 27:return _context2.finish(20);case 28:dispatch(clearIsPendingResponse());_context2.next=31;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__adminPropertiesCommands__["e" /* getAdminProperties */])([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].licenses]));case 31:case'end':return _context2.stop();}}},_callee2,this,[[5,16,20,28],[21,,23,27]]);}));function addLicenses(_x3,_x4){return _ref2.apply(this,arguments);}return addLicenses;}();}function addLicense(serialNumber){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return dispatch(addLicenseAction(Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["d" /* getAdminSession */])(getState()),serialNumber));case 2:case'end':return _context3.stop();}}},_callee3,this);}));function addLicense(_x5,_x6){return _ref3.apply(this,arguments);}return addLicense;}();}function setExtensisAccount(account,password){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var session,publicKeyInfoResult,encryptedPassword,systems;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["d" /* getAdminSession */])(getState());if(!session){_context4.next=22;break;}_context4.next=4;return dispatch(getPublicKeyInfo());case 4:publicKeyInfoResult=_context4.sent;encryptedPassword=Object(__WEBPACK_IMPORTED_MODULE_11_util_serverUtils__["b" /* encrypt */])(password,publicKeyInfoResult.payload);dispatch(setIsPendingResponse());_context4.next=9;return dispatch(setExtensisAccountAction(session,account,encryptedPassword)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].error(e);dispatch(clearIsPendingResponse());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */])(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].LIC_SET_ACCOUNT_ERROR));return;});case 9:if(!account){_context4.next=17;break;}_context4.next=12;return dispatch(getExtensisSystemsAction(session));case 12:systems=Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["F" /* getExtensisSystems */])(getState());// if more than one system, make user select
if(!(systems.length>1)){_context4.next=17;break;}dispatch(clearIsPendingResponse());dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_state_commands_dialogPanelCommands__["b" /* showDialogPanel */])(__WEBPACK_IMPORTED_MODULE_4_util_constants__["_2" /* SET_SYSTEM_PANEL_ID */]));return _context4.abrupt('return');case 17:// no error and no system selection needed
dispatch(clearIsPendingResponse());_context4.next=20;return dispatch(getExtensisAccountInfo());case 20:_context4.next=22;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__adminPropertiesCommands__["e" /* getAdminProperties */])([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].licenses]));case 22:case'end':return _context4.stop();}}},_callee4,this);}));function setExtensisAccount(_x7,_x8){return _ref4.apply(this,arguments);}return setExtensisAccount;}();}function setExtensisSystem(systemId){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["d" /* getAdminSession */])(getState());if(!session){_context5.next=10;break;}dispatch(setIsPendingResponse());_context5.next=5;return dispatch(setExtensisSystemAction(session,systemId));case 5:_context5.next=7;return dispatch(getExtensisAccountInfo());case 7:dispatch(clearIsPendingResponse());_context5.next=10;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__adminPropertiesCommands__["e" /* getAdminProperties */])([__WEBPACK_IMPORTED_MODULE_10_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].licenses]));case 10:case'end':return _context5.stop();}}},_callee5,this);}));function setExtensisSystem(_x9,_x10){return _ref5.apply(this,arguments);}return setExtensisSystem;}();}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(407),
    baseKeys = __webpack_require__(1022),
    isArrayLike = __webpack_require__(156);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDismissedReachoutMessageId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadPersistedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return persist; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_persistReducer__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_state_reducers_reachoutReducer__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_reachoutUtils__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_persistenceUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_intlReducer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOCALE=__WEBPACK_IMPORTED_MODULE_7_util_constants__["_14" /* USER_DATA */].LOCALE;var setLocale=__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_intlReducer__["a" /* actions */].setLocale;var persistAction=__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_persistReducer__["a" /* actions */].persist;function persist(persistData){return persistAction(function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_persistenceUtils__["c" /* saveToLocalStorage */])(__WEBPACK_IMPORTED_MODULE_7_util_constants__["_13" /* STORAGE_KEY */],persistData);});}function loadPersistedData(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var userData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:userData=Object(__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_persistenceUtils__["a" /* getFromLocalStorage */])(__WEBPACK_IMPORTED_MODULE_7_util_constants__["_13" /* STORAGE_KEY */]);if(!userData[LOCALE]){_context.next=4;break;}_context.next=4;return dispatch(setLocale(userData[LOCALE]));case 4:if(userData.dismissedMessageIds){dispatch(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_state_reducers_reachoutReducer__["a" /* actions */].setDismissedMessageIds(userData.dismissedMessageIds));}case 5:case'end':return _context.stop();}}},_callee,this);}));function loadPersistData(_x){return _ref.apply(this,arguments);}return loadPersistData;}();}function addDismissedReachoutMessageId(id){return function addDismissedReachoutMessageId(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_reachoutUtils__["b" /* persistNewDismissedReachoutMessageId */])(id,Object(__WEBPACK_IMPORTED_MODULE_4_state_selectors__["B" /* getDismissedMessageIds */])(getState()),Object(__WEBPACK_IMPORTED_MODULE_4_state_selectors__["_14" /* getReachoutMessages */])(getState()),function(newIdArray){dispatch(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_state_reducers_reachoutReducer__["a" /* actions */].setDismissedMessageIds(newIdArray));dispatch(persist({dismissedMessageIds:newIdArray}));});};}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLATFORM_WINDOWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCT_ADMIN; });
var PLATFORM_WINDOWS='PLATFORM_WINDOWS';var PRODUCT_ADMIN='admin';

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(299);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(40);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(605);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(95);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(607);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(60);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(60);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(637);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(75)(module)))

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(640);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(308);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FC_INVALID_PATH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FC_FILE_NOT_FOUND; });
/* unused harmony export FC_ITEM_NOT_FOUND */
/* unused harmony export FC_DUPLICATE_ITEM */
/* unused harmony export FC_DUPLICATE_FILE */
/* unused harmony export FC_CONTAINS_EXISTING_FOLDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FC_INVALID_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FC_INSUFFICIENT_PRIVILEGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FC_MALFORMED_QUERY_STRING; });
/* unused harmony export FC_NOT_ALLOWED */
/* unused harmony export FC_INVALID_CHARACTER_ENCODING */
/* unused harmony export FC_INVALID_PARAMETERS */
/* unused harmony export FC_UNSUPPORTED_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FC_UNEXPECTED_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FC_SERVER_UNREACHABLE; });
/* unused harmony export FC_LICENSE_COUNT_EXCEEDED */
var FC_INVALID_PATH='InvalidPath';var FC_FILE_NOT_FOUND='FileNotFound';var FC_ITEM_NOT_FOUND='ItemNotFound';var FC_DUPLICATE_ITEM='DuplicateItem';var FC_DUPLICATE_FILE='DuplicateFile';var FC_CONTAINS_EXISTING_FOLDER='ContainsExistingFolder';var FC_INVALID_CREDENTIALS='InvalidCredentials';var FC_INSUFFICIENT_PRIVILEGES='InsufficientPrivileges';var FC_MALFORMED_QUERY_STRING='MalformedQueryString';var FC_NOT_ALLOWED='NotAllowed';var FC_INVALID_CHARACTER_ENCODING='InvalidCharacterEncoding';var FC_INVALID_PARAMETERS='InvalidParameters';var FC_UNSUPPORTED_TYPE='UnsupportedType';var FC_UNEXPECTED_ERROR='UnexpectedError';var FC_SERVER_UNREACHABLE='ServerUnreachable';// Not a server faultcode
var FC_LICENSE_COUNT_EXCEEDED='LicenseCountExceeded';

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_md5__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_reducers_serverReducer__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_types_globalTypes__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_PortfolioError__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portfolio_shared_util_faultCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_portfolio_shared_util_addLocales__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_portfolio_shared_util_persistenceUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_state_commands_persistCommands__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_state_commands_intlCommands__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_util_backupUtils__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_util_serverUtils__ = __webpack_require__(37);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var adminLogin=__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["a" /* actions */].adminLogin,adminLogout=__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["a" /* actions */].adminLogout,getPublicKeyInfo=__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["a" /* actions */].getPublicKeyInfo,identityLogin=__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["a" /* actions */].identityLogin,identityLogout=__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["a" /* actions */].identityLogout,setAdminPropertiesPollInterval=__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["a" /* actions */].setAdminPropertiesPollInterval;var getServerSystemInformation=__WEBPACK_IMPORTED_MODULE_5_state_reducers_serverReducer__["a" /* actions */].getServerSystemInformation,setServerStatus=__WEBPACK_IMPORTED_MODULE_5_state_reducers_serverReducer__["a" /* actions */].setServerStatus;var POLL_INTERVAL_REGULAR=10000;var POLL_INTERVAL_FAST=1000;var pollTimer=void 0;function computePollingInterval(getState){var runState=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_25" /* getServerRunState */])(getState());return runState===__WEBPACK_IMPORTED_MODULE_8_util_constants__["Y" /* SERVER_STATE_STARTING */]||runState===__WEBPACK_IMPORTED_MODULE_8_util_constants__["_0" /* SERVER_STATE_STOPPING */]||Object(__WEBPACK_IMPORTED_MODULE_18_util_backupUtils__["d" /* isBackupRestoreBusy */])(Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["h" /* getBackupRestoreStatus */])(getState()))?POLL_INTERVAL_FAST:POLL_INTERVAL_REGULAR;}function handlePollingTimeout(dispatch,getState,isFirstTime){var _this=this;return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(pollTimer){clearTimeout(pollTimer);pollTimer=null;}if(!(Date.now()-Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_0" /* getLastActivity */])(getState())>Object(__WEBPACK_IMPORTED_MODULE_3_state_reducers_authReducer__["c" /* getClientInactivityTimeout */])())){_context.next=5;break;}dispatch(logout());_context.next=9;break;case 5:if(!(!isFirstTime&&Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(getState()))){_context.next=8;break;}_context.next=8;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__adminPropertiesCommands__["e" /* getAdminProperties */])(getPropertyListForState(getState())));case 8:pollTimer=setTimeout(handlePollingTimeout(dispatch,getState),computePollingInterval(getState));case 9:case'end':return _context.stop();}}},_callee,_this);}));}function login(username,unencryptedPassword){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var hashedPassword,isFullAdmin,rsaEncryptedPassword,publicKeyInfoResult,loginAction,identitySessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:hashedPassword=__WEBPACK_IMPORTED_MODULE_1_md5___default()(unencryptedPassword);_context2.next=3;return dispatch(adminLogin(username,hashedPassword)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('admin login failed, attempting identity service login');});case 3:isFullAdmin=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["T" /* getIsFullAdmin */])(getState());rsaEncryptedPassword=void 0;if(isFullAdmin){_context2.next=10;break;}_context2.next=8;return dispatch(getPublicKeyInfo());case 8:publicKeyInfoResult=_context2.sent;rsaEncryptedPassword=Object(__WEBPACK_IMPORTED_MODULE_19_util_serverUtils__["b" /* encrypt */])(unencryptedPassword,publicKeyInfoResult.payload);case 10:loginAction=identityLogin(username,isFullAdmin?hashedPassword:rsaEncryptedPassword,!isFullAdmin);_context2.next=13;return dispatch(loginAction).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('identity login failed');if(!isFullAdmin){Object(__WEBPACK_IMPORTED_MODULE_10_util_safeDispatch__["c" /* handleError */])(e,dispatch,_defineProperty({},__WEBPACK_IMPORTED_MODULE_12_portfolio_shared_util_faultCode__["c" /* FC_INVALID_CREDENTIALS */],__WEBPACK_IMPORTED_MODULE_13_util_localizedStrings__["a" /* default */].loginFailed));}});case 13:identitySessionId=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(getState());if(identitySessionId){dispatch(setServerStatus(__WEBPACK_IMPORTED_MODULE_8_util_constants__["X" /* SERVER_STATE_STARTED */]));dispatch(getServerSystemInformation(identitySessionId));}if(!isFullAdmin){_context2.next=19;break;}_context2.next=18;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__adminPropertiesCommands__["e" /* getAdminProperties */])(getPropertyListForState(getState())));case 18:// Begin Change Status polling
dispatch(setAdminPropertiesPollInterval(handlePollingTimeout(dispatch,getState,true)));case 19:case'end':return _context2.stop();}}},_callee2,this);}));function login(_x,_x2){return _ref2.apply(this,arguments);}return login;}();}function logout(){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var _this2=this;var _getState,_getState$auth,adminSessionId,identitySessionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_getState=getState(),_getState$auth=_getState.auth,adminSessionId=_getState$auth.adminSessionId,identitySessionId=_getState$auth.identitySessionId;if(!adminSessionId){_context4.next=4;break;}_context4.next=4;return dispatch(adminLogout(adminSessionId)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('admin logout failed');});case 4:if(!identitySessionId){_context4.next=7;break;}_context4.next=7;return dispatch(identityLogout(identitySessionId)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].info('identity logout failed');});case 7:// DESTROY ALL STATE
dispatch(__WEBPACK_IMPORTED_MODULE_9_state_types_globalTypes__["b" /* clearStateAction */]);// Need to reinitialize Intl
Object(__WEBPACK_IMPORTED_MODULE_14_portfolio_shared_util_addLocales__["a" /* addLocales */])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_util_persistenceUtils__["b" /* initLocalStorage */])(__WEBPACK_IMPORTED_MODULE_8_util_constants__["_13" /* STORAGE_KEY */]);_context3.next=3;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_state_commands_persistCommands__["b" /* loadPersistedData */])());case 3:locale=Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_4" /* getLocale */])(getState());_context3.next=6;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_state_commands_intlCommands__["b" /* setMessages */])(locale));case 6:case'end':return _context3.stop();}}},_callee3,_this2);})));case 9:case'end':return _context4.stop();}}},_callee4,this);}));function logout(_x3,_x4){return _ref3.apply(this,arguments);}return logout;}();}function getPropertyListForState(state){var properties=[__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].backupRestoreStatus,__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].diagnosticDataStatus,__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].serverStatus,__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].licenses,__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].loggingConfig,__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].ports,__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].globalSettings];if(Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(state)){properties.push(__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].mediaEngines);properties.push(__WEBPACK_IMPORTED_MODULE_2_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].globalStatistics);}return properties;}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PATH_SEP */
/* unused harmony export ROOT_PATH_SEP */
/* unused harmony export isVaultPath */
/* harmony export (immutable) */ __webpack_exports__["c"] = isPathDescendantOf;
/* unused harmony export getParentPath */
/* harmony export (immutable) */ __webpack_exports__["b"] = getPathSeparator;
/* harmony export (immutable) */ __webpack_exports__["a"] = appendToPath;
/* unused harmony export getExtension */
/* unused harmony export fullPathToRelativePath */
/* unused harmony export trimTrailingPathSep */
/* unused harmony export displayNameFromPath */
/* unused harmony export isValidFileOrDirectoryName */
var PATH_SEP=':';var ROOT_PATH_SEP='::';function isVaultPath(path){if(path===null||path.length===0){return false;}return path===PATH_SEP||path.charAt(0)===PATH_SEP&&path.charAt(1)!==PATH_SEP;}function isPathDescendantOf(path,ancestor){if(path===ancestor){return true;}if(path.indexOf(ROOT_PATH_SEP)!==ancestor.indexOf(ROOT_PATH_SEP)){return false;}ancestor=ancestor.substr(-1)===PATH_SEP?ancestor:ancestor+PATH_SEP;return path.indexOf(ancestor)===0;}function getParentPath(fullPath){// remove any trailing ":" chars from the end of the path
var path=fullPath.lastIndexOf(PATH_SEP)===fullPath.length-1?fullPath.slice(0,-1):fullPath;var parentPath=null;if(path===''||path.lastIndexOf(PATH_SEP)===1){// we have the parent path already
parentPath=path;}else{parentPath=path.slice(0,path.lastIndexOf(PATH_SEP)+1);}return parentPath;}function getPathSeparator(isWindows){return isWindows?'\\':'/';}function appendToPath(root,toAppend,pathSeparator){if(!root&&!toAppend){return'';}else if(!root){return toAppend;}else if(!toAppend){return root;}var result=root;if(!result.endsWith(pathSeparator)&&!toAppend.startsWith(pathSeparator)){result+=pathSeparator;}result+=toAppend;return result;}function getExtension(fileName){return fileName.substr((~-fileName.lastIndexOf('.')>>>0)+2).toLowerCase();}function fullPathToRelativePath(watchFolder,fullPath){var relPath=null;if(watchFolder&&watchFolder.path.length<=fullPath.length){relPath=fullPath.substring(watchFolder.path.length);relPath=relPath.indexOf(PATH_SEP)===0?relPath.slice(1):relPath;relPath=relPath.lastIndexOf(PATH_SEP)===relPath.length-1?relPath.slice(0,-1):relPath;}return relPath;}function trimTrailingPathSep(path){if(!path){return path;}if(path.charAt(path.length-1)===PATH_SEP){path=path.slice(0,-1);}return path;}function displayNameFromPath(path){return path.split(PATH_SEP).filter(function(x){return!!x;}).pop();}// taken from: http://stackoverflow.com/questions/11100821/javascript-regex-for-validating-filenames#11101624
//  and: https://msdn.microsoft.com/en-us/library/windows/desktop/aa365247(v=vs.85).aspx
var LEGAL_CHARS_REGEX=/^[^\\/:*?"<>|]+$/;// forbidden characters: \ / : * ? " < > |
var ENDS_WITH_DOT_REGEX=/\.$/;var ENDS_WITH_WHITESPACE_REGEX=/\s$/;var FORBIDDEN_FILENAMES_REGEX=/^(aux|nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i;function isValidFileOrDirectoryName(fileOrDirName){return LEGAL_CHARS_REGEX.test(fileOrDirName)&&!ENDS_WITH_DOT_REGEX.test(fileOrDirName)&&!FORBIDDEN_FILENAMES_REGEX.test(fileOrDirName)&&!ENDS_WITH_WHITESPACE_REGEX.test(fileOrDirName);}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SYNC_STATUS_FILES_TO_ADD */
/* unused harmony export SYNC_STATUS_INCOMPLETELY_SCANNED */
/* unused harmony export SYNC_STATUS_UNAVAILABLE */
/* unused harmony export SYNC_STATUS_ERROR */
/* unused harmony export SYNC_STATUS_CONTAINS_EXCLUDED_FILES */
/* unused harmony export SYNC_STATUS_FILES_MISSING_ON_DISK */
/* unused harmony export SYNC_STATUS_FILES_MODIFIED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILETYPE; });
/* unused harmony export isFolderAccessible */
/* unused harmony export isFolderOutOfSync */
/* unused harmony export isRootFolder */
/* unused harmony export visibleFolderForPath */
/* unused harmony export watchFolderForPath */
/* unused harmony export watchFolderIdForPath */
/* unused harmony export getParentFolderPath */
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = getFolderForPath;
/* unused harmony export folderListRowCount */
/* unused harmony export getFolderAndLevelForRow */
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeServerFoldersResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_pathUtils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_sharedConstants__ = __webpack_require__(116);
var SYNC_STATUS_FILES_TO_ADD=1;var SYNC_STATUS_INCOMPLETELY_SCANNED=2;var SYNC_STATUS_UNAVAILABLE=4;var SYNC_STATUS_ERROR=8;var SYNC_STATUS_CONTAINS_EXCLUDED_FILES=16;var SYNC_STATUS_FILES_MISSING_ON_DISK=32;var SYNC_STATUS_FILES_MODIFIED=64;var FILETYPE={directory:'directory',file:'file'};//folderUtils.js
function isFolderAccessible(folder){var flags=folder.folderOnlyFlags||0;return(flags&SYNC_STATUS_UNAVAILABLE)===0;}function isFolderOutOfSync(folder){var flags=folder.flags||0;return 0!==(flags&SYNC_STATUS_FILES_TO_ADD+SYNC_STATUS_FILES_MISSING_ON_DISK+SYNC_STATUS_FILES_MODIFIED);}function isRootFolder(folder){return folder?folder.isRoot:false;}// If recurse is false, return the first visibleFolder that is an ancestor of the path or null.
// If recurse is true, return the possibly nested visibleFolder that is an exact
// match of the path or null.
function visibleFolderForPath(path,visibleFolders,recurse){var result=null;while(visibleFolders&&!result){var subfolders=null;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=visibleFolders[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var folder=_step.value;if(Object(__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_pathUtils__["c" /* isPathDescendantOf */])(path,folder.fullPath)){if(recurse){if(path===folder.fullPath){result=folder;}else{subfolders=folder.s;}}else{result=folder;}break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}visibleFolders=subfolders;}return result;}function watchFolderForPath(path,watchFolders){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=Object.keys(watchFolders)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var id=_step2.value;var folder=watchFolders[id];if(Object(__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_pathUtils__["c" /* isPathDescendantOf */])(path,folder.path)){return folder;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return null;}function watchFolderIdForPath(path,watchFolders){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=Object.keys(watchFolders)[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var id=_step3.value;var folder=watchFolders[id];if(Object(__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_pathUtils__["c" /* isPathDescendantOf */])(path,folder.path)){return id;}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return null;}function getParentFolderPath(path){return path.split(':').slice(0,-2).join(':')+':';}// The following functions are used browsing the server filesystem.
// We should be able to adapt them without too much trouble for working with
// watchfolders as well.
/**
 * Given an array of possibly deeply nested folder objects and a currently selected
 * path, get the next or previous path.
 *
 * folders - an array of folder objects
 * cur - the currently selected path
 * isUp - if true, get the previous path, otherwise the next.
 *
 * The simple way to do this would be to iterate through all the expanded
 * folders. I did it a harder way that I hope will scale up better.
 *
 * TODO - pull this out into a utility. This can probably be reused for the
 *   watchfolder list in the organizer panel.
 */function getNextPath(folders,cur,isUp){if(!cur){return folders[0].fullPath;}else{var ancestors=[];if(!getFolderAncestorIndicesForPath(folders,cur,ancestors)){return null;}var tree=null;if(isUp){var level=ancestors.length-1;tree=getTreeForAncestorIndices(folders,ancestors.slice(0,level));var subfolders=level===0?folders:tree.s;if(ancestors[level]>0){tree=subfolders[ancestors[level]-1];while(tree.isExpanded&&tree.s&&tree.s.length>0){tree=tree.s[tree.s.length-1];}}}else{tree=getTreeForAncestorIndices(folders,ancestors);if(tree.isExpanded&&tree.s&&tree.s.length>0){tree=tree.s[0];}else{var _level=ancestors.length;while(--_level>=0){tree=getTreeForAncestorIndices(folders,ancestors.slice(0,_level));var _subfolders=_level===0?folders:tree.s;if(ancestors[_level]<_subfolders.length-1){tree=_subfolders[ancestors[_level]+1];break;}}}}return tree?tree.fullPath:null;}}function separatorForPath(path){var result='\\';if(path){var c1=path.charAt(0);if(c1==='/'||c1===':'){result=c1;}}return result;}function appendSeparator(path,sep){var result=path;var separator=sep?sep:separatorForPath(path);if(path.lastIndexOf(separator)!==path.length-1){result=path+separator;}return result;}/**
 * The first argument is an array of tree objects (see below).
 *
 * The ancestors parameter will be populated with
 * all ancestor tree node indexes starting with the given path.
 *
 * Returns tree if-and-only-if the path is found.
 **/function getFolderAncestorIndicesForPath(treeArray,path,ancestors,separator){var result=false;for(var i=0;i<treeArray.length&&!result;++i){var tree=treeArray[i];if(tree.fullPath===path){ancestors.push(i);result=true;}else if(path.indexOf(appendSeparator(tree.fullPath,separator))===0){ancestors.push(i);result=getFolderAncestorIndicesForPath(tree.s,path,ancestors,separator);}}return result;}function getTreeForAncestorIndices(treeArray,ancestors){var result=null;for(var i=0;i<ancestors.length;++i){if(!result){result=treeArray[ancestors[i]];}else{result=result.s[ancestors[i]];}}return result;}// The first argument is either a tree object, or an array of tree objects.
// The tree objects look like:
// { fullPath: '/Absolute/path/name', displayName: 'name', isExpanded: false, s: [{ <folder object> }, ...] }
function getFolderForPath(tree,path,separator){if(!Array.isArray(tree)){tree=[tree];}var ancestors=[];if(getFolderAncestorIndicesForPath(tree,path,ancestors,separator)){return getTreeForAncestorIndices(tree,ancestors);}return null;}// This is called from the selector getFolderListRowCount
function folderListRowCount(folders){return folders.reduce(function(total,folder){return total+1+(folder.isExpanded&&folderListRowCount(folder.s));},0);}function getFolderAndLevelForRow(folders,row){var currentRow=0;var watchFolderId=0;function getFolderForRowInner(folders,row,level){for(var i=0;i<folders.length;i++){if(level===0){watchFolderId=folders[i].watchFolderId;}if(row===currentRow){return{folder:folders[i],level:level,watchFolderId:watchFolderId};}else if(folders[i].isExpanded){currentRow++;var folder=getFolderForRowInner(folders[i].s,row,level+1);if(folder){return folder;}else{continue;}}currentRow++;}}return getFolderForRowInner(folders,row,0);}// The rawResult is an array of objects that have a name
// and a type. The name is an absolute path for root directories,
// and just a name for all subfolders.
//
// We need to merge these into the serverFolders that contain objects
// with a fullPath member which is an absolute path, a displayName,
// a flag isExpanded, and an array of subfolders called s.
function mergeServerFoldersResult(rawResult,path,state){if(!path){path='';}var separator=Object(__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_pathUtils__["b" /* getPathSeparator */])(__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_sharedConstants__["a" /* PLATFORM_WINDOWS */]===state.serverOsPlatform);// If the path is empty, the name member will contain an absolute path.
// Otherwise, it will contain only a subfolder name, so we compute the prefix
// that we need to make the fullPath.
var prefix=path;if(prefix.length>0&&prefix.substring(path.length-1)!==separator){prefix+=separator;}var folderArray=[];// stringify and parse in order to make a deep copy so we don't modify the state.
var result=path?JSON.parse(JSON.stringify(state.serverFolders)):folderArray;for(var i=0;i<rawResult.length;++i){var name=rawResult[i].name;var pos=name.slice(0,name.length-1).lastIndexOf(separator);var folder={fullPath:prefix+name,displayName:name.substring(pos+1),type:rawResult[i].type};folderArray.push(folder);}// Now we have the new folder array, so sort it.
folderArray.sort(function(a,b){return a.displayName.localeCompare(b.displayName);});if(path){// If path is non-empty, find the folder in which to insert the array of subfolders.
var _folder=getFolderForPath(result,path,separator);if(_folder){// TODO - merge the folder array if there as an existing array of subfolders.
_folder.s=folderArray;}}return result;}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portfolio_shared_view_Utilities_BrowseServerFolders__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_pathUtils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portfolio_shared_util_folderUtils__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_reducers_serverReducer__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BrowseServerFoldersDialog_css__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BrowseServerFoldersDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__BrowseServerFoldersDialog_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getServerFoldersAction=__WEBPACK_IMPORTED_MODULE_13_state_reducers_serverReducer__["a" /* actions */].getServerFolders,updateServerFolders=__WEBPACK_IMPORTED_MODULE_13_state_reducers_serverReducer__["a" /* actions */].updateServerFolders;var BrowseServerFoldersDialog=function(_Component){_inherits(BrowseServerFoldersDialog,_Component);function BrowseServerFoldersDialog(){_classCallCheck(this,BrowseServerFoldersDialog);var _this=_possibleConstructorReturn(this,(BrowseServerFoldersDialog.__proto__||Object.getPrototypeOf(BrowseServerFoldersDialog)).call(this));_this.state={refreshing:false};_this.getSessionId=_this.getSessionId.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.handleFolderSelected=_this.handleFolderSelected.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.handleToggleCollapse=_this.handleToggleCollapse.bind(_this);_this.refreshFolders=_this.refreshFolders.bind(_this);_this.refreshAnimationDidEnd=_this.refreshAnimationDidEnd.bind(_this);_this.renderPanelHeader=_this.renderPanelHeader.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(BrowseServerFoldersDialog,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,getServerFoldersAction=_props.getServerFoldersAction,showFiles=_props.showFiles;var sessionId=this.getSessionId();if(sessionId){getServerFoldersAction(sessionId,undefined,undefined,showFiles);}}// return either admin or identity session id, depending on server state and user
},{key:'getSessionId',value:function getSessionId(){var _props2=this.props,adminSessionId=_props2.adminSessionId,identitySessionId=_props2.identitySessionId,serverStatus=_props2.serverStatus;var isStopped=serverStatus&&serverStatus.runState===__WEBPACK_IMPORTED_MODULE_10_util_constants__["Z" /* SERVER_STATE_STOPPED */];var session=isStopped&&adminSessionId?adminSessionId:identitySessionId;return session;}},{key:'refreshAnimationDidEnd',value:function refreshAnimationDidEnd(){this.setState({refreshing:false});}},{key:'submit',value:function submit(data){this.props.onPathSelected(data.selectedPath);}},{key:'refreshFolders',value:function refreshFolders(){var _props3=this.props,getServerFoldersAction=_props3.getServerFoldersAction,showFiles=_props3.showFiles;var sessionId=this.getSessionId();if(sessionId){getServerFoldersAction(sessionId,'',true,showFiles);}this.setState({refreshing:true});}},{key:'handleToggleCollapse',value:function handleToggleCollapse(path){var _props4=this.props,pathSeparator=_props4.pathSeparator,serverFolders=_props4.serverFolders,showFiles=_props4.showFiles;// Should this be moved into BrowseServerFolders?
var folder=Object(__WEBPACK_IMPORTED_MODULE_12_portfolio_shared_util_folderUtils__["b" /* getFolderForPath */])(serverFolders,path,pathSeparator);folder.isExpanded=!folder.isExpanded;this.props.updateServerFolders(serverFolders);var sessionId=this.getSessionId();if(folder.isExpanded&&sessionId){this.props.getServerFoldersAction(sessionId,path,undefined,showFiles);}this.forceUpdate();// This is what happens when you mutate state
}},{key:'handleFolderSelected',value:function handleFolderSelected(selectedPath){var _props5=this.props,pathSeparator=_props5.pathSeparator,serverFolderRoot=_props5.serverFolderRoot;var absolutePath=Object(__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_pathUtils__["a" /* appendToPath */])(serverFolderRoot,selectedPath,pathSeparator);this.props.change('selectedPath',absolutePath);}},{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'handleKeyDown',value:function handleKeyDown(e){this.serverFoldersHandleKeyDown&&this.serverFoldersHandleKeyDown(e);}},{key:'renderPanelHeader',value:function renderPanelHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'dialog-panel-header',style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'36px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dialog-panel-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].BROWSE_FOLDERS_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-outlined','data-test-name':'refresh',onClick:this.refreshFolders,title:this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].refresh)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-refresh '+(this.state.refreshing?'fa-spin-once':''),onAnimationEnd:this.refreshAnimationDidEnd})))));}},{key:'render',value:function render(){var _this2=this;var _props6=this.props,fileFilter=_props6.fileFilter,handleSubmit=_props6.handleSubmit,formatMessage=_props6.intl.formatMessage,pathSeparator=_props6.pathSeparator,selectedPath=_props6.selectedPath,serverFolders=_props6.serverFolders;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__["a" /* default */],{panelId:__WEBPACK_IMPORTED_MODULE_10_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */],activePanelId:this.props.activePanelId,contentStyle:{width:520,height:620},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].SELECT),handleKeyDown:this.handleKeyDown,hideDialogPanel:this.props.hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:handleSubmit(this.submit),showCancel:true,dataTestName:'browse-server-folders-dialog',panelHeader:this.renderPanelHeader()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_view_Utilities_BrowseServerFolders__["a" /* ServerFolders */],{onFolderSelected:this.handleFolderSelected,onToggleCollapse:this.handleToggleCollapse,outerDivStyle:'browseServerFoldersContainer',pathSeparator:pathSeparator,selectedFolderPath:selectedPath,treeArray:serverFolders,fileFilter:fileFilter,ref:function ref(c){_this2.serverFoldersHandleKeyDown=c?c.handleKeyDown:undefined;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-test-name':'selected-path',className:'selected-path'},selectedPath)));}}]);return BrowseServerFoldersDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BrowseServerFoldersDialog.defaultProps={showFiles:false};function validate(values,props){var errors={};if(!values.selectedPath){errors.selectedPath='Required';}else if(// If we're looking at files, assume we only want files to be valid selections
props.showFiles&&typeof props.fileFilter==='function'&&!props.fileFilter({displayName:values.selectedPath,fullPath:values.selectedPath,isExpanded:false,type:__WEBPACK_IMPORTED_MODULE_12_portfolio_shared_util_folderUtils__["a" /* FILETYPE */].file})){errors.selectedPath='Invalid Selection';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_10_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */],validate:validate})(BrowseServerFoldersDialog);var selector=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_10_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["c" /* getActivePanelId */])(state),adminSessionId:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["d" /* getAdminSession */])(state),identitySessionId:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(state),pathSeparator:Object(__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_pathUtils__["b" /* getPathSeparator */])(Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["Z" /* getIsServerPlatformWindows */])(state)),selectedPath:selector(state,'selectedPath'),// Deep copy of server folders so that we don't directly modify state
// when toggling folders opened and closed.
serverFolders:JSON.parse(JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_24" /* getServerFolders */])(state))),serverStatus:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_27" /* getServerStatus */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getServerFoldersAction:getServerFoldersAction,hideDialogPanel:__WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],updateServerFolders:updateServerFolders});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StaticTextField__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LabeledField__ = __webpack_require__(28);
function FormField(_ref){var children=_ref.children,label=_ref.label,labelClassName=_ref.labelClassName,readonly=_ref.readonly,value=_ref.value,dataTestName=_ref.dataTestName;// if static, use label class name for value too
if(readonly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StaticTextField__["a" /* default */],{label:label,labelClassName:labelClassName,value:value,valueClassName:labelClassName,'data-test-name':dataTestName||'field'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LabeledField__["a" /* default */],{label:label,labelClassName:labelClassName},children);}}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(197);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(783)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(337)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(57).f;
var has = __webpack_require__(65);
var TAG = __webpack_require__(30)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(788);
var global = __webpack_require__(29);
var hide = __webpack_require__(66);
var Iterators = __webpack_require__(84);
var TO_STRING_TAG = __webpack_require__(30)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 144 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* unused harmony export bpfrpt_proptype_RowRenderer */
/* unused harmony export bpfrpt_proptype_RenderedRows */
/* unused harmony export bpfrpt_proptype_Scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var bpfrpt_proptype_RowRendererParams =  true ? null : {
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};






/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(148);
var core = __webpack_require__(69);
var ctx = __webpack_require__(370);
var hide = __webpack_require__(890);
var has = __webpack_require__(217);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(150);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doesUserMatchUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findUserIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isAdminUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sortUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return renderUserType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_tableUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_constants__ = __webpack_require__(4);
function sortUsers(users,sortBy,sortDirection){var sorted=users.sort(function(a,b){var aVal=a[sortBy];var bVal=b[sortBy];var isOnline=function isOnline(userStatus){return userStatus===__WEBPACK_IMPORTED_MODULE_4_util_constants__["m" /* CATALOG_STATUS */].ONLINE;};if(sortBy==='userStatus'){return aVal===bVal?a.name.localeCompare(b.name):isOnline(aVal)?-1:isOnline(bVal)?1:a.name.localeCompare(b.name);}if(sortBy==='roleName'){var sortOrder=Object(__WEBPACK_IMPORTED_MODULE_2__roleUtils__["h" /* roleOrder */])(aVal)-Object(__WEBPACK_IMPORTED_MODULE_2__roleUtils__["h" /* roleOrder */])(bVal);return sortOrder===0?a.name.localeCompare(b.name):sortOrder;}if(typeof aVal==='boolean'){return aVal===bVal?a.name.localeCompare(b.name):aVal?-1:1;}if(!aVal&&!bVal){return a.name.localeCompare(b.name);}else if(!aVal){return 1;}else if(!bVal){return-1;}return aVal.localeCompare(bVal);});return sortDirection===__WEBPACK_IMPORTED_MODULE_1_react_virtualized__["g" /* SortDirection */].ASC?sorted:sorted.reverse();}function isAdminUser(user){return user.name===__WEBPACK_IMPORTED_MODULE_4_util_constants__["e" /* ADMIN_USER_NAME */];}function doesUserMatchUserName(user,userName){return userName&&userName.toLowerCase()===user.name.toLowerCase();}function renderUserType(rowData,rowIndex,selectionState){var selectionContribution=Object(__WEBPACK_IMPORTED_MODULE_3_util_tableUtils__["f" /* isItemAtIndexSelected */])(rowIndex,selectionState)?'-selected':'';if(rowData.fromLDAP){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-refresh pseudo-table-icon'+selectionContribution,'data-test-name':'user-type-ldap'});// We can enable support for token icons but we'll
// need to support sorting them with the users and LDAP users.
// } else if (rowData.isToken) {
//   return <i className="fa fa-cogs pseudo-table-icon" />;
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user fa-lg pseudo-table-icon'+selectionContribution,'data-test-name':'user-type-portfolio'});}function findUserIndex(uuid,sortedUsers){var selectedIndex=void 0;if(uuid){selectedIndex=sortedUsers.findIndex(function(u){return u.uuid===uuid;});}return selectedIndex;}

/***/ }),
/* 154 */
/***/ (function(module, exports) {



/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NodeState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Node; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlattenedNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var NodeState = {
  expanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  deletable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  favorite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var BasicNode = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]).isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(NodeState)
};

var Node = _extends({}, BasicNode);

Node.children = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(Node));

var FlattenedNode = _extends({}, BasicNode, {
  deepness: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  parents: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]))
});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(412),
    isLength = __webpack_require__(233);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1030),
    listCacheDelete = __webpack_require__(1031),
    listCacheGet = __webpack_require__(1032),
    listCacheHas = __webpack_require__(1033),
    listCacheSet = __webpack_require__(1034);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(239);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1052);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1067),
    Map = __webpack_require__(240),
    Promise = __webpack_require__(1068),
    Set = __webpack_require__(1069),
    WeakMap = __webpack_require__(1070),
    baseGetTag = __webpack_require__(70),
    toSource = __webpack_require__(415);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(244);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(427),
    baseAssignValue = __webpack_require__(428);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(1208);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1230);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(464);
var createDesc = __webpack_require__(469);
module.exports = __webpack_require__(167) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(255)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KNOWN_LOCALES */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeLocale;
/* harmony export (immutable) */ __webpack_exports__["a"] = addLocales;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_de__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_it__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_ja__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_ja__);
var KNOWN_LOCALES=['en','en_GB','fr','de','it','es','ja'];function normalizeLocale(locale){if(KNOWN_LOCALES.includes(locale)){return locale;}if(locale&&locale.length>2){var firstTwo=locale.substring(0,2);if(KNOWN_LOCALES.includes(firstTwo)){return firstTwo;}}return'en';}function addLocales(){var cb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default.a);Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es___default.a);Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr___default.a);Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_de___default.a);Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_it___default.a);Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_ja___default.a);if(!window.Intl){__webpack_require__.e/* require.ensure */(0).then((function(require){__webpack_require__(446);__webpack_require__(447);__webpack_require__(448);__webpack_require__(449);__webpack_require__(450);__webpack_require__(451);__webpack_require__(452);cb();}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);}else{cb();}}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = saveToLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getFromLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = initLocalStorage;
/* unused harmony export saveState */
/* unused harmony export loadState */
function saveToLocalStorage(STORAGE_KEY,data){return Promise.resolve(window.localStorage[STORAGE_KEY]=JSON.stringify(data));}function getFromLocalStorage(STORAGE_KEY){return window.localStorage[STORAGE_KEY]&&JSON.parse(window.localStorage[STORAGE_KEY]);}function initLocalStorage(STORAGE_KEY){if(!window.localStorage[STORAGE_KEY]){window.localStorage[STORAGE_KEY]='{}';}return window.localStorage.getItem(STORAGE_KEY);}// These two seem to be only used by the client for testing.
function saveState(STORAGE_KEY,data){return Promise.resolve(window.localStorage.setItem(STORAGE_KEY,JSON.stringify(data)));}function loadState(STORAGE_KEY){var state=window.localStorage.getItem(STORAGE_KEY);return Promise.resolve(state?JSON.parse(state):{});// not necessary now but able to resolve as promise
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_addLocales__ = __webpack_require__(168);
var SET_LOCALE='client/intl/SET_LOCALE';var SET_MESSAGES='client/intl/SET_MESSAGES';var initialState={locale:Object(__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_addLocales__["b" /* normalizeLocale */])(navigator.language),messages:{}};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SET_LOCALE:return Object.assign({},state,{locale:action.payload});case SET_MESSAGES:return Object.assign({},state,{messages:action.payload});default:return state;}}function setLocale(locale){return{type:SET_LOCALE,payload:locale};}function setMessages(messages){return{type:SET_MESSAGES,payload:messages};}var actions={setLocale:setLocale,setMessages:setMessages};/* harmony default export */ __webpack_exports__["b"] = (reducer);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_intlReducer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_commands_persistCommands__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(516);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var setLocaleAction=__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_intlReducer__["a" /* actions */].setLocale,setMessagesAction=__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_state_reducers_intlReducer__["a" /* actions */].setMessages;function setLocale(locale){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_commands_persistCommands__["c" /* persist */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_3_util_constants__["_14" /* USER_DATA */].LOCALE,locale)));case 2:dispatch(setLocaleAction(locale));case 3:case'end':return _context.stop();}}},_callee,this);}));function setLocale(_x,_x2){return _ref.apply(this,arguments);}return setLocale;}();}function setMessages(locale){var localizedMessages=__WEBPACK_IMPORTED_MODULE_4_translations__[locale]||__WEBPACK_IMPORTED_MODULE_4_translations__["en"];return setMessagesAction(localizedMessages);}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(177);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(572);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(610);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(41);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(40);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(619);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(62);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(311);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(94);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(697);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = showBackupRestoreProgress;
/* harmony export (immutable) */ __webpack_exports__["b"] = hideBackupRestoreProgress;
/* harmony export (immutable) */ __webpack_exports__["d"] = isBackupRestoreBusy;
/* harmony export (immutable) */ __webpack_exports__["h"] = isRestoring;
/* harmony export (immutable) */ __webpack_exports__["g"] = isBackupRestoreSuccessful;
/* harmony export (immutable) */ __webpack_exports__["f"] = isBackupRestoreFailed;
/* harmony export (immutable) */ __webpack_exports__["e"] = isBackupRestoreCancelled;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBackupOperation;
/* harmony export (immutable) */ __webpack_exports__["a"] = bytesToString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__ = __webpack_require__(36);
function showBackupRestoreProgress(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["c" /* getActivePanelId */])(getState())!==__WEBPACK_IMPORTED_MODULE_2_util_constants__["h" /* BACKUP_RESTORE_PROGRESS_PANEL_ID */]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_state_commands_dialogPanelCommands__["b" /* showDialogPanel */])(__WEBPACK_IMPORTED_MODULE_2_util_constants__["h" /* BACKUP_RESTORE_PROGRESS_PANEL_ID */]));}}function hideBackupRestoreProgress(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["c" /* getActivePanelId */])(getState())===__WEBPACK_IMPORTED_MODULE_2_util_constants__["h" /* BACKUP_RESTORE_PROGRESS_PANEL_ID */]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */])());}}function isBackupRestoreBusy(backupRestoreStatus){var backupRestoreState=backupRestoreStatus&&backupRestoreStatus.currentOperationState;return[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_PREFLIGHT,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_SHUTTING_DOWN_SERVER,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_BACKING_UP_DATA,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_RESTARTING_SERVER,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_SHUTTING_DOWN_SERVER,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTORE_DATA,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTARTING_SERVER].includes(backupRestoreState);}function isRestoring(backupRestoreStatus){var backupRestoreState=backupRestoreStatus&&backupRestoreStatus.currentOperationState;return[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_SHUTTING_DOWN_SERVER,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTORE_DATA,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTARTING_SERVER].includes(backupRestoreState);}function isBackupRestoreSuccessful(backupRestoreStatus){var backupRestoreState=backupRestoreStatus&&backupRestoreStatus.currentOperationState;return[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_COMPLETE,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_COMPLETE].includes(backupRestoreState);}function isBackupRestoreFailed(backupRestoreStatus){var backupRestoreState=backupRestoreStatus&&backupRestoreStatus.currentOperationState;return[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_FAILED,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_FAILED].includes(backupRestoreState);}function isBackupRestoreCancelled(backupRestoreStatus){var backupRestoreState=backupRestoreStatus&&backupRestoreStatus.currentOperationState;return backupRestoreState===__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_CANCELLED;}function isBackupOperation(backupRestoreStatus){var backupRestoreState=backupRestoreStatus&&backupRestoreStatus.currentOperationState;return[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_PREFLIGHT,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_SHUTTING_DOWN_SERVER,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_BACKING_UP_DATA,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_RESTARTING_SERVER,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_COMPLETE,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_FAILED,__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_CANCELLED].includes(backupRestoreState);}function bytesToString(){var bytes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var levels=['bytes','KB','MB','GB','TB','PB','EB','ZB','YB'];var index=Math.floor(Math.log(bytes)/Math.log(1024));return(bytes/Math.pow(1024,index)).toFixed(2)+' '+levels[index];}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PortfolioError=function(_Error){_inherits(PortfolioError,_Error);function PortfolioError(message,faultCode,context){_classCallCheck(this,PortfolioError);var _this=_possibleConstructorReturn(this,(PortfolioError.__proto__||Object.getPrototypeOf(PortfolioError)).call(this,message));_this.faultCode=faultCode;_this.context=context;return _this;}return PortfolioError;}(Error);/* harmony default export */ __webpack_exports__["a"] = (PortfolioError);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(2);
var localizedStrings=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({OK:{id:'General.OK',defaultMessage:'OK'},Cancel:{id:'General.Cancel',defaultMessage:'Cancel'},Save:{id:'General.Save',defaultMessage:'Save'}});/* harmony default export */ __webpack_exports__["a"] = (localizedStrings);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogPanel__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MODAL_STRING_PROMPT_FORM_NAME='modalStringPromptForm';var bool=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,func=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,number=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,string=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string;var ModalStringPrompt=function(_Component){_inherits(ModalStringPrompt,_Component);function ModalStringPrompt(){_classCallCheck(this,ModalStringPrompt);var _this=_possibleConstructorReturn(this,(ModalStringPrompt.__proto__||Object.getPrototypeOf(ModalStringPrompt)).call(this));_this.handleClose=_this.handleClose.bind(_this);_this.handleSave=_this.handleSave.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.panelId='modal-string-prompt';return _this;}_createClass(ModalStringPrompt,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.initialValue!==nextProps.initialValue){this.props.change('stringInput',nextProps.initialValue);}}},{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'handleSave',value:function handleSave(values){this.props.onSave(values.stringInput);this.handleClose();}},{key:'handleClose',value:function handleClose(){this.props.reset();}},{key:'render',value:function render(){var _props=this.props,customButtonText=_props.customButtonText,isOpen=_props.isOpen,handleSubmit=_props.handleSubmit,label=_props.label,maxLength=_props.maxLength,onClose=_props.onClose,panelTitle=_props.panelTitle,validate=_props.validate;return isOpen&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DialogPanel__["a" /* default */],{activePanelId:this.panelId,contentStyle:{width:400,height:250},customButtonText:customButtonText,dialogFocusId:'stringInput',hideDialogPanel:onClose,isOkEnabled:this.isOkEnabled,onClose:this.handleClose,onSave:handleSubmit(this.handleSave),panelId:this.panelId,panelTitle:panelTitle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-test-name':this.props.dataTestName?this.props.dataTestName:'modal-string-prompt',style:{display:'flex',alignItems:'center',margin:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'stringInput',style:{paddingRight:10}},label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'input',name:'stringInput',id:'stringInput',component:'input',maxLength:maxLength,validate:validate,'data-test-name':'modal-string-prompt-input'})));}}]);return ModalStringPrompt;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ModalStringPrompt.propTypes=Object.assign({},__WEBPACK_IMPORTED_MODULE_2_redux_form__["i" /* propTypes */],{customButtonText:string,initialValue:string,isOpen:bool,label:string.isRequired,maxLength:number,panelTitle:string,onClose:func.isRequired,onSave:func.isRequired,validate:func.isRequired,dataTestName:string});ModalStringPrompt.defaultProps={initialValue:''};var stringPromptForm=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({form:MODAL_STRING_PROMPT_FORM_NAME})(ModalStringPrompt);/* harmony default export */ __webpack_exports__["a"] = (stringPromptForm);

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(199)('keys');
var uid = __webpack_require__(138);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(21);
var global = __webpack_require__(29);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(101) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(48);
var core = __webpack_require__(21);
var fails = __webpack_require__(83);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
var document = __webpack_require__(29).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(58);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(49);
var dPs = __webpack_require__(785);
var enumBugKeys = __webpack_require__(205);
var IE_PROTO = __webpack_require__(198)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(201)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(342).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(30);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(21);
var LIBRARY = __webpack_require__(101);
var wksExt = __webpack_require__(206);
var defineProperty = __webpack_require__(57).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(144);
var createDesc = __webpack_require__(140);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(202);
var has = __webpack_require__(65);
var IE8_DOM_DEFINE = __webpack_require__(334);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(11);









/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);




/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(813), __esModule: true };

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(104);
var TAG = __webpack_require__(30)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(139);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* unused harmony export bpfrpt_proptype_CellMeasurerCache */
/* unused harmony export bpfrpt_proptype_Positioner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PositionCache__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var emptyObject = {};

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Masonry.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isScrolling: false,
      scrollTop: 0
    }, _this._invalidateOnUpdateStartIndex = null, _this._invalidateOnUpdateStopIndex = null, _this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */](), _this._startIndex = null, _this._startIndexMemoized = null, _this._stopIndex = null, _this._stopIndexMemoized = null, _this._debounceResetIsScrollingCallback = function () {
      _this.setState({
        isScrolling: false
      });
    }, _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    }, _this._onScroll = function (event) {
      var height = _this.props.height;


      var eventScrollTop = event.target.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Masonry, [{
    key: 'clearCellPositions',
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var index = _ref2.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: 'recomputeCellPositions',
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;

      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoHeight = _props.autoHeight,
          cellCount = _props.cellCount,
          cellMeasurerCache = _props.cellMeasurerCache,
          cellRenderer = _props.cellRenderer,
          className = _props.className,
          height = _props.height,
          id = _props.id,
          keyMapper = _props.keyMapper,
          overscanByPixels = _props.overscanByPixels,
          role = _props.role,
          style = _props.style,
          tabIndex = _props.tabIndex,
          width = _props.width,
          rowDirection = _props.rowDirection;
      var _state = this.state,
          isScrolling = _state.isScrolling,
          scrollTop = _state.scrollTop;


      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;

      var startIndex = 0;
      var stopIndex = void 0;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'position', 'absolute'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'top', top), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'width', cellMeasurerCache.getWidth(index)), _style)
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;

          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Masonry', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            boxSizing: 'border-box',
            direction: 'ltr',
            height: autoHeight ? 'auto' : height,
            overflowX: 'hidden',
            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
            position: 'relative',
            width: width,
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform'
          }, style),
          tabIndex: tabIndex },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Masonry__innerScrollContainer',
            style: {
              width: '100%',
              height: estimateTotalHeight,
              maxWidth: '100%',
              maxHeight: estimateTotalHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            } },
          children
        )
      );
    }
  }, {
    key: '_checkInvalidateOnUpdate',
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var _startIndex = this._invalidateOnUpdateStartIndex;
        var _stopIndex = this._invalidateOnUpdateStopIndex;

        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(_startIndex, _stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: '_debounceResetIsScrolling',
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedTotalHeight',
    value: function _getEstimatedTotalHeight() {
      var _props2 = this.props,
          cellCount = _props2.cellCount,
          cellMeasurerCache = _props2.cellMeasurerCache,
          width = _props2.width;


      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));

      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: '_invokeOnScrollCallback',
    value: function _invokeOnScrollCallback() {
      var _props3 = this.props,
          height = _props3.height,
          onScroll = _props3.onScroll;
      var scrollTop = this.state.scrollTop;


      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });

        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: '_invokeOnCellsRenderedCallback',
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var _onCellsRendered = this.props.onCellsRendered;


        _onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });

        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: '_populatePositionCache',
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _props4 = this.props,
          cellMeasurerCache = _props4.cellMeasurerCache,
          cellPositioner = _props4.cellPositioner;


      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            _left = _cellPositioner.left,
            _top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Masonry.defaultProps = {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
};
Masonry.propTypes =  true ? null : {
  autoHeight: PropTypes.bool.isRequired,
  cellCount: PropTypes.number.isRequired,
  cellMeasurerCache: function cellMeasurerCache() {
    return (typeof CellMeasurerCache === 'function' ? PropTypes.instanceOf(CellMeasurerCache).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellPositioner: function cellPositioner() {
    return (typeof Positioner === 'function' ? PropTypes.instanceOf(Positioner).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellRenderer: function cellRenderer() {
    return (typeof CellRenderer === 'function' ? PropTypes.instanceOf(CellRenderer).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  id: PropTypes.string,
  keyMapper: function keyMapper() {
    return (typeof KeyMapper === 'function' ? PropTypes.instanceOf(KeyMapper).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  onCellsRendered: function onCellsRendered() {
    return (typeof OnCellsRenderedCallback === 'function' ? PropTypes.instanceOf(OnCellsRenderedCallback) : PropTypes.any).apply(this, arguments);
  },
  onScroll: function onScroll() {
    return (typeof OnScrollCallback === 'function' ? PropTypes.instanceOf(OnScrollCallback) : PropTypes.any).apply(this, arguments);
  },
  overscanByPixels: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
  scrollingResetTimeInterval: PropTypes.number.isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  tabIndex: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  rowDirection: PropTypes.string.isRequired
};


function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
  defaultHeight: PropTypes.number.isRequired,
  defaultWidth: PropTypes.number.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(Masonry);

/* harmony default export */ __webpack_exports__["a"] = (Masonry);

var bpfrpt_proptype_Positioner =  true ? null : PropTypes.func;





/***/ }),
/* 217 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(892);
var enumBugKeys = __webpack_require__(380);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(376);
var defined = __webpack_require__(377);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(384)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(921)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getUsers;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = createUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteUsers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_routeUtils__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_reducers_catalogReducer__ = __webpack_require__(63);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var addOrUpdateUserCatalogInfoAction=__WEBPACK_IMPORTED_MODULE_6_state_reducers_catalogReducer__["a" /* actions */].addOrUpdateUserCatalogInfo,getCatalogsAction=__WEBPACK_IMPORTED_MODULE_6_state_reducers_catalogReducer__["a" /* actions */].getCatalogs;function getUsers(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context.next=4;break;}_context.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["d" /* getUsers */])(session));case 4:case'end':return _context.stop();}}},_callee,this);}));function getUsers(_x,_x2){return _ref.apply(this,arguments);}return getUsers;}();}function updateUser(user,successMessage){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var session,_ref3,_ref3$payload,updatedUser;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context2.next=11;break;}_context2.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["e" /* updateUser */])(session,user));case 4:_ref3=_context2.sent;_ref3$payload=_slicedToArray(_ref3.payload,1);updatedUser=_ref3$payload[0];_context2.next=9;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["d" /* getUsers */])(session));case 9:dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(successMessage,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));return _context2.abrupt('return',updatedUser);case 11:case'end':return _context2.stop();}}},_callee2,this);}));function updateUser(_x3,_x4){return _ref2.apply(this,arguments);}return updateUser;}();}function createUser(user){var addUserToAllCatalogs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var roleName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__WEBPACK_IMPORTED_MODULE_3_util_roleUtils__["c" /* NAME_PUBLISHER */];return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var session,users,userToSelect,catalogs,userInfos;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context3.next=17;break;}_context3.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["a" /* createUser */])(session,user));case 4:_context3.next=6;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["d" /* getUsers */])(session));case 6:users=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["_34" /* getUsers */])(getState());userToSelect=users.find(function(u){return u.name===user.name;});if(userToSelect&&userToSelect.uuid){Object(__WEBPACK_IMPORTED_MODULE_2_util_routeUtils__["a" /* goToRoute */])('users/'+userToSelect.uuid);}if(!addUserToAllCatalogs){_context3.next=17;break;}_context3.next=12;return dispatch(getCatalogsAction(session));case 12:catalogs=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["n" /* getCatalogs */])(getState());userInfos=catalogs.map(function(catalog){return{accountName:user.name,roleName:roleName,catalogName:catalog.name};});if(!(userInfos.length>0)){_context3.next=17;break;}_context3.next=17;return dispatch(addOrUpdateUserCatalogInfoAction(session,userInfos));case 17:case'end':return _context3.stop();}}},_callee3,this);}));function createUser(_x7,_x8){return _ref4.apply(this,arguments);}return createUser;}();}function deleteUsers(users){var cleanupTokens=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context4.next=6;break;}_context4.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["c" /* deleteUsers */])(session,users,cleanupTokens));case 4:_context4.next=6;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers_userReducer__["d" /* getUsers */])(session));case 6:case'end':return _context4.stop();}}},_callee4,this);}));function deleteUsers(_x10,_x11){return _ref5.apply(this,arguments);}return deleteUsers;}();}

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getCertStatus;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCertRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = createCertRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = downloadCertRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = uploadCert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_serverUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;function getCertStatus(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());if(!session){_context.next=4;break;}_context.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["d" /* getCertStatus */])(session));case 4:case'end':return _context.stop();}}},_callee,this);}));function getCertStatus(_x,_x2){return _ref.apply(this,arguments);}return getCertStatus;}();}function deleteCertRequest(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var session,existingCertRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());existingCertRequest=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["p" /* getCertRequestData */])(getState());if(session&&existingCertRequest){dispatch(showModalPrompt({isButton2Default:true,message:__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_DELETE_CONFIRMATION,dataTestName:'delete-cert-request-confirmation',onButton2:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["c" /* deleteCertRequest */])(session));case 2:_context2.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["d" /* getCertStatus */])(session));case 4:case'end':return _context2.stop();}}},_callee2,this);}));function dodelete(){return _ref3.apply(this,arguments);}return dodelete;}()}));}case 3:case'end':return _context3.stop();}}},_callee3,this);}));function deleteCertRequest(_x3,_x4){return _ref2.apply(this,arguments);}return deleteCertRequest;}();}function createCertRequest(certRequest){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var session,existingCertRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());if(!session){_context5.next=11;break;}existingCertRequest=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["p" /* getCertRequestData */])(getState());if(!existingCertRequest){_context5.next=7;break;}dispatch(showModalPrompt({isButton2Default:true,message:__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_REQUEST_ALREADY_CREATED_WARNING,dataTestName:'replace-cert-request-confirmation',onButton2:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["a" /* createCertRequest */])(session,certRequest));case 2:_context4.next=4;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["d" /* getCertStatus */])(session));case 4:case'end':return _context4.stop();}}},_callee4,this);}));function doReplace(){return _ref5.apply(this,arguments);}return doReplace;}()}));_context5.next=11;break;case 7:_context5.next=9;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["a" /* createCertRequest */])(session,certRequest));case 9:_context5.next=11;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["d" /* getCertStatus */])(session));case 11:case'end':return _context5.stop();}}},_callee5,this);}));function createCertRequest(_x5,_x6){return _ref4.apply(this,arguments);}return createCertRequest;}();}function downloadCertRequest(){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch,getState){var session,ports,serverAddress,base,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());if(session){ports=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["_13" /* getPorts */])(getState());serverAddress=Object(__WEBPACK_IMPORTED_MODULE_4_util_serverUtils__["c" /* getAdminAddress */])(ports);base=__WEBPACK_IMPORTED_MODULE_5_util_constants__["f" /* API */]+'/certificate/request?session='+session;url=''+serverAddress+base;window.location=url;}case 2:case'end':return _context6.stop();}}},_callee6,this);}));function getCertRequest(_x7,_x8){return _ref6.apply(this,arguments);}return getCertRequest;}();}function uploadCert(certUpload){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch,getState){var session,formData,error,msgId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());if(!session){_context7.next=12;break;}formData={};if(certUpload.mainCertFile){formData.certificate=certUpload.mainCertFile;}if(certUpload.intermediateCertFile1){formData.intermediate1=certUpload.intermediateCertFile1;}if(certUpload.intermediateCertFile2){formData.intermediate2=certUpload.intermediateCertFile2;}if(certUpload.rootCertFile){formData.rootCertificate=certUpload.rootCertFile;}if(certUpload.password){formData.certificatePassword=certUpload.password;}error=void 0;_context7.next=11;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_state_reducers_certReducer__["e" /* uploadCert */])(session,formData)).catch(function(e){error=e;});case 11:if(error){msgId=void 0;if(error.faultCode==='InvalidParameters'){msgId=__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_IMPORT_FAILED_READING_PKCS12;}else if(error.faultCode==='UnexpectedError'){if(error.message==='import intermediate 1'){msgId=__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_IMPORT_FAILED_INTERMEDIATE1;}else if(error.message==='import intermediate 2'){msgId=__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_IMPORT_FAILED_INTERMEDIATE2;}else if(error.message==='import root'){msgId=__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_IMPORT_FAILED_ROOT;}}dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(msgId,__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CERT_IMPORT_SUCCEEDED,__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}case 12:case'end':return _context7.stop();}}},_callee7,this);}));function uploadCert(_x9,_x10){return _ref7.apply(this,arguments);}return uploadCert;}();}

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = queryDirectoryService;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOrUpdateMappingEntries;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeMappingEntry;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMappings;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveMapping;
/* harmony export (immutable) */ __webpack_exports__["f"] = syncMappings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__ = __webpack_require__(88);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var addMappingsAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].addMappings,getDirectoryServiceMappingsAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].getDirectoryServiceMappings,queryDirectoryServiceAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].queryDirectoryService,setMappingAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].setMapping,setQueryPendingAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].setQueryPending,syncMappingsAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].syncMappings,updateMappingAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_dirSvcReducer__["a" /* actions */].updateMapping;function getQuery(selectedNode,queryType,operator,searchText){if(selectedNode){return'memberOf='+selectedNode.dn;}else{var query=__WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__["a" /* AD_MAPPING_QUERIES */][queryType].query;searchText=searchText||'';searchText=operator===__WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].EQUALS?searchText:searchText.trim();if(queryType===__WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__["e" /* QUERY_TYPE_NAME */]){switch(operator){case __WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].CONTAINS:query=query+(searchText?'*'+searchText+'*':'');break;case __WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].STARTS_WITH:query=query+(searchText?searchText+'*':'');break;default:case __WEBPACK_IMPORTED_MODULE_4_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].EQUALS:query=query+searchText;break;}}return query;}}function queryDirectoryService(operator,searchText){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var session,dirSvcDescription,queryType,selectedNode,dirSvcUuid,defaultSearchBase,query,searchScope;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());dirSvcDescription=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["v" /* getDirectoryServiceDescription */])(getState());queryType=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["z" /* getDirectoryServiceQueryType */])(getState());selectedNode=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["_17" /* getSelectedDirectoryServiceNode */])(getState());if(!(session&&dirSvcDescription)){_context.next=18;break;}dirSvcUuid=dirSvcDescription.uuid;defaultSearchBase=dirSvcDescription.defaultSearchBase;query=getQuery(selectedNode,queryType,operator,searchText);searchScope='2';// TODO: this will change when we browse inside groups
_context.next=11;return dispatch(setQueryPendingAction(true));case 11:_context.prev=11;_context.next=14;return dispatch(queryDirectoryServiceAction(session,dirSvcUuid,defaultSearchBase,searchScope,query));case 14:_context.prev=14;_context.next=17;return dispatch(setQueryPendingAction(false));case 17:return _context.finish(14);case 18:case'end':return _context.stop();}}},_callee,this,[[11,,14,18]]);}));function queryDirectoryService(_x,_x2){return _ref.apply(this,arguments);}return queryDirectoryService;}();}function addOrUpdateMappingEntries(entries){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var defaultRole,defaultRoleUuid,dirSvcDescription,dirSvcUuid,destination,mapping,newEntries;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:defaultRole=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["t" /* getDefaultRole */])(getState());defaultRoleUuid=defaultRole?defaultRole.uuid:'';dirSvcDescription=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["v" /* getDirectoryServiceDescription */])(getState());dirSvcUuid=dirSvcDescription&&dirSvcDescription.uuid||'';destination=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["w" /* getDirectoryServiceDestination */])(getState());mapping=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["a" /* getActiveDirectoryServiceMapping */])(getState())||{identityServiceUuid:dirSvcUuid,targetGroupGuid:destination,uuid:'',entries:[]};// Process the existing entries and update roles
newEntries=mapping.entries.reduce(function(acc,existing){var newEntry=entries.find(function(old){return old.sourceDN===existing.sourceDN;});if(newEntry&&newEntry.roleOverrideGuid){acc.push(newEntry);}else{acc.push(existing);}return acc;},[]);// Process the new entries and add them if they don't already exist.
entries.forEach(function(newEntry){var existing=newEntries.find(function(e){return e.sourceDN===newEntry.sourceDN;});if(!existing){if(!newEntry.roleOverrideGuid){newEntry.roleOverrideGuid=defaultRoleUuid;}newEntries.push(newEntry);// TODO - order?
}});// add or update the mapping
dispatch(setMappingAction(Object.assign({},mapping,{entries:newEntries})));case 9:case'end':return _context2.stop();}}},_callee2,this);}));function addOrUpdateMappingEntries(_x3,_x4){return _ref2.apply(this,arguments);}return addOrUpdateMappingEntries;}();}function removeMappingEntry(entry){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var mapping,newEntries;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:mapping=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["a" /* getActiveDirectoryServiceMapping */])(getState());if(mapping){// Remove the existing mapping
newEntries=mapping.entries.filter(function(oldEntry){return oldEntry.sourceDN!==entry.sourceDN;});dispatch(setMappingAction(Object.assign({},mapping,{entries:newEntries})));}case 2:case'end':return _context3.stop();}}},_callee3,this);}));function removeMappingEntry(_x5,_x6){return _ref3.apply(this,arguments);}return removeMappingEntry;}();}function getMappings(){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var session,dirSvcDescription,dirSvcUuid;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());dirSvcDescription=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["v" /* getDirectoryServiceDescription */])(getState());if(!(session&&dirSvcDescription)){_context4.next=6;break;}dirSvcUuid=dirSvcDescription.uuid;_context4.next=6;return dispatch(getDirectoryServiceMappingsAction(session,dirSvcUuid));case 6:case'end':return _context4.stop();}}},_callee4,this);}));function getMappings(_x7,_x8){return _ref4.apply(this,arguments);}return getMappings;}();}function saveMapping(successMessage,hasDeletes){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var session,dirSvcDescription,dirSvcDescriptionUuid,mapping,isDirty;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());dirSvcDescription=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["v" /* getDirectoryServiceDescription */])(getState());dirSvcDescriptionUuid=dirSvcDescription&&dirSvcDescription.uuid||'';mapping=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["a" /* getActiveDirectoryServiceMapping */])(getState());isDirty=hasDeletes||mapping&&mapping.entries.find(function(e){return e.unsaved;});if(!(session&&dirSvcDescription&&dirSvcDescription.uuid&&mapping&&isDirty)){_context5.next=19;break;}if(!mapping.uuid){_context5.next=11;break;}_context5.next=9;return dispatch(updateMappingAction(session,dirSvcDescription.uuid,mapping));case 9:_context5.next=14;break;case 11:mapping.identityServiceUuid=dirSvcDescriptionUuid;_context5.next=14;return dispatch(addMappingsAction(session,dirSvcDescription.uuid,[mapping]));case 14:_context5.next=16;return dispatch(syncMappingsAction(session,dirSvcDescription.uuid));case 16:dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(successMessage,__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));_context5.next=19;return dispatch(getDirectoryServiceMappingsAction(session,dirSvcDescription.uuid));case 19:case'end':return _context5.stop();}}},_callee5,this);}));function saveMapping(_x9,_x10){return _ref5.apply(this,arguments);}return saveMapping;}();}function syncMappings(successMessage){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch,getState){var session,dirSvcDescription;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());dirSvcDescription=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["v" /* getDirectoryServiceDescription */])(getState());if(!(session&&dirSvcDescription)){_context6.next=6;break;}_context6.next=5;return dispatch(syncMappingsAction(session,dirSvcDescription.uuid));case 5:dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(successMessage,__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));case 6:case'end':return _context6.stop();}}},_callee6,this);}));function syncMappings(_x11,_x12){return _ref6.apply(this,arguments);}return syncMappings;}();}

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_TYPE; });
var UPDATE_TYPE = {
  ADD: 0,
  DELETE: 1,
  UPDATE: 2
};

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export wrapKeyDownEvent */
/* unused harmony export KEY_CODES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitEvent; });
var _wrapKeyDownEvent;

var wrapKeyDownEvent = function wrapKeyDownEvent(availablekeys) {
  return function (handler) {
    return function (_ref) {
      for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      var keyCode = _ref.keyCode;

      if (keyCode in availablekeys) {
        handler.apply(undefined, params);
      }
    };
  };
};

var KEY_CODES = {
  Backspace: 8,
  Tab: 9,
  Enter: 13,
  Shift: 16,
  Ctrl: 17,
  Alt: 18,
  PauseBreak: 19,
  CapsLock: 20,
  Escape: 27,
  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,
  LeftArrow: 37,
  UpArrow: 38,
  RightArrow: 39,
  DownArrow: 40,
  Insert: 45,
  Delete: 46,
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  LeftWindowKey: 91,
  RightWindowKey: 92,
  SelectKey: 93,
  NumPad0: 96,
  NumPad1: 97,
  NumPad2: 98,
  NumPad3: 99,
  NumPad4: 100,
  NumPad5: 101,
  NumPad6: 102,
  NumPad7: 103,
  NumPad8: 104,
  NumPad9: 105,
  Multiply: 106,
  Add: 107,
  Subtract: 109,
  DecimalPoint: 110,
  Divide: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F12: 123,
  NumLock: 144,
  ScrollLock: 145,
  SemiColon: 186,
  EqualSign: 187,
  Comma: 188,
  Dash: 189,
  Period: 190,
  ForwardSlash: 191,
  GraveAccent: 192,
  OpenBracket: 219,
  BackSlash: 220,
  CloseBracket: 221,
  SingleQuote: 222
};

var submitEvent = wrapKeyDownEvent((_wrapKeyDownEvent = {}, _wrapKeyDownEvent[KEY_CODES.Enter] = null, _wrapKeyDownEvent));

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Renderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodeShapes__ = __webpack_require__(155);




var Renderer = {
  measure: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_1__nodeShapes__["a" /* FlattenedNode */])
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(406),
    castFunction = __webpack_require__(1024);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(52),
    stubFalse = __webpack_require__(1020);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 233 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(405);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 236 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(411);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(157),
    stackClear = __webpack_require__(1035),
    stackDelete = __webpack_require__(1036),
    stackGet = __webpack_require__(1037),
    stackHas = __webpack_require__(1038),
    stackSet = __webpack_require__(1039);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1044),
    mapCacheDelete = __webpack_require__(1051),
    mapCacheGet = __webpack_require__(1053),
    mapCacheHas = __webpack_require__(1054),
    mapCacheSet = __webpack_require__(1055);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1066),
    stubArray = __webpack_require__(422);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(44),
    isSymbol = __webpack_require__(244);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(407),
    baseKeysIn = __webpack_require__(1095),
    isArrayLike = __webpack_require__(156);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(418);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Checkboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_checkboard__ = __webpack_require__(1120);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + __WEBPACK_IMPORTED_MODULE_2__helpers_checkboard__["a" /* get */](white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(children) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

/* harmony default export */ __webpack_exports__["a"] = (Checkboard);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1189);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

var CONSTANTS={// Positions
positions:{tl:'tl',tr:'tr',tc:'tc',bl:'bl',br:'br',bc:'bc'},// Levels
levels:{success:'success',error:'error',warning:'warning',info:'info'},// Notification defaults
notification:{title:null,message:null,level:null,position:'tr',autoDismiss:5,dismissible:true,action:null},iconSize:25};module.exports=CONSTANTS;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(438);

var $Error = __webpack_require__(1210);
var $EvalError = __webpack_require__(1211);
var $RangeError = __webpack_require__(1212);
var $ReferenceError = __webpack_require__(1213);
var $SyntaxError = __webpack_require__(1214);
var $TypeError = __webpack_require__(90);
var $URIError = __webpack_require__(1215);

var abs = __webpack_require__(1216);
var floor = __webpack_require__(1217);
var max = __webpack_require__(1218);
var min = __webpack_require__(1219);
var pow = __webpack_require__(1220);
var round = __webpack_require__(1221);
var sign = __webpack_require__(1222);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(439);
var $defineProperty = __webpack_require__(1225);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1226)();

var getProto = __webpack_require__(1228);
var $ObjectGPO = __webpack_require__(441);
var $ReflectGPO = __webpack_require__(440);

var $apply = __webpack_require__(443);
var $call = __webpack_require__(251);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(165);
var hasOwn = __webpack_require__(1233);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(456);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var core = __webpack_require__(92);
var hide = __webpack_require__(166);
var redefine = __webpack_require__(470);
var ctx = __webpack_require__(257);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(472);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(259);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(262);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(478)('wks');
var uid = __webpack_require__(256);
var Symbol = __webpack_require__(91).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(263)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(166)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(490)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(497);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
var PERSIST='client/persist/PERSIST';function persist(fn){return{resource:'PERSISTENCE_RESOURCE',type:PERSIST,payload:fn};}var actions={persist:persist};/* harmony default export */ __webpack_exports__["b"] = ({actions:actions});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reachoutReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
var SET_DISMISSED_MESSAGE_IDS='shared/SET_DISMISSED_MESSAGE_IDS';var initialState={dismissedMessageIds:[]};function reachoutReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SET_DISMISSED_MESSAGE_IDS:return Object.assign({},state,{dismissedMessageIds:action.payload||[]});default:return state;}}function setDismissedMessageIds(Ids){return{type:SET_DISMISSED_MESSAGE_IDS,payload:Ids};}var actions={setDismissedMessageIds:setDismissedMessageIds};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chooseReachoutMessageToDisplay;
/* harmony export (immutable) */ __webpack_exports__["b"] = persistNewDismissedReachoutMessageId;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function chooseReachoutMessageToDisplay(reachoutMessages,dismissedMessageIds){if(!reachoutMessages){return null;}if(!dismissedMessageIds){return reachoutMessages[0];}return reachoutMessages.find(function(m){return!dismissedMessageIds.includes(m.id);});}/**
 * Append the new id to the current array of ids, filter the array to include only ids
 * corresponding to current messages, and save (persist and update store).
 */function persistNewDismissedReachoutMessageId(id,currentDismissedIds,reachoutMessages,saveIds){var dismissedIds=[].concat(_toConsumableArray(currentDismissedIds),[id]);// Clean up the dismissed ids by removing all ids that don't correspond to an existing message.
var currentIds=reachoutMessages.reduce(function(acc,m){acc.push(m.id);return acc;},[]);dismissedIds=dismissedIds.filter(function(h){return currentIds.includes(h);});saveIds(dismissedIds);};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_PROPERTIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_PROPERTIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BACKUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BACKUP_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BACKUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CANCEL_BACKUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CANCEL_BACKUP_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CANCEL_BACKUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLEAR_EMAIL_SERVER_CONFIG_VALIDATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLEAR_MEDIA_ENGINE_TEST_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CREATE_DIR_SVC_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATE_DIR_SVC_DESC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_DIR_SVC_DESC_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_MEDIA_ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CREATE_MEDIA_ENGINE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CREATE_MEDIA_ENGINE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DELETE_DIR_SVC_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DELETE_DIR_SVC_DESC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DELETE_DIR_SVC_DESC_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DELETE_MEDIA_ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DELETE_MEDIA_ENGINE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DELETE_MEDIA_ENGINE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_SERVER_FOLDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_SERVER_FOLDERS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_SERVER_FOLDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_SERVER_SYSTEM_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_SERVER_SYSTEM_INFORMATION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_SERVER_SYSTEM_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SET_SSO_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return SET_SSO_CREDENTIALS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return SET_SSO_CREDENTIALS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return RESTART_SERVER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return RESTART_SERVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RESTART_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return RESTORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return RESTORE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return RESTORE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SEND_DIAGNOSTIC_DATA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SEND_DIAGNOSTIC_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SEND_DIAGNOSTIC_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_BACKUP_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_BACKUP_CONFIG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_BACKUP_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_BRANDING_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SET_BRANDING_IMAGE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SET_BRANDING_IMAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SET_BRANDING_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SET_BRANDING_SETTINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SET_BRANDING_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SET_EMAIL_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_EMAIL_CONFIG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SET_EMAIL_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_EMAIL_SERVER_CONFIG_VALIDATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SET_GLOBAL_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SET_GLOBAL_SETTINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SET_GLOBAL_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_IS_COMMUNICATING_WITH_DIR_SVC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SET_IS_RESTARTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_IS_ADMIN_SERVER_RESTARTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SET_IS_SENDING_DIAGNOSTIC_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SET_LOGGING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SET_LOGGING_CONFIG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SET_LOGGING_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return SET_MOBILE_UPLOAD_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return SET_MOBILE_UPLOAD_SETTINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SET_MOBILE_UPLOAD_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SET_MEDIA_ENGINE_TEST_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SET_PORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SET_PORTS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SET_PORTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SET_SERVER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return START_SERVER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return START_SERVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return START_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return STOP_SERVER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return STOP_SERVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return STOP_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return TEST_MEDIA_ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return TEST_MEDIA_ENGINE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return TEST_MEDIA_ENGINE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return UPDATE_DIR_SVC_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return UPDATE_DIR_SVC_DESC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return UPDATE_DIR_SVC_DESC_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return UPDATE_MEDIA_ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return UPDATE_MEDIA_ENGINE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return UPDATE_MEDIA_ENGINE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return UPDATE_SERVER_FOLDER_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return UPDATE_SERVER_FOLDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return VALIDATE_EMAIL_SERVER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return VALIDATE_EMAIL_SERVER_CONFIG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS; });
/* unused harmony export MOBILE_UPLOADS_ENABLED */
/* unused harmony export MOBILE_UPLOADS_FOLDER */
/* unused harmony export MOBILE_UPLOADS_CATALOG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PORT_KEY_SERVER; });
/* unused harmony export PORT_KEY_SERVER_HTTPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PORT_KEY_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PORT_KEY_ADMIN_SSL; });
var ADMIN_PROPERTIES='admin/server/ADMIN_PROPERTIES';var ADMIN_PROPERTIES_FAIL='admin/server/ADMIN_PROPERTIES_FAIL';var ADMIN_PROPERTIES_SUCCESS='admin/server/ADMIN_PROPERTIES_SUCCESS';var CREATE_DIR_SVC_DESC='admin/server/CREATE_DIR_SVC_DESC';var CREATE_DIR_SVC_DESC_SUCCESS='admin/server/CREATE_DIR_SVC_DESC_SUCCESS';var CREATE_DIR_SVC_DESC_FAIL='admin/server/CREATE_DIR_SVC_DESC_FAIL';var DELETE_DIR_SVC_DESC='admin/server/DELETE_DIR_SVC_DESC';var DELETE_DIR_SVC_DESC_SUCCESS='admin/server/DELETE_DIR_SVC_DESC_SUCCESS';var DELETE_DIR_SVC_DESC_FAIL='admin/server/DELETE_DIR_SVC_DESC_FAIL';var RESTART_SERVER='admin/server/RESTART_SERVER';var RESTART_SERVER_FAIL='admin/server/RESTART_SERVER_FAIL';var RESTART_SERVER_SUCCESS='admin/server/RESTART_SERVER_SUCCESS';var SEND_DIAGNOSTIC_DATA='admin/server/SEND_DIAGNOSTIC_DATA';var SEND_DIAGNOSTIC_DATA_FAIL='admin/server/SEND_DIAGNOSTIC_DATA_FAIL';var SEND_DIAGNOSTIC_DATA_SUCCESS='admin/server/SEND_DIAGNOSTIC_DATA_SUCCESS';var SET_BACKUP_CONFIG='admin/server/SET_BACKUP_CONFIG';var SET_BACKUP_CONFIG_FAIL='admin/server/SET_BACKUP_CONFIG_FAIL';var SET_BACKUP_CONFIG_SUCCESS='admin/server/SET_BACKUP_CONFIG_SUCCESS';var SET_BRANDING_SETTINGS='admin/server/SET_BRANDING_SETTINGS';var SET_BRANDING_SETTINGS_FAIL='admin/server/SET_BRANDING_SETTINGS_FAIL';var SET_BRANDING_SETTINGS_SUCCESS='admin/server/SET_BRANDING_SETTINGS_SUCCESS';var BACKUP='admin/server/BACKUP';var BACKUP_FAIL='admin/server/BACKUP_FAIL';var BACKUP_SUCCESS='admin/server/BACKUP_SUCCESS';var CANCEL_BACKUP='admin/server/CANCEL_BACKUP';var CANCEL_BACKUP_FAIL='admin/server/CANCEL_BACKUP_FAIL';var CANCEL_BACKUP_SUCCESS='admin/server/CANCEL_BACKUP_SUCCESS';var RESTORE='admin/server/RESTORE';var RESTORE_FAIL='admin/server/RESTORE_FAIL';var RESTORE_SUCCESS='admin/server/RESTORE_SUCCESS';var SET_IS_COMMUNICATING_WITH_DIR_SVC='admin/server/SET_IS_COMMUNICATING_WITH_DIR_SVC';var SET_IS_RESTARTING='admin/server/SET_IS_RESTARTING';var SET_IS_ADMIN_SERVER_RESTARTING='admin/server/SET_IS_ADMIN_SERVER_RESTARTING';var SET_IS_SENDING_DIAGNOSTIC_DATA='admin/server/SET_IS_SENDING_DIAGNOSTIC_DATA';var SET_SERVER_STATUS='admin/server/SET_SERVER_STATUS';var START_SERVER='admin/server/START_SERVER';var START_SERVER_FAIL='admin/server/START_SERVER_FAIL';var START_SERVER_SUCCESS='admin/server/START_SERVER_SUCCESS';var STOP_SERVER='admin/server/STOP_SERVER';var STOP_SERVER_FAIL='admin/server/STOP_SERVER_FAIL';var STOP_SERVER_SUCCESS='admin/server/STOP_SERVER_SUCCESS';var GET_SERVER_SYSTEM_INFORMATION='admin/server/GET_SERVER_SYSTEM_INFORMATION';var GET_SERVER_SYSTEM_INFORMATION_SUCCESS='admin/server/GET_SERVER_SYSTEM_INFORMATION_SUCCESS';var GET_SERVER_SYSTEM_INFORMATION_FAIL='admin/server/GET_SERVER_SYSTEM_INFORMATION_FAIL';var GET_SERVER_FOLDERS='admin/server/GET_SERVER_FOLDERS';var GET_SERVER_FOLDERS_FAIL='admin/server/GET_SERVER_FOLDERS_FAIL';var GET_SERVER_FOLDERS_SUCCESS='admin/server/GET_SERVER_FOLDERS_SUCCESS';var SET_SSO_CREDENTIALS='admin/server/SET_SSO_CREDENTIALS';var SET_SSO_CREDENTIALS_FAIL='admin/server/SET_SSO_CREDENTIALS_FAIL';var SET_SSO_CREDENTIALS_SUCCESS='admin/server/SET_SSO_CREDENTIALS_SUCCESS';var SET_GLOBAL_SETTINGS='admin/server/SET_GLOBAL_SETTINGS';var SET_GLOBAL_SETTINGS_SUCCESS='admin/server/SET_GLOBAL_SETTINGS_SUCCESS';var SET_GLOBAL_SETTINGS_FAIL='admin/server/SET_GLOBAL_SETTINGS_FAIL';var SET_MOBILE_UPLOAD_SETTINGS='admin/server/SET_MOBILE_UPLOAD_SETTINGS';var SET_MOBILE_UPLOAD_SETTINGS_SUCCESS='admin/server/SET_MOBILE_UPLOAD_SETTINGS_SUCCESS';var SET_MOBILE_UPLOAD_SETTINGS_FAIL='admin/server/SET_MOBILE_UPLOAD_SETTINGS_FAIL';var SET_LOGGING_CONFIG='admin/server/SET_LOGGING_CONFIG';var SET_LOGGING_CONFIG_SUCCESS='admin/server/SET_LOGGING_CONFIG_SUCCESS';var SET_LOGGING_CONFIG_FAIL='admin/server/SET_LOGGING_CONFIG_FAIL';var UPDATE_DIR_SVC_DESC='admin/server/UPDATE_DIR_SVC_DESC';var UPDATE_DIR_SVC_DESC_SUCCESS='admin/server/UPDATE_DIR_SVC_DESC_SUCCESS';var UPDATE_DIR_SVC_DESC_FAIL='admin/server/UPDATE_DIR_SVC_DESC_FAIL';var UPDATE_SERVER_FOLDERS='admin/server/UPDATE_SERVER_FOLDERS';var UPDATE_SERVER_FOLDER_ROOT='admin/server/UPDATE_SERVER_FOLDER_ROOT';var SET_EMAIL_CONFIG='admin/server/SET_EMAIL_CONFIG';var SET_EMAIL_CONFIG_FAIL='admin/server/SET_EMAIL_CONFIG_FAIL';var SET_EMAIL_CONFIG_SUCCESS='admin/server/SET_EMAIL_CONFIG_SUCCESS';var SET_PORTS='admin/server/SET_PORTS';var SET_PORTS_FAIL='admin/server/SET_PORTS_FAIL';var SET_PORTS_SUCCESS='admin/server/SET_PORTS_SUCCESS';var CREATE_MEDIA_ENGINE='admin/server/CREATE_MEDIA_ENGINE';var CREATE_MEDIA_ENGINE_FAIL='admin/server/CREATE_MEDIA_ENGINE_FAIL';var CREATE_MEDIA_ENGINE_SUCCESS='admin/server/CREATE_MEDIA_ENGINE_SUCCESS';var DELETE_MEDIA_ENGINE='admin/server/DELETE_MEDIA_ENGINE';var DELETE_MEDIA_ENGINE_FAIL='admin/server/DELETE_MEDIA_ENGINE_FAIL';var DELETE_MEDIA_ENGINE_SUCCESS='admin/server/DELETE_MEDIA_ENGINE_SUCCESS';var TEST_MEDIA_ENGINE='admin/server/TEST_MEDIA_ENGINE';var TEST_MEDIA_ENGINE_FAIL='admin/server/TEST_MEDIA_ENGINE_FAIL';var TEST_MEDIA_ENGINE_SUCCESS='admin/server/TEST_MEDIA_ENGINE_SUCCESS';var UPDATE_MEDIA_ENGINE='admin/server/UPDATE_MEDIA_ENGINE';var UPDATE_MEDIA_ENGINE_FAIL='admin/server/UPDATE_MEDIA_ENGINE_FAIL';var UPDATE_MEDIA_ENGINE_SUCCESS='admin/server/UPDATE_MEDIA_ENGINE_SUCCESS';var SET_BRANDING_IMAGE='admin/server/SET_BRANDING_IMAGE';var SET_BRANDING_IMAGE_SUCCESS='admin/server/SET_BRANDING_IMAGE_SUCCESS';var SET_BRANDING_IMAGE_FAIL='admin/server/SET_BRANDING_IMAGE_FAIL';var VALIDATE_EMAIL_SERVER_CONFIG='admin/server/VALIDATE_EMAIL_SERVER_CONFIG';var VALIDATE_EMAIL_SERVER_CONFIG_FAIL='admin/server/VALIDATE_EMAIL_SERVER_CONFIG_FAIL';var VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS='admin/server/VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS';var SET_EMAIL_SERVER_CONFIG_VALIDATING='admin/server/SET_EMAIL_SERVER_CONFIG_VALIDATING';var CLEAR_EMAIL_SERVER_CONFIG_VALIDATING='admin/server/CLEAR_EMAIL_SERVER_CONFIG_VALIDATING';var SET_MEDIA_ENGINE_TEST_PENDING='admin/server/SET_MEDIA_ENGINE_TEST_PENDING';var CLEAR_MEDIA_ENGINE_TEST_PENDING='admin/server/CLEAR_MEDIA_ENGINE_TEST_PENDING';var MOBILE_UPLOADS_ENABLED='mobile.uploads.enabled';var MOBILE_UPLOADS_FOLDER='default.upload.folder';var MOBILE_UPLOADS_CATALOG='mobile.uploads.catalog';var PORT_KEY_SERVER='esp.port.http';var PORT_KEY_SERVER_HTTPS='esp.port.https';var PORT_KEY_ADMIN='esp.port.admin-web-app';var PORT_KEY_ADMIN_SSL='esp.port.admin-web-app-ssl';

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(531);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(272);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(534);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(276);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(173);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(280);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(178);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(554)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(571);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(180);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(577);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(294);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(588);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(611);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(124);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(624);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(40);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(127);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(641);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(298);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(300);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(186);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(654);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(663);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(41);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(96);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(299);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(95);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(305);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(62);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(293);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var ADD_NOTIFICATION='client-next/globalNotify/ADD_NOTIFICATION';var REMOVE_NOTIFICATION='client-next/globalNotify/REMOVE_NOTIFICATION';var CLEAR_NOTIFICATIONS='client-next/globalNotify/CLEAR_NOTIFICATIONS';var initialState={notifications:[]};function globalNotificationsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case ADD_NOTIFICATION:return Object.assign({},state,{notifications:[].concat(_toConsumableArray(state.notifications),[action.payload])});case REMOVE_NOTIFICATION:return Object.assign({},state,{notifications:state.notifications.filter(function(notification){return notification.uid!==action.payload.uid;})});case CLEAR_NOTIFICATIONS:return Object.assign({},state,{notifications:[]});default:return state;}}function addNotification(message,type,dataTestName){return{type:ADD_NOTIFICATION,payload:{uid:__WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()(),dataTestName:dataTestName,message:message,type:type}};}function removeNotification(uid){return{type:REMOVE_NOTIFICATION,payload:{uid:uid}};}function clearNotifications(){return{type:CLEAR_NOTIFICATIONS};}var actions={addNotification:addNotification,clearNotifications:clearNotifications,removeNotification:removeNotification};/* harmony default export */ __webpack_exports__["b"] = (globalNotificationsReducer);

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(747),
      utf8 = __webpack_require__(324).utf8,
      isBuffer = __webpack_require__(748),
      bin = __webpack_require__(324).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 324 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_CLEAR_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearStateAction; });
var ACTION_TYPE_CLEAR_STATE='ACTION_TYPE_CLEAR_STATE';var clearStateAction={type:ACTION_TYPE_CLEAR_STATE};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItem__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PageRoute__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_styles_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__admin_styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nav=function(_Component){_inherits(Nav,_Component);function Nav(){_classCallCheck(this,Nav);return _possibleConstructorReturn(this,(Nav.__proto__||Object.getPrototypeOf(Nav)).apply(this,arguments));}_createClass(Nav,[{key:'render',value:function render(){var _props=this.props,className=_props.className,isFullAdmin=_props.isFullAdmin,isLicensed=_props.isLicensed,hasIdentityService=_props.hasIdentityService,navItemClass=_props.navItemClass,navListClass=_props.navListClass,pages=_props.pages;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className||'nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:navListClass},pages&&pages.map(function(page){return(isFullAdmin||page.visibleForCatalogAdmin)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */],{hasIdentityService:hasIdentityService,isFullAdmin:isFullAdmin,isLicensed:isLicensed||false,key:page.label.defaultMessage,navItemClass:navItemClass,page:page});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-container',id:'pageContainer'},pages&&pages.map(function(page){return(isFullAdmin||page.visibleForCatalogAdmin)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PageRoute__["a" /* default */],{hasIdentityService:hasIdentityService,isFullAdmin:isFullAdmin,key:page.route+'-page',page:page});})));}}]);return Nav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var bool=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,func=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,node=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,string=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string;var TreeView=function(_Component){_inherits(TreeView,_Component);function TreeView(props){_classCallCheck(this,TreeView);var _this=_possibleConstructorReturn(this,(TreeView.__proto__||Object.getPrototypeOf(TreeView)).call(this,props));_this.state={collapsed:props.defaultCollapsed};_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(TreeView,[{key:'handleClick',value:function handleClick(e){e.preventDefault();e.stopPropagation();this.setState({collapsed:!this.state.collapsed});}},{key:'render',value:function render(){var _props=this.props,_props$collapsed=_props.collapsed,collapsed=_props$collapsed===undefined?this.state.collapsed:_props$collapsed,_props$className=_props.className,className=_props$className===undefined?'':_props$className,_props$itemClassName=_props.itemClassName,itemClassName=_props$itemClassName===undefined?'':_props$itemClassName,nodeLabel=_props.nodeLabel,children=_props.children,onClick=_props.onClick,indent=_props.indent,handleOnMouseDown=_props.handleOnMouseDown,handleOnDoubleClick=_props.handleOnDoubleClick,labelWrapper=_props.labelWrapper,rest=_objectWithoutProperties(_props,['collapsed','className','itemClassName','nodeLabel','children','onClick','indent','handleOnMouseDown','handleOnDoubleClick','labelWrapper']);var arrowClassName='tree-view_arrow';var containerClassName='tree-view_children';if(collapsed){arrowClassName+=' tree-view_arrow-collapsed';containerClassName+=' tree-view_children-collapsed';}var arrow=this.props.arrow||__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',Object.assign({},rest,{className:className+' '+arrowClassName,onClick:this.handleClick}));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tree-view',onClick:onClick},labelWrapper(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tree-view_item '+itemClassName,onMouseDown:handleOnMouseDown,onDoubleClick:handleOnDoubleClick},indent,arrow,nodeLabel)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:containerClassName},children));}}]);return TreeView;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);TreeView.propTypes={/**
     * labelWrapper is used to wrap the top-level folder with its associated
     * FolderItemDropTarget. This allows us to draw a drop border around
     * the folder and not its children when hovering over with a drag item.
     */labelWrapper:func.isRequired,collapsed:bool,defaultCollapsed:bool,nodeLabel:node.isRequired,className:string,itemClassName:string,arrow:node,children:node,onClick:func,handleOnMouseDown:func,indent:node,handleOnDoubleClick:func};/* harmony default export */ __webpack_exports__["a"] = (TreeView);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CUSTOM_XMP_NAMESPACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CUSTOM_XMP_NAMESPACES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_CUSTOM_XMP_NAMESPACES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_FIELDS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_NESTED_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADD_NESTED_VALUES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_NESTED_VALUES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADD_OR_UPDATE_USER_CATALOG_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATE_CATALOG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_CATALOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CREATE_CATALOG_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CREATE_CATALOG_TEMPLATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CREATE_CATALOG_TEMPLATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CREATE_METADATA_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CREATE_METADATA_MAPPINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CREATE_METADATA_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CREATE_METADATA_DEFINITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CREATE_METADATA_DEFINITIONS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CREATE_METADATA_DEFINITIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DELETE_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DELETE_CATALOG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DELETE_CATALOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DELETE_CATALOG_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DELETE_CATALOG_TEMPLATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DELETE_CATALOG_TEMPLATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DELETE_METADATA_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DELETE_METADATA_DEFINITION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DELETE_METADATA_DEFINITION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DELETE_METADATA_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DELETE_METADATA_MAPPINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DELETE_METADATA_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DELETE_NESTED_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DELETE_NESTED_VALUES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DELETE_NESTED_VALUES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_CATALOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return GET_CATALOGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return GET_CATALOGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return GET_CATALOG_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return GET_CATALOG_PROPERTIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return GET_CATALOG_PROPERTIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GET_CATALOG_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_CATALOG_TYPES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return GET_CATALOG_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return GET_CUSTOM_XMP_NAMESPACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return GET_CUSTOM_XMP_NAMESPACES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return GET_CUSTOM_XMP_NAMESPACES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return GET_USER_CATALOG_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return GET_USER_CATALOG_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return GET_USER_CATALOG_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return GET_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return GET_FIELDS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return GET_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return GET_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return GET_METADATA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return GET_METADATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return GET_METADATA_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return GET_METADATA_MAPPINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return GET_METADATA_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return REMOVE_ALL_PREDEFINED_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return REMOVE_ALL_PREDEFINED_VALUES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return REMOVE_ALL_PREDEFINED_VALUES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return REMOVE_CUSTOM_XMP_NAMESPACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return REMOVE_CUSTOM_XMP_NAMESPACES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return REMOVE_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return REMOVE_FIELDS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return REMOVE_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return REMOVE_USERS_FROM_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return REMOVE_USERS_FROM_CATALOG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return REMOVE_USERS_FROM_CATALOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return RENAME_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return RENAME_CATALOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return RENAME_CATALOG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return RENAME_CATALOG_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return RENAME_CATALOG_TEMPLATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return RENAME_CATALOG_TEMPLATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return RESTORE_FILE_TYPES_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return RESTORE_FILE_TYPES_DEFAULT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return RESTORE_FILE_TYPES_DEFAULT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SET_EXCLUSION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SET_EXCLUSION_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SET_EXCLUSION_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SET_INGEST_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SET_INGEST_CONFIG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SET_INGEST_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SET_SELECTED_FIELD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SET_SELECTED_FIELDS_LIST_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return UPDATE_CATALOGING_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return UPDATE_CATALOGING_OPTIONS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return UPDATE_CATALOGING_OPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return UPDATE_DISK_PREVIEW_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return UPDATE_DISK_PREVIEW_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return UPDATE_DISK_PREVIEW_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return UPDATE_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return UPDATE_FIELDS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return UPDATE_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return UPDATE_PREDEFINED_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return UPDATE_PREDEFINED_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return UPDATE_PREDEFINED_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return UPDATE_SMART_KEYWORDS_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return UPDATE_SMART_KEYWORDS_SETTINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS; });
var ADD_CUSTOM_XMP_NAMESPACES='admin/catalog/ADD_CUSTOM_XMP_NAMESPACES';var ADD_CUSTOM_XMP_NAMESPACES_FAIL='admin/catalog/ADD_CUSTOM_XMP_NAMESPACES_FAIL';var ADD_CUSTOM_XMP_NAMESPACES_SUCCESS='admin/catalog/ADD_CUSTOM_XMP_NAMESPACES_SUCCESS';var ADD_FIELDS='admin/catalog/ADD_FIELDS';var ADD_FIELDS_FAIL='admin/catalog/ADD_FIELDS_FAIL';var ADD_FIELDS_SUCCESS='admin/catalog/ADD_FIELDS_SUCCESS';var ADD_NESTED_VALUES='admin/catalog/ADD_NESTED_VALUES';var ADD_NESTED_VALUES_SUCCESS='admin/catalog/ADD_NESTED_VALUES_SUCCESS';var ADD_NESTED_VALUES_FAIL='admin/catalog/ADD_NESTED_VALUES_FAIL';var ADD_OR_UPDATE_USER_CATALOG_INFO='admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO';var ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL='admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL';var ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS='admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS';var CREATE_CATALOG='admin/catalog/CREATE_CATALOG';var CREATE_CATALOG_FAIL='admin/catalog/CREATE_CATALOG_FAIL';var CREATE_CATALOG_SUCCESS='admin/catalog/CREATE_CATALOG_SUCCESS';var CREATE_CATALOG_TEMPLATE='admin/catalog/CREATE_CATALOG_TEMPLATE';var CREATE_CATALOG_TEMPLATE_FAIL='admin/catalog/CREATE_CATALOG_TEMPLATE_FAIL';var CREATE_CATALOG_TEMPLATE_SUCCESS='admin/catalog/CREATE_CATALOG_TEMPLATE_SUCCESS';var CREATE_METADATA_DEFINITIONS='admin/catalog/CREATE_METADATA_DEFINITIONS';var CREATE_METADATA_DEFINITIONS_FAIL='admin/catalog/CREATE_METADATA_DEFINITIONS_FAIL';var CREATE_METADATA_DEFINITIONS_SUCCESS='admin/catalog/CREATE_METADATA_DEFINITIONS_SUCCESS';var CREATE_METADATA_MAPPINGS='admin/catalog/CREATE_METADATA_MAPPINGS';var CREATE_METADATA_MAPPINGS_FAIL='admin/catalog/CREATE_METADATA_MAPPINGS_FAIL';var CREATE_METADATA_MAPPINGS_SUCCESS='admin/catalog/CREATE_METADATA_MAPPINGS_SUCCESS';var DELETE_CATALOG='admin/catalog/DELETE_CATALOG';var DELETE_CATALOG_FAIL='admin/catalog/DELETE_CATALOG_FAIL';var DELETE_CATALOG_SUCCESS='admin/catalog/DELETE_CATALOG_SUCCESS';var DELETE_CATALOG_TEMPLATE='admin/catalog/DELETE_CATALOG_TEMPLATE';var DELETE_CATALOG_TEMPLATE_FAIL='admin/catalog/DELETE_CATALOG_TEMPLATE_FAIL';var DELETE_CATALOG_TEMPLATE_SUCCESS='admin/catalog/DELETE_CATALOG_TEMPLATE_SUCCESS';var DELETE_METADATA_DEFINITION='admin/catalog/DELETE_METADATA_DEFINITION';var DELETE_METADATA_DEFINITION_FAIL='admin/catalog/DELETE_METADATA_DEFINITION_FAIL';var DELETE_METADATA_DEFINITION_SUCCESS='admin/catalog/DELETE_METADATA_DEFINITION_SUCCESS';var DELETE_METADATA_MAPPINGS='admin/catalog/DELETE_METADATA_MAPPINGS';var DELETE_METADATA_MAPPINGS_FAIL='admin/catalog/DELETE_METADATA_MAPPINGS_FAIL';var DELETE_METADATA_MAPPINGS_SUCCESS='admin/catalog/DELETE_METADATA_MAPPINGS_SUCCESS';var DELETE_NESTED_VALUES='admin/catalog/DELETE_NESTED_VALUES';var DELETE_NESTED_VALUES_SUCCESS='admin/catalog/DELETE_NESTED_VALUES_SUCCESS';var DELETE_NESTED_VALUES_FAIL='admin/catalog/DELETE_NESTED_VALUES_FAIL';var GET_CATALOGS='admin/catalog/GET_CATALOGS';var GET_CATALOGS_FAIL='admin/catalog/GET_CATALOGS_FAIL';var GET_CATALOGS_SUCCESS='admin/catalog/GET_CATALOGS_SUCCESS';var GET_CATALOG_PROPERTIES='admin/catalog/GET_CATALOG_PROPERTIES';var GET_CATALOG_PROPERTIES_FAIL='admin/catalog/GET_CATALOG_PROPERTIES_FAIL';var GET_CATALOG_PROPERTIES_SUCCESS='admin/catalog/GET_CATALOG_PROPERTIES_SUCCESS';var GET_CATALOG_TYPES='admin/catalog/GET_CATALOG_TYPES';var GET_CATALOG_TYPES_FAIL='admin/catalog/GET_CATALOG_TYPES_FAIL';var GET_CATALOG_TYPES_SUCCESS='admin/catalog/GET_CATALOG_TYPES_SUCCESS';var GET_CUSTOM_XMP_NAMESPACES='admin/catalog/GET_CUSTOM_XMP_NAMESPACES';var GET_CUSTOM_XMP_NAMESPACES_FAIL='admin/catalog/GET_CUSTOM_XMP_NAMESPACES_FAIL';var GET_CUSTOM_XMP_NAMESPACES_SUCCESS='admin/catalog/GET_CUSTOM_XMP_NAMESPACES_SUCCESS';var GET_FIELDS='admin/catalog/GET_FIELDS';var GET_FIELDS_FAIL='admin/catalog/GET_FIELDS_FAIL';var GET_FIELDS_SUCCESS='admin/catalog/GET_FIELDS_SUCCESS';var GET_METADATA='admin/catalog/GET_METADATA';var GET_METADATA_FAIL='admin/catalog/GET_METADATA_FAIL';var GET_METADATA_SUCCESS='admin/catalog/GET_METADATA_SUCCESS';var GET_METADATA_MAPPINGS='admin/catalog/GET_METADATA_MAPPINGS';var GET_METADATA_MAPPINGS_FAIL='admin/catalog/GET_METADATA_MAPPINGS_FAIL';var GET_METADATA_MAPPINGS_SUCCESS='admin/catalog/GET_METADATA_MAPPINGS_SUCCESS';var GET_USER_CATALOG_INFO='admin/catalog/GET_USER_CATALOG_INFO';var GET_USER_CATALOG_INFO_FAIL='admin/catalog/GET_USER_CATALOG_INFO_FAIL';var GET_USER_CATALOG_INFO_SUCCESS='admin/catalog/GET_USER_CATALOG_INFO_SUCCESS';var RENAME_CATALOG='admin/catalog/RENAME_CATALOG';var RENAME_CATALOG_SUCCESS='admin/catalog/RENAME_CATALOG_SUCCESS';var RENAME_CATALOG_FAIL='admin/catalog/RENAME_CATALOG_FAIL';var RENAME_CATALOG_TEMPLATE='admin/catalog/RENAME_CATALOG_TEMPLATE';var RENAME_CATALOG_TEMPLATE_SUCCESS='admin/catalog/RENAME_CATALOG_TEMPLATE_SUCCESS';var RENAME_CATALOG_TEMPLATE_FAIL='admin/catalog/RENAME_CATALOG_TEMPLATE_FAIL';var REMOVE_ALL_PREDEFINED_VALUES='admin/catalog/REMOVE_ALL_PREDEFINED_VALUES';var REMOVE_ALL_PREDEFINED_VALUES_FAIL='admin/catalog/REMOVE_ALL_PREDEFINED_VALUES_FAIL';var REMOVE_ALL_PREDEFINED_VALUES_SUCCESS='admin/catalog/REMOVE_ALL_PREDEFINED_VALUES_SUCCESS';var REMOVE_CUSTOM_XMP_NAMESPACES='admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES';var REMOVE_CUSTOM_XMP_NAMESPACES_FAIL='admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES_FAIL';var REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS='admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS';var REMOVE_FIELDS='admin/catalog/REMOVE_FIELDS';var REMOVE_FIELDS_FAIL='admin/catalog/REMOVE_FIELDS_FAIL';var REMOVE_FIELDS_SUCCESS='admin/catalog/REMOVE_FIELDS_SUCCESS';var REMOVE_USERS_FROM_CATALOG='admin/catalog/REMOVE_USERS_FROM_CATALOG';var REMOVE_USERS_FROM_CATALOG_FAIL='admin/catalog/REMOVE_USERS_FROM_CATALOG_FAIL';var REMOVE_USERS_FROM_CATALOG_SUCCESS='admin/catalog/REMOVE_USERS_FROM_CATALOG_SUCCESS';var RESTORE_FILE_TYPES_DEFAULT='admin/catalog/RESTORE_FILE_TYPES_DEFAULT';var RESTORE_FILE_TYPES_DEFAULT_SUCCESS='admin/catalog/RESTORE_FILE_TYPES_DEFAULT_SUCCESS';var RESTORE_FILE_TYPES_DEFAULT_FAIL='admin/catalog/RESTORE_FILE_TYPES_DEFAULT_FAIL';var SET_EXCLUSION_INFO='admin/catalog/SET_EXCLUSION_INFO';var SET_EXCLUSION_INFO_SUCCESS='admin/catalog/SET_EXCLUSION_INFO_SUCCESS';var SET_EXCLUSION_INFO_FAIL='admin/catalog/SET_EXCLUSION_INFO_FAIL';var SET_INGEST_CONFIG='admin/catalog/SET_INGEST_CONFIG';var SET_INGEST_CONFIG_FAIL='admin/catalog/SET_INGEST_CONFIG_FAIL';var SET_INGEST_CONFIG_SUCCESS='admin/catalog/SET_INGEST_CONFIG_SUCCESS';var SET_SELECTED_FIELD_CATEGORY='admin/catalog/SET_SELECTED_FIELD_CATEGORY';var SET_SELECTED_FIELDS_LIST_ITEM_NAME='admin/catalog/SET_SELECTED_FIELDS_LIST_ITEM_NAME';var UPDATE_CATALOGING_OPTIONS='admin/catalog/UPDATE_CATALOGING_OPTIONS';var UPDATE_CATALOGING_OPTIONS_FAIL='admin/catalog/UPDATE_CATALOGING_OPTIONS_FAIL';var UPDATE_CATALOGING_OPTIONS_SUCCESS='admin/catalog/UPDATE_CATALOGING_OPTIONS_SUCCESS';var UPDATE_DISK_PREVIEW_INFO='admin/catalog/UPDATE_DISK_PREVIEW_INFO';var UPDATE_DISK_PREVIEW_INFO_FAIL='admin/catalog/UPDATE_DISK_PREVIEW_INFO_FAIL';var UPDATE_DISK_PREVIEW_INFO_SUCCESS='admin/catalog/UPDATE_DISK_PREVIEW_INFO_SUCCESS';var UPDATE_FIELDS='admin/catalog/UPDATE_FIELDS';var UPDATE_FIELDS_FAIL='admin/catalog/UPDATE_FIELDS_FAIL';var UPDATE_FIELDS_SUCCESS='admin/catalog/UPDATE_FIELDS_SUCCESS';var UPDATE_PREDEFINED_LIST='admin/catalog/UPDATE_PREDEFINED_LIST';var UPDATE_PREDEFINED_LIST_SUCCESS='admin/catalog/UPDATE_PREDEFINED_LIST_SUCCESS';var UPDATE_PREDEFINED_LIST_FAIL='admin/catalog/UPDATE_PREDEFINED_LIST_FAIL';var UPDATE_SMART_KEYWORDS_SETTINGS='admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS';var UPDATE_SMART_KEYWORDS_SETTINGS_FAIL='admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS_FAIL';var UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS='admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS';// Represents an item in the fields list
// Backed by either a real FieldDefinition or a MetadataDefinition
// This is the type definition. The constant definition lives in util/constants.js
// Everything needed to create a new catalog

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToRoute;
function goToRoute(route){// TODO: is this the best way to change route?
window.location.replace(window.location.pathname+window.location.search+'#/'+route);}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_roleUtils__ = __webpack_require__(34);
var initialState={roles:[],selectedRoleId:null};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["i" /* GET_ROLES_SUCCESS */]:return Object.assign({},state,{roles:Object(__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["i" /* sortRoles */])(action.payload)});case __WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["j" /* SET_SELECTED_ROLE */]:return Object.assign({},state,{selectedRoleId:action.payload.uuid});default:return state;}}function createRole(identitySession,roleName){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["a" /* CREATE_ROLE */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["c" /* CREATE_ROLE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["b" /* CREATE_ROLE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/role',{params:{session:identitySession,roleName:roleName}});}};}function deleteRole(identitySession,roleName){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["d" /* DELETE_ROLE */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["f" /* DELETE_ROLE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["e" /* DELETE_ROLE_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/role',{params:{session:identitySession,roleName:roleName}});}};}function getRoles(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["g" /* GET_ROLES */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["i" /* GET_ROLES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["h" /* GET_ROLES_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/role',{params:{session:identitySession}});}};}function updateRole(identitySession,roleName,grant,revoke){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["k" /* UPDATE_ROLE */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["m" /* UPDATE_ROLE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["l" /* UPDATE_ROLE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/role/'+roleName,{params:{session:identitySession,grants:grant,revokes:revoke}});}};}function setSelectedRole(role){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_roleTypes__["j" /* SET_SELECTED_ROLE */],payload:role};}var actions={createRole:createRole,deleteRole:deleteRole,getRoles:getRoles,setSelectedRole:setSelectedRole,updateRole:updateRole};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollToColumn: 0,
      scrollToRow: 0
    }, _this._columnStartIndex = 0, _this._columnStopIndex = 0, _this._rowStartIndex = 0, _this._rowStopIndex = 0, _this._onKeyDown = function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;


      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }, _this._onSectionRendered = function (_ref2) {
      var columnStartIndex = _ref2.columnStartIndex,
          columnStopIndex = _ref2.columnStopIndex,
          rowStartIndex = _ref2.rowStartIndex,
          rowStopIndex = _ref2.rowStopIndex;

      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'setScrollIndexes',
    value: function setScrollIndexes(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;

      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      var _getScrollState2 = this._getScrollState(),
          scrollToColumn = _getScrollState2.scrollToColumn,
          scrollToRow = _getScrollState2.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](
        'div',
        { className: className, onKeyDown: this._onKeyDown },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: '_getScrollState',
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: '_updateScrollState',
    value: function _updateScrollState(_ref4) {
      var scrollToColumn = _ref4.scrollToColumn,
          scrollToRow = _ref4.scrollToRow;
      var _props2 = this.props,
          isControlled = _props2.isControlled,
          onScrollToChange = _props2.onScrollToChange;


      if (typeof onScrollToChange === 'function') {
        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }

      if (!isControlled) {
        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return null;
      }

      if (nextProps.scrollToColumn !== prevState.scrollToColumn || nextProps.scrollToRow !== prevState.scrollToRow) {
        return {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow
        };
      }

      return null;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
ArrowKeyStepper.propTypes =  true ? null : {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  isControlled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']).isRequired,
  onScrollToChange: PropTypes.func,
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(ArrowKeyStepper);

/* harmony default export */ __webpack_exports__["a"] = (ArrowKeyStepper);




/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(65);
var toObject = __webpack_require__(137);
var IE_PROTO = __webpack_require__(198)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(59) && !__webpack_require__(83)(function () {
  return Object.defineProperty(__webpack_require__(201)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(779), __esModule: true };

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(781);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(791);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(101);
var $export = __webpack_require__(48);
var redefine = __webpack_require__(338);
var hide = __webpack_require__(66);
var Iterators = __webpack_require__(84);
var $iterCreate = __webpack_require__(784);
var setToStringTag = __webpack_require__(142);
var getPrototypeOf = __webpack_require__(333);
var ITERATOR = __webpack_require__(30)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(66);


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(65);
var toIObject = __webpack_require__(67);
var arrayIndexOf = __webpack_require__(786)(false);
var IE_PROTO = __webpack_require__(198)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(104);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(203);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(29).document;
module.exports = document && document.documentElement;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(339);
var hiddenKeys = __webpack_require__(205).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 344 */
/***/ (function(module, exports) {



/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);



















/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;
    _this._styleCache = {};
    _this._cellCache = {};

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    var columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });

    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,

        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,

        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,

      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: 'getTotalRowsHeight',
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: 'getTotalColumnsWidth',
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;
      var instanceProps = this.state.instanceProps;

      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;
      var instanceProps = this.state.instanceProps;


      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState, { needToResetStyleCache: false });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop,
          instanceProps = _state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          autoContainerWidth = _props6.autoContainerWidth,
          autoHeight = _props6.autoHeight,
          autoWidth = _props6.autoWidth,
          className = _props6.className,
          containerProps = _props6.containerProps,
          containerRole = _props6.containerRole,
          containerStyle = _props6.containerStyle,
          height = _props6.height,
          id = _props6.id,
          noContentRenderer = _props6.noContentRenderer,
          role = _props6.role,
          style = _props6.style,
          tabIndex = _props6.tabIndex,
          width = _props6.width;
      var _state2 = this.state,
          instanceProps = _state2.instanceProps,
          needToResetStyleCache = _state2.needToResetStyleCache;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;


      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_handleInvalidatedGridSize',


    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props7 = _this3.props,
              height = _props7.height,
              onScroll = _props7.onScroll,
              width = _props7.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps;

      // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });

      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, {
          isScrolling: false
        });
      }

      var maybeStateA = void 0;
      var maybeStateB = void 0;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });

      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, newState, maybeStateA, maybeStateB);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_getScrollToPositionStateUpdate',


    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return null;
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;

        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollLeftForScrollToColumnStateUpdate',
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return null;
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollTopForScrollToRowStateUpdate',
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return null;
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize___default.a,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
};
Grid.propTypes =  true ? null : {
  "aria-label": PropTypes.string.isRequired,
  "aria-readonly": PropTypes.bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: PropTypes.bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: function cellRenderer() {
    return (typeof bpfrpt_proptype_CellRenderer === 'function' ? bpfrpt_proptype_CellRenderer.isRequired ? bpfrpt_proptype_CellRenderer.isRequired : bpfrpt_proptype_CellRenderer : PropTypes.shape(bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: function cellRangeRenderer() {
    return (typeof bpfrpt_proptype_CellRangeRenderer === 'function' ? bpfrpt_proptype_CellRangeRenderer.isRequired ? bpfrpt_proptype_CellRangeRenderer.isRequired : bpfrpt_proptype_CellRangeRenderer : PropTypes.shape(bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: PropTypes.string,


  /** Number of columns in grid.  */
  columnCount: PropTypes.number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: function columnWidth() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Unfiltered props for the Grid container. */
  containerProps: PropTypes.object,


  /** ARIA role for the cell-container.  */
  containerRole: PropTypes.string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: PropTypes.object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: PropTypes.func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: PropTypes.number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: PropTypes.string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: PropTypes.bool,


  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  isScrollingOptOut: PropTypes.bool.isRequired,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: function noContentRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: PropTypes.func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: PropTypes.func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** ARIA role for the grid element.  */
  role: PropTypes.string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Number of rows in grid.  */
  rowCount: PropTypes.number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Horizontal offset. */
  scrollLeft: PropTypes.number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: PropTypes.number.isRequired,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__["polyfill"])(Grid);
/* harmony default export */ __webpack_exports__["a"] = (Grid);
















/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(807), __esModule: true };

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}



/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(816);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(817));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(214);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(84);
module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(49);
var aFunction = __webpack_require__(139);
var SPECIES = __webpack_require__(30)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(102);
var invoke = __webpack_require__(825);
var html = __webpack_require__(342);
var cel = __webpack_require__(201);
var global = __webpack_require__(29);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(104)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(49);
var isObject = __webpack_require__(58);
var newPromiseCapability = __webpack_require__(215);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_ScrollIndices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ScrollIndices =  true ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};



/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: PropTypes.func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: PropTypes.string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: PropTypes.number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: PropTypes.number,


  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: PropTypes.string,


  /** Callback to be invoked on-resize */
  onResize: PropTypes.func.isRequired,


  /** Optional inline style */
  style: PropTypes.object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellMeasureCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellMeasureCache =  true ? null : {
  hasFixedWidth: PropTypes.func.isRequired,
  hasFixedHeight: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};



/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": PropTypes.string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /** Optional CSS class name */
  className: PropTypes.string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: function noRowsRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: PropTypes.func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: function rowRenderer() {
    return (typeof bpfrpt_proptype_RowRenderer === 'function' ? bpfrpt_proptype_RowRenderer.isRequired ? bpfrpt_proptype_RowRenderer.isRequired : bpfrpt_proptype_RowRenderer : PropTypes.shape(bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },


  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of list */
  width: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (List);













/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(106);


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(106);


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'div',
    { className: className, role: 'row', style: style },
    columns
  );
}
defaultHeaderRowRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRowRendererParams;



/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: label },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], { key: 'SortIndicator', sortDirection: sortDirection }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRendererParams;



/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(146);





/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](
    'svg',
    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
    sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;

  var a11yProps = { 'aria-rowindex': index + 1 };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({ event: event, index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      role: 'row',
      style: style }),
    columns
  );
}
defaultRowRenderer.propTypes =  true ? null : bpfrpt_proptype_RowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_RowRendererParams;



/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortDirection__ = __webpack_require__(146);











/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _React$Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_9__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);












/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }), _this._registerChild = function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    }, _this._onChildScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    }, _this._registerResizeListener = function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    }, _this._unregisterResizeListener = function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    }, _this._onResize = function () {
      _this.updatePosition();
    }, _this.__handleWindowScrollEvent = function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;


      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });

        onScroll({
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });
      }
    }, _this.__resetIsScrolling = function () {
      _this.setState({
        isScrolling: false
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _state = this.state,
          height = _state.height,
          width = _state.width;


      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](this);
      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(scrollElement, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;

      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__["a" /* default */])();

      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;


      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);

        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, prevScrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollTop = _state2.scrollTop,
          scrollLeft = _state2.scrollLeft,
          height = _state2.height,
          width = _state2.width;


      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }

    // Referenced by utils/onScroll


    // Referenced by utils/onScroll

  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
};
WindowScroller.propTypes =  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,


  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired,


  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  onScroll: PropTypes.func.isRequired,


  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.oneOfType([PropTypes.any, function () {
    return (typeof Element === 'function' ? PropTypes.instanceOf(Element) : PropTypes.any).apply(this, arguments);
  }]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Height used for server-side rendering */
  serverHeight: PropTypes.number.isRequired,


  /** Width used for server-side rendering */
  serverWidth: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(888);
module.exports = __webpack_require__(69).Object.assign;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(889);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(149);
var IE8_DOM_DEFINE = __webpack_require__(372);
var toPrimitive = __webpack_require__(374);
var dP = Object.defineProperty;

exports.f = __webpack_require__(86) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(86) && !__webpack_require__(151)(function () {
  return Object.defineProperty(__webpack_require__(373)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(150);
var document = __webpack_require__(148).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(150);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(893);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(897)('keys');
var uid = __webpack_require__(899);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 381 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(377);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(920);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(922);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(923);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(925);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(385);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(152);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(926);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BulmaSlider=function(_Component){_inherits(BulmaSlider,_Component);function BulmaSlider(){_classCallCheck(this,BulmaSlider);var _this=_possibleConstructorReturn(this,(BulmaSlider.__proto__||Object.getPrototypeOf(BulmaSlider)).call(this));_this.state={isDragging:false,value:0};_this.handleChange=_this.handleChange.bind(_this);_this.handleMouseDown=_this.handleMouseDown.bind(_this);_this.handleMouseUp=_this.handleMouseUp.bind(_this);return _this;}_createClass(BulmaSlider,[{key:"componentDidMount",value:function componentDidMount(){this.setState({value:Math.round(this.props.initialValue)});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.initialValue!==nextProps.initialValue){this.setState({value:Math.round(nextProps.initialValue)});}}},{key:"handleChange",value:function handleChange(e){var value=parseInt(e.currentTarget.value,10);this.setState({value:value});}},{key:"handleMouseDown",value:function handleMouseDown(){this.setState({isDragging:true});}},{key:"handleMouseUp",value:function handleMouseUp(){this.setState({isDragging:false});// Call onChange prop here so we don't have to debounce
this.props.onChange(this.state.value,this.props.id);}},{key:"render",value:function render(){var _this2=this;var LABEL_WIDTH=35;var LABEL_OFFSET_V=48;var _props=this.props,disabled=_props.disabled,id=_props.id,min=_props.min,max=_props.max;var _state=this.state,isDragging=_state.isDragging,value=_state.value;var left=0;var top=0;if(this.slider){var rect=this.slider.getBoundingClientRect();var newPoint=(value-min)/(max-min);var newPlace=0;if(newPoint<0){newPlace=0;}else if(newPoint>1){newPlace=rect.width;}else{newPlace=rect.width*newPoint;}left=rect.left-LABEL_WIDTH/2+newPlace;top=rect.top-LABEL_OFFSET_V;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slider-drag-label",style:{left:left,top:top,opacity:isDragging?1.0:0}},value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slider-label-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"slider-label-left",htmlFor:id},min)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"slider",disabled:disabled,id:id,max:max,min:min,onChange:this.handleChange,onMouseDown:this.handleMouseDown,onMouseUp:this.handleMouseUp,ref:function ref(c){_this2.slider=c;},step:"1",title:value,type:"range",value:value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slider-label-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"slider-label-right",htmlFor:id},max)));}}]);return BulmaSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BulmaSlider);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUsers;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = createUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteUsers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
var initialState={users:[]};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["i" /* GET_USERS_SUCCESS */]:return Object.assign({},state,{users:action.payload});default:return state;}}function getUsers(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["g" /* GET_USERS */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["i" /* GET_USERS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["h" /* GET_USERS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/user',{params:{session:identitySession}});}};}function updateUser(identitySession,user){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["j" /* UPDATE_USER */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["l" /* UPDATE_USER_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["k" /* UPDATE_USER_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/user',{params:{session:identitySession},data:[user]});}};}function createUser(identitySession,user){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["a" /* CREATE_USER */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["c" /* CREATE_USER_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["b" /* CREATE_USER_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/user',{params:{session:identitySession},data:user});}};}function deleteUsers(identitySession,users,cleanup_tokens){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["d" /* DELETE_USERS */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["f" /* DELETE_USERS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_userTypes__["e" /* DELETE_USERS_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/user',{params:{session:identitySession},data:{users:users.map(function(u){return u.name;}),cleanup_tokens:cleanup_tokens}});}};}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIALOG_PANEL_SAVE_BUTTON_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_localizedStrings__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DialogPanel_css__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DialogPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DialogPanel_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DIALOG_PANEL_SAVE_BUTTON_ID='dialog-panel-save-button';var DialogPanel=function(_Component){_inherits(DialogPanel,_Component);function DialogPanel(){_classCallCheck(this,DialogPanel);var _this=_possibleConstructorReturn(this,(DialogPanel.__proto__||Object.getPrototypeOf(DialogPanel)).call(this));_this.onRequestClose=_this.onRequestClose.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.onAfterOpen=_this.onAfterOpen.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}// this is called when the esc key is clicked
_createClass(DialogPanel,[{key:'onRequestClose',value:function onRequestClose(){this.onClose();}},{key:'onClose',value:function onClose(){this.props.onClose();this.props.hideDialogPanel();}},{key:'onSave',value:function onSave(){if(this.props.isOkEnabled()){this.props.onSave();if(this.props.closeAfterSave!==false){this.onClose();}}}},{key:'isOkEnabled',value:function isOkEnabled(){if(this.props&&this.props.isOkEnabled){return this.props.isOkEnabled();}else{return true;}}},{key:'handleKeyDown',value:function handleKeyDown(e){var wasHandled=false;if(this.props.handleKeyDown){wasHandled=this.props.handleKeyDown(e);}if(!wasHandled&&e.keyCode===13){this.onSave();}}},{key:'onAfterOpen',value:function onAfterOpen(){if(this.props.dialogFocusId){var target=document.getElementById(this.props.dialogFocusId);if(target){target.focus();if(target.select){target.select();}}}if(this.props.afterOpen){this.props.afterOpen();}}},{key:'render',value:function render(){var _this2=this;var modalStyles={overlay:{backgroundColor:'rgba(127, 127, 127, 0.65)',zIndex:4},content:{width:'800px',height:'700px',backgroundColor:'#fff',position:'absolute',top:'50%',left:'50%',right:'auto',bottom:'auto',overflow:'hidden'}};if(this.props.contentStyle){modalStyles.content=Object.assign({},modalStyles.content,this.props.contentStyle);}var isPanelOpen=this.props.panelId===this.props.activePanelId;var customButtonText=this.props.customButtonText?this.props.customButtonText:this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_localizedStrings__["a" /* default */].Save);var showCancel=this.props.showCancel!==false;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{contentLabel:'Modal Dialog',style:modalStyles,className:'dialog-panel',onRequestClose:this.onRequestClose,shouldCloseOnOverlayClick:false,closeTimeoutMS:150,isOpen:isPanelOpen,onAfterOpen:this.onAfterOpen},this.props.panelHeader,!this.props.panelHeader&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dialog-panel-header','data-test-name':this.props.dataTestName||'dialog-panel-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'dialog-panel-title'},this.props.panelTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:this.props.panelSubtitle?'dialog-panel-subtitle':'dialog-panel-hidden'},this.props.panelSubtitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dialog-panel-body',onKeyDown:this.handleKeyDown},this.props.children),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dialog-panel-buttons-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.lowerLeftButtonText&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'shared-button',onClick:this.props.onClickLowerLeftButton,'data-test-name':'reset-defaults'},this.props.lowerLeftButtonText)),function(){if(showCancel){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'shared-button',onClick:_this2.onRequestClose,'data-test-name':'cancel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_localizedStrings__["a" /* default */].Cancel));}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:DIALOG_PANEL_SAVE_BUTTON_ID,className:this.isOkEnabled()?'shared-button-primary':'shared-button-primary-disabled',onClick:this.onSave,'data-test-name':'save'},customButtonText)));}}]);return DialogPanel;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);DialogPanel.propTypes={activePanelId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,afterOpen:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,children:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,closeAfterSave:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,contentStyle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,customButtonText:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,dataTestName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,dialogFocusId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,handleKeyDown:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,hideDialogPanel:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* intlShape */].isRequired,isOkEnabled:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onSave:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,panelHeader:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,// override the entire panel header (title & subtitle)
panelId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,panelSubtitle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,panelTitle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,showCancel:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,lowerLeftButtonText:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,onClickLowerLeftButton:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};DialogPanel.defaultProps={panelTitle:'Default Panel Title',isOkEnabled:function isOkEnabled(){return true;},onClose:function onClose(){},onSave:function onSave(){}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(DialogPanel));

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateFieldForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FieldFormMappings__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PredefinedList__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_state_reducers_catalogReducer__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setSelectedFieldsListItemName=__WEBPACK_IMPORTED_MODULE_18_state_reducers_catalogReducer__["a" /* actions */].setSelectedFieldsListItemName;var showModalPrompt=__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var hideDialogPanel=__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel,showDialogPanel=__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel;var FIELD_TYPES=[__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING,__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER,__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL,__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DATETIME,__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].TEXTBLOCK,__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].URL,__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].BOOLEAN];var FieldForm=function(_Component){_inherits(FieldForm,_Component);function FieldForm(){_classCallCheck(this,FieldForm);var _this=_possibleConstructorReturn(this,(FieldForm.__proto__||Object.getPrototypeOf(FieldForm)).call(this));_this.addExtractMapping=_this.addExtractMapping.bind(_this);_this.editPDL=_this.editPDL.bind(_this);_this.handleDefaultValueKeyPress=_this.handleDefaultValueKeyPress.bind(_this);_this.handleHasPredefinedValuesCheckboxChange=_this.handleHasPredefinedValuesCheckboxChange.bind(_this);_this.handleTextFieldOnKeyPress=_this.handleTextFieldOnKeyPress.bind(_this);_this.handleTextFieldOnKeyUp=_this.handleTextFieldOnKeyUp.bind(_this);_this.initializeFormValues=_this.initializeFormValues.bind(_this);_this.makeMetadataMapping=_this.makeMetadataMapping.bind(_this);_this.removeMapping=_this.removeMapping.bind(_this);_this.renderFieldTypeData=_this.renderFieldTypeData.bind(_this);_this.renderMetadataMappings=_this.renderMetadataMappings.bind(_this);_this.renderLargeTextField=_this.renderLargeTextField.bind(_this);_this.renderTextField=_this.renderTextField.bind(_this);_this.setEmbedMapping=_this.setEmbedMapping.bind(_this);_this.showAddExtractMappingSelect=_this.showAddExtractMappingSelect.bind(_this);return _this;}_createClass(FieldForm,[{key:'componentDidMount',value:function componentDidMount(){var field=this.props.field;if(field){this.initializeFormValues(field);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var field=this.props.field;if(field!==nextProps.field){this.initializeFormValues(nextProps.field||{});}}},{key:'initializeFormValues',value:function initializeFormValues(field){var defaultValue=field.defaultValues?field.defaultValues[0]:null;if(field.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].BOOLEAN){defaultValue=defaultValue===true||defaultValue==='true';}var maxLength=field.maxLength||250;var precision=field.precision||2;this.props.initialize(Object.assign({},field,{defaultValue:defaultValue,maxLength:maxLength,precision:precision}));}},{key:'handleHasPredefinedValuesCheckboxChange',value:function handleHasPredefinedValuesCheckboxChange(event){var _this2=this;var doUpdate=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:field.hasPredefinedValues=event.target.checked;_context.next=3;return updateFieldsAction(catalog.catalogId,[field]);case 3:if(!(!field.hasPredefinedValues&&field.predefinedValues.length>0)){_context.next=6;break;}_context.next=6;return removeAllPredefinedValuesAction(catalog.catalogId,[field.id]);case 6:case'end':return _context.stop();}}},_callee,this);}));return function doUpdate(){return _ref.apply(this,arguments);};}();var _props=this.props,isCreate=_props.isCreate,field=_props.field,form=_props.form,catalog=_props.catalog,removeAllPredefinedValuesAction=_props.removeAllPredefinedValuesAction,updateFieldsAction=_props.updateFieldsAction;if(isCreate){return;}if(!event.target.checked){this.props.dispatch(showModalPrompt({dataTestName:'confirm-delete-predefined-values',message:__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].CONFIRM_DELETE_PDL,onButton2:doUpdate,onButton1:function onButton1(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["d" /* change */])(form,'hasPredefinedValues',true));}}));}else{doUpdate();}}},{key:'handleDefaultValueKeyPress',value:function handleDefaultValueKeyPress(e){var field=this.props.field;if(!Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["B" /* isCharacterLegal */])(e.key,field,e.target)){e.preventDefault();}}},{key:'handleTextFieldOnKeyPress',value:function handleTextFieldOnKeyPress(e){if(e.key==='Enter'){e.preventDefault();e.currentTarget.blur();}}},{key:'handleTextFieldOnKeyUp',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var target;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(e.key==='Escape')){_context2.next=6;break;}e.preventDefault();target=e.currentTarget;_context2.next=5;return this.props.reset();case 5:target.blur();case 6:case'end':return _context2.stop();}}},_callee2,this);}));function handleTextFieldOnKeyUp(_x){return _ref2.apply(this,arguments);}return handleTextFieldOnKeyUp;}()},{key:'makeMetadataMapping',value:function makeMetadataMapping(fieldDefId,metadataDefId,mappingType){return{fieldDefId:fieldDefId,metadataDefId:metadataDefId,priority:0,// unused
type:mappingType};}},{key:'addExtractMapping',value:function addExtractMapping(mdId){var _props2=this.props,catalog=_props2.catalog,createMetadataMappings=_props2.createMetadataMappings,field=_props2.field;var mappings=[this.makeMetadataMapping(field.id,mdId,__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["k" /* MD_MAPPING_TYPE_EXTRACT */])];createMetadataMappings(catalog.catalogId,mappings);}},{key:'removeMapping',value:function removeMapping(fdId,mdId,type){var _props3=this.props,catalog=_props3.catalog,deleteMetadataMappings=_props3.deleteMetadataMappings;var mappings=[this.makeMetadataMapping(fdId,mdId,type)];deleteMetadataMappings(catalog.catalogId,mappings);}},{key:'setEmbedMapping',value:function setEmbedMapping(event){var _props4=this.props,catalog=_props4.catalog,deleteMetadataMappings=_props4.deleteMetadataMappings,field=_props4.field,metadataDefinitions=_props4.metadataDefinitions,metadataMappings=_props4.metadataMappings,setEmbedMetadataMapping=_props4.setEmbedMetadataMapping;var catId=catalog.catalogId;var mdId=event.target.value;var mapping=this.makeMetadataMapping(field.id,mdId,__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["j" /* MD_MAPPING_TYPE_EMBED */]);if(mdId===__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["n" /* NOT_FOUND */]){// delete existing embed
mapping.metadataDefId=Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["v" /* getEmbedMappingMetadataDefId */])(field.id,metadataDefinitions,metadataMappings);deleteMetadataMappings(catId,[mapping]);}else{// set new embed
setEmbedMetadataMapping(catId,field.id,mapping);}}},{key:'showAddExtractMappingSelect',value:function showAddExtractMappingSelect(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_5_util_constants__["c" /* ADD_EXTRACT_MAPPING_PANEL_ID */]);}},{key:'fieldTypeToLocalizedString',value:function fieldTypeToLocalizedString(type){switch(type){case 1:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_NUMBER;case 2:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_DECIMAL;case 3:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_DATETIME;case 4:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_URL;case 5:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_TEXTBLOCK;case 7:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_BOOLEAN;case 0:default:return __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_TYPE_STRING;}}},{key:'editPDL',value:function editPDL(add,fieldDef,values){var parentNestedValueId=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var catalog=this.props.catalog;this.props.updatePredefinedList(catalog.catalogId,fieldDef,add&&values,!add&&values,parentNestedValueId);}},{key:'renderFieldTypeData',value:function renderFieldTypeData(field){var _this3=this;var _props5=this.props,formatMessage=_props5.intl.formatMessage,isCreate=_props5.isCreate;// String, decimal, and datetime fields have an extra form field.
// Compute the type-dependent properties of the form field.
var label=__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_MAX_LENGTH;var formFieldName='';switch(field.type){case __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL:label=__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_PRECISION;formFieldName='precision';break;case __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DATETIME:label=__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_SHOW_TIME;formFieldName='showTime';break;case __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].STRING:formFieldName='maxLength';break;default:}var isDateField='showTime'===formFieldName;var isDecimalField='precision'===formFieldName;var fieldProps={id:makeFieldId(formFieldName,isCreate),name:formFieldName,component:isDateField?__WEBPACK_IMPORTED_MODULE_15_view_Forms_BulmaCheckRadio__["a" /* default */]:'input',type:'',onKeyPress:undefined,props:{},className:'',style:{},disabled:Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["E" /* isFieldDisabled */])(field)||Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["D" /* isFieldDefInSystemCategory */])(field)};if(isDateField){fieldProps.type='checkbox';fieldProps.props={className:'checkradio-inline'};}else{fieldProps.className='input';fieldProps.style={width:'70px'};fieldProps.onKeyPress=this.handleTextFieldOnKeyPress;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{lineHeight:'40px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:'type'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_FIELD_TYPE),':',' '),isCreate?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'field select',style:{verticalAlign:'middle'},'data-test-name':'field-type'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:'select',id:'field-type',name:'type'},FIELD_TYPES.map(function(t){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'t'+t,value:t,'data-test-name':'field-type-'+t},formatMessage(_this3.fieldTypeToLocalizedString(t)));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:'value',className:'has-text-dark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],this.fieldTypeToLocalizedString(field.type)))),formFieldName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:'data',style:{paddingLeft:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:'label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],label),':',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],fieldProps),isDecimalField&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{paddingLeft:'10px'}},formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_PRECISION_MAX),': ',__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["f" /* MAX_DECIMAL_PRECISION */])));}},{key:'renderMetadataMappings',value:function renderMetadataMappings(){var _this4=this;var _props6=this.props,field=_props6.field,fieldDefinitions=_props6.fieldDefinitions,intl=_props6.intl,metadataDefinitions=_props6.metadataDefinitions,metadataMappings=_props6.metadataMappings;var allEmbeddables=Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["w" /* getEmbeddableMetadataOptions */])(metadataDefinitions);var embedMetadata=field.id===__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["e" /* ID_DISABLED_FIELD_DEF */]?metadataDefinitions.find(function(md){return md.displayName===field.systemName;}):Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["u" /* getEmbedMappingMetadataDef */])(field.id,metadataDefinitions,metadataMappings);var extractMetadata=field.id===__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["e" /* ID_DISABLED_FIELD_DEF */]?[metadataDefinitions.find(function(md){return md.displayName===field.systemName;})]:Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["x" /* getExtractMetadataForField */])(field.id,metadataMappings,metadataDefinitions);var disabled=Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["E" /* isFieldDisabled */])(field);var boxStyle=disabled?{backgroundColor:'var(--formDisabledBackgroundColor)'}:{};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control box',style:boxStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_USE_METADATA)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field fields-mapping-section is-indented-large'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_EXTRACT)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'has-text-dark'},extractMetadata&&extractMetadata.length>0&&extractMetadata.map(function(md){return md&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__FieldFormMappings__["b" /* ExtractMetadataMappingRow */],{disabled:disabled,fdId:field.id,key:md.id,md:md,removeMapping:_this4.removeMapping});}),!disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fields-mapping-row label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_ADD_EXTRACT_METADATA),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button is-primary is-inverted','data-test-name':'add-extract-mapping',disabled:disabled,onClick:this.showAddExtractMappingSelect,type:'button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-plus-circle'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field fields-mapping-section is-indented-large'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_EMBED)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control fields-mapping-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{disabled:disabled,onChange:this.setEmbedMapping,value:embedMetadata?embedMetadata.id:__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["n" /* NOT_FOUND */],'data-test-name':'embed-into-select'},allEmbeddables.map(function(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:e.id,value:e.id,'data-test-name':'embed-into-field'},e.label);})))),embedMetadata&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'is-indented'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__FieldFormMappings__["c" /* MappingWarnings */],{field:field,fieldDefinitions:fieldDefinitions,intl:intl,metadataDef:embedMetadata,metadataMappings:metadataMappings}))));}},{key:'renderLargeTextField',value:function renderLargeTextField(field){return this.renderTextField(field,'is-medium');}},{key:'renderTextField',value:function renderTextField(field,className){var disabled=field.disabled,input=field.input,maxLength=field.maxLength,_field$meta=field.meta,touched=_field$meta.touched,error=_field$meta.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',Object.assign({},input,{id:field.id,className:'input '+(error?'is-danger':'')+' '+className,disabled:disabled,onKeyPress:this.handleTextFieldOnKeyPress,onKeyUp:this.handleTextFieldOnKeyUp,maxLength:maxLength})),touched&&error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'help is-danger'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],error)));}},{key:'render',value:function render(){var _props7=this.props,activePanelId=_props7.activePanelId,field=_props7.field,hideDialogPanel=_props7.hideDialogPanel,formatMessage=_props7.intl.formatMessage,isCreate=_props7.isCreate,metadataDefinitions=_props7.metadataDefinitions,metadataMappings=_props7.metadataMappings,showModalPrompt=_props7.showModalPrompt;var disabled=Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["E" /* isFieldDisabled */])(field);// disallow changing a multi-valued field to a single-valued one
var isMultivaluedDisabled=!isCreate&&field&&field.isMultivalued;var boxStyle=disabled?{backgroundColor:'var(--formDisabledBackgroundColor)'}:{};if(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portfolio-form-container '+(isCreate?'':'is-textured'),'data-test-name':'field-form'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* Form */],{onSubmit:function onSubmit(){},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control '+(isCreate?'':'box'),style:boxStyle},!isCreate&&Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["D" /* isFieldDefInSystemCategory */])(field)?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title is-4',style:{margin:'0 5px'}},field.systemName):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderLargeTextField,id:makeFieldId('systemName',isCreate),name:'systemName',disabled:disabled,maxLength:__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["h" /* MAX_SYSTEM_NAME_FIELD_LEN */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:'5px'},'data-test-name':'field-type'},this.renderFieldTypeData(field)),!Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["C" /* isDateField */])(field)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'defaultValueLabel',style:{padding:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_DEFAULT_VALUE)),field.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].BOOLEAN?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_15_view_Forms_BulmaCheckRadio__["a" /* default */],id:makeFieldId('defaultValue',isCreate),name:'defaultValue',disabled:disabled,type:'checkbox'}):field.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].NUMBER||field.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].DECIMAL?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'input',component:'input',id:makeFieldId('defaultValue',isCreate),name:'defaultValue',disabled:disabled,type:'number',onKeyPress:this.handleDefaultValueKeyPress}):field.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].TEXTBLOCK?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'textarea',component:'textarea',id:makeFieldId('defaultValue',isCreate),name:'defaultValue',disabled:disabled}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:this.renderTextField,id:makeFieldId('defaultValue',isCreate),name:'defaultValue',disabled:disabled,maxLength:field.maxLength||__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["g" /* MAX_STRING_MAX_LENGTH */]})),Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["o" /* canHaveMultipleValues */])(field)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_15_view_Forms_BulmaCheckRadio__["a" /* default */],id:makeFieldId('is-multivalued',isCreate),label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES),name:'isMultivalued',type:'checkbox',disabled:disabled||isMultivaluedDisabled}),Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["p" /* canHavePredefinedValues */])(field)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_15_view_Forms_BulmaCheckRadio__["a" /* default */],id:makeFieldId('has-predefined-values',isCreate),label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES),name:'hasPredefinedValues',type:'checkbox',disabled:disabled,onChange:this.handleHasPredefinedValuesCheckboxChange}),Object(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["p" /* canHavePredefinedValues */])(field)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:'30px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_15_view_Forms_BulmaCheckRadio__["a" /* default */],id:makeFieldId('allow-only-predefined-values',isCreate),label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES),name:'usePredefinedOnly',type:'checkbox',disabled:disabled||!field.hasPredefinedValues}))),field.hasPredefinedValues&&!isCreate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PredefinedList__["a" /* default */],{intl:this.props.intl,editPDL:this.editPDL,fieldDef:field,reduxFormInput:function reduxFormInput(){},showModalPrompt:showModalPrompt,submitFieldValue:function submitFieldValue(){}}),!isCreate&&this.renderMetadataMappings()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__FieldFormMappings__["a" /* AddExtractMapping */],{activePanelId:activePanelId,addExtract:this.addExtractMapping,field:field,hideDialogPanel:hideDialogPanel,formatMessage:formatMessage,mappings:metadataMappings,mds:metadataDefinitions}));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-message'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_NO_FIELD_SELECTED_MESSAGE));}}}]);return FieldForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function makeFieldId(id,isCreate){return''+id+(isCreate?'_create':'');}function validate(data,props){var errors={};var newName=data.systemName&&data.systemName.trim();if(!props.isCreate&&!newName){errors.systemName=__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].REQUIRED_FIELD_ERROR;}if(props.isCreate&&newName){var found=props.fieldNames.find(function(old){return old.toLowerCase()===newName.toLowerCase();});if(found){errors.systemName='duplicate';}}return errors;}function asyncValidate(values,dispatch,props,blurredField){if(!props.valid){return new Promise(function(resolve,reject){props.reset();dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));});}if(blurredField==='defaultValue'){values['defaultValues']=values.defaultValue===''?[]:[values.defaultValue.toString().trim()];}if(blurredField==='systemName'){var newSystemName=values['systemName']=values['systemName'].trim();if(props.field['systemName']!==newSystemName&&props.fieldNames.find(function(old){return old.toLowerCase()===newSystemName.toLowerCase();})){/* eslint-disable no-throw-literal */return new Promise(function(resolve,reject){throw{systemName:__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].DUPLICATE_FIELD_NAME_ERROR};});}else{props.setSelectedFieldsListItemName(newSystemName);setTimeout(function(){var element=document.getElementById('fli-'+newSystemName);element&&element.scrollIntoView();},250);}}return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["E" /* updateFields */])(props.catalog.catalogId,[values]));}var editForm=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({asyncValidate:asyncValidate,form:'FieldForm',validate:validate,asyncBlurFields:['isMultivalued','defaultValue','maxLength','precision','showTime','systemName','usePredefinedOnly']})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(FieldForm));var editFormState=function editFormState(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["c" /* getActivePanelId */])(state),field:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["_18" /* getSelectedField */])(state),fieldDefinitions:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["H" /* getFields */])(state),fieldNames:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["G" /* getFieldNames */])(state),metadataDefinitions:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["_9" /* getMetadataDefinitions */])(state),metadataMappings:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["_10" /* getMetadataMappings */])(state)};};var reduxCreateForm=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_5_util_constants__["v" /* CREATE_FIELD_FORM */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(FieldForm));var createFormValueSelector=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_5_util_constants__["v" /* CREATE_FIELD_FORM */]);var createFormState=function createFormState(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["c" /* getActivePanelId */])(state),fieldDefinitions:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["H" /* getFields */])(state),fieldNames:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["G" /* getFieldNames */])(state),isCreate:true,metadataDefinitions:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["_9" /* getMetadataDefinitions */])(state),metadataMappings:Object(__WEBPACK_IMPORTED_MODULE_12_state_selectors__["_10" /* getMetadataMappings */])(state),systemName:createFormValueSelector(state,'systemName'),type:createFormValueSelector(state,'type')};};var makeForm=function makeForm(form,stateFunction){return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateFunction,function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__["a" /* bindActionCreatorsForm */])({createMetadataMappings:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["g" /* createMetadataMappings */],deleteMetadataMappings:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["k" /* deleteMetadataMappings */],getFieldsAction:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["p" /* getFields */],hideDialogPanel:hideDialogPanel,removeAllPredefinedValuesAction:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["s" /* removeAllPredefinedValues */],setEmbedMetadataMapping:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["z" /* setEmbedMetadataMapping */],setSelectedFieldsListItemName:setSelectedFieldsListItemName,showDialogPanel:showDialogPanel,showModalPrompt:showModalPrompt,updateFieldsAction:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["E" /* updateFields */],updatePredefinedList:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["F" /* updatePredefinedList */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(form));};/* harmony default export */ __webpack_exports__["b"] = (makeForm(editForm,editFormState));var CreateFieldForm=makeForm(reduxCreateForm,createFormState);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["a"] = createCertRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteCertRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCertStatus;
/* harmony export (immutable) */ __webpack_exports__["e"] = uploadCert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
var initialState={certificate:undefined,request:undefined};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["i" /* GET_CERT_STATUS_SUCCESS */]:return Object.assign({},state,{certificate:action.payload.certificate,request:action.payload.request});default:return state;}}function createCertRequest(adminSession,certRequest){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["a" /* CREATE_CERT_REQUEST */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["c" /* CREATE_CERT_REQUEST_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["b" /* CREATE_CERT_REQUEST_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/certificate/create-request',{params:{session:adminSession},data:certRequest});}};}function deleteCertRequest(adminSession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["d" /* DELETE_CERT_REQUEST */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["f" /* DELETE_CERT_REQUEST_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["e" /* DELETE_CERT_REQUEST_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/certificate/request/_delete',{params:{session:adminSession}});}};}function getCertStatus(adminSession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["g" /* GET_CERT_STATUS */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["i" /* GET_CERT_STATUS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["h" /* GET_CERT_STATUS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/certificate/status',{params:{session:adminSession}});}};}function uploadCert(adminSession,formData){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["j" /* IMPORT_CERT */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["l" /* IMPORT_CERT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_certTypes__["k" /* IMPORT_CERT_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/certificate/import',{params:{session:adminSession},formData:formData});}};}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCertStatusText;
/* unused harmony export isCertExpired */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCertStatusStyle;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeSANs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_types__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_state_types__);
function getCertStatusText(info){if(!info||!info.issuer||!info.owner||!info.endDate){return __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_INVALID;}if(info.issuer.indexOf('127.0.0.1')>=0){return __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_SELF_SIGNED;}if(isCertExpired(info)){return __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_EXPIRED;}return __WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_IMPORTED;}function isCertExpired(info){if(!info||!info.endDate){return false;}var endDate=new Date(info.endDate);return endDate.getTime()<new Date().getTime();}function getCertStatusStyle(info){var status=getCertStatusText(info);if(status===__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_SELF_SIGNED){return'has-text-danger';}else if(status===__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_INVALID||status===__WEBPACK_IMPORTED_MODULE_0_util_localizedStrings__["a" /* default */].CERTIFICATE_STATUS_EXPIRED){return'has-text-danger';}return'';}// Create a list of SANs from a comma-delimited string, trim whitespace, and add the FQDN if needed
function normalizeSANs(cdList,fqdn){if(!cdList){cdList='';}var stringArray=cdList.split(',');var saNames=[];var removeWhiteSpaceRegExp=/\s+/g;var includesFqdn=false;stringArray.forEach(function(name){name=name.replace(removeWhiteSpaceRegExp,'');if(name){if(fqdn&&name===fqdn){includesFqdn=true;}saNames.push(name);}});if(!includesFqdn&&fqdn){saNames.push(fqdn);}return saNames;}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DirectoryServiceDescriptionPage=function(_Component){_inherits(DirectoryServiceDescriptionPage,_Component);function DirectoryServiceDescriptionPage(){_classCallCheck(this,DirectoryServiceDescriptionPage);var _this=_possibleConstructorReturn(this,(DirectoryServiceDescriptionPage.__proto__||Object.getPrototypeOf(DirectoryServiceDescriptionPage)).call(this));_this.onClickDelete=_this.onClickDelete.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(DirectoryServiceDescriptionPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getAdminProperties([__WEBPACK_IMPORTED_MODULE_6_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].directoryServiceDescription]);}},{key:'submit',value:function submit(values){var _props=this.props,createDirectoryServiceDescription=_props.createDirectoryServiceDescription,updateDirectoryServiceDescription=_props.updateDirectoryServiceDescription;var desc=Object.assign({},values,{cacheCredentials:true,deleteMissingUsersOnUpdate:true,serviceType:'ActiveDirectory',updateInterval:1440});if(values.uuid){updateDirectoryServiceDescription(desc);}else{createDirectoryServiceDescription(desc);}}},{key:'onClickDelete',value:function onClickDelete(){var _props2=this.props,deleteDirectoryServiceDescription=_props2.deleteDirectoryServiceDescription,directoryServiceDescription=_props2.directoryServiceDescription;directoryServiceDescription&&directoryServiceDescription.uuid&&deleteDirectoryServiceDescription(directoryServiceDescription.uuid);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.directoryServiceDescription!==nextProps.directoryServiceDescription){this.initializeFields(nextProps.directoryServiceDescription);}}},{key:'initializeFields',value:function initializeFields(directoryServiceDescription){this.props.initialize(directoryServiceDescription);}},{key:'render',value:function render(){var _props3=this.props,directoryServiceDescription=_props3.directoryServiceDescription,handleSubmit=_props3.handleSubmit,formatMessage=_props3.intl.formatMessage,invalid=_props3.invalid,isCommunicatingWithDirectoryService=_props3.isCommunicatingWithDirectoryService,pristine=_props3.pristine,reset=_props3.reset;var hasUuid=directoryServiceDescription&&directoryServiceDescription.uuid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents-textured portfolio-form-container','data-test-name':'directory-service-description-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit(this.submit)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_CONFIG_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{labelClassName:'is-medium',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].HOSTNAME)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input is-medium '+(hasUuid?'is-static':''),disabled:hasUuid,component:'input',id:'hostname',name:'hostname',style:{width:'450px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].PORT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input dir-svc-desc-form-field-small-width',component:'input',id:'port',max:65535,min:0,name:'port',type:'number'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].DEFAULT_PORT_NON_SSL),' ','389'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].DEFAULT_PORT_SSL),' 636')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].USE_SSL)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__["a" /* default */],id:'useLdaps',name:'useLdaps',type:'checkbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LDAP_BIND_USERNAME)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input dir-svc-desc-form-field-medium-width',component:'input',id:'loginDN',name:'loginDN'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].PASSWORD)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{autoComplete:'new-password',className:'input dir-svc-desc-form-field-medium-width',component:'input',id:'credential',name:'credential',type:'password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].SYNC_DAILY)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__["a" /* default */],id:'autoUpdate',name:'autoUpdate',type:'checkbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-desc-form-button-group',style:{maxWidth:'500px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:!hasUuid||isCommunicatingWithDirectoryService,onClick:this.onClickDelete,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].REMOVE_DIRECTORY_SERVICE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:pristine||isCommunicatingWithDirectoryService,onClick:reset,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary '+(isCommunicatingWithDirectoryService?'is-loading':''),type:'submit',disabled:pristine|invalid||isCommunicatingWithDirectoryService},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].APPLY))))))));}}]);return DirectoryServiceDescriptionPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};var maxFieldLen=255;if(!data.hostname){errors.hostname='Required';}if(!data.port){errors.port='Required';}if(data.hostname&&data.hostname.length>maxFieldLen){errors.hostname='Invalid';}if(data.loginDN&&data.loginDN.length>maxFieldLen){errors.loginDN='Invalid';}if(data.credential&&data.credential.length>maxFieldLen){errors.credential='Invalid';}return errors;}var FORM_NAME='Directory Service Description';var form=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({destroyOnUnmount:false,form:FORM_NAME,validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(DirectoryServiceDescriptionPage));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directoryServiceDescription:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["v" /* getDirectoryServiceDescription */])(state),isCommunicatingWithDirectoryService:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["P" /* getIsCommunicatingWithDirectoryService */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({createDirectoryServiceDescription:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["c" /* createDirectoryServiceDescription */],deleteDirectoryServiceDescription:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["d" /* deleteDirectoryServiceDescription */],getAdminProperties:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["e" /* getAdminProperties */],updateDirectoryServiceDescription:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["r" /* updateDirectoryServiceDescription */]});})(form));

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DestinationsView__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SourcesView__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_reducers_dirSvcReducer__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var resetState=__WEBPACK_IMPORTED_MODULE_11_state_reducers_dirSvcReducer__["a" /* actions */].resetState;var DirectoryServicesMappingsPage=function(_Component){_inherits(DirectoryServicesMappingsPage,_Component);function DirectoryServicesMappingsPage(){_classCallCheck(this,DirectoryServicesMappingsPage);var _this=_possibleConstructorReturn(this,(DirectoryServicesMappingsPage.__proto__||Object.getPrototypeOf(DirectoryServicesMappingsPage)).call(this));_this.handleClose=_this.handleClose.bind(_this);return _this;}_createClass(DirectoryServicesMappingsPage,[{key:'handleClose',value:function handleClose(){var _props=this.props,hideDialogPanel=_props.hideDialogPanel,resetState=_props.resetState;resetState();hideDialogPanel();}},{key:'renderHeader',value:function renderHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dialog-panel-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dialog-panel-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_MAPIINGS),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete is-large is-pulled-right','data-test-name':'cancel',onClick:this.handleClose})));}},{key:'render',value:function render(){var activePanelId=this.props.activePanelId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'1180px',height:'90%'},dataTestName:'directory-services-configuration-mappings',hideDialogPanel:this.props.hideDialogPanel,panelHeader:this.renderHeader(),panelId:__WEBPACK_IMPORTED_MODULE_7_util_constants__["H" /* DIR_SVC_MAPPINGS_PANEL_ID */],showFooter:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-gapless',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SourcesView__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DestinationsView__["a" /* default */],null)));}}]);return DirectoryServicesMappingsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["c" /* getActivePanelId */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],resetState:resetState});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(DirectoryServicesMappingsPage)));

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TreeContainer__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_nodes__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__renderers__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilteringContainer__ = __webpack_require__(966);
/* unused harmony reexport selectors */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__renderers__["a"]; });
/* unused harmony reexport constants */
/* unused harmony reexport FilteringContainer */






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TreeContainer__["a" /* default */]);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFlattenedTree; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var isNodeExpanded = function isNodeExpanded(node) {
  return node.state && node.state.expanded;
};
var nodeHasChildren = function nodeHasChildren(node) {
  return node.children && node.children.length;
};

var getFlattenedTree = function getFlattenedTree(nodes) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return nodes.reduce(function (flattenedTree, node) {
    var deepness = parents.length;
    var nodeWithHelpers = _extends({}, node, { deepness: deepness, parents: parents });

    if (!nodeHasChildren(node) || !isNodeExpanded(node)) {
      return [].concat(flattenedTree, [nodeWithHelpers]);
    }

    return [].concat(flattenedTree, [nodeWithHelpers], getFlattenedTree(node.children, [].concat(parents, [node.id])));
  }, []);
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
var initialState={extensisAccount:null,isPendingResponse:false,licenseMaintenanceEndDate:null,extensisSystems:[]};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["g" /* GET_EXTENSIS_ACCOUNT_SUCCESS */]:return Object.assign({},state,{extensisAccount:action.payload.account});case __WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["j" /* GET_EXTENSIS_SYSTEMS_SUCCESS */]:return Object.assign({},state,{extensisSystems:action.payload});case __WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["m" /* GET_LICENSING_INFO_SUCCESS */]:return Object.assign({},state,{licenseMaintenanceEndDate:action.payload.maintenanceEndDate});case __WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["d" /* CLEAR_IS_PENDING_RESPONSE */]:return Object.assign({},state,{isPendingResponse:false});case __WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["t" /* SET_IS_PENDING_RESPONSE */]:return Object.assign({},state,{isPendingResponse:true});default:return state;}}function getExtensisAccount(adminSession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["e" /* GET_EXTENSIS_ACCOUNT */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["g" /* GET_EXTENSIS_ACCOUNT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["f" /* GET_EXTENSIS_ACCOUNT_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/extensisAccount',{params:{session:adminSession}});}};}function setExtensisAccount(adminSession,account,password){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["n" /* SET_EXTENSIS_ACCOUNT */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["p" /* SET_EXTENSIS_ACCOUNT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["o" /* SET_EXTENSIS_ACCOUNT_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/extensisAccount',{params:{session:adminSession},data:{account:account,password:password}});}};}function getExtensisSystems(adminSession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["h" /* GET_EXTENSIS_SYSTEMS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["j" /* GET_EXTENSIS_SYSTEMS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["i" /* GET_EXTENSIS_SYSTEMS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/extensisAccount/systems',{params:{session:adminSession}});}};}function setExtensisSystem(adminSession,systemId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["q" /* SET_EXTENSIS_SYSTEM */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["s" /* SET_EXTENSIS_SYSTEM_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["r" /* SET_EXTENSIS_SYSTEM_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/extensisAccount/system/'+systemId,{params:{session:adminSession}});}};}function getLicensingInfo(adminSession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["k" /* GET_LICENSING_INFO */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["m" /* GET_LICENSING_INFO_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["l" /* GET_LICENSING_INFO_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/extensisAccount/licensingInfo',{params:{session:adminSession}});}};}function addLicense(adminSession,serialNumber){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["a" /* ADD_LICENSE */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["c" /* ADD_LICENSE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["b" /* ADD_LICENSE_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/serial-number/'+serialNumber,{params:{session:adminSession}});}};}function clearIsPendingResponse(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["d" /* CLEAR_IS_PENDING_RESPONSE */]};}function setIsPendingResponse(){return{type:__WEBPACK_IMPORTED_MODULE_0_state_types_licenseTypes__["t" /* SET_IS_PENDING_RESPONSE */]};}var actions={addLicense:addLicense,clearIsPendingResponse:clearIsPendingResponse,getExtensisAccount:getExtensisAccount,getExtensisSystems:getExtensisSystems,getLicensingInfo:getLicensingInfo,setExtensisAccount:setExtensisAccount,setExtensisSystem:setExtensisSystem,setIsPendingResponse:setIsPendingResponse};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateUserForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditUserForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_collapse__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_userCommands__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__submitUser__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_util_emailUtils__ = __webpack_require__(400);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserForm=function(_Component){_inherits(UserForm,_Component);function UserForm(){_classCallCheck(this,UserForm);var _this=_possibleConstructorReturn(this,(UserForm.__proto__||Object.getPrototypeOf(UserForm)).call(this));_this.initializeFields=_this.initializeFields.bind(_this);_this.handleAPIToggle=_this.handleAPIToggle.bind(_this);return _this;}_createClass(UserForm,[{key:'fieldStyle',value:function fieldStyle(fieldName){var _props=this.props,formErrors=_props.formErrors,meta=_props.meta;var hasError=formErrors[fieldName]&&meta[fieldName]&&meta[fieldName].touched;return'input '+(hasError&&'is-danger');}},{key:'componentDidMount',value:function componentDidMount(){var user=this.props.user;this.initializeFields(user);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.user!==nextProps.user){this.initializeFields(nextProps.user);}}},{key:'initializeFields',value:function initializeFields(user){var initialize=this.props.initialize;initialize(user);}},{key:'handleAPIToggle',value:function handleAPIToggle(){if(this.accountField){var inputElement=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.accountField);inputElement instanceof HTMLInputElement&&inputElement.focus();}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,addUserToAllCatalogs=_props2.addUserToAllCatalogs,formErrors=_props2.formErrors,fromLDAP=_props2.fromLDAP,handleSubmit=_props2.handleSubmit,_props2$intl=_props2.intl,formatDate=_props2$intl.formatDate,formatMessage=_props2$intl.formatMessage,formatTime=_props2$intl.formatTime,intl=_props2.intl,invalid=_props2.invalid,isCreate=_props2.isCreate,isToken=_props2.isToken,pristine=_props2.pristine,reset=_props2.reset,roles=_props2.roles,submitting=_props2.submitting,user=_props2.user;var isFullAdmin=user.name===__WEBPACK_IMPORTED_MODULE_12_util_constants__["e" /* ADMIN_USER_NAME */];var shortNameStyle=this.fieldStyle('name');var passwordStyle=this.fieldStyle('password');var createdValue=user.creationDate&&formatDate(user.creationDate)+' '+formatTime(user.creationDate);var modifiedValue=user.lastModifiedDate&&formatDate(user.lastModifiedDate)+' '+formatTime(user.lastModifiedDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container '+(isCreate?'page':'is-textured'),'data-test-name':'general-users-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(!isCreate?'box':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit(__WEBPACK_IMPORTED_MODULE_11__submitUser__["a" /* default */]),style:{maxWidth:'700px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_ACCOUNT),labelClassName:'is-medium',readonly:fromLDAP||isFullAdmin,value:user.name,dataTestName:'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{className:'is-medium '+shortNameStyle,component:'input',id:isCreate?'name-create':'name',name:'name',type:'text',ref:function ref(_ref){_this2.accountField=_ref;},withRef:true})),isCreate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field',style:{marginLeft:'185px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_view_Forms_BulmaCheckRadio__["a" /* default */],type:'checkbox',className:'switch is-rounded',name:'isToken',id:'isToken',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].API_TOKEN_CREATE),onChange:this.handleAPIToggle})),!isCreate&&!isToken&&!isFullAdmin&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal',key:'authType'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].ACCOUNT_TYPE_LDAP))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_view_Forms_BulmaCheckRadio__["a" /* default */],id:'authType-checkbox',name:'fromLDAP',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-small'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_collapse__["UnmountClosed"],{isOpened:!isToken,springConfig:{stiffness:250,damping:25}},!fromLDAP&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].PASSWORD)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{autoComplete:'new-password',className:passwordStyle,component:'input',id:'password',name:'password',placeholder:isCreate?'':'************************',type:'password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].FULL_NAME),readonly:fromLDAP,value:user.longName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{className:'input '+(formErrors.longName?'is-danger':''),component:'input',id:'longName',name:'longName',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].EMAIL_ADDRESS),readonly:fromLDAP,value:user.email},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{className:'input '+(formErrors.email?'is-danger':''),component:'input',id:'email',name:'email',type:'text',style:{marginBottom:''+(!isCreate?'0.75rem':'')}}))),isToken&&!isCreate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].TOKEN),readonly:true,value:user.token,'data-test-name':'token'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NOTES)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{className:'textarea '+(formErrors.notes?'is-danger':''),component:'textarea',id:isCreate?'notes-create':'notes',name:'notes',type:'textarea'})),isCreate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:'185px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_view_Forms_BulmaCheckRadio__["a" /* default */],id:'addUserToAllCatalogs','data-test-name':'add-user-to-all-catalogs',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS),name:'addUserToAllCatalogs',type:'checkbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:'select',disabled:!addUserToAllCatalogs,id:'roleName',name:'roleName'},roles.map(function(role){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:role.name,value:role.name,'data-test-name':'role-name-'+role.name},Object(__WEBPACK_IMPORTED_MODULE_14_util_roleUtils__["e" /* getLocalizedRoleName */])(intl,role.name));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-size-7 is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_NEW_USER_INFO_MSG))),!isCreate&&fromLDAP&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:'LDAP DN',readonly:true,value:user.ldapSourceDN,'data-test-name':'sourceDn'}),!isCreate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CREATED_ON_DATE),readonly:true,value:createdValue,'data-test-name':'dateCreated'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LAST_MODIFIED_DATE),readonly:true,value:modifiedValue,'data-test-name':'dateModified'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:pristine|submitting,onClick:reset,type:'button','data-test-name':'revert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary '+(submitting?'is-loading':''),type:'submit',disabled:pristine|invalid|submitting,'data-test-name':'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].APPLY)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'})))));}}]);return UserForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};var maxFieldLen=255;function userExists(user){return props.users.some(function(u){return(// Case insensitive comparison
u.name.localeCompare(user.name,undefined,{sensitivity:'accent',usage:'search'})===0&&u.uuid!==user.uuid);});}if(!data.name||data.name.length>maxFieldLen||userExists(data)){errors.name='Invalid';}if(data.email&&(data.email.length>maxFieldLen||!Object(__WEBPACK_IMPORTED_MODULE_15_util_emailUtils__["a" /* isEmailLegal */])(String(data.email)))){errors.email='Invalid';}if(data.password&&data.password.length>maxFieldLen){errors.password='Invalid';}if(props.isCreate&&!data.password){errors.password='Invalid';}if(data.longName&&data.longName.length>maxFieldLen){errors.longName='Invalid';}if(data.notes&&data.notes.length>maxFieldLen){errors.notes='Invalid';}return errors;}var createUserFormIntl=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_12_util_constants__["A" /* CREATE_USER_FORM */],onSubmit:__WEBPACK_IMPORTED_MODULE_11__submitUser__["a" /* default */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(UserForm));var createUserFormSelector=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_12_util_constants__["A" /* CREATE_USER_FORM */]);var CreateUserForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{addUserToAllCatalogs:createUserFormSelector(state,'addUserToAllCatalogs'),formErrors:Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["g" /* getFormSyncErrors */])(__WEBPACK_IMPORTED_MODULE_12_util_constants__["A" /* CREATE_USER_FORM */])(state),meta:Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["f" /* getFormMeta */])(__WEBPACK_IMPORTED_MODULE_12_util_constants__["A" /* CREATE_USER_FORM */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["_34" /* getUsers */])(state),isToken:createUserFormSelector(state,'isToken'),roles:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["_15" /* getRoles */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({createUser:__WEBPACK_IMPORTED_MODULE_9_state_commands_userCommands__["a" /* createUser */]});})(createUserFormIntl);var editUserFormIntl=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_12_util_constants__["_15" /* USER_DETAILS_FORM */],onSubmit:__WEBPACK_IMPORTED_MODULE_11__submitUser__["a" /* default */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(UserForm));var editUserFormSelector=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_12_util_constants__["_15" /* USER_DETAILS_FORM */]);var EditUserForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{formErrors:Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["g" /* getFormSyncErrors */])(__WEBPACK_IMPORTED_MODULE_12_util_constants__["_15" /* USER_DETAILS_FORM */])(state),meta:Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["f" /* getFormMeta */])(__WEBPACK_IMPORTED_MODULE_12_util_constants__["A" /* CREATE_USER_FORM */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["_34" /* getUsers */])(state),isToken:editUserFormSelector(state,'isToken'),fromLDAP:editUserFormSelector(state,'fromLDAP')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({updateUser:__WEBPACK_IMPORTED_MODULE_9_state_commands_userCommands__["d" /* updateUser */]});})(editUserFormIntl);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__(383);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPRING_PRECISION = 1;

var WAITING = 'WAITING';
var RESIZING = 'RESIZING';
var RESTING = 'RESTING';
var IDLING = 'IDLING';

var noop = function noop() {
  return null;
};
var css = {
  collapse: 'ReactCollapse--collapse',
  content: 'ReactCollapse--content'
};

var Collapse = exports.Collapse = function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      currentState: IDLING,
      from: 0,
      to: 0
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isOpened = _props.isOpened,
          forceInitialAnimation = _props.forceInitialAnimation,
          onRest = _props.onRest;

      if (isOpened) {
        var to = this.getTo();
        if (forceInitialAnimation) {
          var from = this.wrapper.clientHeight;
          this.setState({ currentState: RESIZING, from: from, to: to });
        } else {
          this.setState({ currentState: IDLING, from: to, to: to });
        }
      }
      onRest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasNestedCollapse) {
        // For nested collapses we do not need to change to waiting state
        // and should keep `height:auto`
        // Because children will be animated and height will not jump anyway
        // See https://github.com/nkbt/react-collapse/issues/76 for more details
        if (nextProps.isOpened !== this.props.isOpened) {
          // Still go to WAITING state if own isOpened was changed
          this.setState({ currentState: WAITING });
        }
      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
        this.setState({ currentState: WAITING });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var _props2 = this.props,
          isOpened = _props2.isOpened,
          onRest = _props2.onRest,
          onMeasure = _props2.onMeasure;


      if (this.state.currentState === IDLING) {
        onRest();
        return;
      }

      if (prevState.to !== this.state.to) {
        onMeasure({ height: this.state.to, width: this.content.clientWidth });
      }

      var from = this.wrapper.clientHeight;
      var to = isOpened ? this.getTo() : 0;

      if (from !== to) {
        this.setState({ currentState: RESIZING, from: from, to: to });
        return;
      }

      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
        this.setState({ currentState: IDLING, from: from, to: to });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
        onRest: this.onRest,
        children: this.renderContent }));
    }
  }]);

  return Collapse;
}(_react2.default.PureComponent);

Collapse.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
  forceInitialAnimation: _propTypes2.default.bool,

  hasNestedCollapse: _propTypes2.default.bool,

  fixedHeight: _propTypes2.default.number,

  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
  style: _propTypes2.default.object,

  onRender: _propTypes2.default.func,
  onRest: _propTypes2.default.func,
  onMeasure: _propTypes2.default.func,

  children: _propTypes2.default.node.isRequired
};
Collapse.defaultProps = {
  forceInitialAnimation: false,
  hasNestedCollapse: false,
  fixedHeight: -1,
  style: {},
  theme: css,
  onRender: noop,
  onRest: noop,
  onMeasure: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onContentRef = function (content) {
    _this2.content = content;
  };

  this.onWrapperRef = function (wrapper) {
    _this2.wrapper = wrapper;
  };

  this.onRest = function () {
    _this2.raf = requestAnimationFrame(_this2.setResting);
  };

  this.setResting = function () {
    _this2.setState({ currentState: RESTING });
  };

  this.getTo = function () {
    var fixedHeight = _this2.props.fixedHeight;

    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
  };

  this.getWrapperStyle = function (height) {
    if (_this2.state.currentState === IDLING && _this2.state.to) {
      var fixedHeight = _this2.props.fixedHeight;

      if (fixedHeight > -1) {
        return { overflow: 'hidden', height: fixedHeight };
      }
      return { height: 'auto' };
    }

    if (_this2.state.currentState === WAITING && !_this2.state.to) {
      return { overflow: 'hidden', height: 0 };
    }

    return { overflow: 'hidden', height: Math.max(0, height) };
  };

  this.getMotionProps = function () {
    var springConfig = _this2.props.springConfig;


    return _this2.state.currentState === IDLING ? {
      // When completely stable, instantly jump to the position
      defaultStyle: { height: _this2.state.to },
      style: { height: _this2.state.to }
    } : {
      // Otherwise, animate
      defaultStyle: { height: _this2.state.from },
      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
    };
  };

  this.renderContent = function (_ref) {
    var height = _ref.height;

    // eslint-disable-line
    var _props3 = _this2.props,
        _isOpened = _props3.isOpened,
        _springConfig = _props3.springConfig,
        _forceInitialAnimation = _props3.forceInitialAnimation,
        _hasNestedCollapse = _props3.hasNestedCollapse,
        _fixedHeight = _props3.fixedHeight,
        theme = _props3.theme,
        style = _props3.style,
        onRender = _props3.onRender,
        _onRest = _props3.onRest,
        _onMeasure = _props3.onMeasure,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);

    var _state = _this2.state,
        from = _state.from,
        to = _state.to;

    // DANGEROUS, use with caution, never do setState with it

    onRender({ current: height, from: from, to: to });

    return _react2.default.createElement(
      'div',
      _extends({
        ref: _this2.onWrapperRef,
        className: theme.collapse,
        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
      }, props),
      _react2.default.createElement(
        'div',
        { ref: _this2.onContentRef, className: theme.content },
        children
      )
    );
  };
};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmailLegal;
var emailValidator=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;function isEmailLegal(email){return emailValidator.test(String(email).toLowerCase());}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getSites;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNPServerStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteNPSite;
/* harmony export (immutable) */ __webpack_exports__["d"] = setNPSiteEnabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_netPublishReducer__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var deleteSiteAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_netPublishReducer__["a" /* actions */].deleteSite,getNPServerStatusAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_netPublishReducer__["a" /* actions */].getNPServerStatus,getSitesAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_netPublishReducer__["a" /* actions */].getSites,setSiteEnabledAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_netPublishReducer__["a" /* actions */].setSiteEnabled;function getSites(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context.next=4;break;}_context.next=4;return dispatch(getSitesAction(session));case 4:case'end':return _context.stop();}}},_callee,this);}));function getSites(_x,_x2){return _ref.apply(this,arguments);}return getSites;}();}function getNPServerStatus(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context2.next=4;break;}_context2.next=4;return dispatch(getNPServerStatusAction(session));case 4:case'end':return _context2.stop();}}},_callee2,this);}));function getNPServerStatus(_x3,_x4){return _ref2.apply(this,arguments);}return getNPServerStatus;}();}function deleteNPSite(siteId){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context4.next=4;break;}_context4.next=4;return dispatch(showModalPrompt({isButton2Default:true,message:__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].NP_DELETE_SITE_CONFIRMATION,dataTestName:'delete-site-modal',onButton2:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return dispatch(deleteSiteAction(session,siteId));case 2:_context3.next=4;return dispatch(getSitesAction(session));case 4:case'end':return _context3.stop();}}},_callee3,this);}));function doDelete(){return _ref4.apply(this,arguments);}return doDelete;}()}));case 4:case'end':return _context4.stop();}}},_callee4,this);}));function getNPServerStatus(_x5,_x6){return _ref3.apply(this,arguments);}return getNPServerStatus;}();}function setNPSiteEnabled(siteId,enabled){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context5.next=6;break;}_context5.next=4;return dispatch(setSiteEnabledAction(session,siteId,enabled));case 4:_context5.next=6;return dispatch(getSitesAction(session));case 6:case'end':return _context5.stop();}}},_callee5,this);}));function getNPServerStatus(_x7,_x8){return _ref5.apply(this,arguments);}return getNPServerStatus;}();}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
var initialState={sites:[],status:{}};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["i" /* GET_NP_SITES_SUCCESS */]:return Object.assign({},state,{sites:action.payload.filter(function(site){return!site.isPreview;}).sort(function(a,b){return a.siteName.localeCompare(b.siteName);})});case __WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["f" /* GET_NP_SERVER_STATUS_SUCCESS */]:return Object.assign({},state,{status:action.payload});default:return state;}}function getSites(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["g" /* GET_NP_SITES */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["i" /* GET_NP_SITES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["h" /* GET_NP_SITES_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/netpublish/site',{params:{session:identitySession}});}};}function getNPServerStatus(identitySession){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["d" /* GET_NP_SERVER_STATUS */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["f" /* GET_NP_SERVER_STATUS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["e" /* GET_NP_SERVER_STATUS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/netpublish/server/status',{params:{session:identitySession}});}};}function setSiteEnabled(identitySession,siteId,isEnabled){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["a" /* DELETE_NP_SITE */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["c" /* DELETE_NP_SITE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["b" /* DELETE_NP_SITE_FAIL */]],promise:function promise(client,getState){return client.put(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/netpublish/site/'+siteId+'/setEnabled',{params:{session:identitySession,enabled:isEnabled}});}};}function deleteSite(identitySession,siteId){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["j" /* SET_NP_SITE_ENABLED */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["l" /* SET_NP_SITE_ENABLED_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_netPublishTypes__["k" /* SET_NP_SITE_ENABLED_FAIL */]],promise:function promise(client,getState){return client.delete(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/netpublish/site/'+siteId,{params:{session:identitySession}});}};}var actions={deleteSite:deleteSite,getSites:getSites,getNPServerStatus:getNPServerStatus,setSiteEnabled:setSiteEnabled};

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reportFormConfigs; });
/* harmony export (immutable) */ __webpack_exports__["a"] = localeToReportLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_state_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__ = __webpack_require__(3);
var reportFormConfigs=[{name:'asset-uploads',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].ASSET_UPLOADS,hasDateRange:true,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_ASSET_UPLOADS,viewName:'assetUploads'},{name:'asset-most-downloaded',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].ASSET_DOWNLOADS,hasDateRange:true,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_DOWNLOADED,viewName:'assetMostDownloaded'},{name:'asset-most-previewed',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].ASSET_PREVIEWS,hasDateRange:true,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_ASSET_PREVIEWS,viewName:'assetMostPreviewed'},{name:'asset-deletions',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_NAME_DELETED_BY,hasDateRange:true,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_DELETED_BY,viewName:'deleteBy'},{name:'asset-downloads',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_NAME_DOWNLOADED_BY,hasDateRange:true,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_DOWNLOADED_BY,viewName:'downloadBy'},{name:'file-types',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].FILE_TYPES,hasDateRange:false,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_FILE_TYPES,viewName:'fileTypes'},{name:'search-terms',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].SEARCH_TERMS,hasDateRange:true,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_SEARCH_TERMS,viewName:'searchTerms'},{name:'keyword-statistics',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].KEYWORD_STATISTICS,hasDateRange:false,organizerType:'CATALOGS',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_KEYWORD,viewName:'keywordStatistics'},{name:'netpublish-usage',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NETPUBLISH_USAGE,hasDateRange:true,organizerType:'NP_SITES',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_USAGE,viewName:'netpublishUsage'},{name:'netpublish-download-frequency',label:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].NETPUBLISH_MOST_DOWNLOADED,hasDateRange:true,organizerType:'NP_SITES',description:__WEBPACK_IMPORTED_MODULE_1_util_localizedStrings__["a" /* default */].REPORT_DESCRIPTION_DOWNLOADED,viewName:'netpublishDownloadFrequency'}];function localeToReportLocale(locale){var result='en_US';switch(locale){case'fr':result='fr_FR';break;case'de':result='de_DE';break;case'es':result='es_ES';break;case'it':result='it_IT';break;case'ja':result='ja_JP';break;default:break;}return result;}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMediaEngine;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteMediaEngine;
/* harmony export (immutable) */ __webpack_exports__["c"] = testMediaEngine;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateMediaEngine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__ = __webpack_require__(19);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var clearMediaEngineTestPending=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].clearMediaEngineTestPending,createMediaEngineAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].createMediaEngine,deleteMediaEngineAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].deleteMediaEngine,setMediaEngineTestPending=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].setMediaEngineTestPending,testMediaEngineAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].testMediaEngine,updateMediaEngineAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].updateMediaEngine;var getAdminPropertiesAction=__WEBPACK_IMPORTED_MODULE_2_state_reducers_serverReducer__["a" /* actions */].getAdminProperties;function createMediaEngine(mediaEngine){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var adminSession,identitySession;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:adminSession=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());identitySession=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!identitySession){_context.next=6;break;}_context.next=5;return dispatch(createMediaEngineAction(identitySession,mediaEngine)).catch(function(e){__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_logging__["a" /* default */].error(e);dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_ADD,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));});case 5:dispatch(getAdminPropertiesAction(adminSession,identitySession,[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].mediaEngines]));case 6:case'end':return _context.stop();}}},_callee,this);}));function createMediaEngine(_x,_x2){return _ref.apply(this,arguments);}return createMediaEngine;}();}function deleteMediaEngine(mediaEngineId){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var adminSession,identitySession;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:adminSession=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());identitySession=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!identitySession){_context2.next=6;break;}_context2.next=5;return dispatch(deleteMediaEngineAction(identitySession,mediaEngineId));case 5:dispatch(getAdminPropertiesAction(adminSession,identitySession,[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].mediaEngines]));case 6:case'end':return _context2.stop();}}},_callee2,this);}));function deleteMediaEngine(_x3,_x4){return _ref2.apply(this,arguments);}return deleteMediaEngine;}();}function testMediaEngine(mediaEngine,operationalMsg,notOperationalMsg){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var session,_ref4,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:session=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){_context3.next=9;break;}dispatch(setMediaEngineTestPending());_context3.next=5;return dispatch(testMediaEngineAction(session,mediaEngine));case 5:_ref4=_context3.sent;payload=_ref4.payload;dispatch(clearMediaEngineTestPending());if(payload.isOperational){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(operationalMsg,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["b" /* SUCCESS_LEVEL */]));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(notOperationalMsg,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}case 9:case'end':return _context3.stop();}}},_callee3,this);}));function testMediaEngine(_x5,_x6){return _ref3.apply(this,arguments);}return testMediaEngine;}();}function updateMediaEngine(mediaEngine,notOperationalMsg){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var adminSession,identitySession,testFailed,_ref6,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:adminSession=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["d" /* getAdminSession */])(getState());identitySession=Object(__WEBPACK_IMPORTED_MODULE_1_state_selectors__["L" /* getIdentitySession */])(getState());if(!identitySession){_context4.next=17;break;}testFailed=false;// if we're enabling a ME, test it before enabling it
if(!mediaEngine.enabled){_context4.next=10;break;}_context4.next=7;return dispatch(testMediaEngineAction(identitySession,mediaEngine));case 7:_ref6=_context4.sent;payload=_ref6.payload;testFailed=!payload||!payload.isOperational;case 10:if(!testFailed){_context4.next=14;break;}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(notOperationalMsg,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));_context4.next=17;break;case 14:_context4.next=16;return dispatch(updateMediaEngineAction(identitySession,mediaEngine));case 16:dispatch(getAdminPropertiesAction(adminSession,identitySession,[__WEBPACK_IMPORTED_MODULE_3_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].mediaEngines]));case 17:case'end':return _context4.stop();}}},_callee4,this);}));function updateMediaEngine(_x7,_x8){return _ref5.apply(this,arguments);}return updateMediaEngine;}();}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1016),
    keys = __webpack_require__(113);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1018),
    isArguments = __webpack_require__(408),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(232),
    isIndex = __webpack_require__(409),
    isTypedArray = __webpack_require__(410);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1019),
    isObjectLike = __webpack_require__(54);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1021),
    baseUnary = __webpack_require__(234),
    nodeUtil = __webpack_require__(235);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70),
    isObject = __webpack_require__(89);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1056),
    isObjectLike = __webpack_require__(54);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1057),
    arraySome = __webpack_require__(1060),
    cacheHas = __webpack_require__(1061);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(420),
    getSymbols = __webpack_require__(242),
    keys = __webpack_require__(113);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(421),
    isArray = __webpack_require__(44);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(426),
    toKey = __webpack_require__(162);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(44),
    isKey = __webpack_require__(243),
    stringToPath = __webpack_require__(1074),
    toString = __webpack_require__(1077);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(428),
    eq = __webpack_require__(239);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1092);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(421),
    getPrototype = __webpack_require__(237),
    getSymbols = __webpack_require__(242),
    stubArray = __webpack_require__(422);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(1128);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_debounce__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = __WEBPACK_IMPORTED_MODULE_2__helpers_color__["d" /* simpleCheckForValidColor */](data);
        if (isValidColor) {
          var colors = __WEBPACK_IMPORTED_MODULE_2__helpers_color__["e" /* toState */](data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = __WEBPACK_IMPORTED_MODULE_2__helpers_color__["d" /* simpleCheckForValidColor */](data);
        if (isValidColor) {
          var colors = __WEBPACK_IMPORTED_MODULE_2__helpers_color__["e" /* toState */](data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, __WEBPACK_IMPORTED_MODULE_2__helpers_color__["e" /* toState */](props.color, 0));

      _this.debounce = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_debounce__["a" /* default */])(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends({}, __WEBPACK_IMPORTED_MODULE_2__helpers_color__["e" /* toState */](nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"] || __WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

/* harmony default export */ __webpack_exports__["a"] = (ColorWrap);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__ = __webpack_require__(1135);



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = Object(__WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (baseEach);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deepPurple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return indigo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return lightBlue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return lightGreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return amber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deepOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brown; });
/* unused harmony export grey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return blueGrey; });
/* unused harmony export darkText */
/* unused harmony export lightText */
/* unused harmony export darkIcons */
/* unused harmony export lightIcons */
/* unused harmony export white */
/* unused harmony export black */
var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* unused harmony default export */ var _unused_webpack_default_export = ({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Chrome */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChromeFields__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChromePointer__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChromePointerCircle__ = __webpack_require__(1150);










var Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.saturation },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["g" /* Saturation */], {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: __WEBPACK_IMPORTED_MODULE_7__ChromePointerCircle__["a" /* default */],
        onChange: onChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.body },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.color },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.swatch },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.active }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["b" /* Checkboard */], { renderers: renderers })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.toggles },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.hue },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* Hue */], {
              style: styles.Hue,
              hsl: hsl,
              pointer: __WEBPACK_IMPORTED_MODULE_6__ChromePointer__["a" /* default */],
              onChange: onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.alpha },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Alpha */], {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: __WEBPACK_IMPORTED_MODULE_6__ChromePointer__["a" /* default */],
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ChromeFields__["a" /* default */], {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  disableAlpha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  defaultView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(Chrome));

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = rootReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serverReducer__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authReducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__catalogReducer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__certReducer__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dirSvcReducer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__netPublishReducer__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__roleReducer__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rtiReducer__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_intlReducer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_state_reducers_persistReducer__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__userReducer__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__licenseReducer__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_portfolio_shared_state_reducers_globalNotificationsReducer__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_portfolio_shared_state_reducers_reachoutReducer__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_state_types_globalTypes__ = __webpack_require__(325);
var reducers={auth:__WEBPACK_IMPORTED_MODULE_3__authReducer__["b" /* default */],catalog:__WEBPACK_IMPORTED_MODULE_4__catalogReducer__["b" /* default */],cert:__WEBPACK_IMPORTED_MODULE_5__certReducer__["b" /* default */],dialogPanel:__WEBPACK_IMPORTED_MODULE_12_portfolio_shared_state_reducers_dialogPanelReducer__["b" /* default */],dirSvc:__WEBPACK_IMPORTED_MODULE_6__dirSvcReducer__["b" /* default */],form:__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reducer */],globalNotifications:__WEBPACK_IMPORTED_MODULE_16_portfolio_shared_state_reducers_globalNotificationsReducer__["b" /* default */],intl:__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_intlReducer__["b" /* default */],license:__WEBPACK_IMPORTED_MODULE_15__licenseReducer__["b" /* default */],modalPrompt:__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_state_reducers_modalPromptReducer__["b" /* default */],np:__WEBPACK_IMPORTED_MODULE_7__netPublishReducer__["b" /* default */],persist:__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_state_reducers_persistReducer__["b" /* default */],roles:__WEBPACK_IMPORTED_MODULE_8__roleReducer__["b" /* default */],reachout:__WEBPACK_IMPORTED_MODULE_17_portfolio_shared_state_reducers_reachoutReducer__["b" /* default */],rti:__WEBPACK_IMPORTED_MODULE_9__rtiReducer__["a" /* default */],server:__WEBPACK_IMPORTED_MODULE_2__serverReducer__["b" /* default */],user:__WEBPACK_IMPORTED_MODULE_14__userReducer__["b" /* default */]};var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers);function rootReducer(state,action){if(action.type===__WEBPACK_IMPORTED_MODULE_18_state_types_globalTypes__["a" /* ACTION_TYPE_CLEAR_STATE */]){state=undefined;}return appReducer(state,action);}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(90);
var inspect = __webpack_require__(164);
var getSideChannelList = __webpack_require__(1209);
var getSideChannelMap = __webpack_require__(437);
var getSideChannelWeakMap = __webpack_require__(1234);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(250);
var callBound = __webpack_require__(444);
var inspect = __webpack_require__(164);

var $TypeError = __webpack_require__(90);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(1224);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(438);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(165);
var $TypeError = __webpack_require__(90);

var $call = __webpack_require__(251);
var $actualApply = __webpack_require__(1231);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(250);

var callBindBasic = __webpack_require__(442);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(252);
var getSideChannel = __webpack_require__(436);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) {
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) {
                return [target, source];
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, getMaxIndex(source));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = { obj: obj, prop: key };
                refs[refs.length] = val;
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(454);
module.exports = __webpack_require__(459);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(455).enable();
  window.Promise = __webpack_require__(457);
}

// fetch() polyfill for making API calls.
__webpack_require__(458);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(73);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(253);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(253);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 458 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_includes__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_addLocales__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_persistenceUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_persistCommands__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_intlCommands__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_virtualized_styles_css__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_virtualized_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_virtualized_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_css_font_awesome_css__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bulma_styles_css__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bulma_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__bulma_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_css__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_portfolio_shared_view_Utilities_BrowseServerFolders_css__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_portfolio_shared_view_Utilities_BrowseServerFolders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_view_Utilities_BrowseServerFolders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_view_App_App__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_state_store_storeManager__ = __webpack_require__(1197);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// polyfills needed for IE 11 support
var store=Object(__WEBPACK_IMPORTED_MODULE_17_state_store_storeManager__["a" /* default */])();// Add locales and render app once complete
Object(__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_addLocales__["a" /* addLocales */])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_persistenceUtils__["b" /* initLocalStorage */])(__WEBPACK_IMPORTED_MODULE_8_util_constants__["_13" /* STORAGE_KEY */]);_context.next=3;return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_state_commands_persistCommands__["b" /* loadPersistedData */])());case 3:locale=Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["_4" /* getLocale */])(store.getState());_context.next=6;return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_state_commands_intlCommands__["b" /* setMessages */])(locale));case 6:__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_view_App_App__["a" /* default */],{store:store}),document.getElementById('root'));case 7:case'end':return _context.stop();}}},_callee,_this);})));

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(461);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 461 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(463);
module.exports = __webpack_require__(92).Array.find;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(254);
var $find = __webpack_require__(473)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(264)(KEY);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(465);
var IE8_DOM_DEFINE = __webpack_require__(466);
var toPrimitive = __webpack_require__(468);
var dP = Object.defineProperty;

exports.f = __webpack_require__(167) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(167) && !__webpack_require__(255)(function () {
  return Object.defineProperty(__webpack_require__(467)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114);
var document = __webpack_require__(91).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(114);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var hide = __webpack_require__(166);
var has = __webpack_require__(471);
var SRC = __webpack_require__(256)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(92).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 471 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(257);
var IObject = __webpack_require__(258);
var toObject = __webpack_require__(474);
var toLength = __webpack_require__(261);
var asc = __webpack_require__(475);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(260);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(476);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114);
var isArray = __webpack_require__(477);
var SPECIES = __webpack_require__(263)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(259);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(92);
var global = __webpack_require__(91);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(479) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(481);
module.exports = __webpack_require__(92).Array.includes;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(254);
var $includes = __webpack_require__(482)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(264)('includes');


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(483);
var toLength = __webpack_require__(261);
var toAbsoluteIndex = __webpack_require__(484);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(258);
var defined = __webpack_require__(260);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(262);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(73),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==
b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.6.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,
assign:k}};X.unstable_ConcurrentMode=x;X.unstable_Profiler=u;var Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(73),ba=__webpack_require__(487);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function A(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(A.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});A.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
A.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(A);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=A.extend({data:null}),nb=A.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):
60113,ic=B?Symbol.for("react.memo"):60115,jc=B?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:case 13:var c=a._debugOwner,d=a._debugSource,e=mc(a.type);var f=null;c&&(f=mc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Yb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function xc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
xc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function yc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function zc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ac(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=zc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&yc(a,"checked",b,!1)}
function Dc(a,b){Cc(a,b);var c=zc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,zc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=A.getPooled(Gc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Hc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Gc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Wc=A.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=A.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=A.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=A.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=A}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function G(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=A.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+zc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:zc(c)}}
function ie(a,b){var c=zc(b.value),d=zc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ge(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var He=[],Ie=-1;function H(a){0>Ie||(a.current=He[Ie],He[Ie]=null,Ie--)}function I(a,b){Ie++;He[Ie]=a.current;a.current=b}var Je={},J={current:Je},K={current:!1},Ke=Je;
function Le(a,b){var c=a.type.contextTypes;if(!c)return Je;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Me(a){H(K,a);H(J,a)}function Ne(a){H(K,a);H(J,a)}
function Oe(a,b,c){J.current!==Je?t("168"):void 0;I(J,b,a);I(K,c,a)}function Pe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Qe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Je;Ke=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Re(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Pe(a,b,Ke),d.__reactInternalMemoizedMergedChildContext=b,H(K,a),H(J,a),I(J,b,a)):H(K,a);I(K,c,a)}var Se=null,Te=null;function Ue(a){return function(b){try{return a(b)}catch(c){}}}
function Ve(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Se=Ue(function(a){return b.onCommitFiberRoot(c,a)});Te=Ue(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function We(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function M(a,b,c,d){return new We(a,b,c,d)}
function Xe(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ye(a){if("function"===typeof a)return Xe(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function Ze(a,b){var c=a.alternate;null===c?(c=M(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function $e(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Xe(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return af(c.children,e,f,b);case fc:return bf(c,e|3,f,b);case bc:return bf(c,e|2,f,b);case cc:return a=M(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=M(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=M(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function af(a,b,c,d){a=M(7,a,d,b);a.expirationTime=c;return a}function bf(a,b,c,d){a=M(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function cf(a,b,c){a=M(6,a,null,b);a.expirationTime=c;return a}
function df(a,b,c){b=M(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ef(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);ff(b,a)}
function gf(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c>=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);ff(b,a)}
function hf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function ff(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var jf=!1;
function kf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function lf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function nf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function of(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=kf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=kf(a.memoizedState),e=c.updateQueue=kf(c.memoizedState)):d=a.updateQueue=lf(e):null===e&&(e=c.updateQueue=lf(d));null===e||d===e?nf(d,b):null===d.lastUpdate||null===e.lastUpdate?(nf(d,b),nf(e,b)):(nf(d,b),e.lastUpdate=b)}
function pf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=kf(a.memoizedState):qf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function qf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=lf(b));return b}
function rf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:jf=!0}return d}
function sf(a,b,c,d,e){jf=!1;b=qf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var q=k.expirationTime;q<e?(null===m&&(m=k,null===g&&(f=l)),h<q&&(h=q)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function tf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);uf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;uf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function uf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function vf(a,b){return{value:a,source:b,stack:nc(b)}}var wf={current:null},xf=null,yf=null,zf=null;function Af(a,b){var c=a.type._context;I(wf,c._currentValue,a);c._currentValue=b}function Bf(a){var b=wf.current;H(wf,a);a.type._context._currentValue=b}function Cf(a){xf=a;zf=yf=null;a.firstContextDependency=null}
function Df(a,b){if(zf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)zf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===yf?(null===xf?t("293"):void 0,xf.firstContextDependency=yf=b):yf=yf.next=b}return a._currentValue}var Ef={},N={current:Ef},Ff={current:Ef},Gf={current:Ef};function Hf(a){a===Ef?t("174"):void 0;return a}
function If(a,b){I(Gf,b,a);I(Ff,a,a);I(N,Ef,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}H(N,a);I(N,b,a)}function Jf(a){H(N,a);H(Ff,a);H(Gf,a)}function Kf(a){Hf(Gf.current);var b=Hf(N.current);var c=me(b,a.type);b!==c&&(I(Ff,a,a),I(N,c,a))}function Lf(a){Ff.current===a&&(H(N,a),H(Ff,a))}
function O(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Mf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Nf=Xb.ReactCurrentOwner,Of=(new aa.Component).refs;
function Pf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Uf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Qf();c=Rf(c,a);var d=mf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Sf();of(a,d);Tf(a,c)}};function Vf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Wf(a,b,c){var d=!1,e=Je;var f=b.contextType;"object"===typeof f&&null!==f?f=Nf.currentDispatcher.readContext(f):(e=L(b)?Ke:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Le(a,e):Je);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Uf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Xf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Uf.enqueueReplaceState(b,b.state,null)}
function Yf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Of;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Nf.currentDispatcher.readContext(f):(f=L(b)?Ke:J.current,e.context=Le(a,f));f=a.updateQueue;null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Pf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Uf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Zf=Array.isArray;
function $f(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Of&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function ag(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function bg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=$f(a,b,c),d.return=a,d;d=$e(c.type,c.key,c.props,null,a.mode,d);d.ref=$f(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=af(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function q(a,b,c){if("string"===typeof b||"number"===typeof b)return b=cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=$e(b.type,b.key,b.props,null,a.mode,c),c.ref=$f(a,null,b),c.return=a,c;case $b:return b=df(b,a.mode,c),b.return=a,b}if(Zf(b)||
lc(b))return b=af(b,a.mode,c,null),b.return=a,b;ag(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(Zf(c)||lc(c))return null!==e?null:m(a,b,c,d,null);ag(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Zf(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);ag(b,d)}return null}function C(e,g,h,k){for(var l=null,r=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=x(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===r?l=v:r.sibling=v;r=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=q(e,h[u],k))g=f(m,g,u),null===r?l=m:r.sibling=m,r=m;return l}for(m=d(e,m);u<h.length;u++)if(p=z(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===r?l=p:r.sibling=p,r=p;a&&m.forEach(function(a){return b(e,a)});return l}function Q(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,r=g,u=g=0,p=null,v=h.next();null!==r&&!v.done;u++,v=h.next()){r.index>u?(p=r,r=null):p=r.sibling;var y=x(e,r,v.value,k);if(null===y){r||(r=p);break}a&&r&&null===y.alternate&&b(e,r);g=f(y,g,u);null===m?l=y:m.sibling=y;m=y;r=p}if(v.done)return c(e,r),l;if(null===r){for(;!v.done;u++,v=h.next())v=q(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(r=d(e,r);!v.done;u++,v=h.next())v=z(r,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&r.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=$f(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=af(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=$e(f.type,f.key,f.props,null,a.mode,h),h.ref=$f(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=cf(f,a.mode,h),d.return=a,a=d),g(a);if(Zf(f))return C(a,d,f,h);if(lc(f))return Q(a,d,f,h);l&&ag(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var cg=bg(!0),dg=bg(!1),eg=null,fg=null,gg=!1;
function hg(a,b){var c=M(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function ig(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function jg(a){if(gg){var b=fg;if(b){var c=b;if(!ig(a,b)){b=Fe(c);if(!b||!ig(a,b)){a.effectTag|=2;gg=!1;eg=a;return}hg(eg,c)}eg=a;fg=Ge(b)}else a.effectTag|=2,gg=!1,eg=a}}function kg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;eg=a}function lg(a){if(a!==eg)return!1;if(!gg)return kg(a),gg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=fg;b;)hg(a,b),b=Fe(b);kg(a);fg=eg?Fe(a.stateNode):null;return!0}function mg(){fg=eg=null;gg=!1}var ng=Xb.ReactCurrentOwner;
function P(a,b,c,d){b.child=null===a?dg(b,null,c,d):cg(b,a.child,c,d)}function og(a,b,c,d,e){c=c.render;var f=b.ref;Cf(b,e);d=c(d,f);b.effectTag|=1;P(a,b,d,e);return b.child}
function pg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Xe(g)&&void 0===g.defaultProps&&null===c.compare)return b.tag=15,b.type=g,qg(a,b,g,d,e,f);a=$e(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return rg(a,b,f);a=Ze(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function qg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?rg(a,b,f):sg(a,b,c,d,f)}function tg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function sg(a,b,c,d,e){var f=L(c)?Ke:J.current;f=Le(b,f);Cf(b,e);c=c(d,f);b.effectTag|=1;P(a,b,c,e);return b.child}
function ug(a,b,c,d,e){if(L(c)){var f=!0;Qe(b)}else f=!1;Cf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Wf(b,c,d,e),Yf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l);jf=!1;var x=b.memoizedState;k=g.state=x;var z=b.updateQueue;null!==z&&(sf(b,z,d,g,e),k=b.memoizedState);h!==d||x!==k||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),k=b.memoizedState),(h=jf||Vf(b,c,h,d,x,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:O(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l)),m=c.getDerivedStateFromProps,
(q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l),jf=!1,k=b.memoizedState,x=g.state=k,z=b.updateQueue,null!==z&&(sf(b,z,d,g,e),x=b.memoizedState),h!==d||k!==x||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),x=b.memoizedState),(m=jf||Vf(b,c,h,d,k,x,l))?(q||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vg(a,b,c,d,f,e)}
function vg(a,b,c,d,e,f){tg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Re(b,c,!1),rg(a,b,f);d=b.stateNode;ng.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=cg(b,a.child,null,f),b.child=cg(b,null,h,f)):P(a,b,h,f);b.memoizedState=d.state;e&&Re(b,c,!0);return b.child}function wg(a){var b=a.stateNode;b.pendingContext?Oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Oe(a,b.context,!1);If(a,b.containerInfo)}
function xg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;null===a?g?(g=e.fallback,e=af(null,d,0,null),0===(b.mode&1)&&yg(b,e,null!==b.memoizedState?b.child.child:b.child),d=af(g,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=dg(b,null,e.children,c):null!==a.memoizedState?(d=a.child,a=d.sibling,g?(c=e.fallback,e=Ze(d,d.pendingProps,0),e.effectTag|=2,0===(b.mode&1)&&(g=null!==b.memoizedState?
b.child.child:b.child,g!==d.child&&yg(b,e,g)),d=e.sibling=Ze(a,c,a.expirationTime),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):(g=a.child,d=cg(b,d.child,e.children,c),cg(b,g,null,c),c=d)):(a=a.child,g?(g=e.fallback,e=af(null,d,0,null),e.effectTag|=2,e.child=a,a.return=e,0===(b.mode&1)&&yg(b,e,null!==b.memoizedState?b.child.child:b.child),d=e.sibling=af(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=cg(b,a,e.children,c));b.memoizedState=f;b.child=
c;return d}function yg(a,b,c){for(c=b.child=c;null!==c;)null===b.firstEffect&&(b.firstEffect=c.firstEffect),null!==c.lastEffect&&(null!==b.lastEffect&&(b.lastEffect.nextEffect=c.firstEffect),b.lastEffect=c.lastEffect),1<c.effectTag&&(null!==b.lastEffect?b.lastEffect.nextEffect=c:b.firstEffect=c,b.lastEffect=c),c.return=b,c=c.sibling;a.firstEffect=b.firstEffect;a.lastEffect=b.lastEffect}
function rg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=Ze(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ze(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function zg(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!K.current&&d<c){switch(b.tag){case 3:wg(b);mg();break;case 5:Kf(b);break;case 1:L(b.type)&&Qe(b);break;case 4:If(b,b.stateNode.containerInfo);break;case 10:Af(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return xg(a,b,c);b=rg(a,b,c);return null!==b?b.sibling:null}}return rg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Le(b,J.current);Cf(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(L(d)){var f=!0;Qe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Pf(b,d,g,a);e.updater=Uf;b.stateNode=e;e._reactInternalFiber=b;Yf(b,d,a,c);b=vg(null,b,d,!0,f,c)}else b.tag=0,P(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Mf(e);b.type=a;e=b.tag=Ye(a);f=O(a,f);g=void 0;switch(e){case 0:g=sg(null,b,a,f,c);break;case 1:g=ug(null,b,a,f,c);break;case 11:g=og(null,b,a,f,c);break;case 14:g=pg(null,b,a,O(a.type,f),d,c);break;default:t("283",a)}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),sg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),ug(a,b,d,
e,c);case 3:wg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;sf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)mg(),b=rg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)fg=Ge(b.stateNode.containerInfo),eg=b,e=gg=!0;e?(b.effectTag|=2,b.child=dg(b,null,d,c)):(P(a,b,d,c),mg());b=b.child}return b;case 5:return Kf(b),null===a&&jg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),tg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(P(a,b,g,c),b=b.child),b;case 6:return null===a&&jg(b),null;case 13:return xg(a,b,c);case 4:return If(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=cg(b,null,d,c):P(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),og(a,b,d,e,c);case 7:return P(a,b,b.pendingProps,c),b.child;case 8:return P(a,b,b.pendingProps.children,c),b.child;case 12:return P(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Af(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=rg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=mf(c);k.tag=2;of(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}P(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Cf(b,c),e=Df(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,P(a,b,d,c),b.child;case 14:return e=b.type,f=O(e.type,b.pendingProps),pg(a,b,e,f,d,c);case 15:return qg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Qe(b)):
a=!1,Cf(b,c),Wf(b,d,e,c),Yf(b,d,e,c),vg(null,b,d,!0,a,c);default:t("156")}}function Ag(a){a.effectTag|=4}var Bg=void 0,Cg=void 0,Gg=void 0,Hg=void 0;Bg=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Cg=function(){};
Gg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;Hf(N.current);a=null;switch(c){case "input":f=Ac(g,f);d=Ac(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&Ag(b)}};Hg=function(a,b,c,d){c!==d&&Ag(b)};
function Ig(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Jg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Kg(a,c)}else b.current=null}
function Lg(a){"function"===typeof Te&&Te(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Kg(e,f)}}c=c.next}while(c!==b)}break;case 1:Jg(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Kg(a,f)}break;case 5:Jg(a);break;case 4:Mg(a)}}
function Ng(a){return 5===a.tag||3===a.tag||4===a.tag}
function Og(a){a:{for(var b=a.return;null!==b;){if(Ng(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Ng(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Mg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Lg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Lg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Pg(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ha]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);we(a,e);b=we(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?te(c,h):"dangerouslySetInnerHTML"===g?oe(c,h):"children"===g?pe(c,h):yc(c,g,h,b)}switch(a){case "input":Dc(c,d);break;case "textarea":ie(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?fe(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?fe(c,!!d.multiple,d.defaultValue,!0):fe(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Qf()));if(null!==a)a:for(b=c=a;;){if(5===
b.tag)a=b.stateNode,d?a.style.display="none":(a=b.stateNode,f=b.memoizedProps.style,f=void 0!==f&&null!==f&&f.hasOwnProperty("display")?f.display:null,a.style.display=se("display",f));else if(6===b.tag)b.stateNode.nodeValue=d?"":b.memoizedProps;else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===c)break a;for(;null===b.sibling;){if(null===b.return||b.return===c)break a;b=b.return}b.sibling.return=b.return;b=b.sibling}break;case 17:break;default:t("163")}}
function Qg(a,b,c){c=mf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Rg(d);Ig(a,b)};return c}
function Sg(a,b,c){c=mf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Tg?Tg=new Set([this]):Tg.add(this));var c=b.value,e=b.stack;Ig(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Ug(a){switch(a.tag){case 1:L(a.type)&&Me(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Jf(a),Ne(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Lf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Jf(a),null;case 10:return Bf(a),null;default:return null}}
var Vg={readContext:Df},Wg=Xb.ReactCurrentOwner,Xg=1073741822,Yg=0,Zg=!1,R=null,S=null,T=0,$g=-1,ah=!1,U=null,bh=!1,ch=null,dh=null,Tg=null;function eh(){if(null!==R)for(var a=R.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Me(b);break;case 3:Jf(b);Ne(b);break;case 5:Lf(b);break;case 4:Jf(b);break;case 10:Bf(b)}a=a.return}S=null;T=0;$g=-1;ah=!1;R=null}function Sf(){null!==dh&&(ba.unstable_cancelCallback(ch),dh())}
function fh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){R=a;a:{var e=b;b=a;var f=T;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Me(b);break;case 3:Jf(b);Ne(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)lg(b),b.effectTag&=-3;Cg(b);break;case 5:Lf(b);var h=Hf(Gf.current);f=b.type;if(null!==e&&null!=b.stateNode)Gg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=Hf(N.current);if(lg(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,q=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":G("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)G(bb[l],e);break;case "source":G("error",e);break;case "img":case "image":case "link":G("error",e);G("load",e);break;case "form":G("reset",e);G("submit",e);break;case "details":G("toggle",e);break;case "input":Bc(e,m);G("invalid",e);xe(q,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};G("invalid",e);xe(q,"onChange");break;case "textarea":he(e,m),G("invalid",e),xe(q,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(q,f));switch(h){case "input":Vb(e);Fc(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&Ag(b)}else{m=b;e=f;q=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof q.is?l=l.createElement(e,{is:q.is}):(l=l.createElement(e),"select"===e&&q.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Bg(e,b,!1,!1);q=e;l=f;m=g;var x=h,z=we(l,m);switch(l){case "iframe":case "object":G("load",
q);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)G(bb[h],q);h=m;break;case "source":G("error",q);h=m;break;case "img":case "image":case "link":G("error",q);G("load",q);h=m;break;case "form":G("reset",q);G("submit",q);h=m;break;case "details":G("toggle",q);h=m;break;case "input":Bc(q,m);h=Ac(q,m);G("invalid",q);xe(x,"onChange");break;case "option":h=ee(q,m);break;case "select":q._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});G("invalid",q);xe(x,"onChange");break;case "textarea":he(q,
m);h=ge(q,m);G("invalid",q);xe(x,"onChange");break;default:h=m}ve(l,h);k=void 0;var C=l,Q=q,v=h;for(k in v)if(v.hasOwnProperty(k)){var r=v[k];"style"===k?te(Q,r):"dangerouslySetInnerHTML"===k?(r=r?r.__html:void 0,null!=r&&oe(Q,r)):"children"===k?"string"===typeof r?("textarea"!==C||""!==r)&&pe(Q,r):"number"===typeof r&&pe(Q,""+r):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=r&&xe(x,k):null!=r&&yc(Q,k,r,z))}switch(l){case "input":Vb(q);
Fc(q,m,!1);break;case "textarea":Vb(q);je(q,m);break;case "option":null!=m.value&&q.setAttribute("value",""+zc(m.value));break;case "select":h=q;h.multiple=!!m.multiple;q=m.value;null!=q?fe(h,!!m.multiple,q,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(q.onclick=ye)}(g=Be(f,g))&&Ag(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Hg(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=Hf(Gf.current),Hf(N.current),lg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&Ag(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;b.firstEffect=b.lastEffect=null;R=b;break a}g=null!==g;if(g!==(null!==e&&null!==e.memoizedState)||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;
case 4:Jf(b);Cg(b);break;case 10:Bf(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Me(b);break;default:t("156")}R=null}b=a;if(1===T||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==R)return R.firstEffect=R.lastEffect=null,R;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=
a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Ug(a,T);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function gh(a){var b=zg(a.alternate,a,T);a.memoizedProps=a.pendingProps;null===b&&(b=fh(a));Wg.current=null;return b}
function hh(a,b){Zg?t("243"):void 0;Sf();Zg=!0;Wg.currentDispatcher=Vg;var c=a.nextExpirationTimeToWorkOn;if(c!==T||a!==S||null===R)eh(),S=a,T=c,R=Ze(S.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==R&&!ih();)R=gh(R);else for(;null!==R;)R=gh(R)}catch(C){if(zf=yf=xf=null,null===R)d=!0,Rg(C);else{null===R?t("271"):void 0;var e=R,f=e.return;if(null===f)d=!0,Rg(C);else{a:{var g=a,h=f,k=e,l=C;f=T;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var q=-1,x=-1;do{if(13===l.tag){var z=l.alternate;if(null!==z&&(z=z.memoizedState,null!==z)){x=10*(1073741822-z.timedOutAt);break}z=l.pendingProps.maxDuration;if("number"===typeof z)if(0>=z)q=0;else if(-1===q||z<q)q=z}l=l.return}while(null!==l);l=h;do{if(z=13===l.tag)z=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(z){h=jh.bind(null,g,l,k,0===(l.mode&1)?1073741823:f);m.then(h,h);if(0===(l.mode&1)){l.effectTag|=64;P(k.alternate,k,null,
f);k.effectTag&=-1025;k.effectTag&=-933;1===k.tag&&null===k.alternate&&(k.tag=17);k.expirationTime=f;break a}-1===q?g=1073741823:(-1===x&&(x=10*(1073741822-hf(g,f))-5E3),g=x+q);0<=g&&$g<g&&($g=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+nc(k))}ah=
!0;l=vf(l,k);g=h;do{switch(g.tag){case 3:k=l;g.effectTag|=2048;g.expirationTime=f;f=Qg(g,k,f);pf(g,f);break a;case 1:if(k=l,h=g.type,m=g.stateNode,0===(g.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==m&&"function"===typeof m.componentDidCatch&&(null===Tg||!Tg.has(m)))){g.effectTag|=2048;g.expirationTime=f;f=Sg(g,k,f);pf(g,f);break a}}g=g.return}while(null!==g)}R=fh(e);continue}}}break}while(1);Zg=!1;zf=yf=xf=Wg.currentDispatcher=null;if(d)S=null,a.finishedWork=null;else if(null!==
R)a.finishedWork=null;else{d=a.current.alternate;null===d?t("281"):void 0;S=null;if(ah){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){gf(a,c);kh(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;kh(a,d,c,b,-1);return}}b&&-1!==$g?(gf(a,c),b=10*(1073741822-hf(a,c)),b<$g&&($g=b),b=10*(1073741822-Qf()),b=$g-b,kh(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=
c,a.finishedWork=d)}}function Kg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Tg||!Tg.has(d))){a=vf(b,a);a=Sg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}break;case 3:a=vf(b,a);a=Qg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}c=c.return}3===a.tag&&(c=vf(b,a),c=Qg(a,c,1073741823),of(a,c),Tf(a,1073741823))}
function Rf(a,b){0!==Yg?a=Yg:Zg?a=bh?1073741823:T:b.mode&1?(a=lh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==S&&a===T&&--a):a=1073741823;lh&&(0===mh||a<mh)&&(mh=a);return a}
function jh(a,b,c,d){var e=a.earliestSuspendedTime;var f=a.latestSuspendedTime;if(0!==e&&d<=e&&d>=f){f=e=d;a.didError=!1;var g=a.latestPingedTime;if(0===g||g>f)a.latestPingedTime=f;ff(f,a)}else e=Qf(),e=Rf(e,b),ef(a,e);0!==(b.mode&1)&&a===S&&T===d&&(S=null);nh(b,e);0===(b.mode&1)&&(nh(c,e),1===c.tag&&null!==c.stateNode&&(b=mf(e),b.tag=2,of(c,b)));c=a.expirationTime;0!==c&&oh(a,c)}
function nh(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return null===e?null:e}
function Tf(a,b){a=nh(a,b);null!==a&&(!Zg&&0!==T&&b>T&&eh(),ef(a,b),Zg&&!bh&&S===a||oh(a,a.expirationTime),ph>qh&&(ph=0,t("185")))}function rh(a,b,c,d,e){var f=Yg;Yg=1073741823;try{return a(b,c,d,e)}finally{Yg=f}}var sh=null,V=null,th=0,uh=void 0,W=!1,vh=null,X=0,mh=0,wh=!1,xh=null,Z=!1,yh=!1,lh=!1,zh=null,Ah=ba.unstable_now(),Bh=1073741822-(Ah/10|0),Ch=Bh,qh=50,ph=0,Dh=null;function Eh(){Bh=1073741822-((ba.unstable_now()-Ah)/10|0)}
function Fh(a,b){if(0!==th){if(b<th)return;null!==uh&&ba.unstable_cancelCallback(uh)}th=b;a=ba.unstable_now()-Ah;uh=ba.unstable_scheduleCallback(Gh,{timeout:10*(1073741822-b)-a})}function kh(a,b,c,d,e){a.expirationTime=d;0!==e||ih()?0<e&&(a.timeoutHandle=De(Hh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Hh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Eh();Ch=Bh;Ih(a,c)}function Qf(){if(W)return Ch;Jh();if(0===X||1===X)Eh(),Ch=Bh;return Ch}
function oh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===V?(sh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=sh)):b>a.expirationTime&&(a.expirationTime=b);W||(Z?yh&&(vh=a,X=1073741823,Kh(a,1073741823,!1)):1073741823===b?Lh(1073741823,!1):Fh(a,b))}
function Jh(){var a=0,b=null;if(null!==V)for(var c=V,d=sh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===V?t("244"):void 0;if(d===d.nextScheduledRoot){sh=V=d.nextScheduledRoot=null;break}else if(d===sh)sh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=sh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===V)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}vh=b;X=a}var Mh=!1;function ih(){return Mh?!0:ba.unstable_shouldYield()?Mh=!0:!1}function Gh(){try{if(!ih()&&null!==sh){Eh();var a=sh;do{var b=a.expirationTime;0!==b&&Bh<=b&&(a.nextExpirationTimeToWorkOn=Bh);a=a.nextScheduledRoot}while(a!==sh)}Lh(0,!0)}finally{Mh=!1}}
function Lh(a,b){Jh();if(b)for(Eh(),Ch=Bh;null!==vh&&0!==X&&a<=X&&!(Mh&&Bh>X);)Kh(vh,X,Bh>X),Jh(),Eh(),Ch=Bh;else for(;null!==vh&&0!==X&&a<=X;)Kh(vh,X,!1),Jh();b&&(th=0,uh=null);0!==X&&Fh(vh,X);ph=0;Dh=null;if(null!==zh)for(a=zh,zh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){wh||(wh=!0,xh=d)}}if(wh)throw a=xh,xh=null,wh=!1,a;}function Ih(a,b){W?t("253"):void 0;vh=a;X=b;Kh(a,b,!1);Lh(1073741823,!1)}
function Kh(a,b,c){W?t("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Nh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),hh(a,c),d=a.finishedWork,null!==d&&(ih()?a.finishedWork=d:Nh(a,d,b)))}else d=a.finishedWork,null!==d?Nh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),hh(a,c),d=a.finishedWork,null!==d&&Nh(a,d,b));W=!1}
function Nh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===zh?zh=[d]:zh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Dh?ph++:(Dh=a,ph=0);bh=Zg=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ef(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ef(a,d)):d>e&&ef(a,d));ff(0,a);Wg.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in e)var f={start:e.selectionStart,
end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,q=-1,x=0,z=0,C=e,Q=null;b:for(;;){for(var v;;){C!==f||0!==h&&3!==C.nodeType||(m=l+h);C!==k||0!==g&&3!==C.nodeType||(q=l+g);3===C.nodeType&&(l+=C.nodeValue.length);if(null===(v=C.firstChild))break;Q=C;C=v}for(;;){if(C===e)break b;Q===f&&
++x===h&&(m=l);Q===k&&++z===g&&(q=l);if(null!==(v=C.nextSibling))break;C=Q;Q=C.parentNode}C=v}f=-1===m||-1===q?null:{start:m,end:q}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(U=d;null!==U;){e=!1;f=void 0;try{for(;null!==U;){if(U.effectTag&256)a:{var r=U.alternate;h=U;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==r){var u=r.memoizedProps,y=r.memoizedState,Y=h.stateNode,Uh=Y.getSnapshotBeforeUpdate(h.elementType===h.type?
u:O(h.type,u),y);Y.__reactInternalSnapshotBeforeUpdate=Uh}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}U=U.nextEffect}}catch(db){e=!0,f=db}e&&(null===U?t("178"):void 0,Kg(U,f),null!==U&&(U=U.nextEffect))}for(U=d;null!==U;){r=!1;u=void 0;try{for(;null!==U;){var w=U.effectTag;w&16&&pe(U.stateNode,"");if(w&128){var D=U.alternate;if(null!==D){var p=D.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(w&14){case 2:Og(U);U.effectTag&=-3;break;case 6:Og(U);U.effectTag&=
-3;Pg(U.alternate,U);break;case 4:Pg(U.alternate,U);break;case 8:y=U,Mg(y),y.return=null,y.child=null,y.alternate&&(y.alternate.child=null,y.alternate.return=null)}U=U.nextEffect}}catch(db){r=!0,u=db}r&&(null===U?t("178"):void 0,Kg(U,u),null!==U&&(U=U.nextEffect))}p=Ae;D=Td();w=p.focusedElem;u=p.selectionRange;if(D!==w&&w&&w.ownerDocument&&Sd(w.ownerDocument.documentElement,w)){null!==u&&Ud(w)&&(D=u.start,p=u.end,void 0===p&&(p=D),"selectionStart"in w?(w.selectionStart=D,w.selectionEnd=Math.min(p,
w.value.length)):(p=(D=w.ownerDocument||document)&&D.defaultView||window,p.getSelection&&(p=p.getSelection(),y=w.textContent.length,r=Math.min(u.start,y),u=void 0===u.end?r:Math.min(u.end,y),!p.extend&&r>u&&(y=u,u=r,r=y),y=Rd(w,r),Y=Rd(w,u),y&&Y&&(1!==p.rangeCount||p.anchorNode!==y.node||p.anchorOffset!==y.offset||p.focusNode!==Y.node||p.focusOffset!==Y.offset)&&(D=D.createRange(),D.setStart(y.node,y.offset),p.removeAllRanges(),r>u?(p.addRange(D),p.extend(Y.node,Y.offset)):(D.setEnd(Y.node,Y.offset),
p.addRange(D))))));D=[];for(p=w;p=p.parentNode;)1===p.nodeType&&D.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof w.focus&&w.focus();for(w=0;w<D.length;w++)p=D[w],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(U=d;null!==U;){d=!1;w=void 0;try{for(D=c;null!==U;){var Fb=U.effectTag;if(Fb&36){var Gb=U.alternate;p=U;r=D;switch(p.tag){case 0:case 11:case 15:break;case 1:var wc=p.stateNode;if(p.effectTag&4)if(null===Gb)wc.componentDidMount();
else{var di=p.elementType===p.type?Gb.memoizedProps:O(p.type,Gb.memoizedProps);wc.componentDidUpdate(di,Gb.memoizedState,wc.__reactInternalSnapshotBeforeUpdate)}var Dg=p.updateQueue;null!==Dg&&tf(p,Dg,wc,r);break;case 3:var Eg=p.updateQueue;if(null!==Eg){u=null;if(null!==p.child)switch(p.child.tag){case 5:u=p.child.stateNode;break;case 1:u=p.child.stateNode}tf(p,Eg,u,r)}break;case 5:var ei=p.stateNode;null===Gb&&p.effectTag&4&&Be(p.type,p.memoizedProps)&&ei.focus();break;case 6:break;case 4:break;
case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=U.ref;if(null!==Ic){var Fg=U.stateNode;switch(U.tag){case 5:var de=Fg;break;default:de=Fg}"function"===typeof Ic?Ic(de):Ic.current=de}}U=U.nextEffect}}catch(db){d=!0,w=db}d&&(null===U?t("178"):void 0,Kg(U,w),null!==U&&(U=U.nextEffect))}Zg=bh=!1;"function"===typeof Se&&Se(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Tg=null);a.expirationTime=b;a.finishedWork=null}
function Rg(a){null===vh?t("246"):void 0;vh.expirationTime=0;wh||(wh=!0,xh=a)}function Oh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Lh(1073741823,!1)}}function Ph(a,b){if(Z&&!yh){yh=!0;try{return a(b)}finally{yh=!1}}return a(b)}function Qh(a,b,c){if(lh)return a(b,c);Z||W||0===mh||(Lh(mh,!1),mh=0);var d=lh,e=Z;Z=lh=!0;try{return a(b,c)}finally{lh=d,(Z=e)||W||Lh(1073741823,!1)}}
function Rh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(L(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(L(h)){c=Pe(c,h,g);break a}}c=g}else c=Je;null===b.context?b.context=c:b.pendingContext=c;b=e;e=mf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Sf();of(f,e);Tf(f,d);return d}function Sh(a,b,c,d){var e=b.current,f=Qf();e=Rf(f,e);return Rh(a,b,c,e,d)}function Th(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Vh(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Dc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function Wh(a){var b=1073741822-25*(((1073741822-Qf()+500)/25|0)+1);b>=Xg&&(b=Xg-1);this._expirationTime=Xg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Wh.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Xh;Rh(a,b,null,c,d._onCommit);return d};
Wh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Wh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Ih(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Wh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Xh(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Xh.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Xh.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function Yh(a,b,c){b=M(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Yh.prototype.render=function(a,b){var c=this._internalRoot,d=new Xh;b=void 0===b?null:b;null!==b&&d.then(b);Sh(a,c,null,d._onCommit);return d};Yh.prototype.unmount=function(a){var b=this._internalRoot,c=new Xh;a=void 0===a?null:a;null!==a&&c.then(a);Sh(null,b,null,c._onCommit);return c};Yh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Xh;c=void 0===c?null:c;null!==c&&e.then(c);Sh(b,d,a,e._onCommit);return e};
Yh.prototype.createBatch=function(){var a=new Wh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Zh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Oh;Lb=Qh;Mb=function(){W||0===mh||(Lh(mh,!1),mh=0)};
function $h(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Yh(a,!1,b)}
function ai(a,b,c,d,e){Zh(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Th(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=$h(c,d);if("function"===typeof e){var h=e;e=function(){var a=Th(f._internalRoot);h.call(a)}}Ph(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Th(f._internalRoot)}
function bi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Zh(b)?void 0:t("200");return Vh(a,b,null,c)}
var ci={createPortal:bi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return ai(null,a,b,!0,c)},render:function(a,b,c){return ai(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return ai(a,b,c,!1,d)},unmountComponentAtNode:function(a){Zh(a)?
void 0:t("40");return a._reactRootContainer?(Ph(function(){ai(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return bi.apply(void 0,arguments)},unstable_batchedUpdates:Oh,unstable_interactiveUpdates:Qh,flushSync:function(a,b){W?t("187"):void 0;var c=Z;Z=!0;try{return rh(a,b)}finally{Z=c,Lh(1073741823,!1)}},unstable_flushControlled:function(a){var b=Z;Z=!0;try{rh(a)}finally{(Z=b)||W||Lh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]},unstable_createRoot:function(a,b){Zh(a)?void 0:t("299","unstable_createRoot");return new Yh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Ve(n({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.6.1",rendererPackageName:"react-dom"});
var fi={default:ci},gi=fi&&ci||fi;module.exports=gi.default||gi;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(488);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.11.3
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=c()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=g.next=g.previous=g;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=g,p());b=c.previous;b.next=c.previous=g;g.next=c;g.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,f=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),e=!1;if(0>=P-c)if(-1!==b&&b<=c)e=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=c,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(h){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var e=d;do{if(e.expirationTime>b){c=e;break}e=e.next}while(e!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var c=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=c,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==d&&d.expirationTime<l||w())};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 489 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(491), src$en$$ = __webpack_require__(496);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(266), src$es5$$ = __webpack_require__(492), src$compiler$$ = __webpack_require__(493), intl$messageformat$parser$$ = __webpack_require__(494);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(266);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(495)['default'];
exports['default'] = exports;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 497 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(499)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(504);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(500);
var en_1 = __webpack_require__(503);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(265);
var diff_1 = __webpack_require__(501);
var es5_1 = __webpack_require__(502);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(506);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=o())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,o){var t=!String(e).split(".")[1];return o?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMemoize */
/* unused harmony export createSelectorCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelector; });
/* unused harmony export createStructuredSelector */
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

/**
 * This is a manually concatinated file by dschuman. Also adds modules.exports
 *//* eslint-disable */var navigator=navigator||{};var b64map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var b64pad="=";function hex2b64(h){var i;var c;var ret="";for(i=0;i+3<=h.length;i+=3){c=parseInt(h.substring(i,i+3),16);ret+=b64map.charAt(c>>6)+b64map.charAt(c&63);}if(i+1==h.length){c=parseInt(h.substring(i,i+1),16);ret+=b64map.charAt(c<<2);}else if(i+2==h.length){c=parseInt(h.substring(i,i+2),16);ret+=b64map.charAt(c>>2)+b64map.charAt((c&3)<<4);}while((ret.length&3)>0){ret+=b64pad;}return ret;}// convert a base64 string to hex
function b64tohex(s){var ret="";var i;var k=0;// b64 state, 0-3
var slop;for(i=0;i<s.length;++i){if(s.charAt(i)==b64pad)break;v=b64map.indexOf(s.charAt(i));if(v<0)continue;if(k==0){ret+=int2char(v>>2);slop=v&3;k=1;}else if(k==1){ret+=int2char(slop<<2|v>>4);slop=v&0xf;k=2;}else if(k==2){ret+=int2char(slop);ret+=int2char(v>>2);slop=v&3;k=3;}else{ret+=int2char(slop<<2|v>>4);ret+=int2char(v&0xf);k=0;}}if(k==1)ret+=int2char(slop<<2);return ret;}// convert a base64 string to a byte/number array
function b64toBA(s){//piggyback on b64tohex for now, optimize later
var h=b64tohex(s);var i;var a=new Array();for(i=0;2*i<h.length;++i){a[i]=parseInt(h.substring(2*i,2*i+2),16);}return a;}// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
// Bits per digit
var dbits;// JavaScript engine analysis
var canary=0xdeadbeefcafe;var j_lm=(canary&0xffffff)==0xefcafe;// (public) Constructor
function BigInteger(a,b,c){if(a!=null)if("number"==typeof a)this.fromNumber(a,b,c);else if(b==null&&"string"!=typeof a)this.fromString(a,256);else this.fromString(a,b);}// return new, unset BigInteger
function nbi(){return new BigInteger(null);}// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i,x,w,j,c,n){while(--n>=0){var v=x*this[i++]+w[j]+c;c=Math.floor(v/0x4000000);w[j++]=v&0x3ffffff;}return c;}// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i,x,w,j,c,n){var xl=x&0x7fff,xh=x>>15;while(--n>=0){var l=this[i]&0x7fff;var h=this[i++]>>15;var m=xh*l+h*xl;l=xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);c=(l>>>30)+(m>>>15)+xh*h+(c>>>30);w[j++]=l&0x3fffffff;}return c;}// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i,x,w,j,c,n){var xl=x&0x3fff,xh=x>>14;while(--n>=0){var l=this[i]&0x3fff;var h=this[i++]>>14;var m=xh*l+h*xl;l=xl*l+((m&0x3fff)<<14)+w[j]+c;c=(l>>28)+(m>>14)+xh*h;w[j++]=l&0xfffffff;}return c;}if(j_lm&&navigator.appName=="Microsoft Internet Explorer"){BigInteger.prototype.am=am2;dbits=30;}else if(j_lm&&navigator.appName!="Netscape"){BigInteger.prototype.am=am1;dbits=26;}else{// Mozilla/Netscape seems to prefer am3
BigInteger.prototype.am=am3;dbits=28;}BigInteger.prototype.DB=dbits;BigInteger.prototype.DM=(1<<dbits)-1;BigInteger.prototype.DV=1<<dbits;var BI_FP=52;BigInteger.prototype.FV=Math.pow(2,BI_FP);BigInteger.prototype.F1=BI_FP-dbits;BigInteger.prototype.F2=2*dbits-BI_FP;// Digit conversions
var BI_RM="0123456789abcdefghijklmnopqrstuvwxyz";var BI_RC=new Array();var rr,vv;rr="0".charCodeAt(0);for(vv=0;vv<=9;++vv){BI_RC[rr++]=vv;}rr="a".charCodeAt(0);for(vv=10;vv<36;++vv){BI_RC[rr++]=vv;}rr="A".charCodeAt(0);for(vv=10;vv<36;++vv){BI_RC[rr++]=vv;}function int2char(n){return BI_RM.charAt(n);}function intAt(s,i){var c=BI_RC[s.charCodeAt(i)];return c==null?-1:c;}// (protected) copy this to r
function bnpCopyTo(r){for(var i=this.t-1;i>=0;--i){r[i]=this[i];}r.t=this.t;r.s=this.s;}// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x){this.t=1;this.s=x<0?-1:0;if(x>0)this[0]=x;else if(x<-1)this[0]=x+DV;else this.t=0;}// return bigint initialized to value
function nbv(i){var r=nbi();r.fromInt(i);return r;}// (protected) set from string and radix
function bnpFromString(s,b){var k;if(b==16)k=4;else if(b==8)k=3;else if(b==256)k=8;// byte array
else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else{this.fromRadix(s,b);return;}this.t=0;this.s=0;var i=s.length,mi=false,sh=0;while(--i>=0){var x=k==8?s[i]&0xff:intAt(s,i);if(x<0){if(s.charAt(i)=="-")mi=true;continue;}mi=false;if(sh==0)this[this.t++]=x;else if(sh+k>this.DB){this[this.t-1]|=(x&(1<<this.DB-sh)-1)<<sh;this[this.t++]=x>>this.DB-sh;}else this[this.t-1]|=x<<sh;sh+=k;if(sh>=this.DB)sh-=this.DB;}if(k==8&&(s[0]&0x80)!=0){this.s=-1;if(sh>0)this[this.t-1]|=(1<<this.DB-sh)-1<<sh;}this.clamp();if(mi)BigInteger.ZERO.subTo(this,this);}// (protected) clamp off excess high words
function bnpClamp(){var c=this.s&this.DM;while(this.t>0&&this[this.t-1]==c){--this.t;}}// (public) return string representation in given radix
function bnToString(b){if(this.s<0)return"-"+this.negate().toString(b);var k;if(b==16)k=4;else if(b==8)k=3;else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else return this.toRadix(b);var km=(1<<k)-1,d,m=false,r="",i=this.t;var p=this.DB-i*this.DB%k;if(i-->0){if(p<this.DB&&(d=this[i]>>p)>0){m=true;r=int2char(d);}while(i>=0){if(p<k){d=(this[i]&(1<<p)-1)<<k-p;d|=this[--i]>>(p+=this.DB-k);}else{d=this[i]>>(p-=k)&km;if(p<=0){p+=this.DB;--i;}}if(d>0)m=true;if(m)r+=int2char(d);}}return m?r:"0";}// (public) -this
function bnNegate(){var r=nbi();BigInteger.ZERO.subTo(this,r);return r;}// (public) |this|
function bnAbs(){return this.s<0?this.negate():this;}// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a){var r=this.s-a.s;if(r!=0)return r;var i=this.t;r=i-a.t;if(r!=0)return r;while(--i>=0){if((r=this[i]-a[i])!=0)return r;}return 0;}// returns bit length of the integer x
function nbits(x){var r=1,t;if((t=x>>>16)!=0){x=t;r+=16;}if((t=x>>8)!=0){x=t;r+=8;}if((t=x>>4)!=0){x=t;r+=4;}if((t=x>>2)!=0){x=t;r+=2;}if((t=x>>1)!=0){x=t;r+=1;}return r;}// (public) return the number of bits in "this"
function bnBitLength(){if(this.t<=0)return 0;return this.DB*(this.t-1)+nbits(this[this.t-1]^this.s&this.DM);}// (protected) r = this << n*DB
function bnpDLShiftTo(n,r){var i;for(i=this.t-1;i>=0;--i){r[i+n]=this[i];}for(i=n-1;i>=0;--i){r[i]=0;}r.t=this.t+n;r.s=this.s;}// (protected) r = this >> n*DB
function bnpDRShiftTo(n,r){for(var i=n;i<this.t;++i){r[i-n]=this[i];}r.t=Math.max(this.t-n,0);r.s=this.s;}// (protected) r = this << n
function bnpLShiftTo(n,r){var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<cbs)-1;var ds=Math.floor(n/this.DB),c=this.s<<bs&this.DM,i;for(i=this.t-1;i>=0;--i){r[i+ds+1]=this[i]>>cbs|c;c=(this[i]&bm)<<bs;}for(i=ds-1;i>=0;--i){r[i]=0;}r[ds]=c;r.t=this.t+ds+1;r.s=this.s;r.clamp();}// (protected) r = this >> n
function bnpRShiftTo(n,r){r.s=this.s;var ds=Math.floor(n/this.DB);if(ds>=this.t){r.t=0;return;}var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<bs)-1;r[0]=this[ds]>>bs;for(var i=ds+1;i<this.t;++i){r[i-ds-1]|=(this[i]&bm)<<cbs;r[i-ds]=this[i]>>bs;}if(bs>0)r[this.t-ds-1]|=(this.s&bm)<<cbs;r.t=this.t-ds;r.clamp();}// (protected) r = this - a
function bnpSubTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]-a[i];r[i++]=c&this.DM;c>>=this.DB;}if(a.t<this.t){c-=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}c+=this.s;}else{c+=this.s;while(i<a.t){c-=a[i];r[i++]=c&this.DM;c>>=this.DB;}c-=a.s;}r.s=c<0?-1:0;if(c<-1)r[i++]=this.DV+c;else if(c>0)r[i++]=c;r.t=i;r.clamp();}// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a,r){var x=this.abs(),y=a.abs();var i=x.t;r.t=i+y.t;while(--i>=0){r[i]=0;}for(i=0;i<y.t;++i){r[i+x.t]=x.am(0,y[i],r,i,0,x.t);}r.s=0;r.clamp();if(this.s!=a.s)BigInteger.ZERO.subTo(r,r);}// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r){var x=this.abs();var i=r.t=2*x.t;while(--i>=0){r[i]=0;}for(i=0;i<x.t-1;++i){var c=x.am(i,x[i],r,2*i,0,1);if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1))>=x.DV){r[i+x.t]-=x.DV;r[i+x.t+1]=1;}}if(r.t>0)r[r.t-1]+=x.am(i,x[i],r,2*i,0,1);r.s=0;r.clamp();}// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m,q,r){var pm=m.abs();if(pm.t<=0)return;var pt=this.abs();if(pt.t<pm.t){if(q!=null)q.fromInt(0);if(r!=null)this.copyTo(r);return;}if(r==null)r=nbi();var y=nbi(),ts=this.s,ms=m.s;var nsh=this.DB-nbits(pm[pm.t-1]);// normalize modulus
if(nsh>0){pm.lShiftTo(nsh,y);pt.lShiftTo(nsh,r);}else{pm.copyTo(y);pt.copyTo(r);}var ys=y.t;var y0=y[ys-1];if(y0==0)return;var yt=y0*(1<<this.F1)+(ys>1?y[ys-2]>>this.F2:0);var d1=this.FV/yt,d2=(1<<this.F1)/yt,e=1<<this.F2;var i=r.t,j=i-ys,t=q==null?nbi():q;y.dlShiftTo(j,t);if(r.compareTo(t)>=0){r[r.t++]=1;r.subTo(t,r);}BigInteger.ONE.dlShiftTo(ys,t);t.subTo(y,y);// "negative" y so we can replace sub with am later
while(y.t<ys){y[y.t++]=0;}while(--j>=0){// Estimate quotient digit
var qd=r[--i]==y0?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);if((r[i]+=y.am(0,qd,r,j,0,ys))<qd){// Try it out
y.dlShiftTo(j,t);r.subTo(t,r);while(r[i]<--qd){r.subTo(t,r);}}}if(q!=null){r.drShiftTo(ys,q);if(ts!=ms)BigInteger.ZERO.subTo(q,q);}r.t=ys;r.clamp();if(nsh>0)r.rShiftTo(nsh,r);// Denormalize remainder
if(ts<0)BigInteger.ZERO.subTo(r,r);}// (public) this mod a
function bnMod(a){var r=nbi();this.abs().divRemTo(a,null,r);if(this.s<0&&r.compareTo(BigInteger.ZERO)>0)a.subTo(r,r);return r;}// Modular reduction using "classic" algorithm
function Classic(m){this.m=m;}function cConvert(x){if(x.s<0||x.compareTo(this.m)>=0)return x.mod(this.m);else return x;}function cRevert(x){return x;}function cReduce(x){x.divRemTo(this.m,null,x);}function cMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}function cSqrTo(x,r){x.squareTo(r);this.reduce(r);}Classic.prototype.convert=cConvert;Classic.prototype.revert=cRevert;Classic.prototype.reduce=cReduce;Classic.prototype.mulTo=cMulTo;Classic.prototype.sqrTo=cSqrTo;// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit(){if(this.t<1)return 0;var x=this[0];if((x&1)==0)return 0;var y=x&3;// y == 1/x mod 2^2
y=y*(2-(x&0xf)*y)&0xf;// y == 1/x mod 2^4
y=y*(2-(x&0xff)*y)&0xff;// y == 1/x mod 2^8
y=y*(2-((x&0xffff)*y&0xffff))&0xffff;// y == 1/x mod 2^16
// last step - calculate inverse mod DV directly;
// assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
y=y*(2-x*y%this.DV)%this.DV;// y == 1/x mod 2^dbits
// we really want the negative inverse, and -DV < y < DV
return y>0?this.DV-y:-y;}// Montgomery reduction
function Montgomery(m){this.m=m;this.mp=m.invDigit();this.mpl=this.mp&0x7fff;this.mph=this.mp>>15;this.um=(1<<m.DB-15)-1;this.mt2=2*m.t;}// xR mod m
function montConvert(x){var r=nbi();x.abs().dlShiftTo(this.m.t,r);r.divRemTo(this.m,null,r);if(x.s<0&&r.compareTo(BigInteger.ZERO)>0)this.m.subTo(r,r);return r;}// x/R mod m
function montRevert(x){var r=nbi();x.copyTo(r);this.reduce(r);return r;}// x = x/R mod m (HAC 14.32)
function montReduce(x){while(x.t<=this.mt2){// pad x so am has enough room later
x[x.t++]=0;}for(var i=0;i<this.m.t;++i){// faster way of calculating u0 = x[i]*mp mod DV
var j=x[i]&0x7fff;var u0=j*this.mpl+((j*this.mph+(x[i]>>15)*this.mpl&this.um)<<15)&x.DM;// use am to combine the multiply-shift-add into one call
j=i+this.m.t;x[j]+=this.m.am(0,u0,x,i,0,this.m.t);// propagate carry
while(x[j]>=x.DV){x[j]-=x.DV;x[++j]++;}}x.clamp();x.drShiftTo(this.m.t,x);if(x.compareTo(this.m)>=0)x.subTo(this.m,x);}// r = "x^2/R mod m"; x != r
function montSqrTo(x,r){x.squareTo(r);this.reduce(r);}// r = "xy/R mod m"; x,y != r
function montMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}Montgomery.prototype.convert=montConvert;Montgomery.prototype.revert=montRevert;Montgomery.prototype.reduce=montReduce;Montgomery.prototype.mulTo=montMulTo;Montgomery.prototype.sqrTo=montSqrTo;// (protected) true iff this is even
function bnpIsEven(){return(this.t>0?this[0]&1:this.s)==0;}// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function bnpExp(e,z){if(e>0xffffffff||e<1)return BigInteger.ONE;var r=nbi(),r2=nbi(),g=z.convert(this),i=nbits(e)-1;g.copyTo(r);while(--i>=0){z.sqrTo(r,r2);if((e&1<<i)>0)z.mulTo(r2,g,r);else{var t=r;r=r2;r2=t;}}return z.revert(r);}// (public) this^e % m, 0 <= e < 2^32
function bnModPowInt(e,m){var z;if(e<256||m.isEven())z=new Classic(m);else z=new Montgomery(m);return this.exp(e,z);}// protected
BigInteger.prototype.copyTo=bnpCopyTo;BigInteger.prototype.fromInt=bnpFromInt;BigInteger.prototype.fromString=bnpFromString;BigInteger.prototype.clamp=bnpClamp;BigInteger.prototype.dlShiftTo=bnpDLShiftTo;BigInteger.prototype.drShiftTo=bnpDRShiftTo;BigInteger.prototype.lShiftTo=bnpLShiftTo;BigInteger.prototype.rShiftTo=bnpRShiftTo;BigInteger.prototype.subTo=bnpSubTo;BigInteger.prototype.multiplyTo=bnpMultiplyTo;BigInteger.prototype.squareTo=bnpSquareTo;BigInteger.prototype.divRemTo=bnpDivRemTo;BigInteger.prototype.invDigit=bnpInvDigit;BigInteger.prototype.isEven=bnpIsEven;BigInteger.prototype.exp=bnpExp;// public
BigInteger.prototype.toString=bnToString;BigInteger.prototype.negate=bnNegate;BigInteger.prototype.abs=bnAbs;BigInteger.prototype.compareTo=bnCompareTo;BigInteger.prototype.bitLength=bnBitLength;BigInteger.prototype.mod=bnMod;BigInteger.prototype.modPowInt=bnModPowInt;// "constants"
BigInteger.ZERO=nbv(0);BigInteger.ONE=nbv(1);// prng4.js - uses Arcfour as a PRNG
function Arcfour(){this.i=0;this.j=0;this.S=new Array();}// Initialize arcfour context from key, an array of ints, each from [0..255]
function ARC4init(key){var i,j,t;for(i=0;i<256;++i){this.S[i]=i;}j=0;for(i=0;i<256;++i){j=j+this.S[i]+key[i%key.length]&255;t=this.S[i];this.S[i]=this.S[j];this.S[j]=t;}this.i=0;this.j=0;}function ARC4next(){var t;this.i=this.i+1&255;this.j=this.j+this.S[this.i]&255;t=this.S[this.i];this.S[this.i]=this.S[this.j];this.S[this.j]=t;return this.S[t+this.S[this.i]&255];}Arcfour.prototype.init=ARC4init;Arcfour.prototype.next=ARC4next;// Plug in your RNG constructor here
function prng_newstate(){return new Arcfour();}// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
var rng_psize=256;// Random number generator - requires a PRNG backend, e.g. prng4.js
// For best results, put code like
// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
// in your main HTML document.
var rng_state;var rng_pool;var rng_pptr;// Mix in a 32-bit integer into the pool
function rng_seed_int(x){rng_pool[rng_pptr++]^=x&255;rng_pool[rng_pptr++]^=x>>8&255;rng_pool[rng_pptr++]^=x>>16&255;rng_pool[rng_pptr++]^=x>>24&255;if(rng_pptr>=rng_psize)rng_pptr-=rng_psize;}// Mix in the current time (w/milliseconds) into the pool
function rng_seed_time(){rng_seed_int(new Date().getTime());}// Initialize the pool with junk if needed.
if(rng_pool==null){rng_pool=new Array();rng_pptr=0;var t;if(navigator.appName=="Netscape"&&navigator.appVersion<"5"&&window.crypto){// Extract entropy (256 bits) from NS4 RNG if available
var z=window.crypto.random(32);for(t=0;t<z.length;++t){rng_pool[rng_pptr++]=z.charCodeAt(t)&255;}}while(rng_pptr<rng_psize){// extract some randomness from Math.random()
t=Math.floor(65536*Math.random());rng_pool[rng_pptr++]=t>>>8;rng_pool[rng_pptr++]=t&255;}rng_pptr=0;rng_seed_time();//rng_seed_int(window.screenX);
//rng_seed_int(window.screenY);
}function rng_get_byte(){if(rng_state==null){rng_seed_time();rng_state=prng_newstate();rng_state.init(rng_pool);for(rng_pptr=0;rng_pptr<rng_pool.length;++rng_pptr){rng_pool[rng_pptr]=0;}rng_pptr=0;//rng_pool = null;
}// TODO: allow reseeding after first request
return rng_state.next();}function rng_get_bytes(ba){var i;for(i=0;i<ba.length;++i){ba[i]=rng_get_byte();}}function SecureRandom(){}SecureRandom.prototype.nextBytes=rng_get_bytes;// Depends on jsbn.js and rng.js
// Version 1.1: support utf-8 encoding in pkcs1pad2
// convert a (hex) string to a bignum object
function parseBigInt(str,r){return new BigInteger(str,r);}function linebrk(s,n){var ret="";var i=0;while(i+n<s.length){ret+=s.substring(i,i+n)+"\n";i+=n;}return ret+s.substring(i,s.length);}function byte2Hex(b){if(b<0x10)return"0"+b.toString(16);else return b.toString(16);}// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s,n){if(n<s.length+11){// TODO: fix for utf-8
alert("Message too long for RSA");return null;}var ba=new Array();var i=s.length-1;while(i>=0&&n>0){var c=s.charCodeAt(i--);if(c<128){// encode using utf-8
ba[--n]=c;}else if(c>127&&c<2048){ba[--n]=c&63|128;ba[--n]=c>>6|192;}else{ba[--n]=c&63|128;ba[--n]=c>>6&63|128;ba[--n]=c>>12|224;}}ba[--n]=0;var rng=new SecureRandom();var x=new Array();while(n>2){// random non-zero pad
x[0]=0;while(x[0]==0){rng.nextBytes(x);}ba[--n]=x[0];}ba[--n]=2;ba[--n]=0;return new BigInteger(ba);}// "empty" RSA key constructor
function RSAKey(){this.n=null;this.e=0;this.d=null;this.p=null;this.q=null;this.dmp1=null;this.dmq1=null;this.coeff=null;}// Set the public key fields N and e from hex strings
function RSASetPublic(N,E){if(N!=null&&E!=null&&N.length>0&&E.length>0){this.n=parseBigInt(N,16);this.e=parseInt(E,16);}else alert("Invalid RSA public key");}// Perform raw public operation on "x": return x^e (mod n)
function RSADoPublic(x){return x.modPowInt(this.e,this.n);}// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
function RSAEncrypt(text){var m=pkcs1pad2(text,this.n.bitLength()+7>>3);if(m==null)return null;var c=this.doPublic(m);if(c==null)return null;var h=c.toString(16);if((h.length&1)==0)return h;else return"0"+h;}// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
function RSAEncryptB64(text){var h=this.encrypt(text);if(h)return hex2b64(h);else return null;}// protected
RSAKey.prototype.doPublic=RSADoPublic;// public
RSAKey.prototype.setPublic=RSASetPublic;RSAKey.prototype.encrypt=RSAEncrypt;RSAKey.prototype.encrypt_b64=RSAEncryptB64;module.exports=RSAKey;

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_GB__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fr__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ja__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__it__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_0__de__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_1__en__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en_GB", function() { return __WEBPACK_IMPORTED_MODULE_2__en_GB__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_3__es__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fr", function() { return __WEBPACK_IMPORTED_MODULE_4__fr__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ja", function() { return __WEBPACK_IMPORTED_MODULE_5__ja__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_6__it__["a"]; });


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"Über","ABOUT_API_TAB":"API","ABOUT_VERSION":"Version","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio-Server","ABOUT_PORTFOLIO_VERSION":"Version 9.0","ABOUT_SERVER_TAB":"Server","accessOriginals":"Auf Originale zugreifen und verarbeiten","ACCOUNT_TYPE":"Echtheitsbestätigung","ACCOUNT_TYPE_LDAP":"Verzeichnisdienst","ACCOUNT_TYPE_MANUAL":"Nativ (integriert)","ACTIVE_DIRECTORY":"Active Directory","ADD":"Hinzufügen","ALL_CATALOGS_GROUP":"Alle Kataloge","API_CODE_REFERENCE":"API-Code-Referenzmaterial (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"Entwicklergemeinde","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"Portfolio Administration – Hilfe","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/de/portfolio/administration/{version}/index.htm","API_SECTION_1":"Die Portfolio API stellt eine allgemeine Schnittstelle für Entwickler bereit. Sie dient zur Integrierung von Portfolio-Katalogen, Inventar-Metadaten und Medienverarbeitung für Geschäftssysteme, benutzerdefinierte Arbeitsabläufe und Internet-Infrastrukturen.","API_SECTION_2_PART_1":"Für die Nutzung der API sind Lizenzen erforderlich ","API_SECTION_2_EULA":"wie in der EULA beschrieben","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/de/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":". Zum Anzeigen bzw. Bearbeiten der Lizenzinformationen klicken Sie in der Portfolio Administration-Anwendung auf 'Lizenzen'.","API_SECTION_2_PART_3":"Mehr lernen:","API_TOKEN_CREATE":"Fügen Sie einen neuen API Token hinzu","APPLY":"Anwenden","APP_PAGE_TITLE":"Portfolio-Administrator","AT_TIME":"Uhrzeit","AUTHENTICATION_ERROR":"Fehler bei der Verzeichnisservice-Authentifikation. Prüfen Sie Benutzernamen und Passwort.","BACKUP_BACKUP_BUTTON":"Datensicherung","BACKUP_BACKUP_LABEL":"Datensicherung","BACKUP_BACKUP_NOW_BUTTON":"Jetzt Daten sichern","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Wenn Sie den Backup Speicherort ändern möchten, fahren Sie zuerst den Portfolio Server herunter.","BACKUP_CONFIRMATION_VERBIAGE":"Jetzt Daten sichern? Bis die Datensicherung abgeschlossen ist, wird Portfolio wird offline sein.","BACKUP_DIRECTORY_LABEL":"In Verzeichnis speichern","BACKUP_DIRECTORY_ERROR_MSG":"Das ausgewählte Datensicherungsverzeichnis ist ungültig.","BACKUP_EXPLANATION_TEXT_1":"Backups erfassen und die Server-Datenbank und Einstellungen sicher abspeichern. \nlt erstellt kein Backup Ihrer ursprünglichen Asset-Dateien!","BACKUP_EXPLANATION_TEXT_2":"Während der Datensicherung kann nicht auf den Server zugegriffen werden.","BACKUP_FRIDAY_LABEL":"Freitag","BACKUP_MONDAY_LABEL":"Montag","BACKUP_MOST_RECENT_LABEL":"Neuste Datensicherung","BACKUP_NEXT_SCHEDULED_LABEL":"Nächste planmäßige Datensicherung","BACKUP_NOTIFICATIONS":"E-Mail-Benachrichtigungen nach Backups und Wiederherstellungen senden","BACKUP_NOTIFICATIONS_DISABLED_MSG":"E-Mail Benachrichtigungen müssen in den globalen Einstellungen> E-Mail Benachrichtigungen, aktiviert sein","BACKUP_PROGRESS_BACKING_UP":"Datensicherung läuft","BACKUP_PROGRESS_BACKING_UP_DATA":"Daten werden gesichert...","BACKUP_PROGRESS_BACKUP_CANCELLED":"Datensicherung abgebrochen","BACKUP_PROGRESS_BACKUP_FAILED":"Datensicherung fehlgeschlagen","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"Datensicherung erfolgreich","BACKUP_PROGRESS_PREFLIGHT":"Verfügbarer Speicherplatz wird geprüft...","BACKUP_PROGRESS_RESTARTING":"Server wird neu gestartet...","BACKUP_PROGRESS_RESTORE_FAILED":"Wiederherstellung fehlgeschlagen","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"Wiederherstellung erfolgreich","BACKUP_PROGRESS_RESTORING":"Wird wiederhergestellt","BACKUP_PROGRESS_RESTORING_DATA":"Daten werden wiederhergestellt...","BACKUP_PROGRESS_SHUTTING_DOWN":"Server wird heruntergefahren...","BACKUP_PROGRESS_SUMMARY":"Schritt {stepNum} von {totalSteps}","BACKUP_RESTORE_BUTTON":"Von Datensicherungsdatei wiederherstellen...","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"Datensicherung jetzt wiederherstellen? Bis die Wiederherstellung abgeschlossen ist, ist Portfolio offline. Dies wird Ihre aktuelle Datenbank und Einstellungen überschreiben.","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"Das Datensicherungsarchiv ist fehlerhaft. Wählen Sie für die Wiederherstellung eine andere Datensicherung aus.","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"Die Datensicherungsdiskette verfügt nicht über ausreichend Speicherplatz\num den Vorgang abzuschließen.\n\n{requiredSpace} erforderlich, {availableSpace} verfügbar.","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"Der aktuell konfigurierte Sicherungspfad ist nicht vorhanden. Der Sicherungspfad wird für das Extrahieren des Archivs verwendet, wenn eine Sicherung wiederhergestellt wird. Bitte setzen Sie die Sicherung auf ein gültiges Verzeichnis zurück.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"Bei dem/der Datensicherung ist ein Problem aufgetreten. Siehe Admin-Logs für Einzelheiten.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"Bei dem/der Wiederherstellung ist ein Problem aufgetreten. Siehe Admin-Logs für Einzelheiten.","BACKUP_RESTORE_LABEL":"Wiederherstellen","BACKUP_RESTORE_TITLE":"Sichern/Wiederherstellen","BACKUP_RETAIN_LABEL":"Behalten","BACKUP_RETAIN_VALUE":"Nur die {numBackups} jüngsten Datensicherungen behalten","BACKUP_SATURDAY_LABEL":"Samstag","BACKUP_SCHEDULE_LABEL":"Datensicherungsplan erstellen","BACKUP_SCHEDULE_VALUE":"ein","BACKUP_SUNDAY_LABEL":"Sonntag","BACKUP_THURSDAY_LABEL":"Donnerstag","BACKUP_TUESDAY_LABEL":"Dienstag","BACKUP_WEDNESDAY_LABEL":"Mittwoch","BROWSE":"Durchsuchen","BROWSE_FOLDERS_TITLE":"Ordner auf Server durchsuchen","BROWSE_RECENT_FOLDERS_LABEL":"Letzte Ordner","BROWSE_REFRESH":"Artikel synchronisieren","CALL_ATT_BUTTON_BUY_NOW":"Jetzt kaufen","CALL_ATT_BUTTON_SECONDARY":"Setzen Sie sich mit der Verkaufsabteilung für einen Kostenvoranschlag in Verbindung","CALL_ATT_FADEL_BUTTON_MAIN":"Kontakt-Verkäufe zu mehr Information","CALL_ATT_FADEL_MAIN":"Stellen Sie eine angemessene Nutzung Ihrer lizenzierten Inhalte (von Bildern bis hin zu Videos und alles dazwischen) sicher. Portfolio verbindet sich nahtlos mit Rights-Cloud-Software von FADEL, sodass Sie die Nutzungsrechte in Verbindung mit Ihren Assets mühelos sehen und nachvollziehen können, was Ihnen dabei hilft, Engpässe zu beseitigen und die Gefahr kostspieliger Urheberrechtsverletzungen zu reduzieren.","CALL_ATT_FADEL_SUBTITLE":"Kennen Sie Ihre Asset-Nutzungsrechte","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"Hochleistungsverarbeitung und Umwandlung","CALL_ATT_ME_MAIN":"Bringen Sie Ihren Portfolio Server an seine Leistungsgrenzen? Mit Media Engine vermeiden Sie Verlangsamungen und verbessern die Gesamtproduktivität, indem die Engpässe, die durch hoch belastete Produktionsumgebungen verursacht werden, eliminieren.\n\n\t• Erhöht die Kapazität und den Datendurchsatz\n\t• Entsperrt zusätzliche Ausgabeformate\n\t• Beschleunigt die Erstellung der Video Vorschau\n\t• Fügen Sie verschiedene Media Engines nach Bedarf hinzu\n\t• Wasserzeichenmarkierung (erfordert NetPublish)","CALL_ATT_ME_BUTTON_MAIN":"Holen Sie sich Media Engine","CALL_ATT_NP_SUBTITLE":"Selbstbedienungsportale für einen sofortigen Zugang zu den Assets","CALL_ATT_NP_MAIN":"Sind Sie diese Anfragen nach Assets in letzter Minute leid? Mit NetPublish ist es einfach Selbstbedienungswebseiten zu posten, bei denen jeder nach Bedarf die Assets von jedem Browser auf jedem Gerät lokalisieren und herunterladen kann.\n\n\t• Seitenerstellung mit einem Klick - kein HTML oder CSS erforderlich\n\t• Mobilgeräte-freundliches, ansprechendes Design\n\t• Flexible Nutzerzugangskontrolle\n\t• Deaktivieren Sie Sites automatisch\n\t• Stellen Sie die Auflösung, die Größe und das Format für den Download ein\n\t• Wasserzeichenmarkierung (erfordert Media Engine)\n\t• Nutzungsberichte","CALL_ATT_NP_BUTTON_MAIN":"Holen Sie sich NetPublish","CALL_ATT_REPORT_TITLE":"Berichterstattung für NetPublish","CALL_ATT_REPORT_SUBTITLE":"RelevanteNutzungseinblicke","CALL_ATT_REPORT_MAIN":"Wollen Sie wissen welche Seiten am aktivsten sind, welche Assets benutzt werden und von wem? Mit NetPublish Berichterstattung bekommen Sie die Einblicke, die Sie brauchen, um Entscheidungen auf der Grundlage der Nutzung des Portfolios Ihres Unternehmens zu treffen.\n\nAufschlüsselung der Nutzung von:\n\t• NetPublish Seitenname\n\t• Nutzername\n\t• Assetname und ID\n\t• Datumund Uhrzeit","CALL_ATT_REPORT_BUTTON_MAIN":"Holen Sie sich NetPublish","CALL_ATT_SK_BUTTON_MAIN":"Versuchen Sie es kostenlos","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/ykx7","CALL_ATT_SK_MAIN":"Sie suchen einen Weg, Ihren Prozess zu beschleunigen, Schlüsselwörtern Bildern zuzuweisen? Mit Portfolio Smart Keywords können Sie Ihren Bildern mit nur einem Klick automatisch „smart“ Keywords Ihren Bildern zuweisen. Durch Clarifai unterstützt, ein innovatives künstliches Intelligenz Unternehmen, das sich in der visuellen Erkennungstechnologie auszeichnet, eine Liste von Keywordsvorschlägen wird Ihnen in Sekunden geliefert. \n\n\t • Liefert eine Liste von smart keywords in Sekunden \n\t • Spart Zeit und Ressourcen bei der manuellen Keywordsuche \n\t • Etabliert eine konsistente Systematik für Ihre Organisation \n\t • Macht es einfach, Ihre digitalen Bestände schnell zu finden","CALL_ATT_SK_SUBTITLE":"Automatisieren Sie Ihr Bild Keywording","CALL_ATT_SK_TITLE":"Portfolio Smart Keywords","CALL_ATT_SSO_SUBTITLE":"Nahtlose plattformübergreifende Nutzererfahrungen","CALL_ATT_SSO_TITLE":"Einmalige Anmeldung","CALL_ATT_SSO_MAIN":"Haben die Leute in Ihrem Unternehmen Schwierigkeiten, Ihre Anmeldedaten zu behalten? Mit neuen Lösungen geht typischerweise ein Mehraufwand bei der Verwaltung der Nutzerkonten einher, sowohl für Sie als auch für die Nutzer.\n\nGlücklicherweise unterstützt Portfolio die einmalige Anmeldung mit Active Directory. Wenn sie die einmalige Anmeldung nutzen, können die Nutzer sich automatisch von Ihrer Intranetseite in das Portfolio einloggen, wodurch sie eine kontinuierliche Nutzererfahrung haben.\n\n\t• Wird von Windows Server Active Directory unterstützt\n\t• Verbessert die Gesamtsicherheit\n\t• Vereinfacht die Nutzerverwaltung\n\t• Verbessert die Nutzererfahrung","CALL_ATT_SSO_BUTTON_MAIN":"Holen Sie sich Single Sign-On","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options?lang=de","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/de/portfolio/contact-me","canEmbedMetadata":"Eingebettete Metadaten","canImportMetadata":"Daten exportieren/importieren","canManagePublicGallery":"Öffentliche Galerien verwalten","canPublishNetPublishSites":"Kann Veröffentlichen NetPublish Seiten","canSmartKeyword":"Kann Smart Keyword","CANCEL":"Abbrechen","CATALOG":"Katalog","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"Mitgliedschaft zulassen","CATALOG_BACKUP":"Ausgewählten Katalog sichern","CATALOG_CREATE":"Neuen Katalog hinzufügen","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"Katalogverwalter können vom Desktop Client aus AutoSync-Ordner hinzufügen.","CATALOG_CREATE_AUTOSYNC_FOLDER":"Einen AutoSync-Ordner erstellen","CATALOG_CREATE_CATALOG_TEMPLATE":"Katalogvorlage","CATALOG_TYPE_GENERAL":"Allgemeine Verwendung","CATALOG_TYPE_SIMPLE":"Einfach","CATALOG_CREATE_DATABASES_LIST_LABEL":"Datenbanken","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"Beim Erstellen des {folder}-Ordners trat ein Fehler auf.","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"Standardordner für AutoSync und Vorschaubilder können in den globalen Einstellungen konfiguriert werden.","CATALOG_CREATE_NAME":"Name","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"Vorschaubilder können in den Katalogdetails konfiguriert werden.","CATALOG_CREATE_PREVIEW_FOLDER":"Für schnelleres Anzeigen die Vorschaubilder speichern","CATALOG_CREATE_SHOW_DATABASES":"Datenbanken anzeigen","CATALOG_CREATE_USE_VERSIONING":"Nutzen Sie die Asset Versionierung","CATALOG_DELETE":"Katalog löschen","CATALOG_DELETE_CONFIRM":"Möchten Sie den ausgewählten Katalog löschen?","CATALOG_DETAILS":"Katalogdetails","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"Zum Umbenennen des Katalogs muss dieser vorübergehend offline genommen werden. Möchten Sie fortfahren?","CATALOG_DETAILS_COLLATION":"Sortierfolge","CATALOG_DETAILS_COLLATION_NA":"—","CATALOG_DETAILS_CREATION_DATE":"Erstellungsdatum","CATALOG_DETAILS_DATABASE_TAB":"Allgemein","CATALOG_DETAILS_LAST_MODIFIED":"Zuletzt geändert am","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"Verbundene Benutzer","CATALOG_DETAILS_NUMBER_OF_RECORDS":"Datensätze","CATALOG_DETAILS_NUMBER_OF_USERS":"Mitglieder","CATALOG_DETAILS_SIZE_ON_DISK":"Größe auf Festplatte","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"Der Administrator-Benutzer wird getrennt. Fortfahren?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"Gesperrt für Administration","CATALOG_DETAILS_UNLOCK":"Entsperren","CATALOG_EXPLANATION_VAULT_1":"Vault Kataloge speichern die Assets in einer sicheren Ablage.","CATALOG_EXPLANATION_VAULT_2":"Support-Sperre, Versionseinstellung, Check-Out und Check-In der Vault Kataloge.","CATALOG_EXPLANATION_WF_1":"Watch Ordner Kataloge verfolgen die Assets zurück, die sich in Ihrem Dateisystem befinden.","CATALOG_EXPLANATION_WF_2":"Watch Ordner Kataloge werden von AutoSync. unterstützt.","CATALOG_INGEST_DRAG_HINT_TEXT":"Um dem Upload-Formular Felder hinzuzufügen, ziehen Sie diese aus der Felderliste herüber.","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"Felder für Upload-Formular","CATALOG_INGEST_FIELDS_LABEL":"Felder","CATALOG_INGEST_FORM_HEADER_LABEL":"Formularkopf","CATALOG_INGEST_HEADER_HINT_TEXT":"Der Formularkopf ist optional und erscheint oben auf dem Formular.","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"Die maximale Anzahl hinzufügbarer Felder ist {maxFields}.","CATALOG_INGEST_TAB_TITLE":"Verwalteter Upload","CATALOG_INGEST_USE_INGEST_LABEL":"Managed Upload verwenden","CATALOG_INGEST_REQUIRED_LABEL":"Erforderlich","CATALOG_IS_CONNECTED":"Verbunden","CATALOG_IS_DEFAULT":"Standard","CATALOG_MANAGE_USERS":"Katalogmitgliedschaft verwalten","CATALOG_MANAGE_FIELDS":"Katalogfelder verwalten","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"Katalogvorlagen verwalten...","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"Benutzerdefinierte Katalogvorlagen verwalten","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"Name der Katalogvorlage","CATALOG_MEMBER":"Mitglied","CATALOG_NEW_CATALOG_DETAILS":"Neue Katalogdetails","CATALOG_OFFLINE":"Offline","CATALOG_ONLINE":"Online","CATALOG_OPTIONS_ALL_FILE_TYPES":"Katalog Alle Dateitypen","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"Schlüsselbegriffe von Pfad generieren","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"Dateiname","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"Übergeordneter Ordner","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"Servername","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"Ordnerhierarchie","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"Band","CATALOG_OPTIONS_EXCLUSION_LABEL":"Datei- und Ordnerausschlüsse","CATALOG_OPTIONS_ONLY_FILE_TYPES":"Nur Katalog Catalogar únicamente","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"Ausgewählte(n) Dateityp(en) entfernen?","endsWith":"Endet mit","contains":"Enthält","startsWith":"Beginnt mit","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"Den/die ausgewählten Ausschlüsse entfernen?","CATALOG_OPTIONS_TAB_TITLE":"Katalogisierungsoptionen","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"Der Standardort ist","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"Mindestgröße 300 Pixel, maximale Größe 4000 Pixel (längste Dimension)","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"Clips für Audio/Video-Dateien erstellen","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"Vorschaubilder erstellen","CATALOG_PREVIEWS_FOLDER_LOCATION":"Vorschaubilder und Clips in diesem Ordner speichern","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"Der Server muss auf den Speicherort zugreifen können.","CATALOG_PREVIEWS_MAX_PIXELS":"Maximale Bildgröße","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"Maximale Video-Auflösung","CATALOG_PREVIEWS_MINUTES":"Minuten","CATALOG_PREVIEWS_PIXELS":"Pixel","CATALOG_PREVIEWS_SHORT":"Vorschaubilder","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"Dauer begrenzen auf:","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"Das Erstellen von Clips kann eine Weile dauern. \nWenn Sie die Bearbeitungszeit verkürzen möchten, wählen Sie eine niedrigere Auflösung und Dauer.","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"Mitgliedschaft aufheben","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"Den Nutzer aus dem Katalog entfernen? \nDie aus diesem Katalog ausgechecktenArtikel werden zurückgegeben und zur Verfügung gestellt.","CATALOG_SAVE_TEMPLATE":"Katalogvorlage speichern...","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"Die gespeicherte Katalogvorlage enthält: alle Felder, Metadatenzuordnungen und Katalog-Optionseinstellungen.","CATALOG_SELECT_MESSAGE":"Kein Katalog ausgewählt","CATALOG_SET_AS_DEFAULT":"Standardkatalog festlegen","CATALOG_SK_DEFAULT_SETTINGS":"Standardeinstellungen","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"Konfidenzniveau","CATALOG_SK_DEFAULT_LABEL":"Empfohlen: {recommended}","CATALOG_SK_ENGINES_LABEL":"Smart Keywords-Engines","CATALOG_SK_LANGUAGES_LABEL":"Sprachen für die General-Engine","CATALOG_SK_NUM_KEYWORDS_LABEL":"Anzahl Suchbegriffe","CATALOG_SK_SETTINGS_LABEL":"Einstellungen","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"Smart Keywords in diesem Katalog nutzen","CATALOG_STATUS":"Katalogstatus","CATALOG_STORAGE_TYPE_LABEL":"Speichertyp","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"Ordner beobachten","CATALOG_STORAGE_TYPE_VAULT":"Vault","CATALOG_TAKE_OFFLINE_SHORT":"Offline stellen","CATALOG_TAKE_ONLINE_SHORT":"Online stellen","CATALOG_TEMPLATE":"Vorlage","CATALOG_TEMPLATE_NAME":"Vorlagenname","CATALOG_TEMPLATES_TITLE":"Katalogvorlagen","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"Markierte Katalogvorlage entfernen?","CATALOG_VIEW_DETAILS":"Katalogdetails anzeigen/bearbeiten","CERT_REQUEST_ALREADY_CREATED_WARNING":"Sie haben bereits eine Zertifikatsanforderung gemacht Wenn Sie fortfahren, wird die vorhandene Anforderung gelöscht.","CERTIFICATE_FILE_FILTER":"Zertifikate (p7b, p7, cer, crt, pem, pfx, p12)","CITY_OR_LOCALITY":"Stadt oder Ort","CLEAR_BUTTON_LABEL":"Löschen","COMMUNICATION_AT_INITILIZATION_ERROR":"Bei der Kommunikation mit dem Server ist ein Fehler aufgetreten. Dies wird üblicherweise durch veraltete Daten im Browser-Cache verursacht, könnte aber auch auf ein Problem mit dem Server hinweisen. Wenden Sie sich für weitere Informationen an den Administrator.","CONFIGURE_DIRECTORY_SERVICE":"Verzeichnisdienst konfigurieren","CONFIRM_DELETE_PDL":"Alle vordefinierten Werte für dieses Feld löschen?","CONFIRM_DELETE_SERVICE":"Verzeichnisdienst löschen?\nVom Dienst importierte Benutzer bleiben bestehen. Für deren Passwörter werden zuvor in Portfolio enthaltene Werte wiederhergestellt bzw. deaktiviert (falls zuvor nicht festgelegt).","CONFIRM_TRUNCATE_VALUES":"Die max. Länge überschreitet einen oder mehrere standardmäßige oder vordefinierte Werte für dieses Feld. Werte kürzen?","CONNECTION_REFUSED_ERROR":"Die Verbindung mit dem Verzeichnisservice wurde abgelehnt. Prüfen Sie Hostnamen und Port-Einstellungen.","CONTAINS":"enthält","CONTINUE":"Weiter","CREATE":"Erstellen","CREATE_A_CERTIFICATE_REQUEST":"Zertifikat-Signaturanforderung erstellen","createContactSheet":"PDF erstellen","CREATED_BY":"Erstellt von","CREATE_MAPPING":"Zuweisung Erstellen","CREATE_USER_EXCLUSION_MAPPING":"Benutzer Ausschließen","CREATED_ON_DATE":"Erstellungsdatum","DATE_FORMAT":"DD.MM.YYYY","DATE_FORMAT_ERROR":"Konfigurationsfehler: Falsche Formatierungszeichenfolge.","DATE_INVALID_CHAR_ERROR":"Das Datum enthält ungültige Zeichen.","DATE_TIME_FORMAT":"DD.MM.YYYY L:NN A","DATE_TIME_SECONDS_FORMAT":"DD.MM.YYYY L:NN:SS A","DATE_WRONG_DAY_ERROR":"Geben Sie einen gültigen Tag für den Monat ein.","DATE_WRONG_LENGTH_ERROR":"Geben Sie das Datum in diesem Format ein:","DATE_WRONG_MONTH_ERROR":"Geben Sie einen Monat zwischen 1 und 12 ein","DATE_WRONG_YEAR_ERROR":"Geben Sie ein Jahr zwischen 0 und 9999 ein","DEFAULT_ACCESS_LEVEL":"Standardrolle","DEFAULT_CATALOG":"Standardkatalog","DEFAULT_CATALOG_NONE":"Keine","DEFAULT_PORT_NON_SSL":"Standard-Port für Nicht-SSL:","DEFAULT_PORT_SSL":"Standard-Port für SSL:","DELETE":"Löschen","DELETE_SOURCE":"Quelle Löschen","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"Alle Werte löschen? Dies wird alle Werte löschen, einschließlich verschachtelter Werte.","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"Den Wert '{value}' löschen?\nEr enthält verschachtelte Werte, die ebenfalls gelöscht werden.","DELETE_NESTED_VALUE_CONFIRMATION":"Die auswählten Werte löschen? Sie enthalten verschachtelte Werte, die ebenfalls gelöscht werden.","DELETE_WARNING_BOX_MSG":"Warnung! Das Löschen kann nicht rückgängig gemacht werden!","DELETE_WARNING_CATALOG_VAULT":"Alle Dateien im Katalog werden zerstört.","DIAGNOSTIC_DATA_TITLE":"Diagnosebericht an Portfolio DAM senden","DIAGNOSTIC_DATA_ACCOUNT_NAME":"Unternehmen oder Kontoname (Erforderlich)","DIAGNOSTIC_DATA_CONTACT_NAME":"Name des Kontakts","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"Technischer Support Ticket Nummer","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"Sende Bericht","DIAGNOSTIC_STATUS_ERROR":"Es gab ein Problem beim Hochladen des Diagnoseberichtes auf {date}","DIAGNOSTIC_STATUS_SENDING":"Senden...","DIAGNOSTIC_STATUS_SUCCESS":"Der Diagnosebericht wurde erfolgreich an Portfolio DAM auf {date} gesandt","DIRECTORY_SERVICE_CONNECT_ERROR":"Die Verbindung mit dem Verzeichnisservice konnte nicht hergestellt werden. Prüfen Sie Hostnamen und Port-Einstellungen.","DIRECTORY_SERVICES":"Verzeichnisdienst","DIRECTORY_USERS_CANNOT_BE_DELETED":"Benutzer des Verzeichnisdienstes können nicht gelöscht werden.","DISTRIBUTION_GROUPS":"Distributionsgruppen","DOWNLOAD_CERT_PROMPT":"Zertifikatanforderungsdatei herunterladen?","DOWNLOAD_COMPLETE_STRING":"Download abgeschlossen.","downloadPreviews":"Vorschaubilder herunterladen","EMAIL_ADDRESS":"E-Mail-Adresse","EMAIL_CONFIG_AUTH_PASSWORD":"Kennwort","EMAIL_CONFIG_AUTH_USERNAME":"Benutzername","EMAIL_CONFIG_ENABLED":"E-Mail-Feedback aktivieren","EMAIL_CONFIG_FROM_ADDRESS":"E-Mail von Adresse","EMAIL_CONFIG_INVALID_GENERIC":"E-Mail Server-Konfiguration ist ungültig","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"E-Mail Server nicht gefunden","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"E-Mail Server Authentifizierung fehlgeschlagen","EMAIL_CONFIG_MESSAGE":"Jeder Benutzer, der Benachrichtigungen erhalten möchte, muss im Benutzerbereich eine E-Mail-Adresse zugeordnet bekommen.","EMAIL_CONFIG_SERVER_ADDRESS":"SMTP Server Adresse","EMAIL_CONFIG_SERVER_PORT":"SMTP Server Port","EMAIL_CONFIG_SUCCESS_MESSAGE":"SMTP Server verifiziert","EMAIL_CONFIG_USE_SSL_TLS":"Verwende SSL / TLS","EMAIL_CONFIG_USE_SMTP_AUTH":"Verwende SMTP Authentifizierung","EMAIL_CONFIG_VALIDATE":"Verbindung testen","EMAIL_CONFIG_VALIDATED":"E-Mail Server verifiziert","english":"Englisch","ENTIRE_TREE_UNDER_SEARCH_BASE":"Gesamter Verzeichnisbaum unter Suchbasis","EQUALS":"ist gleich","EXPORT_MENU_STRING":"Werte exportieren","FADEL_HOWTO":"LOGON zu Ihrem FADEL Konto:","FALSE_LABEL":"Falsch","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"Stellen Sie sicher, dass der Admin-Server auf dem lokalen Rechner läuft und den auf der Port-Seite angegebenen Port verwendet. Sollte dies nicht der Fall sein, muss der Server erneut gestartet und diese Anwendung noch einmal geladen werden.","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"Während ein Datensicherungs- oder -wiederherstellungsprozess läuft, kann dieser Vorgang nicht durchgeführt werden.","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"Bei diesem Vorgang ist ein Fehler aufgetreten, da sich der Katalog im Verwaltungsmodus befindet.","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"Ein Katalog mit diesem Namen ist bereits vorhanden.","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"Ein Benutzer mit diesem Kontonamen ist bereits vorhanden.","FAULT_MSG_DB_IN_USE":"Der Vorgang konnte nicht abgeschlossen werden, da der Katalog derzeit von einem Administrator verwendet wird.","FAULT_MSG_DELETE_ADMIN":"Sie können das Administratorkonto nicht löschen.","FAULT_MSG_DELETE_SELF":"Sie können Ihr Benutzerkonto nicht löschen.","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"Während des Löschens der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.","FAULT_MSG_DUPE_NAME":"Ein Objekt mit diesem Namen ist bereits vorhanden. Bitte geben Sie einen anderen Namen ein.","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"Eine Media Engine mit dieser Adresse und diesem Port ist bereits vorhanden.","FAULT_MSG_ENTITY_VERSION_MISMATCH":" Bei diesem Vorgang ist ein Fehler aufgetreten, da die Kundendaten nicht mehr aktuell sind.","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"Stellen Sie sicher, dass der Server auf dem lokalen Rechner läuft und den auf der Port-Seite angegebenen Port verwendet. Sollte dies nicht der Fall sein, muss der Server erneut gestartet und die Anwendung noch einmal geladen werden.","FAULT_MSG_INVALID_SESSION_ID":"Ihre Sitzung ist abgelaufen. Sie müssen sich erneut beim Server anmelden.","FAULT_MSG_IS_NOT_LICENSED":"Für diesen Vorgang besitzt der Server keine Lizenz.","FAULT_MSG_LEGACY_21000":"Dieser Vorgang ist aufgrund eines unbekannten internen Fehlers fehlgeschlagen.","FAULT_MSG_LOGGING_ERR_UPDATE":"Bei der Aktualisierung der Protokoll-Konfiguration ist ein Fehler aufgetreten","FAULT_MSG_LOG_DIR_NOT_VALID":"Das angegebene Log-Verzeichnis existiert nicht, das Schreiben in diesem Verzeichnis ist nicht möglich oder der Pfad ist kein Verzeichnis.","FAULT_MSG_NO_DIRECTORY":"Der angegebene Ort ist nicht vorhanden bzw. ist kein Verzeichnis.","FAULT_MSG_NULL_DESCRIPTION":"Ein unerwarteter Fehler ist aufgetreten; eine Beschreibung ist jedoch nicht vorhanden.","FAULT_MSG_NULL_FAULTEVENT":"Ein unerwarteter Fehler ist aufgetreten; Details sind jedoch nicht vorhanden.","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"Bei diesem Vorgang ist ein Fehler aufgetreten, da Sie unzureichende Berechtigungen haben.","FAULT_MSG_OPERATION_IS_INVALID":"Dieser Vorgang war ungültig.","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"Während der Umbenennung der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"Während der Speicherung der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.","FAULT_MSG_SERVER_NOT_RUNNING":"Der Server läuft nicht.","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"Bei diesem Vorgang trat ein Fehler auf, da der Server keine Enterprise Modul-Lizenz besitzt.","FAULT_MSG_REMOVE_METADATA_DEF":"Die Metadaten-Definition konnte nicht entfernt werden. Möglicherweise wird sie von anderen Katalogen genutzt.","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"Der Server hat einen Fehler mit der folgenden Meldung ausgegeben: ","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"Der Server hat einen Fehler ohne Fehlermeldung ausgegeben. ","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"Der Server hat einen Fehler unbekannter Art mit der folgenden Meldung ausgegeben:","FAULT_MSG_UNKNOWN_SMTP_SERVER":"Verbindung mit dem angegebenen E-Mail Server nicht möglich.","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"Bei diesem Vorgang ist ein Fehler aufgetreten, da sich ein Dienst nicht im erwarteten Zustand befand.","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"Benutzername oder Passwort ist für diese Datenbank ungültig.","FAULT_MSG_BAD_DB_PORT":"Angegebener Datenbank-Anschluss ist ungültig.","FAULT_MSG_BAD_DB_HOST":"Angegebener Datenbank-Hostname oder Anschluss ist ungültig.","FIELD_ACTION_ADD":"Neues benutzerdefiniertes Feld hinzufügen","FIELD_ACTION_DELETE":"Markiertes Feld löschen","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"XMP-Namespaces","FIELD_ACTION_MANAGE_METADATA":"Metadaten verwalten","FIELD_CATEGORY_CUSTOM":"Benutzerdefinierte Felder","FIELD_CATEGORY_SYSTEM":"Systemfelder","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"Film","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"Feldkategorie","FIELD_DISABLE_CONFIRM_MSG":"Möchten Sie das ausgewählte Feld deaktivieren?","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"Alle aktivieren","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"Extraktionszuordnung hinzufügen","FIELD_FORM_LABEL_DEFAULT_VALUE":"Standardwert","FIELD_FORM_LABEL_DISABLED":"(Deaktiviert)","FIELD_FORM_LABEL_EMBED":"In Metadaten einbetten","FIELD_FORM_LABEL_EXTRACT":"Aus Metadaten extrahieren","FIELD_FORM_LABEL_FIELD_NAME":"Feldname","FIELD_FORM_LABEL_FIELD_TYPE":"Feldtyp","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"Mehrere Werte zulassen","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"Hat vordefinierte Werte","FIELD_FORM_LABEL_HELP_TEXT":"Hilfetext","FIELD_FORM_LABEL_MAX":"Max: {max}","FIELD_FORM_LABEL_MAX_LENGTH":"Max. Länge","FIELD_FORM_LABEL_METADATA_TAG":"Metadaten-Name","FIELD_FORM_LABEL_METADATA_TYPE":"Metadaten-Typ","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"Nur vordefinierte Werte zulassen","FIELD_FORM_LABEL_PRECISION":"Präzision","FIELD_FORM_LABEL_PREDEFINED_VALUES":"Vordefinierte Werte","FIELD_FORM_LABEL_SHOW_TIME":"Showtime","FIELD_FORM_LABEL_USE_METADATA":"Metadaten extrahieren und einbetten","FIELD_FORM_WARNING_DUPE_EMBEDS":"Warnung: Es wird mehr als ein Feld in '{metadata}' eingebettet","FIELD_METADATA_DATA_TYPE_LABEL":"Datentyp","FIELD_METADATA_DEFINITION_IS_CUSTOM":"Ist benutzerdefiniert","FIELD_METADATA_DEFINITIONS_TITLE":"Metadaten-Definitionen","FIELD_METADATA_DELETE_CONFIRM_MSG":"Bestätigen: Metadaten-Definition löschen?","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"Mehrwertiger Typ","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"Nicht mehrwertig","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"Geordnet","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"Ungeordnet","FIELD_METADATA_NAME_LABEL":"Name","FIELD_METADATA_NAMESPACE_LABEL":"Namespace","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"Einen benutzerdefinierten XMP-Namespace hinzufügen...","FIELD_METADATA_TAG_LABEL":"Tag","FIELD_METADATA_TYPE_LABEL":"Typ","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"Mehrere Felder ausgewählt","FIELD_NAMESPACE_ABBREVIATION":"Abkürzung","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"Benutzerdefinierten XMP-Namespace löschen?\nMöglicherweise nutzen Felddefinitionen den Namespace.","FIELD_NAMESPACE_URI":"Namespace URI","FIELD_NEW_FIELD_NAME":"Neues Feld","FIELD_NEW_METADATA_TITLE":"Neue Metadaten-Definition","FIELD_NEW_NAMESPACE_TITLE":"Neuer benutzerdefinierter XMP-Namespace","FIELD_NO_FIELD_SELECTED_MESSAGE":"Kein Feld ausgewählt","FIELD_PAGE_TITLE":"Feder für Katalog '{catalogName}' verwalten","FIELD_REVERT_CONFIRM_MSG":"Bestätigen: Feld wiederherstellen?","FIELD_TYPE_BLOB":"Blob","FIELD_TYPE_BOOLEAN":"Boolesch","FIELD_TYPE_DATETIME":"Datum/Uhrzeit","FIELD_TYPE_DECIMAL":"Dezimal","FIELD_TYPE_LANG_ALT":"Lang Alt","FIELD_TYPE_NUMBER":"Zahl","FIELD_TYPE_PICTURE":"Bild","FIELD_TYPE_STRING":"String","FIELD_TYPE_STRUCTURE":"Struktur","FIELD_TYPE_TEXTBLOCK":"Textblock","FIELD_TYPE_UNKNOWN":"Unbekannt","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"Beim Hochladen der Datei auf den Server trat ein Fehler auf.","FILE_WRONG_TYPE_ERROR_MSG":"Dieser Dateityp wird nicht unterstützt. \n Bitte wählen Sie eine jpeg-, gif- oder png-Datei.","FOLDER_PATH_AUTOSYNC_FILES_STRING":"Dateien","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"Eine Datei mit diesem Namen ist vorhanden.","FOLDER_PATH_DOES_NOT_EXIST":"Pfad ist nicht vorhanden.","FOLDER_PATH_ERROR":"Fehler","FOLDER_PATH_NOT_VERIFIED":"Der Ordnerpfad wurde nicht geprüft.","FOLDER_PATH_PATH":"Pfad","FOLDER_PATH_OPERATION_INVALID":"Ein ungültiger Vorgang","FOLDER_PATH_SUCCESS":"Erfolg","FOLDER_PATH_TYPE_AUTOSYNC":"AutoSync","FOLDER_PATH_TYPE_PREVIEW":"Vorschau","FOLDER_PATH_UNKNOWN_FAULT":"Ein unbekannter Fehler","french":"Französisch","FULL_NAME":"Voller Name","FULLY_QUALIFIED_DOMAIN_NAME":"Vollständig qualifizierter Domainname","german":"Deutsch","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"AutoSync-Ordner für neue Kataloge in diesem Ordner erstellen","GLOBAL_SETTINGS_BACKGROUND_COLOR":"Hintergrundfarbe","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"Hintergrundfarbe der Login-Maske.","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"Katalogstandardeinstellung","GLOBAL_SETTINGS_CHOOSE_FILE":"Datei auswählen","GLOBAL_SETTINGS_CUSTOM_IMAGE":"Eigenes Bild","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"Die ungefähre Größe sollte maximal 2400 x 1350 Pixel betragen.","GLOBAL_SETTINGS_CUSTOM_TITLE":"Eigener Titel","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"Der Titel, der auf Reitern oder in Lesezeichen im Browser angezeigt wird.","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"Angepasste Login-Maske","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"Standardrolle","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"Standard-Login-Maske","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"E-Mail Benachrichtigung","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"Der Speicherort der AutoSync- und Vorschauordner muss vom Server aus zugänglich sein.","GLOBAL_SETTINGS_IMAGE_URL":"Link","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"Der Klick auf das Bild öffnet diesen URL in einem neuen Browser-Fenster.","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"Um Änderungen vorzunehmen, starten Sie den Server oder suchen Sie nach einer abgelaufenen Serverlizenz.","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"Vorschaubilder für neue Kataloge in diesem Ordner speichern","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"Serverdatenorte","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"Portfolio LOGON-Kundenbezogenheit","GLOBAL_SETTINGS_SSO_CREDENTIALS":"Einmalige Anmeldedaten (SSO)","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"Geben Sie das Benutzerkonto ein, das mit dem Portfolio Serverdienst für die Kerberos-Authentifizierung verknüpft ist.","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"Temporärer Arbeitsordner:","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"Der Arbeitsordner wird beim nächsten Starten des Servers geändert. Der neue Ordner wird sich hier befinden: ","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"Für diese Änderung müssen Sie den Server erneut starten.","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Portfolio Vault-Konfiguration:","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Portfolio Vault-Ordner:","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Standardmäßiger Portfolio-Vault-Speicherort:","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"Um Portfolio Vault zu verschieben, müssen Sie zuerst den Server herunterfahren.","HELP_URL":"https://helpdocs.portfoliodam.com/de/portfolio/administration/{version}/index.htm","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/de/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"Hostname","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(Standard)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"Directory Service-Verbindung erfolgreich. Konfiguration gespeichert.","IMAGE_FILE_FILTER":"Bilder (jpg, gif, png)","IMPORT_LDAP":"Benutzer aus LDAP/AD-Server importieren","IMPORT_LDAP_SPECIFY_SERVER":"LDAP/AD-Server angeben","IMPORT_MENU_STRING":"Werte importieren","IMPORT_SOURCE":"Quelle importieren","INVALID_DN_SYNTAX_ERROR":"Die Verbindung mit dem Verzeichnisservice konnte aufgrund eines ungültigen DN-Syntaxfehlers nicht hergestellt werden. Prüfen Sie den Benutzernamen.","japanese":"Japanisch","LAST_CERTIFICATE_REQUEST_LABEL":"Letzte Zertifikatsanforderung","LAST_MODIFIED_BY":"Zuletzt geändert von","LAST_MODIFIED_DATE":"Datum der letzten Änderung","LDAP_ADDRESS":"LDAP/AD-Serveradresse","LDAP_BIND_USERNAME":"LDAP-Verbindung-Benutzername","LDAP_SYNC_NOTIFICATION":"Synch-Anforderung beim Server eingegangen.","LIC_ADD_MESSAGE":"Kopieren Sie die Lizenzen und fügen Sie sie ein, oder tragen Sie diese einzeln pro Zeile ein.","LIC_ADD_SN":"Neue Lizenz hinzufügen","LIC_ADD_SN_SHORT":"Fügen Sie Lizenzen hinzu","LIC_ASSET_CAP_DISPLAY":"Assets","LIC_DAYS_REMAINING":"({days} verbleibende Tage)","LIC_DEMO_PERIOD":"Demozeitraum","LIC_ERROR_MSG":"Ungültige Seriennummer, bitte wiederholen Sie die Eingabe. Wenn das Problem weiterhin bestehen sollte, überprüfen Sie Ihr Serverprotokoll oder wenden Sie sich an Ihren Administrator.","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"Die Seriennummer kann dem Portfolio Studio nicht hinzugefügt werden.","LITE_CANNOT_CREATE_FDB_CATALOG":"Ihre Portfolio-Lizenz lässt nur einen Katalog zu. Bitte nehmen Sie ein Upgrade Ihrer Portfolio-Lizenz vor, um diesen Vorgang auszuführen.","LITE_CANNOT_SERVE_FDB_CATALOG":"Das Online-Stellen weiterer Kataloge ist mit Ihrer Portfolio Server-Lizenz nicht gestattet.","LITE_THIS_FEATURE_NOT_SUPPORTED":"Die Portfolio Server-Lizenz unterstützt diesen Vorgang nicht.","LOGGING_CONFIGURATION":"Protokollkonfiguration","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Wenn Sie den Speicherort des Protokolls ändern möchten, fahren Sie zuerst den Portfolio Server herunter.","LOGGING_DEFAULT_LOCATION_MSG":"Stardard-Protokollspeicherort ist","LOGGING_DIR_MUST_EXIST":"HINWEIS: Um das Log-Verzeichnis ändern zu können, muss das neu angegebene Verzeichnis bereits existieren und der Benutzer, der Portfolio Server ausführt, muss darin schreiben können.","LOGGING_LOG_DIR":"Protokollverzeichnis:","LOGGING_LOG_LEVEL":"Protokollebene","LOGGING_NUM_LOGS_TO_RETAIN":"Anzahl der aufzubewahrenden Protokolle","LOGIN":"Login","MAPPING_HEADER":"Benutzer/Gruppenmappings zu Portfolio","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"Die Zuweisungen wurden geändert; sollen sie gespeichert werden?","MEDIA_ENGINES_ACTION_ADD":"Neue Media Engine hinzufügen","MEDIA_ENGINES_ACTION_DELETE":"Media Engine löschen","MEDIA_ENGINES_ACTION_EDIT":"Media Engine-Details anzeigen/bearbeiten","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"Eine weitere Active Media Engine kann nicht hinzugefügt werden, da der Server bereits die von Ihrer Portfolio Media Engine Lizenz zugelassene Höchstanzahl der Active Media Engines verwendet.","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"Sie können keine Media Engine hinzufügen, da dem Server keine Lizenz für Portfolio Media Engine zur Verfügung steht.","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"Die eingebaute Media Engine kann nicht entfernt werden.","MEDIA_ENGINES_COLUMN_ACTIVE":"Aktiv","MEDIA_ENGINES_COLUMN_ADDRESS":"Adresse","MEDIA_ENGINES_COLUMN_PORT":"Port","MEDIA_ENGINES_CONFIRM_DELETE":"Möchten Sie die ausgewählte Media Engine löschen?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Media Engine-Details","MEDIA_ENGINES_LICENSES_LABEL":"Media Engine-Plätze für Aktivierung verfügbar","MEDIA_ENGINES_NEW_DETAILS_HEADER":"Neue Media Engine-Details","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"Media Engines sind nicht aktiv. Sie sollten eine Media Engine aktivieren, bevor die Kunden die Portfolio Media-Dienste verwenden müssen.","MOBILE":"Mobil","MOBILE_ENABLED":"Mobile Uploads erlauben","MOBILE_FOLDER_VERBIAGE":"Mobile Uploads in diesem Ordner speichern.","MOBILE_CREATE_CATALOG_VERBIAGE":"Neuen Katalog 'Mobile Uploads' anlegen, um diesen Ordner automatisch zu überwachen (empfohlen) ","MOBILE_CATALOG_NAME":"Mobile Uploads","modifyAssetContents":"Überprüfen Sie heraus Anlagegüter","MODIFY_LDAP":"LDAP-Abfrage ändern","NAME":"Name","NAME_TOO_LONG_ERROR":"Der Name muss weniger als 256 Zeichen aufweisen","NAV_ABOUT":"Über","NAV_ACCESS_LEVELS":"Rollen","NAV_AUTOSYNC":"Autosync","NAV_BACKUPS":"Sichern/Wiederherstellen","NAV_CATALOGS":"Kataloge","NAV_GLOBAL_SETTINGS":"Globale Einstellungen","NAV_HELP":"Hilfe","NAV_LICENSES":"Lizenzen","NAV_LOGOUT":"Abmelden","NAV_MEDIA_ENGINES":"Media Engines","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"Ports","NAV_REPORTING":"Reports","NAV_SETTINGS":"Einstellungen","NAV_STATUS":"Status","NAV_USERS":"Benutzer","NO_CATALOGS":"Keine","NO_FILE_SELECTED":"Keine Datei ausgewählt","VaultFolderNotFound":"Der Portfolio Vault-Ordner wurde nicht unter {path} gefunden.","NO_VAULT_FOLDER":"Der Portfolio Vault-Ordner wurde nicht unter {path} gefunden. Bitte überprüfen Sie den Ort des Ordners in Ihrem Dateisystem und unter den Globale Einstellung -> Server Datenseite dieser Anwendung.","NOTES":"Hinweise","NUMBER_DECIMAL_POINT_COUNT_ERROR":"Das Dezimaltrennzeichen kann nur einmal vorhanden sein.","NUMBER_EXCEEDS_MAX_ERROR":"Die eingegebene Zahl ist zu groß.","NUMBER_INTEGER_ERROR":"Die Zahl muss eine Ganzzahl sein.","NUMBER_INVALID_CHAR_ERROR":"Die Eingabe enthält ungültige Zeichen.","NUMBER_INVALID_FORMAT_CHARS_ERROR":"Einer der Formatierungsparameter ist ungültig.","NUMBER_LOWER_THAN_MIN_ERROR":"Der eingegebene Betrag ist zu klein.","NUMBER_NEGATIVE_ERROR":"Der Betrag kann nicht negativ sein.","NUMBER_PRECISION_ERROR":"Der eingegebene Betrag enthält zu viele Stellen hinter dem Dezimalkomma.","NUMBER_SEPARATION_ERROR":"Dem Tausender-Trennzeichen müssen drei Stellen folgen.","OK":"OK","ON_DATE":"ein","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"Gruppen","ORGANIZATION_NAME":"Organisationsbezeichnung","ORGANIZATIONAL_UNIT":"Organisatorische Einheit","PASSWORD":"Kennwort","PASSWORD_CONFIRM":"Kennwort bestätigen","PASSWORD_TOO_LONG_ERROR":"Das Kennwort muss weniger als 256 Zeichen aufweisen","PORT":"Port","PORT_VALUE_TOO_HIGH_ERROR":"Der Port-Wert muss kleiner als 65536 sein.","PortfolioAssetCap":"Portfolio Asset Cap","PortfolioAPI":"Portfolio API","PortfolioDemo":"Demo","PortfolioDirServices":"Portfolio Directory Services","PortfolioServer":"Portfolio-Server","PortfolioStudio":"Portfolio Studio Edition","PortfolioProfessional":"Portfolio Professional Edition","PortfolioEnterprise":"Portfolio Enterprise Edition","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keywords","PortfolioUserConnection":"Portfolio-Benutzerverbindung","PortfolioSingleSignOn":"Single-Sign-On (SSO)","PORT_CURRENT_VALUE":"Aktueller Wert","PORT_ERROR_MSG_BAD_PORT_VALUE":"Der neue Port-Wert muss eine Zahl zwischen 1 und 65535 sein.","PORT_ERROR_MSG_CONFLICT":"Die Port-Werte können nicht aktualisiert werden, da einer dieser neuen Werte bereits vom Server verwendet wird.","PORT_FIND_PORT":"Port suchen","PORT_NAME":"Name","PORT_NEW_VALUE":"Neuer Wert","PORT_RESTART_NOTICE":"Hinweis: Port-Aktualisierungen treten erst nach dem erneuten Starten des Servers in Kraft.","PORT_RESTART_SERVER":"Server neu starten","PORT_UPDATE_PORTS":"Ports aktualisieren","PORT_WARNING_ADMIN_RESTART":"Der Admin-Port wurde geändert. Der Browser wird in {numSecs} Sekunden zur neuen Adresse weitergeleitet.","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"Sind Sie sicher?","PROMPT_COULD_NOT_CREATE_FOLDER":"Dieser Ordner konnte nicht erstellt werden. Geben Sie einen anderen Pfad ein.","PROMPT_COULD_NOT_CREATE_FOLDERS":"Geben Sie einen anderen Ordnerpfad ein, da die folgenden Pfade nicht erstellt werden konnten:","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"Dieser Ordner konnte nicht erstellt werden, da bereits eine Datei mit diesem Namen vorhanden ist. Geben Sie einen anderen Pfad ein.","PROMPT_CREATE_THAT_FOLDER":"Dieser Ordner ist nicht vorhanden. Möchten Sie ihn erstellen?","PROMPT_CREATE_THESE_FOLDERS":"Diese Ordner sind nicht vorhanden. Möchten Sie sie erstellen?","PROMPT_DELETE_LICENSE_CONFIRM":"Möchten Sie die ausgewählte Lizenz löschen?","QUERY":"Anfrage","REMOVE":"Entfernen","REMOVE_DIRECTORY_SERVICE":"Verzeichnisdienst entfernen","REPLACE_USER_MAPPING_CONFIRMATION":"Für diesen Benutzernamen ist bereits eine normale Benutzerzuordnung vorhanden. Soll diese durch eine Ausschlusszuordnung ersetzt werden?","REPLACE_USER_EXCLUSION_CONFIRMATION":"Für diesen Benutzernamen ist bereits eine Ausschlusszuordnung vorhanden. Soll diese durch eine normale Benutzerzuordnung ersetzt werden?","REQUIRED_FIELD_ERROR":"Dieses Feld ist erforderlich","REVERT":"Wiederherstellen","REVERT_CHANGES":"Änderungen Aufheben","ROLE_FOR_IMPORT":"Rolle für Import","ROLES_PERMISSION_ENABLED_HEADER":"Aktiviert","ROLES_PERMISSION_NAME_HEADER":"Vorgang","SAVE":"Speichern","SAVE_MAPPING":"Mapping Speichern","saveOutputSetting":"Üben Sie Voreinstellungen aus (Konvertierung und bilden PDF)","SEARCH":"Suchen","SEARCH_BASE":"Suchbasis","SEARCH_RESULTS":"Suchergebnisse","SECURITY_GROUPS":"Sicherheitsgruppen","SELECT":"Auswählen","SEND_DIAGNOSTIC_DATA":"Diagnosebericht an Portfolio DAM senden","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"Standard-Arbeitsort: ","SERVER_RESTART_REQUIRED":"Für das Wirksamwerden der Änderungen muss der Server neu gestartet werden.","SERVER_STATE_ERROR":"Fehler: Genaue Details finden Sie im Verwaltungsprotokoll","SERVER_STATE_STARTED":"Wird ausgeführt","SERVER_STATE_STARTING":"Starten","SERVER_STATE_STOPPED":"Gestoppt","SERVER_STATE_STOPPING":"Stoppen","SERVER_STATE_UNKNOWN":"Unbekannt","SERVICE_BROWSER":"Service-Browser","SK_ENGINE_APPAREL":"Kleid","SK_ENGINE_CELEBRITIES":"Berühmtheiten","SK_ENGINE_FOOD":"Lebensmittel","SK_ENGINE_GENERAL":"Allgemeines","SK_ENGINE_LOGO":"Logo","SK_ENGINE_MODERATION":"Moderation","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"Reise","SK_ENGINE_WEDDINGS":"Hochzeiten","SSL_HANDSHAKE_ERROR":"Fehler bei SSL-Handshake; stellen Sie sicher, dass die Anschluss- und SSL-Einstellungen korrekt sind.","STARTS_WITH":"beginnt mit","STATE_OR_PROVINCE":"Bundesland","STATUS":"Status","STATUS_ADMIN_LOG":"Verwaltungsprotokoll","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"Lizenziert","STATUS_API_STATE_UNLICENSED":"Nicht lizenziert","STATUS_CLEAR_ADMIN_LOG":"Verwaltungsprotokoll löschen","STATUS_CONNECTED_USERS":"Verbundene Benutzer","STATUS_MAX_ALLOWED_CONNECTIONS":"Maximale Verbindungen","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Media Engine","STATUS_MEDIA_ENGINES_ACTIVE":"Aktiv","STATUS_MEDIA_ENGINES_LABEL":"Media Engines","STATUS_RESTART_SERVER":"Portfolio neu starten","STATUS_SEAT_USAGE":"Platznutzung","STATUS_SERVER_STATE":"Portfolio-Zustand","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Portfolio starten","STATUS_STOP_SERVER":"Portfolio stoppen","STATUS_PROBLEMS_DETECTED":"Erkannte Probleme:","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"Die verbleibende Startfestplattenkapazität unterschreitet {minSpace} GB.","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"Der Arbeitsordner ist nicht vorhanden oder zugreifbar.","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"Der Portfolio-Server kann nicht in den Arbeitsordner schreiben.","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"Der Portfolio-Server kann nicht aus dem Arbeitsordner lesen.","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"Der Portfolio-Server kann keine Symlinks im Arbeitsordner erzeugen.","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"Die verbleibende Arbeitsordner-Festplattenkapazität unterschreitet {minSpace} GB.","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"Der Arbeitsordnerstatus kann nicht abgerufen werden.","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"Der Status für den Elasticsearch-Index {index} ist rot.","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"Der Elasticsearch-Index {index} hat nicht initialisierte Shards.","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"Nicht alle Shards sind für den Elasticsearch-Index {index} aktiv.","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"Der Elasticsearch-Status kann nicht abgerufen werden.","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"Fehler können nicht vom Portfolio-Server abgerufen werden.","STATUS_MSG_STARTUP_FAILED":"Start fehlgeschlagen","STATUS_MSG_CANT_GET_SERVER_HEALTH":"Serverzustand kann nicht aktualisiert werden.","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"Die native Agent-Server-Komponente wird nicht ausgeführt.","SUBJECT_ALTERNATIVE_NAMES":"Betreff Alternative Namen","SUBMIT":"Absenden","swedish":"Schwedisch","SYNC_DAILY":"Täglich synchronisieren","SYNCHRONIZE_NOW":"Jetzt synchronisieren","TARGET_CATALOG":"Zielkatalog","THIS_LOCALE":"de","TRUE_LABEL":"Wahr","TOKEN":"Token","TOTAL_ASSETS":"Gesamte Assets","TWO_LETTER_COUNTRY_CODE":"Ländercode mit zwei Buchstaben","TYPE":"Art","UNABLE_CONNECT_LDAP":"Verbindung mit LDAP/AD-Server nicht möglich.","UNABLE_CONNECT_SERVER":"Verbindung mit Server nicht möglich.","UNKNOWN_HOST_ERROR":"Die Verbindung mit dem Verzeichnisservice konnte aufgrund einer Host-Ausnahmebedingung nicht hergestellt werden. Prüfen Sie den Hostnamen.","UNKNOWN_LDAP_USER_ERROR":"Kein Benutzer wurde im Identitätsservice mit den Kontonamen '{accountName}' gefunden.","useCustomPresets":"Voreinstellungen des Konvertiervorgangs verwenden","USE_SSL":"SSL verwenden","USER_ACCOUNT":"Konto","USER_CREATE":"Neuen Benutzer hinzufügen","USER_DELETE":"Benutzer löschen","USER_DELETE_CONFIRM":"Ausgewählte Benutzer löschen?","USER_DELETE__DELETE_PRIVATE":"Dauerhaft gelöscht werden","USER_DELETE__GALLERY_PROMPT":"Über \"Öffentlich machen\" werden alle privaten und schreibgeschützten Galerien dieses Benutzers zu öffentlichen Galerien. \"Alle privaten Galerien löschen\" löscht private Galerien und macht schreibgeschützte Galerien zu öffentlichen Galerien.","USER_DELETE__GALLERY_PROMPT_1":"Die ausgechecktenArtikel der Nutzer werden zurückgegeben und zur Verfügung gestellt.","USER_DELETE__GALLERY_PROMPT_2":"Die Nur-Lesen Gallerien der Nutzer werden veröffentlicht.","USER_DELETE__GALLERY_PROMPT_3":"Die Privatgalerien der Nutzer sollten:","USER_DELETE__MAKE_PUBLIC":"Veröffentlicht werden","USER_DETAILS":"Benutzerdetails","USER_IMPORT":"Benutzer importieren","USER_IMPORT_ACCOUNT":"Benutzername","USER_IMPORT_ACCOUNT_ATTR":"Kontoattribut","USER_IMPORT_EMAIL_ATTR":"E-Mail-Attribut","USER_IMPORT_IMPORT":"Importieren","USER_IMPORT_IMPORT_SELECTED_USERS":"Ausgewählte Benutzer importieren","USER_IMPORT_MODIFY_SEARCH":"Suche ändern","USER_IMPORT_NAME_ATTR":"Kontonamensattribut","USER_IMPORT_NOTES_ATTR":"Notizenattribut","USER_IMPORT_PASSWORD":"Kontokennwort","USER_IMPORT_PASSWORD_ATTR":"Kennwortattribut","USER_IMPORT_SEARCH":"Suche","USER_IMPORT_SEARCH_BASE":"Suchbasis","USER_IMPORT_SEARCH_FILTER":"Suchfilter","USER_IMPORT_SERVER_ADDRESS":"Serveradresse","USER_IMPORT_SPECIFY_LDAP_SERVER":"LDAP Server angeben","USER_LEVEL_ADMINISTRATOR":"Katalogadministrator","USER_LEVEL_EDITOR":"Editor","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"Herausgeber","USER_LEVEL_READER":"Leser","USER_MANAGE_CATALOGS":"Kataloge für ausgewählte Benutzer verwalten","USER_MULT_USERS_SELECTED":"Mehrere Benutzer ausgewählt","USER_NAME":"Benutzername","USER_NEW_USER_DETAILS":"Neue Benutzerdetails","USER_NEW_USER_INFO_MSG":"Zum Hinzufügen eines Benutzers zu bestimmten Katalogen, Kataloge > Benutzer.","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"Benutzer zu allen Katalogen hinzufügen als:","USER_NO_USERS_SELECTED":"Keine Benutzer ausgewählt","USER_ONLINE":"Online","USER_PASSWORD_TOO_SHORT":"Das Passwort muss aus mindestens einem Zeichen bestehen.","USER_PASSWORDS_DO_NOT_MATCH":"Das Kennwortbestätigungsfeld muss mit dem Kennwortfeld übereinstimmen.","USER_ROLE":"Zugriffsmodus","USER_VIEW_DETAILS":"Benutzerdetails anzeigen/bearbeiten","USERS":"Benutzer","VALIDATION_FIELD_LENGTH_EXCEEDED":"Dieses Feld darf 255 Zeichen nicht überschreiten.","VALIDATION_MUST_BE_NONEMPTY":"Dieses Feld ist erforderlich.","VIEW_EDIT_MAPPINGS":"Zuweisungen anzeigen / bearbeiten","General.OK":"OK","General.Cancel":"Abbrechen","PORT_TITLE":"Ports","PORT_DEFAULT":"Standard:","esp.port.admin-web-app":"Portfolio Admin HTTP-Anschluss","esp.port.admin-web-app-ssl":"Portfolio Admin SSL-Anschluss","esp.port.http":"Portfolio Server HTTP-Anschluss","esp.port.ssl":"Portfolio Server SSL-Anschluss","General.Save":"Speichern","CATALOG_DETAILS_FILETYPES_TAB":"Speichertypen","addAsset":"Assets hinzufügen","canManageFieldLists":"Öffentliche Feldlisten verwalten","canModifyFolderStructure":"Ordnerstrukturen ändern","canMoveAssets":"Assets verschieben","deleteAssetContents":"Original-Assets löschen","deleteAssetFromCatalog":"Asset aus Katalog löschen","modifyAssetProperties":"Asset-Felder aktualisieren","synchronizeAutoSyncFolder":"Autosync-Ordner synchronisieren","ASSETS":"Assets","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"Katalog erstellen","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"Der Systemspeicher beträgt {value} GB; dieser Wert unterschreitet die Mindestanforderungen von {minGB} GB.","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"Der von Portfolio berechnete Systemspeicher von {value} GB ist möglicherweise ungenau.","AUTH.couldNotConnect":"Es konnte keine Verbindung zum Server hergestellt werden. Bitte prüfen Sie die Adresse.","ERROR.serverUnavailable":"Der Portfolio-Server ist nicht verfügbar.","ERROR.sessionExpired":"Ihre Sitzung ist abgelaufen.","fileNotFound":"Die Datei wurde auf dem Datenträger nicht gefunden.","ERROR.invalidSearchFailed":"Die Suche ist fehlgeschlagen, da es ein Problem mit der Anfrage gab.","AUTH.loginFailed":"Nutzername und Kennwort waren falsch.","FAULT_CODE.InsufficientPrivileges":"Zur Durchführung dieses Vorgangs reichen Ihre Berechtigungen nicht aus.","unexpectedError":"Ein unerwarteter Fehler ist aufgetreten.","ROLES_CREATE_ROLE_TITLE":"Rolle erstellen","ROLES_DELETE_CONFIRM":"Möchten Sie die ausgewählte Rolle löschen?\nBenutzer mit dieser Rolle werden zu Lesern zurückgestuft.","NOTIFICATION_SUCCESS_UPDATE":"Update erfolgreich","DATA_COLLECTION_TITLE":"Analyse","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"Ich stimme der Weitergabe der Anwendungsnutzungsdaten zu.","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"Helfen Sie uns, die besten Lösungen anzubieten, indem Sie die Nutzung der Anwendung mit uns teilen.\n\nWenn Sie akzeptieren, helfen Sie uns wichtige Informationen zu sammeln, die uns unterstützen, die Qualität weiter zu verbessern und Optimierungen vorzunehmen. Die Informationen werden helfen uns, Ihre Anforderungen an die Lösung zu verstehen.\n\nSie können Ihre Meinung jederzeit ändern und das Teilen von Informationen beenden.\n\nWeiterführende Informationen dazu, wie wir Ihre Daten nutzen und wie Sie sich künftig anderweitig entscheiden können, entnehmen bitte dem Artikel auf der Hilfe-Seite: ","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/de/articles/1260804371029","CREATE_USER":"Benutzer erstellen","CATALOG_FILES_TAB_TITLE":"Aufnehmen","FIELD_CATEGORY_ALL":"Alle aktiven Felder","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"Katalogisiert am","FIELD_DEF.catalogedBy":"Katalogisiert von","FIELD_DEF.colorMode":"Farbmodus","FIELD_DEF.isPanoramic":"Panoramisch","FIELD_DEF.created":"Erstellt am","FIELD_DEF.directoryPath":"Verzeichnispfad","FIELD_DEF.documentText":"Dokumententext","FIELD_DEF.filename":"Dateiname","FIELD_DEF.fileDescription":"Beschreibung","FIELD_DEF.fileSize":"Dateigröße","FIELD_DEF.geometry":"Geo - Karte","FIELD_DEF.height":"Höhe","FIELD_DEF.horizontalResolution":"Horizontal Resolution","FIELD_DEF.keywords":"Schlüsselwörter","FIELD_DEF.lastModified":"Modifiziert","FIELD_DEF.lastUpdated":"Geändert","FIELD_DEF.aliasMac":"Alias (Mac)","FIELD_DEF.creatorMac":"Erstellungsprogramm (Mac)","FIELD_DEF.fileTypeMac":"Dateityp (Mac)","FIELD_DEF.zoneMac":"Zone (Mac)","FIELD_DEF.multipageCount":"Anzahl von Seiten","FIELD_DEF.numBands":"Zahl der Bänder","FIELD_DEF.path":"Pfad","FIELD_DEF.ItemID":"Asset-ID","FIELD_DEF.shortFilenameWin":"Kurzer Dateiname (Win)","FIELD_DEF.thumbnailSize":"Thumbnailgröße","FIELD_DEF.updatedBy":"Geändert von","FIELD_DEF.verticalResolution":"Vertikale Auflösung","FIELD_DEF.volume":"Volume","FIELD_DEF.watermarkURL":"Wasserzeichen-URL","FIELD_DEF.watermarked":"Mit Wasserzeichen","FIELD_DEF.width":"Breite","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"Aktualisieren","ALL_CATALOGS":"Alle Kataloge","ALL_SITES":"Alle Sites","ASSET_DOWNLOADS":"Assets - Häufigste Downloads","ASSET_PREVIEWS":"Assets - Häufigste Voransicht","ASSET_UPLOADS":"Assets - Uploads","DOWNLOAD_REPORT":"Report downloaden","FILE_TYPES":"Speichertypen","FILE_TYPES_SECTION_TITLE":"Speichertypen","FILE_TYPES_ERROR_NAME_EXISTS":"Der '{name}‘-Name stimmt mit dem Namen des vorhandenen Dateityps überein.","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"Auf Standardwerte zurücksetzen","FILE_TYPES_PROMPT_DISCARD_CHANGES":"Ausstehende Änderungen verwerfen?","FILE_TYPES_ADD_FILE_TYPE":"Dateityp hinzufügen","FILE_TYPES_UPDATE_FILE_TYPE":"Dateityp aktualisieren","FILE_TYPES_EXTENSIONS":"Erweiterungen","FROM":"Von","SITE":"Site","KEYWORD_STATISTICS":"Keyword Statistik","NETPUBLISH_MOST_DOWNLOADED":"NetPublish - beliebteste Downloads","NETPUBLISH_USAGE":"NetPublish - Nutzung","REPORT_DESCRIPTION_ASSET_PREVIEWS":"Dieser Bericht enthält alle Asset-Voransichten und wie häufig jeder Posten angesehen wurde.","REPORT_DESCRIPTION_ASSET_UPLOADS":"Dieser Bericht enthält alle hochgeladenen Assets, die Benutzer, die diese hochgeladen haben, und den Zeitpunkt.","REPORT_DESCRIPTION_DOWNLOADED":"Dieser Bericht zeigt welche Posten heruntergeladen wurden und wie oft jeder heruntergeladen wurde.","REPORT_DESCRIPTION_KEYWORD":"In diesem Bericht werden alle Schlüsselwörter in einem Katalog identifiziert und wie viele Posten Ihnen zugeordnet sind.","REPORT_DESCRIPTION_USAGE":"Dieser Bericht zeigt, welche Nutzer welche Posten heruntergeladen haben und wann.","SEARCH_TERMS":"Suchtypen","TO":"Bis","VIEW_REPORT":"Bericht anzeigen","NP_SITES":"NetPublish-Seiten","REPORT_NAME_DELETED_BY":"Assets - Löschungen","REPORT_NAME_DOWNLOADED_BY":"Assets - Downloads","REPORT_DESCRIPTION_DELETED_BY":"Dieser Bericht enthält alle gelöschten Assets, die Benutzer, die diese gelöscht haben, und den Zeitpunkt.","REPORT_DESCRIPTION_DOWNLOADED_BY":"Dieser Bericht enthält alle heruntergeladenen Assets, die Benutzer, die diese heruntergeladen haben, und den Zeitpunkt.","CATALOG_SAVE_TEMPLATE_TITLE":"Katalogvorlage erstellen","BACKUP_FILES_LABEL":"Backup-Dateien","CONFIGURE_EMAIL_LINK":"E-Mail-Benachrichtigungen konfigurieren...","NP_SOURCE":"Quelle","NOTIFICATION_FAILURE_UPDATE":"Update nicht erfolgreich","FIELD_FORM_LABEL_PRECISION_MAX":"Max","REPORT_DESCRIPTION_FILE_TYPES":"Dieser Bericht enthält die häufigsten Speichertypen und deren Festplattenbelegung.","REPORT_DESCRIPTION_SEARCH_TERMS":"Dieser Bericht enthält die häufigsten Wörter und Sätze, nach denen Ihre Benutzer suchen.","DUPLICATE_FIELD_NAME_ERROR":"Doppelte Feldnamen","NO_CATALOGS_EXIST":"Es sind keine Kataloge vorhanden.\n\n-klicken Sie auf die Schaltfläche +, um einen Katalog zu erstellen.","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"Rollentausch","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"Mitgliedschaft aufheben","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"Den Nutzer aus dem Katalog entfernen? \nDie aus diesem Katalog ausgechecktenArtikel werden zurückgegeben und zur Verfügung gestellt.","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"Möchten Sie die Rolle des Benutzers im Katalog wirklich ändern? Dieses Vorgehen kann die Daten des Benutzers löschen, wenn die neue Rolle über eingeschränkte Zugriffsrechte oder Berechtigungen verfügt.","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"Abfragen. Das kann ein paar Minuten dauern...","FIELD_DELETE_CONFIRM_MSG":"Möchten Sie das ausgewählte Feld löschen?","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"Alle Dateitypen auf ihre Standardwerte zurücksetzen?","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"Filter","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"AD-Benutzer und -Gruppen","DIRECTORY_SERVICE_SAVE_MAPPINGS":"Speichern und synchronisieren","DIRECTORY_SERVICE_REMOVE_MAPPING":"Zuordnung entfernen","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Portfolio-Benutzerimporte","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"Keine Zuordnungen.\n\nUm eine Zuordnung zu erstellen, wählen Sie links einen Benutzer oder eine Gruppe aus und klicken Sie auf 'Zuordnung erstellen'.","NOTIFICATION_FAILURE_ADD":"Hinzufügen fehlgeschlagen","FIELD_ADD_EXTRACT_METADATA":"Extraktionszuordnung hinzufügen","FIELD_MULTIPLE_EMBED_WARNING":"Es wird mehr als ein Feld in","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"Smart Keyword, neu katalogisierte Assets","LIC_CLICK_TO_UPGRADE":"Hier klicken, um den Portfolio Server zu aktualisieren","LIC_MAINTENANCE_END_DATE":"Wartungs- / Abonnement-Enddatum","LIC_SEAT_DISPLAY":"Benutzer-Lizenzen","LIC_ACTIVATE":"Portfolio aktivieren (Anmeldedaten erforderlich)","LIC_CLICK_TO_ACTIVATE":"Hier klicken, um den Portfolio Server zu aktivieren","LIC_CLICK_TO_USE":"Hier klicken, um Portfolio für einen begrenzte Zeitraum zu verwenden","LIC_TRIAL":"Portfolio testen (Seriennummer erforderlich)","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/de/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/de/requests/new","LIC_ERROR_GET_ACCOUNT":"Beim Abrufen Ihres Portfolio DAM-Kontos ist ein Problem aufgetreten.","LIC_ERROR_GET_LICENSES":"Beim Abrufen Ihrer Lizenzen von Portfolio DAM ist ein Problem aufgetreten.","CHANGE":"Ändern","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"Um diesen Ordner zu ändern, fahren Sie zunächst den Portfolio-Server herunter.","MEDIA_ENGINES_COLUMN_TEST":"Prüfen","ROLES_PERMISSIONS":"Berechtigungen","NO_SITES_EXIST_1":"Es sind keine NetPublish-Sites vorhanden.","NO_SITES_EXIST_2":"Verwenden Sie die Veröffentlichen-Option in Portfolio, um Sites zu erstellen und zu veröffentlichen.","MEDIA_ENGINE_NOT_OPERATIONAL":"Kein Zugriff auf die Media-Engine.","MEDIA_ENGINE_OPERATIONAL":"Die Media-Engine ist betriebsbereit.","LIC_SET_EXTENSIS_ACCOUNT":"Portfolio DAM-Konto einrichten","LIC_ACCOUNT":"E-Mail-Adresse","LIC_PASSWORD":"Kennwort","CERTS_TITLE":"SSL-Zertifikat","LIC_SYSTEM_ID":"System-ID","LIC_SET_ACCOUNT_ERROR":"Beim Einrichten Ihres Portfolio DAM-Kontos ist ein Problem aufgetreten. Bitte überprüfen Sie die Zugangsdaten und versuchen Sie es erneut.","LIC_SET_SYSTEM_TITLE":"Wählen Sie Ihr Portfolio DAM-System","NP_DELETE_SITE_CONFIRMATION":"Möchten Sie die Seite dauerhaft löschen?","NP_SITE_DELETE_LABEL":"Seite löschen","NP_SITE_ENABLED_LABEL":"Seite aktiviert","CERT_CREATE_REQUEST":"Zertifikatanforderung erstellen","CERT_DOWNLOAD":"Herunterladen","CERT_EXPIRATION_DATE":"Gültigkeitsdatum","CERT_IMPORT":"Ein Zertifikat importieren","CERT_ISSUER":"Aussteller","CERT_OWNER":"Eigentümer","CERT_PENDING_REQUEST":"Ausstehende Zertifikatsanforderung","CERTIFICATE_STATUS_INVALID":"Ungültiges Zertifikat","CERTIFICATE_STATUS_SELF_SIGNED":"Ungültiges Zertifikat: Selbst-signiert","CERTIFICATE_STATUS_EXPIRED":"Zertifikat abgelaufen","CERTIFICATE_STATUS_IMPORTED":"Zertifikat importiert","CERT_DELETE_CONFIRMATION":"Sind Sie sicher, dass Sie die Zertifikatsanforderung löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.","DIAGNOSTICS_TITLE":"Diagnosen","DIAGNOSTICS_NO_PROBLEMS":"Keine Probleme gefunden","SK_ENGINE_ART_STYLE":"Kunststil","SK_ENGINE_ART_SUBJECT":"Kunstgegenstand","SK_ENGINE_ART_MOVEMENT":"Kunstbewegung","CERT_FILE":"Zertifikatdatei","CERT_FILE_INT_1":"Zwischenzertifikat 1","CERT_FILE_INT_2":"Zwischenzertifikat 2","CERT_FILE_PASSWORD":"Zertifikat-Passwort","CERT_FILE_PASSWORD_HELP":"Wenn Ihr Zertifikat ein Passwort hat, geben Sie es bitte hier ein","CERT_FILE_PROMPT":"Auswählen...","CERT_FILE_ROOT":"Grundzertifikat","CERT_IMPORT_SUCCEEDED":"Das Zertifikat wurde erfolgreich importiert. Starten Sie den Portfolio-Server und die Portfolio-Admin-Dienste neu, um das Zertifikat zu verwenden.","CERT_IMPORT_FAILED_READING_PKCS12":"Der Server konnte das PKCS12-Zertifikat nicht lesen. Prüfen Sie das Passwort.","CERT_IMPORT_FAILED_INTERMEDIATE1":"Das Zwischenzertifikat 1 konnte nicht importiert werden.","CERT_IMPORT_FAILED_INTERMEDIATE2":"Das Zwischenzertifikat 2 konnte nicht importiert werden.","CERT_IMPORT_FAILED_ROOT":"Das Wurzelzertifikat konnte nicht importiert werden.","DIRECTORY_SERVICE_CONFIG_TITLE":"Verzeichnisdienst-Konfiguration","DIRECTORY_SERVICES_TITLE":"Verzeichnisdienst","DIRECTORY_SERVICE_MAPIINGS":"Verzeichniselemente für Portfolio-Zuordnungen","DIRECTORY_SERVICE_MAPIINGS_TITLE":"Zuordnungen","PDL_noPredefinedValues":"Keine vordefinierten Werte","PDL_editPredefinedListPlaceholder":"Vordefinierte Liste bearbeiten","PDL_importPredefinedValues":"Vordefinierte Werte importieren","PDL_exportPredefinedValues":"Vordefinierte Werte exportieren","PDL_removeNestedValueConfirmation":"Markierte Werte löschen?\nSie enthalten verschachtelte Werte, die ebenfalls gelöscht werden.","PDL_wrongPdlImportFormat":"Die gewählte Datei enthält keine Textdaten. Wählen Sie bitte eine Textdatei.","LIC_SET_ACCOUNT":"Konto Einrichten","LIC_REMOVE_ACCOUNT":"Konto Entfernen","LIC_CONTACT_CUSTOMER_SUCCESS_1":"Wenn Sie Hilfe bei der Erneuerung Ihres Kontos benötigen, kontaktieren Sie uns bitte unter","LIC_CONTACT_CUSTOMER_SUCCESS_2":"Ihr Customer Success Manager wird Sie innerhalb eines Werktages kontaktieren."});/* eslint-enable */

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"About","ABOUT_API_TAB":"API","ABOUT_VERSION":"Version","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio Server","ABOUT_PORTFOLIO_VERSION":"Version 9.0","ABOUT_SERVER_TAB":"Server","accessOriginals":"Access and Process Originals","ACCOUNT_TYPE":"Authentication","ACCOUNT_TYPE_LDAP":"Directory Service","ACCOUNT_TYPE_MANUAL":"Native (Built-in)","ACTIVE_DIRECTORY":"Active Directory","ADD":"Add","ALL_CATALOGS_GROUP":"All Catalogs","API_CODE_REFERENCE":"API Code Reference (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"Developer Community","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"Portfolio Administration Help","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","API_SECTION_1":"The Portfolio API provides a common interface for developers to integrate Portfolio catalogs, asset metadata, and media processing into business systems, custom workflows, and web infrastructures.","API_SECTION_2_PART_1":"Use of the API requires licenses, as described in the","API_SECTION_2_EULA":"Portfolio EULA","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":". To view or edit license information, click 'Licenses' in the Portfolio Administration application.","API_SECTION_2_PART_3":"Learn more:","API_TOKEN_CREATE":"Add New API Token","APPLY":"Apply","APP_PAGE_TITLE":"Portfolio Admin","AT_TIME":"at","AUTHENTICATION_ERROR":"Directory service authentication failed. Please check your username and password.","BACKUP_BACKUP_BUTTON":"Backup","BACKUP_BACKUP_LABEL":"Backup","BACKUP_BACKUP_NOW_BUTTON":"Backup Now","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"To change the backup location, first shut down Portfolio server.","BACKUP_CONFIRMATION_VERBIAGE":"Backup now? Portfolio will be offline until backup is complete.","BACKUP_DIRECTORY_LABEL":"Store in Directory","BACKUP_DIRECTORY_ERROR_MSG":"The selected backup directory is not valid.","BACKUP_EXPLANATION_TEXT_1":"Backups capture and safely store the server database and settings.\nIt does not backup your original asset files!","BACKUP_EXPLANATION_TEXT_2":"The server will be inaccessible during backups.","BACKUP_FRIDAY_LABEL":"Friday","BACKUP_MONDAY_LABEL":"Monday","BACKUP_MOST_RECENT_LABEL":"Most Recent Backup","BACKUP_NEXT_SCHEDULED_LABEL":"Next Scheduled Backup","BACKUP_NOTIFICATIONS":"Send email notifications after backups and restores","BACKUP_NOTIFICATIONS_DISABLED_MSG":"Email notifications must be enabled in Global Settings > Email Notifications","BACKUP_PROGRESS_BACKING_UP":"Backing Up","BACKUP_PROGRESS_BACKING_UP_DATA":"Backing up data...","BACKUP_PROGRESS_BACKUP_CANCELLED":"Backup Cancelled","BACKUP_PROGRESS_BACKUP_FAILED":"Backup Failed","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"Backup Successful","BACKUP_PROGRESS_PREFLIGHT":"Checking for available space...","BACKUP_PROGRESS_RESTARTING":"Restarting server...","BACKUP_PROGRESS_RESTORE_FAILED":"Restore Failed","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"Restore Successful","BACKUP_PROGRESS_RESTORING":"Restoring","BACKUP_PROGRESS_RESTORING_DATA":"Restoring data...","BACKUP_PROGRESS_SHUTTING_DOWN":"Shutting down server...","BACKUP_PROGRESS_SUMMARY":"Step {stepNum} of {totalSteps}","BACKUP_RESTORE_BUTTON":"Restore From Backup","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"Restore backup now? Portfolio will be offline until restore is complete. This will overwrite your current database and settings.","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"The backup archive is corrupt.\nChoose another backup to restore from.","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"The backup disk has insufficient space\nto complete.\n\n{requiredSpace} required, {availableSpace} available.","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"The currently configured backup location does not exist. The backup location is used to unzip the archive when a backup is being restored. Please reset the backup location to a valid directory.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"There was a problem with the backup.\nSee admin logs for details.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"There was a problem with the restore.\nSee admin logs for details.","BACKUP_RESTORE_LABEL":"Restore","BACKUP_RESTORE_TITLE":"Backup/Restore","BACKUP_RETAIN_LABEL":"Retain","BACKUP_RETAIN_VALUE":"Keep only the {numBackups} most recent backups","BACKUP_SATURDAY_LABEL":"Saturday","BACKUP_SCHEDULE_LABEL":"Schedule Backups","BACKUP_SCHEDULE_VALUE":"on","BACKUP_SUNDAY_LABEL":"Sunday","BACKUP_THURSDAY_LABEL":"Thursday","BACKUP_TUESDAY_LABEL":"Tuesday","BACKUP_WEDNESDAY_LABEL":"Wednesday","BROWSE":"Browse","BROWSE_FOLDERS_TITLE":"Browse Server Folders","BROWSE_RECENT_FOLDERS_LABEL":"Recent Folders","BROWSE_REFRESH":"Synchronize items","CALL_ATT_BUTTON_BUY_NOW":"Buy Now","CALL_ATT_BUTTON_SECONDARY":"Contact Sales for a Quote","CALL_ATT_FADEL_BUTTON_MAIN":"Contact Sales for More Information","CALL_ATT_FADEL_MAIN":"Ensure proper usage of your licensed content, from images to videos and everything in between. Portfolio seamlessly connects with FADEL Rights Cloud software so you can see and easily understand the usage rights associated with your assets—helping you to remove workflow bottlenecks and reduce the risk of expensive copyright violations.","CALL_ATT_FADEL_SUBTITLE":"Know your asset usage rights","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"High-Performance Processing and Conversion","CALL_ATT_ME_MAIN":"Are you pushing the performance limits of your Portfolio server? With Media Engine, avoid slowdowns and improve overall productivity by eliminating the bottlenecks caused by busy production environments.\n\n\t• Increases capacity and throughput\n\t• Unlocks additional output formats\n\t• Accelerates video preview creation\n\t• Add multiple Media Engines as needed\n\t• Watermarking (requires NetPublish)","CALL_ATT_ME_BUTTON_MAIN":"Get Media Engine","CALL_ATT_NP_SUBTITLE":"Self-Service Portals to Access Assets Instantly","CALL_ATT_NP_MAIN":"Tired of those last minute requests every time someone needs an asset? With NetPublish, it's easy to post self-serve websites that allow anyone to locate and download the assets they need from any browser on any device.\n\n\t• One-click site creation - no HTML or CSS required\n\t• Mobile-friendly, responsive design\n\t• Flexible user access control\n\t• Deactivate sites automatically\n\t• Set resolution, size and format on download\n\t• Watermarking (requires Media Engine)\n\t• Usage reporting","CALL_ATT_NP_BUTTON_MAIN":"Get NetPublish","CALL_ATT_REPORT_TITLE":"Reporting for NetPublish","CALL_ATT_REPORT_SUBTITLE":"Relevant Usage Insight","CALL_ATT_REPORT_MAIN":"Want to know which sites are most active, what assets are getting used and by whom? With NetPublish reporting, get the insight you need to make informed decisions based on how Portfolio is being used at your organization.\n\nUsage breakdown by:\n\t• NetPublish site name\n\t• Username\n\t• Asset name and ID\n\t• Date and time","CALL_ATT_REPORT_BUTTON_MAIN":"Get NetPublish","CALL_ATT_SK_BUTTON_MAIN":"Try it for Free","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/wqqb","CALL_ATT_SK_MAIN":"Looking for a way to accelerate your process for assigning keywords to images? With Portfolio Smart Keywords, you can automatically assign “smart” keywords to your images with just one click. Powered by Clarifai, an innovative artificial intelligence company that excels in visual recognition technology, a list of suggested keywords is delivered in seconds.\n\n\t• Delivers a list of smart keywords in seconds\n\t• Saves time and resources by reducing manual keywording\n\t• Establishes a consistent taxonomy for your organization\n\t• Makes it easy to find your digital assets quickly","CALL_ATT_SK_SUBTITLE":"Automate Your Image Keywording","CALL_ATT_SK_TITLE":"Portfolio Smart Keywords","CALL_ATT_SSO_SUBTITLE":"Seamless User Experience Across Platforms","CALL_ATT_SSO_TITLE":"Single Sign-On","CALL_ATT_SSO_MAIN":"Are people in your organization having a hard time keeping their login credentials straight? Typically, with new solutions come extra overhead in managing user accounts, both for you and for the users.\n\nFortunately, Portfolio supports Single Sign-On with Active Directory. Using Single Sign-On, users can login to Portfolio automatically from your intranet site giving them a continuous user experience.\n\n\t• Supports Windows Server Active Directory\n\t• Improves overall security\n\t• Simplifies user management\n\t• Improves user experience","CALL_ATT_SSO_BUTTON_MAIN":"Get Single Sign-On","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/portfolio/contact-me","canEmbedMetadata":"Embed Metadata","canImportMetadata":"Import/Export Metadata","canManagePublicGallery":"Manage Public Galleries","canPublishNetPublishSites":"Publish NetPublish Sites","canSmartKeyword":"Can Smart Keyword","CANCEL":"Cancel","CATALOG":"Catalog","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"Grant Membership","CATALOG_BACKUP":"Backup Selected Catalog","CATALOG_CREATE":"Add New Catalog","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"Catalog Administrators can add AutoSync folders from the Desktop Client.","CATALOG_CREATE_AUTOSYNC_FOLDER":"Create an AutoSync folder","CATALOG_CREATE_CATALOG_TEMPLATE":"Save Catalog Template","CATALOG_TYPE_GENERAL":"General Use","CATALOG_TYPE_SIMPLE":"Simple","CATALOG_CREATE_DATABASES_LIST_LABEL":"Databases","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"An error was encountered when creating the {folder} folder.","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"Default folders for AutoSync and Previews can be configured in Global Settings.","CATALOG_CREATE_NAME":"Name","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"Previews can be configured in Catalog Details.","CATALOG_CREATE_PREVIEW_FOLDER":"Save Previews for faster previewing","CATALOG_CREATE_SHOW_DATABASES":"Show Databases","CATALOG_CREATE_USE_VERSIONING":"Use Asset Versioning","CATALOG_DELETE":"Delete Catalog","CATALOG_DELETE_CONFIRM":"Do you want to delete the selected catalog?","CATALOG_DETAILS":"Catalog Details","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"To rename this catalog we must temporarily take it offline, do you want to continue?","CATALOG_DETAILS_COLLATION":"Collation","CATALOG_DETAILS_COLLATION_NA":"N/A","CATALOG_DETAILS_CREATION_DATE":"Creation Date","CATALOG_DETAILS_DATABASE_TAB":"General","CATALOG_DETAILS_LAST_MODIFIED":"Last Modified","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"Connected Users","CATALOG_DETAILS_NUMBER_OF_RECORDS":"Records","CATALOG_DETAILS_NUMBER_OF_USERS":"Members","CATALOG_DETAILS_SIZE_ON_DISK":"Size on disk","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"The administrator user will be disconnected. Proceed?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"Locked for administration","CATALOG_DETAILS_UNLOCK":"Unlock","CATALOG_EXPLANATION_VAULT_1":"Vault catalogs store assets in a secure repository.","CATALOG_EXPLANATION_VAULT_2":"Vault catalogs support locking, versioning, check-out and check-in.","CATALOG_EXPLANATION_WF_1":"Watch Folder catalogs track assets in place in your file system.","CATALOG_EXPLANATION_WF_2":"Watch Folder catalogs support AutoSync.","CATALOG_INGEST_DRAG_HINT_TEXT":"To add fields to the Upload Form, drag them over from the Fields list.","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"Fields for Upload Form","CATALOG_INGEST_FIELDS_LABEL":"Fields","CATALOG_INGEST_FORM_HEADER_LABEL":"Form Header","CATALOG_INGEST_HEADER_HINT_TEXT":"The form header is optional and appears at the top of the form.","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"The maximum number of fields to add to a form is {maxFields}.","CATALOG_INGEST_TAB_TITLE":"Managed Upload","CATALOG_INGEST_USE_INGEST_LABEL":"Use Managed Upload","CATALOG_INGEST_REQUIRED_LABEL":"Required","CATALOG_IS_CONNECTED":"Connected","CATALOG_IS_DEFAULT":"Default","CATALOG_MANAGE_USERS":"Manage Catalog Membership","CATALOG_MANAGE_FIELDS":"Manage Catalog Fields","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"Manage Catalog Templates...","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"Manage Custom Catalog Templates","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"Catalog Template Name","CATALOG_MEMBER":"Member","CATALOG_NEW_CATALOG_DETAILS":"New Catalog Details","CATALOG_OFFLINE":"Offline","CATALOG_ONLINE":"Online","CATALOG_OPTIONS_ALL_FILE_TYPES":"Catalog All File Types","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"Create Keywords from Path","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"Filename","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"Parent Folder","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"Server Name","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"Folder Tree","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"Volume","CATALOG_OPTIONS_EXCLUSION_LABEL":"File and Folder Exclusions","CATALOG_OPTIONS_ONLY_FILE_TYPES":"Catalog Only","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"Remove the selected file type(s)?","endsWith":"Ends with","contains":"Contains","startsWith":"Starts with","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"Remove the selected exclusion(s)?","CATALOG_OPTIONS_TAB_TITLE":"Cataloging Options","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"The default location is","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"Minimum size 300 pixels, maximum size 4000 pixel (longest dimension)","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"Generate clips for audio/video files","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"Create Previews","CATALOG_PREVIEWS_FOLDER_LOCATION":"Save previews and clips in this folder","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"This location must be accessible to the server.","CATALOG_PREVIEWS_MAX_PIXELS":"Maximum image size","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"Maximum video resolution","CATALOG_PREVIEWS_MINUTES":"minutes","CATALOG_PREVIEWS_PIXELS":"pixels","CATALOG_PREVIEWS_SHORT":"Previews","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"Limit duration to","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"Generating clips can take a while to process.\nTo shorten the processing time, choose a lower resolution and duration.","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"Revoke Membership","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"Remove the user from the catalog?\nThe user's Checked Out items in this catalog will be reverted and made accessible.","CATALOG_SAVE_TEMPLATE":"Save Catalog Template...","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"Catalog templates include all fields, metadata mappings, and cataloging options.","CATALOG_SELECT_MESSAGE":"No Catalog Selected","CATALOG_SET_AS_DEFAULT":"Set Default Catalog","CATALOG_SK_DEFAULT_SETTINGS":"Default Settings","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"Confidence Level","CATALOG_SK_DEFAULT_LABEL":"Recommended: {recommended}","CATALOG_SK_ENGINES_LABEL":"Smart Keyword Engines","CATALOG_SK_LANGUAGES_LABEL":"Languages for General Engine","CATALOG_SK_NUM_KEYWORDS_LABEL":"Number of Keywords","CATALOG_SK_SETTINGS_LABEL":"Settings","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"Use Smart Keywords in this Catalog","CATALOG_STATUS":"Catalog Status","CATALOG_STORAGE_TYPE_LABEL":"Storage Type","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"Watch Folders","CATALOG_STORAGE_TYPE_VAULT":"Vault","CATALOG_TAKE_OFFLINE_SHORT":"Take Offline","CATALOG_TAKE_ONLINE_SHORT":"Take Online","CATALOG_TEMPLATE":"template","CATALOG_TEMPLATE_NAME":"Template Name","CATALOG_TEMPLATES_TITLE":"Catalog Templates","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"Remove the selected catalog template?","CATALOG_VIEW_DETAILS":"View/Edit Catalog Details","CERT_REQUEST_ALREADY_CREATED_WARNING":"You have already created a certificate request. If you continue, the existing request will be deleted.","CERTIFICATE_FILE_FILTER":"Certificates (p7b, cer, crt, der, pfx, p12)","CITY_OR_LOCALITY":"City or Locality","CLEAR_BUTTON_LABEL":"Clear","COMMUNICATION_AT_INITILIZATION_ERROR":"There was an error communicating with the server. This is usually caused by stale data in the browser cache but it could also indicate a problem with the server. Contact your administrator for more information.","CONFIGURE_DIRECTORY_SERVICE":"Configure Directory Service","CONFIRM_DELETE_PDL":"Delete all predefined values for this field?","CONFIRM_DELETE_SERVICE":"Remove Directory Service?\nUsers imported from the service will remain. Their passwords will revert to values set previously in Portfolio, or will be disabled if not set previously.","CONFIRM_TRUNCATE_VALUES":"Max Length exceeds one or more default or predefined values for this field. Truncate values?","CONNECTION_REFUSED_ERROR":"The connection to the directory service was refused. Please check your hostname and port settings.","CONTAINS":"contains","CONTINUE":"Continue","CREATE":"Create","CREATE_A_CERTIFICATE_REQUEST":"Create a certificate signing request","createContactSheet":"Make PDF","CREATED_BY":"Created By","CREATE_MAPPING":"Create Mapping","CREATE_USER_EXCLUSION_MAPPING":"Exclude User","CREATED_ON_DATE":"Date Created","DATE_FORMAT":"MM/DD/YYYY","DATE_FORMAT_ERROR":"Configuration error: Incorrect formatting string.","DATE_INVALID_CHAR_ERROR":"The date contains invalid characters.","DATE_TIME_FORMAT":"MM/DD/YYYY L:NN A","DATE_TIME_SECONDS_FORMAT":"MM/DD/YYYY L:NN:SS A","DATE_WRONG_DAY_ERROR":"Enter a valid day for the month.","DATE_WRONG_LENGTH_ERROR":"Type the date in the format:","DATE_WRONG_MONTH_ERROR":"Enter a month between 1 and 12.","DATE_WRONG_YEAR_ERROR":"Enter a year between 0 and 9999.","DEFAULT_ACCESS_LEVEL":"Default Role","DEFAULT_CATALOG":"Default Catalog","DEFAULT_CATALOG_NONE":"None","DEFAULT_PORT_NON_SSL":"Default port for non-SSL:","DEFAULT_PORT_SSL":"Default port for SSL:","DELETE":"Delete","DELETE_SOURCE":"Delete Source","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"Delete all values?\nThis will delete all values including nested values.","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"Delete the value '{value}'?\nIt contains nested values which will also be deleted.","DELETE_NESTED_VALUE_CONFIRMATION":"Delete the selected values?\nThey contain nested values which will also be deleted.","DELETE_WARNING_BOX_MSG":"Warning! Deleting cannot be undone!","DELETE_WARNING_CATALOG_VAULT":"All files in the catalog will be destroyed.","DIAGNOSTIC_DATA_TITLE":"Send Diagnostic Report to Portfolio DAM","DIAGNOSTIC_DATA_ACCOUNT_NAME":"Company or Account Name (Required)","DIAGNOSTIC_DATA_CONTACT_NAME":"Contact Name","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"Tech Support Ticket Number","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"Send Report","DIAGNOSTIC_STATUS_ERROR":"There was a problem uploading the diagnostic report on {date}","DIAGNOSTIC_STATUS_SENDING":"Sending...","DIAGNOSTIC_STATUS_SUCCESS":"Diagnostic report successfully sent to Portfolio DAM on {date}","DIRECTORY_SERVICE_CONNECT_ERROR":"Unable to connect to the directory service. Please check the hostname and port settings.","DIRECTORY_SERVICES":"Directory Services","DIRECTORY_USERS_CANNOT_BE_DELETED":"Directory Service users cannot be deleted!","DISTRIBUTION_GROUPS":"Distribution Groups","DOWNLOAD_CERT_PROMPT":"Download certificate request file?","DOWNLOAD_COMPLETE_STRING":"Download complete.","downloadPreviews":"Download Previews","EMAIL_ADDRESS":"Email Address","EMAIL_CONFIG_AUTH_PASSWORD":"Password","EMAIL_CONFIG_AUTH_USERNAME":"User Name","EMAIL_CONFIG_ENABLED":"Enable Email Notifications","EMAIL_CONFIG_FROM_ADDRESS":"Email From Address","EMAIL_CONFIG_INVALID_GENERIC":"Email Server Configuration Invalid","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"Email Server Not Found","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"Email Server Authentication Failed","EMAIL_CONFIG_MESSAGE":"Each user who wishes to receive notifications must have an email address assigned in the Users pane.","EMAIL_CONFIG_SERVER_ADDRESS":"SMTP Server Address","EMAIL_CONFIG_SERVER_PORT":"SMTP Server Port","EMAIL_CONFIG_SUCCESS_MESSAGE":"SMTP Server Validated","EMAIL_CONFIG_USE_SSL_TLS":"Use SSL / TLS","EMAIL_CONFIG_USE_SMTP_AUTH":"Use SMTP Authentication","EMAIL_CONFIG_VALIDATE":"Test Connection","EMAIL_CONFIG_VALIDATED":"Email Server Validated","english":"English","ENTIRE_TREE_UNDER_SEARCH_BASE":"Entire tree","EQUALS":"equals","EXPORT_MENU_STRING":"Export Values","FADEL_HOWTO":"Login to your FADEL account:","FALSE_LABEL":"False","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"Please check that the admin server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload this application.","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"This operation cannot be performed while a backup or restore is in progress.","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"That operation failed because the catalog is in admin mode.","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"A catalog already exists with this name.","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"A user already exists with this account name.","FAULT_MSG_DB_IN_USE":"The operation could not be completed because the catalog is currently in use by an administrator.","FAULT_MSG_DELETE_ADMIN":"You cannot delete the administrator account.","FAULT_MSG_DELETE_SELF":"You cannot delete your user account.","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"An unexpected error occurred when deleting the catalog template.","FAULT_MSG_DUPE_NAME":"An object with that name already exists.  Please use another name.","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"There is already a Media Engine with that address and port.","FAULT_MSG_ENTITY_VERSION_MISMATCH":"That operation failed because the client's information was out of date.","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"Please check that the server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload the application.","FAULT_MSG_INVALID_SESSION_ID":"Your session has expired. You must log into the server again.","FAULT_MSG_IS_NOT_LICENSED":"Server not licensed for that operation.","FAULT_MSG_LEGACY_21000":"The operation failed because of an unknown internal error.","FAULT_MSG_LOGGING_ERR_UPDATE":"There has been an error updating the logging configuration","FAULT_MSG_LOG_DIR_NOT_VALID":"The specified log directory does not exist, is not writeable or the path specified is not a directory.","FAULT_MSG_NO_DIRECTORY":"The specified location does not exist or it is not a directory.","FAULT_MSG_NULL_DESCRIPTION":"An unexpected error occurred, but there is no description to report.","FAULT_MSG_NULL_FAULTEVENT":"An unexpected error occurred, but there are no details to report.","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"That operation failed because you do not have sufficient privileges.","FAULT_MSG_OPERATION_IS_INVALID":"That operation was not valid.","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"An unexpected error occurred when renaming the catalog template.","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"An unexpected error occurred when saving the catalog template.","FAULT_MSG_SERVER_NOT_RUNNING":"The server is not running.","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"The operation failed because the server does not have an Enterprise Module license.","FAULT_MSG_REMOVE_METADATA_DEF":"Removing the metadata definition failed.  It may be in use by other catalogs.","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"The server returned a fault with this message:","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"The server returned a fault with no error message.","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"The server returned a fault with an unknown type and this message:","FAULT_MSG_UNKNOWN_SMTP_SERVER":"Unable to connect to the specified mail server.","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"That operation failed because a service was not in the expected state.","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"The username or password supplied for the database is not valid.","FAULT_MSG_BAD_DB_PORT":"The database port specified is not valid.","FAULT_MSG_BAD_DB_HOST":"The database hostname or port specified is invalid.","FIELD_ACTION_ADD":"Add New Custom Field","FIELD_ACTION_DELETE":"Delete Selected Field","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"XMP Namespaces","FIELD_ACTION_MANAGE_METADATA":"Manage Metadata","FIELD_CATEGORY_CUSTOM":"Custom Fields","FIELD_CATEGORY_SYSTEM":"System Fields","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"Movie","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"Field Category","FIELD_DISABLE_CONFIRM_MSG":"Do you want to disable the selected field?","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"Enable All","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"Add Extract Mapping","FIELD_FORM_LABEL_DEFAULT_VALUE":"Default Value","FIELD_FORM_LABEL_DISABLED":"(Disabled)","FIELD_FORM_LABEL_EMBED":"Embed in Metadata","FIELD_FORM_LABEL_EXTRACT":"Extract from Metadata","FIELD_FORM_LABEL_FIELD_NAME":"Field Name","FIELD_FORM_LABEL_FIELD_TYPE":"Field Type","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"Allow Multiple Values","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"Has Predefined Values","FIELD_FORM_LABEL_HELP_TEXT":"Help Text","FIELD_FORM_LABEL_MAX":"Max: {max}","FIELD_FORM_LABEL_MAX_LENGTH":"Max Length","FIELD_FORM_LABEL_METADATA_TAG":"Metadata Name","FIELD_FORM_LABEL_METADATA_TYPE":"Metadata Type","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"Allow Only Predefined Values","FIELD_FORM_LABEL_PRECISION":"Precision","FIELD_FORM_LABEL_PREDEFINED_VALUES":"Predefined Values","FIELD_FORM_LABEL_SHOW_TIME":"Show Time","FIELD_FORM_LABEL_USE_METADATA":"Extract and Embed Metadata","FIELD_FORM_WARNING_DUPE_EMBEDS":"Warning: More than one field embeds to '{metadata}'","FIELD_METADATA_DATA_TYPE_LABEL":"Data Type","FIELD_METADATA_DEFINITION_IS_CUSTOM":"Is Custom","FIELD_METADATA_DEFINITIONS_TITLE":"Metadata Definitions","FIELD_METADATA_DELETE_CONFIRM_MSG":"Confirm: Delete the Metadata Definition?","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"Multivalued Type","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"Not Multivalued","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"Ordered","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"Unordered","FIELD_METADATA_NAME_LABEL":"Name","FIELD_METADATA_NAMESPACE_LABEL":"Namespace","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"Add a Custom XMP Namespace...","FIELD_METADATA_TAG_LABEL":"Tag","FIELD_METADATA_TYPE_LABEL":"Type","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"Multiple Fields Selected","FIELD_NAMESPACE_ABBREVIATION":"Abbreviation","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"Delete the Custom XMP Namespace?\nThere may be Field Definitions using the namespace.","FIELD_NAMESPACE_URI":"Namespace URI","FIELD_NEW_FIELD_NAME":"New Field","FIELD_NEW_METADATA_TITLE":"New Metadata Definition","FIELD_NEW_NAMESPACE_TITLE":"New Custom XMP Namespace","FIELD_NO_FIELD_SELECTED_MESSAGE":"No Field Selected","FIELD_PAGE_TITLE":"Manage Fields for Catalog '{catalogName}'","FIELD_REVERT_CONFIRM_MSG":"Confirm: Revert the field?","FIELD_TYPE_BLOB":"Blob","FIELD_TYPE_BOOLEAN":"Boolean","FIELD_TYPE_DATETIME":"Date/Time","FIELD_TYPE_DECIMAL":"Decimal","FIELD_TYPE_LANG_ALT":"Lang Alt","FIELD_TYPE_NUMBER":"Number","FIELD_TYPE_PICTURE":"Picture","FIELD_TYPE_STRING":"String","FIELD_TYPE_STRUCTURE":"Structure","FIELD_TYPE_TEXTBLOCK":"Text Block","FIELD_TYPE_UNKNOWN":"Unknown","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"There was an error uploading the file to the server.","FILE_WRONG_TYPE_ERROR_MSG":"This file is not a supported file type.\nPlease select a jpeg, gif or png file.","FOLDER_PATH_AUTOSYNC_FILES_STRING":"Files","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"A file exists with this name.","FOLDER_PATH_DOES_NOT_EXIST":"Path does not exist.","FOLDER_PATH_ERROR":"Error","FOLDER_PATH_NOT_VERIFIED":"The folder path has not been verified.","FOLDER_PATH_PATH":"Path","FOLDER_PATH_OPERATION_INVALID":"An invalid operation","FOLDER_PATH_SUCCESS":"Success","FOLDER_PATH_TYPE_AUTOSYNC":"autosync","FOLDER_PATH_TYPE_PREVIEW":"preview","FOLDER_PATH_UNKNOWN_FAULT":"An unknown fault","french":"French","FULL_NAME":"Full Name","FULLY_QUALIFIED_DOMAIN_NAME":"Fully Qualified Domain Name","german":"German","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"Create AutoSync folders for new catalogs in this folder","GLOBAL_SETTINGS_BACKGROUND_COLOR":"Background Color","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"Background color of the login screen.","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"Catalog Defaults","GLOBAL_SETTINGS_CHOOSE_FILE":"Choose File","GLOBAL_SETTINGS_CUSTOM_IMAGE":"Custom Image","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"Approximate size should fit within 2400 x 1350 pixels.","GLOBAL_SETTINGS_CUSTOM_TITLE":"Custom Title","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"The title that appears on the browser tab or bookmark.","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"Customized Login Screen","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"Default Role","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"Default Login Screen","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"Email Notifications","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"The location of AutoSync and Preview folders must be accessible to the server.","GLOBAL_SETTINGS_IMAGE_URL":"Link","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"Clicking the image will launch this URL in another browser window.","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"To make changes, start the server or check for an expired server license.","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"Save Previews for new catalogs in this folder","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"Server Data Locations","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"Portfolio Login Customization","GLOBAL_SETTINGS_SSO_CREDENTIALS":"Single Sign-on Credentials","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"Enter the user account that is associated with the Portfolio Server service for Kerberos authentication.","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"Temporary Work folder","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"The work folder will be changed the next time the server is restarted. The new folder will be located at:","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"You must restart the server for this change to take effect.","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Portfolio Vault Configuration","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Portfolio Vault folder","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Default:","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"To move Portfolio Vault folder, first shut down Portfolio server.","HELP_URL":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"Hostname","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(default)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"Directory Service connection succeeded. Configuration saved.","IMAGE_FILE_FILTER":"Images (jpg, gif, png)","IMPORT_LDAP":"Import users from LDAP/AD server","IMPORT_LDAP_SPECIFY_SERVER":"Specify LDAP/AD Server","IMPORT_MENU_STRING":"Import Values","IMPORT_SOURCE":"Import Source","INVALID_DN_SYNTAX_ERROR":"Unable to connect to the directory service due to invalid DN syntax error. Please check the username.","japanese":"Japanese","LAST_CERTIFICATE_REQUEST_LABEL":"Last Certificate Request","LAST_MODIFIED_BY":"Last Modified By","LAST_MODIFIED_DATE":"Date Last Modified","LDAP_ADDRESS":"LDAP/AD Server address","LDAP_BIND_USERNAME":"LDAP Bind Username","LDAP_SYNC_NOTIFICATION":"The server has received the sync request.","LIC_ADD_MESSAGE":"Copy and Paste Licenses or enter individually one per row.","LIC_ADD_SN":"Add New License","LIC_ADD_SN_SHORT":"Add Licenses","LIC_ASSET_CAP_DISPLAY":"Assets","LIC_DAYS_REMAINING":"({days} Days Remaining)","LIC_DEMO_PERIOD":"Demo Period","LIC_ERROR_MSG":"Invalid serial number, please re-try. If the problem persists check your server log or contact your administrator.","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"The serial number cannot be added to Portfolio Studio.","LITE_CANNOT_CREATE_FDB_CATALOG":"Your Portfolio license does not allow more than one catalog. Please consider upgrading your Portfolio license to perform this action.","LITE_CANNOT_SERVE_FDB_CATALOG":"Your Portfolio Server license does not allow further catalogs to be taken online.","LITE_THIS_FEATURE_NOT_SUPPORTED":"Your Portfolio Server license does not support this action.","LOGGING_CONFIGURATION":"Logging Configuration","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"To move Logs folder, first shut down Portfolio server.","LOGGING_DEFAULT_LOCATION_MSG":"The default log location is","LOGGING_DIR_MUST_EXIST":"NOTE: In order to successfully change the log directory, the newly specified directory must already exist and be writeable by the user under which the Portfolio Server is running.","LOGGING_LOG_DIR":"Logs folder","LOGGING_LOG_LEVEL":"Log level","LOGGING_NUM_LOGS_TO_RETAIN":"Number of logs to retain","LOGIN":"Login","MAPPING_HEADER":"User/Group Mapping to Portfolio","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"The mappings have been modified, would you like to save them?","MEDIA_ENGINES_ACTION_ADD":"Add New Media Engine","MEDIA_ENGINES_ACTION_DELETE":"Delete Media Engine","MEDIA_ENGINES_ACTION_EDIT":"View/Edit Media Engine Details","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"You can not add another active Media Engine because the server is already using the maximum number of active media engines allowed by your Portfolio Media Engine license.","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"You can not add a Media Engine because the server doesn't have any available Portfolio Media Engine licenses.","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"You can not remove the built in Media Engine.","MEDIA_ENGINES_COLUMN_ACTIVE":"Active","MEDIA_ENGINES_COLUMN_ADDRESS":"Address","MEDIA_ENGINES_COLUMN_PORT":"Port","MEDIA_ENGINES_CONFIRM_DELETE":"Do you want to delete the selected Media Engine?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Media Engine Details","MEDIA_ENGINES_LICENSES_LABEL":"Media Engine seats available for activation","MEDIA_ENGINES_NEW_DETAILS_HEADER":"New Media Engine Details","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"No Media Engines are active. You should activate a Media Engine before clients need to use Portfolio Media services.","MOBILE":"Mobile","MOBILE_ENABLED":"Enable Mobile Uploading","MOBILE_FOLDER_VERBIAGE":"Save mobile uploads to this folder:","MOBILE_CREATE_CATALOG_VERBIAGE":"Create new catalog 'Mobile Uploads' to automatically watch this folder (recommended)","MOBILE_CATALOG_NAME":"Mobile Uploads","modifyAssetContents":"Check Out Assets","MODIFY_LDAP":"Modify LDAP query","NAME":"Name","NAME_TOO_LONG_ERROR":"Name must be less than 256 characters.","NAV_ABOUT":"About","NAV_ACCESS_LEVELS":"Roles","NAV_AUTOSYNC":"Autosync","NAV_BACKUPS":"Backup/Restore","NAV_CATALOGS":"Catalogs","NAV_GLOBAL_SETTINGS":"Global Settings","NAV_HELP":"Help","NAV_LICENSES":"Licenses","NAV_LOGOUT":"Logout","NAV_MEDIA_ENGINES":"Media Engines","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"Ports","NAV_REPORTING":"Reports","NAV_SETTINGS":"Settings","NAV_STATUS":"Status","NAV_USERS":"Users","NO_CATALOGS":"None","NO_FILE_SELECTED":"No File Selected","VaultFolderNotFound":"The Portfolio Vault folder was not found at {path}.","NO_VAULT_FOLDER":"The Portfolio Vault folder was not found at {path}.\n\nPlease check the location of the folder on your file system, and in the Global Settings -> Server Data page of this application.","NOTES":"Notes","NUMBER_DECIMAL_POINT_COUNT_ERROR":"The decimal separator can only occur once.","NUMBER_EXCEEDS_MAX_ERROR":"The number entered is too large.","NUMBER_INTEGER_ERROR":"The number must be an integer.","NUMBER_INVALID_CHAR_ERROR":"The input contains invalid characters.","NUMBER_INVALID_FORMAT_CHARS_ERROR":"One of the formatting parameters is invalid.","NUMBER_LOWER_THAN_MIN_ERROR":"The amount entered is too small.","NUMBER_NEGATIVE_ERROR":"The amount may not be negative.","NUMBER_PRECISION_ERROR":"The amount entered has too many digits beyond the decimal point.","NUMBER_SEPARATION_ERROR":"The thousands separator must be followed by three digits.","OK":"OK","ON_DATE":"on","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"Groups","ORGANIZATION_NAME":"Organization Name","ORGANIZATIONAL_UNIT":"Organizational Unit","PASSWORD":"Password","PASSWORD_CONFIRM":"Confirm Password","PASSWORD_TOO_LONG_ERROR":"Password must be less than 256 characters.","PORT":"Port","PORT_VALUE_TOO_HIGH_ERROR":"Port value must be less than 65536.","PortfolioAssetCap":"Portfolio Asset Cap","PortfolioAPI":"Portfolio API","PortfolioDemo":"Demo","PortfolioDirServices":"Portfolio Directory Services","PortfolioServer":"Portfolio Server","PortfolioStudio":"Portfolio Studio Edition","PortfolioProfessional":"Portfolio Professional Edition","PortfolioEnterprise":"Portfolio Enterprise Edition","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keywords","PortfolioUserConnection":"Portfolio User Connection","PortfolioSingleSignOn":"Single Sign On (SSO)","PORT_CURRENT_VALUE":"Current Value","PORT_ERROR_MSG_BAD_PORT_VALUE":"The new port value must be a number between 1 and 65535.","PORT_ERROR_MSG_CONFLICT":"Can not update port values because one or more of the new port values is already in use on the server.","PORT_FIND_PORT":"Find Port","PORT_NAME":"Name","PORT_NEW_VALUE":"New Value","PORT_RESTART_NOTICE":"Note: port updates do not take effect until the server is restarted.","PORT_RESTART_SERVER":"Restart Server","PORT_UPDATE_PORTS":"Update Ports","PORT_WARNING_ADMIN_RESTART":"The admin port was changed. The browser will be redirected to the new location in {numSecs} seconds.","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"Are you sure?","PROMPT_COULD_NOT_CREATE_FOLDER":"That folder could not be created. Please enter another path.","PROMPT_COULD_NOT_CREATE_FOLDERS":"Please enter another folder path because the following paths could not be created:","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"That folder could not be created because there's already a file with that name. Please enter another path.","PROMPT_CREATE_THAT_FOLDER":"That folder does not exist. Create it?","PROMPT_CREATE_THESE_FOLDERS":"These folders do not exist. Do you want to create them?","PROMPT_DELETE_LICENSE_CONFIRM":"Do you want to delete the selected license?","QUERY":"Query","REMOVE":"Remove","REMOVE_DIRECTORY_SERVICE":"Remove Service","REPLACE_USER_MAPPING_CONFIRMATION":"A regular user mapping already exists for this user. Replace it with an exclude user mapping?","REPLACE_USER_EXCLUSION_CONFIRMATION":"An exclude user mapping already exists for this user. Replace it with a regular user mapping?","REQUIRED_FIELD_ERROR":"This field is required.","REVERT":"Revert","REVERT_CHANGES":"Revert Changes","ROLE_FOR_IMPORT":"Role for Import","ROLES_PERMISSION_ENABLED_HEADER":"Enabled","ROLES_PERMISSION_NAME_HEADER":"Operation","SAVE":"Save","SAVE_MAPPING":"Save Mapping","saveOutputSetting":"Manage Presets (Convert and Make PDF)","SEARCH":"Search","SEARCH_BASE":"Search Base","SEARCH_RESULTS":"Search Results","SECURITY_GROUPS":"Security Groups","SELECT":"Select","SEND_DIAGNOSTIC_DATA":"Send diagnostic report to Portfolio DAM","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"Default work location:","SERVER_RESTART_REQUIRED":"The server must be restarted for changes to take effect.","SERVER_STATE_ERROR":"Error: See Admin Log for Details","SERVER_STATE_STARTED":"Running","SERVER_STATE_STARTING":"Starting","SERVER_STATE_STOPPED":"Stopped","SERVER_STATE_STOPPING":"Stopping","SERVER_STATE_UNKNOWN":"Unknown","SERVICE_BROWSER":"Service Browser","SK_ENGINE_APPAREL":"Apparel","SK_ENGINE_CELEBRITIES":"Celebrities","SK_ENGINE_FOOD":"Food","SK_ENGINE_GENERAL":"General","SK_ENGINE_LOGO":"Logo","SK_ENGINE_MODERATION":"Moderation","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"Travel","SK_ENGINE_WEDDINGS":"Weddings","SSL_HANDSHAKE_ERROR":"SSL handshake failed; please verify that the port and SSL settings are correct.","STARTS_WITH":"starts with","STATE_OR_PROVINCE":"State or Province","STATUS":"Status","STATUS_ADMIN_LOG":"Admin Log","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"Licensed","STATUS_API_STATE_UNLICENSED":"Not licensed","STATUS_CLEAR_ADMIN_LOG":"Clear Admin Log","STATUS_CONNECTED_USERS":"Connected Users","STATUS_MAX_ALLOWED_CONNECTIONS":"Maximum Connections","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Media Engine","STATUS_MEDIA_ENGINES_ACTIVE":"Active","STATUS_MEDIA_ENGINES_LABEL":"Media Engines","STATUS_RESTART_SERVER":"Restart Portfolio","STATUS_SEAT_USAGE":"Seat Usage","STATUS_SERVER_STATE":"Portfolio State","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Start Portfolio","STATUS_STOP_SERVER":"Stop Portfolio","STATUS_PROBLEMS_DETECTED":"Problems detected:","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"Remaining startup disk space is under {minSpace}GB.","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"The work folder does not exist or is inaccessible.","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"The Portfolio server cannot write to the work folder.","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"The Portfolio server cannot read from the work folder.","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"The Portfolio server cannot create symlinks in the work folder.","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"Remaining work folder disk space is under {minSpace}GB.","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"Unable to get work folder status.","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"The status for elasticsearch index {index} is red.","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"The elasticsearch index {index} has uninitialized shards.","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"Not all shards are active for the elasticsearch index {index}.","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"Unable to retrieve elasticsearch status.","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"Unable to retrieve errors from the Portfolio server.","STATUS_MSG_STARTUP_FAILED":"Startup failed","STATUS_MSG_CANT_GET_SERVER_HEALTH":"Unable to update server health.","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"The native-agent server component is not running.","SUBJECT_ALTERNATIVE_NAMES":"Subject Alternative Names","SUBMIT":"Submit","swedish":"Swedish","SYNC_DAILY":"Synchronize Daily","SYNCHRONIZE_NOW":"Synchronize Now","TARGET_CATALOG":"Target Catalog","THIS_LOCALE":"en","TRUE_LABEL":"True","TOKEN":"Token","TOTAL_ASSETS":"Total Assets","TWO_LETTER_COUNTRY_CODE":"Two-letter Country Code","TYPE":"Type","UNABLE_CONNECT_LDAP":"Unable to connect to LDAP/AD server.","UNABLE_CONNECT_SERVER":"Unable to connect to server.","UNKNOWN_HOST_ERROR":"Unable to connect to directory service due to an unknown host exception. Please check the hostname.","UNKNOWN_LDAP_USER_ERROR":"No user was found in the Identity Service with the account name '{accountName}'.","useCustomPresets":"Use Convert Presets","USE_SSL":"Use SSL","USER_ACCOUNT":"Account","USER_CREATE":"Add New User","USER_DELETE":"Delete Users","USER_DELETE_CONFIRM":"Delete Selected Users?","USER_DELETE__DELETE_PRIVATE":"Permanently Deleted","USER_DELETE__GALLERY_PROMPT":"Make Public makes all private and read-only galleries that belong to this user, public galleries. \"Delete All Private Galleries\" permanently removes private galleries, and makes read-only galleries public.","USER_DELETE__GALLERY_PROMPT_1":"The users' Checked Out items will be reverted and made accessible.","USER_DELETE__GALLERY_PROMPT_2":"The users' Read-Only Galleries will be made Public.","USER_DELETE__GALLERY_PROMPT_3":"The users' Private Galleries should be:","USER_DELETE__MAKE_PUBLIC":"Made Public","USER_DETAILS":"User Details","USER_IMPORT":"Import Users","USER_IMPORT_ACCOUNT":"Account Name","USER_IMPORT_ACCOUNT_ATTR":"Account Attribute","USER_IMPORT_EMAIL_ATTR":"Email Attribute","USER_IMPORT_IMPORT":"Import","USER_IMPORT_IMPORT_SELECTED_USERS":"Import Selected Users","USER_IMPORT_MODIFY_SEARCH":"Modify Search","USER_IMPORT_NAME_ATTR":"Account Name Attribute","USER_IMPORT_NOTES_ATTR":"Notes Attribute","USER_IMPORT_PASSWORD":"Account Password","USER_IMPORT_PASSWORD_ATTR":"Password Attribute","USER_IMPORT_SEARCH":"Search","USER_IMPORT_SEARCH_BASE":"Search Base","USER_IMPORT_SEARCH_FILTER":"Search Filter","USER_IMPORT_SERVER_ADDRESS":"Server Address","USER_IMPORT_SPECIFY_LDAP_SERVER":"Specify LDAP Server","USER_LEVEL_ADMINISTRATOR":"Catalog Administrator","USER_LEVEL_EDITOR":"Editor","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"Publisher","USER_LEVEL_READER":"Reader","USER_MANAGE_CATALOGS":"Manage Catalogs for Selected Users","USER_MULT_USERS_SELECTED":"Multiple Users Selected","USER_NAME":"User Name","USER_NEW_USER_DETAILS":"New User Details","USER_NEW_USER_INFO_MSG":"To add a user to specific catalogs, use Catalogs > Users.","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"Add user to all catalogs as:","USER_NO_USERS_SELECTED":"No Users Selected","USER_ONLINE":"Online","USER_PASSWORD_TOO_SHORT":"Password must contain at least one character.","USER_PASSWORDS_DO_NOT_MATCH":"The password confirmation field needs to match the password field.","USER_ROLE":"Role","USER_VIEW_DETAILS":"View/Edit User Details","USERS":"Users","VALIDATION_FIELD_LENGTH_EXCEEDED":"This field cannot exceed 255 characters.","VALIDATION_MUST_BE_NONEMPTY":"This field is required.","VIEW_EDIT_MAPPINGS":"View / Edit Mappings","General.OK":"OK","General.Cancel":"Cancel","PORT_TITLE":"Ports","PORT_DEFAULT":"Default:","esp.port.admin-web-app":"Portfolio Admin HTTP Port","esp.port.admin-web-app-ssl":"Portfolio Admin SSL Port","esp.port.http":"Portfolio Server HTTP Port","esp.port.ssl":"Portfolio Server SSL Port","General.Save":"Save","CATALOG_DETAILS_FILETYPES_TAB":"File Types","addAsset":"Add Assets","canManageFieldLists":"Manage Public Field Lists","canModifyFolderStructure":"Modify Folder Structures","canMoveAssets":"Move Assets","deleteAssetContents":"Delete Original Assets","deleteAssetFromCatalog":"Delete Asset from Catalog","modifyAssetProperties":"Update Asset Fields","synchronizeAutoSyncFolder":"Sync Autosync Folders","ASSETS":"Assets","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"Create Catalog","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"The system memory is {value}GB which is below the {minGB}GB minimum requirements.","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"The system memory computed by Portfolio is {value}GB which may be inaccurate.","AUTH.couldNotConnect":"Could not connect to the server. Please check the address.","ERROR.serverUnavailable":"The Portfolio server is not available.","ERROR.sessionExpired":"Your session has expired.","fileNotFound":"The file was not found on disk.","ERROR.invalidSearchFailed":"The search failed because there was a problem with the query.","AUTH.loginFailed":"The username and password were incorrect.","FAULT_CODE.InsufficientPrivileges":"You have insufficient privileges to perform this operation.","unexpectedError":"An unexpected error occurred.","ROLES_CREATE_ROLE_TITLE":"Create Role","ROLES_DELETE_CONFIRM":"Do you want to delete the selected Role?\nUsers with this Role will be demoted to Readers.","NOTIFICATION_SUCCESS_UPDATE":"Update Successful","DATA_COLLECTION_TITLE":"Analytics","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"I agree to share application usage data.","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"Help us deliver the best solutions by sharing application usage with us.\n\nBy accepting, you'll help us gather important information that will guide us toward future quality and feature improvements. The information gathered helps us greatly understand your solution needs.\n\nYou can always change your mind at any time and discontinue sharing information.\n\nFor more information about how we use your information and to opt-out in the future please visit our help article page:","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/en-us/articles/1260804371029","CREATE_USER":"Create User","CATALOG_FILES_TAB_TITLE":"Ingest","FIELD_CATEGORY_ALL":"All Active Fields","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"Cataloged","FIELD_DEF.catalogedBy":"Cataloged By","FIELD_DEF.colorMode":"Color Mode","FIELD_DEF.isPanoramic":"Panoramic","FIELD_DEF.created":"Created","FIELD_DEF.directoryPath":"Directory Path","FIELD_DEF.documentText":"Document Text","FIELD_DEF.filename":"Filename","FIELD_DEF.fileDescription":"Description","FIELD_DEF.fileSize":"File Size","FIELD_DEF.geometry":"Geo - Map","FIELD_DEF.height":"Height","FIELD_DEF.horizontalResolution":"Horizontal Resolution","FIELD_DEF.keywords":"Keywords","FIELD_DEF.lastModified":"Modified","FIELD_DEF.lastUpdated":"Changed","FIELD_DEF.aliasMac":"Alias Mac","FIELD_DEF.creatorMac":"Creator Mac","FIELD_DEF.fileTypeMac":"File Type Mac","FIELD_DEF.zoneMac":"Zone Mac","FIELD_DEF.multipageCount":"Number of Pages","FIELD_DEF.numBands":"Number of Bands","FIELD_DEF.path":"Path","FIELD_DEF.ItemID":"Asset ID","FIELD_DEF.shortFilenameWin":"Short Filename Win","FIELD_DEF.thumbnailSize":"Thumbnail Size","FIELD_DEF.updatedBy":"Changed By","FIELD_DEF.verticalResolution":"Vertical Resolution","FIELD_DEF.volume":"Volume","FIELD_DEF.watermarkURL":"Watermark URL","FIELD_DEF.watermarked":"Watermarked","FIELD_DEF.width":"Width","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"Refresh","ALL_CATALOGS":"All Catalogs","ALL_SITES":"All Sites","ASSET_DOWNLOADS":"Assets - Most Downloaded","ASSET_PREVIEWS":"Assets - Most Previewed","ASSET_UPLOADS":"Assets - Uploads","DOWNLOAD_REPORT":"Download Report","FILE_TYPES":"File Types","FILE_TYPES_SECTION_TITLE":"File Types","FILE_TYPES_ERROR_NAME_EXISTS":"The name '{name}' matches the name of an existing file type.","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"Reset Defaults","FILE_TYPES_PROMPT_DISCARD_CHANGES":"Discard pending changes?","FILE_TYPES_ADD_FILE_TYPE":"Add File Type","FILE_TYPES_UPDATE_FILE_TYPE":"Update File Type","FILE_TYPES_EXTENSIONS":"Extensions","FROM":"From","SITE":"Site","KEYWORD_STATISTICS":"Keyword Statistics","NETPUBLISH_MOST_DOWNLOADED":"NetPublish - Most Downloaded","NETPUBLISH_USAGE":"NetPublish - Usage","REPORT_DESCRIPTION_ASSET_PREVIEWS":"This report identifies which assets were previewed and how many times each was previewed.","REPORT_DESCRIPTION_ASSET_UPLOADS":"This report identifies uploaded assets, which users uploaded them, and when.","REPORT_DESCRIPTION_DOWNLOADED":"This report identifies which assets were downloaded and how many times each was downloaded.","REPORT_DESCRIPTION_KEYWORD":"This report identifies all the keywords in a catalog and how many assets they are applied to.","REPORT_DESCRIPTION_USAGE":"This report identifies which users downloaded which assets, and when.","SEARCH_TERMS":"Search Terms","TO":"To","VIEW_REPORT":"View Report","NP_SITES":"NetPublish Sites","REPORT_NAME_DELETED_BY":"Assets - Deletions","REPORT_NAME_DOWNLOADED_BY":"Assets - Downloads","REPORT_DESCRIPTION_DELETED_BY":"This report identifies deleted assets, which users deleted them, and when.","REPORT_DESCRIPTION_DOWNLOADED_BY":"This report identifies downloaded assets, which users downloaded them, and when.","CATALOG_SAVE_TEMPLATE_TITLE":"Save Catalog Template","BACKUP_FILES_LABEL":"Backup Files","CONFIGURE_EMAIL_LINK":"Configure email notifications...","NP_SOURCE":"Source","NOTIFICATION_FAILURE_UPDATE":"Update Unsuccessful","FIELD_FORM_LABEL_PRECISION_MAX":"Max","REPORT_DESCRIPTION_FILE_TYPES":"This report identifies your most common file types and how much disk space they occupy.","REPORT_DESCRIPTION_SEARCH_TERMS":"This report identifies the most common words and phrases for which your users are searching in QuickFind.","DUPLICATE_FIELD_NAME_ERROR":"Duplicate Field Name","NO_CATALOGS_EXIST":"No Catalogs exist.\n\nClick the + button to create a Catalog.","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"Change {affectedUsersCount, plural, one {Role} other {Roles}}","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"Remove {affectedUsersCount, plural, one {User} other {{affectedUsersCount} Users}} from Catalog","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"Are you sure you want to remove the {affectedUsersCount, plural, one {user} other {selected users}} from the catalog?\n\nThe {affectedUsersCount, plural, one {user's} other {selected users'}} Checked Out items in this catalog will be reverted and made accessible.","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"Are you sure you want to change the {affectedUsersCount, plural, one {user's role} other {selected users' roles}} in the catalog?\n\nThis action can be destructive to the {affectedUsersCount, plural, one {user's} other {selected users'}} data if the new role has reduced access or permissions.","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"Querying\nThis may take a few minutes...","FIELD_DELETE_CONFIRM_MSG":"Do you want to delete the selected field?","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"Reset all FileTypes to their default values?","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"Filter","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"AD Users and Groups","DIRECTORY_SERVICE_SAVE_MAPPINGS":"Save and Sync","DIRECTORY_SERVICE_REMOVE_MAPPING":"Remove Mapping","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Portfolio User Imports","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"No Mappings\n\nTo create a mapping, select a user or group to the left, and click 'Create Mapping'","NOTIFICATION_FAILURE_ADD":"Add Unsuccessful","FIELD_ADD_EXTRACT_METADATA":"Add Extract Metadata","FIELD_MULTIPLE_EMBED_WARNING":"More than one field embeds to","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"Smart Keyword newly cataloged assets","LIC_CLICK_TO_UPGRADE":"Click to upgrade Portfolio Server","LIC_MAINTENANCE_END_DATE":"Maintenance/Subscription End Date","LIC_SEAT_DISPLAY":"User Seats","LIC_ACTIVATE":"Activate Portfolio","LIC_CLICK_TO_ACTIVATE":"Activate Portfolio with your Portfolio DAM credentials","LIC_CLICK_TO_USE":"Try Portfolio for a limited time with a Demo Serial Number","LIC_TRIAL":"Try Portfolio","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/en-us/requests/new","LIC_ERROR_GET_ACCOUNT":"There was a problem getting your Portfolio DAM Account.","LIC_ERROR_GET_LICENSES":"There was a problem retrieving your licenses from Portfolio DAM.","CHANGE":"Change","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"To change this folder, first shut down Portfolio server","MEDIA_ENGINES_COLUMN_TEST":"Test","ROLES_PERMISSIONS":"Permissions","NO_SITES_EXIST_1":"No NetPublish Sites exist.","NO_SITES_EXIST_2":"Use the Publish option found within Portfolio to create and publish Sites.","MEDIA_ENGINE_NOT_OPERATIONAL":"The media engine could not be accessed.","MEDIA_ENGINE_OPERATIONAL":"The media engine is operational.","LIC_SET_EXTENSIS_ACCOUNT":"Set Portfolio DAM Account","LIC_ACCOUNT":"Email","LIC_PASSWORD":"Password","CERTS_TITLE":"SSL Certificate","LIC_SYSTEM_ID":"System ID","LIC_SET_ACCOUNT_ERROR":"There was a problem setting your Portfolio DAM Account. Please check the credentials and try again.","LIC_SET_SYSTEM_TITLE":"Select Your Portfolio DAM System","NP_DELETE_SITE_CONFIRMATION":"Do you want to permanently delete the Site?","NP_SITE_DELETE_LABEL":"Delete Site","NP_SITE_ENABLED_LABEL":"Site Enabled","CERT_CREATE_REQUEST":"Create Certificate Request","CERT_DOWNLOAD":"Download","CERT_EXPIRATION_DATE":"Expiration Date","CERT_IMPORT":"Import Certificate","CERT_ISSUER":"Issuer","CERT_OWNER":"Owner","CERT_PENDING_REQUEST":"Pending Certificate Request","CERTIFICATE_STATUS_INVALID":"Invalid Certificate","CERTIFICATE_STATUS_SELF_SIGNED":"Invalid Certificate: Self-Signed","CERTIFICATE_STATUS_EXPIRED":"Certificate Expired","CERTIFICATE_STATUS_IMPORTED":"Certificate Imported","CERT_DELETE_CONFIRMATION":"Are you sure you want to delete the certificate request? This cannot be undone.","DIAGNOSTICS_TITLE":"Diagnostics","DIAGNOSTICS_NO_PROBLEMS":"No problems found","SK_ENGINE_ART_STYLE":"Art Style","SK_ENGINE_ART_SUBJECT":"Art Subject","SK_ENGINE_ART_MOVEMENT":"Art Movement","CERT_FILE":"Certificate File","CERT_FILE_INT_1":"Intermediate Certificate 1","CERT_FILE_INT_2":"Intermediate Certificate 2","CERT_FILE_PASSWORD":"Certificate Password","CERT_FILE_PASSWORD_HELP":"If your certificate has a password, enter it here","CERT_FILE_PROMPT":"Select...","CERT_FILE_ROOT":"Root Certificate","CERT_IMPORT_SUCCEEDED":"The certificate was successfully imported. Please restart the Portfolio server and Portfolio admin services to begin using the certificate.","CERT_IMPORT_FAILED_READING_PKCS12":"The server could not read the PKCS12 certificate. Check the password.","CERT_IMPORT_FAILED_INTERMEDIATE1":"The Intermediate 1 certificate could not be imported.","CERT_IMPORT_FAILED_INTERMEDIATE2":"The Intermediate 2 certificate could not be imported.","CERT_IMPORT_FAILED_ROOT":"The root certificate could not be imported.","DIRECTORY_SERVICE_CONFIG_TITLE":"Active Directory Configuration","DIRECTORY_SERVICES_TITLE":"Directory Services","DIRECTORY_SERVICE_MAPIINGS":"Directory Items to Portfolio Mappings","DIRECTORY_SERVICE_MAPIINGS_TITLE":"Mappings","PDL_noPredefinedValues":"No Predefined Values","PDL_editPredefinedListPlaceholder":"Edit Predefined List","PDL_importPredefinedValues":"Import Predefined Values","PDL_exportPredefinedValues":"Export Predefined Values","PDL_removeNestedValueConfirmation":"Delete the selected values?\nThey contain nested values which will also be deleted.","PDL_wrongPdlImportFormat":"The selected file did not contain text data. Please select a text file.","LIC_SET_ACCOUNT":"Set Account","LIC_REMOVE_ACCOUNT":"Remove Account","LIC_CONTACT_CUSTOMER_SUCCESS_1":"For assistance with renewing your account, please contact us at","LIC_CONTACT_CUSTOMER_SUCCESS_2":"and your Customer Success Manager will contact you within 1 business day."});/* eslint-enable */

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"About","ABOUT_API_TAB":"API","ABOUT_VERSION":"Version","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio Server","ABOUT_PORTFOLIO_VERSION":"Version 9.0","ABOUT_SERVER_TAB":"Server","accessOriginals":"Access and Process Originals","ACCOUNT_TYPE":"Authentication","ACCOUNT_TYPE_LDAP":"Directory Service","ACCOUNT_TYPE_MANUAL":"Native (Built-in)","ACTIVE_DIRECTORY":"Active Directory","ADD":"Add","ALL_CATALOGS_GROUP":"All Catalogs","API_CODE_REFERENCE":"API Code Reference (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"Developer Community","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"Portfolio Administration Help","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","API_SECTION_1":"The Portfolio API provides a common interface for developers to integrate Portfolio catalogs, asset metadata, and media processing into business systems, custom workflows, and web infrastructures.","API_SECTION_2_PART_1":"Use of the API requires licenses, as described in the","API_SECTION_2_EULA":"Portfolio EULA","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":". To view or edit license information, click 'Licenses' in the Portfolio Administration application.","API_SECTION_2_PART_3":"Learn more:","API_TOKEN_CREATE":"Add New API Token","APPLY":"Apply","APP_PAGE_TITLE":"Portfolio Admin","AT_TIME":"at","AUTHENTICATION_ERROR":"Directory service authentication failed. Please check your username and password.","BACKUP_BACKUP_BUTTON":"Backup","BACKUP_BACKUP_LABEL":"Backup","BACKUP_BACKUP_NOW_BUTTON":"Backup Now","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"To change the backup location, first shut down Portfolio server.","BACKUP_CONFIRMATION_VERBIAGE":"Backup now? Portfolio will be offline until backup is complete.","BACKUP_DIRECTORY_LABEL":"Store in Directory","BACKUP_DIRECTORY_ERROR_MSG":"The selected backup directory is not valid.","BACKUP_EXPLANATION_TEXT_1":"Backups capture and safely store the server database and settings.\nIt does not backup your original asset files!","BACKUP_EXPLANATION_TEXT_2":"The server will be inaccessible during backups.","BACKUP_FRIDAY_LABEL":"Friday","BACKUP_MONDAY_LABEL":"Monday","BACKUP_MOST_RECENT_LABEL":"Most Recent Backup","BACKUP_NEXT_SCHEDULED_LABEL":"Next Scheduled Backup","BACKUP_NOTIFICATIONS":"Send email notifications after backups and restores","BACKUP_NOTIFICATIONS_DISABLED_MSG":"Email notifications must be enabled in Global Settings > Email Notifications","BACKUP_PROGRESS_BACKING_UP":"Backing Up","BACKUP_PROGRESS_BACKING_UP_DATA":"Backing up data...","BACKUP_PROGRESS_BACKUP_CANCELLED":"Backup Cancelled","BACKUP_PROGRESS_BACKUP_FAILED":"Backup Failed","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"Backup Successful","BACKUP_PROGRESS_PREFLIGHT":"Checking for available space...","BACKUP_PROGRESS_RESTARTING":"Restarting server...","BACKUP_PROGRESS_RESTORE_FAILED":"Restore Failed","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"Restore Successful","BACKUP_PROGRESS_RESTORING":"Restoring","BACKUP_PROGRESS_RESTORING_DATA":"Restoring data...","BACKUP_PROGRESS_SHUTTING_DOWN":"Shutting down server...","BACKUP_PROGRESS_SUMMARY":"Step {stepNum} of {totalSteps}","BACKUP_RESTORE_BUTTON":"Restore From Backup","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"Restore backup now? Portfolio will be offline until restore is complete. This will overwrite your current database and settings.","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"The backup archive is corrupt.\nChoose another backup to restore from.","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"The backup disk has insufficient space\nto complete.\n\n{requiredSpace} required, {availableSpace} available.","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"The currently configured backup location does not exist. The backup location is used to unzip the archive when a backup is being restored. Please reset the backup location to a valid directory.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"There was a problem with the backup.\nSee admin logs for details.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"There was a problem with the restore.\nSee admin logs for details.","BACKUP_RESTORE_LABEL":"Restore","BACKUP_RESTORE_TITLE":"Backup/Restore","BACKUP_RETAIN_LABEL":"Retain","BACKUP_RETAIN_VALUE":"Keep only the {numBackups} most recent backups","BACKUP_SATURDAY_LABEL":"Saturday","BACKUP_SCHEDULE_LABEL":"Schedule Backups","BACKUP_SCHEDULE_VALUE":"on","BACKUP_SUNDAY_LABEL":"Sunday","BACKUP_THURSDAY_LABEL":"Thursday","BACKUP_TUESDAY_LABEL":"Tuesday","BACKUP_WEDNESDAY_LABEL":"Wednesday","BROWSE":"Browse","BROWSE_FOLDERS_TITLE":"Browse Server Folders","BROWSE_RECENT_FOLDERS_LABEL":"Recent Folders","BROWSE_REFRESH":"Synchronize items","CALL_ATT_BUTTON_BUY_NOW":"Buy Now","CALL_ATT_BUTTON_SECONDARY":"Contact Sales for a Quote","CALL_ATT_FADEL_BUTTON_MAIN":"Contact Sales for More Information","CALL_ATT_FADEL_MAIN":"Ensure proper usage of your licensed content, from images to videos and everything in between. Portfolio seamlessly connects with FADEL Rights Cloud software so you can see and easily understand the usage rights associated with your assets—helping you to remove workflow bottlenecks and reduce the risk of expensive copyright violations.","CALL_ATT_FADEL_SUBTITLE":"Know your asset usage rights","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"High-Performance Processing and Conversion","CALL_ATT_ME_MAIN":"Are you pushing the performance limits of your Portfolio server? With Media Engine, avoid slowdowns and improve overall productivity by eliminating the bottlenecks caused by busy production environments.\n\n\t• Increases capacity and throughput\n\t• Unlocks additional output formats\n\t• Accelerates video preview creation\n\t• Add multiple Media Engines as needed\n\t• Watermarking (requires NetPublish)","CALL_ATT_ME_BUTTON_MAIN":"Get Media Engine","CALL_ATT_NP_SUBTITLE":"Self-Service Portals to Access Assets Instantly","CALL_ATT_NP_MAIN":"Tired of those last minute requests every time someone needs an asset? With NetPublish, it's easy to post self-serve websites that allow anyone to locate and download the assets they need from any browser on any device.\n\n\t• One-click site creation - no HTML or CSS required\n\t• Mobile-friendly, responsive design\n\t• Flexible user access control\n\t• Deactivate sites automatically\n\t• Set resolution, size and format on download\n\t• Watermarking (requires Media Engine)\n\t• Usage reporting","CALL_ATT_NP_BUTTON_MAIN":"Get NetPublish","CALL_ATT_REPORT_TITLE":"Reporting for NetPublish","CALL_ATT_REPORT_SUBTITLE":"Relevant Usage Insight","CALL_ATT_REPORT_MAIN":"Want to know which sites are most active, what assets are getting used and by whom? With NetPublish reporting, get the insight you need to make informed decisions based on how Portfolio is being used at your organization.\n\nUsage breakdown by:\n\t• NetPublish site name\n\t• Username\n\t• Asset name and ID\n\t• Date and time","CALL_ATT_REPORT_BUTTON_MAIN":"Get NetPublish","CALL_ATT_SK_BUTTON_MAIN":"Try it for Free","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/wqqb","CALL_ATT_SK_MAIN":"Looking for a way to accelerate your process for assigning keywords to images? With Portfolio Smart Keywords, you can automatically assign “smart” keywords to your images with just one click. Powered by Clarifai, an innovative artificial intelligence company that excels in visual recognition technology, a list of suggested keywords is delivered in seconds.\n\n\t• Delivers a list of smart keywords in seconds\n\t• Saves time and resources by reducing manual keywording\n\t• Establishes a consistent taxonomy for your organization\n\t• Makes it easy to find your digital assets quickly","CALL_ATT_SK_SUBTITLE":"Automate Your Image Keywording","CALL_ATT_SK_TITLE":"Portfolio Smart Keywords","CALL_ATT_SSO_SUBTITLE":"Seamless User Experience Across Platforms","CALL_ATT_SSO_TITLE":"Single Sign-On","CALL_ATT_SSO_MAIN":"Are people in your organization having a hard time keeping their login credentials straight? Typically, with new solutions come extra overhead in managing user accounts, both for you and for the users.\n\nFortunately, Portfolio supports Single Sign-On with Active Directory. Using Single Sign-On, users can login to Portfolio automatically from your intranet site giving them a continuous user experience.\n\n\t• Supports Windows Server Active Directory\n\t• Improves overall security\n\t• Simplifies user management\n\t• Improves user experience","CALL_ATT_SSO_BUTTON_MAIN":"Get Single Sign-On","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/portfolio/contact-me","canEmbedMetadata":"Embed Metadata","canImportMetadata":"Import/Export Metadata","canManagePublicGallery":"Manage Public Galleries","canPublishNetPublishSites":"Publish NetPublish Sites","canSmartKeyword":"Can Smart Keyword","CANCEL":"Cancel","CATALOG":"Catalog","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"Grant Membership","CATALOG_BACKUP":"Backup Selected Catalog","CATALOG_CREATE":"Add New Catalog","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"Catalog Administrators can add AutoSync folders from the Desktop Client.","CATALOG_CREATE_AUTOSYNC_FOLDER":"Create an AutoSync folder","CATALOG_CREATE_CATALOG_TEMPLATE":"Save Catalog Template","CATALOG_TYPE_GENERAL":"General Use","CATALOG_TYPE_SIMPLE":"Simple","CATALOG_CREATE_DATABASES_LIST_LABEL":"Databases","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"An error was encountered when creating the {folder} folder.","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"Default folders for AutoSync and Previews can be configured in Global Settings.","CATALOG_CREATE_NAME":"Name","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"Previews can be configured in Catalog Details.","CATALOG_CREATE_PREVIEW_FOLDER":"Save Previews for faster previewing","CATALOG_CREATE_SHOW_DATABASES":"Show Databases","CATALOG_CREATE_USE_VERSIONING":"Use Asset Versioning","CATALOG_DELETE":"Delete Catalog","CATALOG_DELETE_CONFIRM":"Do you want to delete the selected catalog?","CATALOG_DETAILS":"Catalog Details","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"To rename this catalog we must temporarily take it offline, do you want to continue?","CATALOG_DETAILS_COLLATION":"Collation","CATALOG_DETAILS_COLLATION_NA":"N/A","CATALOG_DETAILS_CREATION_DATE":"Creation Date","CATALOG_DETAILS_DATABASE_TAB":"General","CATALOG_DETAILS_LAST_MODIFIED":"Last Modified","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"Connected Users","CATALOG_DETAILS_NUMBER_OF_RECORDS":"Records","CATALOG_DETAILS_NUMBER_OF_USERS":"Members","CATALOG_DETAILS_SIZE_ON_DISK":"Size on disk","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"The administrator user will be disconnected. Proceed?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"Locked for administration","CATALOG_DETAILS_UNLOCK":"Unlock","CATALOG_EXPLANATION_VAULT_1":"Vault catalogs store assets in a secure repository.","CATALOG_EXPLANATION_VAULT_2":"Vault catalogs support locking, versioning, check-out and check-in.","CATALOG_EXPLANATION_WF_1":"Watch Folder catalogs track assets in place in your file system.","CATALOG_EXPLANATION_WF_2":"Watch Folder catalogs support AutoSync.","CATALOG_INGEST_DRAG_HINT_TEXT":"To add fields to the Upload Form, drag them over from the Fields list.","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"Fields for Upload Form","CATALOG_INGEST_FIELDS_LABEL":"Fields","CATALOG_INGEST_FORM_HEADER_LABEL":"Form Header","CATALOG_INGEST_HEADER_HINT_TEXT":"The form header is optional and appears at the top of the form.","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"The maximum number of fields to add to a form is {maxFields}.","CATALOG_INGEST_TAB_TITLE":"Managed Upload","CATALOG_INGEST_USE_INGEST_LABEL":"Use Managed Upload","CATALOG_INGEST_REQUIRED_LABEL":"Required","CATALOG_IS_CONNECTED":"Connected","CATALOG_IS_DEFAULT":"Default","CATALOG_MANAGE_USERS":"Manage Catalog Membership","CATALOG_MANAGE_FIELDS":"Manage Catalog Fields","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"Manage Catalog Templates...","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"Manage Custom Catalog Templates","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"Catalog Template Name","CATALOG_MEMBER":"Member","CATALOG_NEW_CATALOG_DETAILS":"New Catalog Details","CATALOG_OFFLINE":"Offline","CATALOG_ONLINE":"Online","CATALOG_OPTIONS_ALL_FILE_TYPES":"Catalog All File Types","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"Create Keywords from Path","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"Filename","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"Parent Folder","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"Server Name","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"Folder Tree","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"Volume","CATALOG_OPTIONS_EXCLUSION_LABEL":"File and Folder Exclusions","CATALOG_OPTIONS_ONLY_FILE_TYPES":"Catalog Only","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"Remove the selected file type(s)?","endsWith":"Ends with","contains":"Contains","startsWith":"Starts with","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"Remove the selected exclusion(s)?","CATALOG_OPTIONS_TAB_TITLE":"Cataloging Options","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"The default location is","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"Minimum size 300 pixels, maximum size 4000 pixel (longest dimension)","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"Generate clips for audio/video files","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"Create Previews","CATALOG_PREVIEWS_FOLDER_LOCATION":"Save previews and clips in this folder","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"This location must be accessible to the server.","CATALOG_PREVIEWS_MAX_PIXELS":"Maximum image size","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"Maximum video resolution","CATALOG_PREVIEWS_MINUTES":"minutes","CATALOG_PREVIEWS_PIXELS":"pixels","CATALOG_PREVIEWS_SHORT":"Previews","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"Limit duration to","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"Generating clips can take a while to process.\nTo shorten the processing time, choose a lower resolution and duration.","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"Revoke Membership","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"Remove the user from the catalog?\nThe user's Checked Out items in this catalog will be reverted and made accessible.","CATALOG_SAVE_TEMPLATE":"Save Catalog Template...","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"Catalog templates include all fields, metadata mappings, and cataloging options.","CATALOG_SELECT_MESSAGE":"No Catalog Selected","CATALOG_SET_AS_DEFAULT":"Set Default Catalog","CATALOG_SK_DEFAULT_SETTINGS":"Default Settings","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"Confidence Level","CATALOG_SK_DEFAULT_LABEL":"Recommended: {recommended}","CATALOG_SK_ENGINES_LABEL":"Smart Keyword Engines","CATALOG_SK_LANGUAGES_LABEL":"Languages for General Engine","CATALOG_SK_NUM_KEYWORDS_LABEL":"Number of Keywords","CATALOG_SK_SETTINGS_LABEL":"Settings","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"Use Smart Keywords in this Catalog","CATALOG_STATUS":"Catalog Status","CATALOG_STORAGE_TYPE_LABEL":"Storage Type","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"Watch Folders","CATALOG_STORAGE_TYPE_VAULT":"Vault","CATALOG_TAKE_OFFLINE_SHORT":"Take Offline","CATALOG_TAKE_ONLINE_SHORT":"Take Online","CATALOG_TEMPLATE":"template","CATALOG_TEMPLATE_NAME":"Template Name","CATALOG_TEMPLATES_TITLE":"Catalog Templates","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"Remove the selected catalog template?","CATALOG_VIEW_DETAILS":"View/Edit Catalog Details","CERT_REQUEST_ALREADY_CREATED_WARNING":"You have already created a certificate request. If you continue, the existing request will be deleted.","CERTIFICATE_FILE_FILTER":"Certificates (p7b, cer, crt, der, pfx, p12)","CITY_OR_LOCALITY":"City or Locality","CLEAR_BUTTON_LABEL":"Clear","COMMUNICATION_AT_INITILIZATION_ERROR":"There was an error communicating with the server. This is usually caused by stale data in the browser cache but it could also indicate a problem with the server. Contact your administrator for more information.","CONFIGURE_DIRECTORY_SERVICE":"Configure Directory Service","CONFIRM_DELETE_PDL":"Delete all predefined values for this field?","CONFIRM_DELETE_SERVICE":"Remove Directory Service?\nUsers imported from the service will remain. Their passwords will revert to values set previously in Portfolio, or will be disabled if not set previously.","CONFIRM_TRUNCATE_VALUES":"Max Length exceeds one or more default or predefined values for this field. Truncate values?","CONNECTION_REFUSED_ERROR":"The connection to the directory service was refused. Please check your hostname and port settings.","CONTAINS":"contains","CONTINUE":"Continue","CREATE":"Create","CREATE_A_CERTIFICATE_REQUEST":"Create a certificate signing request","createContactSheet":"Make PDF","CREATED_BY":"Created By","CREATE_MAPPING":"Create Mapping","CREATE_USER_EXCLUSION_MAPPING":"Exclude User","CREATED_ON_DATE":"Date Created","DATE_FORMAT":"MM/DD/YYYY","DATE_FORMAT_ERROR":"Configuration error: Incorrect formatting string.","DATE_INVALID_CHAR_ERROR":"The date contains invalid characters.","DATE_TIME_FORMAT":"MM/DD/YYYY L:NN A","DATE_TIME_SECONDS_FORMAT":"MM/DD/YYYY L:NN:SS A","DATE_WRONG_DAY_ERROR":"Enter a valid day for the month.","DATE_WRONG_LENGTH_ERROR":"Type the date in the format:","DATE_WRONG_MONTH_ERROR":"Enter a month between 1 and 12.","DATE_WRONG_YEAR_ERROR":"Enter a year between 0 and 9999.","DEFAULT_ACCESS_LEVEL":"Default Role","DEFAULT_CATALOG":"Default Catalog","DEFAULT_CATALOG_NONE":"None","DEFAULT_PORT_NON_SSL":"Default port for non-SSL:","DEFAULT_PORT_SSL":"Default port for SSL:","DELETE":"Delete","DELETE_SOURCE":"Delete Source","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"Delete all values?\nThis will delete all values including nested values.","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"Delete the value '{value}'?\nIt contains nested values which will also be deleted.","DELETE_NESTED_VALUE_CONFIRMATION":"Delete the selected values?\nThey contain nested values which will also be deleted.","DELETE_WARNING_BOX_MSG":"Warning! Deleting cannot be undone!","DELETE_WARNING_CATALOG_VAULT":"All files in the catalog will be destroyed.","DIAGNOSTIC_DATA_TITLE":"Send Diagnostic Report to Portfolio DAM","DIAGNOSTIC_DATA_ACCOUNT_NAME":"Company or Account Name (Required)","DIAGNOSTIC_DATA_CONTACT_NAME":"Contact Name","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"Tech Support Ticket Number","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"Send Report","DIAGNOSTIC_STATUS_ERROR":"There was a problem uploading the diagnostic report on {date}","DIAGNOSTIC_STATUS_SENDING":"Sending...","DIAGNOSTIC_STATUS_SUCCESS":"Diagnostic report successfully sent to Portfolio DAM on {date}","DIRECTORY_SERVICE_CONNECT_ERROR":"Unable to connect to the directory service. Please check the hostname and port settings.","DIRECTORY_SERVICES":"Directory Services","DIRECTORY_USERS_CANNOT_BE_DELETED":"Directory Service users cannot be deleted!","DISTRIBUTION_GROUPS":"Distribution Groups","DOWNLOAD_CERT_PROMPT":"Download certificate request file?","DOWNLOAD_COMPLETE_STRING":"Download complete.","downloadPreviews":"Download Previews","EMAIL_ADDRESS":"Email Address","EMAIL_CONFIG_AUTH_PASSWORD":"Password","EMAIL_CONFIG_AUTH_USERNAME":"User Name","EMAIL_CONFIG_ENABLED":"Enable Email Notifications","EMAIL_CONFIG_FROM_ADDRESS":"Email From Address","EMAIL_CONFIG_INVALID_GENERIC":"Email Server Configuration Invalid","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"Email Server Not Found","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"Email Server Authentication Failed","EMAIL_CONFIG_MESSAGE":"Each user who wishes to receive notifications must have an email address assigned in the Users pane.","EMAIL_CONFIG_SERVER_ADDRESS":"SMTP Server Address","EMAIL_CONFIG_SERVER_PORT":"SMTP Server Port","EMAIL_CONFIG_SUCCESS_MESSAGE":"SMTP Server Validated","EMAIL_CONFIG_USE_SSL_TLS":"Use SSL / TLS","EMAIL_CONFIG_USE_SMTP_AUTH":"Use SMTP Authentication","EMAIL_CONFIG_VALIDATE":"Test Connection","EMAIL_CONFIG_VALIDATED":"Email Server Validated","english":"English","ENTIRE_TREE_UNDER_SEARCH_BASE":"Entire tree","EQUALS":"equals","EXPORT_MENU_STRING":"Export Values","FADEL_HOWTO":"Login to your FADEL account:","FALSE_LABEL":"False","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"Please check that the admin server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload this application.","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"This operation cannot be performed while a backup or restore is in progress.","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"That operation failed because the catalog is in admin mode.","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"A catalog already exists with this name.","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"A user already exists with this account name.","FAULT_MSG_DB_IN_USE":"The operation could not be completed because the catalog is currently in use by an administrator.","FAULT_MSG_DELETE_ADMIN":"You cannot delete the administrator account.","FAULT_MSG_DELETE_SELF":"You cannot delete your user account.","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"An unexpected error occurred when deleting the catalog template.","FAULT_MSG_DUPE_NAME":"An object with that name already exists.  Please use another name.","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"There is already a Media Engine with that address and port.","FAULT_MSG_ENTITY_VERSION_MISMATCH":"That operation failed because the client's information was out of date.","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"Please check that the server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload the application.","FAULT_MSG_INVALID_SESSION_ID":"Your session has expired. You must log into the server again.","FAULT_MSG_IS_NOT_LICENSED":"Server not licensed for that operation.","FAULT_MSG_LEGACY_21000":"The operation failed because of an unknown internal error.","FAULT_MSG_LOGGING_ERR_UPDATE":"There has been an error updating the logging configuration","FAULT_MSG_LOG_DIR_NOT_VALID":"The specified log directory does not exist, is not writeable or the path specified is not a directory.","FAULT_MSG_NO_DIRECTORY":"The specified location does not exist or it is not a directory.","FAULT_MSG_NULL_DESCRIPTION":"An unexpected error occurred, but there is no description to report.","FAULT_MSG_NULL_FAULTEVENT":"An unexpected error occurred, but there are no details to report.","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"That operation failed because you do not have sufficient privileges.","FAULT_MSG_OPERATION_IS_INVALID":"That operation was not valid.","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"An unexpected error occurred when renaming the catalog template.","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"An unexpected error occurred when saving the catalog template.","FAULT_MSG_SERVER_NOT_RUNNING":"The server is not running.","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"The operation failed because the server does not have an Enterprise Module license.","FAULT_MSG_REMOVE_METADATA_DEF":"Removing the metadata definition failed.  It may be in use by other catalogs.","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"The server returned a fault with this message:","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"The server returned a fault with no error message.","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"The server returned a fault with an unknown type and this message:","FAULT_MSG_UNKNOWN_SMTP_SERVER":"Unable to connect to the specified mail server.","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"That operation failed because a service was not in the expected state.","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"The username or password supplied for the database is not valid.","FAULT_MSG_BAD_DB_PORT":"The database port specified is not valid.","FAULT_MSG_BAD_DB_HOST":"The database hostname or port specified is invalid.","FIELD_ACTION_ADD":"Add New Custom Field","FIELD_ACTION_DELETE":"Delete Selected Field","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"XMP Namespaces","FIELD_ACTION_MANAGE_METADATA":"Manage Metadata","FIELD_CATEGORY_CUSTOM":"Custom Fields","FIELD_CATEGORY_SYSTEM":"System Fields","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"Movie","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"Field Category","FIELD_DISABLE_CONFIRM_MSG":"Do you want to disable the selected field?","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"Enable All","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"Add Extract Mapping","FIELD_FORM_LABEL_DEFAULT_VALUE":"Default Value","FIELD_FORM_LABEL_DISABLED":"(Disabled)","FIELD_FORM_LABEL_EMBED":"Embed in Metadata","FIELD_FORM_LABEL_EXTRACT":"Extract from Metadata","FIELD_FORM_LABEL_FIELD_NAME":"Field Name","FIELD_FORM_LABEL_FIELD_TYPE":"Field Type","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"Allow Multiple Values","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"Has Predefined Values","FIELD_FORM_LABEL_HELP_TEXT":"Help Text","FIELD_FORM_LABEL_MAX":"Max: {max}","FIELD_FORM_LABEL_MAX_LENGTH":"Max Length","FIELD_FORM_LABEL_METADATA_TAG":"Metadata Name","FIELD_FORM_LABEL_METADATA_TYPE":"Metadata Type","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"Allow Only Predefined Values","FIELD_FORM_LABEL_PRECISION":"Precision","FIELD_FORM_LABEL_PREDEFINED_VALUES":"Predefined Values","FIELD_FORM_LABEL_SHOW_TIME":"Show Time","FIELD_FORM_LABEL_USE_METADATA":"Extract and Embed Metadata","FIELD_FORM_WARNING_DUPE_EMBEDS":"Warning: More than one field embeds to '{metadata}'","FIELD_METADATA_DATA_TYPE_LABEL":"Data Type","FIELD_METADATA_DEFINITION_IS_CUSTOM":"Is Custom","FIELD_METADATA_DEFINITIONS_TITLE":"Metadata Definitions","FIELD_METADATA_DELETE_CONFIRM_MSG":"Confirm: Delete the Metadata Definition?","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"Multivalued Type","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"Not Multivalued","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"Ordered","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"Unordered","FIELD_METADATA_NAME_LABEL":"Name","FIELD_METADATA_NAMESPACE_LABEL":"Namespace","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"Add a Custom XMP Namespace...","FIELD_METADATA_TAG_LABEL":"Tag","FIELD_METADATA_TYPE_LABEL":"Type","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"Multiple Fields Selected","FIELD_NAMESPACE_ABBREVIATION":"Abbreviation","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"Delete the Custom XMP Namespace?\nThere may be Field Definitions using the namespace.","FIELD_NAMESPACE_URI":"Namespace URI","FIELD_NEW_FIELD_NAME":"New Field","FIELD_NEW_METADATA_TITLE":"New Metadata Definition","FIELD_NEW_NAMESPACE_TITLE":"New Custom XMP Namespace","FIELD_NO_FIELD_SELECTED_MESSAGE":"No Field Selected","FIELD_PAGE_TITLE":"Manage Fields for Catalog '{catalogName}'","FIELD_REVERT_CONFIRM_MSG":"Confirm: Revert the field?","FIELD_TYPE_BLOB":"Blob","FIELD_TYPE_BOOLEAN":"Boolean","FIELD_TYPE_DATETIME":"Date/Time","FIELD_TYPE_DECIMAL":"Decimal","FIELD_TYPE_LANG_ALT":"Lang Alt","FIELD_TYPE_NUMBER":"Number","FIELD_TYPE_PICTURE":"Picture","FIELD_TYPE_STRING":"String","FIELD_TYPE_STRUCTURE":"Structure","FIELD_TYPE_TEXTBLOCK":"Text Block","FIELD_TYPE_UNKNOWN":"Unknown","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"There was an error uploading the file to the server.","FILE_WRONG_TYPE_ERROR_MSG":"This file is not a supported file type.\nPlease select a jpeg, gif or png file.","FOLDER_PATH_AUTOSYNC_FILES_STRING":"Files","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"A file exists with this name.","FOLDER_PATH_DOES_NOT_EXIST":"Path does not exist.","FOLDER_PATH_ERROR":"Error","FOLDER_PATH_NOT_VERIFIED":"The folder path has not been verified.","FOLDER_PATH_PATH":"Path","FOLDER_PATH_OPERATION_INVALID":"An invalid operation","FOLDER_PATH_SUCCESS":"Success","FOLDER_PATH_TYPE_AUTOSYNC":"autosync","FOLDER_PATH_TYPE_PREVIEW":"preview","FOLDER_PATH_UNKNOWN_FAULT":"An unknown fault","french":"French","FULL_NAME":"Full Name","FULLY_QUALIFIED_DOMAIN_NAME":"Fully Qualified Domain Name","german":"German","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"Create AutoSync folders for new catalogs in this folder","GLOBAL_SETTINGS_BACKGROUND_COLOR":"Background Color","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"Background color of the login screen.","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"Catalog Defaults","GLOBAL_SETTINGS_CHOOSE_FILE":"Choose File","GLOBAL_SETTINGS_CUSTOM_IMAGE":"Custom Image","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"Approximate size should fit within 2400 x 1350 pixels.","GLOBAL_SETTINGS_CUSTOM_TITLE":"Custom Title","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"The title that appears on the browser tab or bookmark.","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"Customized Login Screen","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"Default Role","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"Default Login Screen","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"Email Notifications","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"The location of AutoSync and Preview folders must be accessible to the server.","GLOBAL_SETTINGS_IMAGE_URL":"Link","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"Clicking the image will launch this URL in another browser window.","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"To make changes, start the server or check for an expired server license.","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"Save Previews for new catalogs in this folder","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"Server Data Locations","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"Portfolio Login Customization","GLOBAL_SETTINGS_SSO_CREDENTIALS":"Single Sign-on Credentials","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"Enter the user account that is associated with the Portfolio Server service for Kerberos authentication.","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"Temporary Work folder","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"The work folder will be changed the next time the server is restarted. The new folder will be located at:","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"You must restart the server for this change to take effect.","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Portfolio Vault Configuration","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Portfolio Vault folder","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Default:","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"To move Portfolio Vault folder, first shut down Portfolio server.","HELP_URL":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"Hostname","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(default)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"Directory Service connection succeeded. Configuration saved.","IMAGE_FILE_FILTER":"Images (jpg, gif, png)","IMPORT_LDAP":"Import users from LDAP/AD server","IMPORT_LDAP_SPECIFY_SERVER":"Specify LDAP/AD Server","IMPORT_MENU_STRING":"Import Values","IMPORT_SOURCE":"Import Source","INVALID_DN_SYNTAX_ERROR":"Unable to connect to the directory service due to invalid DN syntax error. Please check the username.","japanese":"Japanese","LAST_CERTIFICATE_REQUEST_LABEL":"Last Certificate Request","LAST_MODIFIED_BY":"Last Modified By","LAST_MODIFIED_DATE":"Date Last Modified","LDAP_ADDRESS":"LDAP/AD Server address","LDAP_BIND_USERNAME":"LDAP Bind Username","LDAP_SYNC_NOTIFICATION":"The server has received the sync request.","LIC_ADD_MESSAGE":"Copy and Paste Licenses or enter individually one per row.","LIC_ADD_SN":"Add New License","LIC_ADD_SN_SHORT":"Add Licenses","LIC_ASSET_CAP_DISPLAY":"Assets","LIC_DAYS_REMAINING":"({days} Days Remaining)","LIC_DEMO_PERIOD":"Demo Period","LIC_ERROR_MSG":"Invalid serial number, please re-try. If the problem persists check your server log or contact your administrator.","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"The serial number cannot be added to Portfolio Studio.","LITE_CANNOT_CREATE_FDB_CATALOG":"Your Portfolio license does not allow more than one catalog. Please consider upgrading your Portfolio license to perform this action.","LITE_CANNOT_SERVE_FDB_CATALOG":"Your Portfolio Server license does not allow further catalogs to be taken online.","LITE_THIS_FEATURE_NOT_SUPPORTED":"Your Portfolio Server license does not support this action.","LOGGING_CONFIGURATION":"Logging Configuration","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"To move Logs folder, first shut down Portfolio server.","LOGGING_DEFAULT_LOCATION_MSG":"The default log location is","LOGGING_DIR_MUST_EXIST":"NOTE: In order to successfully change the log directory, the newly specified directory must already exist and be writeable by the user under which the Portfolio Server is running.","LOGGING_LOG_DIR":"Logs folder","LOGGING_LOG_LEVEL":"Log level","LOGGING_NUM_LOGS_TO_RETAIN":"Number of logs to retain","LOGIN":"Login","MAPPING_HEADER":"User/Group Mapping to Portfolio","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"The mappings have been modified, would you like to save them?","MEDIA_ENGINES_ACTION_ADD":"Add New Media Engine","MEDIA_ENGINES_ACTION_DELETE":"Delete Media Engine","MEDIA_ENGINES_ACTION_EDIT":"View/Edit Media Engine Details","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"You can not add another active Media Engine because the server is already using the maximum number of active media engines allowed by your Portfolio Media Engine license.","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"You can not add a Media Engine because the server doesn't have any available Portfolio Media Engine licenses.","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"You can not remove the built in Media Engine.","MEDIA_ENGINES_COLUMN_ACTIVE":"Active","MEDIA_ENGINES_COLUMN_ADDRESS":"Address","MEDIA_ENGINES_COLUMN_PORT":"Port","MEDIA_ENGINES_CONFIRM_DELETE":"Do you want to delete the selected Media Engine?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Media Engine Details","MEDIA_ENGINES_LICENSES_LABEL":"Media Engine seats available for activation","MEDIA_ENGINES_NEW_DETAILS_HEADER":"New Media Engine Details","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"No Media Engines are active. You should activate a Media Engine before clients need to use Portfolio Media services.","MOBILE":"Mobile","MOBILE_ENABLED":"Enable Mobile Uploading","MOBILE_FOLDER_VERBIAGE":"Save mobile uploads to this folder:","MOBILE_CREATE_CATALOG_VERBIAGE":"Create new catalog 'Mobile Uploads' to automatically watch this folder (recommended)","MOBILE_CATALOG_NAME":"Mobile Uploads","modifyAssetContents":"Check Out Assets","MODIFY_LDAP":"Modify LDAP query","NAME":"Name","NAME_TOO_LONG_ERROR":"Name must be less than 256 characters.","NAV_ABOUT":"About","NAV_ACCESS_LEVELS":"Roles","NAV_AUTOSYNC":"Autosync","NAV_BACKUPS":"Backup/Restore","NAV_CATALOGS":"Catalogs","NAV_GLOBAL_SETTINGS":"Global Settings","NAV_HELP":"Help","NAV_LICENSES":"Licenses","NAV_LOGOUT":"Logout","NAV_MEDIA_ENGINES":"Media Engines","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"Ports","NAV_REPORTING":"Reports","NAV_SETTINGS":"Settings","NAV_STATUS":"Status","NAV_USERS":"Users","NO_CATALOGS":"None","NO_FILE_SELECTED":"No File Selected","VaultFolderNotFound":"The Portfolio Vault folder was not found at {path}.","NO_VAULT_FOLDER":"The Portfolio Vault folder was not found at {path}.\n\nPlease check the location of the folder on your file system, and in the Global Settings -> Server Data page of this application.","NOTES":"Notes","NUMBER_DECIMAL_POINT_COUNT_ERROR":"The decimal separator can only occur once.","NUMBER_EXCEEDS_MAX_ERROR":"The number entered is too large.","NUMBER_INTEGER_ERROR":"The number must be an integer.","NUMBER_INVALID_CHAR_ERROR":"The input contains invalid characters.","NUMBER_INVALID_FORMAT_CHARS_ERROR":"One of the formatting parameters is invalid.","NUMBER_LOWER_THAN_MIN_ERROR":"The amount entered is too small.","NUMBER_NEGATIVE_ERROR":"The amount may not be negative.","NUMBER_PRECISION_ERROR":"The amount entered has too many digits beyond the decimal point.","NUMBER_SEPARATION_ERROR":"The thousands separator must be followed by three digits.","OK":"OK","ON_DATE":"on","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"Groups","ORGANIZATION_NAME":"Organization Name","ORGANIZATIONAL_UNIT":"Organizational Unit","PASSWORD":"Password","PASSWORD_CONFIRM":"Confirm Password","PASSWORD_TOO_LONG_ERROR":"Password must be less than 256 characters.","PORT":"Port","PORT_VALUE_TOO_HIGH_ERROR":"Port value must be less than 65536.","PortfolioAssetCap":"Portfolio Asset Cap","PortfolioAPI":"Portfolio API","PortfolioDemo":"Demo","PortfolioDirServices":"Portfolio Directory Services","PortfolioServer":"Portfolio Server","PortfolioStudio":"Portfolio Studio Edition","PortfolioProfessional":"Portfolio Professional Edition","PortfolioEnterprise":"Portfolio Enterprise Edition","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keywords","PortfolioUserConnection":"Portfolio User Connection","PortfolioSingleSignOn":"Single Sign On (SSO)","PORT_CURRENT_VALUE":"Current Value","PORT_ERROR_MSG_BAD_PORT_VALUE":"The new port value must be a number between 1 and 65535.","PORT_ERROR_MSG_CONFLICT":"Can not update port values because one or more of the new port values is already in use on the server.","PORT_FIND_PORT":"Find Port","PORT_NAME":"Name","PORT_NEW_VALUE":"New Value","PORT_RESTART_NOTICE":"Note: port updates do not take effect until the server is restarted.","PORT_RESTART_SERVER":"Restart Server","PORT_UPDATE_PORTS":"Update Ports","PORT_WARNING_ADMIN_RESTART":"The admin port was changed. The browser will be redirected to the new location in {numSecs} seconds.","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"Are you sure?","PROMPT_COULD_NOT_CREATE_FOLDER":"That folder could not be created. Please enter another path.","PROMPT_COULD_NOT_CREATE_FOLDERS":"Please enter another folder path because the following paths could not be created:","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"That folder could not be created because there's already a file with that name. Please enter another path.","PROMPT_CREATE_THAT_FOLDER":"That folder does not exist. Create it?","PROMPT_CREATE_THESE_FOLDERS":"These folders do not exist. Do you want to create them?","PROMPT_DELETE_LICENSE_CONFIRM":"Do you want to delete the selected license?","QUERY":"Query","REMOVE":"Remove","REMOVE_DIRECTORY_SERVICE":"Remove Service","REPLACE_USER_MAPPING_CONFIRMATION":"A regular user mapping already exists for this user. Replace it with an exclude user mapping?","REPLACE_USER_EXCLUSION_CONFIRMATION":"An exclude user mapping already exists for this user. Replace it with a regular user mapping?","REQUIRED_FIELD_ERROR":"This field is required.","REVERT":"Revert","REVERT_CHANGES":"Revert Changes","ROLE_FOR_IMPORT":"Role for Import","ROLES_PERMISSION_ENABLED_HEADER":"Enabled","ROLES_PERMISSION_NAME_HEADER":"Operation","SAVE":"Save","SAVE_MAPPING":"Save Mapping","saveOutputSetting":"Manage Presets (Convert and Make PDF)","SEARCH":"Search","SEARCH_BASE":"Search Base","SEARCH_RESULTS":"Search Results","SECURITY_GROUPS":"Security Groups","SELECT":"Select","SEND_DIAGNOSTIC_DATA":"Send diagnostic report to Portfolio DAM","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"Default work location:","SERVER_RESTART_REQUIRED":"The server must be restarted for changes to take effect.","SERVER_STATE_ERROR":"Error: See Admin Log for Details","SERVER_STATE_STARTED":"Running","SERVER_STATE_STARTING":"Starting","SERVER_STATE_STOPPED":"Stopped","SERVER_STATE_STOPPING":"Stopping","SERVER_STATE_UNKNOWN":"Unknown","SERVICE_BROWSER":"Service Browser","SK_ENGINE_APPAREL":"Apparel","SK_ENGINE_CELEBRITIES":"Celebrities","SK_ENGINE_FOOD":"Food","SK_ENGINE_GENERAL":"General","SK_ENGINE_LOGO":"Logo","SK_ENGINE_MODERATION":"Moderation","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"Travel","SK_ENGINE_WEDDINGS":"Weddings","SSL_HANDSHAKE_ERROR":"SSL handshake failed; please verify that the port and SSL settings are correct.","STARTS_WITH":"starts with","STATE_OR_PROVINCE":"State or Province","STATUS":"Status","STATUS_ADMIN_LOG":"Admin Log","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"Licensed","STATUS_API_STATE_UNLICENSED":"Not licensed","STATUS_CLEAR_ADMIN_LOG":"Clear Admin Log","STATUS_CONNECTED_USERS":"Connected Users","STATUS_MAX_ALLOWED_CONNECTIONS":"Maximum Connections","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Media Engine","STATUS_MEDIA_ENGINES_ACTIVE":"Active","STATUS_MEDIA_ENGINES_LABEL":"Media Engines","STATUS_RESTART_SERVER":"Restart Portfolio","STATUS_SEAT_USAGE":"Seat Usage","STATUS_SERVER_STATE":"Portfolio State","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Start Portfolio","STATUS_STOP_SERVER":"Stop Portfolio","STATUS_PROBLEMS_DETECTED":"Problems detected:","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"Remaining startup disk space is under {minSpace}GB.","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"The work folder does not exist or is inaccessible.","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"The Portfolio server cannot write to the work folder.","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"The Portfolio server cannot read from the work folder.","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"The Portfolio server cannot create symlinks in the work folder.","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"Remaining work folder disk space is under {minSpace}GB.","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"Unable to get work folder status.","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"The status for elasticsearch index {index} is red.","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"The elasticsearch index {index} has uninitialized shards.","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"Not all shards are active for the elasticsearch index {index}.","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"Unable to retrieve elasticsearch status.","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"Unable to retrieve errors from the Portfolio server.","STATUS_MSG_STARTUP_FAILED":"Startup failed","STATUS_MSG_CANT_GET_SERVER_HEALTH":"Unable to update server health.","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"The native-agent server component is not running.","SUBJECT_ALTERNATIVE_NAMES":"Subject Alternative Names","SUBMIT":"Submit","swedish":"Swedish","SYNC_DAILY":"Synchronize Daily","SYNCHRONIZE_NOW":"Synchronize Now","TARGET_CATALOG":"Target Catalog","THIS_LOCALE":"en","TRUE_LABEL":"True","TOKEN":"Token","TOTAL_ASSETS":"Total Assets","TWO_LETTER_COUNTRY_CODE":"Two-letter Country Code","TYPE":"Type","UNABLE_CONNECT_LDAP":"Unable to connect to LDAP/AD server.","UNABLE_CONNECT_SERVER":"Unable to connect to server.","UNKNOWN_HOST_ERROR":"Unable to connect to directory service due to an unknown host exception. Please check the hostname.","UNKNOWN_LDAP_USER_ERROR":"No user was found in the Identity Service with the account name '{accountName}'.","useCustomPresets":"Use Convert Presets","USE_SSL":"Use SSL","USER_ACCOUNT":"Account","USER_CREATE":"Add New User","USER_DELETE":"Delete Users","USER_DELETE_CONFIRM":"Delete Selected Users?","USER_DELETE__DELETE_PRIVATE":"Permanently Deleted","USER_DELETE__GALLERY_PROMPT":"Make Public makes all private and read-only galleries that belong to this user, public galleries. \"Delete All Private Galleries\" permanently removes private galleries, and makes read-only galleries public.","USER_DELETE__GALLERY_PROMPT_1":"The users' Checked Out items will be reverted and made accessible.","USER_DELETE__GALLERY_PROMPT_2":"The users' Read-Only Galleries will be made Public.","USER_DELETE__GALLERY_PROMPT_3":"The users' Private Galleries should be:","USER_DELETE__MAKE_PUBLIC":"Made Public","USER_DETAILS":"User Details","USER_IMPORT":"Import Users","USER_IMPORT_ACCOUNT":"Account Name","USER_IMPORT_ACCOUNT_ATTR":"Account Attribute","USER_IMPORT_EMAIL_ATTR":"Email Attribute","USER_IMPORT_IMPORT":"Import","USER_IMPORT_IMPORT_SELECTED_USERS":"Import Selected Users","USER_IMPORT_MODIFY_SEARCH":"Modify Search","USER_IMPORT_NAME_ATTR":"Account Name Attribute","USER_IMPORT_NOTES_ATTR":"Notes Attribute","USER_IMPORT_PASSWORD":"Account Password","USER_IMPORT_PASSWORD_ATTR":"Password Attribute","USER_IMPORT_SEARCH":"Search","USER_IMPORT_SEARCH_BASE":"Search Base","USER_IMPORT_SEARCH_FILTER":"Search Filter","USER_IMPORT_SERVER_ADDRESS":"Server Address","USER_IMPORT_SPECIFY_LDAP_SERVER":"Specify LDAP Server","USER_LEVEL_ADMINISTRATOR":"Catalog Administrator","USER_LEVEL_EDITOR":"Editor","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"Publisher","USER_LEVEL_READER":"Reader","USER_MANAGE_CATALOGS":"Manage Catalogs for Selected Users","USER_MULT_USERS_SELECTED":"Multiple Users Selected","USER_NAME":"User Name","USER_NEW_USER_DETAILS":"New User Details","USER_NEW_USER_INFO_MSG":"To add a user to specific catalogs, use Catalogs > Users.","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"Add user to all catalogs as:","USER_NO_USERS_SELECTED":"No Users Selected","USER_ONLINE":"Online","USER_PASSWORD_TOO_SHORT":"Password must contain at least one character.","USER_PASSWORDS_DO_NOT_MATCH":"The password confirmation field needs to match the password field.","USER_ROLE":"Role","USER_VIEW_DETAILS":"View/Edit User Details","USERS":"Users","VALIDATION_FIELD_LENGTH_EXCEEDED":"This field cannot exceed 255 characters.","VALIDATION_MUST_BE_NONEMPTY":"This field is required.","VIEW_EDIT_MAPPINGS":"View / Edit Mappings","General.OK":"OK","General.Cancel":"Cancel","PORT_TITLE":"Ports","PORT_DEFAULT":"Default:","esp.port.admin-web-app":"Portfolio Admin HTTP Port","esp.port.admin-web-app-ssl":"Portfolio Admin SSL Port","esp.port.http":"Portfolio Server HTTP Port","esp.port.ssl":"Portfolio Server SSL Port","General.Save":"Save","CATALOG_DETAILS_FILETYPES_TAB":"File Types","addAsset":"Add Assets","canManageFieldLists":"Manage Public Field Lists","canModifyFolderStructure":"Modify Folder Structures","canMoveAssets":"Move Assets","deleteAssetContents":"Delete Original Assets","deleteAssetFromCatalog":"Delete Asset from Catalog","modifyAssetProperties":"Update Asset Fields","synchronizeAutoSyncFolder":"Sync Autosync Folders","ASSETS":"Assets","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"Create Catalog","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"The system memory is {value}GB which is below the {minGB}GB minimum requirements.","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"The system memory computed by Portfolio is {value}GB which may be inaccurate.","AUTH.couldNotConnect":"Could not connect to the server. Please check the address.","ERROR.serverUnavailable":"The Portfolio server is not available.","ERROR.sessionExpired":"Your session has expired.","fileNotFound":"The file was not found on disk.","ERROR.invalidSearchFailed":"The search failed because there was a problem with the query.","AUTH.loginFailed":"The username and password were incorrect.","FAULT_CODE.InsufficientPrivileges":"You have insufficient privileges to perform this operation.","unexpectedError":"An unexpected error occurred.","ROLES_CREATE_ROLE_TITLE":"Create Role","ROLES_DELETE_CONFIRM":"Do you want to delete the selected Role?\nUsers with this Role will be demoted to Readers.","NOTIFICATION_SUCCESS_UPDATE":"Update Successful","DATA_COLLECTION_TITLE":"Analytics","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"I agree to share application usage data.","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"Help us deliver the best solutions by sharing application usage with us.\n\nBy accepting, you'll help us gather important information that will guide us toward future quality and feature improvements. The information gathered helps us greatly understand your solution needs.\n\nYou can always change your mind at any time and discontinue sharing information.\n\nFor more information about how we use your information and to opt-out in the future please visit our help article page:","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/en-us/articles/1260804371029","CREATE_USER":"Create User","CATALOG_FILES_TAB_TITLE":"Ingest","FIELD_CATEGORY_ALL":"All Active Fields","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"Cataloged","FIELD_DEF.catalogedBy":"Cataloged By","FIELD_DEF.colorMode":"Color Mode","FIELD_DEF.isPanoramic":"Panoramic","FIELD_DEF.created":"Created","FIELD_DEF.directoryPath":"Directory Path","FIELD_DEF.documentText":"Document Text","FIELD_DEF.filename":"Filename","FIELD_DEF.fileDescription":"Description","FIELD_DEF.fileSize":"File Size","FIELD_DEF.geometry":"Geo - Map","FIELD_DEF.height":"Height","FIELD_DEF.horizontalResolution":"Horizontal Resolution","FIELD_DEF.keywords":"Keywords","FIELD_DEF.lastModified":"Modified","FIELD_DEF.lastUpdated":"Changed","FIELD_DEF.aliasMac":"Alias Mac","FIELD_DEF.creatorMac":"Creator Mac","FIELD_DEF.fileTypeMac":"File Type Mac","FIELD_DEF.zoneMac":"Zone Mac","FIELD_DEF.multipageCount":"Number of Pages","FIELD_DEF.numBands":"Number of Bands","FIELD_DEF.path":"Path","FIELD_DEF.ItemID":"Asset ID","FIELD_DEF.shortFilenameWin":"Short Filename Win","FIELD_DEF.thumbnailSize":"Thumbnail Size","FIELD_DEF.updatedBy":"Changed By","FIELD_DEF.verticalResolution":"Vertical Resolution","FIELD_DEF.volume":"Volume","FIELD_DEF.watermarkURL":"Watermark URL","FIELD_DEF.watermarked":"Watermarked","FIELD_DEF.width":"Width","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"Refresh","ALL_CATALOGS":"All Catalogs","ALL_SITES":"All Sites","ASSET_DOWNLOADS":"Assets - Most Downloaded","ASSET_PREVIEWS":"Assets - Most Previewed","ASSET_UPLOADS":"Assets - Uploads","DOWNLOAD_REPORT":"Download Report","FILE_TYPES":"File Types","FILE_TYPES_SECTION_TITLE":"File Types","FILE_TYPES_ERROR_NAME_EXISTS":"The name '{name}' matches the name of an existing file type.","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"Reset Defaults","FILE_TYPES_PROMPT_DISCARD_CHANGES":"Discard pending changes?","FILE_TYPES_ADD_FILE_TYPE":"Add File Type","FILE_TYPES_UPDATE_FILE_TYPE":"Update File Type","FILE_TYPES_EXTENSIONS":"Extensions","FROM":"From","SITE":"Site","KEYWORD_STATISTICS":"Keyword Statistics","NETPUBLISH_MOST_DOWNLOADED":"NetPublish - Most Downloaded","NETPUBLISH_USAGE":"NetPublish - Usage","REPORT_DESCRIPTION_ASSET_PREVIEWS":"This report identifies which assets were previewed and how many times each was previewed.","REPORT_DESCRIPTION_ASSET_UPLOADS":"This report identifies uploaded assets, which users uploaded them, and when.","REPORT_DESCRIPTION_DOWNLOADED":"This report identifies which assets were downloaded and how many times each was downloaded.","REPORT_DESCRIPTION_KEYWORD":"This report identifies all the keywords in a catalog and how many assets they are applied to.","REPORT_DESCRIPTION_USAGE":"This report identifies which users downloaded which assets, and when.","SEARCH_TERMS":"Search Terms","TO":"To","VIEW_REPORT":"View Report","NP_SITES":"NetPublish Sites","REPORT_NAME_DELETED_BY":"Assets - Deletions","REPORT_NAME_DOWNLOADED_BY":"Assets - Downloads","REPORT_DESCRIPTION_DELETED_BY":"This report identifies deleted assets, which users deleted them, and when.","REPORT_DESCRIPTION_DOWNLOADED_BY":"This report identifies downloaded assets, which users downloaded them, and when.","CATALOG_SAVE_TEMPLATE_TITLE":"Save Catalog Template","BACKUP_FILES_LABEL":"Backup Files","CONFIGURE_EMAIL_LINK":"Configure email notifications...","NP_SOURCE":"Source","NOTIFICATION_FAILURE_UPDATE":"Update Unsuccessful","FIELD_FORM_LABEL_PRECISION_MAX":"Max","REPORT_DESCRIPTION_FILE_TYPES":"This report identifies your most common file types and how much disk space they occupy.","REPORT_DESCRIPTION_SEARCH_TERMS":"This report identifies the most common words and phrases for which your users are searching in QuickFind.","DUPLICATE_FIELD_NAME_ERROR":"Duplicate Field Name","NO_CATALOGS_EXIST":"No Catalogs exist.\n\nClick the + button to create a Catalog.","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"Change {affectedUsersCount, plural, one {Role} other {Roles}}","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"Remove {affectedUsersCount, plural, one {User} other {{affectedUsersCount} Users}} from Catalog","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"Are you sure you want to remove the {affectedUsersCount, plural, one {user} other {selected users}} from the catalog?\n\nThe {affectedUsersCount, plural, one {user's} other {selected users'}} Checked Out items in this catalog will be reverted and made accessible.","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"Are you sure you want to change the {affectedUsersCount, plural, one {user's role} other {selected users' roles}} in the catalog?\n\nThis action can be destructive to the {affectedUsersCount, plural, one {user's} other {selected users'}} data if the new role has reduced access or permissions.","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"Querying\nThis may take a few minutes...","FIELD_DELETE_CONFIRM_MSG":"Do you want to delete the selected field?","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"Reset all FileTypes to their default values?","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"Filter","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"AD Users and Groups","DIRECTORY_SERVICE_SAVE_MAPPINGS":"Save and Sync","DIRECTORY_SERVICE_REMOVE_MAPPING":"Remove Mapping","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Portfolio User Imports","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"No Mappings\n\nTo create a mapping, select a user or group to the left, and click 'Create Mapping'","NOTIFICATION_FAILURE_ADD":"Add Unsuccessful","FIELD_ADD_EXTRACT_METADATA":"Add Extract Metadata","FIELD_MULTIPLE_EMBED_WARNING":"More than one field embeds to","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"Smart Keyword newly cataloged assets","LIC_CLICK_TO_UPGRADE":"Click to upgrade Portfolio Server","LIC_MAINTENANCE_END_DATE":"Maintenance/Subscription End Date","LIC_SEAT_DISPLAY":"User Seats","LIC_ACTIVATE":"Activate Portfolio","LIC_CLICK_TO_ACTIVATE":"Activate Portfolio with your Portfolio DAM credentials","LIC_CLICK_TO_USE":"Try Portfolio for a limited time with a Demo Serial Number","LIC_TRIAL":"Try Portfolio","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/en-us/requests/new","LIC_ERROR_GET_ACCOUNT":"There was a problem getting your Portfolio DAM Account.","LIC_ERROR_GET_LICENSES":"There was a problem retrieving your licenses from Portfolio DAM.","CHANGE":"Change","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"To change this folder, first shut down Portfolio server","MEDIA_ENGINES_COLUMN_TEST":"Test","ROLES_PERMISSIONS":"Permissions","NO_SITES_EXIST_1":"No NetPublish Sites exist.","NO_SITES_EXIST_2":"Use the Publish option found within Portfolio to create and publish Sites.","MEDIA_ENGINE_NOT_OPERATIONAL":"The media engine could not be accessed.","MEDIA_ENGINE_OPERATIONAL":"The media engine is operational.","LIC_SET_EXTENSIS_ACCOUNT":"Set Portfolio DAM Account","LIC_ACCOUNT":"Email","LIC_PASSWORD":"Password","CERTS_TITLE":"SSL Certificate","LIC_SYSTEM_ID":"System ID","LIC_SET_ACCOUNT_ERROR":"There was a problem setting your Portfolio DAM Account. Please check the credentials and try again.","LIC_SET_SYSTEM_TITLE":"Select Your Portfolio DAM System","NP_DELETE_SITE_CONFIRMATION":"Do you want to permanently delete the Site?","NP_SITE_DELETE_LABEL":"Delete Site","NP_SITE_ENABLED_LABEL":"Site Enabled","CERT_CREATE_REQUEST":"Create Certificate Request","CERT_DOWNLOAD":"Download","CERT_EXPIRATION_DATE":"Expiration Date","CERT_IMPORT":"Import Certificate","CERT_ISSUER":"Issuer","CERT_OWNER":"Owner","CERT_PENDING_REQUEST":"Pending Certificate Request","CERTIFICATE_STATUS_INVALID":"Invalid Certificate","CERTIFICATE_STATUS_SELF_SIGNED":"Invalid Certificate: Self-Signed","CERTIFICATE_STATUS_EXPIRED":"Certificate Expired","CERTIFICATE_STATUS_IMPORTED":"Certificate Imported","CERT_DELETE_CONFIRMATION":"Are you sure you want to delete the certificate request? This cannot be undone.","DIAGNOSTICS_TITLE":"Diagnostics","DIAGNOSTICS_NO_PROBLEMS":"No problems found","SK_ENGINE_ART_STYLE":"Art Style","SK_ENGINE_ART_SUBJECT":"Art Subject","SK_ENGINE_ART_MOVEMENT":"Art Movement","CERT_FILE":"Certificate File","CERT_FILE_INT_1":"Intermediate Certificate 1","CERT_FILE_INT_2":"Intermediate Certificate 2","CERT_FILE_PASSWORD":"Certificate Password","CERT_FILE_PASSWORD_HELP":"If your certificate has a password, enter it here","CERT_FILE_PROMPT":"Select...","CERT_FILE_ROOT":"Root Certificate","CERT_IMPORT_SUCCEEDED":"The certificate was successfully imported. Please restart the Portfolio server and Portfolio admin services to begin using the certificate.","CERT_IMPORT_FAILED_READING_PKCS12":"The server could not read the PKCS12 certificate. Check the password.","CERT_IMPORT_FAILED_INTERMEDIATE1":"The Intermediate 1 certificate could not be imported.","CERT_IMPORT_FAILED_INTERMEDIATE2":"The Intermediate 2 certificate could not be imported.","CERT_IMPORT_FAILED_ROOT":"The root certificate could not be imported.","DIRECTORY_SERVICE_CONFIG_TITLE":"Active Directory Configuration","DIRECTORY_SERVICES_TITLE":"Directory Services","DIRECTORY_SERVICE_MAPIINGS":"Directory Items to Portfolio Mappings","DIRECTORY_SERVICE_MAPIINGS_TITLE":"Mappings","PDL_noPredefinedValues":"No Predefined Values","PDL_editPredefinedListPlaceholder":"Edit Predefined List","PDL_importPredefinedValues":"Import Predefined Values","PDL_exportPredefinedValues":"Export Predefined Values","PDL_removeNestedValueConfirmation":"Delete the selected values?\nThey contain nested values which will also be deleted.","PDL_wrongPdlImportFormat":"The selected file did not contain text data. Please select a text file.","LIC_SET_ACCOUNT":"Set Account","LIC_REMOVE_ACCOUNT":"Remove Account","LIC_CONTACT_CUSTOMER_SUCCESS_1":"For assistance with renewing your account, please contact us at","LIC_CONTACT_CUSTOMER_SUCCESS_2":"and your Customer Success Manager will contact you within 1 business day."});/* eslint-enable */

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"Acerca de","ABOUT_API_TAB":"API","ABOUT_VERSION":"Versión","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio Server","ABOUT_PORTFOLIO_VERSION":"Versión 9.0","ABOUT_SERVER_TAB":"Servidor","accessOriginals":"Acceder y procesar originales","ACCOUNT_TYPE":"Autenticación","ACCOUNT_TYPE_LDAP":"Servicio de directorios","ACCOUNT_TYPE_MANUAL":"Nativo (incorporado)","ACTIVE_DIRECTORY":"Active Directory","ADD":"Agregar","ALL_CATALOGS_GROUP":"Todos los catálogos","API_CODE_REFERENCE":"Referencia de código de API (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"Comunidad de programadores","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"Ayuda de Portfolio Administration","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","API_SECTION_1":"La API de Portfolio ofrece una interfaz común para que los programadores integren catálogos de Portfolio, metadatos de activos y procesamiento de medios en sistemas de empresas, flujos de trabajo personalizados e infraestructuras Web.","API_SECTION_2_PART_1":"Para utilizar la API es necesario disponer de licencias, como se describe en ","API_SECTION_2_EULA":"el contrato de usuario final (EULA) de Portfolio","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":". Para ver o editar los datos de licencia, haga clic en 'Licencias' en la aplicación de administración Portfolio Administration.","API_SECTION_2_PART_3":"Más información:","API_TOKEN_CREATE":"Agregar Nuevo Identificador API","APPLY":"Aplicar","APP_PAGE_TITLE":"Administración de Portfolio","AT_TIME":"en el momento","AUTHENTICATION_ERROR":"Ha fallado la autenticación del servicio de directorios. Compruebe su nombre de usuario y contraseña.","BACKUP_BACKUP_BUTTON":"Copia de seguridad","BACKUP_BACKUP_LABEL":"Copia de seguridad","BACKUP_BACKUP_NOW_BUTTON":"Hacer copia de seguridad ahora","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Para cambiar la ubicación de la copia de seguridad, desactive en primer lugar el servidor de Portfolio.","BACKUP_CONFIRMATION_VERBIAGE":"¿Hacer copia de seguridad ahora? El portfolio estará fuera de línea hasta que se complete la copia de seguridad.","BACKUP_DIRECTORY_LABEL":"Almacenar en directorio","BACKUP_DIRECTORY_ERROR_MSG":"El directorio de la copia de seguridad seleccionada no es válido.","BACKUP_EXPLANATION_TEXT_1":"Las copias de seguridad capturan y almacenan de forma segura la base de datos y la configuración del servidor.¡\nIt no hace copias de seguridad de sus archivos de valores originales!","BACKUP_EXPLANATION_TEXT_2":"No se podrá acceder al servidor durante la realización de copias de seguridad.","BACKUP_FRIDAY_LABEL":"Viernes","BACKUP_MONDAY_LABEL":"Lunes","BACKUP_MOST_RECENT_LABEL":"Copia de seguridad más reciente","BACKUP_NEXT_SCHEDULED_LABEL":"Próxima copia de seguridad programada","BACKUP_NOTIFICATIONS":"Enviar notificaciones de correo electrónico después de las copias de seguridad y restauraciones","BACKUP_NOTIFICATIONS_DISABLED_MSG":"Las notificaciones de correo electrónico deben estar habilitadas en Ajustes globales > Notificaciones de correo electrónico","BACKUP_PROGRESS_BACKING_UP":"Haciendo copia de seguridad","BACKUP_PROGRESS_BACKING_UP_DATA":"Haciendo copia de seguridad de los datos...","BACKUP_PROGRESS_BACKUP_CANCELLED":"Copia de seguridad cancelada","BACKUP_PROGRESS_BACKUP_FAILED":"Error de copia de seguridad","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"Copia de seguridad satisfactoria","BACKUP_PROGRESS_PREFLIGHT":"Comprobando el espacio disponible...","BACKUP_PROGRESS_RESTARTING":"Reiniciando el servidor...","BACKUP_PROGRESS_RESTORE_FAILED":"Error de restauración","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"Restauración satisfactoria","BACKUP_PROGRESS_RESTORING":"Restaurando","BACKUP_PROGRESS_RESTORING_DATA":"Restaurando datos...","BACKUP_PROGRESS_SHUTTING_DOWN":"Apagando el servidor...","BACKUP_PROGRESS_SUMMARY":"Paso {stepNum} de {totalSteps}","BACKUP_RESTORE_BUTTON":"Restaurar a partir del archivo de copia de seguridad...","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"¿Restaurar copia de seguridad ahora? El portfolio estará fuera de línea hasta que se complete la restauración. Se sobrescribirá su base de datos y su configuración actuales.","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"El archivo de copia de seguridad está corrupto. Elija otra copia de seguridad desde la cual restaurar.","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"El disco de la copia de seguridad no tiene suficiente espacio\nto completa.\n\n{requiredSpace} requerida, {availableSpace} disponible.","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"La ubicación de la copia de seguridad configurada actualmente no existe. La ubicación de la copia de seguridad se utiliza para descomprimir el archivo cuando se restaura una copia de seguridad. Por favor, restablezca la ubicación de la copia de seguridad en un directorio válido.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"Hubo un problema con la copia de seguridad. Ver los registros de administrador para más información.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"Hubo un problema con la restauración. Ver los registros de administrador para más información.","BACKUP_RESTORE_LABEL":"Restaurar","BACKUP_RESTORE_TITLE":"Copia de seguridad/Restablecer","BACKUP_RETAIN_LABEL":"Retener","BACKUP_RETAIN_VALUE":"Mantener sólo las {numBackups} copias de seguridad más recientes","BACKUP_SATURDAY_LABEL":"Sábado","BACKUP_SCHEDULE_LABEL":"Programar copias de seguridad","BACKUP_SCHEDULE_VALUE":"en","BACKUP_SUNDAY_LABEL":"Domingo","BACKUP_THURSDAY_LABEL":"Jueves","BACKUP_TUESDAY_LABEL":"Martes","BACKUP_WEDNESDAY_LABEL":"Miércoles","BROWSE":"Examinar","BROWSE_FOLDERS_TITLE":"Buscar en las carpetas del servidor","BROWSE_RECENT_FOLDERS_LABEL":"Carpetas recientes","BROWSE_REFRESH":"Sincronizar elementos","CALL_ATT_BUTTON_BUY_NOW":"Comprar ahora","CALL_ATT_BUTTON_SECONDARY":"Póngase en contacto con el Departamento de ventas para solicitar presupuesto","CALL_ATT_FADEL_BUTTON_MAIN":"Ventas del contacto para más información","CALL_ATT_FADEL_MAIN":"Garantice un uso adecuado de su contenido con licencia, desde imágenes hasta vídeos y todo lo demás. El Portfolio se conecta de forma ininterrumpida con el software de nube FADEL para que pueda ver y entender fácilmente los derechos de uso asociados con sus activos, ayudándole a desatascar el flujo de trabajo y reducir el riesgo de infracciones costosas de derechos de autor.","CALL_ATT_FADEL_SUBTITLE":"Conozca los derechos de uso de sus activos","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"Procesamiento y conversión de alto rendimiento","CALL_ATT_ME_MAIN":"¿Desea aprovechar al máximo el rendimiento de su servidor de Portfolio? Con Media Engine, evite la ralentización del servidor y mejore la productividad general eliminando los atascos provocados por entornos de producción con alto rendimiento.\n\n\t• Aumenta la capacidad y productividad\n\t• Desbloquea formatos de producción adicionales\n\t• Acelera la creación de vistas previas de vídeo\n\t• Agregue los Media Engines que necesite\n\t• Configuración de marca de agua (precisa de Media Engine)","CALL_ATT_ME_BUTTON_MAIN":"Obtener Media Engine","CALL_ATT_NP_SUBTITLE":"Portales de auto-servicio para acceder a activos al instante","CALL_ATT_NP_MAIN":"¿Está cansado de solicitudes de última hora cada vez que alguien necesita un activo? Con NetPublish, es fácil publicar sitios web de auto-servicio que permitan a todos ubicar y descargar los activos que necesiten utilizando cualquier navegador en cualquier dispositivo.\n\n\t• Creación de sitios con un solo clic – sin necesidad de HTML o CSS\n\t• Diseño con respuesta de fácil uso en dispositivos móviles\n\t• Control flexible de acceso de usuarios\n\t• Desactive sitios de forma automática\n\t• Configure la resolución, tamaño y formato en la descarga\n\t• Configuración de marca de agua (requiere Media Engine)\n\t• Generación de informes de uso","CALL_ATT_NP_BUTTON_MAIN":"Obtener NetPublish","CALL_ATT_REPORT_TITLE":"Generación de informes para NetPublish","CALL_ATT_REPORT_SUBTITLE":"Información de uso relevante","CALL_ATT_REPORT_MAIN":"¿Desea conocer qué sitios están más activos, qué activos son utilizados y por parte de quién? Con la generación de informes de NetPublish, obtenga la información necesaria para tomar decisiones con información basada en el modo en que Portfolio se está utilizando en su organización.\n\nDesglose de uso por:\n\t• Nombre de sitio NetPublish\n\t• Nombre de usuario\n\t• Nombre de ID de activo\n\t• Fecha y hora","CALL_ATT_REPORT_BUTTON_MAIN":"Obtener NetPublish","CALL_ATT_SK_BUTTON_MAIN":"Probar gratuitamente","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/p5u9","CALL_ATT_SK_MAIN":"¿Busca una manera de acelerar la asignación de palabras clave a imágenes? Con Portfolio Smart Keywords podrá asignar automáticamente palabras clave “inteligentes” a sus imágenes con un solo clic. Desarrollado por Clarifai, una innovadora empresa de inteligencia artificial que destaca en la tecnología de reconocimiento visual, ofrece una lista de palabras clave sugeridas en cuestión de segundos.\n\n\t• Ofrece una lista de smart keywords en cuestión de segundos\n\t• Ahorra tiempo y recursos reduciendo la introducción manual de palabras clave\n\t• Crea una clasificación consistente en su organización\n\t• Facilita la búsqueda rápida de activos digitales","CALL_ATT_SK_SUBTITLE":"Automatice las palabras clave de sus imágenes","CALL_ATT_SK_TITLE":"Portfolio Smart Keywords","CALL_ATT_SSO_SUBTITLE":"Experiencia de usuario ininterrumpida en todas las plataformas","CALL_ATT_SSO_TITLE":"Single Sign-On","CALL_ATT_SSO_MAIN":"¿Es complicado para el personal de su organización mantener organizadas sus credenciales de registro? Por lo general, con las nuevas soluciones aparecen gastos extra de gestión de cuentas de usuario, tanto para usted como para los usuarios.\n\nPor suerte, Portfolio admite Single Sign-On con Active Directory. Al utilizar Single Sign-On, los usuarios pueden registrarse en Portfolio de forma automática desde su sitio de Intranet, lo que les proporciona una experiencia de usuario continua.\n\n\t• Admite el Directorio Activo de Servidor de Windows\n\t• Mejora la seguridad general\n\t• Simplifica la gestión de usuarios\n\t• Mejora la experiencia de usuario","CALL_ATT_SSO_BUTTON_MAIN":"Obtener Single Sign-On","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options?lang=es","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/es/portfolio/contact-me","canEmbedMetadata":"Incrustar metadatos","canImportMetadata":"Importar/Exportar datos","canManagePublicGallery":"Gestionar galerías públicas","canPublishNetPublishSites":"Puede publicar sitios NetPublish","canSmartKeyword":"Puede utilizar Smart Keywords","CANCEL":"Cancelar","CATALOG":"Catálogo","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"Hacer socio","CATALOG_BACKUP":"Copia de seguridad del catálogo seleccionado","CATALOG_CREATE":"Agregar catálogo nuevo","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"Los administradores de catálogos pueden agregar carpetas de sincronización automática desde el cliente de escritorio (Desktop Client).","CATALOG_CREATE_AUTOSYNC_FOLDER":"Crear una carpeta de sincronización automática","CATALOG_CREATE_CATALOG_TEMPLATE":"Plantilla de catálogo","CATALOG_TYPE_GENERAL":"General Use","CATALOG_TYPE_SIMPLE":"Simple","CATALOG_CREATE_DATABASES_LIST_LABEL":"Bases de datos","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"Ha surgido un error al crear la carpeta {folder}.","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"Las carpetas predeterminadas de sincronización automática y de vistas previas pueden configurarse en la configuración global.","CATALOG_CREATE_NAME":"Nombre","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"Las vistas previas pueden configurarse en los detalles del catálogo.","CATALOG_CREATE_PREVIEW_FOLDER":"Guarde las vistas previas para que sean más rápidas","CATALOG_CREATE_SHOW_DATABASES":"Mostrar bases de datos","CATALOG_CREATE_USE_VERSIONING":"Utilizar Adjudicación de versión de activo","CATALOG_DELETE":"Eliminar catálogo","CATALOG_DELETE_CONFIRM":"¿Desea eliminar el catálogo seleccionado?","CATALOG_DETAILS":"Detalles del catálogo","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"Para cambiar el nombre de este catálogo, tenemos que sacarlo de línea un momento, ¿Desea continuar?","CATALOG_DETAILS_COLLATION":"Intercalado","CATALOG_DETAILS_COLLATION_NA":"N/A","CATALOG_DETAILS_CREATION_DATE":"Fecha de creación","CATALOG_DETAILS_DATABASE_TAB":"General","CATALOG_DETAILS_LAST_MODIFIED":"Última modificación","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"Usuarios conectados","CATALOG_DETAILS_NUMBER_OF_RECORDS":"Registros","CATALOG_DETAILS_NUMBER_OF_USERS":"Socios","CATALOG_DETAILS_SIZE_ON_DISK":"Tamaño en disco","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"El usuario administrador se desconectará. ¿Continuar?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"Bloqueado para administración","CATALOG_DETAILS_UNLOCK":"Desbloquear","CATALOG_EXPLANATION_VAULT_1":"Los catálogos de Bóveda almacenan activos en un emplazamiento seguro.","CATALOG_EXPLANATION_VAULT_2":"Los catálogos de Bóveda admiten el bloqueo, adjudicación de versión, salida y registro.","CATALOG_EXPLANATION_WF_1":"Los catálogos de Carpeta de observación efectúan el rastreo de activos de su sistema de archivos.","CATALOG_EXPLANATION_WF_2":"Los catálogos de Carpeta de observación admiten AutoSync.","CATALOG_INGEST_DRAG_HINT_TEXT":"Para añadir campos al formulario de subida, arrástrelos desde la lista de campos.","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"Campos del formulario de subida","CATALOG_INGEST_FIELDS_LABEL":"Campos","CATALOG_INGEST_FORM_HEADER_LABEL":"Encabezado del formulario","CATALOG_INGEST_HEADER_HINT_TEXT":"El encabezado del formulario es opcional y aparece en la parte superior del formulario.","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"El número máximo de campos para añadir al formulario es {maxFields}.","CATALOG_INGEST_TAB_TITLE":"Gestor de Subida","CATALOG_INGEST_USE_INGEST_LABEL":"Usar el gestor de subida","CATALOG_INGEST_REQUIRED_LABEL":"Requerido","CATALOG_IS_CONNECTED":"Conectado","CATALOG_IS_DEFAULT":"Predeterminado","CATALOG_MANAGE_USERS":"Gestionar socios del catálogo","CATALOG_MANAGE_FIELDS":"Administrar Campos de Catálogos","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"Gestionar plantillas de catálogo…","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"Gestionar plantillas de catálogo personalizadas","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"Nombre de plantilla de catálogo","CATALOG_MEMBER":"Socio","CATALOG_NEW_CATALOG_DETAILS":"Detalles del nuevo catálogo","CATALOG_OFFLINE":"Fuera de línea","CATALOG_ONLINE":"En línea","CATALOG_OPTIONS_ALL_FILE_TYPES":"Catalogar todos los tipos de archivos","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"Crear palabras claves desde la ruta","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"Nombre de archivo","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"Carpeta principal","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"Nombre de servidor","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"Árbol de carpetas","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"Volumen","CATALOG_OPTIONS_EXCLUSION_LABEL":"Exclusiones de archivos y carpetas","CATALOG_OPTIONS_ONLY_FILE_TYPES":"En línea","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"¿Eliminar el(los) tipo(s) de archivo(s) seleccionado(s)?","endsWith":"Termina con","contains":"Contiene","startsWith":"Empieza con","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"¿Eliminar la(s) exclusión(es) seleccionada(s)?","CATALOG_OPTIONS_TAB_TITLE":"Opciones de categorización","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"La ubicación predeterminada es","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"Tamaño mínimo 300 píxeles, tamaño máximo 4.000 píxeles (mayor dimensión)","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"Generar clips para archivos de audio/vídeo","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"Crear vistas previas","CATALOG_PREVIEWS_FOLDER_LOCATION":"Guardar vistas previas y clips en esta carpeta","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"Esta ubicación debe ser accesible para el servidor.","CATALOG_PREVIEWS_MAX_PIXELS":"Tamaño máximo de imagen","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"Resolución máxima de vídeo","CATALOG_PREVIEWS_MINUTES":"minutos","CATALOG_PREVIEWS_PIXELS":"píxeles","CATALOG_PREVIEWS_SHORT":"Vistas previas","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"Limitar duración a","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"El proceso de generación de clips puede llevar tiempo.\nPara que tarde menos, seleccione una resolución menor y una duración más corta.","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"Cancelar socio","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"¿Eliminar este usuario del catálogo?\nLos elementos en Salida del usuario se revertirán y se podrá acceder a estos.","CATALOG_SAVE_TEMPLATE":"Guardar plantilla de catálogo...","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"La plantilla guardada incluye: todas las configuraciones de campos, mapeados de metadatos y opciones de catálogos.","CATALOG_SELECT_MESSAGE":"No hay catálogo seleccionado","CATALOG_SET_AS_DEFAULT":"Configurar catálogo predeterminado","CATALOG_SK_DEFAULT_SETTINGS":"Configuración por defecto","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"Nivel de fiabilidad","CATALOG_SK_DEFAULT_LABEL":"Recomendado: {recommended}","CATALOG_SK_ENGINES_LABEL":"Motores palabras Smart Keywords","CATALOG_SK_LANGUAGES_LABEL":"Idiomas del motor general","CATALOG_SK_NUM_KEYWORDS_LABEL":"Número de palabras clave","CATALOG_SK_SETTINGS_LABEL":"Configuración","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"Utilizar Smart Keywords en este catálogo","CATALOG_STATUS":"Estado de catálogo","CATALOG_STORAGE_TYPE_LABEL":"Tipo de almacenamiento","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"Carpetas de inspección","CATALOG_STORAGE_TYPE_VAULT":"Bóveda","CATALOG_TAKE_OFFLINE_SHORT":"Poner fuera de línea","CATALOG_TAKE_ONLINE_SHORT":"Poner en línea","CATALOG_TEMPLATE":"plantilla","CATALOG_TEMPLATE_NAME":"Nombre de plantilla","CATALOG_TEMPLATES_TITLE":"Plantillas de Catálogo","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"¿Eliminar la plantilla de catálogo seleccionada?","CATALOG_VIEW_DETAILS":"Ver/Editar detalles del catálogo","CERT_REQUEST_ALREADY_CREATED_WARNING":"Ya ha creado una solicitud de certificado. Si continúa, se eliminará la solicitud existente.","CERTIFICATE_FILE_FILTER":"Certificados (p7b, p7, cer, crt, pem, pfx, p12)","CITY_OR_LOCALITY":"Ciudad o localidad","CLEAR_BUTTON_LABEL":"Borrar","COMMUNICATION_AT_INITILIZATION_ERROR":"Se produjo un error de comunicación con el servidor. Esto suele causarlo la antigüedad de los datos en la caché del navegador, pero también podría indicar un problema con el servidor. Póngase en contacto con el administrador si desea más información.","CONFIGURE_DIRECTORY_SERVICE":"Configurar servicio de directorios","CONFIRM_DELETE_PDL":"¿Eliminar todos los valores predefinidos para este campo?","CONFIRM_DELETE_SERVICE":"¿Eliminar servicio de directorios?\nSe mantendrán los usuarios importados desde el servicio. Sus contraseñas recuperarán los valores anteriormente definidos en Portfolio, o se inhabilitarán si es que no se habían definido anteriormente.","CONFIRM_TRUNCATE_VALUES":"La longitud máxima supera uno o varios valores predeterminados o predefinidos para este campo. ¿Truncar valores?","CONNECTION_REFUSED_ERROR":"Se ha denegado la conexión al servicio de directorios. Compruebe su nombre de host y la configuración del puerto.","CONTAINS":"contiene","CONTINUE":"Continuar","CREATE":"Crear","CREATE_A_CERTIFICATE_REQUEST":"Crear una solicitud de firma de certificado","createContactSheet":"Crear PDF","CREATED_BY":"Creado por","CREATE_MAPPING":"Crear Correspondencia","CREATE_USER_EXCLUSION_MAPPING":"Usuario de Exclusión","CREATED_ON_DATE":"Fecha de creación","DATE_FORMAT":"DD/MM/YYYY","DATE_FORMAT_ERROR":"Error de configuración: Cadena de formato incorrecto.","DATE_INVALID_CHAR_ERROR":"La fecha contiene caracteres no válidos.","DATE_TIME_FORMAT":"DD/MM/YYYY L:NN A","DATE_TIME_SECONDS_FORMAT":"DD/MM/YYYY L:NN:SS A","DATE_WRONG_DAY_ERROR":"Introduzca un día válido para el mes.","DATE_WRONG_LENGTH_ERROR":"Escriba la fecha con el formato:","DATE_WRONG_MONTH_ERROR":"Introduzca un mes entre 1 y 12","DATE_WRONG_YEAR_ERROR":"Introduzca un año entre 0 y 9999","DEFAULT_ACCESS_LEVEL":"Roles predeterminados","DEFAULT_CATALOG":"Catálogo predeterminado","DEFAULT_CATALOG_NONE":"Ninguno","DEFAULT_PORT_NON_SSL":"Puerto predeterminado para no SSL:","DEFAULT_PORT_SSL":"Puerto predeterminado para SSL:","DELETE":"Eliminar","DELETE_SOURCE":"Eliminar Fuente","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"¿Eliminar todos los valores? Se eliminarán todos los valores incluyendo los valores jerarquizados.","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"Elimine el valor '{value}'?\n Contiene valores alojados que también se eliminarán.","DELETE_NESTED_VALUE_CONFIRMATION":"¿Eliminar los valores seleccionados? Contienen valores jerarquizados que también se eliminarán.","DELETE_WARNING_BOX_MSG":"Advertencia! La eliminación no puede deshacerse!","DELETE_WARNING_CATALOG_VAULT":"Todos los ficheros en el catálogo serán destruidos.","DIAGNOSTIC_DATA_TITLE":"Enviar Informe de diagnóstico a Portfolio DAM","DIAGNOSTIC_DATA_ACCOUNT_NAME":"Nombre de Cuenta o Empresa (obligatorio)","DIAGNOSTIC_DATA_CONTACT_NAME":"Nombre de la persona de contacto","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"Número de identificador de Soporte técnico","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"Enviar Informe","DIAGNOSTIC_STATUS_ERROR":"Se ha producido un problema al cargar el informe de diagnóstico el {date}","DIAGNOSTIC_STATUS_SENDING":"Enviando...","DIAGNOSTIC_STATUS_SUCCESS":"Se ha enviado informe de diagnóstico de forma satisfactoria a Portfolio DAM el {date}","DIRECTORY_SERVICE_CONNECT_ERROR":"Imposible conectar con el servicio de directorios. Compruebe el nombre de host y la configuración del puerto.","DIRECTORY_SERVICES":"Servicios de directorio","DIRECTORY_USERS_CANNOT_BE_DELETED":"No es posible eliminar usuarios de servicio de directorios.","DISTRIBUTION_GROUPS":"Grupos de distribución","DOWNLOAD_CERT_PROMPT":"¿Descargar archivo de solicitud de certificado?","DOWNLOAD_COMPLETE_STRING":"Descarga completa.","downloadPreviews":"Descargar vistas previas","EMAIL_ADDRESS":"Dirección de correo electrónico","EMAIL_CONFIG_AUTH_PASSWORD":"Contraseña","EMAIL_CONFIG_AUTH_USERNAME":"Nombre de usuario","EMAIL_CONFIG_ENABLED":"Habilitar notificaciones de correo electrónico","EMAIL_CONFIG_FROM_ADDRESS":"Correo electrónico desde dirección","EMAIL_CONFIG_INVALID_GENERIC":"Configuración de servidor de correo electrónico no válida","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"Servidor de correo electrónico no encontrado","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"Fallo de autenticación del servidor de correo electrónico","EMAIL_CONFIG_MESSAGE":"Cada usuario que desee recibir notificaciones debe tener una dirección de correo electrónico asignada en el panel de usuarios.","EMAIL_CONFIG_SERVER_ADDRESS":"Dirección del servidor SMTP","EMAIL_CONFIG_SERVER_PORT":"Puerto del servidor SMTP","EMAIL_CONFIG_SUCCESS_MESSAGE":"Servidor SMTP validado","EMAIL_CONFIG_USE_SSL_TLS":"Utilizar SSL/TLS","EMAIL_CONFIG_USE_SMTP_AUTH":"Utilizar autenticación SMTP","EMAIL_CONFIG_VALIDATE":"Prueba de conexión","EMAIL_CONFIG_VALIDATED":"Servidor de correo electrónico validado","english":"Inglés","ENTIRE_TREE_UNDER_SEARCH_BASE":"Árbol completo bajo base de búsqueda","EQUALS":"es igual a","EXPORT_MENU_STRING":"Exportar valores","FADEL_HOWTO":"Conexión a su cuenta de FADEL:","FALSE_LABEL":"Falso","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"Compruebe que se está ejecutando el servidor de administración en el equipo local en el puerto indicado en la página de puertos. Si no es así, reinicie el servidor y vuelva a cargar esta aplicación.","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"No se puede realizar esta operación mientras la copia de seguridad o restauración está en progreso.","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"La operación no ha funcionado porque el catálogo está en modo de administración.","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"Ya existe un catálogo con ese nombre.","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"Ya existe un usuario con este nombre de cuenta.","FAULT_MSG_DB_IN_USE":"No ha sido posible realizar la operación porque el catálogo está en uso por parte de un administrador.","FAULT_MSG_DELETE_ADMIN":"No puede borrar la cuenta del administrador.","FAULT_MSG_DELETE_SELF":"No puede eliminar su cuenta de usuario.","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"Se ha producido un error inesperado al eliminar la plantilla de catálogo","FAULT_MSG_DUPE_NAME":"Ya existe un objeto con ese nombre. Utilice un nombre distinto.","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"Ya existe un motor de medios con esa dirección y puerto.","FAULT_MSG_ENTITY_VERSION_MISMATCH":" No ha funcionado esa operación porque los datos del cliente estaban desfasados.","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"Compruebe que se está ejecutando el servidor en el equipo local en el puerto indicado en la página de puertos. Si no es así, reinicie el servidor y vuelva a cargar la aplicación.","FAULT_MSG_INVALID_SESSION_ID":"Ha caducado su sesión. Necesita volver a iniciar sesión en el servidor.","FAULT_MSG_IS_NOT_LICENSED":"El servidor no tiene licencia para esa operación.","FAULT_MSG_LEGACY_21000":"Ha fallado la operación debido a un error interno desconocido.","FAULT_MSG_LOGGING_ERR_UPDATE":"Ha surgido un error al actualizar la configuración de registro","FAULT_MSG_LOG_DIR_NOT_VALID":"El directorio de registro especificado no existe, no se puede escribir en él, o la ruta no dirige a un directorio.","FAULT_MSG_NO_DIRECTORY":"No existe la ubicación especificada o no es un directorio.","FAULT_MSG_NULL_DESCRIPTION":"Se ha producido un error inesperado, pero no hay ninguna descripción al respecto.","FAULT_MSG_NULL_FAULTEVENT":"Se ha producido un error inesperado, pero no hay detalles al respecto.","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"No ha funcionado esa operación porque usted no tiene suficientes privilegios.","FAULT_MSG_OPERATION_IS_INVALID":"Esa operación no era válida.","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"Se ha producido un error inesperado al dar nuevo nombre a la plantilla de catálogo","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"Se ha producido un error inesperado al guardar la plantilla de catálogo","FAULT_MSG_SERVER_NOT_RUNNING":"El servidor no se está ejecutando.","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"Ha fallado la operación porque el servidor no tiene una licencia del módulo para empresas.","FAULT_MSG_REMOVE_METADATA_DEF":"Error en la eliminación de la definición de metadatos. Puede estar en uso por otros catálogos.","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"El servidor ha devuelto un error con este mensaje: ","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"El servidor ha devuelto un error sin mensaje. ","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"El servidor ha devuelto un error de tipo desconocido y este mensaje:","FAULT_MSG_UNKNOWN_SMTP_SERVER":"No se pudo conectar al servidor de correo electrónico especificado.","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"No ha funcionado esa operación porque uno de los servicios no tenía el estado esperado.","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"El nombre de usuario o la contraseña que se han indicado no son válidos para la base de datos.","FAULT_MSG_BAD_DB_PORT":"El puerto de base de datos que se ha especificado no es válido.","FAULT_MSG_BAD_DB_HOST":"El nombre de host o el puerto especificado para la base de datos no son válidos.","FIELD_ACTION_ADD":"Agregar nuevo campo personalizado","FIELD_ACTION_DELETE":"Eliminar campo seleccionado","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"Espacios de nombre XMP","FIELD_ACTION_MANAGE_METADATA":"Administrar metadatos","FIELD_CATEGORY_CUSTOM":"Campos personalizados","FIELD_CATEGORY_SYSTEM":"Campos del sistema","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"Película","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"Categoría de campo","FIELD_DISABLE_CONFIRM_MSG":"¿Desea deshabilitar el campo seleccionado?","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"Habilitar todos","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"Añadir mapa de extracción","FIELD_FORM_LABEL_DEFAULT_VALUE":"Valor predeterminado","FIELD_FORM_LABEL_DISABLED":"(Deshabilitado)","FIELD_FORM_LABEL_EMBED":"Integrar en Metadatos","FIELD_FORM_LABEL_EXTRACT":"Extraer de Metadatos","FIELD_FORM_LABEL_FIELD_NAME":"Nombre del campo","FIELD_FORM_LABEL_FIELD_TYPE":"Tipo de campo","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"Permitir múltiples valores","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"Tiene valores predefinidos","FIELD_FORM_LABEL_HELP_TEXT":"Texto de ayuda","FIELD_FORM_LABEL_MAX":"Máx: {max}","FIELD_FORM_LABEL_MAX_LENGTH":"Longitud máxima","FIELD_FORM_LABEL_METADATA_TAG":"Nombre de metadatos","FIELD_FORM_LABEL_METADATA_TYPE":"Tipo de metadatos","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"Permitir sólo valores predefinidos","FIELD_FORM_LABEL_PRECISION":"Precisión","FIELD_FORM_LABEL_PREDEFINED_VALUES":"Valores predefinidos","FIELD_FORM_LABEL_SHOW_TIME":"Mostrar hora","FIELD_FORM_LABEL_USE_METADATA":"Extraer y asignar metadatos","FIELD_FORM_WARNING_DUPE_EMBEDS":"Advertencia: Más de un campo se integra en '{metadata}'","FIELD_METADATA_DATA_TYPE_LABEL":"Tipo de datos","FIELD_METADATA_DEFINITION_IS_CUSTOM":"Está personalizado","FIELD_METADATA_DEFINITIONS_TITLE":"Definiciones de metadatos","FIELD_METADATA_DELETE_CONFIRM_MSG":"Confirmar: ¿Eliminar la definición de metadatos?","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"Tipo con múltiples valores","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"Sin múltiples valores","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"Ordenados","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"Sin ordenar","FIELD_METADATA_NAME_LABEL":"Nombre","FIELD_METADATA_NAMESPACE_LABEL":"Espacio de nombres","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"Agregar un Espacio de nombres XMP personalizado...","FIELD_METADATA_TAG_LABEL":"Etiqueta","FIELD_METADATA_TYPE_LABEL":"Tipo","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"Se han seleccionado varios campos","FIELD_NAMESPACE_ABBREVIATION":"Abreviatura","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"¿Eliminar el Espacio de nombres XMP personalizado?\nPueden existir Definiciones de campo que utilicen el espacio de nombres.","FIELD_NAMESPACE_URI":"URI de Espacio de nombres","FIELD_NEW_FIELD_NAME":"Nuevo campo","FIELD_NEW_METADATA_TITLE":"Nueva definición de metadatos","FIELD_NEW_NAMESPACE_TITLE":"Nuevo Espacio de nombres XMP personalizado","FIELD_NO_FIELD_SELECTED_MESSAGE":"No se ha seleccionado campo","FIELD_PAGE_TITLE":"Administrar campos para catálogo '{catalogName}'","FIELD_REVERT_CONFIRM_MSG":"Confirmar: ¿Revertir el campo?","FIELD_TYPE_BLOB":"Blob","FIELD_TYPE_BOOLEAN":"Booleano","FIELD_TYPE_DATETIME":"Fecha/Hora","FIELD_TYPE_DECIMAL":"Decimal","FIELD_TYPE_LANG_ALT":"Idioma Alt","FIELD_TYPE_NUMBER":"Número","FIELD_TYPE_PICTURE":"Imagen","FIELD_TYPE_STRING":"Cadena","FIELD_TYPE_STRUCTURE":"Estructura","FIELD_TYPE_TEXTBLOCK":"Bloque de texto","FIELD_TYPE_UNKNOWN":"Desconocido","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"Se ha producido un error al subir el archivo al servidor.","FILE_WRONG_TYPE_ERROR_MSG":"Este archivo no es un formato compatible. Por favor, seleccione un archivo jpeg, gif o png.","FOLDER_PATH_AUTOSYNC_FILES_STRING":"Archivos","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"Ya existe un archivo con ese nombre.","FOLDER_PATH_DOES_NOT_EXIST":"No existe la ruta.","FOLDER_PATH_ERROR":"Error","FOLDER_PATH_NOT_VERIFIED":"No se ha verificado la ruta de carpetas.","FOLDER_PATH_PATH":"Ruta","FOLDER_PATH_OPERATION_INVALID":"Operación no válida","FOLDER_PATH_SUCCESS":"Éxito","FOLDER_PATH_TYPE_AUTOSYNC":"sincronización automática","FOLDER_PATH_TYPE_PREVIEW":"vista previa","FOLDER_PATH_UNKNOWN_FAULT":"Fallo desconocido","french":"Francés","FULL_NAME":"Nombre y apellidos","FULLY_QUALIFIED_DOMAIN_NAME":"Nombre de dominio completo","german":"Alemán","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"Crear carpetas de sincronización automática para los catálogos nuevos en esta carpeta","GLOBAL_SETTINGS_BACKGROUND_COLOR":"Color de fondo","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"Color de fondo de la pantalla de inicio de sesión.","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"Valores predeterminados de catálogo","GLOBAL_SETTINGS_CHOOSE_FILE":"Seleccione archivo","GLOBAL_SETTINGS_CUSTOM_IMAGE":"Imagen personalizada","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"El tamaño máximo debería ser 2400 x 1350 píxeles.","GLOBAL_SETTINGS_CUSTOM_TITLE":"Título personalizado","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"El título que aparece en la pestaña del navegador o marcador.","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"Pantalla de inicio personalizada","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"Roles predeterminados","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"Pantalla predeterminada de login","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"Notificaciones de correo electrónico","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"La ubicación de las carpetas de sincronización automática y de vistas previas debe estar accesible para el servidor.","GLOBAL_SETTINGS_IMAGE_URL":"Enlace","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"Al hacer clic en la imagen la URL se abrirá en otra ventana del navegador.","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"Para realizar cambios, introduzca el servidor o compruebe si ha caducado la licencia del servidor.","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"Guardar vistas previas de nuevos catálogos en esta carpeta","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"Ubicaciones de datos del servidor","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"Arreglo para requisitos particulares de la conexión de la Portfolio","GLOBAL_SETTINGS_SSO_CREDENTIALS":"Credenciales de registro únicas","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"Introduzca la cuenta de usuario asociada al servicio Portfolio Server para autenticación Kerberos.","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"Carpeta de trabajo temporal","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"La carpeta de trabajo se modificará la próxima vez que se reinicie el servidor. La nueva carpeta se ubicará en: ","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"Es necesario reiniciar el servidor para que este cambio surta efecto.","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Configuración de Bóveda de Portfolio","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Carpeta de bóveda de Portfolio:","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Ubicación de bóveda de Portfolio por defecto:","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"Para mover la Bóveda de Portfolio, desactive el servidor en primer lugar.","HELP_URL":"https://helpdocs.portfoliodam.com/es/portfolio/administration/{version}/index.htm","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/es/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"Nombre de host","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(predeterminado)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"Conexión al servicio de directorio satisfactoria. Configuración guardada.","IMAGE_FILE_FILTER":"Imágenes (jpg, gif, png)","IMPORT_LDAP":"Importar usuarios desde servidor LDAP/AD","IMPORT_LDAP_SPECIFY_SERVER":"Specificare il server LDAP/AD","IMPORT_MENU_STRING":"Importar valores","IMPORT_SOURCE":"Importar fuente","INVALID_DN_SYNTAX_ERROR":"Imposible conectar con el servicio de directorios por un error de sintaxis de ND no válido. Compruebe el nombre de usuario.","japanese":"Japonés","LAST_CERTIFICATE_REQUEST_LABEL":"Última solicitud de certificado","LAST_MODIFIED_BY":"Última modificación por","LAST_MODIFIED_DATE":"Fecha de última modificación","LDAP_ADDRESS":"Dirección del servidor LDAP/AD","LDAP_BIND_USERNAME":"Nombre de usuario de conexión LDAP","LDAP_SYNC_NOTIFICATION":"El servidor ha recibido la solicitud de sincronización.","LIC_ADD_MESSAGE":"Copie y pegue licencias o introduzca individualmente una por cada fila.","LIC_ADD_SN":"Agregar licencia nueva","LIC_ADD_SN_SHORT":"Agregar Licencias","LIC_ASSET_CAP_DISPLAY":"Activos","LIC_DAYS_REMAINING":"({days} días restantes)","LIC_DEMO_PERIOD":"Periodo de demostración","LIC_ERROR_MSG":"Número de serie no válido, vuelva a intentarlo. Si el problema persiste, confirme el registro de servidor o póngase en contacto con el administrador.","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"No se puede agregar el número de serie a Portfolio Studio.","LITE_CANNOT_CREATE_FDB_CATALOG":"Su licencia de Portfolio no permite más de un catálogo. Considere actualizar su licencia de Portfolio para poder ejecutar esta acción.","LITE_CANNOT_SERVE_FDB_CATALOG":"Su licencia de Portfolio Server no permite poner más catálogos en línea.","LITE_THIS_FEATURE_NOT_SUPPORTED":"Su licencia de Portfolio Server no permite realizar esta acción.","LOGGING_CONFIGURATION":"Configuración de registro","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Para cambiar la ubicación del registro, desactive en primer lugar el servidor de Portfolio.","LOGGING_DEFAULT_LOCATION_MSG":"La ubicación de registro predeterminada es","LOGGING_DIR_MUST_EXIST":"NOTA: Para poder cambiar el directorio de registro, el nuevo directorio que se especifique debe existir ya y debe permitir que escriba en él el usuario bajo el cual se está ejecutando Portfolio Server.","LOGGING_LOG_DIR":"Directorio de registro:","LOGGING_LOG_LEVEL":"Nivel de registro","LOGGING_NUM_LOGS_TO_RETAIN":"Número de registros para conservar","LOGIN":"Iniciar sesión","MAPPING_HEADER":"Asignación de usuario/grupo a cartera","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"Se han modificado las correspondencias, ¿desea guardarlas?","MEDIA_ENGINES_ACTION_ADD":"Agregar nuevo motor de medios","MEDIA_ENGINES_ACTION_DELETE":"Eliminar motor de medios","MEDIA_ENGINES_ACTION_EDIT":"Ver/Editar detalles de motor de medios","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"No es posible agregar otro motor de medios activo porque el servidor ya está utilizando el número máximo de motores de medios activos que le permite su licencia de Portfolio Media Engine.","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"No puede agregar un motor de medios porque el servidor no dispone de licencias de Portfolio Media Engine.","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"No puede quitar el motor de medios que viene integrado.","MEDIA_ENGINES_COLUMN_ACTIVE":"Activo","MEDIA_ENGINES_COLUMN_ADDRESS":"Dirección","MEDIA_ENGINES_COLUMN_PORT":"Puerto","MEDIA_ENGINES_CONFIRM_DELETE":"¿Desea eliminar el motor de medios seleccionado?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Detalles del motor de medios","MEDIA_ENGINES_LICENSES_LABEL":"Plazas en el motor de medios disponibles para activación","MEDIA_ENGINES_NEW_DETAILS_HEADER":"Detalles del nuevo motor de medios","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"No hay motores de medios activos. Debería activar un motor de medios antes de que los clientes necesiten utilizar los servicios de medios de Portfolio.","MOBILE":"Móvil","MOBILE_ENABLED":"Habilitar la carga móvil","MOBILE_FOLDER_VERBIAGE":"Guardar las cargas móviles en esta carpeta:","MOBILE_CREATE_CATALOG_VERBIAGE":"Crear un catálogo nuevo 'Cargas móviles' para ver automáticamente esta carpeta (recomendado)","MOBILE_CATALOG_NAME":"Cargas móviles","modifyAssetContents":"Controle hacia fuera los activos","MODIFY_LDAP":"Modificar consulta LDAP","NAME":"Nombre","NAME_TOO_LONG_ERROR":"El nombre debe tener menos de 256 caracteres","NAV_ABOUT":"Acerca de","NAV_ACCESS_LEVELS":"Roles","NAV_AUTOSYNC":"Sincronización automática","NAV_BACKUPS":"Copia de seguridad/Restablecer","NAV_CATALOGS":"Catálogos","NAV_GLOBAL_SETTINGS":"Configuración global","NAV_HELP":"Ayuda","NAV_LICENSES":"Licencias","NAV_LOGOUT":"Cerrar sesión","NAV_MEDIA_ENGINES":"Motores de medios","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"Puertos","NAV_REPORTING":"Notificaciones","NAV_SETTINGS":"Configuración","NAV_STATUS":"Estado","NAV_USERS":"Usuarios","NO_CATALOGS":"Ninguno","NO_FILE_SELECTED":"Ningun archivo seleccionado","VaultFolderNotFound":"No se ha encontrado la carpeta Bóveda de Portfolio en {path}.","NO_VAULT_FOLDER":"No se ha encontrado la carpeta Bóveda de Portfolio en {path}.  Verifique la ubicación de la carpeta en su sistema de archivos y en la página Configuración global -> Datos del servidor de esta aplicación.","NOTES":"Notas","NUMBER_DECIMAL_POINT_COUNT_ERROR":"El separador de decimales sólo puede aparecer una vez.","NUMBER_EXCEEDS_MAX_ERROR":"El número introducido es demasiado grande.","NUMBER_INTEGER_ERROR":"El número debe ser entero.","NUMBER_INVALID_CHAR_ERROR":"La entrada contiene caracteres no válidos.","NUMBER_INVALID_FORMAT_CHARS_ERROR":"Uno de los parámetros de formato no es válido.","NUMBER_LOWER_THAN_MIN_ERROR":"La cantidad introducida es demasiado pequeña.","NUMBER_NEGATIVE_ERROR":"La cantidad no puede ser negativa.","NUMBER_PRECISION_ERROR":"La cantidad introducida tiene demasiados dígitos tras el separador de decimales.","NUMBER_SEPARATION_ERROR":"El separador de miles debe ir seguido de tres dígitos.","OK":"Aceptar","ON_DATE":"en","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"Grupos","ORGANIZATION_NAME":"Nombre de la organización","ORGANIZATIONAL_UNIT":"Unidad organizativa","PASSWORD":"Contraseña","PASSWORD_CONFIRM":"Confirmar contraseña","PASSWORD_TOO_LONG_ERROR":"La contraseña debe tener menos de 256 caracteres","PORT":"Puerto","PORT_VALUE_TOO_HIGH_ERROR":"El valor del puerto debe ser inferior a 65536.","PortfolioAssetCap":"Portfolio Asset Cap","PortfolioAPI":"Portfolio API","PortfolioDemo":"Demo","PortfolioDirServices":"Portfolio Directory Services","PortfolioServer":"Portfolio Server","PortfolioStudio":"Portfolio Studio Edition","PortfolioProfessional":"Portfolio Professional Edition","PortfolioEnterprise":"Portfolio Enterprise Edition","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keywords","PortfolioUserConnection":"Portfolio User Connection","PortfolioSingleSignOn":"Single Sign On (SSO)","PORT_CURRENT_VALUE":"Valor actual","PORT_ERROR_MSG_BAD_PORT_VALUE":"El valor del puerto nuevo tiene que ser un número entre 1 y 65535.","PORT_ERROR_MSG_CONFLICT":"Imposible actualizar los valores de puertos porque uno o varios de los nuevos valores de puerto ya están en uso en el servidor.","PORT_FIND_PORT":"Buscar puerto","PORT_NAME":"Nombre","PORT_NEW_VALUE":"Nuevo valor","PORT_RESTART_NOTICE":"Nota: las actualizaciones de puertos no serán efectivas hasta que se reinicie el servidor.","PORT_RESTART_SERVER":"Reiniciar servidor","PORT_UPDATE_PORTS":"Actualizar puertos","PORT_WARNING_ADMIN_RESTART":"Ha cambiado el puerto de administración. El navegador se redirigirá a la nueva ubicación dentro de {numSecs} segundos.","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"¿Está seguro?","PROMPT_COULD_NOT_CREATE_FOLDER":"No ha sido posible crear la carpeta. Introduzca una ruta distinta.","PROMPT_COULD_NOT_CREATE_FOLDERS":"Introduzca otra ruta de carpetas, ya que no ha sido posible crear las trayectorias siguientes:","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"No ha sido posible crear esa carpeta porque ya existe un archivo con ese nombre. Introduzca una ruta distinta.","PROMPT_CREATE_THAT_FOLDER":"Esa carpeta no existe. ¿Desea crearla?","PROMPT_CREATE_THESE_FOLDERS":"Estas carpetas no existen. ¿Desea crearlas?","PROMPT_DELETE_LICENSE_CONFIRM":"¿Desea eliminar la licencia seleccionada?","QUERY":"Consulta","REMOVE":"Quitar","REMOVE_DIRECTORY_SERVICE":"Eliminar servicio de directorios","REPLACE_USER_MAPPING_CONFIRMATION":"Ya existe una correspondencia de usuario regular para este usuario. ¿Desea reemplazarla con una correspondencia de usuario de exclusión?","REPLACE_USER_EXCLUSION_CONFIRMATION":"Ya existe una correspondencia de usuario de exclusión para este usuario. ¿Desea reemplazarla con una correspondencia de usuario regular?","REQUIRED_FIELD_ERROR":"Este campo es imprescindible","REVERT":"Revertir","REVERT_CHANGES":"Invertir Cambios","ROLE_FOR_IMPORT":"Rol para importar","ROLES_PERMISSION_ENABLED_HEADER":"Activado","ROLES_PERMISSION_NAME_HEADER":"Operación","SAVE":"Guardar","SAVE_MAPPING":"Guardar Correspondencia","saveOutputSetting":"Gestionar preconfiguraciones convertidas y haga el PDF","SEARCH":"Buscar","SEARCH_BASE":"Buscar en Base","SEARCH_RESULTS":"Resultados de la búsqueda","SECURITY_GROUPS":"Grupos de seguridad","SELECT":"Seleccionar","SEND_DIAGNOSTIC_DATA":"Enviar Informe de diagnóstico a Portfolio DAM","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"Ubicación de trabajo predeterminada: ","SERVER_RESTART_REQUIRED":"Es necesario reiniciar el servidor para que surtan efecto los cambios.","SERVER_STATE_ERROR":"Error: Encontrará detalles en el registro de administración","SERVER_STATE_STARTED":"Ejecutando","SERVER_STATE_STARTING":"Iniciando","SERVER_STATE_STOPPED":"Detenido","SERVER_STATE_STOPPING":"Deteniendo","SERVER_STATE_UNKNOWN":"Desconocido","SERVICE_BROWSER":"Examinador de servicios","SK_ENGINE_APPAREL":"Ropa","SK_ENGINE_CELEBRITIES":"Celebridades","SK_ENGINE_FOOD":"Alimentación","SK_ENGINE_GENERAL":"General","SK_ENGINE_LOGO":"Logotipo","SK_ENGINE_MODERATION":"Moderación","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"Viajes","SK_ENGINE_WEDDINGS":"Bodas","SSL_HANDSHAKE_ERROR":"Fallo en el saludo SSL; verifique que la configuración de puertos y SSL es la correcta.","STARTS_WITH":"comienza con","STATE_OR_PROVINCE":"Estado o provincia","STATUS":"Estado","STATUS_ADMIN_LOG":"Registro de administración","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"Con licencia","STATUS_API_STATE_UNLICENSED":"Sin licencia","STATUS_CLEAR_ADMIN_LOG":"Borrar registro de administración","STATUS_CONNECTED_USERS":"Usuarios conectados","STATUS_MAX_ALLOWED_CONNECTIONS":"Máximo de conexiones","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Motor de medios","STATUS_MEDIA_ENGINES_ACTIVE":"Activo","STATUS_MEDIA_ENGINES_LABEL":"Motores de medios","STATUS_RESTART_SERVER":"Reiniciar Portfolio","STATUS_SEAT_USAGE":"Uso de asientos","STATUS_SERVER_STATE":"Estado de Portfolio","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Iniciar Portfolio","STATUS_STOP_SERVER":"Detener Portfolio","STATUS_PROBLEMS_DETECTED":"Problemas detectados:","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"El espacio restante en el disco de inicio es inferior a {minSpace} GB.","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"La carpeta de trabajo no existe o es imposible acceder a ella.","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"El servidor Portfolio no puede escribir en la carpeta de trabajo.","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"El servidor Portfolio no puede leer desde la carpeta de trabajo.","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"El servidor Portfolio no puede crear enlaces simbólicos en la carpeta de trabajo.","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"El espacio restante en el disco de carpetas de trabajo es inferior a {minSpace} GB.","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"No es posible obtener el estado de la carpeta de trabajo.","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"El estado del índice de búsqueda elástica {index} es rojo.","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"El índice de búsqueda elástica {index} tiene fragmentos no inicializados.","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"No están activos todos los fragmentos para el índice de búsqueda elástica {index}.","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"No es posible recuperar el estado de la búsqueda elástica.","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"No es posible recuperar los errores desde el servidor Portfolio.","STATUS_MSG_STARTUP_FAILED":"Se ha producido un error al iniciar","STATUS_MSG_CANT_GET_SERVER_HEALTH":"No es posible actualizar el estado del servidor.","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"El componente de servidor de agente nativo no se encuentra en ejecución.","SUBJECT_ALTERNATIVE_NAMES":"Nombres de asunto alternativos","SUBMIT":"Enviar","swedish":"Sueco","SYNC_DAILY":"Sincronizar a diario","SYNCHRONIZE_NOW":"Sincronizar ahora","TARGET_CATALOG":"Catálogo de destino","THIS_LOCALE":"es","TRUE_LABEL":"Verdadero","TOKEN":"Identificador","TOTAL_ASSETS":"Total de activos","TWO_LETTER_COUNTRY_CODE":"Código de país de dos letras","TYPE":"Tipo","UNABLE_CONNECT_LDAP":"Imposible conectar al servidor LDAP/AD.","UNABLE_CONNECT_SERVER":"Imposible conectar al servidor.","UNKNOWN_HOST_ERROR":"Imposible conectarse con el servicio de directorios por una excepción de host desconocido. Compruebe el nombre de host.","UNKNOWN_LDAP_USER_ERROR":"No se encontró ningún usuario en el Servicio de Identidad con el nombre de cuenta '{accountName}'.","useCustomPresets":"Utilizar ajustes de conversión predefinidos","USE_SSL":"Usar SSL","USER_ACCOUNT":"Cuenta","USER_CREATE":"Agregar usuario nuevo","USER_DELETE":"Eliminar usuarios","USER_DELETE_CONFIRM":"¿Eliminar usuarios seleccionados?","USER_DELETE__DELETE_PRIVATE":"Eliminarse permanentemente","USER_DELETE__GALLERY_PROMPT":"La opción Hacer público convierte en públicas todas las galerías privadas y de sólo lectura pertenecientes a este usuario. \"Eliminar todas las galerías privadas\" borra permanentemente todas las galerías privadas y convierte en públicas las galerías de sólo lectura.","USER_DELETE__GALLERY_PROMPT_1":"Los elementos en Salida de los usuarios se revertirán y se podrá acceder a los mismos.","USER_DELETE__GALLERY_PROMPT_2":"Se harán Públicas las Galerías de Sólo lectura de los usuarios.","USER_DELETE__GALLERY_PROMPT_3":"Las Galerías privadas de los usuarios deben:","USER_DELETE__MAKE_PUBLIC":"Hacerse Públicas","USER_DETAILS":"Detalles del usuario","USER_IMPORT":"Importar usuarios","USER_IMPORT_ACCOUNT":"Nombre de cuenta","USER_IMPORT_ACCOUNT_ATTR":"Atributo de cuenta","USER_IMPORT_EMAIL_ATTR":"Atributo de correo electrónico","USER_IMPORT_IMPORT":"Importar","USER_IMPORT_IMPORT_SELECTED_USERS":"Importar usuarios seleccionados","USER_IMPORT_MODIFY_SEARCH":"Modificar búsqueda","USER_IMPORT_NAME_ATTR":"Atributo de nombre de cuenta","USER_IMPORT_NOTES_ATTR":"Atributo de notas","USER_IMPORT_PASSWORD":"Contraseña de la cuenta","USER_IMPORT_PASSWORD_ATTR":"Atributo de contraseña","USER_IMPORT_SEARCH":"Buscar","USER_IMPORT_SEARCH_BASE":"Base de búsqueda","USER_IMPORT_SEARCH_FILTER":"Filtro de búsqueda","USER_IMPORT_SERVER_ADDRESS":"Dirección de servidor","USER_IMPORT_SPECIFY_LDAP_SERVER":"Especificar servidor LDAP","USER_LEVEL_ADMINISTRATOR":"Administrador del catálogo","USER_LEVEL_EDITOR":"Editor","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"Publicador","USER_LEVEL_READER":"Lector","USER_MANAGE_CATALOGS":"Gestionar catálogos de usuarios seleccionados","USER_MULT_USERS_SELECTED":"Varios usuarios seleccionados","USER_NAME":"Nombre de usuario","USER_NEW_USER_DETAILS":"Detalles de nuevo usuario","USER_NEW_USER_INFO_MSG":"Para agregar un usuario a catálogos concretos, utilice Catálogos > Usuarios.","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"Agregar  usuarios a todos los catálogos como:","USER_NO_USERS_SELECTED":"No hay usuarios seleccionados","USER_ONLINE":"En línea","USER_PASSWORD_TOO_SHORT":"La contraseña tiene que incluir como mínimo un carácter.","USER_PASSWORDS_DO_NOT_MATCH":"El campo de confirmación de contraseña tiene que concordar con el campo de contraseña.","USER_ROLE":"Nivel de acceso","USER_VIEW_DETAILS":"Ver/Editar detalles de usuario","USERS":"Usuarios","VALIDATION_FIELD_LENGTH_EXCEEDED":"El campo no puede superar 255 caracteres.","VALIDATION_MUST_BE_NONEMPTY":"Este campo es imprescindible.","VIEW_EDIT_MAPPINGS":"Ver / Editar correspondencias","General.OK":"Aceptar","General.Cancel":"Cancelar","PORT_TITLE":"Puertos","PORT_DEFAULT":"Predeterminado:","esp.port.admin-web-app":"Portfolio Administrador Puerto HTTP","esp.port.admin-web-app-ssl":"Portfolio Administrador Puerto SSL","esp.port.http":"Portfolio Servidor Puerto HTTP","esp.port.ssl":"Portfolio Servidor Puerto SSL","General.Save":"Guardar","CATALOG_DETAILS_FILETYPES_TAB":"Tipos de archivo","addAsset":"Añadir activos","canManageFieldLists":"Gestionar listas de campos públicos","canModifyFolderStructure":"Modificar estructuras de carpeta","canMoveAssets":"Mover activos","deleteAssetContents":"Eliminar activos originales","deleteAssetFromCatalog":"Eliminar activo del catálogo","modifyAssetProperties":"Actualizar campos del activo","synchronizeAutoSyncFolder":"Sincronizar carpetas de sincronización automática","ASSETS":"Activos","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"Crear catálogo","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"La memoria del sistema es {value} GB inferior al requisito mínimo de {minGB} GB.","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"La memoria del sistema calculada por Portfolio es {value}GB. Podría no ser exacta.","AUTH.couldNotConnect":"No fue posible conectar con el servidor. Compruebe la dirección, por favor.","ERROR.serverUnavailable":"El servidor del Portfolio no está disponible.","ERROR.sessionExpired":"La sesión ha caducado.","fileNotFound":"No se encontró el archivo dentro del disco.","ERROR.invalidSearchFailed":"La búsqueda ha fallado porque hubo un problema con la consulta.","AUTH.loginFailed":"Clave de usuario y contraseña incorrectos.","FAULT_CODE.InsufficientPrivileges":"Tiene privilegios insuficientes para realizar esta operación.","unexpectedError":"Ha surgido un error inesperado.","ROLES_CREATE_ROLE_TITLE":"Crear rol","ROLES_DELETE_CONFIRM":"¿Desea eliminar el nivel de acceso seleccionado?\nLos usuarios con este Rol serán degradados al nivel de Lector.","NOTIFICATION_SUCCESS_UPDATE":"Actualización con éxito","DATA_COLLECTION_TITLE":"Análisis","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"Acepto compartir datos de uso de aplicaciones.","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"Ayúdenos a ofrecer las mejores soluciones compartiendo el uso de aplicaciones con nosotros.\n\nAl aceptar, nos ayudará a recopilar información importante que nos guiará hacia futuras mejoras en la calidad y las funciones. La información recopilada nos ayudará a comprender cuáles son las soluciones que necesita.\n\nPuede siempre cambiar de opinión en cualquier momento y dejar de compartir la información.\n\nPara más información acerca de cómo utilizaremos sus datos y retirarse en el futuro, visite nuestra página de artículo de ayuda: ","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/es/articles/1260804371029","CREATE_USER":"Crear Usuario","CATALOG_FILES_TAB_TITLE":"Procesar","FIELD_CATEGORY_ALL":"Todos los campos activos","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"Catalogado","FIELD_DEF.catalogedBy":"Catalogado por","FIELD_DEF.colorMode":"Modo de color","FIELD_DEF.isPanoramic":"Panorámica","FIELD_DEF.created":"Creado","FIELD_DEF.directoryPath":"Ruta de directorios","FIELD_DEF.documentText":"Texto del documento","FIELD_DEF.filename":"Nombre de archivo","FIELD_DEF.fileDescription":"Descripción","FIELD_DEF.fileSize":"Tamaño de archivo","FIELD_DEF.geometry":"Geo - Correspondencia","FIELD_DEF.height":"Altura","FIELD_DEF.horizontalResolution":"Resolución horizontal","FIELD_DEF.keywords":"Palabras clave","FIELD_DEF.lastModified":"Modificado","FIELD_DEF.lastUpdated":"Cambiado","FIELD_DEF.aliasMac":"Mac de alias","FIELD_DEF.creatorMac":"Mac de creador","FIELD_DEF.fileTypeMac":"Mac de tipo de archivo","FIELD_DEF.zoneMac":"Mac de zona","FIELD_DEF.multipageCount":"Número de páginas","FIELD_DEF.numBands":"Número de vendas","FIELD_DEF.path":"Ruta","FIELD_DEF.ItemID":"ID de activo","FIELD_DEF.shortFilenameWin":"Nombre de archivo corto Windows","FIELD_DEF.thumbnailSize":"Tamaño de miniatura","FIELD_DEF.updatedBy":"Cambiado por","FIELD_DEF.verticalResolution":"Resolución vertical","FIELD_DEF.volume":"Volumen","FIELD_DEF.watermarkURL":"URL de marca de agua","FIELD_DEF.watermarked":"Marca de agua","FIELD_DEF.width":"Anchura","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"Actualizar","ALL_CATALOGS":"Todos los catálogos","ALL_SITES":"Todos Los Sitios","ASSET_DOWNLOADS":"Activos - Los más descargados","ASSET_PREVIEWS":"Activos - Los más vistos previamente","ASSET_UPLOADS":"Activos - Cargas","DOWNLOAD_REPORT":"Descargar Reporte","FILE_TYPES":"Tipos de archivo","FILE_TYPES_SECTION_TITLE":"Tipos de archivo","FILE_TYPES_ERROR_NAME_EXISTS":"El nombre '{name}' coincide con el nombre de un tipo de archivo existente.","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"Restablecer valores predeterminados","FILE_TYPES_PROMPT_DISCARD_CHANGES":"¿Descartar cambios pendientes?","FILE_TYPES_ADD_FILE_TYPE":"Añadir tipo de archivo","FILE_TYPES_UPDATE_FILE_TYPE":"Actualizar tipo de archivo","FILE_TYPES_EXTENSIONS":"Extensiones","FROM":"De","SITE":"Sitio","KEYWORD_STATISTICS":"Estadísticas de palabras clave","NETPUBLISH_MOST_DOWNLOADED":"Lo más descargado de NetPublish","NETPUBLISH_USAGE":"Uso de NetPublish","REPORT_DESCRIPTION_ASSET_PREVIEWS":"Este informe identifica qué activos han sido descargados y cuántas veces se descargó cada uno.","REPORT_DESCRIPTION_ASSET_UPLOADS":"En este informe se identifican los activos cargados, los usuarios que los cargaron, y cuándo.","REPORT_DESCRIPTION_DOWNLOADED":"Este informe identifica qué activos han sido descargados y cuántas veces se descargó cada uno.","REPORT_DESCRIPTION_KEYWORD":"Este informe identifica todas las palabras clave del catálogo y a cuántos activos se han aplicado.","REPORT_DESCRIPTION_USAGE":"Este informe identifica qué usuarios han descargado qué activos y cuándo.","SEARCH_TERMS":"Buscar términos","TO":"Hasta","VIEW_REPORT":"Ver informe","NP_SITES":"Sitios NetPublish","REPORT_NAME_DELETED_BY":"Activos - Eliminaciones","REPORT_NAME_DOWNLOADED_BY":"Activos - Descargas","REPORT_DESCRIPTION_DELETED_BY":"En este informe se identifican los activos eliminados, los usuarios que los han eliminado, y cuándo.","REPORT_DESCRIPTION_DOWNLOADED_BY":"En este informe se identifican los activos descargados, los usuarios que los descargaron, y cuándo.","CATALOG_SAVE_TEMPLATE_TITLE":"Guardar plantilla de catálogo","BACKUP_FILES_LABEL":"Archivos copia de seguridad","CONFIGURE_EMAIL_LINK":"Configurar notificaciones de correo electrónico...","NP_SOURCE":"Fuente","NOTIFICATION_FAILURE_UPDATE":"Fracasó la actualización","FIELD_FORM_LABEL_PRECISION_MAX":"Máx","REPORT_DESCRIPTION_FILE_TYPES":"Este informe identifica los tipos de archivo más comunes y el espacio en disco que ocupan.","REPORT_DESCRIPTION_SEARCH_TERMS":"Este informe identifica las palabras y frases más comunes que buscan los usuarios.","DUPLICATE_FIELD_NAME_ERROR":"Campo Nombre duplicado","NO_CATALOGS_EXIST":"No existen catálogos.\n\nHaga clic en el botón + para crear un Catálogo.","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"Cambiar Roles","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"Annulla membership","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"¿Eliminar este usuario del catálogo?\nLos elementos en Salida del usuario se revertirán y se podrá acceder a estos.","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"¿Está seguro de que desea cambiar el rol del usuario en el catálogo? Esta acción puede resultar en la eliminación de los datos del usuario si el nuevo rol tiene acceso o permisos reducidos.","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"Consultando. Esto puede tardar unos minutos...","FIELD_DELETE_CONFIRM_MSG":"¿Desea borrar el campo seleccionado?","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"¿Restablecer todos los tipos de archivo a sus valores predeterminados?","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"Filtro","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"AD Usuarios y grupos","DIRECTORY_SERVICE_SAVE_MAPPINGS":"Guardar y sincronizar","DIRECTORY_SERVICE_REMOVE_MAPPING":"Eliminar mapeo","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Importaciones de usuario Portfolio","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"No hay Correspondencias.\n\nPara crear una correspondencia, seleccione un usuario o grupo a la izquierda y haga clic en 'Crear correspondencia'.","NOTIFICATION_FAILURE_ADD":"No se ha podido agregar","FIELD_ADD_EXTRACT_METADATA":"Añadir mapa de extracción","FIELD_MULTIPLE_EMBED_WARNING":"Más de un campo se integra en","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"Nuevos activos de palabras clave inteligentes catalogadas","LIC_CLICK_TO_UPGRADE":"Haga clic para actualizar Portfolio Server","LIC_MAINTENANCE_END_DATE":"Fecha de finalización de mantenimiento / suscripción","LIC_SEAT_DISPLAY":"Puestos del usuario","LIC_ACTIVATE":"Active Portfolio (Se requieren credenciales)","LIC_CLICK_TO_ACTIVATE":"Haga clic para activar Portfolio Server","LIC_CLICK_TO_USE":"Haga clic para utilizar Portfolio por un periodo de tiempo limitado","LIC_TRIAL":"Portfolio de prueba (Se requiere número de serie)","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/en-us/requests/new","LIC_ERROR_GET_ACCOUNT":"Surgió un problema al obtener su cuenta Portfolio DAM.","LIC_ERROR_GET_LICENSES":"Surgió un problema al recuperar sus licencias de Portfolio DAM.","CHANGE":"Cambiar","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"Para cambiar esta carpeta, primero detenga Portfolio.","MEDIA_ENGINES_COLUMN_TEST":"Probar","ROLES_PERMISSIONS":"Permisos","NO_SITES_EXIST_1":"No existen sitios NetPublish.","NO_SITES_EXIST_2":"Utilice la opción Publicar de Portfolio para crear y publicar sitios.","MEDIA_ENGINE_NOT_OPERATIONAL":"No se pudo acceder al motor de medios.","MEDIA_ENGINE_OPERATIONAL":"El media engine es operacional.","LIC_SET_EXTENSIS_ACCOUNT":"Configure la cuenta Portfolio DAM","LIC_ACCOUNT":"Dirección de correo electrónico","LIC_PASSWORD":"Contraseña","CERTS_TITLE":"Certificado SSL","LIC_SYSTEM_ID":"Identificación del sistema","LIC_SET_ACCOUNT_ERROR":"Surgió un problema al configurar su cuenta Portfolio DAM. Revise las credenciales e intente de nuevo.","LIC_SET_SYSTEM_TITLE":"Seleccione su sistema Portfolio DAM","NP_DELETE_SITE_CONFIRMATION":"¿Desea borrar el Sitio de forma permanente?","NP_SITE_DELETE_LABEL":"Eliminar sitio","NP_SITE_ENABLED_LABEL":"Sitio Habilitado","CERT_CREATE_REQUEST":"Crear solicitud de certificado","CERT_DOWNLOAD":"Descargar","CERT_EXPIRATION_DATE":"Fecha de caducidad","CERT_IMPORT":"Importar un certificado","CERT_ISSUER":"Emisor","CERT_OWNER":"Propietario","CERT_PENDING_REQUEST":"Solicitud de certificado pendiente","CERTIFICATE_STATUS_INVALID":"Certificado no válido","CERTIFICATE_STATUS_SELF_SIGNED":"Certificado no válido: Autofirmado","CERTIFICATE_STATUS_EXPIRED":"Certificado caducado","CERTIFICATE_STATUS_IMPORTED":"Certificado importado","CERT_DELETE_CONFIRMATION":"¿Está seguro de que desea eliminar la solicitud de certificado? Esta acción no se puede deshacer.","DIAGNOSTICS_TITLE":"Diagnóstico","DIAGNOSTICS_NO_PROBLEMS":"No se encontraron problemas","SK_ENGINE_ART_STYLE":"Estilo de arte","SK_ENGINE_ART_SUBJECT":"Sujeto de arte","SK_ENGINE_ART_MOVEMENT":"Movimiento de arte","CERT_FILE":"Archivo de certificado","CERT_FILE_INT_1":"Certificado intermedio 1","CERT_FILE_INT_2":"Certificado intermedio 2","CERT_FILE_PASSWORD":"Contraseña del certificado","CERT_FILE_PASSWORD_HELP":"Si su certificado tiene contraseña, introdúzcala aquí","CERT_FILE_PROMPT":"Seleccionar...","CERT_FILE_ROOT":"Certificado raíz","CERT_IMPORT_SUCCEEDED":"El certificado se ha importado con éxito. Reinicie el servidor Portfolio y los servicios administrativos de Portfolio para comenzar a utilizar el certificado.","CERT_IMPORT_FAILED_READING_PKCS12":"El servidor no pudo leer el certificado PKCS12. Compruebe la contraseña.","CERT_IMPORT_FAILED_INTERMEDIATE1":"No se ha podido importar el certificado Intermedio 1.","CERT_IMPORT_FAILED_INTERMEDIATE2":"No se ha podido importar el certificado Intermedio 2.","CERT_IMPORT_FAILED_ROOT":"No se ha podido importar el certificado raíz.","DIRECTORY_SERVICE_CONFIG_TITLE":"Configuración del servicio de directorio","DIRECTORY_SERVICES_TITLE":"Servicios de directorio","DIRECTORY_SERVICE_MAPIINGS":"Elementos de directorio a Correspondencias Portfolio","DIRECTORY_SERVICE_MAPIINGS_TITLE":"Correspondencias","PDL_noPredefinedValues":"No hay valores predefinidos","PDL_editPredefinedListPlaceholder":"Editar lista predefinida","PDL_importPredefinedValues":"Importar valores predefinidos","PDL_exportPredefinedValues":"Exportar valores predefinidos","PDL_removeNestedValueConfirmation":"¿Eliminar los valores seleccionados?\nContienen valores anidados que también se eliminarán.","PDL_wrongPdlImportFormat":"El archivo seleccionado no contenía datos de texto. Seleccione un archivo de texto.","LIC_SET_ACCOUNT":"Establecer Cuenta","LIC_REMOVE_ACCOUNT":"Eliminar Cuenta","LIC_CONTACT_CUSTOMER_SUCCESS_1":"Para obtener ayuda con la renovación de su cuenta, comuníquese con nosotros al","LIC_CONTACT_CUSTOMER_SUCCESS_2":"y su Gerente de Éxito del Cliente se comunicará con usted dentro de 1 día hábil."});/* eslint-enable */

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"À propos de","ABOUT_API_TAB":"API","ABOUT_VERSION":"Version","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio Server","ABOUT_PORTFOLIO_VERSION":"Version 9.0","ABOUT_SERVER_TAB":"Serveur","accessOriginals":"Originaux des accès et des procédures","ACCOUNT_TYPE":"Authentification","ACCOUNT_TYPE_LDAP":"Service d'annuaire","ACCOUNT_TYPE_MANUAL":"Natif (intégré)","ACTIVE_DIRECTORY":"Active Directory","ADD":"Ajouter","ALL_CATALOGS_GROUP":"Tous les catalogues","API_CODE_REFERENCE":"Référence du code de l'API (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"Communauté des développeurs","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"Rubrique d'aide sur l'administration du serveur","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/fr/portfolio/administration/{version}/index.htm","API_SECTION_1":"L'API de Portfolio propose aussi une interface commune pour que les développeurs puissent intégrer les catalogues Portfolio, les métadonnées de ressources, et le traitement multimédia dans les systèmes métier, les flux d'opérations personnalisés, et les infrastructures Web.","API_SECTION_2_PART_1":"L'utilisation de l'API nécessite des licences, comme stipulé dans le ","API_SECTION_2_EULA":"CLUF de Portfolio","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/fr/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":". Pour consulter ou modifier les informations de licence, cliquez sur 'Licences' dans l'application Administration du serveur.","API_SECTION_2_PART_3":"En savoir plus :","API_TOKEN_CREATE":"Ajouter nouveau jeton API","APPLY":"Appliquer","APP_PAGE_TITLE":"Administrateur de Portfolio","AT_TIME":"au moment","AUTHENTICATION_ERROR":"L'authentification du service de répertoire a échoué. Veuillez vérifier votre nom d'utilisateur et mot de passe.","BACKUP_BACKUP_BUTTON":"Sauvegarder","BACKUP_BACKUP_LABEL":"Sauvegarder","BACKUP_BACKUP_NOW_BUTTON":"Sauvegarder maintenant","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Pour modifier l’emplacement de sauvegarde, arrêtez d’abord le serveur Portfolio.","BACKUP_CONFIRMATION_VERBIAGE":"Sauvegarder maintenant? Le Portfolio sera hors ligne jusqu'à ce que la sauvegarde soit terminée.","BACKUP_DIRECTORY_LABEL":"Stocker dans le répertoire","BACKUP_DIRECTORY_ERROR_MSG":"Le répertoire de sauvegarde sélectionné est erroné.","BACKUP_EXPLANATION_TEXT_1":"Extraire les sauvegardes et stocker en toute sécurité la base de données du serveur et les paramètres.\nIt ne sauvegarde pas vos fichiers de composants d'origine!","BACKUP_EXPLANATION_TEXT_2":"Le serveur sera inaccessible durant les sauvegardes.","BACKUP_FRIDAY_LABEL":"Vendredi","BACKUP_MONDAY_LABEL":"Lundi","BACKUP_MOST_RECENT_LABEL":"Sauvegarde la plus récente","BACKUP_NEXT_SCHEDULED_LABEL":"Prochaine sauvegarde planifiée","BACKUP_NOTIFICATIONS":"Envoyer des notifications par courriel après les sauvegardes et les restaurations","BACKUP_NOTIFICATIONS_DISABLED_MSG":"Les notifications par courriel doivent être activés dans Paramètres généraux > Notifications par courriel","BACKUP_PROGRESS_BACKING_UP":"Sauvegarde en cours","BACKUP_PROGRESS_BACKING_UP_DATA":"Sauvegarde des données en cours...","BACKUP_PROGRESS_BACKUP_CANCELLED":"Sauvegarde annulée","BACKUP_PROGRESS_BACKUP_FAILED":"Échec de la sauvegarde","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"Sauvegarde réussie","BACKUP_PROGRESS_PREFLIGHT":"Vérification de l'espace disponible...","BACKUP_PROGRESS_RESTARTING":"Redémarrage du serveur...","BACKUP_PROGRESS_RESTORE_FAILED":"Échec de la restauration","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"Restauration réussie","BACKUP_PROGRESS_RESTORING":"Restauration en cours","BACKUP_PROGRESS_RESTORING_DATA":"Restauration des données en cours...","BACKUP_PROGRESS_SHUTTING_DOWN":"Fermeture du serveur en cours...","BACKUP_PROGRESS_SUMMARY":"Étape {stepNum} sur {totalSteps}","BACKUP_RESTORE_BUTTON":"Restaurer à partir du fichier de sauvegarde...","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"Restaurer la sauvegarde maintenant? Le portefeuille sera hors ligne jusqu'à ce que la restauration soit terminée. Ceci écrasera votre base de données actuelle et vos paramètres.","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"Les archives de sauvegardes sont corrompues. Sélectionnez une autre sauvegarde pour une restauration.","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"Le lecteur de sauvegarde ne dispose pas d'un espace suffisant\n pour terminer.\n\n{requiredSpace} requis, {availableSpace} disponible.","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"L’emplacement de sauvegarde actuellement configuré n’existe pas. L’emplacement de sauvegarde est utilisé pour décompresser l’archive lorsqu’une sauvegarde est restaurée. Veuillez sélectionner un répertoire valide pour l’emplacement de sauvegarde.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"Problème avec la sauvegarde. Pour plus d'informations, consultez le journal d'admin.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"Problème avec la restauration. Pour plus d'informations, consultez le journal d'admin.","BACKUP_RESTORE_LABEL":"Restaurer","BACKUP_RESTORE_TITLE":"Sauvegarde/Restauration","BACKUP_RETAIN_LABEL":"Conserver","BACKUP_RETAIN_VALUE":"Conserver uniquement les {numBackups} sauvegardes les plus récentes","BACKUP_SATURDAY_LABEL":"Samedi","BACKUP_SCHEDULE_LABEL":"Planifier les sauvegardes","BACKUP_SCHEDULE_VALUE":"le","BACKUP_SUNDAY_LABEL":"Dimanche","BACKUP_THURSDAY_LABEL":"Jeudi","BACKUP_TUESDAY_LABEL":"Mardi","BACKUP_WEDNESDAY_LABEL":"Mercredi","BROWSE":"Parcourir","BROWSE_FOLDERS_TITLE":"Parcourir les dossiers du serveur","BROWSE_RECENT_FOLDERS_LABEL":"Dossiers récents","BROWSE_REFRESH":"Synchroniser des éléments","CALL_ATT_BUTTON_BUY_NOW":"Acheter maintenant","CALL_ATT_BUTTON_SECONDARY":"Contacter le service des ventes pour un devis","CALL_ATT_FADEL_BUTTON_MAIN":"Ventes de contact pour plus d'information","CALL_ATT_FADEL_MAIN":"Assurez-vous de la bonne utilisation du contenu sous licence, des images aux vidéos et de tout ce qui se situe entre les deux. Le portefeuille se connecte sans difficulté au logiciel FADEL Rights Cloud pour que vous puissiez aisément comprendre les droits d’utilisation qui sont associés à vos éléments. Cela vous aide à résoudre les embouteillages de workflow et à réduire le risque d'infractions onéreuses aux droits d’auteur.","CALL_ATT_FADEL_SUBTITLE":"Prenez connaissance de vos droits d’utilisateur","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"Conversion et traitement de haut niveau","CALL_ATT_ME_MAIN":"Est-ce que vous repoussez les limites de performance de votre serveur Portfolio? Grâce à Media Engine, évitez les baisses de rendement et augmentez la productivité globale en supprimant les goulots d’étranglement propres aux environnements de production actifs.\n\n\t• Augmente la capacité et le débit\n\t• Déverrouille des formats de sortie supplémentaires\n\t• Accélère la création des aperçus vidéo\n\t• Ajouter plusieurs Media Engines selon les besoins\n\t• Filigrane (nécessite NetPublish)","CALL_ATT_ME_BUTTON_MAIN":"Obtenir Media Engine","CALL_ATT_NP_SUBTITLE":"Portails libre-service pour un accès immédiat aux actifs","CALL_ATT_NP_MAIN":"Vous en avez assez de ces demandes de dernière minute à chaque fois qu’une personne a besoin d’un actif ? Grâce à NetPublish, il est facile de publier des sites Internet en libre service qui permettent à tous les utilisateurs de trouver et télécharger les actifs dont ils besoin à partir de n’importe quel navigateur et périphérique.\n\n\t• Création de site d’un simple clic- aucun code HTML ou CSS\n\t• Conception interactive et compatible avec les portables\n\t• Contrôle souple de l’accès utilisateur\n\t• Désactiver automatiquement les sites\n\t• Définir la résolution, la taille et le format lors du téléchargement\n\t• Filigrane (nécessite Media Engine)\n\t• Rapport d’utilisation","CALL_ATT_NP_BUTTON_MAIN":"Obtenir NetPublish","CALL_ATT_REPORT_TITLE":"Création de rapports pour NetPublish","CALL_ATT_REPORT_SUBTITLE":"Informations d’utilisation pertinentes","CALL_ATT_REPORT_MAIN":"Vous voulez savoir quels sites sont les plus actifs, quels actifs sont utilisés et par qui ? Avec la création de rapports NetPublish, obtenez les informations dont vous avez besoin pour prendre les décisions éclairées sur l’utilisation de Portfolio au sein de votre organisation.\n\nRépartition de l’utilisation par :\n\t•Nom de site NetPublish\n\t• Nom d’utilisateur\n\t• ID et nom d’actif\n\t• Date et heure","CALL_ATT_REPORT_BUTTON_MAIN":"Obtenir NetPublish","CALL_ATT_SK_BUTTON_MAIN":"Essayer gratuitement","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/jzp6","CALL_ATT_SK_MAIN":"Vous cherchez une façon d'accélérer votre processus pour affecter des mots-clés aux images ? Avec Portfolio Smart Keywords, vous pouvez automatiquement affecter des mots-clés « intelligents » à vos images d'un seul clic. Optimisé par Clarifai, une société innovante d'intelligence artificielle qui excelle dans les technologies de reconnaissance visuelle, une liste de mots-clés peut être fournie en quelques secondes.\n\n\t• Fournit une liste de Smart Keywords en quelques secondes\n\t• Économise du temps et des ressources en réduisant la saisie manuelle de mots-clés\n\t• Établit une taxonomie cohérente pour votre organisation\n\t• Facilite la recherche rapide de vos ressources numériques","CALL_ATT_SK_SUBTITLE":"Automatisez votre association de mots-clés avec des images","CALL_ATT_SK_TITLE":"Portfolio Smart Keywords","CALL_ATT_SSO_SUBTITLE":"Expérience utilisateur transparente entre les plates-formes","CALL_ATT_SSO_TITLE":"Single Sign-On","CALL_ATT_SSO_MAIN":"Est-ce qu’une gestion simple de leurs informations de connexion pose des difficultés aux membres de votre organisation ? Généralement, les nouvelles solutions de gestion des comptes utilisateurs sont synonymes de frais supplémentaires pour votre organisation et les utilisateurs.\n\nHeureusement, Portfolio prend en charge Single Sign-On avec Active Directory. Grâce à Single Sign-On, les utilisateurs peuvent se connecter dans Portfolio automatiquement depuis votre site intranet et de bénéficier d’une expérience utilisateur totale.\n\n\t• Prend en charge Windows Server Active Directory\n\t• Améliore la sécurité globale\n\t• Simplifie la gestion des utilisateurs\n\t• Améliore l’expérience utilisateur","CALL_ATT_SSO_BUTTON_MAIN":"Obtenir Single Sign-On","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options?lang=fr","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/fr/portfolio/contact-me","canEmbedMetadata":"Intégrer les métadonnées","canImportMetadata":"Importer/Exporter des données","canManagePublicGallery":"Gérer les présentations publiques","canPublishNetPublishSites":"Peut publier des sites NetPublish","canSmartKeyword":"Accès à Smart Keyword","CANCEL":"Annuler","CATALOG":"Catalogue","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"Autoriser l'adhésion","CATALOG_BACKUP":"Sauvegarder le catalogue sélectionné","CATALOG_CREATE":"Ajouter un nouveau catalogue","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"Les administrateurs de catalogue peuvent ajouter des dossiers AutoSync à partir du Client du bureau.","CATALOG_CREATE_AUTOSYNC_FOLDER":"Créer un dossier AutoSync","CATALOG_CREATE_CATALOG_TEMPLATE":"Modèle de catalogue","CATALOG_TYPE_GENERAL":"Utilisation générale","CATALOG_TYPE_SIMPLE":"Simple","CATALOG_CREATE_DATABASES_LIST_LABEL":"Bases de données","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"Une erreur est survenue lors de la création du {folder} dossier.","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"Les dossiers par défaut pour AutoSync et les prévisualisations peuvent être configurés dans les paramètres généraux.","CATALOG_CREATE_NAME":"Nom","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"Les prévisualisations peuvent être configurées dans les détails du catalogue.","CATALOG_CREATE_PREVIEW_FOLDER":"Enregistrer les prévisualisations pour une prévisualisation plus rapide","CATALOG_CREATE_SHOW_DATABASES":"Afficher les bases de données","CATALOG_CREATE_USE_VERSIONING":"Utiliser le versionnage d'actifs","CATALOG_DELETE":"Supprimer le catalogue","CATALOG_DELETE_CONFIRM":"Voulez-vous supprimer le catalogue sélectionné ?","CATALOG_DETAILS":"Détails du catalogue","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"Pour renommer ce catalogue, nous devons le mettre hors ligne temporairement ; voulez-vous continuer ?","CATALOG_DETAILS_COLLATION":"Assemblage","CATALOG_DETAILS_COLLATION_NA":"N/D","CATALOG_DETAILS_CREATION_DATE":"Date de création","CATALOG_DETAILS_DATABASE_TAB":"General","CATALOG_DETAILS_LAST_MODIFIED":"Date de la dernière modification","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"Utilisateurs connectés","CATALOG_DETAILS_NUMBER_OF_RECORDS":"Enregistrements","CATALOG_DETAILS_NUMBER_OF_USERS":"Membres","CATALOG_DETAILS_SIZE_ON_DISK":"Taille sur le disque","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"L'utilisateur administrateur sera déconnecté. Continuer?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"Verrouillé pour l'administration","CATALOG_DETAILS_UNLOCK":"Déverrouiller","CATALOG_EXPLANATION_VAULT_1":"Les catalogues d'archivage stockent les actifs dans un emplacement sécurisé.","CATALOG_EXPLANATION_VAULT_2":"Les catalogues d’archivage prennent en charge le verrouillage, les différences de version, l’extraction et l’archivage.","CATALOG_EXPLANATION_WF_1":"Les catalogues de surveillance de dossier suivent les actifs contenus dans votre système de fichiers.","CATALOG_EXPLANATION_WF_2":"Les catalogues de surveillance de dossier prennent en charge AutoSync.","CATALOG_INGEST_DRAG_HINT_TEXT":"Pour ajouter des champs au formulaire de téléchargement, faites les glisser sur la liste des champs.","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"Champs pour le formulaire de téléchargement","CATALOG_INGEST_FIELDS_LABEL":"Champs","CATALOG_INGEST_FORM_HEADER_LABEL":"En-tête du formulaire","CATALOG_INGEST_HEADER_HINT_TEXT":"L'en-tête du formulaire est optionnel et s'affiche en haut du formulaire.","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"Le nombre maximum de champs pouvant être ajoutés à un formulaire est de {maxFields}.","CATALOG_INGEST_TAB_TITLE":"Gestion des Ajouts","CATALOG_INGEST_USE_INGEST_LABEL":"Utiliser la gestion de téléchargement","CATALOG_INGEST_REQUIRED_LABEL":"Obligatoire","CATALOG_IS_CONNECTED":"Connecté","CATALOG_IS_DEFAULT":"Par défaut","CATALOG_MANAGE_USERS":"Gestion des adhésions au catalogue","CATALOG_MANAGE_FIELDS":"Gérer des champs de catalogue","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"Gérer les modèles de catalogue...","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"Gérer les modèles de catalogue personnalisés","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"Nom du modèle de catalogue","CATALOG_MEMBER":"Membre","CATALOG_NEW_CATALOG_DETAILS":"Détails sur le nouveau catalogue","CATALOG_OFFLINE":"Hors ligne","CATALOG_ONLINE":"En ligne","CATALOG_OPTIONS_ALL_FILE_TYPES":"Cataloguer tous les types de fichiers","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"Créer des mots clefs à partir du chemin d'accès","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"Nom de fichier","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"Dossier parent","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"Nom du serveur","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"Arborescence des dossiers","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"Volume","CATALOG_OPTIONS_EXCLUSION_LABEL":"Exclusion de fichiers et dossiers","CATALOG_OPTIONS_ONLY_FILE_TYPES":"Cataloguer uniquemente","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"Enlever le ou les type(s) de fichiers sélectionné(s) ?","endsWith":"Se termine par","contains":"Contient","startsWith":"Commence avec","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"Enlever la ou les exceptions sélectionnées?","CATALOG_OPTIONS_TAB_TITLE":"Options de catalogage","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"L’emplacement par défaut est","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"Taille minimale 300 pixels, taille maximale 4000 pixels (plus grande dimension)","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"Générer des clips pour des fichiers audio/vidéo","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"Créer des aperçus","CATALOG_PREVIEWS_FOLDER_LOCATION":"Enregistrer les prévisualisations et clips dans ce dossier","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"L'emplacement doit être accessible au serveur.","CATALOG_PREVIEWS_MAX_PIXELS":"Taille d'image maximale","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"Résolution vidéo maximale","CATALOG_PREVIEWS_MINUTES":"minutes","CATALOG_PREVIEWS_PIXELS":"pixels","CATALOG_PREVIEWS_SHORT":"Aperçus","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"Limiter la durée à","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"Générer des clips peut prendre un certain temps de traitement.\nPour limiter le temps de traitement, choisissez une résolution et durée plus faible.","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"Révoquer l'adhésion","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"Supprimer l’utilisateur du catalogue ?\nLes éléments extraits des utilisateurs dans ce catalogue seront restaurés et rendus accessibles.","CATALOG_SAVE_TEMPLATE":"Sauvegarder le modèle de catalogue","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"Le modèle sauvegardé comprend : tous les champs, les mappages des métadonnées et les paramètres optionnels du catalogue.","CATALOG_SELECT_MESSAGE":"Aucun catalogue sélectionné","CATALOG_SET_AS_DEFAULT":"Définir le catalogue par défaut","CATALOG_SK_DEFAULT_SETTINGS":"Réglages par défaut","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"Niveau de confidentialité","CATALOG_SK_DEFAULT_LABEL":"Recommandé : {recommended}","CATALOG_SK_ENGINES_LABEL":"Moteurs de Smart Keywords","CATALOG_SK_LANGUAGES_LABEL":"Langues pour le moteur général","CATALOG_SK_NUM_KEYWORDS_LABEL":"Nombre de mots-clés","CATALOG_SK_SETTINGS_LABEL":"Paramètres","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"Utiliser des Smart Keywords dans ce catalogue","CATALOG_STATUS":"État du catalogue","CATALOG_STORAGE_TYPE_LABEL":"Type de stockage","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"Voir les dossiers","CATALOG_STORAGE_TYPE_VAULT":"Archivage","CATALOG_TAKE_OFFLINE_SHORT":"Travailler hors ligne","CATALOG_TAKE_ONLINE_SHORT":"Travailler en ligne","CATALOG_TEMPLATE":"modèle","CATALOG_TEMPLATE_NAME":"Nom du modèle","CATALOG_TEMPLATES_TITLE":"Modèles de Catalogue","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"Supprimer le modèle de catalogue sélectionné ?","CATALOG_VIEW_DETAILS":"Afficher/Modifier les détails du catalogue","CERT_REQUEST_ALREADY_CREATED_WARNING":"Vous avez déjà créé une demande de certificat. Si vous continuez, la demande existante sera supprimée.","CERTIFICATE_FILE_FILTER":"Certificats (p7b, p7, cer, crt, pem, pfx, p12)","CITY_OR_LOCALITY":"Ville ou localité","CLEAR_BUTTON_LABEL":"Effacer","COMMUNICATION_AT_INITILIZATION_ERROR":"Erreur de communication avec le serveur. Cette erreur est souvent causée par les données anciennes du cache du navigateur mais cela pourrait aussi signaler un problème venant du serveur. Veuillez contacter votre administrateur pour plus d'informations.","CONFIGURE_DIRECTORY_SERVICE":"Configurer le service d'annuaire","CONFIRM_DELETE_PDL":"Supprimer toutes les valeurs prédéfinies pour ce champ ?","CONFIRM_DELETE_SERVICE":"Supprimer le service d'annuaire?\nLes utilisateurs importés de ce service resteront. Leurs mots de passe seront réinitialisés aux valeurs définies précédemment dans Portfolio (le cas échéant), ou seront désactivés.","CONFIRM_TRUNCATE_VALUES":"La longueur maximale dépasse une ou plusieurs valeur prédéfinies ou par défaut pour ce champ. Raccourcir les valeurs ?","CONNECTION_REFUSED_ERROR":"La connexion au service de répertoire a été refusée. Veuillez vérifier votre nom d'hôte et vos paramètres de port.","CONTAINS":"contient","CONTINUE":"Continuer","CREATE":"Créer","CREATE_A_CERTIFICATE_REQUEST":"Créer une demande de signature de certificat","createContactSheet":"Créer un PDF","CREATED_BY":"Créé par","CREATE_MAPPING":"Créer un Mappage","CREATE_USER_EXCLUSION_MAPPING":"Exclure l'Utilisateur","CREATED_ON_DATE":"Date de création","DATE_FORMAT":"DD-MM-YYYY","DATE_FORMAT_ERROR":"Erreur de configuration : Mise en forme chaîne incorrecte.","DATE_INVALID_CHAR_ERROR":"La date contient des caractères non valides.","DATE_TIME_FORMAT":"DD-MM-YYYY L:NN A","DATE_TIME_SECONDS_FORMAT":"DD-MM-YYYY L:NN:SS A","DATE_WRONG_DAY_ERROR":"Saisir un jour valide pour le mois.","DATE_WRONG_LENGTH_ERROR":"Saisir la date au format :","DATE_WRONG_MONTH_ERROR":"Saisir un mois entre 1 et 12","DATE_WRONG_YEAR_ERROR":"Saisir une année entre 0 et 9999","DEFAULT_ACCESS_LEVEL":"role par défaut","DEFAULT_CATALOG":"Catalogue par défaut","DEFAULT_CATALOG_NONE":"Aucun","DEFAULT_PORT_NON_SSL":"Port non SSL par défaut:","DEFAULT_PORT_SSL":"Port SSL par défaut:","DELETE":"Supprimer","DELETE_SOURCE":"Supprimer la Source","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"Supprimer toutes les valeurs? Ceci supprimera toutes les valeurs y compris les valeurs imbriquées.","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"Supprimer la valeur '{value}' ?\nIt Contient des valeurs imbriquées qui seront aussi supprimées.","DELETE_NESTED_VALUE_CONFIRMATION":"Supprimer les valeurs sélectionnées? Elles comportent des valeurs imbriquées qui seront également supprimées.","DELETE_WARNING_BOX_MSG":"Attention ! La suppression est irréversible!","DELETE_WARNING_CATALOG_VAULT":"Tous les fichiers dans le catalogue seront détruits.","DIAGNOSTIC_DATA_TITLE":"Envoyer le rapport de diagnostic à Portfolio DAM","DIAGNOSTIC_DATA_ACCOUNT_NAME":"Nom de compte ou d’entreprise (Requis)","DIAGNOSTIC_DATA_CONTACT_NAME":"Nom du contact","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"Numéro de ticket d’assistance technique","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"Envoyer rapport","DIAGNOSTIC_STATUS_ERROR":"Problème lors du chargement du rapport de diagnosticle {date}","DIAGNOSTIC_STATUS_SENDING":"Envoi en cours...","DIAGNOSTIC_STATUS_SUCCESS":"Envoi réussi du rapport de diagnostic à Portfolio DAM le {date}","DIRECTORY_SERVICE_CONNECT_ERROR":"Impossible de se connecter au service de répertoire. Veuillez vérifier le nom d'hôte et les paramètres de port.","DIRECTORY_SERVICES":"Services d'annuaire","DIRECTORY_USERS_CANNOT_BE_DELETED":"Les utilisateurs du service d'annuaire ne peuvent pas être supprimés !","DISTRIBUTION_GROUPS":"Groupes de distribution","DOWNLOAD_CERT_PROMPT":"Télécharger le fichier de demande de certificat ?","DOWNLOAD_COMPLETE_STRING":"Fin du téléchargement.","downloadPreviews":"Télécharger les aperçus","EMAIL_ADDRESS":"Adresse email","EMAIL_CONFIG_AUTH_PASSWORD":"Mot de passe","EMAIL_CONFIG_AUTH_USERNAME":"Nom d'utilisateur","EMAIL_CONFIG_ENABLED":"Activer les notifications par courriel","EMAIL_CONFIG_FROM_ADDRESS":"Adresse de l'émetteur du courriel","EMAIL_CONFIG_INVALID_GENERIC":"Configuration du serveur de messagerie non valide","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"Serveur de messagerie non trouvé","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"Échec de l'authentification du serveur de messagerie","EMAIL_CONFIG_MESSAGE":"Tout utilisateur souhaitant recevoir des notifications doit disposer d'une adresse de courriel affectée dans le volet Utilisateurs.","EMAIL_CONFIG_SERVER_ADDRESS":"Adresse du serveur SMTP","EMAIL_CONFIG_SERVER_PORT":"Port serveur SMTP","EMAIL_CONFIG_SUCCESS_MESSAGE":"Serveur SMTP validé","EMAIL_CONFIG_USE_SSL_TLS":"Utiliser SSL / TLS","EMAIL_CONFIG_USE_SMTP_AUTH":"Utiliser l'authentification SMTP","EMAIL_CONFIG_VALIDATE":"Test de connexion","EMAIL_CONFIG_VALIDATED":"Serveur de messagerie validé","english":"Anglais","ENTIRE_TREE_UNDER_SEARCH_BASE":"Arborescence entière sous la base de recherche","EQUALS":"égal à","EXPORT_MENU_STRING":"Exporter des valeurs","FADEL_HOWTO":"Procédure de connexion à votre compte de FADEL :","FALSE_LABEL":"Faux","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"Assurez-vous que le serveur d'administration est en cours d'exécution sur votre ordinateur local, avec le numéro de port inscrit sur la page des ports. Si ce n'est pas le cas, redémarrez le serveur et relancez l'application.","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"Cette opération ne peut pas être effectuée alors que la sauvegarde ou la restauration est en cours.","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"L'opération a échoué car le catalogue est en mode administrateur.","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"Un catalogue existe déjà sous ce nom.","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"Un utilisateur utilise déjà ce nom de compte.","FAULT_MSG_DB_IN_USE":"L'opération n'a pu se terminer car un administrateur est en train d'utiliser le catalogue.","FAULT_MSG_DELETE_ADMIN":"Vous ne pouvez pas supprimer le compte de l'administrateur.","FAULT_MSG_DELETE_SELF":"Vous ne pouvez pas supprimer votre compte utilisateur.","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"Une erreur inattendue s'est produite lors de la suppression du modèle du catalogue","FAULT_MSG_DUPE_NAME":"Un objet existe déjà sous ce nom. Veuillez utiliser un autre nom.","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"Un Media Engine existe déjà sous cette adresse et ce numéro de port.","FAULT_MSG_ENTITY_VERSION_MISMATCH":" L'opération a échoué car les informations du client n'étaient plus à jour.","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"Assurez-vous que le serveur est en cours d'exécution sur votre ordinateur local, avec le numéro de port inscrit sur la page des ports. Si ce n'est pas le cas, redémarrez le serveur et relancez l'application.","FAULT_MSG_INVALID_SESSION_ID":"Votre session a expiré. Vous devez vous connecter une nouvelle fois au serveur.","FAULT_MSG_IS_NOT_LICENSED":"Le serveur n'est pas autorisé à effectuer cette opération.","FAULT_MSG_LEGACY_21000":"L'opération a échoué suite à une erreur interne.","FAULT_MSG_LOGGING_ERR_UPDATE":"Une erreur s'est produite lors de la mise à jour de la configuration de la journalisation","FAULT_MSG_LOG_DIR_NOT_VALID":"Le répertoire du journal spécifié n'existe pas, n'est pas inscriptible, ou le chemin spécifié n'est pas un répertoire.","FAULT_MSG_NO_DIRECTORY":"L’emplacement indiqué n’existe pas ou ne se trouve pas dans un répertoire.","FAULT_MSG_NULL_DESCRIPTION":"Une erreur inattendue est survenue, mais aucune description n'est disponible.","FAULT_MSG_NULL_FAULTEVENT":"Une erreur inattendue est survenue, mais aucun détail n'est disponible.","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"L'opération a échoué car vous ne disposez pas des autorisations nécessaires.","FAULT_MSG_OPERATION_IS_INVALID":"L'opération n'était pas valide.","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"Une erreur inattendue s'est produite lors du renommage du modèle du catalogue","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"Une erreur inattendue s'est produite lors de la sauvegarde du modèle du catalogue","FAULT_MSG_SERVER_NOT_RUNNING":"Le serveur n’est pas actif.","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"L'opération a échoué car le serveur n'a pas de licence pour le module Entreprise.","FAULT_MSG_REMOVE_METADATA_DEF":"La suppression de la définition des métadonnées a échoué. Elle peut être utilisée par d’autres catalogues.","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"Le serveur a renvoyé une faute avec ce message : ","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"Le serveur a renvoyé une faute sans message d'erreur. ","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"Le serveur a renvoyé une faute à cause d'un type inconnu avec ce message :","FAULT_MSG_UNKNOWN_SMTP_SERVER":"Impossible de se connecter au serveur de messagerie spécifié.","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"Cette opération a échoué car un des services n'avait pas l'état attendu.","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"Le nom d'utilisateur ou le mot de passe indiqué pour la base de données n’est pas valide.","FAULT_MSG_BAD_DB_PORT":"Le port de la base de données indiqué n’est pas valide.","FAULT_MSG_BAD_DB_HOST":"Le nom d’hôte de la base de données ou le port indiqué n’est pas valide.","FIELD_ACTION_ADD":"Ajouter un nouveau champ personnalisé","FIELD_ACTION_DELETE":"Supprimer le champ sélectionné","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"Espaces de noms XMP","FIELD_ACTION_MANAGE_METADATA":"Gérer les métadonnées","FIELD_CATEGORY_CUSTOM":"Champs personnalisés","FIELD_CATEGORY_SYSTEM":"Champs système","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"Film","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"Catégorie de champ","FIELD_DISABLE_CONFIRM_MSG":"Voulez-vous désactiver le champ sélectionné?","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"Activer tout","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"Ajouter le mappage de l’extrait","FIELD_FORM_LABEL_DEFAULT_VALUE":"Valeur par défaut","FIELD_FORM_LABEL_DISABLED":"(Désactivé)","FIELD_FORM_LABEL_EMBED":"Incorporer aux métadonnées","FIELD_FORM_LABEL_EXTRACT":"Extraire des métadonnées","FIELD_FORM_LABEL_FIELD_NAME":"Nom du champ","FIELD_FORM_LABEL_FIELD_TYPE":"Type du champ","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"Autoriser plusieurs valeurs","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"Contient des valeurs prédéfinies","FIELD_FORM_LABEL_HELP_TEXT":"Texte d’aide","FIELD_FORM_LABEL_MAX":"Max : {max}","FIELD_FORM_LABEL_MAX_LENGTH":"Longueur max.","FIELD_FORM_LABEL_METADATA_TAG":"Nom de métadonnées","FIELD_FORM_LABEL_METADATA_TYPE":"Type de métadonnées","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"Autoriser seulement les valeurs prédéfinies","FIELD_FORM_LABEL_PRECISION":"Précision","FIELD_FORM_LABEL_PREDEFINED_VALUES":"Valeurs prédéfinies","FIELD_FORM_LABEL_SHOW_TIME":"Afficher l’heure","FIELD_FORM_LABEL_USE_METADATA":"Extraire et incorporer des Métadonnées","FIELD_FORM_WARNING_DUPE_EMBEDS":"Avertissement : Plus d’un champ est intégré dans '{metadata}'","FIELD_METADATA_DATA_TYPE_LABEL":"Type de données","FIELD_METADATA_DEFINITION_IS_CUSTOM":"est personnalisé","FIELD_METADATA_DEFINITIONS_TITLE":"Définitions des métadonnées","FIELD_METADATA_DELETE_CONFIRM_MSG":"Confirmer : Supprimer la définition des métadonnées ?","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"Type à plusieurs valeurs","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"N’accepte pas plusieurs valeurs","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"Classé","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"Non classé","FIELD_METADATA_NAME_LABEL":"Nom","FIELD_METADATA_NAMESPACE_LABEL":"Espace de nom","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"Ajouter un espace de nom XMP personnalisé...","FIELD_METADATA_TAG_LABEL":"Balise","FIELD_METADATA_TYPE_LABEL":"Type","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"Plusieurs champs sélectionnés","FIELD_NAMESPACE_ABBREVIATION":"Abréviation","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"Supprimer l’espace de nom XMP personnalisé ?\n L’espace de nom est peut-être utilisé par des définitions de champ.","FIELD_NAMESPACE_URI":"URI espace de nom","FIELD_NEW_FIELD_NAME":"Nouveau champ","FIELD_NEW_METADATA_TITLE":"Nouvelle définition de métadonnées","FIELD_NEW_NAMESPACE_TITLE":"Nouvel espace de nom XMP personnalisé","FIELD_NO_FIELD_SELECTED_MESSAGE":"Aucun champ sélectionné","FIELD_PAGE_TITLE":"Gérer les champs pour le catalogue '{catalogName}'","FIELD_REVERT_CONFIRM_MSG":"Confirmer : Renverser le champ ?","FIELD_TYPE_BLOB":"Blob","FIELD_TYPE_BOOLEAN":"Booléen","FIELD_TYPE_DATETIME":"Date/Heure","FIELD_TYPE_DECIMAL":"Décimal","FIELD_TYPE_LANG_ALT":"Lang Alt","FIELD_TYPE_NUMBER":"Nombre","FIELD_TYPE_PICTURE":"Image","FIELD_TYPE_STRING":"Chaîne","FIELD_TYPE_STRUCTURE":"Structure","FIELD_TYPE_TEXTBLOCK":"Bloc de texte","FIELD_TYPE_UNKNOWN":"Inconnu","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"Une erreur s'est produite lors de l'ajout du fichier au serveur.","FILE_WRONG_TYPE_ERROR_MSG":"Ce type de fichier n'est pas pris en charge.\nSélectionnez un fichier jpeg, gif ou png.","FOLDER_PATH_AUTOSYNC_FILES_STRING":"Fichiers","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"Un fichier portant ce nom existe déjà.","FOLDER_PATH_DOES_NOT_EXIST":"Le chemin d’accès n’existe pas.","FOLDER_PATH_ERROR":"Erreur","FOLDER_PATH_NOT_VERIFIED":"Le chemin d’accès au dossier n’a pas été vérifié.","FOLDER_PATH_PATH":"Chemin d’accès","FOLDER_PATH_OPERATION_INVALID":"Une opération non valide","FOLDER_PATH_SUCCESS":"Réussite","FOLDER_PATH_TYPE_AUTOSYNC":"autosync","FOLDER_PATH_TYPE_PREVIEW":"prévisualisation","FOLDER_PATH_UNKNOWN_FAULT":"Une faute inconnue","french":"Français","FULL_NAME":"Nom complet","FULLY_QUALIFIED_DOMAIN_NAME":"Nom de domaine pleinement qualifié","german":"Allemand","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"Créer des dossiers AutoSync pour les nouveaux catalogues dans ce dossier","GLOBAL_SETTINGS_BACKGROUND_COLOR":"Couleur d’arrière-plan","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"Couleur d'arrière-plan de l'écran de connexion.","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"Valeurs par défaut du catalogue","GLOBAL_SETTINGS_CHOOSE_FILE":"Choisir un fichier","GLOBAL_SETTINGS_CUSTOM_IMAGE":"Image personnalisée","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"La taille approximative doit être de 2400x1350 pixels.","GLOBAL_SETTINGS_CUSTOM_TITLE":"Titre personnalisé","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"Titre qui apparaît sur l'onglet ou le signet du navigateur.","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"Écran de connexion personnalisé","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"role par défaut","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"Écran de connexion par défaut","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"Notifications par courriel","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"L’emplacement des dossiers AutoSync et de prévisualisation doit être accessible au serveur.","GLOBAL_SETTINGS_IMAGE_URL":"Lien","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"L'URL sera lancée dans une autre fenêtre du navigateur si vous cliquez sur l'image.","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"Pour apporter des modifications, démarrez le serveur ou vérifiez si une licence de serveur est arrivée à expiration.","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"Enregistrer les prévisualisations pour les nouveaux catalogues dans ce dossier","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"Emplacements des données du serveur","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"Personnalisation de procédure de connexion de Portfolio","GLOBAL_SETTINGS_SSO_CREDENTIALS":"Informations d’identification pour l’authentification unique","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"Saisir le compte de l’utilisateur associé au service Portfolio Server avec l’authentification Kerberos.","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"Dossier de travail temporaire:","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"Le dossier de travail sera modifié lors du prochain démarrage du serveur. Le nouveau dossier se trouvera à l’emplacement suivant : ","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"Vous devez redémarrer le serveur pour que cette modification prenne effet.","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Configuration de Portfolio Vault","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Dossier d'archivage du portefeuille :","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Emplacement par défaut de l’archivage du portefeuille :","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"Avant de déplacer Portfolio Vault, veuillez arrêter le serveur.","HELP_URL":"https://helpdocs.portfoliodam.com/fr/portfolio/administration/{version}/index.htm","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/fr/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"Nom d'hôte","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(par défaut)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"Connexion au service de répertoire réussie. Configuration enregistrée.","IMAGE_FILE_FILTER":"Images (jpg, gif, png)","IMPORT_LDAP":"Importer des utilisateurs à partir du serveur LDAP/AD","IMPORT_LDAP_SPECIFY_SERVER":"Spécifier le serveur LDAP/AD ","IMPORT_MENU_STRING":"Importer des valeurs","IMPORT_SOURCE":"Importer la source","INVALID_DN_SYNTAX_ERROR":"Impossible de se connecter au service de répertoire en raison d'une erreur de syntaxe DN. Veuillez vérifier le nom d'utilisateur.","japanese":"Japonais","LAST_CERTIFICATE_REQUEST_LABEL":"Dernière demande de certificat","LAST_MODIFIED_BY":"Dernière modification par","LAST_MODIFIED_DATE":"Date de la dernière modification","LDAP_ADDRESS":"Adresse du serveur LDAP/AD","LDAP_BIND_USERNAME":"Nom d'utilisateur pour la liaison LDAP","LDAP_SYNC_NOTIFICATION":"Le serveur a reçu la demande de synchronisation.","LIC_ADD_MESSAGE":"Copiez et collez les licences ou saisissez-les individuellement sur chaque ligne.","LIC_ADD_SN":"Ajouter une nouvelle licence","LIC_ADD_SN_SHORT":"Ajouter licences","LIC_ASSET_CAP_DISPLAY":"Actifs","LIC_DAYS_REMAINING":"({days} jours restants)","LIC_DEMO_PERIOD":"Période d’évaluation","LIC_ERROR_MSG":"Numéro de série, veuillez recommencer. Si le problème persiste, vérifiez le journal de votre serveur ou contactez votre administrateur.","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"Impossible d’ajouter le numéro de série à Portfolio Studio.","LITE_CANNOT_CREATE_FDB_CATALOG":"La licence de votre Portfolio ne vous autorise pas à plusieurs catalogues. Veuillez envisager de mettre à jour votre licence de Portfolio pour accomplir cette action.","LITE_CANNOT_SERVE_FDB_CATALOG":"Votre licence Portfolio Server ne permet pas de mettre en ligne d'autres catalogues.","LITE_THIS_FEATURE_NOT_SUPPORTED":"Votre licence Portfolio Server ne prend pas en charge cette action.","LOGGING_CONFIGURATION":"Configuration de la journalisation","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Pour modifier l’emplacement du journal, arrêtez d’abord le serveur Portfolio.","LOGGING_DEFAULT_LOCATION_MSG":"L’emplacement par défaut du journal est","LOGGING_DIR_MUST_EXIST":"REMARQUE : Afin de modifier correctement le répertoire du journal, le nouveau répertoire spécifié doit déjà exister et être inscriptible par l'utilisateur sous lequel la version de Portfolio Server s'exécute.","LOGGING_LOG_DIR":"Répertoire du journal :","LOGGING_LOG_LEVEL":"Niveau de journalisation","LOGGING_NUM_LOGS_TO_RETAIN":"Nombre de journaux à conserver","LOGIN":"Connexion","MAPPING_HEADER":"Mappage des utilisateurs/groupes vers Portfolio","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"Les mappages ont été modifiés. Voulez-vous les enregistrer ?","MEDIA_ENGINES_ACTION_ADD":"Ajouter un nouveau Media Engine","MEDIA_ENGINES_ACTION_DELETE":"Supprimer Media Engine","MEDIA_ENGINES_ACTION_EDIT":"Afficher/modifier les détails de Media Engine","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"Impossible d'ajouter un autre  moteur média actif car le serveur utilise déjà actuellement le nombre maximum de moteurs média autorisés par votre licence Portfolio Media Engine.","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"Vous ne pouvez pas ajouter de Media Engine car le serveur ne dispose par de licences Portfolio Media Engine.","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"Vous ne pouvez pas supprimer le Media Engine  intégré.","MEDIA_ENGINES_COLUMN_ACTIVE":"Actif","MEDIA_ENGINES_COLUMN_ADDRESS":"Adresse","MEDIA_ENGINES_COLUMN_PORT":"Port","MEDIA_ENGINES_CONFIRM_DELETE":"Voulez-vous supprimer le moteur média sélectionné ?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Détails de Media Engine","MEDIA_ENGINES_LICENSES_LABEL":"Sièges Media Engine disponibles pour l'activation","MEDIA_ENGINES_NEW_DETAILS_HEADER":"Détails du nouveau Media Engine","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"Aucun Media Engine n'est activé. Vous devriez activer un Media Engine avant que les clients ne doivent utiliser les services de Portfolio Media.","MOBILE":"Mobile","MOBILE_ENABLED":"Activer le téléchargement mobile","MOBILE_FOLDER_VERBIAGE":"Enregistrer les téléchargements mobiles dans ce dossier :","MOBILE_CREATE_CATALOG_VERBIAGE":"Créer un nouveau catalogue « Téléchargements mobiles » pour surveiller automatiquement ce dossier (recommandé)","MOBILE_CATALOG_NAME":"Téléchargements mobiles","modifyAssetContents":"Vérifiez les biens","MODIFY_LDAP":"Modifier demande LDAP","NAME":"Nom","NAME_TOO_LONG_ERROR":"Le nom ne doit pas dépasser 256 caractères","NAV_ABOUT":"À propos de","NAV_ACCESS_LEVELS":"Rôles","NAV_AUTOSYNC":"Synchronisation automatique","NAV_BACKUPS":"Sauvegarde/Restauration","NAV_CATALOGS":"Catalogues","NAV_GLOBAL_SETTINGS":"Paramètres généraux","NAV_HELP":"Aide","NAV_LICENSES":"Licences","NAV_LOGOUT":"Déconnexion","NAV_MEDIA_ENGINES":"Media Engines","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"Ports","NAV_REPORTING":"Rapports","NAV_SETTINGS":"Paramètres","NAV_STATUS":"État","NAV_USERS":"Utilisateurs","NO_CATALOGS":"Aucun","NO_FILE_SELECTED":"Aucun fichier sélectionné","VaultFolderNotFound":"Dossier Portfolio Vault introuvable à l’emplacement {path}.","NO_VAULT_FOLDER":"Dossier Portfolio Vault introuvable à l’emplacement {path}.  Veuillez vérifier l’emplacement du dossier dans votre système de fichiers, et dans la page Paramètres globaux -> Données du serveur de cette application.","NOTES":"Remarques","NUMBER_DECIMAL_POINT_COUNT_ERROR":"Le séparateur de décimal ne peut apparaitre qu'une fois.","NUMBER_EXCEEDS_MAX_ERROR":"Le nombre saisi est trop grand.","NUMBER_INTEGER_ERROR":"Le nombre doit être un entier.","NUMBER_INVALID_CHAR_ERROR":"La saisie contient des caractères non valides.","NUMBER_INVALID_FORMAT_CHARS_ERROR":"Un des paramètres de mise en forme n’est pas valide.","NUMBER_LOWER_THAN_MIN_ERROR":"La quantité saisie est trop petite.","NUMBER_NEGATIVE_ERROR":"La quantité ne doit pas être négative.","NUMBER_PRECISION_ERROR":"La quantité saisie contient trop de chiffres après la décimale.","NUMBER_SEPARATION_ERROR":"Le séparateur des milliers doivent être suivis de trois chiffres.","OK":"OK","ON_DATE":"le","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"Groupes","ORGANIZATION_NAME":"Nom de l’organisation","ORGANIZATIONAL_UNIT":"Unité organisationnelle","PASSWORD":"Mot de passe","PASSWORD_CONFIRM":"Confirmer le mot de passe","PASSWORD_TOO_LONG_ERROR":"Le mot de passe ne doit pas dépasser 256 caractères","PORT":"Port","PORT_VALUE_TOO_HIGH_ERROR":"La valeur du port doit être inférieure à 65536.","PortfolioAssetCap":"Portfolio Asset Cap","PortfolioAPI":"Portfolio API","PortfolioDemo":"Demo","PortfolioDirServices":"Portfolio Directory Services","PortfolioServer":"Portfolio Server","PortfolioStudio":"Portfolio Studio Edition","PortfolioProfessional":"Portfolio Professional Edition","PortfolioEnterprise":"Portfolio Enterprise Edition","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keywords","PortfolioUserConnection":"Connexion utilisateur Portfolio","PortfolioSingleSignOn":"Authentification unique (SSO)","PORT_CURRENT_VALUE":"Valeur actuelle","PORT_ERROR_MSG_BAD_PORT_VALUE":"La nouvelle valeur de port doit être un nombre entre 1 et 65 535.","PORT_ERROR_MSG_CONFLICT":"Vous ne pouvez pas mettre à jour les valeurs de port car une ou plusieurs des nouvelles valeurs sont actuellement utilisées sur le serveur.","PORT_FIND_PORT":"Trouver un port","PORT_NAME":"Nom","PORT_NEW_VALUE":"Nouvelle valeur","PORT_RESTART_NOTICE":"Remarque : les mises à jour du port ne prennent effet qu'après le redémarrage du serveur.","PORT_RESTART_SERVER":"Redémarrer le serveur","PORT_UPDATE_PORTS":"Mettre à jour les ports","PORT_WARNING_ADMIN_RESTART":"Le port d'administration a été modifié. Le navigateur sera redirigé vers le nouvel emplacement dans {numSecs} secondes.","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"Êtes-vous sûr(e) ?","PROMPT_COULD_NOT_CREATE_FOLDER":"Impossible de créer ce dossier. Veuillez entrer un autre chemin.","PROMPT_COULD_NOT_CREATE_FOLDERS":"Saisissez un autre chemin d’accès au dossier, car il est impossible de créer les chemins d’accès suivants :","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"Impossible de créer ce dossier car un fichier existe déjà sous ce nom. Veuillez entrer un autre chemin.","PROMPT_CREATE_THAT_FOLDER":"Ce dossier n'existe pas. Voulez-vous le créer ?","PROMPT_CREATE_THESE_FOLDERS":"Ces dossiers n’existent pas. Voulez-vous les créer ?","PROMPT_DELETE_LICENSE_CONFIRM":"Voulez-vous supprimer la licence sélectionnée?","QUERY":"Requête","REMOVE":"Supprimer","REMOVE_DIRECTORY_SERVICE":"Retirer le service d'annuaire","REPLACE_USER_MAPPING_CONFIRMATION":"Un mappage d'utilisateur régulier existe déjà pour cet utilisateur. Voulez-vous le remplacer par un mappage d'utilisateur exclus?","REPLACE_USER_EXCLUSION_CONFIRMATION":"Un mappage d'utilisateur exclus existe déjà pour cet utilisateur. Voulez-vous le remplacer par un mappage d'utilisateur régulier?","REQUIRED_FIELD_ERROR":"Ce champ est obligatoire","REVERT":"Rétablir","REVERT_CHANGES":"Rétablir les Modifications","ROLE_FOR_IMPORT":"Rôle pour l’importation","ROLES_PERMISSION_ENABLED_HEADER":"Activé","ROLES_PERMISSION_NAME_HEADER":"Opération","SAVE":"Enregistrer","SAVE_MAPPING":"Enregistrer le Mappage","saveOutputSetting":"Gérer les prédéfinitions de conversion et créer un PDF","SEARCH":"Rechercher","SEARCH_BASE":"Base de Recherche","SEARCH_RESULTS":"Résultats de recherche","SECURITY_GROUPS":"Groupes de sécurité","SELECT":"Sélectionner","SEND_DIAGNOSTIC_DATA":"Envoyer le rapport de diagnostic à Portfolio DAM","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"Emplacement du travail par défaut: ","SERVER_RESTART_REQUIRED":"Le serveur doit être redémarré pour que les modifications soient prises en compte.","SERVER_STATE_ERROR":"Erreur : Voir le journal de l'administrateur pour plus de détails","SERVER_STATE_STARTED":"Déroulement","SERVER_STATE_STARTING":"Démarrage","SERVER_STATE_STOPPED":"Arrêté","SERVER_STATE_STOPPING":"Arrêt","SERVER_STATE_UNKNOWN":"Inconnu","SERVICE_BROWSER":"Navigateur de services","SK_ENGINE_APPAREL":"Habillement","SK_ENGINE_CELEBRITIES":"Célébrités","SK_ENGINE_FOOD":"Nourriture","SK_ENGINE_GENERAL":"Généralités.","SK_ENGINE_LOGO":"Logo","SK_ENGINE_MODERATION":"Modération","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"Voyage","SK_ENGINE_WEDDINGS":"Mariages","SSL_HANDSHAKE_ERROR":"L'établissement de liaison SSL a échoué ; veuillez vérifier que les paramètres de port et SSL sont corrects.","STARTS_WITH":"commence par","STATE_OR_PROVINCE":"État ou province","STATUS":"État","STATUS_ADMIN_LOG":"Journal de l'administrateur","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"Sous licence","STATUS_API_STATE_UNLICENSED":"Sans licence","STATUS_CLEAR_ADMIN_LOG":"Effacer le journal de l'administrateur","STATUS_CONNECTED_USERS":"Utilisateurs connectés","STATUS_MAX_ALLOWED_CONNECTIONS":"Nombre maximum de connexions","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Media Engine","STATUS_MEDIA_ENGINES_ACTIVE":"Actif","STATUS_MEDIA_ENGINES_LABEL":"Media Engines","STATUS_RESTART_SERVER":"Redémarrer Portfolio","STATUS_SEAT_USAGE":"Utilisation des postes de travail","STATUS_SERVER_STATE":"Etat de Portfolio","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Démarrer Portfolio","STATUS_STOP_SERVER":"Arrêter Portfolio","STATUS_PROBLEMS_DETECTED":"Problèmes détectés :","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"L’espace restant du disque de démarrage est inférieur à {minSpace} GO.","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"Le dossier de travail n’existe pas ou est inaccessible.","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"Le serveur Portfolio ne peut pas écrire dans le dossier de travail.","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"Le serveur Portfolio ne peut pas lire dans le dossier de travail.","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"Le serveur Portfolio ne peut créer de liens symboliques (symlinks) dans le dossier de travail.","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"L’espace restant du disque du dossier de travail est inférieur à {minSpace} GO.","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"Impossible d’obtenir le statut du dossier de travail.","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"Le statut de l’index Elasticsearch {index} est rouge.","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"L’index Elasticsearch {index} comporte des shards non initialisés.","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"Certains shards sont actifs pour l’index Elasticsearch {index}.","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"Impossible de récupérer le statut d’Elasticsearch.","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"Impossible de récupérer des erreurs du serveur Portfolio.","STATUS_MSG_STARTUP_FAILED":"Le démarrage a échoué","STATUS_MSG_CANT_GET_SERVER_HEALTH":"Impossible de mettre à jour l’intégrité du serveur.","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"Le composant agent natif du serveur n’est pas en cours d’exécution.","SUBJECT_ALTERNATIVE_NAMES":"Autres noms de sujet","SUBMIT":"Soumettre","swedish":"Suédois","SYNC_DAILY":"Synchroniser quotidiennement","SYNCHRONIZE_NOW":"Synchroniser maintenant","TARGET_CATALOG":"Catalogue cible","THIS_LOCALE":"fr","TRUE_LABEL":"Vrai","TOKEN":"Jeton","TOTAL_ASSETS":"Total des actifs","TWO_LETTER_COUNTRY_CODE":"Code pays à deux lettres","TYPE":"Type","UNABLE_CONNECT_LDAP":"Connexion impossible au serveur LDAP/AD.","UNABLE_CONNECT_SERVER":" Connexion impossible au serveur.","UNKNOWN_HOST_ERROR":"Impossible de se connecter au service de répertoire en raison d'une exception d'hôte inconnu. Veuillez vérifier le nom d'hôte.","UNKNOWN_LDAP_USER_ERROR":"Aucun utilisateur n'a été trouvé dans le service d'identité avec le nom d'utilisateur « {accountName} ».","useCustomPresets":"Utiliser les préréglages de conversion","USE_SSL":"Utiliser SSL","USER_ACCOUNT":"Compte","USER_CREATE":"Ajouter un nouvel utilisateur","USER_DELETE":"Supprimer les utilisateurs","USER_DELETE_CONFIRM":"Supprimer les utilisateurs sélectionnés ?","USER_DELETE__DELETE_PRIVATE":"Supprimées définitivement","USER_DELETE__GALLERY_PROMPT":"L'option « Rendre publique » rend publiques toutes les présentations privées ou en lecture seule de l'utilisateur. « Supprimer toutes les présentations privées » supprime de façon permanente les présentations privées et rend publiques les présentations en lecture seule.","USER_DELETE__GALLERY_PROMPT_1":"Les éléments extraits des utilisateurs seront restaurés et rendus accessibles.","USER_DELETE__GALLERY_PROMPT_2":"Les galeries en lecture seule des utilisateurs seront rendues publiques.","USER_DELETE__GALLERY_PROMPT_3":"Les galeries privées des utilisateurs doivent être :","USER_DELETE__MAKE_PUBLIC":"Rendues publiques","USER_DETAILS":"Détails de l'utilisateur","USER_IMPORT":"Importer les utilisateurs","USER_IMPORT_ACCOUNT":"Nom du compte","USER_IMPORT_ACCOUNT_ATTR":"Attribut du compte","USER_IMPORT_EMAIL_ATTR":"Attribut du courrier électronique","USER_IMPORT_IMPORT":"Importer","USER_IMPORT_IMPORT_SELECTED_USERS":"Importer les utilisateurs sélectionnés","USER_IMPORT_MODIFY_SEARCH":"Modifier la recherche","USER_IMPORT_NAME_ATTR":"Attribut du nom de compte","USER_IMPORT_NOTES_ATTR":"Attribut des remarques","USER_IMPORT_PASSWORD":"Mot de passe du compte","USER_IMPORT_PASSWORD_ATTR":"Attribut du mot de passe","USER_IMPORT_SEARCH":"Rechercher","USER_IMPORT_SEARCH_BASE":"Base de recherche","USER_IMPORT_SEARCH_FILTER":"Filtre de recherche","USER_IMPORT_SERVER_ADDRESS":"Adresse du serveur","USER_IMPORT_SPECIFY_LDAP_SERVER":"Spécifier le serveur LDAP","USER_LEVEL_ADMINISTRATOR":"Administrateur du catalogue","USER_LEVEL_EDITOR":"Éditeur","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"Publisher","USER_LEVEL_READER":"Reader","USER_MANAGE_CATALOGS":"Gérer les catalogues des utilisateurs sélectionnés","USER_MULT_USERS_SELECTED":"Plusieurs utilisateurs sélectionnés","USER_NAME":"Nom d'utilisateur","USER_NEW_USER_DETAILS":"Détails du nouvel utilisateur","USER_NEW_USER_INFO_MSG":"Pour ajouter un utilisateur à des catalogues spécifiques, choisissez Catalogues > Utilisateurs.","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"Ajouter l’utilisateur à tous les catalogues comme:","USER_NO_USERS_SELECTED":"Aucun utilisateur sélectionné","USER_ONLINE":"En ligne","USER_PASSWORD_TOO_SHORT":"Le mot de passe doit contenir au moins un caractère.","USER_PASSWORDS_DO_NOT_MATCH":"Le champ de confirmation du mot de passe doit correspondre au champ du mot de passe.","USER_ROLE":"Niveau d'accès","USER_VIEW_DETAILS":"Afficher/modifier les détails de l'utilisateur","USERS":"Utilisateurs","VALIDATION_FIELD_LENGTH_EXCEEDED":"Ce champ ne peut dépasser 255 caractères.","VALIDATION_MUST_BE_NONEMPTY":"Ce champ est obligatoire.","VIEW_EDIT_MAPPINGS":"Afficher / Modifier le mappage","General.OK":"OK","General.Cancel":"Annuler","PORT_TITLE":"Ports","PORT_DEFAULT":"Par défaut :","esp.port.admin-web-app":"Port HTTP administrateur Portfolio","esp.port.admin-web-app-ssl":"Port SSL administrateur Portfolio","esp.port.http":"Port HTTP serveur Portfolio","esp.port.ssl":"Port SSL serveur Portfolio","General.Save":"Enregistrer","CATALOG_DETAILS_FILETYPES_TAB":"Types de fichiers","addAsset":"Ajouter des ressources","canManageFieldLists":"Gérer les listes de champs publics","canModifyFolderStructure":"Modifier les structures du dossier","canMoveAssets":"Déplacer les ressources","deleteAssetContents":"Supprimer les éléments d'origine","deleteAssetFromCatalog":"Supprimer la ressource du catalogue","modifyAssetProperties":"Mettre à jour les champs de ressource","synchronizeAutoSyncFolder":"Synchroniser les dossiers Autosync","ASSETS":"Éléments","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"Créer une catalogue","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"La mémoire système est {value}Go, ce qui est inférieur à la configuration minimale requise de {minGB}Go.","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"La mémoire système calculée par portefeuille est {value}Go, ce qui peut être inexact.","AUTH.couldNotConnect":"Ne peut se connecter au serveur. Veuillez vérifier l'adresse.","ERROR.serverUnavailable":"Le serveur du portefeuille n’est pas disponible.","ERROR.sessionExpired":"Votre session a expiré.","fileNotFound":"Le fichier n'a pas été trouvé sur le disque.","ERROR.invalidSearchFailed":"La recherche a échoué, car il y a eu un problème avec la demande.","AUTH.loginFailed":"Le nom d'utilisateur et le mot de passe étaient incorrects.","FAULT_CODE.InsufficientPrivileges":"Vous ne disposez pas des autorisations nécessaires pour pouvoir effectuer cette opération.","unexpectedError":"Une erreur inattendue est survenue.","ROLES_CREATE_ROLE_TITLE":"Créer le Rôle","ROLES_DELETE_CONFIRM":"Désirez-vous supprimer le rôle sélectionné?\nLes utilisateurs avec ce rôle seront reclassés au niveau inférieur de Lecteur.","NOTIFICATION_SUCCESS_UPDATE":"Mise à jour réussie","DATA_COLLECTION_TITLE":"Analytique","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"Je suis d’accord pour partager des données d’utilisation sur l’application.","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"Aidez-nous à fournir les meilleures solutions en partageant l'utilisation de l'application avec nous.\n\nEn acceptant, vous nous aiderez à rassembler des informations importantes qui vont nous guider afin d’améliorer la qualité et les caractéristiques futures. Les informations rassemblées nous aident à comprendre vos besoins.\n\nVous pouvez toujours changer d’avis à tout moment et interrompre le partage des informations.\n\nPour plus d’informations sur la manière d’utiliser vos informations et vous désabonner dans le futur, veuillez consulter notre page d’aide: ","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/fr/articles/1260804371029","CREATE_USER":"Créer un utilisateur","CATALOG_FILES_TAB_TITLE":"Ingérer","FIELD_CATEGORY_ALL":"Tous Champs Actifs","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"Catalogué","FIELD_DEF.catalogedBy":"Catalogué par","FIELD_DEF.colorMode":"Mode couleur","FIELD_DEF.isPanoramic":"Panoramique","FIELD_DEF.created":"Créé","FIELD_DEF.directoryPath":"Chemin du répertoire","FIELD_DEF.documentText":"Compléter le texte","FIELD_DEF.filename":"Nom de fichier","FIELD_DEF.fileDescription":"Description","FIELD_DEF.fileSize":"Taille du fichier","FIELD_DEF.geometry":"Geo - Carte","FIELD_DEF.height":"Hauteur","FIELD_DEF.horizontalResolution":"Horizontal Resolution","FIELD_DEF.keywords":"Mots-clés","FIELD_DEF.lastModified":"Modifié","FIELD_DEF.lastUpdated":"Changé","FIELD_DEF.aliasMac":"Alias Mac","FIELD_DEF.creatorMac":"Créateur pour Mac","FIELD_DEF.fileTypeMac":"Type de fichier Mac","FIELD_DEF.zoneMac":"Zone Mac","FIELD_DEF.multipageCount":"Nombre de pages","FIELD_DEF.numBands":"Nombre de bandes","FIELD_DEF.path":"Chemin","FIELD_DEF.ItemID":"ID d’élément","FIELD_DEF.shortFilenameWin":"Nom de fichier court Win","FIELD_DEF.thumbnailSize":"Taille de vue miniature","FIELD_DEF.updatedBy":"Modifié par","FIELD_DEF.verticalResolution":"Résolution verticale","FIELD_DEF.volume":"Volume","FIELD_DEF.watermarkURL":"Adresse Internet du filigrane","FIELD_DEF.watermarked":"Avec filigrane","FIELD_DEF.width":"Largeur","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"Actualiser","ALL_CATALOGS":"Tous les catalogues","ALL_SITES":"Tous les sites","ASSET_DOWNLOADS":"Actifs - les plus téléchargés","ASSET_PREVIEWS":"Actifs - Les plus prévisualisés","ASSET_UPLOADS":"Actif - Publications en ligne","DOWNLOAD_REPORT":"Télécharger le rapport","FILE_TYPES":"Types de fichiers","FILE_TYPES_SECTION_TITLE":"Types de fichiers","FILE_TYPES_ERROR_NAME_EXISTS":"Le nom « {name} » correspond au nom d’un type de fichier existant.","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"Réinitialiser les valeurs par défauts","FILE_TYPES_PROMPT_DISCARD_CHANGES":"Ignorer les modifications en attente ?","FILE_TYPES_ADD_FILE_TYPE":"Ajouter le type de fichier","FILE_TYPES_UPDATE_FILE_TYPE":"Mettre à jour le type de fichier","FILE_TYPES_EXTENSIONS":"Extensions","FROM":"Du","SITE":"Site","KEYWORD_STATISTICS":"Statistiques sur les mots-clés","NETPUBLISH_MOST_DOWNLOADED":"NetPublish - Les plus téléchargés","NETPUBLISH_USAGE":"NetPublish - Usage","REPORT_DESCRIPTION_ASSET_PREVIEWS":"Ce rapport identifie les ressources qui ont été prévisualisées et combien de fois chacune a été prévisualisée.","REPORT_DESCRIPTION_ASSET_UPLOADS":"Ce rapport identifie les ressources téléchargées, les utilisateurs qui les ont téléchargées et à quel moment.","REPORT_DESCRIPTION_DOWNLOADED":"Ce rapport identifie les ressources qui ont été téléchargées et combien de fois chacune a été téléchargée.","REPORT_DESCRIPTION_KEYWORD":"Ce rapport identifie tous les mots-clés dans un catalogue et dénombre les ressources auxquelles ils sont appliqués.","REPORT_DESCRIPTION_USAGE":"Ce rapport identifie quels utilisateurs ont téléchargé quelles ressources, et quand.","SEARCH_TERMS":"Termes de recherche","TO":"Au","VIEW_REPORT":"Voir le rapport","NP_SITES":"Sites NetPublish","REPORT_NAME_DELETED_BY":"Actifs - Suppressions","REPORT_NAME_DOWNLOADED_BY":"Actifs - Téléchargements","REPORT_DESCRIPTION_DELETED_BY":"Ce rapport identifie les ressources supprimées, les utilisateurs qui les ont supprimées età quel moment.","REPORT_DESCRIPTION_DOWNLOADED_BY":"Ce rapport identifie les ressources téléchargées, les utilisateurs qui les ont téléchargées età quel moment.","CATALOG_SAVE_TEMPLATE_TITLE":"Sauvegarder le modèle de catalogue","BACKUP_FILES_LABEL":"Fichiers de sauvegarde","CONFIGURE_EMAIL_LINK":"Configurer les notifications par courriel…","NP_SOURCE":"Source","NOTIFICATION_FAILURE_UPDATE":"La mise à jour à échoué","FIELD_FORM_LABEL_PRECISION_MAX":"Max","REPORT_DESCRIPTION_FILE_TYPES":"Ce rapport identifie vos types de fichiers les plus courants et l'espace disque qu'ils occupent.","REPORT_DESCRIPTION_SEARCH_TERMS":"Ce rapport identifie les mots et expressions les plus courants que vos utilisateurs recherchent.","DUPLICATE_FIELD_NAME_ERROR":"Duplication du nom du champ","NO_CATALOGS_EXIST":"Aucun catalogue existant.\n\nCliquez sur le bouton + pour créer un catalogue.","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"Changer les rôles","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"Révoquer l'adhésion","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"Supprimer l’utilisateur du catalogue ?\nLes éléments extraits des utilisateurs dans ce catalogue seront restaurés et rendus accessibles.","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"Voulez-vous vraiment modifier le rôle de l’utilisateur dans le catalogue ? Cette action risque de détruire les données de l’utilisateur si l'accès ou les autorisations liés au nouveau rôle sont réduits.","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"Requête en cours. Cela peut prendre quelques minutes...","FIELD_DELETE_CONFIRM_MSG":"Voulez-vous supprimer le champ sélectionné ?","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"Réinitialiser tous les types de fichiers à leurs valeurs par défaut ?","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"Filtre","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"Active Directory pour utilisateurs et groupes","DIRECTORY_SERVICE_SAVE_MAPPINGS":"Enregistrer et synchroniser","DIRECTORY_SERVICE_REMOVE_MAPPING":"Supprimer le mappage","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Importations d'utilisateurs de Portfolio","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"Aucun mappage.\n\nPour créer un mappage, sélectionnez un utilisateur ou un groupe sur la gauche, puis cliquez sur « Créer un mappage ».","NOTIFICATION_FAILURE_ADD":"Erreur lors de l’ajout.","FIELD_ADD_EXTRACT_METADATA":"Ajouter le mappage de l’extrait","FIELD_MULTIPLE_EMBED_WARNING":"Plus d’un champ est intégré dans","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"Mots-clés intelligents nouveaux actifs catalogués","LIC_CLICK_TO_UPGRADE":"Cliquez pour mettre à niveau Portfolio Server","LIC_MAINTENANCE_END_DATE":"Date de fin de maintenance / abonnement","LIC_SEAT_DISPLAY":"Sièges utilisateur","LIC_ACTIVATE":"Activer Portfolio (identifiants requis)","LIC_CLICK_TO_ACTIVATE":"Cliquez pour activer Portfolio Server","LIC_CLICK_TO_USE":"Cliquez pour utiliser Portfolio pendant une durée limitée","LIC_TRIAL":"Tester Portfolio (numéro de série requis)","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/fr/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/fr/requests/new","LIC_ERROR_GET_ACCOUNT":"Un problème s’est produit pour obtenir votre compte Portfolio DAM.","LIC_ERROR_GET_LICENSES":"Un problème s’est produit lors de la récupération de vos licences Portfolio DAM.","CHANGE":"Modifier","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"Pour modifier ce dossier, vous devez d'abord fermer le serveur Portfolio.","MEDIA_ENGINES_COLUMN_TEST":"Tester","ROLES_PERMISSIONS":"Autorisations","NO_SITES_EXIST_1":"Pas de sites NetPublish.","NO_SITES_EXIST_2":"Utiliser l’option Publier dans Portfolio pour créer et publier des sites.","MEDIA_ENGINE_NOT_OPERATIONAL":"Le moteur média n'était pas accessible.","MEDIA_ENGINE_OPERATIONAL":"Le moteur de médias est opérationnel.","LIC_SET_EXTENSIS_ACCOUNT":"Définir le compte Portfolio DAM","LIC_ACCOUNT":"Adresse email","LIC_PASSWORD":"Mot de passe","CERTS_TITLE":"Certificat SSL","LIC_SYSTEM_ID":"ID système","LIC_SET_ACCOUNT_ERROR":"Un problème s’est produit lors de la configuration de votre compte Portfolio DAM. Veuillez vérifier les identifiants et réessayer.","LIC_SET_SYSTEM_TITLE":"Sélectionnez votre système Portfolio DAM","NP_DELETE_SITE_CONFIRMATION":"Voulez-vous supprimer définitivement le site ?","NP_SITE_DELETE_LABEL":"Supprimer le site","NP_SITE_ENABLED_LABEL":"Site activé","CERT_CREATE_REQUEST":"Créer une demande de certificat","CERT_DOWNLOAD":"Télécharger","CERT_EXPIRATION_DATE":"Date d’expiration","CERT_IMPORT":"Importer un certificat","CERT_ISSUER":"Émetteur","CERT_OWNER":"Propriétaire","CERT_PENDING_REQUEST":"Demande de certificat en attente","CERTIFICATE_STATUS_INVALID":"Certificat non valide","CERTIFICATE_STATUS_SELF_SIGNED":"Certificat non valide : Auto-signé","CERTIFICATE_STATUS_EXPIRED":"Certificat expiré","CERTIFICATE_STATUS_IMPORTED":"Certificat importé","CERT_DELETE_CONFIRMATION":"Voulez-vous vraiment supprimer les polices sélectionnées ? La suppression est irréversible.","DIAGNOSTICS_TITLE":"Diagnostics","DIAGNOSTICS_NO_PROBLEMS":"Aucun problème trouvé","SK_ENGINE_ART_STYLE":"Style d'art","SK_ENGINE_ART_SUBJECT":"Sujet d'art","SK_ENGINE_ART_MOVEMENT":"Mouvement artistique","CERT_FILE":"Fichier certificat","CERT_FILE_INT_1":"Certificat intermédiaire 1","CERT_FILE_INT_2":"Certificat intermédiaire 2","CERT_FILE_PASSWORD":"Mot de passe du certificat","CERT_FILE_PASSWORD_HELP":"Si votre certificat est protégé par un mot de passe, saisissez-le ici","CERT_FILE_PROMPT":"Sélectionner...","CERT_FILE_ROOT":"Certificat racine","CERT_IMPORT_SUCCEEDED":"Le certificat a été importé avec succès. Veuillez redémarrer le serveur Portfolio et les services d’administration Portfolio pour commencer à utiliser le certificat.","CERT_IMPORT_FAILED_READING_PKCS12":"Le serveur n'a pas pu lire le certificat PKCS12. Vérifiez le mot de passe.","CERT_IMPORT_FAILED_INTERMEDIATE1":"Le certificat intermédiaire 1 n’a pas pu être importé.","CERT_IMPORT_FAILED_INTERMEDIATE2":"Le certificat intermédiaire 2 n’a pas pu être importé.","CERT_IMPORT_FAILED_ROOT":"Le certificat racine n'a pas pu être importé.","DIRECTORY_SERVICE_CONFIG_TITLE":"Configuration des services d'annuaire","DIRECTORY_SERVICES_TITLE":"Services d'annuaire","DIRECTORY_SERVICE_MAPIINGS":"Éléments de l’annuaire pour les mappages de Portfolio","DIRECTORY_SERVICE_MAPIINGS_TITLE":"Mappages","PDL_noPredefinedValues":"Aucune valeur prédéfinie","PDL_editPredefinedListPlaceholder":"Modifier la liste prédéfinie","PDL_importPredefinedValues":"Importer des valeurs prédéfinies","PDL_exportPredefinedValues":"Exporter des valeurs prédéfinies","PDL_removeNestedValueConfirmation":"Supprimer les valeurs sélectionnées?\nElles comportent des valeurs imbriquées qui seront également supprimées.","PDL_wrongPdlImportFormat":"Le fichier sélectionné ne contient pas de données textuelles. Veuillez sélectionner un fichier texte.","LIC_SET_ACCOUNT":"Définir un Compte","LIC_REMOVE_ACCOUNT":"Supprimer le Compte","LIC_CONTACT_CUSTOMER_SUCCESS_1":"Pour obtenir de l'aide sur le renouvellement de votre compte, veuillez nous contacter au","LIC_CONTACT_CUSTOMER_SUCCESS_2":"et votre Customer Success Manager vous contactera dans un délai d'un jour ouvrable."});/* eslint-enable */

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"概要","ABOUT_API_TAB":"API","ABOUT_VERSION":"バージョン","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio Server","ABOUT_PORTFOLIO_VERSION":"バージョン 9.0","ABOUT_SERVER_TAB":"サーバー","accessOriginals":"オリジナルへのアクセスおよび処理","ACCOUNT_TYPE":"認証","ACCOUNT_TYPE_LDAP":"ディレクトリサービス","ACCOUNT_TYPE_MANUAL":"ネイティブ (ビルドイン)","ACTIVE_DIRECTORY":"Active Directory","ADD":"追加","ALL_CATALOGS_GROUP":"すべてのカタログ","API_CODE_REFERENCE":"APIコードレファレンス (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"開発者コミュニティ","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"サーバ管理者ヘルプ","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/ja/portfolio/administration/{version}/Content/Home.htm#googtrans(ja)","API_SECTION_1":"開発者はポートフォリオサーバAPIを使うと、ポートフォリオサーバカタログ、アセットのメタデータ、メディアプロセッシングをビジネスシステム、カスタムワークフロー、ウェブインフラストラクチャに統合できるようになります。","API_SECTION_2_PART_1":" ","API_SECTION_2_EULA":"ポートフォリオサーバEULAに記述してあるとおり","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/ja/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":" 、APIの使用にはライセンスが必要です。 ライセンス情報を表示・編集するには、サーバ管理アプリケーションで［ライセンス］をクリックします。","API_SECTION_2_PART_3":"開始：","API_TOKEN_CREATE":"新規APIトークンを追加","APPLY":"適用","APP_PAGE_TITLE":"Portfolio Admin","AT_TIME":"次の時刻に","AUTHENTICATION_ERROR":"ディレクトリサービスの認証が失敗しました。 ユーザー名とパスワードを確認してください。","BACKUP_BACKUP_BUTTON":"バックアップ","BACKUP_BACKUP_LABEL":"バックアップ","BACKUP_BACKUP_NOW_BUTTON":"今すぐバックアップ","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"バックアップの保存場所を変更するには、まずPortfolioのサーバーを終了する必要があります。","BACKUP_CONFIRMATION_VERBIAGE":"今すぐバックアップしますか？バックアップが完了するまで、Portfolioはオフラインになります。","BACKUP_DIRECTORY_LABEL":"ディレクトリに保存","BACKUP_DIRECTORY_ERROR_MSG":"選択したバックアップディレクトリは使用できません。","BACKUP_EXPLANATION_TEXT_1":"バックアップはサーバーのデータベースをキャプチャーして、安全に保存します。\nItはオリジナルファイルをバックアップしません！","BACKUP_EXPLANATION_TEXT_2":"バックアップ中はサーバーに接続できません。","BACKUP_FRIDAY_LABEL":"金曜日","BACKUP_MONDAY_LABEL":"月曜日","BACKUP_MOST_RECENT_LABEL":"最近のバックアップ","BACKUP_NEXT_SCHEDULED_LABEL":"次回のバックアップ","BACKUP_NOTIFICATIONS":"バックアップ/復元後にEmail通知を送信","BACKUP_NOTIFICATIONS_DISABLED_MSG":"グローバル設定＞Email通知で、Email通知を有効化してください。","BACKUP_PROGRESS_BACKING_UP":"バックアップ","BACKUP_PROGRESS_BACKING_UP_DATA":"データをバックアップ中…","BACKUP_PROGRESS_BACKUP_CANCELLED":"バックアップキャンセル","BACKUP_PROGRESS_BACKUP_FAILED":"バックアップ失敗","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"バックアップ成功","BACKUP_PROGRESS_PREFLIGHT":"利用可能な領域をチェック","BACKUP_PROGRESS_RESTARTING":"サーバーを再起動中…","BACKUP_PROGRESS_RESTORE_FAILED":"復元失敗","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"復元成功","BACKUP_PROGRESS_RESTORING":"復元","BACKUP_PROGRESS_RESTORING_DATA":"データを復元中…","BACKUP_PROGRESS_SHUTTING_DOWN":"サーバーを終了中…","BACKUP_PROGRESS_SUMMARY":"ステップ {stepNum}/{totalSteps}","BACKUP_RESTORE_BUTTON":"バックアップファイルから復元","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"今すぐバックアップを復元しますか？復元が完了するまで、Portfolioはオフラインになります。この処理は現在のデータベースと設定を上書きします。","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"バックアップアーカイブが破損しています。他のバックアップを選択してください。","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"バックアップディスクが十分ではありません。","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"現在のバックアップの保存先は存在しません。バックアップの保存先は、復元時にバックアップのアーカイブを解凍するのにも使用されます。有効な保存先を選択しなおしてください。","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"[backup/restore]に問題が発生しました。詳細は管理ログを参照してください。","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"[backup/restore]に問題が発生しました。詳細は管理ログを参照してください。","BACKUP_RESTORE_LABEL":"復元","BACKUP_RESTORE_TITLE":"バックアップ/復元","BACKUP_RETAIN_LABEL":"保存","BACKUP_RETAIN_VALUE":"最近の{numBackups}つのバックアップを保持","BACKUP_SATURDAY_LABEL":"土曜日","BACKUP_SCHEDULE_LABEL":"バックアップをスケジュール","BACKUP_SCHEDULE_VALUE":"に","BACKUP_SUNDAY_LABEL":"日曜日","BACKUP_THURSDAY_LABEL":"木曜日","BACKUP_TUESDAY_LABEL":"火曜日","BACKUP_WEDNESDAY_LABEL":"水曜日","BROWSE":"ブラウズ","BROWSE_FOLDERS_TITLE":"サーバーフォルダ参照","BROWSE_RECENT_FOLDERS_LABEL":"最近使ったフォルダ","BROWSE_REFRESH":"アイテムの同期","CALL_ATT_BUTTON_BUY_NOW":"購入する","CALL_ATT_BUTTON_SECONDARY":"価格についてセールスにお問い合わせ","CALL_ATT_FADEL_BUTTON_MAIN":"より多くの情報のための接触の販売","CALL_ATT_FADEL_MAIN":"ライセンスで保護された画像やムービーなどを正しく使用する助けになります。PortfolioはFADEL Rights Cloudソフトウェアにシームレスに接続して、あなたのアセットに関連づけられている使用権を簡単に確認できるようにします。これによって、ライセンスの調査に必要な時間やコピーライトを違反するリスクを減らすことができるはずです。","CALL_ATT_FADEL_SUBTITLE":"アセットの使用状況の取得","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"高いパフォーマンスの処理と変換","CALL_ATT_ME_MAIN":"Portfolioサーバーのパフォーマンスをさらに向上させたいですか？Media Engineがあれば、処理速度の低下を避け、処理が集中することによって発生するボトルネックを除去して、全体的な生産性を高めることができます。\n\n\t• 処理能力を向上\n\t• 追加の出力形式を使用可能\n\t• ビデオプレビューの作成を高速化\n\t• 必要に応じて複数のMedia Engineを追加\n\t• ウォーターマークを追加（NetPublishが必要です）","CALL_ATT_ME_BUTTON_MAIN":"Media Engineを購入","CALL_ATT_NP_SUBTITLE":"必要なアセットを簡単に見つけることができるセルフサービスのポータルサイト","CALL_ATT_NP_MAIN":"アセットを使用したい人物からのいつも突然のリクエストに辟易していませんか？NetPublishがあれば、誰でもそれぞれのデバイスのブラウザから、必要なアセットを見つけてダウンロードすることができる、セルフサービスのウェブサイトを簡単に作成することができます。\n\n\t• ワンクリックでサイトを作成 - HTMLやCSSの知識は必要ありません\n\t• モバイルデバイスに適したレスポンシブデザイン\n\t• フレキシブルなユーザーアクセス制御\n\t• サイトの使用期限を設定\n\t• ダウンロード時に、解像度、サイズ、形式を設定\n\t• ウォーターマークを追加（Media Engineが必要です）\n\t• 使用状況レポート","CALL_ATT_NP_BUTTON_MAIN":"NetPublishを購入","CALL_ATT_REPORT_TITLE":"NetPublishレポート","CALL_ATT_REPORT_SUBTITLE":"使用状況の適切な解析","CALL_ATT_REPORT_MAIN":"どのサイトが最も頻繁に利用されており、どのアセットが誰に使用されているのかを知りたくはありませんか？NetPublishレポートがあれば、実際にPortfolioがどのように使用されているのかにもとづいて、あなたが根拠のある決定をするために必要な解析結果を取得することができます。\n\n次の分類による使用状況:\n\t• NetPublishサイト名\n\t• ユーザー名\n\t• アセット名とID\n\t• 日時","CALL_ATT_REPORT_BUTTON_MAIN":"NetPublishを購入","CALL_ATT_SK_BUTTON_MAIN":"無料体験版","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/wqqb","CALL_ATT_SK_MAIN":"画像にキーワードを割り当てる作業を高速化したくはありませんか？Portfolio Smart Keywordsを使用すれば、「スマートな」キーワードをワンクリックで自動的に画像に割り当てることができます。この技術は、画像認識に秀でた人工知能を研究する革新的な企業であるClarifaiによって提供されています。\n\n\t・Smart Keywordsとして割り当てられるキーワードのリストはすぐに提供されます。\n\t・今までキーワードの割り当てに費やしていた時間と労力を減らすことができます。\n\t・一貫性のある最適な方法で、あなたの組織の資産となる膨大な画像を分類します。\n\t・必要なデジタルアセットを必要な時に即座に見つけることが容易になるはずです。","CALL_ATT_SK_SUBTITLE":"キーワードを自動的に作成","CALL_ATT_SK_TITLE":"Portfolio Smart Keywords","CALL_ATT_SSO_SUBTITLE":"プラットフォームの種類に影響されない一貫したユーザーエクスペリエンス","CALL_ATT_SSO_TITLE":"シングルサインオン","CALL_ATT_SSO_MAIN":"ログイン認証の信頼性を維持するために、多大な労力が費やされているということはありませんか？一般的には、新しい製品の使用を開始すると、あなたとあなたのユーザーの両方のアカウントを管理するために、追加費用が必要になります。\n\n幸いなことに、Portfolioはアクティブディレクトリによるシングルサインオンをサポートしています。シングルサインオンを使用すれば、ユーザーはあなたの社内ネットワークから自動的にPortfolioにログインすることができ、連続的なユーザーエクスペリエンスの提供を受けることができます。\n\n\t• Windows Serverのアクティブディレクトリをサポート\n\t• 全体的なセキュリティを向上\n\t• ユーザーの管理を簡略化\n\t• ユーザーエクスペリエンスを向上","CALL_ATT_SSO_BUTTON_MAIN":"シングルサインオンを購入","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/portfolio/contact-me","canEmbedMetadata":"メタデータの埋め込み","canImportMetadata":"データの読み込み / データの書き出し","canManagePublicGallery":"パブリック ギャラリーの管理","canPublishNetPublishSites":"NetPublishサイトの発行","canSmartKeyword":"Smart Keywordの使用","CANCEL":"キャンセル","CATALOG":"カタログ","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"メンバシップを与える","CATALOG_BACKUP":"選択したカタログをバックアップ","CATALOG_CREATE":"新規カタログを追加","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"カタログ管理者は、デスクトップクライアントにてオートシンクフォルダを追加できます。","CATALOG_CREATE_AUTOSYNC_FOLDER":"オートシンクフォルダを作成","CATALOG_CREATE_CATALOG_TEMPLATE":"カタログテンプレート","CATALOG_TYPE_GENERAL":"汎用","CATALOG_TYPE_SIMPLE":"簡易","CATALOG_CREATE_DATABASES_LIST_LABEL":"データベース","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"{folder}　フォルダを作成中にエラーが発生しました。","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"オートシンクおよびプレビューのデフォルトフォルダは、グローバル設定で変更できます。","CATALOG_CREATE_NAME":"名前","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"カタログ詳細にてプレビュー設定ができます。","CATALOG_CREATE_PREVIEW_FOLDER":"プレビューの表示速度を向上するには、プレビューを保存します","CATALOG_CREATE_SHOW_DATABASES":"データベースを表示","CATALOG_CREATE_USE_VERSIONING":"アセットのバージョン管理を使用","CATALOG_DELETE":"カタログを削除","CATALOG_DELETE_CONFIRM":"選択したカタログを削除しますか?","CATALOG_DETAILS":"カタログの詳細情報","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"カタログの名前を変更するには、このカタログを一時的にオフラインにする必要があります。続行しますか?","CATALOG_DETAILS_COLLATION":"対象","CATALOG_DETAILS_COLLATION_NA":"なし","CATALOG_DETAILS_CREATION_DATE":"作成日","CATALOG_DETAILS_DATABASE_TAB":"一般","CATALOG_DETAILS_LAST_MODIFIED":"最終修正日","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"接続しているユーザー","CATALOG_DETAILS_NUMBER_OF_RECORDS":"レコード","CATALOG_DETAILS_NUMBER_OF_USERS":"メンバ","CATALOG_DETAILS_SIZE_ON_DISK":"ディスク上のサイズ","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"管理者ユーザーの接続を解除します。続行してよろしいですか?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"管理用にロック","CATALOG_DETAILS_UNLOCK":"ロック解除","CATALOG_EXPLANATION_VAULT_1":"Vaultカタログはアセットを安全なリポジトリに保管します。","CATALOG_EXPLANATION_VAULT_2":"Vaultカタログは、ロック、バージョン管理、チェックアウトおよびチェックインをサポートします。","CATALOG_EXPLANATION_WF_1":"監視フォルダカタログはアセットの元の場所を参照します。","CATALOG_EXPLANATION_WF_2":"監視フォルダカタログはオートシンクをサポートします。","CATALOG_INGEST_DRAG_HINT_TEXT":"アップロードフォームにフィールドを追加するには、フィールドリストからドラッグしてください。","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"アップロードフォームのフィールド","CATALOG_INGEST_FIELDS_LABEL":"フィールド","CATALOG_INGEST_FORM_HEADER_LABEL":"フォームヘッダー","CATALOG_INGEST_HEADER_HINT_TEXT":"フォームヘッダーは、フォームの一番上に表示されるオプションです。","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"フォームに追加できるフィールドの最大数は{maxFields}です。","CATALOG_INGEST_TAB_TITLE":"管理されたアップロード","CATALOG_INGEST_USE_INGEST_LABEL":"管理されたアップロードを使用","CATALOG_INGEST_REQUIRED_LABEL":"必須","CATALOG_IS_CONNECTED":"接続済み","CATALOG_IS_DEFAULT":"デフォルト","CATALOG_MANAGE_USERS":"カタログのメンバシップを管理","CATALOG_MANAGE_FIELDS":"カタログフィールドの管理","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"カタログテンプレートを管理","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"カスタムカタログテンプレートを管理","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"カタログテンプレート名","CATALOG_MEMBER":"メンバ","CATALOG_NEW_CATALOG_DETAILS":"新規カタログの詳細情報","CATALOG_OFFLINE":"オフライン","CATALOG_ONLINE":"オンライン","CATALOG_OPTIONS_ALL_FILE_TYPES":"全てのファイルタイプをカタログ化","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"パスからキーワードを作成","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"ファイル名","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"上位フォルダ","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"サーバー名","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"フォルダ構造","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"ボリューム","CATALOG_OPTIONS_EXCLUSION_LABEL":"除外するファイルとフォルダ","CATALOG_OPTIONS_ONLY_FILE_TYPES":"次のファイルタイプのみカタログ化","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"選択したファイルタイプを削除しますか？","endsWith":"で終わる","contains":"含む","startsWith":"で始まる","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"選択した除外を削除しますか？","CATALOG_OPTIONS_TAB_TITLE":"カタログ作成オプション","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"デフォルトの場所","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"最小サイズ300ピクセル、最大サイズ4000ピクセル（長辺）","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"オーディオ/ビデオファイルのクリップを作成","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"プレビューを作成","CATALOG_PREVIEWS_FOLDER_LOCATION":"プレビューとクリップを次のフォルダに保存","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"サーバーから参照可能な場所に指定する必要があります。","CATALOG_PREVIEWS_MAX_PIXELS":"最大画像サイズ","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"最大動画解像度","CATALOG_PREVIEWS_MINUTES":"分","CATALOG_PREVIEWS_PIXELS":"ピクセル","CATALOG_PREVIEWS_SHORT":"プレビュー","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"時間制限","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"クリップの作成には時間がかかります。\n処理時間を短縮するには解像度と継続時間の値を下げてください。","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"メンバシップを取り消し","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"カタログからユーザーを削除しますか？\nユーザーのこのカタログのチェックアウトアイテムが復帰して、アクセス可能になります。","CATALOG_SAVE_TEMPLATE":"カタログテンプレートを保存","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"保存したテンプレートには、フィールド、メタデータのマッピング、カタログ作成オプションの設定が含まれています。","CATALOG_SELECT_MESSAGE":"カタログ未選択","CATALOG_SET_AS_DEFAULT":"デフォルトカタログを設定","CATALOG_SK_DEFAULT_SETTINGS":"デフォルト設定","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"精度","CATALOG_SK_DEFAULT_LABEL":"推奨: {recommended}","CATALOG_SK_ENGINES_LABEL":"Smart Keywordエンジン","CATALOG_SK_LANGUAGES_LABEL":"General Engineの言語","CATALOG_SK_NUM_KEYWORDS_LABEL":"キーワード数","CATALOG_SK_SETTINGS_LABEL":"設定","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"このカタログでSmart Keywordsを使用","CATALOG_STATUS":"カタログの状態","CATALOG_STORAGE_TYPE_LABEL":"ストレージタイプ","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"監視フォルダ","CATALOG_STORAGE_TYPE_VAULT":"Vault","CATALOG_TAKE_OFFLINE_SHORT":"オフラインにする","CATALOG_TAKE_ONLINE_SHORT":"オンラインにする","CATALOG_TEMPLATE":"テンプレート","CATALOG_TEMPLATE_NAME":"テンプレート名","CATALOG_TEMPLATES_TITLE":"カタログテンプレート","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"選択したカタログテンプレートを削除しますか？","CATALOG_VIEW_DETAILS":"カタログ詳細情報を表示/編集","CERT_REQUEST_ALREADY_CREATED_WARNING":"証明書リクエストは既に作成されています。続行すると既存のリクエストは削除されます。","CERTIFICATE_FILE_FILTER":"証明書 (p7b, p7, cer, crt, pem, pfx, p12)","CITY_OR_LOCALITY":"市または地域","CLEAR_BUTTON_LABEL":"消去","COMMUNICATION_AT_INITILIZATION_ERROR":"サーバー接続時にエラー。これはブラウザのキャッシュに含まれる古いデータが原因になることが良くありますが、サーバー側の問題の可能性もあります。詳細な情報については管理者にお問い合わせください。","CONFIGURE_DIRECTORY_SERVICE":"ディレクトリサービスを設定","CONFIRM_DELETE_PDL":"全ての定義済みの値を削除しますか？","CONFIRM_DELETE_SERVICE":"ディレクトリサービスを削除しますか?\nサービスからインポートされたユーザは残ります。 これらのユーザのパスワードは、以前 Portfolio で設定された値に戻ります。以前設定されていない場合は無効になります。","CONFIRM_TRUNCATE_VALUES":"最大の長さが、デフォルト値か定義済みの値の一つ以上を超えています。値を切り捨てますか？","CONNECTION_REFUSED_ERROR":"ディレクトリサービスへの接続が拒否されました。 ホスト名とポートの設定を確認してください。","CONTAINS":"を含む","CONTINUE":"続ける","CREATE":"作成","CREATE_A_CERTIFICATE_REQUEST":"証明書署名リクエストを作成","createContactSheet":"PDF 作成","CREATED_BY":"作成者","CREATE_MAPPING":"マッピングを作成","CREATE_USER_EXCLUSION_MAPPING":"ユーザーを除外","CREATED_ON_DATE":"作成日","DATE_FORMAT":"YYYY-MM-DD","DATE_FORMAT_ERROR":"設定エラー：不正な形式の文字列です。","DATE_INVALID_CHAR_ERROR":"使用できない文字が含まれています。","DATE_TIME_FORMAT":"YYYY-MM-DD L:NN A","DATE_TIME_SECONDS_FORMAT":"YYYY-MM-DD L:NN:SS A","DATE_WRONG_DAY_ERROR":"有効な日付を入力してください。","DATE_WRONG_LENGTH_ERROR":"日付を入力してください。","DATE_WRONG_MONTH_ERROR":"1〜12の月を入力","DATE_WRONG_YEAR_ERROR":"0〜9999の年を入力","DEFAULT_ACCESS_LEVEL":"デフォルトの役割","DEFAULT_CATALOG":"デフォルトカタログ","DEFAULT_CATALOG_NONE":"なし","DEFAULT_PORT_NON_SSL":"非SSL用のデフォルトポート:","DEFAULT_PORT_SSL":"SSL用のデフォルトポート:","DELETE":"削除","DELETE_SOURCE":"ソースを削除","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"全ての値を削除しますか？ネスト化された値も全て削除されます。","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"{value}'の値を削除しますか？\nネスト化された値も削除されます。","DELETE_NESTED_VALUE_CONFIRMATION":"選択した値を削除しますか？","DELETE_WARNING_BOX_MSG":"警告 いったん削除を実行すると、操作を取り消すことはできません!","DELETE_WARNING_CATALOG_VAULT":"カタログのすべてのファイルは破壊される。","DIAGNOSTIC_DATA_TITLE":"Portfolio DAMに診断レポートを送信","DIAGNOSTIC_DATA_ACCOUNT_NAME":"会社名（必須）","DIAGNOSTIC_DATA_CONTACT_NAME":"担当者名","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"テクニカルサポートチケット番号","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"レポートを送信","DIAGNOSTIC_STATUS_ERROR":"{date} の診断レポートをアップロード中に問題が発生しました。","DIAGNOSTIC_STATUS_SENDING":"発送...","DIAGNOSTIC_STATUS_SUCCESS":"{date} にPortfolio DAMへ正しく送信された診断レポート","DIRECTORY_SERVICE_CONNECT_ERROR":"ディレクトリサービスに接続できません。 ホスト名とポートの設定を確認してください。","DIRECTORY_SERVICES":"ディレクトリサービス","DIRECTORY_USERS_CANNOT_BE_DELETED":"ディレクトリサービスのユーザーは削除できません。","DISTRIBUTION_GROUPS":"配布グループ","DOWNLOAD_CERT_PROMPT":"証明書リクエストファイルをダウンロードしますか？","DOWNLOAD_COMPLETE_STRING":"ダウンロード完了","downloadPreviews":"プレビューをダウンロード","EMAIL_ADDRESS":"電子メールアドレス","EMAIL_CONFIG_AUTH_PASSWORD":"パスワード","EMAIL_CONFIG_AUTH_USERNAME":"ユーザー名","EMAIL_CONFIG_ENABLED":"Email通知を有効化","EMAIL_CONFIG_FROM_ADDRESS":"差出人Emailアドレス","EMAIL_CONFIG_INVALID_GENERIC":"Emailサーバーの設定が無効です","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"Emailサーバーが見つかりません","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"Emailサーバーの認証に失敗しました","EMAIL_CONFIG_MESSAGE":"通知を受け取りたいユーザーのEmailアドレスをユーザーパネルで設定してください。","EMAIL_CONFIG_SERVER_ADDRESS":"SMTPサーバーアドレス","EMAIL_CONFIG_SERVER_PORT":"SMTPサーバーポート","EMAIL_CONFIG_SUCCESS_MESSAGE":"SMTPサーバーが有効です","EMAIL_CONFIG_USE_SSL_TLS":"SSL/TLSを使用","EMAIL_CONFIG_USE_SMTP_AUTH":"SMTP認証を使用","EMAIL_CONFIG_VALIDATE":"接続テスト","EMAIL_CONFIG_VALIDATED":"Emailサーバーが有効です","english":"英語","ENTIRE_TREE_UNDER_SEARCH_BASE":"検索ベース内のツリー全体","EQUALS":"等しい","EXPORT_MENU_STRING":"値の書き出し","FADEL_HOWTO":"FADELのアカウントへのログイン:","FALSE_LABEL":"偽の","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"管理サーバーがローカルコンピュータ上で動作しており、ポートページで表示されているポートを使っていることを確認してください。 そのようになっていない場合は、サーバーを再起動し、このアプリケーションを再び読み込んでください。","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"この処理は、バックアップ中もしくは復元中には行えません。","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"カタログが管理者モードになっているため、この操作を行うことができません。","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"この名前のカタログはすでに存在します。","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"このアカウント名のユーザーはすでに存在しています。","FAULT_MSG_DB_IN_USE":"現在、管理者がカタログを使用しているため、この操作を完了することができません。","FAULT_MSG_DELETE_ADMIN":"管理者アカウントを削除することはできません。","FAULT_MSG_DELETE_SELF":"自分のユーザーアカウントを削除することはできません。","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"カタログテンプレートの削除に予期しないエラーが発生しました。","FAULT_MSG_DUPE_NAME":"この名前のオブジェクトはすでに存在します。 他の名前を使ってください。","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"このアドレスとポート番号を使っている Media Engine はすでに存在します。","FAULT_MSG_ENTITY_VERSION_MISMATCH":" クライアント情報が古いため、この操作を行うことができません。","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"サーバーがローカルコンピュータ上で動作しており、ポートページで表示されているポートを使っていることを確認してください。 そのようになっていない場合は、サーバーを再起動し、このアプリケーションを再び読み込んでください。","FAULT_MSG_INVALID_SESSION_ID":"セッションが時間切れになりました。 もう一度サーバーにログインしてください。","FAULT_MSG_IS_NOT_LICENSED":"この操作を行うのに必要なライセンスがサーバーにありません。","FAULT_MSG_LEGACY_21000":"不明な内部エラーが発生したため、この操作に失敗しました。","FAULT_MSG_LOGGING_ERR_UPDATE":"ログ設定の更新時にエラーが発生しました","FAULT_MSG_LOG_DIR_NOT_VALID":"指定されたログディレクトリは存在しないか、指定されたパスはディレクトリではありません。","FAULT_MSG_NO_DIRECTORY":"指定された場所は存在しないか、ディレクトリではありません。","FAULT_MSG_NULL_DESCRIPTION":"予期しないエラーが発生しましたが、内容は不明です。","FAULT_MSG_NULL_FAULTEVENT":"予期しないエラーが発生しましたが、詳細は不明です。","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"十分なアクセス権がないため、この操作を行うことができません。","FAULT_MSG_OPERATION_IS_INVALID":"不正な操作です。","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"カタログテンプレート名の変更に予期しないエラーが発生しました。","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"カタログテンプレートの保存に予期しないエラーが発生しました。","FAULT_MSG_SERVER_NOT_RUNNING":"サーバーが動作していません。","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"Enterprise Module ライセンスが見つからないため処理に失敗。","FAULT_MSG_REMOVE_METADATA_DEF":"メタデータの定義の削除に失敗しました。他のカタログで使用中の可能性があります。","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"サーバーがエラーを返しました。メッセージ内容:","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"サーバーがエラーを返しました。エラーメッセージはありません。","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"サーバーが不明な種類のエラーを返しました。メッセージ内容:","FAULT_MSG_UNKNOWN_SMTP_SERVER":"指定されたEmailサーバーに接続できません。","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"サービスが、なっているはずの状態にないため、この操作を行うことができません。","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"データベースに提供されたユーザ名またはパスワードは無効です。","FAULT_MSG_BAD_DB_PORT":"データベースのポートは無効です。","FAULT_MSG_BAD_DB_HOST":"データベースのホスト名またはポートの設定が無効です。","FIELD_ACTION_ADD":"新しいカスタムフィールドを追加","FIELD_ACTION_DELETE":"選択したフィールドを削除","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"XMP名前スペース","FIELD_ACTION_MANAGE_METADATA":"メタデータの管理","FIELD_CATEGORY_CUSTOM":"カスタムフィールド","FIELD_CATEGORY_SYSTEM":"システムフィールド","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"ムービー","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"フィールドカテゴリー","FIELD_DISABLE_CONFIRM_MSG":"選択したフィールドを無効にしますか？","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"すべて許可","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"抽出マッピングを追加","FIELD_FORM_LABEL_DEFAULT_VALUE":"デフォルト値","FIELD_FORM_LABEL_DISABLED":"（禁止）","FIELD_FORM_LABEL_EMBED":"メタデータの埋め込み","FIELD_FORM_LABEL_EXTRACT":"メタデータの抽出","FIELD_FORM_LABEL_FIELD_NAME":"フィールド名","FIELD_FORM_LABEL_FIELD_TYPE":"フィールドタイプ","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"複数の値を許可","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"定義済みの値を保持","FIELD_FORM_LABEL_HELP_TEXT":"ヘルプテキスト","FIELD_FORM_LABEL_MAX":"最大：{max}","FIELD_FORM_LABEL_MAX_LENGTH":"最大の長さ","FIELD_FORM_LABEL_METADATA_TAG":"メタデータ名","FIELD_FORM_LABEL_METADATA_TYPE":"メタデータタイプ","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"定義済みの値のみ許可","FIELD_FORM_LABEL_PRECISION":"精度","FIELD_FORM_LABEL_PREDEFINED_VALUES":"定義済みの値","FIELD_FORM_LABEL_SHOW_TIME":"時刻の表示","FIELD_FORM_LABEL_USE_METADATA":"メタデータの抽出と埋め込み","FIELD_FORM_WARNING_DUPE_EMBEDS":"警告：複数のフィールドが '{metadata}' に埋め込まれます","FIELD_METADATA_DATA_TYPE_LABEL":"データの種類","FIELD_METADATA_DEFINITION_IS_CUSTOM":"カスタム","FIELD_METADATA_DEFINITIONS_TITLE":"メタデータの定義","FIELD_METADATA_DELETE_CONFIRM_MSG":"確認：メタデータの定義を削除しますか？","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"複数の値を許可されたタイプ","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"単一の値のみ許可","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"整列","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"整列なし","FIELD_METADATA_NAME_LABEL":"名前","FIELD_METADATA_NAMESPACE_LABEL":"名前スペース","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"カスタムXMP名前スペースの追加","FIELD_METADATA_TAG_LABEL":"タグ","FIELD_METADATA_TYPE_LABEL":"タイプ","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"複数のフィールドが選択されています。","FIELD_NAMESPACE_ABBREVIATION":"省略","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"カスタムXMP名前スペースを削除しますか？\n名前スペースを使用したフィールドの定義が存在している可能性があります。","FIELD_NAMESPACE_URI":"名前スペースURI","FIELD_NEW_FIELD_NAME":"新しいフィールド","FIELD_NEW_METADATA_TITLE":"新しいメタデータの定義","FIELD_NEW_NAMESPACE_TITLE":"新しいカスタムXMP名前スペース","FIELD_NO_FIELD_SELECTED_MESSAGE":"フィールドが選択されていません。","FIELD_PAGE_TITLE":"カタログ'{catalogName}'のフィールドの管理","FIELD_REVERT_CONFIRM_MSG":"確認：フィールドを元に戻しますか？","FIELD_TYPE_BLOB":"BLOB","FIELD_TYPE_BOOLEAN":"論理","FIELD_TYPE_DATETIME":"日付/時刻","FIELD_TYPE_DECIMAL":"少数","FIELD_TYPE_LANG_ALT":"言語","FIELD_TYPE_NUMBER":"数値","FIELD_TYPE_PICTURE":"写真","FIELD_TYPE_STRING":"文字列","FIELD_TYPE_STRUCTURE":"構造","FIELD_TYPE_TEXTBLOCK":"テキストブロック","FIELD_TYPE_UNKNOWN":"未定義","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"サーバーへのファイルアップロードにエラーがありました。","FILE_WRONG_TYPE_ERROR_MSG":"このファイル形式はサポートされていません。.jpegまたは.gif、.pngファイルを選択してください。","FOLDER_PATH_AUTOSYNC_FILES_STRING":"ファイル","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"同名ファイルが存在します。","FOLDER_PATH_DOES_NOT_EXIST":"パスは存在しません。","FOLDER_PATH_ERROR":"エラー","FOLDER_PATH_NOT_VERIFIED":"フォルダパスは未確認です。","FOLDER_PATH_PATH":"パス","FOLDER_PATH_OPERATION_INVALID":"無効な処理","FOLDER_PATH_SUCCESS":"成功","FOLDER_PATH_TYPE_AUTOSYNC":"オートシンク","FOLDER_PATH_TYPE_PREVIEW":"プレビュー","FOLDER_PATH_UNKNOWN_FAULT":"原因不明の失敗","french":"フランス語","FULL_NAME":"フルネーム","FULLY_QUALIFIED_DOMAIN_NAME":"完全なドメイン名（FQDN）","german":"ドイツ語","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"新規カタログのオートシンクフォルダを次のフォルダ内に作成","GLOBAL_SETTINGS_BACKGROUND_COLOR":"背景カラー","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"ログイン画面の背景カラー","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"デフォルトカタログ","GLOBAL_SETTINGS_CHOOSE_FILE":"ファイルを選択","GLOBAL_SETTINGS_CUSTOM_IMAGE":"カスタムイメージ","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"適切なサイズは2400 x 13500ピクセル内です。","GLOBAL_SETTINGS_CUSTOM_TITLE":"カスタムタイトル","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"このタイトルはブラウザタブやブックマークに表示されます。","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"カスタマイズされたログイン画面","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"デフォルトの役割","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"初期ログイン画面","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"Email通知","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"オートシンクフォルダとプレビューフォルダの場所は、サーバーからアクセスできなければなりません。","GLOBAL_SETTINGS_IMAGE_URL":"リンク","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"画像をクリックして他のブラウザウィンドウ内でこのURLを表示します。","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"変更するには、サーバーを起動するか、期限切れのサーバーライセンスをチェックしてください。","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"新規カタログのプレビューを次のフォルダ内に保存","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"サーバーデータの場所","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"ログインのカスタマイゼーション","GLOBAL_SETTINGS_SSO_CREDENTIALS":"シングルサインオン証明書","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"ケルベロス認証を利用しているPortfolio Serverサービスに関連づけられたユーザーアカウントを入力してください。","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"一時作業フォルダ","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"作業フォルダは次回のサーバー起動時には変更されます。新しいフォルダは次の場所に作成されます:","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"設定の変更を有効にするには、サーバーを再起動する必要があります。","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Portfolio Vault設定","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Portfolio Vaultフォルダ:","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Portfolio Vaultのデフォルトの場所:","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"Portfolio Vaultを移動するには、まずサーバーを終了する必要があります。","HELP_URL":"https://helpdocs.portfoliodam.com/ja/portfolio/administration/{version}/Content/Home.htm#googtrans(ja)","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/ja/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"ホスト名","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(デフォルト)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"ディレクトリサービスの接続に成功。設定は保存されました。","IMAGE_FILE_FILTER":"画像 (jpg, gif, png)","IMPORT_LDAP":"LDAP/AD サーバーからユーザーをインポート","IMPORT_LDAP_SPECIFY_SERVER":"LDAP/AD サーバーを指定","IMPORT_MENU_STRING":"値の読み込み","IMPORT_SOURCE":"ソースをインポート","INVALID_DN_SYNTAX_ERROR":"指定した DN の形式に誤りがあるため (Invalid DN syntax)、ディレクトリサービスに接続できません。 ユーザー名を確認してください。","japanese":"日本語","LAST_CERTIFICATE_REQUEST_LABEL":"最終証明書リクエスト","LAST_MODIFIED_BY":"最終修正者","LAST_MODIFIED_DATE":"最終修正日","LDAP_ADDRESS":"LDAP/AD サーバーのアドレス","LDAP_BIND_USERNAME":"LDAP バインドユーザー名","LDAP_SYNC_NOTIFICATION":"サーバーは同期要求を受信しました。","LIC_ADD_MESSAGE":"ライセンスをコピー＆ペーストするか、1列ずつ個別に入力してください。","LIC_ADD_SN":"新規ライセンスを追加","LIC_ADD_SN_SHORT":"ライセンスを追加","LIC_ASSET_CAP_DISPLAY":"アセット","LIC_DAYS_REMAINING":"（残り {days} 日）","LIC_DEMO_PERIOD":"試用期間","LIC_ERROR_MSG":"不正なシリアル番号です。やり直してください。問題が回避できない場合は、サーバーのログを確認するか、管理者に連絡してください。","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"シリアル番号をPortfolio Studioに追加することができません。","LITE_CANNOT_CREATE_FDB_CATALOG":"お持ちのライセンスでは、カタログをこれ以上増やすことはできません。アップグレードをご検討ください。","LITE_CANNOT_SERVE_FDB_CATALOG":"この Portfolio Server ライセンスでは、これ以上オンラインでカタログ作成できません。","LITE_THIS_FEATURE_NOT_SUPPORTED":"この Portfolio Server ライセンスでは、処理をサポートしていません。","LOGGING_CONFIGURATION":"ログ設定","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"ログの保存場所を変更するには、まずPortfolioのサーバーを終了する必要があります。","LOGGING_DEFAULT_LOCATION_MSG":"デフォルトの場所","LOGGING_DIR_MUST_EXIST":"注意: ログディレクトリを正しく変更するには、既に新しいディレクトリが存在している必要があります。","LOGGING_LOG_DIR":"ログディレクトリ","LOGGING_LOG_LEVEL":"ログレベル:","LOGGING_NUM_LOGS_TO_RETAIN":"保存するログ数","LOGIN":"ログイン","MAPPING_HEADER":"Portfolio ユーザー/グループのマッピング","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"マッピングが変更されました。保存しますか?","MEDIA_ENGINES_ACTION_ADD":"新規 Media Engine を追加","MEDIA_ENGINES_ACTION_DELETE":"Media Engine を削除","MEDIA_ENGINES_ACTION_EDIT":"Media Engine 詳細情報を表示/編集","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"お持ちの Portfolio Media Engine ライセンスで指定された最大数の Media Engine がサーバーでアクティブになっているため、新たな Media Engine をアクティブにすることができません。","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"利用可能な Portfolio Media Engine ライセンスがサーバーにないため、Media Engine を追加することはできません。","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"Media Engine でこのビルドを削除することはできません。","MEDIA_ENGINES_COLUMN_ACTIVE":"使用可能","MEDIA_ENGINES_COLUMN_ADDRESS":"アドレス","MEDIA_ENGINES_COLUMN_PORT":"ポート","MEDIA_ENGINES_CONFIRM_DELETE":"選択したメディアエンジンを削除しますか?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Media Engine の詳細情報","MEDIA_ENGINES_LICENSES_LABEL":"Media Engine のアクティベーションに利用可能","MEDIA_ENGINES_NEW_DETAILS_HEADER":"新規 Media Engine の詳細情報","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"動作している Media Engine がありません。 Portfolio Media サービスを使用するには、Media Engine を開始する必要があります。","MOBILE":"モバイル","MOBILE_ENABLED":"モバイルアップロードを有効","MOBILE_FOLDER_VERBIAGE":"モバイルアップロードをこのフォルダに保存:","MOBILE_CREATE_CATALOG_VERBIAGE":"このフォルダを自動監視する新規カタログ「モバイルアップロード」を作成（推奨）","MOBILE_CATALOG_NAME":"モバイルアップロード","modifyAssetContents":"アセットのチェックアウト","MODIFY_LDAP":"LDAP クエリーを変更","NAME":"名前","NAME_TOO_LONG_ERROR":"名前は 1 バイト文字換算で 256 文字未満にしてください","NAV_ABOUT":"バージョン情報","NAV_ACCESS_LEVELS":"役割","NAV_AUTOSYNC":"オートシンク","NAV_BACKUPS":"バックアップ/復元","NAV_CATALOGS":"カタログ","NAV_GLOBAL_SETTINGS":"グローバル設定","NAV_HELP":"ヘルプ","NAV_LICENSES":"ライセンス","NAV_LOGOUT":"ログアウト","NAV_MEDIA_ENGINES":"Media Engine","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"ポート","NAV_REPORTING":"レポート作成","NAV_SETTINGS":"設定","NAV_STATUS":"ステータス","NAV_USERS":"ユーザー","NO_CATALOGS":"なし","NO_FILE_SELECTED":"ファイルが選択されていません","VaultFolderNotFound":"Portfolio Vaultフォルダが {path} にありませんでした。","NO_VAULT_FOLDER":"Portfolio Vaultフォルダが {path} にありませんでした。フォルダの実際の場所と、グローバル設定のサーバーデータページを確認してください。","NOTES":"メモ","NUMBER_DECIMAL_POINT_COUNT_ERROR":"小数点は一度だけ使用できます。","NUMBER_EXCEEDS_MAX_ERROR":"入力した数値が大きすぎます。","NUMBER_INTEGER_ERROR":"数値は整数である必要があります。","NUMBER_INVALID_CHAR_ERROR":"不正な文字が含まれています。","NUMBER_INVALID_FORMAT_CHARS_ERROR":"形式のパラメータの一つが不正です。","NUMBER_LOWER_THAN_MIN_ERROR":"合計が小さすぎます。","NUMBER_NEGATIVE_ERROR":"合計がマイナスの可能性があります。","NUMBER_PRECISION_ERROR":"小数点以下の桁数が多すぎます。","NUMBER_SEPARATION_ERROR":"桁区切り文字は三桁ごとに入力してください。","OK":"OK","ON_DATE":"に","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"グループ","ORGANIZATION_NAME":"組織名","ORGANIZATIONAL_UNIT":"部門名","PASSWORD":"パスワード","PASSWORD_CONFIRM":"パスワードの確認","PASSWORD_TOO_LONG_ERROR":"パスワードは 1 バイト文字換算で 256 文字未満にしてください","PORT":"ポート","PORT_VALUE_TOO_HIGH_ERROR":"ポートの値は、65536以下である必要があります。","PortfolioAssetCap":"Portfolioアセット容量","PortfolioAPI":"Portfolio API","PortfolioDemo":"デモ","PortfolioDirServices":"Portfolioディレクトリサービス","PortfolioServer":"Portfolio Server","PortfolioStudio":"Portfolio Studioエディション","PortfolioProfessional":"Portfolio Professionalエディション","PortfolioEnterprise":"Portfolio Enterpriseエディション","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keywords","PortfolioUserConnection":"Portfolio User接続","PortfolioSingleSignOn":"シングルサインオン（SSO）","PORT_CURRENT_VALUE":"現在の値","PORT_ERROR_MSG_BAD_PORT_VALUE":"新しいポート番号は、1～65535 の数値で入力してください。","PORT_ERROR_MSG_CONFLICT":"サーバーですでに使用されているポート番号が指定されたため、ポート番号を変更することができません。","PORT_FIND_PORT":"ポートを検索","PORT_NAME":"名前","PORT_NEW_VALUE":"新しい値","PORT_RESTART_NOTICE":"注意: ポート番号の変更を適用するには、サーバーを再起動してください。","PORT_RESTART_SERVER":"サーバーを再起動","PORT_UPDATE_PORTS":"ポートを変更","PORT_WARNING_ADMIN_RESTART":"管理用ポートが変更されました。 {numSecs} 秒後に、新しいページが表示されます。","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"実行しますか?","PROMPT_COULD_NOT_CREATE_FOLDER":"このフォルダを作成することができません。 別のパスを入力してください。","PROMPT_COULD_NOT_CREATE_FOLDERS":"次のパスは作成できなかったため、別フォルダのパスを入力してください。","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"同じ名前を持つファイルがすでに存在するため、このフォルダを作成することができません。 別のパスを入力してください。","PROMPT_CREATE_THAT_FOLDER":"このフォルダが存在しません。 作成しますか?","PROMPT_CREATE_THESE_FOLDERS":"このフォルダは存在しません。フォルダを新規作成してよろしいですか?","PROMPT_DELETE_LICENSE_CONFIRM":"選択したライセンスを削除してよろしいですか?","QUERY":"クエリー","REMOVE":"削除","REMOVE_DIRECTORY_SERVICE":"ディレクトリサービスを削除する","REPLACE_USER_MAPPING_CONFIRMATION":"通常のユーザーマッピングが、このユーザーに対してすでに存在しています。 除外ユーザーマッピングで置き換えますか?","REPLACE_USER_EXCLUSION_CONFIRMATION":"除外ユーザーマッピングが、このユーザーに対してすでに存在しています。 通常のユーザーマッピングで置き換えますか?","REQUIRED_FIELD_ERROR":"このフィールドは必須です","REVERT":"元に戻す","REVERT_CHANGES":"変更を元に戻す","ROLE_FOR_IMPORT":"インポートユーザーの役割","ROLES_PERMISSION_ENABLED_HEADER":"使用可能","ROLES_PERMISSION_NAME_HEADER":"操作","SAVE":"保存","SAVE_MAPPING":"マッピングを保存","saveOutputSetting":"プリセットを管理しなさい(改宗者はPDFを作り、)","SEARCH":"検索","SEARCH_BASE":"検索ベース","SEARCH_RESULTS":"検索結果","SECURITY_GROUPS":"セキュリティグループ","SELECT":"選択","SEND_DIAGNOSTIC_DATA":"Portfolio DAMに診断レポートを送信","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"デフォルトの作業場所","SERVER_RESTART_REQUIRED":"訂正内容を有効にするためには、サーバを再起動する必要があります。","SERVER_STATE_ERROR":"エラー: 管理ログで詳細を見る","SERVER_STATE_STARTED":"動作中","SERVER_STATE_STARTING":"起動しています","SERVER_STATE_STOPPED":"停止しました","SERVER_STATE_STOPPING":"停止しています","SERVER_STATE_UNKNOWN":"不明","SERVICE_BROWSER":"サービスブラウザ","SK_ENGINE_APPAREL":"服装","SK_ENGINE_CELEBRITIES":"名声","SK_ENGINE_FOOD":"食品","SK_ENGINE_GENERAL":"一般","SK_ENGINE_LOGO":"ロゴ","SK_ENGINE_MODERATION":"モデレーション","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"旅行","SK_ENGINE_WEDDINGS":"結婚式","SSL_HANDSHAKE_ERROR":"SSL ハンドシェイクに失敗しました。ポートと SSL 設定が正しいことを確認してください。","STARTS_WITH":"で始まる","STATE_OR_PROVINCE":"国または州","STATUS":"ステータス","STATUS_ADMIN_LOG":"管理ログ","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"ライセンスあり","STATUS_API_STATE_UNLICENSED":"ライセンスなし","STATUS_CLEAR_ADMIN_LOG":"管理ログを消去","STATUS_CONNECTED_USERS":"接続ユーザー","STATUS_MAX_ALLOWED_CONNECTIONS":"最大接続数","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Media Engine","STATUS_MEDIA_ENGINES_ACTIVE":"使用可能","STATUS_MEDIA_ENGINES_LABEL":"Media Engine","STATUS_RESTART_SERVER":"Portfolioの再起動","STATUS_SEAT_USAGE":"使用中","STATUS_SERVER_STATE":"Portfolioの状態","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Portfolioの起動","STATUS_STOP_SERVER":"Portfolioの停止","STATUS_PROBLEMS_DETECTED":"検出された問題：","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"起動ディスクの空き容量が {minSpace}GB 以下になっています。","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"作業フォルダが存在しないかアクセスできません。","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"Portfolioは作業フォルダに書き込みできません。","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"Portfolioは作業フォルダから読み取りできません。","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"Portfolioは作業フォルダにシンボリックリンクを作成できません。","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"作業フォルダのあるディスクの空き容量が {minSpace}GB 以下になっています。","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"作業フォルダのステータスを取得できません。","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"Elasticsearchのインデックス {index} のステータスがレッドになっています。","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"Elasticsearchのインデックス {index} に初期化されていないシャードがあります。","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"Elasticsearchのインデックス {index} の全てのシャードがアクティブになっていません。","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"Elasticsearchのステータスを収集できません。","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"Portfolioサーバーからエラーを収集できません。","STATUS_MSG_STARTUP_FAILED":"起動失敗","STATUS_MSG_CANT_GET_SERVER_HEALTH":"サーバーの状態を確認できません","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"サーバーのnative-agentコンポーネントが動作していません。","SUBJECT_ALTERNATIVE_NAMES":"サブジェクトの別名（SANs）","SUBMIT":"送信","swedish":"スウェーデン語","SYNC_DAILY":"毎日同期","SYNCHRONIZE_NOW":"同期化を実行","TARGET_CATALOG":"対象カタログ","THIS_LOCALE":"ja","TRUE_LABEL":"真の","TOKEN":"トークン","TOTAL_ASSETS":"アセットの合計","TWO_LETTER_COUNTRY_CODE":"2文字国コード","TYPE":"タイプ","UNABLE_CONNECT_LDAP":"LDAP/AD サーバーに接続できません。","UNABLE_CONNECT_SERVER":"サーバーに接続できません。","UNKNOWN_HOST_ERROR":"不明なホストによる例外が発生したため、ディレクトリサービスに接続できません。 ホスト名を確認してください。","UNKNOWN_LDAP_USER_ERROR":"ID サービスはアカウント名 「{accountName}」 のユーザを見つけられませんでした。","useCustomPresets":"変換プリセットの使用","USE_SSL":"SSL を使用","USER_ACCOUNT":"アカウント","USER_CREATE":"新規ユーザーを追加","USER_DELETE":"ユーザーを削除","USER_DELETE_CONFIRM":"選択したユーザーを削除しますか?","USER_DELETE__DELETE_PRIVATE":"完全に削除します。","USER_DELETE__GALLERY_PROMPT":"パブリックにすると、このユーザーが所有するすべてのプライベートおよび閲覧専用ギャラリーが、パブリックギャラリーになります。 「プライベートギャラリーをすべて削除」は、プライベートギャラリーを完全に削除し、閲覧専用ギャラリーをパブリックにします。","USER_DELETE__GALLERY_PROMPT_1":"ユーザーのチェックアウトアイテムが復帰して、アクセス可能になります。","USER_DELETE__GALLERY_PROMPT_2":"ユーザーの閲覧専用ギャラリーがパブリックになります。","USER_DELETE__GALLERY_PROMPT_3":"ユーザーのプライベートギャラリーを","USER_DELETE__MAKE_PUBLIC":"パブリックにします。","USER_DETAILS":"ユーザーの詳細情報","USER_IMPORT":"ユーザーをインポート","USER_IMPORT_ACCOUNT":"アカウント名","USER_IMPORT_ACCOUNT_ATTR":"アカウントの属性","USER_IMPORT_EMAIL_ATTR":"電子メールの属性","USER_IMPORT_IMPORT":"インポート","USER_IMPORT_IMPORT_SELECTED_USERS":"選択したユーザーをインポート","USER_IMPORT_MODIFY_SEARCH":"検索条件を変更","USER_IMPORT_NAME_ATTR":"アカウント名の属性","USER_IMPORT_NOTES_ATTR":"メモの属性","USER_IMPORT_PASSWORD":"アカウントのパスワード","USER_IMPORT_PASSWORD_ATTR":"パスワードの属性","USER_IMPORT_SEARCH":"検索","USER_IMPORT_SEARCH_BASE":"検索ベース","USER_IMPORT_SEARCH_FILTER":"検索フィルタ","USER_IMPORT_SERVER_ADDRESS":"サーバーのアドレス","USER_IMPORT_SPECIFY_LDAP_SERVER":"LDAP サーバーを指定","USER_LEVEL_ADMINISTRATOR":"カタログ管理者","USER_LEVEL_EDITOR":"編集者","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"発行者","USER_LEVEL_READER":"閲覧者","USER_MANAGE_CATALOGS":"選択したユーザーに対してカタログを管理","USER_MULT_USERS_SELECTED":"複数のユーザーを選択","USER_NAME":"ユーザー名","USER_NEW_USER_DETAILS":"新規ユーザーの詳細情報","USER_NEW_USER_INFO_MSG":"ユーザーを特定のカタログに追加するには、カタログ > ユーザー。","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"ユーザーを全カタログに追加:","USER_NO_USERS_SELECTED":"ユーザー未選択","USER_ONLINE":"オンライン","USER_PASSWORD_TOO_SHORT":"パスワードには、少なくとも 1 文字が必要です。","USER_PASSWORDS_DO_NOT_MATCH":"確認用パスワードがパスワードと一致しません。","USER_ROLE":"アクセスレベル","USER_VIEW_DETAILS":"ユーザー詳細情報を表示/編集","USERS":"ユーザー","VALIDATION_FIELD_LENGTH_EXCEEDED":"このフィールドは最大 255 文字まで入力できます。","VALIDATION_MUST_BE_NONEMPTY":"このフィールドは必須です。","VIEW_EDIT_MAPPINGS":"マッピングの表示/編集","General.OK":"OK","General.Cancel":"キャンセル","PORT_TITLE":"ポート","PORT_DEFAULT":"デフォルト:","esp.port.admin-web-app":"Portfolioアドミン HTTPポート","esp.port.admin-web-app-ssl":"Portfolioアドミン SSLポート","esp.port.http":"Portfolioサーバー HTTPポート","esp.port.ssl":"Portfolioサーバー SSLポート","General.Save":"保存","CATALOG_DETAILS_FILETYPES_TAB":"ファイルタイプ","addAsset":"アセットを追加","canManageFieldLists":"パブリックフィールドの一覧を管理","canModifyFolderStructure":"フォルダ階層を編集","canMoveAssets":"アセットを移動","deleteAssetContents":"オリジナルアセットの削除","deleteAssetFromCatalog":"カタログからアセットを削除","modifyAssetProperties":"アセットのフィールドを更新","synchronizeAutoSyncFolder":"監視フォルダを同期","ASSETS":"アセット","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"カタログを作成","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"システムのメモリは{value}GBですが、最小動作環境は{minGB}GBです。","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"Portfolioが計算したシステムのメモリは{value}GBですが、これは正しくない可能性があります。","AUTH.couldNotConnect":"サーバーに接続できません。アドレスを確認してください。","ERROR.serverUnavailable":"Portfolioサーバーを使用できません。","ERROR.sessionExpired":"セッションの期限が切れました。","fileNotFound":"ディスク上にファイルが見つかりません。","ERROR.invalidSearchFailed":"サーバーへのリクエストに問題が発生したため検索に失敗しました。","AUTH.loginFailed":"ユーザー名とパスワードが間違っています。","FAULT_CODE.InsufficientPrivileges":"この操作に必要な権限がありません。","unexpectedError":"予期しないエラーが発生しました。","ROLES_CREATE_ROLE_TITLE":"役割を作成","ROLES_DELETE_CONFIRM":"選択した役割を削除しますか？\nこの役割のユーザーは閲覧者になります。","NOTIFICATION_SUCCESS_UPDATE":"アップデートに成功しました","DATA_COLLECTION_TITLE":"分析","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"私は、アプリケーションの使用データを共有することに同意します。","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"アプリケーションの使用状況を共有して、当社が最適なソリューションを提供できるようにご協力ください。\n\nこれにより、今後の品質や機能の向上に役立つ重要な情報を収集することができます。収集された情報は、お客様のソリューションニーズを理解するのに役立ちます。\n\n情報のご提供はいつでも中止できます。\n\n収集した情報の使用方法や情報提供を中止する方法の詳細については、次の記事をご確認ください。 ","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/ja/articles/360010122274","CREATE_USER":"ユーザーを作成","CATALOG_FILES_TAB_TITLE":"取り込み","FIELD_CATEGORY_ALL":"全使用中フィールド","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"カタログ登録日","FIELD_DEF.catalogedBy":"カタログ登録者","FIELD_DEF.colorMode":"カラーモード","FIELD_DEF.isPanoramic":"パノラマ","FIELD_DEF.created":"作成日","FIELD_DEF.directoryPath":"ディレクトリパス","FIELD_DEF.documentText":"文書テキスト","FIELD_DEF.filename":"ファイル名","FIELD_DEF.fileDescription":"説明","FIELD_DEF.fileSize":"ファイルサイズ","FIELD_DEF.geometry":"Geo - マップ","FIELD_DEF.height":"高さ","FIELD_DEF.horizontalResolution":"水平解像度","FIELD_DEF.keywords":"キーワード","FIELD_DEF.lastModified":"変更日","FIELD_DEF.lastUpdated":"設定日","FIELD_DEF.aliasMac":"Mac エイリアス","FIELD_DEF.creatorMac":"クリエータ (Mac)","FIELD_DEF.fileTypeMac":"ファイルタイプ (Mac)","FIELD_DEF.zoneMac":"AppleTalk ゾーン","FIELD_DEF.multipageCount":"ページ数","FIELD_DEF.numBands":"バンドの番号","FIELD_DEF.path":"パス","FIELD_DEF.ItemID":"アセット ID","FIELD_DEF.shortFilenameWin":"ショートファイル名 (Win)","FIELD_DEF.thumbnailSize":"サムネールのサイズ","FIELD_DEF.updatedBy":"設定者","FIELD_DEF.verticalResolution":"垂直解像度","FIELD_DEF.volume":"ボリューム名","FIELD_DEF.watermarkURL":"透かしの URL","FIELD_DEF.watermarked":"透かし付き","FIELD_DEF.width":"幅","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"更新","ALL_CATALOGS":"すべてのカタログ","ALL_SITES":"すべてのサイト","ASSET_DOWNLOADS":"アセット - 最多ダウンロード","ASSET_PREVIEWS":"アセット - 最多プレビュー","ASSET_UPLOADS":"アセット - アップロード","DOWNLOAD_REPORT":"レポートをダウンロード","FILE_TYPES":"ファイルタイプ","FILE_TYPES_SECTION_TITLE":"ファイルタイプ","FILE_TYPES_ERROR_NAME_EXISTS":"{name}' は既存のファイ","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"初期化","FILE_TYPES_PROMPT_DISCARD_CHANGES":"保留中の変更を破棄しますか？","FILE_TYPES_ADD_FILE_TYPE":"ファイルタイプを追加","FILE_TYPES_UPDATE_FILE_TYPE":"ファイルタイプを更新","FILE_TYPES_EXTENSIONS":"拡張子","FROM":"から","SITE":"サイト","KEYWORD_STATISTICS":"キーワード統計","NETPUBLISH_MOST_DOWNLOADED":"NetPublish - ダウンロード状況","NETPUBLISH_USAGE":"NetPublish - 使用状況","REPORT_DESCRIPTION_ASSET_PREVIEWS":"どのアセットがそれぞれ何回プレビューされたかについてのレポートです。","REPORT_DESCRIPTION_ASSET_UPLOADS":"アップロードされたアセット、アップロードしたユーザー、そしてその日時についてのレポートです。","REPORT_DESCRIPTION_DOWNLOADED":"どのアセットがそれぞれ何回ダウンロードされたかについてのレポートです。","REPORT_DESCRIPTION_KEYWORD":"カタログの全キーワードとそれらが適用されているアセット数についてのレポートです。","REPORT_DESCRIPTION_USAGE":"どのユーザーが何のアセットをいつダウンロードしたかについてのレポートです。","SEARCH_TERMS":"検索語句","TO":"まで","VIEW_REPORT":"レポートを表示","NP_SITES":"NetPublishサイト","REPORT_NAME_DELETED_BY":"アセット - 削除","REPORT_NAME_DOWNLOADED_BY":"アセット - ダウンロード","REPORT_DESCRIPTION_DELETED_BY":"削除されたアセット、削除したユーザー、そしてその日時についてのレポートです。","REPORT_DESCRIPTION_DOWNLOADED_BY":"ダウンロードされたアセット、ダウンロードしたユーザー、そしてその日時についてのレポートです。","CATALOG_SAVE_TEMPLATE_TITLE":"カタログテンプレートを作成","BACKUP_FILES_LABEL":"バックアップファイル","CONFIGURE_EMAIL_LINK":"Email通知を設定","NP_SOURCE":"ソース","NOTIFICATION_FAILURE_UPDATE":"アップデートに失敗しました","FIELD_FORM_LABEL_PRECISION_MAX":"最大","REPORT_DESCRIPTION_FILE_TYPES":"最も一般的なファイルタイプとそのディスク容量についてのレポートです。","REPORT_DESCRIPTION_SEARCH_TERMS":"最も一般的な検索語句についてのレポートです。","DUPLICATE_FIELD_NAME_ERROR":"フィールド名を複製","NO_CATALOGS_EXIST":"カタログがありません。\n\n+ボタンをクリックしてカタログを作成してください。","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"役割を変更します","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"メンバシップを取り消し","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"カタログからユーザーを削除しますか？\nユーザーのこのカタログのチェックアウトアイテムが復帰して、アクセス可能になります。","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"本当にユーザーの役割を変更しますか？変更後の役割に許可されている機能が少ないと、ユーザーのデータが失われる可能性があります。","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"問い合わせ中です。数分かかる可能性があります。","FIELD_DELETE_CONFIRM_MSG":"選択したフィールドを削除しますか？","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"全てのファイルタイプを初期化しますか？","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"フィルタ","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"AD ユーザーとグループ","DIRECTORY_SERVICE_SAVE_MAPPINGS":"保存して同期","DIRECTORY_SERVICE_REMOVE_MAPPING":"マッピングを削除","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Portfolioユーザーの取り込み","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"マッピングがありません。\n\nユーザーかグループを選択して「マッピングを作成」をクリックしてください。","NOTIFICATION_FAILURE_ADD":"追加失敗","FIELD_ADD_EXTRACT_METADATA":"抽出マッピングを追加","FIELD_MULTIPLE_EMBED_WARNING":"複数のフィールドが に埋め込まれます","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"カタログに新規登録されたアセットにSmart Keywordを追加","LIC_CLICK_TO_UPGRADE":"Portfolio Serverをアップグレードするにはクリックします。","LIC_MAINTENANCE_END_DATE":"メンテナンス/サブスクリプションの終了日","LIC_SEAT_DISPLAY":"シートを使用","LIC_ACTIVATE":"Portfolioをアクティベート (要認証情報)","LIC_CLICK_TO_ACTIVATE":"Portfolio Serverをアクティベートするにはクリックします。","LIC_CLICK_TO_USE":"Portfolioを一時的に使用するにはクリックします。","LIC_TRIAL":"Portfolioを試用 (要シリアル番号)","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/en-us/requests/new","LIC_ERROR_GET_ACCOUNT":"Portfolio DAMアカウントの取得に問題が発生しました。","LIC_ERROR_GET_LICENSES":"Portfolio DAMからライセンスを復帰するのに問題が発生しました。","CHANGE":"変更","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"このフォルダを変更するには、Portfolioサーバーを終了してください。","MEDIA_ENGINES_COLUMN_TEST":"テスト","ROLES_PERMISSIONS":"許可","NO_SITES_EXIST_1":"NetPublishサイトがありません","NO_SITES_EXIST_2":"Portfolio WebのPublishオプションを使用して、サイトを作成して発行してください。","MEDIA_ENGINE_NOT_OPERATIONAL":"Media Engineは利用不可です。","MEDIA_ENGINE_OPERATIONAL":"Media Engineは稼働中です。","LIC_SET_EXTENSIS_ACCOUNT":"Portfolio DAMアカウントを設定","LIC_ACCOUNT":"電子メールアドレス","LIC_PASSWORD":"パスワード","CERTS_TITLE":"SSL証明書","LIC_SYSTEM_ID":"システムID","LIC_SET_ACCOUNT_ERROR":"Portfolio DAMアカウントの設定に問題が発生しました。認証情報を確認して再度お試しください。","LIC_SET_SYSTEM_TITLE":"Portfolio DAMシステムを選択","NP_DELETE_SITE_CONFIRMATION":"サイトを完全に削除しますか？","NP_SITE_DELETE_LABEL":"サイトを削除","NP_SITE_ENABLED_LABEL":"有効サイト","CERT_CREATE_REQUEST":"証明書要求を作成","CERT_DOWNLOAD":"ダウンロード","CERT_EXPIRATION_DATE":"有効期限","CERT_IMPORT":"証明書を取り込む","CERT_ISSUER":"発行元","CERT_OWNER":"所有者","CERT_PENDING_REQUEST":"保留中の証明書リクエスト","CERTIFICATE_STATUS_INVALID":"無効な証明書","CERTIFICATE_STATUS_SELF_SIGNED":"無効な証明書：自己署名","CERTIFICATE_STATUS_EXPIRED":"証明書の期限が切れています","CERTIFICATE_STATUS_IMPORTED":"証明書が取り込まれています","CERT_DELETE_CONFIRMATION":"証明書リクエストを本当に削除しますか？ この操作は取り消しできません。","DIAGNOSTICS_TITLE":"診断","DIAGNOSTICS_NO_PROBLEMS":"問題なし","SK_ENGINE_ART_STYLE":"アートスタイル","SK_ENGINE_ART_SUBJECT":"アート科目","SK_ENGINE_ART_MOVEMENT":"アートムーブメント","CERT_FILE":"証明書ファイル","CERT_FILE_INT_1":"中間証明書 1","CERT_FILE_INT_2":"中間証明書 2","CERT_FILE_PASSWORD":"証明書パスワード","CERT_FILE_PASSWORD_HELP":"証明書にパスワードが設定されている場合はここに入力します","CERT_FILE_PROMPT":"選択","CERT_FILE_ROOT":"ルート証明書","CERT_IMPORT_SUCCEEDED":"証明書の取り込みに成功しました。証明書を使用するには、PortfolioサーバーとPortfolio adminサービスを再起動します。","CERT_IMPORT_FAILED_READING_PKCS12":"PKCS12証明書を取り込めませんでした。パスワードを確認してください。","CERT_IMPORT_FAILED_INTERMEDIATE1":"中間証明書を取り込めませんでした。","CERT_IMPORT_FAILED_INTERMEDIATE2":"中間証明書を取り込めませんでした。","CERT_IMPORT_FAILED_ROOT":"ルート証明書を取り込めませんでした。","DIRECTORY_SERVICE_CONFIG_TITLE":"ディレクトリサービスの設定","DIRECTORY_SERVICES_TITLE":"ディレクトリサービス","DIRECTORY_SERVICE_MAPIINGS":"Portfolioマッピングのディレクトリアイテム","DIRECTORY_SERVICE_MAPIINGS_TITLE":"マッピング","PDL_noPredefinedValues":"定義済みの値なし","PDL_editPredefinedListPlaceholder":"定義済みの値のリストを編集","PDL_importPredefinedValues":"定義済みの値を読み込む","PDL_exportPredefinedValues":"定義済みの値を書き出す","PDL_removeNestedValueConfirmation":"選択した値を削除しますか？\n選択した値に含まれる下位の値も一緒に削除されます。","PDL_wrongPdlImportFormat":"選択したファイルにはテキストデータがありませんでした。テキストファイルを選択してください。","LIC_SET_ACCOUNT":"アカウントを設定","LIC_REMOVE_ACCOUNT":"アカウントを削除","LIC_CONTACT_CUSTOMER_SUCCESS_1":"アカウントの更新についてサポートが必要な場合は、","LIC_CONTACT_CUSTOMER_SUCCESS_2":"までご連絡ください。カスタマーサクセスマネージャーから1営業日以内にご連絡いたします。"});/* eslint-enable */

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes *//* harmony default export */ __webpack_exports__["a"] = ({"ABOUT":"Tema","ABOUT_API_TAB":"API","ABOUT_VERSION":"Versione","ABOUT_EXTENSIS_URL":"www.portfoliodam.com","ABOUT_PORTFOLIO_SERVER":"Portfolio Server","ABOUT_PORTFOLIO_VERSION":"Versione 9.0","ABOUT_SERVER_TAB":"Server","accessOriginals":"Accedi agli originali ed elaborali","ACCOUNT_TYPE":"Autenticazione","ACCOUNT_TYPE_LDAP":"Servizio Directory","ACCOUNT_TYPE_MANUAL":"Nativo (incorporato)","ACTIVE_DIRECTORY":"Active Directory","ADD":"Aggiungi","ALL_CATALOGS_GROUP":"Tutti i cataloghi","API_CODE_REFERENCE":"Riferimento codice API (English)","API_CODE_REFERENCE_URL":"https://doc.portfoliodam.com/api/portfolio/index.html","API_DEVELOPER_COMMUNITY":"Community degli sviluppatori","API_DEVELOPER_COMMUNITY_URL":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","API_PORTFOLIO_HELP":"Guida di Portfolio Administration","API_PORTFOLIO_HELP_URL":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","API_SECTION_1":"L'API di Portfolio fornisce agli sviluppatori un'interfaccia comune per integrare i cataloghi di Portfolio, i metadati degli asset e l'elaborazione dei media nei sistemi aziendali, nei flussi di lavoro personalizzati e nelle infrastrutture web.","API_SECTION_2_PART_1":"Per utilizzare l'API sono necessarie delle licenze, come descritto ","API_SECTION_2_EULA":"nell'EULA di Portfolio","API_SECTION_2_EULA_URL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","API_SECTION_2_PART_2":". Per visualizzare o modificare le informazioni su una licenza, fare clic su 'Licenze' nell'applicazione Portfolio Administration.","API_SECTION_2_PART_3":"Per sapere di più:","API_TOKEN_CREATE":"Aggiungi nuovo Token API","APPLY":"Applica","APP_PAGE_TITLE":"Portfolio Admin","AT_TIME":"alle ore","AUTHENTICATION_ERROR":"Autenticazione servizio directory non riuscita. Controllare nome utente e password.","BACKUP_BACKUP_BUTTON":"Backup","BACKUP_BACKUP_LABEL":"Backup","BACKUP_BACKUP_NOW_BUTTON":"Esegui il backup adesso","BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Per cambiare la posizione di backup, spegnere prima il server del Portfolio.","BACKUP_CONFIRMATION_VERBIAGE":"Esegui il backup adesso? Il Portfolio sarà offline fino a quando il backup non è completo.","BACKUP_DIRECTORY_LABEL":"Archivia nella directory","BACKUP_DIRECTORY_ERROR_MSG":"La directory di backup selezionata non è valida.","BACKUP_EXPLANATION_TEXT_1":"Con il backup si acquisiscono e si archiviano i database del server e le impostazioni in modo sicuro.\nlt non esegue il backup dei file delle risorse originali!","BACKUP_EXPLANATION_TEXT_2":"Non sarà possibile accedere al server durante i backup.","BACKUP_FRIDAY_LABEL":"Venerdì","BACKUP_MONDAY_LABEL":"Lunedì","BACKUP_MOST_RECENT_LABEL":"Il backup più recente","BACKUP_NEXT_SCHEDULED_LABEL":"Prossimo backup pianificato","BACKUP_NOTIFICATIONS":"Inviare una notifica per e-mail dopo backup e ripristini","BACKUP_NOTIFICATIONS_DISABLED_MSG":"Notifiche via e-mail deve essere abilitato in Impostazioni globali > Notifiche via e-mail","BACKUP_PROGRESS_BACKING_UP":"Backup in corso","BACKUP_PROGRESS_BACKING_UP_DATA":"Backup dei dati in corso...","BACKUP_PROGRESS_BACKUP_CANCELLED":"Backup cancellato","BACKUP_PROGRESS_BACKUP_FAILED":"Backup non riuscito","BACKUP_PROGRESS_BACKUP_SUCCESSFUL":"Backup eseguito con successo","BACKUP_PROGRESS_PREFLIGHT":"Controllo spazio disponibile...","BACKUP_PROGRESS_RESTARTING":"Riavvio server in corso...","BACKUP_PROGRESS_RESTORE_FAILED":"Ripristino fallito","BACKUP_PROGRESS_RESTORE_SUCCESSFUL":"Ripristino eseguito con successo","BACKUP_PROGRESS_RESTORING":"Ripristino in corso","BACKUP_PROGRESS_RESTORING_DATA":"Ripristino dati in corso...","BACKUP_PROGRESS_SHUTTING_DOWN":"Spegnimento server in corso...","BACKUP_PROGRESS_SUMMARY":"Passaggio {stepNum} di {totalSteps}","BACKUP_RESTORE_BUTTON":"Ripristino dal file di backup in corso...","BACKUP_RESTORE_CONFIRMATION_VERBIAGE":"Ripristinare il backup adesso? Il Portfolio sarà offline fino a quando il ripristino non è completo. Il database e le impostazioni correnti verranno sovrascritte.","BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":"L'archivio di backup è danneggiato. Scegli un altro backup da cui eseguire il ripristino.","BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":"Lo spazio nel disco di backup non è sufficiente\nper completare.\n\n{requiredSpace} necessari, {availableSpace} disponibili.","BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":"La posizione di backup correntemente configurata non esiste. La posizione di backup è utilizzata per decomprimere l’archivio quando un backup è in ripristino. Ripristina la posizione di backup in una directory valida.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":"Si è verificato un problema con il backup. Consultare i registri admin per i dettagli.","BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":"Si è verificato un problema con il ripristino. Consultare i registri admin per i dettagli.","BACKUP_RESTORE_LABEL":"Ripristino","BACKUP_RESTORE_TITLE":"Backup/Ripristino","BACKUP_RETAIN_LABEL":"Conserva","BACKUP_RETAIN_VALUE":"Tenere solo i {numBackups} backup più recenti","BACKUP_SATURDAY_LABEL":"Sabato","BACKUP_SCHEDULE_LABEL":"Pianifica i backup","BACKUP_SCHEDULE_VALUE":"il","BACKUP_SUNDAY_LABEL":"Domenica","BACKUP_THURSDAY_LABEL":"Giovedì","BACKUP_TUESDAY_LABEL":"Martedì","BACKUP_WEDNESDAY_LABEL":"Mercoledì","BROWSE":"Sfoglia","BROWSE_FOLDERS_TITLE":"Sfoglia le cartelle del server","BROWSE_RECENT_FOLDERS_LABEL":"Cartelle recenti","BROWSE_REFRESH":"Sincronizza articoli","CALL_ATT_BUTTON_BUY_NOW":"Acquista ora","CALL_ATT_BUTTON_SECONDARY":"Contatta l'ufficio vendite per un preventivo","CALL_ATT_FADEL_BUTTON_MAIN":"Vendite del contatto per più informazioni","CALL_ATT_FADEL_MAIN":"Assicurati un uso corretto dei contenuti soggetti a licenza, dalle immagini ai video e tutto ciò che comprendono. Portfolio si collega senza problemi al software FADEL Rights Cloud in modo da poter vedere e comprendere facilmente l'uso di diritti associati alle proprie risorse—aiutandoti a rimuovere le strettorie del flusso di lavoro e ridurre il rischio di violazioni del diritto d'autore.","CALL_ATT_FADEL_SUBTITLE":"Conosci i tuoi diritti di uso delle risorse","CALL_ATT_FADEL_TITLE":"FADEL RIGHTS CLOUD","CALL_ATT_ME_SUBTITLE":"Gestione e conversione ad alte prestazioni","CALL_ATT_ME_MAIN":"Spingere i limiti prestazionali del proprio server Portfolio? Con Media Engine, si evitano rallentamenti e si migliora la produttività generale eliminando i colli di bottiglia causati da ambienti di produzione sovraccarichi.\n\n\t• Aumenta rendimento e velocità\n\t• Sblocca formati di uscita aggiuntivi\n\t• Accelera creazione anteprima video\n\t• Aggiungi più motori multimediali secondo necessità\n\t• Filigrana (richiede NetPublish)","CALL_ATT_ME_BUTTON_MAIN":"Ottieni Media Engine","CALL_ATT_NP_SUBTITLE":"Portali Self-Service per accedere immediatamente agli asset","CALL_ATT_NP_MAIN":"Stanco di quelle richieste last minute ogni volta che qualcuno ha bisogno di un asset? Con NetPublish, è molto semplice pubblicare siti web self service che consentono a tutti di individuare e scaricare gli asset di cui hanno bisogno da qualsiasi browser su qualsiasi dispositivo.\n\n\t• Creazione di siti con un click: nessun HTML o CSS necessario\n\t• Design rapido e ottimizzato per dispositivi mobili\n\t• Controllo accesso utente flessibile\n\t• Disattiva siti automaticamente\n\t• Imposta risoluzione, dimensioni e formato al momento del download\n\t• Filigrana (richiede Media Engine)\n\t• Rapporto utilizzo","CALL_ATT_NP_BUTTON_MAIN":"Ottieni NetPublish","CALL_ATT_REPORT_TITLE":"Report per NetPublish","CALL_ATT_REPORT_SUBTITLE":"Verifica uso rilevante","CALL_ATT_REPORT_MAIN":"Vuoi sapere quali siti sono più attivi, quali asset sono usati e da chi? Con il report NetPublish, ottieni le informazioni di cui hai bisogno per prendere decisioni informate in base a come il Portfolio è usato nella tua organizzazione.\n\nAnalisi uso da:\n\t• Nome sito NetPublish\n\t• Nome utente\n\t• Nome asset e ID\n\t• Data e ora","CALL_ATT_REPORT_BUTTON_MAIN":"Ottieni NetPublish","CALL_ATT_SK_BUTTON_MAIN":"Prova gratis","CALL_ATT_SK_BUTTON_TRY_NOW":"https://extens.is/wqqb","CALL_ATT_SK_MAIN":"Cercare un modo di accelerare il proprio processo di assegnazione di parole chiave a immagini? Con Portfolio Smart Keyword, è possibile assegnare automaticamente parole chiave \"smart\" alle proprie immagini con un solo clic. Sponsorizzato da Clarifai, una società innovativa di licenza artificiale che eccelle nella tecnologia di riconoscimento visivo, un elenco di parole chiave suggerito è fornito in secondi.\n\n\t• Fornisce un elenco di smart keyword in secondi\n\t• Fa risparmiare tempo e risorse riducendo le parole chiave manuali\n\t• Stabilisce una tassonomia consistente per la propria organizzazione\n\t• Rende semplice trovare le risorse rapidamente.","CALL_ATT_SK_SUBTITLE":"Automatizzare la creazione di parole chiave per la tua immagine","CALL_ATT_SK_TITLE":"Portfolio Smart Keyword","CALL_ATT_SSO_SUBTITLE":"Esperienza utente unica trasversale a tutte le piattaforme","CALL_ATT_SSO_TITLE":"Accesso singolo","CALL_ATT_SSO_MAIN":"I membri della tua organizzazione stanno avendo difficoltà nel gestire le loro credenziali di accesso? Solitamente, le nuove soluzioni sono corredate da informazioni extra per la gestione degli account, utilizzabili da te e dagli utenti finali..\n\nFortunatamente, il Portfolio supporta l’accesso singolo con directory attiva. Utilizzando l'accesso singolo, gli utenti possono accedere automaticamente al Portfolio dal proprio sito intranet e ricevere un'esperienza utente continua.\n\n\t• Supporta Windows Server Active Directory\n\t• Migliora la sicurezza generale\n\t• Semplifica gestione utente\n\t• Migliora l'esperienza dell'utente","CALL_ATT_SSO_BUTTON_MAIN":"Ottieni accesso singolo","CALL_ATT_URL_BUY_NOW":"https://secure.portfoliodam.com/portfolio-options?lang=it","CALL_ATT_URL_CONTACT_SALES":"https://portfoliodam.com/portfolio/contact-me","canEmbedMetadata":"Nidifica Metadati","canImportMetadata":"Importa/Esporta dati","canManagePublicGallery":"Gestisci gallerie pubbliche","canPublishNetPublishSites":"Può pubblicare siti NetPublish","canSmartKeyword":"Può Smart Keyword","CANCEL":"Annulla","CATALOG":"Cataloga","CATALOG_ADD_SELECTED_USERS_TO_CATALOG":"Concedi membership","CATALOG_BACKUP":"Esegui backup del catalogo selezionato","CATALOG_CREATE":"Aggiungi nuovo catalogo","CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":"Gli amministratori di catalogo possono aggiungere cartelle AutoSync dal Desktop Client.","CATALOG_CREATE_AUTOSYNC_FOLDER":"Creare una cartella AutoSync","CATALOG_CREATE_CATALOG_TEMPLATE":"Modello di catalogo","CATALOG_TYPE_GENERAL":"General Use","CATALOG_TYPE_SIMPLE":"Simple","CATALOG_CREATE_DATABASES_LIST_LABEL":"Database","CATALOG_CREATE_ERROR_CREATING_FOLDERS":"Si è verificato un errore durante la creazione della cartella {folder}.","CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":"Le cartelle predefinite AutoSync e Anteprima possono essere configurate nelle Impostazioni globali.","CATALOG_CREATE_NAME":"Nome","CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":"Le anteprime possono essere visualizzate in Dettagli catalogo.","CATALOG_CREATE_PREVIEW_FOLDER":"Salvare le anteprime per visualizzarle velocemente","CATALOG_CREATE_SHOW_DATABASES":"Mostra database","CATALOG_CREATE_USE_VERSIONING":"Utilizza Versione Asset","CATALOG_DELETE":"Elimina catalogo","CATALOG_DELETE_CONFIRM":"Eliminare il catalogo selezionato?","CATALOG_DETAILS":"Dettagli catalogo","CATALOG_DETAILS_CHANGE_NAME_PROMPT":"Per rinominare questo catalogo è necessario metterlo temporaneamente offline, si desidera continuare?","CATALOG_DETAILS_COLLATION":"Fascicolazione","CATALOG_DETAILS_COLLATION_NA":"N/D","CATALOG_DETAILS_CREATION_DATE":"Data di creazione","CATALOG_DETAILS_DATABASE_TAB":"Generale","CATALOG_DETAILS_LAST_MODIFIED":"Ultima modifica","CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":"Utenti collegati","CATALOG_DETAILS_NUMBER_OF_RECORDS":"Registrazioni","CATALOG_DETAILS_NUMBER_OF_USERS":"Membri","CATALOG_DETAILS_SIZE_ON_DISK":"Dimensione su disco","CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":"L'utente amministratore sarà scollegato. Procedere?","CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":"Bloccato per l'amministrazione","CATALOG_DETAILS_UNLOCK":"Sblocca","CATALOG_EXPLANATION_VAULT_1":"I cataloghi Vault conservano asset in depositi sicuri.","CATALOG_EXPLANATION_VAULT_2":"I cataloghi Vault supportano blocco, versionamento, estrazione e archiviazione.","CATALOG_EXPLANATION_WF_1":"I cataloghi Watch Folder monitorano asset presenti nel file system.","CATALOG_EXPLANATION_WF_2":"Cataloghi Watch Folder supportano AutoSync.","CATALOG_INGEST_DRAG_HINT_TEXT":"Per aggiungere campi al Modulo di upload, trascinarli dall'elenco Campi.","CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":"Campi per Modulo di upload","CATALOG_INGEST_FIELDS_LABEL":"Campi","CATALOG_INGEST_FORM_HEADER_LABEL":"Intestazione modulo","CATALOG_INGEST_HEADER_HINT_TEXT":"L'intestazione del modulo è opzionale e appare nella parte alta del modulo.","CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":"Il numero massimo di campi da aggiungere a un modulo è {maxFields}.","CATALOG_INGEST_TAB_TITLE":"Upload Gestito","CATALOG_INGEST_USE_INGEST_LABEL":"Utilizza Upload gestito","CATALOG_INGEST_REQUIRED_LABEL":"Necessario","CATALOG_IS_CONNECTED":"Collegato","CATALOG_IS_DEFAULT":"Predefinito","CATALOG_MANAGE_USERS":"Gestisci membership catalogo","CATALOG_MANAGE_FIELDS":"Gestisci campi catalogo","CATALOG_MANAGE_TEMPLATES_MENU_LABEL":"Gestisci modelli di catalogo...","CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":"Gestisci modelli di catalogo personalizzati","CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":"Nome modello di catalogo","CATALOG_MEMBER":"Membro","CATALOG_NEW_CATALOG_DETAILS":"Dettagli nuovo catalogo","CATALOG_OFFLINE":"Offline","CATALOG_ONLINE":"Online","CATALOG_OPTIONS_ALL_FILE_TYPES":"Cataloga tutti i tipi di file","CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":"Crea parole chiave dal percorso","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":"Nome file","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":"Cartella principale","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":"Nome server","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":"Struttura ad albero cartelle","CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":"Volume","CATALOG_OPTIONS_EXCLUSION_LABEL":"Esclusioni file e cartella","CATALOG_OPTIONS_ONLY_FILE_TYPES":"Cataloga solamente","CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":"Rimuovere il/i tipo/i di file selezionato/i? ","endsWith":"Finisce con","contains":"Contiene","startsWith":"Inizia con","CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":"Rimuovere la/le esclusione/i selezionata/e?","CATALOG_OPTIONS_TAB_TITLE":"Opzioni di catalogazione","CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":"La posizione predefinita è","CATALOG_PREVIEWS_DIMENSIONS_LABEL":"Dimensioni minime 300 pixel, dimensioni massime 4000 pixel (dimensione più lunga)","CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":"Genera clip per file audio/video","CATALOG_PREVIEWS_GENERATE_PREVIEWS":"Crea anteprime","CATALOG_PREVIEWS_FOLDER_LOCATION":"Salva anteprime e clip in questa cartella","CATALOG_PREVIEWS_LOCATION_WARNING_INFO":"Questa posizione deve essere accessibile al server.","CATALOG_PREVIEWS_MAX_PIXELS":"Dimensione massima dell'immagine","CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":"Risoluzione video massima","CATALOG_PREVIEWS_MINUTES":"minuti","CATALOG_PREVIEWS_PIXELS":"pixel","CATALOG_PREVIEWS_SHORT":"Anteprime","CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":"Limita la durata a ","CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":"La generazione di clip può richiedere un po' di tempo per l'elaborazione.\nPer accorciare il tempo di elaborazione, scegliere una risoluzione e una durata inferiori.","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":"Annulla membership","CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":"Rimuovi l'utente dal catalogo?\nGli articoli Pagati dall’utente in questo catalogo saranno ripristinati e resi accessibili.","CATALOG_SAVE_TEMPLATE":"Salva modello catalogo...","CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":"Il modello salvato include: tutti i campi, le mappature dei metadati e le impostazioni delle opzioni catalogo.","CATALOG_SELECT_MESSAGE":"Nessun catalogo selezionato","CATALOG_SET_AS_DEFAULT":"Imposta catalogo predefinito","CATALOG_SK_DEFAULT_SETTINGS":"Impostazioni predefinite","CATALOG_SK_CONFIDENCE_LEVEL_LABEL":"Livello di riservatezza","CATALOG_SK_DEFAULT_LABEL":"Raccomandato: {recommended}","CATALOG_SK_ENGINES_LABEL":"Motori di ricerca con Smart Keywords","CATALOG_SK_LANGUAGES_LABEL":"Lingue per General Engine","CATALOG_SK_NUM_KEYWORDS_LABEL":"Numero di parole chiave","CATALOG_SK_SETTINGS_LABEL":"Impostazioni","CATALOG_SK_TAB_TITLE":"Smart Keywords","CATALOG_SK_USE_SK_LABEL":"Utilizzare Smart Keywords in questo catalogo","CATALOG_STATUS":"Stato catalogo","CATALOG_STORAGE_TYPE_LABEL":"Tipo di archiviazione","CATALOG_STORAGE_TYPE_WATCHFOLDERS":"Guarda cartelle","CATALOG_STORAGE_TYPE_VAULT":"Insieme di credenziali","CATALOG_TAKE_OFFLINE_SHORT":"Porta offline","CATALOG_TAKE_ONLINE_SHORT":"Porta online","CATALOG_TEMPLATE":"modello","CATALOG_TEMPLATE_NAME":"Nome modello","CATALOG_TEMPLATES_TITLE":"Modelli di Catalogo","CATALOG_TEMPLATE_REMOVE_CONFIRMATION":"Rimuovere il modello di catalogo selezionato?","CATALOG_VIEW_DETAILS":"Visualizza/Modifica dettagli catalogo","CERT_REQUEST_ALREADY_CREATED_WARNING":"Hai già creato una richiesta di certificato. Se continui, la richiesta esistente verrà eliminata.","CERTIFICATE_FILE_FILTER":"Certificati (p7b, p7, cer, crt, pem, pfx, p12)","CITY_OR_LOCALITY":"Città o località","CLEAR_BUTTON_LABEL":"Cancella","COMMUNICATION_AT_INITILIZATION_ERROR":"Si è verificato un errore durante la comunicazione con il server. Ciò in genere è dovuto alla presenza di dati non aggiornati nella cache del browser, ma può anche indicare un problema del server. Contattare l'amministratore per maggiori informazioni.","CONFIGURE_DIRECTORY_SERVICE":"Configura Servizio Directory","CONFIRM_DELETE_PDL":"Eliminare tutti i valori predefiniti per questo campo?","CONFIRM_DELETE_SERVICE":"Eliminare servizio directory?\nGli utenti importati dal servizio verranno mantenuti. Le password verranno riportate ai valori  impostati in precedenza in Portfolio oppure verranno disabilitate se non sono state definite in precedenza.","CONFIRM_TRUNCATE_VALUES":"La lunghezza max supera uno o più valori di default o predefiniti per questo campo. Troncare i valori?","CONNECTION_REFUSED_ERROR":"Collegamento al servizio directory rifiutato. Controllare nome host e impostazioni porta.","CONTAINS":"contiene","CONTINUE":"Continua","CREATE":"Crea","CREATE_A_CERTIFICATE_REQUEST":"Crea una richiesta di firma del certificato","createContactSheet":"Crea PDF","CREATED_BY":"Creato da","CREATE_MAPPING":"Crea Mappatura","CREATE_USER_EXCLUSION_MAPPING":"Escludi Utente","CREATED_ON_DATE":"Data di creazione","DATE_FORMAT":"DD/MM/YYYY","DATE_FORMAT_ERROR":"Errore di configurazione; formattazione stringa non corretta.","DATE_INVALID_CHAR_ERROR":"La data contiene caratteri non validi.","DATE_TIME_FORMAT":"DD/MM/YYYY L:NN A","DATE_TIME_SECONDS_FORMAT":"DD/MM/YYYY L:NN:SS A","DATE_WRONG_DAY_ERROR":"Immettere un giorno valido per il mese.","DATE_WRONG_LENGTH_ERROR":"Digitare la data nel formato:","DATE_WRONG_MONTH_ERROR":"Inserire un mese tra 1 e 12","DATE_WRONG_YEAR_ERROR":"Inserire un anno tra 0 e 9999","DEFAULT_ACCESS_LEVEL":"Ruolo predefinito","DEFAULT_CATALOG":"Catalogo predefinito","DEFAULT_CATALOG_NONE":"Nessuno","DEFAULT_PORT_NON_SSL":"Porta predefinita per non-SSL:","DEFAULT_PORT_SSL":"Porta predefinita per SSL:","DELETE":"Elimina","DELETE_SOURCE":"Elimina Sorgente","DELETE_ALL_NESTED_VALUES_CONFIRMATION":"Cancellare tutti i valori? Ciò cancellerà tutti i valori inclusi i valori nidificati.","DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":"Eliminare il valore '{value}'?\nContiene valori nidificati che saranno cancellati.","DELETE_NESTED_VALUE_CONFIRMATION":"Cancellare i valori selezionati? Contengono valori nidificati che saranno altresì cancellati.","DELETE_WARNING_BOX_MSG":"Avvertenza! Non sarà possibile annullare l'eliminazione!","DELETE_WARNING_CATALOG_VAULT":"Tutti gli archivi nel catalogo si distruggeranno.","DIAGNOSTIC_DATA_TITLE":"Invia Report diagnostico a Portfolio DAM","DIAGNOSTIC_DATA_ACCOUNT_NAME":"Società o Nome Account (Obbligatorio)","DIAGNOSTIC_DATA_CONTACT_NAME":"Nome contatto","DIAGNOSTIC_DATA_TS_TICKET_NUMBER":"Numero ticket assistenza tecnica","DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":"Invia report","DIAGNOSTIC_STATUS_ERROR":"Si è verificato un problema durante il caricamento del report diagnostico {date}","DIAGNOSTIC_STATUS_SENDING":"Invio in corso...","DIAGNOSTIC_STATUS_SUCCESS":"Report diagnostico inviato con successo a Portfolio DAM il {date}","DIRECTORY_SERVICE_CONNECT_ERROR":"Impossibile collegarsi al servizio directory. Controllare nome host e impostazioni porta.","DIRECTORY_SERVICES":"Servizi Directory","DIRECTORY_USERS_CANNOT_BE_DELETED":"Gli utenti di Servizi Directory non possono essere eliminati!","DISTRIBUTION_GROUPS":"Gruppi di distribuzione","DOWNLOAD_CERT_PROMPT":"Scaricare il file di richiesta del certificato?","DOWNLOAD_COMPLETE_STRING":"Download completato.","downloadPreviews":"Scarica anteprime","EMAIL_ADDRESS":"Indirizzo e-mail","EMAIL_CONFIG_AUTH_PASSWORD":"Password","EMAIL_CONFIG_AUTH_USERNAME":"Nome utente","EMAIL_CONFIG_ENABLED":"Abilita notifiche via e-mail","EMAIL_CONFIG_FROM_ADDRESS":"E-mail da indirizzo","EMAIL_CONFIG_INVALID_GENERIC":"Configurazione Server E-mail non valida","EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":"Server e-mail non trovato","EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":"Autenticazione Server E-mail non riuscita","EMAIL_CONFIG_MESSAGE":"Ogni utente che desidera ricevere notifiche deve avare un indirizzo e-mail assegnato nel pannello Utenti.","EMAIL_CONFIG_SERVER_ADDRESS":"Indirizzo Server SMTP","EMAIL_CONFIG_SERVER_PORT":"Porta Server SMTP","EMAIL_CONFIG_SUCCESS_MESSAGE":"Server SMTP validato","EMAIL_CONFIG_USE_SSL_TLS":"Utilizzare SSL / TLS","EMAIL_CONFIG_USE_SMTP_AUTH":"Utilizzare autenticazione SMTP","EMAIL_CONFIG_VALIDATE":"Connessione di prova","EMAIL_CONFIG_VALIDATED":"Server e-mail validato","english":"Inglese","ENTIRE_TREE_UNDER_SEARCH_BASE":"Intera struttura sotto Ricerca Base","EQUALS":"uguale","EXPORT_MENU_STRING":"Esporta valori","FADEL_HOWTO":"Collegamento al vostro cliente di FADEL:","FALSE_LABEL":"Falso","FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":"Verificare che il server di amministrazione sia in funzione nella macchina locale sulla porta indicata nella relativa pagina. Diversamente, riavviare il server e ricaricare questa applicazione.","FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":"Questa operazione non può essere eseguita mentre è in corso il backup o il ripristino.","FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":"Operazione non riuscita poiché il catalogo è in modalità amministrazione.","FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":"Esiste già un catalogo con questo nome.","FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":"Esiste già un utente con questo nome account.","FAULT_MSG_DB_IN_USE":"Impossibile completare l'operazione perché il catalogo è attualmente in uso da parte di un amministratore.","FAULT_MSG_DELETE_ADMIN":"Impossibile eliminare l'account dell'amministratore.","FAULT_MSG_DELETE_SELF":"Impossibile eliminare l'account utente.","FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":"Si è verificato un errore imprevisto durante la cancellazione del modello di catalogo","FAULT_MSG_DUPE_NAME":"Esiste già un oggetto con questo nome. Utilizzare un altro nome.","FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":"Esiste già un Media Engine con questo indirizzo e questa porta.","FAULT_MSG_ENTITY_VERSION_MISMATCH":" Operazione non riuscita poiché le informazioni client erano scadute.","FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":"Verificare che il server sia in funzione nella macchina locale sulla porta indicata nella relativa pagina. Diversamente, riavviare il server e ricaricare l'applicazione.","FAULT_MSG_INVALID_SESSION_ID":"Sessione scaduta. È necessario accedere di nuovo al server.","FAULT_MSG_IS_NOT_LICENSED":"Server non licenziato per tale operazione.","FAULT_MSG_LEGACY_21000":"Operazione non riuscita a causa di un errore interno sconosciuto.","FAULT_MSG_LOGGING_ERR_UPDATE":"Si è verificato un errore nell'aggiornamento della configurazione di log","FAULT_MSG_LOG_DIR_NOT_VALID":"Le directory di log specificata non esiste, non è scrivibile oppure il percorso specificato non è una directory.","FAULT_MSG_NO_DIRECTORY":"La posizione specificata non esiste o non è una directory.","FAULT_MSG_NULL_DESCRIPTION":"Si è verificato un errore imprevisto, ma non esiste alcuna descrizione per il report.","FAULT_MSG_NULL_FAULTEVENT":"Si è verificato un errore imprevisto, ma non esiste alcun dettaglio per il report.","FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":"Operazione non riuscita poiché non si dispone dei privilegi sufficienti.","FAULT_MSG_OPERATION_IS_INVALID":"Operazione non valida.","FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":"Si è verificato un errore imprevisto durante la ridenominazione del modello di catalogo","FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":"Si è verificato un errore imprevisto durante il salvataggio del modello di catalogo","FAULT_MSG_SERVER_NOT_RUNNING":"Server non in funzione.","FAULT_MSG_ENTERPRISE_NOT_LICENSED":"Operazione non riuscita poiché il server non ha una licenza Enterprise Module.","FAULT_MSG_REMOVE_METADATA_DEF":"Rimozione definizione metadata non riuscita. Può essere in uso da altri cataloghi.","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":"Il server ha restituito un errore con questo messaggio: ","FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":"Il server ha restituito un errore senza messaggi di errore: ","FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":"Il server ha restituito un errore di tipo sconosciuto con il seguente messaggio:","FAULT_MSG_UNKNOWN_SMTP_SERVER":"Impossibile collegarsi al server di posta specificato.","FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":"Operazione non riuscita poiché un servizio non era nello stato previsto.","FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":"Il nome utente o la password indicati per il database non sono validi.","FAULT_MSG_BAD_DB_PORT":"La porta del database specificata non è valida.","FAULT_MSG_BAD_DB_HOST":"Il nome host del database o la porta specificata non sono validi.","FIELD_ACTION_ADD":"Aggiungi nuovo campo personalizzato","FIELD_ACTION_DELETE":"Elimina campo selezionato","FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":"Spazio nomi XMP","FIELD_ACTION_MANAGE_METADATA":"Gestisci metadata","FIELD_CATEGORY_CUSTOM":"Campi personalizzati","FIELD_CATEGORY_SYSTEM":"Campi sistema","FIELD_CATEGORY_EXIF":"EXIF","FIELD_CATEGORY_IPTC":"IPTC","FIELD_CATEGORY_XMP":"XMP","FIELD_CATEGORY_MOVIE":"Filmato","FIELD_CATEGORY_OFFICE":"MS Office","FIELD_CATEGORY_GEO":"GEO","FIELD_CATEGORY_LABEL":"Categoria campo","FIELD_DISABLE_CONFIRM_MSG":"Vuoi disabilitare il campo selezionato?","FIELD_ENABLE_ALL_CATEGORIES_LABEL":"Abilita tutto","FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":"Aggiungi Estrai mappatura","FIELD_FORM_LABEL_DEFAULT_VALUE":"Valore predefinito","FIELD_FORM_LABEL_DISABLED":"(Disabilitato)","FIELD_FORM_LABEL_EMBED":"Nascondi metadata","FIELD_FORM_LABEL_EXTRACT":"Estrai da metadata","FIELD_FORM_LABEL_FIELD_NAME":"Nome campo","FIELD_FORM_LABEL_FIELD_TYPE":"Tipo campo","FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":"Consenti più valori","FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":"Ha valori predefiniti","FIELD_FORM_LABEL_HELP_TEXT":"Testo guida","FIELD_FORM_LABEL_MAX":"Max: {max}","FIELD_FORM_LABEL_MAX_LENGTH":"Lunghezza max","FIELD_FORM_LABEL_METADATA_TAG":"Nome metadati","FIELD_FORM_LABEL_METADATA_TYPE":"Tipo metadati","FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":"Consenti solo valori predefiniti","FIELD_FORM_LABEL_PRECISION":"Precisione","FIELD_FORM_LABEL_PREDEFINED_VALUES":"Valori predefiniti","FIELD_FORM_LABEL_SHOW_TIME":"Mostra ora","FIELD_FORM_LABEL_USE_METADATA":"Estrarre e incorporare metadati","FIELD_FORM_WARNING_DUPE_EMBEDS":"Avviso: Più di un campo si incorpora su '{metadata}'","FIELD_METADATA_DATA_TYPE_LABEL":"Tipo dati","FIELD_METADATA_DEFINITION_IS_CUSTOM":"È personalizzato","FIELD_METADATA_DEFINITIONS_TITLE":"Definizioni metadati","FIELD_METADATA_DELETE_CONFIRM_MSG":"Conferma: Eliminare la definizione dei metadati?","FIELD_METADATA_MULTIVALUED_TYPE_LABEL":"Tipo multivalore","FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":"Non multivalore","FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":"Ordinato","FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":"Non ordinato","FIELD_METADATA_NAME_LABEL":"Nome","FIELD_METADATA_NAMESPACE_LABEL":"Spazio dei nomi","FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":"Aggiungi spazio dei nomi XMP personalizzato...","FIELD_METADATA_TAG_LABEL":"Tag","FIELD_METADATA_TYPE_LABEL":"Tipo","FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":"Più campi selezionati","FIELD_NAMESPACE_ABBREVIATION":"Abbreviazione","FIELD_NAMESPACE_REMOVE_CONFIRMATION":"Eliminare spazio dei nomi XMP personalizzato?\nUsando lo spazio dei nomi è possibile vi siano delle definizioni di campo.","FIELD_NAMESPACE_URI":"Spazio dei nomi URI","FIELD_NEW_FIELD_NAME":"Nuovo campo","FIELD_NEW_METADATA_TITLE":"Nuova definizione metadati","FIELD_NEW_NAMESPACE_TITLE":"Nuovo spazio dei nomi XMP personalizzato","FIELD_NO_FIELD_SELECTED_MESSAGE":"Nessun campo selezionato","FIELD_PAGE_TITLE":"Gestisci campi per catalogo '{catalogName}'","FIELD_REVERT_CONFIRM_MSG":"Conferma: Ripristinare il campo?","FIELD_TYPE_BLOB":"Blob","FIELD_TYPE_BOOLEAN":"Booleano","FIELD_TYPE_DATETIME":"Data/ora","FIELD_TYPE_DECIMAL":"Decimale","FIELD_TYPE_LANG_ALT":"Alt Lang","FIELD_TYPE_NUMBER":"Numero","FIELD_TYPE_PICTURE":"Immagine","FIELD_TYPE_STRING":"Stringa","FIELD_TYPE_STRUCTURE":"Struttura","FIELD_TYPE_TEXTBLOCK":"Blocco testo","FIELD_TYPE_UNKNOWN":"Sconosciuto","FIELD_TYPE_URL":"URL","FILE_IO_ERROR_MSG":"C'è stato un errore caricando il documento sul server.","FILE_WRONG_TYPE_ERROR_MSG":"Questo formato di documento non è supportato. \n Scegli un documento di formato jpeg, gif o png.","FOLDER_PATH_AUTOSYNC_FILES_STRING":"File","FOLDER_PATH_ALREADY_EXIST_AS_FILE":"Esiste un file con questo nome.","FOLDER_PATH_DOES_NOT_EXIST":"Il percorso non esiste.","FOLDER_PATH_ERROR":"Errore","FOLDER_PATH_NOT_VERIFIED":"Il percorso alla cartella non è stato verificato.","FOLDER_PATH_PATH":"Percorso","FOLDER_PATH_OPERATION_INVALID":"Operazione non valida","FOLDER_PATH_SUCCESS":"Riuscito","FOLDER_PATH_TYPE_AUTOSYNC":"autosync","FOLDER_PATH_TYPE_PREVIEW":"anteprima","FOLDER_PATH_UNKNOWN_FAULT":"Errore sconosciuto","french":"Francese","FULL_NAME":"Nome intero","FULLY_QUALIFIED_DOMAIN_NAME":"Nome dominio completamente qualificato","german":"Tedesco","GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":"Creare cartelle AutoSync per i nuovi cataloghi in questa cartella","GLOBAL_SETTINGS_BACKGROUND_COLOR":"Colore di sottofondo","GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":"Colore di sottofondo dello schermo log-in.","GLOBAL_SETTINGS_CATALOG_DEFAULTS":"Impostazioni predefinite catalogo","GLOBAL_SETTINGS_CHOOSE_FILE":"Scegli un documento","GLOBAL_SETTINGS_CUSTOM_IMAGE":"Immagine personalizzato","GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":"La grandezza indicativa dovrebbe stare dentro 2400 x 1350 pixel.","GLOBAL_SETTINGS_CUSTOM_TITLE":"Titolo personalizzato","GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":"Il titolo che appare nel browser o nel segnalibri.","GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":"Schermo di log-in personalizzato","GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":"Ruolo predefinito","GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":"Schermo di log-in predefinito","GLOBAL_SETTINGS_EMAIL_CONFIGURATION":"Notifiche via e-mail","GLOBAL_SETTINGS_FADEL":"FADEL Rights Cloud","GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":"La posizione delle cartelle AutoSync e Anteprima deve essere accessibile al server.","GLOBAL_SETTINGS_IMAGE_URL":"Collegamento","GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":"Cliccando sull'immagine apre questo URL in una nuova finestra.","GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":"Per apportare delle modifiche, avviare il server o verificare se la licenza server è scaduta.","GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":"Salvare le anteprime dei nuovi cataloghi in questa cartella","GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":"Posizioni dati server","GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":"Adattamento di collegamento Portfolio","GLOBAL_SETTINGS_SSO_CREDENTIALS":"Credenziali accesso singolo","GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":"Inserire l'account utente associato al servizio Portfolio Server per autenticazione Kerberos.","GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":"Cartella di lavoro temporanea: ","GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":"La cartella di lavoro verrà modificata al prossimo riavvio del server. La nuova cartella verrà posizionata in: ","GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":"Affinché questa modifica abbia effetto è necessario riavviare il server.","GLOBAL_SETTINGS_VAULT_CONFIGURATION":"Configurazione Portfolio Vault:","GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":"Cartella insieme di credenziali Portfolio:","SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":"Posizione predefinita insieme di credenziali Portfolio:","GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":"Per spostare Portfolio Vault, spegnere prima il server.","HELP_URL":"https://helpdocs.portfoliodam.com/it/portfolio/administration/{version}/index.htm","HELP_URL_FADEL":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/it/Content/03_Catalogs/05_FADEL.htm","HOSTNAME":"Nome host","IDENTITY_SERVICE_DEFAULT_ROLE_STRING":"(predefinito)","IDENTITY_SERVICE_SUCCESSFUL_CREATION":"Connessione al servizio directory avvenuta con successo. Configurazione salvata.","IMAGE_FILE_FILTER":"Immagini (jpg, gif, png)","IMPORT_LDAP":"Importa utenti da server LDAP/AD","IMPORT_LDAP_SPECIFY_SERVER":"Especificar servidor LDAP/AD","IMPORT_MENU_STRING":"Importa valori","IMPORT_SOURCE":"Importa sorgente","INVALID_DN_SYNTAX_ERROR":"Impossibile collegarsi al servizio directory a causa di un errore di sintassi DN non valido. Controllare il nome utente.","japanese":"Giapponese","LAST_CERTIFICATE_REQUEST_LABEL":"Ultima richiesta di certificato","LAST_MODIFIED_BY":"Ultima modifica di","LAST_MODIFIED_DATE":"Data ultima modifica","LDAP_ADDRESS":"Indirizzo server LDAP/AD","LDAP_BIND_USERNAME":"Nome utente LDAP Bind","LDAP_SYNC_NOTIFICATION":"Il server ha ricevuto una richiesta di sincronizzazione.","LIC_ADD_MESSAGE":"Copiare e incollare le licenze o inserirle singolarmente una per riga.","LIC_ADD_SN":"Aggiungi nuova licenza","LIC_ADD_SN_SHORT":"Aggiungi licenze","LIC_ASSET_CAP_DISPLAY":"Asset","LIC_DAYS_REMAINING":"({days} giorni restanti)","LIC_DEMO_PERIOD":"Periodo di demo","LIC_ERROR_MSG":"Numero di serie non valido; riprovare. Se il problema persiste, controllare il log del server e contattare l'amministratore.","LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":"Il numero di serie non può essere aggiunto a Portfolio Studio.","LITE_CANNOT_CREATE_FDB_CATALOG":"La licenza Portfolio non consente più di un catalogo. Aggiornare la licenza Portfolio per eseguire questa azione.","LITE_CANNOT_SERVE_FDB_CATALOG":"La licenza Portfolio Server di cui si dispone non consente di prendere ulteriori cataloghi online.","LITE_THIS_FEATURE_NOT_SUPPORTED":"La licenza Portfolio Server non supporta questa azione.","LOGGING_CONFIGURATION":"Configurazione di log","LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":"Per cambiare la posizione del log, spegnere prima il server del Portfolio.","LOGGING_DEFAULT_LOCATION_MSG":"La posizione predefinita per il log è","LOGGING_DIR_MUST_EXIST":"NOTA: Per poter modificare correttamente la directory di log, la directory da specificare deve essere già esistente ed essere scrivibile da parte dell'utente per il quale è in funzione Portfolio Server.","LOGGING_LOG_DIR":"Directory di log:","LOGGING_LOG_LEVEL":"Livello di log","LOGGING_NUM_LOGS_TO_RETAIN":"Numero di log da conservare","LOGIN":"Login","MAPPING_HEADER":"Mappatura utente/gruppo a Portfolio","MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":"Le mappature sono state modificate, salvarle?","MEDIA_ENGINES_ACTION_ADD":"Aggiungi nuovo Media Engine","MEDIA_ENGINES_ACTION_DELETE":"Elimina Media Engine","MEDIA_ENGINES_ACTION_EDIT":"Visualizza/Modifica dettagli Media Engine","MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":"Impossibile aggiungere un altro Media Engine attivo poiché il server sta già usando il numero massimo di media engine attivi consentito dalla licenza Portfolio Media Engine.","MEDIA_ENGINES_CANT_ADD_NO_LICENSES":"Impossibile aggiungere un Media Engine poiché il server non dispone di una licenza Portfolio Media Engine disponibile.","MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":"Impossibile rimuovere il Media Engine incorporato.","MEDIA_ENGINES_COLUMN_ACTIVE":"Attivo","MEDIA_ENGINES_COLUMN_ADDRESS":"Indirizzo","MEDIA_ENGINES_COLUMN_PORT":"Porta","MEDIA_ENGINES_CONFIRM_DELETE":"Eliminare il Media Engine selezionato?","MEDIA_ENGINES_EDIT_DETAILS_HEADER":"Dettagli Media Engine","MEDIA_ENGINES_LICENSES_LABEL":"Posti Media Engine disponibili per l'attivazione","MEDIA_ENGINES_NEW_DETAILS_HEADER":"Dettagli nuovo Media Engine","MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":"Nessun Media Engine attivo. È necessario attivare un Media Engine prima che i client debbano utilizzare i servizi Portfolio Media.","MOBILE":"Cellulare","MOBILE_ENABLED":"Abilita caricamenti dal cellulare","MOBILE_FOLDER_VERBIAGE":"Salva i caricamenti dal cellulare in questa cartella:","MOBILE_CREATE_CATALOG_VERBIAGE":"Creare il nuovo catalogo 'caricamenti da cellulare' per visionare automaticamente questa cartella (raccomandato)","MOBILE_CATALOG_NAME":"Caricamenti da cellulare","modifyAssetContents":"Verifichi i beni","MODIFY_LDAP":"Modifica richiesta LDAP","NAME":"Nome","NAME_TOO_LONG_ERROR":"Il nome deve contenere meno di 256 caratteri","NAV_ABOUT":"Info su","NAV_ACCESS_LEVELS":"Ruoli","NAV_AUTOSYNC":"Sincr. automatica","NAV_BACKUPS":"Backup/Ripristino","NAV_CATALOGS":"Cataloghi","NAV_GLOBAL_SETTINGS":"Impostazioni globali","NAV_HELP":"Guida","NAV_LICENSES":"Licenze","NAV_LOGOUT":"Logout","NAV_MEDIA_ENGINES":"Media Engine","NAV_NETPUBLISH_SETTINGS":"NetPublish","NAV_PORTS":"Porte","NAV_REPORTING":"Creazione di report","NAV_SETTINGS":"Impostazioni","NAV_STATUS":"Stato","NAV_USERS":"Utenti","NO_CATALOGS":"Nessuno","NO_FILE_SELECTED":"Nessun documento scelto","VaultFolderNotFound":"La cartella Portfolio Vault non è stata trovata in {path}.","NO_VAULT_FOLDER":"La cartella Portfolio Vault non è stata trovata in {path}.  Verificare la posizione della cartella nel proprio file di sistema, e nella pagina Impostazioni globali -> Dati server di questa applicazione.","NOTES":"Note","NUMBER_DECIMAL_POINT_COUNT_ERROR":"Il separatore decimale può essere presente solo una volta.","NUMBER_EXCEEDS_MAX_ERROR":"Il numero immesso è troppo grande.","NUMBER_INTEGER_ERROR":"Il numero deve essere un numero intero.","NUMBER_INVALID_CHAR_ERROR":"L'immissione contiene caratteri non validi.","NUMBER_INVALID_FORMAT_CHARS_ERROR":"Uno dei parametri di formattazione non è valido.","NUMBER_LOWER_THAN_MIN_ERROR":"L'importo inserito è troppo piccolo.","NUMBER_NEGATIVE_ERROR":"L'importo può essere negativo.","NUMBER_PRECISION_ERROR":"L'importo inserito è composto da troppe cifre dopo il punto decimale.","NUMBER_SEPARATION_ERROR":"Il separatore delle migliaia deve essere seguito da tre cifre.","OK":"OK","ON_DATE":"il","OPEN_DIRECTORY":"Open Directory","OPEN_DIRECTORY_GROUPS":"Gruppi","ORGANIZATION_NAME":"Nome organizzazione","ORGANIZATIONAL_UNIT":"Unità organizzazione","PASSWORD":"Password","PASSWORD_CONFIRM":"Conferma password","PASSWORD_TOO_LONG_ERROR":"La password deve contenere meno di 256 caratteri","PORT":"Porta","PORT_VALUE_TOO_HIGH_ERROR":"Il valore di porta deve essere inferiore a 65536.","PortfolioAssetCap":"Portfolio Asset Cap","PortfolioAPI":"Portfolio API","PortfolioDemo":"Demo","PortfolioDirServices":"Portfolio Directory Services","PortfolioServer":"Portfolio Server","PortfolioStudio":"Portfolio Studio Edition","PortfolioProfessional":"Portfolio Professional Edition","PortfolioEnterprise":"Portfolio Enterprise Edition","PortfolioMediaEngine":"Portfolio Media Engine","NetPublish":"Portfolio NetPublish","PortfolioMobile":"Portfolio Flow","PortfolioSmartKeywords":"Portfolio Smart Keyword","PortfolioUserConnection":"Portfolio User Connection","PortfolioSingleSignOn":"Accesso singolo (SSO)","PORT_CURRENT_VALUE":"Valore corrente","PORT_ERROR_MSG_BAD_PORT_VALUE":"Il nuovo valore porta deve essere un numero compreso tra 1 e 65535.","PORT_ERROR_MSG_CONFLICT":"Impossibile aggiornare i valori porta poiché uno o più dei nuovi valori porta è già in uso sul server.","PORT_FIND_PORT":"Trova porta","PORT_NAME":"Nome","PORT_NEW_VALUE":"Nuovo valore","PORT_RESTART_NOTICE":"Nota: gli aggiornamenti delle porte hanno effetto solo dopo il riavvio del server.","PORT_RESTART_SERVER":"Riavvia server","PORT_UPDATE_PORTS":"Aggiorna porte","PORT_WARNING_ADMIN_RESTART":"Porta di amministrazione modificata. Il browser sarà reindirizzato nella nuova posizione fra {numSecs} secondi.","PREVIEW_MAX_VIDEO_RESOLUTION_360":"360p","PREVIEW_MAX_VIDEO_RESOLUTION_480":"480p","PREVIEW_MAX_VIDEO_RESOLUTION_540":"540p HD","PREVIEW_MAX_VIDEO_RESOLUTION_720":"720p HD","PREVIEW_MAX_VIDEO_RESOLUTION_1080":"1080p HD","PROMPT_ARE_YOU_SURE":"Sicuro?","PROMPT_COULD_NOT_CREATE_FOLDER":"Impossibile creare cartella. Inserire un altro percorso.","PROMPT_COULD_NOT_CREATE_FOLDERS":"Inserire un altro percorso alla cartella poiché non è possibile creare i seguenti percorsi:","PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":"Impossibile creare cartella poiché esiste già un file con questo nome. Inserire un altro percorso.","PROMPT_CREATE_THAT_FOLDER":"Questa cartella non esiste. Crearla?","PROMPT_CREATE_THESE_FOLDERS":"Queste cartelle non esistono. Si desidera crearle?","PROMPT_DELETE_LICENSE_CONFIRM":"Eliminare la licenza selezionata?","QUERY":"Interrogazione","REMOVE":"Rimuovi","REMOVE_DIRECTORY_SERVICE":"Rimuovi servizio directory","REPLACE_USER_MAPPING_CONFIRMATION":"Per questo utente esiste già una mappatura utente regolare. Sostituirla con una mappatura utente di esclusione?","REPLACE_USER_EXCLUSION_CONFIRMATION":"Per questo utente esiste già una mappatura utente di esclusione. Sostituirla con una mappatura utente regolare?","REQUIRED_FIELD_ERROR":"Questo campo è obbligatorio","REVERT":"Inverti","REVERT_CHANGES":"Inverti Modifiche","ROLE_FOR_IMPORT":"Ruolo per importazione","ROLES_PERMISSION_ENABLED_HEADER":"Abilitato","ROLES_PERMISSION_NAME_HEADER":"Operazione","SAVE":"Salva","SAVE_MAPPING":"Salva Mappatura","saveOutputSetting":"Gestisci preimpostazioni conversione e fate il PDF","SEARCH":"Cerca","SEARCH_BASE":"Base di Ricerca","SEARCH_RESULTS":"Risultati ricerca","SECURITY_GROUPS":"Gruppi di sicurezza","SELECT":"Seleziona","SEND_DIAGNOSTIC_DATA":"Invia Report diagnostico a Portfolio DAM","SERVER_DATA_DEFAULT_WORK_LOCATION_IS":"Posizione di lavoro predefinita: ","SERVER_RESTART_REQUIRED":"È necessario riavviare il server affinché le modifiche abbiano effetto.","SERVER_STATE_ERROR":"Errore: Vedere il log di amministrazione per ulteriori dettagli","SERVER_STATE_STARTED":"Esecuzione","SERVER_STATE_STARTING":"Avvio","SERVER_STATE_STOPPED":"Interrotto","SERVER_STATE_STOPPING":"Interruzione","SERVER_STATE_UNKNOWN":"Sconosciuto","SERVICE_BROWSER":"Browser servizi","SK_ENGINE_APPAREL":"Abito","SK_ENGINE_CELEBRITIES":"Celebrità","SK_ENGINE_FOOD":"Cibo","SK_ENGINE_GENERAL":"Generale","SK_ENGINE_LOGO":"Logo","SK_ENGINE_MODERATION":"Regolazione","SK_ENGINE_NSFW":"NSFW","SK_ENGINE_TRAVEL":"Viaggio","SK_ENGINE_WEDDINGS":"Matrimoni","SSL_HANDSHAKE_ERROR":"Handshake SSL non riuscito; verificare che la porta e le impostazioni SSL siano corrette.","STARTS_WITH":"inizia con","STATE_OR_PROVINCE":"Stato o Provincia","STATUS":"Stato","STATUS_ADMIN_LOG":"Log di ammin.","STATUS_API_VERSION_LABEL":"API","STATUS_API_STATE_LICENSED":"Licenziato","STATUS_API_STATE_UNLICENSED":"Non licenziato","STATUS_CLEAR_ADMIN_LOG":"Cancella log di ammin.","STATUS_CONNECTED_USERS":"Utenti connessi","STATUS_MAX_ALLOWED_CONNECTIONS":"Connessioni massime","STATUS_MEDIA_ENGINE_VERSION_LABEL":"Media Engine","STATUS_MEDIA_ENGINES_ACTIVE":"Attivo","STATUS_MEDIA_ENGINES_LABEL":"Media Engine","STATUS_RESTART_SERVER":"Riavvia Portfolio","STATUS_SEAT_USAGE":"Utilizzo posto","STATUS_SERVER_STATE":"Portfolio State","STATUS_SERVER_VERSION_LABEL":"Portfolio","STATUS_START_SERVER":"Avvia Portfolio","STATUS_STOP_SERVER":"Arresta Portfolio","STATUS_PROBLEMS_DETECTED":"Problemi rilevati:","STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":"Lo spazio rimanente del disco di avvio è sotto {minSpace}GB.","STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":"La cartella di lavoro non esiste o non è accessibile.","STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":"Il server Portfolio non può scrivere nella cartella di lavoro.","STATUS_MSG_WORK_FOLDER_NOT_READABLE":"Il server Portfolio non può leggere dalla cartella di lavoro.","STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":"Il server Portfolio non può creare un collegamento simbolico nella cartella di lavoro.","STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":"Lo spazio rimanente nel disco di lavoro è sotto {minSpace}GB.","STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":"Impossibile ottenere lo stato della cartella di lavoro.","STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":"Lo stato dell’indice ElasticSearch è rosso {index}.","STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":"L’indice ElasticSearch {index} presenta partizioni non inizializzate.","STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":"Non tutte le partizioni sono attive per l’indice ElasticSearch {index}.","STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":"Impossibile recuperare lo stato ElasticSearch.","STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":"Impossibile recuperare gli errori dal server Portfolio.","STATUS_MSG_STARTUP_FAILED":"Avvio non riuscito","STATUS_MSG_CANT_GET_SERVER_HEALTH":"Impossibile aggiornare l’integrità del server.","STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":"Il componente del server Native Agent non è in esecuzione.","SUBJECT_ALTERNATIVE_NAMES":"Nomi alternativi oggetto","SUBMIT":"Invia","swedish":"Svedese","SYNC_DAILY":"Sincronizza giornalmente","SYNCHRONIZE_NOW":"Sincronizza ora","TARGET_CATALOG":"Catalogo target","THIS_LOCALE":"ir","TRUE_LABEL":"Vero","TOKEN":"Token","TOTAL_ASSETS":"Risorse totali","TWO_LETTER_COUNTRY_CODE":"Codice Paese di due lettere","TYPE":"Carattere","UNABLE_CONNECT_LDAP":"Impossibile collegarsi al server LDAP/AD.","UNABLE_CONNECT_SERVER":"Impossibile collegarsi al server.","UNKNOWN_HOST_ERROR":"Impossibile collegarsi al servizio directory a causa di una eccezione host sconosciuta. Controllare il nome host.","UNKNOWN_LDAP_USER_ERROR":"In Identity Service non è stato trovato alcun utente con il nome account '{accountName}'.","useCustomPresets":"Usa impostazioni di conversione predefinite","USE_SSL":"Usa SSL","USER_ACCOUNT":"Conteggio","USER_CREATE":"Aggiungi nome utente","USER_DELETE":"Elimina utenti","USER_DELETE_CONFIRM":"Elimina utenti selezionati?","USER_DELETE__DELETE_PRIVATE":"Eliminate in modo permanente","USER_DELETE__GALLERY_PROMPT":"Il comando Rendi pubblico rende pubbliche tutte le gallerie private e a sola lettura appartenenti a questo utente. Il comando \"Elimina tutte le gallerie private\" rimuove in modo permanente le gallerie private e rende pubbliche le gallerie a sola lettura.","USER_DELETE__GALLERY_PROMPT_1":"Gli articoli Pagati degli utenti saranno ripristinati e resi accessibili.","USER_DELETE__GALLERY_PROMPT_2":"Le Gallerie di sola lettura degli utenti saranno rese Pubbliche.","USER_DELETE__GALLERY_PROMPT_3":"Le Gallerie private degli utenti dovrebbero essere:","USER_DELETE__MAKE_PUBLIC":"Rese Pubbliche","USER_DETAILS":"Dettagli utente","USER_IMPORT":"Importa utenti","USER_IMPORT_ACCOUNT":"Nome account","USER_IMPORT_ACCOUNT_ATTR":"Attributo account","USER_IMPORT_EMAIL_ATTR":"Attributo e-mail","USER_IMPORT_IMPORT":"Importa","USER_IMPORT_IMPORT_SELECTED_USERS":"Importa utenti selezionati","USER_IMPORT_MODIFY_SEARCH":"Modifica ricerca","USER_IMPORT_NAME_ATTR":"Attributo nome account","USER_IMPORT_NOTES_ATTR":"Attributo note","USER_IMPORT_PASSWORD":"Password account","USER_IMPORT_PASSWORD_ATTR":"Attributo password","USER_IMPORT_SEARCH":"Cerca","USER_IMPORT_SEARCH_BASE":"Base di ricerca","USER_IMPORT_SEARCH_FILTER":"Filtro di ricerca","USER_IMPORT_SERVER_ADDRESS":"Indirizzo server","USER_IMPORT_SPECIFY_LDAP_SERVER":"Specifica server LDAP","USER_LEVEL_ADMINISTRATOR":"Amministratore catalogo","USER_LEVEL_EDITOR":"Curatore","USER_LEVEL_NON_MEMBER":"--","USER_LEVEL_PUBLISHER":"Editore","USER_LEVEL_READER":"Lettore","USER_MANAGE_CATALOGS":"Gestisci cataloghi per utenti selezionati","USER_MULT_USERS_SELECTED":"Più utenti selezionati","USER_NAME":"Nome utente","USER_NEW_USER_DETAILS":"Dettagli nuovo utente","USER_NEW_USER_INFO_MSG":"Per aggiungere un utente ad un catalogo specifico, usare Cataloghi > Utenti.","USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":"Aggiungi utente a tutti i cataloghi come:","USER_NO_USERS_SELECTED":"Nessun utente selezionato","USER_ONLINE":"Online","USER_PASSWORD_TOO_SHORT":"La password deve contenere almeno un carattere.","USER_PASSWORDS_DO_NOT_MATCH":"Il campo di conferma password deve corrispondere al campo della password.","USER_ROLE":"Livello di accesso","USER_VIEW_DETAILS":"Visualizza/Modifica dettagli utente","USERS":"Utenti","VALIDATION_FIELD_LENGTH_EXCEEDED":"Questo campo non può superare i 255 caratteri.","VALIDATION_MUST_BE_NONEMPTY":"Questo campo è obbligatorio.","VIEW_EDIT_MAPPINGS":"Mostra / Modifica mappature","General.OK":"OK","General.Cancel":"Annulla","PORT_TITLE":"Porte","PORT_DEFAULT":"Predefinito:","esp.port.admin-web-app":"Porta HTTP Admin Portfolio","esp.port.admin-web-app-ssl":"Porta SSL Admin Portfolio","esp.port.http":"Porta HTTP server Portfolio","esp.port.ssl":"Porta SSL server Portfolio","General.Save":"Salva","CATALOG_DETAILS_FILETYPES_TAB":"Tipi di file","addAsset":"Aggiungi risorse","canManageFieldLists":"Gestisci Elenchi campo pubblico","canModifyFolderStructure":"Modifica le strutture delle cartelle","canMoveAssets":"Sposta risorse","deleteAssetContents":"Elimina risorse originali","deleteAssetFromCatalog":"Elimina risorsa dal catalogo","modifyAssetProperties":"Aggiorna campi risorsa","synchronizeAutoSyncFolder":"Cartelle Sync Autosync","ASSETS":"Risorse","CATALOG_STORAGE_TYPE_S3":"S3","CREATE_CATALOG":"Creare catalogo","STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":"La memoria di sistema è {value}GB che risulta al di sotto dei requisiti minimi di {minGB}GB","STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":"La memoria di sistema calcolata dal Portfolio è di {value}GB che potrebbe risultare inaccurata.","AUTH.couldNotConnect":"Impossibile collegarsi al server. Verificare l'indirizzo.","ERROR.serverUnavailable":"Il server Portfolio non disponibile.","ERROR.sessionExpired":"La tua sessione è scaduta.","fileNotFound":"Il file non è stato trovato su disco.","ERROR.invalidSearchFailed":"La ricerca è fallita in quanto si è verificato un problema con la richiesta.","AUTH.loginFailed":"Nome utente e password errati.","FAULT_CODE.InsufficientPrivileges":"Per eseguire questa operazione non si dispone dei privilegi sufficienti.","unexpectedError":"Si è verificato un errore imprevisto.","ROLES_CREATE_ROLE_TITLE":"Creare ruolo","ROLES_DELETE_CONFIRM":"Si intende cancellare il ruolo selezionato?\nGli utenti con tale ruolo saranno declassati a lettori.","NOTIFICATION_SUCCESS_UPDATE":"Aggiornamento avvenuto con successo","DATA_COLLECTION_TITLE":"Analisi","DATA_COLLECTION_RTI_OPT_OUT_LABEL":"Accetto di condividere i dati sull’utilizzo dell’applicazione.","DATA_COLLECTION_RTI_OPT_OUT_TEXT":"Aiutaci a fornire le migliori soluzioni possibili condividendo l’uso dell’applicazione con noi.\n\nAccettando, ci aiuterai a raccogliere informazioni importanti che ci guideranno verso miglioramenti futuri in termini di qualità e funzionalità. I dati raccolti ci consentono di capire ciò che gli utenti si aspettano da una soluzione.\n\nPuoi sempre cambiare idea in qualsiasi momento e interrompere la condivisione delle tue informazioni.\n\nPer sapere di più su come utilizziamo le tue informazioni e per esercitare in futuro il diritto di opt-out, visita la pagina dell’articolo guida: ","DATA_COLLECTION_HELP_URL":"https://help.portfoliodam.com/hc/it/articles/1260804371029","CREATE_USER":"Crea utente","CATALOG_FILES_TAB_TITLE":"Assimilare","FIELD_CATEGORY_ALL":"Tutti i campi attivi","FIELD_CATEGORY_FONTSENSE":"Portfolio DAM Font Sense","FIELD_DEF.cataloged":"Catalogato","FIELD_DEF.catalogedBy":"Catalogato da","FIELD_DEF.colorMode":"Modalità colore","FIELD_DEF.isPanoramic":"Panoramica","FIELD_DEF.created":"Creato","FIELD_DEF.directoryPath":"Percorso directory","FIELD_DEF.documentText":"Testo documento","FIELD_DEF.filename":"Nome file","FIELD_DEF.fileDescription":"Descrizione","FIELD_DEF.fileSize":"Dimensione file","FIELD_DEF.geometry":"Geo - Programma","FIELD_DEF.height":"Altezza","FIELD_DEF.horizontalResolution":"Risoluzione orizzontale","FIELD_DEF.keywords":"Parole chiave","FIELD_DEF.lastModified":"Modificato","FIELD_DEF.lastUpdated":"Cambiato","FIELD_DEF.aliasMac":"Alias Mac","FIELD_DEF.creatorMac":"Autore Mac","FIELD_DEF.fileTypeMac":"Tipo di file Mac","FIELD_DEF.zoneMac":"Zona Mac","FIELD_DEF.multipageCount":"Numero pagine","FIELD_DEF.numBands":"Numero delle fasce","FIELD_DEF.path":"Percorso","FIELD_DEF.ItemID":"ID risorsa","FIELD_DEF.shortFilenameWin":"Nome file corto Win","FIELD_DEF.thumbnailSize":"Formato miniatura","FIELD_DEF.updatedBy":"Modificato da","FIELD_DEF.verticalResolution":"Risoluzione verticale","FIELD_DEF.volume":"Volume","FIELD_DEF.watermarkURL":"URL filigrana","FIELD_DEF.watermarked":"Filigranato","FIELD_DEF.width":"Larghezza","FIELD_DEF.SuggestedKeywords":"Smart Keywords","REFRESH":"Aggiorna","ALL_CATALOGS":"Tutti i cataloghi","ALL_SITES":"Tutti i Site","ASSET_DOWNLOADS":"Asset - maggiormente scaricati","ASSET_PREVIEWS":"Asset - maggiormente visualizzati in anteprima","ASSET_UPLOADS":"Asset - caricamenti","DOWNLOAD_REPORT":"Download","FILE_TYPES":"Tipi di file","FILE_TYPES_SECTION_TITLE":"Tipi di file","FILE_TYPES_ERROR_NAME_EXISTS":"Il nome '{name}' concorda con il nome di un tipo di file esistente.","FILE_TYPES_LABEL_RESTORE_DEFAULTS":"Ripristina valori predefiniti","FILE_TYPES_PROMPT_DISCARD_CHANGES":"Eliminare le modifiche in sospeso?","FILE_TYPES_ADD_FILE_TYPE":"Aggiungi tipo di file","FILE_TYPES_UPDATE_FILE_TYPE":"Aggiorna tipo di file","FILE_TYPES_EXTENSIONS":"Estensioni","FROM":"da","SITE":"Site","KEYWORD_STATISTICS":"Statistiche Parole chiave","NETPUBLISH_MOST_DOWNLOADED":"NetPublish - Più Scaricato","NETPUBLISH_USAGE":"NetPublish - Uso","REPORT_DESCRIPTION_ASSET_PREVIEWS":"Tale report identifica quali asset siano stati visualizzati in anteprima e quante volte ognuno di questi sia stato visualizzato in anteprima.","REPORT_DESCRIPTION_ASSET_UPLOADS":"Tale report identifica gli asset caricati, quali utenti li abbiano caricati e quando.","REPORT_DESCRIPTION_DOWNLOADED":"Questo report identifica quali risorse sono state scaricate e quante volte al giorno sono state scaricate.","REPORT_DESCRIPTION_KEYWORD":"Questo report identifica tutte le parole chiave in catalogo e a quante risorse si applicano.","REPORT_DESCRIPTION_USAGE":"Questo report include quali utenti hanno scaricato risorse e quando.","SEARCH_TERMS":"Termini di ricerca","TO":"a","VIEW_REPORT":"Visualizza report","NP_SITES":"Siti NetPublish","REPORT_NAME_DELETED_BY":"Asset - cancellazioni","REPORT_NAME_DOWNLOADED_BY":"Asset - download","REPORT_DESCRIPTION_DELETED_BY":"Tale report identifica gli asset modificati, quali utenti li abbiano cancellati e quando.","REPORT_DESCRIPTION_DOWNLOADED_BY":"Tale report identifica gli asset scaricati, quali autenti li abbiano scaricati e quando.","CATALOG_SAVE_TEMPLATE_TITLE":"Creazione modello catalogo","BACKUP_FILES_LABEL":"File di backup","CONFIGURE_EMAIL_LINK":"Configurazione notifiche email...","NP_SOURCE":"Sorgente","NOTIFICATION_FAILURE_UPDATE":"Aggiornamento avvenuto senza successo","FIELD_FORM_LABEL_PRECISION_MAX":"Max","REPORT_DESCRIPTION_FILE_TYPES":"Tale report identifica le tipologie di file più comuni e quanto spazio su disco viene occupato.","REPORT_DESCRIPTION_SEARCH_TERMS":"Il presente report identifica le parole e le frasi più comuni per le quali gli utenti stanno svolgendo ricerche.","DUPLICATE_FIELD_NAME_ERROR":"Nome campo duplicato","NO_CATALOGS_EXIST":"Non esistono cataloghi.\n\nClicca sul pulsante + per creare un catalogo.","CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":"Cambia Ruolo","REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":"Cancelar socio","REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":"Rimuovi l'utente dal catalogo?\nGli articoli Pagati dall’utente in questo catalogo saranno ripristinati e resi accessibili.","CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":"Vuoi davvero modificare il ruolo dell'utente nel catalogo? Se il nuovo ruolo ha accesso o autorizzazioni ridotti, questa azione può essere distruttiva per i dati dell'utente.","DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":"Interrogazione in corso... Questa operazione potrebbe richiedere alcuni minuti.","FIELD_DELETE_CONFIRM_MSG":"Vuoi cancellare il campo selezionato?","FILE_TYPES_PROMPT_RESTORE_DEFAULTS":"Ripristinare tutti i Tipi di file ai loro valori predefiniti?","DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":"Filtra","DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":"AD utenti e gruppi","DIRECTORY_SERVICE_SAVE_MAPPINGS":"Salva e sincronizza","DIRECTORY_SERVICE_REMOVE_MAPPING":"Rimuovi mappatura","DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":"Portfolio importazioni utente","DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":"Nessuna mappatura.\n\nPer crearne una, seleziona un utente o un gruppo a sinistra, quindi clicca su 'Crea Mappatura'.","NOTIFICATION_FAILURE_ADD":"Aggiunta non riuscita","FIELD_ADD_EXTRACT_METADATA":"Aggiungi Estrai mappatura","FIELD_MULTIPLE_EMBED_WARNING":"Più di un campo si incorpora su","CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":"Smart Keyword per beni di recente catalogazione","LIC_CLICK_TO_UPGRADE":"Cliccare per aggiornare Portfolio Server","LIC_MAINTENANCE_END_DATE":"Data di fine della manutenzione / sottoscrizione","LIC_SEAT_DISPLAY":"Postazioni utente","LIC_ACTIVATE":"Attivare Portfolio (Credenziali Necessarie)","LIC_CLICK_TO_ACTIVATE":"Cliccare per attivare Portfolio Server","LIC_CLICK_TO_USE":"Cliccare per utilizzare Portfolio per un periodo di tempo limitato","LIC_TRIAL":"Prova Portfolio (Numero di Serie Necessario)","EXTENSIS_CONTACT_US_URL":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","EXTENSIS_SUPPORT_URL":"https://help.portfoliodam.com/hc/en-us/requests/new","LIC_ERROR_GET_ACCOUNT":"Si è verificato un problema nell'ottenimento del tuo account Portfolio DAM.","LIC_ERROR_GET_LICENSES":"Si è verificato un problema nel recupero delle tue licenze da Portfolio DAM.","CHANGE":"Modifica","GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":"Per modificare questa cartella, prima arresta Portfolio.","MEDIA_ENGINES_COLUMN_TEST":"Testa","ROLES_PERMISSIONS":"Autorizzazioni","NO_SITES_EXIST_1":"Non esiste alcun sito NetPublish.","NO_SITES_EXIST_2":"Utilizza l‘opzione Pubblica trovata in Portfolio per creare e pubblicare siti.","MEDIA_ENGINE_NOT_OPERATIONAL":"Non è stato possibile accedere ai motori di ricerca mediatici.","MEDIA_ENGINE_OPERATIONAL":"Media engine è operativo.","LIC_SET_EXTENSIS_ACCOUNT":"Imposta account Portfolio DAM","LIC_ACCOUNT":"Indirizzo e-mail","LIC_PASSWORD":"Password","CERTS_TITLE":"Certificato SSL","LIC_SYSTEM_ID":"ID sistema","LIC_SET_ACCOUNT_ERROR":"Si è verificato un problema nell'impostazione del tuo account Portfolio DAM. Controlla le credenziali e riprova.","LIC_SET_SYSTEM_TITLE":"Seleziona il tuo sistema Portfolio DAM","NP_DELETE_SITE_CONFIRMATION":"Vuoi eliminare definitivamente il sito?","NP_SITE_DELETE_LABEL":"Elimina sito","NP_SITE_ENABLED_LABEL":"Sito abilitato","CERT_CREATE_REQUEST":"Crea una richiesta di certificato","CERT_DOWNLOAD":"Scarica","CERT_EXPIRATION_DATE":"Data di scadenza","CERT_IMPORT":"Importa un certificato","CERT_ISSUER":"Emittente","CERT_OWNER":"Proprietario","CERT_PENDING_REQUEST":"Richiesta di certificato in sospeso","CERTIFICATE_STATUS_INVALID":"Certificato non valido","CERTIFICATE_STATUS_SELF_SIGNED":"Certificato non valido: Auto-firmato","CERTIFICATE_STATUS_EXPIRED":"Certificato scaduto","CERTIFICATE_STATUS_IMPORTED":"Certificato importato","CERT_DELETE_CONFIRMATION":"Sicuro di voler cancellare la richiesta di certificato? Azione irreversibile.","DIAGNOSTICS_TITLE":"Diagnostica","DIAGNOSTICS_NO_PROBLEMS":"Nessun problema riscontrato","SK_ENGINE_ART_STYLE":"Stile artistico","SK_ENGINE_ART_SUBJECT":"Soggetto artistico","SK_ENGINE_ART_MOVEMENT":"Movimento artistico","CERT_FILE":"File del certificato","CERT_FILE_INT_1":"Certificato intermedio 1","CERT_FILE_INT_2":"Certificato intermedio 2","CERT_FILE_PASSWORD":"Password del certificato","CERT_FILE_PASSWORD_HELP":"Se il tuo certificato è dotato di password, inseriscila qui","CERT_FILE_PROMPT":"Seleziona...","CERT_FILE_ROOT":"Certificato radice","CERT_IMPORT_SUCCEEDED":"Il certificato è stato importato con successo. Riavvia il server Portfolio e i servizi di Admin Portfolio per iniziare ad usare il certificato.","CERT_IMPORT_FAILED_READING_PKCS12":"Il server non è riuscito a leggere il certificato PKCS12. Controlla la password.","CERT_IMPORT_FAILED_INTERMEDIATE1":"Impossibile importare il certificato Intermedio 1.","CERT_IMPORT_FAILED_INTERMEDIATE2":"Impossibile importare il certificato Intermedio 2.","CERT_IMPORT_FAILED_ROOT":"Impossibile importare il certificato radice.","DIRECTORY_SERVICE_CONFIG_TITLE":"Configurazione del Servizio Directory","DIRECTORY_SERVICES_TITLE":"Servizi Directory","DIRECTORY_SERVICE_MAPIINGS":"Elementi della directory nelle mappature di Portfolio","DIRECTORY_SERVICE_MAPIINGS_TITLE":"Mappature","PDL_noPredefinedValues":"Nessun valore predefinito","PDL_editPredefinedListPlaceholder":"Modifica la lista predefinita","PDL_importPredefinedValues":"Importa valori predefiniti","PDL_exportPredefinedValues":"Esporta i valori predefiniti","PDL_removeNestedValueConfirmation":"Eliminare i valori selezionati?\nContengono valori nidificati che saranno altresì cancellati.","PDL_wrongPdlImportFormat":"Il file selezionato non contiene dati di testo. Selezionare un file di testo.","LIC_SET_ACCOUNT":"Imposta Account","LIC_REMOVE_ACCOUNT":"Rimuovi l'Account","LIC_CONTACT_CUSTOMER_SUCCESS_1":"Per assistenza con il rinnovo del tuo account, contattaci all'indirizzo","LIC_CONTACT_CUSTOMER_SUCCESS_2":"e il tuo Customer Success Manager ti contatterà entro 1 giorno lavorativo."});/* eslint-enable */

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Login_LoginModal__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__About_AboutModal__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_ModalPrompt__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Nav__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pageData__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_styles_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__admin_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_state_reducers_authReducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_view_App_NotificationDisplay_GlobalNotifications__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DialogPanels_BackupRestoreProgressDialog__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showDialogPanel=__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel,hideDialogPanel=__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel;var updateLastActivity=__WEBPACK_IMPORTED_MODULE_16_state_reducers_authReducer__["a" /* actions */].updateLastActivity;var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.showAbout=_this.showAbout.bind(_this);_this.renderLogin=_this.renderLogin.bind(_this);return _this;}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){// react-modal needs to know the App element  so screen
// readers don't see main content when a modal is opened.
__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a.setAppElement(document.getElementById('root'));}},{key:'showAbout',value:function showAbout(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_14_util_constants__["a" /* ABOUT_PANEL_ID */]);}},{key:'renderLogin',value:function renderLogin(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Login_LoginModal__["a" /* default */],{isFullAdmin:this.props.isFullAdmin,showAbout:this.showAbout});}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,backupRestoreStatus=_props.backupRestoreStatus,cancelBackup=_props.cancelBackup,hasIdentityService=_props.hasIdentityService,hideDialogPanel=_props.hideDialogPanel,_props$intl=_props.intl,locale=_props$intl.locale,messages=_props$intl.messages,isFullAdmin=_props.isFullAdmin,isLoggedIn=_props.isLoggedIn,main=_props.licensedFeatures.main,updateLastActivity=_props.updateLastActivity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* IntlProvider */],{key:locale,locale:locale,messages:messages},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:this.props.store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app',onClick:updateLastActivity,onKeyDown:updateLastActivity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_ModalPrompt__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_view_App_NotificationDisplay_GlobalNotifications__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__About_AboutModal__["a" /* default */],{isOpen:activePanelId===__WEBPACK_IMPORTED_MODULE_14_util_constants__["a" /* ABOUT_PANEL_ID */],onClose:hideDialogPanel}),isLoggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Nav__["a" /* default */],{hasIdentityService:hasIdentityService,isFullAdmin:isFullAdmin,isLicensed:main,navItemClass:'nav-item',navListClass:'nav-list',pages:__WEBPACK_IMPORTED_MODULE_12__pageData__["d" /* mainPages */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DialogPanels_BackupRestoreProgressDialog__["a" /* default */],{activePanelId:activePanelId,backupRestoreStatus:backupRestoreStatus,cancelBackup:cancelBackup,hideDialogPanel:hideDialogPanel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/login',render:this.renderLogin}),!isLoggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:'/login'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{exact:true,from:'/globalSettings',strict:true,to:'/globalSettings/dataLocations'})))))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);App=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["c" /* getActivePanelId */])(state),backupRestoreStatus:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["h" /* getBackupRestoreStatus */])(state),hasIdentityService:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["J" /* getHasIdentityService */])(state),intl:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["N" /* getIntl */])(state),isFullAdmin:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["T" /* getIsFullAdmin */])(state),isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["U" /* getIsLoggedIn */])(state),licensedFeatures:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_2" /* getLicensedFeatures */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({cancelBackup:__WEBPACK_IMPORTED_MODULE_19_state_commands_adminPropertiesCommands__["b" /* cancelBackup */],hideDialogPanel:hideDialogPanel,showDialogPanel:showDialogPanel,updateLastActivity:updateLastActivity});})(App);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(173);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(274);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(544);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(275);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(540);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32), __webpack_require__(75)(module)))

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(275);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(276);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(545);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(173);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(176);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(176);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(552);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(177);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(278);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(556);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(558);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(282);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(560);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(177);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(562);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(178);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(282);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(178);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(566);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(280);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(568);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(284);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(179);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(39);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(569);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(570);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(284);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(573);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(179);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(283);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(283);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormSection);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (formPropTypes);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(294);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(293);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(118);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(119);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(589);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(182);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(184);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(600);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(120);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(298);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(595);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(40);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(120);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(120);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(120);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(122);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(122);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(122);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(122);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(123);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(123);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(123);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(123);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(94);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(118);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(127);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(121);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(182);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(622);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(627);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(629);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(186);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(35);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(634);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(60);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(60);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(296);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(75)(module)))

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(305);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(40);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(40);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(40);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(40);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(118);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(292);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(10);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(313);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(124);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(186);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(96);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(314);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(662);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(96);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(96);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(314);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(93);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(124);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(127);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(316);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(191);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(736);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(319);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(717);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(40);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(75)(module)))

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(712);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(302);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(128);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(41);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(60);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(60);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(320);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(129);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(95);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(721);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(730);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(726);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(725);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(729);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(130);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(41);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(321);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(10);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(290);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(75)(module)))

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(118);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(743);
var bytesToUuid = __webpack_require__(744);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 744 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return electronModule; });
// App-specific definitions for use in shared code.
// The shared code imports this. Everything defined here should have a counterpart
// in the client-next/src/sharedCodeDependencies.
var electronModule=null;

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalizedError; });
/*
*  A custom error that can hold a message object
*  This message object can be used to store the
*  react intl message format
* */function createLocalizedError(){function LocError(message){this.name='LocError';this.message=message;}LocError.prototype=new Error();LocError.prototype.constructor=LocError;return LocError;};var LocalizedError=createLocalizedError();

/***/ }),
/* 747 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 748 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_LOGIN_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADMIN_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADMIN_LOGOUT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADMIN_LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADMIN_PROPERTIES_INTERVAL_RESOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_IDENTITY_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_PUBLIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_PUBLIC_KEY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_PUBLIC_KEY_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return IDENTITY_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IDENTITY_LOGIN_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return IDENTITY_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return IDENTITY_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return IDENTITY_LOGOUT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IDENTITY_LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESOURCE_ADMIN_PROPERTIES_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_LAST_ACTIVITY; });
var ADMIN_LOGIN='admin/auth/ADMIN_LOGIN';var ADMIN_LOGIN_FAIL='admin/auth/ADMIN_LOGIN_FAIL';var ADMIN_LOGIN_SUCCESS='admin/auth/ADMIN_LOGIN_SUCCESS';var ADMIN_LOGOUT='admin/auth/ADMIN_LOGOUT';var ADMIN_LOGOUT_FAIL='admin/auth/ADMIN_LOGOUT_FAIL';var ADMIN_LOGOUT_SUCCESS='admin/auth/ADMIN_LOGOUT_SUCCESS';var ADMIN_PROPERTIES_INTERVAL_RESOURCE='ADMIN_PROPERTIES_INTERVAL_RESOURCE';var RESOURCE_ADMIN_PROPERTIES_INTERVAL='admin/auth/RESOURCE_ADMIN_PROPERTIES_INTERVAL';var CLEAR_IDENTITY_SESSION='admin/CLEAR_IDENTITY_SESSION';var GET_PUBLIC_KEY='admin/GET_PUBLIC_KEY';var GET_PUBLIC_KEY_SUCCESS='admin/GET_PUBLIC_KEY_SUCCESS';var GET_PUBLIC_KEY_FAIL='admin/GET_PUBLIC_KEY_FAIL';var IDENTITY_LOGIN='admin/auth/IDENTITY_LOGIN';var IDENTITY_LOGIN_FAIL='admin/auth/IDENTITY_LOGIN_FAIL';var IDENTITY_LOGIN_SUCCESS='admin/auth/IDENTITY_LOGIN_SUCCESS';var IDENTITY_LOGOUT='admin/auth/IDENTITY_LOGOUT';var IDENTITY_LOGOUT_FAIL='admin/auth/IDENTITY_LOGOUT_FAIL';var IDENTITY_LOGOUT_SUCCESS='admin/auth/IDENTITY_LOGOUT_SUCCESS';var SET_LAST_ACTIVITY='admin/auth/SET_LAST_ACTIVITY';

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_view_Reachout_Reachout__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_authCommands__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__admin_styles_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__admin_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__admin_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_browserUtils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_persistCommands__ = __webpack_require__(115);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showDialogPanel=__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel,hideDialogPanel=__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel;var Header=function(_Component){_inherits(Header,_Component);function Header(){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this));_this.handleLogout=_this.handleLogout.bind(_this);_this.handleShowAbout=_this.handleShowAbout.bind(_this);_this.openHelpLink=_this.openHelpLink.bind(_this);return _this;}_createClass(Header,[{key:'handleLogout',value:function handleLogout(){this.props.logout();}},{key:'handleShowAbout',value:function handleShowAbout(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_10_util_constants__["a" /* ABOUT_PANEL_ID */]);}},{key:'openHelpLink',value:function openHelpLink(){Object(__WEBPACK_IMPORTED_MODULE_11_util_browserUtils__["c" /* openHelpLink */])(this.props.intl);}},{key:'render',value:function render(){var _props=this.props,addDismissedReachoutMessageId=_props.addDismissedReachoutMessageId,dismissedMessageIds=_props.dismissedMessageIds,reachoutMessages=_props.reachoutMessages;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_view_Reachout_Reachout__["a" /* default */],{reachoutMessages:reachoutMessages,className:'reachout',classNameDismiss:'reachoutDismiss',onDismissMessage:addDismissedReachoutMessageId,dismissedMessageIds:dismissedMessageIds,openLink:__WEBPACK_IMPORTED_MODULE_11_util_browserUtils__["d" /* openLink */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'header-item','data-test-name':'logout-link',onClick:this.handleLogout},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].NAV_LOGOUT)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'header-item','data-test-name':'help-link',onClick:this.openHelpLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].NAV_HELP)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'header-item','data-test-name':'about-link',onClick:this.handleShowAbout},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].NAV_ABOUT)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'horizontal-spacer-infinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'})));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{reachoutMessages:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_14" /* getReachoutMessages */])(state),dismissedMessageIds:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["B" /* getDismissedMessageIds */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addDismissedReachoutMessageId:__WEBPACK_IMPORTED_MODULE_12_state_commands_persistCommands__["a" /* addDismissedReachoutMessageId */],logout:__WEBPACK_IMPORTED_MODULE_7_state_commands_authCommands__["b" /* logout */],hideDialogPanel:hideDialogPanel,showDialogPanel:showDialogPanel});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(Header)));

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_reachoutUtils__ = __webpack_require__(269);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Reachout=function(_Component){_inherits(Reachout,_Component);function Reachout(){_classCallCheck(this,Reachout);var _this=_possibleConstructorReturn(this,(Reachout.__proto__||Object.getPrototypeOf(Reachout)).call(this));_this.chooseReachoutMessage=_this.chooseReachoutMessage.bind(_this);_this.handleDismiss=_this.handleDismiss.bind(_this);return _this;}_createClass(Reachout,[{key:'chooseReachoutMessage',value:function chooseReachoutMessage(){var _props=this.props,reachoutMessages=_props.reachoutMessages,dismissedMessageIds=_props.dismissedMessageIds;return Object(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_reachoutUtils__["a" /* chooseReachoutMessageToDisplay */])(reachoutMessages,dismissedMessageIds);}},{key:'handleDismiss',value:function handleDismiss(){var rm=this.chooseReachoutMessage();if(rm){this.props.onDismissMessage(rm.id);}}},{key:'render',value:function render(){var _props2=this.props,className=_props2.className,classNameDismiss=_props2.classNameDismiss,openLink=_props2.openLink;var reachoutMessage=this.chooseReachoutMessage();if(!reachoutMessage){return null;}var text=reachoutMessage.text,url=reachoutMessage.url,urlText=reachoutMessage.urlText;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:className,style:{width:'100%',position:'relative',lineHeight:'30px',paddingLeft:'10px',paddingRight:'35px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:'message'},text),url&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return openLink(url);}// eslint-disable-line react/jsx-no-bind
,className:className,style:{marginLeft:'10px',textDecoration:'underline',cursor:'pointer'}},urlText||url),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'fa-stack',style:{position:'absolute',right:'10px',top:'4px',fontSize:'11px'},onClick:this.handleDismiss},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-circle fa-stack-2x'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-close fa-stack-1x fa-lg '+classNameDismiss})));}}]);return Reachout;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Reachout.propTypes={reachoutMessages:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,dismissedMessageIds:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,classNameDismiss:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,onDismissMessage:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,openLink:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Reachout);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoginForm__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_browserUtils__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginModal=function(_Component){_inherits(LoginModal,_Component);function LoginModal(){_classCallCheck(this,LoginModal);var _this=_possibleConstructorReturn(this,(LoginModal.__proto__||Object.getPrototypeOf(LoginModal)).call(this));_this.closeModal=_this.closeModal.bind(_this);_this.openHelpLink=_this.openHelpLink.bind(_this);return _this;}_createClass(LoginModal,[{key:'closeModal',value:function closeModal(){var _props=this.props,history=_props.history,isFullAdmin=_props.isFullAdmin;history.push(isFullAdmin?'/status':'/catalogs');}},{key:'openHelpLink',value:function openHelpLink(){Object(__WEBPACK_IMPORTED_MODULE_6_util_browserUtils__["c" /* openHelpLink */])(this.props.intl);}},{key:'render',value:function render(){var formatMessage=this.props.intl.formatMessage;var modalStyles={overlay:{backgroundColor:'rgba(127, 127, 127, 0.9)'},content:{padding:'0px',width:'100%',height:'100%',top:'50%',left:'50%',right:'auto',bottom:'auto',transform:'translate(-50%, -50%)',overflow:'hidden'}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{style:modalStyles,contentLabel:'Login Modal',isOpen:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'splashScreen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'helpAboutLinkContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'upperRightLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'helpLink',onClick:this.openHelpLink},formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].NAV_HELP))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'//'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'upperRightLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'helpLink',onClick:this.props.showAbout},formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].ABOUT)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LoginForm__["a" /* default */],{closeModal:this.closeModal}))));}}]);return LoginModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginModal=Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(LoginModal)));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_intlCommands__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_view_Login_LocaleSwitcher__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_authCommands__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_faultCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Login_css__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Login_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginForm=function(_Component){_inherits(LoginForm,_Component);function LoginForm(){_classCallCheck(this,LoginForm);var _this=_possibleConstructorReturn(this,(LoginForm.__proto__||Object.getPrototypeOf(LoginForm)).call(this));_this.renderInput=_this.renderInput.bind(_this);_this.submit=_this.submit.bind(_this);_this.setLocale=_this.setLocale.bind(_this);return _this;}// Uncomment to automatically login for development.
/*
  async componentDidMount() {
    if (!window.didAutologin) {
      await this.props.login('administrator', 'password');
      this.props.closeModal();
      window.didAutologin = true;
    }
  }
  */_createClass(LoginForm,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(values,dispatch,props){var username,password;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// TODO: submit form and close modal via reducers
username=values.username,password=values.password;_context.next=3;return this.props.login(username,password);case 3:if(this.props.isLoggedIn){this.props.closeModal();}case 4:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2,_x3){return _ref.apply(this,arguments);}return submit;}()},{key:'setLocale',value:function setLocale(locale){this.props.setLocale(locale);this.props.setMessages(locale);}},{key:'renderInput',value:function renderInput(field){var intl=this.props.intl;var input=field.input,_field$type=field.type,type=_field$type===undefined?'text':_field$type;var name=input.name;var placeholder=name==='username'?intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].USER_NAME):intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].PASSWORD);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',Object.assign({},input,{'data-test-name':name+'-input',className:'input',placeholder:placeholder,style:{width:'100%'},type:type}));}},{key:'render',value:function render(){var _props=this.props,error=_props.error,handleSubmit=_props.handleSubmit,intl=_props.intl,pristine=_props.pristine;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:handleSubmit(this.submit),'data-test-name':'login-form'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginHeader'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginForm'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:'username',component:this.renderInput,type:'text'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:'password',component:this.renderInput,type:'password'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'level select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_view_Login_LocaleSwitcher__["a" /* default */],{locale:this.props.intl.locale,selectClassName:'localePicker',setLocale:this.setLocale})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit','data-test-name':'login-submit-button',className:'button is-primary',disabled:pristine||error,style:{width:'100%'}},intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].LOGIN))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'versionNumber'},'Portfolio ',__WEBPACK_IMPORTED_MODULE_12_util_constants__["_19" /* version */])));}}]);return LoginForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function validate(data,props){return{_error:!data.username||!data.password};}var wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({form:'login',validate:validate})(LoginForm);wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(wrappedForm);/* harmony default export */ __webpack_exports__["a"] = (wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["U" /* getIsLoggedIn */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["a" /* bindActionCreatorsForm */])({login:__WEBPACK_IMPORTED_MODULE_10_state_commands_authCommands__["a" /* login */],setLocale:__WEBPACK_IMPORTED_MODULE_6_state_commands_intlCommands__["a" /* setLocale */],setMessages:__WEBPACK_IMPORTED_MODULE_6_state_commands_intlCommands__["b" /* setMessages */]},_defineProperty({},__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_faultCode__["c" /* FC_INVALID_CREDENTIALS */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].loginFailed));})(wrappedForm));

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// A Select widget that displays and switches the current locale
var LocaleSwitcher=function(_Component){_inherits(LocaleSwitcher,_Component);function LocaleSwitcher(){_classCallCheck(this,LocaleSwitcher);var _this=_possibleConstructorReturn(this,(LocaleSwitcher.__proto__||Object.getPrototypeOf(LocaleSwitcher)).call(this));_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(LocaleSwitcher,[{key:'handleChange',value:function handleChange(e){this.props.setLocale(e.target.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{id:'localeSelect','data-test-name':'locale-select',className:this.props.selectClassName,onChange:this.handleChange,value:this.props.locale},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'en'},'English (U.S.)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'en-GB'},'English'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'fr'},'Fran\xE7ais'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'de'},'Deutsch'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'it'},'Italiano'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'es'},'Espa\xF1ol'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'ja'},'Nihongo'));}}]);return LocaleSwitcher;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);LocaleSwitcher.propTypes={locale:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,setLocale:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,selectClassName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (LocaleSwitcher);

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_browserUtils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutModal_css__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AboutModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AboutModal=function(_Component){_inherits(AboutModal,_Component);function AboutModal(){_classCallCheck(this,AboutModal);return _possibleConstructorReturn(this,(AboutModal.__proto__||Object.getPrototypeOf(AboutModal)).apply(this,arguments));}_createClass(AboutModal,[{key:'renderPortfolioInfo',value:function renderPortfolioInfo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aboutPanelBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Portfolio DAM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.portfoliodam.com',rel:'noopener noreferrer',target:'_blank'},'www.portfoliodam.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'US: 857.408.4923',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Copyright \xA9 2026 Portfolio DAM, LLC. All rights reserved.');}},{key:'renderAPIInfo',value:function renderAPIInfo(_ref){var formatMessage=_ref.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aboutPanelBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].API_SECTION_1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].API_SECTION_2_PART_3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].API_CODE_REFERENCE_URL),rel:'noopener noreferrer',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].API_CODE_REFERENCE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].API_PORTFOLIO_HELP_URL,{version:Object(__WEBPACK_IMPORTED_MODULE_5_util_browserUtils__["a" /* getHelpVersion */])()}),rel:'noopener noreferrer',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].API_PORTFOLIO_HELP)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}},{key:'render',value:function render(){var _props=this.props,isOpen=_props.isOpen,onClose=_props.onClose;var modalStyles={overlay:{backgroundColor:'rgba(127, 127, 127, 0.65)',zIndex:2},content:{padding:'0px',height:'520px',width:'600px',top:'50%',left:'50%',right:'auto',bottom:'auto',overflow:'hidden'}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{closeTimeoutMS:150,isOpen:isOpen,onRequestClose:onClose,shouldCloseOnOverlayClick:true,style:modalStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aboutPanelLogo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panelHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panelTitle'},'Portfolio Administration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panelSubtitle'},'Version ',__WEBPACK_IMPORTED_MODULE_4_util_constants__["_19" /* version */])),this.renderPortfolioInfo(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),this.renderAPIInfo(this.props)));}}]);return AboutModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(AboutModal));

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_portfolio_shared_util_localizedStrings__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_view_ModalPrompt_ModalPrompt_css__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_view_ModalPrompt_ModalPrompt_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_view_ModalPrompt_ModalPrompt_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// An easy-to-use modal prompt that has
// 1) A localized message
// 2) Zero or more buttons
// It can be dismissed by escape (or not), enter, or by clicking a button.
// The text on the buttons can be customized.
// To use it, dispatch showModalPrompt from the modalPromptReducer, and pass
// properties.
//
// dispatch(showModalPrompt({
//   message: { id: 'message-id', defaultMessage: 'Hello, {friend}' },
//   messageArguments: { friend: 'David' },
//   button1text: { id: 'cancel-id', defaultMessage: 'Cancel' } // Leave this out for default (Cancel)
//   button2text: { id: 'ok-id', defaultMessage: 'OK' } // Leave this out for default (OK)
//   onButton1: anOptionalFunction,
//   onButton2: anotherOptionalFunction,
//   closeOnEscape: true,
//   isButton1Default: false, // Yes, they can both be default, or neither can.
//   isButton2Default: true
// }));
//
var hideModalPrompt=__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].hideModalPrompt;var kButton1Id='modalPromptButton1';var kButton2Id='modalPromptButton2';var ModalPrompt=function(_Component){_inherits(ModalPrompt,_Component);function ModalPrompt(){_classCallCheck(this,ModalPrompt);var _this=_possibleConstructorReturn(this,(ModalPrompt.__proto__||Object.getPrototypeOf(ModalPrompt)).call(this));_this.onButton1=_this.onButton1.bind(_this);_this.onButton2=_this.onButton2.bind(_this);_this.onRequestClose=_this.onRequestClose.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.onAfterOpen=_this.onAfterOpen.bind(_this);_this.linesToParagraphs=_this.linesToParagraphs.bind(_this);return _this;}_createClass(ModalPrompt,[{key:'onButton1',value:function onButton1(){this.props.hideModalPrompt();if(this.props.onButton1){this.props.onButton1();}}},{key:'onButton2',value:function onButton2(){this.props.hideModalPrompt();if(this.props.onButton2){this.props.onButton2();}}// this is called when the esc key is clicked
},{key:'onRequestClose',value:function onRequestClose(){if(this.props.closeOnEscape!==false){this.props.hideModalPrompt();}}},{key:'handleKeyDown',value:function handleKeyDown(e){if(e.keyCode===13){if(this.props.isButton1Default){this.onButton1();}else if(this.props.isButton2Default){this.onButton2();}}}},{key:'onAfterOpen',value:function onAfterOpen(){if(this.props.isButton1Default){document.getElementById(kButton1Id).focus();}else if(this.props.isButton2Default){document.getElementById(kButton2Id).focus();}}},{key:'render',value:function render(){// TODO: move me later
var modalStyles={overlay:{zIndex:9998,backgroundColor:'rgba(127, 127, 127, 0.9)'},content:Object.assign({position:'absolute',top:'45%',left:'50%',maxWidth:'400px',minWidth:'250px',backgroundColor:'#fff',margin:'30px auto auto'},this.props.contentStyle)};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{style:modalStyles,className:'modal-prompt-panel',contentLabel:'Modal Prompt',onRequestClose:this.onRequestClose,shouldCloseOnOverlayClick:false,closeTimeoutMS:150,isOpen:this.props.isPanelOpen,onAfterOpen:this.onAfterOpen,shouldReturnFocusAfterClose:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-prompt-panelBody','data-test-name':this.props.dataTestName||'modal-prompt'},this.linesToParagraphs()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-prompt-panelButtonsContainer buttons'},this.props.button1text?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:kButton1Id,className:this.props.isButton1Default?'button is-primary':'button',type:'button',onClick:this.onButton1,value:this.props.intl.formatMessage(this.props.button1text)}):'',this.props.button2text?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:kButton2Id,className:this.props.isButton2Default?'button is-primary':'button',type:'button',onClick:this.onButton2,value:this.props.intl.formatMessage(this.props.button2text)}):''));}},{key:'linesToParagraphs',value:function linesToParagraphs(){if(this.props.message){var string=this.props.intl.formatMessage(this.props.message,this.props.messageArguments);var lines=string.split('\n');return lines.map(function(line,index){var key='line'+index;if(line.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:key},'\xA0');}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-prompt-panelLine',key:key},line);}});}}}]);return ModalPrompt;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ModalPrompt.propTypes={intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["g" /* intlShape */].isRequired,isPanelOpen:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,hideModalPrompt:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,message:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,messageArguments:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,button1text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,button2text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,onButton1:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onButton2:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,closeOnEscape:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,isButton1Default:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,isButton2Default:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,contentStyle:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,dataTestName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};var wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* injectIntl */])(ModalPrompt);/* harmony default export */ __webpack_exports__["a"] = (wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){var props=Object.assign({isPanelOpen:state.modalPrompt.isVisible},state.modalPrompt.properties);if(props.button1text===undefined){props.button1text=__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_util_localizedStrings__["a" /* default */].Cancel;}if(props.button2text===undefined){props.button2text=__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_util_localizedStrings__["a" /* default */].OK;}if(props.isButton1Default===undefined){props.isButton1Default=false;}if(props.isButton2Default===undefined){props.isButton2Default=false;}return props;},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({hideModalPrompt:hideModalPrompt},dispatch);})(wrappedForm));

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pageData__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__admin_styles_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__admin_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__admin_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_badge_png__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_badge_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_badge_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavItem=function(_Component){_inherits(NavItem,_Component);function NavItem(){_classCallCheck(this,NavItem);return _possibleConstructorReturn(this,(NavItem.__proto__||Object.getPrototypeOf(NavItem)).apply(this,arguments));}_createClass(NavItem,[{key:'render',value:function render(){var _props=this.props,hasIdentityService=_props.hasIdentityService,isFullAdmin=_props.isFullAdmin,isLicensed=_props.isLicensed,navItemClass=_props.navItemClass,page=_props.page;// Most pages require the user to be the full admin, some allow catalog admins.
// Some pages require the server to be licensed, but catalog admins cannot retrieve licenses.
// This leaves open a gap for catalog admins who log into an unlicensed server,
// which is not ideal but is similar to Classic Admin behavior and an edge case.
var isEnabled=(!__WEBPACK_IMPORTED_MODULE_3__pageData__["e" /* pageRouteRequiresIdentityService */].includes(page.route)||hasIdentityService)&&(isLicensed||!__WEBPACK_IMPORTED_MODULE_3__pageData__["f" /* pageRouteRequiresLicense */].includes(page.route)||!isFullAdmin);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{activeClassName:'nav-item-selected',className:isEnabled?navItemClass:navItemClass+' nav-item-disabled','data-test-name':'nav-item-'+(page.label.defaultMessage||''),to:page.route},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],page.label),page.badge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_badge_png___default.a,className:'badge',alt:'Unlicensed feature badge'}));}}]);return NavItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pageData__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_styles_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__admin_styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GlobalSettingsPage=function(_Component){_inherits(GlobalSettingsPage,_Component);function GlobalSettingsPage(){_classCallCheck(this,GlobalSettingsPage);return _possibleConstructorReturn(this,(GlobalSettingsPage.__proto__||Object.getPrototypeOf(GlobalSettingsPage)).apply(this,arguments));}_createClass(GlobalSettingsPage,[{key:'render',value:function render(){var _props=this.props,isFullAdmin=_props.isFullAdmin,hasIdentityService=_props.hasIdentityService;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Nav__["a" /* default */],{className:'nav-secondary',hasIdentityService:hasIdentityService,isFullAdmin:isFullAdmin,navItemClass:'nav-item nav-item-secondary',navListClass:'nav-list nav-list-secondary',pages:__WEBPACK_IMPORTED_MODULE_2__pageData__["b" /* globalSettingsPages */]}));}}]);return GlobalSettingsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GlobalSettingsPage);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_BrowseServerFoldersDialog__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_Forms_FormField__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_Forms_StaticTextField__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_folderUtils__ = __webpack_require__(134);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loc=__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */];var backupDays=[{label:loc.BACKUP_SUNDAY_LABEL,value:'areBackupsScheduledSunday'},{label:loc.BACKUP_MONDAY_LABEL,value:'areBackupsScheduledMonday'},{label:loc.BACKUP_TUESDAY_LABEL,value:'areBackupsScheduledTuesday'},{label:loc.BACKUP_WEDNESDAY_LABEL,value:'areBackupsScheduledWednesday'},{label:loc.BACKUP_THURSDAY_LABEL,value:'areBackupsScheduledThursday'},{label:loc.BACKUP_FRIDAY_LABEL,value:'areBackupsScheduledFriday'},{label:loc.BACKUP_SATURDAY_LABEL,value:'areBackupsScheduledSaturday'}];var retainOptions=['1','2','3','5','10'];var TIME_SEP=':';var AM='AM';var PM='PM';var DEFAULT_TIME='12:00:AM';var BackupsPage=function(_Component){_inherits(BackupsPage,_Component);function BackupsPage(){_classCallCheck(this,BackupsPage);var _this=_possibleConstructorReturn(this,(BackupsPage.__proto__||Object.getPrototypeOf(BackupsPage)).call(this));_this.state={isSelectingRestoreArchive:false};_this.getTimeOptionForValue=_this.getTimeOptionForValue.bind(_this);_this.getTimeOptions=_this.getTimeOptions.bind(_this);_this.handleBrowseForDirectory=_this.handleBrowseForDirectory.bind(_this);_this.handleClickBackup=_this.handleClickBackup.bind(_this);_this.handleClickRestore=_this.handleClickRestore.bind(_this);_this.handlePathSelected=_this.handlePathSelected.bind(_this);_this.normalizeTimeValueForServer=_this.normalizeTimeValueForServer.bind(_this);_this.onChangeCheckbox=_this.onChangeCheckbox.bind(_this);_this.onChangeField=_this.onChangeField.bind(_this);_this.setIsScheduled=_this.setIsScheduled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(BackupsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getAdminProperties([__WEBPACK_IMPORTED_MODULE_6_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].backupConfig]);}},{key:'handleBrowseForDirectory',value:function handleBrowseForDirectory(){this.setState({isSelectingRestoreArchive:false});this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_7_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]);}},{key:'handleBrowseForZipFile',value:function handleBrowseForZipFile(){this.setState({isSelectingRestoreArchive:true});this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_7_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]);}},{key:'handleClickBackup',value:function handleClickBackup(){this.props.backup();}},{key:'handleClickRestore',value:function handleClickRestore(){this.handleBrowseForZipFile();}},{key:'handlePathSelected',value:function handlePathSelected(path){if(this.state.isSelectingRestoreArchive){this.props.restore(path);}else{this.submit('backupsDirectory',path);}}},{key:'onChangeField',value:function onChangeField(event,fieldName){this.submit(fieldName,event.target.value);}},{key:'onChangeCheckbox',value:function onChangeCheckbox(event,fieldName){this.submit(fieldName,event.target.checked);}},{key:'normalizeTimeValueForServer',value:function normalizeTimeValueForServer(config){// don't ever send the server null for time
if(!config.backupScheduledTime){config.backupScheduledTime=DEFAULT_TIME;}var parts=config.backupScheduledTime.split(TIME_SEP);// server can send hour as '00' but it expects to be given '12'
if(Number(parts[0])===0){config.backupScheduledTime='12'+TIME_SEP+parts[1]+TIME_SEP+parts[2];}}},{key:'setIsScheduled',value:function setIsScheduled(c){c.areBackupsScheduled=c.areBackupsScheduledSunday||c.areBackupsScheduledMonday||c.areBackupsScheduledTuesday||c.areBackupsScheduledWednesday||c.areBackupsScheduledThursday||c.areBackupsScheduledFriday||c.areBackupsScheduledSaturday;}},{key:'submit',value:function submit(fieldName,value){var newConfig=Object.assign({},this.props.backupConfig,_defineProperty({},fieldName,value));this.normalizeTimeValueForServer(newConfig);this.setIsScheduled(newConfig);this.props.setBackupConfig(newConfig);}// 48 options, 1 per each half hour
},{key:'getTimeOptions',value:function getTimeOptions(){var opts=[];for(var ix=0;ix<48;++ix){var hour=Math.floor(ix/2)||12;hour=hour>12?hour-12:hour;var min=ix%2===0?'00':'30';var ampm=ix<24?AM:PM;opts.push({label:hour+TIME_SEP+min+' '+ampm,value:hour+TIME_SEP+min+TIME_SEP+ampm});}return opts;}},{key:'getTimeOptionForValue',value:function getTimeOptionForValue(value){var index=0;if(value){var parts=value.split(TIME_SEP);var hours=Number(parts[0]);var mins=Number(parts[1]);index=hours*2+(mins>=30?1:0)+(parts[2]===AM?0:24);}return this.getTimeOptions()[index];}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activePanelId=_props.activePanelId,backupConfig=_props.backupConfig,_props$intl=_props.intl,formatDate=_props$intl.formatDate,formatMessage=_props$intl.formatMessage,formatTime=_props$intl.formatTime,serverStatus=_props.serverStatus;var backupDate=backupConfig.nextScheduledBackup;var formattedDate=backupDate&&formatDate(backupDate)||formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].DEFAULT_CATALOG_NONE);var formattedTime=backupDate&&formatTime(backupDate)||'';var timeOptionForValue=this.getTimeOptionForValue(backupConfig.backupScheduledTime).value;var isStopped=serverStatus.runState===__WEBPACK_IMPORTED_MODULE_7_util_constants__["Z" /* SERVER_STATE_STOPPED */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'backup-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.NAV_BACKUPS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_EXPLANATION_TEXT_1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_EXPLANATION_TEXT_2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons large-buttons backups-page-main-button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-medium is-primary is-outlined','data-test-name':'backup-button',onClick:this.handleClickBackup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_BACKUP_NOW_BUTTON)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'horizontal-spacer-xlarge'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-medium is-primary is-outlined','data-test-name':'restore-button',onClick:this.handleClickRestore},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_RESTORE_BUTTON)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'next-backup',key:'BACKUP_NEXT_SCHEDULED_LABEL',label:formatMessage(loc.BACKUP_NEXT_SCHEDULED_LABEL),value:formattedDate+' '+formattedTime,valueClassName:!backupConfig.areBackupsScheduled?'has-text-danger':''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_view_Forms_FormField__["a" /* default */],{label:formatMessage(loc.AT_TIME)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'backupScheduleTime',onChange:function onChange(e){return _this2.onChangeField(e,'backupScheduledTime');},style:{width:'140px'},value:timeOptionForValue},this.getTimeOptions().map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.value,value:opt.value},opt.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_SCHEDULE_VALUE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline',style:{marginTop:'5px'}},backupDays.map(function(backupDay){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:backupDay.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:!!backupConfig[backupDay.value],className:'is-checkradio',id:backupDay.value,onChange:function onChange(e){return _this2.onChangeCheckbox(e,backupDay.value);},type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label',htmlFor:backupDay.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],backupDay.label)));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'most-recent-backup',key:'BACKUP_MOST_RECENT_LABEL',label:formatMessage(loc.BACKUP_MOST_RECENT_LABEL),value:backupConfig.mostRecentBackupFileName||formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].DEFAULT_CATALOG_NONE)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_DIRECTORY_LABEL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'input','data-test-name':'store-in-directory',readOnly:true,style:{width:'600px'},value:backupConfig.backupsDirectory||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-outlined','data-test-name':'browse-for-directory',disabled:!isStopped,onClick:this.handleBrowseForDirectory},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BROWSE))))),!isStopped&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_Forms_StaticTextField__["a" /* default */],{label:'',valueClassName:'help',value:formatMessage(loc.BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_RETAIN_LABEL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'select','data-test-name':'backups-to-retain',id:'backupsRetainCount',onChange:function onChange(e){return _this2.onChangeField(e,'backupsRetainCount');},style:{width:'100px'},value:backupConfig.backupsRetainCount},retainOptions.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt,value:opt},opt);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label is-pulled-left',style:{marginLeft:'16px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.BACKUP_FILES_LABEL)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:backupConfig.isEmailNotificationConfigured||false,className:'is-checkradio','data-test-name':'enable-email-notifications',id:'isEmailNotificationConfigured',onChange:function onChange(e){return _this2.onChangeCheckbox(e,'isEmailNotificationConfigured');},type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label control',htmlFor:'isEmailNotificationConfigured'},formatMessage(loc.BACKUP_NOTIFICATIONS))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'is-indented control',href:'#globalSettings/email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],loc.CONFIGURE_EMAIL_LINK)))))),activePanelId===__WEBPACK_IMPORTED_MODULE_7_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_BrowseServerFoldersDialog__["a" /* default */],{fileFilter:this.state.isSelectingRestoreArchive&&zipFileFilter||undefined,onPathSelected:this.handlePathSelected,showFiles:this.state.isSelectingRestoreArchive}));}}]);return BackupsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function zipFileFilter(tree){return tree&&tree.fullPath&&(tree.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_folderUtils__["a" /* FILETYPE */].directory||tree.type===__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_folderUtils__["a" /* FILETYPE */].file&&tree.fullPath.toLowerCase().endsWith('.zip'));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["c" /* getActivePanelId */])(state),backupConfig:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["g" /* getBackupConfig */])(state),serverStatus:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_27" /* getServerStatus */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({backup:__WEBPACK_IMPORTED_MODULE_3_state_commands_adminPropertiesCommands__["a" /* backup */],getAdminProperties:__WEBPACK_IMPORTED_MODULE_3_state_commands_adminPropertiesCommands__["e" /* getAdminProperties */],restore:__WEBPACK_IMPORTED_MODULE_3_state_commands_adminPropertiesCommands__["g" /* restore */],setBackupConfig:__WEBPACK_IMPORTED_MODULE_3_state_commands_adminPropertiesCommands__["i" /* setBackupConfig */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_4_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(BackupsPage)));

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerFolders; });
/* unused harmony export ServerFolderSubTree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_view_Utilities_TreeView__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_folderUtils__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_sharedConstants__ = __webpack_require__(116);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/jsx-no-bind */var array=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,func=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,number=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,object=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,string=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string;// Admin doesn't have CSS modules so mock it using global CSS names
var browseStyles="admin"===__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_util_sharedConstants__["b" /* PRODUCT_ADMIN */]?{arrow:'arrow',folderIconContainer:'folderIconContainer',folderList:'folderList',folderListActive:'folderListActive',folderListContainer:'folderListContainer',folderListInner:'folderListInner',noselect:'noselect'}:__webpack_require__(764);var TREE_ITEM_HEIGHT=23;var OUTER_DIV_ID='serverFoldersContainer';var ServerFolders=function(_Component){_inherits(ServerFolders,_Component);function ServerFolders(){_classCallCheck(this,ServerFolders);var _this=_possibleConstructorReturn(this,(ServerFolders.__proto__||Object.getPrototypeOf(ServerFolders)).call(this));_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}// This is intended to be used by the containing and must be retrieved via a ref.
_createClass(ServerFolders,[{key:'handleKeyDown',value:function handleKeyDown(e){var result=false;if(e.keyCode===38||e.keyCode===40){result=true;// The up and down arrow keys
e.preventDefault();// Get the next or previous path depending on the key.
var nextPath=Object(__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_folderUtils__["c" /* getNextPath */])(this.props.treeArray,this.props.selectedFolderPath,e.keyCode===38);if(nextPath){this.props.onFolderSelected(nextPath);}}else if(e.keyCode===37||e.keyCode===39){result=true;// The left and right arrow keys
// Don't preventDefault in this case so that these can be captured by other controls.
var selectedPath=this.props.selectedFolderPath;var selectedFolder=Object(__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_folderUtils__["b" /* getFolderForPath */])(this.props.treeArray,selectedPath);if(selectedFolder){if(e.keyCode===39){// Expand the folder if it is not already.
if(!selectedFolder.isExpanded){this.props.onToggleCollapse(selectedPath);}}else{// Close the folder if it is expanded.
if(selectedFolder.isExpanded){this.props.onToggleCollapse(selectedPath);}}}}return result;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,fileFilter=_props.fileFilter,selectedFolderPath=_props.selectedFolderPath,treeArray=_props.treeArray;var folders=[];if(treeArray&&Array.isArray(treeArray)&&treeArray.length>0){folders=treeArray;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{tabIndex:'0',id:OUTER_DIV_ID,className:this.props.outerDivStyle+' '+browseStyles.folderListContainer},folders.filter(fileFilter).map(function(folder){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ServerFolderSubTree,{fileFilter:fileFilter,key:folder.fullPath,selectedFolderPath:selectedFolderPath,onToggleCollapse:_this2.props.onToggleCollapse,onFolderSelected:_this2.props.onFolderSelected,tree:folder,level:0});}));}}]);return ServerFolders;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ServerFolders.propTypes={fileFilter:func,treeArray:array,onToggleCollapse:func.isRequired,onFolderSelected:func.isRequired,selectedFolderPath:string,outerDivStyle:string.isRequired,pathSeparator:string.isRequired};ServerFolders.defaultProps={fileFilter:function fileFilter(tree){return true;}};var ServerFolderSubTree=function(_Component2){_inherits(ServerFolderSubTree,_Component2);function ServerFolderSubTree(){_classCallCheck(this,ServerFolderSubTree);var _this3=_possibleConstructorReturn(this,(ServerFolderSubTree.__proto__||Object.getPrototypeOf(ServerFolderSubTree)).call(this));_this3.onLabelClick=_this3.onLabelClick.bind(_this3);_this3.handleCollapse=_this3.handleCollapse.bind(_this3);_this3.isSelected=_this3.isSelected.bind(_this3);return _this3;}_createClass(ServerFolderSubTree,[{key:'onLabelClick',value:function onLabelClick(tree,e){e.preventDefault();e.stopPropagation();this.props.onFolderSelected(tree.fullPath,e);}},{key:'handleCollapse',value:function handleCollapse(){this.props.onToggleCollapse(this.props.tree.fullPath);}},{key:'isSelected',value:function isSelected(){return this.props.selectedFolderPath===this.props.tree.fullPath;}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.isSelected()){// Adjust the scroll bar so that the selected item is visible.
var me=__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);var myRect=me.getBoundingClientRect();var scrollBox=document.getElementById(OUTER_DIV_ID);var scrollRect=scrollBox.getBoundingClientRect();if(myRect.top>=scrollRect.bottom-TREE_ITEM_HEIGHT/2){scrollBox.scrollTop=scrollBox.scrollTop+TREE_ITEM_HEIGHT;}else if(myRect.bottom<=scrollRect.top+TREE_ITEM_HEIGHT/2){scrollBox.scrollTop=scrollBox.scrollTop-TREE_ITEM_HEIGHT;}}}},{key:'renderIcon',value:function renderIcon(fsObj){switch(fsObj.type){case __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_folderUtils__["a" /* FILETYPE */].directory:return fsObj.isExpanded?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-folder-open-o'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-folder-o'});case __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_folderUtils__["a" /* FILETYPE */].file:if(fsObj.displayName.toLowerCase().endsWith('.zip')){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-file-archive-o'});}// falls through
default:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-file-o'});}}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,fileFilter=_props2.fileFilter,tree=_props2.tree,level=_props2.level;if(!tree){__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_logging__["a" /* default */].error('BrowseServerFolders render: tree is null');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}var folderStyle=browseStyles.folderList;if(this.isSelected()){folderStyle=browseStyles.folderListActive;}var label=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-test-name':tree.fullPath,className:browseStyles.folderListInner},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:browseStyles.folderIconContainer},this.renderIcon(tree)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:browseStyles.noselect,'data-test-name':'folder-selectable'},tree.displayName));var plusMinus=!tree.isExpanded?'plus':'minus';var arrow=tree.type===__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_util_folderUtils__["a" /* FILETYPE */].file?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:browseStyles.arrow,style:{width:'29px'}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:browseStyles.arrow,onClick:function onClick(e){e.preventDefault();e.stopPropagation();_this4.handleCollapse(tree.fullPath);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-'+plusMinus}));var indent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{minWidth:level*20}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_view_Utilities_TreeView__["a" /* default */],{labelWrapper:function labelWrapper(children){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,children);},nodeLabel:label,arrow:arrow,indent:indent,collapsed:!tree.isExpanded,itemClassName:folderStyle,onClick:function onClick(e){return _this4.onLabelClick(tree,e);}},tree.s&&tree.s.filter(fileFilter).map(function(childTree){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ServerFolderSubTree,{fileFilter:fileFilter,key:childTree.fullPath,selectedFolderPath:_this4.props.selectedFolderPath,onToggleCollapse:_this4.props.onToggleCollapse,onFolderSelected:_this4.props.onFolderSelected,tree:childTree,level:level+1});}));}}]);return ServerFolderSubTree;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ServerFolderSubTree.propTypes={fileFilter:func.isRequired,tree:object.isRequired,level:number.isRequired,onToggleCollapse:func.isRequired,onFolderSelected:func.isRequired,selectedFolderPath:string};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BrowseServerFolders.69778b11.scss";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CatalogsPage__ = __webpack_require__(767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__CatalogsPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CatalogDetailsPage__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CatalogDetailsPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CatalogIngestPage__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__CatalogIngestPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CatalogingOptionsForm__ = __webpack_require__(878);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__CatalogingOptionsForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManagedFields_CatalogManagedUploadForm__ = __webpack_require__(884);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__ManagedFields_CatalogManagedUploadForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CatalogPreviewsForm__ = __webpack_require__(929);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__CatalogPreviewsForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CatalogSmartKeywordsPage__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__CatalogSmartKeywordsPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CatalogUsersPage__ = __webpack_require__(932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__CatalogUsersPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldsPage__ = __webpack_require__(936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__FieldsPage__["a"]; });


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CatalogRoutes__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CreateCatalogDialog__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DeleteVaultCatalogDialog__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_view_App_pageData__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CatalogsPage=function(_Component){_inherits(CatalogsPage,_Component);function CatalogsPage(){_classCallCheck(this,CatalogsPage);var _this=_possibleConstructorReturn(this,(CatalogsPage.__proto__||Object.getPrototypeOf(CatalogsPage)).call(this));_this.handleClickAdd=_this.handleClickAdd.bind(_this);_this.handleClickRemove=_this.handleClickRemove.bind(_this);return _this;}_createClass(CatalogsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getCatalogTypesAction();this.props.getCatalogsAction();}},{key:'handleClickAdd',value:function handleClickAdd(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_12_util_constants__["t" /* CREATE_CATALOG_PANEL_ID */]);}},{key:'handleClickRemove',value:function handleClickRemove(){var _props=this.props,catalogs=_props.catalogs,deleteCatalog=_props.deleteCatalog;var selectedCatalogId=this.selectedCatalogId();var catalog=selectedCatalogId&&catalogs.find(function(c){return c.catalogId===selectedCatalogId;});catalog&&deleteCatalog(catalog);}},{key:'selectedCatalogId',value:function selectedCatalogId(){var parts=this.props.location.pathname.split('/');var idx=parts.indexOf('catalogs');return parts[idx+1];}},{key:'selectedCatalogSubpage',value:function selectedCatalogSubpage(){var parts=this.props.location.pathname.split('/');var idx=parts.indexOf('catalogs');return parts.slice(idx+2).join('/');}},{key:'renderHeader',value:function renderHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header','data-test-name':'catalogs-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NAV_CATALOGS),this.props.isFullAdmin&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-white is-outlined',onClick:this.handleClickAdd,'data-test-name':'add-catalog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-plus-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-white is-outlined',disabled:!this.selectedCatalogId(),onClick:this.handleClickRemove,'data-test-name':'del-catalog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-minus-circle'})))));}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,activePanelId=_props2.activePanelId,catalogs=_props2.catalogs;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents'},activePanelId===__WEBPACK_IMPORTED_MODULE_12_util_constants__["t" /* CREATE_CATALOG_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CreateCatalogDialog__["a" /* default */],null),activePanelId===__WEBPACK_IMPORTED_MODULE_12_util_constants__["F" /* DELETE_VAULT_CATALOG_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DeleteVaultCatalogDialog__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents columns is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-quarter page'},this.renderHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page bordered-page-column is-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-hoverable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,catalogs.map(function(catalog){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CatalogRoutes__["a" /* CatalogNavLink */],{catalog:catalog,key:catalog.catalogId,subPage:_this2.selectedCatalogSubpage()});}))))),catalogs.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-three-quarters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-page-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NO_CATALOGS_EXIST))),catalogs.map(function(catalog){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{key:catalog.catalogId,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CatalogRoutes__["b" /* CatalogRoute */],Object.assign({catalog:catalog},props));}});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,catalogs.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{exact:true,from:'/catalogs',to:'/catalogs/'+catalogs[0].catalogId+'/'+__WEBPACK_IMPORTED_MODULE_13_view_App_pageData__["a" /* catalogPages */][0].subroute}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{exact:true,from:'/catalogs/:catalogId',to:'/catalogs/:catalogId/'+__WEBPACK_IMPORTED_MODULE_13_view_App_pageData__["a" /* catalogPages */][0].subroute}))));}}]);return CatalogsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var catalogPageWrapper=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["c" /* getActivePanelId */])(state),isFullAdmin:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["T" /* getIsFullAdmin */])(state),catalogs:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["n" /* getCatalogs */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteCatalog:__WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__["h" /* deleteCatalog */],getCatalogsAction:__WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__["n" /* getCatalogs */],getCatalogTypesAction:__WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__["m" /* getCatalogTypes */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_8_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(CatalogsPage);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(catalogPageWrapper));

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CatalogNavLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CatalogRoute; });
/* unused harmony export CatalogSubroute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_App_pageData__ = __webpack_require__(81);
var CatalogNavLink=function CatalogNavLink(_ref){var catalog=_ref.catalog,subPage=_ref.subPage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{className:'list-item nav-item-list',activeClassName:'nav-item-list-selected',to:'/catalogs/'+catalog.catalogId+(subPage?'/'+subPage:''),'data-test-name':'catalog-select-'+catalog.name},catalog.name)));};var CatalogRoute=function CatalogRoute(_ref2){var match=_ref2.match,catalog=_ref2.catalog;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{key:catalog.catalogId,path:match.path+'/:catalogId',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CatalogSubroute,Object.assign({catalog:catalog},props));}});};var CatalogSubroute=function CatalogSubroute(_ref3){var match=_ref3.match,catalog=_ref3.catalog;if(catalog&&match.url.includes('catalogs/'+catalog.catalogId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column',style:{height:'calc(100% - 64px)'/** FIXME: hack for bug PORT-11900 */}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header-tabs-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs is-centered is-full-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_3_view_App_pageData__["a" /* catalogPages */].map(function(page){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:page.label.defaultMessage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{className:'nav-item-horizontal',activeClassName:'nav-item-horizontal-selected',to:match.url+'/'+page.subroute,'data-test-name':page.dataTestName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],page.label)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:match.path+'/:subroute',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CatalogPage,Object.assign({catalog:catalog},props));}}));}else{return null;}};var CatalogPage=function CatalogPage(_ref4){var match=_ref4.match,catalog=_ref4.catalog;var page=__WEBPACK_IMPORTED_MODULE_3_view_App_pageData__["a" /* catalogPages */].find(function(p){return p.subroute===match.params.subroute;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents'},page&&page.contents?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(page.contents.component,{catalog:catalog}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Subroute: ',match.params.subroute),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Catalog Id: ',match.params.catalogId)));};

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_catalogUtils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_logging__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var msgs=__webpack_require__(770);function validate(data,props){var errors={};if(!data.name||!data.name.trim()){errors.name='Required';}else if(Object(__WEBPACK_IMPORTED_MODULE_11_util_catalogUtils__["a" /* catalogNameExists */])(props.catalogs,data.name)){errors.name='Duplicate';}if(!data.storageType){errors.storageType='Required';}return errors;}var collations=[{value:'en',label:'english'},{value:'fr',label:'french'},{value:'de',label:'german'},{value:'ja',label:'japanese'},{value:'sv',label:'swedish'}];var CreateCatalogDialog=function(_Component){_inherits(CreateCatalogDialog,_Component);function CreateCatalogDialog(){_classCallCheck(this,CreateCatalogDialog);var _this=_possibleConstructorReturn(this,(CreateCatalogDialog.__proto__||Object.getPrototypeOf(CreateCatalogDialog)).call(this));_this.handleClose=_this.handleClose.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.prepareCatalogTypes=_this.prepareCatalogTypes.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(CreateCatalogDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid&&!this.props.pristine;}},{key:'handleClose',value:function handleClose(){this.props.reset();}},{key:'handleChange',value:function handleChange(event,newValue,previousValue,name){if(!Object(__WEBPACK_IMPORTED_MODULE_11_util_catalogUtils__["c" /* isLegalCatalogName */])(newValue)){event.preventDefault();}}},{key:'submit',value:function submit(values){var _props=this.props,catalogTypes=_props.catalogTypes,createCatalog=_props.createCatalog,hideDialogPanel=_props.hideDialogPanel,intl=_props.intl;var collation=values.collation,createAutosyncFolder=values.createAutosyncFolder,name=values.name,storageType=values.storageType,template=values.template,useVersioning=values.useVersioning;// if we are using a custom template then set the locale to custom as well
var templateObject=catalogTypes.find(function(t){return t.name===template;});if(!templateObject){__WEBPACK_IMPORTED_MODULE_13_portfolio_shared_util_logging__["a" /* default */].warn('Could not find template for name '+template);return;}var isCustom=!!templateObject.guid;var catalogTypeSpecifier=isCustom?templateObject.guid:templateObject.name;var catalogTypeLocale=isCustom?'custom':intl.locale;var watchFolderNamePartFiles=intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FOLDER_PATH_AUTOSYNC_FILES_STRING);var catalog={catalogType:catalogTypeSpecifier,catalogTypeLocale:catalogTypeLocale,collation:collation,catalogId:'',isVersioningEnabled:useVersioning&&storageType===__WEBPACK_IMPORTED_MODULE_8_util_constants__["n" /* CATALOG_STORAGE_TYPE */].VAULT,name:name.trim(),storageType:storageType};hideDialogPanel();createCatalog(catalog,createAutosyncFolder,watchFolderNamePartFiles);}},{key:'prepareCatalogTypes',value:function prepareCatalogTypes(types){var builtIns=[];var customs=[];types.forEach(function(type){if(type.guid&&type.guid.length>0){customs.push(type);}else{builtIns.push(type);}});return[builtIns.sort(function(a,b){if(__WEBPACK_IMPORTED_MODULE_8_util_constants__["D" /* DEFAULT_CATALOG_TYPE_NAMES */].includes(a.name)){return-1;}else if(__WEBPACK_IMPORTED_MODULE_8_util_constants__["D" /* DEFAULT_CATALOG_TYPE_NAMES */].includes(b.name)){return 1;}return a.name.localeCompare(b.name);}),customs.sort(function(a,b){return a.name.localeCompare(b.name);})];}},{key:'renderCatalogTypes',value:function renderCatalogTypes(catalogTypes){var _this2=this;var _prepareCatalogTypes=this.prepareCatalogTypes(catalogTypes),_prepareCatalogTypes2=_slicedToArray(_prepareCatalogTypes,2),builtIns=_prepareCatalogTypes2[0],customs=_prepareCatalogTypes2[1];return[builtIns.map(function(opt){return _this2.renderCatalogType(opt);}),customs&&customs.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'sep',disabled:'disabled'},'\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500'),customs.map(function(opt){return _this2.renderCatalogType(opt);})];}},{key:'renderCatalogType',value:function renderCatalogType(type){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:type.name,value:type.name},type.name);}},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,handleSubmit=_props2.handleSubmit,hideDialogPanel=_props2.hideDialogPanel,formatMessage=_props2.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'650px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CREATE),dialogFocusId:'name',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onClose:this.handleClose,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_8_util_constants__["t" /* CREATE_CATALOG_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CREATE_CATALOG),showCancel:true,dataTestName:'create-catalog-dialog'},this.renderForm());}},{key:'renderForm',value:function renderForm(){var _props3=this.props,catalogTypes=_props3.catalogTypes,handleSubmit=_props3.handleSubmit,formatMessage=_props3.intl.formatMessage,storageType=_props3.storageType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container',onSubmit:handleSubmit(this.submit)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal',key:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].NAME))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input',component:'input',id:'name',name:'name',onChange:this.handleChange,type:'text'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal',key:'template'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_CREATE_CATALOG_TEMPLATE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'select is-fullwidth',component:'select',id:'template',name:'template'},this.renderCatalogTypes(catalogTypes))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal',key:'locale'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_DETAILS_COLLATION))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'select is-fullwidth',component:'select',id:'collation',name:'collation'},collations.map(function(collation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:collation.value,value:collation.value},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */][collation.label]));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal',key:'storageType'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_LABEL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field',style:{marginTop:'6px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__["a" /* default */],fieldValue:storageType,id:'storageType-vault',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_VAULT),name:'storageType',type:'radio',value:__WEBPACK_IMPORTED_MODULE_8_util_constants__["n" /* CATALOG_STORAGE_TYPE */].VAULT}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_EXPLANATION_VAULT_1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_EXPLANATION_VAULT_2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'is-small',component:__WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__["a" /* default */],disabled:storageType!==__WEBPACK_IMPORTED_MODULE_8_util_constants__["n" /* CATALOG_STORAGE_TYPE */].VAULT,id:'useVersioning',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_CREATE_USE_VERSIONING),name:'useVersioning',type:'checkbox'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__["a" /* default */],fieldValue:storageType,id:'storageType-watchFolders',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_WATCHFOLDERS),name:'storageType',type:'radio',value:__WEBPACK_IMPORTED_MODULE_8_util_constants__["n" /* CATALOG_STORAGE_TYPE */].FILESYSTEM}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_EXPLANATION_WF_1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_EXPLANATION_WF_2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'is-small',component:__WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__["a" /* default */],disabled:storageType!==__WEBPACK_IMPORTED_MODULE_8_util_constants__["n" /* CATALOG_STORAGE_TYPE */].FILESYSTEM,id:'createAutosyncFolder',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_CREATE_AUTOSYNC_FOLDER),name:'createAutosyncFolder',type:'checkbox'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'})))));}}]);return CreateCatalogDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var form=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_8_util_constants__["t" /* CREATE_CATALOG_PANEL_ID */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(CreateCatalogDialog));var selector=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_8_util_constants__["t" /* CREATE_CATALOG_PANEL_ID */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["c" /* getActivePanelId */])(state),catalogs:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["n" /* getCatalogs */])(state),catalogTypes:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["l" /* getCatalogTypes */])(state),globalSettings:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["I" /* getGlobalSettings */])(state),storageType:selector(state,'storageType'),initialValues:{collation:'en',createAutosyncFolder:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["q" /* getCreateAutosyncFolder */])(state),useVersioning:true,// This is a bit of a hack, we need to find a template via a localized name
template:msgs['CATALOG_TYPE_GENERAL'][Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["_4" /* getLocale */])(state)]||'General Use'}};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({createCatalog:__WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__["d" /* createCatalog */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_9_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(form));

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = {"ABOUT":{"de":"Über","en":"About","es":"Acerca de","fr":"À propos de","it":"Tema","ja":"概要"},"ABOUT_API_TAB":{"de":"API","en":"API","es":"API","fr":"API","it":"API","ja":"API"},"ABOUT_VERSION":{"de":"Version","en":"Version","es":"Versión","fr":"Version","it":"Versione","ja":"バージョン"},"ABOUT_EXTENSIS_URL":{"de":"www.portfoliodam.com","en":"www.portfoliodam.com","es":"www.portfoliodam.com","fr":"www.portfoliodam.com","it":"www.portfoliodam.com","ja":"www.portfoliodam.com"},"ABOUT_PORTFOLIO_SERVER":{"de":"Portfolio-Server","en":"Portfolio Server","es":"Portfolio Server","fr":"Portfolio Server","it":"Portfolio Server","ja":"Portfolio Server"},"ABOUT_PORTFOLIO_VERSION":{"de":"Version 9.0","en":"Version 9.0","es":"Versión 9.0","fr":"Version 9.0","it":"Versione 9.0","ja":"バージョン 9.0"},"ABOUT_SERVER_TAB":{"de":"Server","en":"Server","es":"Servidor","fr":"Serveur","it":"Server","ja":"サーバー"},"accessOriginals":{"de":"Auf Originale zugreifen und verarbeiten","en":"Access and Process Originals","es":"Acceder y procesar originales","fr":"Originaux des accès et des procédures","it":"Accedi agli originali ed elaborali","ja":"オリジナルへのアクセスおよび処理"},"ACCOUNT_TYPE":{"de":"Echtheitsbestätigung","en":"Authentication","es":"Autenticación","fr":"Authentification","it":"Autenticazione","ja":"認証"},"ACCOUNT_TYPE_LDAP":{"de":"Verzeichnisdienst","en":"Directory Service","es":"Servicio de directorios","fr":"Service d'annuaire","it":"Servizio Directory","ja":"ディレクトリサービス"},"ACCOUNT_TYPE_MANUAL":{"de":"Nativ (integriert)","en":"Native (Built-in)","es":"Nativo (incorporado)","fr":"Natif (intégré)","it":"Nativo (incorporato)","ja":"ネイティブ (ビルドイン)"},"ACTIVE_DIRECTORY":{"de":"Active Directory","en":"Active Directory","es":"Active Directory","fr":"Active Directory","it":"Active Directory","ja":"Active Directory"},"ADD":{"de":"Hinzufügen","en":"Add","es":"Agregar","fr":"Ajouter","it":"Aggiungi","ja":"追加"},"ALL_CATALOGS_GROUP":{"de":"Alle Kataloge","en":"All Catalogs","es":"Todos los catálogos","fr":"Tous les catalogues","it":"Tutti i cataloghi","ja":"すべてのカタログ"},"API_CODE_REFERENCE":{"de":"API-Code-Referenzmaterial (English)","en":"API Code Reference (English)","es":"Referencia de código de API (English)","fr":"Référence du code de l'API (English)","it":"Riferimento codice API (English)","ja":"APIコードレファレンス (English)"},"API_CODE_REFERENCE_URL":{"de":"https://doc.portfoliodam.com/api/portfolio/index.html","en":"https://doc.portfoliodam.com/api/portfolio/index.html","es":"https://doc.portfoliodam.com/api/portfolio/index.html","fr":"https://doc.portfoliodam.com/api/portfolio/index.html","it":"https://doc.portfoliodam.com/api/portfolio/index.html","ja":"https://doc.portfoliodam.com/api/portfolio/index.html"},"API_DEVELOPER_COMMUNITY":{"de":"Entwicklergemeinde","en":"Developer Community","es":"Comunidad de programadores","fr":"Communauté des développeurs","it":"Community degli sviluppatori","ja":"開発者コミュニティ"},"API_DEVELOPER_COMMUNITY_URL":{"de":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","en":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","es":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","fr":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","it":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community","ja":"https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community"},"API_PORTFOLIO_HELP":{"de":"Portfolio Administration – Hilfe","en":"Portfolio Administration Help","es":"Ayuda de Portfolio Administration","fr":"Rubrique d'aide sur l'administration du serveur","it":"Guida di Portfolio Administration","ja":"サーバ管理者ヘルプ"},"API_PORTFOLIO_HELP_URL":{"de":"https://helpdocs.portfoliodam.com/de/portfolio/administration/{version}/index.htm","en":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","es":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","fr":"https://helpdocs.portfoliodam.com/fr/portfolio/administration/{version}/index.htm","it":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","ja":"https://helpdocs.portfoliodam.com/ja/portfolio/administration/{version}/Content/Home.htm#googtrans(ja)"},"API_SECTION_1":{"de":"Die Portfolio API stellt eine allgemeine Schnittstelle für Entwickler bereit. Sie dient zur Integrierung von Portfolio-Katalogen, Inventar-Metadaten und Medienverarbeitung für Geschäftssysteme, benutzerdefinierte Arbeitsabläufe und Internet-Infrastrukturen.","en":"The Portfolio API provides a common interface for developers to integrate Portfolio catalogs, asset metadata, and media processing into business systems, custom workflows, and web infrastructures.","es":"La API de Portfolio ofrece una interfaz común para que los programadores integren catálogos de Portfolio, metadatos de activos y procesamiento de medios en sistemas de empresas, flujos de trabajo personalizados e infraestructuras Web.","fr":"L'API de Portfolio propose aussi une interface commune pour que les développeurs puissent intégrer les catalogues Portfolio, les métadonnées de ressources, et le traitement multimédia dans les systèmes métier, les flux d'opérations personnalisés, et les infrastructures Web.","it":"L'API di Portfolio fornisce agli sviluppatori un'interfaccia comune per integrare i cataloghi di Portfolio, i metadati degli asset e l'elaborazione dei media nei sistemi aziendali, nei flussi di lavoro personalizzati e nelle infrastrutture web.","ja":"開発者はポートフォリオサーバAPIを使うと、ポートフォリオサーバカタログ、アセットのメタデータ、メディアプロセッシングをビジネスシステム、カスタムワークフロー、ウェブインフラストラクチャに統合できるようになります。"},"API_SECTION_2_PART_1":{"de":"Für die Nutzung der API sind Lizenzen erforderlich ","en":"Use of the API requires licenses, as described in the","es":"Para utilizar la API es necesario disponer de licencias, como se describe en ","fr":"L'utilisation de l'API nécessite des licences, comme stipulé dans le ","it":"Per utilizzare l'API sono necessarie delle licenze, come descritto ","ja":" "},"API_SECTION_2_EULA":{"de":"wie in der EULA beschrieben","en":"Portfolio EULA","es":"el contrato de usuario final (EULA) de Portfolio","fr":"CLUF de Portfolio","it":"nell'EULA di Portfolio","ja":"ポートフォリオサーバEULAに記述してあるとおり"},"API_SECTION_2_EULA_URL":{"de":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/de/Content/Legal/extensis-portfolio-eula.htm","en":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","es":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","fr":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/fr/Content/Legal/extensis-portfolio-eula.htm","it":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm","ja":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/ja/Content/Legal/extensis-portfolio-eula.htm"},"API_SECTION_2_PART_2":{"de":". Zum Anzeigen bzw. Bearbeiten der Lizenzinformationen klicken Sie in der Portfolio Administration-Anwendung auf 'Lizenzen'.","en":". To view or edit license information, click 'Licenses' in the Portfolio Administration application.","es":". Para ver o editar los datos de licencia, haga clic en 'Licencias' en la aplicación de administración Portfolio Administration.","fr":". Pour consulter ou modifier les informations de licence, cliquez sur 'Licences' dans l'application Administration du serveur.","it":". Per visualizzare o modificare le informazioni su una licenza, fare clic su 'Licenze' nell'applicazione Portfolio Administration.","ja":" 、APIの使用にはライセンスが必要です。 ライセンス情報を表示・編集するには、サーバ管理アプリケーションで［ライセンス］をクリックします。"},"API_SECTION_2_PART_3":{"de":"Mehr lernen:","en":"Learn more:","es":"Más información:","fr":"En savoir plus :","it":"Per sapere di più:","ja":"開始："},"API_TOKEN_CREATE":{"de":"Fügen Sie einen neuen API Token hinzu","en":"Add New API Token","es":"Agregar Nuevo Identificador API","fr":"Ajouter nouveau jeton API","it":"Aggiungi nuovo Token API","ja":"新規APIトークンを追加"},"APPLY":{"de":"Anwenden","en":"Apply","es":"Aplicar","fr":"Appliquer","it":"Applica","ja":"適用"},"APP_PAGE_TITLE":{"de":"Portfolio-Administrator","en":"Portfolio Admin","es":"Administración de Portfolio","fr":"Administrateur de Portfolio","it":"Portfolio Admin","ja":"Portfolio Admin"},"AT_TIME":{"de":"Uhrzeit","en":"at","es":"en el momento","fr":"au moment","it":"alle ore","ja":"次の時刻に"},"AUTHENTICATION_ERROR":{"de":"Fehler bei der Verzeichnisservice-Authentifikation. Prüfen Sie Benutzernamen und Passwort.","en":"Directory service authentication failed. Please check your username and password.","es":"Ha fallado la autenticación del servicio de directorios. Compruebe su nombre de usuario y contraseña.","fr":"L'authentification du service de répertoire a échoué. Veuillez vérifier votre nom d'utilisateur et mot de passe.","it":"Autenticazione servizio directory non riuscita. Controllare nome utente e password.","ja":"ディレクトリサービスの認証が失敗しました。 ユーザー名とパスワードを確認してください。"},"BACKUP_BACKUP_BUTTON":{"de":"Datensicherung","en":"Backup","es":"Copia de seguridad","fr":"Sauvegarder","it":"Backup","ja":"バックアップ"},"BACKUP_BACKUP_LABEL":{"de":"Datensicherung","en":"Backup","es":"Copia de seguridad","fr":"Sauvegarder","it":"Backup","ja":"バックアップ"},"BACKUP_BACKUP_NOW_BUTTON":{"de":"Jetzt Daten sichern","en":"Backup Now","es":"Hacer copia de seguridad ahora","fr":"Sauvegarder maintenant","it":"Esegui il backup adesso","ja":"今すぐバックアップ"},"BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE":{"de":"Wenn Sie den Backup Speicherort ändern möchten, fahren Sie zuerst den Portfolio Server herunter.","en":"To change the backup location, first shut down Portfolio server.","es":"Para cambiar la ubicación de la copia de seguridad, desactive en primer lugar el servidor de Portfolio.","fr":"Pour modifier l’emplacement de sauvegarde, arrêtez d’abord le serveur Portfolio.","it":"Per cambiare la posizione di backup, spegnere prima il server del Portfolio.","ja":"バックアップの保存場所を変更するには、まずPortfolioのサーバーを終了する必要があります。"},"BACKUP_CONFIRMATION_VERBIAGE":{"de":"Jetzt Daten sichern? Bis die Datensicherung abgeschlossen ist, wird Portfolio wird offline sein.","en":"Backup now? Portfolio will be offline until backup is complete.","es":"¿Hacer copia de seguridad ahora? El portfolio estará fuera de línea hasta que se complete la copia de seguridad.","fr":"Sauvegarder maintenant? Le Portfolio sera hors ligne jusqu'à ce que la sauvegarde soit terminée.","it":"Esegui il backup adesso? Il Portfolio sarà offline fino a quando il backup non è completo.","ja":"今すぐバックアップしますか？バックアップが完了するまで、Portfolioはオフラインになります。"},"BACKUP_DIRECTORY_LABEL":{"de":"In Verzeichnis speichern","en":"Store in Directory","es":"Almacenar en directorio","fr":"Stocker dans le répertoire","it":"Archivia nella directory","ja":"ディレクトリに保存"},"BACKUP_DIRECTORY_ERROR_MSG":{"de":"Das ausgewählte Datensicherungsverzeichnis ist ungültig.","en":"The selected backup directory is not valid.","es":"El directorio de la copia de seguridad seleccionada no es válido.","fr":"Le répertoire de sauvegarde sélectionné est erroné.","it":"La directory di backup selezionata non è valida.","ja":"選択したバックアップディレクトリは使用できません。"},"BACKUP_EXPLANATION_TEXT_1":{"de":"Backups erfassen und die Server-Datenbank und Einstellungen sicher abspeichern. \nlt erstellt kein Backup Ihrer ursprünglichen Asset-Dateien!","en":"Backups capture and safely store the server database and settings.\nIt does not backup your original asset files!","es":"Las copias de seguridad capturan y almacenan de forma segura la base de datos y la configuración del servidor.¡\nIt no hace copias de seguridad de sus archivos de valores originales!","fr":"Extraire les sauvegardes et stocker en toute sécurité la base de données du serveur et les paramètres.\nIt ne sauvegarde pas vos fichiers de composants d'origine!","it":"Con il backup si acquisiscono e si archiviano i database del server e le impostazioni in modo sicuro.\nlt non esegue il backup dei file delle risorse originali!","ja":"バックアップはサーバーのデータベースをキャプチャーして、安全に保存します。\nItはオリジナルファイルをバックアップしません！"},"BACKUP_EXPLANATION_TEXT_2":{"de":"Während der Datensicherung kann nicht auf den Server zugegriffen werden.","en":"The server will be inaccessible during backups.","es":"No se podrá acceder al servidor durante la realización de copias de seguridad.","fr":"Le serveur sera inaccessible durant les sauvegardes.","it":"Non sarà possibile accedere al server durante i backup.","ja":"バックアップ中はサーバーに接続できません。"},"BACKUP_FRIDAY_LABEL":{"de":"Freitag","en":"Friday","es":"Viernes","fr":"Vendredi","it":"Venerdì","ja":"金曜日"},"BACKUP_MONDAY_LABEL":{"de":"Montag","en":"Monday","es":"Lunes","fr":"Lundi","it":"Lunedì","ja":"月曜日"},"BACKUP_MOST_RECENT_LABEL":{"de":"Neuste Datensicherung","en":"Most Recent Backup","es":"Copia de seguridad más reciente","fr":"Sauvegarde la plus récente","it":"Il backup più recente","ja":"最近のバックアップ"},"BACKUP_NEXT_SCHEDULED_LABEL":{"de":"Nächste planmäßige Datensicherung","en":"Next Scheduled Backup","es":"Próxima copia de seguridad programada","fr":"Prochaine sauvegarde planifiée","it":"Prossimo backup pianificato","ja":"次回のバックアップ"},"BACKUP_NOTIFICATIONS":{"de":"E-Mail-Benachrichtigungen nach Backups und Wiederherstellungen senden","en":"Send email notifications after backups and restores","es":"Enviar notificaciones de correo electrónico después de las copias de seguridad y restauraciones","fr":"Envoyer des notifications par courriel après les sauvegardes et les restaurations","it":"Inviare una notifica per e-mail dopo backup e ripristini","ja":"バックアップ/復元後にEmail通知を送信"},"BACKUP_NOTIFICATIONS_DISABLED_MSG":{"de":"E-Mail Benachrichtigungen müssen in den globalen Einstellungen> E-Mail Benachrichtigungen, aktiviert sein","en":"Email notifications must be enabled in Global Settings > Email Notifications","es":"Las notificaciones de correo electrónico deben estar habilitadas en Ajustes globales > Notificaciones de correo electrónico","fr":"Les notifications par courriel doivent être activés dans Paramètres généraux > Notifications par courriel","it":"Notifiche via e-mail deve essere abilitato in Impostazioni globali > Notifiche via e-mail","ja":"グローバル設定＞Email通知で、Email通知を有効化してください。"},"BACKUP_PROGRESS_BACKING_UP":{"de":"Datensicherung läuft","en":"Backing Up","es":"Haciendo copia de seguridad","fr":"Sauvegarde en cours","it":"Backup in corso","ja":"バックアップ"},"BACKUP_PROGRESS_BACKING_UP_DATA":{"de":"Daten werden gesichert...","en":"Backing up data...","es":"Haciendo copia de seguridad de los datos...","fr":"Sauvegarde des données en cours...","it":"Backup dei dati in corso...","ja":"データをバックアップ中…"},"BACKUP_PROGRESS_BACKUP_CANCELLED":{"de":"Datensicherung abgebrochen","en":"Backup Cancelled","es":"Copia de seguridad cancelada","fr":"Sauvegarde annulée","it":"Backup cancellato","ja":"バックアップキャンセル"},"BACKUP_PROGRESS_BACKUP_FAILED":{"de":"Datensicherung fehlgeschlagen","en":"Backup Failed","es":"Error de copia de seguridad","fr":"Échec de la sauvegarde","it":"Backup non riuscito","ja":"バックアップ失敗"},"BACKUP_PROGRESS_BACKUP_SUCCESSFUL":{"de":"Datensicherung erfolgreich","en":"Backup Successful","es":"Copia de seguridad satisfactoria","fr":"Sauvegarde réussie","it":"Backup eseguito con successo","ja":"バックアップ成功"},"BACKUP_PROGRESS_PREFLIGHT":{"de":"Verfügbarer Speicherplatz wird geprüft...","en":"Checking for available space...","es":"Comprobando el espacio disponible...","fr":"Vérification de l'espace disponible...","it":"Controllo spazio disponibile...","ja":"利用可能な領域をチェック"},"BACKUP_PROGRESS_RESTARTING":{"de":"Server wird neu gestartet...","en":"Restarting server...","es":"Reiniciando el servidor...","fr":"Redémarrage du serveur...","it":"Riavvio server in corso...","ja":"サーバーを再起動中…"},"BACKUP_PROGRESS_RESTORE_FAILED":{"de":"Wiederherstellung fehlgeschlagen","en":"Restore Failed","es":"Error de restauración","fr":"Échec de la restauration","it":"Ripristino fallito","ja":"復元失敗"},"BACKUP_PROGRESS_RESTORE_SUCCESSFUL":{"de":"Wiederherstellung erfolgreich","en":"Restore Successful","es":"Restauración satisfactoria","fr":"Restauration réussie","it":"Ripristino eseguito con successo","ja":"復元成功"},"BACKUP_PROGRESS_RESTORING":{"de":"Wird wiederhergestellt","en":"Restoring","es":"Restaurando","fr":"Restauration en cours","it":"Ripristino in corso","ja":"復元"},"BACKUP_PROGRESS_RESTORING_DATA":{"de":"Daten werden wiederhergestellt...","en":"Restoring data...","es":"Restaurando datos...","fr":"Restauration des données en cours...","it":"Ripristino dati in corso...","ja":"データを復元中…"},"BACKUP_PROGRESS_SHUTTING_DOWN":{"de":"Server wird heruntergefahren...","en":"Shutting down server...","es":"Apagando el servidor...","fr":"Fermeture du serveur en cours...","it":"Spegnimento server in corso...","ja":"サーバーを終了中…"},"BACKUP_PROGRESS_SUMMARY":{"de":"Schritt {stepNum} von {totalSteps}","en":"Step {stepNum} of {totalSteps}","es":"Paso {stepNum} de {totalSteps}","fr":"Étape {stepNum} sur {totalSteps}","it":"Passaggio {stepNum} di {totalSteps}","ja":"ステップ {stepNum}/{totalSteps}"},"BACKUP_RESTORE_BUTTON":{"de":"Von Datensicherungsdatei wiederherstellen...","en":"Restore From Backup","es":"Restaurar a partir del archivo de copia de seguridad...","fr":"Restaurer à partir du fichier de sauvegarde...","it":"Ripristino dal file di backup in corso...","ja":"バックアップファイルから復元"},"BACKUP_RESTORE_CONFIRMATION_VERBIAGE":{"de":"Datensicherung jetzt wiederherstellen? Bis die Wiederherstellung abgeschlossen ist, ist Portfolio offline. Dies wird Ihre aktuelle Datenbank und Einstellungen überschreiben.","en":"Restore backup now? Portfolio will be offline until restore is complete. This will overwrite your current database and settings.","es":"¿Restaurar copia de seguridad ahora? El portfolio estará fuera de línea hasta que se complete la restauración. Se sobrescribirá su base de datos y su configuración actuales.","fr":"Restaurer la sauvegarde maintenant? Le portefeuille sera hors ligne jusqu'à ce que la restauration soit terminée. Ceci écrasera votre base de données actuelle et vos paramètres.","it":"Ripristinare il backup adesso? Il Portfolio sarà offline fino a quando il ripristino non è completo. Il database e le impostazioni correnti verranno sovrascritte.","ja":"今すぐバックアップを復元しますか？復元が完了するまで、Portfolioはオフラインになります。この処理は現在のデータベースと設定を上書きします。"},"BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE":{"de":"Das Datensicherungsarchiv ist fehlerhaft. Wählen Sie für die Wiederherstellung eine andere Datensicherung aus.","en":"The backup archive is corrupt.\nChoose another backup to restore from.","es":"El archivo de copia de seguridad está corrupto. Elija otra copia de seguridad desde la cual restaurar.","fr":"Les archives de sauvegardes sont corrompues. Sélectionnez une autre sauvegarde pour une restauration.","it":"L'archivio di backup è danneggiato. Scegli un altro backup da cui eseguire il ripristino.","ja":"バックアップアーカイブが破損しています。他のバックアップを選択してください。"},"BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE":{"de":"Die Datensicherungsdiskette verfügt nicht über ausreichend Speicherplatz\num den Vorgang abzuschließen.\n\n{requiredSpace} erforderlich, {availableSpace} verfügbar.","en":"The backup disk has insufficient space\nto complete.\n\n{requiredSpace} required, {availableSpace} available.","es":"El disco de la copia de seguridad no tiene suficiente espacio\nto completa.\n\n{requiredSpace} requerida, {availableSpace} disponible.","fr":"Le lecteur de sauvegarde ne dispose pas d'un espace suffisant\n pour terminer.\n\n{requiredSpace} requis, {availableSpace} disponible.","it":"Lo spazio nel disco di backup non è sufficiente\nper completare.\n\n{requiredSpace} necessari, {availableSpace} disponibili.","ja":"バックアップディスクが十分ではありません。"},"BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY":{"de":"Der aktuell konfigurierte Sicherungspfad ist nicht vorhanden. Der Sicherungspfad wird für das Extrahieren des Archivs verwendet, wenn eine Sicherung wiederhergestellt wird. Bitte setzen Sie die Sicherung auf ein gültiges Verzeichnis zurück.","en":"The currently configured backup location does not exist. The backup location is used to unzip the archive when a backup is being restored. Please reset the backup location to a valid directory.","es":"La ubicación de la copia de seguridad configurada actualmente no existe. La ubicación de la copia de seguridad se utiliza para descomprimir el archivo cuando se restaura una copia de seguridad. Por favor, restablezca la ubicación de la copia de seguridad en un directorio válido.","fr":"L’emplacement de sauvegarde actuellement configuré n’existe pas. L’emplacement de sauvegarde est utilisé pour décompresser l’archive lorsqu’une sauvegarde est restaurée. Veuillez sélectionner un répertoire valide pour l’emplacement de sauvegarde.","it":"La posizione di backup correntemente configurata non esiste. La posizione di backup è utilizzata per decomprimere l’archivio quando un backup è in ripristino. Ripristina la posizione di backup in una directory valida.","ja":"現在のバックアップの保存先は存在しません。バックアップの保存先は、復元時にバックアップのアーカイブを解凍するのにも使用されます。有効な保存先を選択しなおしてください。"},"BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP":{"de":"Bei dem/der Datensicherung ist ein Problem aufgetreten. Siehe Admin-Logs für Einzelheiten.","en":"There was a problem with the backup.\nSee admin logs for details.","es":"Hubo un problema con la copia de seguridad. Ver los registros de administrador para más información.","fr":"Problème avec la sauvegarde. Pour plus d'informations, consultez le journal d'admin.","it":"Si è verificato un problema con il backup. Consultare i registri admin per i dettagli.","ja":"[backup/restore]に問題が発生しました。詳細は管理ログを参照してください。"},"BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE":{"de":"Bei dem/der Wiederherstellung ist ein Problem aufgetreten. Siehe Admin-Logs für Einzelheiten.","en":"There was a problem with the restore.\nSee admin logs for details.","es":"Hubo un problema con la restauración. Ver los registros de administrador para más información.","fr":"Problème avec la restauration. Pour plus d'informations, consultez le journal d'admin.","it":"Si è verificato un problema con il ripristino. Consultare i registri admin per i dettagli.","ja":"[backup/restore]に問題が発生しました。詳細は管理ログを参照してください。"},"BACKUP_RESTORE_LABEL":{"de":"Wiederherstellen","en":"Restore","es":"Restaurar","fr":"Restaurer","it":"Ripristino","ja":"復元"},"BACKUP_RESTORE_TITLE":{"de":"Sichern/Wiederherstellen","en":"Backup/Restore","es":"Copia de seguridad/Restablecer","fr":"Sauvegarde/Restauration","it":"Backup/Ripristino","ja":"バックアップ/復元"},"BACKUP_RETAIN_LABEL":{"de":"Behalten","en":"Retain","es":"Retener","fr":"Conserver","it":"Conserva","ja":"保存"},"BACKUP_RETAIN_VALUE":{"de":"Nur die {numBackups} jüngsten Datensicherungen behalten","en":"Keep only the {numBackups} most recent backups","es":"Mantener sólo las {numBackups} copias de seguridad más recientes","fr":"Conserver uniquement les {numBackups} sauvegardes les plus récentes","it":"Tenere solo i {numBackups} backup più recenti","ja":"最近の{numBackups}つのバックアップを保持"},"BACKUP_SATURDAY_LABEL":{"de":"Samstag","en":"Saturday","es":"Sábado","fr":"Samedi","it":"Sabato","ja":"土曜日"},"BACKUP_SCHEDULE_LABEL":{"de":"Datensicherungsplan erstellen","en":"Schedule Backups","es":"Programar copias de seguridad","fr":"Planifier les sauvegardes","it":"Pianifica i backup","ja":"バックアップをスケジュール"},"BACKUP_SCHEDULE_VALUE":{"de":"ein","en":"on","es":"en","fr":"le","it":"il","ja":"に"},"BACKUP_SUNDAY_LABEL":{"de":"Sonntag","en":"Sunday","es":"Domingo","fr":"Dimanche","it":"Domenica","ja":"日曜日"},"BACKUP_THURSDAY_LABEL":{"de":"Donnerstag","en":"Thursday","es":"Jueves","fr":"Jeudi","it":"Giovedì","ja":"木曜日"},"BACKUP_TUESDAY_LABEL":{"de":"Dienstag","en":"Tuesday","es":"Martes","fr":"Mardi","it":"Martedì","ja":"火曜日"},"BACKUP_WEDNESDAY_LABEL":{"de":"Mittwoch","en":"Wednesday","es":"Miércoles","fr":"Mercredi","it":"Mercoledì","ja":"水曜日"},"BROWSE":{"de":"Durchsuchen","en":"Browse","es":"Examinar","fr":"Parcourir","it":"Sfoglia","ja":"ブラウズ"},"BROWSE_FOLDERS_TITLE":{"de":"Ordner auf Server durchsuchen","en":"Browse Server Folders","es":"Buscar en las carpetas del servidor","fr":"Parcourir les dossiers du serveur","it":"Sfoglia le cartelle del server","ja":"サーバーフォルダ参照"},"BROWSE_RECENT_FOLDERS_LABEL":{"de":"Letzte Ordner","en":"Recent Folders","es":"Carpetas recientes","fr":"Dossiers récents","it":"Cartelle recenti","ja":"最近使ったフォルダ"},"BROWSE_REFRESH":{"de":"Artikel synchronisieren","en":"Synchronize items","es":"Sincronizar elementos","fr":"Synchroniser des éléments","it":"Sincronizza articoli","ja":"アイテムの同期"},"CALL_ATT_BUTTON_BUY_NOW":{"de":"Jetzt kaufen","en":"Buy Now","es":"Comprar ahora","fr":"Acheter maintenant","it":"Acquista ora","ja":"購入する"},"CALL_ATT_BUTTON_SECONDARY":{"de":"Setzen Sie sich mit der Verkaufsabteilung für einen Kostenvoranschlag in Verbindung","en":"Contact Sales for a Quote","es":"Póngase en contacto con el Departamento de ventas para solicitar presupuesto","fr":"Contacter le service des ventes pour un devis","it":"Contatta l'ufficio vendite per un preventivo","ja":"価格についてセールスにお問い合わせ"},"CALL_ATT_FADEL_BUTTON_MAIN":{"de":"Kontakt-Verkäufe zu mehr Information","en":"Contact Sales for More Information","es":"Ventas del contacto para más información","fr":"Ventes de contact pour plus d'information","it":"Vendite del contatto per più informazioni","ja":"より多くの情報のための接触の販売"},"CALL_ATT_FADEL_MAIN":{"de":"Stellen Sie eine angemessene Nutzung Ihrer lizenzierten Inhalte (von Bildern bis hin zu Videos und alles dazwischen) sicher. Portfolio verbindet sich nahtlos mit Rights-Cloud-Software von FADEL, sodass Sie die Nutzungsrechte in Verbindung mit Ihren Assets mühelos sehen und nachvollziehen können, was Ihnen dabei hilft, Engpässe zu beseitigen und die Gefahr kostspieliger Urheberrechtsverletzungen zu reduzieren.","en":"Ensure proper usage of your licensed content, from images to videos and everything in between. Portfolio seamlessly connects with FADEL Rights Cloud software so you can see and easily understand the usage rights associated with your assets—helping you to remove workflow bottlenecks and reduce the risk of expensive copyright violations.","es":"Garantice un uso adecuado de su contenido con licencia, desde imágenes hasta vídeos y todo lo demás. El Portfolio se conecta de forma ininterrumpida con el software de nube FADEL para que pueda ver y entender fácilmente los derechos de uso asociados con sus activos, ayudándole a desatascar el flujo de trabajo y reducir el riesgo de infracciones costosas de derechos de autor.","fr":"Assurez-vous de la bonne utilisation du contenu sous licence, des images aux vidéos et de tout ce qui se situe entre les deux. Le portefeuille se connecte sans difficulté au logiciel FADEL Rights Cloud pour que vous puissiez aisément comprendre les droits d’utilisation qui sont associés à vos éléments. Cela vous aide à résoudre les embouteillages de workflow et à réduire le risque d'infractions onéreuses aux droits d’auteur.","it":"Assicurati un uso corretto dei contenuti soggetti a licenza, dalle immagini ai video e tutto ciò che comprendono. Portfolio si collega senza problemi al software FADEL Rights Cloud in modo da poter vedere e comprendere facilmente l'uso di diritti associati alle proprie risorse—aiutandoti a rimuovere le strettorie del flusso di lavoro e ridurre il rischio di violazioni del diritto d'autore.","ja":"ライセンスで保護された画像やムービーなどを正しく使用する助けになります。PortfolioはFADEL Rights Cloudソフトウェアにシームレスに接続して、あなたのアセットに関連づけられている使用権を簡単に確認できるようにします。これによって、ライセンスの調査に必要な時間やコピーライトを違反するリスクを減らすことができるはずです。"},"CALL_ATT_FADEL_SUBTITLE":{"de":"Kennen Sie Ihre Asset-Nutzungsrechte","en":"Know your asset usage rights","es":"Conozca los derechos de uso de sus activos","fr":"Prenez connaissance de vos droits d’utilisateur","it":"Conosci i tuoi diritti di uso delle risorse","ja":"アセットの使用状況の取得"},"CALL_ATT_FADEL_TITLE":{"de":"FADEL RIGHTS CLOUD","en":"FADEL RIGHTS CLOUD","es":"FADEL RIGHTS CLOUD","fr":"FADEL RIGHTS CLOUD","it":"FADEL RIGHTS CLOUD","ja":"FADEL RIGHTS CLOUD"},"CALL_ATT_ME_SUBTITLE":{"de":"Hochleistungsverarbeitung und Umwandlung","en":"High-Performance Processing and Conversion","es":"Procesamiento y conversión de alto rendimiento","fr":"Conversion et traitement de haut niveau","it":"Gestione e conversione ad alte prestazioni","ja":"高いパフォーマンスの処理と変換"},"CALL_ATT_ME_MAIN":{"de":"Bringen Sie Ihren Portfolio Server an seine Leistungsgrenzen? Mit Media Engine vermeiden Sie Verlangsamungen und verbessern die Gesamtproduktivität, indem die Engpässe, die durch hoch belastete Produktionsumgebungen verursacht werden, eliminieren.\n\n\t• Erhöht die Kapazität und den Datendurchsatz\n\t• Entsperrt zusätzliche Ausgabeformate\n\t• Beschleunigt die Erstellung der Video Vorschau\n\t• Fügen Sie verschiedene Media Engines nach Bedarf hinzu\n\t• Wasserzeichenmarkierung (erfordert NetPublish)","en":"Are you pushing the performance limits of your Portfolio server? With Media Engine, avoid slowdowns and improve overall productivity by eliminating the bottlenecks caused by busy production environments.\n\n\t• Increases capacity and throughput\n\t• Unlocks additional output formats\n\t• Accelerates video preview creation\n\t• Add multiple Media Engines as needed\n\t• Watermarking (requires NetPublish)","es":"¿Desea aprovechar al máximo el rendimiento de su servidor de Portfolio? Con Media Engine, evite la ralentización del servidor y mejore la productividad general eliminando los atascos provocados por entornos de producción con alto rendimiento.\n\n\t• Aumenta la capacidad y productividad\n\t• Desbloquea formatos de producción adicionales\n\t• Acelera la creación de vistas previas de vídeo\n\t• Agregue los Media Engines que necesite\n\t• Configuración de marca de agua (precisa de Media Engine)","fr":"Est-ce que vous repoussez les limites de performance de votre serveur Portfolio? Grâce à Media Engine, évitez les baisses de rendement et augmentez la productivité globale en supprimant les goulots d’étranglement propres aux environnements de production actifs.\n\n\t• Augmente la capacité et le débit\n\t• Déverrouille des formats de sortie supplémentaires\n\t• Accélère la création des aperçus vidéo\n\t• Ajouter plusieurs Media Engines selon les besoins\n\t• Filigrane (nécessite NetPublish)","it":"Spingere i limiti prestazionali del proprio server Portfolio? Con Media Engine, si evitano rallentamenti e si migliora la produttività generale eliminando i colli di bottiglia causati da ambienti di produzione sovraccarichi.\n\n\t• Aumenta rendimento e velocità\n\t• Sblocca formati di uscita aggiuntivi\n\t• Accelera creazione anteprima video\n\t• Aggiungi più motori multimediali secondo necessità\n\t• Filigrana (richiede NetPublish)","ja":"Portfolioサーバーのパフォーマンスをさらに向上させたいですか？Media Engineがあれば、処理速度の低下を避け、処理が集中することによって発生するボトルネックを除去して、全体的な生産性を高めることができます。\n\n\t• 処理能力を向上\n\t• 追加の出力形式を使用可能\n\t• ビデオプレビューの作成を高速化\n\t• 必要に応じて複数のMedia Engineを追加\n\t• ウォーターマークを追加（NetPublishが必要です）"},"CALL_ATT_ME_BUTTON_MAIN":{"de":"Holen Sie sich Media Engine","en":"Get Media Engine","es":"Obtener Media Engine","fr":"Obtenir Media Engine","it":"Ottieni Media Engine","ja":"Media Engineを購入"},"CALL_ATT_NP_SUBTITLE":{"de":"Selbstbedienungsportale für einen sofortigen Zugang zu den Assets","en":"Self-Service Portals to Access Assets Instantly","es":"Portales de auto-servicio para acceder a activos al instante","fr":"Portails libre-service pour un accès immédiat aux actifs","it":"Portali Self-Service per accedere immediatamente agli asset","ja":"必要なアセットを簡単に見つけることができるセルフサービスのポータルサイト"},"CALL_ATT_NP_MAIN":{"de":"Sind Sie diese Anfragen nach Assets in letzter Minute leid? Mit NetPublish ist es einfach Selbstbedienungswebseiten zu posten, bei denen jeder nach Bedarf die Assets von jedem Browser auf jedem Gerät lokalisieren und herunterladen kann.\n\n\t• Seitenerstellung mit einem Klick - kein HTML oder CSS erforderlich\n\t• Mobilgeräte-freundliches, ansprechendes Design\n\t• Flexible Nutzerzugangskontrolle\n\t• Deaktivieren Sie Sites automatisch\n\t• Stellen Sie die Auflösung, die Größe und das Format für den Download ein\n\t• Wasserzeichenmarkierung (erfordert Media Engine)\n\t• Nutzungsberichte","en":"Tired of those last minute requests every time someone needs an asset? With NetPublish, it's easy to post self-serve websites that allow anyone to locate and download the assets they need from any browser on any device.\n\n\t• One-click site creation - no HTML or CSS required\n\t• Mobile-friendly, responsive design\n\t• Flexible user access control\n\t• Deactivate sites automatically\n\t• Set resolution, size and format on download\n\t• Watermarking (requires Media Engine)\n\t• Usage reporting","es":"¿Está cansado de solicitudes de última hora cada vez que alguien necesita un activo? Con NetPublish, es fácil publicar sitios web de auto-servicio que permitan a todos ubicar y descargar los activos que necesiten utilizando cualquier navegador en cualquier dispositivo.\n\n\t• Creación de sitios con un solo clic – sin necesidad de HTML o CSS\n\t• Diseño con respuesta de fácil uso en dispositivos móviles\n\t• Control flexible de acceso de usuarios\n\t• Desactive sitios de forma automática\n\t• Configure la resolución, tamaño y formato en la descarga\n\t• Configuración de marca de agua (requiere Media Engine)\n\t• Generación de informes de uso","fr":"Vous en avez assez de ces demandes de dernière minute à chaque fois qu’une personne a besoin d’un actif ? Grâce à NetPublish, il est facile de publier des sites Internet en libre service qui permettent à tous les utilisateurs de trouver et télécharger les actifs dont ils besoin à partir de n’importe quel navigateur et périphérique.\n\n\t• Création de site d’un simple clic- aucun code HTML ou CSS\n\t• Conception interactive et compatible avec les portables\n\t• Contrôle souple de l’accès utilisateur\n\t• Désactiver automatiquement les sites\n\t• Définir la résolution, la taille et le format lors du téléchargement\n\t• Filigrane (nécessite Media Engine)\n\t• Rapport d’utilisation","it":"Stanco di quelle richieste last minute ogni volta che qualcuno ha bisogno di un asset? Con NetPublish, è molto semplice pubblicare siti web self service che consentono a tutti di individuare e scaricare gli asset di cui hanno bisogno da qualsiasi browser su qualsiasi dispositivo.\n\n\t• Creazione di siti con un click: nessun HTML o CSS necessario\n\t• Design rapido e ottimizzato per dispositivi mobili\n\t• Controllo accesso utente flessibile\n\t• Disattiva siti automaticamente\n\t• Imposta risoluzione, dimensioni e formato al momento del download\n\t• Filigrana (richiede Media Engine)\n\t• Rapporto utilizzo","ja":"アセットを使用したい人物からのいつも突然のリクエストに辟易していませんか？NetPublishがあれば、誰でもそれぞれのデバイスのブラウザから、必要なアセットを見つけてダウンロードすることができる、セルフサービスのウェブサイトを簡単に作成することができます。\n\n\t• ワンクリックでサイトを作成 - HTMLやCSSの知識は必要ありません\n\t• モバイルデバイスに適したレスポンシブデザイン\n\t• フレキシブルなユーザーアクセス制御\n\t• サイトの使用期限を設定\n\t• ダウンロード時に、解像度、サイズ、形式を設定\n\t• ウォーターマークを追加（Media Engineが必要です）\n\t• 使用状況レポート"},"CALL_ATT_NP_BUTTON_MAIN":{"de":"Holen Sie sich NetPublish","en":"Get NetPublish","es":"Obtener NetPublish","fr":"Obtenir NetPublish","it":"Ottieni NetPublish","ja":"NetPublishを購入"},"CALL_ATT_REPORT_TITLE":{"de":"Berichterstattung für NetPublish","en":"Reporting for NetPublish","es":"Generación de informes para NetPublish","fr":"Création de rapports pour NetPublish","it":"Report per NetPublish","ja":"NetPublishレポート"},"CALL_ATT_REPORT_SUBTITLE":{"de":"RelevanteNutzungseinblicke","en":"Relevant Usage Insight","es":"Información de uso relevante","fr":"Informations d’utilisation pertinentes","it":"Verifica uso rilevante","ja":"使用状況の適切な解析"},"CALL_ATT_REPORT_MAIN":{"de":"Wollen Sie wissen welche Seiten am aktivsten sind, welche Assets benutzt werden und von wem? Mit NetPublish Berichterstattung bekommen Sie die Einblicke, die Sie brauchen, um Entscheidungen auf der Grundlage der Nutzung des Portfolios Ihres Unternehmens zu treffen.\n\nAufschlüsselung der Nutzung von:\n\t• NetPublish Seitenname\n\t• Nutzername\n\t• Assetname und ID\n\t• Datumund Uhrzeit","en":"Want to know which sites are most active, what assets are getting used and by whom? With NetPublish reporting, get the insight you need to make informed decisions based on how Portfolio is being used at your organization.\n\nUsage breakdown by:\n\t• NetPublish site name\n\t• Username\n\t• Asset name and ID\n\t• Date and time","es":"¿Desea conocer qué sitios están más activos, qué activos son utilizados y por parte de quién? Con la generación de informes de NetPublish, obtenga la información necesaria para tomar decisiones con información basada en el modo en que Portfolio se está utilizando en su organización.\n\nDesglose de uso por:\n\t• Nombre de sitio NetPublish\n\t• Nombre de usuario\n\t• Nombre de ID de activo\n\t• Fecha y hora","fr":"Vous voulez savoir quels sites sont les plus actifs, quels actifs sont utilisés et par qui ? Avec la création de rapports NetPublish, obtenez les informations dont vous avez besoin pour prendre les décisions éclairées sur l’utilisation de Portfolio au sein de votre organisation.\n\nRépartition de l’utilisation par :\n\t•Nom de site NetPublish\n\t• Nom d’utilisateur\n\t• ID et nom d’actif\n\t• Date et heure","it":"Vuoi sapere quali siti sono più attivi, quali asset sono usati e da chi? Con il report NetPublish, ottieni le informazioni di cui hai bisogno per prendere decisioni informate in base a come il Portfolio è usato nella tua organizzazione.\n\nAnalisi uso da:\n\t• Nome sito NetPublish\n\t• Nome utente\n\t• Nome asset e ID\n\t• Data e ora","ja":"どのサイトが最も頻繁に利用されており、どのアセットが誰に使用されているのかを知りたくはありませんか？NetPublishレポートがあれば、実際にPortfolioがどのように使用されているのかにもとづいて、あなたが根拠のある決定をするために必要な解析結果を取得することができます。\n\n次の分類による使用状況:\n\t• NetPublishサイト名\n\t• ユーザー名\n\t• アセット名とID\n\t• 日時"},"CALL_ATT_REPORT_BUTTON_MAIN":{"de":"Holen Sie sich NetPublish","en":"Get NetPublish","es":"Obtener NetPublish","fr":"Obtenir NetPublish","it":"Ottieni NetPublish","ja":"NetPublishを購入"},"CALL_ATT_SK_BUTTON_MAIN":{"de":"Versuchen Sie es kostenlos","en":"Try it for Free","es":"Probar gratuitamente","fr":"Essayer gratuitement","it":"Prova gratis","ja":"無料体験版"},"CALL_ATT_SK_BUTTON_TRY_NOW":{"de":"https://extens.is/ykx7","en":"https://extens.is/wqqb","es":"https://extens.is/p5u9","fr":"https://extens.is/jzp6","it":"https://extens.is/wqqb","ja":"https://extens.is/wqqb"},"CALL_ATT_SK_MAIN":{"de":"Sie suchen einen Weg, Ihren Prozess zu beschleunigen, Schlüsselwörtern Bildern zuzuweisen? Mit Portfolio Smart Keywords können Sie Ihren Bildern mit nur einem Klick automatisch „smart“ Keywords Ihren Bildern zuweisen. Durch Clarifai unterstützt, ein innovatives künstliches Intelligenz Unternehmen, das sich in der visuellen Erkennungstechnologie auszeichnet, eine Liste von Keywordsvorschlägen wird Ihnen in Sekunden geliefert. \n\n\t • Liefert eine Liste von smart keywords in Sekunden \n\t • Spart Zeit und Ressourcen bei der manuellen Keywordsuche \n\t • Etabliert eine konsistente Systematik für Ihre Organisation \n\t • Macht es einfach, Ihre digitalen Bestände schnell zu finden","en":"Looking for a way to accelerate your process for assigning keywords to images? With Portfolio Smart Keywords, you can automatically assign “smart” keywords to your images with just one click. Powered by Clarifai, an innovative artificial intelligence company that excels in visual recognition technology, a list of suggested keywords is delivered in seconds.\n\n\t• Delivers a list of smart keywords in seconds\n\t• Saves time and resources by reducing manual keywording\n\t• Establishes a consistent taxonomy for your organization\n\t• Makes it easy to find your digital assets quickly","es":"¿Busca una manera de acelerar la asignación de palabras clave a imágenes? Con Portfolio Smart Keywords podrá asignar automáticamente palabras clave “inteligentes” a sus imágenes con un solo clic. Desarrollado por Clarifai, una innovadora empresa de inteligencia artificial que destaca en la tecnología de reconocimiento visual, ofrece una lista de palabras clave sugeridas en cuestión de segundos.\n\n\t• Ofrece una lista de smart keywords en cuestión de segundos\n\t• Ahorra tiempo y recursos reduciendo la introducción manual de palabras clave\n\t• Crea una clasificación consistente en su organización\n\t• Facilita la búsqueda rápida de activos digitales","fr":"Vous cherchez une façon d'accélérer votre processus pour affecter des mots-clés aux images ? Avec Portfolio Smart Keywords, vous pouvez automatiquement affecter des mots-clés « intelligents » à vos images d'un seul clic. Optimisé par Clarifai, une société innovante d'intelligence artificielle qui excelle dans les technologies de reconnaissance visuelle, une liste de mots-clés peut être fournie en quelques secondes.\n\n\t• Fournit une liste de Smart Keywords en quelques secondes\n\t• Économise du temps et des ressources en réduisant la saisie manuelle de mots-clés\n\t• Établit une taxonomie cohérente pour votre organisation\n\t• Facilite la recherche rapide de vos ressources numériques","it":"Cercare un modo di accelerare il proprio processo di assegnazione di parole chiave a immagini? Con Portfolio Smart Keyword, è possibile assegnare automaticamente parole chiave \"smart\" alle proprie immagini con un solo clic. Sponsorizzato da Clarifai, una società innovativa di licenza artificiale che eccelle nella tecnologia di riconoscimento visivo, un elenco di parole chiave suggerito è fornito in secondi.\n\n\t• Fornisce un elenco di smart keyword in secondi\n\t• Fa risparmiare tempo e risorse riducendo le parole chiave manuali\n\t• Stabilisce una tassonomia consistente per la propria organizzazione\n\t• Rende semplice trovare le risorse rapidamente.","ja":"画像にキーワードを割り当てる作業を高速化したくはありませんか？Portfolio Smart Keywordsを使用すれば、「スマートな」キーワードをワンクリックで自動的に画像に割り当てることができます。この技術は、画像認識に秀でた人工知能を研究する革新的な企業であるClarifaiによって提供されています。\n\n\t・Smart Keywordsとして割り当てられるキーワードのリストはすぐに提供されます。\n\t・今までキーワードの割り当てに費やしていた時間と労力を減らすことができます。\n\t・一貫性のある最適な方法で、あなたの組織の資産となる膨大な画像を分類します。\n\t・必要なデジタルアセットを必要な時に即座に見つけることが容易になるはずです。"},"CALL_ATT_SK_SUBTITLE":{"de":"Automatisieren Sie Ihr Bild Keywording","en":"Automate Your Image Keywording","es":"Automatice las palabras clave de sus imágenes","fr":"Automatisez votre association de mots-clés avec des images","it":"Automatizzare la creazione di parole chiave per la tua immagine","ja":"キーワードを自動的に作成"},"CALL_ATT_SK_TITLE":{"de":"Portfolio Smart Keywords","en":"Portfolio Smart Keywords","es":"Portfolio Smart Keywords","fr":"Portfolio Smart Keywords","it":"Portfolio Smart Keyword","ja":"Portfolio Smart Keywords"},"CALL_ATT_SSO_SUBTITLE":{"de":"Nahtlose plattformübergreifende Nutzererfahrungen","en":"Seamless User Experience Across Platforms","es":"Experiencia de usuario ininterrumpida en todas las plataformas","fr":"Expérience utilisateur transparente entre les plates-formes","it":"Esperienza utente unica trasversale a tutte le piattaforme","ja":"プラットフォームの種類に影響されない一貫したユーザーエクスペリエンス"},"CALL_ATT_SSO_TITLE":{"de":"Einmalige Anmeldung","en":"Single Sign-On","es":"Single Sign-On","fr":"Single Sign-On","it":"Accesso singolo","ja":"シングルサインオン"},"CALL_ATT_SSO_MAIN":{"de":"Haben die Leute in Ihrem Unternehmen Schwierigkeiten, Ihre Anmeldedaten zu behalten? Mit neuen Lösungen geht typischerweise ein Mehraufwand bei der Verwaltung der Nutzerkonten einher, sowohl für Sie als auch für die Nutzer.\n\nGlücklicherweise unterstützt Portfolio die einmalige Anmeldung mit Active Directory. Wenn sie die einmalige Anmeldung nutzen, können die Nutzer sich automatisch von Ihrer Intranetseite in das Portfolio einloggen, wodurch sie eine kontinuierliche Nutzererfahrung haben.\n\n\t• Wird von Windows Server Active Directory unterstützt\n\t• Verbessert die Gesamtsicherheit\n\t• Vereinfacht die Nutzerverwaltung\n\t• Verbessert die Nutzererfahrung","en":"Are people in your organization having a hard time keeping their login credentials straight? Typically, with new solutions come extra overhead in managing user accounts, both for you and for the users.\n\nFortunately, Portfolio supports Single Sign-On with Active Directory. Using Single Sign-On, users can login to Portfolio automatically from your intranet site giving them a continuous user experience.\n\n\t• Supports Windows Server Active Directory\n\t• Improves overall security\n\t• Simplifies user management\n\t• Improves user experience","es":"¿Es complicado para el personal de su organización mantener organizadas sus credenciales de registro? Por lo general, con las nuevas soluciones aparecen gastos extra de gestión de cuentas de usuario, tanto para usted como para los usuarios.\n\nPor suerte, Portfolio admite Single Sign-On con Active Directory. Al utilizar Single Sign-On, los usuarios pueden registrarse en Portfolio de forma automática desde su sitio de Intranet, lo que les proporciona una experiencia de usuario continua.\n\n\t• Admite el Directorio Activo de Servidor de Windows\n\t• Mejora la seguridad general\n\t• Simplifica la gestión de usuarios\n\t• Mejora la experiencia de usuario","fr":"Est-ce qu’une gestion simple de leurs informations de connexion pose des difficultés aux membres de votre organisation ? Généralement, les nouvelles solutions de gestion des comptes utilisateurs sont synonymes de frais supplémentaires pour votre organisation et les utilisateurs.\n\nHeureusement, Portfolio prend en charge Single Sign-On avec Active Directory. Grâce à Single Sign-On, les utilisateurs peuvent se connecter dans Portfolio automatiquement depuis votre site intranet et de bénéficier d’une expérience utilisateur totale.\n\n\t• Prend en charge Windows Server Active Directory\n\t• Améliore la sécurité globale\n\t• Simplifie la gestion des utilisateurs\n\t• Améliore l’expérience utilisateur","it":"I membri della tua organizzazione stanno avendo difficoltà nel gestire le loro credenziali di accesso? Solitamente, le nuove soluzioni sono corredate da informazioni extra per la gestione degli account, utilizzabili da te e dagli utenti finali..\n\nFortunatamente, il Portfolio supporta l’accesso singolo con directory attiva. Utilizzando l'accesso singolo, gli utenti possono accedere automaticamente al Portfolio dal proprio sito intranet e ricevere un'esperienza utente continua.\n\n\t• Supporta Windows Server Active Directory\n\t• Migliora la sicurezza generale\n\t• Semplifica gestione utente\n\t• Migliora l'esperienza dell'utente","ja":"ログイン認証の信頼性を維持するために、多大な労力が費やされているということはありませんか？一般的には、新しい製品の使用を開始すると、あなたとあなたのユーザーの両方のアカウントを管理するために、追加費用が必要になります。\n\n幸いなことに、Portfolioはアクティブディレクトリによるシングルサインオンをサポートしています。シングルサインオンを使用すれば、ユーザーはあなたの社内ネットワークから自動的にPortfolioにログインすることができ、連続的なユーザーエクスペリエンスの提供を受けることができます。\n\n\t• Windows Serverのアクティブディレクトリをサポート\n\t• 全体的なセキュリティを向上\n\t• ユーザーの管理を簡略化\n\t• ユーザーエクスペリエンスを向上"},"CALL_ATT_SSO_BUTTON_MAIN":{"de":"Holen Sie sich Single Sign-On","en":"Get Single Sign-On","es":"Obtener Single Sign-On","fr":"Obtenir Single Sign-On","it":"Ottieni accesso singolo","ja":"シングルサインオンを購入"},"CALL_ATT_URL_BUY_NOW":{"de":"https://secure.portfoliodam.com/portfolio-options?lang=de","en":"https://secure.portfoliodam.com/portfolio-options","es":"https://secure.portfoliodam.com/portfolio-options?lang=es","fr":"https://secure.portfoliodam.com/portfolio-options?lang=fr","it":"https://secure.portfoliodam.com/portfolio-options?lang=it","ja":"https://secure.portfoliodam.com/portfolio-options"},"CALL_ATT_URL_CONTACT_SALES":{"de":"https://portfoliodam.com/de/portfolio/contact-me","en":"https://portfoliodam.com/portfolio/contact-me","es":"https://portfoliodam.com/es/portfolio/contact-me","fr":"https://portfoliodam.com/fr/portfolio/contact-me","it":"https://portfoliodam.com/portfolio/contact-me","ja":"https://portfoliodam.com/portfolio/contact-me"},"canEmbedMetadata":{"de":"Eingebettete Metadaten","en":"Embed Metadata","es":"Incrustar metadatos","fr":"Intégrer les métadonnées","it":"Nidifica Metadati","ja":"メタデータの埋め込み"},"canImportMetadata":{"de":"Daten exportieren/importieren","en":"Import/Export Metadata","es":"Importar/Exportar datos","fr":"Importer/Exporter des données","it":"Importa/Esporta dati","ja":"データの読み込み / データの書き出し"},"canManagePublicGallery":{"de":"Öffentliche Galerien verwalten","en":"Manage Public Galleries","es":"Gestionar galerías públicas","fr":"Gérer les présentations publiques","it":"Gestisci gallerie pubbliche","ja":"パブリック ギャラリーの管理"},"canPublishNetPublishSites":{"de":"Kann Veröffentlichen NetPublish Seiten","en":"Publish NetPublish Sites","es":"Puede publicar sitios NetPublish","fr":"Peut publier des sites NetPublish","it":"Può pubblicare siti NetPublish","ja":"NetPublishサイトの発行"},"canSmartKeyword":{"de":"Kann Smart Keyword","en":"Can Smart Keyword","es":"Puede utilizar Smart Keywords","fr":"Accès à Smart Keyword","it":"Può Smart Keyword","ja":"Smart Keywordの使用"},"CANCEL":{"de":"Abbrechen","en":"Cancel","es":"Cancelar","fr":"Annuler","it":"Annulla","ja":"キャンセル"},"CATALOG":{"de":"Katalog","en":"Catalog","es":"Catálogo","fr":"Catalogue","it":"Cataloga","ja":"カタログ"},"CATALOG_ADD_SELECTED_USERS_TO_CATALOG":{"de":"Mitgliedschaft zulassen","en":"Grant Membership","es":"Hacer socio","fr":"Autoriser l'adhésion","it":"Concedi membership","ja":"メンバシップを与える"},"CATALOG_BACKUP":{"de":"Ausgewählten Katalog sichern","en":"Backup Selected Catalog","es":"Copia de seguridad del catálogo seleccionado","fr":"Sauvegarder le catalogue sélectionné","it":"Esegui backup del catalogo selezionato","ja":"選択したカタログをバックアップ"},"CATALOG_CREATE":{"de":"Neuen Katalog hinzufügen","en":"Add New Catalog","es":"Agregar catálogo nuevo","fr":"Ajouter un nouveau catalogue","it":"Aggiungi nuovo catalogo","ja":"新規カタログを追加"},"CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG":{"de":"Katalogverwalter können vom Desktop Client aus AutoSync-Ordner hinzufügen.","en":"Catalog Administrators can add AutoSync folders from the Desktop Client.","es":"Los administradores de catálogos pueden agregar carpetas de sincronización automática desde el cliente de escritorio (Desktop Client).","fr":"Les administrateurs de catalogue peuvent ajouter des dossiers AutoSync à partir du Client du bureau.","it":"Gli amministratori di catalogo possono aggiungere cartelle AutoSync dal Desktop Client.","ja":"カタログ管理者は、デスクトップクライアントにてオートシンクフォルダを追加できます。"},"CATALOG_CREATE_AUTOSYNC_FOLDER":{"de":"Einen AutoSync-Ordner erstellen","en":"Create an AutoSync folder","es":"Crear una carpeta de sincronización automática","fr":"Créer un dossier AutoSync","it":"Creare una cartella AutoSync","ja":"オートシンクフォルダを作成"},"CATALOG_CREATE_CATALOG_TEMPLATE":{"de":"Katalogvorlage","en":"Save Catalog Template","es":"Plantilla de catálogo","fr":"Modèle de catalogue","it":"Modello di catalogo","ja":"カタログテンプレート"},"CATALOG_TYPE_GENERAL":{"de":"Allgemeine Verwendung","en":"General Use","es":"General Use","fr":"Utilisation générale","it":"General Use","ja":"汎用"},"CATALOG_TYPE_SIMPLE":{"de":"Einfach","en":"Simple","es":"Simple","fr":"Simple","it":"Simple","ja":"簡易"},"CATALOG_CREATE_DATABASES_LIST_LABEL":{"de":"Datenbanken","en":"Databases","es":"Bases de datos","fr":"Bases de données","it":"Database","ja":"データベース"},"CATALOG_CREATE_ERROR_CREATING_FOLDERS":{"de":"Beim Erstellen des {folder}-Ordners trat ein Fehler auf.","en":"An error was encountered when creating the {folder} folder.","es":"Ha surgido un error al crear la carpeta {folder}.","fr":"Une erreur est survenue lors de la création du {folder} dossier.","it":"Si è verificato un errore durante la creazione della cartella {folder}.","ja":"{folder}　フォルダを作成中にエラーが発生しました。"},"CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG":{"de":"Standardordner für AutoSync und Vorschaubilder können in den globalen Einstellungen konfiguriert werden.","en":"Default folders for AutoSync and Previews can be configured in Global Settings.","es":"Las carpetas predeterminadas de sincronización automática y de vistas previas pueden configurarse en la configuración global.","fr":"Les dossiers par défaut pour AutoSync et les prévisualisations peuvent être configurés dans les paramètres généraux.","it":"Le cartelle predefinite AutoSync e Anteprima possono essere configurate nelle Impostazioni globali.","ja":"オートシンクおよびプレビューのデフォルトフォルダは、グローバル設定で変更できます。"},"CATALOG_CREATE_NAME":{"de":"Name","en":"Name","es":"Nombre","fr":"Nom","it":"Nome","ja":"名前"},"CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG":{"de":"Vorschaubilder können in den Katalogdetails konfiguriert werden.","en":"Previews can be configured in Catalog Details.","es":"Las vistas previas pueden configurarse en los detalles del catálogo.","fr":"Les prévisualisations peuvent être configurées dans les détails du catalogue.","it":"Le anteprime possono essere visualizzate in Dettagli catalogo.","ja":"カタログ詳細にてプレビュー設定ができます。"},"CATALOG_CREATE_PREVIEW_FOLDER":{"de":"Für schnelleres Anzeigen die Vorschaubilder speichern","en":"Save Previews for faster previewing","es":"Guarde las vistas previas para que sean más rápidas","fr":"Enregistrer les prévisualisations pour une prévisualisation plus rapide","it":"Salvare le anteprime per visualizzarle velocemente","ja":"プレビューの表示速度を向上するには、プレビューを保存します"},"CATALOG_CREATE_SHOW_DATABASES":{"de":"Datenbanken anzeigen","en":"Show Databases","es":"Mostrar bases de datos","fr":"Afficher les bases de données","it":"Mostra database","ja":"データベースを表示"},"CATALOG_CREATE_USE_VERSIONING":{"de":"Nutzen Sie die Asset Versionierung","en":"Use Asset Versioning","es":"Utilizar Adjudicación de versión de activo","fr":"Utiliser le versionnage d'actifs","it":"Utilizza Versione Asset","ja":"アセットのバージョン管理を使用"},"CATALOG_DELETE":{"de":"Katalog löschen","en":"Delete Catalog","es":"Eliminar catálogo","fr":"Supprimer le catalogue","it":"Elimina catalogo","ja":"カタログを削除"},"CATALOG_DELETE_CONFIRM":{"de":"Möchten Sie den ausgewählten Katalog löschen?","en":"Do you want to delete the selected catalog?","es":"¿Desea eliminar el catálogo seleccionado?","fr":"Voulez-vous supprimer le catalogue sélectionné ?","it":"Eliminare il catalogo selezionato?","ja":"選択したカタログを削除しますか?"},"CATALOG_DETAILS":{"de":"Katalogdetails","en":"Catalog Details","es":"Detalles del catálogo","fr":"Détails du catalogue","it":"Dettagli catalogo","ja":"カタログの詳細情報"},"CATALOG_DETAILS_CHANGE_NAME_PROMPT":{"de":"Zum Umbenennen des Katalogs muss dieser vorübergehend offline genommen werden. Möchten Sie fortfahren?","en":"To rename this catalog we must temporarily take it offline, do you want to continue?","es":"Para cambiar el nombre de este catálogo, tenemos que sacarlo de línea un momento, ¿Desea continuar?","fr":"Pour renommer ce catalogue, nous devons le mettre hors ligne temporairement ; voulez-vous continuer ?","it":"Per rinominare questo catalogo è necessario metterlo temporaneamente offline, si desidera continuare?","ja":"カタログの名前を変更するには、このカタログを一時的にオフラインにする必要があります。続行しますか?"},"CATALOG_DETAILS_COLLATION":{"de":"Sortierfolge","en":"Collation","es":"Intercalado","fr":"Assemblage","it":"Fascicolazione","ja":"対象"},"CATALOG_DETAILS_COLLATION_NA":{"de":"—","en":"N/A","es":"N/A","fr":"N/D","it":"N/D","ja":"なし"},"CATALOG_DETAILS_CREATION_DATE":{"de":"Erstellungsdatum","en":"Creation Date","es":"Fecha de creación","fr":"Date de création","it":"Data di creazione","ja":"作成日"},"CATALOG_DETAILS_DATABASE_TAB":{"de":"Allgemein","en":"General","es":"General","fr":"General","it":"Generale","ja":"一般"},"CATALOG_DETAILS_LAST_MODIFIED":{"de":"Zuletzt geändert am","en":"Last Modified","es":"Última modificación","fr":"Date de la dernière modification","it":"Ultima modifica","ja":"最終修正日"},"CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS":{"de":"Verbundene Benutzer","en":"Connected Users","es":"Usuarios conectados","fr":"Utilisateurs connectés","it":"Utenti collegati","ja":"接続しているユーザー"},"CATALOG_DETAILS_NUMBER_OF_RECORDS":{"de":"Datensätze","en":"Records","es":"Registros","fr":"Enregistrements","it":"Registrazioni","ja":"レコード"},"CATALOG_DETAILS_NUMBER_OF_USERS":{"de":"Mitglieder","en":"Members","es":"Socios","fr":"Membres","it":"Membri","ja":"メンバ"},"CATALOG_DETAILS_SIZE_ON_DISK":{"de":"Größe auf Festplatte","en":"Size on disk","es":"Tamaño en disco","fr":"Taille sur le disque","it":"Dimensione su disco","ja":"ディスク上のサイズ"},"CATALOG_DETAILS_WARN_DISCONNECT_ADMIN":{"de":"Der Administrator-Benutzer wird getrennt. Fortfahren?","en":"The administrator user will be disconnected. Proceed?","es":"El usuario administrador se desconectará. ¿Continuar?","fr":"L'utilisateur administrateur sera déconnecté. Continuer?","it":"L'utente amministratore sarà scollegato. Procedere?","ja":"管理者ユーザーの接続を解除します。続行してよろしいですか?"},"CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION":{"de":"Gesperrt für Administration","en":"Locked for administration","es":"Bloqueado para administración","fr":"Verrouillé pour l'administration","it":"Bloccato per l'amministrazione","ja":"管理用にロック"},"CATALOG_DETAILS_UNLOCK":{"de":"Entsperren","en":"Unlock","es":"Desbloquear","fr":"Déverrouiller","it":"Sblocca","ja":"ロック解除"},"CATALOG_EXPLANATION_VAULT_1":{"de":"Vault Kataloge speichern die Assets in einer sicheren Ablage.","en":"Vault catalogs store assets in a secure repository.","es":"Los catálogos de Bóveda almacenan activos en un emplazamiento seguro.","fr":"Les catalogues d'archivage stockent les actifs dans un emplacement sécurisé.","it":"I cataloghi Vault conservano asset in depositi sicuri.","ja":"Vaultカタログはアセットを安全なリポジトリに保管します。"},"CATALOG_EXPLANATION_VAULT_2":{"de":"Support-Sperre, Versionseinstellung, Check-Out und Check-In der Vault Kataloge.","en":"Vault catalogs support locking, versioning, check-out and check-in.","es":"Los catálogos de Bóveda admiten el bloqueo, adjudicación de versión, salida y registro.","fr":"Les catalogues d’archivage prennent en charge le verrouillage, les différences de version, l’extraction et l’archivage.","it":"I cataloghi Vault supportano blocco, versionamento, estrazione e archiviazione.","ja":"Vaultカタログは、ロック、バージョン管理、チェックアウトおよびチェックインをサポートします。"},"CATALOG_EXPLANATION_WF_1":{"de":"Watch Ordner Kataloge verfolgen die Assets zurück, die sich in Ihrem Dateisystem befinden.","en":"Watch Folder catalogs track assets in place in your file system.","es":"Los catálogos de Carpeta de observación efectúan el rastreo de activos de su sistema de archivos.","fr":"Les catalogues de surveillance de dossier suivent les actifs contenus dans votre système de fichiers.","it":"I cataloghi Watch Folder monitorano asset presenti nel file system.","ja":"監視フォルダカタログはアセットの元の場所を参照します。"},"CATALOG_EXPLANATION_WF_2":{"de":"Watch Ordner Kataloge werden von AutoSync. unterstützt.","en":"Watch Folder catalogs support AutoSync.","es":"Los catálogos de Carpeta de observación admiten AutoSync.","fr":"Les catalogues de surveillance de dossier prennent en charge AutoSync.","it":"Cataloghi Watch Folder supportano AutoSync.","ja":"監視フォルダカタログはオートシンクをサポートします。"},"CATALOG_INGEST_DRAG_HINT_TEXT":{"de":"Um dem Upload-Formular Felder hinzuzufügen, ziehen Sie diese aus der Felderliste herüber.","en":"To add fields to the Upload Form, drag them over from the Fields list.","es":"Para añadir campos al formulario de subida, arrástrelos desde la lista de campos.","fr":"Pour ajouter des champs au formulaire de téléchargement, faites les glisser sur la liste des champs.","it":"Per aggiungere campi al Modulo di upload, trascinarli dall'elenco Campi.","ja":"アップロードフォームにフィールドを追加するには、フィールドリストからドラッグしてください。"},"CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL":{"de":"Felder für Upload-Formular","en":"Fields for Upload Form","es":"Campos del formulario de subida","fr":"Champs pour le formulaire de téléchargement","it":"Campi per Modulo di upload","ja":"アップロードフォームのフィールド"},"CATALOG_INGEST_FIELDS_LABEL":{"de":"Felder","en":"Fields","es":"Campos","fr":"Champs","it":"Campi","ja":"フィールド"},"CATALOG_INGEST_FORM_HEADER_LABEL":{"de":"Formularkopf","en":"Form Header","es":"Encabezado del formulario","fr":"En-tête du formulaire","it":"Intestazione modulo","ja":"フォームヘッダー"},"CATALOG_INGEST_HEADER_HINT_TEXT":{"de":"Der Formularkopf ist optional und erscheint oben auf dem Formular.","en":"The form header is optional and appears at the top of the form.","es":"El encabezado del formulario es opcional y aparece en la parte superior del formulario.","fr":"L'en-tête du formulaire est optionnel et s'affiche en haut du formulaire.","it":"L'intestazione del modulo è opzionale e appare nella parte alta del modulo.","ja":"フォームヘッダーは、フォームの一番上に表示されるオプションです。"},"CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE":{"de":"Die maximale Anzahl hinzufügbarer Felder ist {maxFields}.","en":"The maximum number of fields to add to a form is {maxFields}.","es":"El número máximo de campos para añadir al formulario es {maxFields}.","fr":"Le nombre maximum de champs pouvant être ajoutés à un formulaire est de {maxFields}.","it":"Il numero massimo di campi da aggiungere a un modulo è {maxFields}.","ja":"フォームに追加できるフィールドの最大数は{maxFields}です。"},"CATALOG_INGEST_TAB_TITLE":{"de":"Verwalteter Upload","en":"Managed Upload","es":"Gestor de Subida","fr":"Gestion des Ajouts","it":"Upload Gestito","ja":"管理されたアップロード"},"CATALOG_INGEST_USE_INGEST_LABEL":{"de":"Managed Upload verwenden","en":"Use Managed Upload","es":"Usar el gestor de subida","fr":"Utiliser la gestion de téléchargement","it":"Utilizza Upload gestito","ja":"管理されたアップロードを使用"},"CATALOG_INGEST_REQUIRED_LABEL":{"de":"Erforderlich","en":"Required","es":"Requerido","fr":"Obligatoire","it":"Necessario","ja":"必須"},"CATALOG_IS_CONNECTED":{"de":"Verbunden","en":"Connected","es":"Conectado","fr":"Connecté","it":"Collegato","ja":"接続済み"},"CATALOG_IS_DEFAULT":{"de":"Standard","en":"Default","es":"Predeterminado","fr":"Par défaut","it":"Predefinito","ja":"デフォルト"},"CATALOG_MANAGE_USERS":{"de":"Katalogmitgliedschaft verwalten","en":"Manage Catalog Membership","es":"Gestionar socios del catálogo","fr":"Gestion des adhésions au catalogue","it":"Gestisci membership catalogo","ja":"カタログのメンバシップを管理"},"CATALOG_MANAGE_FIELDS":{"de":"Katalogfelder verwalten","en":"Manage Catalog Fields","es":"Administrar Campos de Catálogos","fr":"Gérer des champs de catalogue","it":"Gestisci campi catalogo","ja":"カタログフィールドの管理"},"CATALOG_MANAGE_TEMPLATES_MENU_LABEL":{"de":"Katalogvorlagen verwalten...","en":"Manage Catalog Templates...","es":"Gestionar plantillas de catálogo…","fr":"Gérer les modèles de catalogue...","it":"Gestisci modelli di catalogo...","ja":"カタログテンプレートを管理"},"CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE":{"de":"Benutzerdefinierte Katalogvorlagen verwalten","en":"Manage Custom Catalog Templates","es":"Gestionar plantillas de catálogo personalizadas","fr":"Gérer les modèles de catalogue personnalisés","it":"Gestisci modelli di catalogo personalizzati","ja":"カスタムカタログテンプレートを管理"},"CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER":{"de":"Name der Katalogvorlage","en":"Catalog Template Name","es":"Nombre de plantilla de catálogo","fr":"Nom du modèle de catalogue","it":"Nome modello di catalogo","ja":"カタログテンプレート名"},"CATALOG_MEMBER":{"de":"Mitglied","en":"Member","es":"Socio","fr":"Membre","it":"Membro","ja":"メンバ"},"CATALOG_NEW_CATALOG_DETAILS":{"de":"Neue Katalogdetails","en":"New Catalog Details","es":"Detalles del nuevo catálogo","fr":"Détails sur le nouveau catalogue","it":"Dettagli nuovo catalogo","ja":"新規カタログの詳細情報"},"CATALOG_OFFLINE":{"de":"Offline","en":"Offline","es":"Fuera de línea","fr":"Hors ligne","it":"Offline","ja":"オフライン"},"CATALOG_ONLINE":{"de":"Online","en":"Online","es":"En línea","fr":"En ligne","it":"Online","ja":"オンライン"},"CATALOG_OPTIONS_ALL_FILE_TYPES":{"de":"Katalog Alle Dateitypen","en":"Catalog All File Types","es":"Catalogar todos los tipos de archivos","fr":"Cataloguer tous les types de fichiers","it":"Cataloga tutti i tipi di file","ja":"全てのファイルタイプをカタログ化"},"CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL":{"de":"Schlüsselbegriffe von Pfad generieren","en":"Create Keywords from Path","es":"Crear palabras claves desde la ruta","fr":"Créer des mots clefs à partir du chemin d'accès","it":"Crea parole chiave dal percorso","ja":"パスからキーワードを作成"},"CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME":{"de":"Dateiname","en":"Filename","es":"Nombre de archivo","fr":"Nom de fichier","it":"Nome file","ja":"ファイル名"},"CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT":{"de":"Übergeordneter Ordner","en":"Parent Folder","es":"Carpeta principal","fr":"Dossier parent","it":"Cartella principale","ja":"上位フォルダ"},"CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER":{"de":"Servername","en":"Server Name","es":"Nombre de servidor","fr":"Nom du serveur","it":"Nome server","ja":"サーバー名"},"CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE":{"de":"Ordnerhierarchie","en":"Folder Tree","es":"Árbol de carpetas","fr":"Arborescence des dossiers","it":"Struttura ad albero cartelle","ja":"フォルダ構造"},"CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME":{"de":"Band","en":"Volume","es":"Volumen","fr":"Volume","it":"Volume","ja":"ボリューム"},"CATALOG_OPTIONS_EXCLUSION_LABEL":{"de":"Datei- und Ordnerausschlüsse","en":"File and Folder Exclusions","es":"Exclusiones de archivos y carpetas","fr":"Exclusion de fichiers et dossiers","it":"Esclusioni file e cartella","ja":"除外するファイルとフォルダ"},"CATALOG_OPTIONS_ONLY_FILE_TYPES":{"de":"Nur Katalog Catalogar únicamente","en":"Catalog Only","es":"En línea","fr":"Cataloguer uniquemente","it":"Cataloga solamente","ja":"次のファイルタイプのみカタログ化"},"CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION":{"de":"Ausgewählte(n) Dateityp(en) entfernen?","en":"Remove the selected file type(s)?","es":"¿Eliminar el(los) tipo(s) de archivo(s) seleccionado(s)?","fr":"Enlever le ou les type(s) de fichiers sélectionné(s) ?","it":"Rimuovere il/i tipo/i di file selezionato/i? ","ja":"選択したファイルタイプを削除しますか？"},"endsWith":{"de":"Endet mit","en":"Ends with","es":"Termina con","fr":"Se termine par","it":"Finisce con","ja":"で終わる"},"contains":{"de":"Enthält","en":"Contains","es":"Contiene","fr":"Contient","it":"Contiene","ja":"含む"},"startsWith":{"de":"Beginnt mit","en":"Starts with","es":"Empieza con","fr":"Commence avec","it":"Inizia con","ja":"で始まる"},"CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION":{"de":"Den/die ausgewählten Ausschlüsse entfernen?","en":"Remove the selected exclusion(s)?","es":"¿Eliminar la(s) exclusión(es) seleccionada(s)?","fr":"Enlever la ou les exceptions sélectionnées?","it":"Rimuovere la/le esclusione/i selezionata/e?","ja":"選択した除外を削除しますか？"},"CATALOG_OPTIONS_TAB_TITLE":{"de":"Katalogisierungsoptionen","en":"Cataloging Options","es":"Opciones de categorización","fr":"Options de catalogage","it":"Opzioni di catalogazione","ja":"カタログ作成オプション"},"CATALOG_PREVIEWS_DEFAULT_LOCATION_IS":{"de":"Der Standardort ist","en":"The default location is","es":"La ubicación predeterminada es","fr":"L’emplacement par défaut est","it":"La posizione predefinita è","ja":"デフォルトの場所"},"CATALOG_PREVIEWS_DIMENSIONS_LABEL":{"de":"Mindestgröße 300 Pixel, maximale Größe 4000 Pixel (längste Dimension)","en":"Minimum size 300 pixels, maximum size 4000 pixel (longest dimension)","es":"Tamaño mínimo 300 píxeles, tamaño máximo 4.000 píxeles (mayor dimensión)","fr":"Taille minimale 300 pixels, taille maximale 4000 pixels (plus grande dimension)","it":"Dimensioni minime 300 pixel, dimensioni massime 4000 pixel (dimensione più lunga)","ja":"最小サイズ300ピクセル、最大サイズ4000ピクセル（長辺）"},"CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES":{"de":"Clips für Audio/Video-Dateien erstellen","en":"Generate clips for audio/video files","es":"Generar clips para archivos de audio/vídeo","fr":"Générer des clips pour des fichiers audio/vidéo","it":"Genera clip per file audio/video","ja":"オーディオ/ビデオファイルのクリップを作成"},"CATALOG_PREVIEWS_GENERATE_PREVIEWS":{"de":"Vorschaubilder erstellen","en":"Create Previews","es":"Crear vistas previas","fr":"Créer des aperçus","it":"Crea anteprime","ja":"プレビューを作成"},"CATALOG_PREVIEWS_FOLDER_LOCATION":{"de":"Vorschaubilder und Clips in diesem Ordner speichern","en":"Save previews and clips in this folder","es":"Guardar vistas previas y clips en esta carpeta","fr":"Enregistrer les prévisualisations et clips dans ce dossier","it":"Salva anteprime e clip in questa cartella","ja":"プレビューとクリップを次のフォルダに保存"},"CATALOG_PREVIEWS_LOCATION_WARNING_INFO":{"de":"Der Server muss auf den Speicherort zugreifen können.","en":"This location must be accessible to the server.","es":"Esta ubicación debe ser accesible para el servidor.","fr":"L'emplacement doit être accessible au serveur.","it":"Questa posizione deve essere accessibile al server.","ja":"サーバーから参照可能な場所に指定する必要があります。"},"CATALOG_PREVIEWS_MAX_PIXELS":{"de":"Maximale Bildgröße","en":"Maximum image size","es":"Tamaño máximo de imagen","fr":"Taille d'image maximale","it":"Dimensione massima dell'immagine","ja":"最大画像サイズ"},"CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION":{"de":"Maximale Video-Auflösung","en":"Maximum video resolution","es":"Resolución máxima de vídeo","fr":"Résolution vidéo maximale","it":"Risoluzione video massima","ja":"最大動画解像度"},"CATALOG_PREVIEWS_MINUTES":{"de":"Minuten","en":"minutes","es":"minutos","fr":"minutes","it":"minuti","ja":"分"},"CATALOG_PREVIEWS_PIXELS":{"de":"Pixel","en":"pixels","es":"píxeles","fr":"pixels","it":"pixel","ja":"ピクセル"},"CATALOG_PREVIEWS_SHORT":{"de":"Vorschaubilder","en":"Previews","es":"Vistas previas","fr":"Aperçus","it":"Anteprime","ja":"プレビュー"},"CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION":{"de":"Dauer begrenzen auf:","en":"Limit duration to","es":"Limitar duración a","fr":"Limiter la durée à","it":"Limita la durata a ","ja":"時間制限"},"CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT":{"de":"Das Erstellen von Clips kann eine Weile dauern. \nWenn Sie die Bearbeitungszeit verkürzen möchten, wählen Sie eine niedrigere Auflösung und Dauer.","en":"Generating clips can take a while to process.\nTo shorten the processing time, choose a lower resolution and duration.","es":"El proceso de generación de clips puede llevar tiempo.\nPara que tarde menos, seleccione una resolución menor y una duración más corta.","fr":"Générer des clips peut prendre un certain temps de traitement.\nPour limiter le temps de traitement, choisissez une résolution et durée plus faible.","it":"La generazione di clip può richiedere un po' di tempo per l'elaborazione.\nPer accorciare il tempo di elaborazione, scegliere una risoluzione e una durata inferiori.","ja":"クリップの作成には時間がかかります。\n処理時間を短縮するには解像度と継続時間の値を下げてください。"},"CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG":{"de":"Mitgliedschaft aufheben","en":"Revoke Membership","es":"Cancelar socio","fr":"Révoquer l'adhésion","it":"Annulla membership","ja":"メンバシップを取り消し"},"CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION":{"de":"Den Nutzer aus dem Katalog entfernen? \nDie aus diesem Katalog ausgechecktenArtikel werden zurückgegeben und zur Verfügung gestellt.","en":"Remove the user from the catalog?\nThe user's Checked Out items in this catalog will be reverted and made accessible.","es":"¿Eliminar este usuario del catálogo?\nLos elementos en Salida del usuario se revertirán y se podrá acceder a estos.","fr":"Supprimer l’utilisateur du catalogue ?\nLes éléments extraits des utilisateurs dans ce catalogue seront restaurés et rendus accessibles.","it":"Rimuovi l'utente dal catalogo?\nGli articoli Pagati dall’utente in questo catalogo saranno ripristinati e resi accessibili.","ja":"カタログからユーザーを削除しますか？\nユーザーのこのカタログのチェックアウトアイテムが復帰して、アクセス可能になります。"},"CATALOG_SAVE_TEMPLATE":{"de":"Katalogvorlage speichern...","en":"Save Catalog Template...","es":"Guardar plantilla de catálogo...","fr":"Sauvegarder le modèle de catalogue","it":"Salva modello catalogo...","ja":"カタログテンプレートを保存"},"CATALOG_SAVE_TEMPLATE_DETAILS_TEXT":{"de":"Die gespeicherte Katalogvorlage enthält: alle Felder, Metadatenzuordnungen und Katalog-Optionseinstellungen.","en":"Catalog templates include all fields, metadata mappings, and cataloging options.","es":"La plantilla guardada incluye: todas las configuraciones de campos, mapeados de metadatos y opciones de catálogos.","fr":"Le modèle sauvegardé comprend : tous les champs, les mappages des métadonnées et les paramètres optionnels du catalogue.","it":"Il modello salvato include: tutti i campi, le mappature dei metadati e le impostazioni delle opzioni catalogo.","ja":"保存したテンプレートには、フィールド、メタデータのマッピング、カタログ作成オプションの設定が含まれています。"},"CATALOG_SELECT_MESSAGE":{"de":"Kein Katalog ausgewählt","en":"No Catalog Selected","es":"No hay catálogo seleccionado","fr":"Aucun catalogue sélectionné","it":"Nessun catalogo selezionato","ja":"カタログ未選択"},"CATALOG_SET_AS_DEFAULT":{"de":"Standardkatalog festlegen","en":"Set Default Catalog","es":"Configurar catálogo predeterminado","fr":"Définir le catalogue par défaut","it":"Imposta catalogo predefinito","ja":"デフォルトカタログを設定"},"CATALOG_SK_DEFAULT_SETTINGS":{"de":"Standardeinstellungen","en":"Default Settings","es":"Configuración por defecto","fr":"Réglages par défaut","it":"Impostazioni predefinite","ja":"デフォルト設定"},"CATALOG_SK_CONFIDENCE_LEVEL_LABEL":{"de":"Konfidenzniveau","en":"Confidence Level","es":"Nivel de fiabilidad","fr":"Niveau de confidentialité","it":"Livello di riservatezza","ja":"精度"},"CATALOG_SK_DEFAULT_LABEL":{"de":"Empfohlen: {recommended}","en":"Recommended: {recommended}","es":"Recomendado: {recommended}","fr":"Recommandé : {recommended}","it":"Raccomandato: {recommended}","ja":"推奨: {recommended}"},"CATALOG_SK_ENGINES_LABEL":{"de":"Smart Keywords-Engines","en":"Smart Keyword Engines","es":"Motores palabras Smart Keywords","fr":"Moteurs de Smart Keywords","it":"Motori di ricerca con Smart Keywords","ja":"Smart Keywordエンジン"},"CATALOG_SK_LANGUAGES_LABEL":{"de":"Sprachen für die General-Engine","en":"Languages for General Engine","es":"Idiomas del motor general","fr":"Langues pour le moteur général","it":"Lingue per General Engine","ja":"General Engineの言語"},"CATALOG_SK_NUM_KEYWORDS_LABEL":{"de":"Anzahl Suchbegriffe","en":"Number of Keywords","es":"Número de palabras clave","fr":"Nombre de mots-clés","it":"Numero di parole chiave","ja":"キーワード数"},"CATALOG_SK_SETTINGS_LABEL":{"de":"Einstellungen","en":"Settings","es":"Configuración","fr":"Paramètres","it":"Impostazioni","ja":"設定"},"CATALOG_SK_TAB_TITLE":{"de":"Smart Keywords","en":"Smart Keywords","es":"Smart Keywords","fr":"Smart Keywords","it":"Smart Keywords","ja":"Smart Keywords"},"CATALOG_SK_USE_SK_LABEL":{"de":"Smart Keywords in diesem Katalog nutzen","en":"Use Smart Keywords in this Catalog","es":"Utilizar Smart Keywords en este catálogo","fr":"Utiliser des Smart Keywords dans ce catalogue","it":"Utilizzare Smart Keywords in questo catalogo","ja":"このカタログでSmart Keywordsを使用"},"CATALOG_STATUS":{"de":"Katalogstatus","en":"Catalog Status","es":"Estado de catálogo","fr":"État du catalogue","it":"Stato catalogo","ja":"カタログの状態"},"CATALOG_STORAGE_TYPE_LABEL":{"de":"Speichertyp","en":"Storage Type","es":"Tipo de almacenamiento","fr":"Type de stockage","it":"Tipo di archiviazione","ja":"ストレージタイプ"},"CATALOG_STORAGE_TYPE_WATCHFOLDERS":{"de":"Ordner beobachten","en":"Watch Folders","es":"Carpetas de inspección","fr":"Voir les dossiers","it":"Guarda cartelle","ja":"監視フォルダ"},"CATALOG_STORAGE_TYPE_VAULT":{"de":"Vault","en":"Vault","es":"Bóveda","fr":"Archivage","it":"Insieme di credenziali","ja":"Vault"},"CATALOG_TAKE_OFFLINE_SHORT":{"de":"Offline stellen","en":"Take Offline","es":"Poner fuera de línea","fr":"Travailler hors ligne","it":"Porta offline","ja":"オフラインにする"},"CATALOG_TAKE_ONLINE_SHORT":{"de":"Online stellen","en":"Take Online","es":"Poner en línea","fr":"Travailler en ligne","it":"Porta online","ja":"オンラインにする"},"CATALOG_TEMPLATE":{"de":"Vorlage","en":"template","es":"plantilla","fr":"modèle","it":"modello","ja":"テンプレート"},"CATALOG_TEMPLATE_NAME":{"de":"Vorlagenname","en":"Template Name","es":"Nombre de plantilla","fr":"Nom du modèle","it":"Nome modello","ja":"テンプレート名"},"CATALOG_TEMPLATES_TITLE":{"de":"Katalogvorlagen","en":"Catalog Templates","es":"Plantillas de Catálogo","fr":"Modèles de Catalogue","it":"Modelli di Catalogo","ja":"カタログテンプレート"},"CATALOG_TEMPLATE_REMOVE_CONFIRMATION":{"de":"Markierte Katalogvorlage entfernen?","en":"Remove the selected catalog template?","es":"¿Eliminar la plantilla de catálogo seleccionada?","fr":"Supprimer le modèle de catalogue sélectionné ?","it":"Rimuovere il modello di catalogo selezionato?","ja":"選択したカタログテンプレートを削除しますか？"},"CATALOG_VIEW_DETAILS":{"de":"Katalogdetails anzeigen/bearbeiten","en":"View/Edit Catalog Details","es":"Ver/Editar detalles del catálogo","fr":"Afficher/Modifier les détails du catalogue","it":"Visualizza/Modifica dettagli catalogo","ja":"カタログ詳細情報を表示/編集"},"CERT_REQUEST_ALREADY_CREATED_WARNING":{"de":"Sie haben bereits eine Zertifikatsanforderung gemacht Wenn Sie fortfahren, wird die vorhandene Anforderung gelöscht.","en":"You have already created a certificate request. If you continue, the existing request will be deleted.","es":"Ya ha creado una solicitud de certificado. Si continúa, se eliminará la solicitud existente.","fr":"Vous avez déjà créé une demande de certificat. Si vous continuez, la demande existante sera supprimée.","it":"Hai già creato una richiesta di certificato. Se continui, la richiesta esistente verrà eliminata.","ja":"証明書リクエストは既に作成されています。続行すると既存のリクエストは削除されます。"},"CERTIFICATE_FILE_FILTER":{"de":"Zertifikate (p7b, p7, cer, crt, pem, pfx, p12)","en":"Certificates (p7b, cer, crt, der, pfx, p12)","es":"Certificados (p7b, p7, cer, crt, pem, pfx, p12)","fr":"Certificats (p7b, p7, cer, crt, pem, pfx, p12)","it":"Certificati (p7b, p7, cer, crt, pem, pfx, p12)","ja":"証明書 (p7b, p7, cer, crt, pem, pfx, p12)"},"CITY_OR_LOCALITY":{"de":"Stadt oder Ort","en":"City or Locality","es":"Ciudad o localidad","fr":"Ville ou localité","it":"Città o località","ja":"市または地域"},"CLEAR_BUTTON_LABEL":{"de":"Löschen","en":"Clear","es":"Borrar","fr":"Effacer","it":"Cancella","ja":"消去"},"COMMUNICATION_AT_INITILIZATION_ERROR":{"de":"Bei der Kommunikation mit dem Server ist ein Fehler aufgetreten. Dies wird üblicherweise durch veraltete Daten im Browser-Cache verursacht, könnte aber auch auf ein Problem mit dem Server hinweisen. Wenden Sie sich für weitere Informationen an den Administrator.","en":"There was an error communicating with the server. This is usually caused by stale data in the browser cache but it could also indicate a problem with the server. Contact your administrator for more information.","es":"Se produjo un error de comunicación con el servidor. Esto suele causarlo la antigüedad de los datos en la caché del navegador, pero también podría indicar un problema con el servidor. Póngase en contacto con el administrador si desea más información.","fr":"Erreur de communication avec le serveur. Cette erreur est souvent causée par les données anciennes du cache du navigateur mais cela pourrait aussi signaler un problème venant du serveur. Veuillez contacter votre administrateur pour plus d'informations.","it":"Si è verificato un errore durante la comunicazione con il server. Ciò in genere è dovuto alla presenza di dati non aggiornati nella cache del browser, ma può anche indicare un problema del server. Contattare l'amministratore per maggiori informazioni.","ja":"サーバー接続時にエラー。これはブラウザのキャッシュに含まれる古いデータが原因になることが良くありますが、サーバー側の問題の可能性もあります。詳細な情報については管理者にお問い合わせください。"},"CONFIGURE_DIRECTORY_SERVICE":{"de":"Verzeichnisdienst konfigurieren","en":"Configure Directory Service","es":"Configurar servicio de directorios","fr":"Configurer le service d'annuaire","it":"Configura Servizio Directory","ja":"ディレクトリサービスを設定"},"CONFIRM_DELETE_PDL":{"de":"Alle vordefinierten Werte für dieses Feld löschen?","en":"Delete all predefined values for this field?","es":"¿Eliminar todos los valores predefinidos para este campo?","fr":"Supprimer toutes les valeurs prédéfinies pour ce champ ?","it":"Eliminare tutti i valori predefiniti per questo campo?","ja":"全ての定義済みの値を削除しますか？"},"CONFIRM_DELETE_SERVICE":{"de":"Verzeichnisdienst löschen?\nVom Dienst importierte Benutzer bleiben bestehen. Für deren Passwörter werden zuvor in Portfolio enthaltene Werte wiederhergestellt bzw. deaktiviert (falls zuvor nicht festgelegt).","en":"Remove Directory Service?\nUsers imported from the service will remain. Their passwords will revert to values set previously in Portfolio, or will be disabled if not set previously.","es":"¿Eliminar servicio de directorios?\nSe mantendrán los usuarios importados desde el servicio. Sus contraseñas recuperarán los valores anteriormente definidos en Portfolio, o se inhabilitarán si es que no se habían definido anteriormente.","fr":"Supprimer le service d'annuaire?\nLes utilisateurs importés de ce service resteront. Leurs mots de passe seront réinitialisés aux valeurs définies précédemment dans Portfolio (le cas échéant), ou seront désactivés.","it":"Eliminare servizio directory?\nGli utenti importati dal servizio verranno mantenuti. Le password verranno riportate ai valori  impostati in precedenza in Portfolio oppure verranno disabilitate se non sono state definite in precedenza.","ja":"ディレクトリサービスを削除しますか?\nサービスからインポートされたユーザは残ります。 これらのユーザのパスワードは、以前 Portfolio で設定された値に戻ります。以前設定されていない場合は無効になります。"},"CONFIRM_TRUNCATE_VALUES":{"de":"Die max. Länge überschreitet einen oder mehrere standardmäßige oder vordefinierte Werte für dieses Feld. Werte kürzen?","en":"Max Length exceeds one or more default or predefined values for this field. Truncate values?","es":"La longitud máxima supera uno o varios valores predeterminados o predefinidos para este campo. ¿Truncar valores?","fr":"La longueur maximale dépasse une ou plusieurs valeur prédéfinies ou par défaut pour ce champ. Raccourcir les valeurs ?","it":"La lunghezza max supera uno o più valori di default o predefiniti per questo campo. Troncare i valori?","ja":"最大の長さが、デフォルト値か定義済みの値の一つ以上を超えています。値を切り捨てますか？"},"CONNECTION_REFUSED_ERROR":{"de":"Die Verbindung mit dem Verzeichnisservice wurde abgelehnt. Prüfen Sie Hostnamen und Port-Einstellungen.","en":"The connection to the directory service was refused. Please check your hostname and port settings.","es":"Se ha denegado la conexión al servicio de directorios. Compruebe su nombre de host y la configuración del puerto.","fr":"La connexion au service de répertoire a été refusée. Veuillez vérifier votre nom d'hôte et vos paramètres de port.","it":"Collegamento al servizio directory rifiutato. Controllare nome host e impostazioni porta.","ja":"ディレクトリサービスへの接続が拒否されました。 ホスト名とポートの設定を確認してください。"},"CONTAINS":{"de":"enthält","en":"contains","es":"contiene","fr":"contient","it":"contiene","ja":"を含む"},"CONTINUE":{"de":"Weiter","en":"Continue","es":"Continuar","fr":"Continuer","it":"Continua","ja":"続ける"},"CREATE":{"de":"Erstellen","en":"Create","es":"Crear","fr":"Créer","it":"Crea","ja":"作成"},"CREATE_A_CERTIFICATE_REQUEST":{"de":"Zertifikat-Signaturanforderung erstellen","en":"Create a certificate signing request","es":"Crear una solicitud de firma de certificado","fr":"Créer une demande de signature de certificat","it":"Crea una richiesta di firma del certificato","ja":"証明書署名リクエストを作成"},"createContactSheet":{"de":"PDF erstellen","en":"Make PDF","es":"Crear PDF","fr":"Créer un PDF","it":"Crea PDF","ja":"PDF 作成"},"CREATED_BY":{"de":"Erstellt von","en":"Created By","es":"Creado por","fr":"Créé par","it":"Creato da","ja":"作成者"},"CREATE_MAPPING":{"de":"Zuweisung Erstellen","en":"Create Mapping","es":"Crear Correspondencia","fr":"Créer un Mappage","it":"Crea Mappatura","ja":"マッピングを作成"},"CREATE_USER_EXCLUSION_MAPPING":{"de":"Benutzer Ausschließen","en":"Exclude User","es":"Usuario de Exclusión","fr":"Exclure l'Utilisateur","it":"Escludi Utente","ja":"ユーザーを除外"},"CREATED_ON_DATE":{"de":"Erstellungsdatum","en":"Date Created","es":"Fecha de creación","fr":"Date de création","it":"Data di creazione","ja":"作成日"},"DATE_FORMAT":{"de":"DD.MM.YYYY","en":"MM/DD/YYYY","es":"DD/MM/YYYY","fr":"DD-MM-YYYY","it":"DD/MM/YYYY","ja":"YYYY-MM-DD"},"DATE_FORMAT_ERROR":{"de":"Konfigurationsfehler: Falsche Formatierungszeichenfolge.","en":"Configuration error: Incorrect formatting string.","es":"Error de configuración: Cadena de formato incorrecto.","fr":"Erreur de configuration : Mise en forme chaîne incorrecte.","it":"Errore di configurazione; formattazione stringa non corretta.","ja":"設定エラー：不正な形式の文字列です。"},"DATE_INVALID_CHAR_ERROR":{"de":"Das Datum enthält ungültige Zeichen.","en":"The date contains invalid characters.","es":"La fecha contiene caracteres no válidos.","fr":"La date contient des caractères non valides.","it":"La data contiene caratteri non validi.","ja":"使用できない文字が含まれています。"},"DATE_TIME_FORMAT":{"de":"DD.MM.YYYY L:NN A","en":"MM/DD/YYYY L:NN A","es":"DD/MM/YYYY L:NN A","fr":"DD-MM-YYYY L:NN A","it":"DD/MM/YYYY L:NN A","ja":"YYYY-MM-DD L:NN A"},"DATE_TIME_SECONDS_FORMAT":{"de":"DD.MM.YYYY L:NN:SS A","en":"MM/DD/YYYY L:NN:SS A","es":"DD/MM/YYYY L:NN:SS A","fr":"DD-MM-YYYY L:NN:SS A","it":"DD/MM/YYYY L:NN:SS A","ja":"YYYY-MM-DD L:NN:SS A"},"DATE_WRONG_DAY_ERROR":{"de":"Geben Sie einen gültigen Tag für den Monat ein.","en":"Enter a valid day for the month.","es":"Introduzca un día válido para el mes.","fr":"Saisir un jour valide pour le mois.","it":"Immettere un giorno valido per il mese.","ja":"有効な日付を入力してください。"},"DATE_WRONG_LENGTH_ERROR":{"de":"Geben Sie das Datum in diesem Format ein:","en":"Type the date in the format:","es":"Escriba la fecha con el formato:","fr":"Saisir la date au format :","it":"Digitare la data nel formato:","ja":"日付を入力してください。"},"DATE_WRONG_MONTH_ERROR":{"de":"Geben Sie einen Monat zwischen 1 und 12 ein","en":"Enter a month between 1 and 12.","es":"Introduzca un mes entre 1 y 12","fr":"Saisir un mois entre 1 et 12","it":"Inserire un mese tra 1 e 12","ja":"1〜12の月を入力"},"DATE_WRONG_YEAR_ERROR":{"de":"Geben Sie ein Jahr zwischen 0 und 9999 ein","en":"Enter a year between 0 and 9999.","es":"Introduzca un año entre 0 y 9999","fr":"Saisir une année entre 0 et 9999","it":"Inserire un anno tra 0 e 9999","ja":"0〜9999の年を入力"},"DEFAULT_ACCESS_LEVEL":{"de":"Standardrolle","en":"Default Role","es":"Roles predeterminados","fr":"role par défaut","it":"Ruolo predefinito","ja":"デフォルトの役割"},"DEFAULT_CATALOG":{"de":"Standardkatalog","en":"Default Catalog","es":"Catálogo predeterminado","fr":"Catalogue par défaut","it":"Catalogo predefinito","ja":"デフォルトカタログ"},"DEFAULT_CATALOG_NONE":{"de":"Keine","en":"None","es":"Ninguno","fr":"Aucun","it":"Nessuno","ja":"なし"},"DEFAULT_PORT_NON_SSL":{"de":"Standard-Port für Nicht-SSL:","en":"Default port for non-SSL:","es":"Puerto predeterminado para no SSL:","fr":"Port non SSL par défaut:","it":"Porta predefinita per non-SSL:","ja":"非SSL用のデフォルトポート:"},"DEFAULT_PORT_SSL":{"de":"Standard-Port für SSL:","en":"Default port for SSL:","es":"Puerto predeterminado para SSL:","fr":"Port SSL par défaut:","it":"Porta predefinita per SSL:","ja":"SSL用のデフォルトポート:"},"DELETE":{"de":"Löschen","en":"Delete","es":"Eliminar","fr":"Supprimer","it":"Elimina","ja":"削除"},"DELETE_SOURCE":{"de":"Quelle Löschen","en":"Delete Source","es":"Eliminar Fuente","fr":"Supprimer la Source","it":"Elimina Sorgente","ja":"ソースを削除"},"DELETE_ALL_NESTED_VALUES_CONFIRMATION":{"de":"Alle Werte löschen? Dies wird alle Werte löschen, einschließlich verschachtelter Werte.","en":"Delete all values?\nThis will delete all values including nested values.","es":"¿Eliminar todos los valores? Se eliminarán todos los valores incluyendo los valores jerarquizados.","fr":"Supprimer toutes les valeurs? Ceci supprimera toutes les valeurs y compris les valeurs imbriquées.","it":"Cancellare tutti i valori? Ciò cancellerà tutti i valori inclusi i valori nidificati.","ja":"全ての値を削除しますか？ネスト化された値も全て削除されます。"},"DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION":{"de":"Den Wert '{value}' löschen?\nEr enthält verschachtelte Werte, die ebenfalls gelöscht werden.","en":"Delete the value '{value}'?\nIt contains nested values which will also be deleted.","es":"Elimine el valor '{value}'?\n Contiene valores alojados que también se eliminarán.","fr":"Supprimer la valeur '{value}' ?\nIt Contient des valeurs imbriquées qui seront aussi supprimées.","it":"Eliminare il valore '{value}'?\nContiene valori nidificati che saranno cancellati.","ja":"{value}'の値を削除しますか？\nネスト化された値も削除されます。"},"DELETE_NESTED_VALUE_CONFIRMATION":{"de":"Die auswählten Werte löschen? Sie enthalten verschachtelte Werte, die ebenfalls gelöscht werden.","en":"Delete the selected values?\nThey contain nested values which will also be deleted.","es":"¿Eliminar los valores seleccionados? Contienen valores jerarquizados que también se eliminarán.","fr":"Supprimer les valeurs sélectionnées? Elles comportent des valeurs imbriquées qui seront également supprimées.","it":"Cancellare i valori selezionati? Contengono valori nidificati che saranno altresì cancellati.","ja":"選択した値を削除しますか？"},"DELETE_WARNING_BOX_MSG":{"de":"Warnung! Das Löschen kann nicht rückgängig gemacht werden!","en":"Warning! Deleting cannot be undone!","es":"Advertencia! La eliminación no puede deshacerse!","fr":"Attention ! La suppression est irréversible!","it":"Avvertenza! Non sarà possibile annullare l'eliminazione!","ja":"警告 いったん削除を実行すると、操作を取り消すことはできません!"},"DELETE_WARNING_CATALOG_VAULT":{"de":"Alle Dateien im Katalog werden zerstört.","en":"All files in the catalog will be destroyed.","es":"Todos los ficheros en el catálogo serán destruidos.","fr":"Tous les fichiers dans le catalogue seront détruits.","it":"Tutti gli archivi nel catalogo si distruggeranno.","ja":"カタログのすべてのファイルは破壊される。"},"DIAGNOSTIC_DATA_TITLE":{"de":"Diagnosebericht an Portfolio DAM senden","en":"Send Diagnostic Report to Portfolio DAM","es":"Enviar Informe de diagnóstico a Portfolio DAM","fr":"Envoyer le rapport de diagnostic à Portfolio DAM","it":"Invia Report diagnostico a Portfolio DAM","ja":"Portfolio DAMに診断レポートを送信"},"DIAGNOSTIC_DATA_ACCOUNT_NAME":{"de":"Unternehmen oder Kontoname (Erforderlich)","en":"Company or Account Name (Required)","es":"Nombre de Cuenta o Empresa (obligatorio)","fr":"Nom de compte ou d’entreprise (Requis)","it":"Società o Nome Account (Obbligatorio)","ja":"会社名（必須）"},"DIAGNOSTIC_DATA_CONTACT_NAME":{"de":"Name des Kontakts","en":"Contact Name","es":"Nombre de la persona de contacto","fr":"Nom du contact","it":"Nome contatto","ja":"担当者名"},"DIAGNOSTIC_DATA_TS_TICKET_NUMBER":{"de":"Technischer Support Ticket Nummer","en":"Tech Support Ticket Number","es":"Número de identificador de Soporte técnico","fr":"Numéro de ticket d’assistance technique","it":"Numero ticket assistenza tecnica","ja":"テクニカルサポートチケット番号"},"DIAGNOSTIC_DATA_SEND_REPORT_BUTTON":{"de":"Sende Bericht","en":"Send Report","es":"Enviar Informe","fr":"Envoyer rapport","it":"Invia report","ja":"レポートを送信"},"DIAGNOSTIC_STATUS_ERROR":{"de":"Es gab ein Problem beim Hochladen des Diagnoseberichtes auf {date}","en":"There was a problem uploading the diagnostic report on {date}","es":"Se ha producido un problema al cargar el informe de diagnóstico el {date}","fr":"Problème lors du chargement du rapport de diagnosticle {date}","it":"Si è verificato un problema durante il caricamento del report diagnostico {date}","ja":"{date} の診断レポートをアップロード中に問題が発生しました。"},"DIAGNOSTIC_STATUS_SENDING":{"de":"Senden...","en":"Sending...","es":"Enviando...","fr":"Envoi en cours...","it":"Invio in corso...","ja":"発送..."},"DIAGNOSTIC_STATUS_SUCCESS":{"de":"Der Diagnosebericht wurde erfolgreich an Portfolio DAM auf {date} gesandt","en":"Diagnostic report successfully sent to Portfolio DAM on {date}","es":"Se ha enviado informe de diagnóstico de forma satisfactoria a Portfolio DAM el {date}","fr":"Envoi réussi du rapport de diagnostic à Portfolio DAM le {date}","it":"Report diagnostico inviato con successo a Portfolio DAM il {date}","ja":"{date} にPortfolio DAMへ正しく送信された診断レポート"},"DIRECTORY_SERVICE_CONNECT_ERROR":{"de":"Die Verbindung mit dem Verzeichnisservice konnte nicht hergestellt werden. Prüfen Sie Hostnamen und Port-Einstellungen.","en":"Unable to connect to the directory service. Please check the hostname and port settings.","es":"Imposible conectar con el servicio de directorios. Compruebe el nombre de host y la configuración del puerto.","fr":"Impossible de se connecter au service de répertoire. Veuillez vérifier le nom d'hôte et les paramètres de port.","it":"Impossibile collegarsi al servizio directory. Controllare nome host e impostazioni porta.","ja":"ディレクトリサービスに接続できません。 ホスト名とポートの設定を確認してください。"},"DIRECTORY_SERVICES":{"de":"Verzeichnisdienst","en":"Directory Services","es":"Servicios de directorio","fr":"Services d'annuaire","it":"Servizi Directory","ja":"ディレクトリサービス"},"DIRECTORY_USERS_CANNOT_BE_DELETED":{"de":"Benutzer des Verzeichnisdienstes können nicht gelöscht werden.","en":"Directory Service users cannot be deleted!","es":"No es posible eliminar usuarios de servicio de directorios.","fr":"Les utilisateurs du service d'annuaire ne peuvent pas être supprimés !","it":"Gli utenti di Servizi Directory non possono essere eliminati!","ja":"ディレクトリサービスのユーザーは削除できません。"},"DISTRIBUTION_GROUPS":{"de":"Distributionsgruppen","en":"Distribution Groups","es":"Grupos de distribución","fr":"Groupes de distribution","it":"Gruppi di distribuzione","ja":"配布グループ"},"DOWNLOAD_CERT_PROMPT":{"de":"Zertifikatanforderungsdatei herunterladen?","en":"Download certificate request file?","es":"¿Descargar archivo de solicitud de certificado?","fr":"Télécharger le fichier de demande de certificat ?","it":"Scaricare il file di richiesta del certificato?","ja":"証明書リクエストファイルをダウンロードしますか？"},"DOWNLOAD_COMPLETE_STRING":{"de":"Download abgeschlossen.","en":"Download complete.","es":"Descarga completa.","fr":"Fin du téléchargement.","it":"Download completato.","ja":"ダウンロード完了"},"downloadPreviews":{"de":"Vorschaubilder herunterladen","en":"Download Previews","es":"Descargar vistas previas","fr":"Télécharger les aperçus","it":"Scarica anteprime","ja":"プレビューをダウンロード"},"EMAIL_ADDRESS":{"de":"E-Mail-Adresse","en":"Email Address","es":"Dirección de correo electrónico","fr":"Adresse email","it":"Indirizzo e-mail","ja":"電子メールアドレス"},"EMAIL_CONFIG_AUTH_PASSWORD":{"de":"Kennwort","en":"Password","es":"Contraseña","fr":"Mot de passe","it":"Password","ja":"パスワード"},"EMAIL_CONFIG_AUTH_USERNAME":{"de":"Benutzername","en":"User Name","es":"Nombre de usuario","fr":"Nom d'utilisateur","it":"Nome utente","ja":"ユーザー名"},"EMAIL_CONFIG_ENABLED":{"de":"E-Mail-Feedback aktivieren","en":"Enable Email Notifications","es":"Habilitar notificaciones de correo electrónico","fr":"Activer les notifications par courriel","it":"Abilita notifiche via e-mail","ja":"Email通知を有効化"},"EMAIL_CONFIG_FROM_ADDRESS":{"de":"E-Mail von Adresse","en":"Email From Address","es":"Correo electrónico desde dirección","fr":"Adresse de l'émetteur du courriel","it":"E-mail da indirizzo","ja":"差出人Emailアドレス"},"EMAIL_CONFIG_INVALID_GENERIC":{"de":"E-Mail Server-Konfiguration ist ungültig","en":"Email Server Configuration Invalid","es":"Configuración de servidor de correo electrónico no válida","fr":"Configuration du serveur de messagerie non valide","it":"Configurazione Server E-mail non valida","ja":"Emailサーバーの設定が無効です"},"EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND":{"de":"E-Mail Server nicht gefunden","en":"Email Server Not Found","es":"Servidor de correo electrónico no encontrado","fr":"Serveur de messagerie non trouvé","it":"Server e-mail non trovato","ja":"Emailサーバーが見つかりません"},"EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED":{"de":"E-Mail Server Authentifizierung fehlgeschlagen","en":"Email Server Authentication Failed","es":"Fallo de autenticación del servidor de correo electrónico","fr":"Échec de l'authentification du serveur de messagerie","it":"Autenticazione Server E-mail non riuscita","ja":"Emailサーバーの認証に失敗しました"},"EMAIL_CONFIG_MESSAGE":{"de":"Jeder Benutzer, der Benachrichtigungen erhalten möchte, muss im Benutzerbereich eine E-Mail-Adresse zugeordnet bekommen.","en":"Each user who wishes to receive notifications must have an email address assigned in the Users pane.","es":"Cada usuario que desee recibir notificaciones debe tener una dirección de correo electrónico asignada en el panel de usuarios.","fr":"Tout utilisateur souhaitant recevoir des notifications doit disposer d'une adresse de courriel affectée dans le volet Utilisateurs.","it":"Ogni utente che desidera ricevere notifiche deve avare un indirizzo e-mail assegnato nel pannello Utenti.","ja":"通知を受け取りたいユーザーのEmailアドレスをユーザーパネルで設定してください。"},"EMAIL_CONFIG_SERVER_ADDRESS":{"de":"SMTP Server Adresse","en":"SMTP Server Address","es":"Dirección del servidor SMTP","fr":"Adresse du serveur SMTP","it":"Indirizzo Server SMTP","ja":"SMTPサーバーアドレス"},"EMAIL_CONFIG_SERVER_PORT":{"de":"SMTP Server Port","en":"SMTP Server Port","es":"Puerto del servidor SMTP","fr":"Port serveur SMTP","it":"Porta Server SMTP","ja":"SMTPサーバーポート"},"EMAIL_CONFIG_SUCCESS_MESSAGE":{"de":"SMTP Server verifiziert","en":"SMTP Server Validated","es":"Servidor SMTP validado","fr":"Serveur SMTP validé","it":"Server SMTP validato","ja":"SMTPサーバーが有効です"},"EMAIL_CONFIG_USE_SSL_TLS":{"de":"Verwende SSL / TLS","en":"Use SSL / TLS","es":"Utilizar SSL/TLS","fr":"Utiliser SSL / TLS","it":"Utilizzare SSL / TLS","ja":"SSL/TLSを使用"},"EMAIL_CONFIG_USE_SMTP_AUTH":{"de":"Verwende SMTP Authentifizierung","en":"Use SMTP Authentication","es":"Utilizar autenticación SMTP","fr":"Utiliser l'authentification SMTP","it":"Utilizzare autenticazione SMTP","ja":"SMTP認証を使用"},"EMAIL_CONFIG_VALIDATE":{"de":"Verbindung testen","en":"Test Connection","es":"Prueba de conexión","fr":"Test de connexion","it":"Connessione di prova","ja":"接続テスト"},"EMAIL_CONFIG_VALIDATED":{"de":"E-Mail Server verifiziert","en":"Email Server Validated","es":"Servidor de correo electrónico validado","fr":"Serveur de messagerie validé","it":"Server e-mail validato","ja":"Emailサーバーが有効です"},"english":{"de":"Englisch","en":"English","es":"Inglés","fr":"Anglais","it":"Inglese","ja":"英語"},"ENTIRE_TREE_UNDER_SEARCH_BASE":{"de":"Gesamter Verzeichnisbaum unter Suchbasis","en":"Entire tree","es":"Árbol completo bajo base de búsqueda","fr":"Arborescence entière sous la base de recherche","it":"Intera struttura sotto Ricerca Base","ja":"検索ベース内のツリー全体"},"EQUALS":{"de":"ist gleich","en":"equals","es":"es igual a","fr":"égal à","it":"uguale","ja":"等しい"},"EXPORT_MENU_STRING":{"de":"Werte exportieren","en":"Export Values","es":"Exportar valores","fr":"Exporter des valeurs","it":"Esporta valori","ja":"値の書き出し"},"FADEL_HOWTO":{"de":"LOGON zu Ihrem FADEL Konto:","en":"Login to your FADEL account:","es":"Conexión a su cuenta de FADEL:","fr":"Procédure de connexion à votre compte de FADEL :","it":"Collegamento al vostro cliente di FADEL:","ja":"FADELのアカウントへのログイン:"},"FALSE_LABEL":{"de":"Falsch","en":"False","es":"Falso","fr":"Faux","it":"Falso","ja":"偽の"},"FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR":{"de":"Stellen Sie sicher, dass der Admin-Server auf dem lokalen Rechner läuft und den auf der Port-Seite angegebenen Port verwendet. Sollte dies nicht der Fall sein, muss der Server erneut gestartet und diese Anwendung noch einmal geladen werden.","en":"Please check that the admin server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload this application.","es":"Compruebe que se está ejecutando el servidor de administración en el equipo local en el puerto indicado en la página de puertos. Si no es así, reinicie el servidor y vuelva a cargar esta aplicación.","fr":"Assurez-vous que le serveur d'administration est en cours d'exécution sur votre ordinateur local, avec le numéro de port inscrit sur la page des ports. Si ce n'est pas le cas, redémarrez le serveur et relancez l'application.","it":"Verificare che il server di amministrazione sia in funzione nella macchina locale sulla porta indicata nella relativa pagina. Diversamente, riavviare il server e ricaricare questa applicazione.","ja":"管理サーバーがローカルコンピュータ上で動作しており、ポートページで表示されているポートを使っていることを確認してください。 そのようになっていない場合は、サーバーを再起動し、このアプリケーションを再び読み込んでください。"},"FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS":{"de":"Während ein Datensicherungs- oder -wiederherstellungsprozess läuft, kann dieser Vorgang nicht durchgeführt werden.","en":"This operation cannot be performed while a backup or restore is in progress.","es":"No se puede realizar esta operación mientras la copia de seguridad o restauración está en progreso.","fr":"Cette opération ne peut pas être effectuée alors que la sauvegarde ou la restauration est en cours.","it":"Questa operazione non può essere eseguita mentre è in corso il backup o il ripristino.","ja":"この処理は、バックアップ中もしくは復元中には行えません。"},"FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE":{"de":"Bei diesem Vorgang ist ein Fehler aufgetreten, da sich der Katalog im Verwaltungsmodus befindet.","en":"That operation failed because the catalog is in admin mode.","es":"La operación no ha funcionado porque el catálogo está en modo de administración.","fr":"L'opération a échoué car le catalogue est en mode administrateur.","it":"Operazione non riuscita poiché il catalogo è in modalità amministrazione.","ja":"カタログが管理者モードになっているため、この操作を行うことができません。"},"FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME":{"de":"Ein Katalog mit diesem Namen ist bereits vorhanden.","en":"A catalog already exists with this name.","es":"Ya existe un catálogo con ese nombre.","fr":"Un catalogue existe déjà sous ce nom.","it":"Esiste già un catalogo con questo nome.","ja":"この名前のカタログはすでに存在します。"},"FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME":{"de":"Ein Benutzer mit diesem Kontonamen ist bereits vorhanden.","en":"A user already exists with this account name.","es":"Ya existe un usuario con este nombre de cuenta.","fr":"Un utilisateur utilise déjà ce nom de compte.","it":"Esiste già un utente con questo nome account.","ja":"このアカウント名のユーザーはすでに存在しています。"},"FAULT_MSG_DB_IN_USE":{"de":"Der Vorgang konnte nicht abgeschlossen werden, da der Katalog derzeit von einem Administrator verwendet wird.","en":"The operation could not be completed because the catalog is currently in use by an administrator.","es":"No ha sido posible realizar la operación porque el catálogo está en uso por parte de un administrador.","fr":"L'opération n'a pu se terminer car un administrateur est en train d'utiliser le catalogue.","it":"Impossibile completare l'operazione perché il catalogo è attualmente in uso da parte di un amministratore.","ja":"現在、管理者がカタログを使用しているため、この操作を完了することができません。"},"FAULT_MSG_DELETE_ADMIN":{"de":"Sie können das Administratorkonto nicht löschen.","en":"You cannot delete the administrator account.","es":"No puede borrar la cuenta del administrador.","fr":"Vous ne pouvez pas supprimer le compte de l'administrateur.","it":"Impossibile eliminare l'account dell'amministratore.","ja":"管理者アカウントを削除することはできません。"},"FAULT_MSG_DELETE_SELF":{"de":"Sie können Ihr Benutzerkonto nicht löschen.","en":"You cannot delete your user account.","es":"No puede eliminar su cuenta de usuario.","fr":"Vous ne pouvez pas supprimer votre compte utilisateur.","it":"Impossibile eliminare l'account utente.","ja":"自分のユーザーアカウントを削除することはできません。"},"FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR":{"de":"Während des Löschens der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.","en":"An unexpected error occurred when deleting the catalog template.","es":"Se ha producido un error inesperado al eliminar la plantilla de catálogo","fr":"Une erreur inattendue s'est produite lors de la suppression du modèle du catalogue","it":"Si è verificato un errore imprevisto durante la cancellazione del modello di catalogo","ja":"カタログテンプレートの削除に予期しないエラーが発生しました。"},"FAULT_MSG_DUPE_NAME":{"de":"Ein Objekt mit diesem Namen ist bereits vorhanden. Bitte geben Sie einen anderen Namen ein.","en":"An object with that name already exists.  Please use another name.","es":"Ya existe un objeto con ese nombre. Utilice un nombre distinto.","fr":"Un objet existe déjà sous ce nom. Veuillez utiliser un autre nom.","it":"Esiste già un oggetto con questo nome. Utilizzare un altro nome.","ja":"この名前のオブジェクトはすでに存在します。 他の名前を使ってください。"},"FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS":{"de":"Eine Media Engine mit dieser Adresse und diesem Port ist bereits vorhanden.","en":"There is already a Media Engine with that address and port.","es":"Ya existe un motor de medios con esa dirección y puerto.","fr":"Un Media Engine existe déjà sous cette adresse et ce numéro de port.","it":"Esiste già un Media Engine con questo indirizzo e questa porta.","ja":"このアドレスとポート番号を使っている Media Engine はすでに存在します。"},"FAULT_MSG_ENTITY_VERSION_MISMATCH":{"de":" Bei diesem Vorgang ist ein Fehler aufgetreten, da die Kundendaten nicht mehr aktuell sind.","en":"That operation failed because the client's information was out of date.","es":" No ha funcionado esa operación porque los datos del cliente estaban desfasados.","fr":" L'opération a échoué car les informations du client n'étaient plus à jour.","it":" Operazione non riuscita poiché le informazioni client erano scadute.","ja":" クライアント情報が古いため、この操作を行うことができません。"},"FAULT_MSG_IDENT_SERVICE_CREATION_ERROR":{"de":"Stellen Sie sicher, dass der Server auf dem lokalen Rechner läuft und den auf der Port-Seite angegebenen Port verwendet. Sollte dies nicht der Fall sein, muss der Server erneut gestartet und die Anwendung noch einmal geladen werden.","en":"Please check that the server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload the application.","es":"Compruebe que se está ejecutando el servidor en el equipo local en el puerto indicado en la página de puertos. Si no es así, reinicie el servidor y vuelva a cargar la aplicación.","fr":"Assurez-vous que le serveur est en cours d'exécution sur votre ordinateur local, avec le numéro de port inscrit sur la page des ports. Si ce n'est pas le cas, redémarrez le serveur et relancez l'application.","it":"Verificare che il server sia in funzione nella macchina locale sulla porta indicata nella relativa pagina. Diversamente, riavviare il server e ricaricare l'applicazione.","ja":"サーバーがローカルコンピュータ上で動作しており、ポートページで表示されているポートを使っていることを確認してください。 そのようになっていない場合は、サーバーを再起動し、このアプリケーションを再び読み込んでください。"},"FAULT_MSG_INVALID_SESSION_ID":{"de":"Ihre Sitzung ist abgelaufen. Sie müssen sich erneut beim Server anmelden.","en":"Your session has expired. You must log into the server again.","es":"Ha caducado su sesión. Necesita volver a iniciar sesión en el servidor.","fr":"Votre session a expiré. Vous devez vous connecter une nouvelle fois au serveur.","it":"Sessione scaduta. È necessario accedere di nuovo al server.","ja":"セッションが時間切れになりました。 もう一度サーバーにログインしてください。"},"FAULT_MSG_IS_NOT_LICENSED":{"de":"Für diesen Vorgang besitzt der Server keine Lizenz.","en":"Server not licensed for that operation.","es":"El servidor no tiene licencia para esa operación.","fr":"Le serveur n'est pas autorisé à effectuer cette opération.","it":"Server non licenziato per tale operazione.","ja":"この操作を行うのに必要なライセンスがサーバーにありません。"},"FAULT_MSG_LEGACY_21000":{"de":"Dieser Vorgang ist aufgrund eines unbekannten internen Fehlers fehlgeschlagen.","en":"The operation failed because of an unknown internal error.","es":"Ha fallado la operación debido a un error interno desconocido.","fr":"L'opération a échoué suite à une erreur interne.","it":"Operazione non riuscita a causa di un errore interno sconosciuto.","ja":"不明な内部エラーが発生したため、この操作に失敗しました。"},"FAULT_MSG_LOGGING_ERR_UPDATE":{"de":"Bei der Aktualisierung der Protokoll-Konfiguration ist ein Fehler aufgetreten","en":"There has been an error updating the logging configuration","es":"Ha surgido un error al actualizar la configuración de registro","fr":"Une erreur s'est produite lors de la mise à jour de la configuration de la journalisation","it":"Si è verificato un errore nell'aggiornamento della configurazione di log","ja":"ログ設定の更新時にエラーが発生しました"},"FAULT_MSG_LOG_DIR_NOT_VALID":{"de":"Das angegebene Log-Verzeichnis existiert nicht, das Schreiben in diesem Verzeichnis ist nicht möglich oder der Pfad ist kein Verzeichnis.","en":"The specified log directory does not exist, is not writeable or the path specified is not a directory.","es":"El directorio de registro especificado no existe, no se puede escribir en él, o la ruta no dirige a un directorio.","fr":"Le répertoire du journal spécifié n'existe pas, n'est pas inscriptible, ou le chemin spécifié n'est pas un répertoire.","it":"Le directory di log specificata non esiste, non è scrivibile oppure il percorso specificato non è una directory.","ja":"指定されたログディレクトリは存在しないか、指定されたパスはディレクトリではありません。"},"FAULT_MSG_NO_DIRECTORY":{"de":"Der angegebene Ort ist nicht vorhanden bzw. ist kein Verzeichnis.","en":"The specified location does not exist or it is not a directory.","es":"No existe la ubicación especificada o no es un directorio.","fr":"L’emplacement indiqué n’existe pas ou ne se trouve pas dans un répertoire.","it":"La posizione specificata non esiste o non è una directory.","ja":"指定された場所は存在しないか、ディレクトリではありません。"},"FAULT_MSG_NULL_DESCRIPTION":{"de":"Ein unerwarteter Fehler ist aufgetreten; eine Beschreibung ist jedoch nicht vorhanden.","en":"An unexpected error occurred, but there is no description to report.","es":"Se ha producido un error inesperado, pero no hay ninguna descripción al respecto.","fr":"Une erreur inattendue est survenue, mais aucune description n'est disponible.","it":"Si è verificato un errore imprevisto, ma non esiste alcuna descrizione per il report.","ja":"予期しないエラーが発生しましたが、内容は不明です。"},"FAULT_MSG_NULL_FAULTEVENT":{"de":"Ein unerwarteter Fehler ist aufgetreten; Details sind jedoch nicht vorhanden.","en":"An unexpected error occurred, but there are no details to report.","es":"Se ha producido un error inesperado, pero no hay detalles al respecto.","fr":"Une erreur inattendue est survenue, mais aucun détail n'est disponible.","it":"Si è verificato un errore imprevisto, ma non esiste alcun dettaglio per il report.","ja":"予期しないエラーが発生しましたが、詳細は不明です。"},"FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES":{"de":"Bei diesem Vorgang ist ein Fehler aufgetreten, da Sie unzureichende Berechtigungen haben.","en":"That operation failed because you do not have sufficient privileges.","es":"No ha funcionado esa operación porque usted no tiene suficientes privilegios.","fr":"L'opération a échoué car vous ne disposez pas des autorisations nécessaires.","it":"Operazione non riuscita poiché non si dispone dei privilegi sufficienti.","ja":"十分なアクセス権がないため、この操作を行うことができません。"},"FAULT_MSG_OPERATION_IS_INVALID":{"de":"Dieser Vorgang war ungültig.","en":"That operation was not valid.","es":"Esa operación no era válida.","fr":"L'opération n'était pas valide.","it":"Operazione non valida.","ja":"不正な操作です。"},"FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR":{"de":"Während der Umbenennung der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.","en":"An unexpected error occurred when renaming the catalog template.","es":"Se ha producido un error inesperado al dar nuevo nombre a la plantilla de catálogo","fr":"Une erreur inattendue s'est produite lors du renommage du modèle du catalogue","it":"Si è verificato un errore imprevisto durante la ridenominazione del modello di catalogo","ja":"カタログテンプレート名の変更に予期しないエラーが発生しました。"},"FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR":{"de":"Während der Speicherung der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.","en":"An unexpected error occurred when saving the catalog template.","es":"Se ha producido un error inesperado al guardar la plantilla de catálogo","fr":"Une erreur inattendue s'est produite lors de la sauvegarde du modèle du catalogue","it":"Si è verificato un errore imprevisto durante il salvataggio del modello di catalogo","ja":"カタログテンプレートの保存に予期しないエラーが発生しました。"},"FAULT_MSG_SERVER_NOT_RUNNING":{"de":"Der Server läuft nicht.","en":"The server is not running.","es":"El servidor no se está ejecutando.","fr":"Le serveur n’est pas actif.","it":"Server non in funzione.","ja":"サーバーが動作していません。"},"FAULT_MSG_ENTERPRISE_NOT_LICENSED":{"de":"Bei diesem Vorgang trat ein Fehler auf, da der Server keine Enterprise Modul-Lizenz besitzt.","en":"The operation failed because the server does not have an Enterprise Module license.","es":"Ha fallado la operación porque el servidor no tiene una licencia del módulo para empresas.","fr":"L'opération a échoué car le serveur n'a pas de licence pour le module Entreprise.","it":"Operazione non riuscita poiché il server non ha una licenza Enterprise Module.","ja":"Enterprise Module ライセンスが見つからないため処理に失敗。"},"FAULT_MSG_REMOVE_METADATA_DEF":{"de":"Die Metadaten-Definition konnte nicht entfernt werden. Möglicherweise wird sie von anderen Katalogen genutzt.","en":"Removing the metadata definition failed.  It may be in use by other catalogs.","es":"Error en la eliminación de la definición de metadatos. Puede estar en uso por otros catálogos.","fr":"La suppression de la définition des métadonnées a échoué. Elle peut être utilisée par d’autres catalogues.","it":"Rimozione definizione metadata non riuscita. Può essere in uso da altri cataloghi.","ja":"メタデータの定義の削除に失敗しました。他のカタログで使用中の可能性があります。"},"FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT":{"de":"Der Server hat einen Fehler mit der folgenden Meldung ausgegeben: ","en":"The server returned a fault with this message:","es":"El servidor ha devuelto un error con este mensaje: ","fr":"Le serveur a renvoyé une faute avec ce message : ","it":"Il server ha restituito un errore con questo messaggio: ","ja":"サーバーがエラーを返しました。メッセージ内容:"},"FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE":{"de":"Der Server hat einen Fehler ohne Fehlermeldung ausgegeben. ","en":"The server returned a fault with no error message.","es":"El servidor ha devuelto un error sin mensaje. ","fr":"Le serveur a renvoyé une faute sans message d'erreur. ","it":"Il server ha restituito un errore senza messaggi di errore: ","ja":"サーバーがエラーを返しました。エラーメッセージはありません。"},"FAULT_MSG_UNHANDLED_UNKNOWN_FAULT":{"de":"Der Server hat einen Fehler unbekannter Art mit der folgenden Meldung ausgegeben:","en":"The server returned a fault with an unknown type and this message:","es":"El servidor ha devuelto un error de tipo desconocido y este mensaje:","fr":"Le serveur a renvoyé une faute à cause d'un type inconnu avec ce message :","it":"Il server ha restituito un errore di tipo sconosciuto con il seguente messaggio:","ja":"サーバーが不明な種類のエラーを返しました。メッセージ内容:"},"FAULT_MSG_UNKNOWN_SMTP_SERVER":{"de":"Verbindung mit dem angegebenen E-Mail Server nicht möglich.","en":"Unable to connect to the specified mail server.","es":"No se pudo conectar al servidor de correo electrónico especificado.","fr":"Impossible de se connecter au serveur de messagerie spécifié.","it":"Impossibile collegarsi al server di posta specificato.","ja":"指定されたEmailサーバーに接続できません。"},"FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING":{"de":"Bei diesem Vorgang ist ein Fehler aufgetreten, da sich ein Dienst nicht im erwarteten Zustand befand.","en":"That operation failed because a service was not in the expected state.","es":"No ha funcionado esa operación porque uno de los servicios no tenía el estado esperado.","fr":"Cette opération a échoué car un des services n'avait pas l'état attendu.","it":"Operazione non riuscita poiché un servizio non era nello stato previsto.","ja":"サービスが、なっているはずの状態にないため、この操作を行うことができません。"},"FAULT_MSG_INVALID_LOGINID_OR_PASSWORD":{"de":"Benutzername oder Passwort ist für diese Datenbank ungültig.","en":"The username or password supplied for the database is not valid.","es":"El nombre de usuario o la contraseña que se han indicado no son válidos para la base de datos.","fr":"Le nom d'utilisateur ou le mot de passe indiqué pour la base de données n’est pas valide.","it":"Il nome utente o la password indicati per il database non sono validi.","ja":"データベースに提供されたユーザ名またはパスワードは無効です。"},"FAULT_MSG_BAD_DB_PORT":{"de":"Angegebener Datenbank-Anschluss ist ungültig.","en":"The database port specified is not valid.","es":"El puerto de base de datos que se ha especificado no es válido.","fr":"Le port de la base de données indiqué n’est pas valide.","it":"La porta del database specificata non è valida.","ja":"データベースのポートは無効です。"},"FAULT_MSG_BAD_DB_HOST":{"de":"Angegebener Datenbank-Hostname oder Anschluss ist ungültig.","en":"The database hostname or port specified is invalid.","es":"El nombre de host o el puerto especificado para la base de datos no son válidos.","fr":"Le nom d’hôte de la base de données ou le port indiqué n’est pas valide.","it":"Il nome host del database o la porta specificata non sono validi.","ja":"データベースのホスト名またはポートの設定が無効です。"},"FIELD_ACTION_ADD":{"de":"Neues benutzerdefiniertes Feld hinzufügen","en":"Add New Custom Field","es":"Agregar nuevo campo personalizado","fr":"Ajouter un nouveau champ personnalisé","it":"Aggiungi nuovo campo personalizzato","ja":"新しいカスタムフィールドを追加"},"FIELD_ACTION_DELETE":{"de":"Markiertes Feld löschen","en":"Delete Selected Field","es":"Eliminar campo seleccionado","fr":"Supprimer le champ sélectionné","it":"Elimina campo selezionato","ja":"選択したフィールドを削除"},"FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES":{"de":"XMP-Namespaces","en":"XMP Namespaces","es":"Espacios de nombre XMP","fr":"Espaces de noms XMP","it":"Spazio nomi XMP","ja":"XMP名前スペース"},"FIELD_ACTION_MANAGE_METADATA":{"de":"Metadaten verwalten","en":"Manage Metadata","es":"Administrar metadatos","fr":"Gérer les métadonnées","it":"Gestisci metadata","ja":"メタデータの管理"},"FIELD_CATEGORY_CUSTOM":{"de":"Benutzerdefinierte Felder","en":"Custom Fields","es":"Campos personalizados","fr":"Champs personnalisés","it":"Campi personalizzati","ja":"カスタムフィールド"},"FIELD_CATEGORY_SYSTEM":{"de":"Systemfelder","en":"System Fields","es":"Campos del sistema","fr":"Champs système","it":"Campi sistema","ja":"システムフィールド"},"FIELD_CATEGORY_EXIF":{"de":"EXIF","en":"EXIF","es":"EXIF","fr":"EXIF","it":"EXIF","ja":"EXIF"},"FIELD_CATEGORY_IPTC":{"de":"IPTC","en":"IPTC","es":"IPTC","fr":"IPTC","it":"IPTC","ja":"IPTC"},"FIELD_CATEGORY_XMP":{"de":"XMP","en":"XMP","es":"XMP","fr":"XMP","it":"XMP","ja":"XMP"},"FIELD_CATEGORY_MOVIE":{"de":"Film","en":"Movie","es":"Película","fr":"Film","it":"Filmato","ja":"ムービー"},"FIELD_CATEGORY_OFFICE":{"de":"MS Office","en":"MS Office","es":"MS Office","fr":"MS Office","it":"MS Office","ja":"MS Office"},"FIELD_CATEGORY_GEO":{"de":"GEO","en":"GEO","es":"GEO","fr":"GEO","it":"GEO","ja":"GEO"},"FIELD_CATEGORY_LABEL":{"de":"Feldkategorie","en":"Field Category","es":"Categoría de campo","fr":"Catégorie de champ","it":"Categoria campo","ja":"フィールドカテゴリー"},"FIELD_DISABLE_CONFIRM_MSG":{"en":"Do you want to disable the selected field?","de":"Möchten Sie das ausgewählte Feld deaktivieren?","es":"¿Desea deshabilitar el campo seleccionado?","fr":"Voulez-vous désactiver le champ sélectionné?","it":"Vuoi disabilitare il campo selezionato?","ja":"選択したフィールドを無効にしますか？"},"FIELD_ENABLE_ALL_CATEGORIES_LABEL":{"de":"Alle aktivieren","en":"Enable All","es":"Habilitar todos","fr":"Activer tout","it":"Abilita tutto","ja":"すべて許可"},"FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING":{"de":"Extraktionszuordnung hinzufügen","en":"Add Extract Mapping","es":"Añadir mapa de extracción","fr":"Ajouter le mappage de l’extrait","it":"Aggiungi Estrai mappatura","ja":"抽出マッピングを追加"},"FIELD_FORM_LABEL_DEFAULT_VALUE":{"de":"Standardwert","en":"Default Value","es":"Valor predeterminado","fr":"Valeur par défaut","it":"Valore predefinito","ja":"デフォルト値"},"FIELD_FORM_LABEL_DISABLED":{"de":"(Deaktiviert)","en":"(Disabled)","es":"(Deshabilitado)","fr":"(Désactivé)","it":"(Disabilitato)","ja":"（禁止）"},"FIELD_FORM_LABEL_EMBED":{"de":"In Metadaten einbetten","en":"Embed in Metadata","es":"Integrar en Metadatos","fr":"Incorporer aux métadonnées","it":"Nascondi metadata","ja":"メタデータの埋め込み"},"FIELD_FORM_LABEL_EXTRACT":{"de":"Aus Metadaten extrahieren","en":"Extract from Metadata","es":"Extraer de Metadatos","fr":"Extraire des métadonnées","it":"Estrai da metadata","ja":"メタデータの抽出"},"FIELD_FORM_LABEL_FIELD_NAME":{"de":"Feldname","en":"Field Name","es":"Nombre del campo","fr":"Nom du champ","it":"Nome campo","ja":"フィールド名"},"FIELD_FORM_LABEL_FIELD_TYPE":{"de":"Feldtyp","en":"Field Type","es":"Tipo de campo","fr":"Type du champ","it":"Tipo campo","ja":"フィールドタイプ"},"FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES":{"de":"Mehrere Werte zulassen","en":"Allow Multiple Values","es":"Permitir múltiples valores","fr":"Autoriser plusieurs valeurs","it":"Consenti più valori","ja":"複数の値を許可"},"FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES":{"de":"Hat vordefinierte Werte","en":"Has Predefined Values","es":"Tiene valores predefinidos","fr":"Contient des valeurs prédéfinies","it":"Ha valori predefiniti","ja":"定義済みの値を保持"},"FIELD_FORM_LABEL_HELP_TEXT":{"de":"Hilfetext","en":"Help Text","es":"Texto de ayuda","fr":"Texte d’aide","it":"Testo guida","ja":"ヘルプテキスト"},"FIELD_FORM_LABEL_MAX":{"de":"Max: {max}","en":"Max: {max}","es":"Máx: {max}","fr":"Max : {max}","it":"Max: {max}","ja":"最大：{max}"},"FIELD_FORM_LABEL_MAX_LENGTH":{"de":"Max. Länge","en":"Max Length","es":"Longitud máxima","fr":"Longueur max.","it":"Lunghezza max","ja":"最大の長さ"},"FIELD_FORM_LABEL_METADATA_TAG":{"de":"Metadaten-Name","en":"Metadata Name","es":"Nombre de metadatos","fr":"Nom de métadonnées","it":"Nome metadati","ja":"メタデータ名"},"FIELD_FORM_LABEL_METADATA_TYPE":{"de":"Metadaten-Typ","en":"Metadata Type","es":"Tipo de metadatos","fr":"Type de métadonnées","it":"Tipo metadati","ja":"メタデータタイプ"},"FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES":{"de":"Nur vordefinierte Werte zulassen","en":"Allow Only Predefined Values","es":"Permitir sólo valores predefinidos","fr":"Autoriser seulement les valeurs prédéfinies","it":"Consenti solo valori predefiniti","ja":"定義済みの値のみ許可"},"FIELD_FORM_LABEL_PRECISION":{"de":"Präzision","en":"Precision","es":"Precisión","fr":"Précision","it":"Precisione","ja":"精度"},"FIELD_FORM_LABEL_PREDEFINED_VALUES":{"de":"Vordefinierte Werte","en":"Predefined Values","es":"Valores predefinidos","fr":"Valeurs prédéfinies","it":"Valori predefiniti","ja":"定義済みの値"},"FIELD_FORM_LABEL_SHOW_TIME":{"de":"Showtime","en":"Show Time","es":"Mostrar hora","fr":"Afficher l’heure","it":"Mostra ora","ja":"時刻の表示"},"FIELD_FORM_LABEL_USE_METADATA":{"de":"Metadaten extrahieren und einbetten","en":"Extract and Embed Metadata","es":"Extraer y asignar metadatos","fr":"Extraire et incorporer des Métadonnées","it":"Estrarre e incorporare metadati","ja":"メタデータの抽出と埋め込み"},"FIELD_FORM_WARNING_DUPE_EMBEDS":{"de":"Warnung: Es wird mehr als ein Feld in '{metadata}' eingebettet","en":"Warning: More than one field embeds to '{metadata}'","es":"Advertencia: Más de un campo se integra en '{metadata}'","fr":"Avertissement : Plus d’un champ est intégré dans '{metadata}'","it":"Avviso: Più di un campo si incorpora su '{metadata}'","ja":"警告：複数のフィールドが '{metadata}' に埋め込まれます"},"FIELD_METADATA_DATA_TYPE_LABEL":{"de":"Datentyp","en":"Data Type","es":"Tipo de datos","fr":"Type de données","it":"Tipo dati","ja":"データの種類"},"FIELD_METADATA_DEFINITION_IS_CUSTOM":{"de":"Ist benutzerdefiniert","en":"Is Custom","es":"Está personalizado","fr":"est personnalisé","it":"È personalizzato","ja":"カスタム"},"FIELD_METADATA_DEFINITIONS_TITLE":{"de":"Metadaten-Definitionen","en":"Metadata Definitions","es":"Definiciones de metadatos","fr":"Définitions des métadonnées","it":"Definizioni metadati","ja":"メタデータの定義"},"FIELD_METADATA_DELETE_CONFIRM_MSG":{"de":"Bestätigen: Metadaten-Definition löschen?","en":"Confirm: Delete the Metadata Definition?","es":"Confirmar: ¿Eliminar la definición de metadatos?","fr":"Confirmer : Supprimer la définition des métadonnées ?","it":"Conferma: Eliminare la definizione dei metadati?","ja":"確認：メタデータの定義を削除しますか？"},"FIELD_METADATA_MULTIVALUED_TYPE_LABEL":{"de":"Mehrwertiger Typ","en":"Multivalued Type","es":"Tipo con múltiples valores","fr":"Type à plusieurs valeurs","it":"Tipo multivalore","ja":"複数の値を許可されたタイプ"},"FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL":{"de":"Nicht mehrwertig","en":"Not Multivalued","es":"Sin múltiples valores","fr":"N’accepte pas plusieurs valeurs","it":"Non multivalore","ja":"単一の値のみ許可"},"FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL":{"de":"Geordnet","en":"Ordered","es":"Ordenados","fr":"Classé","it":"Ordinato","ja":"整列"},"FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL":{"de":"Ungeordnet","en":"Unordered","es":"Sin ordenar","fr":"Non classé","it":"Non ordinato","ja":"整列なし"},"FIELD_METADATA_NAME_LABEL":{"de":"Name","en":"Name","es":"Nombre","fr":"Nom","it":"Nome","ja":"名前"},"FIELD_METADATA_NAMESPACE_LABEL":{"de":"Namespace","en":"Namespace","es":"Espacio de nombres","fr":"Espace de nom","it":"Spazio dei nomi","ja":"名前スペース"},"FIELD_METADATA_NEW_NAMESPACE_TOOLTIP":{"de":"Einen benutzerdefinierten XMP-Namespace hinzufügen...","en":"Add a Custom XMP Namespace...","es":"Agregar un Espacio de nombres XMP personalizado...","fr":"Ajouter un espace de nom XMP personnalisé...","it":"Aggiungi spazio dei nomi XMP personalizzato...","ja":"カスタムXMP名前スペースの追加"},"FIELD_METADATA_TAG_LABEL":{"de":"Tag","en":"Tag","es":"Etiqueta","fr":"Balise","it":"Tag","ja":"タグ"},"FIELD_METADATA_TYPE_LABEL":{"de":"Typ","en":"Type","es":"Tipo","fr":"Type","it":"Tipo","ja":"タイプ"},"FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE":{"de":"Mehrere Felder ausgewählt","en":"Multiple Fields Selected","es":"Se han seleccionado varios campos","fr":"Plusieurs champs sélectionnés","it":"Più campi selezionati","ja":"複数のフィールドが選択されています。"},"FIELD_NAMESPACE_ABBREVIATION":{"de":"Abkürzung","en":"Abbreviation","es":"Abreviatura","fr":"Abréviation","it":"Abbreviazione","ja":"省略"},"FIELD_NAMESPACE_REMOVE_CONFIRMATION":{"de":"Benutzerdefinierten XMP-Namespace löschen?\nMöglicherweise nutzen Felddefinitionen den Namespace.","en":"Delete the Custom XMP Namespace?\nThere may be Field Definitions using the namespace.","es":"¿Eliminar el Espacio de nombres XMP personalizado?\nPueden existir Definiciones de campo que utilicen el espacio de nombres.","fr":"Supprimer l’espace de nom XMP personnalisé ?\n L’espace de nom est peut-être utilisé par des définitions de champ.","it":"Eliminare spazio dei nomi XMP personalizzato?\nUsando lo spazio dei nomi è possibile vi siano delle definizioni di campo.","ja":"カスタムXMP名前スペースを削除しますか？\n名前スペースを使用したフィールドの定義が存在している可能性があります。"},"FIELD_NAMESPACE_URI":{"de":"Namespace URI","en":"Namespace URI","es":"URI de Espacio de nombres","fr":"URI espace de nom","it":"Spazio dei nomi URI","ja":"名前スペースURI"},"FIELD_NEW_FIELD_NAME":{"de":"Neues Feld","en":"New Field","es":"Nuevo campo","fr":"Nouveau champ","it":"Nuovo campo","ja":"新しいフィールド"},"FIELD_NEW_METADATA_TITLE":{"de":"Neue Metadaten-Definition","en":"New Metadata Definition","es":"Nueva definición de metadatos","fr":"Nouvelle définition de métadonnées","it":"Nuova definizione metadati","ja":"新しいメタデータの定義"},"FIELD_NEW_NAMESPACE_TITLE":{"de":"Neuer benutzerdefinierter XMP-Namespace","en":"New Custom XMP Namespace","es":"Nuevo Espacio de nombres XMP personalizado","fr":"Nouvel espace de nom XMP personnalisé","it":"Nuovo spazio dei nomi XMP personalizzato","ja":"新しいカスタムXMP名前スペース"},"FIELD_NO_FIELD_SELECTED_MESSAGE":{"de":"Kein Feld ausgewählt","en":"No Field Selected","es":"No se ha seleccionado campo","fr":"Aucun champ sélectionné","it":"Nessun campo selezionato","ja":"フィールドが選択されていません。"},"FIELD_PAGE_TITLE":{"de":"Feder für Katalog '{catalogName}' verwalten","en":"Manage Fields for Catalog '{catalogName}'","es":"Administrar campos para catálogo '{catalogName}'","fr":"Gérer les champs pour le catalogue '{catalogName}'","it":"Gestisci campi per catalogo '{catalogName}'","ja":"カタログ'{catalogName}'のフィールドの管理"},"FIELD_REVERT_CONFIRM_MSG":{"de":"Bestätigen: Feld wiederherstellen?","en":"Confirm: Revert the field?","es":"Confirmar: ¿Revertir el campo?","fr":"Confirmer : Renverser le champ ?","it":"Conferma: Ripristinare il campo?","ja":"確認：フィールドを元に戻しますか？"},"FIELD_TYPE_BLOB":{"de":"Blob","en":"Blob","es":"Blob","fr":"Blob","it":"Blob","ja":"BLOB"},"FIELD_TYPE_BOOLEAN":{"de":"Boolesch","en":"Boolean","es":"Booleano","fr":"Booléen","it":"Booleano","ja":"論理"},"FIELD_TYPE_DATETIME":{"de":"Datum/Uhrzeit","en":"Date/Time","es":"Fecha/Hora","fr":"Date/Heure","it":"Data/ora","ja":"日付/時刻"},"FIELD_TYPE_DECIMAL":{"de":"Dezimal","en":"Decimal","es":"Decimal","fr":"Décimal","it":"Decimale","ja":"少数"},"FIELD_TYPE_LANG_ALT":{"de":"Lang Alt","en":"Lang Alt","es":"Idioma Alt","fr":"Lang Alt","it":"Alt Lang","ja":"言語"},"FIELD_TYPE_NUMBER":{"de":"Zahl","en":"Number","es":"Número","fr":"Nombre","it":"Numero","ja":"数値"},"FIELD_TYPE_PICTURE":{"de":"Bild","en":"Picture","es":"Imagen","fr":"Image","it":"Immagine","ja":"写真"},"FIELD_TYPE_STRING":{"de":"String","en":"String","es":"Cadena","fr":"Chaîne","it":"Stringa","ja":"文字列"},"FIELD_TYPE_STRUCTURE":{"de":"Struktur","en":"Structure","es":"Estructura","fr":"Structure","it":"Struttura","ja":"構造"},"FIELD_TYPE_TEXTBLOCK":{"de":"Textblock","en":"Text Block","es":"Bloque de texto","fr":"Bloc de texte","it":"Blocco testo","ja":"テキストブロック"},"FIELD_TYPE_UNKNOWN":{"de":"Unbekannt","en":"Unknown","es":"Desconocido","fr":"Inconnu","it":"Sconosciuto","ja":"未定義"},"FIELD_TYPE_URL":{"de":"URL","en":"URL","es":"URL","fr":"URL","it":"URL","ja":"URL"},"FILE_IO_ERROR_MSG":{"de":"Beim Hochladen der Datei auf den Server trat ein Fehler auf.","en":"There was an error uploading the file to the server.","es":"Se ha producido un error al subir el archivo al servidor.","fr":"Une erreur s'est produite lors de l'ajout du fichier au serveur.","it":"C'è stato un errore caricando il documento sul server.","ja":"サーバーへのファイルアップロードにエラーがありました。"},"FILE_WRONG_TYPE_ERROR_MSG":{"de":"Dieser Dateityp wird nicht unterstützt. \n Bitte wählen Sie eine jpeg-, gif- oder png-Datei.","en":"This file is not a supported file type.\nPlease select a jpeg, gif or png file.","es":"Este archivo no es un formato compatible. Por favor, seleccione un archivo jpeg, gif o png.","fr":"Ce type de fichier n'est pas pris en charge.\nSélectionnez un fichier jpeg, gif ou png.","it":"Questo formato di documento non è supportato. \n Scegli un documento di formato jpeg, gif o png.","ja":"このファイル形式はサポートされていません。.jpegまたは.gif、.pngファイルを選択してください。"},"FOLDER_PATH_AUTOSYNC_FILES_STRING":{"de":"Dateien","en":"Files","es":"Archivos","fr":"Fichiers","it":"File","ja":"ファイル"},"FOLDER_PATH_ALREADY_EXIST_AS_FILE":{"de":"Eine Datei mit diesem Namen ist vorhanden.","en":"A file exists with this name.","es":"Ya existe un archivo con ese nombre.","fr":"Un fichier portant ce nom existe déjà.","it":"Esiste un file con questo nome.","ja":"同名ファイルが存在します。"},"FOLDER_PATH_DOES_NOT_EXIST":{"de":"Pfad ist nicht vorhanden.","en":"Path does not exist.","es":"No existe la ruta.","fr":"Le chemin d’accès n’existe pas.","it":"Il percorso non esiste.","ja":"パスは存在しません。"},"FOLDER_PATH_ERROR":{"de":"Fehler","en":"Error","es":"Error","fr":"Erreur","it":"Errore","ja":"エラー"},"FOLDER_PATH_NOT_VERIFIED":{"de":"Der Ordnerpfad wurde nicht geprüft.","en":"The folder path has not been verified.","es":"No se ha verificado la ruta de carpetas.","fr":"Le chemin d’accès au dossier n’a pas été vérifié.","it":"Il percorso alla cartella non è stato verificato.","ja":"フォルダパスは未確認です。"},"FOLDER_PATH_PATH":{"de":"Pfad","en":"Path","es":"Ruta","fr":"Chemin d’accès","it":"Percorso","ja":"パス"},"FOLDER_PATH_OPERATION_INVALID":{"de":"Ein ungültiger Vorgang","en":"An invalid operation","es":"Operación no válida","fr":"Une opération non valide","it":"Operazione non valida","ja":"無効な処理"},"FOLDER_PATH_SUCCESS":{"de":"Erfolg","en":"Success","es":"Éxito","fr":"Réussite","it":"Riuscito","ja":"成功"},"FOLDER_PATH_TYPE_AUTOSYNC":{"de":"AutoSync","en":"autosync","es":"sincronización automática","fr":"autosync","it":"autosync","ja":"オートシンク"},"FOLDER_PATH_TYPE_PREVIEW":{"de":"Vorschau","en":"preview","es":"vista previa","fr":"prévisualisation","it":"anteprima","ja":"プレビュー"},"FOLDER_PATH_UNKNOWN_FAULT":{"de":"Ein unbekannter Fehler","en":"An unknown fault","es":"Fallo desconocido","fr":"Une faute inconnue","it":"Errore sconosciuto","ja":"原因不明の失敗"},"french":{"de":"Französisch","en":"French","es":"Francés","fr":"Français","it":"Francese","ja":"フランス語"},"FULL_NAME":{"de":"Voller Name","en":"Full Name","es":"Nombre y apellidos","fr":"Nom complet","it":"Nome intero","ja":"フルネーム"},"FULLY_QUALIFIED_DOMAIN_NAME":{"de":"Vollständig qualifizierter Domainname","en":"Fully Qualified Domain Name","es":"Nombre de dominio completo","fr":"Nom de domaine pleinement qualifié","it":"Nome dominio completamente qualificato","ja":"完全なドメイン名（FQDN）"},"german":{"de":"Deutsch","en":"German","es":"Alemán","fr":"Allemand","it":"Tedesco","ja":"ドイツ語"},"GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL":{"de":"AutoSync-Ordner für neue Kataloge in diesem Ordner erstellen","en":"Create AutoSync folders for new catalogs in this folder","es":"Crear carpetas de sincronización automática para los catálogos nuevos en esta carpeta","fr":"Créer des dossiers AutoSync pour les nouveaux catalogues dans ce dossier","it":"Creare cartelle AutoSync per i nuovi cataloghi in questa cartella","ja":"新規カタログのオートシンクフォルダを次のフォルダ内に作成"},"GLOBAL_SETTINGS_BACKGROUND_COLOR":{"de":"Hintergrundfarbe","en":"Background Color","es":"Color de fondo","fr":"Couleur d’arrière-plan","it":"Colore di sottofondo","ja":"背景カラー"},"GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP":{"de":"Hintergrundfarbe der Login-Maske.","en":"Background color of the login screen.","es":"Color de fondo de la pantalla de inicio de sesión.","fr":"Couleur d'arrière-plan de l'écran de connexion.","it":"Colore di sottofondo dello schermo log-in.","ja":"ログイン画面の背景カラー"},"GLOBAL_SETTINGS_CATALOG_DEFAULTS":{"de":"Katalogstandardeinstellung","en":"Catalog Defaults","es":"Valores predeterminados de catálogo","fr":"Valeurs par défaut du catalogue","it":"Impostazioni predefinite catalogo","ja":"デフォルトカタログ"},"GLOBAL_SETTINGS_CHOOSE_FILE":{"de":"Datei auswählen","en":"Choose File","es":"Seleccione archivo","fr":"Choisir un fichier","it":"Scegli un documento","ja":"ファイルを選択"},"GLOBAL_SETTINGS_CUSTOM_IMAGE":{"de":"Eigenes Bild","en":"Custom Image","es":"Imagen personalizada","fr":"Image personnalisée","it":"Immagine personalizzato","ja":"カスタムイメージ"},"GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT":{"de":"Die ungefähre Größe sollte maximal 2400 x 1350 Pixel betragen.","en":"Approximate size should fit within 2400 x 1350 pixels.","es":"El tamaño máximo debería ser 2400 x 1350 píxeles.","fr":"La taille approximative doit être de 2400x1350 pixels.","it":"La grandezza indicativa dovrebbe stare dentro 2400 x 1350 pixel.","ja":"適切なサイズは2400 x 13500ピクセル内です。"},"GLOBAL_SETTINGS_CUSTOM_TITLE":{"de":"Eigener Titel","en":"Custom Title","es":"Título personalizado","fr":"Titre personnalisé","it":"Titolo personalizzato","ja":"カスタムタイトル"},"GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP":{"de":"Der Titel, der auf Reitern oder in Lesezeichen im Browser angezeigt wird.","en":"The title that appears on the browser tab or bookmark.","es":"El título que aparece en la pestaña del navegador o marcador.","fr":"Titre qui apparaît sur l'onglet ou le signet du navigateur.","it":"Il titolo che appare nel browser o nel segnalibri.","ja":"このタイトルはブラウザタブやブックマークに表示されます。"},"GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN":{"de":"Angepasste Login-Maske","en":"Customized Login Screen","es":"Pantalla de inicio personalizada","fr":"Écran de connexion personnalisé","it":"Schermo di log-in personalizzato","ja":"カスタマイズされたログイン画面"},"GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL":{"de":"Standardrolle","en":"Default Role","es":"Roles predeterminados","fr":"role par défaut","it":"Ruolo predefinito","ja":"デフォルトの役割"},"GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN":{"de":"Standard-Login-Maske","en":"Default Login Screen","es":"Pantalla predeterminada de login","fr":"Écran de connexion par défaut","it":"Schermo di log-in predefinito","ja":"初期ログイン画面"},"GLOBAL_SETTINGS_EMAIL_CONFIGURATION":{"de":"E-Mail Benachrichtigung","en":"Email Notifications","es":"Notificaciones de correo electrónico","fr":"Notifications par courriel","it":"Notifiche via e-mail","ja":"Email通知"},"GLOBAL_SETTINGS_FADEL":{"de":"FADEL Rights Cloud","en":"FADEL Rights Cloud","es":"FADEL Rights Cloud","fr":"FADEL Rights Cloud","it":"FADEL Rights Cloud","ja":"FADEL Rights Cloud"},"GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG":{"de":"Der Speicherort der AutoSync- und Vorschauordner muss vom Server aus zugänglich sein.","en":"The location of AutoSync and Preview folders must be accessible to the server.","es":"La ubicación de las carpetas de sincronización automática y de vistas previas debe estar accesible para el servidor.","fr":"L’emplacement des dossiers AutoSync et de prévisualisation doit être accessible au serveur.","it":"La posizione delle cartelle AutoSync e Anteprima deve essere accessibile al server.","ja":"オートシンクフォルダとプレビューフォルダの場所は、サーバーからアクセスできなければなりません。"},"GLOBAL_SETTINGS_IMAGE_URL":{"de":"Link","en":"Link","es":"Enlace","fr":"Lien","it":"Collegamento","ja":"リンク"},"GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP":{"de":"Der Klick auf das Bild öffnet diesen URL in einem neuen Browser-Fenster.","en":"Clicking the image will launch this URL in another browser window.","es":"Al hacer clic en la imagen la URL se abrirá en otra ventana del navegador.","fr":"L'URL sera lancée dans une autre fenêtre du navigateur si vous cliquez sur l'image.","it":"Cliccando sull'immagine apre questo URL in una nuova finestra.","ja":"画像をクリックして他のブラウザウィンドウ内でこのURLを表示します。"},"GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG":{"de":"Um Änderungen vorzunehmen, starten Sie den Server oder suchen Sie nach einer abgelaufenen Serverlizenz.","en":"To make changes, start the server or check for an expired server license.","es":"Para realizar cambios, introduzca el servidor o compruebe si ha caducado la licencia del servidor.","fr":"Pour apporter des modifications, démarrez le serveur ou vérifiez si une licence de serveur est arrivée à expiration.","it":"Per apportare delle modifiche, avviare il server o verificare se la licenza server è scaduta.","ja":"変更するには、サーバーを起動するか、期限切れのサーバーライセンスをチェックしてください。"},"GLOBAL_SETTINGS_PREVIEW_PATH_LABEL":{"de":"Vorschaubilder für neue Kataloge in diesem Ordner speichern","en":"Save Previews for new catalogs in this folder","es":"Guardar vistas previas de nuevos catálogos en esta carpeta","fr":"Enregistrer les prévisualisations pour les nouveaux catalogues dans ce dossier","it":"Salvare le anteprime dei nuovi cataloghi in questa cartella","ja":"新規カタログのプレビューを次のフォルダ内に保存"},"GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS":{"de":"Serverdatenorte","en":"Server Data Locations","es":"Ubicaciones de datos del servidor","fr":"Emplacements des données du serveur","it":"Posizioni dati server","ja":"サーバーデータの場所"},"GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION":{"de":"Portfolio LOGON-Kundenbezogenheit","en":"Portfolio Login Customization","es":"Arreglo para requisitos particulares de la conexión de la Portfolio","fr":"Personnalisation de procédure de connexion de Portfolio","it":"Adattamento di collegamento Portfolio","ja":"ログインのカスタマイゼーション"},"GLOBAL_SETTINGS_SSO_CREDENTIALS":{"de":"Einmalige Anmeldedaten (SSO)","en":"Single Sign-on Credentials","es":"Credenciales de registro únicas","fr":"Informations d’identification pour l’authentification unique","it":"Credenziali accesso singolo","ja":"シングルサインオン証明書"},"GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP":{"de":"Geben Sie das Benutzerkonto ein, das mit dem Portfolio Serverdienst für die Kerberos-Authentifizierung verknüpft ist.","en":"Enter the user account that is associated with the Portfolio Server service for Kerberos authentication.","es":"Introduzca la cuenta de usuario asociada al servicio Portfolio Server para autenticación Kerberos.","fr":"Saisir le compte de l’utilisateur associé au service Portfolio Server avec l’authentification Kerberos.","it":"Inserire l'account utente associato al servizio Portfolio Server per autenticazione Kerberos.","ja":"ケルベロス認証を利用しているPortfolio Serverサービスに関連づけられたユーザーアカウントを入力してください。"},"GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL":{"de":"Temporärer Arbeitsordner:","en":"Temporary Work folder","es":"Carpeta de trabajo temporal","fr":"Dossier de travail temporaire:","it":"Cartella di lavoro temporanea: ","ja":"一時作業フォルダ"},"GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG":{"de":"Der Arbeitsordner wird beim nächsten Starten des Servers geändert. Der neue Ordner wird sich hier befinden: ","en":"The work folder will be changed the next time the server is restarted. The new folder will be located at:","es":"La carpeta de trabajo se modificará la próxima vez que se reinicie el servidor. La nueva carpeta se ubicará en: ","fr":"Le dossier de travail sera modifié lors du prochain démarrage du serveur. Le nouveau dossier se trouvera à l’emplacement suivant : ","it":"La cartella di lavoro verrà modificata al prossimo riavvio del server. La nuova cartella verrà posizionata in: ","ja":"作業フォルダは次回のサーバー起動時には変更されます。新しいフォルダは次の場所に作成されます:"},"GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG":{"de":"Für diese Änderung müssen Sie den Server erneut starten.","en":"You must restart the server for this change to take effect.","es":"Es necesario reiniciar el servidor para que este cambio surta efecto.","fr":"Vous devez redémarrer le serveur pour que cette modification prenne effet.","it":"Affinché questa modifica abbia effetto è necessario riavviare il server.","ja":"設定の変更を有効にするには、サーバーを再起動する必要があります。"},"GLOBAL_SETTINGS_VAULT_CONFIGURATION":{"de":"Portfolio Vault-Konfiguration:","en":"Portfolio Vault Configuration","es":"Configuración de Bóveda de Portfolio","fr":"Configuration de Portfolio Vault","it":"Configurazione Portfolio Vault:","ja":"Portfolio Vault設定"},"GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL":{"de":"Portfolio Vault-Ordner:","en":"Portfolio Vault folder","es":"Carpeta de bóveda de Portfolio:","fr":"Dossier d'archivage du portefeuille :","it":"Cartella insieme di credenziali Portfolio:","ja":"Portfolio Vaultフォルダ:"},"SERVER_DATA_DEFAULT_VAULT_LOCATION_IS":{"de":"Standardmäßiger Portfolio-Vault-Speicherort:","en":"Default:","es":"Ubicación de bóveda de Portfolio por defecto:","fr":"Emplacement par défaut de l’archivage du portefeuille :","it":"Posizione predefinita insieme di credenziali Portfolio:","ja":"Portfolio Vaultのデフォルトの場所:"},"GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE":{"de":"Um Portfolio Vault zu verschieben, müssen Sie zuerst den Server herunterfahren.","en":"To move Portfolio Vault folder, first shut down Portfolio server.","es":"Para mover la Bóveda de Portfolio, desactive el servidor en primer lugar.","fr":"Avant de déplacer Portfolio Vault, veuillez arrêter le serveur.","it":"Per spostare Portfolio Vault, spegnere prima il server.","ja":"Portfolio Vaultを移動するには、まずサーバーを終了する必要があります。"},"HELP_URL":{"de":"https://helpdocs.portfoliodam.com/de/portfolio/administration/{version}/index.htm","en":"https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm","es":"https://helpdocs.portfoliodam.com/es/portfolio/administration/{version}/index.htm","fr":"https://helpdocs.portfoliodam.com/fr/portfolio/administration/{version}/index.htm","it":"https://helpdocs.portfoliodam.com/it/portfolio/administration/{version}/index.htm","ja":"https://helpdocs.portfoliodam.com/ja/portfolio/administration/{version}/Content/Home.htm#googtrans(ja)"},"HELP_URL_FADEL":{"de":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/de/Content/03_Catalogs/05_FADEL.htm","en":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/03_Catalogs/05_FADEL.htm","es":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/es/Content/03_Catalogs/05_FADEL.htm","fr":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/fr/Content/03_Catalogs/05_FADEL.htm","it":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/it/Content/03_Catalogs/05_FADEL.htm","ja":"https://helpdocs.portfoliodam.com/portfolio/{version}/administration/ja/Content/03_Catalogs/05_FADEL.htm"},"HOSTNAME":{"de":"Hostname","en":"Hostname","es":"Nombre de host","fr":"Nom d'hôte","it":"Nome host","ja":"ホスト名"},"IDENTITY_SERVICE_DEFAULT_ROLE_STRING":{"de":"(Standard)","en":"(default)","es":"(predeterminado)","fr":"(par défaut)","it":"(predefinito)","ja":"(デフォルト)"},"IDENTITY_SERVICE_SUCCESSFUL_CREATION":{"de":"Directory Service-Verbindung erfolgreich. Konfiguration gespeichert.","en":"Directory Service connection succeeded. Configuration saved.","es":"Conexión al servicio de directorio satisfactoria. Configuración guardada.","fr":"Connexion au service de répertoire réussie. Configuration enregistrée.","it":"Connessione al servizio directory avvenuta con successo. Configurazione salvata.","ja":"ディレクトリサービスの接続に成功。設定は保存されました。"},"IMAGE_FILE_FILTER":{"de":"Bilder (jpg, gif, png)","en":"Images (jpg, gif, png)","es":"Imágenes (jpg, gif, png)","fr":"Images (jpg, gif, png)","it":"Immagini (jpg, gif, png)","ja":"画像 (jpg, gif, png)"},"IMPORT_LDAP":{"de":"Benutzer aus LDAP/AD-Server importieren","en":"Import users from LDAP/AD server","es":"Importar usuarios desde servidor LDAP/AD","fr":"Importer des utilisateurs à partir du serveur LDAP/AD","it":"Importa utenti da server LDAP/AD","ja":"LDAP/AD サーバーからユーザーをインポート"},"IMPORT_LDAP_SPECIFY_SERVER":{"de":"LDAP/AD-Server angeben","en":"Specify LDAP/AD Server","es":"Specificare il server LDAP/AD","fr":"Spécifier le serveur LDAP/AD ","it":"Especificar servidor LDAP/AD","ja":"LDAP/AD サーバーを指定"},"IMPORT_MENU_STRING":{"de":"Werte importieren","en":"Import Values","es":"Importar valores","fr":"Importer des valeurs","it":"Importa valori","ja":"値の読み込み"},"IMPORT_SOURCE":{"de":"Quelle importieren","en":"Import Source","es":"Importar fuente","fr":"Importer la source","it":"Importa sorgente","ja":"ソースをインポート"},"INVALID_DN_SYNTAX_ERROR":{"de":"Die Verbindung mit dem Verzeichnisservice konnte aufgrund eines ungültigen DN-Syntaxfehlers nicht hergestellt werden. Prüfen Sie den Benutzernamen.","en":"Unable to connect to the directory service due to invalid DN syntax error. Please check the username.","es":"Imposible conectar con el servicio de directorios por un error de sintaxis de ND no válido. Compruebe el nombre de usuario.","fr":"Impossible de se connecter au service de répertoire en raison d'une erreur de syntaxe DN. Veuillez vérifier le nom d'utilisateur.","it":"Impossibile collegarsi al servizio directory a causa di un errore di sintassi DN non valido. Controllare il nome utente.","ja":"指定した DN の形式に誤りがあるため (Invalid DN syntax)、ディレクトリサービスに接続できません。 ユーザー名を確認してください。"},"japanese":{"de":"Japanisch","en":"Japanese","es":"Japonés","fr":"Japonais","it":"Giapponese","ja":"日本語"},"LAST_CERTIFICATE_REQUEST_LABEL":{"de":"Letzte Zertifikatsanforderung","en":"Last Certificate Request","es":"Última solicitud de certificado","fr":"Dernière demande de certificat","it":"Ultima richiesta di certificato","ja":"最終証明書リクエスト"},"LAST_MODIFIED_BY":{"de":"Zuletzt geändert von","en":"Last Modified By","es":"Última modificación por","fr":"Dernière modification par","it":"Ultima modifica di","ja":"最終修正者"},"LAST_MODIFIED_DATE":{"de":"Datum der letzten Änderung","en":"Date Last Modified","es":"Fecha de última modificación","fr":"Date de la dernière modification","it":"Data ultima modifica","ja":"最終修正日"},"LDAP_ADDRESS":{"de":"LDAP/AD-Serveradresse","en":"LDAP/AD Server address","es":"Dirección del servidor LDAP/AD","fr":"Adresse du serveur LDAP/AD","it":"Indirizzo server LDAP/AD","ja":"LDAP/AD サーバーのアドレス"},"LDAP_BIND_USERNAME":{"de":"LDAP-Verbindung-Benutzername","en":"LDAP Bind Username","es":"Nombre de usuario de conexión LDAP","fr":"Nom d'utilisateur pour la liaison LDAP","it":"Nome utente LDAP Bind","ja":"LDAP バインドユーザー名"},"LDAP_SYNC_NOTIFICATION":{"de":"Synch-Anforderung beim Server eingegangen.","en":"The server has received the sync request.","es":"El servidor ha recibido la solicitud de sincronización.","fr":"Le serveur a reçu la demande de synchronisation.","it":"Il server ha ricevuto una richiesta di sincronizzazione.","ja":"サーバーは同期要求を受信しました。"},"LIC_ADD_MESSAGE":{"de":"Kopieren Sie die Lizenzen und fügen Sie sie ein, oder tragen Sie diese einzeln pro Zeile ein.","en":"Copy and Paste Licenses or enter individually one per row.","es":"Copie y pegue licencias o introduzca individualmente una por cada fila.","fr":"Copiez et collez les licences ou saisissez-les individuellement sur chaque ligne.","it":"Copiare e incollare le licenze o inserirle singolarmente una per riga.","ja":"ライセンスをコピー＆ペーストするか、1列ずつ個別に入力してください。"},"LIC_ADD_SN":{"de":"Neue Lizenz hinzufügen","en":"Add New License","es":"Agregar licencia nueva","fr":"Ajouter une nouvelle licence","it":"Aggiungi nuova licenza","ja":"新規ライセンスを追加"},"LIC_ADD_SN_SHORT":{"de":"Fügen Sie Lizenzen hinzu","en":"Add Licenses","es":"Agregar Licencias","fr":"Ajouter licences","it":"Aggiungi licenze","ja":"ライセンスを追加"},"LIC_ASSET_CAP_DISPLAY":{"de":"Assets","en":"Assets","es":"Activos","fr":"Actifs","it":"Asset","ja":"アセット"},"LIC_DAYS_REMAINING":{"de":"({days} verbleibende Tage)","en":"({days} Days Remaining)","es":"({days} días restantes)","fr":"({days} jours restants)","it":"({days} giorni restanti)","ja":"（残り {days} 日）"},"LIC_DEMO_PERIOD":{"de":"Demozeitraum","en":"Demo Period","es":"Periodo de demostración","fr":"Période d’évaluation","it":"Periodo di demo","ja":"試用期間"},"LIC_ERROR_MSG":{"de":"Ungültige Seriennummer, bitte wiederholen Sie die Eingabe. Wenn das Problem weiterhin bestehen sollte, überprüfen Sie Ihr Serverprotokoll oder wenden Sie sich an Ihren Administrator.","en":"Invalid serial number, please re-try. If the problem persists check your server log or contact your administrator.","es":"Número de serie no válido, vuelva a intentarlo. Si el problema persiste, confirme el registro de servidor o póngase en contacto con el administrador.","fr":"Numéro de série, veuillez recommencer. Si le problème persiste, vérifiez le journal de votre serveur ou contactez votre administrateur.","it":"Numero di serie non valido; riprovare. Se il problema persiste, controllare il log del server e contattare l'amministratore.","ja":"不正なシリアル番号です。やり直してください。問題が回避できない場合は、サーバーのログを確認するか、管理者に連絡してください。"},"LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG":{"de":"Die Seriennummer kann dem Portfolio Studio nicht hinzugefügt werden.","en":"The serial number cannot be added to Portfolio Studio.","es":"No se puede agregar el número de serie a Portfolio Studio.","fr":"Impossible d’ajouter le numéro de série à Portfolio Studio.","it":"Il numero di serie non può essere aggiunto a Portfolio Studio.","ja":"シリアル番号をPortfolio Studioに追加することができません。"},"LITE_CANNOT_CREATE_FDB_CATALOG":{"de":"Ihre Portfolio-Lizenz lässt nur einen Katalog zu. Bitte nehmen Sie ein Upgrade Ihrer Portfolio-Lizenz vor, um diesen Vorgang auszuführen.","en":"Your Portfolio license does not allow more than one catalog. Please consider upgrading your Portfolio license to perform this action.","es":"Su licencia de Portfolio no permite más de un catálogo. Considere actualizar su licencia de Portfolio para poder ejecutar esta acción.","fr":"La licence de votre Portfolio ne vous autorise pas à plusieurs catalogues. Veuillez envisager de mettre à jour votre licence de Portfolio pour accomplir cette action.","it":"La licenza Portfolio non consente più di un catalogo. Aggiornare la licenza Portfolio per eseguire questa azione.","ja":"お持ちのライセンスでは、カタログをこれ以上増やすことはできません。アップグレードをご検討ください。"},"LITE_CANNOT_SERVE_FDB_CATALOG":{"de":"Das Online-Stellen weiterer Kataloge ist mit Ihrer Portfolio Server-Lizenz nicht gestattet.","en":"Your Portfolio Server license does not allow further catalogs to be taken online.","es":"Su licencia de Portfolio Server no permite poner más catálogos en línea.","fr":"Votre licence Portfolio Server ne permet pas de mettre en ligne d'autres catalogues.","it":"La licenza Portfolio Server di cui si dispone non consente di prendere ulteriori cataloghi online.","ja":"この Portfolio Server ライセンスでは、これ以上オンラインでカタログ作成できません。"},"LITE_THIS_FEATURE_NOT_SUPPORTED":{"de":"Die Portfolio Server-Lizenz unterstützt diesen Vorgang nicht.","en":"Your Portfolio Server license does not support this action.","es":"Su licencia de Portfolio Server no permite realizar esta acción.","fr":"Votre licence Portfolio Server ne prend pas en charge cette action.","it":"La licenza Portfolio Server non supporta questa azione.","ja":"この Portfolio Server ライセンスでは、処理をサポートしていません。"},"LOGGING_CONFIGURATION":{"de":"Protokollkonfiguration","en":"Logging Configuration","es":"Configuración de registro","fr":"Configuration de la journalisation","it":"Configurazione di log","ja":"ログ設定"},"LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE":{"de":"Wenn Sie den Speicherort des Protokolls ändern möchten, fahren Sie zuerst den Portfolio Server herunter.","en":"To move Logs folder, first shut down Portfolio server.","es":"Para cambiar la ubicación del registro, desactive en primer lugar el servidor de Portfolio.","fr":"Pour modifier l’emplacement du journal, arrêtez d’abord le serveur Portfolio.","it":"Per cambiare la posizione del log, spegnere prima il server del Portfolio.","ja":"ログの保存場所を変更するには、まずPortfolioのサーバーを終了する必要があります。"},"LOGGING_DEFAULT_LOCATION_MSG":{"de":"Stardard-Protokollspeicherort ist","en":"The default log location is","es":"La ubicación de registro predeterminada es","fr":"L’emplacement par défaut du journal est","it":"La posizione predefinita per il log è","ja":"デフォルトの場所"},"LOGGING_DIR_MUST_EXIST":{"de":"HINWEIS: Um das Log-Verzeichnis ändern zu können, muss das neu angegebene Verzeichnis bereits existieren und der Benutzer, der Portfolio Server ausführt, muss darin schreiben können.","en":"NOTE: In order to successfully change the log directory, the newly specified directory must already exist and be writeable by the user under which the Portfolio Server is running.","es":"NOTA: Para poder cambiar el directorio de registro, el nuevo directorio que se especifique debe existir ya y debe permitir que escriba en él el usuario bajo el cual se está ejecutando Portfolio Server.","fr":"REMARQUE : Afin de modifier correctement le répertoire du journal, le nouveau répertoire spécifié doit déjà exister et être inscriptible par l'utilisateur sous lequel la version de Portfolio Server s'exécute.","it":"NOTA: Per poter modificare correttamente la directory di log, la directory da specificare deve essere già esistente ed essere scrivibile da parte dell'utente per il quale è in funzione Portfolio Server.","ja":"注意: ログディレクトリを正しく変更するには、既に新しいディレクトリが存在している必要があります。"},"LOGGING_LOG_DIR":{"de":"Protokollverzeichnis:","en":"Logs folder","es":"Directorio de registro:","fr":"Répertoire du journal :","it":"Directory di log:","ja":"ログディレクトリ"},"LOGGING_LOG_LEVEL":{"de":"Protokollebene","en":"Log level","es":"Nivel de registro","fr":"Niveau de journalisation","it":"Livello di log","ja":"ログレベル:"},"LOGGING_NUM_LOGS_TO_RETAIN":{"de":"Anzahl der aufzubewahrenden Protokolle","en":"Number of logs to retain","es":"Número de registros para conservar","fr":"Nombre de journaux à conserver","it":"Numero di log da conservare","ja":"保存するログ数"},"LOGIN":{"de":"Login","en":"Login","es":"Iniciar sesión","fr":"Connexion","it":"Login","ja":"ログイン"},"MAPPING_HEADER":{"de":"Benutzer/Gruppenmappings zu Portfolio","en":"User/Group Mapping to Portfolio","es":"Asignación de usuario/grupo a cartera","fr":"Mappage des utilisateurs/groupes vers Portfolio","it":"Mappatura utente/gruppo a Portfolio","ja":"Portfolio ユーザー/グループのマッピング"},"MAPPINGS_HAVE_BEEN_MODIFIED_ALERT":{"de":"Die Zuweisungen wurden geändert; sollen sie gespeichert werden?","en":"The mappings have been modified, would you like to save them?","es":"Se han modificado las correspondencias, ¿desea guardarlas?","fr":"Les mappages ont été modifiés. Voulez-vous les enregistrer ?","it":"Le mappature sono state modificate, salvarle?","ja":"マッピングが変更されました。保存しますか?"},"MEDIA_ENGINES_ACTION_ADD":{"de":"Neue Media Engine hinzufügen","en":"Add New Media Engine","es":"Agregar nuevo motor de medios","fr":"Ajouter un nouveau Media Engine","it":"Aggiungi nuovo Media Engine","ja":"新規 Media Engine を追加"},"MEDIA_ENGINES_ACTION_DELETE":{"de":"Media Engine löschen","en":"Delete Media Engine","es":"Eliminar motor de medios","fr":"Supprimer Media Engine","it":"Elimina Media Engine","ja":"Media Engine を削除"},"MEDIA_ENGINES_ACTION_EDIT":{"de":"Media Engine-Details anzeigen/bearbeiten","en":"View/Edit Media Engine Details","es":"Ver/Editar detalles de motor de medios","fr":"Afficher/modifier les détails de Media Engine","it":"Visualizza/Modifica dettagli Media Engine","ja":"Media Engine 詳細情報を表示/編集"},"MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE":{"de":"Eine weitere Active Media Engine kann nicht hinzugefügt werden, da der Server bereits die von Ihrer Portfolio Media Engine Lizenz zugelassene Höchstanzahl der Active Media Engines verwendet.","en":"You can not add another active Media Engine because the server is already using the maximum number of active media engines allowed by your Portfolio Media Engine license.","es":"No es posible agregar otro motor de medios activo porque el servidor ya está utilizando el número máximo de motores de medios activos que le permite su licencia de Portfolio Media Engine.","fr":"Impossible d'ajouter un autre  moteur média actif car le serveur utilise déjà actuellement le nombre maximum de moteurs média autorisés par votre licence Portfolio Media Engine.","it":"Impossibile aggiungere un altro Media Engine attivo poiché il server sta già usando il numero massimo di media engine attivi consentito dalla licenza Portfolio Media Engine.","ja":"お持ちの Portfolio Media Engine ライセンスで指定された最大数の Media Engine がサーバーでアクティブになっているため、新たな Media Engine をアクティブにすることができません。"},"MEDIA_ENGINES_CANT_ADD_NO_LICENSES":{"de":"Sie können keine Media Engine hinzufügen, da dem Server keine Lizenz für Portfolio Media Engine zur Verfügung steht.","en":"You can not add a Media Engine because the server doesn't have any available Portfolio Media Engine licenses.","es":"No puede agregar un motor de medios porque el servidor no dispone de licencias de Portfolio Media Engine.","fr":"Vous ne pouvez pas ajouter de Media Engine car le serveur ne dispose par de licences Portfolio Media Engine.","it":"Impossibile aggiungere un Media Engine poiché il server non dispone di una licenza Portfolio Media Engine disponibile.","ja":"利用可能な Portfolio Media Engine ライセンスがサーバーにないため、Media Engine を追加することはできません。"},"MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER":{"de":"Die eingebaute Media Engine kann nicht entfernt werden.","en":"You can not remove the built in Media Engine.","es":"No puede quitar el motor de medios que viene integrado.","fr":"Vous ne pouvez pas supprimer le Media Engine  intégré.","it":"Impossibile rimuovere il Media Engine incorporato.","ja":"Media Engine でこのビルドを削除することはできません。"},"MEDIA_ENGINES_COLUMN_ACTIVE":{"de":"Aktiv","en":"Active","es":"Activo","fr":"Actif","it":"Attivo","ja":"使用可能"},"MEDIA_ENGINES_COLUMN_ADDRESS":{"de":"Adresse","en":"Address","es":"Dirección","fr":"Adresse","it":"Indirizzo","ja":"アドレス"},"MEDIA_ENGINES_COLUMN_PORT":{"de":"Port","en":"Port","es":"Puerto","fr":"Port","it":"Porta","ja":"ポート"},"MEDIA_ENGINES_CONFIRM_DELETE":{"de":"Möchten Sie die ausgewählte Media Engine löschen?","en":"Do you want to delete the selected Media Engine?","es":"¿Desea eliminar el motor de medios seleccionado?","fr":"Voulez-vous supprimer le moteur média sélectionné ?","it":"Eliminare il Media Engine selezionato?","ja":"選択したメディアエンジンを削除しますか?"},"MEDIA_ENGINES_EDIT_DETAILS_HEADER":{"de":"Media Engine-Details","en":"Media Engine Details","es":"Detalles del motor de medios","fr":"Détails de Media Engine","it":"Dettagli Media Engine","ja":"Media Engine の詳細情報"},"MEDIA_ENGINES_LICENSES_LABEL":{"de":"Media Engine-Plätze für Aktivierung verfügbar","en":"Media Engine seats available for activation","es":"Plazas en el motor de medios disponibles para activación","fr":"Sièges Media Engine disponibles pour l'activation","it":"Posti Media Engine disponibili per l'attivazione","ja":"Media Engine のアクティベーションに利用可能"},"MEDIA_ENGINES_NEW_DETAILS_HEADER":{"de":"Neue Media Engine-Details","en":"New Media Engine Details","es":"Detalles del nuevo motor de medios","fr":"Détails du nouveau Media Engine","it":"Dettagli nuovo Media Engine","ja":"新規 Media Engine の詳細情報"},"MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE":{"de":"Media Engines sind nicht aktiv. Sie sollten eine Media Engine aktivieren, bevor die Kunden die Portfolio Media-Dienste verwenden müssen.","en":"No Media Engines are active. You should activate a Media Engine before clients need to use Portfolio Media services.","es":"No hay motores de medios activos. Debería activar un motor de medios antes de que los clientes necesiten utilizar los servicios de medios de Portfolio.","fr":"Aucun Media Engine n'est activé. Vous devriez activer un Media Engine avant que les clients ne doivent utiliser les services de Portfolio Media.","it":"Nessun Media Engine attivo. È necessario attivare un Media Engine prima che i client debbano utilizzare i servizi Portfolio Media.","ja":"動作している Media Engine がありません。 Portfolio Media サービスを使用するには、Media Engine を開始する必要があります。"},"MOBILE":{"de":"Mobil","en":"Mobile","es":"Móvil","fr":"Mobile","it":"Cellulare","ja":"モバイル"},"MOBILE_ENABLED":{"de":"Mobile Uploads erlauben","en":"Enable Mobile Uploading","es":"Habilitar la carga móvil","fr":"Activer le téléchargement mobile","it":"Abilita caricamenti dal cellulare","ja":"モバイルアップロードを有効"},"MOBILE_FOLDER_VERBIAGE":{"de":"Mobile Uploads in diesem Ordner speichern.","en":"Save mobile uploads to this folder:","es":"Guardar las cargas móviles en esta carpeta:","fr":"Enregistrer les téléchargements mobiles dans ce dossier :","it":"Salva i caricamenti dal cellulare in questa cartella:","ja":"モバイルアップロードをこのフォルダに保存:"},"MOBILE_CREATE_CATALOG_VERBIAGE":{"de":"Neuen Katalog 'Mobile Uploads' anlegen, um diesen Ordner automatisch zu überwachen (empfohlen) ","en":"Create new catalog 'Mobile Uploads' to automatically watch this folder (recommended)","es":"Crear un catálogo nuevo 'Cargas móviles' para ver automáticamente esta carpeta (recomendado)","fr":"Créer un nouveau catalogue « Téléchargements mobiles » pour surveiller automatiquement ce dossier (recommandé)","it":"Creare il nuovo catalogo 'caricamenti da cellulare' per visionare automaticamente questa cartella (raccomandato)","ja":"このフォルダを自動監視する新規カタログ「モバイルアップロード」を作成（推奨）"},"MOBILE_CATALOG_NAME":{"de":"Mobile Uploads","en":"Mobile Uploads","es":"Cargas móviles","fr":"Téléchargements mobiles","it":"Caricamenti da cellulare","ja":"モバイルアップロード"},"modifyAssetContents":{"de":"Überprüfen Sie heraus Anlagegüter","en":"Check Out Assets","es":"Controle hacia fuera los activos","fr":"Vérifiez les biens","it":"Verifichi i beni","ja":"アセットのチェックアウト"},"MODIFY_LDAP":{"de":"LDAP-Abfrage ändern","en":"Modify LDAP query","es":"Modificar consulta LDAP","fr":"Modifier demande LDAP","it":"Modifica richiesta LDAP","ja":"LDAP クエリーを変更"},"NAME":{"de":"Name","en":"Name","es":"Nombre","fr":"Nom","it":"Nome","ja":"名前"},"NAME_TOO_LONG_ERROR":{"de":"Der Name muss weniger als 256 Zeichen aufweisen","en":"Name must be less than 256 characters.","es":"El nombre debe tener menos de 256 caracteres","fr":"Le nom ne doit pas dépasser 256 caractères","it":"Il nome deve contenere meno di 256 caratteri","ja":"名前は 1 バイト文字換算で 256 文字未満にしてください"},"NAV_ABOUT":{"de":"Über","en":"About","es":"Acerca de","fr":"À propos de","it":"Info su","ja":"バージョン情報"},"NAV_ACCESS_LEVELS":{"de":"Rollen","en":"Roles","es":"Roles","fr":"Rôles","it":"Ruoli","ja":"役割"},"NAV_AUTOSYNC":{"de":"Autosync","en":"Autosync","es":"Sincronización automática","fr":"Synchronisation automatique","it":"Sincr. automatica","ja":"オートシンク"},"NAV_BACKUPS":{"de":"Sichern/Wiederherstellen","en":"Backup/Restore","es":"Copia de seguridad/Restablecer","fr":"Sauvegarde/Restauration","it":"Backup/Ripristino","ja":"バックアップ/復元"},"NAV_CATALOGS":{"de":"Kataloge","en":"Catalogs","es":"Catálogos","fr":"Catalogues","it":"Cataloghi","ja":"カタログ"},"NAV_GLOBAL_SETTINGS":{"de":"Globale Einstellungen","en":"Global Settings","es":"Configuración global","fr":"Paramètres généraux","it":"Impostazioni globali","ja":"グローバル設定"},"NAV_HELP":{"de":"Hilfe","en":"Help","es":"Ayuda","fr":"Aide","it":"Guida","ja":"ヘルプ"},"NAV_LICENSES":{"de":"Lizenzen","en":"Licenses","es":"Licencias","fr":"Licences","it":"Licenze","ja":"ライセンス"},"NAV_LOGOUT":{"de":"Abmelden","en":"Logout","es":"Cerrar sesión","fr":"Déconnexion","it":"Logout","ja":"ログアウト"},"NAV_MEDIA_ENGINES":{"de":"Media Engines","en":"Media Engines","es":"Motores de medios","fr":"Media Engines","it":"Media Engine","ja":"Media Engine"},"NAV_NETPUBLISH_SETTINGS":{"de":"NetPublish","en":"NetPublish","es":"NetPublish","fr":"NetPublish","it":"NetPublish","ja":"NetPublish"},"NAV_PORTS":{"de":"Ports","en":"Ports","es":"Puertos","fr":"Ports","it":"Porte","ja":"ポート"},"NAV_REPORTING":{"de":"Reports","en":"Reports","es":"Notificaciones","fr":"Rapports","it":"Creazione di report","ja":"レポート作成"},"NAV_SETTINGS":{"de":"Einstellungen","en":"Settings","es":"Configuración","fr":"Paramètres","it":"Impostazioni","ja":"設定"},"NAV_STATUS":{"de":"Status","en":"Status","es":"Estado","fr":"État","it":"Stato","ja":"ステータス"},"NAV_USERS":{"de":"Benutzer","en":"Users","es":"Usuarios","fr":"Utilisateurs","it":"Utenti","ja":"ユーザー"},"NO_CATALOGS":{"de":"Keine","en":"None","es":"Ninguno","fr":"Aucun","it":"Nessuno","ja":"なし"},"NO_FILE_SELECTED":{"de":"Keine Datei ausgewählt","en":"No File Selected","es":"Ningun archivo seleccionado","fr":"Aucun fichier sélectionné","it":"Nessun documento scelto","ja":"ファイルが選択されていません"},"VaultFolderNotFound":{"de":"Der Portfolio Vault-Ordner wurde nicht unter {path} gefunden.","en":"The Portfolio Vault folder was not found at {path}.","es":"No se ha encontrado la carpeta Bóveda de Portfolio en {path}.","fr":"Dossier Portfolio Vault introuvable à l’emplacement {path}.","it":"La cartella Portfolio Vault non è stata trovata in {path}.","ja":"Portfolio Vaultフォルダが {path} にありませんでした。"},"NO_VAULT_FOLDER":{"de":"Der Portfolio Vault-Ordner wurde nicht unter {path} gefunden. Bitte überprüfen Sie den Ort des Ordners in Ihrem Dateisystem und unter den Globale Einstellung -> Server Datenseite dieser Anwendung.","en":"The Portfolio Vault folder was not found at {path}.\n\nPlease check the location of the folder on your file system, and in the Global Settings -> Server Data page of this application.","es":"No se ha encontrado la carpeta Bóveda de Portfolio en {path}.  Verifique la ubicación de la carpeta en su sistema de archivos y en la página Configuración global -> Datos del servidor de esta aplicación.","fr":"Dossier Portfolio Vault introuvable à l’emplacement {path}.  Veuillez vérifier l’emplacement du dossier dans votre système de fichiers, et dans la page Paramètres globaux -> Données du serveur de cette application.","it":"La cartella Portfolio Vault non è stata trovata in {path}.  Verificare la posizione della cartella nel proprio file di sistema, e nella pagina Impostazioni globali -> Dati server di questa applicazione.","ja":"Portfolio Vaultフォルダが {path} にありませんでした。フォルダの実際の場所と、グローバル設定のサーバーデータページを確認してください。"},"NOTES":{"de":"Hinweise","en":"Notes","es":"Notas","fr":"Remarques","it":"Note","ja":"メモ"},"NUMBER_DECIMAL_POINT_COUNT_ERROR":{"de":"Das Dezimaltrennzeichen kann nur einmal vorhanden sein.","en":"The decimal separator can only occur once.","es":"El separador de decimales sólo puede aparecer una vez.","fr":"Le séparateur de décimal ne peut apparaitre qu'une fois.","it":"Il separatore decimale può essere presente solo una volta.","ja":"小数点は一度だけ使用できます。"},"NUMBER_EXCEEDS_MAX_ERROR":{"de":"Die eingegebene Zahl ist zu groß.","en":"The number entered is too large.","es":"El número introducido es demasiado grande.","fr":"Le nombre saisi est trop grand.","it":"Il numero immesso è troppo grande.","ja":"入力した数値が大きすぎます。"},"NUMBER_INTEGER_ERROR":{"de":"Die Zahl muss eine Ganzzahl sein.","en":"The number must be an integer.","es":"El número debe ser entero.","fr":"Le nombre doit être un entier.","it":"Il numero deve essere un numero intero.","ja":"数値は整数である必要があります。"},"NUMBER_INVALID_CHAR_ERROR":{"de":"Die Eingabe enthält ungültige Zeichen.","en":"The input contains invalid characters.","es":"La entrada contiene caracteres no válidos.","fr":"La saisie contient des caractères non valides.","it":"L'immissione contiene caratteri non validi.","ja":"不正な文字が含まれています。"},"NUMBER_INVALID_FORMAT_CHARS_ERROR":{"de":"Einer der Formatierungsparameter ist ungültig.","en":"One of the formatting parameters is invalid.","es":"Uno de los parámetros de formato no es válido.","fr":"Un des paramètres de mise en forme n’est pas valide.","it":"Uno dei parametri di formattazione non è valido.","ja":"形式のパラメータの一つが不正です。"},"NUMBER_LOWER_THAN_MIN_ERROR":{"de":"Der eingegebene Betrag ist zu klein.","en":"The amount entered is too small.","es":"La cantidad introducida es demasiado pequeña.","fr":"La quantité saisie est trop petite.","it":"L'importo inserito è troppo piccolo.","ja":"合計が小さすぎます。"},"NUMBER_NEGATIVE_ERROR":{"de":"Der Betrag kann nicht negativ sein.","en":"The amount may not be negative.","es":"La cantidad no puede ser negativa.","fr":"La quantité ne doit pas être négative.","it":"L'importo può essere negativo.","ja":"合計がマイナスの可能性があります。"},"NUMBER_PRECISION_ERROR":{"de":"Der eingegebene Betrag enthält zu viele Stellen hinter dem Dezimalkomma.","en":"The amount entered has too many digits beyond the decimal point.","es":"La cantidad introducida tiene demasiados dígitos tras el separador de decimales.","fr":"La quantité saisie contient trop de chiffres après la décimale.","it":"L'importo inserito è composto da troppe cifre dopo il punto decimale.","ja":"小数点以下の桁数が多すぎます。"},"NUMBER_SEPARATION_ERROR":{"de":"Dem Tausender-Trennzeichen müssen drei Stellen folgen.","en":"The thousands separator must be followed by three digits.","es":"El separador de miles debe ir seguido de tres dígitos.","fr":"Le séparateur des milliers doivent être suivis de trois chiffres.","it":"Il separatore delle migliaia deve essere seguito da tre cifre.","ja":"桁区切り文字は三桁ごとに入力してください。"},"OK":{"de":"OK","en":"OK","es":"Aceptar","fr":"OK","it":"OK","ja":"OK"},"ON_DATE":{"de":"ein","en":"on","es":"en","fr":"le","it":"il","ja":"に"},"OPEN_DIRECTORY":{"de":"Open Directory","en":"Open Directory","es":"Open Directory","fr":"Open Directory","it":"Open Directory","ja":"Open Directory"},"OPEN_DIRECTORY_GROUPS":{"de":"Gruppen","en":"Groups","es":"Grupos","fr":"Groupes","it":"Gruppi","ja":"グループ"},"ORGANIZATION_NAME":{"de":"Organisationsbezeichnung","en":"Organization Name","es":"Nombre de la organización","fr":"Nom de l’organisation","it":"Nome organizzazione","ja":"組織名"},"ORGANIZATIONAL_UNIT":{"de":"Organisatorische Einheit","en":"Organizational Unit","es":"Unidad organizativa","fr":"Unité organisationnelle","it":"Unità organizzazione","ja":"部門名"},"PASSWORD":{"de":"Kennwort","en":"Password","es":"Contraseña","fr":"Mot de passe","it":"Password","ja":"パスワード"},"PASSWORD_CONFIRM":{"de":"Kennwort bestätigen","en":"Confirm Password","es":"Confirmar contraseña","fr":"Confirmer le mot de passe","it":"Conferma password","ja":"パスワードの確認"},"PASSWORD_TOO_LONG_ERROR":{"de":"Das Kennwort muss weniger als 256 Zeichen aufweisen","en":"Password must be less than 256 characters.","es":"La contraseña debe tener menos de 256 caracteres","fr":"Le mot de passe ne doit pas dépasser 256 caractères","it":"La password deve contenere meno di 256 caratteri","ja":"パスワードは 1 バイト文字換算で 256 文字未満にしてください"},"PORT":{"de":"Port","en":"Port","es":"Puerto","fr":"Port","it":"Porta","ja":"ポート"},"PORT_VALUE_TOO_HIGH_ERROR":{"de":"Der Port-Wert muss kleiner als 65536 sein.","en":"Port value must be less than 65536.","es":"El valor del puerto debe ser inferior a 65536.","fr":"La valeur du port doit être inférieure à 65536.","it":"Il valore di porta deve essere inferiore a 65536.","ja":"ポートの値は、65536以下である必要があります。"},"PortfolioAssetCap":{"de":"Portfolio Asset Cap","en":"Portfolio Asset Cap","es":"Portfolio Asset Cap","fr":"Portfolio Asset Cap","it":"Portfolio Asset Cap","ja":"Portfolioアセット容量"},"PortfolioAPI":{"de":"Portfolio API","en":"Portfolio API","es":"Portfolio API","fr":"Portfolio API","it":"Portfolio API","ja":"Portfolio API"},"PortfolioDemo":{"de":"Demo","en":"Demo","es":"Demo","fr":"Demo","it":"Demo","ja":"デモ"},"PortfolioDirServices":{"de":"Portfolio Directory Services","en":"Portfolio Directory Services","es":"Portfolio Directory Services","fr":"Portfolio Directory Services","it":"Portfolio Directory Services","ja":"Portfolioディレクトリサービス"},"PortfolioServer":{"de":"Portfolio-Server","en":"Portfolio Server","es":"Portfolio Server","fr":"Portfolio Server","it":"Portfolio Server","ja":"Portfolio Server"},"PortfolioStudio":{"de":"Portfolio Studio Edition","en":"Portfolio Studio Edition","es":"Portfolio Studio Edition","fr":"Portfolio Studio Edition","it":"Portfolio Studio Edition","ja":"Portfolio Studioエディション"},"PortfolioProfessional":{"de":"Portfolio Professional Edition","en":"Portfolio Professional Edition","es":"Portfolio Professional Edition","fr":"Portfolio Professional Edition","it":"Portfolio Professional Edition","ja":"Portfolio Professionalエディション"},"PortfolioEnterprise":{"de":"Portfolio Enterprise Edition","en":"Portfolio Enterprise Edition","es":"Portfolio Enterprise Edition","fr":"Portfolio Enterprise Edition","it":"Portfolio Enterprise Edition","ja":"Portfolio Enterpriseエディション"},"PortfolioMediaEngine":{"de":"Portfolio Media Engine","en":"Portfolio Media Engine","es":"Portfolio Media Engine","fr":"Portfolio Media Engine","it":"Portfolio Media Engine","ja":"Portfolio Media Engine"},"NetPublish":{"de":"Portfolio NetPublish","en":"Portfolio NetPublish","es":"Portfolio NetPublish","fr":"Portfolio NetPublish","it":"Portfolio NetPublish","ja":"Portfolio NetPublish"},"PortfolioMobile":{"de":"Portfolio Flow","en":"Portfolio Flow","es":"Portfolio Flow","fr":"Portfolio Flow","it":"Portfolio Flow","ja":"Portfolio Flow"},"PortfolioSmartKeywords":{"de":"Portfolio Smart Keywords","en":"Portfolio Smart Keywords","es":"Portfolio Smart Keywords","fr":"Portfolio Smart Keywords","it":"Portfolio Smart Keyword","ja":"Portfolio Smart Keywords"},"PortfolioUserConnection":{"de":"Portfolio-Benutzerverbindung","en":"Portfolio User Connection","es":"Portfolio User Connection","fr":"Connexion utilisateur Portfolio","it":"Portfolio User Connection","ja":"Portfolio User接続"},"PortfolioSingleSignOn":{"de":"Single-Sign-On (SSO)","en":"Single Sign On (SSO)","es":"Single Sign On (SSO)","fr":"Authentification unique (SSO)","it":"Accesso singolo (SSO)","ja":"シングルサインオン（SSO）"},"PORT_CURRENT_VALUE":{"de":"Aktueller Wert","en":"Current Value","es":"Valor actual","fr":"Valeur actuelle","it":"Valore corrente","ja":"現在の値"},"PORT_ERROR_MSG_BAD_PORT_VALUE":{"de":"Der neue Port-Wert muss eine Zahl zwischen 1 und 65535 sein.","en":"The new port value must be a number between 1 and 65535.","es":"El valor del puerto nuevo tiene que ser un número entre 1 y 65535.","fr":"La nouvelle valeur de port doit être un nombre entre 1 et 65 535.","it":"Il nuovo valore porta deve essere un numero compreso tra 1 e 65535.","ja":"新しいポート番号は、1～65535 の数値で入力してください。"},"PORT_ERROR_MSG_CONFLICT":{"de":"Die Port-Werte können nicht aktualisiert werden, da einer dieser neuen Werte bereits vom Server verwendet wird.","en":"Can not update port values because one or more of the new port values is already in use on the server.","es":"Imposible actualizar los valores de puertos porque uno o varios de los nuevos valores de puerto ya están en uso en el servidor.","fr":"Vous ne pouvez pas mettre à jour les valeurs de port car une ou plusieurs des nouvelles valeurs sont actuellement utilisées sur le serveur.","it":"Impossibile aggiornare i valori porta poiché uno o più dei nuovi valori porta è già in uso sul server.","ja":"サーバーですでに使用されているポート番号が指定されたため、ポート番号を変更することができません。"},"PORT_FIND_PORT":{"de":"Port suchen","en":"Find Port","es":"Buscar puerto","fr":"Trouver un port","it":"Trova porta","ja":"ポートを検索"},"PORT_NAME":{"de":"Name","en":"Name","es":"Nombre","fr":"Nom","it":"Nome","ja":"名前"},"PORT_NEW_VALUE":{"de":"Neuer Wert","en":"New Value","es":"Nuevo valor","fr":"Nouvelle valeur","it":"Nuovo valore","ja":"新しい値"},"PORT_RESTART_NOTICE":{"de":"Hinweis: Port-Aktualisierungen treten erst nach dem erneuten Starten des Servers in Kraft.","en":"Note: port updates do not take effect until the server is restarted.","es":"Nota: las actualizaciones de puertos no serán efectivas hasta que se reinicie el servidor.","fr":"Remarque : les mises à jour du port ne prennent effet qu'après le redémarrage du serveur.","it":"Nota: gli aggiornamenti delle porte hanno effetto solo dopo il riavvio del server.","ja":"注意: ポート番号の変更を適用するには、サーバーを再起動してください。"},"PORT_RESTART_SERVER":{"de":"Server neu starten","en":"Restart Server","es":"Reiniciar servidor","fr":"Redémarrer le serveur","it":"Riavvia server","ja":"サーバーを再起動"},"PORT_UPDATE_PORTS":{"de":"Ports aktualisieren","en":"Update Ports","es":"Actualizar puertos","fr":"Mettre à jour les ports","it":"Aggiorna porte","ja":"ポートを変更"},"PORT_WARNING_ADMIN_RESTART":{"de":"Der Admin-Port wurde geändert. Der Browser wird in {numSecs} Sekunden zur neuen Adresse weitergeleitet.","en":"The admin port was changed. The browser will be redirected to the new location in {numSecs} seconds.","es":"Ha cambiado el puerto de administración. El navegador se redirigirá a la nueva ubicación dentro de {numSecs} segundos.","fr":"Le port d'administration a été modifié. Le navigateur sera redirigé vers le nouvel emplacement dans {numSecs} secondes.","it":"Porta di amministrazione modificata. Il browser sarà reindirizzato nella nuova posizione fra {numSecs} secondi.","ja":"管理用ポートが変更されました。 {numSecs} 秒後に、新しいページが表示されます。"},"PREVIEW_MAX_VIDEO_RESOLUTION_360":{"de":"360p","en":"360p","es":"360p","fr":"360p","it":"360p","ja":"360p"},"PREVIEW_MAX_VIDEO_RESOLUTION_480":{"de":"480p","en":"480p","es":"480p","fr":"480p","it":"480p","ja":"480p"},"PREVIEW_MAX_VIDEO_RESOLUTION_540":{"de":"540p HD","en":"540p HD","es":"540p HD","fr":"540p HD","it":"540p HD","ja":"540p HD"},"PREVIEW_MAX_VIDEO_RESOLUTION_720":{"de":"720p HD","en":"720p HD","es":"720p HD","fr":"720p HD","it":"720p HD","ja":"720p HD"},"PREVIEW_MAX_VIDEO_RESOLUTION_1080":{"de":"1080p HD","en":"1080p HD","es":"1080p HD","fr":"1080p HD","it":"1080p HD","ja":"1080p HD"},"PROMPT_ARE_YOU_SURE":{"de":"Sind Sie sicher?","en":"Are you sure?","es":"¿Está seguro?","fr":"Êtes-vous sûr(e) ?","it":"Sicuro?","ja":"実行しますか?"},"PROMPT_COULD_NOT_CREATE_FOLDER":{"de":"Dieser Ordner konnte nicht erstellt werden. Geben Sie einen anderen Pfad ein.","en":"That folder could not be created. Please enter another path.","es":"No ha sido posible crear la carpeta. Introduzca una ruta distinta.","fr":"Impossible de créer ce dossier. Veuillez entrer un autre chemin.","it":"Impossibile creare cartella. Inserire un altro percorso.","ja":"このフォルダを作成することができません。 別のパスを入力してください。"},"PROMPT_COULD_NOT_CREATE_FOLDERS":{"de":"Geben Sie einen anderen Ordnerpfad ein, da die folgenden Pfade nicht erstellt werden konnten:","en":"Please enter another folder path because the following paths could not be created:","es":"Introduzca otra ruta de carpetas, ya que no ha sido posible crear las trayectorias siguientes:","fr":"Saisissez un autre chemin d’accès au dossier, car il est impossible de créer les chemins d’accès suivants :","it":"Inserire un altro percorso alla cartella poiché non è possibile creare i seguenti percorsi:","ja":"次のパスは作成できなかったため、別フォルダのパスを入力してください。"},"PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT":{"de":"Dieser Ordner konnte nicht erstellt werden, da bereits eine Datei mit diesem Namen vorhanden ist. Geben Sie einen anderen Pfad ein.","en":"That folder could not be created because there's already a file with that name. Please enter another path.","es":"No ha sido posible crear esa carpeta porque ya existe un archivo con ese nombre. Introduzca una ruta distinta.","fr":"Impossible de créer ce dossier car un fichier existe déjà sous ce nom. Veuillez entrer un autre chemin.","it":"Impossibile creare cartella poiché esiste già un file con questo nome. Inserire un altro percorso.","ja":"同じ名前を持つファイルがすでに存在するため、このフォルダを作成することができません。 別のパスを入力してください。"},"PROMPT_CREATE_THAT_FOLDER":{"de":"Dieser Ordner ist nicht vorhanden. Möchten Sie ihn erstellen?","en":"That folder does not exist. Create it?","es":"Esa carpeta no existe. ¿Desea crearla?","fr":"Ce dossier n'existe pas. Voulez-vous le créer ?","it":"Questa cartella non esiste. Crearla?","ja":"このフォルダが存在しません。 作成しますか?"},"PROMPT_CREATE_THESE_FOLDERS":{"de":"Diese Ordner sind nicht vorhanden. Möchten Sie sie erstellen?","en":"These folders do not exist. Do you want to create them?","es":"Estas carpetas no existen. ¿Desea crearlas?","fr":"Ces dossiers n’existent pas. Voulez-vous les créer ?","it":"Queste cartelle non esistono. Si desidera crearle?","ja":"このフォルダは存在しません。フォルダを新規作成してよろしいですか?"},"PROMPT_DELETE_LICENSE_CONFIRM":{"de":"Möchten Sie die ausgewählte Lizenz löschen?","en":"Do you want to delete the selected license?","es":"¿Desea eliminar la licencia seleccionada?","fr":"Voulez-vous supprimer la licence sélectionnée?","it":"Eliminare la licenza selezionata?","ja":"選択したライセンスを削除してよろしいですか?"},"QUERY":{"de":"Anfrage","en":"Query","es":"Consulta","fr":"Requête","it":"Interrogazione","ja":"クエリー"},"REMOVE":{"de":"Entfernen","en":"Remove","es":"Quitar","fr":"Supprimer","it":"Rimuovi","ja":"削除"},"REMOVE_DIRECTORY_SERVICE":{"de":"Verzeichnisdienst entfernen","en":"Remove Service","es":"Eliminar servicio de directorios","fr":"Retirer le service d'annuaire","it":"Rimuovi servizio directory","ja":"ディレクトリサービスを削除する"},"REPLACE_USER_MAPPING_CONFIRMATION":{"de":"Für diesen Benutzernamen ist bereits eine normale Benutzerzuordnung vorhanden. Soll diese durch eine Ausschlusszuordnung ersetzt werden?","en":"A regular user mapping already exists for this user. Replace it with an exclude user mapping?","es":"Ya existe una correspondencia de usuario regular para este usuario. ¿Desea reemplazarla con una correspondencia de usuario de exclusión?","fr":"Un mappage d'utilisateur régulier existe déjà pour cet utilisateur. Voulez-vous le remplacer par un mappage d'utilisateur exclus?","it":"Per questo utente esiste già una mappatura utente regolare. Sostituirla con una mappatura utente di esclusione?","ja":"通常のユーザーマッピングが、このユーザーに対してすでに存在しています。 除外ユーザーマッピングで置き換えますか?"},"REPLACE_USER_EXCLUSION_CONFIRMATION":{"de":"Für diesen Benutzernamen ist bereits eine Ausschlusszuordnung vorhanden. Soll diese durch eine normale Benutzerzuordnung ersetzt werden?","en":"An exclude user mapping already exists for this user. Replace it with a regular user mapping?","es":"Ya existe una correspondencia de usuario de exclusión para este usuario. ¿Desea reemplazarla con una correspondencia de usuario regular?","fr":"Un mappage d'utilisateur exclus existe déjà pour cet utilisateur. Voulez-vous le remplacer par un mappage d'utilisateur régulier?","it":"Per questo utente esiste già una mappatura utente di esclusione. Sostituirla con una mappatura utente regolare?","ja":"除外ユーザーマッピングが、このユーザーに対してすでに存在しています。 通常のユーザーマッピングで置き換えますか?"},"REQUIRED_FIELD_ERROR":{"de":"Dieses Feld ist erforderlich","en":"This field is required.","es":"Este campo es imprescindible","fr":"Ce champ est obligatoire","it":"Questo campo è obbligatorio","ja":"このフィールドは必須です"},"REVERT":{"de":"Wiederherstellen","en":"Revert","es":"Revertir","fr":"Rétablir","it":"Inverti","ja":"元に戻す"},"REVERT_CHANGES":{"de":"Änderungen Aufheben","en":"Revert Changes","es":"Invertir Cambios","fr":"Rétablir les Modifications","it":"Inverti Modifiche","ja":"変更を元に戻す"},"ROLE_FOR_IMPORT":{"de":"Rolle für Import","en":"Role for Import","es":"Rol para importar","fr":"Rôle pour l’importation","it":"Ruolo per importazione","ja":"インポートユーザーの役割"},"ROLES_PERMISSION_ENABLED_HEADER":{"de":"Aktiviert","en":"Enabled","es":"Activado","fr":"Activé","it":"Abilitato","ja":"使用可能"},"ROLES_PERMISSION_NAME_HEADER":{"de":"Vorgang","en":"Operation","es":"Operación","fr":"Opération","it":"Operazione","ja":"操作"},"SAVE":{"de":"Speichern","en":"Save","es":"Guardar","fr":"Enregistrer","it":"Salva","ja":"保存"},"SAVE_MAPPING":{"de":"Mapping Speichern","en":"Save Mapping","es":"Guardar Correspondencia","fr":"Enregistrer le Mappage","it":"Salva Mappatura","ja":"マッピングを保存"},"saveOutputSetting":{"de":"Üben Sie Voreinstellungen aus (Konvertierung und bilden PDF)","en":"Manage Presets (Convert and Make PDF)","es":"Gestionar preconfiguraciones convertidas y haga el PDF","fr":"Gérer les prédéfinitions de conversion et créer un PDF","it":"Gestisci preimpostazioni conversione e fate il PDF","ja":"プリセットを管理しなさい(改宗者はPDFを作り、)"},"SEARCH":{"de":"Suchen","en":"Search","es":"Buscar","fr":"Rechercher","it":"Cerca","ja":"検索"},"SEARCH_BASE":{"de":"Suchbasis","en":"Search Base","es":"Buscar en Base","fr":"Base de Recherche","it":"Base di Ricerca","ja":"検索ベース"},"SEARCH_RESULTS":{"de":"Suchergebnisse","en":"Search Results","es":"Resultados de la búsqueda","fr":"Résultats de recherche","it":"Risultati ricerca","ja":"検索結果"},"SECURITY_GROUPS":{"de":"Sicherheitsgruppen","en":"Security Groups","es":"Grupos de seguridad","fr":"Groupes de sécurité","it":"Gruppi di sicurezza","ja":"セキュリティグループ"},"SELECT":{"de":"Auswählen","en":"Select","es":"Seleccionar","fr":"Sélectionner","it":"Seleziona","ja":"選択"},"SEND_DIAGNOSTIC_DATA":{"de":"Diagnosebericht an Portfolio DAM senden","en":"Send diagnostic report to Portfolio DAM","es":"Enviar Informe de diagnóstico a Portfolio DAM","fr":"Envoyer le rapport de diagnostic à Portfolio DAM","it":"Invia Report diagnostico a Portfolio DAM","ja":"Portfolio DAMに診断レポートを送信"},"SERVER_DATA_DEFAULT_WORK_LOCATION_IS":{"de":"Standard-Arbeitsort: ","en":"Default work location:","es":"Ubicación de trabajo predeterminada: ","fr":"Emplacement du travail par défaut: ","it":"Posizione di lavoro predefinita: ","ja":"デフォルトの作業場所"},"SERVER_RESTART_REQUIRED":{"de":"Für das Wirksamwerden der Änderungen muss der Server neu gestartet werden.","en":"The server must be restarted for changes to take effect.","es":"Es necesario reiniciar el servidor para que surtan efecto los cambios.","fr":"Le serveur doit être redémarré pour que les modifications soient prises en compte.","it":"È necessario riavviare il server affinché le modifiche abbiano effetto.","ja":"訂正内容を有効にするためには、サーバを再起動する必要があります。"},"SERVER_STATE_ERROR":{"de":"Fehler: Genaue Details finden Sie im Verwaltungsprotokoll","en":"Error: See Admin Log for Details","es":"Error: Encontrará detalles en el registro de administración","fr":"Erreur : Voir le journal de l'administrateur pour plus de détails","it":"Errore: Vedere il log di amministrazione per ulteriori dettagli","ja":"エラー: 管理ログで詳細を見る"},"SERVER_STATE_STARTED":{"de":"Wird ausgeführt","en":"Running","es":"Ejecutando","fr":"Déroulement","it":"Esecuzione","ja":"動作中"},"SERVER_STATE_STARTING":{"de":"Starten","en":"Starting","es":"Iniciando","fr":"Démarrage","it":"Avvio","ja":"起動しています"},"SERVER_STATE_STOPPED":{"de":"Gestoppt","en":"Stopped","es":"Detenido","fr":"Arrêté","it":"Interrotto","ja":"停止しました"},"SERVER_STATE_STOPPING":{"de":"Stoppen","en":"Stopping","es":"Deteniendo","fr":"Arrêt","it":"Interruzione","ja":"停止しています"},"SERVER_STATE_UNKNOWN":{"de":"Unbekannt","en":"Unknown","es":"Desconocido","fr":"Inconnu","it":"Sconosciuto","ja":"不明"},"SERVICE_BROWSER":{"de":"Service-Browser","en":"Service Browser","es":"Examinador de servicios","fr":"Navigateur de services","it":"Browser servizi","ja":"サービスブラウザ"},"SK_ENGINE_APPAREL":{"de":"Kleid","en":"Apparel","es":"Ropa","fr":"Habillement","it":"Abito","ja":"服装"},"SK_ENGINE_CELEBRITIES":{"de":"Berühmtheiten","en":"Celebrities","es":"Celebridades","fr":"Célébrités","it":"Celebrità","ja":"名声"},"SK_ENGINE_FOOD":{"de":"Lebensmittel","en":"Food","es":"Alimentación","fr":"Nourriture","it":"Cibo","ja":"食品"},"SK_ENGINE_GENERAL":{"de":"Allgemeines","en":"General","es":"General","fr":"Généralités.","it":"Generale","ja":"一般"},"SK_ENGINE_LOGO":{"de":"Logo","en":"Logo","es":"Logotipo","fr":"Logo","it":"Logo","ja":"ロゴ"},"SK_ENGINE_MODERATION":{"de":"Moderation","en":"Moderation","es":"Moderación","fr":"Modération","it":"Regolazione","ja":"モデレーション"},"SK_ENGINE_NSFW":{"de":"NSFW","en":"NSFW","es":"NSFW","fr":"NSFW","it":"NSFW","ja":"NSFW"},"SK_ENGINE_TRAVEL":{"de":"Reise","en":"Travel","es":"Viajes","fr":"Voyage","it":"Viaggio","ja":"旅行"},"SK_ENGINE_WEDDINGS":{"de":"Hochzeiten","en":"Weddings","es":"Bodas","fr":"Mariages","it":"Matrimoni","ja":"結婚式"},"SSL_HANDSHAKE_ERROR":{"de":"Fehler bei SSL-Handshake; stellen Sie sicher, dass die Anschluss- und SSL-Einstellungen korrekt sind.","en":"SSL handshake failed; please verify that the port and SSL settings are correct.","es":"Fallo en el saludo SSL; verifique que la configuración de puertos y SSL es la correcta.","fr":"L'établissement de liaison SSL a échoué ; veuillez vérifier que les paramètres de port et SSL sont corrects.","it":"Handshake SSL non riuscito; verificare che la porta e le impostazioni SSL siano corrette.","ja":"SSL ハンドシェイクに失敗しました。ポートと SSL 設定が正しいことを確認してください。"},"STARTS_WITH":{"de":"beginnt mit","en":"starts with","es":"comienza con","fr":"commence par","it":"inizia con","ja":"で始まる"},"STATE_OR_PROVINCE":{"de":"Bundesland","en":"State or Province","es":"Estado o provincia","fr":"État ou province","it":"Stato o Provincia","ja":"国または州"},"STATUS":{"de":"Status","en":"Status","es":"Estado","fr":"État","it":"Stato","ja":"ステータス"},"STATUS_ADMIN_LOG":{"de":"Verwaltungsprotokoll","en":"Admin Log","es":"Registro de administración","fr":"Journal de l'administrateur","it":"Log di ammin.","ja":"管理ログ"},"STATUS_API_VERSION_LABEL":{"de":"API","en":"API","es":"API","fr":"API","it":"API","ja":"API"},"STATUS_API_STATE_LICENSED":{"de":"Lizenziert","en":"Licensed","es":"Con licencia","fr":"Sous licence","it":"Licenziato","ja":"ライセンスあり"},"STATUS_API_STATE_UNLICENSED":{"de":"Nicht lizenziert","en":"Not licensed","es":"Sin licencia","fr":"Sans licence","it":"Non licenziato","ja":"ライセンスなし"},"STATUS_CLEAR_ADMIN_LOG":{"de":"Verwaltungsprotokoll löschen","en":"Clear Admin Log","es":"Borrar registro de administración","fr":"Effacer le journal de l'administrateur","it":"Cancella log di ammin.","ja":"管理ログを消去"},"STATUS_CONNECTED_USERS":{"de":"Verbundene Benutzer","en":"Connected Users","es":"Usuarios conectados","fr":"Utilisateurs connectés","it":"Utenti connessi","ja":"接続ユーザー"},"STATUS_MAX_ALLOWED_CONNECTIONS":{"de":"Maximale Verbindungen","en":"Maximum Connections","es":"Máximo de conexiones","fr":"Nombre maximum de connexions","it":"Connessioni massime","ja":"最大接続数"},"STATUS_MEDIA_ENGINE_VERSION_LABEL":{"de":"Media Engine","en":"Media Engine","es":"Motor de medios","fr":"Media Engine","it":"Media Engine","ja":"Media Engine"},"STATUS_MEDIA_ENGINES_ACTIVE":{"de":"Aktiv","en":"Active","es":"Activo","fr":"Actif","it":"Attivo","ja":"使用可能"},"STATUS_MEDIA_ENGINES_LABEL":{"de":"Media Engines","en":"Media Engines","es":"Motores de medios","fr":"Media Engines","it":"Media Engine","ja":"Media Engine"},"STATUS_RESTART_SERVER":{"de":"Portfolio neu starten","en":"Restart Portfolio","es":"Reiniciar Portfolio","fr":"Redémarrer Portfolio","it":"Riavvia Portfolio","ja":"Portfolioの再起動"},"STATUS_SEAT_USAGE":{"de":"Platznutzung","en":"Seat Usage","es":"Uso de asientos","fr":"Utilisation des postes de travail","it":"Utilizzo posto","ja":"使用中"},"STATUS_SERVER_STATE":{"de":"Portfolio-Zustand","en":"Portfolio State","es":"Estado de Portfolio","fr":"Etat de Portfolio","it":"Portfolio State","ja":"Portfolioの状態"},"STATUS_SERVER_VERSION_LABEL":{"de":"Portfolio","en":"Portfolio","es":"Portfolio","fr":"Portfolio","it":"Portfolio","ja":"Portfolio"},"STATUS_START_SERVER":{"de":"Portfolio starten","en":"Start Portfolio","es":"Iniciar Portfolio","fr":"Démarrer Portfolio","it":"Avvia Portfolio","ja":"Portfolioの起動"},"STATUS_STOP_SERVER":{"de":"Portfolio stoppen","en":"Stop Portfolio","es":"Detener Portfolio","fr":"Arrêter Portfolio","it":"Arresta Portfolio","ja":"Portfolioの停止"},"STATUS_PROBLEMS_DETECTED":{"de":"Erkannte Probleme:","en":"Problems detected:","es":"Problemas detectados:","fr":"Problèmes détectés :","it":"Problemi rilevati:","ja":"検出された問題："},"STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM":{"de":"Die verbleibende Startfestplattenkapazität unterschreitet {minSpace} GB.","en":"Remaining startup disk space is under {minSpace}GB.","es":"El espacio restante en el disco de inicio es inferior a {minSpace} GB.","fr":"L’espace restant du disque de démarrage est inférieur à {minSpace} GO.","it":"Lo spazio rimanente del disco di avvio è sotto {minSpace}GB.","ja":"起動ディスクの空き容量が {minSpace}GB 以下になっています。"},"STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST":{"de":"Der Arbeitsordner ist nicht vorhanden oder zugreifbar.","en":"The work folder does not exist or is inaccessible.","es":"La carpeta de trabajo no existe o es imposible acceder a ella.","fr":"Le dossier de travail n’existe pas ou est inaccessible.","it":"La cartella di lavoro non esiste o non è accessibile.","ja":"作業フォルダが存在しないかアクセスできません。"},"STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE":{"de":"Der Portfolio-Server kann nicht in den Arbeitsordner schreiben.","en":"The Portfolio server cannot write to the work folder.","es":"El servidor Portfolio no puede escribir en la carpeta de trabajo.","fr":"Le serveur Portfolio ne peut pas écrire dans le dossier de travail.","it":"Il server Portfolio non può scrivere nella cartella di lavoro.","ja":"Portfolioは作業フォルダに書き込みできません。"},"STATUS_MSG_WORK_FOLDER_NOT_READABLE":{"de":"Der Portfolio-Server kann nicht aus dem Arbeitsordner lesen.","en":"The Portfolio server cannot read from the work folder.","es":"El servidor Portfolio no puede leer desde la carpeta de trabajo.","fr":"Le serveur Portfolio ne peut pas lire dans le dossier de travail.","it":"Il server Portfolio non può leggere dalla cartella di lavoro.","ja":"Portfolioは作業フォルダから読み取りできません。"},"STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE":{"de":"Der Portfolio-Server kann keine Symlinks im Arbeitsordner erzeugen.","en":"The Portfolio server cannot create symlinks in the work folder.","es":"El servidor Portfolio no puede crear enlaces simbólicos en la carpeta de trabajo.","fr":"Le serveur Portfolio ne peut créer de liens symboliques (symlinks) dans le dossier de travail.","it":"Il server Portfolio non può creare un collegamento simbolico nella cartella di lavoro.","ja":"Portfolioは作業フォルダにシンボリックリンクを作成できません。"},"STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW":{"de":"Die verbleibende Arbeitsordner-Festplattenkapazität unterschreitet {minSpace} GB.","en":"Remaining work folder disk space is under {minSpace}GB.","es":"El espacio restante en el disco de carpetas de trabajo es inferior a {minSpace} GB.","fr":"L’espace restant du disque du dossier de travail est inférieur à {minSpace} GO.","it":"Lo spazio rimanente nel disco di lavoro è sotto {minSpace}GB.","ja":"作業フォルダのあるディスクの空き容量が {minSpace}GB 以下になっています。"},"STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS":{"de":"Der Arbeitsordnerstatus kann nicht abgerufen werden.","en":"Unable to get work folder status.","es":"No es posible obtener el estado de la carpeta de trabajo.","fr":"Impossible d’obtenir le statut du dossier de travail.","it":"Impossibile ottenere lo stato della cartella di lavoro.","ja":"作業フォルダのステータスを取得できません。"},"STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED":{"de":"Der Status für den Elasticsearch-Index {index} ist rot.","en":"The status for elasticsearch index {index} is red.","es":"El estado del índice de búsqueda elástica {index} es rojo.","fr":"Le statut de l’index Elasticsearch {index} est rouge.","it":"Lo stato dell’indice ElasticSearch è rosso {index}.","ja":"Elasticsearchのインデックス {index} のステータスがレッドになっています。"},"STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS":{"de":"Der Elasticsearch-Index {index} hat nicht initialisierte Shards.","en":"The elasticsearch index {index} has uninitialized shards.","es":"El índice de búsqueda elástica {index} tiene fragmentos no inicializados.","fr":"L’index Elasticsearch {index} comporte des shards non initialisés.","it":"L’indice ElasticSearch {index} presenta partizioni non inizializzate.","ja":"Elasticsearchのインデックス {index} に初期化されていないシャードがあります。"},"STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE":{"de":"Nicht alle Shards sind für den Elasticsearch-Index {index} aktiv.","en":"Not all shards are active for the elasticsearch index {index}.","es":"No están activos todos los fragmentos para el índice de búsqueda elástica {index}.","fr":"Certains shards sont actifs pour l’index Elasticsearch {index}.","it":"Non tutte le partizioni sono attive per l’indice ElasticSearch {index}.","ja":"Elasticsearchのインデックス {index} の全てのシャードがアクティブになっていません。"},"STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS":{"de":"Der Elasticsearch-Status kann nicht abgerufen werden.","en":"Unable to retrieve elasticsearch status.","es":"No es posible recuperar el estado de la búsqueda elástica.","fr":"Impossible de récupérer le statut d’Elasticsearch.","it":"Impossibile recuperare lo stato ElasticSearch.","ja":"Elasticsearchのステータスを収集できません。"},"STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER":{"de":"Fehler können nicht vom Portfolio-Server abgerufen werden.","en":"Unable to retrieve errors from the Portfolio server.","es":"No es posible recuperar los errores desde el servidor Portfolio.","fr":"Impossible de récupérer des erreurs du serveur Portfolio.","it":"Impossibile recuperare gli errori dal server Portfolio.","ja":"Portfolioサーバーからエラーを収集できません。"},"STATUS_MSG_STARTUP_FAILED":{"de":"Start fehlgeschlagen","en":"Startup failed","es":"Se ha producido un error al iniciar","fr":"Le démarrage a échoué","it":"Avvio non riuscito","ja":"起動失敗"},"STATUS_MSG_CANT_GET_SERVER_HEALTH":{"de":"Serverzustand kann nicht aktualisiert werden.","en":"Unable to update server health.","es":"No es posible actualizar el estado del servidor.","fr":"Impossible de mettre à jour l’intégrité du serveur.","it":"Impossibile aggiornare l’integrità del server.","ja":"サーバーの状態を確認できません"},"STATUS_MSG_NATIVE_AGENT_NOT_RUNNING":{"de":"Die native Agent-Server-Komponente wird nicht ausgeführt.","en":"The native-agent server component is not running.","es":"El componente de servidor de agente nativo no se encuentra en ejecución.","fr":"Le composant agent natif du serveur n’est pas en cours d’exécution.","it":"Il componente del server Native Agent non è in esecuzione.","ja":"サーバーのnative-agentコンポーネントが動作していません。"},"SUBJECT_ALTERNATIVE_NAMES":{"de":"Betreff Alternative Namen","en":"Subject Alternative Names","es":"Nombres de asunto alternativos","fr":"Autres noms de sujet","it":"Nomi alternativi oggetto","ja":"サブジェクトの別名（SANs）"},"SUBMIT":{"de":"Absenden","en":"Submit","es":"Enviar","fr":"Soumettre","it":"Invia","ja":"送信"},"swedish":{"de":"Schwedisch","en":"Swedish","es":"Sueco","fr":"Suédois","it":"Svedese","ja":"スウェーデン語"},"SYNC_DAILY":{"de":"Täglich synchronisieren","en":"Synchronize Daily","es":"Sincronizar a diario","fr":"Synchroniser quotidiennement","it":"Sincronizza giornalmente","ja":"毎日同期"},"SYNCHRONIZE_NOW":{"de":"Jetzt synchronisieren","en":"Synchronize Now","es":"Sincronizar ahora","fr":"Synchroniser maintenant","it":"Sincronizza ora","ja":"同期化を実行"},"TARGET_CATALOG":{"de":"Zielkatalog","en":"Target Catalog","es":"Catálogo de destino","fr":"Catalogue cible","it":"Catalogo target","ja":"対象カタログ"},"THIS_LOCALE":{"de":"de","en":"en","es":"es","fr":"fr","it":"ir","ja":"ja"},"TRUE_LABEL":{"de":"Wahr","en":"True","es":"Verdadero","fr":"Vrai","it":"Vero","ja":"真の"},"TOKEN":{"de":"Token","en":"Token","es":"Identificador","fr":"Jeton","it":"Token","ja":"トークン"},"TOTAL_ASSETS":{"de":"Gesamte Assets","en":"Total Assets","es":"Total de activos","fr":"Total des actifs","it":"Risorse totali","ja":"アセットの合計"},"TWO_LETTER_COUNTRY_CODE":{"de":"Ländercode mit zwei Buchstaben","en":"Two-letter Country Code","es":"Código de país de dos letras","fr":"Code pays à deux lettres","it":"Codice Paese di due lettere","ja":"2文字国コード"},"TYPE":{"de":"Art","en":"Type","es":"Tipo","fr":"Type","it":"Carattere","ja":"タイプ"},"UNABLE_CONNECT_LDAP":{"de":"Verbindung mit LDAP/AD-Server nicht möglich.","en":"Unable to connect to LDAP/AD server.","es":"Imposible conectar al servidor LDAP/AD.","fr":"Connexion impossible au serveur LDAP/AD.","it":"Impossibile collegarsi al server LDAP/AD.","ja":"LDAP/AD サーバーに接続できません。"},"UNABLE_CONNECT_SERVER":{"de":"Verbindung mit Server nicht möglich.","en":"Unable to connect to server.","es":"Imposible conectar al servidor.","fr":" Connexion impossible au serveur.","it":"Impossibile collegarsi al server.","ja":"サーバーに接続できません。"},"UNKNOWN_HOST_ERROR":{"de":"Die Verbindung mit dem Verzeichnisservice konnte aufgrund einer Host-Ausnahmebedingung nicht hergestellt werden. Prüfen Sie den Hostnamen.","en":"Unable to connect to directory service due to an unknown host exception. Please check the hostname.","es":"Imposible conectarse con el servicio de directorios por una excepción de host desconocido. Compruebe el nombre de host.","fr":"Impossible de se connecter au service de répertoire en raison d'une exception d'hôte inconnu. Veuillez vérifier le nom d'hôte.","it":"Impossibile collegarsi al servizio directory a causa di una eccezione host sconosciuta. Controllare il nome host.","ja":"不明なホストによる例外が発生したため、ディレクトリサービスに接続できません。 ホスト名を確認してください。"},"UNKNOWN_LDAP_USER_ERROR":{"de":"Kein Benutzer wurde im Identitätsservice mit den Kontonamen '{accountName}' gefunden.","en":"No user was found in the Identity Service with the account name '{accountName}'.","es":"No se encontró ningún usuario en el Servicio de Identidad con el nombre de cuenta '{accountName}'.","fr":"Aucun utilisateur n'a été trouvé dans le service d'identité avec le nom d'utilisateur « {accountName} ».","it":"In Identity Service non è stato trovato alcun utente con il nome account '{accountName}'.","ja":"ID サービスはアカウント名 「{accountName}」 のユーザを見つけられませんでした。"},"useCustomPresets":{"de":"Voreinstellungen des Konvertiervorgangs verwenden","en":"Use Convert Presets","es":"Utilizar ajustes de conversión predefinidos","fr":"Utiliser les préréglages de conversion","it":"Usa impostazioni di conversione predefinite","ja":"変換プリセットの使用"},"USE_SSL":{"de":"SSL verwenden","en":"Use SSL","es":"Usar SSL","fr":"Utiliser SSL","it":"Usa SSL","ja":"SSL を使用"},"USER_ACCOUNT":{"de":"Konto","en":"Account","es":"Cuenta","fr":"Compte","it":"Conteggio","ja":"アカウント"},"USER_CREATE":{"de":"Neuen Benutzer hinzufügen","en":"Add New User","es":"Agregar usuario nuevo","fr":"Ajouter un nouvel utilisateur","it":"Aggiungi nome utente","ja":"新規ユーザーを追加"},"USER_DELETE":{"de":"Benutzer löschen","en":"Delete Users","es":"Eliminar usuarios","fr":"Supprimer les utilisateurs","it":"Elimina utenti","ja":"ユーザーを削除"},"USER_DELETE_CONFIRM":{"de":"Ausgewählte Benutzer löschen?","en":"Delete Selected Users?","es":"¿Eliminar usuarios seleccionados?","fr":"Supprimer les utilisateurs sélectionnés ?","it":"Elimina utenti selezionati?","ja":"選択したユーザーを削除しますか?"},"USER_DELETE__DELETE_PRIVATE":{"de":"Dauerhaft gelöscht werden","en":"Permanently Deleted","es":"Eliminarse permanentemente","fr":"Supprimées définitivement","it":"Eliminate in modo permanente","ja":"完全に削除します。"},"USER_DELETE__GALLERY_PROMPT":{"de":"Über \"Öffentlich machen\" werden alle privaten und schreibgeschützten Galerien dieses Benutzers zu öffentlichen Galerien. \"Alle privaten Galerien löschen\" löscht private Galerien und macht schreibgeschützte Galerien zu öffentlichen Galerien.","en":"Make Public makes all private and read-only galleries that belong to this user, public galleries. \"Delete All Private Galleries\" permanently removes private galleries, and makes read-only galleries public.","es":"La opción Hacer público convierte en públicas todas las galerías privadas y de sólo lectura pertenecientes a este usuario. \"Eliminar todas las galerías privadas\" borra permanentemente todas las galerías privadas y convierte en públicas las galerías de sólo lectura.","fr":"L'option « Rendre publique » rend publiques toutes les présentations privées ou en lecture seule de l'utilisateur. « Supprimer toutes les présentations privées » supprime de façon permanente les présentations privées et rend publiques les présentations en lecture seule.","it":"Il comando Rendi pubblico rende pubbliche tutte le gallerie private e a sola lettura appartenenti a questo utente. Il comando \"Elimina tutte le gallerie private\" rimuove in modo permanente le gallerie private e rende pubbliche le gallerie a sola lettura.","ja":"パブリックにすると、このユーザーが所有するすべてのプライベートおよび閲覧専用ギャラリーが、パブリックギャラリーになります。 「プライベートギャラリーをすべて削除」は、プライベートギャラリーを完全に削除し、閲覧専用ギャラリーをパブリックにします。"},"USER_DELETE__GALLERY_PROMPT_1":{"de":"Die ausgechecktenArtikel der Nutzer werden zurückgegeben und zur Verfügung gestellt.","en":"The users' Checked Out items will be reverted and made accessible.","es":"Los elementos en Salida de los usuarios se revertirán y se podrá acceder a los mismos.","fr":"Les éléments extraits des utilisateurs seront restaurés et rendus accessibles.","it":"Gli articoli Pagati degli utenti saranno ripristinati e resi accessibili.","ja":"ユーザーのチェックアウトアイテムが復帰して、アクセス可能になります。"},"USER_DELETE__GALLERY_PROMPT_2":{"de":"Die Nur-Lesen Gallerien der Nutzer werden veröffentlicht.","en":"The users' Read-Only Galleries will be made Public.","es":"Se harán Públicas las Galerías de Sólo lectura de los usuarios.","fr":"Les galeries en lecture seule des utilisateurs seront rendues publiques.","it":"Le Gallerie di sola lettura degli utenti saranno rese Pubbliche.","ja":"ユーザーの閲覧専用ギャラリーがパブリックになります。"},"USER_DELETE__GALLERY_PROMPT_3":{"de":"Die Privatgalerien der Nutzer sollten:","en":"The users' Private Galleries should be:","es":"Las Galerías privadas de los usuarios deben:","fr":"Les galeries privées des utilisateurs doivent être :","it":"Le Gallerie private degli utenti dovrebbero essere:","ja":"ユーザーのプライベートギャラリーを"},"USER_DELETE__MAKE_PUBLIC":{"de":"Veröffentlicht werden","en":"Made Public","es":"Hacerse Públicas","fr":"Rendues publiques","it":"Rese Pubbliche","ja":"パブリックにします。"},"USER_DETAILS":{"de":"Benutzerdetails","en":"User Details","es":"Detalles del usuario","fr":"Détails de l'utilisateur","it":"Dettagli utente","ja":"ユーザーの詳細情報"},"USER_IMPORT":{"de":"Benutzer importieren","en":"Import Users","es":"Importar usuarios","fr":"Importer les utilisateurs","it":"Importa utenti","ja":"ユーザーをインポート"},"USER_IMPORT_ACCOUNT":{"de":"Benutzername","en":"Account Name","es":"Nombre de cuenta","fr":"Nom du compte","it":"Nome account","ja":"アカウント名"},"USER_IMPORT_ACCOUNT_ATTR":{"de":"Kontoattribut","en":"Account Attribute","es":"Atributo de cuenta","fr":"Attribut du compte","it":"Attributo account","ja":"アカウントの属性"},"USER_IMPORT_EMAIL_ATTR":{"de":"E-Mail-Attribut","en":"Email Attribute","es":"Atributo de correo electrónico","fr":"Attribut du courrier électronique","it":"Attributo e-mail","ja":"電子メールの属性"},"USER_IMPORT_IMPORT":{"de":"Importieren","en":"Import","es":"Importar","fr":"Importer","it":"Importa","ja":"インポート"},"USER_IMPORT_IMPORT_SELECTED_USERS":{"de":"Ausgewählte Benutzer importieren","en":"Import Selected Users","es":"Importar usuarios seleccionados","fr":"Importer les utilisateurs sélectionnés","it":"Importa utenti selezionati","ja":"選択したユーザーをインポート"},"USER_IMPORT_MODIFY_SEARCH":{"de":"Suche ändern","en":"Modify Search","es":"Modificar búsqueda","fr":"Modifier la recherche","it":"Modifica ricerca","ja":"検索条件を変更"},"USER_IMPORT_NAME_ATTR":{"de":"Kontonamensattribut","en":"Account Name Attribute","es":"Atributo de nombre de cuenta","fr":"Attribut du nom de compte","it":"Attributo nome account","ja":"アカウント名の属性"},"USER_IMPORT_NOTES_ATTR":{"de":"Notizenattribut","en":"Notes Attribute","es":"Atributo de notas","fr":"Attribut des remarques","it":"Attributo note","ja":"メモの属性"},"USER_IMPORT_PASSWORD":{"de":"Kontokennwort","en":"Account Password","es":"Contraseña de la cuenta","fr":"Mot de passe du compte","it":"Password account","ja":"アカウントのパスワード"},"USER_IMPORT_PASSWORD_ATTR":{"de":"Kennwortattribut","en":"Password Attribute","es":"Atributo de contraseña","fr":"Attribut du mot de passe","it":"Attributo password","ja":"パスワードの属性"},"USER_IMPORT_SEARCH":{"de":"Suche","en":"Search","es":"Buscar","fr":"Rechercher","it":"Cerca","ja":"検索"},"USER_IMPORT_SEARCH_BASE":{"de":"Suchbasis","en":"Search Base","es":"Base de búsqueda","fr":"Base de recherche","it":"Base di ricerca","ja":"検索ベース"},"USER_IMPORT_SEARCH_FILTER":{"de":"Suchfilter","en":"Search Filter","es":"Filtro de búsqueda","fr":"Filtre de recherche","it":"Filtro di ricerca","ja":"検索フィルタ"},"USER_IMPORT_SERVER_ADDRESS":{"de":"Serveradresse","en":"Server Address","es":"Dirección de servidor","fr":"Adresse du serveur","it":"Indirizzo server","ja":"サーバーのアドレス"},"USER_IMPORT_SPECIFY_LDAP_SERVER":{"de":"LDAP Server angeben","en":"Specify LDAP Server","es":"Especificar servidor LDAP","fr":"Spécifier le serveur LDAP","it":"Specifica server LDAP","ja":"LDAP サーバーを指定"},"USER_LEVEL_ADMINISTRATOR":{"de":"Katalogadministrator","en":"Catalog Administrator","es":"Administrador del catálogo","fr":"Administrateur du catalogue","it":"Amministratore catalogo","ja":"カタログ管理者"},"USER_LEVEL_EDITOR":{"de":"Editor","en":"Editor","es":"Editor","fr":"Éditeur","it":"Curatore","ja":"編集者"},"USER_LEVEL_NON_MEMBER":{"de":"--","en":"--","es":"--","fr":"--","it":"--","ja":"--"},"USER_LEVEL_PUBLISHER":{"de":"Herausgeber","en":"Publisher","es":"Publicador","fr":"Publisher","it":"Editore","ja":"発行者"},"USER_LEVEL_READER":{"de":"Leser","en":"Reader","es":"Lector","fr":"Reader","it":"Lettore","ja":"閲覧者"},"USER_MANAGE_CATALOGS":{"de":"Kataloge für ausgewählte Benutzer verwalten","en":"Manage Catalogs for Selected Users","es":"Gestionar catálogos de usuarios seleccionados","fr":"Gérer les catalogues des utilisateurs sélectionnés","it":"Gestisci cataloghi per utenti selezionati","ja":"選択したユーザーに対してカタログを管理"},"USER_MULT_USERS_SELECTED":{"de":"Mehrere Benutzer ausgewählt","en":"Multiple Users Selected","es":"Varios usuarios seleccionados","fr":"Plusieurs utilisateurs sélectionnés","it":"Più utenti selezionati","ja":"複数のユーザーを選択"},"USER_NAME":{"de":"Benutzername","en":"User Name","es":"Nombre de usuario","fr":"Nom d'utilisateur","it":"Nome utente","ja":"ユーザー名"},"USER_NEW_USER_DETAILS":{"de":"Neue Benutzerdetails","en":"New User Details","es":"Detalles de nuevo usuario","fr":"Détails du nouvel utilisateur","it":"Dettagli nuovo utente","ja":"新規ユーザーの詳細情報"},"USER_NEW_USER_INFO_MSG":{"de":"Zum Hinzufügen eines Benutzers zu bestimmten Katalogen, Kataloge > Benutzer.","en":"To add a user to specific catalogs, use Catalogs > Users.","es":"Para agregar un usuario a catálogos concretos, utilice Catálogos > Usuarios.","fr":"Pour ajouter un utilisateur à des catalogues spécifiques, choisissez Catalogues > Utilisateurs.","it":"Per aggiungere un utente ad un catalogo specifico, usare Cataloghi > Utenti.","ja":"ユーザーを特定のカタログに追加するには、カタログ > ユーザー。"},"USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS":{"de":"Benutzer zu allen Katalogen hinzufügen als:","en":"Add user to all catalogs as:","es":"Agregar  usuarios a todos los catálogos como:","fr":"Ajouter l’utilisateur à tous les catalogues comme:","it":"Aggiungi utente a tutti i cataloghi come:","ja":"ユーザーを全カタログに追加:"},"USER_NO_USERS_SELECTED":{"de":"Keine Benutzer ausgewählt","en":"No Users Selected","es":"No hay usuarios seleccionados","fr":"Aucun utilisateur sélectionné","it":"Nessun utente selezionato","ja":"ユーザー未選択"},"USER_ONLINE":{"de":"Online","en":"Online","es":"En línea","fr":"En ligne","it":"Online","ja":"オンライン"},"USER_PASSWORD_TOO_SHORT":{"de":"Das Passwort muss aus mindestens einem Zeichen bestehen.","en":"Password must contain at least one character.","es":"La contraseña tiene que incluir como mínimo un carácter.","fr":"Le mot de passe doit contenir au moins un caractère.","it":"La password deve contenere almeno un carattere.","ja":"パスワードには、少なくとも 1 文字が必要です。"},"USER_PASSWORDS_DO_NOT_MATCH":{"de":"Das Kennwortbestätigungsfeld muss mit dem Kennwortfeld übereinstimmen.","en":"The password confirmation field needs to match the password field.","es":"El campo de confirmación de contraseña tiene que concordar con el campo de contraseña.","fr":"Le champ de confirmation du mot de passe doit correspondre au champ du mot de passe.","it":"Il campo di conferma password deve corrispondere al campo della password.","ja":"確認用パスワードがパスワードと一致しません。"},"USER_ROLE":{"de":"Zugriffsmodus","en":"Role","es":"Nivel de acceso","fr":"Niveau d'accès","it":"Livello di accesso","ja":"アクセスレベル"},"USER_VIEW_DETAILS":{"de":"Benutzerdetails anzeigen/bearbeiten","en":"View/Edit User Details","es":"Ver/Editar detalles de usuario","fr":"Afficher/modifier les détails de l'utilisateur","it":"Visualizza/Modifica dettagli utente","ja":"ユーザー詳細情報を表示/編集"},"USERS":{"de":"Benutzer","en":"Users","es":"Usuarios","fr":"Utilisateurs","it":"Utenti","ja":"ユーザー"},"VALIDATION_FIELD_LENGTH_EXCEEDED":{"de":"Dieses Feld darf 255 Zeichen nicht überschreiten.","en":"This field cannot exceed 255 characters.","es":"El campo no puede superar 255 caracteres.","fr":"Ce champ ne peut dépasser 255 caractères.","it":"Questo campo non può superare i 255 caratteri.","ja":"このフィールドは最大 255 文字まで入力できます。"},"VALIDATION_MUST_BE_NONEMPTY":{"de":"Dieses Feld ist erforderlich.","en":"This field is required.","es":"Este campo es imprescindible.","fr":"Ce champ est obligatoire.","it":"Questo campo è obbligatorio.","ja":"このフィールドは必須です。"},"VIEW_EDIT_MAPPINGS":{"de":"Zuweisungen anzeigen / bearbeiten","en":"View / Edit Mappings","es":"Ver / Editar correspondencias","fr":"Afficher / Modifier le mappage","it":"Mostra / Modifica mappature","ja":"マッピングの表示/編集"},"General.OK":{"en":"OK","de":"OK","es":"Aceptar","fr":"OK","it":"OK","ja":"OK"},"General.Cancel":{"de":"Abbrechen","en":"Cancel","es":"Cancelar","fr":"Annuler","it":"Annulla","ja":"キャンセル"},"PORT_TITLE":{"en":"Ports","de":"Ports","es":"Puertos","fr":"Ports","it":"Porte","ja":"ポート"},"PORT_DEFAULT":{"de":"Standard:","en":"Default:","es":"Predeterminado:","fr":"Par défaut :","it":"Predefinito:","ja":"デフォルト:"},"esp.port.admin-web-app":{"en":"Portfolio Admin HTTP Port","de":"Portfolio Admin HTTP-Anschluss","es":"Portfolio Administrador Puerto HTTP","fr":"Port HTTP administrateur Portfolio","it":"Porta HTTP Admin Portfolio","ja":"Portfolioアドミン HTTPポート"},"esp.port.admin-web-app-ssl":{"en":"Portfolio Admin SSL Port","de":"Portfolio Admin SSL-Anschluss","es":"Portfolio Administrador Puerto SSL","fr":"Port SSL administrateur Portfolio","it":"Porta SSL Admin Portfolio","ja":"Portfolioアドミン SSLポート"},"esp.port.http":{"en":"Portfolio Server HTTP Port","de":"Portfolio Server HTTP-Anschluss","es":"Portfolio Servidor Puerto HTTP","fr":"Port HTTP serveur Portfolio","it":"Porta HTTP server Portfolio","ja":"Portfolioサーバー HTTPポート"},"esp.port.ssl":{"en":"Portfolio Server SSL Port","de":"Portfolio Server SSL-Anschluss","es":"Portfolio Servidor Puerto SSL","fr":"Port SSL serveur Portfolio","it":"Porta SSL server Portfolio","ja":"Portfolioサーバー SSLポート"},"General.Save":{"de":"Speichern","en":"Save","es":"Guardar","fr":"Enregistrer","it":"Salva","ja":"保存"},"CATALOG_DETAILS_FILETYPES_TAB":{"en":"File Types","de":"Speichertypen","es":"Tipos de archivo","fr":"Types de fichiers","it":"Tipi di file","ja":"ファイルタイプ"},"addAsset":{"en":"Add Assets","de":"Assets hinzufügen","es":"Añadir activos","fr":"Ajouter des ressources","it":"Aggiungi risorse","ja":"アセットを追加"},"canManageFieldLists":{"en":"Manage Public Field Lists","de":"Öffentliche Feldlisten verwalten","es":"Gestionar listas de campos públicos","fr":"Gérer les listes de champs publics","it":"Gestisci Elenchi campo pubblico","ja":"パブリックフィールドの一覧を管理"},"canModifyFolderStructure":{"en":"Modify Folder Structures","de":"Ordnerstrukturen ändern","es":"Modificar estructuras de carpeta","fr":"Modifier les structures du dossier","it":"Modifica le strutture delle cartelle","ja":"フォルダ階層を編集"},"canMoveAssets":{"en":"Move Assets","de":"Assets verschieben","es":"Mover activos","fr":"Déplacer les ressources","it":"Sposta risorse","ja":"アセットを移動"},"deleteAssetContents":{"en":"Delete Original Assets","de":"Original-Assets löschen","es":"Eliminar activos originales","fr":"Supprimer les éléments d'origine","it":"Elimina risorse originali","ja":"オリジナルアセットの削除"},"deleteAssetFromCatalog":{"en":"Delete Asset from Catalog","de":"Asset aus Katalog löschen","es":"Eliminar activo del catálogo","fr":"Supprimer la ressource du catalogue","it":"Elimina risorsa dal catalogo","ja":"カタログからアセットを削除"},"modifyAssetProperties":{"en":"Update Asset Fields","de":"Asset-Felder aktualisieren","es":"Actualizar campos del activo","fr":"Mettre à jour les champs de ressource","it":"Aggiorna campi risorsa","ja":"アセットのフィールドを更新"},"synchronizeAutoSyncFolder":{"en":"Sync Autosync Folders","de":"Autosync-Ordner synchronisieren","es":"Sincronizar carpetas de sincronización automática","fr":"Synchroniser les dossiers Autosync","it":"Cartelle Sync Autosync","ja":"監視フォルダを同期"},"ASSETS":{"en":"Assets","de":"Assets","es":"Activos","fr":"Éléments","it":"Risorse","ja":"アセット"},"CATALOG_STORAGE_TYPE_S3":{"en":"S3","de":"S3","es":"S3","fr":"S3","it":"S3","ja":"S3"},"CREATE_CATALOG":{"en":"Create Catalog","de":"Katalog erstellen","es":"Crear catálogo","fr":"Créer une catalogue","it":"Creare catalogo","ja":"カタログを作成"},"STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS":{"en":"The system memory is {value}GB which is below the {minGB}GB minimum requirements.","de":"Der Systemspeicher beträgt {value} GB; dieser Wert unterschreitet die Mindestanforderungen von {minGB} GB.","es":"La memoria del sistema es {value} GB inferior al requisito mínimo de {minGB} GB.","fr":"La mémoire système est {value}Go, ce qui est inférieur à la configuration minimale requise de {minGB}Go.","it":"La memoria di sistema è {value}GB che risulta al di sotto dei requisiti minimi di {minGB}GB","ja":"システムのメモリは{value}GBですが、最小動作環境は{minGB}GBです。"},"STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE":{"en":"The system memory computed by Portfolio is {value}GB which may be inaccurate.","de":"Der von Portfolio berechnete Systemspeicher von {value} GB ist möglicherweise ungenau.","es":"La memoria del sistema calculada por Portfolio es {value}GB. Podría no ser exacta.","fr":"La mémoire système calculée par portefeuille est {value}Go, ce qui peut être inexact.","it":"La memoria di sistema calcolata dal Portfolio è di {value}GB che potrebbe risultare inaccurata.","ja":"Portfolioが計算したシステムのメモリは{value}GBですが、これは正しくない可能性があります。"},"AUTH.couldNotConnect":{"de":"Es konnte keine Verbindung zum Server hergestellt werden. Bitte prüfen Sie die Adresse.","en":"Could not connect to the server. Please check the address.","es":"No fue posible conectar con el servidor. Compruebe la dirección, por favor.","fr":"Ne peut se connecter au serveur. Veuillez vérifier l'adresse.","it":"Impossibile collegarsi al server. Verificare l'indirizzo.","ja":"サーバーに接続できません。アドレスを確認してください。"},"ERROR.serverUnavailable":{"de":"Der Portfolio-Server ist nicht verfügbar.","en":"The Portfolio server is not available.","es":"El servidor del Portfolio no está disponible.","fr":"Le serveur du portefeuille n’est pas disponible.","it":"Il server Portfolio non disponibile.","ja":"Portfolioサーバーを使用できません。"},"ERROR.sessionExpired":{"de":"Ihre Sitzung ist abgelaufen.","en":"Your session has expired.","es":"La sesión ha caducado.","fr":"Votre session a expiré.","it":"La tua sessione è scaduta.","ja":"セッションの期限が切れました。"},"fileNotFound":{"de":"Die Datei wurde auf dem Datenträger nicht gefunden.","en":"The file was not found on disk.","es":"No se encontró el archivo dentro del disco.","fr":"Le fichier n'a pas été trouvé sur le disque.","it":"Il file non è stato trovato su disco.","ja":"ディスク上にファイルが見つかりません。"},"ERROR.invalidSearchFailed":{"de":"Die Suche ist fehlgeschlagen, da es ein Problem mit der Anfrage gab.","en":"The search failed because there was a problem with the query.","es":"La búsqueda ha fallado porque hubo un problema con la consulta.","fr":"La recherche a échoué, car il y a eu un problème avec la demande.","it":"La ricerca è fallita in quanto si è verificato un problema con la richiesta.","ja":"サーバーへのリクエストに問題が発生したため検索に失敗しました。"},"AUTH.loginFailed":{"de":"Nutzername und Kennwort waren falsch.","en":"The username and password were incorrect.","es":"Clave de usuario y contraseña incorrectos.","fr":"Le nom d'utilisateur et le mot de passe étaient incorrects.","it":"Nome utente e password errati.","ja":"ユーザー名とパスワードが間違っています。"},"FAULT_CODE.InsufficientPrivileges":{"de":"Zur Durchführung dieses Vorgangs reichen Ihre Berechtigungen nicht aus.","en":"You have insufficient privileges to perform this operation.","es":"Tiene privilegios insuficientes para realizar esta operación.","fr":"Vous ne disposez pas des autorisations nécessaires pour pouvoir effectuer cette opération.","it":"Per eseguire questa operazione non si dispone dei privilegi sufficienti.","ja":"この操作に必要な権限がありません。"},"unexpectedError":{"de":"Ein unerwarteter Fehler ist aufgetreten.","en":"An unexpected error occurred.","es":"Ha surgido un error inesperado.","fr":"Une erreur inattendue est survenue.","it":"Si è verificato un errore imprevisto.","ja":"予期しないエラーが発生しました。"},"ROLES_CREATE_ROLE_TITLE":{"en":"Create Role","de":"Rolle erstellen","es":"Crear rol","fr":"Créer le Rôle","it":"Creare ruolo","ja":"役割を作成"},"ROLES_DELETE_CONFIRM":{"en":"Do you want to delete the selected Role?\nUsers with this Role will be demoted to Readers.","de":"Möchten Sie die ausgewählte Rolle löschen?\nBenutzer mit dieser Rolle werden zu Lesern zurückgestuft.","es":"¿Desea eliminar el nivel de acceso seleccionado?\nLos usuarios con este Rol serán degradados al nivel de Lector.","fr":"Désirez-vous supprimer le rôle sélectionné?\nLes utilisateurs avec ce rôle seront reclassés au niveau inférieur de Lecteur.","it":"Si intende cancellare il ruolo selezionato?\nGli utenti con tale ruolo saranno declassati a lettori.","ja":"選択した役割を削除しますか？\nこの役割のユーザーは閲覧者になります。"},"NOTIFICATION_SUCCESS_UPDATE":{"en":"Update Successful","de":"Update erfolgreich","es":"Actualización con éxito","fr":"Mise à jour réussie","it":"Aggiornamento avvenuto con successo","ja":"アップデートに成功しました"},"DATA_COLLECTION_TITLE":{"en":"Analytics","de":"Analyse","es":"Análisis","fr":"Analytique","it":"Analisi","ja":"分析"},"DATA_COLLECTION_RTI_OPT_OUT_LABEL":{"en":"I agree to share application usage data.","de":"Ich stimme der Weitergabe der Anwendungsnutzungsdaten zu.","es":"Acepto compartir datos de uso de aplicaciones.","fr":"Je suis d’accord pour partager des données d’utilisation sur l’application.","it":"Accetto di condividere i dati sull’utilizzo dell’applicazione.","ja":"私は、アプリケーションの使用データを共有することに同意します。"},"DATA_COLLECTION_RTI_OPT_OUT_TEXT":{"en":"Help us deliver the best solutions by sharing application usage with us.\n\nBy accepting, you'll help us gather important information that will guide us toward future quality and feature improvements. The information gathered helps us greatly understand your solution needs.\n\nYou can always change your mind at any time and discontinue sharing information.\n\nFor more information about how we use your information and to opt-out in the future please visit our help article page:","de":"Helfen Sie uns, die besten Lösungen anzubieten, indem Sie die Nutzung der Anwendung mit uns teilen.\n\nWenn Sie akzeptieren, helfen Sie uns wichtige Informationen zu sammeln, die uns unterstützen, die Qualität weiter zu verbessern und Optimierungen vorzunehmen. Die Informationen werden helfen uns, Ihre Anforderungen an die Lösung zu verstehen.\n\nSie können Ihre Meinung jederzeit ändern und das Teilen von Informationen beenden.\n\nWeiterführende Informationen dazu, wie wir Ihre Daten nutzen und wie Sie sich künftig anderweitig entscheiden können, entnehmen bitte dem Artikel auf der Hilfe-Seite: ","es":"Ayúdenos a ofrecer las mejores soluciones compartiendo el uso de aplicaciones con nosotros.\n\nAl aceptar, nos ayudará a recopilar información importante que nos guiará hacia futuras mejoras en la calidad y las funciones. La información recopilada nos ayudará a comprender cuáles son las soluciones que necesita.\n\nPuede siempre cambiar de opinión en cualquier momento y dejar de compartir la información.\n\nPara más información acerca de cómo utilizaremos sus datos y retirarse en el futuro, visite nuestra página de artículo de ayuda: ","fr":"Aidez-nous à fournir les meilleures solutions en partageant l'utilisation de l'application avec nous.\n\nEn acceptant, vous nous aiderez à rassembler des informations importantes qui vont nous guider afin d’améliorer la qualité et les caractéristiques futures. Les informations rassemblées nous aident à comprendre vos besoins.\n\nVous pouvez toujours changer d’avis à tout moment et interrompre le partage des informations.\n\nPour plus d’informations sur la manière d’utiliser vos informations et vous désabonner dans le futur, veuillez consulter notre page d’aide: ","it":"Aiutaci a fornire le migliori soluzioni possibili condividendo l’uso dell’applicazione con noi.\n\nAccettando, ci aiuterai a raccogliere informazioni importanti che ci guideranno verso miglioramenti futuri in termini di qualità e funzionalità. I dati raccolti ci consentono di capire ciò che gli utenti si aspettano da una soluzione.\n\nPuoi sempre cambiare idea in qualsiasi momento e interrompere la condivisione delle tue informazioni.\n\nPer sapere di più su come utilizziamo le tue informazioni e per esercitare in futuro il diritto di opt-out, visita la pagina dell’articolo guida: ","ja":"アプリケーションの使用状況を共有して、当社が最適なソリューションを提供できるようにご協力ください。\n\nこれにより、今後の品質や機能の向上に役立つ重要な情報を収集することができます。収集された情報は、お客様のソリューションニーズを理解するのに役立ちます。\n\n情報のご提供はいつでも中止できます。\n\n収集した情報の使用方法や情報提供を中止する方法の詳細については、次の記事をご確認ください。 "},"DATA_COLLECTION_HELP_URL":{"en":"https://help.portfoliodam.com/hc/en-us/articles/1260804371029","de":"https://help.portfoliodam.com/hc/de/articles/1260804371029","es":"https://help.portfoliodam.com/hc/es/articles/1260804371029","fr":"https://help.portfoliodam.com/hc/fr/articles/1260804371029","it":"https://help.portfoliodam.com/hc/it/articles/1260804371029","ja":"https://help.portfoliodam.com/hc/ja/articles/360010122274"},"CREATE_USER":{"en":"Create User","de":"Benutzer erstellen","es":"Crear Usuario","fr":"Créer un utilisateur","it":"Crea utente","ja":"ユーザーを作成"},"CATALOG_FILES_TAB_TITLE":{"en":"Ingest","de":"Aufnehmen","es":"Procesar","fr":"Ingérer","it":"Assimilare","ja":"取り込み"},"FIELD_CATEGORY_ALL":{"en":"All Active Fields","de":"Alle aktiven Felder","es":"Todos los campos activos","fr":"Tous Champs Actifs","it":"Tutti i campi attivi","ja":"全使用中フィールド"},"FIELD_CATEGORY_FONTSENSE":{"en":"Portfolio DAM Font Sense","de":"Portfolio DAM Font Sense","es":"Portfolio DAM Font Sense","fr":"Portfolio DAM Font Sense","it":"Portfolio DAM Font Sense","ja":"Portfolio DAM Font Sense"},"FIELD_DEF.cataloged":{"de":"Katalogisiert am","en":"Cataloged","es":"Catalogado","fr":"Catalogué","it":"Catalogato","ja":"カタログ登録日"},"FIELD_DEF.catalogedBy":{"de":"Katalogisiert von","en":"Cataloged By","es":"Catalogado por","fr":"Catalogué par","it":"Catalogato da","ja":"カタログ登録者"},"FIELD_DEF.colorMode":{"de":"Farbmodus","en":"Color Mode","es":"Modo de color","fr":"Mode couleur","it":"Modalità colore","ja":"カラーモード"},"FIELD_DEF.isPanoramic":{"de":"Panoramisch","en":"Panoramic","es":"Panorámica","fr":"Panoramique","it":"Panoramica","ja":"パノラマ"},"FIELD_DEF.created":{"de":"Erstellt am","en":"Created","es":"Creado","fr":"Créé","it":"Creato","ja":"作成日"},"FIELD_DEF.directoryPath":{"de":"Verzeichnispfad","en":"Directory Path","es":"Ruta de directorios","fr":"Chemin du répertoire","it":"Percorso directory","ja":"ディレクトリパス"},"FIELD_DEF.documentText":{"de":"Dokumententext","en":"Document Text","es":"Texto del documento","fr":"Compléter le texte","it":"Testo documento","ja":"文書テキスト"},"FIELD_DEF.filename":{"de":"Dateiname","en":"Filename","es":"Nombre de archivo","fr":"Nom de fichier","it":"Nome file","ja":"ファイル名"},"FIELD_DEF.fileDescription":{"de":"Beschreibung","en":"Description","es":"Descripción","fr":"Description","it":"Descrizione","ja":"説明"},"FIELD_DEF.fileSize":{"de":"Dateigröße","en":"File Size","es":"Tamaño de archivo","fr":"Taille du fichier","it":"Dimensione file","ja":"ファイルサイズ"},"FIELD_DEF.geometry":{"de":"Geo - Karte","en":"Geo - Map","es":"Geo - Correspondencia","fr":"Geo - Carte","it":"Geo - Programma","ja":"Geo - マップ"},"FIELD_DEF.height":{"de":"Höhe","en":"Height","es":"Altura","fr":"Hauteur","it":"Altezza","ja":"高さ"},"FIELD_DEF.horizontalResolution":{"de":"Horizontal Resolution","en":"Horizontal Resolution","es":"Resolución horizontal","fr":"Horizontal Resolution","it":"Risoluzione orizzontale","ja":"水平解像度"},"FIELD_DEF.keywords":{"de":"Schlüsselwörter","en":"Keywords","es":"Palabras clave","fr":"Mots-clés","it":"Parole chiave","ja":"キーワード"},"FIELD_DEF.lastModified":{"de":"Modifiziert","en":"Modified","es":"Modificado","fr":"Modifié","it":"Modificato","ja":"変更日"},"FIELD_DEF.lastUpdated":{"de":"Geändert","en":"Changed","es":"Cambiado","fr":"Changé","it":"Cambiato","ja":"設定日"},"FIELD_DEF.aliasMac":{"de":"Alias (Mac)","en":"Alias Mac","es":"Mac de alias","fr":"Alias Mac","it":"Alias Mac","ja":"Mac エイリアス"},"FIELD_DEF.creatorMac":{"de":"Erstellungsprogramm (Mac)","en":"Creator Mac","es":"Mac de creador","fr":"Créateur pour Mac","it":"Autore Mac","ja":"クリエータ (Mac)"},"FIELD_DEF.fileTypeMac":{"de":"Dateityp (Mac)","en":"File Type Mac","es":"Mac de tipo de archivo","fr":"Type de fichier Mac","it":"Tipo di file Mac","ja":"ファイルタイプ (Mac)"},"FIELD_DEF.zoneMac":{"de":"Zone (Mac)","en":"Zone Mac","es":"Mac de zona","fr":"Zone Mac","it":"Zona Mac","ja":"AppleTalk ゾーン"},"FIELD_DEF.multipageCount":{"de":"Anzahl von Seiten","en":"Number of Pages","es":"Número de páginas","fr":"Nombre de pages","it":"Numero pagine","ja":"ページ数"},"FIELD_DEF.numBands":{"de":"Zahl der Bänder","en":"Number of Bands","es":"Número de vendas","fr":"Nombre de bandes","it":"Numero delle fasce","ja":"バンドの番号"},"FIELD_DEF.path":{"de":"Pfad","en":"Path","es":"Ruta","fr":"Chemin","it":"Percorso","ja":"パス"},"FIELD_DEF.ItemID":{"de":"Asset-ID","en":"Asset ID","es":"ID de activo","fr":"ID d’élément","it":"ID risorsa","ja":"アセット ID"},"FIELD_DEF.shortFilenameWin":{"de":"Kurzer Dateiname (Win)","en":"Short Filename Win","es":"Nombre de archivo corto Windows","fr":"Nom de fichier court Win","it":"Nome file corto Win","ja":"ショートファイル名 (Win)"},"FIELD_DEF.thumbnailSize":{"de":"Thumbnailgröße","en":"Thumbnail Size","es":"Tamaño de miniatura","fr":"Taille de vue miniature","it":"Formato miniatura","ja":"サムネールのサイズ"},"FIELD_DEF.updatedBy":{"de":"Geändert von","en":"Changed By","es":"Cambiado por","fr":"Modifié par","it":"Modificato da","ja":"設定者"},"FIELD_DEF.verticalResolution":{"de":"Vertikale Auflösung","en":"Vertical Resolution","es":"Resolución vertical","fr":"Résolution verticale","it":"Risoluzione verticale","ja":"垂直解像度"},"FIELD_DEF.volume":{"de":"Volume","en":"Volume","es":"Volumen","fr":"Volume","it":"Volume","ja":"ボリューム名"},"FIELD_DEF.watermarkURL":{"de":"Wasserzeichen-URL","en":"Watermark URL","es":"URL de marca de agua","fr":"Adresse Internet du filigrane","it":"URL filigrana","ja":"透かしの URL"},"FIELD_DEF.watermarked":{"de":"Mit Wasserzeichen","en":"Watermarked","es":"Marca de agua","fr":"Avec filigrane","it":"Filigranato","ja":"透かし付き"},"FIELD_DEF.width":{"de":"Breite","en":"Width","es":"Anchura","fr":"Largeur","it":"Larghezza","ja":"幅"},"FIELD_DEF.SuggestedKeywords":{"en":"Smart Keywords","de":"Smart Keywords","es":"Smart Keywords","fr":"Smart Keywords","it":"Smart Keywords","ja":"Smart Keywords"},"REFRESH":{"de":"Aktualisieren","en":"Refresh","es":"Actualizar","fr":"Actualiser","it":"Aggiorna","ja":"更新"},"ALL_CATALOGS":{"en":"All Catalogs","de":"Alle Kataloge","es":"Todos los catálogos","fr":"Tous les catalogues","it":"Tutti i cataloghi","ja":"すべてのカタログ"},"ALL_SITES":{"en":"All Sites","de":"Alle Sites","es":"Todos Los Sitios","fr":"Tous les sites","it":"Tutti i Site","ja":"すべてのサイト"},"ASSET_DOWNLOADS":{"en":"Assets - Most Downloaded","de":"Assets - Häufigste Downloads","es":"Activos - Los más descargados","fr":"Actifs - les plus téléchargés","it":"Asset - maggiormente scaricati","ja":"アセット - 最多ダウンロード"},"ASSET_PREVIEWS":{"en":"Assets - Most Previewed","de":"Assets - Häufigste Voransicht","es":"Activos - Los más vistos previamente","fr":"Actifs - Les plus prévisualisés","it":"Asset - maggiormente visualizzati in anteprima","ja":"アセット - 最多プレビュー"},"ASSET_UPLOADS":{"en":"Assets - Uploads","de":"Assets - Uploads","es":"Activos - Cargas","fr":"Actif - Publications en ligne","it":"Asset - caricamenti","ja":"アセット - アップロード"},"DOWNLOAD_REPORT":{"en":"Download Report","de":"Report downloaden","es":"Descargar Reporte","fr":"Télécharger le rapport","it":"Download","ja":"レポートをダウンロード"},"FILE_TYPES":{"en":"File Types","de":"Speichertypen","es":"Tipos de archivo","fr":"Types de fichiers","it":"Tipi di file","ja":"ファイルタイプ"},"FILE_TYPES_SECTION_TITLE":{"en":"File Types","de":"Speichertypen","es":"Tipos de archivo","fr":"Types de fichiers","it":"Tipi di file","ja":"ファイルタイプ"},"FILE_TYPES_ERROR_NAME_EXISTS":{"en":"The name '{name}' matches the name of an existing file type.","de":"Der '{name}‘-Name stimmt mit dem Namen des vorhandenen Dateityps überein.","es":"El nombre '{name}' coincide con el nombre de un tipo de archivo existente.","fr":"Le nom « {name} » correspond au nom d’un type de fichier existant.","it":"Il nome '{name}' concorda con il nome di un tipo di file esistente.","ja":"{name}' は既存のファイ"},"FILE_TYPES_LABEL_RESTORE_DEFAULTS":{"en":"Reset Defaults","de":"Auf Standardwerte zurücksetzen","es":"Restablecer valores predeterminados","fr":"Réinitialiser les valeurs par défauts","it":"Ripristina valori predefiniti","ja":"初期化"},"FILE_TYPES_PROMPT_DISCARD_CHANGES":{"en":"Discard pending changes?","de":"Ausstehende Änderungen verwerfen?","es":"¿Descartar cambios pendientes?","fr":"Ignorer les modifications en attente ?","it":"Eliminare le modifiche in sospeso?","ja":"保留中の変更を破棄しますか？"},"FILE_TYPES_ADD_FILE_TYPE":{"en":"Add File Type","de":"Dateityp hinzufügen","es":"Añadir tipo de archivo","fr":"Ajouter le type de fichier","it":"Aggiungi tipo di file","ja":"ファイルタイプを追加"},"FILE_TYPES_UPDATE_FILE_TYPE":{"en":"Update File Type","de":"Dateityp aktualisieren","es":"Actualizar tipo de archivo","fr":"Mettre à jour le type de fichier","it":"Aggiorna tipo di file","ja":"ファイルタイプを更新"},"FILE_TYPES_EXTENSIONS":{"en":"Extensions","de":"Erweiterungen","es":"Extensiones","fr":"Extensions","it":"Estensioni","ja":"拡張子"},"FROM":{"en":"From","de":"Von","es":"De","fr":"Du","it":"da","ja":"から"},"SITE":{"en":"Site","de":"Site","es":"Sitio","fr":"Site","it":"Site","ja":"サイト"},"KEYWORD_STATISTICS":{"en":"Keyword Statistics","de":"Keyword Statistik","es":"Estadísticas de palabras clave","fr":"Statistiques sur les mots-clés","it":"Statistiche Parole chiave","ja":"キーワード統計"},"NETPUBLISH_MOST_DOWNLOADED":{"en":"NetPublish - Most Downloaded","de":"NetPublish - beliebteste Downloads","es":"Lo más descargado de NetPublish","fr":"NetPublish - Les plus téléchargés","it":"NetPublish - Più Scaricato","ja":"NetPublish - ダウンロード状況"},"NETPUBLISH_USAGE":{"en":"NetPublish - Usage","de":"NetPublish - Nutzung","es":"Uso de NetPublish","fr":"NetPublish - Usage","it":"NetPublish - Uso","ja":"NetPublish - 使用状況"},"REPORT_DESCRIPTION_ASSET_PREVIEWS":{"en":"This report identifies which assets were previewed and how many times each was previewed.","de":"Dieser Bericht enthält alle Asset-Voransichten und wie häufig jeder Posten angesehen wurde.","es":"Este informe identifica qué activos han sido descargados y cuántas veces se descargó cada uno.","fr":"Ce rapport identifie les ressources qui ont été prévisualisées et combien de fois chacune a été prévisualisée.","it":"Tale report identifica quali asset siano stati visualizzati in anteprima e quante volte ognuno di questi sia stato visualizzato in anteprima.","ja":"どのアセットがそれぞれ何回プレビューされたかについてのレポートです。"},"REPORT_DESCRIPTION_ASSET_UPLOADS":{"en":"This report identifies uploaded assets, which users uploaded them, and when.","de":"Dieser Bericht enthält alle hochgeladenen Assets, die Benutzer, die diese hochgeladen haben, und den Zeitpunkt.","es":"En este informe se identifican los activos cargados, los usuarios que los cargaron, y cuándo.","fr":"Ce rapport identifie les ressources téléchargées, les utilisateurs qui les ont téléchargées et à quel moment.","it":"Tale report identifica gli asset caricati, quali utenti li abbiano caricati e quando.","ja":"アップロードされたアセット、アップロードしたユーザー、そしてその日時についてのレポートです。"},"REPORT_DESCRIPTION_DOWNLOADED":{"en":"This report identifies which assets were downloaded and how many times each was downloaded.","de":"Dieser Bericht zeigt welche Posten heruntergeladen wurden und wie oft jeder heruntergeladen wurde.","es":"Este informe identifica qué activos han sido descargados y cuántas veces se descargó cada uno.","fr":"Ce rapport identifie les ressources qui ont été téléchargées et combien de fois chacune a été téléchargée.","it":"Questo report identifica quali risorse sono state scaricate e quante volte al giorno sono state scaricate.","ja":"どのアセットがそれぞれ何回ダウンロードされたかについてのレポートです。"},"REPORT_DESCRIPTION_KEYWORD":{"en":"This report identifies all the keywords in a catalog and how many assets they are applied to.","de":"In diesem Bericht werden alle Schlüsselwörter in einem Katalog identifiziert und wie viele Posten Ihnen zugeordnet sind.","es":"Este informe identifica todas las palabras clave del catálogo y a cuántos activos se han aplicado.","fr":"Ce rapport identifie tous les mots-clés dans un catalogue et dénombre les ressources auxquelles ils sont appliqués.","it":"Questo report identifica tutte le parole chiave in catalogo e a quante risorse si applicano.","ja":"カタログの全キーワードとそれらが適用されているアセット数についてのレポートです。"},"REPORT_DESCRIPTION_USAGE":{"en":"This report identifies which users downloaded which assets, and when.","de":"Dieser Bericht zeigt, welche Nutzer welche Posten heruntergeladen haben und wann.","es":"Este informe identifica qué usuarios han descargado qué activos y cuándo.","fr":"Ce rapport identifie quels utilisateurs ont téléchargé quelles ressources, et quand.","it":"Questo report include quali utenti hanno scaricato risorse e quando.","ja":"どのユーザーが何のアセットをいつダウンロードしたかについてのレポートです。"},"SEARCH_TERMS":{"en":"Search Terms","de":"Suchtypen","es":"Buscar términos","fr":"Termes de recherche","it":"Termini di ricerca","ja":"検索語句"},"TO":{"en":"To","de":"Bis","es":"Hasta","fr":"Au","it":"a","ja":"まで"},"VIEW_REPORT":{"en":"View Report","de":"Bericht anzeigen","es":"Ver informe","fr":"Voir le rapport","it":"Visualizza report","ja":"レポートを表示"},"NP_SITES":{"en":"NetPublish Sites","de":"NetPublish-Seiten","es":"Sitios NetPublish","fr":"Sites NetPublish","it":"Siti NetPublish","ja":"NetPublishサイト"},"REPORT_NAME_DELETED_BY":{"en":"Assets - Deletions","de":"Assets - Löschungen","es":"Activos - Eliminaciones","fr":"Actifs - Suppressions","it":"Asset - cancellazioni","ja":"アセット - 削除"},"REPORT_NAME_DOWNLOADED_BY":{"en":"Assets - Downloads","de":"Assets - Downloads","es":"Activos - Descargas","fr":"Actifs - Téléchargements","it":"Asset - download","ja":"アセット - ダウンロード"},"REPORT_DESCRIPTION_DELETED_BY":{"en":"This report identifies deleted assets, which users deleted them, and when.","de":"Dieser Bericht enthält alle gelöschten Assets, die Benutzer, die diese gelöscht haben, und den Zeitpunkt.","es":"En este informe se identifican los activos eliminados, los usuarios que los han eliminado, y cuándo.","fr":"Ce rapport identifie les ressources supprimées, les utilisateurs qui les ont supprimées età quel moment.","it":"Tale report identifica gli asset modificati, quali utenti li abbiano cancellati e quando.","ja":"削除されたアセット、削除したユーザー、そしてその日時についてのレポートです。"},"REPORT_DESCRIPTION_DOWNLOADED_BY":{"en":"This report identifies downloaded assets, which users downloaded them, and when.","de":"Dieser Bericht enthält alle heruntergeladenen Assets, die Benutzer, die diese heruntergeladen haben, und den Zeitpunkt.","es":"En este informe se identifican los activos descargados, los usuarios que los descargaron, y cuándo.","fr":"Ce rapport identifie les ressources téléchargées, les utilisateurs qui les ont téléchargées età quel moment.","it":"Tale report identifica gli asset scaricati, quali autenti li abbiano scaricati e quando.","ja":"ダウンロードされたアセット、ダウンロードしたユーザー、そしてその日時についてのレポートです。"},"CATALOG_SAVE_TEMPLATE_TITLE":{"en":"Save Catalog Template","de":"Katalogvorlage erstellen","es":"Guardar plantilla de catálogo","fr":"Sauvegarder le modèle de catalogue","it":"Creazione modello catalogo","ja":"カタログテンプレートを作成"},"BACKUP_FILES_LABEL":{"en":"Backup Files","de":"Backup-Dateien","es":"Archivos copia de seguridad","fr":"Fichiers de sauvegarde","it":"File di backup","ja":"バックアップファイル"},"CONFIGURE_EMAIL_LINK":{"en":"Configure email notifications...","de":"E-Mail-Benachrichtigungen konfigurieren...","es":"Configurar notificaciones de correo electrónico...","fr":"Configurer les notifications par courriel…","it":"Configurazione notifiche email...","ja":"Email通知を設定"},"NP_SOURCE":{"en":"Source","de":"Quelle","es":"Fuente","fr":"Source","it":"Sorgente","ja":"ソース"},"NOTIFICATION_FAILURE_UPDATE":{"en":"Update Unsuccessful","de":"Update nicht erfolgreich","es":"Fracasó la actualización","fr":"La mise à jour à échoué","it":"Aggiornamento avvenuto senza successo","ja":"アップデートに失敗しました"},"FIELD_FORM_LABEL_PRECISION_MAX":{"en":"Max","de":"Max","es":"Máx","fr":"Max","it":"Max","ja":"最大"},"REPORT_DESCRIPTION_FILE_TYPES":{"en":"This report identifies your most common file types and how much disk space they occupy.","de":"Dieser Bericht enthält die häufigsten Speichertypen und deren Festplattenbelegung.","es":"Este informe identifica los tipos de archivo más comunes y el espacio en disco que ocupan.","fr":"Ce rapport identifie vos types de fichiers les plus courants et l'espace disque qu'ils occupent.","it":"Tale report identifica le tipologie di file più comuni e quanto spazio su disco viene occupato.","ja":"最も一般的なファイルタイプとそのディスク容量についてのレポートです。"},"REPORT_DESCRIPTION_SEARCH_TERMS":{"en":"This report identifies the most common words and phrases for which your users are searching in QuickFind.","de":"Dieser Bericht enthält die häufigsten Wörter und Sätze, nach denen Ihre Benutzer suchen.","es":"Este informe identifica las palabras y frases más comunes que buscan los usuarios.","fr":"Ce rapport identifie les mots et expressions les plus courants que vos utilisateurs recherchent.","it":"Il presente report identifica le parole e le frasi più comuni per le quali gli utenti stanno svolgendo ricerche.","ja":"最も一般的な検索語句についてのレポートです。"},"DUPLICATE_FIELD_NAME_ERROR":{"en":"Duplicate Field Name","de":"Doppelte Feldnamen","es":"Campo Nombre duplicado","fr":"Duplication du nom du champ","it":"Nome campo duplicato","ja":"フィールド名を複製"},"NO_CATALOGS_EXIST":{"en":"No Catalogs exist.\n\nClick the + button to create a Catalog.","de":"Es sind keine Kataloge vorhanden.\n\n-klicken Sie auf die Schaltfläche +, um einen Katalog zu erstellen.","es":"No existen catálogos.\n\nHaga clic en el botón + para crear un Catálogo.","fr":"Aucun catalogue existant.\n\nCliquez sur le bouton + pour créer un catalogue.","it":"Non esistono cataloghi.\n\nClicca sul pulsante + per creare un catalogo.","ja":"カタログがありません。\n\n+ボタンをクリックしてカタログを作成してください。"},"CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS":{"en":"Change {affectedUsersCount, plural, one {Role} other {Roles}}","de":"Rollentausch","es":"Cambiar Roles","fr":"Changer les rôles","it":"Cambia Ruolo","ja":"役割を変更します"},"REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE":{"en":"Remove {affectedUsersCount, plural, one {User} other {{affectedUsersCount} Users}} from Catalog","de":"Mitgliedschaft aufheben","es":"Annulla membership","fr":"Révoquer l'adhésion","it":"Cancelar socio","ja":"メンバシップを取り消し"},"REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG":{"en":"Are you sure you want to remove the {affectedUsersCount, plural, one {user} other {selected users}} from the catalog?\n\nThe {affectedUsersCount, plural, one {user's} other {selected users'}} Checked Out items in this catalog will be reverted and made accessible.","de":"Den Nutzer aus dem Katalog entfernen? \nDie aus diesem Katalog ausgechecktenArtikel werden zurückgegeben und zur Verfügung gestellt.","es":"¿Eliminar este usuario del catálogo?\nLos elementos en Salida del usuario se revertirán y se podrá acceder a estos.","fr":"Supprimer l’utilisateur du catalogue ?\nLes éléments extraits des utilisateurs dans ce catalogue seront restaurés et rendus accessibles.","it":"Rimuovi l'utente dal catalogo?\nGli articoli Pagati dall’utente in questo catalogo saranno ripristinati e resi accessibili.","ja":"カタログからユーザーを削除しますか？\nユーザーのこのカタログのチェックアウトアイテムが復帰して、アクセス可能になります。"},"CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG":{"en":"Are you sure you want to change the {affectedUsersCount, plural, one {user's role} other {selected users' roles}} in the catalog?\n\nThis action can be destructive to the {affectedUsersCount, plural, one {user's} other {selected users'}} data if the new role has reduced access or permissions.","de":"Möchten Sie die Rolle des Benutzers im Katalog wirklich ändern? Dieses Vorgehen kann die Daten des Benutzers löschen, wenn die neue Rolle über eingeschränkte Zugriffsrechte oder Berechtigungen verfügt.","es":"¿Está seguro de que desea cambiar el rol del usuario en el catálogo? Esta acción puede resultar en la eliminación de los datos del usuario si el nuevo rol tiene acceso o permisos reducidos.","fr":"Voulez-vous vraiment modifier le rôle de l’utilisateur dans le catalogue ? Cette action risque de détruire les données de l’utilisateur si l'accès ou les autorisations liés au nouveau rôle sont réduits.","it":"Vuoi davvero modificare il ruolo dell'utente nel catalogo? Se il nuovo ruolo ha accesso o autorizzazioni ridotti, questa azione può essere distruttiva per i dati dell'utente.","ja":"本当にユーザーの役割を変更しますか？変更後の役割に許可されている機能が少ないと、ユーザーのデータが失われる可能性があります。"},"DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE":{"en":"Querying\nThis may take a few minutes...","de":"Abfragen. Das kann ein paar Minuten dauern...","es":"Consultando. Esto puede tardar unos minutos...","fr":"Requête en cours. Cela peut prendre quelques minutes...","it":"Interrogazione in corso... Questa operazione potrebbe richiedere alcuni minuti.","ja":"問い合わせ中です。数分かかる可能性があります。"},"FIELD_DELETE_CONFIRM_MSG":{"en":"Do you want to delete the selected field?","de":"Möchten Sie das ausgewählte Feld löschen?","es":"¿Desea borrar el campo seleccionado?","fr":"Voulez-vous supprimer le champ sélectionné ?","it":"Vuoi cancellare il campo selezionato?","ja":"選択したフィールドを削除しますか？"},"FILE_TYPES_PROMPT_RESTORE_DEFAULTS":{"en":"Reset all FileTypes to their default values?","de":"Alle Dateitypen auf ihre Standardwerte zurücksetzen?","es":"¿Restablecer todos los tipos de archivo a sus valores predeterminados?","fr":"Réinitialiser tous les types de fichiers à leurs valeurs par défaut ?","it":"Ripristinare tutti i Tipi di file ai loro valori predefiniti?","ja":"全てのファイルタイプを初期化しますか？"},"DIRECTORY_SERVICE_BROWSE_FILTER_LABEL":{"en":"Filter","de":"Filter","es":"Filtro","fr":"Filtre","it":"Filtra","ja":"フィルタ"},"DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL":{"en":"AD Users and Groups","de":"AD-Benutzer und -Gruppen","es":"AD Usuarios y grupos","fr":"Active Directory pour utilisateurs et groupes","it":"AD utenti e gruppi","ja":"AD ユーザーとグループ"},"DIRECTORY_SERVICE_SAVE_MAPPINGS":{"en":"Save and Sync","de":"Speichern und synchronisieren","es":"Guardar y sincronizar","fr":"Enregistrer et synchroniser","it":"Salva e sincronizza","ja":"保存して同期"},"DIRECTORY_SERVICE_REMOVE_MAPPING":{"en":"Remove Mapping","de":"Zuordnung entfernen","es":"Eliminar mapeo","fr":"Supprimer le mappage","it":"Rimuovi mappatura","ja":"マッピングを削除"},"DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL":{"en":"Portfolio User Imports","de":"Portfolio-Benutzerimporte","es":"Importaciones de usuario Portfolio","fr":"Importations d'utilisateurs de Portfolio","it":"Portfolio importazioni utente","ja":"Portfolioユーザーの取り込み"},"DIRECTORY_SERVICE_NO_MAPPINGS_LABEL":{"en":"No Mappings\n\nTo create a mapping, select a user or group to the left, and click 'Create Mapping'","de":"Keine Zuordnungen.\n\nUm eine Zuordnung zu erstellen, wählen Sie links einen Benutzer oder eine Gruppe aus und klicken Sie auf 'Zuordnung erstellen'.","es":"No hay Correspondencias.\n\nPara crear una correspondencia, seleccione un usuario o grupo a la izquierda y haga clic en 'Crear correspondencia'.","fr":"Aucun mappage.\n\nPour créer un mappage, sélectionnez un utilisateur ou un groupe sur la gauche, puis cliquez sur « Créer un mappage ».","it":"Nessuna mappatura.\n\nPer crearne una, seleziona un utente o un gruppo a sinistra, quindi clicca su 'Crea Mappatura'.","ja":"マッピングがありません。\n\nユーザーかグループを選択して「マッピングを作成」をクリックしてください。"},"NOTIFICATION_FAILURE_ADD":{"en":"Add Unsuccessful","de":"Hinzufügen fehlgeschlagen","es":"No se ha podido agregar","fr":"Erreur lors de l’ajout.","it":"Aggiunta non riuscita","ja":"追加失敗"},"FIELD_ADD_EXTRACT_METADATA":{"en":"Add Extract Metadata","de":"Extraktionszuordnung hinzufügen","es":"Añadir mapa de extracción","fr":"Ajouter le mappage de l’extrait","it":"Aggiungi Estrai mappatura","ja":"抽出マッピングを追加"},"FIELD_MULTIPLE_EMBED_WARNING":{"en":"More than one field embeds to","de":"Es wird mehr als ein Feld in","es":"Más de un campo se integra en","fr":"Plus d’un champ est intégré dans","it":"Più di un campo si incorpora su","ja":"複数のフィールドが に埋め込まれます"},"CATALOG_SK_KEYWORD_ON_CATALOG_LABEL":{"en":"Smart Keyword newly cataloged assets","de":"Smart Keyword, neu katalogisierte Assets","es":"Nuevos activos de palabras clave inteligentes catalogadas","fr":"Mots-clés intelligents nouveaux actifs catalogués","it":"Smart Keyword per beni di recente catalogazione","ja":"カタログに新規登録されたアセットにSmart Keywordを追加"},"LIC_CLICK_TO_UPGRADE":{"en":"Click to upgrade Portfolio Server","de":"Hier klicken, um den Portfolio Server zu aktualisieren","es":"Haga clic para actualizar Portfolio Server","fr":"Cliquez pour mettre à niveau Portfolio Server","it":"Cliccare per aggiornare Portfolio Server","ja":"Portfolio Serverをアップグレードするにはクリックします。"},"LIC_MAINTENANCE_END_DATE":{"en":"Maintenance/Subscription End Date","de":"Wartungs- / Abonnement-Enddatum","es":"Fecha de finalización de mantenimiento / suscripción","fr":"Date de fin de maintenance / abonnement","it":"Data di fine della manutenzione / sottoscrizione","ja":"メンテナンス/サブスクリプションの終了日"},"LIC_SEAT_DISPLAY":{"en":"User Seats","de":"Benutzer-Lizenzen","es":"Puestos del usuario","fr":"Sièges utilisateur","it":"Postazioni utente","ja":"シートを使用"},"LIC_ACTIVATE":{"en":"Activate Portfolio","de":"Portfolio aktivieren (Anmeldedaten erforderlich)","es":"Active Portfolio (Se requieren credenciales)","fr":"Activer Portfolio (identifiants requis)","it":"Attivare Portfolio (Credenziali Necessarie)","ja":"Portfolioをアクティベート (要認証情報)"},"LIC_CLICK_TO_ACTIVATE":{"en":"Activate Portfolio with your Portfolio DAM credentials","de":"Hier klicken, um den Portfolio Server zu aktivieren","es":"Haga clic para activar Portfolio Server","fr":"Cliquez pour activer Portfolio Server","it":"Cliccare per attivare Portfolio Server","ja":"Portfolio Serverをアクティベートするにはクリックします。"},"LIC_CLICK_TO_USE":{"en":"Try Portfolio for a limited time with a Demo Serial Number","de":"Hier klicken, um Portfolio für einen begrenzte Zeitraum zu verwenden","es":"Haga clic para utilizar Portfolio por un periodo de tiempo limitado","fr":"Cliquez pour utiliser Portfolio pendant une durée limitée","it":"Cliccare per utilizzare Portfolio per un periodo di tempo limitato","ja":"Portfolioを一時的に使用するにはクリックします。"},"LIC_TRIAL":{"en":"Try Portfolio","de":"Portfolio testen (Seriennummer erforderlich)","es":"Portfolio de prueba (Se requiere número de serie)","fr":"Tester Portfolio (numéro de série requis)","it":"Prova Portfolio (Numero di Serie Necessario)","ja":"Portfolioを試用 (要シリアル番号)"},"EXTENSIS_CONTACT_US_URL":{"en":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","de":"https://www.portfoliodam.com/de/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","es":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","fr":"https://www.portfoliodam.com/fr/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","it":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option","ja":"https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option"},"EXTENSIS_SUPPORT_URL":{"en":"https://help.portfoliodam.com/hc/en-us/requests/new","de":"https://help.portfoliodam.com/hc/de/requests/new","es":"https://help.portfoliodam.com/hc/en-us/requests/new","fr":"https://help.portfoliodam.com/hc/fr/requests/new","it":"https://help.portfoliodam.com/hc/en-us/requests/new","ja":"https://help.portfoliodam.com/hc/en-us/requests/new"},"LIC_ERROR_GET_ACCOUNT":{"en":"There was a problem getting your Portfolio DAM Account.","de":"Beim Abrufen Ihres Portfolio DAM-Kontos ist ein Problem aufgetreten.","es":"Surgió un problema al obtener su cuenta Portfolio DAM.","fr":"Un problème s’est produit pour obtenir votre compte Portfolio DAM.","it":"Si è verificato un problema nell'ottenimento del tuo account Portfolio DAM.","ja":"Portfolio DAMアカウントの取得に問題が発生しました。"},"LIC_ERROR_GET_LICENSES":{"en":"There was a problem retrieving your licenses from Portfolio DAM.","de":"Beim Abrufen Ihrer Lizenzen von Portfolio DAM ist ein Problem aufgetreten.","es":"Surgió un problema al recuperar sus licencias de Portfolio DAM.","fr":"Un problème s’est produit lors de la récupération de vos licences Portfolio DAM.","it":"Si è verificato un problema nel recupero delle tue licenze da Portfolio DAM.","ja":"Portfolio DAMからライセンスを復帰するのに問題が発生しました。"},"CHANGE":{"en":"Change","de":"Ändern","es":"Cambiar","fr":"Modifier","it":"Modifica","ja":"変更"},"GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE":{"en":"To change this folder, first shut down Portfolio server","de":"Um diesen Ordner zu ändern, fahren Sie zunächst den Portfolio-Server herunter.","es":"Para cambiar esta carpeta, primero detenga Portfolio.","fr":"Pour modifier ce dossier, vous devez d'abord fermer le serveur Portfolio.","it":"Per modificare questa cartella, prima arresta Portfolio.","ja":"このフォルダを変更するには、Portfolioサーバーを終了してください。"},"MEDIA_ENGINES_COLUMN_TEST":{"en":"Test","de":"Prüfen","es":"Probar","fr":"Tester","it":"Testa","ja":"テスト"},"ROLES_PERMISSIONS":{"en":"Permissions","de":"Berechtigungen","es":"Permisos","fr":"Autorisations","it":"Autorizzazioni","ja":"許可"},"NO_SITES_EXIST_1":{"en":"No NetPublish Sites exist.","de":"Es sind keine NetPublish-Sites vorhanden.","es":"No existen sitios NetPublish.","fr":"Pas de sites NetPublish.","it":"Non esiste alcun sito NetPublish.","ja":"NetPublishサイトがありません"},"NO_SITES_EXIST_2":{"en":"Use the Publish option found within Portfolio to create and publish Sites.","de":"Verwenden Sie die Veröffentlichen-Option in Portfolio, um Sites zu erstellen und zu veröffentlichen.","es":"Utilice la opción Publicar de Portfolio para crear y publicar sitios.","fr":"Utiliser l’option Publier dans Portfolio pour créer et publier des sites.","it":"Utilizza l‘opzione Pubblica trovata in Portfolio per creare e pubblicare siti.","ja":"Portfolio WebのPublishオプションを使用して、サイトを作成して発行してください。"},"MEDIA_ENGINE_NOT_OPERATIONAL":{"en":"The media engine could not be accessed.","de":"Kein Zugriff auf die Media-Engine.","es":"No se pudo acceder al motor de medios.","fr":"Le moteur média n'était pas accessible.","it":"Non è stato possibile accedere ai motori di ricerca mediatici.","ja":"Media Engineは利用不可です。"},"MEDIA_ENGINE_OPERATIONAL":{"en":"The media engine is operational.","de":"Die Media-Engine ist betriebsbereit.","es":"El media engine es operacional.","fr":"Le moteur de médias est opérationnel.","it":"Media engine è operativo.","ja":"Media Engineは稼働中です。"},"LIC_SET_EXTENSIS_ACCOUNT":{"en":"Set Portfolio DAM Account","de":"Portfolio DAM-Konto einrichten","es":"Configure la cuenta Portfolio DAM","fr":"Définir le compte Portfolio DAM","it":"Imposta account Portfolio DAM","ja":"Portfolio DAMアカウントを設定"},"LIC_ACCOUNT":{"en":"Email","de":"E-Mail-Adresse","es":"Dirección de correo electrónico","fr":"Adresse email","it":"Indirizzo e-mail","ja":"電子メールアドレス"},"LIC_PASSWORD":{"en":"Password","de":"Kennwort","es":"Contraseña","fr":"Mot de passe","it":"Password","ja":"パスワード"},"CERTS_TITLE":{"en":"SSL Certificate","de":"SSL-Zertifikat","es":"Certificado SSL","fr":"Certificat SSL","it":"Certificato SSL","ja":"SSL証明書"},"LIC_SYSTEM_ID":{"en":"System ID","de":"System-ID","es":"Identificación del sistema","fr":"ID système","it":"ID sistema","ja":"システムID"},"LIC_SET_ACCOUNT_ERROR":{"en":"There was a problem setting your Portfolio DAM Account. Please check the credentials and try again.","de":"Beim Einrichten Ihres Portfolio DAM-Kontos ist ein Problem aufgetreten. Bitte überprüfen Sie die Zugangsdaten und versuchen Sie es erneut.","es":"Surgió un problema al configurar su cuenta Portfolio DAM. Revise las credenciales e intente de nuevo.","fr":"Un problème s’est produit lors de la configuration de votre compte Portfolio DAM. Veuillez vérifier les identifiants et réessayer.","it":"Si è verificato un problema nell'impostazione del tuo account Portfolio DAM. Controlla le credenziali e riprova.","ja":"Portfolio DAMアカウントの設定に問題が発生しました。認証情報を確認して再度お試しください。"},"LIC_SET_SYSTEM_TITLE":{"en":"Select Your Portfolio DAM System","de":"Wählen Sie Ihr Portfolio DAM-System","es":"Seleccione su sistema Portfolio DAM","fr":"Sélectionnez votre système Portfolio DAM","it":"Seleziona il tuo sistema Portfolio DAM","ja":"Portfolio DAMシステムを選択"},"NP_DELETE_SITE_CONFIRMATION":{"en":"Do you want to permanently delete the Site?","de":"Möchten Sie die Seite dauerhaft löschen?","es":"¿Desea borrar el Sitio de forma permanente?","fr":"Voulez-vous supprimer définitivement le site ?","it":"Vuoi eliminare definitivamente il sito?","ja":"サイトを完全に削除しますか？"},"NP_SITE_DELETE_LABEL":{"en":"Delete Site","de":"Seite löschen","es":"Eliminar sitio","fr":"Supprimer le site","it":"Elimina sito","ja":"サイトを削除"},"NP_SITE_ENABLED_LABEL":{"en":"Site Enabled","de":"Seite aktiviert","es":"Sitio Habilitado","fr":"Site activé","it":"Sito abilitato","ja":"有効サイト"},"CERT_CREATE_REQUEST":{"en":"Create Certificate Request","de":"Zertifikatanforderung erstellen","es":"Crear solicitud de certificado","fr":"Créer une demande de certificat","it":"Crea una richiesta di certificato","ja":"証明書要求を作成"},"CERT_DOWNLOAD":{"en":"Download","de":"Herunterladen","es":"Descargar","fr":"Télécharger","it":"Scarica","ja":"ダウンロード"},"CERT_EXPIRATION_DATE":{"en":"Expiration Date","de":"Gültigkeitsdatum","es":"Fecha de caducidad","fr":"Date d’expiration","it":"Data di scadenza","ja":"有効期限"},"CERT_IMPORT":{"en":"Import Certificate","de":"Ein Zertifikat importieren","es":"Importar un certificado","fr":"Importer un certificat","it":"Importa un certificato","ja":"証明書を取り込む"},"CERT_ISSUER":{"en":"Issuer","de":"Aussteller","es":"Emisor","fr":"Émetteur","it":"Emittente","ja":"発行元"},"CERT_OWNER":{"en":"Owner","de":"Eigentümer","es":"Propietario","fr":"Propriétaire","it":"Proprietario","ja":"所有者"},"CERT_PENDING_REQUEST":{"en":"Pending Certificate Request","de":"Ausstehende Zertifikatsanforderung","es":"Solicitud de certificado pendiente","fr":"Demande de certificat en attente","it":"Richiesta di certificato in sospeso","ja":"保留中の証明書リクエスト"},"CERTIFICATE_STATUS_INVALID":{"en":"Invalid Certificate","de":"Ungültiges Zertifikat","es":"Certificado no válido","fr":"Certificat non valide","it":"Certificato non valido","ja":"無効な証明書"},"CERTIFICATE_STATUS_SELF_SIGNED":{"en":"Invalid Certificate: Self-Signed","de":"Ungültiges Zertifikat: Selbst-signiert","es":"Certificado no válido: Autofirmado","fr":"Certificat non valide : Auto-signé","it":"Certificato non valido: Auto-firmato","ja":"無効な証明書：自己署名"},"CERTIFICATE_STATUS_EXPIRED":{"en":"Certificate Expired","de":"Zertifikat abgelaufen","es":"Certificado caducado","fr":"Certificat expiré","it":"Certificato scaduto","ja":"証明書の期限が切れています"},"CERTIFICATE_STATUS_IMPORTED":{"en":"Certificate Imported","de":"Zertifikat importiert","es":"Certificado importado","fr":"Certificat importé","it":"Certificato importato","ja":"証明書が取り込まれています"},"CERT_DELETE_CONFIRMATION":{"en":"Are you sure you want to delete the certificate request? This cannot be undone.","de":"Sind Sie sicher, dass Sie die Zertifikatsanforderung löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.","es":"¿Está seguro de que desea eliminar la solicitud de certificado? Esta acción no se puede deshacer.","fr":"Voulez-vous vraiment supprimer les polices sélectionnées ? La suppression est irréversible.","it":"Sicuro di voler cancellare la richiesta di certificato? Azione irreversibile.","ja":"証明書リクエストを本当に削除しますか？ この操作は取り消しできません。"},"DIAGNOSTICS_TITLE":{"en":"Diagnostics","de":"Diagnosen","es":"Diagnóstico","fr":"Diagnostics","it":"Diagnostica","ja":"診断"},"DIAGNOSTICS_NO_PROBLEMS":{"en":"No problems found","de":"Keine Probleme gefunden","es":"No se encontraron problemas","fr":"Aucun problème trouvé","it":"Nessun problema riscontrato","ja":"問題なし"},"SK_ENGINE_ART_STYLE":{"en":"Art Style","de":"Kunststil","es":"Estilo de arte","fr":"Style d'art","it":"Stile artistico","ja":"アートスタイル"},"SK_ENGINE_ART_SUBJECT":{"en":"Art Subject","de":"Kunstgegenstand","es":"Sujeto de arte","fr":"Sujet d'art","it":"Soggetto artistico","ja":"アート科目"},"SK_ENGINE_ART_MOVEMENT":{"en":"Art Movement","de":"Kunstbewegung","es":"Movimiento de arte","fr":"Mouvement artistique","it":"Movimento artistico","ja":"アートムーブメント"},"CERT_FILE":{"en":"Certificate File","de":"Zertifikatdatei","es":"Archivo de certificado","fr":"Fichier certificat","it":"File del certificato","ja":"証明書ファイル"},"CERT_FILE_INT_1":{"en":"Intermediate Certificate 1","de":"Zwischenzertifikat 1","es":"Certificado intermedio 1","fr":"Certificat intermédiaire 1","it":"Certificato intermedio 1","ja":"中間証明書 1"},"CERT_FILE_INT_2":{"en":"Intermediate Certificate 2","de":"Zwischenzertifikat 2","es":"Certificado intermedio 2","fr":"Certificat intermédiaire 2","it":"Certificato intermedio 2","ja":"中間証明書 2"},"CERT_FILE_PASSWORD":{"en":"Certificate Password","de":"Zertifikat-Passwort","es":"Contraseña del certificado","fr":"Mot de passe du certificat","it":"Password del certificato","ja":"証明書パスワード"},"CERT_FILE_PASSWORD_HELP":{"en":"If your certificate has a password, enter it here","de":"Wenn Ihr Zertifikat ein Passwort hat, geben Sie es bitte hier ein","es":"Si su certificado tiene contraseña, introdúzcala aquí","fr":"Si votre certificat est protégé par un mot de passe, saisissez-le ici","it":"Se il tuo certificato è dotato di password, inseriscila qui","ja":"証明書にパスワードが設定されている場合はここに入力します"},"CERT_FILE_PROMPT":{"en":"Select...","de":"Auswählen...","es":"Seleccionar...","fr":"Sélectionner...","it":"Seleziona...","ja":"選択"},"CERT_FILE_ROOT":{"en":"Root Certificate","de":"Grundzertifikat","es":"Certificado raíz","fr":"Certificat racine","it":"Certificato radice","ja":"ルート証明書"},"CERT_IMPORT_SUCCEEDED":{"en":"The certificate was successfully imported. Please restart the Portfolio server and Portfolio admin services to begin using the certificate.","de":"Das Zertifikat wurde erfolgreich importiert. Starten Sie den Portfolio-Server und die Portfolio-Admin-Dienste neu, um das Zertifikat zu verwenden.","es":"El certificado se ha importado con éxito. Reinicie el servidor Portfolio y los servicios administrativos de Portfolio para comenzar a utilizar el certificado.","fr":"Le certificat a été importé avec succès. Veuillez redémarrer le serveur Portfolio et les services d’administration Portfolio pour commencer à utiliser le certificat.","it":"Il certificato è stato importato con successo. Riavvia il server Portfolio e i servizi di Admin Portfolio per iniziare ad usare il certificato.","ja":"証明書の取り込みに成功しました。証明書を使用するには、PortfolioサーバーとPortfolio adminサービスを再起動します。"},"CERT_IMPORT_FAILED_READING_PKCS12":{"en":"The server could not read the PKCS12 certificate. Check the password.","de":"Der Server konnte das PKCS12-Zertifikat nicht lesen. Prüfen Sie das Passwort.","es":"El servidor no pudo leer el certificado PKCS12. Compruebe la contraseña.","fr":"Le serveur n'a pas pu lire le certificat PKCS12. Vérifiez le mot de passe.","it":"Il server non è riuscito a leggere il certificato PKCS12. Controlla la password.","ja":"PKCS12証明書を取り込めませんでした。パスワードを確認してください。"},"CERT_IMPORT_FAILED_INTERMEDIATE1":{"en":"The Intermediate 1 certificate could not be imported.","de":"Das Zwischenzertifikat 1 konnte nicht importiert werden.","es":"No se ha podido importar el certificado Intermedio 1.","fr":"Le certificat intermédiaire 1 n’a pas pu être importé.","it":"Impossibile importare il certificato Intermedio 1.","ja":"中間証明書を取り込めませんでした。"},"CERT_IMPORT_FAILED_INTERMEDIATE2":{"en":"The Intermediate 2 certificate could not be imported.","de":"Das Zwischenzertifikat 2 konnte nicht importiert werden.","es":"No se ha podido importar el certificado Intermedio 2.","fr":"Le certificat intermédiaire 2 n’a pas pu être importé.","it":"Impossibile importare il certificato Intermedio 2.","ja":"中間証明書を取り込めませんでした。"},"CERT_IMPORT_FAILED_ROOT":{"en":"The root certificate could not be imported.","de":"Das Wurzelzertifikat konnte nicht importiert werden.","es":"No se ha podido importar el certificado raíz.","fr":"Le certificat racine n'a pas pu être importé.","it":"Impossibile importare il certificato radice.","ja":"ルート証明書を取り込めませんでした。"},"DIRECTORY_SERVICE_CONFIG_TITLE":{"en":"Active Directory Configuration","de":"Verzeichnisdienst-Konfiguration","es":"Configuración del servicio de directorio","fr":"Configuration des services d'annuaire","it":"Configurazione del Servizio Directory","ja":"ディレクトリサービスの設定"},"DIRECTORY_SERVICES_TITLE":{"en":"Directory Services","de":"Verzeichnisdienst","es":"Servicios de directorio","fr":"Services d'annuaire","it":"Servizi Directory","ja":"ディレクトリサービス"},"DIRECTORY_SERVICE_MAPIINGS":{"en":"Directory Items to Portfolio Mappings","de":"Verzeichniselemente für Portfolio-Zuordnungen","es":"Elementos de directorio a Correspondencias Portfolio","fr":"Éléments de l’annuaire pour les mappages de Portfolio","it":"Elementi della directory nelle mappature di Portfolio","ja":"Portfolioマッピングのディレクトリアイテム"},"DIRECTORY_SERVICE_MAPIINGS_TITLE":{"en":"Mappings","de":"Zuordnungen","es":"Correspondencias","fr":"Mappages","it":"Mappature","ja":"マッピング"},"PDL_noPredefinedValues":{"de":"Keine vordefinierten Werte","en":"No Predefined Values","es":"No hay valores predefinidos","fr":"Aucune valeur prédéfinie","it":"Nessun valore predefinito","ja":"定義済みの値なし"},"PDL_editPredefinedListPlaceholder":{"de":"Vordefinierte Liste bearbeiten","en":"Edit Predefined List","es":"Editar lista predefinida","fr":"Modifier la liste prédéfinie","it":"Modifica la lista predefinita","ja":"定義済みの値のリストを編集"},"PDL_importPredefinedValues":{"de":"Vordefinierte Werte importieren","en":"Import Predefined Values","es":"Importar valores predefinidos","fr":"Importer des valeurs prédéfinies","it":"Importa valori predefiniti","ja":"定義済みの値を読み込む"},"PDL_exportPredefinedValues":{"de":"Vordefinierte Werte exportieren","en":"Export Predefined Values","es":"Exportar valores predefinidos","fr":"Exporter des valeurs prédéfinies","it":"Esporta i valori predefiniti","ja":"定義済みの値を書き出す"},"PDL_removeNestedValueConfirmation":{"de":"Markierte Werte löschen?\nSie enthalten verschachtelte Werte, die ebenfalls gelöscht werden.","en":"Delete the selected values?\nThey contain nested values which will also be deleted.","es":"¿Eliminar los valores seleccionados?\nContienen valores anidados que también se eliminarán.","fr":"Supprimer les valeurs sélectionnées?\nElles comportent des valeurs imbriquées qui seront également supprimées.","it":"Eliminare i valori selezionati?\nContengono valori nidificati che saranno altresì cancellati.","ja":"選択した値を削除しますか？\n選択した値に含まれる下位の値も一緒に削除されます。"},"PDL_wrongPdlImportFormat":{"de":"Die gewählte Datei enthält keine Textdaten. Wählen Sie bitte eine Textdatei.","en":"The selected file did not contain text data. Please select a text file.","es":"El archivo seleccionado no contenía datos de texto. Seleccione un archivo de texto.","fr":"Le fichier sélectionné ne contient pas de données textuelles. Veuillez sélectionner un fichier texte.","it":"Il file selezionato non contiene dati di testo. Selezionare un file di testo.","ja":"選択したファイルにはテキストデータがありませんでした。テキストファイルを選択してください。"},"LIC_SET_ACCOUNT":{"en":"Set Account","de":"Konto Einrichten","es":"Establecer Cuenta","fr":"Définir un Compte","it":"Imposta Account","ja":"アカウントを設定"},"LIC_REMOVE_ACCOUNT":{"en":"Remove Account","de":"Konto Entfernen","es":"Eliminar Cuenta","fr":"Supprimer le Compte","it":"Rimuovi l'Account","ja":"アカウントを削除"},"LIC_CONTACT_CUSTOMER_SUCCESS_1":{"en":"For assistance with renewing your account, please contact us at","de":"Wenn Sie Hilfe bei der Erneuerung Ihres Kontos benötigen, kontaktieren Sie uns bitte unter","es":"Para obtener ayuda con la renovación de su cuenta, comuníquese con nosotros al","fr":"Pour obtenir de l'aide sur le renouvellement de votre compte, veuillez nous contacter au","it":"Per assistenza con il rinnovo del tuo account, contattaci all'indirizzo","ja":"アカウントの更新についてサポートが必要な場合は、"},"LIC_CONTACT_CUSTOMER_SUCCESS_2":{"en":"and your Customer Success Manager will contact you within 1 business day.","de":"Ihr Customer Success Manager wird Sie innerhalb eines Werktages kontaktieren.","es":"y su Gerente de Éxito del Cliente se comunicará con usted dentro de 1 día hábil.","fr":"et votre Customer Success Manager vous contactera dans un délai d'un jour ouvrable.","it":"e il tuo Customer Success Manager ti contatterà entro 1 giorno lavorativo.","ja":"までご連絡ください。カスタマーサクセスマネージャーから1営業日以内にご連絡いたします。"}}

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteVaultCatalogDialog=function(_Component){_inherits(DeleteVaultCatalogDialog,_Component);function DeleteVaultCatalogDialog(){_classCallCheck(this,DeleteVaultCatalogDialog);var _this=_possibleConstructorReturn(this,(DeleteVaultCatalogDialog.__proto__||Object.getPrototypeOf(DeleteVaultCatalogDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(DeleteVaultCatalogDialog,[{key:'submit',value:function submit(values){var activePanelData=this.props.activePanelData;if(activePanelData&&typeof activePanelData.doDelete==='function'){activePanelData.doDelete();}}},{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'renderForm',value:function renderForm(){var _props=this.props,confirm=_props.confirm,handleSubmit=_props.handleSubmit,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container',onSubmit:handleSubmit(this.submit)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__["a" /* default */],id:'confirm',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_DELETE_CONFIRM),name:'confirm',type:'checkbox'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(confirm?'is-danger':'is-warning')+' has-text-weight-bold has-text-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].DELETE_WARNING_BOX_MSG),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].DELETE_WARNING_CATALOG_VAULT)));}},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,handleSubmit=_props2.handleSubmit,hideDialogPanel=_props2.hideDialogPanel,formatMessage=_props2.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'650px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].DELETE),dialogFocusId:'confirm',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_8_util_constants__["F" /* DELETE_VAULT_CATALOG_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_DELETE),showCancel:true},this.renderForm());}}]);return DeleteVaultCatalogDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};if(!data.confirm){errors.confirm='Required';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_8_util_constants__["F" /* DELETE_VAULT_CATALOG_PANEL_ID */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(DeleteVaultCatalogDialog));var selector=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_8_util_constants__["F" /* DELETE_VAULT_CATALOG_PANEL_ID */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelData:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["b" /* getActivePanelData */])(state),activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state),confirm:selector(state,'confirm')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(form));

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_view_Forms_StaticTextField__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_catalogUtils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_view_App_DialogPanels_ModalStringPrompt__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_state_commands_roleCommands__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_util_serverUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CatalogTemplatesDialog__ = __webpack_require__(775);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _storageTypeKeyToStri,_statusKeyToString;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var storageTypeKeyToString=(_storageTypeKeyToStri={},_defineProperty(_storageTypeKeyToStri,__WEBPACK_IMPORTED_MODULE_9_util_constants__["n" /* CATALOG_STORAGE_TYPE */].FILESYSTEM,__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_WATCHFOLDERS),_defineProperty(_storageTypeKeyToStri,__WEBPACK_IMPORTED_MODULE_9_util_constants__["n" /* CATALOG_STORAGE_TYPE */].VAULT,__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_VAULT),_defineProperty(_storageTypeKeyToStri,__WEBPACK_IMPORTED_MODULE_9_util_constants__["n" /* CATALOG_STORAGE_TYPE */].S3,__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_S3),_storageTypeKeyToStri);var statusKeyToString=(_statusKeyToString={},_defineProperty(_statusKeyToString,__WEBPACK_IMPORTED_MODULE_9_util_constants__["m" /* CATALOG_STATUS */].OFFLINE,__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_OFFLINE),_defineProperty(_statusKeyToString,__WEBPACK_IMPORTED_MODULE_9_util_constants__["m" /* CATALOG_STATUS */].ONLINE,__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_ONLINE),_statusKeyToString);var CatalogDetailsPage=function(_Component){_inherits(CatalogDetailsPage,_Component);function CatalogDetailsPage(){_classCallCheck(this,CatalogDetailsPage);var _this=_possibleConstructorReturn(this,(CatalogDetailsPage.__proto__||Object.getPrototypeOf(CatalogDetailsPage)).call(this));_this.state={isCreateTemplateVisible:false};_this.closeCreateTemplatePrompt=_this.closeCreateTemplatePrompt.bind(_this);_this.doCreateTemplate=_this.doCreateTemplate.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleCreateCatalogTemplate=_this.handleCreateCatalogTemplate.bind(_this);_this.handleDefaultRoleChange=_this.handleDefaultRoleChange.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.showManageTemplatesDialog=_this.showManageTemplatesDialog.bind(_this);_this.submit=_this.submit.bind(_this);_this.templateNameValidator=_this.templateNameValidator.bind(_this);return _this;}_createClass(CatalogDetailsPage,[{key:'componentDidMount',value:function componentDidMount(){var catalog=this.props.catalog;if(catalog){this.props.getCatalogPropertiesAction(catalog.catalogId,[__WEBPACK_IMPORTED_MODULE_9_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]);this.props.getCatalogTypesAction(catalog.catalogId);this.props.getRolesAction();this.props.initialize({name:catalog.name});}}},{key:'submit',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref){var name=_ref.name;var _props,catalog,formatMessage,successMessage,newCatalog,newName;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,catalog=_props.catalog,formatMessage=_props.intl.formatMessage;successMessage=formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE);// server expects "id" instead of "catalogId" (see PORT-13172)
newCatalog=Object.assign({},catalog,{id:catalog.catalogId,name:name});_context.next=5;return this.props.renameCatalog(newCatalog,successMessage);case 5:newName=_context.sent;this.props.initialize({name:newName});case 7:case'end':return _context.stop();}}},_callee,this);}));function submit(_x){return _ref2.apply(this,arguments);}return submit;}()},{key:'handleChange',value:function handleChange(event,newValue){if(!Object(__WEBPACK_IMPORTED_MODULE_14_util_catalogUtils__["c" /* isLegalCatalogName */])(newValue)){event.preventDefault();}}},{key:'handleKeyDown',value:function handleKeyDown(event){var target=event.target;var blur=function blur(){if(target instanceof HTMLInputElement){setTimeout(function(){return target.blur();});}};switch(event.key){case'Escape':this.props.reset();blur();break;case'Enter':if(this.props.valid){blur();}break;default:// do nothing
}}},{key:'handleCreateCatalogTemplate',value:function handleCreateCatalogTemplate(){//remove focus from button, otherwise it gets clicked again when submitting modal
var b=document.activeElement;b&&b.blur();this.setState({isCreateTemplateVisible:true});}},{key:'closeCreateTemplatePrompt',value:function closeCreateTemplatePrompt(){this.setState({isCreateTemplateVisible:false});}},{key:'doCreateTemplate',value:function doCreateTemplate(name){var _props2=this.props,catalog=_props2.catalog,createCatalogTemplateAction=_props2.createCatalogTemplateAction,formatMessage=_props2.intl.formatMessage;var msg=formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE);createCatalogTemplateAction(catalog.catalogId,name,msg);}},{key:'templateNameValidator',value:function templateNameValidator(value){if(!value||!value.length){return'Empty String';}else if(this.props.catalogTypes.map(function(template){return template.name.toLowerCase();}).includes(value.toLowerCase())){return'Existing Template';}}},{key:'showManageTemplatesDialog',value:function showManageTemplatesDialog(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["o" /* CATALOG_TEMPLATES_PANEL_ID */]);}},{key:'handleDefaultRoleChange',value:function handleDefaultRoleChange(e){var newRoleName=e.currentTarget.value;this.props.setGlobalSettings(_defineProperty({},__WEBPACK_IMPORTED_MODULE_19_util_serverUtils__["a" /* GLOBAL_SETTING */].DEFAULT_USER_ACCESS_LEVEL,newRoleName));}},{key:'render',value:function render(){var _props3=this.props,activePanelId=_props3.activePanelId,catalog=_props3.catalog,catalogProperties=_props3.catalogProperties,defaultRole=_props3.defaultRole,handleSubmit=_props3.handleSubmit,intl=_props3.intl,_props3$intl=_props3.intl,formatDate=_props3$intl.formatDate,formatTime=_props3$intl.formatTime,formatMessage=_props3$intl.formatMessage,invalid=_props3.invalid,pristine=_props3.pristine,roles=_props3.roles,submitting=_props3.submitting;var catalogDetails=catalogProperties&&catalogProperties.catalogDetails;if(!catalogDetails||!catalog){return null;}else{var createdDate=new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(catalogDetails.creationDate).toString());var staticFormData=[{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STATUS),value:formatMessage(statusKeyToString[catalogDetails.status])},{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_STORAGE_TYPE_LABEL),value:formatMessage(storageTypeKeyToString[catalogDetails.storageType])},{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].ASSETS),value:catalogDetails.assetCount},{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].USERS),value:catalogDetails.numberOfUsersConnected+' / '+catalogDetails.numberOfMembers},{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_DETAILS_CREATION_DATE),value:formatDate(createdDate)+' '+formatTime(createdDate)}];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portfolio-form-container is-textured','data-test-name':'general-catalog-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["b" /* Form */],{onSubmit:handleSubmit(this.submit),className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-horizontal has-addons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-label is-normal is-medium'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].NAME))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{name:'name',className:'input is-medium',component:'input',onChange:this.handleChange,onKeyDown:this.handleKeyDown,style:{width:'400px'},type:'text','data-test-name':'catalog-name'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button is-primary is-medium '+(submitting?'is-loading':''),disabled:pristine||invalid,type:'submit','data-test-name':'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].APPLY))))),staticFormData.map(function(data){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_StaticTextField__["a" /* default */],{key:data.label,label:data.label,value:data.value});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_TEMPLATES_TITLE)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'buttons dir-svc-desc-form-button-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',onClick:this.handleCreateCatalogTemplate,'data-test-name':'create-template'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SAVE_TEMPLATE)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',onClick:this.showManageTemplatesDialog,'data-test-name':'manage-templates'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_MANAGE_TEMPLATES_MENU_LABEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'help'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SAVE_TEMPLATE_DETAILS_TEXT))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CATALOG_DEFAULTS)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].DEFAULT_ACCESS_LEVEL)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{className:'select',component:'select','data-test-name':'default-user-role',id:'accessLevel',name:'accessLevel',onChange:this.handleDefaultRoleChange,type:'select',value:defaultRole&&defaultRole.name},roles.map(function(role){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:role.name,value:role.name},Object(__WEBPACK_IMPORTED_MODULE_18_util_roleUtils__["e" /* getLocalizedRoleName */])(intl,role.name));}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_view_App_DialogPanels_ModalStringPrompt__["a" /* default */],{dataTestName:'create-template-modal',isOpen:this.state.isCreateTemplateVisible,label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].NAME),onClose:this.closeCreateTemplatePrompt,onSave:this.doCreateTemplate,panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SAVE_TEMPLATE_TITLE),maxLength:100,validate:this.templateNameValidator}),activePanelId===__WEBPACK_IMPORTED_MODULE_9_util_constants__["o" /* CATALOG_TEMPLATES_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__CatalogTemplatesDialog__["a" /* default */],null));}}}]);return CatalogDetailsPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function validate(data,props){var errors={};var maxFieldLen=255;if(!data.name||data.name.length>maxFieldLen){errors.name='Invalid';}else if(Object(__WEBPACK_IMPORTED_MODULE_14_util_catalogUtils__["a" /* catalogNameExists */])(props.catalogs,data.name)){errors.name='Duplicate';}return errors;}var detailsForm=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["k" /* reduxForm */])({form:'CATALOG_DETAILS_FORM',validate:validate})(CatalogDetailsPage);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["c" /* getActivePanelId */])(state),catalogProperties:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["k" /* getCatalogProperties */])(state),catalogs:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["n" /* getCatalogs */])(state),catalogTypes:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["l" /* getCatalogTypes */])(state),defaultRole:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["t" /* getDefaultRole */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["_15" /* getRoles */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__["a" /* bindActionCreatorsForm */])({createCatalogTemplateAction:__WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__["e" /* createCatalogTemplate */],getCatalogPropertiesAction:__WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__["l" /* getCatalogProperties */],getCatalogTypesAction:__WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__["m" /* getCatalogTypes */],getRolesAction:__WEBPACK_IMPORTED_MODULE_17_state_commands_roleCommands__["c" /* getRoles */],renameCatalog:__WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__["w" /* renameCatalog */],setGlobalSettings:__WEBPACK_IMPORTED_MODULE_11_state_commands_adminPropertiesCommands__["l" /* setGlobalSettings */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_13_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(detailsForm)));

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ROLE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_ROLE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_ROLES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_ROLES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SELECTED_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_ROLE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_ROLE_SUCCESS; });
var CREATE_ROLE='admin/role/CREATE_ROLE';var CREATE_ROLE_FAIL='admin/role/CREATE_ROLE_FAIL';var CREATE_ROLE_SUCCESS='admin/role/CREATE_ROLE_SUCCESS';var DELETE_ROLE='admin/role/DELETE_ROLE';var DELETE_ROLE_FAIL='admin/role/DELETE_ROLE_FAIL';var DELETE_ROLE_SUCCESS='admin/role/DELETE_ROLE_SUCCESS';var GET_ROLES='admin/role/GET_ROLES';var GET_ROLES_FAIL='admin/role/GET_ROLES_FAIL';var GET_ROLES_SUCCESS='admin/role/GET_ROLES_SUCCESS';var SET_SELECTED_ROLE='admin/role/SET_SELECTED_ROLE';var UPDATE_ROLE='admin/role/UPDATE_ROLE';var UPDATE_ROLE_FAIL='admin/role/UPDATE_ROLE_FAIL';var UPDATE_ROLE_SUCCESS='admin/role/UPDATE_ROLE_SUCCESS';

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_App_MultipleSelectionTable__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_tableUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_view_App_DialogPanels_ModalStringPrompt__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var CatalogTemplatesDialog=function(_Component){_inherits(CatalogTemplatesDialog,_Component);function CatalogTemplatesDialog(){_classCallCheck(this,CatalogTemplatesDialog);var _this=_possibleConstructorReturn(this,(CatalogTemplatesDialog.__proto__||Object.getPrototypeOf(CatalogTemplatesDialog)).call(this));_this.state={isRenameVisible:false,selectionState:Object(__WEBPACK_IMPORTED_MODULE_13_util_tableUtils__["d" /* getNewSelectionState */])()};_this.doDelete=_this.doDelete.bind(_this);_this.doRename=_this.doRename.bind(_this);_this.getSelectedTemplate=_this.getSelectedTemplate.bind(_this);_this.handleCloseRename=_this.handleCloseRename.bind(_this);_this.handleDeleteTemplate=_this.handleDeleteTemplate.bind(_this);_this.handleDoubleClick=_this.handleDoubleClick.bind(_this);_this.handleSelectionChanged=_this.handleSelectionChanged.bind(_this);_this.renderPanelHeader=_this.renderPanelHeader.bind(_this);_this.renderTableCell=_this.renderTableCell.bind(_this);_this.templateRenameValidator=_this.templateRenameValidator.bind(_this);return _this;}_createClass(CatalogTemplatesDialog,[{key:'handleSelectionChanged',value:function handleSelectionChanged(selectionState){this.setState({selectionState:selectionState});}},{key:'getSelectedTemplate',value:function getSelectedTemplate(){var selectionState=this.state.selectionState;var catalogTemplates=this.props.catalogTemplates;var index=Object(__WEBPACK_IMPORTED_MODULE_13_util_tableUtils__["c" /* getIndexOfFirstSelectedItem */])(selectionState);var ix=Number(index);return catalogTemplates[ix];}},{key:'handleDeleteTemplate',value:function handleDeleteTemplate(){var template=this.getSelectedTemplate();if(template){this.props.showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__["a" /* default */].CATALOG_TEMPLATE_REMOVE_CONFIRMATION,onButton2:this.doDelete,closeOnEscape:true,isButton2Default:true});}}},{key:'doDelete',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var template;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:template=this.getSelectedTemplate();_context.next=3;return this.props.deleteCatalogTemplate(template.guid);case 3:this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_13_util_tableUtils__["d" /* getNewSelectionState */])()});case 4:case'end':return _context.stop();}}},_callee,this);}));function doDelete(){return _ref.apply(this,arguments);}return doDelete;}()},{key:'handleDoubleClick',value:function handleDoubleClick(){this.setState({isRenameVisible:true});}},{key:'doRename',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(name){var template;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:template=this.getSelectedTemplate();_context2.next=3;return this.props.renameCatalogTemplate(template.guid,name);case 3:case'end':return _context2.stop();}}},_callee2,this);}));function doRename(_x){return _ref2.apply(this,arguments);}return doRename;}()},{key:'handleCloseRename',value:function handleCloseRename(){this.setState({isRenameVisible:false});}},{key:'templateRenameValidator',value:function templateRenameValidator(value){if(!value||!value.length){return'Empty String';}else if(this.props.catalogTemplates.map(function(t){return t.name.toLowerCase();}).includes(value.toLowerCase())){return'Existing Template';}}},{key:'renderPanelHeader',value:function renderPanelHeader(){var deleteDisabled=Object(__WEBPACK_IMPORTED_MODULE_13_util_tableUtils__["e" /* getSelectedIndices */])(this.state.selectionState).length===0;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'36px'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__["a" /* default */].CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-dark is-outlined is-inverted',disabled:deleteDisabled,onClick:deleteDisabled?undefined:this.handleDeleteTemplate,'data-test-name':'delete-template'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-lg fa-minus-circle'}))));}},{key:'renderTableCell',value:function renderTableCell(_ref3){var cellData=_ref3.cellData;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onDoubleClick:this.handleDoubleClick},cellData);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activePanelId=_props.activePanelId,catalogTemplates=_props.catalogTemplates,hideDialogPanel=_props.hideDialogPanel,formatMessage=_props.intl.formatMessage;var selectionState=this.state.selectionState;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'700px',height:'500px'},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__["a" /* default */].OK),hideDialogPanel:hideDialogPanel,panelHeader:this.renderPanelHeader(),panelId:__WEBPACK_IMPORTED_MODULE_9_util_constants__["o" /* CATALOG_TEMPLATES_PANEL_ID */],showCancel:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_virtualized__["b" /* AutoSizer */],null,function(_ref4){var height=_ref4.height,width=_ref4.width;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_App_MultipleSelectionTable__["a" /* default */],{headerHeight:40,height:height,onSelectionChanged:_this2.handleSelectionChanged,rowHeight:40,selectionState:selectionState,singleSelectionOnly:true,sortedItems:catalogTemplates,width:width},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_virtualized__["e" /* Column */],{cellRenderer:_this2.renderTableCell,className:'list-item',dataKey:'name',label:formatMessage(__WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__["a" /* default */].CATALOG_TEMPLATE_NAME),width:width}));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_view_App_DialogPanels_ModalStringPrompt__["a" /* default */],{initialValue:this.getSelectedTemplate()&&this.getSelectedTemplate().name,isOpen:this.state.isRenameVisible,label:formatMessage(__WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__["a" /* default */].NAME),onClose:this.handleCloseRename,onSave:this.doRename,panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_11__util_localizedStrings__["a" /* default */].CATALOG_TEMPLATE_NAME),maxLength:100,validate:this.templateRenameValidator,dataTestName:'rename-template-modal'}));}}]);return CatalogTemplatesDialog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state),catalogTemplates:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["r" /* getCustomCatalogTemplates */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_10_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteCatalogTemplate:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["i" /* deleteCatalogTemplate */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],renameCatalogTemplate:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["x" /* renameCatalogTemplate */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__["b" /* showDialogPanel */],showModalPrompt:showModalPrompt});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(CatalogTemplatesDialog)));

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(332);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(355);
/* unused harmony reexport bpfrpt_proptype_ScrollIndices */








/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(778);
module.exports = __webpack_require__(21).Object.getPrototypeOf;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(137);
var $getPrototypeOf = __webpack_require__(333);

__webpack_require__(200)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(780);
var $Object = __webpack_require__(21).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(48);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperty: __webpack_require__(57).f });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(782), __esModule: true };

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(141);
__webpack_require__(143);
module.exports = __webpack_require__(206).f('iterator');


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(203);
var defined = __webpack_require__(197);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(204);
var descriptor = __webpack_require__(140);
var setToStringTag = __webpack_require__(142);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(66)(IteratorPrototype, __webpack_require__(30)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(57);
var anObject = __webpack_require__(49);
var getKeys = __webpack_require__(103);

module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(341);
var toAbsoluteIndex = __webpack_require__(787);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(203);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(789);
var step = __webpack_require__(790);
var Iterators = __webpack_require__(84);
var toIObject = __webpack_require__(67);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(337)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(792), __esModule: true };

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(793);
__webpack_require__(344);
__webpack_require__(798);
__webpack_require__(799);
module.exports = __webpack_require__(21).Symbol;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(29);
var has = __webpack_require__(65);
var DESCRIPTORS = __webpack_require__(59);
var $export = __webpack_require__(48);
var redefine = __webpack_require__(338);
var META = __webpack_require__(794).KEY;
var $fails = __webpack_require__(83);
var shared = __webpack_require__(199);
var setToStringTag = __webpack_require__(142);
var uid = __webpack_require__(138);
var wks = __webpack_require__(30);
var wksExt = __webpack_require__(206);
var wksDefine = __webpack_require__(207);
var enumKeys = __webpack_require__(795);
var isArray = __webpack_require__(796);
var anObject = __webpack_require__(49);
var isObject = __webpack_require__(58);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(202);
var createDesc = __webpack_require__(140);
var _create = __webpack_require__(204);
var gOPNExt = __webpack_require__(797);
var $GOPD = __webpack_require__(209);
var $DP = __webpack_require__(57);
var $keys = __webpack_require__(103);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(343).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(144).f = $propertyIsEnumerable;
  __webpack_require__(208).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(101)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(66)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(138)('meta');
var isObject = __webpack_require__(58);
var has = __webpack_require__(65);
var setDesc = __webpack_require__(57).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(83)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(103);
var gOPS = __webpack_require__(208);
var pIE = __webpack_require__(144);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(104);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(67);
var gOPN = __webpack_require__(343).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(207)('asyncIterator');


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(207)('observable');


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(801), __esModule: true };

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(802);
module.exports = __webpack_require__(21).Object.setPrototypeOf;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(48);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(803).set });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(58);
var anObject = __webpack_require__(49);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(102)(Function.call, __webpack_require__(209).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(805), __esModule: true };

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(806);
var $Object = __webpack_require__(21).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(48);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(204) });


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(808);
module.exports = __webpack_require__(21).Object.assign;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(48);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(809) });


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(103);
var gOPS = __webpack_require__(208);
var pIE = __webpack_require__(144);
var toObject = __webpack_require__(137);
var IObject = __webpack_require__(340);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(83)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(11);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);




/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(814);
module.exports = __webpack_require__(21).Object.keys;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(137);
var $keys = __webpack_require__(103);

__webpack_require__(200)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(11);




/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}



/***/ }),
/* 816 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(819), __esModule: true };

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
__webpack_require__(141);
__webpack_require__(143);
__webpack_require__(820);
__webpack_require__(831);
__webpack_require__(832);
module.exports = __webpack_require__(21).Promise;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(101);
var global = __webpack_require__(29);
var ctx = __webpack_require__(102);
var classof = __webpack_require__(214);
var $export = __webpack_require__(48);
var isObject = __webpack_require__(58);
var aFunction = __webpack_require__(139);
var anInstance = __webpack_require__(821);
var forOf = __webpack_require__(822);
var speciesConstructor = __webpack_require__(351);
var task = __webpack_require__(352).set;
var microtask = __webpack_require__(826)();
var newPromiseCapabilityModule = __webpack_require__(215);
var perform = __webpack_require__(353);
var userAgent = __webpack_require__(827);
var promiseResolve = __webpack_require__(354);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(30)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(828)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(142)($Promise, PROMISE);
__webpack_require__(829)(PROMISE);
Wrapper = __webpack_require__(21)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(830)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(102);
var call = __webpack_require__(823);
var isArrayIter = __webpack_require__(824);
var anObject = __webpack_require__(49);
var toLength = __webpack_require__(341);
var getIterFn = __webpack_require__(350);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(49);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(84);
var ITERATOR = __webpack_require__(30)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 825 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var macrotask = __webpack_require__(352).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(104)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(66);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var core = __webpack_require__(21);
var dP = __webpack_require__(57);
var DESCRIPTORS = __webpack_require__(59);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(30)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(48);
var core = __webpack_require__(21);
var global = __webpack_require__(29);
var speciesConstructor = __webpack_require__(351);
var promiseResolve = __webpack_require__(354);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(48);
var newPromiseCapability = __webpack_require__(215);
var perform = __webpack_require__(353);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}



/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(356);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);








/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return typeof children === 'function' ? children({ measure: this._measure }) : children;
    }
  }, {
    key: '_getCellMeasurements',
    value: function _getCellMeasurements() {
      var cache = this.props.cache;


      var node = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this);

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return { height: height, width: width };
      } else {
        return { height: 0, width: 0 };
      }
    }
  }, {
    key: '_maybeMeasureCell',
    value: function _maybeMeasureCell() {
      var _props = this.props,
          cache = _props.cache,
          _props$columnIndex = _props.columnIndex,
          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
          parent = _props.parent,
          _props$rowIndex = _props.rowIndex,
          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;


      if (!cache.has(rowIndex, columnIndex)) {
        var _getCellMeasurements2 = this._getCellMeasurements(),
            height = _getCellMeasurements2.height,
            width = _getCellMeasurements2.width;

        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

// Used for DEV mode warning check


CellMeasurer.__internalCellMeasurerFlag = false;
CellMeasurer.propTypes =  true ? null : {
  cache: function cache() {
    return (typeof bpfrpt_proptype_CellMeasureCache === 'function' ? bpfrpt_proptype_CellMeasureCache.isRequired ? bpfrpt_proptype_CellMeasureCache.isRequired : bpfrpt_proptype_CellMeasureCache : PropTypes.shape(bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  columnIndex: PropTypes.number,
  index: PropTypes.number,
  parent: PropTypes.shape({
    invalidateCellSizeAfterRender: PropTypes.func,
    recomputeGridSize: PropTypes.func
  }).isRequired,
  rowIndex: PropTypes.number
};
/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}



/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(359);




var DEFAULT_HEIGHT = 30;

var DEFAULT_WIDTH = 100;

// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache = function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    this._cellHeightCache = {};
    this._cellWidthCache = {};
    this._columnWidthCache = {};
    this._rowHeightCache = {};
    this._columnCount = 0;
    this._rowCount = 0;

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
    };

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;


    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;

    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: 'clear',
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache.hasOwnProperty(key);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }

      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: '_updateCachedColumnAndRowSizes',
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCache);


function defaultKeyMapper(rowIndex, columnIndex) {
  return rowIndex + '-' + columnIndex;
}


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(839);
/* unused harmony reexport Collection */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionView__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(85);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'forceUpdate',
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props,
          cellCount = _props.cellCount,
          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
          sectionSize = _props.sectionSize;


      var data = Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _props2 = this.props,
          cellGroupRenderer = _props2.cellGroupRenderer,
          cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: '_setCollectionViewRef',
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};


function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize__);













// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()
    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };
    _this._calculateSizeAndPositionDataOnNextUpdate = false;
    _this._onSectionRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    _this._invokeOnSectionRenderedHelper = function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;


      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._updateScrollPositionForScrollToCell = function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;

      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    };

    _this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default()();
    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          cellLayoutManager = _props.cellLayoutManager,
          scrollLeft = _props.scrollLeft,
          scrollToCell = _props.scrollToCell,
          scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width;

      // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          height = _props2.height,
          scrollToAlignment = _props2.scrollToAlignment,
          scrollToCell = _props2.scrollToCell,
          width = _props2.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          autoHeight = _props3.autoHeight,
          cellCount = _props3.cellCount,
          cellLayoutManager = _props3.cellLayoutManager,
          className = _props3.className,
          height = _props3.height,
          horizontalOverscanSize = _props3.horizontalOverscanSize,
          id = _props3.id,
          noContentRenderer = _props3.noContentRenderer,
          style = _props3.style,
          verticalOverscanSize = _props3.verticalOverscanSize,
          width = _props3.width;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;

      // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;

        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width;

      // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0 },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            } },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;


        isScrollingChange(false);

        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this3 = this;

      var scrollLeft = _ref2.scrollLeft,
          scrollTop = _ref2.scrollTop,
          totalHeight = _ref2.totalHeight,
          totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft,
              scrollTop = _ref3.scrollTop;
          var _props4 = _this3.props,
              height = _props4.height,
              onScroll = _props4.onScroll,
              width = _props4.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft,
          scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
};
CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(CollectionView);

/* harmony default export */ __webpack_exports__["a"] = (CollectionView);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(842);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(85);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);



/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(85);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);



/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(846);
/* unused harmony reexport ColumnSizer */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          columnMaxWidth = _props.columnMaxWidth,
          columnMinWidth = _props.columnMinWidth,
          columnCount = _props.columnCount,
          width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnMaxWidth = _props2.columnMaxWidth,
          columnMinWidth = _props2.columnMinWidth,
          columnCount = _props2.columnCount,
          width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(848);
/* unused harmony reexport InfiniteLoader */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__ = __webpack_require__(212);









/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'resetLoadMoreRowsCache',
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;

      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: '_doStuff',
    value: function _doStuff(startIndex, stopIndex) {
      var _this3 = this;

      var _props = this.props,
          isRowLoaded = _props.isRowLoaded,
          minimumBatchSize = _props.minimumBatchSize,
          rowCount = _props.rowCount,
          threshold = _props.threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
      }, []);

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref2) {
  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
      startIndex = _ref2.startIndex,
      stopIndex = _ref2.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref3) {
  var isRowLoaded = _ref3.isRowLoaded,
      minimumBatchSize = _ref3.minimumBatchSize,
      rowCount = _ref3.rowCount,
      startIndex = _ref3.startIndex,
      stopIndex = _ref3.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(360);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(145);
/* unused harmony reexport bpfrpt_proptype_RowRendererParams */








/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(851), __esModule: true };

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(852);
var $Object = __webpack_require__(21).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(67);
var $getOwnPropertyDescriptor = __webpack_require__(209).f;

__webpack_require__(200)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(216);
/* unused harmony reexport createCellPositioner */
/* unused harmony reexport Masonry */



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["a" /* default */]);


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Masonry__ = __webpack_require__(216);


function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;

  var columnHeights = void 0;

  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;
    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;

    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;

    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];
    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;

    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;

  return cellPositioner;
}



/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(335);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__ = __webpack_require__(864);





// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    this._columnSizeMap = {};
    this._intervalTree = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__["a" /* default */])();
    this._leftMap = {};
  }
  // Tracks the height of each column


  // Store tops and bottoms of each cell for fast intersection lookup.


  // Maps cell index to x coordinates for quick lookup.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: 'estimateTotalHeight',
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.

  }, {
    key: 'range',
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;

      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: 'count',
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: 'shortestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: 'tallestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (PositionCache);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(858);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(861);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(859), __esModule: true };

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(141);
module.exports = __webpack_require__(860);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(214);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(84);
module.exports = __webpack_require__(21).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(862), __esModule: true };

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(141);
module.exports = __webpack_require__(863);


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(49);
var get = __webpack_require__(350);
module.exports = __webpack_require__(21).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(865);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/



var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);

  var mid = pts[pts.length >> 1];

  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);

  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});

Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});

function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(867);
/* unused harmony reexport MultiGrid */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(31);













var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _initialiseProps.call(_this);

    var deferredMeasurementCache = props.deferredMeasurementCache,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount;


    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'forceUpdateGrids',
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
          _ref2$rowIndex = _ref2.rowIndex,
          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;

      var _props = this.props,
          fixedColumnCount = _props.fixedColumnCount,
          fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          scrollLeft = _props2.scrollLeft,
          scrollTop = _props2.scrollTop;


      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          onScroll = _props3.onScroll,
          onSectionRendered = _props3.onSectionRendered,
          onScrollbarPresenceChange = _props3.onScrollbarPresenceChange,
          scrollLeftProp = _props3.scrollLeft,
          scrollToColumn = _props3.scrollToColumn,
          scrollTopProp = _props3.scrollTop,
          scrollToRow = _props3.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      this._prepareForRender();

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _props4 = this.props,
          columnWidth = _props4.columnWidth,
          enableFixedColumnScroll = _props4.enableFixedColumnScroll,
          enableFixedRowScroll = _props4.enableFixedRowScroll,
          height = _props4.height,
          fixedColumnCount = _props4.fixedColumnCount,
          fixedRowCount = _props4.fixedRowCount,
          rowHeight = _props4.rowHeight,
          style = _props4.style,
          styleBottomLeftGrid = _props4.styleBottomLeftGrid,
          styleBottomRightGrid = _props4.styleBottomRightGrid,
          styleTopLeftGrid = _props4.styleTopLeftGrid,
          styleTopRightGrid = _props4.styleTopRightGrid,
          width = _props4.width;


      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          overflow: 'visible', // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible', // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: '_prepareForRender',
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;


      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'BottomLeftGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._bottomLeftGridStyle, {
              height: height,
              width: width,
              overflowY: 'hidden'
            }) },
          bottomLeftGrid
        );
      }
      return bottomLeftGrid;
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _state2 = this.state,
          showHorizontalScrollbar = _state2.showHorizontalScrollbar,
          scrollbarSize = _state2.scrollbarSize;


      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'TopRightGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
              height: height,
              width: width,
              overflowX: 'hidden'
            }) },
          topRightGrid
        );
      }
      return topRightGrid;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

MultiGrid.defaultProps = {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    scrollLeft: 0,
    scrollTop: 0,
    scrollbarSize: 0,
    showHorizontalScrollbar: false,
    showVerticalScrollbar: false
  };
  this._deferredInvalidateColumnIndex = null;
  this._deferredInvalidateRowIndex = null;

  this._bottomLeftGridRef = function (ref) {
    _this2._bottomLeftGrid = ref;
  };

  this._bottomRightGridRef = function (ref) {
    _this2._bottomRightGrid = ref;
  };

  this._cellRendererBottomLeftGrid = function (_ref3) {
    var rowIndex = _ref3.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['rowIndex']);

    var _props5 = _this2.props,
        cellRenderer = _props5.cellRenderer,
        fixedRowCount = _props5.fixedRowCount,
        rowCount = _props5.rowCount;


    if (rowIndex === rowCount - fixedRowCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          height: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        parent: _this2,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  };

  this._cellRendererBottomRightGrid = function (_ref4) {
    var columnIndex = _ref4.columnIndex,
        rowIndex = _ref4.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex', 'rowIndex']);

    var _props6 = _this2.props,
        cellRenderer = _props6.cellRenderer,
        fixedColumnCount = _props6.fixedColumnCount,
        fixedRowCount = _props6.fixedRowCount;


    return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
      columnIndex: columnIndex + fixedColumnCount,
      parent: _this2,
      rowIndex: rowIndex + fixedRowCount
    }));
  };

  this._cellRendererTopRightGrid = function (_ref5) {
    var columnIndex = _ref5.columnIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['columnIndex']);

    var _props7 = _this2.props,
        cellRenderer = _props7.cellRenderer,
        columnCount = _props7.columnCount,
        fixedColumnCount = _props7.fixedColumnCount;


    if (columnIndex === columnCount - fixedColumnCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          width: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this2
      }));
    }
  };

  this._columnWidthRightGrid = function (_ref6) {
    var index = _ref6.index;
    var _props8 = _this2.props,
        columnCount = _props8.columnCount,
        fixedColumnCount = _props8.fixedColumnCount,
        columnWidth = _props8.columnWidth;
    var _state3 = _this2.state,
        scrollbarSize = _state3.scrollbarSize,
        showHorizontalScrollbar = _state3.showHorizontalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
      return scrollbarSize;
    }

    return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
  };

  this._onScroll = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft,
        scrollTop = scrollInfo.scrollTop;

    _this2.setState({
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    });
    var onScroll = _this2.props.onScroll;
    if (onScroll) {
      onScroll(scrollInfo);
    }
  };

  this._onScrollbarPresenceChange = function (_ref7) {
    var horizontal = _ref7.horizontal,
        size = _ref7.size,
        vertical = _ref7.vertical;
    var _state4 = _this2.state,
        showHorizontalScrollbar = _state4.showHorizontalScrollbar,
        showVerticalScrollbar = _state4.showVerticalScrollbar;


    if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
      _this2.setState({
        scrollbarSize: size,
        showHorizontalScrollbar: horizontal,
        showVerticalScrollbar: vertical
      });

      var onScrollbarPresenceChange = _this2.props.onScrollbarPresenceChange;

      if (typeof onScrollbarPresenceChange === 'function') {
        onScrollbarPresenceChange({
          horizontal: horizontal,
          size: size,
          vertical: vertical
        });
      }
    }
  };

  this._onScrollLeft = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft;

    _this2._onScroll({
      scrollLeft: scrollLeft,
      scrollTop: _this2.state.scrollTop
    });
  };

  this._onScrollTop = function (scrollInfo) {
    var scrollTop = scrollInfo.scrollTop;

    _this2._onScroll({
      scrollTop: scrollTop,
      scrollLeft: _this2.state.scrollLeft
    });
  };

  this._rowHeightBottomGrid = function (_ref8) {
    var index = _ref8.index;
    var _props9 = _this2.props,
        fixedRowCount = _props9.fixedRowCount,
        rowCount = _props9.rowCount,
        rowHeight = _props9.rowHeight;
    var _state5 = _this2.state,
        scrollbarSize = _state5.scrollbarSize,
        showVerticalScrollbar = _state5.showVerticalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
      return scrollbarSize;
    }

    return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
  };

  this._topLeftGridRef = function (ref) {
    _this2._topLeftGrid = ref;
  };

  this._topRightGridRef = function (ref) {
    _this2._topRightGrid = ref;
  };
};

MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(MultiGrid);

/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(358);




/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    };

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;


    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: 'clear',
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCacheDecorator);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(870);
/* unused harmony reexport ScrollSync */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(873);
/* unused harmony reexport createMultiSort */
/* unused harmony reexport defaultCellDataGetter */
/* unused harmony reexport defaultCellRenderer */
/* unused harmony reexport defaultHeaderRowRenderer */
/* unused harmony reexport defaultHeaderRenderer */
/* unused harmony reexport defaultRowRenderer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__SortDirection__["a"]; });
/* unused harmony reexport SortIndicator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__Table__["a"]; });











/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error('Required parameter "sortCallback" not specified');
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};

  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);
      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      // Clear sortBy array of all non-selected keys
      sortBy.length = 0;
      sortBy.push(dataKey);

      // Clear sortDirection object of all non-selected keys
      var sortDirectionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sortDirection);
      sortDirectionKeys.forEach(function (key) {
        if (key !== dataKey) delete sortDirection[key];
      });

      // If key is already selected, reverse sort direction.
      // Else, set sort direction to default direction.
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    }

    // Notify application code
    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SortDirection__ = __webpack_require__(146);




















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _React$PureComponent);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _Grid$getOffsetForCel.scrollTop;

        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeader = _props.disableHeader,
          gridClassName = _props.gridClassName,
          gridStyle = _props.gridStyle,
          headerHeight = _props.headerHeight,
          headerRowRenderer = _props.headerRowRenderer,
          height = _props.height,
          id = _props.id,
          noRowsRenderer = _props.noRowsRenderer,
          rowClassName = _props.rowClassName,
          rowStyle = _props.rowStyle,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flexStyles, {
          overflow: 'hidden'
        });
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': this.props['aria-label'],
          'aria-labelledby': this.props['aria-labelledby'],
          'aria-colcount': __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).length,
          'aria-rowcount': this.props.rowCount,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table', className),
          id: id,
          role: 'grid',
          style: style },
        !disableHeader && headerRowRenderer({
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerRow', rowClass),
          columns: this._getHeaderColumns(),
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            height: headerHeight,
            overflow: 'hidden',
            paddingRight: scrollbarWidth,
            width: width
          }, rowStyleObject)
        }),
        __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          autoContainerWidth: true,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: this._setRef,
          role: 'rowgroup',
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({ columnData: columnData, dataKey: dataKey, event: event });
      };

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-colindex': columnIndex + 1,
          'aria-describedby': id,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__rowColumn', className),
          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
          onClick: onClick,
          role: 'gridcell',
          style: style,
          title: title },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _props2 = this.props,
          headerClassName = _props2.headerClassName,
          headerStyle = _props2.headerStyle,
          onHeaderClick = _props2.onHeaderClick,
          sort = _props2.sort,
          sortBy = _props2.sortBy,
          sortDirection = _props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;

      var sortEnabled = !disableSort && sort;

      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headerStyle, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var headerOnClick = void 0,
          headerOnKeyDown = void 0,
          headerTabIndex = void 0,
          headerAriaSort = void 0,
          headerAriaLabel = void 0;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': headerAriaLabel,
          'aria-sort': headerAriaSort,
          className: classNames,
          id: id,
          key: 'Header-Col' + index,
          onClick: headerOnClick,
          onKeyDown: headerOnKeyDown,
          role: 'columnheader',
          style: style,
          tabIndex: headerTabIndex },
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _props3 = this.props,
          children = _props3.children,
          onRowClick = _props3.onRowClick,
          onRowDoubleClick = _props3.onRowDoubleClick,
          onRowRightClick = _props3.onRowRightClick,
          onRowMouseOver = _props3.onRowMouseOver,
          onRowMouseOut = _props3.onRowMouseOut,
          rowClassName = _props3.rowClassName,
          rowGetter = _props3.rowGetter,
          rowRenderer = _props3.rowRenderer,
          rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getHeaderColumns',
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _props4 = this.props,
          children = _props4.children,
          disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this.Grid);
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        var scrollbarWidth = offsetWidth - clientWidth;

        this.setState({ scrollbarWidth: scrollbarWidth });
      }
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
Table.propTypes =  false ? {
  /** This is just set on the grid top element. */
  'aria-label': PropTypes.string,

  /** This is just set on the grid top element. */
  'aria-labelledby': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(368);
/* unused harmony reexport WindowScroller */
/* unused harmony reexport IS_SCROLLING_TIMEOUT */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(368);



var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });

  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */

var isWindow = function isWindow(element) {
  return element === window;
};

// TODO Move this into WindowScroller and import from there


var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;

    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_App_pageData__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Simple parent container for ingest forms (e.g. Cataloging Options,
// Managed Uploads, etc.)
var CatalogIngestPage=function(_Component){_inherits(CatalogIngestPage,_Component);function CatalogIngestPage(){_classCallCheck(this,CatalogIngestPage);return _possibleConstructorReturn(this,(CatalogIngestPage.__proto__||Object.getPrototypeOf(CatalogIngestPage)).apply(this,arguments));}_createClass(CatalogIngestPage,[{key:'render',value:function render(){var catalog=this.props.catalog;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'catalog-ingest-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header-tabs-container-secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs is-centered is-full-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_3_view_App_pageData__["c" /* ingestForms */].map(function(form){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:form.route,'data-test-name':'nav-link-'+(form.label.defaultMessage||'unknown')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{activeClassName:'nav-item-horizontal-secondary-selected',className:'nav-item-horizontal-secondary',to:'/catalogs/'+catalog.catalogId+'/ingest/'+form.route},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],form.label)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_3_view_App_pageData__["c" /* ingestForms */].map(function(form){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{key:form.route,path:'/catalogs/'+catalog.catalogId+'/ingest/'+form.route,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(form.component,{catalog:catalog});}});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{exact:true,from:'/catalogs/:catalogId/ingest',to:'ingest/'+__WEBPACK_IMPORTED_MODULE_3_view_App_pageData__["c" /* ingestForms */][0].route})));}}]);return CatalogIngestPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CatalogIngestPage);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_catalogUtils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FileAndFolderExclusions__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FileTypesComponent__ = __webpack_require__(880);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var OPTION_FILENAME=1;var OPTION_PARENT_FOLDER=2;var OPTION_FOLDER_TREE=4;var OPTION_VOLUME=8;var OPTION_SERVER=16;var CatalogingOptionsForm=function(_Component){_inherits(CatalogingOptionsForm,_Component);function CatalogingOptionsForm(){_classCallCheck(this,CatalogingOptionsForm);var _this=_possibleConstructorReturn(this,(CatalogingOptionsForm.__proto__||Object.getPrototypeOf(CatalogingOptionsForm)).call(this));_this.onChangeKeywordPathStyle=_this.onChangeKeywordPathStyle.bind(_this);return _this;}_createClass(CatalogingOptionsForm,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.catalog){this.props.getCatalogPropertiesCommand(this.props.catalog.catalogId,[__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOGING_OPTIONS,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].EXCLUSION_INFO,__WEBPACK_IMPORTED_MODULE_7_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]);}}},{key:'onChangeKeywordPathStyle',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event,flag){var catalogingOptions,keywordsFromPathStyle,checked,newCatOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:catalogingOptions=this.props.catalogingOptions;keywordsFromPathStyle=catalogingOptions&&catalogingOptions.keywordsFromPathStyle;checked=event.target.checked;if(checked){keywordsFromPathStyle+=flag;}else{keywordsFromPathStyle-=flag;}newCatOptions=Object.assign({},catalogingOptions,{keywordsFromPathStyle:keywordsFromPathStyle});_context.next=7;return this.props.updateCatalogingOptions(this.props.catalog.catalogId,newCatOptions);case 7:case'end':return _context.stop();}}},_callee,this);}));function onChangeKeywordPathStyle(_x,_x2){return _ref.apply(this,arguments);}return onChangeKeywordPathStyle;}()},{key:'isKeywordOptionSelected',value:function isKeywordOptionSelected(catOptions,flag){return(catOptions&&catOptions.keywordsFromPathStyle&flag)===flag;}},{key:'renderKeywordFromPathCheckbox',value:function renderKeywordFromPathCheckbox(option){var _this2=this;var _props=this.props,catalogingOptions=_props.catalogingOptions,formatMessage=_props.intl.formatMessage;var flag=option.flag,label=option.label,isDisabled=option.isDisabled;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field',key:flag},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{checked:this.isKeywordOptionSelected(catalogingOptions,flag),className:'is-checkradio',id:flag,onChange:function onChange(e){return _this2.onChangeKeywordPathStyle(e,flag);},disabled:isDisabled,type:'checkbox','data-test-name':'checkbox-for-'+label}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:flag},formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */][label])));}},{key:'renderKeywordsFromPathComponent',value:function renderKeywordsFromPathComponent(){var _this3=this;var catalogProperties=this.props.catalogProperties;var checkboxOptions=[{flag:OPTION_FILENAME,label:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME',isDisabled:false},{flag:OPTION_PARENT_FOLDER,label:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT',isDisabled:false},{flag:OPTION_FOLDER_TREE,label:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE',isDisabled:false},{flag:OPTION_VOLUME,label:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME',isDisabled:Object(__WEBPACK_IMPORTED_MODULE_9_util_catalogUtils__["d" /* isVaultCatalog */])(catalogProperties)},{flag:OPTION_SERVER,label:'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER',isDisabled:Object(__WEBPACK_IMPORTED_MODULE_9_util_catalogUtils__["d" /* isVaultCatalog */])(catalogProperties)}];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL)),checkboxOptions.map(function(option){return _this3.renderKeywordFromPathCheckbox(option);}));}},{key:'render',value:function render(){var _props2=this.props,catalog=_props2.catalog,exclusionInfo=_props2.exclusionInfo;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contents-textured portfolio-form-container','data-test-name':'catalog-options-page'},this.renderKeywordsFromPathComponent(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__FileAndFolderExclusions__["a" /* default */],{catalogId:catalog.catalogId,exclusionInfo:exclusionInfo,setExclusionInfo:this.props.setExclusionInfo,showModalPrompt:this.props.showModalPrompt}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FileTypesComponent__["a" /* default */],{exclusionInfo:exclusionInfo,catalog:catalog}));}}]);return CatalogingOptionsForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{catalogingOptions:Object(__WEBPACK_IMPORTED_MODULE_4_state_selectors__["m" /* getCatalogingOptions */])(state),catalogProperties:Object(__WEBPACK_IMPORTED_MODULE_4_state_selectors__["k" /* getCatalogProperties */])(state),exclusionInfo:Object(__WEBPACK_IMPORTED_MODULE_4_state_selectors__["j" /* getCatalogExclusionInfo */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({getCatalogPropertiesCommand:__WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__["l" /* getCatalogProperties */],setExclusionInfo:__WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__["A" /* setExclusionInfo */],showModalPrompt:showModalPrompt,updateCatalogingOptions:__WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__["C" /* updateCatalogingOptions */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(CatalogingOptionsForm)));

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var exclusionPredicates=['startsWith','endsWith','contains'];var FileAndFolderExclusions=function(_Component){_inherits(FileAndFolderExclusions,_Component);function FileAndFolderExclusions(){_classCallCheck(this,FileAndFolderExclusions);var _this=_possibleConstructorReturn(this,(FileAndFolderExclusions.__proto__||Object.getPrototypeOf(FileAndFolderExclusions)).call(this));_this.state={exclusionPredicate:'startsWith',exclusionParam:'',isLoading:false,selectedExclusion:0};_this.handleChangeParam=_this.handleChangeParam.bind(_this);_this.handleChangePredicate=_this.handleChangePredicate.bind(_this);_this.handleChangeSelected=_this.handleChangeSelected.bind(_this);_this.handleClickAdd=_this.handleClickAdd.bind(_this);_this.handleListKeyDown=_this.handleListKeyDown.bind(_this);_this.handleParamKeyDown=_this.handleParamKeyDown.bind(_this);return _this;}_createClass(FileAndFolderExclusions,[{key:'handleChangeSelected',value:function handleChangeSelected(e){this.setState({selectedExclusion:parseInt(e.currentTarget.value,10)});}},{key:'handleChangePredicate',value:function handleChangePredicate(e){this.setState({exclusionPredicate:e.currentTarget.value});}},{key:'handleChangeParam',value:function handleChangeParam(e){this.setState({exclusionParam:e.currentTarget.value});}},{key:'handleListKeyDown',value:function handleListKeyDown(e){var _this2=this;var _props=this.props,catalogId=_props.catalogId,exclusionInfo=_props.exclusionInfo;var selectedIndices=[].concat(_toConsumableArray(e.currentTarget.options)).reduce(function(acc,o,idx){return o.selected&&acc.concat(idx)||acc;},[]);if(['Backspace','Delete'].includes(e.key)&&exclusionInfo&&Array.isArray(exclusionInfo.pathExclusions)&&selectedIndices.length){__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__["a" /* default */].debug('Delete ',selectedIndices.map(function(i){return exclusionInfo.pathExclusions[i];}));this.props.showModalPrompt({isButton2Default:true,message:__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION,onButton2:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this2.setState({isLoading:true});_context.next=3;return _this2.props.setExclusionInfo(catalogId,Object.assign({},exclusionInfo,{pathExclusions:exclusionInfo.pathExclusions.filter(function(ex,idx){return!selectedIndices.includes(idx);})}));case 3:_this2.setState({isLoading:false});case 4:case'end':return _context.stop();}}},_callee,_this2);}));function onButton2(){return _ref.apply(this,arguments);}return onButton2;}()});}}},{key:'handleParamKeyDown',value:function handleParamKeyDown(e){if(e.key==='Enter'){this.handleClickAdd(e);}}},{key:'handleClickAdd',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var _props2,catalogId,exclusionInfo,_state,exclusionParam,exclusionPredicate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_props2=this.props,catalogId=_props2.catalogId,exclusionInfo=_props2.exclusionInfo;_state=this.state,exclusionParam=_state.exclusionParam,exclusionPredicate=_state.exclusionPredicate;if(!(exclusionParam&&exclusionInfo)){_context2.next=8;break;}__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__["a" /* default */].debug('Add exclusion: {'+exclusionPredicate+', '+exclusionParam+'}');this.setState({exclusionParam:'',isLoading:true});_context2.next=7;return this.props.setExclusionInfo(catalogId,Object.assign({},exclusionInfo,{pathExclusions:[].concat(_toConsumableArray(exclusionInfo.pathExclusions),[{name:exclusionPredicate,value:exclusionParam}])}));case 7:this.setState({isLoading:false});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function handleClickAdd(_x){return _ref2.apply(this,arguments);}return handleClickAdd;}()},{key:'render',value:function render(){var _props3=this.props,exclusionInfo=_props3.exclusionInfo,formatMessage=_props3.intl.formatMessage;var _state2=this.state,exclusionPredicate=_state2.exclusionPredicate,exclusionParam=_state2.exclusionParam,isLoading=_state2.isLoading;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_EXCLUSION_LABEL)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-multiple is-small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{multiple:true,onChange:this.handleChangeSelected,onKeyDown:this.handleListKeyDown,size:'8',style:{width:'400px'},'data-test-name':'file-exclusions'},exclusionInfo&&exclusionInfo.pathExclusions&&exclusionInfo.pathExclusions.map(function(ex,idx){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:idx,value:idx,'data-test-name':'exclusion'},formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */][ex.name])+' \''+ex.value+'\'');})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-small'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{onChange:this.handleChangePredicate,value:exclusionPredicate,'data-test-name':'new-exclusion-predicate'},exclusionPredicates.map(function(t){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:t,value:t,'data-test-name':'predicate'},formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */][t]));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'input',type:'text',onChange:this.handleChangeParam,onKeyDown:this.handleParamKeyDown,value:exclusionParam,'data-test-name':'new-exclusion-def'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button '+(isLoading?'is-loading':''),disabled:!exclusionParam||isLoading,onClick:this.handleClickAdd,'data-test-name':'add-exclusion'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-plus'})))))));}}]);return FileAndFolderExclusions;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(FileAndFolderExclusions));

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_Pages_CatalogsPage_FileTypeEditor__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_Pages_CatalogsPage_FileTypeComponent__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_view_Forms_Listbox__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var initialState={allowAllFileTypes:true,selectedFileTypeName:undefined,selectedFileType:undefined,isAddFileType:false,editorHasUnsavedChanges:false,listboxSelection:{selectedItems:[],lastClicked:undefined,lastArrowed:undefined}};var FileTypesComponent=function(_Component){_inherits(FileTypesComponent,_Component);function FileTypesComponent(){_classCallCheck(this,FileTypesComponent);var _this=_possibleConstructorReturn(this,(FileTypesComponent.__proto__||Object.getPrototypeOf(FileTypesComponent)).call(this));_this.state=initialState;_this.fileTypeToComponent=_this.fileTypeToComponent.bind(_this);_this.onChangeAllowFileTypes=_this.onChangeAllowFileTypes.bind(_this);_this.handleAddFileType=_this.handleAddFileType.bind(_this);_this.handleAddFileType_postPrompt=_this.handleAddFileType_postPrompt.bind(_this);_this.handleSelectFileType_postPrompt=_this.handleSelectFileType_postPrompt.bind(_this);_this.handleCancelFileTypeEdit=_this.handleCancelFileTypeEdit.bind(_this);_this.handleRemoveFileType=_this.handleRemoveFileType.bind(_this);_this.handleSelectFileType=_this.handleSelectFileType.bind(_this);_this.handleToggleFileTypeEnabled=_this.handleToggleFileTypeEnabled.bind(_this);_this.setFileTypes=_this.setFileTypes.bind(_this);_this.setEditorHasUnsavedChanges=_this.setEditorHasUnsavedChanges.bind(_this);_this.handleRestoreDefaults=_this.handleRestoreDefaults.bind(_this);return _this;}_createClass(FileTypesComponent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.exclusionInfo){this.setState({allowAllFileTypes:nextProps.exclusionInfo.allowAllFileTypes});}}},{key:'onChangeAllowFileTypes',value:function onChangeAllowFileTypes(e){var _props=this.props,catalog=_props.catalog,exclusionInfo=_props.exclusionInfo;var allowAll=e.currentTarget.value==='allFileTypes';this.props.setExclusionInfo(catalog.catalogId,Object.assign({},exclusionInfo,{allowAllFileTypes:allowAll}));this.setState({allowAllFileTypes:allowAll});}},{key:'handleToggleFileTypeEnabled',value:function handleToggleFileTypeEnabled(enabled,name,ft){this.setFileTypes(this.props.exclusionInfo.fileTypes.map(function(f){return f.title===ft.title&&f.extensions===ft.extensions?{title:ft.title,extensions:ft.extensions,enabled:enabled}:f;}));}},{key:'setFileTypes',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileTypes,newFileType){var _props2,catalog,exclusionInfo,name;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props2=this.props,catalog=_props2.catalog,exclusionInfo=_props2.exclusionInfo;_context.next=3;return this.props.setExclusionInfo(catalog.catalogId,Object.assign({},exclusionInfo,{fileTypes:fileTypes.map(function(ft){return{title:ft.title,extensions:ft.extensions,enabled:ft.enabled};})}));case 3:if(this.state.isAddFileType){name=Object(__WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__["b" /* computeFileTypeName */])(newFileType);this.setState({selectedFileTypeName:name,selectedFileType:newFileType,editorHasUnsavedChanges:false,isAddFileType:false,listboxSelection:{selectedItems:[name],lastClicked:name,lastArrowed:name}});}else{this.setState({editorHasUnsavedChanges:false});}case 4:case'end':return _context.stop();}}},_callee,this);}));function setFileTypes(_x,_x2){return _ref.apply(this,arguments);}return setFileTypes;}()},{key:'handleSelectFileType_postPrompt',value:function handleSelectFileType_postPrompt(selectionState){if(!selectionState){return;}if(selectionState.selectedItems.length===1){var ft=this.props.exclusionInfo.fileTypes.find(function(f){return Object(__WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__["b" /* computeFileTypeName */])(f)===selectionState.selectedItems[0];});this.setState({selectedFileTypeName:ft?Object(__WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__["b" /* computeFileTypeName */])(ft):undefined,selectedFileType:ft,editorHasUnsavedChanges:false,isAddFileType:false,listboxSelection:selectionState});}else{this.setState({selectedFileTypeName:undefined,selectedFileType:undefined,editorHasUnsavedChanges:false,isAddFileType:false,listboxSelection:selectionState});}}},{key:'handleSelectFileType',value:function handleSelectFileType(selectionState){var _this2=this;if(this.state.editorHasUnsavedChanges){this.props.showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FILE_TYPES_PROMPT_DISCARD_CHANGES,onButton2:function onButton2(){return _this2.handleSelectFileType_postPrompt(selectionState);}});}else{this.handleSelectFileType_postPrompt(selectionState);}}},{key:'handleAddFileType_postPrompt',value:function handleAddFileType_postPrompt(){this.setState({selectedFileTypeName:undefined,selectedFileType:undefined,isAddFileType:true});}},{key:'handleAddFileType',value:function handleAddFileType(){var _this3=this;if(this.state.editorHasUnsavedChanges){this.props.showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FILE_TYPES_PROMPT_DISCARD_CHANGES,onButton2:function onButton2(){return _this3.handleAddFileType_postPrompt();}});}else{this.handleAddFileType_postPrompt();}}},{key:'handleRemoveFileType',value:function handleRemoveFileType(){var _this4=this;var _props3=this.props,fileTypes=_props3.exclusionInfo.fileTypes,showModalPrompt=_props3.showModalPrompt;var selectedItems=this.state.listboxSelection.selectedItems;showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION,onButton2:function onButton2(){_this4.setFileTypes(fileTypes.filter(function(ft){return!selectedItems.includes(Object(__WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__["b" /* computeFileTypeName */])(ft));}));_this4.setState({selectedFileTypeName:undefined,selectedFileType:undefined,listboxSelection:{selectedItems:[],lastClicked:undefined,lastArrowed:undefined}});}});}},{key:'handleRestoreDefaults',value:function handleRestoreDefaults(){var _this5=this;var _props4=this.props,catalog=_props4.catalog,restoreFileTypesDefault=_props4.restoreFileTypesDefault,showModalPrompt=_props4.showModalPrompt;var allowAllFileTypes=this.state.allowAllFileTypes;showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FILE_TYPES_PROMPT_RESTORE_DEFAULTS,onButton2:function onButton2(){restoreFileTypesDefault(catalog.catalogId);_this5.setState(Object.assign({},initialState,{allowAllFileTypes:allowAllFileTypes}));}});}},{key:'handleCancelFileTypeEdit',value:function handleCancelFileTypeEdit(){this.setState({isAddFileType:false,editorHasUnsavedChanges:false});}},{key:'setEditorHasUnsavedChanges',value:function setEditorHasUnsavedChanges(v){this.setState({editorHasUnsavedChanges:v});}},{key:'fileTypeToComponent',value:function fileTypeToComponent(item,isSelected,onClick,onKeyDown,disabled){var name=Object(__WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__["b" /* computeFileTypeName */])(item);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_Pages_CatalogsPage_FileTypeComponent__["a" /* default */],{disabled:disabled,key:name,name:name,fileType:item,onClick:onClick,onKeyDown:onKeyDown,selectFileType:this.handleSelectFileType,toggleFileTypeEnabled:this.handleToggleFileTypeEnabled,isSelected:isSelected});}},{key:'render',value:function render(){var _this6=this;var exclusionInfo=this.props.exclusionInfo;var allowAllFileTypes=this.state.allowAllFileTypes;var fileTypes=(exclusionInfo&&exclusionInfo.fileTypes||[]).map(function(f){return Object.assign({},f,{listId:Object(__WEBPACK_IMPORTED_MODULE_7_util_catalogUtils__["b" /* computeFileTypeName */])(f)});}).sort(function(a,b){return a.listId.localeCompare(b.listId);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'box',style:{height:'600px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FILE_TYPES_SECTION_TITLE)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control',key:'allFileTypes',style:{marginBottom:'.5rem'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{checked:allowAllFileTypes,className:'is-checkradio',value:'allFileTypes',id:'allFileTypes',onChange:this.onChangeAllowFileTypes,type:'radio','data-test-name':'radio-allFileTypes'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'role-label',htmlFor:'allFileTypes'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_ALL_FILE_TYPES))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control',key:'onlyTheseFileTypes',style:{marginBottom:'.5rem'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{checked:!allowAllFileTypes,className:'is-checkradio',value:'onlyTheseFileTypes',id:'onlyTheseFileTypes',onChange:this.onChangeAllowFileTypes,type:'radio','data-test-name':'radio-onlyTheseFileTypes'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'role-label',htmlFor:'onlyTheseFileTypes'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CATALOG_OPTIONS_ONLY_FILE_TYPES))),!allowAllFileTypes&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box filetype-main-box',key:'fileTypesManager'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control filetype-list',key:'fileTypesList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_Listbox__["a" /* default */],{outerClass:'select is-multiple is-small',items:fileTypes,itemToComponent:this.fileTypeToComponent,selectionState:this.state.listboxSelection,disabled:allowAllFileTypes})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_Pages_CatalogsPage_FileTypeEditor__["a" /* default */],{disabled:allowAllFileTypes||!this.state.isAddFileType&&!this.state.selectedFileTypeName,fileType:this.state.selectedFileType,fileTypeName:this.state.selectedFileTypeName,fileTypes:fileTypes,setFileTypes:this.setFileTypes,isAdd:this.state.isAddFileType,onCancel:this.handleCancelFileTypeEdit,setHasUnsavedChanges:this.setEditorHasUnsavedChanges,ref:function ref(c){return _this6.fileTypeEditor=c;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-grouped is-pulled-left',style:{marginLeft:'40px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',onClick:this.handleAddFileType,type:'button',disabled:this.state.isAddFileType,'data-test-name':'file-type-add'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-plus'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',type:'button','data-test-name':'file-type-remove',disabled:!this.state.listboxSelection.selectedItems.length,onClick:this.handleRemoveFileType},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-minus'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',type:'button','data-test-name':'file-type-reset',onClick:this.handleRestoreDefaults},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FILE_TYPES_LABEL_RESTORE_DEFAULTS))))));}}]);return FileTypesComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{exclusionInfo:Object(__WEBPACK_IMPORTED_MODULE_11_state_selectors__["j" /* getCatalogExclusionInfo */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_10_util_safeDispatch__["a" /* bindActionCreatorsForm */])({restoreFileTypesDefault:__WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__["y" /* restoreFileTypesDefault */],setExclusionInfo:__WEBPACK_IMPORTED_MODULE_12_state_commands_catalogCommands__["A" /* setExclusionInfo */],showModalPrompt:showModalPrompt});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(FileTypesComponent)));

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_view_Forms_FormField__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_catalogUtils__ = __webpack_require__(100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var FileTypeEditor=function(_Component){_inherits(FileTypeEditor,_Component);function FileTypeEditor(){_classCallCheck(this,FileTypeEditor);var _this=_possibleConstructorReturn(this,(FileTypeEditor.__proto__||Object.getPrototypeOf(FileTypeEditor)).call(this));_this.setFocusOnTitle=_this.setFocusOnTitle.bind(_this);_this.handleCancelClicked=_this.handleCancelClicked.bind(_this);_this.resetAndCancel=_this.resetAndCancel.bind(_this);_this.handleAddOrUpdateClicked=_this.handleAddOrUpdateClicked.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}_createClass(FileTypeEditor,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,fileType=_props.fileType,initialize=_props.initialize;initialize(fileTypeToFormValues(fileType));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;var _props2=this.props,fileType=_props2.fileType,initialize=_props2.initialize,isAdd=_props2.isAdd;function makeId(ft){return ft?Object(__WEBPACK_IMPORTED_MODULE_10_util_catalogUtils__["b" /* computeFileTypeName */])(ft).toLowerCase():'';}if(makeId(fileType)!==makeId(nextProps.fileType)){initialize(fileTypeToFormValues(nextProps.fileType));}if(!isAdd&&nextProps.isAdd){setTimeout(function(){return _this2.setFocusOnTitle();});}}},{key:'setFocusOnTitle',value:function setFocusOnTitle(){if(this.titleField){var titleElement=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.titleField);titleElement instanceof HTMLInputElement&&titleElement.focus();}}},{key:'handleCancelClicked',value:function handleCancelClicked(){var _props3=this.props,pristine=_props3.pristine,showModalPrompt=_props3.showModalPrompt;if(!pristine){showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FILE_TYPES_PROMPT_DISCARD_CHANGES,onButton2:this.resetAndCancel,isButton1Default:true,isButton2Default:false});}else{this.resetAndCancel();}}},{key:'resetAndCancel',value:function resetAndCancel(){var _props4=this.props,onCancel=_props4.onCancel,reset=_props4.reset;reset();onCancel();}},{key:'handleAddOrUpdateClicked',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props5,extensions,fileType,fileTypeNameProp,fileTypesProp,isAdd,setFileTypes,showSingleButtonAlert,title,newFileType,fileTypes,fileTypeName,newName,newFileTypes,oldName,otherFileTypes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props5=this.props,extensions=_props5.extensions,fileType=_props5.fileType,fileTypeNameProp=_props5.fileTypeName,fileTypesProp=_props5.fileTypes,isAdd=_props5.isAdd,setFileTypes=_props5.setFileTypes,showSingleButtonAlert=_props5.showSingleButtonAlert,title=_props5.title;newFileType={title:title||'',extensions:toExtensionArray(extensions),enabled:isAdd||(fileType?fileType.enabled:false)};fileTypes=fileTypesProp||[];fileTypeName=fileTypeNameProp||'';newName=Object(__WEBPACK_IMPORTED_MODULE_10_util_catalogUtils__["b" /* computeFileTypeName */])(newFileType).toLowerCase();newFileTypes=void 0;if(isAdd){if(!fileTypes.find(function(ft){return Object(__WEBPACK_IMPORTED_MODULE_10_util_catalogUtils__["b" /* computeFileTypeName */])(ft).toLowerCase()===newName;})){newFileTypes=[].concat(_toConsumableArray(fileTypes),[newFileType]);}}else{oldName=fileTypeName.toLowerCase();otherFileTypes=fileTypes.filter(function(ft){return Object(__WEBPACK_IMPORTED_MODULE_10_util_catalogUtils__["b" /* computeFileTypeName */])(ft).toLowerCase()!==oldName;});if(!otherFileTypes.find(function(ft){return Object(__WEBPACK_IMPORTED_MODULE_10_util_catalogUtils__["b" /* computeFileTypeName */])(ft).toLowerCase()===newName;})){newFileTypes=[].concat(_toConsumableArray(otherFileTypes),[newFileType]);}}if(!newFileTypes){_context.next=13;break;}_context.next=10;return setFileTypes(newFileTypes,newFileType);case 10:this.props.initialize(fileTypeToFormValues(newFileType));_context.next=15;break;case 13:showSingleButtonAlert(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FILE_TYPES_ERROR_NAME_EXISTS,{name:newName});this.setFocusOnTitle();case 15:case'end':return _context.stop();}}},_callee,this);}));function handleAddOrUpdateClicked(){return _ref.apply(this,arguments);}return handleAddOrUpdateClicked;}()},{key:'handleKeyDown',value:function handleKeyDown(e){var keyHandled=false;if(e.key==='Enter'){keyHandled=true;this.handleAddOrUpdateClicked();}else if(e.key==='Escape'){keyHandled=true;this.resetAndCancel();}if(keyHandled){e.stopPropagation();e.preventDefault();}}},{key:'render',value:function render(){var _this3=this;var _props6=this.props,disabled=_props6.disabled,fileType=_props6.fileType,formatMessage=_props6.intl.formatMessage,isAdd=_props6.isAdd,pristine=_props6.pristine,submitting=_props6.submitting,error=_props6.error;var addOrUpdateMessage=!!fileType?__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FILE_TYPES_UPDATE_FILE_TYPE:__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FILE_TYPES_ADD_FILE_TYPE;// Below: Setting autoComplete to an invalid value seems to be the currently
// accepted way to turn it off.
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'filetype-editor','data-test-name':'filetypes-editor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CUSTOM_TITLE),labelClassName:'is-normal',dataTestName:'file-type-custom-name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{className:'input',component:'input',id:'title',name:'title',type:'text',disabled:disabled,onKeyDown:this.handleKeyDown,autoComplete:'invalid-autocomplete-value',ref:function ref(c){return _this3.titleField=c;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FILE_TYPES_EXTENSIONS),labelClassName:'is-normal',dataTestName:'file-type-extensions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{className:'textarea no-resize',component:'textarea',id:'extensions',name:'extensions',type:'textarea',disabled:disabled,onKeyDown:this.handleKeyDown})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-grouped',style:{justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',disabled:!isAdd&&pristine||submitting||disabled,onClick:this.handleCancelClicked,type:'button','data-test-name':'file-type-cancel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CANCEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control inline'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',disabled:pristine||submitting||disabled||error,onClick:this.handleAddOrUpdateClicked,type:'button','data-test-name':'file-type-add-or-update'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */],addOrUpdateMessage)))));}}]);return FileTypeEditor;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function toExtensionArray(s){if(!s){return[];}var a=s.split(',');return a.reduce(function(acc,ex){ex=ex.trim();if(ex){acc.push(ex);}return acc;},[]);}function extensionsToString(extensions){return extensions.reduce(function(acc,s){if(acc){acc=acc+',';}return acc+s;},'');}function fileTypeToFormValues(ft){if(!ft){return{};}return{title:ft.title||'',extensions:extensionsToString(ft.extensions)};}function validate(data,props){return{_error:!data.extensions||!toExtensionArray(data.extensions).length};}var FORM_NAME='FileTypeEditor';var form=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["k" /* reduxForm */])({form:'FileTypeEditor',validate:validate,onChange:function onChange(values,dispatch,props){props.setHasUnsavedChanges(props.dirty);}})(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* injectIntl */])(FileTypeEditor));var valueSelector=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(FORM_NAME);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{title:valueSelector(state,'title'),extensions:valueSelector(state,'extensions')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__["a" /* bindActionCreatorsForm */])({showModalPrompt:showModalPrompt,showSingleButtonAlert:__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */]});})(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileTypeComponent=function(_Component){_inherits(FileTypeComponent,_Component);function FileTypeComponent(){_classCallCheck(this,FileTypeComponent);var _this=_possibleConstructorReturn(this,(FileTypeComponent.__proto__||Object.getPrototypeOf(FileTypeComponent)).call(this));_this.handleEnable=_this.handleEnable.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}_createClass(FileTypeComponent,[{key:'handleEnable',value:function handleEnable(){var _props=this.props,toggleFileTypeEnabled=_props.toggleFileTypeEnabled,name=_props.name,fileType=_props.fileType,disabled=_props.disabled;if(!disabled){toggleFileTypeEnabled(fileType.enabled===false,name,fileType);}}},{key:'handleSelect',value:function handleSelect(e){e.stopPropagation();var _props2=this.props,onClick=_props2.onClick,selectFileType=_props2.selectFileType,name=_props2.name,disabled=_props2.disabled;if(!disabled){var selectState=onClick(e,name);if(selectState){selectFileType(selectState);}}}},{key:'handleKeyDown',value:function handleKeyDown(e){var _props3=this.props,disabled=_props3.disabled,onKeyDown=_props3.onKeyDown,selectFileType=_props3.selectFileType;if(!disabled){var selectState=onKeyDown(e);if(selectState){selectFileType(selectState);}}}},{key:'render',value:function render(){var _props4=this.props,fileType=_props4.fileType,name=_props4.name,isSelected=_props4.isSelected,disabled=_props4.disabled;var id='filetype-'+name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field filetype '+(isSelected?'selected':''),'data-test-name':'file-types-component',tabIndex:'0',onKeyDown:this.handleKeyDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'is-checkradio is-small',checked:fileType.enabled,disabled:disabled,id:id,onChange:this.handleEnable,type:'checkbox','data-test-name':id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{marginRight:0,paddingRight:0},htmlFor:id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'filetype-name '+(disabled?'filetype-disabled':''),onClick:this.handleSelect},name));}}]);return FileTypeComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FileTypeComponent);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Listbox=function(_Component){_inherits(Listbox,_Component);function Listbox(){_classCallCheck(this,Listbox);var _this=_possibleConstructorReturn(this,(Listbox.__proto__||Object.getPrototypeOf(Listbox)).call(this));_this.handleClick=_this.handleClick.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}_createClass(Listbox,[{key:'handleClick',value:function handleClick(e,itemId){var _props=this.props,items=_props.items,selectionState=_props.selectionState;var newState=computeNewSelectionForMouseClick(e,itemId,items,selectionState);if(newState){return Object.assign({},this.state,newState);}}},{key:'handleKeyDown',value:function handleKeyDown(e){var _props2=this.props,items=_props2.items,selectionState=_props2.selectionState;if(!selectionState.selectedItems.length){return;}var newState=computeNewSelectionForKeyDown(e,items,selectionState);if(newState){e.stopPropagation();e.preventDefault();}return newState;}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,disabled=_props3.disabled,items=_props3.items,itemToComponent=_props3.itemToComponent,outerClass=_props3.outerClass,selectionState=_props3.selectionState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerClass},items.map(function(i){return itemToComponent(i,selectionState.selectedItems.includes(i.listId),_this2.handleClick,_this2.handleKeyDown,disabled);}));}}]);return Listbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// TODO - refactor to simplify after writing tests.
/* harmony default export */ __webpack_exports__["a"] = (Listbox);function computeNewSelectionForMouseClick(e,// could be a synthetic event or a test fixture
itemId,items,selectionState){var selectedItems=selectionState.selectedItems,lastClicked=selectionState.lastClicked;var newState=void 0;if(e.shiftKey&&lastClicked){var iFirst=items.findIndex(function(i){return lastClicked===i.listId;});if(iFirst>=0){var iItem=items.findIndex(function(i){return i.listId===itemId;});var newSelected=items.reduce(function(acc,i,idx){if(idx>=iFirst&&idx<=iItem||idx<=iFirst&&idx>=iItem){acc.push(i.listId);}return acc;},[]);newState={selectedItems:newSelected,lastClicked:itemId,lastArrowed:itemId};}}else if(e.metaKey||e.ctrlKey){var isIncluded=selectedItems.includes(itemId);var newSelectedItems=isIncluded?selectedItems.filter(function(i){return i!==itemId;}):[].concat(_toConsumableArray(selectedItems),[itemId]);newState={selectedItems:newSelectedItems,lastClicked:itemId,lastArrowed:itemId};}else{newState={lastClicked:itemId,lastArrowed:itemId,selectedItems:[itemId]};}return newState;}// TODO - refactor to simplify after writing tests.
function computeNewSelectionForKeyDown(e,// could be a synthetic event or a test fixture
items,selectionState){if(!items||!items.length){return null;}var selectedItems=selectionState.selectedItems,lastClicked=selectionState.lastClicked,lastArrowed=selectionState.lastArrowed;var newState=void 0;if(e.keyCode===40){// down arrow
if(!lastClicked){return{selectedItems:[items[0].listId],lastClicked:items[0].listId,lastArrowed:items[0].listId};}else if(e.shiftKey){var iLast=items.findIndex(function(i){return i.listId===lastArrowed;});if(iLast+1<items.length){var newLastArrowed=items[iLast+1].listId;var newSelectedItems=[].concat(_toConsumableArray(selectedItems));if(!newSelectedItems.includes(newLastArrowed)){newSelectedItems.push(newLastArrowed);}else if(lastArrowed!==lastClicked){newSelectedItems=newSelectedItems.filter(function(i){return i!==lastArrowed;});}newState={selectedItems:newSelectedItems,lastArrowed:newLastArrowed};}}else{var _iLast=items.findIndex(function(i){return i.listId===lastArrowed;});if(_iLast+1<items.length){var _lastArrowed=items[_iLast+1].listId;newState={selectedItems:[_lastArrowed],lastArrowed:_lastArrowed,lastClicked:_lastArrowed};}}}else if(e.keyCode===38){// up arrow
if(!lastClicked){var _lastClicked=items[items.length-1].listId;newState={selectedItems:[_lastClicked],lastClicked:_lastClicked,lastArrowed:_lastClicked};}else if(e.shiftKey){var _iLast2=items.findIndex(function(i){return i.listId===lastArrowed;});if(_iLast2-1>=0){var _newLastArrowed=items[_iLast2-1].listId;var _newSelectedItems=[].concat(_toConsumableArray(selectedItems));if(!_newSelectedItems.includes(_newLastArrowed)){_newSelectedItems.push(_newLastArrowed);}else if(lastArrowed!==lastClicked){_newSelectedItems=_newSelectedItems.filter(function(i){return i!==lastArrowed;});}newState={selectedItems:_newSelectedItems,lastArrowed:_newLastArrowed};}}else{var _iLast3=items.findIndex(function(i){return i.listId===lastArrowed;});if(_iLast3-1>=0){var _lastArrowed2=items[_iLast3-1].listId;newState={selectedItems:[_lastArrowed2],lastArrowed:_lastArrowed2,lastClicked:_lastArrowed2};}}}return newState?Object.assign({},selectionState,newState):null;}

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CatalogManagedUploadFields__ = __webpack_require__(885);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CatalogManagedUploadForm=function(_Component){_inherits(CatalogManagedUploadForm,_Component);function CatalogManagedUploadForm(){_classCallCheck(this,CatalogManagedUploadForm);var _this=_possibleConstructorReturn(this,(CatalogManagedUploadForm.__proto__||Object.getPrototypeOf(CatalogManagedUploadForm)).call(this));_this.submit=_this.submit.bind(_this);return _this;}_createClass(CatalogManagedUploadForm,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var catalogId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.props.catalog){_context.next=4;break;}catalogId=this.props.catalog.catalogId;_context.next=4;return Promise.all([this.props.getCatalogPropertiesCommand(catalogId,[__WEBPACK_IMPORTED_MODULE_10_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOGING_OPTIONS,__WEBPACK_IMPORTED_MODULE_10_util_constants__["l" /* CATALOG_PROPERTY_KEY */].INGEST_CONFIG,__WEBPACK_IMPORTED_MODULE_10_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]),this.props.getFieldsCommand(catalogId)]);case 4:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'submit',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(values){var _props,catalog,catalogingOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_props=this.props,catalog=_props.catalog,catalogingOptions=_props.catalogingOptions;__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_util_logging__["a" /* default */].debug({managedIngest:values});_context2.next=4;return this.props.setIngestConfig(catalog.catalogId,Object.assign({},catalogingOptions,{useConstrainedIngest:values.useManagedUpload}),{headerText:values.formHeader,fields:values.formFields});case 4:case'end':return _context2.stop();}}},_callee2,this);}));function submit(_x){return _ref2.apply(this,arguments);}return submit;}()},{key:'render',value:function render(){var _props2=this.props,fieldDefs=_props2.fieldDefs,handleSubmit=_props2.handleSubmit,formatMessage=_props2.intl.formatMessage,invalid=_props2.invalid,pristine=_props2.pristine,submitting=_props2.submitting,useManagedUpload=_props2.useManagedUpload;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portfolio-form-container page-contents-textured','data-test-name':'managed-upload-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'box',onSubmit:handleSubmit(this.submit)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'is-medium',component:__WEBPACK_IMPORTED_MODULE_7_view_Forms_BulmaCheckRadio__["a" /* default */],id:'useManagedUpload',label:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].CATALOG_INGEST_USE_INGEST_LABEL),name:'useManagedUpload',type:'checkbox'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].CATALOG_INGEST_FORM_HEADER_LABEL)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control','data-test-name':'form-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'textarea',component:'textarea',disabled:!useManagedUpload,name:'formHeader',rows:2,type:'textarea'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'help'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].CATALOG_INGEST_HEADER_HINT_TEXT))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12__CatalogManagedUploadFields__["a" /* default */],disabled:!useManagedUpload,name:'formFields',fieldDefs:fieldDefs})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:pristine||submitting,onClick:this.props.reset},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button is-primary '+(submitting?'is-loading':''),'data-test-name':'apply',disabled:pristine||invalid,type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].APPLY)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'})));}}]);return CatalogManagedUploadForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var FORM_NAME='CatalogManagedUploadForm';var form=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({enableReinitialize:true,form:FORM_NAME})(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* injectIntl */])(CatalogManagedUploadForm));var uploadFormSelector=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* formValueSelector */])(FORM_NAME);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{catalogingOptions:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["m" /* getCatalogingOptions */])(state),fieldDefs:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["H" /* getFields */])(state),initialValues:{formHeader:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["M" /* getIngestConfig */])(state).headerText,useManagedUpload:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_31" /* getUseConstrainedIngest */])(state),formFields:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["M" /* getIngestConfig */])(state).fields},ingestConfig:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["M" /* getIngestConfig */])(state),useManagedUpload:uploadFormSelector(state,'useManagedUpload')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({getCatalogPropertiesCommand:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["l" /* getCatalogProperties */],getFieldsCommand:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["p" /* getFields */],setIngestConfig:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["B" /* setIngestConfig */],updateCatalogingOptions:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["C" /* updateCatalogingOptions */]});})(form));

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManagedUploadField__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Field__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portfolio_shared_util_fieldDefUtils__ = __webpack_require__(74);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FIELD_DEFS_ID='fieldDefinitions';var FORM_FIELDS_ID='formFields';var DROPPABLE_TABLE_STYLE={display:'flex',flexDirection:'column',width:'45%'};function TableHeader(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-marginless has-text-weight-bold is-size-7'},props.children);}var ManagedUploadFields=function(_Component){_inherits(ManagedUploadFields,_Component);function ManagedUploadFields(){_classCallCheck(this,ManagedUploadFields);var _this=_possibleConstructorReturn(this,(ManagedUploadFields.__proto__||Object.getPrototypeOf(ManagedUploadFields)).call(this));_this.getListClass=_this.getListClass.bind(_this);_this.handleDragEnd=_this.handleDragEnd.bind(_this);_this.handleRequiredClick=_this.handleRequiredClick.bind(_this);_this.moveFieldFromFormFields=_this.moveFieldFromFormFields.bind(_this);_this.moveFieldToFormFields=_this.moveFieldToFormFields.bind(_this);return _this;}_createClass(ManagedUploadFields,[{key:'moveFieldToFormFields',value:function moveFieldToFormFields(fdId){var destinationIndex=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Number.MAX_SAFE_INTEGER;var _props=this.props,fieldDefs=_props.fieldDefs,_props$input=_props.input,onChange=_props$input.onChange,value=_props$input.value;var newValue=Array.from(value);newValue.splice(destinationIndex,0,{fieldDefinition:fieldDefs.find(function(fd){return fd.id===fdId;}),required:false});onChange(newValue);}},{key:'moveFieldFromFormFields',value:function moveFieldFromFormFields(fdId){var _props$input2=this.props.input,onChange=_props$input2.onChange,value=_props$input2.value;onChange(value.filter(function(f){return f.fieldDefinition.id!==fdId;}));}},{key:'handleDragEnd',value:function handleDragEnd(result){var _props$input3=this.props.input,onChange=_props$input3.onChange,value=_props$input3.value;var source=result.source,destination=result.destination;if(!destination){return;}if(source.droppableId===destination.droppableId){if(source.droppableId===FIELD_DEFS_ID){return;}// reorder
var newValue=Array.from(value);var _newValue$splice=newValue.splice(source.index,1),_newValue$splice2=_slicedToArray(_newValue$splice,1),removed=_newValue$splice2[0];newValue.splice(destination.index,0,removed);onChange(newValue);}else if(destination.droppableId===FIELD_DEFS_ID){this.moveFieldFromFormFields(result.draggableId);}else if(destination.droppableId===FORM_FIELDS_ID){this.moveFieldToFormFields(result.draggableId,destination.index);}}},{key:'getItemStyle',value:function getItemStyle(isDragging,draggableStyle){var spacing=2;return Object.assign({fontSize:'14px',userSelect:'none',padding:spacing,margin:'0 0 '+spacing+'px 0'},draggableStyle);}},{key:'getListStyle',value:function getListStyle(isDraggingOver){return{border:'solid 1px var(--borderColor)',outline:isDraggingOver?'solid 2px var(--darkGrey)':'',padding:8,height:350,overflowY:'auto',overflowX:'hidden'};}},{key:'getListClass',value:function getListClass(){var disabled=this.props.disabled;return''+(disabled?'has-background-light has-text-grey':'has-text-grey-darker');}},{key:'handleRequiredClick',value:function handleRequiredClick(id){var _props$input4=this.props.input,onChange=_props$input4.onChange,value=_props$input4.value;onChange(value.map(function(icf){return icf.fieldDefinition.id===id?Object.assign({},icf,{required:!icf.required}):icf;}));}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,disabled=_props2.disabled,fieldDefs=_props2.fieldDefs,value=_props2.input.value,intl=_props2.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["a" /* DragDropContext */],{onDragEnd:this.handleDragEnd},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:DROPPABLE_TABLE_STYLE,'data-test-name':'available-fields'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableHeader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_INGEST_FIELDS_LABEL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["c" /* Droppable */],{droppableId:FIELD_DEFS_ID},function(provided,snapshot){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:_this2.getListClass(),ref:provided.innerRef,style:_this2.getListStyle(snapshot.isDraggingOver)},Object(__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_util_fieldDefUtils__["d" /* getAllDisplayableFields */])(fieldDefs).filter(function(fd){return!__WEBPACK_IMPORTED_MODULE_8_portfolio_shared_util_fieldDefUtils__["a" /* ALL_KNOWN_READ_ONLY_FIELD_DEF_NAMES */].includes(fd.systemName)&&Array.isArray(value)&&!value.find(function(v){return v.fieldDefinition.id===fd.id;});}).sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["q" /* displayNameForField */])(intl,a.systemName).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["q" /* displayNameForField */])(intl,b.systemName));}).map(function(fd,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["b" /* Draggable */],{key:fd.id,draggableId:fd.id,index:idx,isDragDisabled:disabled},function(provided,snapshot){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({ref:provided.innerRef},provided.draggableProps,provided.dragHandleProps,{style:_this2.getItemStyle(snapshot.isDragging,provided.draggableProps.style),'data-test-name':'available-field-'+fd.systemName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Field__["a" /* default */],{fieldDef:fd,onDoubleClick:_this2.moveFieldToFormFields}));});}),provided.placeholder);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:DROPPABLE_TABLE_STYLE,'data-test-name':'selected-fields'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableHeader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_INGEST_REQUIRED_LABEL)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-three-quarters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["c" /* Droppable */],{droppableId:FORM_FIELDS_ID},function(provided,snapshot){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:_this2.getListClass(),ref:provided.innerRef,style:_this2.getListStyle(snapshot.isDraggingOver)},Array.isArray(value)&&value.map(function(fd,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["b" /* Draggable */],{isDragDisabled:disabled,key:fd.fieldDefinition.id,draggableId:fd.fieldDefinition.id,index:idx},function(provided,snapshot){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({ref:provided.innerRef},provided.draggableProps,provided.dragHandleProps,{style:_this2.getItemStyle(snapshot.isDragging,provided.draggableProps.style),'data-test-name':'selected-field-'+fd.fieldDefinition.systemName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ManagedUploadField__["a" /* default */],{disabled:disabled,field:fd,onDoubleClick:_this2.moveFieldFromFormFields,onRequiredClick:_this2.handleRequiredClick}));});}),Array.isArray(value)&&value.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'has-text-centered has-text-grey is-size-7',style:{margin:'40% 8px',userSelect:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_INGEST_DRAG_HINT_TEXT)),provided.placeholder);}))));}}]);return ManagedUploadFields;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(ManagedUploadFields));

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectedDroppable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConnectedDraggable; });
/* unused harmony export resetServerContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_invariant__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_box_model__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_memoize_one__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf_schd__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_motion__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_motion__);














var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var absolute = function absolute(point) {
  return {
    x: Math.abs(point.x),
    y: Math.abs(point.y)
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var expandByPosition = function expandByPosition(spacing, position) {
  return {
    top: spacing.top - position.y,
    left: spacing.left - position.x,
    right: spacing.right + position.x,
    bottom: spacing.bottom + position.y
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var clip = function clip(frame, subject) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["d" /* getRect */])({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
};
var getDroppableDimension = function getDroppableDimension(_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest$$1 = _ref.closest;

  var scrollable = function () {
    if (!closest$$1) {
      return null;
    }

    var maxScroll = getMaxScroll({
      scrollHeight: closest$$1.scrollHeight,
      scrollWidth: closest$$1.scrollWidth,
      height: closest$$1.client.paddingBox.height,
      width: closest$$1.client.paddingBox.width
    });
    return {
      framePageMarginBox: closest$$1.page.marginBox,
      shouldClipSubject: closest$$1.shouldClipSubject,
      scroll: {
        initial: closest$$1.scroll,
        current: closest$$1.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var subjectPageMarginBox = page.marginBox;
  var clippedPageMarginBox = scrollable && scrollable.shouldClipSubject ? clip(scrollable.framePageMarginBox, subjectPageMarginBox) : subjectPageMarginBox;
  var viewport = {
    closestScrollable: scrollable,
    subjectPageMarginBox: subjectPageMarginBox,
    clippedPageMarginBox: clippedPageMarginBox
  };
  var dimension = {
    descriptor: descriptor,
    axis: direction === 'vertical' ? vertical : horizontal,
    isEnabled: isEnabled,
    client: client,
    page: page,
    viewport: viewport
  };
  return dimension;
};
var scrollDroppable = function scrollDroppable(droppable, newScroll) {
  !droppable.viewport.closestScrollable ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var scrollable = droppable.viewport.closestScrollable;
  var framePageMarginBox = scrollable.framePageMarginBox;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);
  var closestScrollable = {
    framePageMarginBox: scrollable.framePageMarginBox,
    shouldClipSubject: scrollable.shouldClipSubject,
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  };
  var displacedSubject = offsetByPosition(droppable.viewport.subjectPageMarginBox, scrollDisplacement);
  var clippedPageMarginBox = closestScrollable.shouldClipSubject ? clip(framePageMarginBox, displacedSubject) : Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["d" /* getRect */])(displacedSubject);
  var viewport = {
    closestScrollable: closestScrollable,
    subjectPageMarginBox: droppable.viewport.subjectPageMarginBox,
    clippedPageMarginBox: clippedPageMarginBox
  };

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    viewport: viewport
  });

  return result;
};

var toDroppableMap = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (droppables) {
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(droppables).map(function (id) {
    return droppables[id];
  });
});
var toDraggableList = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (draggables) {
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(draggables).map(function (id) {
    return draggables[id];
  });
});

var getDraggablesInsideDroppable = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (droppable, draggables) {
  return toDraggableList(draggables).filter(function (draggable) {
    return droppable.descriptor.id === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
});

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return value <= upperBound && value >= lowerBound;
  };
});

var isPositionInFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (point) {
    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
  };
});

var getRequiredGrowth = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (draggable, draggables, droppable) {
  var getResult = function getResult(existingSpace) {
    var requiredSpace = draggable.page.marginBox[droppable.axis.size];

    if (requiredSpace <= existingSpace) {
      return null;
    }

    var requiredGrowth = patch(droppable.axis.line, requiredSpace - existingSpace);
    return requiredGrowth;
  };

  var dimensions = getDraggablesInsideDroppable(droppable, draggables);

  if (!dimensions.length) {
    var _existingSpace = droppable.page.marginBox[droppable.axis.size];
    return getResult(_existingSpace);
  }

  var endOfDraggables = dimensions[dimensions.length - 1].page.marginBox[droppable.axis.end];
  var endOfDroppable = droppable.page.marginBox[droppable.axis.end];
  var existingSpace = endOfDroppable - endOfDraggables;
  return getResult(existingSpace);
});
var getWithGrowth = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (area, growth) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["d" /* getRect */])(expandByPosition(area, growth));
});

var getClippedRectWithPlaceholder = function getClippedRectWithPlaceholder(_ref) {
  var draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      previousDroppableOverId = _ref.previousDroppableOverId;
  var isHome = draggable.descriptor.droppableId === droppable.descriptor.id;
  var wasOver = Boolean(previousDroppableOverId && previousDroppableOverId === droppable.descriptor.id);
  var clippedPageMarginBox = droppable.viewport.clippedPageMarginBox;

  if (!clippedPageMarginBox) {
    return clippedPageMarginBox;
  }

  if (isHome || !wasOver) {
    return clippedPageMarginBox;
  }

  var requiredGrowth = getRequiredGrowth(draggable, draggables, droppable);

  if (!requiredGrowth) {
    return clippedPageMarginBox;
  }

  var subjectWithGrowth = getWithGrowth(clippedPageMarginBox, requiredGrowth);
  var closestScrollable = droppable.viewport.closestScrollable;

  if (!closestScrollable) {
    return subjectWithGrowth;
  }

  if (!closestScrollable.shouldClipSubject) {
    return subjectWithGrowth;
  }

  return clip(closestScrollable.framePageMarginBox, subjectWithGrowth);
};

var getDroppableOver = (function (_ref2) {
  var target = _ref2.target,
      draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousDroppableOverId = _ref2.previousDroppableOverId;
  var maybe = toDroppableList(droppables).filter(function (droppable) {
    return droppable.isEnabled;
  }).find(function (droppable) {
    var withPlaceholder = getClippedRectWithPlaceholder({
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      previousDroppableOverId: previousDroppableOverId
    });

    if (!withPlaceholder) {
      return false;
    }

    return isPositionInFrame(withPlaceholder)(target);
  });
  return maybe ? maybe.descriptor.id : null;
});

var noMovement = {
  displaced: [],
  amount: origin,
  isBeyondStartPosition: false
};
var noImpact = {
  movement: noMovement,
  direction: null,
  destination: null
};

var getDisplacementMap = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (displaced) {
  return displaced.reduce(function (map, displacement) {
    map[displacement.draggableId] = displacement;
    return map;
  }, {});
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var isVisible = function isVisible(_ref) {
  var target = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacement = destination.viewport.closestScrollable ? destination.viewport.closestScrollable.scroll.diff.displacement : origin;
  var withDisplacement = offsetByPosition(target, displacement);

  if (!destination.viewport.clippedPageMarginBox) {
    return false;
  }

  var isVisibleInDroppable = isVisibleThroughFrameFn(destination.viewport.clippedPageMarginBox)(withDisplacement);
  var isVisibleInViewport = isVisibleThroughFrameFn(viewport)(withDisplacement);
  return isVisibleInDroppable && isVisibleInViewport;
};

var isPartiallyVisible = function isPartiallyVisible(_ref2) {
  var target = _ref2.target,
      destination = _ref2.destination,
      viewport = _ref2.viewport;
  return isVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  });
};
var isTotallyVisible = function isTotallyVisible(_ref3) {
  var target = _ref3.target,
      destination = _ref3.destination,
      viewport = _ref3.viewport;
  return isVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  });
};

var getDisplacement = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var id = draggable.descriptor.id;
  var map = getDisplacementMap(previousImpact.movement.displaced);
  var isVisible = isPartiallyVisible({
    target: draggable.page.marginBox,
    destination: destination,
    viewport: viewport
  });

  var shouldAnimate = function () {
    if (!isVisible) {
      return false;
    }

    var previous = map[id];

    if (!previous) {
      return true;
    }

    return previous.shouldAnimate;
  }();

  var displacement = {
    draggableId: id,
    isVisible: isVisible,
    shouldAnimate: shouldAnimate
  };
  return displacement;
});

var withDroppableScroll = (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;

  if (!closestScrollable) {
    return point;
  }

  return add(point, closestScrollable.scroll.diff.value);
});

var inHomeList = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      home = _ref.home,
      insideHome = _ref.insideHome,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var axis = home.axis;
  var originalCenter = draggable.page.borderBox.center;
  var currentCenter = withDroppableScroll(home, pageBorderBoxCenter);
  var isBeyondStartPosition = currentCenter[axis.line] - originalCenter[axis.line] > 0;
  var amount = patch(axis.line, draggable.client.marginBox[axis.size]);
  var displaced = insideHome.filter(function (child) {
    if (child === draggable) {
      return false;
    }

    var borderBox = child.page.borderBox;

    if (isBeyondStartPosition) {
      if (borderBox.center[axis.line] < originalCenter[axis.line]) {
        return false;
      }

      return currentCenter[axis.line] > borderBox[axis.start];
    }

    if (originalCenter[axis.line] < borderBox.center[axis.line]) {
      return false;
    }

    return currentCenter[axis.line] < borderBox[axis.end];
  }).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: home,
      previousImpact: previousImpact,
      viewport: viewport.frame
    });
  });
  var ordered = isBeyondStartPosition ? displaced.reverse() : displaced;

  var index = function () {
    var startIndex = draggable.descriptor.index;
    var length = ordered.length;

    if (!length) {
      return startIndex;
    }

    if (isBeyondStartPosition) {
      return startIndex + length;
    }

    return startIndex - length;
  }();

  var movement = {
    amount: amount,
    displaced: ordered,
    isBeyondStartPosition: isBeyondStartPosition
  };
  var impact = {
    movement: movement,
    direction: axis.direction,
    destination: {
      droppableId: home.descriptor.id,
      index: index
    }
  };
  return impact;
});

var inForeignList = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var axis = destination.axis;
  var currentCenter = withDroppableScroll(destination, pageBorderBoxCenter);
  var displaced = insideDestination.filter(function (child) {
    var threshold = child.page.borderBox[axis.end];
    return threshold > currentCenter[axis.line];
  }).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport.frame
    });
  });
  var newIndex = insideDestination.length - displaced.length;
  var movement = {
    amount: patch(axis.line, draggable.page.marginBox[axis.size]),
    displaced: displaced,
    isBeyondStartPosition: false
  };
  var impact = {
    movement: movement,
    direction: axis.direction,
    destination: {
      droppableId: destination.descriptor.id,
      index: newIndex
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var previousDroppableOverId = previousImpact.destination && previousImpact.destination.droppableId;
  var destinationId = getDroppableOver({
    target: pageBorderBoxCenter,
    draggable: draggable,
    draggables: draggables,
    droppables: droppables,
    previousDroppableOverId: previousDroppableOverId
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];

  if (!destination.isEnabled) {
    return noImpact;
  }

  var home = droppables[draggable.descriptor.droppableId];
  var isWithinHomeDroppable = home.descriptor.id === destinationId;
  var insideDestination = getDraggablesInsideDroppable(destination, draggables);

  if (isWithinHomeDroppable) {
    return inHomeList({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      home: home,
      insideHome: insideDestination,
      previousImpact: previousImpact || noImpact,
      viewport: viewport
    });
  }

  return inForeignList({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact || noImpact,
    viewport: viewport
  });
});

var getHomeLocation = (function (critical) {
  return {
    index: critical.draggable.index,
    droppableId: critical.droppable.id
  };
});

var getSafeClipped = function getSafeClipped(droppable) {
  var rect = droppable.viewport.clippedPageMarginBox;
  !rect ?  false ? invariant(false, 'Cannot get clipped area from droppable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var sourceClipped = source.viewport.clippedPageMarginBox;

  if (!sourceClipped) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(sourceClipped[axis.start], sourceClipped[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    var clippedPageMarginBox = droppable.viewport.clippedPageMarginBox;

    if (!clippedPageMarginBox) {
      return false;
    }

    return isPartiallyVisibleThroughFrame(viewport.frame)(clippedPageMarginBox);
  }).filter(function (droppable) {
    var targetClipped = getSafeClipped(droppable);

    if (isMovingForward) {
      return sourceClipped[axis.crossAxisEnd] < targetClipped[axis.crossAxisEnd];
    }

    return targetClipped[axis.crossAxisStart] < sourceClipped[axis.crossAxisStart];
  }).filter(function (droppable) {
    var targetClipped = getSafeClipped(droppable);
    var isBetweenDestinationClipped = isWithin(targetClipped[axis.start], targetClipped[axis.end]);
    return isBetweenSourceClipped(targetClipped[axis.start]) || isBetweenSourceClipped(targetClipped[axis.end]) || isBetweenDestinationClipped(sourceClipped[axis.start]) || isBetweenDestinationClipped(sourceClipped[axis.end]);
  }).sort(function (a, b) {
    var first = getSafeClipped(a)[axis.crossAxisStart];
    var second = getSafeClipped(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getSafeClipped(droppable)[axis.crossAxisStart] === getSafeClipped(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getSafeClipped(droppable)[axis.start], getSafeClipped(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getSafeClipped(a)[axis.start] - getSafeClipped(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getSafeClipped(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getSafeClipped(b)));

    if (first !== second) {
      return first - second;
    }

    return getSafeClipped(a)[axis.start] - getSafeClipped(b)[axis.start];
  })[0];
});

var withDroppableDisplacement = (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;

  if (!closestScrollable) {
    return point;
  }

  return add(point, closestScrollable.scroll.diff.displacement);
});

var getClosestDraggable = (function (_ref) {
  var axis = _ref.axis,
      viewport = _ref.viewport,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination;

  if (!insideDestination.length) {
    return null;
  }

  var result = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: draggable.page.borderBox,
      destination: destination,
      viewport: viewport.frame
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, a.page.borderBox.center));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, b.page.borderBox.center));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.page.borderBox[axis.start] - b.page.borderBox[axis.start];
  });
  return result.length ? result[0] : null;
});

var moveToEdge = (function (_ref) {
  var source = _ref.source,
      sourceEdge = _ref.sourceEdge,
      destination = _ref.destination,
      destinationEdge = _ref.destinationEdge,
      destinationAxis = _ref.destinationAxis;

  var getCorner = function getCorner(area) {
    return patch(destinationAxis.line, area[destinationAxis[destinationEdge]], area[destinationAxis.crossAxisStart]);
  };

  var corner = getCorner(destination);
  var centerDiff = absolute(subtract(source.center, getCorner(source)));
  var signed = patch(destinationAxis.line, (sourceEdge === 'end' ? -1 : 1) * centerDiff[destinationAxis.line], centerDiff[destinationAxis.crossAxisLine]);
  return add(corner, signed);
});

var toHomeList = (function (_ref) {
  var amount = _ref.amount,
      homeIndex = _ref.homeIndex,
      movingRelativeTo = _ref.movingRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var axis = destination.axis;
  var targetIndex = insideDestination.indexOf(movingRelativeTo);
  !(targetIndex !== -1) ?  false ? invariant(false, 'Unable to find target in destination droppable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

  if (targetIndex === homeIndex) {
    var _newCenter = draggable.page.borderBox.center;
    var _newImpact = {
      movement: {
        displaced: [],
        amount: amount,
        isBeyondStartPosition: false
      },
      direction: destination.axis.direction,
      destination: {
        droppableId: destination.descriptor.id,
        index: homeIndex
      }
    };
    return {
      pageBorderBoxCenter: withDroppableDisplacement(destination, _newCenter),
      impact: _newImpact
    };
  }

  var isMovingPastOriginalIndex = targetIndex > homeIndex;
  var edge = isMovingPastOriginalIndex ? 'end' : 'start';
  var newCenter = moveToEdge({
    source: draggable.page.borderBox,
    sourceEdge: edge,
    destination: isMovingPastOriginalIndex ? movingRelativeTo.page.borderBox : movingRelativeTo.page.marginBox,
    destinationEdge: edge,
    destinationAxis: axis
  });

  var modified = function () {
    if (!isMovingPastOriginalIndex) {
      return insideDestination.slice(targetIndex, homeIndex);
    }

    var from = homeIndex + 1;
    var to = targetIndex + 1;
    return insideDestination.slice(from, to).reverse();
  }();

  var displaced = modified.map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport.frame
    });
  });
  var newImpact = {
    movement: {
      displaced: displaced,
      amount: amount,
      isBeyondStartPosition: isMovingPastOriginalIndex
    },
    direction: axis.direction,
    destination: {
      droppableId: destination.descriptor.id,
      index: targetIndex
    }
  };
  return {
    pageBorderBoxCenter: withDroppableDisplacement(destination, newCenter),
    impact: newImpact
  };
});

var toForeignList = (function (_ref) {
  var amount = _ref.amount,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      movingRelativeTo = _ref.movingRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var axis = destination.axis;
  var isGoingBeforeTarget = Boolean(movingRelativeTo && pageBorderBoxCenter[destination.axis.line] < movingRelativeTo.page.borderBox.center[destination.axis.line]);

  if (!movingRelativeTo) {
    var _newCenter = moveToEdge({
      source: draggable.page.borderBox,
      sourceEdge: 'start',
      destination: destination.page.contentBox,
      destinationEdge: 'start',
      destinationAxis: axis
    });

    var _newImpact = {
      movement: {
        displaced: [],
        amount: amount,
        isBeyondStartPosition: false
      },
      direction: axis.direction,
      destination: {
        droppableId: destination.descriptor.id,
        index: 0
      }
    };
    return {
      pageBorderBoxCenter: withDroppableDisplacement(destination, _newCenter),
      impact: _newImpact
    };
  }

  var targetIndex = insideDestination.indexOf(movingRelativeTo);
  !(targetIndex !== -1) ?  false ? invariant(false, 'The target was not found within its droppable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var proposedIndex = isGoingBeforeTarget ? targetIndex : targetIndex + 1;
  var newCenter = moveToEdge({
    source: draggable.page.borderBox,
    sourceEdge: 'start',
    destination: movingRelativeTo.page.marginBox,
    destinationEdge: isGoingBeforeTarget ? 'start' : 'end',
    destinationAxis: axis
  });
  var displaced = insideDestination.slice(proposedIndex, insideDestination.length).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      viewport: viewport.frame,
      previousImpact: previousImpact
    });
  });
  var newImpact = {
    movement: {
      displaced: displaced,
      amount: amount,
      isBeyondStartPosition: false
    },
    direction: axis.direction,
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    }
  };
  return {
    pageBorderBoxCenter: withDroppableDisplacement(destination, newCenter),
    impact: newImpact
  };
});

var moveToNewDroppable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      movingRelativeTo = _ref.movingRelativeTo,
      home = _ref.home,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var amount = patch(destination.axis.line, draggable.client.marginBox[destination.axis.size]);

  if (destination.descriptor.id === draggable.descriptor.droppableId) {
    !movingRelativeTo ?  false ? invariant(false, 'There will always be a target in the original list') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    return toHomeList({
      amount: amount,
      homeIndex: home.index,
      movingRelativeTo: movingRelativeTo,
      insideDestination: insideDestination,
      draggable: draggable,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport
    });
  }

  return toForeignList({
    amount: amount,
    pageBorderBoxCenter: pageBorderBoxCenter,
    movingRelativeTo: movingRelativeTo,
    insideDestination: insideDestination,
    draggable: draggable,
    destination: destination,
    previousImpact: previousImpact,
    viewport: viewport
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggableId = _ref.draggableId,
      droppableId = _ref.droppableId,
      home = _ref.home,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;
  var draggable = draggables[draggableId];
  var source = droppables[droppableId];
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: pageBorderBoxCenter,
    source: source,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination, draggables);
  var movingRelativeTo = getClosestDraggable({
    axis: destination.axis,
    pageBorderBoxCenter: pageBorderBoxCenter,
    destination: destination,
    insideDestination: insideDestination,
    viewport: viewport
  });

  if (insideDestination.length && !movingRelativeTo) {
    return null;
  }

  return moveToNewDroppable({
    pageBorderBoxCenter: pageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    movingRelativeTo: movingRelativeTo,
    insideDestination: insideDestination,
    home: home,
    previousImpact: previousImpact || noImpact,
    viewport: viewport
  });
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport;
  var diff = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, diff);
  return isTotallyVisible({
    target: shifted,
    destination: destination,
    viewport: viewport
  });
});

var withFirstAdded = function withFirstAdded(_ref) {
  var add = _ref.add,
      previousImpact = _ref.previousImpact,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var newDisplacement = {
    draggableId: add,
    isVisible: true,
    shouldAnimate: true
  };
  var added = [newDisplacement].concat(previousImpact.movement.displaced);
  var withUpdatedVisibility = added.map(function (current) {
    if (current === newDisplacement) {
      return current;
    }

    var updated = getDisplacement({
      draggable: draggables[current.draggableId],
      destination: droppable,
      previousImpact: previousImpact,
      viewport: viewport.frame
    });
    return updated;
  });
  return withUpdatedVisibility;
};

var forceVisibleDisplacement = function forceVisibleDisplacement(current) {
  if (current.isVisible) {
    return current;
  }

  return {
    draggableId: current.draggableId,
    isVisible: true,
    shouldAnimate: false
  };
};

var withFirstRemoved = function withFirstRemoved(_ref2) {
  var dragging = _ref2.dragging,
      isVisibleInNewLocation = _ref2.isVisibleInNewLocation,
      previousImpact = _ref2.previousImpact,
      droppable = _ref2.droppable,
      draggables = _ref2.draggables;
  var last = previousImpact.movement.displaced;
  !last.length ?  false ? invariant(false, 'Cannot remove displacement from empty list') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var withFirstRestored = last.slice(1, last.length);

  if (!withFirstRestored.length) {
    return withFirstRestored;
  }

  if (isVisibleInNewLocation) {
    return withFirstRestored;
  }

  var axis = droppable.axis;
  var sizeOfRestored = draggables[last[0].draggableId].page.marginBox[axis.size];
  var sizeOfDragging = draggables[dragging].page.marginBox[axis.size];
  var buffer = sizeOfRestored + sizeOfDragging;
  var withUpdatedVisibility = withFirstRestored.map(function (displacement, index) {
    if (index === 0) {
      return forceVisibleDisplacement(displacement);
    }

    if (buffer > 0) {
      var current = draggables[displacement.draggableId];
      var size = current.page.marginBox[axis.size];
      buffer -= size;
      return forceVisibleDisplacement(displacement);
    }

    return {
      draggableId: displacement.draggableId,
      isVisible: false,
      shouldAnimate: false
    };
  });
  return withUpdatedVisibility;
};

var inHomeList$1 = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggableId = _ref.draggableId,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousImpact = _ref.previousImpact,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var location = previousImpact.destination;
  !location ?  false ? invariant(false, 'Cannot move to next index in home list when there is no previous destination') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var draggable = draggables[draggableId];
  var axis = droppable.axis;
  var insideDroppable = getDraggablesInsideDroppable(droppable, draggables);
  var startIndex = draggable.descriptor.index;
  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (proposedIndex > insideDroppable.length - 1) {
    return null;
  }

  if (proposedIndex < 0) {
    return null;
  }

  var destination = insideDroppable[proposedIndex];
  var isMovingTowardStart = isMovingForward && proposedIndex <= startIndex || !isMovingForward && proposedIndex >= startIndex;

  var edge = function () {
    if (!isMovingTowardStart) {
      return isMovingForward ? 'end' : 'start';
    }

    return isMovingForward ? 'start' : 'end';
  }();

  var newPageBorderBoxCenter = moveToEdge({
    source: draggable.page.borderBox,
    sourceEdge: edge,
    destination: destination.page.borderBox,
    destinationEdge: edge,
    destinationAxis: droppable.axis
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: droppable,
    newPageBorderBoxCenter: newPageBorderBoxCenter,
    viewport: viewport.frame
  });
  var displaced = isMovingTowardStart ? withFirstRemoved({
    dragging: draggableId,
    isVisibleInNewLocation: isVisibleInNewLocation,
    previousImpact: previousImpact,
    droppable: droppable,
    draggables: draggables
  }) : withFirstAdded({
    add: destination.descriptor.id,
    previousImpact: previousImpact,
    droppable: droppable,
    draggables: draggables,
    viewport: viewport
  });
  var newImpact = {
    movement: {
      displaced: displaced,
      amount: patch(axis.line, draggable.page.marginBox[axis.size]),
      isBeyondStartPosition: proposedIndex > startIndex
    },
    destination: {
      droppableId: droppable.descriptor.id,
      index: proposedIndex
    },
    direction: droppable.axis.direction
  };

  if (isVisibleInNewLocation) {
    return {
      pageBorderBoxCenter: withDroppableDisplacement(droppable, newPageBorderBoxCenter),
      impact: newImpact,
      scrollJumpRequest: null
    };
  }

  var distance$$1 = subtract(newPageBorderBoxCenter, previousPageBorderBoxCenter);
  var distanceWithScroll = withDroppableDisplacement(droppable, distance$$1);
  return {
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    impact: newImpact,
    scrollJumpRequest: distanceWithScroll
  };
});

var inForeignList$1 = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggableId = _ref.draggableId,
      previousImpact = _ref.previousImpact,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  !previousImpact.destination ?  false ? invariant(false, 'Cannot move to next index where there is no previous destination') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var location = previousImpact.destination;
  var draggable = draggables[draggableId];
  var axis = droppable.axis;
  var insideForeignDroppable = getDraggablesInsideDroppable(droppable, draggables);
  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var lastIndex = insideForeignDroppable.length - 1;

  if (proposedIndex > insideForeignDroppable.length) {
    return null;
  }

  if (proposedIndex < 0) {
    return null;
  }

  var movingRelativeTo = insideForeignDroppable[Math.min(proposedIndex, lastIndex)];
  var isMovingPastLastIndex = proposedIndex > lastIndex;
  var sourceEdge = 'start';

  var destinationEdge = function () {
    if (isMovingPastLastIndex) {
      return 'end';
    }

    return 'start';
  }();

  var newPageBorderBoxCenter = moveToEdge({
    source: draggable.page.borderBox,
    sourceEdge: sourceEdge,
    destination: movingRelativeTo.page.marginBox,
    destinationEdge: destinationEdge,
    destinationAxis: droppable.axis
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: droppable,
    newPageBorderBoxCenter: newPageBorderBoxCenter,
    viewport: viewport.frame
  });

  var displaced = function () {
    if (isMovingForward) {
      return withFirstRemoved({
        dragging: draggableId,
        isVisibleInNewLocation: isVisibleInNewLocation,
        previousImpact: previousImpact,
        droppable: droppable,
        draggables: draggables
      });
    }

    return withFirstAdded({
      add: movingRelativeTo.descriptor.id,
      previousImpact: previousImpact,
      droppable: droppable,
      draggables: draggables,
      viewport: viewport
    });
  }();

  var newImpact = {
    movement: {
      displaced: displaced,
      amount: patch(axis.line, draggable.page.marginBox[axis.size]),
      isBeyondStartPosition: false
    },
    destination: {
      droppableId: droppable.descriptor.id,
      index: proposedIndex
    },
    direction: droppable.axis.direction
  };

  if (isVisibleInNewLocation) {
    return {
      pageBorderBoxCenter: withDroppableDisplacement(droppable, newPageBorderBoxCenter),
      impact: newImpact,
      scrollJumpRequest: null
    };
  }

  var distanceMoving = subtract(newPageBorderBoxCenter, previousPageBorderBoxCenter);
  var distanceWithScroll = withDroppableDisplacement(droppable, distanceMoving);
  return {
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    impact: newImpact,
    scrollJumpRequest: distanceWithScroll
  };
});

var moveToNextIndex = (function (args) {
  var draggableId = args.draggableId,
      draggables = args.draggables,
      droppable = args.droppable;
  var draggable = draggables[draggableId];
  var isInHomeList = draggable.descriptor.droppableId === droppable.descriptor.id;

  if (!droppable.isEnabled) {
    return null;
  }

  if (isInHomeList) {
    return inHomeList$1(args);
  }

  return inForeignList$1(args);
});

var getClientSelection = function getClientSelection(pageBorderBoxCenter, currentScroll) {
  return subtract(pageBorderBoxCenter, currentScroll);
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;

  var _ref2 = function () {
    if (state.impact.destination) {
      return {
        droppable: state.dimensions.droppables[state.impact.destination.droppableId],
        isMainAxisMovementAllowed: true
      };
    }

    return {
      droppable: state.dimensions.droppables[state.critical.droppable.id],
      isMainAxisMovementAllowed: false
    };
  }(),
      droppable = _ref2.droppable,
      isMainAxisMovementAllowed = _ref2.isMainAxisMovementAllowed;

  var direction = droppable.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';

  if (isMovingOnMainAxis) {
    var _result = moveToNextIndex({
      isMovingForward: isMovingForward,
      draggableId: state.critical.draggable.id,
      droppable: droppable,
      draggables: state.dimensions.draggables,
      previousPageBorderBoxCenter: state.current.page.borderBoxCenter,
      previousImpact: state.impact,
      viewport: state.viewport
    });

    if (!_result) {
      return null;
    }

    return {
      impact: _result.impact,
      clientSelection: getClientSelection(_result.pageBorderBoxCenter, state.viewport.scroll.current),
      scrollJumpRequest: _result.scrollJumpRequest
    };
  }

  var home = getHomeLocation(state.critical);
  var result = moveCrossAxis({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: state.current.page.borderBoxCenter,
    draggableId: state.critical.draggable.id,
    droppableId: droppable.descriptor.id,
    home: home,
    draggables: state.dimensions.draggables,
    droppables: state.dimensions.droppables,
    previousImpact: state.impact,
    viewport: state.viewport
  });

  if (!result) {
    return null;
  }

  return {
    clientSelection: getClientSelection(result.pageBorderBoxCenter, state.viewport.scroll.current),
    impact: result.impact,
    scrollJumpRequest: null
  };
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["d" /* getRect */])({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

var getHomeImpact = (function (critical, dimensions) {
  var home = dimensions.droppables[critical.droppable.id];
  var axis = home.axis;
  var draggable = dimensions.draggables[critical.draggable.id];
  return {
    movement: {
      displaced: [],
      isBeyondStartPosition: false,
      amount: patch(axis.line, draggable.client.marginBox[axis.size])
    },
    direction: axis.direction,
    destination: getHomeLocation(critical)
  };
});

var getPageItemPositions = (function (client, windowScroll) {
  return {
    selection: add(client.selection, windowScroll),
    borderBoxCenter: add(client.borderBoxCenter, windowScroll),
    offset: add(client.offset, windowScroll)
  };
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

var idle = {
  phase: 'IDLE'
};
var preparing = {
  phase: 'PREPARING'
};

var moveWithPositionUpdates = function moveWithPositionUpdates(_ref) {
  var state = _ref.state,
      clientSelection = _ref.clientSelection,
      shouldAnimate = _ref.shouldAnimate,
      viewport = _ref.viewport,
      impact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var newViewport = viewport || state.viewport;
  var currentWindowScroll = newViewport.scroll.current;

  var client = function () {
    var offset = subtract(clientSelection, state.initial.client.selection);
    return {
      offset: offset,
      selection: clientSelection,
      borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
    };
  }();

  var page = getPageItemPositions(client, currentWindowScroll);
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, {
      current: current
    });
  }

  var newImpact = impact || getDragImpact({
    pageBorderBoxCenter: page.borderBoxCenter,
    draggable: state.dimensions.draggables[state.critical.draggable.id],
    draggables: state.dimensions.draggables,
    droppables: state.dimensions.droppables,
    previousImpact: state.impact,
    viewport: newViewport
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state, {
    current: current,
    shouldAnimate: shouldAnimate,
    impact: newImpact,
    scrollJumpRequest: scrollJumpRequest || null,
    viewport: newViewport
  });

  return result;
};

var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'CLEAN') {
    return idle;
  }

  if (action.type === 'PREPARE') {
    return preparing;
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'PREPARING') ?  false ? invariant(false, 'INITIAL_PUBLISH must come after a PREPARING phase') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        client = _action$payload.client,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        autoScrollMode = _action$payload.autoScrollMode;
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: origin
      }
    };
    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      autoScrollMode: autoScrollMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      impact: getHomeImpact(critical, dimensions),
      viewport: viewport,
      scrollJumpRequest: null,
      shouldAnimate: false
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    var _extends2;

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, "Collection cannot start from phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    var _result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));

    return _result;
  }

  if (action.type === 'PUBLISH') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
     false ? invariant(false, "Dynamic additions and removals of Draggable and Droppable components\n      is currently not supported. But will be soon!") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false);
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'PREPARING') {
      return state;
    }

    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload2 = action.payload,
        _client = _action$payload2.client,
        shouldAnimate = _action$payload2.shouldAnimate;

    if (state.shouldAnimate === shouldAnimate && isEqual(_client, state.current.client.selection)) {
      return state;
    }

    var impact = state.autoScrollMode === 'JUMP' ? state.impact : null;
    return moveWithPositionUpdates({
      state: state,
      clientSelection: _client,
      impact: impact,
      shouldAnimate: shouldAnimate
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    var _extends3, _extends4;

    if (state.phase === 'PREPARING') {
      return state;
    }

    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload3 = action.payload,
        id = _action$payload3.id,
        offset = _action$payload3.offset;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var updated = scrollDroppable(target, offset);

    var _dimensions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.dimensions, {
      droppables: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.dimensions.droppables, (_extends3 = {}, _extends3[id] = updated, _extends3))
    });

    var _impact = function () {
      !isMovementAllowed(state) ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

      if (state.autoScrollMode === 'JUMP') {
        return state.impact;
      }

      return getDragImpact({
        pageBorderBoxCenter: state.current.page.borderBoxCenter,
        draggable: _dimensions.draggables[state.critical.draggable.id],
        draggables: _dimensions.draggables,
        droppables: _dimensions.droppables,
        previousImpact: state.impact,
        viewport: state.viewport
      });
    }();

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, (_extends4 = {}, _extends4["phase"] = state.phase, _extends4.impact = _impact, _extends4.dimensions = _dimensions, _extends4.scrollJumpRequest = null, _extends4));
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    var _extends5, _extends6;

    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload4 = action.payload,
        _id = _action$payload4.id,
        isEnabled = _action$payload4.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    var _updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target, {
      isEnabled: isEnabled
    });

    var _dimensions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.dimensions, {
      droppables: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.dimensions.droppables, (_extends5 = {}, _extends5[_id] = _updated, _extends5))
    });

    var _impact2 = getDragImpact({
      pageBorderBoxCenter: state.current.page.borderBoxCenter,
      draggable: _dimensions2.draggables[state.critical.draggable.id],
      draggables: _dimensions2.draggables,
      droppables: _dimensions2.droppables,
      previousImpact: state.impact,
      viewport: state.viewport
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, (_extends6 = {}, _extends6["phase"] = state.phase, _extends6.impact = _impact2, _extends6.dimensions = _dimensions2, _extends6));
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'PREPARING') {
      return state;
    }

    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Cannot move by window in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var newScroll = action.payload.scroll;

    if (isEqual(state.viewport.scroll.current, newScroll)) {
      return state;
    }

    var isJumpScrolling = state.autoScrollMode === 'JUMP';

    var _impact3 = isJumpScrolling ? state.impact : null;

    var _viewport = scrollViewport(state.viewport, newScroll);

    return moveWithPositionUpdates({
      state: state,
      clientSelection: state.current.client.selection,
      viewport: _viewport,
      shouldAnimate: false,
      impact: _impact3
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    var _extends7;

    !state.isDragging ?  false ? invariant(false, 'Cannot update the max viewport scroll if not dragging') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var existing = state.viewport;

    var _viewport2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, {
      scroll: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing.scroll, {
        max: action.payload
      })
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, (_extends7 = {}, _extends7["phase"] = state.phase, _extends7.viewport = _viewport2, _extends7));
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'PREPARING') {
      return state;
    }

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, action.type + " received while not in DRAGGING phase") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return moveWithPositionUpdates({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      shouldAnimate: true,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var _extends8;

    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    var newState = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DROP_PENDING'
    }, state, (_extends8 = {}, _extends8["phase"] = 'DROP_PENDING', _extends8.isWaiting = true, _extends8.reason = reason, _extends8));

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var pending = action.payload;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot animate drop from phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      pending: pending,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    return idle;
  }

  return state;
});

var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publish = function publish(args) {
  return {
    type: 'PUBLISH',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(max) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: max
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var clean = function clean() {
  return {
    type: 'CLEAN',
    payload: null
  };
};
var prepare = function prepare() {
  return {
    type: 'PREPARE',
    payload: null
  };
};
var animateDrop = function animateDrop(pending) {
  return {
    type: 'DROP_ANIMATE',
    payload: pending
  };
};
var completeDrop = function completeDrop(result) {
  return {
    type: 'DROP_COMPLETE',
    payload: result
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

var lift$1 = (function (getMarshal) {
  var timeoutId = null;

  var tryAbortCriticalCollection = function tryAbortCriticalCollection() {
    if (timeoutId == null) {
      return;
    }

    clearTimeout(timeoutId);
    timeoutId = null;
  };

  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type === 'CLEAN') {
          tryAbortCriticalCollection();
          next(action);
          return;
        }

        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        !!timeoutId ?  false ? invariant(false, 'There should not be a pending complete lift phase when a lift action is fired') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
        var marshal = getMarshal();
        var _action$payload = action.payload,
            id = _action$payload.id,
            client = _action$payload.client,
            autoScrollMode = _action$payload.autoScrollMode,
            viewport = _action$payload.viewport;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop(initial.pending.result));
        }

        var postFlushState = getState();
        !(postFlushState.phase === 'IDLE') ?  false ? invariant(false, 'Incorrect phase to start a drag') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
        dispatch(prepare());
        timeoutId = setTimeout(function () {
          timeoutId = null;
          var state = getState();
          !(state.phase === 'PREPARING') ?  false ? invariant(false, 'Invalid phase for completing lift') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
          var scrollOptions = {
            shouldPublishImmediately: autoScrollMode === 'JUMP'
          };
          var request = {
            draggableId: id,
            scrollOptions: scrollOptions
          };

          var _marshal$startPublish = marshal.startPublishing(request, viewport.scroll.current),
              critical = _marshal$startPublish.critical,
              dimensions = _marshal$startPublish.dimensions;

          dispatch(initialPublish({
            critical: critical,
            dimensions: dimensions,
            client: client,
            autoScrollMode: autoScrollMode,
            viewport: viewport
          }));
        });
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'COLLECTION_STARTING') {
          marshal.collecting();
        }

        if (action.type === 'PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.result.reason);
        }

        if (action.type === 'CLEAN' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var getNewHomeClientBorderBoxCenter = (function (_ref) {
  var movement = _ref.movement,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination;
  var originalCenter = draggable.client.borderBox.center;

  if (destination == null) {
    return originalCenter;
  }

  var displaced = movement.displaced,
      isBeyondStartPosition = movement.isBeyondStartPosition;
  var axis = destination.axis;
  var isWithinHomeDroppable = destination.descriptor.id === draggable.descriptor.droppableId;

  if (isWithinHomeDroppable && !displaced.length) {
    return originalCenter;
  }

  var draggablesInDestination = getDraggablesInsideDroppable(destination, draggables);

  var movingRelativeTo = function () {
    if (isWithinHomeDroppable) {
      return draggables[displaced[0].draggableId].client.borderBox;
    }

    if (displaced.length) {
      return draggables[displaced[0].draggableId].client.borderBox;
    }

    if (draggablesInDestination.length) {
      return draggablesInDestination[draggablesInDestination.length - 1].client.marginBox;
    }

    return destination.client.contentBox;
  }();

  var _ref2 = function () {
    if (isWithinHomeDroppable) {
      if (isBeyondStartPosition) {
        return {
          sourceEdge: 'end',
          destinationEdge: 'end'
        };
      }

      return {
        sourceEdge: 'start',
        destinationEdge: 'start'
      };
    }

    if (!displaced.length && draggablesInDestination.length) {
      return {
        sourceEdge: 'start',
        destinationEdge: 'end'
      };
    }

    return {
      sourceEdge: 'start',
      destinationEdge: 'start'
    };
  }(),
      sourceEdge = _ref2.sourceEdge,
      destinationEdge = _ref2.destinationEdge;

  var source = draggable.client.borderBox;
  var targetCenter = moveToEdge({
    source: source,
    sourceEdge: sourceEdge,
    destination: movingRelativeTo,
    destinationEdge: destinationEdge,
    destinationAxis: axis
  });
  return targetCenter;
});

var getScrollDisplacement = function getScrollDisplacement(droppable, viewport) {
  return withDroppableDisplacement(droppable, viewport.scroll.diff.displacement);
};

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'PREPARING') {
        dispatch(clean());
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot drop in phase: " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var impact = reason === 'DROP' ? state.impact : noImpact;
      var home = dimensions.droppables[state.critical.droppable.id];
      var draggable = dimensions.draggables[state.critical.draggable.id];
      var droppable = impact && impact.destination ? dimensions.droppables[impact.destination.droppableId] : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var destination = reason === 'DROP' ? impact.destination : null;
      var result = {
        draggableId: draggable.descriptor.id,
        type: home.descriptor.type,
        source: source,
        destination: destination,
        reason: reason
      };

      var clientOffset = function () {
        if (reason === 'CANCEL') {
          return origin;
        }

        var newBorderBoxClientCenter = getNewHomeClientBorderBoxCenter({
          movement: impact.movement,
          draggable: draggable,
          draggables: dimensions.draggables,
          destination: droppable
        });
        return subtract(newBorderBoxClientCenter, draggable.client.borderBox.center);
      }();

      var newHomeOffset = add(clientOffset, getScrollDisplacement(droppable || home, state.viewport));
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeOffset);
      var pending = {
        newHomeOffset: newHomeOffset,
        result: result,
        impact: impact
      };

      if (isAnimationRequired) {
        dispatch(animateDrop(pending));
        return;
      }

      dispatch(completeDrop(result));
    };
  };
});

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + (start.source.index + 1) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};

var onDragUpdate = function onDragUpdate(update) {
  if (!update.destination) {
    return 'You are currently not dragging over a droppable area';
  }

  if (update.source.droppableId === update.destination.droppableId) {
    return "You have moved the item to position " + (update.destination.index + 1);
  }

  return "\n    You have moved the item from list " + update.source.droppableId + " in position " + (update.source.index + 1) + "\n    to list " + update.destination.droppableId + " in position " + (update.destination.index + 1) + "\n  ";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      The item has returned to its starting position of " + (result.source.index + 1) + "\n    ";
  }

  if (!result.destination) {
    return "\n      The item has been dropped while not over a droppable location.\n      The item has returned to its starting position of " + (result.source.index + 1) + "\n    ";
  }

  if (result.source.droppableId === result.destination.droppableId) {
    if (result.source.index === result.destination.index) {
      return "\n        You have dropped the item.\n        It has been dropped on its starting position of " + (result.source.index + 1) + "\n      ";
    }

    return "\n      You have dropped the item.\n      It has moved from position " + (result.source.index + 1) + " to " + (result.destination.index + 1) + "\n    ";
  }

  return "\n    You have dropped the item.\n    It has moved from position " + (result.source.index + 1) + " in list " + result.source.droppableId + "\n    to position " + (result.destination.index + 1) + " in list " + result.destination.droppableId + "\n  ";
};

var preset = {
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var records = {};
var flag = '__react-beautiful-dnd-debug-timings-hook__';

var isTimingsEnabled = function isTimingsEnabled() {
  return Boolean(window[flag]);
};

var start = function start(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    records[key] = now;
  }
};
var finish = function finish(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    var previous = records[key];
    !previous ? process.env.NODE_ENV !== "production" ? invariant(false, 'cannot finish timing as no previous time found') : invariant(false) : void 0;
    var result = now - previous;
    var rounded = result.toFixed(2);

    var style = function () {
      if (result < 12) {
        return {
          textColor: 'green',
          symbol: '✅'
        };
      }

      if (result < 40) {
        return {
          textColor: 'orange',
          symbol: '⚠️'
        };
      }

      return {
        textColor: 'red',
        symbol: '❌'
      };
    }();

    console.log(style.symbol + " %cTiming %c" + rounded + " %cms %c" + key, 'color: blue; font-weight: bold; ', "color: " + style.textColor + "; font-size: 1.1em;", 'color: grey;', 'color: purple; font-weight: bold;');
  }
};

var withTimings = function withTimings(key, fn) {
  start(key);
  fn();
  finish(key);
};

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};

var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var getExpiringAnnounce = function getExpiringAnnounce(announce) {
  var wasCalled = false;
  var isExpired = false;
  setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      if (false) {
        console.warn('Announcement already made. Not making a second announcement');
      }

      return;
    }

    if (isExpired) {
      if (false) {
        console.warn("\n          Announcements cannot be made asynchronously.\n          Default message has already been announced.\n        ");
      }

      return;
    }

    wasCalled = true;
    announce(message);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
};

var getDragStart = function getDragStart(critical) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    }
  };
};

var hooks = (function (getHooks, announce) {
  var execute = function execute(hook, data, getDefaultMessage) {
    if (!hook) {
      announce(getDefaultMessage(data));
      return;
    }

    var willExpire = getExpiringAnnounce(announce);
    var provided = {
      announce: willExpire
    };
    hook(data, provided);

    if (!willExpire.wasCalled()) {
      announce(getDefaultMessage(data));
    }
  };

  var publisher = function () {
    var lastLocation = null;
    var lastCritical = null;
    var _isDragStartPublished = false;

    var beforeStart = function beforeStart(critical) {
      !!_isDragStartPublished ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      withTimings('onBeforeDragStart', function () {
        var fn = getHooks().onBeforeDragStart;

        if (fn) {
          fn(getDragStart(critical));
        }
      });
    };

    var start$$1 = function start$$1(critical) {
      !!_isDragStartPublished ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var data = getDragStart(critical);
      lastCritical = critical;
      lastLocation = data.source;
      _isDragStartPublished = true;
      withTimings('onDragStart', function () {
        return execute(getHooks().onDragStart, data, preset.onDragStart);
      });
    };

    var move = function move(critical, location) {
      !(_isDragStartPublished && lastCritical) ?  false ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var hasCriticalChanged = !isCriticalEqual(critical, lastCritical);

      if (hasCriticalChanged) {
        lastCritical = critical;
      }

      var hasLocationChanged = !areLocationsEqual(lastLocation, location);

      if (hasLocationChanged) {
        lastLocation = location;
      }

      if (!hasCriticalChanged && !hasLocationChanged) {
        return;
      }

      var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(critical), {
        destination: location
      });

      withTimings('onDragUpdate', function () {
        return execute(getHooks().onDragUpdate, data, preset.onDragUpdate);
      });
    };

    var drop = function drop(result) {
      !_isDragStartPublished ?  false ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      _isDragStartPublished = false;
      lastLocation = null;
      lastCritical = null;
      withTimings('onDragEnd', function () {
        return execute(getHooks().onDragEnd, result, preset.onDragEnd);
      });
    };

    var abort = function abort() {
      !(_isDragStartPublished && lastCritical) ?  false ? invariant(false, 'Cannot cancel when onDragStart not fired') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

      var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(lastCritical), {
        destination: null,
        reason: 'CANCEL'
      });

      drop(result);
    };

    return {
      beforeStart: beforeStart,
      start: start$$1,
      move: move,
      drop: drop,
      abort: abort,
      isDragStartPublished: function isDragStartPublished() {
        return _isDragStartPublished;
      }
    };
  }();

  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical);
          next(action);
          publisher.start(critical);
          return;
        }

        next(action);

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload;
          publisher.drop(result);
          return;
        }

        if (action.type === 'CLEAN') {
          if (publisher.isDragStartPublished()) {
            publisher.abort();
          }

          return;
        }

        if (!publisher.isDragStartPublished()) {
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.move(state.critical, state.impact.destination);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      store.dispatch(completeDrop(state.pending.result));
    };
  };
});

var dimensionMarshalStopper = (function (getMarshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'CLEAN' || action.type === 'DROP_ANIMATE') {
          var marshal = getMarshal();
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var shouldCancel = function shouldCancel(action) {
  return action.type === 'CANCEL' || action.type === 'DROP_ANIMATE' || action.type === 'DROP' || action.type === 'DROP_COMPLETE' || action.type === 'COLLECTION_STARTING';
};

var autoScroll = (function (getScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldCancel(action)) {
          getScroller().cancel();
          next(action);
          return;
        }

        next(action);
        var state = store.getState();

        if (state.phase !== 'DRAGGING') {
          return;
        }

        if (state.autoScrollMode === 'FLUID') {
          getScroller().fluidScroll(state);
          return;
        }

        if (!state.scrollJumpRequest) {
          return;
        }

        getScroller().jumpScroll(state);
      };
    };
  };
});

var shouldCheckOnAction = function shouldCheckOnAction(action) {
  return action.type === 'MOVE' || action.type === 'MOVE_UP' || action.type === 'MOVE_RIGHT' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_BY_WINDOW_SCROLL';
};

var hasDroppableOverChanged = function hasDroppableOverChanged(previous, current) {
  if (!previous) {
    return Boolean(current);
  }

  if (!current) {
    return Boolean(previous);
  }

  return previous.droppableId !== current.droppableId;
};

var getNewMaxScroll = function getNewMaxScroll(previous, current, action) {
  if (!shouldCheckOnAction(action)) {
    return null;
  }

  if (!isMovementAllowed(previous) || !isMovementAllowed(current)) {
    return null;
  }

  if (!hasDroppableOverChanged(previous.impact.destination, current.impact.destination)) {
    return null;
  }

  var viewport = current.viewport;
  var doc = document.documentElement;
  !doc ?  false ? invariant(false, 'Could not find document.documentElement') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: viewport.frame.width,
    height: viewport.frame.height
  });

  if (isEqual(maxScroll, viewport.scroll.max)) {
    return null;
  }

  return maxScroll;
};

var maxScrollUpdater = (function (store) {
  return function (next) {
    return function (action) {
      var previous = store.getState();
      next(action);
      var current = store.getState();
      var maxScroll = getNewMaxScroll(previous, current, action);

      if (maxScroll) {
        next(updateViewportMaxScroll(maxScroll));
      }
    };
  };
});

var composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */];
var createStore$1 = (function (_ref) {
  var getDimensionMarshal = _ref.getDimensionMarshal,
      styleMarshal = _ref.styleMarshal,
      getHooks = _ref.getHooks,
      announce = _ref.announce,
      getScroller = _ref.getScroller;
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["e" /* createStore */])(reducer, composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_5_redux__["a" /* applyMiddleware */])(style(styleMarshal), dimensionMarshalStopper(getDimensionMarshal), lift$1(getDimensionMarshal), drop$1, dropAnimationFinish, maxScrollUpdater, autoScroll(getScroller), hooks(getHooks, announce))));
});

var getEmptyMap = function getEmptyMap() {
  return {
    draggables: {},
    droppables: {}
  };
};

var timingKey = 'Publish collection from DOM';
var createPublisher = (function (_ref) {
  var getProvided = _ref.getProvided,
      callbacks = _ref.callbacks;

  var advancedUsageWarning = function () {
    if (true) {
      return function () {};
    }

    var hasAnnounced = false;
    return function () {
      if (hasAnnounced) {
        return;
      }

      hasAnnounced = true;

      if (true) {
        return;
      }

      console.warn("\n        Advanced usage warning: you are adding or removing a dimension during a drag\n        This an advanced feature used to support dynamic interactions such as lazy loading lists.\n\n        Keep in mind the following restrictions:\n\n        - Draggable's can only be added to Droppable's that are scroll containers\n        - Adding a Droppable cannot impact the placement of other Droppables\n          (it cannot push a Droppable on the page)\n\n        (This warning will be stripped in production builds)\n      ".trim());
    };
  }();

  var additions = getEmptyMap();
  var removals = getEmptyMap();
  var frameId = null;

  var reset = function reset() {
    additions = getEmptyMap();
    removals = getEmptyMap();
  };

  var collect = function collect() {
    advancedUsageWarning();

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      callbacks.collectionStarting();
      start(timingKey);

      var _getProvided = getProvided(),
          entries = _getProvided.entries,
          collection = _getProvided.collection;

      var windowScroll = collection.initialWindowScroll;

      var draggables = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(additions.draggables).map(function (id) {
        return entries.draggables[id].getDimension(windowScroll);
      });

      var droppables = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(additions.droppables).map(function (id) {
        return entries.droppables[id].callbacks.getDimensionAndWatchScroll(windowScroll, collection.scrollOptions);
      });

      var result = {
        additions: {
          draggables: draggables,
          droppables: droppables
        },
        removals: {
          draggables: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(removals.draggables),
          droppables: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(removals.droppables)
        }
      };
      reset();
      finish(timingKey);
      callbacks.publish(result);
    });
  };

  var addDraggable = function addDraggable(id) {
    additions.draggables[id] = true;

    if (removals.draggables[id]) {
      delete removals.draggables[id];
    }

    collect();
  };

  var removeDraggable = function removeDraggable(id) {
    removals.draggables[id] = true;

    if (additions.draggables[id]) {
      delete additions.draggables[id];
    }

    collect();
  };

  var addDroppable = function addDroppable(id) {
    additions.droppables[id] = true;

    if (removals.droppables[id]) {
      delete removals.droppables[id];
    }

    collect();
  };

  var removeDroppable = function removeDroppable(id) {
    removals.droppables[id] = true;

    if (additions.droppables[id]) {
      delete additions.droppables[id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    reset();
  };

  return {
    addDraggable: addDraggable,
    removeDraggable: removeDraggable,
    addDroppable: addDroppable,
    removeDroppable: removeDroppable,
    stop: stop
  };
});

var createDimensionMarshal = (function (callbacks) {
  var entries = {
    droppables: {},
    draggables: {}
  };
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publish,
      collectionStarting: callbacks.collectionStarting
    },
    getProvided: function getProvided() {
      !collection ?  false ? invariant(false, 'Cannot get scroll options when there is no collection') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      return {
        entries: entries,
        collection: collection
      };
    }
  });

  var registerDraggable = function registerDraggable(descriptor, getDimension) {
    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;

    if (!collection) {
      return;
    }

    if (collection.critical.draggable.type !== descriptor.type) {
      return;
    }

    publisher.addDraggable(descriptor.id);
  };

  var updateDraggable = function updateDraggable(previous, descriptor, getDimension) {
    !entries.draggables[previous.id] ?  false ? invariant(false, 'Cannot update draggable registration as no previous registration was found') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    delete entries.draggables[previous.id];
    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;
  };

  var unregisterDraggable = function unregisterDraggable(descriptor) {
    var entry = entries.draggables[descriptor.id];
    !entry ?  false ? invariant(false, "Cannot unregister Draggable with id " + descriptor.id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.draggables[descriptor.id];

    if (!collection) {
      return;
    }

    !(collection.critical.draggable.id !== descriptor.id) ?  false ? invariant(false, 'Cannot remove the dragging item during a drag') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (descriptor.type !== collection.critical.draggable.type) {
      return;
    }

    publisher.removeDraggable(descriptor.id);
  };

  var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
    var id = descriptor.id;
    entries.droppables[id] = {
      descriptor: descriptor,
      callbacks: droppableCallbacks
    };

    if (!collection) {
      return;
    }

    if (descriptor.type !== collection.critical.droppable.type) {
      return;
    }

    publisher.addDroppable(id);
  };

  var updateDroppable = function updateDroppable(previous, descriptor, droppableCallbacks) {
    !entries.droppables[previous.id] ?  false ? invariant(false, 'Cannot update droppable registration as no previous registration was found') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    delete entries.droppables[previous.id];
    var entry = {
      descriptor: descriptor,
      callbacks: droppableCallbacks
    };
    entries.droppables[descriptor.id] = entry;

    if (collection) {
       false ? invariant(false, 'You are not able to update the id or type of a droppable during a drag') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false);
    }
  };

  var unregisterDroppable = function unregisterDroppable(descriptor) {
    var entry = entries.droppables[descriptor.id];
    !entry ?  false ? invariant(false, "Cannot unregister Droppable with id " + descriptor.id + " as as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.droppables[descriptor.id];

    if (!collection) {
      return;
    }

    !(collection.critical.droppable.id !== descriptor.id) ?  false ? invariant(false, 'Cannot remove the home Droppable during a drag') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (collection.critical.droppable.type !== descriptor.type) {
      return;
    }

    publisher.removeDroppable(descriptor.id);
  };

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableScroll({
      id: id,
      offset: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    var entry = entries.droppables[id];
    !entry ?  false ? invariant(false, "Cannot scroll Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    entry.callbacks.scroll(change);
  };

  var getInitialPublish = function getInitialPublish(args) {
    var critical = args.critical,
        scrollOptions = args.scrollOptions,
        windowScroll = args.initialWindowScroll;
    var timingKey = 'Initial collection from DOM';
    start(timingKey);
    var home = critical.droppable;

    var droppables = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(entries.droppables).map(function (id) {
      return entries.droppables[id];
    }).filter(function (entry) {
      return entry.descriptor.type === home.type;
    }).map(function (entry) {
      return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    }).reduce(function (previous, dimension) {
      previous[dimension.descriptor.id] = dimension;
      return previous;
    }, {});

    var draggables = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(entries.draggables).map(function (id) {
      return entries.draggables[id];
    }).filter(function (entry) {
      return entry.descriptor.type === critical.draggable.type;
    }).map(function (entry) {
      return entry.getDimension(windowScroll);
    }).reduce(function (previous, dimension) {
      previous[dimension.descriptor.id] = dimension;
      return previous;
    }, {});

    finish(timingKey);
    var dimensions = {
      draggables: draggables,
      droppables: droppables
    };
    var result = {
      dimensions: dimensions,
      critical: critical
    };
    return result;
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_keys___default()(entries.droppables).filter(function (id) {
      return entries.droppables[id].descriptor.type === home.type;
    }).forEach(function (id) {
      return entries.droppables[id].callbacks.unwatchScroll();
    });

    collection = null;
  };

  var startPublishing = function startPublishing(request, windowScroll) {
    !!collection ?  false ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var entry = entries.draggables[request.draggableId];
    !entry ?  false ? invariant(false, 'Cannot find critical draggable entry') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var home = entries.droppables[entry.descriptor.droppableId];
    !home ?  false ? invariant(false, 'Cannot find critical droppable entry') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    collection = {
      scrollOptions: request.scrollOptions,
      critical: critical,
      initialWindowScroll: windowScroll
    };
    return getInitialPublish(collection);
  };

  var marshal = {
    registerDraggable: registerDraggable,
    updateDraggable: updateDraggable,
    unregisterDraggable: unregisterDraggable,
    registerDroppable: registerDroppable,
    updateDroppable: updateDroppable,
    unregisterDroppable: unregisterDroppable,
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var physics = function () {
  var base = {
    stiffness: 1000,
    damping: 60,
    precision: 0.99
  };

  var standard = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, base);

  var fast = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, base, {
    stiffness: base.stiffness * 2
  });

  return {
    standard: standard,
    fast: fast
  };
}();
var css = {
  outOfTheWay: 'transform 0.2s cubic-bezier(0.2, 0, 0, 1)'
};

var prefix = 'data-react-beautiful-dnd';
var dragHandle = prefix + "-drag-handle";
var draggable = prefix + "-draggable";
var droppable = prefix + "-droppable";

var getStyles = (function (styleContext) {
  var dragHandleSelector = "[" + dragHandle + "=\"" + styleContext + "\"]";
  var draggableSelector = "[" + draggable + "=\"" + styleContext + "\"]";
  var droppableSelector = "[" + droppable + "=\"" + styleContext + "\"]";
  var dragHandleStyles = {
    base: "\n      " + dragHandleSelector + " {\n        -webkit-touch-callout: none;\n        -webkit-tap-highlight-color: rgba(0,0,0,0);\n        touch-action: manipulation;\n      }\n    ",
    grabCursor: "\n      " + dragHandleSelector + " {\n        cursor: -webkit-grab;\n        cursor: grab;\n      }\n    ",
    blockPointerEvents: "\n      " + dragHandleSelector + " {\n        pointer-events: none;\n      }\n    "
  };
  var draggableStyles = {
    animateMovement: "\n      " + draggableSelector + " {\n        transition: " + css.outOfTheWay + ";\n      }\n    "
  };
  var droppableStyles = {
    base: "\n      " + droppableSelector + " {\n        overflow-anchor: none;\n      }\n    "
  };
  var bodyStyles = {
    whileActiveDragging: "\n      body {\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n      }\n    "
  };
  var base = [dragHandleStyles.base, droppableStyles.base];
  var resting = base.concat([dragHandleStyles.grabCursor]);
  var collecting = base.concat([dragHandleStyles.blockPointerEvents, bodyStyles.whileActiveDragging]);
  var dragging = collecting.concat([draggableStyles.animateMovement]);
  var dropAnimating = base.concat([dragHandleStyles.grabCursor, draggableStyles.animateMovement]);
  var userCancel = base.concat([draggableStyles.animateMovement]);
  return {
    resting: resting.join(''),
    dragging: dragging.join(''),
    dropAnimating: dropAnimating.join(''),
    collecting: collecting.join(''),
    userCancel: userCancel.join('')
  };
});

var count = 0;
var resetStyleContext = function resetStyleContext() {
  count = 0;
};

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? invariant(false, 'Cannot find the head to append a style to') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  return head;
};

var createStyleMarshal = (function () {
  var context = "" + count++;
  var styles = getStyles(context);
  var el = null;
  var setStyle = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (proposed) {
    !el ?  false ? invariant(false, 'Cannot set style of style tag if not mounted') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    el.innerHTML = proposed;
  });

  var mount = function mount() {
    !!el ?  false ? invariant(false, 'Style marshal already mounted') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    el = document.createElement('style');
    el.type = 'text/css';
    el.setAttribute(prefix, context);
    getHead().appendChild(el);
    setStyle(styles.resting);
  };

  var collecting = function collecting() {
    return setStyle(styles.collecting);
  };

  var dragging = function dragging() {
    return setStyle(styles.dragging);
  };

  var dropping = function dropping(reason) {
    if (reason === 'DROP') {
      setStyle(styles.dropAnimating);
      return;
    }

    setStyle(styles.userCancel);
  };

  var resting = function resting() {
    return setStyle(styles.resting);
  };

  var unmount = function unmount() {
    !el ?  false ? invariant(false, 'Cannot unmount style marshal as it is already unmounted') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    getHead().removeChild(el);
    el = null;
  };

  var marshal = {
    collecting: collecting,
    dragging: dragging,
    dropping: dropping,
    resting: resting,
    styleContext: context,
    mount: mount,
    unmount: unmount
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.pending.result.draggableId === id) {
    return false;
  }

  return state.pending.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var count$1 = 0;
var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getBody = function getBody() {
  !document.body ?  false ? invariant(false, 'Announcer cannot find document.body') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  return document.body;
};

var createAnnouncer = (function () {
  var id = "react-beautiful-dnd-announcement-" + count$1++;
  var el = null;

  var announce = function announce(message) {
    !el ?  false ? invariant(false, 'Cannot announce to unmounted node') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    el.textContent = message;
  };

  var mount = function mount() {
    !!el ?  false ? invariant(false, 'Announcer already mounted') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    el = document.createElement('div');
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');
    el.setAttribute('aria-atomic', 'true');

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign___default()(el.style, visuallyHidden);

    getBody().appendChild(el);
  };

  var unmount = function unmount() {
    !el ?  false ? invariant(false, 'Will not unmount annoucer as it is already unmounted') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    getBody().removeChild(el);
    el = null;
  };

  var announcer = {
    announce: announce,
    id: id,
    mount: mount,
    unmount: unmount
  };
  return announcer;
});

var getScrollableDroppables = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.viewport.closestScrollable) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = getScrollableDroppables(droppables).find(function (droppable) {
    !droppable.viewport.closestScrollable ?  false ? invariant(false, 'Invalid result') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    return isPositionInFrame(droppable.viewport.closestScrollable.framePageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination.droppableId];

    if (!_dimension.viewport.closestScrollable) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var closest$$1 = droppable.viewport.closestScrollable;

  if (!closest$$1) {
    return false;
  }

  return canPartiallyScroll({
    current: closest$$1.scroll.current,
    max: closest$$1.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var closest$$1 = droppable.viewport.closestScrollable;

  if (!closest$$1) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: closest$$1.scroll.current,
    max: closest$$1.scroll.max,
    change: change
  });
};

var config = {
  startFrom: 0.25,
  maxSpeedAt: 0.05,
  maxScrollSpeed: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  }
};
var clean$1 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getPixelThresholds = function getPixelThresholds(container, axis) {
  var startFrom = container[axis.size] * config.startFrom;
  var maxSpeedAt = container[axis.size] * config.maxSpeedAt;
  var accelerationPlane = startFrom - maxSpeedAt;
  var thresholds = {
    startFrom: startFrom,
    maxSpeedAt: maxSpeedAt,
    accelerationPlane: accelerationPlane
  };
  return thresholds;
};

var getSpeed = function getSpeed(distance$$1, thresholds) {
  if (distance$$1 >= thresholds.startFrom) {
    return 0;
  }

  if (distance$$1 <= thresholds.maxSpeedAt) {
    return config.maxScrollSpeed;
  }

  var distancePastStart = thresholds.startFrom - distance$$1;
  var percentage = distancePastStart / thresholds.accelerationPlane;
  var transformed = config.ease(percentage);
  var speed = config.maxScrollSpeed * transformed;
  return speed;
};

var adjustForSizeLimits = function adjustForSizeLimits(_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
};

var getRequiredScroll = function getRequiredScroll(_ref2) {
  var container = _ref2.container,
      subject = _ref2.subject,
      center = _ref2.center;
  var distance$$1 = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };

  var y = function () {
    var thresholds = getPixelThresholds(container, vertical);
    var isCloserToBottom = distance$$1.bottom < distance$$1.top;

    if (isCloserToBottom) {
      return getSpeed(distance$$1.bottom, thresholds);
    }

    return -1 * getSpeed(distance$$1.top, thresholds);
  }();

  var x = function () {
    var thresholds = getPixelThresholds(container, horizontal);
    var isCloserToRight = distance$$1.right < distance$$1.left;

    if (isCloserToRight) {
      return getSpeed(distance$$1.right, thresholds);
    }

    return -1 * getSpeed(distance$$1.left, thresholds);
  }();

  var required = clean$1({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
};

var withPlaceholder = function withPlaceholder(droppable, draggable) {
  var closest$$1 = droppable.viewport.closestScrollable;

  if (!closest$$1) {
    return null;
  }

  var isOverHome = droppable.descriptor.id === draggable.descriptor.droppableId;
  var max = closest$$1.scroll.max;
  var current = closest$$1.scroll.current;

  if (isOverHome) {
    return {
      max: max,
      current: current
    };
  }

  var spaceForPlaceholder = patch(droppable.axis.line, draggable.placeholder.client.borderBox[droppable.axis.size]);
  var newMax = add(max, spaceForPlaceholder);
  var newCurrent = {
    x: Math.min(current.x, newMax.x),
    y: Math.min(current.y, newMax.y)
  };
  return {
    max: newMax,
    current: newCurrent
  };
};

var createFluidScroller = (function (_ref3) {
  var scrollWindow = _ref3.scrollWindow,
      scrollDroppable = _ref3.scrollDroppable;
  var scheduleWindowScroll = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(scrollWindow);
  var scheduleDroppableScroll = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(scrollDroppable);

  var scroller = function scroller(state) {
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    var viewport = state.viewport;
    var requiredWindowScroll = getRequiredScroll({
      container: viewport.frame,
      subject: subject,
      center: center
    });

    if (requiredWindowScroll && canScrollWindow(viewport, requiredWindowScroll)) {
      scheduleWindowScroll(requiredWindowScroll);
      return;
    }

    var droppable = getBestScrollableDroppable({
      center: center,
      destination: state.impact.destination,
      droppables: state.dimensions.droppables
    });

    if (!droppable) {
      return;
    }

    var closestScrollable = droppable.viewport.closestScrollable;

    if (!closestScrollable) {
      return;
    }

    var requiredFrameScroll = getRequiredScroll({
      container: closestScrollable.framePageMarginBox,
      subject: subject,
      center: center
    });

    if (!requiredFrameScroll) {
      return;
    }

    var result = withPlaceholder(droppable, draggable);

    if (!result) {
      return;
    }

    var closest$$1 = droppable.viewport.closestScrollable;

    if (!closest$$1) {
      return;
    }

    var canScrollDroppable$$1 = canPartiallyScroll({
      current: result.current,
      max: result.max,
      change: requiredFrameScroll
    });

    if (canScrollDroppable$$1) {
      scheduleDroppableScroll(droppable.descriptor.id, requiredFrameScroll);
    }
  };

  scroller.cancel = function () {
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
  };

  return scroller;
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client,
      shouldAnimate: true
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(viewport, change) {
    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = state.impact.destination;
    !destination ?  false ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination.droppableId], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroll = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var marshal = {
    cancel: fluidScroll.cancel,
    fluidScroll: fluidScroll,
    jumpScroll: jumpScroll
  };
  return marshal;
});

var prefix$1 = function prefix(key) {
  return "private-react-beautiful-dnd-key-do-not-use-" + key;
};

var storeKey = prefix$1('store');
var droppableIdKey = prefix$1('droppable-id');
var droppableTypeKey = prefix$1('droppable-type');
var dimensionMarshalKey = prefix$1('dimension-marshal');
var styleContextKey = prefix$1('style-context');
var canLiftContextKey = prefix$1('can-lift');

var _DragDropContext$chil;
var resetServerContext = function resetServerContext() {
  resetStyleContext();
};

var printFatalDevError = function printFatalDevError(error) {
  if (true) {
    return;
  }

  console.warn("\n    An error has occurred while a drag is occurring.\n    Any existing drag will be cancelled.\n\n    Raw error:\n  ");
  console.error(error);
};

var DragDropContext = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DragDropContext, _React$Component);

  function DragDropContext(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.store = void 0;
    _this.dimensionMarshal = void 0;
    _this.styleMarshal = void 0;
    _this.autoScroller = void 0;
    _this.announcer = void 0;
    _this.unsubscribe = void 0;

    _this.canLift = function (id) {
      return canStartDrag(_this.store.getState(), id);
    };

    _this.onFatalError = function (error) {
      printFatalDevError(error);

      var state = _this.store.getState();

      if (state.phase !== 'IDLE') {
        _this.store.dispatch(clean());
      }
    };

    _this.onWindowError = function (error) {
      return _this.onFatalError(error);
    };

    _this.announcer = createAnnouncer();
    _this.styleMarshal = createStyleMarshal();
    _this.store = createStore$1({
      getDimensionMarshal: function getDimensionMarshal() {
        return _this.dimensionMarshal;
      },
      styleMarshal: _this.styleMarshal,
      getHooks: function getHooks() {
        return {
          onBeforeDragStart: _this.props.onBeforeDragStart,
          onDragStart: _this.props.onDragStart,
          onDragEnd: _this.props.onDragEnd,
          onDragUpdate: _this.props.onDragUpdate
        };
      },
      announce: _this.announcer.announce,
      getScroller: function getScroller() {
        return _this.autoScroller;
      }
    });
    var callbacks = Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      collectionStarting: collectionStarting,
      publish: publish,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled
    }, _this.store.dispatch);
    _this.dimensionMarshal = createDimensionMarshal(callbacks);
    _this.autoScroller = createAutoScroller(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      scrollWindow: scrollWindow,
      scrollDroppable: _this.dimensionMarshal.scrollDroppable
    }, Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      move: move
    }, _this.store.dispatch)));
    return _this;
  }

  var _proto = DragDropContext.prototype;

  _proto.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[storeKey] = this.store, _ref[dimensionMarshalKey] = this.dimensionMarshal, _ref[styleContextKey] = this.styleMarshal.styleContext, _ref[canLiftContextKey] = this.canLift, _ref;
  };

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('error', this.onWindowError);
    this.styleMarshal.mount();
    this.announcer.mount();
  };

  _proto.componentDidCatch = function componentDidCatch(error) {
    this.onFatalError(error);

    if (error.message.indexOf('Invariant failed') !== -1) {
      this.setState({});
      return;
    }

    throw error;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('error', this.onWindowError);
    var state = this.store.getState();

    if (state.phase !== 'IDLE') {
      this.store.dispatch(clean());
    }

    this.styleMarshal.unmount();
    this.announcer.unmount();
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return DragDropContext;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

DragDropContext.childContextTypes = (_DragDropContext$chil = {}, _DragDropContext$chil[storeKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape({
  dispatch: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  subscribe: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired
}).isRequired, _DragDropContext$chil[dimensionMarshalKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired, _DragDropContext$chil[styleContextKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _DragDropContext$chil[canLiftContextKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired, _DragDropContext$chil);

var isScrollable = function isScrollable() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.some(function (value) {
    return value === 'auto' || value === 'scroll';
  });
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  return isScrollable(style.overflow, style.overflowY, style.overflowX);
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var _DroppableDimensionPu;

var getScroll = function getScroll(el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
};

var checkForNestedScrollContainers = function checkForNestedScrollContainers(scrollable) {
  if (true) {
    return;
  }

  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

  console.warn("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ");
};

var listenerOptions = {
  passive: true
};

var DroppableDimensionPublisher = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DroppableDimensionPublisher, _React$Component);

  function DroppableDimensionPublisher(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.watchingScroll = null;
    _this.callbacks = void 0;
    _this.publishedDescriptor = null;

    _this.getClosestScroll = function () {
      if (!_this.watchingScroll) {
        return origin;
      }

      return getScroll(_this.watchingScroll.closestScrollable);
    };

    _this.memoizedUpdateScroll = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (x, y) {
      !_this.publishedDescriptor ?  false ? invariant(false, 'Cannot update scroll on unpublished droppable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var newScroll = {
        x: x,
        y: y
      };
      var marshal = _this.context[dimensionMarshalKey];
      marshal.updateDroppableScroll(_this.publishedDescriptor.id, newScroll);
    });

    _this.updateScroll = function () {
      var offset = _this.getClosestScroll();

      _this.memoizedUpdateScroll(offset.x, offset.y);
    };

    _this.scheduleScrollUpdate = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(_this.updateScroll);

    _this.onClosestScroll = function () {
      !_this.watchingScroll ?  false ? invariant(false, 'Could not find scroll options while scrolling') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var options = _this.watchingScroll.options;

      if (options.shouldPublishImmediately) {
        _this.updateScroll();

        return;
      }

      _this.scheduleScrollUpdate();
    };

    _this.scroll = function (change) {
      !_this.watchingScroll ?  false ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var closestScrollable = _this.watchingScroll.closestScrollable;
      closestScrollable.scrollTop += change.y;
      closestScrollable.scrollLeft += change.x;
    };

    _this.watchScroll = function (closestScrollable, options) {
      !!_this.watchingScroll ?  false ? invariant(false, 'Droppable cannot watch scroll as it is already watching scroll') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

      if (!closestScrollable) {
        return;
      }

      _this.watchingScroll = {
        options: options,
        closestScrollable: closestScrollable
      };
      closestScrollable.addEventListener('scroll', _this.onClosestScroll, listenerOptions);
    };

    _this.unwatchScroll = function () {
      var watching = _this.watchingScroll;

      if (!watching) {
        return;
      }

      _this.scheduleScrollUpdate.cancel();

      watching.closestScrollable.removeEventListener('scroll', _this.onClosestScroll, listenerOptions);
      _this.watchingScroll = null;
    };

    _this.getMemoizedDescriptor = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (id, type) {
      return {
        id: id,
        type: type
      };
    });

    _this.publish = function () {
      var marshal = _this.context[dimensionMarshalKey];

      var descriptor = _this.getMemoizedDescriptor(_this.props.droppableId, _this.props.type);

      if (!_this.publishedDescriptor) {
        marshal.registerDroppable(descriptor, _this.callbacks);
        _this.publishedDescriptor = descriptor;
        return;
      }

      if (_this.publishedDescriptor === descriptor) {
        return;
      }

      marshal.updateDroppable(_this.publishedDescriptor, descriptor, _this.callbacks);
      _this.publishedDescriptor = descriptor;
    };

    _this.unpublish = function () {
      !_this.publishedDescriptor ?  false ? invariant(false, 'Cannot unpublish descriptor when none is published') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var marshal = _this.context[dimensionMarshalKey];
      marshal.unregisterDroppable(_this.publishedDescriptor);
      _this.publishedDescriptor = null;
    };

    _this.getDimensionAndWatchScroll = function (windowScroll, options) {
      var _this$props = _this.props,
          direction = _this$props.direction,
          ignoreContainerClipping = _this$props.ignoreContainerClipping,
          isDropDisabled = _this$props.isDropDisabled,
          getDroppableRef = _this$props.getDroppableRef;
      var targetRef = getDroppableRef();
      var descriptor = _this.publishedDescriptor;
      !targetRef ?  false ? invariant(false, 'Cannot calculate a dimension when not attached to the DOM') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      !descriptor ?  false ? invariant(false, 'Cannot get dimension for unpublished droppable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var scrollableRef = getClosestScrollable(targetRef);
      checkForNestedScrollContainers(scrollableRef);

      _this.watchScroll(scrollableRef, options);

      var client = function () {
        var base = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["c" /* getBox */])(targetRef);

        if (!scrollableRef) {
          return base;
        }

        if (targetRef !== scrollableRef) {
          return base;
        }

        var top = base.paddingBox.top - scrollableRef.scrollTop;
        var left = base.paddingBox.left - scrollableRef.scrollLeft;
        var bottom = top + scrollableRef.scrollHeight;
        var right = left + scrollableRef.scrollWidth;
        var paddingBox = {
          top: top,
          right: right,
          bottom: bottom,
          left: left
        };
        var borderBox = {
          top: paddingBox.top - base.border.top,
          right: paddingBox.right + base.border.right,
          bottom: paddingBox.bottom + base.border.bottom,
          left: paddingBox.left - base.border.left
        };
        return Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["b" /* createBox */])({
          borderBox: borderBox,
          margin: base.margin,
          border: base.border,
          padding: base.padding
        });
      }();

      var page = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["e" /* withScroll */])(client, windowScroll);

      var closest$$1 = function () {
        if (!scrollableRef) {
          return null;
        }

        var frameClient = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["c" /* getBox */])(scrollableRef);
        return {
          client: frameClient,
          page: Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["e" /* withScroll */])(frameClient),
          scrollHeight: scrollableRef.scrollHeight,
          scrollWidth: scrollableRef.scrollWidth,
          scroll: getScroll(scrollableRef),
          shouldClipSubject: !ignoreContainerClipping
        };
      }();

      return getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        direction: direction,
        client: client,
        page: page,
        closest: closest$$1
      });
    };

    var callbacks = {
      getDimensionAndWatchScroll: _this.getDimensionAndWatchScroll,
      unwatchScroll: _this.unwatchScroll,
      scroll: _this.scroll
    };
    _this.callbacks = callbacks;
    return _this;
  }

  var _proto = DroppableDimensionPublisher.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.publish();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.publish();

    if (this.props.isDropDisabled === prevProps.isDropDisabled) {
      return;
    }

    var marshal = this.context[dimensionMarshalKey];
    marshal.updateDroppableIsEnabled(this.props.droppableId, !this.props.isDropDisabled);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.watchingScroll) {
      if (false) {
        console.warn('Unmounting droppable while it was watching scroll');
      }

      this.unwatchScroll();
    }

    this.unpublish();
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return DroppableDimensionPublisher;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

DroppableDimensionPublisher.contextTypes = (_DroppableDimensionPu = {}, _DroppableDimensionPu[dimensionMarshalKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired, _DroppableDimensionPu);

var Placeholder = function (_PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Placeholder, _PureComponent);

  function Placeholder() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Placeholder.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  };

  _proto.render = function render() {
    var placeholder = this.props.placeholder;
    var client = placeholder.client,
        display = placeholder.display,
        tagName = placeholder.tagName;
    var style = {
      display: display,
      boxSizing: 'border-box',
      width: client.borderBox.width,
      height: client.borderBox.height,
      marginTop: client.margin.top,
      marginRight: client.margin.right,
      marginBottom: client.margin.bottom,
      marginLeft: client.margin.left,
      flexShrink: '0',
      flexGrow: '0',
      pointerEvents: 'none'
    };
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(tagName, {
      style: style
    });
  };

  return Placeholder;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

var throwIfRefIsInvalid = (function (ref) {
  !(ref && ref instanceof HTMLElement) ?  false ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
});

var _Droppable$contextTyp, _Droppable$childConte;

var Droppable = function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Droppable, _Component);

  function Droppable(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this;
    _this.styleContext = void 0;
    _this.ref = null;
    _this.isPlaceholderMounted = false;

    _this.onPlaceholderMount = function () {
      _this.isPlaceholderMounted = true;
    };

    _this.onPlaceholderUnmount = function () {
      _this.isPlaceholderMounted = false;
    };

    _this.setRef = function (ref) {
      if (ref === null) {
        return;
      }

      if (ref === _this.ref) {
        return;
      }

      _this.ref = ref;
      throwIfRefIsInvalid(ref);
    };

    _this.getDroppableRef = function () {
      return _this.ref;
    };

    _this.styleContext = context[styleContextKey];
    return _this;
  }

  var _proto = Droppable.prototype;

  _proto.getChildContext = function getChildContext() {
    var _value;

    var value = (_value = {}, _value[droppableIdKey] = this.props.droppableId, _value[droppableTypeKey] = this.props.type, _value);
    return value;
  };

  _proto.componentDidMount = function componentDidMount() {
    throwIfRefIsInvalid(this.ref);
    this.warnIfPlaceholderNotMounted();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.warnIfPlaceholderNotMounted();
  };

  _proto.warnIfPlaceholderNotMounted = function warnIfPlaceholderNotMounted() {
    if (true) {
      return;
    }

    if (!this.props.placeholder) {
      return;
    }

    if (this.isPlaceholderMounted) {
      return;
    }

    console.warn("\n      Droppable setup issue: DroppableProvided > placeholder could not be found.\n      Please be sure to add the {provided.placeholder} Node as a child of your Droppable\n\n      More information: https://github.com/atlassian/react-beautiful-dnd#1-provided-droppableprovided\n    ");
  };

  _proto.getPlaceholder = function getPlaceholder() {
    if (!this.props.placeholder) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Placeholder, {
      placeholder: this.props.placeholder,
      onMount: this.onPlaceholderMount,
      onUnmount: this.onPlaceholderUnmount
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        direction = _this$props.direction,
        droppableId = _this$props.droppableId,
        ignoreContainerClipping = _this$props.ignoreContainerClipping,
        isDraggingOver = _this$props.isDraggingOver,
        isDropDisabled = _this$props.isDropDisabled,
        draggingOverWith = _this$props.draggingOverWith,
        type = _this$props.type;
    var provided = {
      innerRef: this.setRef,
      placeholder: this.getPlaceholder(),
      droppableProps: {
        'data-react-beautiful-dnd-droppable': this.styleContext
      }
    };
    var snapshot = {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith
    };
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(DroppableDimensionPublisher, {
      droppableId: droppableId,
      type: type,
      direction: direction,
      ignoreContainerClipping: ignoreContainerClipping,
      isDropDisabled: isDropDisabled,
      getDroppableRef: this.getDroppableRef
    }, children(provided, snapshot));
  };

  return Droppable;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Droppable.contextTypes = (_Droppable$contextTyp = {}, _Droppable$contextTyp[styleContextKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _Droppable$contextTyp);
Droppable.childContextTypes = (_Droppable$childConte = {}, _Droppable$childConte[droppableIdKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _Droppable$childConte[droppableTypeKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _Droppable$childConte);

var isStrictEqual = (function (a, b) {
  return a === b;
});

var makeMapStateToProps = function makeMapStateToProps() {
  var getIsDraggingOver = function getIsDraggingOver(id, destination) {
    if (!destination) {
      return false;
    }

    return destination.droppableId === id;
  };

  var shouldUsePlaceholder = function shouldUsePlaceholder(id, descriptor, destination) {
    if (!destination) {
      return false;
    }

    if (id === descriptor.droppableId) {
      return false;
    }

    return id === destination.droppableId;
  };

  var getMapProps = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (isDraggingOver, draggingOverWith, placeholder) {
    return {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith,
      placeholder: placeholder
    };
  });

  var getDefault = function getDefault() {
    return getMapProps(false, null, null);
  };

  var selector = function selector(state, ownProps) {
    if (ownProps.isDropDisabled) {
      return getDefault();
    }

    var id = ownProps.droppableId;

    if (state.isDragging) {
      var destination = state.impact.destination;
      var isDraggingOver = getIsDraggingOver(id, destination);
      var draggableId = state.critical.draggable.id;
      var draggingOverWith = isDraggingOver ? draggableId : null;
      var draggable = state.dimensions.draggables[draggableId];
      var placeholder = shouldUsePlaceholder(id, draggable.descriptor, destination) ? draggable.placeholder : null;
      return getMapProps(isDraggingOver, draggingOverWith, placeholder);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var _destination = state.pending.impact.destination;

      var _isDraggingOver = getIsDraggingOver(id, _destination);

      var _draggableId = state.pending.result.draggableId;

      var _draggingOverWith = _isDraggingOver ? _draggableId : null;

      var _draggable = state.dimensions.draggables[_draggableId];

      var _placeholder = shouldUsePlaceholder(id, _draggable.descriptor, _destination) ? _draggable.placeholder : null;

      return getMapProps(_isDraggingOver, _draggingOverWith, _placeholder);
    }

    return getDefault();
  };

  return selector;
};
var connectedDroppable = Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(makeMapStateToProps, null, null, {
  storeKey: storeKey,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
connectedDroppable.defaultProps = {
  type: 'DEFAULT',
  isDropDisabled: false,
  direction: 'vertical',
  ignoreContainerClipping: false
};

var _DraggableDimensionPu;

var DraggableDimensionPublisher = function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DraggableDimensionPublisher, _Component);

  function DraggableDimensionPublisher() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.publishedDescriptor = null;
    _this.getMemoizedDescriptor = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (id, index, droppableId, type) {
      return {
        id: id,
        index: index,
        droppableId: droppableId,
        type: type
      };
    });

    _this.publish = function () {
      var marshal = _this.context[dimensionMarshalKey];

      var descriptor = _this.getMemoizedDescriptor(_this.props.draggableId, _this.props.index, _this.props.droppableId, _this.props.type);

      if (!_this.publishedDescriptor) {
        marshal.registerDraggable(descriptor, _this.getDimension);
        _this.publishedDescriptor = descriptor;
        return;
      }

      if (descriptor === _this.publishedDescriptor) {
        return;
      }

      marshal.updateDraggable(_this.publishedDescriptor, descriptor, _this.getDimension);
      _this.publishedDescriptor = descriptor;
    };

    _this.unpublish = function () {
      !_this.publishedDescriptor ?  false ? invariant(false, 'Cannot unpublish descriptor when none is published') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var marshal = _this.context[dimensionMarshalKey];
      marshal.unregisterDraggable(_this.publishedDescriptor);
      _this.publishedDescriptor = null;
    };

    _this.getDimension = function (windowScroll) {
      var targetRef = _this.props.getDraggableRef();

      var descriptor = _this.publishedDescriptor;
      !targetRef ?  false ? invariant(false, 'DraggableDimensionPublisher cannot calculate a dimension when not attached to the DOM') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      !descriptor ?  false ? invariant(false, 'Cannot get dimension for unpublished draggable') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var computedStyles = window.getComputedStyle(targetRef);
      var borderBox = targetRef.getBoundingClientRect();
      var client = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["a" /* calculateBox */])(borderBox, computedStyles);
      var page = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["e" /* withScroll */])(client, windowScroll);
      var placeholder = {
        client: client,
        tagName: targetRef.tagName.toLowerCase(),
        display: computedStyles.display
      };
      var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        client: client,
        page: page
      };
      return dimension;
    };

    return _this;
  }

  var _proto = DraggableDimensionPublisher.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.publish();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.publish();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unpublish();
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return DraggableDimensionPublisher;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

DraggableDimensionPublisher.contextTypes = (_DraggableDimensionPu = {}, _DraggableDimensionPu[dimensionMarshalKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired, _DraggableDimensionPu);

var DoubleRenderBlocker = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DoubleRenderBlocker, _React$Component);

  function DoubleRenderBlocker() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DoubleRenderBlocker.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (isEqual(origin, nextProps.change)) {
      return true;
    }

    if (isEqual(this.props.change, nextProps.change)) {
      return false;
    }

    return true;
  };

  _proto.render = function render() {
    return this.props.children(this.props.change);
  };

  return DoubleRenderBlocker;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

var Moveable = function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Moveable, _Component);

  function Moveable() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto2 = Moveable.prototype;

  _proto2.getFinal = function getFinal() {
    var destination = this.props.destination;
    var speed = this.props.speed;

    if (speed === 'INSTANT') {
      return destination;
    }

    var config = speed === 'FAST' ? physics.fast : physics.standard;
    return {
      x: Object(__WEBPACK_IMPORTED_MODULE_12_react_motion__["spring"])(destination.x, config),
      y: Object(__WEBPACK_IMPORTED_MODULE_12_react_motion__["spring"])(destination.y, config)
    };
  };

  _proto2.render = function render() {
    var _this = this;

    var final = this.getFinal();
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_motion__["Motion"], {
      defaultStyle: origin,
      style: final,
      onRest: this.props.onMoveEnd
    }, function (current) {
      var _this$props = _this.props,
          speed = _this$props.speed,
          destination = _this$props.destination,
          children = _this$props.children;
      var target = speed === 'INSTANT' ? destination : current;
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(DoubleRenderBlocker, {
        change: target
      }, children);
    });
  };

  return Moveable;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Moveable.defaultProps = {
  destination: origin
};

var getWindowFromRef = (function (ref) {
  return ref ? ref.ownerDocument.defaultView : window;
});

var selector = "[" + dragHandle + "]";

var isSVG = function isSVG(el) {
  if (typeof SVGElement === 'undefined') {
    return false;
  }

  return el instanceof SVGElement;
};

var throwIfSVG = function throwIfSVG(el) {
  !!isSVG(el) ?  false ? invariant(false, "A drag handle cannot be an SVGElement: it has inconsistent focus support.\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/tree/master/docs/guides/dragging-svgs.md") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
};

var getDragHandleRef = function getDragHandleRef(draggableRef) {
  if (draggableRef.hasAttribute(dragHandle)) {
    throwIfSVG(draggableRef);
    return draggableRef;
  }

  var el = draggableRef.querySelector(selector);
  throwIfSVG(draggableRef);
  !el ?  false ? invariant(false, "\n      Cannot find drag handle element inside of Draggable.\n      Please be sure to apply the {...provided.dragHandleProps} to your Draggable\n\n      More information: https://github.com/atlassian/react-beautiful-dnd#draggable\n    ") : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  !(el instanceof HTMLElement) ?  false ? invariant(false, 'A drag handle must be a HTMLElement') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  return el;
};

var retainingFocusFor = null;
var listenerOptions$1 = {
  capture: true
};

var clearRetentionOnFocusChange = function () {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    window.addEventListener('focus', onWindowFocusChange, listenerOptions$1);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    window.removeEventListener('focus', onWindowFocusChange, listenerOptions$1);
  };

  var onWindowFocusChange = function onWindowFocusChange() {
    unbind();
    retainingFocusFor = null;
  };

  var result = function result() {
    return bind();
  };

  result.cancel = function () {
    return unbind();
  };

  return result;
}();

var retain = function retain(id) {
  retainingFocusFor = id;
  clearRetentionOnFocusChange();
};

var tryRestoreFocus = function tryRestoreFocus(id, draggableRef) {
  if (!retainingFocusFor) {
    return;
  }

  if (id !== retainingFocusFor) {
    return;
  }

  retainingFocusFor = null;
  clearRetentionOnFocusChange.cancel();
  var dragHandleRef = getDragHandleRef(draggableRef);

  if (!dragHandleRef) {
    console.warn('Could not find drag handle in the DOM to focus on it');
    return;
  }

  dragHandleRef.focus();
};

var retainer = {
  retain: retain,
  tryRestoreFocus: tryRestoreFocus
};

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

var isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
};

var shouldAllowDraggingFromTarget = (function (event, props) {
  if (props.canDragInteractiveElements) {
    return true;
  }

  var target = event.target,
      currentTarget = event.currentTarget;

  if (!(target instanceof Element) || !(currentTarget instanceof Element)) {
    return true;
  }

  return !isAnInteractiveElement(currentTarget, target);
});

var createScheduler = (function (callbacks) {
  var memoizedMove = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (x, y) {
    var point = {
      x: x,
      y: y
    };
    callbacks.onMove(point);
  });
  var move = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(function (point) {
    return memoizedMove(point.x, point.y);
  });
  var moveUp = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(callbacks.onMoveUp);
  var moveDown = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(callbacks.onMoveDown);
  var moveRight = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(callbacks.onMoveRight);
  var moveLeft = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(callbacks.onMoveLeft);
  var windowScrollMove = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(callbacks.onWindowScroll);

  var cancel = function cancel() {
    move.cancel();
    moveUp.cancel();
    moveDown.cancel();
    moveRight.cancel();
    moveLeft.cancel();
    windowScrollMove.cancel();
  };

  return {
    move: move,
    moveUp: moveUp,
    moveDown: moveDown,
    moveRight: moveRight,
    moveLeft: moveLeft,
    windowScrollMove: windowScrollMove,
    cancel: cancel
  };
});

var sloppyClickThreshold = 5;
var isSloppyClickThresholdExceeded = (function (original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
});

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var getOptions = function getOptions(shared, fromBinding) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, shared, fromBinding);
};

var bindEvents = function bindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
  });
};
var unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.removeEventListener(binding.eventName, binding.fn, options);
  });
};

var sharedOptions = {
  capture: true
};
var createPostDragEventPreventer = (function (getWindow) {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    bindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    unbindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var pointerEvents = [{
    eventName: 'click',
    fn: function fn(event) {
      event.preventDefault();
      unbind();
    }
  }, {
    eventName: 'mousedown',
    fn: unbind
  }, {
    eventName: 'touchstart',
    fn: unbind
  }];

  var preventNext = function preventNext() {
    if (isBound) {
      unbind();
    }

    bind();
  };

  var preventer = {
    preventNext: preventNext,
    abort: unbind
  };
  return preventer;
});

var createEventMarshal = (function () {
  var isMouseDownHandled = false;

  var handle = function handle() {
    !!isMouseDownHandled ?  false ? invariant(false, 'Cannot handle mouse down as it is already handled') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
    isMouseDownHandled = true;
  };

  var isHandled = function isHandled() {
    return isMouseDownHandled;
  };

  var reset = function reset() {
    isMouseDownHandled = false;
  };

  return {
    handle: handle,
    isHandled: isHandled,
    reset: reset
  };
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = candidates.find(function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;

var noop = function noop() {};

var mouseDownMarshal = createEventMarshal();
var createMouseSensor = (function (_ref) {
  var callbacks = _ref.callbacks,
      getWindow = _ref.getWindow,
      canStartCapturing = _ref.canStartCapturing;
  var state = {
    isDragging: false,
    pending: null
  };

  var setState = function setState(newState) {
    state = newState;
  };

  var isDragging = function isDragging() {
    return state.isDragging;
  };

  var isCapturing = function isCapturing() {
    return Boolean(state.pending || state.isDragging);
  };

  var schedule = createScheduler(callbacks);
  var postDragEventPreventer = createPostDragEventPreventer(getWindow);

  var startDragging = function startDragging(fn) {
    if (fn === void 0) {
      fn = noop;
    }

    setState({
      pending: null,
      isDragging: true
    });
    fn();
  };

  var stopDragging = function stopDragging(fn, shouldBlockClick) {
    if (fn === void 0) {
      fn = noop;
    }

    if (shouldBlockClick === void 0) {
      shouldBlockClick = true;
    }

    schedule.cancel();
    unbindWindowEvents();
    mouseDownMarshal.reset();

    if (shouldBlockClick) {
      postDragEventPreventer.preventNext();
    }

    setState({
      isDragging: false,
      pending: null
    });
    fn();
  };

  var startPendingDrag = function startPendingDrag(point) {
    setState({
      pending: point,
      isDragging: false
    });
    bindWindowEvents();
  };

  var stopPendingDrag = function stopPendingDrag() {
    stopDragging(noop, false);
  };

  var kill = function kill(fn) {
    if (fn === void 0) {
      fn = noop;
    }

    if (state.pending) {
      stopPendingDrag();
      return;
    }

    stopDragging(fn);
  };

  var unmount = function unmount() {
    kill();
    postDragEventPreventer.abort();
  };

  var cancel = function cancel() {
    kill(callbacks.onCancel);
  };

  var windowBindings = [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };

      if (state.isDragging) {
        event.preventDefault();
        schedule.move(point);
        return;
      }

      if (!state.pending) {
        kill();
         false ? invariant(false, 'Expected there to be a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false);
      }

      if (!isSloppyClickThresholdExceeded(state.pending, point)) {
        return;
      }

      event.preventDefault();
      startDragging(function () {
        return callbacks.onLift({
          clientSelection: point,
          autoScrollMode: 'FLUID'
        });
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      if (state.pending) {
        stopPendingDrag();
        return;
      }

      event.preventDefault();
      stopDragging(callbacks.onDrop);
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (state.isDragging) {
        event.preventDefault();
      }

      stopDragging(callbacks.onCancel);
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (!state.isDragging) {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (state.pending) {
        stopPendingDrag();
        return;
      }

      schedule.windowScrollMove();
    }
  }, {
    eventName: 'webkitmouseforcechanged',
    fn: function fn(event) {
      if (event.webkitForce == null || MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN == null) {
        if (false) {
          console.warn('handling a mouse force changed event when it is not supported');
        }

        return;
      }

      var forcePressThreshold = MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
      var isForcePressing = event.webkitForce >= forcePressThreshold;

      if (isForcePressing) {
        cancel();
      }
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];

  var bindWindowEvents = function bindWindowEvents() {
    var win = getWindow();
    bindEvents(win, windowBindings, {
      capture: true
    });
  };

  var unbindWindowEvents = function unbindWindowEvents() {
    var win = getWindow();
    unbindEvents(win, windowBindings, {
      capture: true
    });
  };

  var onMouseDown = function onMouseDown(event) {
    if (mouseDownMarshal.isHandled()) {
      return;
    }

    !!isCapturing() ?  false ? invariant(false, 'Should not be able to perform a mouse down while a drag or pending drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    mouseDownMarshal.handle();
    event.preventDefault();
    var point = {
      x: event.clientX,
      y: event.clientY
    };
    startPendingDrag(point);
  };

  var sensor = {
    onMouseDown: onMouseDown,
    kill: kill,
    isCapturing: isCapturing,
    isDragging: isDragging,
    unmount: unmount
  };
  return sensor;
});

var getBorderBoxCenterPosition = (function (el) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["d" /* getRect */])(el.getBoundingClientRect()).center;
});

var _scrollJumpKeys;
var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

var noop$1 = function noop() {};

var createKeyboardSensor = (function (_ref) {
  var callbacks = _ref.callbacks,
      getWindow = _ref.getWindow,
      getDraggableRef = _ref.getDraggableRef,
      canStartCapturing = _ref.canStartCapturing;
  var state = {
    isDragging: false
  };

  var setState = function setState(newState) {
    state = newState;
  };

  var startDragging = function startDragging(fn) {
    if (fn === void 0) {
      fn = noop$1;
    }

    setState({
      isDragging: true
    });
    bindWindowEvents();
    fn();
  };

  var stopDragging = function stopDragging(fn) {
    if (fn === void 0) {
      fn = noop$1;
    }

    schedule.cancel();
    unbindWindowEvents();
    setState({
      isDragging: false
    });
    fn();
  };

  var kill = function kill() {
    return stopDragging();
  };

  var cancel = function cancel() {
    stopDragging(callbacks.onCancel);
  };

  var isDragging = function isDragging() {
    return state.isDragging;
  };

  var schedule = createScheduler(callbacks);

  var onKeyDown = function onKeyDown(event) {
    if (!isDragging()) {
      if (event.defaultPrevented) {
        return;
      }

      if (!canStartCapturing(event)) {
        return;
      }

      if (event.keyCode !== space) {
        return;
      }

      var ref = getDraggableRef();
      !ref ?  false ? invariant(false, 'Cannot start a keyboard drag without a draggable ref') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var center = getBorderBoxCenterPosition(ref);
      event.preventDefault();
      startDragging(function () {
        return callbacks.onLift({
          clientSelection: center,
          autoScrollMode: 'JUMP'
        });
      });
      return;
    }

    if (event.keyCode === escape) {
      event.preventDefault();
      cancel();
      return;
    }

    if (event.keyCode === space) {
      event.preventDefault();
      stopDragging(callbacks.onDrop);
      return;
    }

    if (event.keyCode === arrowDown) {
      event.preventDefault();
      schedule.moveDown();
      return;
    }

    if (event.keyCode === arrowUp) {
      event.preventDefault();
      schedule.moveUp();
      return;
    }

    if (event.keyCode === arrowRight) {
      event.preventDefault();
      schedule.moveRight();
      return;
    }

    if (event.keyCode === arrowLeft) {
      event.preventDefault();
      schedule.moveLeft();
      return;
    }

    if (scrollJumpKeys[event.keyCode]) {
      event.preventDefault();
      return;
    }

    preventStandardKeyEvents(event);
  };

  var windowBindings = [{
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      capture: false
    },
    fn: callbacks.onWindowScroll
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];

  var bindWindowEvents = function bindWindowEvents() {
    bindEvents(getWindow(), windowBindings, {
      capture: true
    });
  };

  var unbindWindowEvents = function unbindWindowEvents() {
    unbindEvents(getWindow(), windowBindings, {
      capture: true
    });
  };

  var sensor = {
    onKeyDown: onKeyDown,
    kill: kill,
    isDragging: isDragging,
    isCapturing: isDragging,
    unmount: kill
  };
  return sensor;
});

var timeForLongPress = 150;
var forcePressThreshold = 0.15;
var touchStartMarshal = createEventMarshal();

var noop$2 = function noop() {};

var webkitHack = function () {
  var stub = {
    preventTouchMove: noop$2,
    releaseTouchMove: noop$2
  };

  if (typeof window === 'undefined') {
    return stub;
  }

  if (!('ontouchstart' in window)) {
    return stub;
  }

  var isBlocking = false;
  window.addEventListener('touchmove', function (event) {
    if (!isBlocking) {
      return;
    }

    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();
  }, {
    passive: false,
    capture: false
  });

  var preventTouchMove = function preventTouchMove() {
    isBlocking = true;
  };

  var releaseTouchMove = function releaseTouchMove() {
    isBlocking = false;
  };

  return {
    preventTouchMove: preventTouchMove,
    releaseTouchMove: releaseTouchMove
  };
}();

var initial = {
  isDragging: false,
  pending: null,
  hasMoved: false,
  longPressTimerId: null
};
var createTouchSensor = (function (_ref) {
  var callbacks = _ref.callbacks,
      getWindow = _ref.getWindow,
      canStartCapturing = _ref.canStartCapturing;
  var state = initial;

  var setState = function setState(partial) {
    state = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state, partial);
  };

  var isDragging = function isDragging() {
    return state.isDragging;
  };

  var isCapturing = function isCapturing() {
    return Boolean(state.pending || state.isDragging || state.longPressTimerId);
  };

  var schedule = createScheduler(callbacks);
  var postDragEventPreventer = createPostDragEventPreventer(getWindow);

  var startDragging = function startDragging() {
    var pending = state.pending;

    if (!pending) {
      kill();
       false ? invariant(false, 'cannot start a touch drag without a pending position') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false);
    }

    setState({
      isDragging: true,
      hasMoved: false,
      pending: null,
      longPressTimerId: null
    });
    callbacks.onLift({
      clientSelection: pending,
      autoScrollMode: 'FLUID'
    });
  };

  var stopDragging = function stopDragging(fn) {
    if (fn === void 0) {
      fn = noop$2;
    }

    schedule.cancel();
    touchStartMarshal.reset();
    webkitHack.releaseTouchMove();
    unbindWindowEvents();
    postDragEventPreventer.preventNext();
    setState(initial);
    fn();
  };

  var startPendingDrag = function startPendingDrag(event) {
    var touch = event.touches[0];
    var clientX = touch.clientX,
        clientY = touch.clientY;
    var point = {
      x: clientX,
      y: clientY
    };
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setState({
      longPressTimerId: longPressTimerId,
      pending: point,
      isDragging: false,
      hasMoved: false
    });
    bindWindowEvents();
  };

  var stopPendingDrag = function stopPendingDrag() {
    if (state.longPressTimerId) {
      clearTimeout(state.longPressTimerId);
    }

    schedule.cancel();
    touchStartMarshal.reset();
    webkitHack.releaseTouchMove();
    unbindWindowEvents();
    setState(initial);
  };

  var kill = function kill(fn) {
    if (fn === void 0) {
      fn = noop$2;
    }

    if (state.pending) {
      stopPendingDrag();
      return;
    }

    stopDragging(fn);
  };

  var unmount = function unmount() {
    kill();
    postDragEventPreventer.abort();
  };

  var cancel = function cancel() {
    kill(callbacks.onCancel);
  };

  var windowBindings = [{
    eventName: 'touchmove',
    options: {
      passive: false
    },
    fn: function fn(event) {
      if (!state.isDragging) {
        stopPendingDrag();
        return;
      }

      if (!state.hasMoved) {
        setState({
          hasMoved: true
        });
      }

      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      schedule.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      if (!state.isDragging) {
        stopPendingDrag();
        return;
      }

      event.preventDefault();
      stopDragging(callbacks.onDrop);
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (!state.isDragging) {
        stopPendingDrag();
        return;
      }

      event.preventDefault();
      stopDragging(callbacks.onCancel);
    }
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (state.pending) {
        stopPendingDrag();
        return;
      }

      schedule.windowScrollMove();
    }
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (!state.isDragging) {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      if (state.hasMoved) {
        event.preventDefault();
        return;
      }

      var touch = event.touches[0];

      if (touch.force >= forcePressThreshold) {
        cancel();
      }
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];

  var bindWindowEvents = function bindWindowEvents() {
    bindEvents(getWindow(), windowBindings, {
      capture: true
    });
  };

  var unbindWindowEvents = function unbindWindowEvents() {
    unbindEvents(getWindow(), windowBindings, {
      capture: true
    });
  };

  var onTouchStart = function onTouchStart(event) {
    if (touchStartMarshal.isHandled()) {
      return;
    }

    !!isCapturing() ?  false ? invariant(false, 'Should not be able to perform a touch start while a drag or pending drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    touchStartMarshal.handle();
    webkitHack.preventTouchMove();
    startPendingDrag(event);
  };

  var sensor = {
    onTouchStart: onTouchStart,
    kill: kill,
    isCapturing: isCapturing,
    isDragging: isDragging,
    unmount: unmount
  };
  return sensor;
});

var _DragHandle$contextTy;

var preventHtml5Dnd = function preventHtml5Dnd(event) {
  event.preventDefault();
};

var DragHandle = function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DragHandle, _Component);

  function DragHandle(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this;
    _this.mouseSensor = void 0;
    _this.keyboardSensor = void 0;
    _this.touchSensor = void 0;
    _this.sensors = void 0;
    _this.styleContext = void 0;
    _this.canLift = void 0;
    _this.isFocused = false;
    _this.lastDraggableRef = void 0;

    _this.onFocus = function () {
      _this.isFocused = true;
    };

    _this.onBlur = function () {
      _this.isFocused = false;
    };

    _this.onKeyDown = function (event) {
      if (_this.mouseSensor.isCapturing() || _this.touchSensor.isCapturing()) {
        return;
      }

      _this.keyboardSensor.onKeyDown(event);
    };

    _this.onMouseDown = function (event) {
      if (_this.keyboardSensor.isCapturing() || _this.mouseSensor.isCapturing()) {
        return;
      }

      _this.mouseSensor.onMouseDown(event);
    };

    _this.onTouchStart = function (event) {
      if (_this.mouseSensor.isCapturing() || _this.keyboardSensor.isCapturing()) {
        return;
      }

      _this.touchSensor.onTouchStart(event);
    };

    _this.canStartCapturing = function (event) {
      if (_this.isAnySensorCapturing()) {
        return false;
      }

      if (!_this.canLift(_this.props.draggableId)) {
        return false;
      }

      return shouldAllowDraggingFromTarget(event, _this.props);
    };

    _this.isAnySensorCapturing = function () {
      return _this.sensors.some(function (sensor) {
        return sensor.isCapturing();
      });
    };

    _this.getProvided = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (isEnabled) {
      if (!isEnabled) {
        return null;
      }

      var provided = {
        onMouseDown: _this.onMouseDown,
        onKeyDown: _this.onKeyDown,
        onTouchStart: _this.onTouchStart,
        onFocus: _this.onFocus,
        onBlur: _this.onBlur,
        tabIndex: 0,
        'data-react-beautiful-dnd-drag-handle': _this.styleContext,
        'aria-roledescription': 'Draggable item. Press space bar to lift',
        draggable: false,
        onDragStart: preventHtml5Dnd
      };
      return provided;
    });

    var getWindow = function getWindow() {
      return getWindowFromRef(_this.props.getDraggableRef());
    };

    var args = {
      callbacks: _this.props.callbacks,
      getDraggableRef: _this.props.getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: _this.canStartCapturing
    };
    _this.mouseSensor = createMouseSensor(args);
    _this.keyboardSensor = createKeyboardSensor(args);
    _this.touchSensor = createTouchSensor(args);
    _this.sensors = [_this.mouseSensor, _this.keyboardSensor, _this.touchSensor];
    _this.styleContext = context[styleContextKey];
    _this.canLift = context[canLiftContextKey];
    return _this;
  }

  var _proto = DragHandle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var draggableRef = this.props.getDraggableRef();
    this.lastDraggableRef = draggableRef;
    !draggableRef ?  false ? invariant(false, 'Cannot get draggable ref from drag handle') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!this.props.isEnabled) {
      return;
    }

    var dragHandleRef = getDragHandleRef(draggableRef);
    retainer.tryRestoreFocus(this.props.draggableId, dragHandleRef);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var ref = this.props.getDraggableRef();

    if (ref !== this.lastDraggableRef) {
      this.lastDraggableRef = ref;

      if (!ref || !this.isFocused) {
        return;
      }

      if (!this.props.isEnabled) {
        return;
      }

      getDragHandleRef(ref).focus();
    }

    var isCapturing = this.isAnySensorCapturing();

    if (!isCapturing) {
      return;
    }

    var isDragStopping = prevProps.isDragging && !this.props.isDragging;

    if (isDragStopping) {
      this.sensors.forEach(function (sensor) {
        if (sensor.isCapturing()) {
          sensor.kill();
        }
      });
    }

    if (this.props.isEnabled) {
      return;
    }

    this.sensors.forEach(function (sensor) {
      if (!sensor.isCapturing()) {
        return;
      }

      var wasDragging = sensor.isDragging();
      sensor.kill();

      if (wasDragging) {
        if (false) {
          console.warn('You have disabled dragging on a Draggable while it was dragging. The drag has been cancelled');
        }

        _this2.props.callbacks.onCancel();
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    this.sensors.forEach(function (sensor) {
      var wasDragging = sensor.isDragging();
      sensor.unmount();

      if (wasDragging) {
        _this3.props.callbacks.onCancel();
      }
    });

    var shouldRetainFocus = function () {
      if (!_this3.props.isEnabled) {
        return false;
      }

      if (!_this3.isFocused) {
        return false;
      }

      return _this3.props.isDragging || _this3.props.isDropAnimating;
    }();

    if (shouldRetainFocus) {
      retainer.retain(this.props.draggableId);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        isEnabled = _this$props.isEnabled;
    return children(this.getProvided(isEnabled));
  };

  return DragHandle;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

DragHandle.contextTypes = (_DragHandle$contextTy = {}, _DragHandle$contextTy[styleContextKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _DragHandle$contextTy[canLiftContextKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired, _DragHandle$contextTy);

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = document.documentElement;
  !doc ?  false ? invariant(false, 'Could not find document.documentElement') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = Object(__WEBPACK_IMPORTED_MODULE_2_css_box_model__["d" /* getRect */])({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: frame.width,
    height: frame.height
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var _Draggable$contextTyp;
var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getTranslate = function getTranslate(offset) {
  if (isEqual(offset, origin)) {
    return null;
  }

  return "translate(" + offset.x + "px, " + offset.y + "px)";
};

var getSpeed$1 = function getSpeed(isDragging, shouldAnimateDragMovement, isDropAnimating) {
  if (isDropAnimating) {
    return 'STANDARD';
  }

  if (isDragging && shouldAnimateDragMovement) {
    return 'FAST';
  }

  return 'INSTANT';
};

var Draggable = function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Draggable, _Component);

  function Draggable(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this;
    _this.callbacks = void 0;
    _this.styleContext = void 0;
    _this.ref = null;

    _this.onMoveEnd = function () {
      if (_this.props.isDropAnimating) {
        _this.props.dropAnimationFinished();
      }
    };

    _this.onLift = function (options) {
      start('LIFT');
      var ref = _this.ref;
      !ref ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      !!_this.props.isDragDisabled ?  false ? invariant(false, 'Cannot lift a Draggable when it is disabled') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
      var clientSelection = options.clientSelection,
          autoScrollMode = options.autoScrollMode;
      var _this$props = _this.props,
          lift = _this$props.lift,
          draggableId = _this$props.draggableId;
      var client = {
        selection: clientSelection,
        borderBoxCenter: getBorderBoxCenterPosition(ref),
        offset: origin
      };
      lift({
        id: draggableId,
        client: client,
        autoScrollMode: autoScrollMode,
        viewport: getViewport()
      });
      finish('LIFT');
    };

    _this.setRef = function (ref) {
      if (ref === null) {
        return;
      }

      if (ref === _this.ref) {
        return;
      }

      _this.ref = ref;
      throwIfRefIsInvalid(ref);
    };

    _this.getDraggableRef = function () {
      return _this.ref;
    };

    _this.getDraggingStyle = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (change, dimension, isDropAnimating) {
      var box = dimension.client;
      var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: 'none',
        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
        transform: getTranslate(change),
        pointerEvents: 'none'
      };
      return style;
    });
    _this.getNotDraggingStyle = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (current, shouldAnimateDisplacement) {
      var style = {
        transform: getTranslate(current),
        transition: shouldAnimateDisplacement ? null : 'none'
      };
      return style;
    });
    _this.getProvided = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (change, isDragging, isDropAnimating, shouldAnimateDisplacement, dimension, dragHandleProps) {
      var useDraggingStyle = isDragging || isDropAnimating;

      var draggableStyle = function () {
        if (!useDraggingStyle) {
          return _this.getNotDraggingStyle(change, shouldAnimateDisplacement);
        }

        !dimension ?  false ? invariant(false, 'draggable dimension required for dragging') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
        return _this.getDraggingStyle(change, dimension, isDropAnimating);
      }();

      var provided = {
        innerRef: _this.setRef,
        draggableProps: {
          'data-react-beautiful-dnd-draggable': _this.styleContext,
          style: draggableStyle
        },
        dragHandleProps: dragHandleProps
      };
      return provided;
    });
    _this.getSnapshot = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (isDragging, isDropAnimating, draggingOver) {
      return {
        isDragging: isDragging || isDropAnimating,
        isDropAnimating: isDropAnimating,
        draggingOver: draggingOver
      };
    });

    _this.renderChildren = function (change, dragHandleProps) {
      var _this$props2 = _this.props,
          isDragging = _this$props2.isDragging,
          isDropAnimating = _this$props2.isDropAnimating,
          dimension = _this$props2.dimension,
          draggingOver = _this$props2.draggingOver,
          shouldAnimateDisplacement = _this$props2.shouldAnimateDisplacement,
          children = _this$props2.children;
      var child = children(_this.getProvided(change, isDragging, isDropAnimating, shouldAnimateDisplacement, dimension, dragHandleProps), _this.getSnapshot(isDragging, isDropAnimating, draggingOver));
      var isDraggingOrDropping = isDragging || isDropAnimating;

      var placeholder = function () {
        if (!isDraggingOrDropping) {
          return null;
        }

        !dimension ?  false ? invariant(false, 'Draggable: Dimension is required for dragging') : Object(__WEBPACK_IMPORTED_MODULE_1_tiny_invariant__["a" /* default */])(false) : void 0;
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Placeholder, {
          placeholder: dimension.placeholder
        });
      }();

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, child, placeholder);
    };

    var callbacks = {
      onLift: _this.onLift,
      onMove: function onMove(clientSelection) {
        return props.move({
          client: clientSelection,
          shouldAnimate: false
        });
      },
      onDrop: function onDrop() {
        return props.drop({
          reason: 'DROP'
        });
      },
      onCancel: function onCancel() {
        return props.drop({
          reason: 'CANCEL'
        });
      },
      onMoveUp: props.moveUp,
      onMoveDown: props.moveDown,
      onMoveRight: props.moveRight,
      onMoveLeft: props.moveLeft,
      onWindowScroll: function onWindowScroll() {
        return props.moveByWindowScroll({
          scroll: getWindowScroll()
        });
      }
    };
    _this.callbacks = callbacks;
    _this.styleContext = context[styleContextKey];
    return _this;
  }

  var _proto = Draggable.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.ref = null;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        draggableId = _this$props3.draggableId,
        index = _this$props3.index,
        offset = _this$props3.offset,
        isDragging = _this$props3.isDragging,
        isDropAnimating = _this$props3.isDropAnimating,
        isDragDisabled = _this$props3.isDragDisabled,
        shouldAnimateDragMovement = _this$props3.shouldAnimateDragMovement,
        disableInteractiveElementBlocking = _this$props3.disableInteractiveElementBlocking;
    var droppableId = this.context[droppableIdKey];
    var type = this.context[droppableTypeKey];
    var speed = getSpeed$1(isDragging, shouldAnimateDragMovement, isDropAnimating);
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(DraggableDimensionPublisher, {
      key: draggableId,
      draggableId: draggableId,
      droppableId: droppableId,
      type: type,
      index: index,
      getDraggableRef: this.getDraggableRef
    }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Moveable, {
      speed: speed,
      destination: offset,
      onMoveEnd: this.onMoveEnd
    }, function (change) {
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(DragHandle, {
        draggableId: draggableId,
        isDragging: isDragging,
        isDropAnimating: isDropAnimating,
        isEnabled: !isDragDisabled,
        callbacks: _this2.callbacks,
        getDraggableRef: _this2.getDraggableRef,
        canDragInteractiveElements: disableInteractiveElementBlocking
      }, function (dragHandleProps) {
        return _this2.renderChildren(change, dragHandleProps);
      });
    }));
  };

  return Draggable;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Draggable.contextTypes = (_Draggable$contextTyp = {}, _Draggable$contextTyp[droppableIdKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _Draggable$contextTyp[droppableTypeKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _Draggable$contextTyp[styleContextKey] = __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired, _Draggable$contextTyp);

var defaultMapProps = {
  isDropAnimating: false,
  isDragging: false,
  offset: origin,
  shouldAnimateDragMovement: false,
  shouldAnimateDisplacement: true,
  dimension: null,
  draggingOver: null
};
var makeMapStateToProps$1 = function makeMapStateToProps() {
  var memoizedOffset = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getNotDraggingProps = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (offset, shouldAnimateDisplacement) {
    return {
      isDropAnimating: false,
      isDragging: false,
      offset: offset,
      shouldAnimateDisplacement: shouldAnimateDisplacement,
      shouldAnimateDragMovement: false,
      dimension: null,
      draggingOver: null
    };
  });
  var getDraggingProps = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["a" /* default */])(function (offset, shouldAnimateDragMovement, dimension, draggingOver) {
    return {
      isDragging: true,
      isDropAnimating: false,
      shouldAnimateDisplacement: false,
      offset: offset,
      shouldAnimateDragMovement: shouldAnimateDragMovement,
      dimension: dimension,
      draggingOver: draggingOver
    };
  });

  var getOutOfTheWayMovement = function getOutOfTheWayMovement(id, movement) {
    var map = getDisplacementMap(movement.displaced);
    var displacement = map[id];

    if (!displacement) {
      return null;
    }

    if (!displacement.isVisible) {
      return null;
    }

    var amount = movement.isBeyondStartPosition ? negate(movement.amount) : movement.amount;
    return getNotDraggingProps(memoizedOffset(amount.x, amount.y), displacement.shouldAnimate);
  };

  var draggingSelector = function draggingSelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var shouldAnimateDragMovement = state.shouldAnimate;
      var draggingOver = state.impact.destination ? state.impact.destination.droppableId : null;
      return getDraggingProps(memoizedOffset(offset.x, offset.y), shouldAnimateDragMovement, dimension, draggingOver);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var pending = state.pending;

      if (pending.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var _draggingOver = pending.result.destination ? pending.result.destination.droppableId : null;

      return {
        isDragging: false,
        isDropAnimating: true,
        offset: pending.newHomeOffset,
        dimension: state.dimensions.draggables[ownProps.draggableId],
        draggingOver: _draggingOver,
        shouldAnimateDragMovement: false,
        shouldAnimateDisplacement: false
      };
    }

    return null;
  };

  var movingOutOfTheWaySelector = function movingOutOfTheWaySelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getOutOfTheWayMovement(ownProps.draggableId, state.impact.movement);
    }

    if (state.phase === 'DROP_ANIMATING') {
      if (state.pending.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getOutOfTheWayMovement(ownProps.draggableId, state.pending.impact.movement);
    }

    return null;
  };

  var selector = function selector(state, ownProps) {
    var dragging = draggingSelector(state, ownProps);

    if (dragging) {
      return dragging;
    }

    var movingOutOfTheWay = movingOutOfTheWaySelector(state, ownProps);

    if (movingOutOfTheWay) {
      return movingOutOfTheWay;
    }

    return defaultMapProps;
  };

  return selector;
};
var mapDispatchToProps = {
  lift: lift,
  move: move,
  moveUp: moveUp,
  moveDown: moveDown,
  moveLeft: moveLeft,
  moveRight: moveRight,
  moveByWindowScroll: moveByWindowScroll,
  drop: drop,
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(makeMapStateToProps$1, mapDispatchToProps, null, {
  storeKey: storeKey,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);
ConnectedDraggable.defaultProps = {
  isDragDisabled: false,
  disableInteractiveElementBlocking: false
};




/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_assign_js__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_assign_js__);

function _extends() {
  return _extends = __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_assign_js___default.a ? __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_assign_js___default.a.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(147);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(891) });


/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(371);
var createDesc = __webpack_require__(375);
module.exports = __webpack_require__(86) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(86);
var getKeys = __webpack_require__(218);
var gOPS = __webpack_require__(900);
var pIE = __webpack_require__(381);
var toObject = __webpack_require__(382);
var IObject = __webpack_require__(376);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(151)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(217);
var toIObject = __webpack_require__(219);
var arrayIndexOf = __webpack_require__(894)(false);
var IE_PROTO = __webpack_require__(379)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 893 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(219);
var toLength = __webpack_require__(895);
var toAbsoluteIndex = __webpack_require__(896);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(378);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(378);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(69);
var global = __webpack_require__(148);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(898) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 899 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 900 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createBox; });
/* unused harmony export expand */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRect; });
/* unused harmony export offset */
/* unused harmony export shrink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return withScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_invariant__ = __webpack_require__(175);


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : Object(__WEBPACK_IMPORTED_MODULE_0_tiny_invariant__["a" /* default */])(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};




/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(903);

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(904);
module.exports = __webpack_require__(69).Object.keys;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(382);
var $keys = __webpack_require__(218);

__webpack_require__(905)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(147);
var core = __webpack_require__(69);
var fails = __webpack_require__(151);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(369);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ __webpack_exports__["a"] = (rafSchd);


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_create_js__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__ = __webpack_require__(915);


function _inheritsLoose(t, o) {
  t.prototype = __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_create_js___default()(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(911);
var $Object = __webpack_require__(69).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(147);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(912) });


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(149);
var dPs = __webpack_require__(913);
var enumBugKeys = __webpack_require__(380);
var IE_PROTO = __webpack_require__(379)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(373)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(914).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(371);
var anObject = __webpack_require__(149);
var getKeys = __webpack_require__(218);

module.exports = __webpack_require__(86) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(148).document;
module.exports = document && document.documentElement;


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_set_prototype_of_js__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_set_prototype_of_js__);

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_set_prototype_of_js___default.a ? __WEBPACK_IMPORTED_MODULE_0_core_js_library_fn_object_set_prototype_of_js___default.a.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(917);
module.exports = __webpack_require__(69).Object.setPrototypeOf;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(147);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(918).set });


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(150);
var anObject = __webpack_require__(149);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(370)(Function.call, __webpack_require__(919).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(381);
var createDesc = __webpack_require__(375);
var toIObject = __webpack_require__(219);
var toPrimitive = __webpack_require__(374);
var has = __webpack_require__(217);
var IE8_DOM_DEFINE = __webpack_require__(372);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(86) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(220);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(152);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(221);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(222);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(223);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(224);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(384)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(220);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(152);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(221);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(222);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(223);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(224);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(220);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(152);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(221);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(924);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(222);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(223);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(224);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(385);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_fieldsPageUtils__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManagedUploadField=function(_Component){_inherits(ManagedUploadField,_Component);function ManagedUploadField(){_classCallCheck(this,ManagedUploadField);var _this=_possibleConstructorReturn(this,(ManagedUploadField.__proto__||Object.getPrototypeOf(ManagedUploadField)).call(this));_this.handleCheckboxClick=_this.handleCheckboxClick.bind(_this);_this.handleDoubleClick=_this.handleDoubleClick.bind(_this);return _this;}_createClass(ManagedUploadField,[{key:'handleCheckboxClick',value:function handleCheckboxClick(){var id=this.props.field.fieldDefinition.id;this.props.onRequiredClick(id);}},{key:'handleDoubleClick',value:function handleDoubleClick(){var _props=this.props,id=_props.field.fieldDefinition.id,onDoubleClick=_props.onDoubleClick;onDoubleClick(id);}},{key:'render',value:function render(){var _props2=this.props,disabled=_props2.disabled,_props2$field=_props2.field,fieldDefinition=_props2$field.fieldDefinition,required=_props2$field.required,intl=_props2.intl;var id='uploadField-'+fieldDefinition.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns',onDoubleClick:this.handleDoubleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:required,className:'is-checkradio',disabled:disabled,id:id,onChange:this.handleCheckboxClick,type:'checkbox','data-test-name':'field-isRequired'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{marginRight:0,paddingRight:0},htmlFor:id})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-three-quarters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''+(disabled?'has-text-grey':'has-text-grey-darker'),'data-test-name':'display-name'},Object(__WEBPACK_IMPORTED_MODULE_2_util_fieldsPageUtils__["q" /* displayNameForField */])(intl,fieldDefinition.systemName))));}}]);return ManagedUploadField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(ManagedUploadField));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_fieldsPageUtils__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Field=function(_Component){_inherits(Field,_Component);function Field(){_classCallCheck(this,Field);var _this=_possibleConstructorReturn(this,(Field.__proto__||Object.getPrototypeOf(Field)).call(this));_this.handleDoubleClick=_this.handleDoubleClick.bind(_this);return _this;}_createClass(Field,[{key:'handleDoubleClick',value:function handleDoubleClick(){var _props=this.props,id=_props.fieldDef.id,onDoubleClick=_props.onDoubleClick;onDoubleClick(id);}},{key:'render',value:function render(){var _props2=this.props,fieldDef=_props2.fieldDef,intl=_props2.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onDoubleClick:this.handleDoubleClick},Object(__WEBPACK_IMPORTED_MODULE_2_util_fieldsPageUtils__["q" /* displayNameForField */])(intl,fieldDef.systemName));}}]);return Field;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(Field));

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_BrowseServerFoldersDialog__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MIN_DIMENSION=300;var MAX_DIMENSION=4000;var MIN_DURATION=1;var MAX_DURATION=180;var AV_RES=[{key:'360p',value:360},{key:'480p',value:480},{key:'540p HD',value:540},{key:'720p HD',value:720},{key:'1080p HD',value:1080}];var CatalogPreviewsForm=function(_Component){_inherits(CatalogPreviewsForm,_Component);function CatalogPreviewsForm(){_classCallCheck(this,CatalogPreviewsForm);var _this=_possibleConstructorReturn(this,(CatalogPreviewsForm.__proto__||Object.getPrototypeOf(CatalogPreviewsForm)).call(this));_this.handleBrowsePreviewsFolder=_this.handleBrowsePreviewsFolder.bind(_this);_this.initializeFields=_this.initializeFields.bind(_this);_this.submit=_this.submit.bind(_this);_this.handlePreviewFolderPathSelected=_this.handlePreviewFolderPathSelected.bind(_this);return _this;}_createClass(CatalogPreviewsForm,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.catalog){this.props.getCatalogPropertiesAction(this.props.catalog.catalogId,[__WEBPACK_IMPORTED_MODULE_8_util_constants__["l" /* CATALOG_PROPERTY_KEY */].DISK_PREVIEW_INFO,__WEBPACK_IMPORTED_MODULE_8_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.diskPreviewInfo!==nextProps.diskPreviewInfo){this.initializeFields(nextProps.diskPreviewInfo);}}},{key:'initializeFields',value:function initializeFields(diskPreviewInfo){this.props.initialize(diskPreviewInfo);}},{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(values){var _props,catalog,formatMessage,updateDiskPreviewInfo,audioVideoPreviewsEnabled,enabled,jpegCompression,limitVideoDurationEnabled,maxDimension,maxVideoDuration,maxVideoResolution,path,dpi,successMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,catalog=_props.catalog,formatMessage=_props.intl.formatMessage,updateDiskPreviewInfo=_props.updateDiskPreviewInfo;audioVideoPreviewsEnabled=values.audioVideoPreviewsEnabled,enabled=values.enabled,jpegCompression=values.jpegCompression,limitVideoDurationEnabled=values.limitVideoDurationEnabled,maxDimension=values.maxDimension,maxVideoDuration=values.maxVideoDuration,maxVideoResolution=values.maxVideoResolution,path=values.path;dpi={audioVideoPreviewsEnabled:audioVideoPreviewsEnabled,enabled:enabled,jpegCompression:jpegCompression,limitVideoDurationEnabled:limitVideoDurationEnabled,maxDimension:maxDimension,maxVideoDuration:maxVideoDuration,maxVideoResolution:maxVideoResolution,path:path};successMessage=formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE);_context.next=6;return updateDiskPreviewInfo(catalog.catalogId,dpi,successMessage);case 6:case'end':return _context.stop();}}},_callee,this);}));function submit(_x){return _ref.apply(this,arguments);}return submit;}()},{key:'handleBrowsePreviewsFolder',value:function handleBrowsePreviewsFolder(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_8_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]);}},{key:'handlePreviewFolderPathSelected',value:function handlePreviewFolderPathSelected(selectedPath){this.props.change('path',selectedPath);}},{key:'render',value:function render(){var _props2=this.props,diskPreviewInfo=_props2.diskPreviewInfo,handleSubmit=_props2.handleSubmit,formatMessage=_props2.intl.formatMessage,invalid=_props2.invalid,pristine=_props2.pristine,reset=_props2.reset;return!diskPreviewInfo?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portfolio-form-container page-contents-textured','data-test-name':'catalog-preview-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_App_DialogPanels_BrowseServerFoldersDialog__["a" /* default */],{onPathSelected:this.handlePreviewFolderPathSelected}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{width:'700px'},onSubmit:handleSubmit(this.submit)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_MAX_PIXELS)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-expanded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'input',component:'input',id:'maxDimension',max:MAX_DIMENSION,min:MIN_DIMENSION,name:'maxDimension',style:{width:'100px'},type:'number'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-static'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_PIXELS)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'help'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_DIMENSIONS_LABEL)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__["a" /* default */],id:'audioVideoPreviewsEnabled',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES),name:'audioVideoPreviewsEnabled',type:'checkbox'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-indented'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'maxVideoResolution',name:'maxVideoResolution'},AV_RES.map(function(res){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:res.key,value:res.value,'data-test-name':'max-video-resolution-option'},res.key);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-indented'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_view_Forms_BulmaCheckRadio__["a" /* default */],id:'limitVideoDurationEnabled',label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION),name:'limitVideoDurationEnabled',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field has-addons',style:{marginTop:'5px',marginLeft:'0.5rem'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'input',component:'input',id:'maxVideoDuration',max:MAX_DURATION,min:MIN_DURATION,name:'maxVideoDuration',style:{width:'100px'},type:'number'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-static'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_MINUTES))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'help'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',alignItems:'baseline'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_PREVIEWS_FOLDER_LOCATION)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-text',onClick:this.handleBrowsePreviewsFolder,'data-test-name':'browser-for-previews-folder'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].BROWSE))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},this.props.path)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:pristine,onClick:reset,type:'button','data-test-name':'reset'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button is-primary',type:'submit',disabled:pristine|invalid,'data-test-name':'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].APPLY)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'}))));}}]);return CatalogPreviewsForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function validate(data,props){var errors={};if(data.maxDimension<MIN_DIMENSION||data.maxDimension>MAX_DIMENSION){errors.maxDimension='Invalid';}if(data.maxVideoDuration<MIN_DURATION||data.maxVideoDuration>MAX_DIMENSION){errors.maxVideoDuration='Invalid';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({destroyOnUnmount:false,form:'CatalogPreviewsForm',validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(CatalogPreviewsForm));var previewsFormSelector=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])('CatalogPreviewsForm');/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{diskPreviewInfo:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["A" /* getDiskPreviewInfo */])(state),path:previewsFormSelector(state,'path')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__["a" /* bindActionCreatorsForm */])({getCatalogPropertiesAction:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["l" /* getCatalogProperties */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_11_state_commands_dialogPanelCommands__["b" /* showDialogPanel */],updateDiskPreviewInfo:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["D" /* updateDiskPreviewInfo */]});})(form));

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SmartKeywordsEngineSettingsRow__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BulmaSlider__ = __webpack_require__(386);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SK_ENGINE_GENERAL='SK_ENGINE_GENERAL';var SK_ENGINE_TRAVEL='SK_ENGINE_TRAVEL';var SK_ENGINE_FOOD='SK_ENGINE_FOOD';var SK_ENGINE_WEDDINGS='SK_ENGINE_WEDDINGS';var SK_ENGINE_NSFW='SK_ENGINE_NSFW';var SK_ENGINE_CELEBRITIES='SK_ENGINE_CELEBRITIES';var SK_ENGINE_APPAREL='SK_ENGINE_APPAREL';var SK_ENGINE_LOGO='SK_ENGINE_LOGO';var SK_ENGINE_MODERATION='SK_ENGINE_MODERATION';var SK_ENGINE_ART_STYLE='SK_ENGINE_ART_STYLE';var SK_ENGINE_ART_MOVEMENT='SK_ENGINE_ART_MOVEMENT';var SK_ENGINE_ART_SUBJECT='SK_ENGINE_ART_SUBJECT';var skLanguages=[{locale:'en',label:'English'},{locale:'fr',label:'French'},{locale:'de',label:'German'},{locale:'es',label:'Spanish'},{locale:'it',label:'Italian'},{locale:'ja',label:'Japanese'},{locale:'ar',label:'Arabic'},{locale:'bn',label:'Bengali'},{locale:'da',label:'Danish'},{locale:'fi',label:'Finnish'},{locale:'hi',label:'Hindi'},{locale:'hu',label:'Hungarian'},{locale:'ko',label:'Korean'},{locale:'nl',label:'Dutch'},{locale:'no',label:'Norwegian'},{locale:'pa',label:'Punjabi'},{locale:'pl',label:'Polish'},{locale:'pt',label:'Portuguese'},{locale:'ru',label:'Russian'},{locale:'sv',label:'Swedish'},{locale:'tr',label:'Turkish'},{locale:'zh',label:'Chinese Simplified'},{locale:'zh-TW',label:'Chinese Traditional'}];var skEngines=[{token:SK_ENGINE_GENERAL},{token:SK_ENGINE_TRAVEL},{token:SK_ENGINE_FOOD},{token:SK_ENGINE_WEDDINGS},{token:SK_ENGINE_NSFW},{token:SK_ENGINE_CELEBRITIES},{token:SK_ENGINE_APPAREL},{token:SK_ENGINE_LOGO},{token:SK_ENGINE_MODERATION},{token:SK_ENGINE_ART_STYLE},{token:SK_ENGINE_ART_MOVEMENT},{token:SK_ENGINE_ART_SUBJECT}];var CatalogSmartKeywordsPage=function(_Component){_inherits(CatalogSmartKeywordsPage,_Component);function CatalogSmartKeywordsPage(){_classCallCheck(this,CatalogSmartKeywordsPage);var _this=_possibleConstructorReturn(this,(CatalogSmartKeywordsPage.__proto__||Object.getPrototypeOf(CatalogSmartKeywordsPage)).call(this));_this.handleChangeEngineCheckbox=_this.handleChangeEngineCheckbox.bind(_this);_this.handleChangeLanguageCheckbox=_this.handleChangeLanguageCheckbox.bind(_this);_this.handleChangeSlider=_this.handleChangeSlider.bind(_this);_this.handleChangeTopLevelCheckbox=_this.handleChangeTopLevelCheckbox.bind(_this);_this.updateSettings=_this.updateSettings.bind(_this);return _this;}_createClass(CatalogSmartKeywordsPage,[{key:'componentDidMount',value:function componentDidMount(){var catalog=this.props.catalog;if(catalog){this.props.getCatalogPropertiesCommand(catalog.catalogId,[__WEBPACK_IMPORTED_MODULE_6_util_constants__["l" /* CATALOG_PROPERTY_KEY */].SMART_KEYWORDS_SETTINGS,__WEBPACK_IMPORTED_MODULE_6_util_constants__["l" /* CATALOG_PROPERTY_KEY */].CATALOG_DETAILS]);}}},{key:'handleChangeTopLevelCheckbox',value:function handleChangeTopLevelCheckbox(e){var _props=this.props,catalog=_props.catalog,smartKeywordsSettings=_props.smartKeywordsSettings;var id=e.currentTarget.id;if(smartKeywordsSettings){this.props.updateSmartKeywordsSettings(catalog.catalogId,Object.assign({},smartKeywordsSettings,_defineProperty({},id,!smartKeywordsSettings[id])));}}},{key:'handleChangeEngineCheckbox',value:function handleChangeEngineCheckbox(e){var _props2=this.props,catalog=_props2.catalog,smartKeywordsSettings=_props2.smartKeywordsSettings;var _e$currentTarget=e.currentTarget,id=_e$currentTarget.id,checked=_e$currentTarget.checked;if(smartKeywordsSettings){this.props.updateSmartKeywordsSettings(catalog.catalogId,Object.assign({},smartKeywordsSettings,{engines:checked?[].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(smartKeywordsSettings.engines),[id])))):smartKeywordsSettings.engines.filter(function(engine){return engine!==id;})}));}}},{key:'handleChangeLanguageCheckbox',value:function handleChangeLanguageCheckbox(e){var smartKeywordsSettings=this.props.smartKeywordsSettings;var _e$currentTarget2=e.currentTarget,id=_e$currentTarget2.id,checked=_e$currentTarget2.checked;if(smartKeywordsSettings){this.updateSettings(Object.assign({},smartKeywordsSettings,{languages:checked?[].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(smartKeywordsSettings.languages),[id])))):smartKeywordsSettings.languages.filter(function(language){return language!==id;})}));}}},{key:'handleChangeSlider',value:function handleChangeSlider(value,id){var smartKeywordsSettings=this.props.smartKeywordsSettings;if(smartKeywordsSettings){if(id===__WEBPACK_IMPORTED_MODULE_6_util_constants__["r" /* CONFIDENCE_LEVEL */]){value/=100;}this.updateSettings(Object.assign({},smartKeywordsSettings,_defineProperty({},id,value)));}}},{key:'updateSettings',value:function updateSettings(smartKeywordsSettings){var _props3=this.props,catalog=_props3.catalog,updateSmartKeywordsSettings=_props3.updateSmartKeywordsSettings;updateSmartKeywordsSettings(catalog.catalogId,smartKeywordsSettings);}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,intl=_props4.intl,formatMessage=_props4.intl.formatMessage,smartKeywordsSettings=_props4.smartKeywordsSettings;var _ref=smartKeywordsSettings&&[smartKeywordsSettings.enabled,smartKeywordsSettings.smartKeywordOnCataloging,smartKeywordsSettings.numKeywords,smartKeywordsSettings.confidenceLevel*100,smartKeywordsSettings.languages]||[false,false,1,1,[]],_ref2=_slicedToArray(_ref,5),enabled=_ref2[0],smartKeywordOnCataloging=_ref2[1],numKeywords=_ref2[2],confidenceLevel=_ref2[3],languages=_ref2[4];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container is-textured','data-test-name':'catalog-smart-keywords-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'is-checkradio is-medium','data-test-name':'enabled-checkbox',id:'enabled',type:'checkbox',checked:enabled,onChange:this.handleChangeTopLevelCheckbox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'enabled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_USE_SK_LABEL)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'is-checkradio','data-test-name':'smart-keyword-on-cataloging',disabled:!enabled,id:'smartKeywordOnCataloging',type:'checkbox',checked:smartKeywordOnCataloging,onChange:this.handleChangeTopLevelCheckbox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'smartKeywordOnCataloging'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_ON_CATALOGING_LABEL)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_DEFAULT_SETTINGS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_NUM_KEYWORDS_LABEL),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_DEFAULT_LABEL,{values:{recommended:'7'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-small','data-test-name':'default-num-keywords'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BulmaSlider__["a" /* default */],{disabled:!enabled,id:__WEBPACK_IMPORTED_MODULE_6_util_constants__["S" /* NUM_KEYWORDS */],initialValue:numKeywords,min:1,max:20,onChange:this.handleChangeSlider})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_CONFIDENCE_LEVEL_LABEL),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_DEFAULT_LABEL,{values:{recommended:'87'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-small','data-test-name':'default-confidence-level'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BulmaSlider__["a" /* default */],{disabled:!enabled,id:__WEBPACK_IMPORTED_MODULE_6_util_constants__["r" /* CONFIDENCE_LEVEL */],initialValue:confidenceLevel,onChange:this.handleChangeSlider,min:1,max:100}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-divider','data-content':formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_ENGINES_LABEL)}),smartKeywordsSettings&&skEngines.map(function(engine){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SmartKeywordsEngineSettingsRow__["a" /* default */],{engine:engine,handleChangeEngineCheckbox:_this2.handleChangeEngineCheckbox,intl:intl,key:'engine-settings-'+engine.token,smartKeywordsSettings:smartKeywordsSettings,updateSettings:_this2.updateSettings});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-divider','data-content':formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CATALOG_SK_LANGUAGES_LABEL)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},skLanguages.map(function(language){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:language.locale},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'is-checkradio is-small','data-test-name':'skLocale-'+language.label,disabled:!enabled,id:language.locale,type:'checkbox',checked:languages.includes(language.locale),onChange:_this2.handleChangeLanguageCheckbox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:language.locale},language.label));}))))));}}]);return CatalogSmartKeywordsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{smartKeywordsSettings:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_29" /* getSmartKeywordsSettings */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getCatalogPropertiesCommand:__WEBPACK_IMPORTED_MODULE_4_state_commands_catalogCommands__["l" /* getCatalogProperties */],updateSmartKeywordsSettings:__WEBPACK_IMPORTED_MODULE_4_state_commands_catalogCommands__["G" /* updateSmartKeywordsSettings */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(CatalogSmartKeywordsPage)));

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BulmaSlider__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SmartKeywordsEngineSettingsRow=function(_Component){_inherits(SmartKeywordsEngineSettingsRow,_Component);function SmartKeywordsEngineSettingsRow(){_classCallCheck(this,SmartKeywordsEngineSettingsRow);var _this=_possibleConstructorReturn(this,(SmartKeywordsEngineSettingsRow.__proto__||Object.getPrototypeOf(SmartKeywordsEngineSettingsRow)).call(this));_this.handleChangeSlider=_this.handleChangeSlider.bind(_this);_this.getValueForSlider=_this.getValueForSlider.bind(_this);return _this;}_createClass(SmartKeywordsEngineSettingsRow,[{key:'getValueForSlider',value:function getValueForSlider(key){var _props=this.props,engine=_props.engine,smartKeywordsSettings=_props.smartKeywordsSettings;var result=0;if(smartKeywordsSettings.engineSettings){var engineSpecificSettings=smartKeywordsSettings.engineSettings.find(function(es){return es.name===engine.token;});if(engineSpecificSettings&&engineSpecificSettings[key]){result=engineSpecificSettings[key];}}result=result||smartKeywordsSettings[key];if(key===__WEBPACK_IMPORTED_MODULE_2_util_constants__["r" /* CONFIDENCE_LEVEL */]){result*=100;}return result;}},{key:'handleChangeSlider',value:function handleChangeSlider(value,id){var _props2=this.props,engine=_props2.engine,smartKeywordsSettings=_props2.smartKeywordsSettings,updateSettings=_props2.updateSettings;id=id.split(':')[0];if(id===__WEBPACK_IMPORTED_MODULE_2_util_constants__["r" /* CONFIDENCE_LEVEL */]){value/=100;}var newSettings=Object.assign({},smartKeywordsSettings);// we might need to create the engineSettings array
if(!newSettings.engineSettings){newSettings.engineSettings=[];}// we might need to create a new engine-specific settings object
var indexOfEngineSettings=newSettings.engineSettings.findIndex(function(es){return es.name===engine.token;});if(indexOfEngineSettings===-1){newSettings.engineSettings.push(_defineProperty({name:engine.token},id,value));}else{newSettings.engineSettings[indexOfEngineSettings][id]=value;}updateSettings(newSettings);}},{key:'render',value:function render(){var _props3=this.props,engine=_props3.engine,handleChangeEngineCheckbox=_props3.handleChangeEngineCheckbox,smartKeywordsSettings=_props3.smartKeywordsSettings;var enginesEnabled=smartKeywordsSettings.engines;var enabled=smartKeywordsSettings.enabled;var numKeywords=this.getValueForSlider(__WEBPACK_IMPORTED_MODULE_2_util_constants__["S" /* NUM_KEYWORDS */]);var confidenceLevel=this.getValueForSlider(__WEBPACK_IMPORTED_MODULE_2_util_constants__["r" /* CONFIDENCE_LEVEL */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns',key:engine.token},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field',style:{minHeight:'40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'is-checkradio','data-test-name':'skEngine-'+engine.token,disabled:!enabled,id:engine.token,type:'checkbox',checked:enginesEnabled.includes(engine.token),onChange:handleChangeEngineCheckbox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:engine.token},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */][engine.token]))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},enginesEnabled.includes(engine.token)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BulmaSlider__["a" /* default */],{disabled:!enabled,id:__WEBPACK_IMPORTED_MODULE_2_util_constants__["S" /* NUM_KEYWORDS */]+':'+engine.token,initialValue:numKeywords,min:1,max:20,onChange:this.handleChangeSlider})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},enginesEnabled.includes(engine.token)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BulmaSlider__["a" /* default */],{disabled:!enabled,id:__WEBPACK_IMPORTED_MODULE_2_util_constants__["r" /* CONFIDENCE_LEVEL */]+':'+engine.token,initialValue:confidenceLevel,onChange:this.handleChangeSlider,min:1,max:100})));}}]);return SmartKeywordsEngineSettingsRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SmartKeywordsEngineSettingsRow);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_reducers_catalogReducer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_userCommands__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_roleCommands__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_userUtils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_tableUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UserRolePicker__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConfirmUserRoleChangeDialog__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_view_App_MultipleSelectionTable__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getUserCatalogInfoAction=__WEBPACK_IMPORTED_MODULE_8_state_reducers_catalogReducer__["a" /* actions */].getUserCatalogInfo;var iconWidth=35;var connectedWidth=120;var roleWidth=180;var CatalogUsersPage=function(_Component){_inherits(CatalogUsersPage,_Component);function CatalogUsersPage(){_classCallCheck(this,CatalogUsersPage);var _this=_possibleConstructorReturn(this,(CatalogUsersPage.__proto__||Object.getPrototypeOf(CatalogUsersPage)).call(this));_this.state={selectionState:Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["d" /* getNewSelectionState */])(),sortDirection:__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["g" /* SortDirection */].ASC,sortBy:'name',sortedUsers:[]};_this.confirmDialogCallback=_this.confirmDialogCallback.bind(_this);_this.handleChangeRole=_this.handleChangeRole.bind(_this);_this.handleSelectionChanged=_this.handleSelectionChanged.bind(_this);_this.sort=_this.sort.bind(_this);_this.userConnectedCellRenderer=_this.userConnectedCellRenderer.bind(_this);_this.userRoleCellRenderer=_this.userRoleCellRenderer.bind(_this);_this.userTypeCellRenderer=_this.userTypeCellRenderer.bind(_this);return _this;}_createClass(CatalogUsersPage,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,catalog=_props.catalog,identitySession=_props.identitySession;this.props.getUserCatalogInfoAction(identitySession,catalog.name);this.props.getUsersAction();this.props.getRolesAction();}},{key:'mergeUserCatInfo',value:function mergeUserCatInfo(users,userCatalogInfo){return users.map(function(user){var userCatInfo=userCatalogInfo.find(function(info){return info.accountName===user.name;});if(userCatInfo){return Object.assign({},user,{roleName:userCatInfo.roleName,userStatus:userCatInfo.userStatus});}else return Object.assign({},user,{roleName:''});});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.userCatalogInfo!==nextProps.userCatalogInfo){// Merge membership info into user list
var _sortedUsers=Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["e" /* sortUsers */])(this.mergeUserCatInfo(nextProps.users,nextProps.userCatalogInfo),this.state.sortBy,this.state.sortDirection);this.setState({sortedUsers:_sortedUsers});}}},{key:'handleSelectionChanged',value:function handleSelectionChanged(selectionState){this.setState({selectionState:selectionState});}},{key:'userTypeCellRenderer',value:function userTypeCellRenderer(_ref){var cellData=_ref.cellData,columnData=_ref.columnData,columnIndex=_ref.columnIndex,dataKey=_ref.dataKey,isScrolling=_ref.isScrolling,rowData=_ref.rowData,rowIndex=_ref.rowIndex;return Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["d" /* renderUserType */])(rowData,rowIndex,this.state.selectionState);}},{key:'userConnectedCellRenderer',value:function userConnectedCellRenderer(_ref2){var cellData=_ref2.cellData,columnData=_ref2.columnData,columnIndex=_ref2.columnIndex,dataKey=_ref2.dataKey,isScrolling=_ref2.isScrolling,rowData=_ref2.rowData,rowIndex=_ref2.rowIndex,style=_ref2.style;if(rowData.userStatus===__WEBPACK_IMPORTED_MODULE_14_util_constants__["m" /* CATALOG_STATUS */].ONLINE){var selectionContribution=Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["f" /* isItemAtIndexSelected */])(rowIndex,this.state.selectionState)?'-selected':' has-text-primary';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check pseudo-table-icon'+selectionContribution,style:style});}}},{key:'handleChangeRole',value:function handleChangeRole(user,roleName){var loggedInUserName=this.props.loggedInUserName;var _state=this.state,selectionState=_state.selectionState,sortedUsers=_state.sortedUsers;// filter out the admin user or logged in user from the affectedUsersCount
var selectedUsersCount=Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["e" /* getSelectedIndices */])(selectionState).map(function(idx){return sortedUsers[idx];}).filter(function(u){return!Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["c" /* isAdminUser */])(u)&&!Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["a" /* doesUserMatchUserName */])(u,loggedInUserName);}).length;this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_14_util_constants__["s" /* CONFIRM_USER_ROLE_CHANGE_PANEL_ID */],{affectedUsersCount:Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["g" /* isItemWithIdSelected */])(user.uuid,selectionState)&&selectedUsersCount||1,user:user,roleName:roleName});}},{key:'userRoleCellRenderer',value:function userRoleCellRenderer(_ref3){var cellData=_ref3.cellData,columnData=_ref3.columnData,columnIndex=_ref3.columnIndex,dataKey=_ref3.dataKey,isScrolling=_ref3.isScrolling,rowData=_ref3.rowData,rowIndex=_ref3.rowIndex,style=_ref3.style;var _props2=this.props,loggedInUserName=_props2.loggedInUserName,roles=_props2.roles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__UserRolePicker__["a" /* default */],{loggedInUserName:loggedInUserName,onChangeRole:this.handleChangeRole,roles:roles,user:rowData});}},{key:'sort',value:function sort(_ref4){var sortBy=_ref4.sortBy,sortDirection=_ref4.sortDirection;var sortedUsers=Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["e" /* sortUsers */])(this.mergeUserCatInfo(this.props.users,this.props.userCatalogInfo),sortBy,sortDirection);this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["h" /* reindexSelectedItems */])(sortedUsers,this.state.selectionState),sortBy:sortBy,sortDirection:sortDirection,sortedUsers:sortedUsers});}},{key:'confirmDialogCallback',value:function confirmDialogCallback(data){var user=data.user,roleName=data.roleName;var _props3=this.props,catalog=_props3.catalog,loggedInUserName=_props3.loggedInUserName;var _state2=this.state,selectionState=_state2.selectionState,sortedUsers=_state2.sortedUsers;if(roleName){var userInfo=void 0;if(Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["g" /* isItemWithIdSelected */])(user.uuid,selectionState)){userInfo=Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["e" /* getSelectedIndices */])(selectionState).map(function(idx){return sortedUsers[idx];}).filter(function(u){return!Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["c" /* isAdminUser */])(u)&&!Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["a" /* doesUserMatchUserName */])(u,loggedInUserName);}).map(function(u){return{accountName:u.name,roleName:roleName,catalogName:catalog.name};});}else{userInfo=[{accountName:user.name,roleName:roleName,catalogName:catalog.name}];}this.props.addOrUpdateUserCatalogInfo(userInfo,catalog.name);}else{var usernames=void 0;// If the user is in the current selection, change all users in the selection.
if(Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["g" /* isItemWithIdSelected */])(user.uuid,selectionState)){usernames=Object(__WEBPACK_IMPORTED_MODULE_12_util_tableUtils__["e" /* getSelectedIndices */])(selectionState).map(function(idx){return sortedUsers[idx];}).filter(function(u){return!Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["c" /* isAdminUser */])(u)&&!Object(__WEBPACK_IMPORTED_MODULE_11_util_userUtils__["a" /* doesUserMatchUserName */])(u,loggedInUserName);}).map(function(u){return u.name;});}else{usernames=[user.name];}this.props.removeUsersFromCatalog(catalog.name,usernames);}}},{key:'render',value:function render(){var _this2=this;var formatMessage=this.props.intl.formatMessage;var _state3=this.state,selectionState=_state3.selectionState,sortBy=_state3.sortBy,sortDirection=_state3.sortDirection,sortedUsers=_state3.sortedUsers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'catalog-user-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ConfirmUserRoleChangeDialog__["a" /* default */],{callback:this.confirmDialogCallback}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["b" /* AutoSizer */],null,function(_ref5){var height=_ref5.height,width=_ref5.width;var leftoverWidth=width-(iconWidth+connectedWidth+roleWidth);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_view_App_MultipleSelectionTable__["a" /* default */],{headerHeight:40,height:height,onSelectionChanged:_this2.handleSelectionChanged,rowHeight:30,selectionState:selectionState,sort:_this2.sort,sortBy:sortBy,sortDirection:sortDirection,sortedItems:sortedUsers,width:width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{cellRenderer:_this2.userTypeCellRenderer,dataKey:'fromLDAP',width:iconWidth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'name',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].USER_ACCOUNT),width:leftoverWidth/2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'longName',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].FULL_NAME),width:leftoverWidth/2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{cellRenderer:_this2.userRoleCellRenderer,className:'list-item',dataKey:'roleName',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].USER_ROLE),width:roleWidth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{cellRenderer:_this2.userConnectedCellRenderer,dataKey:'userStatus',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CATALOG_IS_CONNECTED),width:connectedWidth}));}));}}]);return CatalogUsersPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{identitySession:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["L" /* getIdentitySession */])(state),loggedInUserName:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_33" /* getUsername */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_15" /* getRoles */])(state),userCatalogInfo:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_32" /* getUserCatalogInfo */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_34" /* getUsers */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addOrUpdateUserCatalogInfo:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["c" /* addOrUpdateUserCatalogInfo */],getRolesAction:__WEBPACK_IMPORTED_MODULE_10_state_commands_roleCommands__["c" /* getRoles */],getUserCatalogInfoAction:getUserCatalogInfoAction,getUsersAction:__WEBPACK_IMPORTED_MODULE_9_state_commands_userCommands__["c" /* getUsers */],removeUsersFromCatalog:__WEBPACK_IMPORTED_MODULE_6_state_commands_catalogCommands__["v" /* removeUsersFromCatalog */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_15_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(CatalogUsersPage)));

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_USERS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_USERS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_USER_SUCCESS; });
var GET_USERS='admin/users/GET_USERS';var GET_USERS_FAIL='admin/users/GET_USERS_FAIL';var GET_USERS_SUCCESS='admin/users/GET_USERS_SUCCESS';var UPDATE_USER='admin/users/UPDATE_USER';var UPDATE_USER_FAIL='admin/users/UPDATE_USER_FAIL';var UPDATE_USER_SUCCESS='admin/users/UPDATE_USER_SUCCESS';var CREATE_USER='admin/users/CREATE_USER';var CREATE_USER_FAIL='admin/users/CREATE_USER_FAIL';var CREATE_USER_SUCCESS='admin/users/CREATE_USER_SUCCESS';var DELETE_USERS='admin/users/DELETE_USERS';var DELETE_USERS_FAIL='admin/users/DELETE_USERS_FAIL';var DELETE_USERS_SUCCESS='admin/users/DELETE_USERS_SUCCESS';

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_userUtils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserRolePicker=function(_Component){_inherits(UserRolePicker,_Component);function UserRolePicker(){_classCallCheck(this,UserRolePicker);var _this=_possibleConstructorReturn(this,(UserRolePicker.__proto__||Object.getPrototypeOf(UserRolePicker)).call(this));_this.handleChangeRole=_this.handleChangeRole.bind(_this);return _this;}_createClass(UserRolePicker,[{key:'handleChangeRole',value:function handleChangeRole(e){this.props.onChangeRole(this.props.user,e.currentTarget.value);}},{key:'handleClick',value:function handleClick(e){// Don't change the selection when the user clicks the Role dropdown.
e.stopPropagation();}},{key:'isRoleReadOnly',value:function isRoleReadOnly(user){var loggedInUserName=this.props.loggedInUserName;return Object(__WEBPACK_IMPORTED_MODULE_3_util_userUtils__["c" /* isAdminUser */])(user)||Object(__WEBPACK_IMPORTED_MODULE_3_util_userUtils__["a" /* doesUserMatchUserName */])(user,loggedInUserName);}},{key:'render',value:function render(){var _props=this.props,intl=_props.intl,roles=_props.roles,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.isRoleReadOnly(user)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-size-7'},Object(__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["e" /* getLocalizedRoleName */])(intl,__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["a" /* NAME_ADMIN */])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:this.handleChangeRole,onClick:this.handleClick,value:user.roleName,'data-test-name':'user-role-picker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4__util_localizedStrings__["a" /* default */].NO_CATALOGS)),roles.map(function(role){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:role.name,value:role.name,'data-test-name':'role-name-'+role.name},Object(__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["e" /* getLocalizedRoleName */])(intl,role.name));}))));}}]);return UserRolePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(UserRolePicker));

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_view_DialogPanel_DialogPanel__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmUserRoleChangeDialog=function(_Component){_inherits(ConfirmUserRoleChangeDialog,_Component);function ConfirmUserRoleChangeDialog(){_classCallCheck(this,ConfirmUserRoleChangeDialog);var _this=_possibleConstructorReturn(this,(ConfirmUserRoleChangeDialog.__proto__||Object.getPrototypeOf(ConfirmUserRoleChangeDialog)).call(this));_this.handleConfirm=_this.handleConfirm.bind(_this);return _this;}_createClass(ConfirmUserRoleChangeDialog,[{key:'handleConfirm',value:function handleConfirm(){this.props.callback(this.props.activePanelData);this.props.hideDialogPanel();}},{key:'render',value:function render(){var _props=this.props,activePanelData=_props.activePanelData,activePanelId=_props.activePanelId,hideDialogPanel=_props.hideDialogPanel,formatMessage=_props.intl.formatMessage;var title=activePanelData&&activePanelData.roleName===''?__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS;var message=activePanelData&&activePanelData.roleName===''?__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG;var button=activePanelData&&activePanelData.roleName===''?__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].REMOVE:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS;var args=activePanelData&&{affectedUsersCount:activePanelData.affectedUsersCount}||{affectedUsersCount:1};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'550px',height:null},customButtonText:formatMessage(button,args),dataTestName:'confirm-user-role-change-dialog',dialogFocusId:__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_view_DialogPanel_DialogPanel__["a" /* DIALOG_PANEL_SAVE_BUTTON_ID */],hideDialogPanel:hideDialogPanel,onSave:this.handleConfirm,panelId:__WEBPACK_IMPORTED_MODULE_9_util_constants__["s" /* CONFIRM_USER_ROLE_CHANGE_PANEL_ID */],panelTitle:formatMessage(title,args),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container'},formatMessage(message,args)));}}]);return ConfirmUserRoleChangeDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state),activePanelData:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["b" /* getActivePanelData */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["a" /* bindActionCreatorsForm */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(ConfirmUserRoleChangeDialog)));

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_reducers_catalogReducer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FieldForm__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CreateFieldDialog__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MetadataDefinitionsDialog__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CreateMetadataDefinitionDialog__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__XMPNamespacesDialog__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CreateXMPNamespaceDialog__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_view_Pages_PageHeader__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_portfolio_shared_util_logging__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setSelectedFieldCategory=__WEBPACK_IMPORTED_MODULE_4_state_reducers_catalogReducer__["a" /* actions */].setSelectedFieldCategory,setSelectedFieldsListItemName=__WEBPACK_IMPORTED_MODULE_4_state_reducers_catalogReducer__["a" /* actions */].setSelectedFieldsListItemName;var FieldsPage=function(_Component){_inherits(FieldsPage,_Component);function FieldsPage(){_classCallCheck(this,FieldsPage);var _this=_possibleConstructorReturn(this,(FieldsPage.__proto__||Object.getPrototypeOf(FieldsPage)).call(this));_this.displayNameForFieldListItem=_this.displayNameForFieldListItem.bind(_this);_this.getFieldsListItems=_this.getFieldsListItems.bind(_this);_this.handleChangeCategory=_this.handleChangeCategory.bind(_this);_this.handleClickAdd=_this.handleClickAdd.bind(_this);_this.handleClickMetadataDefinitions=_this.handleClickMetadataDefinitions.bind(_this);_this.handleClickNamespaceDefinitions=_this.handleClickNamespaceDefinitions.bind(_this);_this.handleDeleteField=_this.handleDeleteField.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.handleSelectFieldsListItem=_this.handleSelectFieldsListItem.bind(_this);_this.handleToggleFieldEnabled=_this.handleToggleFieldEnabled.bind(_this);_this.isFieldRemovable=_this.isFieldRemovable.bind(_this);return _this;}_createClass(FieldsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getFieldsAction(this.props.catalog.catalogId);this.props.getMetadataDefinitionsAction();this.props.getMetadataMappingsAction(this.props.catalog.catalogId);}},{key:'handleClickAdd',value:function handleClickAdd(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_17_util_constants__["w" /* CREATE_FIELD_PANEL_ID */]);}},{key:'handleClickMetadataDefinitions',value:function handleClickMetadataDefinitions(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_17_util_constants__["R" /* METADATA_PANEL_ID */]);}},{key:'handleClickNamespaceDefinitions',value:function handleClickNamespaceDefinitions(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_17_util_constants__["_16" /* XMP_NAMESPACE_PANEL_ID */]);}},{key:'handleSelectFieldsListItem',value:function handleSelectFieldsListItem(e,name){this.props.setSelectedFieldsListItemName(name);}},{key:'displayNameForFieldListItem',value:function displayNameForFieldListItem(fli){return Object(__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["q" /* displayNameForField */])(this.props.intl,fli.name);}},{key:'handleKeyDown',value:function handleKeyDown(e){var _this2=this;var fieldListItems=this.getFieldsListItems();var fli=void 0;if(!e.metaKey&&(e.key==='ArrowDown'||e.key==='ArrowUp')){var currentIndex=this.getSelectedIndex();if(e.key==='ArrowUp'&&currentIndex>0){fli=fieldListItems[currentIndex-1];}else if(e.key==='ArrowDown'&&currentIndex<fieldListItems.length-1){fli=fieldListItems[currentIndex+1];}}else if(!e.metaKey&&/[a-z,0-9]/i.test(e.key)){fli=fieldListItems.find(function(f){return _this2.displayNameForFieldListItem(f).substr(0,1).localeCompare(e.key,undefined,{usage:'search',sensitivity:'base'})===0;});}if(fli){this.props.setSelectedFieldsListItemName(fli.name);var elem=document.getElementById('fli-'+fli.name);elem&&elem.scrollIntoView();e.preventDefault();}}// Return sorted FLIs for the current category
},{key:'getFieldsListItems',value:function getFieldsListItems(){var _this3=this;var _props=this.props,category=_props.category,fields=_props.fields,metadataDefinitions=_props.metadataDefinitions;if(!category){return[];}var flis=Object(__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["s" /* fieldsListItemsForCategory */])(fields,metadataDefinitions,category);var sortedFlis=flis.sort(function(a,b){return _this3.displayNameForFieldListItem(a).localeCompare(_this3.displayNameForFieldListItem(b));});return sortedFlis;}},{key:'getSelectedIndex',value:function getSelectedIndex(){var selectedFieldsListItemName=this.props.selectedFieldsListItemName;var ix=this.getFieldsListItems().findIndex(function(fli){return fli.name===selectedFieldsListItemName;});return ix;}},{key:'handleChangeCategory',value:function handleChangeCategory(e){this.props.setSelectedFieldsListItemName(null);this.props.setSelectedFieldCategory(e.target.value);}},{key:'handleDeleteField',value:function handleDeleteField(){var catalog=this.props.catalog;var fieldListItems=this.getFieldsListItems();var currentIndex=this.getSelectedIndex();var selectedFieldsListItem=fieldListItems[currentIndex];if(selectedFieldsListItem){this.props.removeFieldsAction(catalog.catalogId,[selectedFieldsListItem.fieldDef.id]);}}},{key:'isFieldRemovable',value:function isFieldRemovable(){var metadataDefinitions=this.props.metadataDefinitions;var fieldListItems=this.getFieldsListItems();var currentIndex=this.getSelectedIndex();var selectedFieldsListItem=fieldListItems[currentIndex];if(selectedFieldsListItem&&selectedFieldsListItem.fieldDef){return Object(__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["F" /* isFieldRemovable */])(selectedFieldsListItem.fieldDef,metadataDefinitions);}return false;}},{key:'handleToggleFieldEnabled',value:function handleToggleFieldEnabled(){var _props2=this.props,addFieldsAction=_props2.addFieldsAction,catalog=_props2.catalog,removeFieldsAction=_props2.removeFieldsAction,fields=_props2.fields,metadataDefinitions=_props2.metadataDefinitions;var fieldListItems=this.getFieldsListItems();var currentIndex=this.getSelectedIndex();var selectedFieldsListItem=fieldListItems[currentIndex];var mdId=selectedFieldsListItem.metadataDefinition.id;var fieldDef=Object(__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["r" /* fieldDefForFieldsListItemName */])(selectedFieldsListItem.internalName,metadataDefinitions,fields);if(!fieldDef){__WEBPACK_IMPORTED_MODULE_18_portfolio_shared_util_logging__["a" /* default */].warn('Could not get a field def for the fields list item '+selectedFieldsListItem.internalName);return;}if(selectedFieldsListItem.isEnabled){removeFieldsAction(catalog.catalogId,[fieldDef.id],true);}else{addFieldsAction(catalog.catalogId,[fieldDef],mdId);}}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,catalogId=_props3.catalog.catalogId,activePanelId=_props3.activePanelId,category=_props3.category,formatMessage=_props3.intl.formatMessage,selectedFieldsListItemName=_props3.selectedFieldsListItemName;var fieldsListItems=this.getFieldsListItems();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents','data-test-name':'catalog-fields-page'},activePanelId===__WEBPACK_IMPORTED_MODULE_17_util_constants__["w" /* CREATE_FIELD_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CreateFieldDialog__["a" /* default */],{catalogId:catalogId}),activePanelId===__WEBPACK_IMPORTED_MODULE_17_util_constants__["R" /* METADATA_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MetadataDefinitionsDialog__["a" /* default */],null),activePanelId===__WEBPACK_IMPORTED_MODULE_17_util_constants__["z" /* CREATE_METADATA_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CreateMetadataDefinitionDialog__["a" /* default */],null),activePanelId===__WEBPACK_IMPORTED_MODULE_17_util_constants__["_16" /* XMP_NAMESPACE_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__XMPNamespacesDialog__["a" /* default */],null),activePanelId===__WEBPACK_IMPORTED_MODULE_17_util_constants__["C" /* CREATE_XMP_NAMESPACE_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__CreateXMPNamespaceDialog__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents columns is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'fields-page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_view_Pages_PageHeader__["a" /* default */],{isSecondary:true,deleteDisabled:!this.isFieldRemovable(),onClickAdd:this.handleClickAdd,onClickDelete:this.handleDeleteField,title:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CATALOG_INGEST_FIELDS_LABEL)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page bordered-page-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fields-page-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'select',onChange:this.handleChangeCategory,value:category,'data-test-name':'select-category-select'},__WEBPACK_IMPORTED_MODULE_7_util_fieldsPageUtils__["a" /* FIELDS_CATEGORIES */].map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:category.id,value:category.id,'data-test-name':'field-category-'+_this4.props.intl.formatMessage(category.label)},formatMessage(category.label));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-scrollable',onKeyDown:this.handleKeyDown,tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-hoverable is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,fieldsListItems.map(function(fli,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldsListRenderer,{canBeDisabled:fli.canBeDisabled,hasCheckbox:fli.hasCheckbox,isEnabled:fli.isEnabled,name:_this4.displayNameForFieldListItem(fli),internalName:fli.name,index:index,isSelected:!!selectedFieldsListItemName&&fli.name===selectedFieldsListItemName,key:fli.name,onClick:_this4.handleSelectFieldsListItem,onToggleFieldEnabled:_this4.handleToggleFieldEnabled});})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'fields-page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fields-page-header-button-group buttons buttonsGroup is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button','data-test-name':'manage-metadata',onClick:this.handleClickMetadataDefinitions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_ACTION_MANAGE_METADATA)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button','data-test-name':'manage-xmp-namespaces',onClick:this.handleClickNamespaceDefinitions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FieldForm__["b" /* default */],{catalog:this.props.catalog}))));}}]);return FieldsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var FieldsListRenderer=function(_Component2){_inherits(FieldsListRenderer,_Component2);function FieldsListRenderer(){_classCallCheck(this,FieldsListRenderer);var _this5=_possibleConstructorReturn(this,(FieldsListRenderer.__proto__||Object.getPrototypeOf(FieldsListRenderer)).call(this));_this5.handleChangeCheckbox=_this5.handleChangeCheckbox.bind(_this5);_this5.handleClick=_this5.handleClick.bind(_this5);return _this5;}_createClass(FieldsListRenderer,[{key:'handleClick',value:function handleClick(e){this.props.onClick(e,this.props.internalName);}},{key:'handleChangeCheckbox',value:function handleChangeCheckbox(){this.props.onToggleFieldEnabled(this.props.internalName);}},{key:'render',value:function render(){var _props4=this.props,canBeDisabled=_props4.canBeDisabled,hasCheckbox=_props4.hasCheckbox,isEnabled=_props4.isEnabled,isSelected=_props4.isSelected,name=_props4.name;var className='has-pointer '+(isSelected?'is-selected':'');var checkClassName='is-checkradio is-small '+(isSelected?' has-background-color is-white':'');var checkboxId='enabled-'+name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:className,id:'fli-'+name,onClick:this.handleClick,'data-test-name':'field-name-'+name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},hasCheckbox&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,canBeDisabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:checkClassName,'data-test-name':'enable-field-checkbox',id:checkboxId,type:'checkbox',checked:isEnabled,onChange:this.handleChangeCheckbox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:checkboxId}))),name)));}}]);return FieldsListRenderer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["c" /* getActivePanelId */])(state),category:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_19" /* getSelectedFieldCategory */])(state),fields:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["H" /* getFields */])(state),metadataDefinitions:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_9" /* getMetadataDefinitions */])(state),metadataMappings:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_10" /* getMetadataMappings */])(state),selectedFieldsListItemName:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_20" /* getSelectedFieldsListItemName */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addFieldsAction:__WEBPACK_IMPORTED_MODULE_3_state_commands_catalogCommands__["b" /* addFields */],getFieldsAction:__WEBPACK_IMPORTED_MODULE_3_state_commands_catalogCommands__["p" /* getFields */],getMetadataDefinitionsAction:__WEBPACK_IMPORTED_MODULE_3_state_commands_catalogCommands__["q" /* getMetadataDefinitions */],getMetadataMappingsAction:__WEBPACK_IMPORTED_MODULE_3_state_commands_catalogCommands__["r" /* getMetadataMappings */],removeFieldsAction:__WEBPACK_IMPORTED_MODULE_3_state_commands_catalogCommands__["u" /* removeFields */],setSelectedFieldCategory:setSelectedFieldCategory,setSelectedFieldsListItemName:setSelectedFieldsListItemName,showDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(FieldsPage)));

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ExtractMetadataMappingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddExtractMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MappingWarnings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hideDialogPanel=__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel;var ExtractMetadataMappingRow=function(_Component){_inherits(ExtractMetadataMappingRow,_Component);function ExtractMetadataMappingRow(){_classCallCheck(this,ExtractMetadataMappingRow);var _this=_possibleConstructorReturn(this,(ExtractMetadataMappingRow.__proto__||Object.getPrototypeOf(ExtractMetadataMappingRow)).call(this));_this.handleRemoveExtractMapping=_this.handleRemoveExtractMapping.bind(_this);return _this;}_createClass(ExtractMetadataMappingRow,[{key:'handleRemoveExtractMapping',value:function handleRemoveExtractMapping(){var _props=this.props,fdId=_props.fdId,md=_props.md,removeMapping=_props.removeMapping;removeMapping(fdId,md.id,__WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__["k" /* MD_MAPPING_TYPE_EXTRACT */]);}},{key:'render',value:function render(){var _props2=this.props,disabled=_props2.disabled,md=_props2.md;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fields-mapping-row '+(disabled?' fields-mapping-row-disabled':''),'data-test-name':'extract-mapping-row'},md.displayName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-inverted','data-test-name':'remove-extract-mapping',disabled:disabled,onClick:this.handleRemoveExtractMapping,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-minus-circle'})));}}]);return ExtractMetadataMappingRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AddExtractMapping=function(_Component2){_inherits(AddExtractMapping,_Component2);function AddExtractMapping(){_classCallCheck(this,AddExtractMapping);var _this2=_possibleConstructorReturn(this,(AddExtractMapping.__proto__||Object.getPrototypeOf(AddExtractMapping)).call(this));_this2.handleAddExtract=_this2.handleAddExtract.bind(_this2);return _this2;}_createClass(AddExtractMapping,[{key:'handleAddExtract',value:function handleAddExtract(){var mds=this.props.mds;var md=Object(__WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__["z" /* getMetadataDef */])(this.extractSelect.value,mds);md&&this.props.addExtract(md.id);}},{key:'render',value:function render(){var _this3=this;var _props3=this.props,activePanelId=_props3.activePanelId,field=_props3.field,hideDialogPanel=_props3.hideDialogPanel,formatMessage=_props3.formatMessage,mappings=_props3.mappings,mds=_props3.mds;var existingExtractMetadata=Object(__WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__["x" /* getExtractMetadataForField */])(field.id,mappings,mds);var freeMetadataDefs=mds.filter(function(md){return!existingExtractMetadata.includes(md);});return activePanelId===__WEBPACK_IMPORTED_MODULE_2_util_constants__["c" /* ADD_EXTRACT_MAPPING_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:500,height:250},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].ADD),hideDialogPanel:hideDialogPanel,onSave:this.handleAddExtract,panelId:__WEBPACK_IMPORTED_MODULE_2_util_constants__["c" /* ADD_EXTRACT_MAPPING_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].FIELD_ADD_EXTRACT_METADATA)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',margin:'20px'},'data-test-name':'add-mapping-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'data-test-name':'add-mapping-select',ref:function ref(s){_this3.extractSelect=s;}},freeMetadataDefs.map(function(md){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:md.id,value:md.id,'data-test-name':'extract-field'},md.displayName);})))));}}]);return AddExtractMapping;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MappingWarnings=function(_Component3){_inherits(MappingWarnings,_Component3);function MappingWarnings(){_classCallCheck(this,MappingWarnings);return _possibleConstructorReturn(this,(MappingWarnings.__proto__||Object.getPrototypeOf(MappingWarnings)).apply(this,arguments));}_createClass(MappingWarnings,[{key:'render',value:function render(){var _props4=this.props,fieldDefinitions=_props4.fieldDefinitions,intl=_props4.intl,metadataDef=_props4.metadataDef,metadataMappings=_props4.metadataMappings;var fieldDefs=Object(__WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__["y" /* getFieldsThatEmbedToMetadata */])(metadataDef.id,metadataMappings,fieldDefinitions)||[];var labels=fieldDefs.map(function(fd){return Object(__WEBPACK_IMPORTED_MODULE_3_util_fieldsPageUtils__["q" /* displayNameForField */])(intl,fd.systemName);}).sort(function(a,b){return a.toLowerCase().localeCompare(b.toLowerCase());});if(fieldDefs.length>1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-danger',style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body','data-test-name':'multiple-embed-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].FIELD_MULTIPLE_EMBED_WARNING),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),metadataDef.displayName,':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,labels.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'is-indented',key:label},'\u2022\xA0',label);}))));}else{return null;}}}]);return MappingWarnings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_types_catalogTypes__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_nestedValues__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_portfolio_shared_view_Field_PDLSubTree__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portfolio_shared_util_fieldDefUtils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_view_Utilities_Listbox__ = __webpack_require__(942);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** This component is ported from the client's PredefinedList component, with apply values removed */var IS_WINDOWS=window.navigator.appVersion.includes('Windows');var PredefinedList=function(_Component){_inherits(PredefinedList,_Component);function PredefinedList(){_classCallCheck(this,PredefinedList);var _this=_possibleConstructorReturn(this,(PredefinedList.__proto__||Object.getPrototypeOf(PredefinedList)).call(this));_this.state={selectedPDLItems:new Set(),predefValueInput:''};_this.addSelectedPDLItems=_this.addSelectedPDLItems.bind(_this);_this.addValueToPDL=_this.addValueToPDL.bind(_this);_this.exportPDL=_this.exportPDL.bind(_this);_this.findLeafmostSelectedNestedValues=_this.findLeafmostSelectedNestedValues.bind(_this);_this.getLastSelectedNestedValue=_this.getLastSelectedNestedValue.bind(_this);_this.handleKeyPress_editPredefinedValuesInput=_this.handleKeyPress_editPredefinedValuesInput.bind(_this);_this.handleKeyUp_editPredefinedValuesInput=_this.handleKeyUp_editPredefinedValuesInput.bind(_this);_this.handleSelectFileForImportPDL=_this.handleSelectFileForImportPDL.bind(_this);_this.importPDL=_this.importPDL.bind(_this);_this.normalizer=_this.normalizer.bind(_this);_this.onChangeValuesListSelection=_this.onChangeValuesListSelection.bind(_this);_this.onKeyPressPredefinedList=_this.onKeyPressPredefinedList.bind(_this);_this.onPredefValueChange=_this.onPredefValueChange.bind(_this);_this.removePDLValues=_this.removePDLValues.bind(_this);_this.removeSelectedPDLItems=_this.removeSelectedPDLItems.bind(_this);_this.removeSelectedValuesFromPDL=_this.removeSelectedValuesFromPDL.bind(_this);_this.removeSelectedValuesFromPDLList=_this.removeSelectedValuesFromPDLList.bind(_this);_this.removeSelectedValuesFromPDLTree=_this.removeSelectedValuesFromPDLTree.bind(_this);_this.renderValuesTree=_this.renderValuesTree.bind(_this);_this.setSelectedPDLItems=_this.setSelectedPDLItems.bind(_this);_this.submitFieldValue=_this.submitFieldValue.bind(_this);return _this;}_createClass(PredefinedList,[{key:'setSelectedPDLItems',value:function setSelectedPDLItems(items){this.setState({selectedPDLItems:new Set(items)});}},{key:'addSelectedPDLItems',value:function addSelectedPDLItems(items){var newVals=new Set([].concat(_toConsumableArray(this.state.selectedPDLItems)));items.forEach(function(item){return newVals.add(item);});this.setState({selectedPDLItems:newVals});}},{key:'removeSelectedPDLItems',value:function removeSelectedPDLItems(items){var newVals=new Set([].concat(_toConsumableArray(this.state.selectedPDLItems)));items.forEach(function(item){return newVals.delete(item);});this.setState({selectedPDLItems:newVals});}},{key:'submitFieldValue',value:function submitFieldValue(value){// The reduxFormInput prop is passed in by FieldEditorPDL, but not in
// other places that PredefinedList is used. So, pass it in as a second
// argument if it's there.
var _props=this.props,submitFieldValue=_props.submitFieldValue,reduxFormInput=_props.reduxFormInput;return submitFieldValue(value,reduxFormInput);}},{key:'onChangeValuesListSelection',value:function onChangeValuesListSelection(){this.setState({selectedPDLItems:new Set(this.pdlListbox.getSelectedValues())});}},{key:'onKeyPressPredefinedList',value:function onKeyPressPredefinedList(e){if(e.key==='Delete'||e.key==='Backspace'){this.removeSelectedValuesFromPDL();e.preventDefault();}}},{key:'renderValuesList',value:function renderValuesList(values){var _this2=this;var fieldDef=this.props.fieldDef;Object(__WEBPACK_IMPORTED_MODULE_9_portfolio_shared_util_fieldDefUtils__["f" /* sortValuesForFieldDef */])(fieldDef,values);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_view_Utilities_Listbox__["a" /* default */],{className:'pdl-select',testName:'pdl-flat',ref:function ref(input){_this2.pdlListbox=input;},isMultiple:fieldDef.isMultivalued,onChange:this.onChangeValuesListSelection,onKeyDown:this.onKeyPressPredefinedList,listItems:values,initialSize:6});}},{key:'renderValuesTree',value:function renderValuesTree(values){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pdl-tree','data-test-name':'pdl-tree'},values.sort(function(a,b){return a.value.localeCompare(b.value);}).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_view_Field_PDLSubTree__["a" /* default */],{ancestorValues:[value],itemSelectedStyle:'pdl-item-selected',itemStyle:'pdl-item',key:'PDL-'+value.id,level:0,selectedPDLItems:_this3.state.selectedPDLItems,setSelectedPDLItems:_this3.setSelectedPDLItems,addSelectedPDLItems:_this3.addSelectedPDLItems,removeSelectedPDLItems:_this3.removeSelectedPDLItems,submitFieldValue:_this3.submitFieldValue,tree:value});}));}},{key:'isDuplicateHierarchicalValue',value:function isDuplicateHierarchicalValue(value){var _this4=this;var fieldDef=this.props.fieldDef;var result=false;if(fieldDef.isHierarchical){(function(){// selectedPDLItems has the state of the items when they were selected,
// but that may not be an accurate picture of the children nodes if children have been added
// and the selection has not changed.
// So we walk the fieldDef.nestedPredefinedValues (which has all the latest changes) finding
// our selectedNestedValue nodes until we get its peers, then we look for dupes.
var selectedNestedValues=[].concat(_toConsumableArray(_this4.state.selectedPDLItems));var nodes=fieldDef.nestedPredefinedValues;var _loop=function _loop(idx){if(idx===0){nodes=fieldDef.nestedPredefinedValues.filter(function(nv){return nv.id===selectedNestedValues[idx].id;});}else{nodes=nodes[0].children.filter(function(nv){return nv.id===selectedNestedValues[idx].id;});}};for(var idx=0;idx<selectedNestedValues.length;idx++){_loop(idx);}if(nodes&&nodes.length>0){var peers=selectedNestedValues.length===0?nodes:nodes[0].children;if(peers.some(function(nv){return nv.value.toLowerCase()===value[0].value.toLowerCase();})){result=true;// dupe found
}}})();}return result;}},{key:'addValueToPDL',value:function addValueToPDL(){var fieldDef=this.props.fieldDef;var value=this.editPredefInput.value;value=value?value.trim():value;if(value){value=fieldDef.isHierarchical?[{value:value}]:[value];var parentNode=fieldDef.isHierarchical?this.getLastSelectedNestedValue():null;if(fieldDef.isHierarchical&&this.isDuplicateHierarchicalValue(value)){return;// early return, found a duplicate
}var parentNodeId=parentNode&&parentNode.id;this.props.editPDL(true,fieldDef,value,parentNodeId);this.setState({predefValueInput:''});}}},{key:'getLastSelectedNestedValue',value:function getLastSelectedNestedValue(){var nvs=this.findLeafmostSelectedNestedValues();var result=nvs[nvs.length-1];return result;}// Return any selected NVs which don't have children among the selected NVs
},{key:'findLeafmostSelectedNestedValues',value:function findLeafmostSelectedNestedValues(){var selectedNestedValues=[].concat(_toConsumableArray(this.state.selectedPDLItems));var selectedNestedValueIds=selectedNestedValues.map(function(val){return val.id;});var leafmostNodes=selectedNestedValues.filter(function(nv){return!nv.children||nv.children.every(function(child){return!selectedNestedValueIds.includes(child.id);});});return leafmostNodes;}},{key:'removeSelectedValuesFromPDL',value:function removeSelectedValuesFromPDL(){var fieldDef=this.props.fieldDef;if(fieldDef.isHierarchical){this.removeSelectedValuesFromPDLTree();}else{this.removeSelectedValuesFromPDLList();}}},{key:'removeSelectedValuesFromPDLList',value:function removeSelectedValuesFromPDLList(){this.removePDLValues(this.pdlListbox.getSelectedValues());}},{key:'removeSelectedValuesFromPDLTree',value:function removeSelectedValuesFromPDLTree(){var _this5=this;var showModalPrompt=this.props.showModalPrompt;// We just want the leaf-most NVs, not the ancestors
// So filter out any NVs which have any children among the selected NVs
var nestedValuesToRemove=this.findLeafmostSelectedNestedValues();var valueIds=nestedValuesToRemove.map(function(nestedValue){return nestedValue.id;});var doRemove=function doRemove(){// remove from server
_this5.removePDLValues(valueIds);// remove from this state's selected PDL items
_this5.removeSelectedPDLItems(nestedValuesToRemove);};// Require confirmation if there are children
var anyValuesToRemoveHaveChildren=nestedValuesToRemove.some(function(nv){return nv.children&&nv.children.length>0;});if(anyValuesToRemoveHaveChildren){showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PDL_removeNestedValueConfirmation,onButton2:doRemove,closeOnEscape:true,isButton2Default:true});}else{doRemove();}}},{key:'removePDLValues',value:function removePDLValues(values){var fieldDef=this.props.fieldDef;if(values&&values.length>0){this.props.editPDL(false,fieldDef,values);}}},{key:'handleKeyPress_editPredefinedValuesInput',value:function handleKeyPress_editPredefinedValuesInput(e,f){if(e.key==='Enter'){this.addValueToPDL();e.preventDefault();}else if(!Object(__WEBPACK_IMPORTED_MODULE_8_util_fieldsPageUtils__["B" /* isCharacterLegal */])(e.key,this.props.fieldDef,e.target)){e.preventDefault();}}},{key:'handleKeyUp_editPredefinedValuesInput',value:function handleKeyUp_editPredefinedValuesInput(e){if(e.key==='Escape'){e.preventDefault();this.setState({predefValueInput:''});}}},{key:'onPredefValueChange',value:function onPredefValueChange(e){var normalized=this.normalizer(e.target.value,this.state.predefValueInput);this.setState({predefValueInput:normalized});}},{key:'normalizer',value:function normalizer(value,previousValue){return Object(__WEBPACK_IMPORTED_MODULE_8_util_fieldsPageUtils__["I" /* normalizeValue */])(this.props.fieldDef,value,previousValue);}},{key:'renderNoPredefinedValues',value:function renderNoPredefinedValues(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pdl-select-no-values'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PDL_noPredefinedValues));}},{key:'nullIfEmpty',value:function nullIfEmpty(array){return array&&array.length===0?null:array;}},{key:'exportPDL',value:function exportPDL(){var fieldDef=this.props.fieldDef;var filename=fieldDef.systemName+'.txt';var returnChar=IS_WINDOWS?'\r\n':'\n';var content='';if(fieldDef.isHierarchical){var nestedValues=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(fieldDef.nestedPredefinedValues);var flatNestedValues=Object(__WEBPACK_IMPORTED_MODULE_6_util_nestedValues__["a" /* flattenNestedValues */])(nestedValues,0);content=Object(__WEBPACK_IMPORTED_MODULE_6_util_nestedValues__["b" /* nestedValuesToArray */])(flatNestedValues,returnChar);}else{content=fieldDef.predefinedValues.map(function(value){return value+returnChar;});}var file=new Blob(content,{type:'text/plain'});if(window.navigator.msSaveOrOpenBlob){// IE and Edge
window.navigator.msSaveOrOpenBlob(file,filename);}else{var el=document.createElement('a');document.body&&document.body.appendChild(el);// attach to DOM for Firefox
el.href=URL.createObjectURL(file);el.download=filename;el.click();}}},{key:'importPDL',value:function importPDL(e){this.fileInput.click();e.preventDefault();}},{key:'handleSelectFileForImportPDL',value:function handleSelectFileForImportPDL(e){var _props2=this.props,editPDL=_props2.editPDL,fieldDef=_props2.fieldDef,showModalPrompt=_props2.showModalPrompt;var files=this.fileInput.files;var reader=new FileReader();var filename=files[0].name.toLowerCase();// Browsers will correctly restrict the selection to text files, but unfortunately,
// the version of electron we are currently using (1.7.10) does not, so we need
// to do this check.
if(!filename.endsWith('.txt')&&!filename.endsWith('.text')){showModalPrompt(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_reducers_modalPromptReducer__["c" /* propsForSingleButtonAlert */])(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PDL_wrongPdlImportFormat));}else{reader.onload=function(){var text=reader.result;var results=Object(__WEBPACK_IMPORTED_MODULE_6_util_nestedValues__["c" /* parseList */])(text,fieldDef);editPDL(true,fieldDef,results);};reader.readAsText(files[0]);}// reset file input so user can reselect same file if they want
this.fileInput.value=null;}},{key:'render',value:function render(){var _this6=this;var _props3=this.props,fieldDef=_props3.fieldDef,formatMessage=_props3.intl.formatMessage,editPDL=_props3.editPDL;var listValues=this.nullIfEmpty(fieldDef.predefinedValues);var nestedValues=this.nullIfEmpty(fieldDef.nestedPredefinedValues);// 'no predefined values' state
if(!editPDL&&!listValues&&!nestedValues){return this.renderNoPredefinedValues();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box','data-test-name':'pdl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].FIELD_FORM_LABEL_PREDEFINED_VALUES)),listValues&&this.renderValuesList(listValues),nestedValues&&this.renderValuesTree(nestedValues),!listValues&&!nestedValues&&this.renderNoPredefinedValues(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'managePredefs',className:'pdl-field-widgets'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'input',type:'text',style:{flex:2,marginRight:'4px',minWidth:'50px'},onKeyPress:this.handleKeyPress_editPredefinedValuesInput,onKeyUp:this.handleKeyUp_editPredefinedValuesInput,onChange:this.onPredefValueChange,maxLength:1000,ref:function ref(input){_this6.editPredefInput=input;},value:this.state.predefValueInput,placeholder:formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PDL_editPredefinedListPlaceholder),'data-test-name':'edit-predefined-list-input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-inverted',key:'add-predefined-value','data-test-name':'add-predefined-value',onClick:this.addValueToPDL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-inverted',key:'remove-predefined-value','data-test-name':'remove-predefined-value',onClick:this.removeSelectedValuesFromPDL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-minus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-inverted',key:'export-predefined-values','data-test-name':'export-predefined-values',title:formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PDL_exportPredefinedValues),onClick:this.exportPDL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-inverted',key:'import-predefined-values','data-test-name':'import-predefined-values',title:formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PDL_importPredefinedValues),onClick:this.importPDL},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{accept:'.txt, .text',ref:function ref(c){_this6.fileInput=c;},type:'file',style:{display:'none'},onChange:this.handleSelectFileForImportPDL})));}}]);return PredefinedList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PredefinedList);

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.23';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);

      // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
      var index = -1,
          length = path.length;

      if (!length) {
        return true;
      }

      var isRootPrimitive = object == null || (typeof object !== 'object' && typeof object !== 'function');

      while (++index < length) {
        var key = path[index];

        // skip non-string keys (e.g., Symbols, numbers)
        if (typeof key !== 'string') {
          continue;
        }

        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
          return false;
        }

        // Block "constructor.prototype" chains
        if (key === 'constructor' &&
            (index + 1) < length &&
            typeof path[index + 1] === 'string' &&
            path[index + 1] === 'prototype') {

          // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
          if (isRootPrimitive && index === 0) {
            continue;
          }

          return false;
        }
      }

      var obj = parent(object, path);
      return obj == null || delete obj[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(64)(module)))

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_NEW_LINE_CHAR */
/* unused harmony export WINDOWS_NEW_LINE_CHAR */
/* unused harmony export DEFAULT_TAB_CHAR */
/* unused harmony export createNestedValue */
/* unused harmony export isNestedValueAncestorOfNestedValue */
/* unused harmony export addChildToNestedValue */
/* harmony export (immutable) */ __webpack_exports__["a"] = flattenNestedValues;
/* harmony export (immutable) */ __webpack_exports__["b"] = nestedValuesToArray;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseList;
/* unused harmony export nestedValuesFromStrings */
/* unused harmony export areNestedValueListsEqual */
/* unused harmony export nestedValuesArrayToStructuredString */
/* unused harmony export _nestedValueToStructuredString */
/* unused harmony export nestedValueToServerObject */
/* unused harmony export nestedValuesToServerObjects */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_fieldDefUtils__ = __webpack_require__(74);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Utilities for Nested Values
var DEFAULT_NEW_LINE_CHAR='\n';var WINDOWS_NEW_LINE_CHAR='\r\n';var DEFAULT_TAB_CHAR='\t';function createNestedValue(value){var isRoot=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{children:[],id:null,isRootNode:isRoot,parent:null,value:value};}function isNestedValueAncestorOfNestedValue(possibleAncestor,nv){// don't pay attention to null ids, e.g. if the NVs were created locally and
// not yet persisted, and therefore don't have ids yet.
if(!possibleAncestor.id||!nv||!nv.id){return false;}if(nv.parent&&!nv.parent.isRootNode){if(nv.parent.id===possibleAncestor.id){return true;}else{return possibleAncestor.isNestedValueAncestorOfNestedValue(possibleAncestor,nv.parent);}}return false;}function addChildToNestedValue(child,nestedValue){// guard against creating circular references
if(!isNestedValueAncestorOfNestedValue(child,nestedValue)){child.parent=nestedValue;nestedValue.children.push(child);}}// flattens the nested values and calculates the tab index
// for each value depending on its depth
function flattenNestedValues(values,tabIndex){var flat=[];values.forEach(function(value){value.tabIndex=tabIndex;flat.push(value);if(Array.isArray(value.children)&&value.children.length>0){flat.push.apply(flat,_toConsumableArray(flattenNestedValues(value.children,tabIndex+1)));delete value.children;}delete value.children;});return flat;}// takes an array of flattened nested values and
// creates an array of strings for output
// tab characters denote the depth of the items
function nestedValuesToArray(items,returnChar){var result=[];items.forEach(function(item){var tabs='';for(var i=0;i<item.tabIndex;++i){tabs+=DEFAULT_TAB_CHAR;}result.push(tabs+item.value+returnChar);});return result;}//
// Note: The following methods are ported as directly as possible
// from flex-shared's classes NestedValue.as, ListEditor.mxml, and
// HierarchicalList.mxml
//
function parseList(text,fieldDef){if(!text||text.trim()===''){return;}var items=void 0;var isWinNewlineDelimited=-1!==text.indexOf(WINDOWS_NEW_LINE_CHAR);if(isWinNewlineDelimited){items=text.split(WINDOWS_NEW_LINE_CHAR);}else{items=text.split(DEFAULT_NEW_LINE_CHAR);}if(fieldDef.isHierarchical){var rootNode=createNestedValue('dummy root node',true);rootNode.children=fieldDef.nestedPredefinedValues;return _parseHierarchicalList(rootNode,items,fieldDef);}else{// Replace control charcters. These cause a WstxUnexpectedCharException in the SOAP parser
// Alas, the Flex/ECMA RegEx engine doesn't do Unicode ranges, need to match u00-u1F and u7F individually.
var pattern=/\x00|\x01|\x02|\x03|\x04|\x05|\x06|\x07|\x08|\x09|\x0A|\x0B|\x0C|\x0D|\x0E|\x0F|\x10|\x11|\x12|\x13|\x14|\x15|\x16|\x17|\x18|\x19|\x1A|\x1B|\x1C|\x1D|\x1E|\x1F|\x7F/g;for(var ix=0;ix<items.length;ix++){items[ix]=items[ix].replace(pattern,'');}return _parseFlatList(items,fieldDef);}}function _parseFlatList(items,fieldDef){// trim lines and remove blank lines
items=items.map(function(item){return item.trim();}).filter(function(item){return item.trim()!=='';});// During development we only tested up to 10k items. With larger lists, like 70k
// we need to make a few shortcuts or the app becomes unresponsive. Avoid validating,
// looking for duplicates, and sorting large lists. Rely on the server for this.
var bulkAdd=items.length>10000;if(!bulkAdd){items.sort(Object(__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_fieldDefUtils__["e" /* multivalueCompareFn */])(fieldDef,items[0]));}return items;}function _parseHierarchicalList(rootNode,items,fieldDef){var newValues=nestedValuesFromStrings(items);var addedValues=[];newValues.forEach(function(newValue){if(!_newValueIsDuplicateOfExistingNestedValueInList(newValue.value,rootNode.children)){addChildToNestedValue(newValue,rootNode);addedValues.push(newValue);}});if(addedValues.length>0){return nestedValuesToServerObjects(addedValues);}}function _newValueIsDuplicateOfExistingNestedValueInList(newValue,existing){for(var ix=0;ix<existing.length;++ix){var nestedValue=existing[ix];if(nestedValue.value.toLowerCase()===newValue.toLowerCase()){return true;}}return false;}// Parses a list of Nested Values from a list of strings,
// where tabs are assumed to be structural.
// Sorts and culls dupes.
function nestedValuesFromStrings(stringValues){var tabChar=arguments.length>1&&arguments[1]!==undefined?arguments[1]:DEFAULT_TAB_CHAR;var currParents=[];// parent at each lower level
var ret=[];for(var ix=0;ix<stringValues.length;++ix){var val=stringValues[ix];var currTabIx=0;while(val.charAt(0)===tabChar){val=val.substr(1);++currTabIx;}// make sure we do not have parentless nvs except for root ones
if(currTabIx!==0&&currParents.length<currTabIx){__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_logging__["a" /* default */].info('error parsing nested values from strings');// TODO: should we be more forgiving and just ignore this subtree?
return null;}val.trim();if(val.length>0){var nv=createNestedValue(val);if(currTabIx===0){ret.push(nv);}else{var parent=currParents[currTabIx-1];addChildToNestedValue(nv,parent);}// update curr parents
if(currParents.length===currTabIx){currParents.push(nv);}else{currParents[currTabIx]=nv;}// remove any old parents beyond curr ix
while(currParents.length>currTabIx+1){currParents.pop();}}}// sort and cull dupes
_sortNVs(ret);ret=_cullDupes(ret);return ret;}function _sortNVs(nvs){nvs.forEach(function(nv){if(nv.children){_sortNVs(nv.children);}});nvs.sort(function(a,b){return a.value.localeCompare(b.value);});}// Return a list of nested values with dupes culled and children coalesced.
function _cullDupes(nestedValues){var ret=[];for(var ix=0;ix<nestedValues.length;++ix){var nestedValue=nestedValues[ix];var peers=[];for(var jx=ix+1;jx<nestedValues.length;++jx){peers.push(nestedValues[jx]);}var dupe=_findDupeValueAmongNestedValues(nestedValue,peers);if(dupe){var _dupe$children;// add nested values children to the dupe
// TODO: we may have to make this method multi-pass we if we really care
// about proper child coalescing
(_dupe$children=dupe.children).push.apply(_dupe$children,_toConsumableArray(nestedValue.children));continue;}else{ret.push(nestedValue);// cull children recursively
nestedValue.children=_cullDupes(nestedValue.children);}}return ret;}function _findDupeValueAmongNestedValues(nv,values){for(var ix=0;ix<values.length;++ix){if(nv.value===values[ix].value){return values[ix];}}return null;}// Walk two nested value lists and make sure the values are equivalent.
// Assumes sorted lists.
function areNestedValueListsEqual(nvs1,nvs2){var nv1=void 0;var nv2=void 0;if(!nvs1&&!nvs2){return true;}if(nvs1.length!==nvs2.length){return false;}for(var ix=0;ix<nvs1.length;++ix){nv1=nvs1[ix];nv2=nvs2[ix];if(nv1.value!==nv2.value){return false;}if(!areNestedValueListsEqual(nv1.children,nv2.children)){return false;}}return true;}// List of NVs to string
function nestedValuesArrayToStructuredString(nvs){var newLineChar=arguments.length>1&&arguments[1]!==undefined?arguments[1]:DEFAULT_NEW_LINE_CHAR;var tabChar=arguments.length>2&&arguments[2]!==undefined?arguments[2]:DEFAULT_TAB_CHAR;var ret='';for(var ix=0;ix<nvs.length;++ix){var nv=nvs[ix];ret+=_nestedValueToStructuredString(nv,0,newLineChar,tabChar);}return ret;}// Single NV to structured string
function _nestedValueToStructuredString(nv){var tabIx=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var newLineChar=arguments.length>2&&arguments[2]!==undefined?arguments[2]:DEFAULT_NEW_LINE_CHAR;var tabChar=arguments.length>3&&arguments[3]!==undefined?arguments[3]:DEFAULT_TAB_CHAR;var ret='';for(var tx=0;tx<tabIx;++tx){ret+=tabChar;}ret+=nv.value;ret+=newLineChar;if(nv.children){for(var ix=0;ix<nv.children.length;++ix){ret+=_nestedValueToStructuredString(nv.children[ix],tabIx+1,newLineChar,tabChar);}}return ret;}// Converts from a NV to the server-side object format
function nestedValueToServerObject(nv){var o={children:[],id:nv.id,parentId:nv.parentId=nv.parent?nv.parent.id:null,value:nv.value};// recursively call toObject() for all children of this nested value
nv.children.forEach(function(child){return o.children.push(nestedValueToServerObject(child));});return o;}function nestedValuesToServerObjects(nvs){return nvs.map(function(nv){return nestedValueToServerObject(nv);});}

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_view_Utilities_TreeView__ = __webpack_require__(328);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var array=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,func=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,number=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,object=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,string=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string;var PDLSubTree=function(_Component){_inherits(PDLSubTree,_Component);function PDLSubTree(){_classCallCheck(this,PDLSubTree);var _this=_possibleConstructorReturn(this,(PDLSubTree.__proto__||Object.getPrototypeOf(PDLSubTree)).call(this));_this.getSubtreeNodes=_this.getSubtreeNodes.bind(_this);_this.isSelected=_this.isSelected.bind(_this);_this.onClickTreeValue=_this.onClickTreeValue.bind(_this);_this.onDoubleClickTreeValue=_this.onDoubleClickTreeValue.bind(_this);return _this;}_createClass(PDLSubTree,[{key:'getSubtreeNodes',value:function getSubtreeNodes(node){var _this2=this;var result=[node];node.children&&node.children.forEach(function(child){result.push(child);result.push.apply(result,_toConsumableArray(_this2.getSubtreeNodes(child)));});return result;}},{key:'onClickTreeValue',value:function onClickTreeValue(e){var _props=this.props,addSelectedPDLItems=_props.addSelectedPDLItems,ancestorValues=_props.ancestorValues,removeSelectedPDLItems=_props.removeSelectedPDLItems,setSelectedPDLItems=_props.setSelectedPDLItems,tree=_props.tree;e.preventDefault();e.stopPropagation();if(e.ctrlKey||e.metaKey){if(this.isSelected()){var nodes=this.getSubtreeNodes(tree);removeSelectedPDLItems(nodes);}else{addSelectedPDLItems(ancestorValues);}}else{setSelectedPDLItems(ancestorValues);}}},{key:'onDoubleClickTreeValue',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _props2,ancestorValues,selectedPDLItems,setSelectedPDLItems,submitFieldValue,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,nestedValue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props2=this.props,ancestorValues=_props2.ancestorValues,selectedPDLItems=_props2.selectedPDLItems,setSelectedPDLItems=_props2.setSelectedPDLItems,submitFieldValue=_props2.submitFieldValue;setSelectedPDLItems(ancestorValues,e);// TODO: remove the async await when we fix PORT-10666
_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=5;_iterator=selectedPDLItems[Symbol.iterator]();case 7:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=14;break;}nestedValue=_step.value;_context.next=11;return submitFieldValue(nestedValue.value);case 11:_iteratorNormalCompletion=true;_context.next=7;break;case 14:_context.next=20;break;case 16:_context.prev=16;_context.t0=_context['catch'](5);_didIteratorError=true;_iteratorError=_context.t0;case 20:_context.prev=20;_context.prev=21;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 23:_context.prev=23;if(!_didIteratorError){_context.next=26;break;}throw _iteratorError;case 26:return _context.finish(23);case 27:return _context.finish(20);case 28:case'end':return _context.stop();}}},_callee,this,[[5,16,20,28],[21,,23,27]]);}));function onDoubleClickTreeValue(_x){return _ref.apply(this,arguments);}return onDoubleClickTreeValue;}()},{key:'isSelected',value:function isSelected(){var _props3=this.props,ancestorValues=_props3.ancestorValues,selectedPDLItems=_props3.selectedPDLItems;var ancestorIds=ancestorValues.map(function(v){return v.id;});var selectedIds=[].concat(_toConsumableArray(selectedPDLItems)).map(function(v){return v.id;});return ancestorIds.every(function(id){return selectedIds.includes(id);});}},{key:'render',value:function render(){var _props4=this.props,addSelectedPDLItems=_props4.addSelectedPDLItems,ancestorValues=_props4.ancestorValues,filterValue=_props4.filterValue,itemSelectedStyle=_props4.itemSelectedStyle,itemStyle=_props4.itemStyle,level=_props4.level,removeSelectedPDLItems=_props4.removeSelectedPDLItems,selectedPDLItems=_props4.selectedPDLItems,setSelectedPDLItems=_props4.setSelectedPDLItems,submitFieldValue=_props4.submitFieldValue,tree=_props4.tree;var computedItemStyle=this.isSelected()?itemSelectedStyle:itemStyle;var indent=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{minWidth:level*14}});// no arrows for leaf nodes
var arrowClassName=tree.children.length===0?'tree-view_arrow-invisible':null;if(!filterValue||tree.show){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_view_Utilities_TreeView__["a" /* default */],{labelWrapper:function labelWrapper(children){return(// eslint-disable-line react/jsx-no-bind
__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,children));},className:arrowClassName,indent:indent,itemClassName:computedItemStyle,nodeLabel:tree.value,handleOnMouseDown:this.onClickTreeValue,handleOnDoubleClick:this.onDoubleClickTreeValue},tree.children?tree.children.sort(function(a,b){return a.value.localeCompare(b.value);}).map(function(childTree){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(PDLSubTree,{ancestorValues:ancestorValues.concat(childTree),itemSelectedStyle:itemSelectedStyle,itemStyle:itemStyle,key:'PDL-'+childTree.value,level:level+1,selectedPDLItems:selectedPDLItems,setSelectedPDLItems:setSelectedPDLItems,addSelectedPDLItems:addSelectedPDLItems,removeSelectedPDLItems:removeSelectedPDLItems,submitFieldValue:submitFieldValue,tree:childTree,filterValue:filterValue});}):'');}else{return null;}}}]);return PDLSubTree;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);PDLSubTree.propTypes={addSelectedPDLItems:func.isRequired,ancestorValues:array.isRequired,filterValue:string,itemSelectedStyle:string,itemStyle:string,level:number.isRequired,removeSelectedPDLItems:func.isRequired,selectedPDLItems:object.isRequired,setSelectedPDLItems:func.isRequired,submitFieldValue:func.isRequired,tree:object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PDLSubTree);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * There are some problems with this implementation.
 * 1) On chrome, it's easy to inadvertently change the selection while resizing. PORT-8772
 * 2) On safari, there is a resize handle, but you can't resize.
 * 3) On edge and chrome, you can't resize (the resize property isn't supported)
 * In the future we may want to re-implement this, and virtualize it as well to
 * support large lists.
 */var Listbox=function(_Component){_inherits(Listbox,_Component);function Listbox(){_classCallCheck(this,Listbox);return _possibleConstructorReturn(this,(Listbox.__proto__||Object.getPrototypeOf(Listbox)).call(this));}// Public interface called by the parent to get the selection.
_createClass(Listbox,[{key:'getSelectedValues',value:function getSelectedValues(){var options=Array.apply(null,this.selectControl.options);return options.filter(function(option){return option.selected;}).map(function(option){return option.value;});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,className=_props.className,disabled=_props.disabled,initialSize=_props.initialSize,isMultiple=_props.isMultiple,listItems=_props.listItems,onChange=_props.onChange,onItemDoubleClick=_props.onItemDoubleClick,onKeyDown=_props.onKeyDown,testName=_props.testName;// TODO - consider re-implementing without using select - see above.
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{className:className,disabled:disabled,'data-test-name':testName,ref:function ref(input){_this2.selectControl=input;},multiple:isMultiple,onChange:onChange,onKeyDown:onKeyDown,size:initialSize},listItems&&listItems.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{onDoubleClick:function onDoubleClick(){// eslint-disable-line react/jsx-no-bind
if(!disabled&&onItemDoubleClick){onItemDoubleClick(value);}},key:'listbox-'+value,value:value},value);}));}}]);return Listbox;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Listbox.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,initialSize:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,isMultiple:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,listItems:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,onChange:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onItemDoubleClick:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onKeyDown:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,selectRef:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,testName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Listbox);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldForm__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_reducers_catalogReducer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_portfolio_shared_util_fieldDefUtils__ = __webpack_require__(74);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hideDialogPanel=__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel;var setSelectedFieldCategory=__WEBPACK_IMPORTED_MODULE_12_state_reducers_catalogReducer__["a" /* actions */].setSelectedFieldCategory,setSelectedFieldsListItemName=__WEBPACK_IMPORTED_MODULE_12_state_reducers_catalogReducer__["a" /* actions */].setSelectedFieldsListItemName;var initialFieldState={defaultValues:[],hasPredefinedValues:false,id:'',isEmbeddable:false,isExtractable:false,isHierarchical:false,isMultivalued:false,isSearchable:false,isSortable:false,isSystem:false,maxLength:250,nestedPredefinedValues:[],precision:2,predefinedValues:[],showTime:false,systemName:'',type:0,usePredefinedOnly:false};var CreateFieldDialog=function(_Component){_inherits(CreateFieldDialog,_Component);function CreateFieldDialog(){_classCallCheck(this,CreateFieldDialog);var _this=_possibleConstructorReturn(this,(CreateFieldDialog.__proto__||Object.getPrototypeOf(CreateFieldDialog)).call(this));_this.state={field:initialFieldState};_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.handleCreateField=_this.handleCreateField.bind(_this);return _this;}_createClass(CreateFieldDialog,[{key:'isOkEnabled',value:function isOkEnabled(){var systemName=this.props.field.systemName;var allFieldNames=this.props.allFieldNames;var trimmedFieldName=systemName&&systemName.trim();return trimmedFieldName&&!allFieldNames.find(function(old){return old.toLowerCase()===trimmedFieldName.toLowerCase();});}},{key:'handleCreateField',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,addFields,catalogId,field,selectedFieldCategory;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,addFields=_props.addFields,catalogId=_props.catalogId,field=_props.field,selectedFieldCategory=_props.selectedFieldCategory;if(field.type===__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].URL){field.isMultivalued=true;}if(field.type===__WEBPACK_IMPORTED_MODULE_15_portfolio_shared_util_fieldDefUtils__["b" /* FIELD_TYPE */].TEXTBLOCK){field.maxLength=undefined;field.precision=undefined;}_context.next=5;return addFields(catalogId,[field]);case 5:// new field won't be visible unless we're already in All or Custom category
if(selectedFieldCategory!==__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["b" /* FIELDS_CATEGORY_ALL */]&&selectedFieldCategory!==__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["c" /* FIELDS_CATEGORY_CUSTOM */]){this.props.setSelectedFieldCategory(__WEBPACK_IMPORTED_MODULE_14_util_fieldsPageUtils__["b" /* FIELDS_CATEGORY_ALL */]);}this.props.setSelectedFieldsListItemName(field.systemName);case 7:case'end':return _context.stop();}}},_callee,this);}));function handleCreateField(){return _ref.apply(this,arguments);}return handleCreateField;}()},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,field=_props2.field,hideDialogPanel=_props2.hideDialogPanel,formatMessage=_props2.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'650px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CREATE),dialogFocusId:'systemName_create',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onClose:function onClose(){},onSave:this.handleCreateField,panelId:__WEBPACK_IMPORTED_MODULE_7_util_constants__["w" /* CREATE_FIELD_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_ACTION_ADD),showCancel:true,dataTestName:'create-field-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FieldForm__["a" /* CreateFieldForm */],{field:Object.assign({},this.state.field,field)}));}}]);return CreateFieldDialog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var formSelector=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_7_util_constants__["v" /* CREATE_FIELD_FORM */]);function formDefaultValueToFieldDefaultValues(v){return v?[v]:[];}function toNumber(n){if(!n){return 0;}return typeof n==='number'?n:Number(n);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["c" /* getActivePanelId */])(state),allFieldNames:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["G" /* getFieldNames */])(state),field:{systemName:formSelector(state,'systemName'),type:toNumber(formSelector(state,'type')),hasPredefinedValues:formSelector(state,'hasPredefinedValues'),isMultivalued:formSelector(state,'isMultivalued'),maxLength:formSelector(state,'maxLength'),precision:formSelector(state,'precision'),showTime:formSelector(state,'showTime'),usePredefinedOnly:formSelector(state,'usePredefinedOnly'),predefinedValues:formSelector(state,'predefinedValues'),defaultValues:formDefaultValueToFieldDefaultValues(formSelector(state,'defaultValue'))},selectedFieldCategory:Object(__WEBPACK_IMPORTED_MODULE_10_state_selectors__["_19" /* getSelectedFieldCategory */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addFields:__WEBPACK_IMPORTED_MODULE_13_state_commands_catalogCommands__["b" /* addFields */],hideDialogPanel:hideDialogPanel,setSelectedFieldCategory:setSelectedFieldCategory,setSelectedFieldsListItemName:setSelectedFieldsListItemName});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(CreateFieldDialog)));

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_tableUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_fieldsPageUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_view_App_MultipleSelectionTable__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_view_Pages_PageHeader__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MetadataDefinitionsDialog=function(_Component){_inherits(MetadataDefinitionsDialog,_Component);function MetadataDefinitionsDialog(){_classCallCheck(this,MetadataDefinitionsDialog);var _this=_possibleConstructorReturn(this,(MetadataDefinitionsDialog.__proto__||Object.getPrototypeOf(MetadataDefinitionsDialog)).call(this));_this.state={selectionState:Object(__WEBPACK_IMPORTED_MODULE_4_util_tableUtils__["d" /* getNewSelectionState */])(),sortBy:'displayName',sortDirection:__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["g" /* SortDirection */].ASC,sortedMetadataDefinitions:[]};_this.createMetadataDefinition=_this.createMetadataDefinition.bind(_this);_this.dataTypeCellRenderer=_this.dataTypeCellRenderer.bind(_this);_this.getSelectedMetadataDefinition=_this.getSelectedMetadataDefinition.bind(_this);_this.handleSelectionChanged=_this.handleSelectionChanged.bind(_this);_this.removeMetadataDefinition=_this.removeMetadataDefinition.bind(_this);_this.sort=_this.sort.bind(_this);return _this;}_createClass(MetadataDefinitionsDialog,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,stateProps){if(this.props.metadataDefinitions!==nextProps.metadataDefinitions){var _sortedMetadataDefinitions=this.sortMetadataDefinitions(nextProps.metadataDefinitions,this.state.sortBy,this.state.sortDirection);this.setState({sortedMetadataDefinitions:_sortedMetadataDefinitions,selectionState:Object(__WEBPACK_IMPORTED_MODULE_4_util_tableUtils__["h" /* reindexSelectedItems */])(_sortedMetadataDefinitions,this.state.selectionState)});}}},{key:'componentDidMount',value:function componentDidMount(){this.props.getMetadataDefinitionsAction();}},{key:'dataTypeCellRenderer',value:function dataTypeCellRenderer(_ref){var rowData=_ref.rowData;return this.props.intl.formatMessage(Object(__WEBPACK_IMPORTED_MODULE_10_util_fieldsPageUtils__["H" /* metadataTypeToLocalizedString */])(rowData.dataType));}},{key:'sortMetadataDefinitions',value:function sortMetadataDefinitions(metadataDefs,sortBy,sortDirection){var formatMessage=this.props.intl.formatMessage;var sorted=metadataDefs.sort(function(a,b){var aVal=a[sortBy];var bVal=b[sortBy];if(sortBy==='dataType'){aVal=formatMessage(Object(__WEBPACK_IMPORTED_MODULE_10_util_fieldsPageUtils__["H" /* metadataTypeToLocalizedString */])(aVal));bVal=formatMessage(Object(__WEBPACK_IMPORTED_MODULE_10_util_fieldsPageUtils__["H" /* metadataTypeToLocalizedString */])(bVal));}return aVal.localeCompare(bVal);});return sortDirection===__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["g" /* SortDirection */].ASC?sorted:sorted.reverse();}},{key:'sort',value:function sort(_ref2){var sortBy=_ref2.sortBy,sortDirection=_ref2.sortDirection;var sortedMetadataDefinitions=this.sortMetadataDefinitions(this.props.metadataDefinitions,sortBy,sortDirection);this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_4_util_tableUtils__["h" /* reindexSelectedItems */])(sortedMetadataDefinitions,this.state.selectionState),sortedMetadataDefinitions:sortedMetadataDefinitions,sortBy:sortBy,sortDirection:sortDirection});}},{key:'handleSelectionChanged',value:function handleSelectionChanged(selectionState){this.setState({selectionState:selectionState});}},{key:'removeMetadataDefinition',value:function removeMetadataDefinition(){var md=this.getSelectedMetadataDefinition();this.props.deleteMetadataDefinitionAction(md.id);}},{key:'createMetadataDefinition',value:function createMetadataDefinition(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["z" /* CREATE_METADATA_PANEL_ID */]);}},{key:'getSelectedMetadataDefinition',value:function getSelectedMetadataDefinition(){var _state=this.state,selectionState=_state.selectionState,sortedMetadataDefinitions=_state.sortedMetadataDefinitions;var selectedIndices=Object(__WEBPACK_IMPORTED_MODULE_4_util_tableUtils__["e" /* getSelectedIndices */])(selectionState);if(selectedIndices.length===1){var selectedMetadataDef=sortedMetadataDefinitions[selectedIndices[0]];return selectedMetadataDef;}}},{key:'renderPanelHeader',value:function renderPanelHeader(){var formatMessage=this.props.intl.formatMessage;var selectedMetadataDef=this.getSelectedMetadataDefinition();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-test-name':'dialog-panel-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_view_Pages_PageHeader__["a" /* default */],{deleteDisabled:!selectedMetadataDef||!selectedMetadataDef.isEditable,onClickAdd:this.createMetadataDefinition,onClickDelete:this.removeMetadataDefinition,title:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_METADATA_DEFINITIONS_TITLE)}));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activePanelId=_props.activePanelId,hideDialogPanel=_props.hideDialogPanel,formatMessage=_props.intl.formatMessage;var _state2=this.state,selectionState=_state2.selectionState,sortedMetadataDefinitions=_state2.sortedMetadataDefinitions,sortBy=_state2.sortBy,sortDirection=_state2.sortDirection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'850px',height:null},hideDialogPanel:hideDialogPanel,panelHeader:this.renderPanelHeader(),panelId:__WEBPACK_IMPORTED_MODULE_9_util_constants__["R" /* METADATA_PANEL_ID */],showCancel:false,customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].OK)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'500px',width:'850px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["b" /* AutoSizer */],null,function(_ref3){var height=_ref3.height,width=_ref3.width;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_App_MultipleSelectionTable__["a" /* default */],{headerHeight:40,height:height,onSelectionChanged:_this2.handleSelectionChanged,rowHeight:30,selectionState:selectionState,singleSelectionOnly:true,sort:_this2.sort,sortBy:sortBy,sortDirection:sortDirection,sortedItems:sortedMetadataDefinitions,width:width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_METADATA_NAME_LABEL),dataKey:'displayName',width:300}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'tag',label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_METADATA_TAG_LABEL),width:300}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'type',label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_METADATA_TYPE_LABEL),width:100}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'dataType',label:formatMessage(__WEBPACK_IMPORTED_MODULE_11_util_localizedStrings__["a" /* default */].FIELD_METADATA_DATA_TYPE_LABEL),cellRenderer:_this2.dataTypeCellRenderer,width:175}));})));}}]);return MetadataDefinitionsDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state),metadataDefinitions:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["_9" /* getMetadataDefinitions */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteMetadataDefinitionAction:__WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__["j" /* deleteMetadataDefinition */],getMetadataDefinitionsAction:__WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__["q" /* getMetadataDefinitions */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(MetadataDefinitionsDialog)));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hideDialogPanel=__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].hideDialogPanel;var initialFieldState={canEmbed:true,dataType:'String',displayName:'',displayNames:[],id:'',isEditable:true,multivalueType:'NotMultiValued',namespace:'dc',parentId:'',tag:'',type:__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["d" /* FIELDS_CATEGORY_XMP */]};var CreateMetadataDefinitionDialog=function(_Component){_inherits(CreateMetadataDefinitionDialog,_Component);function CreateMetadataDefinitionDialog(){_classCallCheck(this,CreateMetadataDefinitionDialog);var _this=_possibleConstructorReturn(this,(CreateMetadataDefinitionDialog.__proto__||Object.getPrototypeOf(CreateMetadataDefinitionDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(CreateMetadataDefinitionDialog,[{key:'componentDidMount',value:function componentDidMount(){this.props.getCustomXmpNamespacesAction();}},{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(values){var createMetadataDefinitions,metadataDefinition,tagPrefix;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:createMetadataDefinitions=this.props.createMetadataDefinitions;metadataDefinition=Object.assign({},values);// special case for tag
tagPrefix=values.type===__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["d" /* FIELDS_CATEGORY_XMP */]?values.namespace+':':'';metadataDefinition.tag=''+tagPrefix+values.tag;_context.next=6;return createMetadataDefinitions([metadataDefinition]);case 6:case'end':return _context.stop();}}},_callee,this);}));function submit(_x){return _ref.apply(this,arguments);}return submit;}()},{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,customXMPNamespaces=_props.customXMPNamespaces,handleSubmit=_props.handleSubmit,hideDialogPanel=_props.hideDialogPanel,formatMessage=_props.intl.formatMessage,metadataDefinitions=_props.metadataDefinitions,namespace=_props.namespace,type=_props.type;var namespaces=Object(__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["A" /* getMetadataNamespaces */])(customXMPNamespaces,metadataDefinitions);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'650px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CREATE),dialogFocusId:'displayName',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onClose:function onClose(){},onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_6_util_constants__["z" /* CREATE_METADATA_PANEL_ID */],panelTitle:'Create Metadata Definition',showCancel:true,dataTestName:'create-metadata-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'portfolio-form-container',onSubmit:handleSubmit(this.submit)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FIELD_METADATA_NAME_LABEL)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'input',component:'input',id:'displayName',name:'displayName',type:'text'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FIELD_METADATA_TYPE_LABEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'type',name:'type'},__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["m" /* MD_TYPES */].map(function(type){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:type.id,value:type.id},formatMessage(type.label));}))))))),type===__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["d" /* FIELDS_CATEGORY_XMP */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FIELD_METADATA_NAMESPACE_LABEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'namespace',name:'namespace'},namespaces.map(function(ns){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:ns,value:ns},ns);}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-horizontal has-addons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FIELD_METADATA_TAG_LABEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field has-addons'},type===__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["d" /* FIELDS_CATEGORY_XMP */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-static'},namespace,':')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'input',component:'input',id:'tag',name:'tag',type:'text'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FIELD_METADATA_DATA_TYPE_LABEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'dataType',name:'dataType'},__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["i" /* MD_DATATYPES */].map(function(type){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:type.id,value:type.id},formatMessage(type.label));}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].FIELD_METADATA_MULTIVALUED_TYPE_LABEL))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'multivalueType',name:'multivalueType'},__WEBPACK_IMPORTED_MODULE_13_util_fieldsPageUtils__["l" /* MD_MULTIVALUED_TYPES */].map(function(type){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:type.id,value:type.id},formatMessage(type.label));})))))))));}}]);return CreateMetadataDefinitionDialog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function validate(data,props){var errors={};if(!data.displayName){errors.displayName='Required';}if(!data.tag){errors.tag='Required';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_6_util_constants__["y" /* CREATE_METADATA_FORM_ID */],initialValues:initialFieldState,validate:validate})(CreateMetadataDefinitionDialog);var selector=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_6_util_constants__["y" /* CREATE_METADATA_FORM_ID */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state),customXMPNamespaces:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["s" /* getCustomXMPNamespaces */])(state),metadataDefinitions:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["_9" /* getMetadataDefinitions */])(state),namespace:selector(state,'namespace'),type:selector(state,'type')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({createMetadataDefinitions:__WEBPACK_IMPORTED_MODULE_11_state_commands_catalogCommands__["f" /* createMetadataDefinitions */],getCustomXmpNamespacesAction:__WEBPACK_IMPORTED_MODULE_11_state_commands_catalogCommands__["o" /* getCustomXmpNamespaces */],hideDialogPanel:hideDialogPanel});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_tableUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_App_MultipleSelectionTable__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_view_Pages_PageHeader__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var XMPNamespacesDialog=function(_Component){_inherits(XMPNamespacesDialog,_Component);function XMPNamespacesDialog(){_classCallCheck(this,XMPNamespacesDialog);var _this=_possibleConstructorReturn(this,(XMPNamespacesDialog.__proto__||Object.getPrototypeOf(XMPNamespacesDialog)).call(this));_this.state={selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["d" /* getNewSelectionState */])(),sortBy:'namespace',sortDirection:__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["g" /* SortDirection */].ASC,sortedNamespaceDefinitions:[]};_this.createNamespaceDefinition=_this.createNamespaceDefinition.bind(_this);_this.handleSelectionChanged=_this.handleSelectionChanged.bind(_this);_this.removeNamespaceDefinitions=_this.removeNamespaceDefinitions.bind(_this);_this.sort=_this.sort.bind(_this);return _this;}_createClass(XMPNamespacesDialog,[{key:'componentDidMount',value:function componentDidMount(){this.props.getCustomXMPNamespacesAction();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,stateProps){if(this.props.customXMPNamespaces!==nextProps.customXMPNamespaces){var _sortedNamespaceDefinitions=this.sortNamespaceDefinitions(nextProps.customXMPNamespaces,this.state.sortBy,this.state.sortDirection);this.setState({sortedNamespaceDefinitions:_sortedNamespaceDefinitions,selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["h" /* reindexSelectedItems */])(_sortedNamespaceDefinitions,this.state.selectionState)});}}},{key:'handleSelectionChanged',value:function handleSelectionChanged(selectionState){this.setState({selectionState:selectionState});}},{key:'sortNamespaceDefinitions',value:function sortNamespaceDefinitions(namespaceDefinitions,sortBy,sortDirection){var sorted=namespaceDefinitions.sort(function(a,b){var aVal=a[sortBy];var bVal=b[sortBy];return aVal.localeCompare(bVal);});return sortDirection===__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["g" /* SortDirection */].ASC?sorted:sorted.reverse();}},{key:'sort',value:function sort(_ref){var sortBy=_ref.sortBy,sortDirection=_ref.sortDirection;var sortedNamespaceDefinitions=this.sortNamespaceDefinitions(this.props.customXMPNamespaces,sortBy,sortDirection);this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["h" /* reindexSelectedItems */])(sortedNamespaceDefinitions,this.state.selectionState),sortedNamespaceDefinitions:sortedNamespaceDefinitions,sortBy:sortBy,sortDirection:sortDirection});}},{key:'removeNamespaceDefinitions',value:function removeNamespaceDefinitions(){var _this2=this;var namespaceIds=Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["e" /* getSelectedIndices */])(this.state.selectionState).map(function(idx){return _this2.state.sortedNamespaceDefinitions[idx].id;});if(namespaceIds.length){this.props.removeCustomXmpNamespaces(namespaceIds);}}},{key:'createNamespaceDefinition',value:function createNamespaceDefinition(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_6_util_constants__["C" /* CREATE_XMP_NAMESPACE_PANEL_ID */]);}},{key:'renderPanelHeader',value:function renderPanelHeader(){var formatMessage=this.props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-test-name':'dialog-panel-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_Pages_PageHeader__["a" /* default */],{deleteDisabled:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["e" /* getSelectedIndices */])(this.state.selectionState).length===0,onClickAdd:this.createNamespaceDefinition,onClickDelete:this.removeNamespaceDefinitions,title:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES)}));}},{key:'render',value:function render(){var _this3=this;var _props=this.props,activePanelId=_props.activePanelId,formatMessage=_props.intl.formatMessage;var _state=this.state,selectionState=_state.selectionState,sortBy=_state.sortBy,sortDirection=_state.sortDirection,sortedNamespaceDefinitions=_state.sortedNamespaceDefinitions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'600px',height:null},hideDialogPanel:this.props.hideDialogPanel,panelId:__WEBPACK_IMPORTED_MODULE_6_util_constants__["_16" /* XMP_NAMESPACE_PANEL_ID */],panelHeader:this.renderPanelHeader(),showCancel:false,customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].OK)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'300px',width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["b" /* AutoSizer */],null,function(_ref2){var height=_ref2.height,width=_ref2.width;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_App_MultipleSelectionTable__["a" /* default */],{headerHeight:40,height:height,onSelectionChanged:_this3.handleSelectionChanged,rowHeight:30,selectionState:selectionState,singleSelectionOnly:true,sort:_this3.sort,sortBy:sortBy,sortDirection:sortDirection,sortedItems:sortedNamespaceDefinitions,width:width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'preferredAbbreviation',label:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_NAMESPACE_ABBREVIATION),width:300}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized__["e" /* Column */],{className:'list-item',label:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].FIELD_NAMESPACE_URI),dataKey:'namespace',width:300}));})));}}]);return XMPNamespacesDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["c" /* getActivePanelId */])(state),customXMPNamespaces:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["s" /* getCustomXMPNamespaces */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getCustomXMPNamespacesAction:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["o" /* getCustomXmpNamespaces */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],removeCustomXmpNamespaces:__WEBPACK_IMPORTED_MODULE_10_state_commands_catalogCommands__["t" /* removeCustomXmpNamespaces */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(XMPNamespacesDialog)));

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Forms_FormField__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_commands_catalogCommands__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function renderInput(_ref){var id=_ref.id,input=_ref.input,type=_ref.type,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error,warning=_ref$meta.warning;var hasError=error&&touched;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({},input,{id:id,className:'input '+(hasError?'is-danger':''),type:type}));}var CreateXMPNamespaceDialog=function(_Component){_inherits(CreateXMPNamespaceDialog,_Component);function CreateXMPNamespaceDialog(){_classCallCheck(this,CreateXMPNamespaceDialog);var _this=_possibleConstructorReturn(this,(CreateXMPNamespaceDialog.__proto__||Object.getPrototypeOf(CreateXMPNamespaceDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(CreateXMPNamespaceDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'submit',value:function submit(data,props){this.props.addCustomXmpNamespaces([{id:0,namespace:data.uri,preferredAbbreviation:data.abbreviation}]);}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,handleSubmit=_props.handleSubmit,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'600px',height:null},dialogFocusId:'abbreviation',hideDialogPanel:this.props.hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_7_util_constants__["C" /* CREATE_XMP_NAMESPACE_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].FIELD_NEW_NAMESPACE_TITLE),showCancel:true,customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SUBMIT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].FIELD_NAMESPACE_ABBREVIATION)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{id:'abbreviation',name:'abbreviation',component:renderInput,type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_Forms_FormField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].FIELD_NAMESPACE_URI)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{name:'uri',component:renderInput,type:'text'}))));}}]);return CreateXMPNamespaceDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};if(!data.abbreviation){errors.abbreviation='Required';}else if(props.customXmpNamespaces.find(function(ns){return ns.preferredAbbreviation===data.abbreviation;})){errors.abbreviation='Duplicate';}if(!data.uri){errors.uri='Required';}else if(props.customXmpNamespaces.find(function(ns){return ns.namespace===data.uri;})){errors.uri='Duplicate';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_7_util_constants__["C" /* CREATE_XMP_NAMESPACE_PANEL_ID */],validate:validate})(CreateXMPNamespaceDialog);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state),customXmpNamespaces:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["s" /* getCustomXMPNamespaces */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({addCustomXmpNamespaces:__WEBPACK_IMPORTED_MODULE_11_state_commands_catalogCommands__["a" /* addCustomXmpNamespaces */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_certCommands__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_certUtils__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CreateCertRequestDialog__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CertUploadDialog__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showDialogPanel=__WEBPACK_IMPORTED_MODULE_12_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel;var CertsPage=function(_Component){_inherits(CertsPage,_Component);function CertsPage(){_classCallCheck(this,CertsPage);var _this=_possibleConstructorReturn(this,(CertsPage.__proto__||Object.getPrototypeOf(CertsPage)).call(this));_this.handleDeleteCertRequest=_this.handleDeleteCertRequest.bind(_this);_this.handleDownloadCertRequest=_this.handleDownloadCertRequest.bind(_this);_this.handleShowCreateCertRequestDialog=_this.handleShowCreateCertRequestDialog.bind(_this);_this.handleShowUploadCertDialog=_this.handleShowUploadCertDialog.bind(_this);_this.renderStatus=_this.renderStatus.bind(_this);return _this;}_createClass(CertsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getCertStatus();}},{key:'handleDeleteCertRequest',value:function handleDeleteCertRequest(){this.props.deleteCertRequest();}},{key:'handleDownloadCertRequest',value:function handleDownloadCertRequest(){this.props.downloadCertRequest();}},{key:'handleShowCreateCertRequestDialog',value:function handleShowCreateCertRequestDialog(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["u" /* CREATE_CERT_REQUEST_PANEL_ID */]);}},{key:'handleShowUploadCertDialog',value:function handleShowUploadCertDialog(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["p" /* CERT_UPLOAD_PANEL_ID */]);}},{key:'renderStatus',value:function renderStatus(){var certInfo=this.props.certInfo;var msg=Object(__WEBPACK_IMPORTED_MODULE_8_util_certUtils__["b" /* getCertStatusText */])(certInfo);var style=Object(__WEBPACK_IMPORTED_MODULE_8_util_certUtils__["a" /* getCertStatusStyle */])(certInfo);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATUS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle '+style,'data-test-name':'cert-status-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],msg)));}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,certInfo=_props.certInfo,certRequest=_props.certRequest,_props$intl=_props.intl,formatDate=_props$intl.formatDate,formatMessage=_props$intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'cert-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERTS_TITLE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-inverted is-outlined','data-test-name':'cert-create-request-button',onClick:this.handleShowCreateCertRequestDialog},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_CREATE_REQUEST)),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-inverted is-outlined','data-test-name':'cert-import-button',onClick:this.handleShowUploadCertDialog},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_IMPORT)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container is-textured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},this.renderStatus(),certInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-info-owner',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_OWNER),value:certInfo.owner}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-info-alt-names',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].SUBJECT_ALTERNATIVE_NAMES),value:certInfo.subjectAlternativeNames&&certInfo.subjectAlternativeNames.toString()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-info-issuer',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_ISSUER),value:certInfo.issuer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-info-expiration',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_EXPIRATION_DATE),value:formatDate(certInfo.endDate)}))),certRequest&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certSectionHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_PENDING_REQUEST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined','data-test-name':'cert-request-delete-button',onClick:this.handleDeleteCertRequest},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-minus-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].DELETE)),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-outlined','data-test-name':'cert-request-download-button',onClick:this.handleDownloadCertRequest},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CERT_DOWNLOAD)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-domain-name',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].FULLY_QUALIFIED_DOMAIN_NAME),value:certRequest.FQDN}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-org-name',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].ORGANIZATION_NAME),value:certRequest.organizationName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-org-unit',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].ORGANIZATIONAL_UNIT),value:certRequest.organizationalUnit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-city',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CITY_OR_LOCALITY),value:certRequest.cityOrLocality}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-state',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATE_OR_PROVINCE),value:certRequest.stateOrProvince}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-country',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].TWO_LETTER_COUNTRY_CODE),value:certRequest.countryCode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-alt-names',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].SUBJECT_ALTERNATIVE_NAMES),value:certRequest.subjectAlternativeNames&&certRequest.subjectAlternativeNames.toString()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'cert-request-created-date',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CREATED_ON_DATE),value:formatDate(certRequest.timestamp)}))))),activePanelId===__WEBPACK_IMPORTED_MODULE_9_util_constants__["u" /* CREATE_CERT_REQUEST_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CreateCertRequestDialog__["a" /* default */],null),activePanelId===__WEBPACK_IMPORTED_MODULE_9_util_constants__["p" /* CERT_UPLOAD_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CertUploadDialog__["a" /* default */],null));}}]);return CertsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var certsPageWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["c" /* getActivePanelId */])(state),certInfo:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["o" /* getCertInfo */])(state),certRequest:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["p" /* getCertRequestData */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteCertRequest:__WEBPACK_IMPORTED_MODULE_7_state_commands_certCommands__["b" /* deleteCertRequest */],downloadCertRequest:__WEBPACK_IMPORTED_MODULE_7_state_commands_certCommands__["c" /* downloadCertRequest */],getCertStatus:__WEBPACK_IMPORTED_MODULE_7_state_commands_certCommands__["d" /* getCertStatus */],showDialogPanel:showDialogPanel});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(CertsPage));/* harmony default export */ __webpack_exports__["a"] = (certsPageWrapper);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_CERT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_CERT_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_CERT_REQUEST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_CERT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_CERT_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_CERT_REQUEST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_CERT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_CERT_STATUS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_CERT_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IMPORT_CERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IMPORT_CERT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return IMPORT_CERT_SUCCESS; });
var CREATE_CERT_REQUEST='admin/cert/CREATE_CERT_REQUEST_STATUS';var CREATE_CERT_REQUEST_SUCCESS='admin/cert/CREATE_CERT_REQUEST_SUCCESS';var CREATE_CERT_REQUEST_FAIL='admin/cert/CREATE_CERT_REQUEST_FAIL';var DELETE_CERT_REQUEST='admin/cert/DELETE_CERT_REQUEST_STATUS';var DELETE_CERT_REQUEST_SUCCESS='admin/cert/DELETE_CERT_REQUEST_SUCCESS';var DELETE_CERT_REQUEST_FAIL='admin/cert/DELETE_CERT_REQUEST_FAIL';var GET_CERT_STATUS='admin/cert/GET_CERT_STATUS';var GET_CERT_STATUS_SUCCESS='admin/cert/GET_CERT_STATUS_SUCCESS';var GET_CERT_STATUS_FAIL='admin/cert/GET_CERT_STATUS_FAIL';var IMPORT_CERT='admin/cert/IMPORT_CERT';var IMPORT_CERT_SUCCESS='admin/cert/IMPORT_CERT_SUCCESS';var IMPORT_CERT_FAIL='admin/cert/IMPORT_CERT_FAIL';

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_commands_certCommands__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_certUtils__ = __webpack_require__(391);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fields=[{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].FULLY_QUALIFIED_DOMAIN_NAME,dataTestName:'cert-create-request-fqdn',id:'FQDN',isRequired:true},{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].ORGANIZATION_NAME,dataTestName:'cert-create-request-org-name',id:'organizationName',isRequired:true},{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].ORGANIZATIONAL_UNIT,dataTestName:'cert-create-request-org-unit',id:'organizationalUnit'},{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CITY_OR_LOCALITY,dataTestName:'cert-create-request-city',id:'cityOrLocality',isRequired:true},{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].STATE_OR_PROVINCE,dataTestName:'cert-create-request-state',id:'stateOrProvince',isRequired:true},{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].TWO_LETTER_COUNTRY_CODE,dataTestName:'cert-create-request-country',id:'countryCode',isRequired:true},{label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SUBJECT_ALTERNATIVE_NAMES,dataTestName:'cert-create-request-alt-names',id:'subjectAlternativeNames'}];var CreateCertRequestDialog=function(_Component){_inherits(CreateCertRequestDialog,_Component);function CreateCertRequestDialog(){_classCallCheck(this,CreateCertRequestDialog);var _this=_possibleConstructorReturn(this,(CreateCertRequestDialog.__proto__||Object.getPrototypeOf(CreateCertRequestDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(CreateCertRequestDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'submit',value:function submit(data,props){var certRequest=Object.assign({},data);certRequest.subjectAlternativeNames=Object(__WEBPACK_IMPORTED_MODULE_12_util_certUtils__["c" /* normalizeSANs */])(certRequest.subjectAlternativeNames,certRequest.FQDN);this.props.createCertRequest(certRequest);}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,handleSubmit=_props.handleSubmit,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'800px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CREATE),hideDialogPanel:this.props.hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_7_util_constants__["u" /* CREATE_CERT_REQUEST_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CERT_CREATE_REQUEST),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container'},fields.map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_Forms_LabeledField__["a" /* default */],{key:field.id,label:formatMessage(field.label)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'input',component:'input','data-test-name':field.dataTestName||'',id:field.id,name:field.id,type:'text'}));})));}}]);return CreateCertRequestDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};fields.forEach(function(field){if(field.isRequired&&!data[field.id]){errors[field.id]='Required';}});return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_7_util_constants__["u" /* CREATE_CERT_REQUEST_PANEL_ID */],validate:validate})(CreateCertRequestDialog);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({createCertRequest:__WEBPACK_IMPORTED_MODULE_11_state_commands_certCommands__["a" /* createCertRequest */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_certCommands__ = __webpack_require__(226);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MODE_NONE='none';var MODE_UNBUNDLED='unbundled';var MODE_PKCS='pkcs';var allCertFileTypes='.cer, .crt, .p7, .p7b, .p12, .pem, .pfx';var pemFileTypes='.cer, .crt, .pem';var CertUploadDialog=function(_Component){_inherits(CertUploadDialog,_Component);function CertUploadDialog(){_classCallCheck(this,CertUploadDialog);var _this=_possibleConstructorReturn(this,(CertUploadDialog.__proto__||Object.getPrototypeOf(CertUploadDialog)).call(this));_this.state={mode:MODE_NONE,mainCertFile:undefined,intermediateCertFile1:undefined,intermediateCertFile2:undefined,rootCertFile:undefined,password:undefined};_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.onFileSelected=_this.onFileSelected.bind(_this);_this.onPasswordUpdated=_this.onPasswordUpdated.bind(_this);_this.renderFilePicker=_this.renderFilePicker.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(CertUploadDialog,[{key:'onFileSelected',value:function onFileSelected(e){var file=e.target.files&&e.target.files[0];if(e.target.name==='mainCertFile'){// TODO: if mode is unbundled, require there be a pending request?
this.setState({mainCertFile:file,mode:this.modeForMainFile(file)});}else{this.setState(_defineProperty({},e.target.name,file));}}},{key:'onPasswordUpdated',value:function onPasswordUpdated(e){this.setState({password:e.target.value});}},{key:'modeForMainFile',value:function modeForMainFile(file){if(!file){return MODE_NONE;}var extension=file.name.split('.').pop();return this.isPemExtension(extension)?MODE_UNBUNDLED:MODE_PKCS;}},{key:'isPemExtension',value:function isPemExtension(extension){return extension==='pem'||extension==='cer'||extension==='crt';}},{key:'isOkEnabled',value:function isOkEnabled(){var _state=this.state,mode=_state.mode,rootCertFile=_state.rootCertFile;if(mode===MODE_NONE){return false;}else if(mode===MODE_PKCS){return true;}else{return!!rootCertFile;}}},{key:'submit',value:function submit(){var _state2=this.state,mainCertFile=_state2.mainCertFile,intermediateCertFile1=_state2.intermediateCertFile1,intermediateCertFile2=_state2.intermediateCertFile2,rootCertFile=_state2.rootCertFile,password=_state2.password;var uploadData={mainCertFile:mainCertFile,intermediateCertFile1:intermediateCertFile1,intermediateCertFile2:intermediateCertFile2,rootCertFile:rootCertFile,password:password};this.props.uploadCert(uploadData);}},{key:'renderFilePicker',value:function renderFilePicker(name,labelId,accept,file){var className=(file?'':'is-primary')+' file has-name is-fullwidth is-right';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],labelId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'file-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{accept:accept,className:'file-input',name:name,onChange:this.onFileSelected,type:'file','data-test-name':'cert-input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-cta'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE_PROMPT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-name is-right'},file&&file.name||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].NO_FILE_SELECTED)))),!file&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-indented'},'(',accept,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}));}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,formatMessage=_props.intl.formatMessage;var isUnbundledCert=this.state.mode===MODE_UNBUNDLED;var isPkcsCert=this.state.mode===MODE_PKCS;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'500px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].USER_IMPORT_IMPORT),hideDialogPanel:this.props.hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:this.submit,panelId:__WEBPACK_IMPORTED_MODULE_6_util_constants__["p" /* CERT_UPLOAD_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_IMPORT),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container'},this.renderFilePicker('mainCertFile',__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE,allCertFileTypes,this.state.mainCertFile),isUnbundledCert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderFilePicker('intermediateCertFile1',__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE_INT_1,pemFileTypes,this.state.intermediateCertFile1),this.renderFilePicker('intermediateCertFile2',__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE_INT_2,pemFileTypes,this.state.intermediateCertFile2),this.renderFilePicker('rootCertFile',__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE_ROOT,pemFileTypes,this.state.rootCertFile)),isPkcsCert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE_PASSWORD)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'input',type:'password',onChange:this.onPasswordUpdated}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].CERT_FILE_PASSWORD_HELP)))))));}}]);return CertUploadDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__["a" /* bindActionCreatorsForm */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_4_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],uploadCert:__WEBPACK_IMPORTED_MODULE_9_state_commands_certCommands__["e" /* uploadCert */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(CertUploadDialog)));

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DirectoryServicesPage__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DirectoryServiceDescriptionPage__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DirectoryServicesMappingsPage__ = __webpack_require__(393);
/* unused harmony reexport DirectoryServiceDescriptionPage */
/* unused harmony reexport DirectoryServicesMappingsPage */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DirectoryServicesPage__["a" /* default */]);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_dirSvcCommands__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DirectoryServiceDescriptionPage__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DirectoryServicesMappingsPage__ = __webpack_require__(393);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DirectoryServicesPage=function(_Component){_inherits(DirectoryServicesPage,_Component);function DirectoryServicesPage(){_classCallCheck(this,DirectoryServicesPage);var _this=_possibleConstructorReturn(this,(DirectoryServicesPage.__proto__||Object.getPrototypeOf(DirectoryServicesPage)).call(this));_this.handleShowMappings=_this.handleShowMappings.bind(_this);_this.handleSync=_this.handleSync.bind(_this);return _this;}_createClass(DirectoryServicesPage,[{key:'handleSync',value:function handleSync(){var _props=this.props,formatMessage=_props.intl.formatMessage,syncMappingsCommand=_props.syncMappingsCommand;var msg=formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].LDAP_SYNC_NOTIFICATION);syncMappingsCommand(msg);}},{key:'handleShowMappings',value:function handleShowMappings(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["H" /* DIR_SVC_MAPPINGS_PANEL_ID */]);}},{key:'render',value:function render(){var activePanelId=this.props.activePanelId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'directory-services-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICES_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-inverted is-outlined','data-test-name':'directory-services-configuration',onClick:this.handleShowMappings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_MAPIINGS_TITLE)),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-inverted is-outlined','data-test-name':'synchronize-now',onClick:this.handleSync},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-refresh'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].SYNCHRONIZE_NOW))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DirectoryServiceDescriptionPage__["a" /* default */],null),activePanelId===__WEBPACK_IMPORTED_MODULE_9_util_constants__["H" /* DIR_SVC_MAPPINGS_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DirectoryServicesMappingsPage__["a" /* default */],null));}}]);return DirectoryServicesPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({showDialogPanel:__WEBPACK_IMPORTED_MODULE_3_state_commands_dialogPanelCommands__["b" /* showDialogPanel */],syncMappingsCommand:__WEBPACK_IMPORTED_MODULE_4_state_commands_dirSvcCommands__["f" /* syncMappings */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(DirectoryServicesPage)));

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_DIR_SVC_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_DIR_SVC_MAPPINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_DIR_SVC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_DIR_SVC_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_DIR_SVC_MAPPINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_DIR_SVC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return QUERY_DIR_SVC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return QUERY_DIR_SVC_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return QUERY_DIR_SVC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_DIR_SVC_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_QUERY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_QUERY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_SELECTED_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SYNC_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SYNC_MAPPINGS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SYNC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_DIR_SVC_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_DIR_SVC_MAPPING_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_DIR_SVC_MAPPING_SUCCESS; });
var ADD_DIR_SVC_MAPPINGS='/admin/dirSvc/ADD_DIR_SVC_MAPPINGS';var ADD_DIR_SVC_MAPPINGS_FAIL='/admin/dirSvc/ADD_DIR_SVC_MAPPINGS_FAIL';var ADD_DIR_SVC_MAPPINGS_SUCCESS='/admin/dirSvc/ADD_DIR_SVC_MAPPINGS_SUCCESS';var GET_DIR_SVC_MAPPINGS='/admin/dirSvc/GET_DIR_SVC_MAPPINGS';var GET_DIR_SVC_MAPPINGS_FAIL='/admin/dirSvc/GET_DIR_SVC_MAPPINGS_FAIL';var GET_DIR_SVC_MAPPINGS_SUCCESS='/admin/dirSvc/GET_DIR_SVC_MAPPINGS_SUCCESS';var QUERY_DIR_SVC='/admin/dirSvc/QUERY_DIR_SVC';var QUERY_DIR_SVC_FAIL='admin/dirSvc/QUERY_DIR_SVC_FAIL';var QUERY_DIR_SVC_SUCCESS='admin/dirSvc/QUERY_DIR_SVC_SUCCESS';var RESET_STATE='admin/dirSvc/RESET_STATE';var SET_QUERY_PENDING='admin/dirSvc/SET_QUERY_PENDING';var SET_DESTINATION='admin/dirSvc/SET_DESTINATION';var SET_DIR_SVC_MAPPING='admin/dirSvc/SET_DIR_SVC_MAPPING';var SET_QUERY_TYPE='admin/dirSvc/SET_QUERY_TYPE';var SET_SELECTED_NODE='admin/dirSvc/SET_SELECTED_NODE';var SYNC_MAPPINGS='admin/dirSvc/SYNC_MAPPINGS';var SYNC_MAPPINGS_SUCCESS='admin/dirSvc/SYNC_MAPPINGS_SUCCESS';var SYNC_MAPPINGS_FAIL='admin/dirSvc/SYNC_MAPPINGS_FAIL';var UPDATE_DIR_SVC_MAPPING='admin/dirSvc/UPDATE_DIR_SVC_MAPPING';var UPDATE_DIR_SVC_MAPPING_FAIL='admin/dirSvc/UPDATE_DIR_SVC_MAPPING_FAIL';var UPDATE_DIR_SVC_MAPPING_SUCCESS='admin/dirSvc/UPDATE_DIR_SVC_MAPPING_SUCCESS';

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dirSvcCommands__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_roleCommands__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_reducers_dirSvcReducer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DestinationNode__ = __webpack_require__(956);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setDestinationAction=__WEBPACK_IMPORTED_MODULE_7_state_reducers_dirSvcReducer__["a" /* actions */].setDestination;var DestinationsView=function(_Component){_inherits(DestinationsView,_Component);function DestinationsView(){_classCallCheck(this,DestinationsView);var _this=_possibleConstructorReturn(this,(DestinationsView.__proto__||Object.getPrototypeOf(DestinationsView)).call(this));_this.state={hasDeletes:false,selectedNode:undefined};_this.handleSelectNode=_this.handleSelectNode.bind(_this);_this.onChangeDestination=_this.onChangeDestination.bind(_this);_this.onClickRemoveMapping=_this.onClickRemoveMapping.bind(_this);_this.onClickRevert=_this.onClickRevert.bind(_this);_this.onClickSaveMapping=_this.onClickSaveMapping.bind(_this);return _this;}_createClass(DestinationsView,[{key:'componentDidMount',value:function componentDidMount(){this.props.getCatalogsAction();this.props.getRolesAction();this.props.getMappingsCommand();}},{key:'onChangeDestination',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.setDestinationAction(e.target.value);case 2:this.setState({selectedNode:undefined});case 3:case'end':return _context.stop();}}},_callee,this);}));function onChangeDestination(_x){return _ref.apply(this,arguments);}return onChangeDestination;}()},{key:'handleSelectNode',value:function handleSelectNode(entry){this.setState({selectedNode:entry});}},{key:'onClickSaveMapping',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var _props,saveMapping,formatMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_props=this.props,saveMapping=_props.saveMapping,formatMessage=_props.intl.formatMessage;_context2.next=3;return saveMapping(formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].LDAP_SYNC_NOTIFICATION),this.state.hasDeletes);case 3:this.setState({hasDeletes:false});case 4:case'end':return _context2.stop();}}},_callee2,this);}));function onClickSaveMapping(_x2){return _ref2.apply(this,arguments);}return onClickSaveMapping;}()},{key:'onClickRemoveMapping',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e){var removeMappingEntry,selectedNode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:removeMappingEntry=this.props.removeMappingEntry;selectedNode=this.state.selectedNode;if(!selectedNode){_context3.next=6;break;}_context3.next=5;return removeMappingEntry(selectedNode);case 5:this.setState({hasDeletes:true,selectedNode:undefined});case 6:case'end':return _context3.stop();}}},_callee3,this);}));function onClickRemoveMapping(_x3){return _ref3.apply(this,arguments);}return onClickRemoveMapping;}()},{key:'onClickRevert',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.props.getMappingsCommand();case 2:this.setState({hasDeletes:false});case 3:case'end':return _context4.stop();}}},_callee4,this);}));function onClickRevert(){return _ref4.apply(this,arguments);}return onClickRevert;}()},{key:'renderEntries',value:function renderEntries(entriesForDestination,showRoles){var _this2=this;var _props2=this.props,addOrUpdateMappingEntries=_props2.addOrUpdateMappingEntries,intl=_props2.intl,roles=_props2.roles;return entriesForDestination.length?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,entriesForDestination.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["i" /* getUserName */])(a.sourceDN).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["i" /* getUserName */])(b.sourceDN));}).map(function(entry){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DestinationNode__["a" /* default */],{addOrUpdateMappingEntries:addOrUpdateMappingEntries,entry:entry,intl:intl,isSelected:_this2.state.selectedNode===entry,key:entry.sourceDN,onSelectNode:_this2.handleSelectNode,roles:roles,showRoles:showRoles});})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-message','data-test-name':'no-mappings-message'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_NO_MAPPINGS_LABEL));}},{key:'render',value:function render(){var _props3=this.props,catalogs=_props3.catalogs,destination=_props3.destination,formatMessage=_props3.intl.formatMessage,isDirty=_props3.isDirty,mappings=_props3.mappings,queryType=_props3.queryType;var hasDeletes=this.state.hasDeletes;var mappingsAreDirty=isDirty||hasDeletes;var entriesForDestination=Object(__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["h" /* getMappingEntriesForDestination */])(mappings,destination);var showRoles=destination!==__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["d" /* NO_CATALOGS_GUID */];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page column is-three-fifths'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:queryType===__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["e" /* QUERY_TYPE_NAME */]?'dir-svc-mapping-form-section-expanded':'dir-svc-mapping-form-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{margin:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].CATALOG)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{component:'input','data-test-name':'catalogSelect',onChange:this.onChangeDestination,value:destination},catalogs.map(function(catalog){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:catalog.catalogId,value:catalog.catalogId},catalog.name);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["b" /* ALL_CATALOGS_GUID */],value:__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["b" /* ALL_CATALOGS_GUID */]},formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].ALL_CATALOGS_GROUP)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["d" /* NO_CATALOGS_GUID */],value:__WEBPACK_IMPORTED_MODULE_12_util_dirSvcUtils__["d" /* NO_CATALOGS_GUID */]},formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].NO_CATALOGS))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dir-svc-mapping-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dir-svc-table-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dir-svc-mapping-column dir-svc-cell dir-svc-cell-padded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL)),showRoles&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dir-svc-mapping-column dir-svc-cell dir-svc-cell-padded'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].USER_ROLE)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dir-svc-mapping-main-section','data-test-name':'dir-svc-mappings-dest'},this.renderEntries(entriesForDestination,showRoles)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dir-svc-mapping-controls-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'buttons buttonsGroup is-pulled-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-dark is-outlined','data-test-name':'remove-mapping',onClick:this.onClickRemoveMapping,disabled:!this.state.selectedNode},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_REMOVE_MAPPING),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-times-circle'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'buttons buttonsGroup is-pulled-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-dark is-outlined','data-test-name':'revert-changes',onClick:this.onClickRevert,disabled:!mappingsAreDirty},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].REVERT_CHANGES),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-times-circle'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'button is-primary','data-test-name':'save-mappings',onClick:this.onClickSaveMapping,disabled:!mappingsAreDirty},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_SAVE_MAPPINGS),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-check-circle fa-lg'}))))));}}]);return DestinationsView;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{catalogs:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["n" /* getCatalogs */])(state),destination:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["w" /* getDirectoryServiceDestination */])(state),isDirty:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["Q" /* getIsDirectoryServiceMappingsDirty */])(state),mappings:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["x" /* getDirectoryServiceMappings */])(state),queryType:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["z" /* getDirectoryServiceQueryType */])(state),roles:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["_15" /* getRoles */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addOrUpdateMappingEntries:__WEBPACK_IMPORTED_MODULE_5_state_commands_dirSvcCommands__["a" /* addOrUpdateMappingEntries */],getCatalogsAction:__WEBPACK_IMPORTED_MODULE_4_state_commands_catalogCommands__["n" /* getCatalogs */],setDestinationAction:setDestinationAction,getMappingsCommand:__WEBPACK_IMPORTED_MODULE_5_state_commands_dirSvcCommands__["b" /* getMappings */],getRolesAction:__WEBPACK_IMPORTED_MODULE_6_state_commands_roleCommands__["c" /* getRoles */],removeMappingEntry:__WEBPACK_IMPORTED_MODULE_5_state_commands_dirSvcCommands__["d" /* removeMappingEntry */],saveMapping:__WEBPACK_IMPORTED_MODULE_5_state_commands_dirSvcCommands__["e" /* saveMapping */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(DestinationsView)));

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_dirSvcUtils__ = __webpack_require__(88);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DestinationNode=function(_Component){_inherits(DestinationNode,_Component);function DestinationNode(){_classCallCheck(this,DestinationNode);var _this=_possibleConstructorReturn(this,(DestinationNode.__proto__||Object.getPrototypeOf(DestinationNode)).call(this));_this.handleSelect=_this.handleSelect.bind(_this);_this.onChangeSelectRole=_this.onChangeSelectRole.bind(_this);_this.onChangeSelectRole=_this.onChangeSelectRole.bind(_this);_this.renderIcon=_this.renderIcon.bind(_this);_this.renderRole=_this.renderRole.bind(_this);return _this;}_createClass(DestinationNode,[{key:'handleSelect',value:function handleSelect(){var _props=this.props,entry=_props.entry,onSelectNode=_props.onSelectNode;onSelectNode(entry);}},{key:'onChangeSelectRole',value:function onChangeSelectRole(e){var _props2=this.props,addOrUpdateMappingEntries=_props2.addOrUpdateMappingEntries,entry=_props2.entry;addOrUpdateMappingEntries([Object.assign({},entry,{roleOverrideGuid:e.currentTarget.value})]);}},{key:'renderIcon',value:function renderIcon(){var entry=this.props.entry;var name=Object(__WEBPACK_IMPORTED_MODULE_3_util_dirSvcUtils__["i" /* getUserName */])(entry.sourceDN);var icon=entry.sourceType===__WEBPACK_IMPORTED_MODULE_3_util_dirSvcUtils__["g" /* SOURCE_TYPE_USER_EXCLUSION */]?'fa-minus-circle':'fa-arrow-circle-right';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-mapping-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg '+icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-cell','data-test-name':entry.sourceType===__WEBPACK_IMPORTED_MODULE_3_util_dirSvcUtils__["g" /* SOURCE_TYPE_USER_EXCLUSION */]?'excluded-user':'mapped-user'},name)));}},{key:'renderRole',value:function renderRole(){var _props3=this.props,entry=_props3.entry,intl=_props3.intl,roles=_props3.roles;var role=Object(__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["f" /* getRoleForUUID */])(roles,entry.roleOverrideGuid);var roleName=role?role.name:'-';if(entry.sourceType===__WEBPACK_IMPORTED_MODULE_3_util_dirSvcUtils__["g" /* SOURCE_TYPE_USER_EXCLUSION */]){return null;}return entry.unsaved?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-role-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:this.onChangeSelectRole,value:entry.roleOverrideGuid},roles.map(function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:r.uuid,value:r.uuid},Object(__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["e" /* getLocalizedRoleName */])(intl,r.name));})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'display-role',className:'dir-svc-mapping-column dir-svc-cell dir-svc-cell-padded'},roleName);}},{key:'render',value:function render(){var _props4=this.props,entry=_props4.entry,isSelected=_props4.isSelected,showRoles=_props4.showRoles;var rowClass=isSelected?'pseudo-table-row-selected':'pseudo-table-row';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:rowClass,key:entry.sourceDN,onClick:this.handleSelect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-row'},this.renderIcon(),showRoles&&this.renderRole()));}}]);return DestinationNode;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DestinationNode);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_virtualized_tree__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_dirSvcCommands__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_reducers_dirSvcReducer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SourceNode__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_Forms_LabeledField__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setDirectoryServiceQueryTypeAction=__WEBPACK_IMPORTED_MODULE_5_state_reducers_dirSvcReducer__["a" /* actions */].setDirectoryServiceQueryType,setSelectedNodeAction=__WEBPACK_IMPORTED_MODULE_5_state_reducers_dirSvcReducer__["a" /* actions */].setSelectedNode;var SourcesView=function(_Component){_inherits(SourcesView,_Component);_createClass(SourcesView,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.directoryServiceQueryResults!==nextProps.directoryServiceQueryResults){this.setState({nodes:nextProps.directoryServiceQueryResults});}}}]);function SourcesView(){_classCallCheck(this,SourcesView);var _this=_possibleConstructorReturn(this,(SourcesView.__proto__||Object.getPrototypeOf(SourcesView)).call(this));_this.state={nodes:[],nameQueryOperator:__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].CONTAINS,nameQueryText:''};_this.handleChange=function(nodes){_this.setState({nodes:nodes});};_this.handleChange=_this.handleChange.bind(_this);_this.onChangeQueryType=_this.onChangeQueryType.bind(_this);_this.onChangeNameQueryOperator=_this.onChangeNameQueryOperator.bind(_this);_this.onChangeNameQueryText=_this.onChangeNameQueryText.bind(_this);_this.onClickCreateExclusion=_this.onClickCreateExclusion.bind(_this);_this.onClickCreateMapping=_this.onClickCreateMapping.bind(_this);_this.onSearchByName=_this.onSearchByName.bind(_this);_this.onKeyDownNameQueryText=_this.onKeyDownNameQueryText.bind(_this);return _this;}_createClass(SourcesView,[{key:'componentDidMount',value:function componentDidMount(){this.props.queryDirectoryServiceCommand();}},{key:'onChangeQueryType',value:function onChangeQueryType(e){this.props.setSelectedNodeAction(null);this.props.setDirectoryServiceQueryTypeAction(e.target.value);if(e.target.value===__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["e" /* QUERY_TYPE_NAME */]){this.setState({nameQueryText:'',nodes:[]});}else{this.props.queryDirectoryServiceCommand();}}},{key:'onSearchByName',value:function onSearchByName(){this.props.queryDirectoryServiceCommand(this.state.nameQueryOperator,this.state.nameQueryText);}},{key:'onChangeNameQueryOperator',value:function onChangeNameQueryOperator(e){this.setState({nameQueryOperator:e.target.value});}},{key:'onChangeNameQueryText',value:function onChangeNameQueryText(e){this.setState({nameQueryText:e.target.value});}},{key:'onClickCreateExclusion',value:function onClickCreateExclusion(e){var selectedNode=this.props.selectedNode;if(!selectedNode||!Object(__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["k" /* isNodeUser */])(selectedNode)){return;}var entry={sourceDN:selectedNode.dn,sourceType:__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["g" /* SOURCE_TYPE_USER_EXCLUSION */],roleOverrideGuid:'',mappingOrder:'0',unsaved:true};this.props.addOrUpdateMappingEntries([entry]);}},{key:'onClickCreateMapping',value:function onClickCreateMapping(e){var selectedNode=this.props.selectedNode;if(!selectedNode){return;}var entry={sourceDN:selectedNode.dn,sourceType:Object(__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["l" /* ldapSourceToNumber */])(selectedNode.attributes.objectClass),roleOverrideGuid:'',mappingOrder:'0',unsaved:true};this.props.addOrUpdateMappingEntries([entry]);}},{key:'onKeyDownNameQueryText',value:function onKeyDownNameQueryText(e){if(e.key==='Enter'){this.onSearchByName();e.stopPropagation();}}},{key:'renderQueryResults',value:function renderQueryResults(){var _this2=this;var _props=this.props,isQueryPending=_props.isQueryPending,queryDirectoryServiceCommand=_props.queryDirectoryServiceCommand,selectedNode=_props.selectedNode,setSelectedNodeAction=_props.setSelectedNodeAction;return isQueryPending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-page-message','data-test-name':'query-pending-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-spin fa-circle-o-notch fa-2x fa-fw has-text-primary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE)):this.state.nodes&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_virtualized_tree__["a" /* default */],{nodes:this.state.nodes,onChange:this.handleChange},function(_ref){var node=_ref.node;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SourceNode__["a" /* default */],{node:node,onChange:_this2.handleChange,queryDirectoryServiceCommand:queryDirectoryServiceCommand,selectedNode:selectedNode,setSelectedNode:setSelectedNodeAction});});}},{key:'render',value:function render(){var _props2=this.props,formatMessage=_props2.intl.formatMessage,queryType=_props2.queryType,selectedNode=_props2.selectedNode;var isNameQuery=queryType===__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["e" /* QUERY_TYPE_NAME */];var formClass='dir-svc-mapping-form-section'+(isNameQuery?' name-query':'');var NAME_QUERY_OPERATORS=[__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].EQUALS,__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].CONTAINS,__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["c" /* NAME_QUERY_OP */].STARTS_WITH];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page column is-two-fifths bordered-page-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:formClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_BROWSE_FILTER_LABEL),style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{component:'input','data-test-name':'querySelect',onChange:this.onChangeQueryType,value:queryType},Object.keys(__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["a" /* AD_MAPPING_QUERIES */]).map(function(queryTypeKey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:queryTypeKey,value:queryTypeKey},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */][__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["a" /* AD_MAPPING_QUERIES */][queryTypeKey].name]));}))),isNameQuery&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'nameQueryOptions',className:'name-query-options field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'select is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{component:'input','data-test-name':'name-query-operator',value:this.state.nameQueryOperator,onChange:this.onChangeNameQueryOperator},NAME_QUERY_OPERATORS.map(function(op){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:op,value:op},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */][op]));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'input is-small is-fullwidth','data-test-name':'name-query-text',onChange:this.onChangeNameQueryText,onKeyDown:this.onKeyDownNameQueryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'buttons buttonsGroup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary is-small','data-test-name':'name-search-button',onClick:this.onSearchByName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].SEARCH)))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-mapping-header dir-svc-cell dir-svc-cell-padded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-mapping-main-section','data-test-name':'dir-svc-mappings-source'},this.renderQueryResults()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dir-svc-mapping-controls-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons buttonsGroup is-pulled-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-dark is-outlined','data-test-name':'exclude-user',disabled:!selectedNode||!Object(__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["k" /* isNodeUser */])(selectedNode),onClick:this.onClickCreateExclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CREATE_USER_EXCLUSION_MAPPING),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-circle-right'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons buttonsGroup is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-primary','data-test-name':'create-mapping',disabled:!selectedNode||!Object(__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["k" /* isNodeUser */])(selectedNode)&&!Object(__WEBPACK_IMPORTED_MODULE_9_util_dirSvcUtils__["j" /* isNodeGroup */])(selectedNode),onClick:this.onClickCreateMapping},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].CREATE_MAPPING),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-circle-right fa-lg'}))))));}}]);return SourcesView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{directoryServiceQueryResults:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["y" /* getDirectoryServiceQueryResults */])(state),isQueryPending:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["R" /* getIsDirectoryServiceQueryPending */])(state),queryType:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["z" /* getDirectoryServiceQueryType */])(state),selectedNode:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_17" /* getSelectedDirectoryServiceNode */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addOrUpdateMappingEntries:__WEBPACK_IMPORTED_MODULE_4_state_commands_dirSvcCommands__["a" /* addOrUpdateMappingEntries */],getDirectoryServiceQueryResults:__WEBPACK_IMPORTED_MODULE_6_state_selectors__["y" /* getDirectoryServiceQueryResults */],queryDirectoryServiceCommand:__WEBPACK_IMPORTED_MODULE_4_state_commands_dirSvcCommands__["c" /* queryDirectoryService */],setDirectoryServiceQueryTypeAction:setDirectoryServiceQueryTypeAction,setSelectedNodeAction:setSelectedNodeAction});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(SourcesView)));

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tree__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_getFlattenedTree__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_nodes__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shapes_nodeShapes__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reselect__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reselect__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _DEFAULT_UPDATE_TYPES, _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var DEFAULT_UPDATE_TYPES = (_DEFAULT_UPDATE_TYPES = {}, _DEFAULT_UPDATE_TYPES[__WEBPACK_IMPORTED_MODULE_3__contants__["a" /* UPDATE_TYPE */].DELETE] = __WEBPACK_IMPORTED_MODULE_5__selectors_nodes__["b" /* deleteNodeFromTree */], _DEFAULT_UPDATE_TYPES[__WEBPACK_IMPORTED_MODULE_3__contants__["a" /* UPDATE_TYPE */].UPDATE] = __WEBPACK_IMPORTED_MODULE_5__selectors_nodes__["e" /* replaceNodeFromTree */], _DEFAULT_UPDATE_TYPES);

var getExtensions = Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(function (e) {
  return e;
}, function () {
  var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _extensions$updateTyp = extensions.updateTypeHandlers,
      updateTypeHandlers = _extensions$updateTyp === undefined ? {} : _extensions$updateTyp;


  return {
    updateTypeHandlers: _extends({}, DEFAULT_UPDATE_TYPES, updateTypeHandlers)
  };
});

var TreeContainer = (_temp2 = _class = function (_React$Component) {
  _inherits(TreeContainer, _React$Component);

  function TreeContainer() {
    var _temp, _this, _ret;

    _classCallCheck(this, TreeContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (_ref) {
      var node = _ref.node,
          type = _ref.type;

      var updatedNodes = getExtensions(_this.props.extensions).updateTypeHandlers[type](_this.nodes, node);

      _this.props.onChange(updatedNodes);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TreeContainer.prototype.render = function render() {
    var flattenedTree = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_getFlattenedTree__["a" /* getFlattenedTree */])(this.props.nodes);
    var rowIndex = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_nodes__["d" /* getRowIndexFromId */])(flattenedTree, this.props.scrollToId);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Tree__["a" /* default */], {
      nodeMarginLeft: this.props.nodeMarginLeft,
      nodes: flattenedTree,
      onChange: this.handleChange,
      NodeRenderer: this.props.children,
      scrollToIndex: rowIndex
    });
  };

  _createClass(TreeContainer, [{
    key: 'nodes',
    get: function get() {
      return this.context.unfilteredNodes || this.props.nodes;
    }
  }]);

  return TreeContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.contextTypes = {
  unfilteredNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_6__shapes_nodeShapes__["b" /* Node */]))
}, _temp2);



TreeContainer.propTypes =  false ? {
  extensions: PropTypes.shape({
    updateTypeHandlers: PropTypes.object
  }),
  nodes: PropTypes.arrayOf(PropTypes.shape(Node)).isRequired,
  onChange: PropTypes.func,
  children: PropTypes.func.isRequired,
  nodeMarginLeft: PropTypes.number,
  width: PropTypes.number,
  scrollToId: PropTypes.number
} : {};

TreeContainer.defaultProps = {
  nodeMarginLeft: 30
};

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shapes_nodeShapes__ = __webpack_require__(155);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Tree = function (_React$Component) {
  _inherits(Tree, _React$Component);

  function Tree() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._cache = new __WEBPACK_IMPORTED_MODULE_2_react_virtualized__["d" /* CellMeasurerCache */]({
      fixedWidth: true,
      minHeight: 20
    }), _this.rowRenderer = function (_ref) {
      var node = _ref.node,
          key = _ref.key,
          measure = _ref.measure,
          style = _ref.style,
          NodeRenderer = _ref.NodeRenderer;
      var nodeMarginLeft = _this.props.nodeMarginLeft;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: key, className: 'tree-node', style: _extends({}, style, { marginLeft: node.deepness * nodeMarginLeft }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeRenderer, { node: node, onChange: _this.props.onChange, measure: measure })
      );
    }, _this.measureRowRenderer = function (nodes) {
      return function (_ref2) {
        var key = _ref2.key,
            index = _ref2.index,
            style = _ref2.style,
            parent = _ref2.parent;
        var NodeRenderer = _this.props.NodeRenderer;

        var node = nodes[index];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_virtualized__["c" /* CellMeasurer */],
          { cache: _this._cache, columnIndex: 0, key: key, rowIndex: index, parent: parent },
          function (m) {
            return _this.rowRenderer(_extends({}, m, { node: node, key: key, style: style, NodeRenderer: NodeRenderer }));
          }
        );
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tree.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        nodes = _props.nodes,
        width = _props.width,
        scrollToIndex = _props.scrollToIndex;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_virtualized__["b" /* AutoSizer */],
      { disableWidth: Boolean(width) },
      function (_ref3) {
        var height = _ref3.height,
            autoWidth = _ref3.width;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_virtualized__["f" /* List */], {
          deferredMeasurementCache: _this2._cache,
          ref: function ref(r) {
            return _this2._list = r;
          },
          height: height,
          rowCount: nodes.length,
          rowHeight: _this2._cache.rowHeight,
          rowRenderer: _this2.measureRowRenderer(nodes),
          width: width || autoWidth,
          scrollToIndex: scrollToIndex
        });
      }
    );
  };

  return Tree;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);




Tree.propTypes =  false ? {
  nodes: PropTypes.arrayOf(PropTypes.shape(FlattenedNode)).isRequired,
  NodeRenderer: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  nodeMarginLeft: PropTypes.number,
  width: PropTypes.number
} : {};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable string keyed properties of `object` that are
 * not omitted.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = baseRest(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap(baseFlatten(props, 1), toKey);
  return basePick(object, baseDifference(getAllKeysIn(object), props));
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = omit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = findIndex;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(64)(module)))

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Deletable__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Expandable__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Favorite__ = __webpack_require__(965);




/* harmony default export */ __webpack_exports__["a"] = ({ Deletable: __WEBPACK_IMPORTED_MODULE_0__Deletable__["a" /* default */], Expandable: __WEBPACK_IMPORTED_MODULE_1__Expandable__["a" /* default */], Favorite: __WEBPACK_IMPORTED_MODULE_2__Favorite__["a" /* default */] });

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventWrappers__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_nodes__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shapes_rendererShapes__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var Deletable = function Deletable(_ref) {
  var _classNames;

  var onChange = _ref.onChange,
      node = _ref.node,
      _ref$iconsClassNameMa = _ref.iconsClassNameMap,
      iconsClassNameMap = _ref$iconsClassNameMa === undefined ? {
    delete: 'mi mi-delete'
  } : _ref$iconsClassNameMa,
      children = _ref.children;

  var _getNodeRenderOptions = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_nodes__["c" /* getNodeRenderOptions */])(node),
      isDeletable = _getNodeRenderOptions.isDeletable;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, _classNames[iconsClassNameMap.delete] = isDeletable, _classNames));

  var handleChange = function handleChange() {
    return onChange(Object(__WEBPACK_IMPORTED_MODULE_4__selectors_nodes__["a" /* deleteNode */])(node));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    isDeletable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { tabIndex: 0, onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_3__eventWrappers__["a" /* submitEvent */])(handleChange), onClick: handleChange, className: className }),
    children
  );
};

Deletable.propTypes =  false ? _extends({}, Renderer, {
  iconsClassNameMap: PropTypes.shape({
    delete: PropTypes.string
  })
}) : {};

/* harmony default export */ __webpack_exports__["a"] = (Deletable);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventWrappers__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_nodes__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shapes_rendererShapes__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var Expandable = function Expandable(_ref) {
  var _classNames;

  var onChange = _ref.onChange,
      node = _ref.node,
      children = _ref.children,
      _ref$iconsClassNameMa = _ref.iconsClassNameMap,
      iconsClassNameMap = _ref$iconsClassNameMa === undefined ? {
    expanded: 'mi mi-keyboard-arrow-down',
    collapsed: 'mi mi-keyboard-arrow-right',
    lastChild: ''
  } : _ref$iconsClassNameMa;

  var _getNodeRenderOptions = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_nodes__["c" /* getNodeRenderOptions */])(node),
      hasChildren = _getNodeRenderOptions.hasChildren,
      isExpanded = _getNodeRenderOptions.isExpanded;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, _classNames[iconsClassNameMap.expanded] = hasChildren && isExpanded, _classNames[iconsClassNameMap.collapsed] = hasChildren && !isExpanded, _classNames[iconsClassNameMap.lastChild] = !hasChildren, _classNames));

  var handleChange = function handleChange() {
    return onChange(Object(__WEBPACK_IMPORTED_MODULE_4__selectors_nodes__["f" /* updateNode */])(node, { expanded: !isExpanded }));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    { onDoubleClick: handleChange },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { tabIndex: 0, onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_3__eventWrappers__["a" /* submitEvent */])(handleChange), onClick: handleChange, className: className }),
    children
  );
};

Expandable.propTypes =  false ? _extends({}, Renderer, {
  iconsClassNameMap: PropTypes.shape({
    expanded: PropTypes.string,
    collapsed: PropTypes.string,
    lastChild: PropTypes.string
  })
}) : {};

/* harmony default export */ __webpack_exports__["a"] = (Expandable);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventWrappers__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_nodes__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shapes_rendererShapes__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var Favorite = function Favorite(_ref) {
  var _classNames;

  var onChange = _ref.onChange,
      node = _ref.node,
      _ref$iconsClassNameMa = _ref.iconsClassNameMap,
      iconsClassNameMap = _ref$iconsClassNameMa === undefined ? {
    favorite: 'mi mi-star',
    notFavorite: 'mi mi-star-border'
  } : _ref$iconsClassNameMa,
      children = _ref.children;

  var _getNodeRenderOptions = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_nodes__["c" /* getNodeRenderOptions */])(node),
      isFavorite = _getNodeRenderOptions.isFavorite;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, _classNames[iconsClassNameMap.favorite] = isFavorite, _classNames[iconsClassNameMap.notFavorite] = !isFavorite, _classNames));

  var handleChange = function handleChange() {
    return onChange(Object(__WEBPACK_IMPORTED_MODULE_4__selectors_nodes__["f" /* updateNode */])(node, { favorite: !isFavorite }));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { tabIndex: 0, onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_3__eventWrappers__["a" /* submitEvent */])(handleChange), onClick: handleChange, className: className }),
    children
  );
};

Favorite.propTypes =  false ? _extends({}, Renderer, {
  iconsClassNameMap: PropTypes.shape({
    favorite: PropTypes.string,
    notFavorite: PropTypes.string
  })
}) : {};

/* harmony default export */ __webpack_exports__["a"] = (Favorite);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtering_DefaultGroupRenderer__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shapes_nodeShapes__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_filtering__ = __webpack_require__(969);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var nameMatchesSearchTerm = function nameMatchesSearchTerm(searchTerm) {
  return function (_ref) {
    var name = _ref.name;

    var upperCaseName = name.toUpperCase();
    var upperCaseSearchTerm = searchTerm.toUpperCase();

    return upperCaseName.indexOf(upperCaseSearchTerm.trim()) > -1;
  };
};

var FilteringContainer = (_temp = _class = function (_React$Component) {
  _inherits(FilteringContainer, _React$Component);

  function FilteringContainer(props) {
    _classCallCheck(this, FilteringContainer);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      filterText: '',
      filterTerm: ''
    };

    _this.getChildContext = function () {
      return { unfilteredNodes: _this.props.nodes };
    };

    _this.handleFilterTextChange = function (e) {
      var filterText = e.target.value;

      _this.setState({ filterText: filterText });

      _this.setFilterTerm();
    };

    _this.setFilterTerm = props.debouncer(_this.setFilterTerm, 300);
    return _this;
  }

  FilteringContainer.prototype.setFilterTerm = function setFilterTerm() {
    this.setState(function (ps) {
      return { filterTerm: ps.filterText };
    });
  };

  FilteringContainer.prototype.render = function render() {
    var _state = this.state,
        filterTerm = _state.filterTerm,
        filterText = _state.filterText;
    var _props = this.props,
        nodes = _props.nodes,
        treeRenderer = _props.children,
        groups = _props.groups,
        selectedGroup = _props.selectedGroup,
        GroupRenderer = _props.groupRenderer,
        onSelectedGroupChange = _props.onSelectedGroupChange;


    var relevantNodes = groups && selectedGroup && groups[selectedGroup] ? Object(__WEBPACK_IMPORTED_MODULE_6__selectors_filtering__["a" /* filterNodes */])(groups[selectedGroup].filter, nodes) : { nodes: nodes, nodeParentMappings: [] };

    var _ref2 = filterTerm ? Object(__WEBPACK_IMPORTED_MODULE_6__selectors_filtering__["a" /* filterNodes */])(nameMatchesSearchTerm(filterTerm), relevantNodes.nodes) : relevantNodes,
        filteredNodes = _ref2.nodes,
        nodeParentMappings = _ref2.nodeParentMappings;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'tree-filter-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tree-lookup-input', { group: !!groups }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: filterText, onChange: this.handleFilterTextChange, placeholder: 'Search...' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { 'aria-hidden': 'true', className: 'mi mi-11 mi-search' }),
        groups && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupRenderer, { groups: groups, selectedGroup: selectedGroup, onChange: onSelectedGroupChange })
      ),
      treeRenderer({ nodes: filteredNodes, nodeParentMappings: nodeParentMappings })
    );
  };

  return FilteringContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.childContextTypes = {
  unfilteredNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_5__shapes_nodeShapes__["b" /* Node */])).isRequired
}, _class.defaultProps = {
  debouncer: __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default.a,
  groupRenderer: __WEBPACK_IMPORTED_MODULE_4__filtering_DefaultGroupRenderer__["a" /* default */]
}, _temp);



FilteringContainer.propTypes =  false ? {
  children: PropTypes.func.isRequired,
  debouncer: PropTypes.func,
  groups: PropTypes.object,
  selectedGroup: PropTypes.string,
  groupRenderer: PropTypes.func,
  onSelectedGroupChange: PropTypes.func
} : {};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DefaultGroupRenderer = function DefaultGroupRenderer(_ref) {
  var _onChange = _ref.onChange,
      groups = _ref.groups,
      selectedGroup = _ref.selectedGroup;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "select",
    {
      className: "tree-group",
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;

        _onChange(value);
      },
      value: selectedGroup
    },
    Object.keys(groups).map(function (g) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "option",
        { key: g, value: g },
        groups[g].name
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultGroupRenderer);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterNodes; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var INITIAL_FILTERED_VALUE = { nodes: [], nodeParentMappings: {} };

var filterNodes = function filterNodes(filter, nodes) {
  var parents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return nodes.reduce(function (filtered, n) {
    var _extends2;

    var _ref = n.children ? filterNodes(filter, n.children, [].concat(parents, [n.id])) : INITIAL_FILTERED_VALUE,
        filteredChildren = _ref.nodes,
        childrenNodeMappings = _ref.nodeParentMappings;

    return !(filter(n) || filteredChildren.length) ? filtered : {
      nodes: [].concat(filtered.nodes, [_extends({}, n, {
        children: filteredChildren
      })]),
      nodeParentMappings: _extends({}, filtered.nodeParentMappings, childrenNodeMappings, (_extends2 = {}, _extends2[n.id] = parents, _extends2))
    };
  }, INITIAL_FILTERED_VALUE);
};

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_virtualized_tree__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__ = __webpack_require__(88);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Expandable=__WEBPACK_IMPORTED_MODULE_1_react_virtualized_tree__["b" /* renderers */].Expandable;var SourceNode=function(_Component){_inherits(SourceNode,_Component);function SourceNode(){_classCallCheck(this,SourceNode);var _this=_possibleConstructorReturn(this,(SourceNode.__proto__||Object.getPrototypeOf(SourceNode)).call(this));_this.handleClickNode=_this.handleClickNode.bind(_this);_this.getNodeIcon=_this.getNodeIcon.bind(_this);return _this;}_createClass(SourceNode,[{key:'handleClickNode',value:function handleClickNode(){var _props=this.props,node=_props.node,setSelectedNode=_props.setSelectedNode;setSelectedNode(node);if(Object(__WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__["j" /* isNodeGroup */])(node)){this.props.queryDirectoryServiceCommand();}}},{key:'getNodeIcon',value:function getNodeIcon(node){if(Object(__WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__["k" /* isNodeUser */])(node)){return'fa fa-user';}else if(Object(__WEBPACK_IMPORTED_MODULE_2_util_dirSvcUtils__["j" /* isNodeGroup */])(node)){return'fa fa-users';}else{return'fa fa-circle';}}},{key:'render',value:function render(){var _props2=this.props,onChange=_props2.onChange,node=_props2.node,selectedNode=_props2.selectedNode;var className=selectedNode&&selectedNode.id===node.id?'pseudo-table-row-selected':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'has-pointer '+className,onClick:this.handleClickNode,style:{padding:'4px 8px'},'data-test-name':'mapping-source-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Expandable,{iconsClassNameMap:{expanded:'fa fa-folder-open',collapsed:'fa fa-folder',lastChild:this.getNodeIcon(node)},node:node,onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'6px'}},node.attributes.name)));}}]);return SourceNode;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SourceNode);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_view_Pages_StatusPage_Diagnostics__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_Pages_StatusPage_ProductDetails__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_Pages_StatusPage_ServerStateControls__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_Pages_LicensesPage_Account__ = __webpack_require__(976);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatusPage=function(_Component){_inherits(StatusPage,_Component);function StatusPage(){_classCallCheck(this,StatusPage);return _possibleConstructorReturn(this,(StatusPage.__proto__||Object.getPrototypeOf(StatusPage)).apply(this,arguments));}_createClass(StatusPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents status-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_view_Pages_StatusPage_ServerStateControls__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_view_Pages_StatusPage_ProductDetails__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_Pages_LicensesPage_Account__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_view_Pages_StatusPage_Diagnostics__["a" /* default */],null));}}]);return StatusPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (StatusPage);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_App_DialogPanels_DiagnosticDataDialog__ = __webpack_require__(973);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Diagnostics=function(_Component){_inherits(Diagnostics,_Component);function Diagnostics(){_classCallCheck(this,Diagnostics);var _this=_possibleConstructorReturn(this,(Diagnostics.__proto__||Object.getPrototypeOf(Diagnostics)).call(this));_this.state={showVaultErrorPrompt:true};_this.handleSendDiagnosticData=_this.handleSendDiagnosticData.bind(_this);return _this;}_createClass(Diagnostics,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){var vaultErrorMessage=this.props.errorStatuses.find(function(e){return e.id==='VaultFolderNotFound';});if(vaultErrorMessage&&this.state.showVaultErrorPrompt){this.setState({showVaultErrorPrompt:false});this.props.showSingleButtonAlert(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].NO_VAULT_FOLDER,vaultErrorMessage.parameters);}}},{key:'handleSendDiagnosticData',value:function handleSendDiagnosticData(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_6_util_constants__["G" /* DIAGNOSTIC_DATA_PANEL_ID */]);}},{key:'getDiagnosticDataLabel',value:function getDiagnosticDataLabel(){var _props=this.props,diagnosticDataStatus=_props.diagnosticDataStatus,intl=_props.intl,isSendingDiagnosticData=_props.isSendingDiagnosticData;if(isSendingDiagnosticData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].DIAGNOSTIC_STATUS_SENDING);}if(diagnosticDataStatus!==''){var status=diagnosticDataStatus.split(' ');if(status.length>1){var date=status[1];var message=__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].DIAGNOSTIC_STATUS_ERROR;if(diagnosticDataStatus.includes('success')){message=__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].DIAGNOSTIC_STATUS_SUCCESS;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],Object.assign({},message,{values:{date:intl.formatDate(date)+' '+intl.formatTime(date)}}));}}return diagnosticDataStatus;}},{key:'getDiagnosticDataClassName',value:function getDiagnosticDataClassName(){var _props2=this.props,diagnosticDataStatus=_props2.diagnosticDataStatus,isSendingDiagnosticData=_props2.isSendingDiagnosticData;if(isSendingDiagnosticData){return'has-text-primary has-text-weight-bold';}else if(diagnosticDataStatus!==''){if(this.props.diagnosticDataStatus.includes('success')){return'has-text-black';}else{return'has-text-danger';}}return'';}},{key:'render',value:function render(){var _props3=this.props,errorStatuses=_props3.errorStatuses,startupFailureReason=_props3.startupFailureReason;var allGood=!startupFailureReason&&!errorStatuses.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].DIAGNOSTICS_TITLE)),allGood&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-circle fa-lg has-text-primary licenseIcon'}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].DIAGNOSTICS_NO_PROBLEMS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-grid'},startupFailureReason&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].STATUS_MSG_STARTUP_FAILED)),startupFailureReason&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-grid-item-right error','data-test-name':'startup-error'},startupFailureReason),errorStatuses.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].STATUS_PROBLEMS_DETECTED)),errorStatuses.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-grid-item-right',style:{height:'100px',overflow:'auto'}},errorStatuses.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */][e.id],{values:e.parameters&&e.parameters.reduce(function(acc,v){acc[v.name]=v.value;return acc;},{})})));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-text',onClick:this.handleSendDiagnosticData,'data-test-name':'send-diag-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].DIAGNOSTIC_DATA_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-diagnostic-data-status '+this.getDiagnosticDataClassName(),'data-test-name':'diag-data-status'},this.getDiagnosticDataLabel()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_App_DialogPanels_DiagnosticDataDialog__["a" /* default */],null));}}]);return Diagnostics;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(Diagnostics);/* harmony default export */ __webpack_exports__["a"] = (wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{diagnosticDataStatus:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["u" /* getDiagnosticDataStatus */])(state),errorStatuses:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_22" /* getServerErrorStatuses */])(state),isSendingDiagnosticData:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["Y" /* getIsSendingDiagnosticData */])(state),startupFailureReason:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_26" /* getServerStartupFailureReason */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({showDialogPanel:__WEBPACK_IMPORTED_MODULE_8_state_commands_dialogPanelCommands__["b" /* showDialogPanel */],showSingleButtonAlert:__WEBPACK_IMPORTED_MODULE_7_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */]});})(wrappedForm));

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_reducers_serverReducer__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setIsSendingDiagnosticData=__WEBPACK_IMPORTED_MODULE_11_state_reducers_serverReducer__["a" /* actions */].setIsSendingDiagnosticData;var ACCOUNT_NAME_ID='accountNameId';function validate(data){var errors={};if(!data.accountName){errors.accountName='Required';}return errors;}var DiagnosticDataDialog=function(_Component){_inherits(DiagnosticDataDialog,_Component);function DiagnosticDataDialog(){_classCallCheck(this,DiagnosticDataDialog);var _this=_possibleConstructorReturn(this,(DiagnosticDataDialog.__proto__||Object.getPrototypeOf(DiagnosticDataDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(DiagnosticDataDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid&&!this.props.pristine;}},{key:'submit',value:function submit(values,dispatch,props){var accountName=values.accountName,contactName=values.contactName,techSupportTicketNum=values.techSupportTicketNum;this.props.sendDiagnosticData(accountName,contactName,techSupportTicketNum);this.props.setIsSendingDiagnosticData(true);}},{key:'onClose',value:function onClose(){this.props.reset();}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{panelId:__WEBPACK_IMPORTED_MODULE_10_util_constants__["G" /* DIAGNOSTIC_DATA_PANEL_ID */],activePanelId:this.props.activePanelId,closeAfterSave:true,contentStyle:{width:675,height:320},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIAGNOSTIC_DATA_SEND_REPORT_BUTTON),dialogFocusId:ACCOUNT_NAME_ID,hideDialogPanel:this.props.hideDialogPanel,isOkEnabled:this.isOkEnabled,onClose:this.onClose,onSave:handleSubmit(this.submit),panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIAGNOSTIC_DATA_TITLE),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit(this.submit),className:'diagnostic-data-form','data-test-name':'diagnostic-data-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIAGNOSTIC_DATA_ACCOUNT_NAME))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{name:'accountName',id:ACCOUNT_NAME_ID,className:'input',component:'input',type:'text'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIAGNOSTIC_DATA_CONTACT_NAME))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{name:'contactName',className:'input',component:'input',type:'text'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].DIAGNOSTIC_DATA_TS_TICKET_NUMBER))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{name:'techSupportTicketNum',className:'input',component:'input',type:'text'})))))));}}]);return DiagnosticDataDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var wrappedDialog=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_10_util_constants__["G" /* DIAGNOSTIC_DATA_PANEL_ID */],validate:validate})(DiagnosticDataDialog);wrappedDialog=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(wrappedDialog);/* harmony default export */ __webpack_exports__["a"] = (wrappedDialog=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["a" /* bindActionCreatorsForm */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],sendDiagnosticData:__WEBPACK_IMPORTED_MODULE_7_state_commands_adminPropertiesCommands__["h" /* sendDiagnosticData */],setIsSendingDiagnosticData:setIsSendingDiagnosticData});})(wrappedDialog));

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_licenseUtils__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ASSET_CAP_DANGER_ZONE=10000;var Row=function(_Component){_inherits(Row,_Component);function Row(){_classCallCheck(this,Row);return _possibleConstructorReturn(this,(Row.__proto__||Object.getPrototypeOf(Row)).apply(this,arguments));}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,id=_props.id,label=_props.label,value=_props.value,valueClassName=_props.valueClassName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-grid-item-right '+(valueClassName||''),'data-test-name':id},value));}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDetails=function(_Component2){_inherits(ProductDetails,_Component2);function ProductDetails(){_classCallCheck(this,ProductDetails);var _this2=_possibleConstructorReturn(this,(ProductDetails.__proto__||Object.getPrototypeOf(ProductDetails)).call(this));_this2.getDemoDaysRemaining=_this2.getDemoDaysRemaining.bind(_this2);return _this2;}_createClass(ProductDetails,[{key:'getDemoDaysRemaining',value:function getDemoDaysRemaining(){var licenses=this.props.licenses;var demoLicense=licenses.find(function(license){return license.productId===__WEBPACK_IMPORTED_MODULE_6_util_licenseUtils__["a" /* SN_TYPE_DEMO */];});return demoLicense?Object(__WEBPACK_IMPORTED_MODULE_6_util_licenseUtils__["c" /* daysUntilExpiration */])(demoLicense):0;}},{key:'getIconForFeature',value:function getIconForFeature(feature){var licensedFeatures=this.props.licensedFeatures;return licensedFeatures[feature]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-circle fa-lg has-text-primary licenseIcon'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-minus-circle fa-lg has-text-danger licenseIcon'});}},{key:'render',value:function render(){var _props2=this.props,ApiVersion=_props2.ApiVersion,assetCapCount=_props2.assetCapCount,enabledMediaEnginesCount=_props2.enabledMediaEnginesCount,extensisAccount=_props2.extensisAccount,_props2$intl=_props2.intl,formatMessage=_props2$intl.formatMessage,formatNumber=_props2$intl.formatNumber,licensedFeatures=_props2.licensedFeatures,licenses=_props2.licenses,maxSeatCount=_props2.maxSeatCount,mediaEngineTotalSeatCount=_props2.mediaEngineTotalSeatCount,seatCount=_props2.seatCount,totalAssetCount=_props2.totalAssetCount;if(!extensisAccount&&(!licenses||!Object(__WEBPACK_IMPORTED_MODULE_6_util_licenseUtils__["e" /* isDemoMode */])(licenses))){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}var isNearAssetCap=totalAssetCount+ASSET_CAP_DANGER_ZONE>=assetCapCount;var dangerZoneClass='has-text-danger has-text-weight-bold';var assetCapClass=isNearAssetCap?dangerZoneClass:'';var apiLicensed=licensedFeatures.api?formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATUS_API_STATE_LICENSED):formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATUS_API_STATE_UNLICENSED);var apiValue=ApiVersion+' '+apiLicensed;var mediaEngineValue=enabledMediaEnginesCount+' / '+mediaEngineTotalSeatCount;var assetValue=formatNumber(totalAssetCount)+' / '+formatNumber(assetCapCount);var seatValue=formatNumber(seatCount>maxSeatCount?maxSeatCount:seatCount)+' / '+formatNumber(maxSeatCount);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Portfolio ',__WEBPACK_IMPORTED_MODULE_5_util_constants__["_17" /* appVersion */],licenses&&Object(__WEBPACK_IMPORTED_MODULE_6_util_licenseUtils__["e" /* isDemoMode */])(licenses)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].PortfolioDemo),'\xA0',formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].LIC_DAYS_REMAINING,{days:this.getDemoDaysRemaining()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{id:'version-number',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].ABOUT_VERSION),value:__WEBPACK_IMPORTED_MODULE_5_util_constants__["_18" /* buildVersion */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{id:'api-version-info',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATUS_API_VERSION_LABEL),value:apiValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{id:'media-engine-seat-count',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATUS_MEDIA_ENGINES_LABEL),value:mediaEngineValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{id:'asset-count',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].TOTAL_ASSETS),value:assetValue,valueClassName:assetCapClass}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{id:'seat-count',label:formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].STATUS_CONNECTED_USERS),value:seatValue}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-grid-vrule'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-feature'},this.getIconForFeature('np'),'\xA0NetPublish'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-feature'},this.getIconForFeature('me'),'\xA0Media Engine'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-feature'},this.getIconForFeature('sso'),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CALL_ATT_SSO_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-feature'},this.getIconForFeature('api'),'\xA0Portfolio API'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-feature'},this.getIconForFeature('sk'),'\xA0Smart Keywords'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-page-feature'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-circle fa-lg has-text-primary licenseIcon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].EXTENSIS_CONTACT_US_URL),rel:'noopener noreferrer',target:'_blank'},'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].LIC_CLICK_TO_UPGRADE))))));}}]);return ProductDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(ProductDetails);/* harmony default export */ __webpack_exports__["a"] = (wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{ApiVersion:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["e" /* getApiVersion */])(state),assetCapCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["f" /* getAssetCapCount */])(state),enabledMediaEnginesCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["D" /* getEnabledMediaEnginesCount */])(state),extensisAccount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["E" /* getExtensisAccount */])(state),licenses:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_3" /* getLicenses */])(state),licensedFeatures:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_2" /* getLicensedFeatures */])(state),maxSeatCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_6" /* getMaxSeatCount */])(state),mediaEngineTotalSeatCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_7" /* getMediaEngineTotalSeatCount */])(state),seatCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_16" /* getSeatCount */])(state),totalAssetCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_30" /* getTotalAssetCount */])(state)};})(wrappedForm));

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServerStateControls=function(_Component){_inherits(ServerStateControls,_Component);function ServerStateControls(){_classCallCheck(this,ServerStateControls);var _this=_possibleConstructorReturn(this,(ServerStateControls.__proto__||Object.getPrototypeOf(ServerStateControls)).call(this));_this.handleRestartServer=_this.handleRestartServer.bind(_this);_this.handleStartServer=_this.handleStartServer.bind(_this);_this.handleStopServer=_this.handleStopServer.bind(_this);return _this;}_createClass(ServerStateControls,[{key:'handleStartServer',value:function handleStartServer(){this.props.startServer();}},{key:'handleStopServer',value:function handleStopServer(){this.props.stopServer();}},{key:'handleRestartServer',value:function handleRestartServer(){this.props.restartServer();}},{key:'render',value:function render(){var _props=this.props,intl=_props.intl,isRestarting=_props.isRestarting,serverRunState=_props.serverRunState;var isTransitionalRunState=serverRunState===__WEBPACK_IMPORTED_MODULE_7_util_constants__["Y" /* SERVER_STATE_STARTING */]||serverRunState===__WEBPACK_IMPORTED_MODULE_7_util_constants__["_0" /* SERVER_STATE_STOPPING */]||isRestarting;var runStateIcon='';var runStateClass='';var runStateLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SERVER_STATE_UNKNOWN;var startButtonLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].STATUS_START_SERVER;var startButtonIcon='fa fa-play';var stopButtonHidden=isTransitionalRunState||serverRunState===__WEBPACK_IMPORTED_MODULE_7_util_constants__["Z" /* SERVER_STATE_STOPPED */];var startButtonHidden=isTransitionalRunState;switch(serverRunState.toLowerCase()){case __WEBPACK_IMPORTED_MODULE_7_util_constants__["X" /* SERVER_STATE_STARTED */]:runStateIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-circle fa-3x has-text-primary'});runStateLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SERVER_STATE_STARTED;runStateClass='has-text-primary';startButtonLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].STATUS_RESTART_SERVER;startButtonIcon='fa fa-repeat fa-rotate-270';break;case __WEBPACK_IMPORTED_MODULE_7_util_constants__["Y" /* SERVER_STATE_STARTING */]:runStateIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle-o-notch fa-spin fa-2x has-text-primary'});runStateLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SERVER_STATE_STARTING;runStateClass='has-text-primary is-italic';break;case __WEBPACK_IMPORTED_MODULE_7_util_constants__["Z" /* SERVER_STATE_STOPPED */]:if(isRestarting){runStateIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle-o-notch fa-spin fa-2x has-text-primary'});runStateLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SERVER_STATE_STARTING;runStateClass='has-text-primary is-italic';}else{runStateIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-stop-circle fa-3x has-text-danger'});runStateLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SERVER_STATE_STOPPED;runStateClass='has-text-danger';}break;case __WEBPACK_IMPORTED_MODULE_7_util_constants__["_0" /* SERVER_STATE_STOPPING */]:runStateIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle-o-notch fa-spin fa-2x has-text-danger'});runStateLabel=__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].SERVER_STATE_STOPPING;runStateClass='has-text-danger is-italic';break;default:}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box status-display'},runStateIcon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'24px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:runStateClass,'data-test-name':'server-state-'+intl.formatMessage(runStateLabel)},'Portfolio ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],runStateLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'96px'}}),!stopButtonHidden&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-outlined is-medium',onClick:this.handleStopServer,'data-test-name':'stop-server'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-stop'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].STATUS_STOP_SERVER)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'32px'}}),!startButtonHidden&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-medium\n                '+(serverRunState===__WEBPACK_IMPORTED_MODULE_7_util_constants__["Z" /* SERVER_STATE_STOPPED */]?'':'is-outlined'),onClick:serverRunState===__WEBPACK_IMPORTED_MODULE_7_util_constants__["X" /* SERVER_STATE_STARTED */]?this.handleRestartServer:this.handleStartServer,'data-test-name':'start-restart-server'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:startButtonIcon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],startButtonLabel)));}}]);return ServerStateControls;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(ServerStateControls);/* harmony default export */ __webpack_exports__["a"] = (wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isRestarting:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["X" /* getIsRestarting */])(state),serverRunState:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_25" /* getServerRunState */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({restartServer:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["f" /* restartServer */],startServer:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["p" /* startServer */],stopServer:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["q" /* stopServer */]});})(wrappedForm));

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SetAccountDialog__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountRenderer__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NoAccount__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SetSystemDialog__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_licenseUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_licenseCommands__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Account=function(_Component){_inherits(Account,_Component);function Account(){_classCallCheck(this,Account);var _this=_possibleConstructorReturn(this,(Account.__proto__||Object.getPrototypeOf(Account)).call(this));_this.handleClickSetExtensisAccount=_this.handleClickSetExtensisAccount.bind(_this);return _this;}_createClass(Account,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,extensisAccount=_props.extensisAccount,licenses=_props.licenses;// prevent re-fectching if possible, it's annoying to see the spinner
// when navigating to this page, and it's time-consuming talking to Bonfire
if(Object(__WEBPACK_IMPORTED_MODULE_8_util_licenseUtils__["d" /* hasMainProductLicense */])(licenses)&&!Object(__WEBPACK_IMPORTED_MODULE_8_util_licenseUtils__["e" /* isDemoMode */])(licenses)&&!extensisAccount){this.props.getExtensisAccountInfo();}}},{key:'handleClickSetExtensisAccount',value:function handleClickSetExtensisAccount(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_11_util_constants__["_1" /* SET_ACCOUNT_PANEL_ID */]);}},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,addLicenses=_props2.addLicenses,extensisAccount=_props2.extensisAccount,extensisSystems=_props2.extensisSystems,hideDialogPanel=_props2.hideDialogPanel,intl=_props2.intl,isPendingResponseFromBonfire=_props2.isPendingResponseFromBonfire,licenseMaintenanceEndDate=_props2.licenseMaintenanceEndDate,setExtensisSystem=_props2.setExtensisSystem,showDialogPanel=_props2.showDialogPanel;if(isPendingResponseFromBonfire){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accountResponsePending'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle-o-notch fa-spin fa-3x has-text-primary'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,extensisAccount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccountRenderer__["a" /* default */],{extensisAccount:extensisAccount,clickSetExtensisAccount:this.handleClickSetExtensisAccount,intl:intl,licenseMaintenanceEndDate:licenseMaintenanceEndDate}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NoAccount__["a" /* default */],{activePanelId:activePanelId,addLicenses:addLicenses,hideDialogPanel:hideDialogPanel,intl:intl,showDialogPanel:showDialogPanel}),activePanelId===__WEBPACK_IMPORTED_MODULE_11_util_constants__["_2" /* SET_SYSTEM_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SetSystemDialog__["a" /* default */],{activePanelId:activePanelId,hideDialogPanel:hideDialogPanel,intl:intl,setExtensisSystem:setExtensisSystem,systems:extensisSystems}),activePanelId===__WEBPACK_IMPORTED_MODULE_11_util_constants__["_1" /* SET_ACCOUNT_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SetAccountDialog__["a" /* default */],{activePanelId:activePanelId,hideDialogPanel:hideDialogPanel}));}}]);return Account;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state),assetCapCount:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["f" /* getAssetCapCount */])(state),extensisAccount:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["E" /* getExtensisAccount */])(state),extensisSystems:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["F" /* getExtensisSystems */])(state),isPendingResponseFromBonfire:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["W" /* getIsPendingResponseFromBonfire */])(state),licenseMaintenanceEndDate:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["_1" /* getLicenseMaintenanceEndDate */])(state),licensedFeatures:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["_2" /* getLicensedFeatures */])(state),licenses:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["_3" /* getLicenses */])(state),maxSeatCount:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["_6" /* getMaxSeatCount */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({addLicenses:__WEBPACK_IMPORTED_MODULE_12_state_commands_licenseCommands__["a" /* addLicenses */],getExtensisAccountInfo:__WEBPACK_IMPORTED_MODULE_12_state_commands_licenseCommands__["b" /* getExtensisAccountInfo */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_10_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],setExtensisSystem:__WEBPACK_IMPORTED_MODULE_12_state_commands_licenseCommands__["d" /* setExtensisSystem */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_10_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(Account)));

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_licenseCommands__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_safeDispatch__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SetAccountDialog=function(_Component){_inherits(SetAccountDialog,_Component);_createClass(SetAccountDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid&&!this.props.pristine;}},{key:'submit',value:function submit(data,props){this.handleSubmit(data.extensisAccount,data.extensisAccountPassword);}},{key:'handleRemoveAccount',value:function handleRemoveAccount(){this.handleSubmit('','');}},{key:'handleSubmit',value:function handleSubmit(account,password){this.props.setExtensisAccount(account,password);this.props.hideDialogPanel();}}]);function SetAccountDialog(){_classCallCheck(this,SetAccountDialog);var _this=_possibleConstructorReturn(this,(SetAccountDialog.__proto__||Object.getPrototypeOf(SetAccountDialog)).call(this));_this.handleRemoveAccount=_this.handleRemoveAccount.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(SetAccountDialog,[{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,extensisAccount=_props.extensisAccount,handleSubmit=_props.handleSubmit,hideDialogPanel=_props.hideDialogPanel,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'600px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LIC_SET_ACCOUNT),dialogFocusId:'extensisAccount',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,lowerLeftButtonText:extensisAccount?formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LIC_REMOVE_ACCOUNT):'',onClickLowerLeftButton:extensisAccount?this.handleRemoveAccount:function(){},onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_5_util_constants__["_1" /* SET_ACCOUNT_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LIC_SET_EXTENSIS_ACCOUNT),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LIC_ACCOUNT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{autoComplete:'extensis-account',className:'input',component:'input','data-test-name':'account-name',id:'extensisAccount',name:'extensisAccount',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LIC_PASSWORD)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{autoComplete:'new-password',className:'input',component:'input','data-test-name':'account-password',id:'extensisAccountPassword',name:'extensisAccountPassword',type:'password'}))));}}]);return SetAccountDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data){var errors={};if(!data.extensisAccount){errors.extensisAccount='Required';}if(!data.extensisAccountPassword){errors.extensisAccountPassword='Required';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_5_util_constants__["_1" /* SET_ACCOUNT_PANEL_ID */],validate:validate})(SetAccountDialog);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{extensisAccount:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["E" /* getExtensisAccount */])(state),initialValues:{extensisAccount:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["E" /* getExtensisAccount */])(state)}};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_10_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */],setExtensisAccount:__WEBPACK_IMPORTED_MODULE_9_state_commands_licenseCommands__["c" /* setExtensisAccount */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LICENSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_LICENSE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_IS_PENDING_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_EXTENSIS_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_EXTENSIS_ACCOUNT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_EXTENSIS_ACCOUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_EXTENSIS_SYSTEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_EXTENSIS_SYSTEMS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_EXTENSIS_SYSTEMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_LICENSING_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_LICENSING_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_LICENSING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_EXTENSIS_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_EXTENSIS_ACCOUNT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_EXTENSIS_ACCOUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_EXTENSIS_SYSTEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_EXTENSIS_SYSTEM_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_EXTENSIS_SYSTEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_IS_PENDING_RESPONSE; });
var ADD_LICENSE='admin/licenseAction/ADD_LICENSE';var ADD_LICENSE_FAIL='admin/licenseAction/ADD_LICENSE_FAIL';var ADD_LICENSE_SUCCESS='admin/licenseAction/ADD_LICENSE_SUCCESS';var GET_EXTENSIS_ACCOUNT='admin/licenseAction/GET_EXTENSIS_ACCOUNT';var GET_EXTENSIS_ACCOUNT_FAIL='admin/licenseAction/GET_EXTENSIS_ACCOUNT_FAIL';var GET_EXTENSIS_ACCOUNT_SUCCESS='admin/licenseAction/GET_EXTENSIS_ACCOUNT_SUCCESS';var GET_EXTENSIS_SYSTEMS='admin/licenseAction/GET_EXTENSIS_SYSTEMS';var GET_EXTENSIS_SYSTEMS_FAIL='admin/licenseAction/GET_EXTENSIS_SYSTEMS_FAIL';var GET_EXTENSIS_SYSTEMS_SUCCESS='admin/licenseAction/GET_EXTENSIS_SYSTEMS_SUCCESS';var GET_LICENSING_INFO='admin/licenseAction/GET_LICENSING_INFO';var GET_LICENSING_INFO_FAIL='admin/licenseAction/GET_LICENSING_INFO_FAIL';var GET_LICENSING_INFO_SUCCESS='admin/licenseAction/GET_LICENSING_INFO_SUCCESS';var SET_EXTENSIS_ACCOUNT='admin/licenseAction/SET_EXTENSIS_ACCOUNT';var SET_EXTENSIS_ACCOUNT_FAIL='admin/licenseAction/SET_EXTENSIS_ACCOUNT_FAIL';var SET_EXTENSIS_ACCOUNT_SUCCESS='admin/licenseAction/SET_EXTENSIS_ACCOUNT_SUCCESS';var SET_EXTENSIS_SYSTEM='admin/licenseAction/SET_EXTENSIS_SYSTEM';var SET_EXTENSIS_SYSTEM_FAIL='admin/licenseAction/SET_EXTENSIS_SYSTEM_FAIL';var SET_EXTENSIS_SYSTEM_SUCCESS='admin/licenseAction/SET_EXTENSIS_SYSTEM_SUCCESS';var SET_IS_PENDING_RESPONSE='admin/licenseAction/SET_IS_PENDING_RESPONSE';var CLEAR_IS_PENDING_RESPONSE='admin/licenseAction/CLEAR_IS_PENDING_RESPONSE';

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccountRenderer=function(_Component){_inherits(AccountRenderer,_Component);function AccountRenderer(){_classCallCheck(this,AccountRenderer);var _this=_possibleConstructorReturn(this,(AccountRenderer.__proto__||Object.getPrototypeOf(AccountRenderer)).call(this));_this.clickSetAccount=_this.clickSetAccount.bind(_this);return _this;}_createClass(AccountRenderer,[{key:'clickSetAccount',value:function clickSetAccount(){this.setAccountButtonRef.blur();this.props.clickSetExtensisAccount();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,extensisAccount=_props.extensisAccount,licenseMaintenanceEndDate=_props.licenseMaintenanceEndDate;var isExpiredMaintenanceEndDate=!!(licenseMaintenanceEndDate&&new Date(licenseMaintenanceEndDate)<Date.now());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].USER_ACCOUNT)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-medium','data-test-name':'set-account-button',onClick:this.clickSetAccount,ref:function ref(b){_this2.setAccountButtonRef=b;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,extensisAccount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-medium has-text-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-gear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),licenseMaintenanceEndDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].LIC_MAINTENANCE_END_DATE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'24px'},className:isExpiredMaintenanceEndDate?'has-text-danger':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedDate */],{value:licenseMaintenanceEndDate})),isExpiredMaintenanceEndDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].LIC_CONTACT_CUSTOMER_SUCCESS_1),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:info@portfoliodam.com'},'info@portfoliodam.com'),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].LIC_CONTACT_CUSTOMER_SUCCESS_2))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-indented has-text-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].LIC_ERROR_GET_ACCOUNT)));}}]);return AccountRenderer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AccountRenderer);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_commands_licenseCommands__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddLicenseDialog__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NoAccount=function(_Component){_inherits(NoAccount,_Component);function NoAccount(){_classCallCheck(this,NoAccount);var _this=_possibleConstructorReturn(this,(NoAccount.__proto__||Object.getPrototypeOf(NoAccount)).call(this));_this.handleClickAddLicense=_this.handleClickAddLicense.bind(_this);_this.handleClickSetExtensisAccount=_this.handleClickSetExtensisAccount.bind(_this);_this.renderOption=_this.renderOption.bind(_this);_this.renderSupportLink=_this.renderSupportLink.bind(_this);return _this;}_createClass(NoAccount,[{key:'handleClickAddLicense',value:function handleClickAddLicense(e){e&&e.currentTarget&&e.currentTarget.blur();this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_6_util_constants__["d" /* ADD_LICENSE_PANEL_ID */]);}},{key:'handleClickSetExtensisAccount',value:function handleClickSetExtensisAccount(e){e&&e.currentTarget&&e.currentTarget.blur();this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_6_util_constants__["_1" /* SET_ACCOUNT_PANEL_ID */]);}},{key:'renderOption',value:function renderOption(title,buttonLabel,handleClick,dataTestName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],title)),this.renderSupportLink()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-outlined','data-test-name':dataTestName,onClick:handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-plus-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],buttonLabel))));}},{key:'renderSupportLink',value:function renderSupportLink(){var formatMessage=this.props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].EXTENSIS_SUPPORT_URL),rel:'noopener noreferrer',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-question-circle fa-2x has-text-primary licenseInfoIcon'}));}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,addLicenses=_props.addLicenses,hideDialogPanel=_props.hideDialogPanel,showDialogPanel=_props.showDialogPanel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AddLicenseDialog__["a" /* default */],{activePanelId:activePanelId,addLicenses:addLicenses,hideDialogPanel:hideDialogPanel,showDialogPanel:showDialogPanel}),this.renderOption(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].LIC_ACTIVATE,__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].LIC_CLICK_TO_ACTIVATE,this.handleClickSetExtensisAccount,'activate-with-account'),this.renderOption(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].LIC_TRIAL,__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].LIC_CLICK_TO_USE,this.handleClickAddLicense,'try-with-demo'));}}]);return NoAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NoAccount);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_licenseUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_licenseCommands__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_dialogPanelCommands__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddLicenseDialog=function(_Component){_inherits(AddLicenseDialog,_Component);function AddLicenseDialog(){_classCallCheck(this,AddLicenseDialog);var _this=_possibleConstructorReturn(this,(AddLicenseDialog.__proto__||Object.getPrototypeOf(AddLicenseDialog)).call(this));_this.handleClose=_this.handleClose.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(AddLicenseDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid&&!this.props.pristine;}},{key:'handleKeyDown',value:function handleKeyDown(e){return e.keyCode===13&&!e.ctrlKey;}},{key:'handleChange',value:function handleChange(event,newValue,previousValue,name){if(!/^[a-zA-Z0-9-\s]*$/.test(newValue)){event.preventDefault();}}},{key:'handleClose',value:function handleClose(){this.props.reset();}},{key:'submit',value:function submit(values){var _props=this.props,addLicenses=_props.addLicenses,hideDialogPanel=_props.hideDialogPanel,intl=_props.intl,licenseText=_props.licenseText;hideDialogPanel();addLicenses(licenseText,intl);this.handleClose();// resets the form, so call after we use the licenseText value.
}},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,formatMessage=_props2.intl.formatMessage,handleSubmit=_props2.handleSubmit,hideDialogPanel=_props2.hideDialogPanel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,closeAfterSave:false,contentStyle:{width:'500px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LIC_ADD_SN_SHORT),dialogFocusId:'licenses',handleKeyDown:this.handleKeyDown,hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onClose:this.handleClose,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_6_util_constants__["d" /* ADD_LICENSE_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LIC_ADD_SN_SHORT),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',style:{padding:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LIC_ADD_MESSAGE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'textarea',component:'textarea',id:'licenses',name:'licenses',onChange:this.handleChange,rows:'10',type:'text',style:{resize:'none'}}))))));}}]);return AddLicenseDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data){var errors={};if(!Object(__WEBPACK_IMPORTED_MODULE_4_util_licenseUtils__["b" /* containsValidLicenses */])(data.licenses)){errors.licenses='Required';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_6_util_constants__["d" /* ADD_LICENSE_PANEL_ID */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(AddLicenseDialog));var selector=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_6_util_constants__["d" /* ADD_LICENSE_PANEL_ID */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{licenseText:selector(state,'licenses')};})(form));

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_licenseCommands__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SetSystemDialog=function(_Component){_inherits(SetSystemDialog,_Component);function SetSystemDialog(){_classCallCheck(this,SetSystemDialog);var _this=_possibleConstructorReturn(this,(SetSystemDialog.__proto__||Object.getPrototypeOf(SetSystemDialog)).call(this));_this.state={selectedValue:undefined};_this.handleClickSystemCheckbox=_this.handleClickSystemCheckbox.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.renderSystem=_this.renderSystem.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(SetSystemDialog,[{key:'handleClickSystemCheckbox',value:function handleClickSystemCheckbox(event){if(event.currentTarget.checked){this.setState({selectedValue:event.currentTarget.id});}}},{key:'isOkEnabled',value:function isOkEnabled(){return this.state.selectedValue;}},{key:'submit',value:function submit(){if(this.state.selectedValue){this.props.setExtensisSystem(this.state.selectedValue);this.props.hideDialogPanel();}}},{key:'renderSystem',value:function renderSystem(system){var intl=this.props.intl;var label=intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].LIC_SYSTEM_ID)+': '+system.systemId+' '+intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].LIC_MAINTENANCE_END_DATE)+': '+intl.formatDate(system.licensingInfo.maintenanceEndDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:system.systemId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:this.state.selectedValue===system.systemId,className:'is-checkradio',id:system.systemId,onChange:this.handleClickSystemCheckbox,type:'radio',name:'selectedSystem'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:system.systemId},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activePanelId=_props.activePanelId,hideDialogPanel=_props.hideDialogPanel,intl=_props.intl,systems=_props.systems;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'600px',height:null},hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:this.submit,panelId:__WEBPACK_IMPORTED_MODULE_2_util_constants__["_2" /* SET_SYSTEM_PANEL_ID */],panelTitle:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].LIC_SET_SYSTEM_TITLE),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container'},systems.map(function(system){return _this2.renderSystem(system);})));}}]);return SetSystemDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SetSystemDialog);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RolesPage_js__ = __webpack_require__(984);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RolesPage_js__["a" /* default */]);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RoleRow__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_roleCommands__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RoleDetailsForm__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PageHeader__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_roleUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_view_App_DialogPanels_ModalStringPrompt__ = __webpack_require__(196);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RolesPage=function(_Component){_inherits(RolesPage,_Component);function RolesPage(){_classCallCheck(this,RolesPage);var _this=_possibleConstructorReturn(this,(RolesPage.__proto__||Object.getPrototypeOf(RolesPage)).call(this));_this.state={isCreateRoleVisible:false};_this.closeCreateRolePrompt=_this.closeCreateRolePrompt.bind(_this);_this.doCreateRole=_this.doCreateRole.bind(_this);_this.handleSelectRow=_this.handleSelectRow.bind(_this);_this.onCreateRole=_this.onCreateRole.bind(_this);_this.onDeleteRole=_this.onDeleteRole.bind(_this);_this.roleNameValidator=_this.roleNameValidator.bind(_this);return _this;}_createClass(RolesPage,[{key:'componentDidMount',value:function componentDidMount(){this.getRoles();}},{key:'getRoles',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.getRolesCommand();case 2:_context.next=4;return this.props.setSelectedRoleCommand(this.props.roles[0]);case 4:case'end':return _context.stop();}}},_callee,this);}));function getRoles(){return _ref.apply(this,arguments);}return getRoles;}()},{key:'handleSelectRow',value:function handleSelectRow(e,index){this.props.setSelectedRoleCommand(this.props.roles[index]);}},{key:'isSelectedRoleCustom',value:function isSelectedRoleCustom(){var role=this.props.selectedRole;return Object(__WEBPACK_IMPORTED_MODULE_11_util_roleUtils__["g" /* isRoleCustom */])(role);}},{key:'onCreateRole',value:function onCreateRole(){this.setState({isCreateRoleVisible:true});}},{key:'closeCreateRolePrompt',value:function closeCreateRolePrompt(){this.setState({isCreateRoleVisible:false});}},{key:'roleNameValidator',value:function roleNameValidator(value){if(!value||!value.length){return'Empty String';}else if(this.props.roles.map(function(role){return role.name.toLowerCase();}).includes(value.toLowerCase())){return'Existing Role';}}},{key:'doCreateRole',value:function doCreateRole(roleName){this.props.createRoleCommand(roleName);}},{key:'onDeleteRole',value:function onDeleteRole(){if(this.props.selectedRole){var roleName=this.props.selectedRole.name;this.props.deleteRoleCommand(roleName);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,roles=_props.roles,formatMessage=_props.intl.formatMessage,selectedRole=_props.selectedRole,updateRoleCommand=_props.updateRoleCommand;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page','data-test-name':'roles-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contents columns is-gapless'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column is-one-third page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PageHeader__["a" /* default */],{deleteDisabled:!this.isSelectedRoleCustom(),onClickAdd:this.onCreateRole,onClickDelete:this.onDeleteRole,title:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].NAV_ACCESS_LEVELS)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page bordered-page-column is-scrollable'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table is-fullwidth is-hoverable','data-test-name':'role-list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,roles.map(function(role,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RoleRow__["a" /* default */],{role:role,index:index,isSelected:!!(selectedRole&&role.uuid===selectedRole.uuid),key:role.uuid,onClick:_this2.handleSelectRow});}))))),selectedRole&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RoleDetailsForm__["a" /* default */],{role:selectedRole,updateRole:updateRoleCommand})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_view_App_DialogPanels_ModalStringPrompt__["a" /* default */],{isOpen:this.state.isCreateRoleVisible,label:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].NAME),onClose:this.closeCreateRolePrompt,onSave:this.doCreateRole,panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].ROLES_CREATE_ROLE_TITLE),maxLength:100,validate:this.roleNameValidator,dataTestName:'create-role-modal'}));}}]);return RolesPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{roles:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_15" /* getRoles */])(state),selectedRole:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_21" /* getSelectedRole */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({createRoleCommand:__WEBPACK_IMPORTED_MODULE_7_state_commands_roleCommands__["a" /* createRole */],deleteRoleCommand:__WEBPACK_IMPORTED_MODULE_7_state_commands_roleCommands__["b" /* deleteRole */],getRolesCommand:__WEBPACK_IMPORTED_MODULE_7_state_commands_roleCommands__["c" /* getRoles */],setSelectedRoleCommand:__WEBPACK_IMPORTED_MODULE_7_state_commands_roleCommands__["d" /* setSelectedRole */],updateRoleCommand:__WEBPACK_IMPORTED_MODULE_7_state_commands_roleCommands__["e" /* updateRole */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(RolesPage)));

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_roleUtils__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoleRow=function(_Component){_inherits(RoleRow,_Component);function RoleRow(){_classCallCheck(this,RoleRow);var _this=_possibleConstructorReturn(this,(RoleRow.__proto__||Object.getPrototypeOf(RoleRow)).call(this));_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(RoleRow,[{key:'handleClick',value:function handleClick(e){this.props.onClick(e,this.props.index);}},{key:'render',value:function render(){var _props=this.props,intl=_props.intl,isSelected=_props.isSelected,role=_props.role;var className='role-row has-pointer '+(isSelected?'is-selected':'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:className,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'list-item no-padding','data-test-name':'role-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'role-item'},Object(__WEBPACK_IMPORTED_MODULE_2_util_roleUtils__["e" /* getLocalizedRoleName */])(intl,role.name))));}}]);return RoleRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(RoleRow));

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_commands_roleCommands__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_permissionUtils__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_roleUtils__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoleDetailsPage=function(_Component){_inherits(RoleDetailsPage,_Component);function RoleDetailsPage(){_classCallCheck(this,RoleDetailsPage);var _this=_possibleConstructorReturn(this,(RoleDetailsPage.__proto__||Object.getPrototypeOf(RoleDetailsPage)).call(this));_this.isDisabled=_this.isDisabled.bind(_this);_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(RoleDetailsPage,[{key:'isDisabled',value:function isDisabled(perm,role){switch(role&&role.name){case __WEBPACK_IMPORTED_MODULE_5_util_roleUtils__["a" /* NAME_ADMIN */]:return true;case __WEBPACK_IMPORTED_MODULE_5_util_roleUtils__["c" /* NAME_PUBLISHER */]:return __WEBPACK_IMPORTED_MODULE_4_util_permissionUtils__["d" /* unsettableForPublisher */].includes(perm);case __WEBPACK_IMPORTED_MODULE_5_util_roleUtils__["b" /* NAME_EDITOR */]:return __WEBPACK_IMPORTED_MODULE_4_util_permissionUtils__["c" /* unsettableForEditor */].includes(perm);case __WEBPACK_IMPORTED_MODULE_5_util_roleUtils__["d" /* NAME_READER */]:return!__WEBPACK_IMPORTED_MODULE_4_util_permissionUtils__["b" /* settableForReader */].includes(perm);default:return false;}}},{key:'onChange',value:function onChange(event,name){var _props=this.props,role=_props.role,updateRole=_props.updateRole;var checked=event.target.checked;var grant=checked?name:'';var revoke=checked?'':name;updateRole(role.name,grant,revoke);}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,role=_props2.role,formatMessage=_props2.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */].ROLES_PERMISSIONS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container is-textured','data-test-name':'role-permission-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_4_util_permissionUtils__["a" /* allPermissions */].sort(function(a,b){return formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */][a]).localeCompare(formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */][b]));}).map(function(perm){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field',key:perm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:role.permissions.includes(perm),className:'is-checkradio',disabled:_this2.isDisabled(perm,role),id:perm,onChange:function onChange(e){return _this2.onChange(e,perm);},type:'checkbox','data-test-name':'permission-'+perm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'role-label',htmlFor:perm},formatMessage(__WEBPACK_IMPORTED_MODULE_3_util_localizedStrings__["a" /* default */][perm])));}))));}}]);return RoleDetailsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(RoleDetailsPage));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PERMISSION_ACCESS_ORIGINALS */
/* unused harmony export PERMISSION_ADD_ASSET */
/* unused harmony export PERMISSION_DELETE_ASSET_CONTENTS */
/* unused harmony export PERMISSION_DELETE_ASSET_FROM_CATALOG */
/* unused harmony export PERMISSION_CAN_EMBED_METADATA */
/* unused harmony export PERMISSION_CAN_IMPORT_METADATA */
/* unused harmony export PERMISSION_CAN_MANAGE_PUBLIC_GALLERY */
/* unused harmony export PERMISSION_CAN_PUBLISH_NP_SITES */
/* unused harmony export PERMISSION_CAN_SMART_KEYWORD */
/* unused harmony export PERMISSION_CREATE_CONTACT_SHEET */
/* unused harmony export PERMISSION_MANAGE_FIELD_LISTS */
/* unused harmony export PERMISSION_MODIFY_ASSET_CONTENTS */
/* unused harmony export PERMISSION_MODIFY_ASSET_PROPERTIES */
/* unused harmony export PERMISSION_MODIFY_FOLDER_STRUCTURE */
/* unused harmony export PERMISSION_MOVE_ASSETS */
/* unused harmony export PERMISSION_SAVE_OUTPUT_SETTING */
/* unused harmony export PERMISSION_SYNC_AUTOSYNC_FOLDERS */
/* unused harmony export PERMISSION_USE_CUSTOM_PRESETS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settableForReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unsettableForEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unsettableForPublisher; });
var PERMISSION_ACCESS_ORIGINALS='accessOriginals';var PERMISSION_ADD_ASSET='addAsset';var PERMISSION_DELETE_ASSET_CONTENTS='deleteAssetContents';var PERMISSION_DELETE_ASSET_FROM_CATALOG='deleteAssetFromCatalog';var PERMISSION_CAN_EMBED_METADATA='canEmbedMetadata';var PERMISSION_CAN_IMPORT_METADATA='canImportMetadata';var PERMISSION_CAN_MANAGE_PUBLIC_GALLERY='canManagePublicGallery';var PERMISSION_CAN_PUBLISH_NP_SITES='canPublishNetPublishSites';var PERMISSION_CAN_SMART_KEYWORD='canSmartKeyword';var PERMISSION_CREATE_CONTACT_SHEET='createContactSheet';// export const PERMISSION_DOWNLOAD_PREVIEWS = 'downloadPreviews'; // not exposed in the UI
var PERMISSION_MANAGE_FIELD_LISTS='canManageFieldLists';var PERMISSION_MODIFY_ASSET_CONTENTS='modifyAssetContents';var PERMISSION_MODIFY_ASSET_PROPERTIES='modifyAssetProperties';var PERMISSION_MODIFY_FOLDER_STRUCTURE='canModifyFolderStructure';var PERMISSION_MOVE_ASSETS='canMoveAssets';var PERMISSION_SAVE_OUTPUT_SETTING='saveOutputSetting';var PERMISSION_SYNC_AUTOSYNC_FOLDERS='synchronizeAutoSyncFolder';var PERMISSION_USE_CUSTOM_PRESETS='useCustomPresets';var allPermissions=[PERMISSION_ACCESS_ORIGINALS,PERMISSION_ADD_ASSET,PERMISSION_DELETE_ASSET_CONTENTS,PERMISSION_DELETE_ASSET_FROM_CATALOG,PERMISSION_CAN_EMBED_METADATA,PERMISSION_CAN_IMPORT_METADATA,PERMISSION_CAN_MANAGE_PUBLIC_GALLERY,PERMISSION_CAN_PUBLISH_NP_SITES,PERMISSION_CAN_SMART_KEYWORD,PERMISSION_CREATE_CONTACT_SHEET,PERMISSION_MANAGE_FIELD_LISTS,PERMISSION_MODIFY_ASSET_CONTENTS,PERMISSION_MODIFY_ASSET_PROPERTIES,PERMISSION_MODIFY_FOLDER_STRUCTURE,PERMISSION_MOVE_ASSETS,PERMISSION_SAVE_OUTPUT_SETTING,PERMISSION_SYNC_AUTOSYNC_FOLDERS,PERMISSION_USE_CUSTOM_PRESETS];var settableForReader=[PERMISSION_ACCESS_ORIGINALS,PERMISSION_CREATE_CONTACT_SHEET,PERMISSION_CAN_MANAGE_PUBLIC_GALLERY,PERMISSION_USE_CUSTOM_PRESETS];var unsettableForEditor=[PERMISSION_SAVE_OUTPUT_SETTING,PERMISSION_MODIFY_ASSET_CONTENTS,PERMISSION_CAN_PUBLISH_NP_SITES];var unsettableForPublisher=[PERMISSION_USE_CUSTOM_PRESETS,PERMISSION_ACCESS_ORIGINALS,PERMISSION_CAN_EMBED_METADATA,PERMISSION_CAN_MANAGE_PUBLIC_GALLERY,PERMISSION_CREATE_CONTACT_SHEET,PERMISSION_MODIFY_ASSET_CONTENTS];

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UsersPage__ = __webpack_require__(989);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__UsersPage__["a" /* default */]);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_virtualized__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_userCommands__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_userUtils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_tableUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UserForm__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CreateUserDialog__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DeleteUsersDialog__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PageHeader__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_view_App_MultipleSelectionTable__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MULTIPLE='multiple';var NONE='none';var UsersPage=function(_Component){_inherits(UsersPage,_Component);function UsersPage(){_classCallCheck(this,UsersPage);var _this=_possibleConstructorReturn(this,(UsersPage.__proto__||Object.getPrototypeOf(UsersPage)).call(this));_this.state={selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["d" /* getNewSelectionState */])(),sortDirection:__WEBPACK_IMPORTED_MODULE_5_react_virtualized__["g" /* SortDirection */].ASC,sortBy:'name',sortedUsers:[]};_this.deleteDialogCallback=_this.deleteDialogCallback.bind(_this);_this.handleClickAdd=_this.handleClickAdd.bind(_this);_this.handleClickDelete=_this.handleClickDelete.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.handleSelectionChanged=_this.handleSelectionChanged.bind(_this);_this.sort=_this.sort.bind(_this);_this.userTypeCellRenderer=_this.userTypeCellRenderer.bind(_this);return _this;}_createClass(UsersPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getUsersAction();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _state=this.state,selectionState=_state.selectionState,sortBy=_state.sortBy,sortDirection=_state.sortDirection;if(this.props.users!==nextProps.users||this.props.location.pathname!==nextProps.location.pathname&&!nextProps.location.pathname.endsWith(MULTIPLE)&&!nextProps.location.pathname.endsWith(NONE)){var _sortedUsers=Object(__WEBPACK_IMPORTED_MODULE_10_util_userUtils__["e" /* sortUsers */])(nextProps.users,sortBy,sortDirection);var selectedIndex=Object(__WEBPACK_IMPORTED_MODULE_10_util_userUtils__["b" /* findUserIndex */])(this.userUuidFromPath(nextProps.location.pathname),_sortedUsers)||0;this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["b" /* computeNewSelection */])(selectedIndex,_sortedUsers,selectionState,{}),sortedUsers:_sortedUsers});}}// TODO: There's a bug in React 16.3 regarding getDerivedStateFromProps().
//  It's fixed in 16.4 but will change when getDerivedStateFromProps() is called.
// Reenable and test after we upgrade to 16.4
//
// https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html
//
// static getDerivedStateFromProps(nextProps, prevState) {
//   return {
//     ...prevState,
//     sortedUsers: sortUsers(
//       nextProps.users,
//       prevState.sortBy,
//       prevState.sortDirection
//     ),
//   };
// }
},{key:'handleSelectionChanged',value:function handleSelectionChanged(selectionState){this.setState({selectionState:selectionState});var selectedIndices=Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["e" /* getSelectedIndices */])(selectionState);if(selectedIndices.length===1){var uuid=this.state.sortedUsers[selectedIndices[0]].uuid;if(uuid){this.props.history.replace('/users/'+uuid);}}else if(selectedIndices.length>1){this.props.history.replace('/users/'+MULTIPLE);}else if(selectedIndices.length===0){this.props.history.replace('/users/'+NONE);}}},{key:'handleClickAdd',value:function handleClickAdd(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_17_util_constants__["B" /* CREATE_USER_PANEL_ID */]);}},{key:'handleClickDelete',value:function handleClickDelete(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_17_util_constants__["E" /* DELETE_USER_PANEL_ID */]);}},{key:'deleteDialogCallback',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(deletePrivateGalleries){var _state2,selectionState,sortedUsersOriginal,sortedUsers,targets,cleanupToken,lowestSelectedIndex,selectedIndices,newSortedUsers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_state2=this.state,selectionState=_state2.selectionState,sortedUsersOriginal=_state2.sortedUsers;// Make a copy so we don't modify state directly
sortedUsers=[].concat(_toConsumableArray(sortedUsersOriginal));targets=this.getUsersInSelection();if(!targets.length){_context.next=13;break;}cleanupToken=deletePrivateGalleries?__WEBPACK_IMPORTED_MODULE_17_util_constants__["q" /* CLEANUP_TOKEN */].deletePrivateGalleries:__WEBPACK_IMPORTED_MODULE_17_util_constants__["q" /* CLEANUP_TOKEN */].makePrivateGalleriesPublic;__WEBPACK_IMPORTED_MODULE_18_portfolio_shared_util_logging__["a" /* default */].debug('Delete users: ',targets,' token: ',cleanupToken);_context.next=8;return this.props.deleteUsers(targets,[cleanupToken]);case 8:lowestSelectedIndex=sortedUsersOriginal.length;selectedIndices=Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["e" /* getSelectedIndices */])(selectionState);// Compute lowest selected index
selectedIndices.forEach(function(u){if(u<lowestSelectedIndex){lowestSelectedIndex=u;}});newSortedUsers=sortedUsers.filter(function(u,idx){return!selectedIndices.includes(idx);});this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["b" /* computeNewSelection */])(Math.min(lowestSelectedIndex,sortedUsers.length-2),newSortedUsers,selectionState,{}),sortedUsers:newSortedUsers});case 13:case'end':return _context.stop();}}},_callee,this);}));function deleteDialogCallback(_x){return _ref.apply(this,arguments);}return deleteDialogCallback;}()},{key:'userUuidFromPath',value:function userUuidFromPath(pathname){return pathname.split('/')[2];}},{key:'sort',value:function sort(_ref2){var sortBy=_ref2.sortBy,sortDirection=_ref2.sortDirection;var sortedUsers=Object(__WEBPACK_IMPORTED_MODULE_10_util_userUtils__["e" /* sortUsers */])(this.props.users,sortBy,sortDirection);this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["h" /* reindexSelectedItems */])(sortedUsers,this.state.selectionState),sortBy:sortBy,sortDirection:sortDirection,sortedUsers:sortedUsers});}},{key:'userTypeCellRenderer',value:function userTypeCellRenderer(_ref3){var cellData=_ref3.cellData,columnData=_ref3.columnData,columnIndex=_ref3.columnIndex,dataKey=_ref3.dataKey,isScrolling=_ref3.isScrolling,rowData=_ref3.rowData,rowIndex=_ref3.rowIndex;return Object(__WEBPACK_IMPORTED_MODULE_10_util_userUtils__["d" /* renderUserType */])(rowData,rowIndex,this.state.selectionState);}},{key:'handleKeyDown',value:function handleKeyDown(e){// Typeahead first character only
var _state3=this.state,selectionState=_state3.selectionState,sortBy=_state3.sortBy,sortedUsers=_state3.sortedUsers;var searchField=sortBy==='longName'?'longName':'name';if(!e.metaKey&&/[a-z,0-9]/i.test(e.key)){var index=sortedUsers.findIndex(function(u){return u[searchField]!==undefined&&u[searchField].substr(0,1).localeCompare(e.key,undefined,{usage:'search',sensitivity:'base'})===0;});if(index!==-1){this.setState({selectionState:Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["b" /* computeNewSelection */])(index,sortedUsers,selectionState,{})});e.preventDefault();}}}},{key:'getUsersInSelection',value:function getUsersInSelection(){var _state4=this.state,selectionState=_state4.selectionState,sortedUsers=_state4.sortedUsers;var selectedIndices=Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["e" /* getSelectedIndices */])(selectionState);return selectedIndices.map(function(idx){return sortedUsers[idx];});}},{key:'isDeleteDisabled',value:function isDeleteDisabled(){return this.getUsersInSelection().findIndex(function(u){return u&&Object(__WEBPACK_IMPORTED_MODULE_10_util_userUtils__["c" /* isAdminUser */])(u);})!==-1;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activePanelId=_props.activePanelId,formatMessage=_props.intl.formatMessage;var _state5=this.state,selectionState=_state5.selectionState,sortBy=_state5.sortBy,sortDirection=_state5.sortDirection,sortedUsers=_state5.sortedUsers;var selectedUsers=Object(__WEBPACK_IMPORTED_MODULE_11_util_tableUtils__["e" /* getSelectedIndices */])(selectionState);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contents','data-test-name':'users-page'},activePanelId===__WEBPACK_IMPORTED_MODULE_17_util_constants__["B" /* CREATE_USER_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CreateUserDialog__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DeleteUsersDialog__["a" /* default */],{callback:this.deleteDialogCallback}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contents columns is-gapless'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column is-one-third page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PageHeader__["a" /* default */],{deleteDisabled:this.isDeleteDisabled(),onClickAdd:this.handleClickAdd,onClickDelete:this.handleClickDelete,title:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NAV_USERS)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page bordered-page-column',onKeyDown:this.handleKeyDown},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_virtualized__["b" /* AutoSizer */],null,function(_ref4){var height=_ref4.height,width=_ref4.width;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_view_App_MultipleSelectionTable__["a" /* default */],{headerHeight:40,height:height,onSelectionChanged:_this2.handleSelectionChanged,rowHeight:50,selectionState:_this2.state.selectionState,sort:_this2.sort,sortBy:sortBy,sortDirection:sortDirection,sortedItems:_this2.state.sortedUsers,width:width},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_virtualized__["e" /* Column */],{cellRenderer:_this2.userTypeCellRenderer,dataKey:'fromLDAP',width:35}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'name',label:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].USER_ACCOUNT),width:200}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_virtualized__["e" /* Column */],{className:'list-item',dataKey:'longName',label:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].FULL_NAME),width:300}));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-header'}),selectedUsers.length===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-message'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].USER_NO_USERS_SELECTED)),sortedUsers.length>0&&selectedUsers.length===1&&sortedUsers[selectedUsers[0]]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UserForm__["b" /* EditUserForm */],{successMessage:formatMessage(__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].NOTIFICATION_SUCCESS_UPDATE),user:sortedUsers[selectedUsers[0]]}),selectedUsers.length>1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-message'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9_util_localizedStrings__["a" /* default */].USER_MULT_USERS_SELECTED)))));}}]);return UsersPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var usersPageWrapper=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["c" /* getActivePanelId */])(state),users:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_34" /* getUsers */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteUsers:__WEBPACK_IMPORTED_MODULE_8_state_commands_userCommands__["b" /* deleteUsers */],getUsersAction:__WEBPACK_IMPORTED_MODULE_8_state_commands_userCommands__["c" /* getUsers */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_13_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(UsersPage));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* withRouter */])(usersPageWrapper));

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(399),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__(991),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__(399);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  function UnmountClosed(props) {
    _classCallCheck(this, UnmountClosed);

    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));

    _this.componentWillReceiveProps = function (_ref) {
      var isOpened = _ref.isOpened;

      if (!_this.props.isOpened && isOpened) {
        _this.setState({
          forceInitialAnimation: true,
          shouldUnmount: false
        });
      }
    };

    _this.onRest = function () {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          onRest = _this$props.onRest;


      if (!isOpened) {
        _this.setState({ shouldUnmount: true });
      }
      if (onRest) {
        onRest.apply(undefined, arguments);
      }
    };

    _this.state = {
      shouldUnmount: !_this.props.isOpened,
      forceInitialAnimation: !_this.props.isOpened
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          _onRest = _props.onRest,
          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);

      var _state = this.state,
          forceInitialAnimation = _state.forceInitialAnimation,
          shouldUnmount = _state.shouldUnmount;


      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
        forceInitialAnimation: forceInitialAnimation,
        isOpened: isOpened,
        onRest: this.onRest
      }, props));
    }
  }]);

  return UnmountClosed;
}(_react2.default.PureComponent);

UnmountClosed.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  onRest: _propTypes2.default.func
};

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = submit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_md5__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__ = __webpack_require__(19);
function submit(data,dispatch,props){var createUser=props.createUser,initialize=props.initialize,isCreate=props.isCreate,successMessage=props.successMessage,updateUser=props.updateUser,isToken=props.isToken;var addUserToAllCatalogs=data.addUserToAllCatalogs,name=data.name,password=data.password,longName=data.longName,email=data.email,notes=data.notes,roleName=data.roleName,uuid=data.uuid,fromLDAP=data.fromLDAP,ldapSourceDN=data.ldapSourceDN;var user={name:name,password:password?__WEBPACK_IMPORTED_MODULE_0_md5___default()(password):password,longName:longName,email:email,notes:notes,uuid:uuid,isToken:isToken,fromLDAP:fromLDAP,ldapSourceDN:ldapSourceDN};if(isCreate){__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__["a" /* default */].debug('Submitting create user: ',user);createUser(user,addUserToAllCatalogs,roleName);}else{__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__["a" /* default */].debug('Submitting update user: ',user);updateUser(user,successMessage);delete user.password;initialize(user);}}

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UserForm__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_roleCommands__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_roleUtils__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var newUser={addUserToAllCatalogs:false,fromLDAP:false,name:'',roleName:__WEBPACK_IMPORTED_MODULE_13_util_roleUtils__["c" /* NAME_PUBLISHER */]};var CreateUserDialog=function(_Component){_inherits(CreateUserDialog,_Component);function CreateUserDialog(){_classCallCheck(this,CreateUserDialog);var _this=_possibleConstructorReturn(this,(CreateUserDialog.__proto__||Object.getPrototypeOf(CreateUserDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);return _this;}_createClass(CreateUserDialog,[{key:'componentDidMount',value:function componentDidMount(){this.props.getRolesAction();}},{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,dispatch,hideDialogPanel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,dispatch=_props.dispatch,hideDialogPanel=_props.hideDialogPanel;//$FlowFixMe
_context.next=3;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["l" /* submit */])(__WEBPACK_IMPORTED_MODULE_10_util_constants__["A" /* CREATE_USER_FORM */]));case 3:hideDialogPanel();case 4:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,hideDialogPanel=_props2.hideDialogPanel,formatMessage=_props2.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,closeAfterSave:false,contentStyle:{width:'650px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CREATE),dialogFocusId:'name-create',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:this.onSubmit,panelId:__WEBPACK_IMPORTED_MODULE_10_util_constants__["B" /* CREATE_USER_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CREATE_USER),showCancel:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UserForm__["a" /* CreateUserForm */],{isCreate:true,user:newUser}));}}]);return CreateUserDialog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state),valid:Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["h" /* isValid */])(__WEBPACK_IMPORTED_MODULE_10_util_constants__["A" /* CREATE_USER_FORM */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_util_safeDispatch__["a" /* bindActionCreatorsForm */])({getRolesAction:__WEBPACK_IMPORTED_MODULE_12_state_commands_roleCommands__["c" /* getRoles */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_8_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(CreateUserDialog)));

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteUserDialog=function(_Component){_inherits(DeleteUserDialog,_Component);function DeleteUserDialog(){_classCallCheck(this,DeleteUserDialog);var _this=_possibleConstructorReturn(this,(DeleteUserDialog.__proto__||Object.getPrototypeOf(DeleteUserDialog)).call(this));_this.submit=_this.submit.bind(_this);return _this;}_createClass(DeleteUserDialog,[{key:'submit',value:function submit(data){this.props.callback(data.privateGalleries==='delete');this.props.hideDialogPanel();}},{key:'isOkEnabled',value:function isOkEnabled(){return true;}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,privateGalleries=_props.privateGalleries,handleSubmit=_props.handleSubmit,hideDialogPanel=_props.hideDialogPanel,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,closeAfterSave:false,contentStyle:{width:'650px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].DELETE),dialogFocusId:'public',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_9_util_constants__["E" /* DELETE_USER_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_DELETE_CONFIRM),showCancel:true,dataTestName:'remove-user-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_DELETE__GALLERY_PROMPT_1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_DELETE__GALLERY_PROMPT_2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_DELETE__GALLERY_PROMPT_3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'0.5em'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-indented'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__["a" /* default */],fieldValue:privateGalleries,id:'public',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_DELETE__MAKE_PUBLIC),name:'privateGalleries',type:'radio',value:'public'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_10_view_Forms_BulmaCheckRadio__["a" /* default */],fieldValue:privateGalleries,id:'private',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_DELETE__DELETE_PRIVATE),name:'privateGalleries',type:'radio',value:'delete'})))));}}]);return DeleteUserDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var form=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_9_util_constants__["E" /* DELETE_USER_PANEL_ID */],initialValues:{privateGalleries:'public'}})(DeleteUserDialog);var selector=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_9_util_constants__["E" /* DELETE_USER_PANEL_ID */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state),privateGalleries:selector(state,'privateGalleries')};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["a" /* bindActionCreatorsForm */])({hideDialogPanel:__WEBPACK_IMPORTED_MODULE_7_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_types_reportTypes__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_netPublishCommands__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_reportCommands__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_reportUtils__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_view_Forms_LabeledField__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// TODO: remove viewReport import
var ALL_CATALOGS='All Catalogs';var ALL_SITES='All Sites';var ReportsPage=function(_Component){_inherits(ReportsPage,_Component);function ReportsPage(){_classCallCheck(this,ReportsPage);var _this=_possibleConstructorReturn(this,(ReportsPage.__proto__||Object.getPrototypeOf(ReportsPage)).call(this));_this.initializeForm=_this.initializeForm.bind(_this);_this.getCurrentReportFormConfig=_this.getCurrentReportFormConfig.bind(_this);_this.getDefaultDateValues=_this.getDefaultDateValues.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(ReportsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getCatalogsAction();if(this.props.licensedFeatures&&this.props.licensedFeatures.np){this.props.getSitesAction();}this.initializeForm();}},{key:'getDefaultDateValues',value:function getDefaultDateValues(){var startingDate=new Date();startingDate.setMonth(startingDate.getMonth()-3);return{endingDate:new Date().toISOString().substr(0,10),startingDate:startingDate.toISOString().substr(0,10)};}},{key:'initializeForm',value:function initializeForm(){var reportFormConfig=this.getCurrentReportFormConfig();var organizerType=reportFormConfig&&reportFormConfig.organizerType;this.props.initialize(Object.assign({catalogName:organizerType&&organizerType===__WEBPACK_IMPORTED_MODULE_6_state_types_reportTypes__["a" /* REPORT_ORGANIZER_TYPE_CATALOGS */]&&ALL_CATALOGS,siteName:organizerType&&organizerType===__WEBPACK_IMPORTED_MODULE_6_state_types_reportTypes__["b" /* REPORT_ORGANIZER_TYPE_NP_SITES */]&&ALL_SITES},this.getDefaultDateValues()));}},{key:'getCurrentReportFormConfig',value:function getCurrentReportFormConfig(){var pathSegments=this.props.location.pathname.split('/');var reportName=pathSegments[pathSegments.length-1];var reportFormConfig=__WEBPACK_IMPORTED_MODULE_11_util_reportUtils__["b" /* reportFormConfigs */].find(function(rf){return rf.name===reportName;});return reportFormConfig;}},{key:'submit',value:function submit(values){var catalog=this.props.catalogs.find(function(c){return c.name===values.catalogName;});var site=values.site&&this.props.sites.find(function(s){return s.siteName===values.site;});var catalogId=catalog&&catalog.catalogId;var reportFormConfig=this.getCurrentReportFormConfig();var reportData={catalogName:values.catalogName,catalogId:catalogId,endingDate:values.endingDate,isDownload:values.isDownload,name:reportFormConfig&&reportFormConfig.name,siteId:site&&site.siteId,startingDate:values.startingDate,viewName:reportFormConfig&&reportFormConfig.viewName};if(values.isDownload){this.props.downloadReport(reportData);}else{// TODO: remove this else block, viewReport is no longer used
this.props.viewReport(reportData);}}},{key:'renderForm',value:function renderForm(reportConfig){var _this2=this;var _props=this.props,catalogs=_props.catalogs,formatMessage=_props.intl.formatMessage,handleSubmit=_props.handleSubmit,invalid=_props.invalid,sites=_props.sites;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-two-thirds page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],reportConfig.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{style:{width:'700px'},onSubmit:handleSubmit(this.submit),'data-test-name':'report-form'},reportConfig.organizerType===__WEBPACK_IMPORTED_MODULE_6_state_types_reportTypes__["a" /* REPORT_ORGANIZER_TYPE_CATALOGS */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].CATALOG)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'catalogName',name:'catalogName',style:{width:'400px'},type:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:ALL_CATALOGS,value:ALL_CATALOGS},formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].ALL_CATALOGS)),catalogs.map(function(catalog){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:catalog.name,value:catalog.name},catalog.name);})))),reportConfig.organizerType===__WEBPACK_IMPORTED_MODULE_6_state_types_reportTypes__["b" /* REPORT_ORGANIZER_TYPE_NP_SITES */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].SITE)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'select',component:'select',id:'site',name:'site',style:{width:'400px'},type:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:ALL_SITES,value:ALL_SITES},formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].ALL_SITES)),sites.map(function(site){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:site.siteId},site.siteName);})))),reportConfig.hasDateRange&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].FROM)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'date',component:'input',id:'startingDate',name:'startingDate',style:{fontSize:'15px',marginTop:'4px'},type:'date'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].TO)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{className:'date',component:'input',id:'endingDate',name:'endingDate',style:{fontSize:'15px',marginTop:'4px'},type:'date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_view_Forms_LabeledField__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button','data-test-name':'download-report',disabled:invalid,type:'button',onClick:handleSubmit(function(values){return _this2.submit(Object.assign({},values,{isDownload:true}));})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].DOWNLOAD_REPORT)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'}),reportConfig.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],reportConfig.description))));}},{key:'render',value:function render(){var _this3=this;var formatMessage=this.props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'reports-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents columns is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},formatMessage(__WEBPACK_IMPORTED_MODULE_10_util_localizedStrings__["a" /* default */].NAV_REPORTING)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page bordered-page-column is-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-hoverable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_11_util_reportUtils__["b" /* reportFormConfigs */].map(function(reportConfig){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:reportConfig.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'no-padding','data-test-name':'report-select-'+reportConfig.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{className:'list-item nav-item-list',activeClassName:'nav-item-list-selected',to:'/reports/'+reportConfig.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],reportConfig.label))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{exact:true,from:'/reports',to:'reports/'+__WEBPACK_IMPORTED_MODULE_11_util_reportUtils__["b" /* reportFormConfigs */][0].name}),__WEBPACK_IMPORTED_MODULE_11_util_reportUtils__["b" /* reportFormConfigs */].map(function(reportConfig){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{key:reportConfig.name,path:'/reports/'+reportConfig.name,render:function render(props){return _this3.renderForm(reportConfig);}});}))));}}]);return ReportsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(values){var errors={};if(values.startingDate&&values.endingDate&&values.startingDate>values.endingDate){errors.startingDate='Invalid';errors.endingDate='Invalid';}return errors;}var reportForm=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({form:'ReportForm',validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(ReportsPage));var reportsPageWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{catalogs:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["n" /* getCatalogs */])(state),licensedFeatures:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_2" /* getLicensedFeatures */])(state),sites:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_28" /* getSites */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_util_safeDispatch__["a" /* bindActionCreatorsForm */])({downloadReport:__WEBPACK_IMPORTED_MODULE_9_state_commands_reportCommands__["a" /* downloadReport */],getCatalogsAction:__WEBPACK_IMPORTED_MODULE_7_state_commands_catalogCommands__["n" /* getCatalogs */],getSitesAction:__WEBPACK_IMPORTED_MODULE_8_state_commands_netPublishCommands__["c" /* getSites */],// TODO: remove viewReport from bindActionCreatorsForm
viewReport:__WEBPACK_IMPORTED_MODULE_9_state_commands_reportCommands__["b" /* viewReport */]});})(reportForm);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(reportsPageWrapper));

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REPORT_ORGANIZER_TYPE_CATALOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPORT_ORGANIZER_TYPE_NP_SITES; });
/* unused harmony export REPORT_ORGANIZER_TYPE_NONE */
var REPORT_ORGANIZER_TYPE_CATALOGS='CATALOGS';var REPORT_ORGANIZER_TYPE_NP_SITES='NP_SITES';var REPORT_ORGANIZER_TYPE_NONE='NONE';// data used to create the various report forms
// data used to run a report

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_NP_SITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_NP_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_NP_SITE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_NP_SITES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_NP_SITES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_NP_SITES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_NP_SERVER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_NP_SERVER_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_NP_SERVER_STATUS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_NP_SITE_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_NP_SITE_ENABLED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_NP_SITE_ENABLED_FAIL; });
var GET_NP_SITES='admin/np/GET_NP_SITES';var GET_NP_SITES_SUCCESS='admin/np/GET_NP_SITES_SUCCESS';var GET_NP_SITES_FAIL='admin/np/GET_NP_SITES_FAIL';var GET_NP_SERVER_STATUS='admin/np/GET_NP_SERVER_STATUS';var GET_NP_SERVER_STATUS_SUCCESS='admin/np/GET_NP_SERVER_STATUS_SUCCESS';var GET_NP_SERVER_STATUS_FAIL='admin/np/GET_NP_SERVER_STATUS_FAIL';var DELETE_NP_SITE='admin/np/DELETE_NP_SITE';var DELETE_NP_SITE_SUCCESS='admin/np/DELETE_NP_SITE_SUCCESS';var DELETE_NP_SITE_FAIL='admin/np/DELETE_NP_SITE_FAIL';var SET_NP_SITE_ENABLED='admin/np/SET_NP_SITE_ENABLED';var SET_NP_SITE_ENABLED_SUCCESS='admin/np/SET_NP_SITE_ENABLED_SUCCESS';var SET_NP_SITE_ENABLED_FAIL='admin/np/SET_NP_SITE_ENABLED_FAIL';

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = downloadReport;
/* harmony export (immutable) */ __webpack_exports__["b"] = viewReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_reportUtils__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_serverUtils__ = __webpack_require__(37);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getURLFragmentForReportName(reportName){if(reportName==='keyword-statistics'){return'&fieldName=Keywords&maxRows=0';}return'';}function getUrl(base,reportData,getState){var session=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["L" /* getIdentitySession */])(getState());if(!session){__WEBPACK_IMPORTED_MODULE_1_portfolio_shared_util_logging__["a" /* default */].error("Can't run report, no identity session");return;}var locale=Object(__WEBPACK_IMPORTED_MODULE_4_util_reportUtils__["a" /* localeToReportLocale */])(Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_4" /* getLocale */])(getState()));var ports=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_13" /* getPorts */])(getState());var serverAddress=Object(__WEBPACK_IMPORTED_MODULE_5_util_serverUtils__["c" /* getAdminAddress */])(ports);var dateFragment=reportData.startingDate&&reportData.endingDate?'&startingDate='+reportData.startingDate+'&endingDate='+reportData.endingDate:'';var catalogIdFragment=reportData.catalogId?'&catalog_id='+reportData.catalogId:'';var catalogNameFragment=reportData.catalogName?'&catalogName='+reportData.catalogName:'';var siteIdFragment=reportData.siteId?'&site_id='+reportData.siteId:'';var reportSpecificFragment=getURLFragmentForReportName(reportData.name);var includeHeader=(!!reportData.isDownload).toString();return serverAddress+base+('&session='+session)+('&locale='+locale)+('&includeHeader='+includeHeader)+reportSpecificFragment+catalogNameFragment+catalogIdFragment+siteIdFragment+dateFragment;}function downloadReport(reportData){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var base,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:base=__WEBPACK_IMPORTED_MODULE_3_util_constants__["f" /* API */]+'/report/'+reportData.name+'?';url=getUrl(base,reportData,getState);window.location=url;case 3:case'end':return _context.stop();}}},_callee,this);}));function downloadReport(_x,_x2){return _ref.apply(this,arguments);}return downloadReport;}();}function viewReport(reportData){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var ports,port,base,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:ports=Object(__WEBPACK_IMPORTED_MODULE_2_state_selectors__["_13" /* getPorts */])(getState());port=Object(__WEBPACK_IMPORTED_MODULE_5_util_serverUtils__["e" /* getMainServerPort */])(ports);base='/reporting/rdPage.aspx?'+('rdReport='+reportData.viewName)+('&port='+port);url=getUrl(base,reportData,getState);window.open(url,'_blank');case 5:case'end':return _context2.stop();}}},_callee2,this);}));function viewReport(_x3,_x4){return _ref2.apply(this,arguments);}return viewReport;}();}

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_netPublishCommands__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_view_Forms_StaticTextField__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NetPublishPage=function(_Component){_inherits(NetPublishPage,_Component);function NetPublishPage(){_classCallCheck(this,NetPublishPage);var _this=_possibleConstructorReturn(this,(NetPublishPage.__proto__||Object.getPrototypeOf(NetPublishPage)).call(this));_this.handleDeleteSite=_this.handleDeleteSite.bind(_this);_this.handleSetEnabled=_this.handleSetEnabled.bind(_this);_this.renderNoSites=_this.renderNoSites.bind(_this);return _this;}_createClass(NetPublishPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getSitesAction();this.props.getNPServerStatusAction();}},{key:'handleSetEnabled',value:function handleSetEnabled(siteId,enabled){this.props.setNPSiteEnabledAction(siteId,enabled);}},{key:'handleDeleteSite',value:function handleDeleteSite(siteId){this.props.deleteNPSiteAction(siteId);}},{key:'renderNoSites',value:function renderNoSites(){var formatMessage=this.props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NP_SITES)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents full-page-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-two-thirds'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NO_SITES_EXIST_1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NO_SITES_EXIST_2))));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,intl=_props.intl,formatMessage=_props.intl.formatMessage,sites=_props.sites,serverStatus=_props.serverStatus;if(sites.length===0){return this.renderNoSites();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents columns is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NP_SITES)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page bordered-page-column is-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-hoverable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,sites.map(function(site){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:site.siteId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{className:'list-item nav-item-list','data-test-name':'np-nav-item-'+site.siteId,activeClassName:'nav-item-list-selected',to:'/netPublish/'+site.siteId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,site.siteName))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-two-thirds page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,sites.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{exact:true,from:'/netPublish',to:'/netPublish/'+sites[0].siteId}),sites.map(function(site){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{key:site.siteId,path:'/netPublish/'+site.siteId,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SiteDetails,{deleteNPSite:_this2.handleDeleteSite,intl:intl,site:site,serverStatus:serverStatus,setNPSiteEnabled:_this2.handleSetEnabled});}});}))))));}}]);return NetPublishPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SiteDetails=function(_Component2){_inherits(SiteDetails,_Component2);function SiteDetails(){_classCallCheck(this,SiteDetails);var _this3=_possibleConstructorReturn(this,(SiteDetails.__proto__||Object.getPrototypeOf(SiteDetails)).call(this));_this3.handleDeleteSite=_this3.handleDeleteSite.bind(_this3);_this3.handleSetEnabled=_this3.handleSetEnabled.bind(_this3);return _this3;}_createClass(SiteDetails,[{key:'handleSetEnabled',value:function handleSetEnabled(){var _props2=this.props,setNPSiteEnabled=_props2.setNPSiteEnabled,site=_props2.site;setNPSiteEnabled(site.siteId,!site.enabled);}},{key:'handleDeleteSite',value:function handleDeleteSite(){var _props3=this.props,deleteNPSite=_props3.deleteNPSite,site=_props3.site;deleteNPSite(site.siteId);}},{key:'render',value:function render(){var _props4=this.props,_props4$intl=_props4.intl,formatDate=_props4$intl.formatDate,formatMessage=_props4$intl.formatMessage,formatTime=_props4$intl.formatTime,site=_props4.site,serverStatus=_props4.serverStatus;var host='http://'+window.location.hostname+':'+serverStatus.port;var location=serverStatus.siteBasePath?site.urlName:serverStatus.siteBasePath+'/'+site.urlName;var siteUrl=host+location;var source=!site.galleryName?site.catalogName:site.catalogName+' > '+site.galleryName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'np-site-name',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NAME),labelClassName:'is-medium',value:site.siteName,valueClassName:'is-medium'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].FIELD_TYPE_URL)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'6px',wordBreak:'break-all'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-test-name':'np-site-url',href:siteUrl,target:'_blank'},siteUrl))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'np-site-source',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NP_SOURCE),value:source}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_StaticTextField__["a" /* default */],{dataTestName:'np-site-created',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CREATED_ON_DATE),value:formatDate(site.creationDate)+' '+formatTime(site.creationDate)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:site.enabled,className:'is-checkradio','data-test-name':'np-site-enabled-checkbox',id:'enabled',onChange:this.handleSetEnabled,type:'checkbox',name:'enabled'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'enabled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NP_SITE_ENABLED_LABEL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_view_Forms_LabeledField__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined','data-test-name':'np-site-delete-button',onClick:this.handleDeleteSite},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-minus-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NP_SITE_DELETE_LABEL))));}}]);return SiteDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var npPageWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{sites:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_28" /* getSites */])(state),serverStatus:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_11" /* getNPServerStatus */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteNPSiteAction:__WEBPACK_IMPORTED_MODULE_4_state_commands_netPublishCommands__["a" /* deleteNPSite */],getNPServerStatusAction:__WEBPACK_IMPORTED_MODULE_4_state_commands_netPublishCommands__["b" /* getNPServerStatus */],getSitesAction:__WEBPACK_IMPORTED_MODULE_4_state_commands_netPublishCommands__["c" /* getSites */],setNPSiteEnabledAction:__WEBPACK_IMPORTED_MODULE_4_state_commands_netPublishCommands__["d" /* setNPSiteEnabled */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(NetPublishPage));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(npPageWrapper));

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_BrowseServerFoldersDialog__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_serverUtils__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobilePage=function(_Component){_inherits(MobilePage,_Component);function MobilePage(){_classCallCheck(this,MobilePage);var _this=_possibleConstructorReturn(this,(MobilePage.__proto__||Object.getPrototypeOf(MobilePage)).call(this));_this.handleToggleCheckbox=_this.handleToggleCheckbox.bind(_this);_this.handleBrowseForDirectory=_this.handleBrowseForDirectory.bind(_this);_this.handlePathSelected=_this.handlePathSelected.bind(_this);return _this;}_createClass(MobilePage,[{key:'handleToggleCheckbox',value:function handleToggleCheckbox(event){var _settings;var _props=this.props,setMobileUploadSettings=_props.setMobileUploadSettings,currentLocale=_props.currentLocale,intl=_props.intl;var settings=(_settings={},_defineProperty(_settings,event.target.id,event.target.checked),_defineProperty(_settings,'locale',currentLocale),_defineProperty(_settings,'catalogName',intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].MOBILE_CATALOG_NAME)),_settings);setMobileUploadSettings(settings);}},{key:'handleBrowseForDirectory',value:function handleBrowseForDirectory(event){var key=event.target.id;this.setState({activeBrowsingFolder:key});this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]);}},{key:'handlePathSelected',value:function handlePathSelected(path){var _settings2;var _props2=this.props,globalSettings=_props2.globalSettings,setMobileUploadSettings=_props2.setMobileUploadSettings;var settings=(_settings2={},_defineProperty(_settings2,__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_FOLDER,path),_defineProperty(_settings2,__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_CATALOG,!!globalSettings[__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_CATALOG]),_settings2);setMobileUploadSettings(settings);this.setState({activeBrowsingFolder:undefined});}},{key:'render',value:function render(){var _props3=this.props,globalSettings=_props3.globalSettings,formatMessage=_props3.intl.formatMessage,activePanelId=_props3.activePanelId,serverStatus=_props3.serverStatus;var isMobileEnabled=globalSettings[__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_ENABLED]==='true';var hasUploadCatalog=globalSettings[__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_CATALOG]!=='';var isStopped=serverStatus.runState===__WEBPACK_IMPORTED_MODULE_9_util_constants__["Z" /* SERVER_STATE_STOPPED */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents columns is-gapless','data-test-name':'mobile-uploads-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].MOBILE_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section page-contents-textured portfolio-form-container mobile-uploads'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-flex',style:{justifyContent:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:isMobileEnabled,'data-test-name':'mobile-enabled',disabled:isStopped,className:'is-checkradio is-medium',id:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_ENABLED,onChange:this.handleToggleCheckbox,name:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_ENABLED,type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium',htmlFor:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_ENABLED},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].MOBILE_ENABLED))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'16px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:'10px',paddingLeft:'2.5rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-flex',style:{justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium'},formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].MOBILE_FOLDER_VERBIAGE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button',disabled:!isMobileEnabled||isStopped,onClick:this.handleBrowseForDirectory,id:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_FOLDER,'data-test-name':__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_FOLDER},formatMessage(__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].CHANGE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-indented-large has-text-black'},globalSettings[__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_FOLDER]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'32px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-flex',style:{justifyContent:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'is-checkradio is-medium','data-test-name':'mobile-create-upload-catalog',id:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_CATALOG,name:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_CATALOG,type:'checkbox',disabled:!isMobileEnabled||hasUploadCatalog||isStopped,onChange:this.handleToggleCheckbox,checked:hasUploadCatalog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium',htmlFor:__WEBPACK_IMPORTED_MODULE_10_util_serverUtils__["a" /* GLOBAL_SETTING */].MOBILE_UPLOADS_CATALOG},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4_util_localizedStrings__["a" /* default */].MOBILE_CREATE_CATALOG_VERBIAGE)))),activePanelId===__WEBPACK_IMPORTED_MODULE_9_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_BrowseServerFoldersDialog__["a" /* default */],{onPathSelected:this.handlePathSelected,showFiles:false})))));}}]);return MobilePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{globalSettings:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["I" /* getGlobalSettings */])(state),activePanelId:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["c" /* getActivePanelId */])(state),serverStatus:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_27" /* getServerStatus */])(state),currentLocale:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["_4" /* getLocale */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getActivePanelId:__WEBPACK_IMPORTED_MODULE_7_state_selectors__["c" /* getActivePanelId */],getGlobalSettings:__WEBPACK_IMPORTED_MODULE_7_state_selectors__["I" /* getGlobalSettings */],setMobileUploadSettings:__WEBPACK_IMPORTED_MODULE_8_state_commands_adminPropertiesCommands__["n" /* setMobileUploadSettings */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_6_state_commands_dialogPanelCommands__["b" /* showDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(MobilePage)));

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_BrowseServerFoldersDialog__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServerLocationRow__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_serverUtils__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showModalPrompt=__WEBPACK_IMPORTED_MODULE_11_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var ServerLocationsPage=function(_Component){_inherits(ServerLocationsPage,_Component);function ServerLocationsPage(){_classCallCheck(this,ServerLocationsPage);var _this=_possibleConstructorReturn(this,(ServerLocationsPage.__proto__||Object.getPrototypeOf(ServerLocationsPage)).call(this));_this.handleBrowseForDirectory=_this.handleBrowseForDirectory.bind(_this);_this.handlePathSelected=_this.handlePathSelected.bind(_this);_this.handleToggleCheckbox=_this.handleToggleCheckbox.bind(_this);_this.updateGlobalSetting=_this.updateGlobalSetting.bind(_this);return _this;}_createClass(ServerLocationsPage,[{key:'handleBrowseForDirectory',value:function handleBrowseForDirectory(event,folder){this.setState({activeBrowsingFolder:folder});this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_12_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]);}},{key:'handlePathSelected',value:function handlePathSelected(path){this.updateGlobalSetting(this.state.activeBrowsingFolder,path);this.setState({activeBrowsingFolder:undefined});}},{key:'handleToggleCheckbox',value:function handleToggleCheckbox(event,key){var newValue=this.props.globalSettings[key]==='false';this.updateGlobalSetting(key,newValue);}},{key:'updateGlobalSetting',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(name,value){var _props,setGlobalSettings,setLoggingConfig,showModalPrompt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,setGlobalSettings=_props.setGlobalSettings,setLoggingConfig=_props.setLoggingConfig,showModalPrompt=_props.showModalPrompt;if(!(name===__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_LOGS)){_context.next=5;break;}setLoggingConfig(Object.assign({},this.props.loggingConfig,{logDirectory:value}));_context.next=8;break;case 5:_context.next=7;return setGlobalSettings(_defineProperty({},name,value));case 7:if(name===__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_WORK){showModalPrompt({message:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG});}case 8:case'end':return _context.stop();}}},_callee,this);}));function updateGlobalSetting(_x,_x2){return _ref.apply(this,arguments);}return updateGlobalSetting;}()},{key:'render',value:function render(){var _props2=this.props,activePanelId=_props2.activePanelId,globalSettings=_props2.globalSettings,loggingConfig=_props2.loggingConfig,serverStatus=_props2.serverStatus;var isStopped=serverStatus.runState===__WEBPACK_IMPORTED_MODULE_12_util_constants__["Z" /* SERVER_STATE_STOPPED */];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page page-contents','data-test-name':'data-locations-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ServerLocationRow__["a" /* default */],{checkboxChecked:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].CREATE_AUTOSYNC_FOLDER]==='true',checkboxKey:__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].CREATE_AUTOSYNC_FOLDER,disabled:isStopped,folderKey:__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_AUTOSYNC,handleChangeLocation:this.handleBrowseForDirectory,handleToggleCheckbox:this.handleToggleCheckbox,label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL,path:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_AUTOSYNC],showCheckbox:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ServerLocationRow__["a" /* default */],{defaultPath:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_PREVIEWS_DEFAULT],disabled:isStopped,folderKey:__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_PREVIEWS,handleChangeLocation:this.handleBrowseForDirectory,label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_PREVIEW_PATH_LABEL,path:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_PREVIEWS]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ServerLocationRow__["a" /* default */],{defaultPath:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_WORK_DEFAULT],folderKey:__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_WORK,handleChangeLocation:this.handleBrowseForDirectory,label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL,path:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_WORK]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ServerLocationRow__["a" /* default */],{defaultPath:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_VAULT_DEFAULT],disabled:!isStopped,folderKey:__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_VAULT,handleChangeLocation:this.handleBrowseForDirectory,label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL,path:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_VAULT]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ServerLocationRow__["a" /* default */],{defaultPath:globalSettings[__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_LOGS_DEFAULT],disabled:!isStopped,folderKey:__WEBPACK_IMPORTED_MODULE_13_util_serverUtils__["a" /* GLOBAL_SETTING */].FOLDER_LOGS,handleChangeLocation:this.handleBrowseForDirectory,label:__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].LOGGING_LOG_DIR,path:loggingConfig.logDirectory}))),activePanelId===__WEBPACK_IMPORTED_MODULE_12_util_constants__["k" /* BROWSE_SERVER_FOLDERS_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_view_App_DialogPanels_BrowseServerFoldersDialog__["a" /* default */],{onPathSelected:this.handlePathSelected,showFiles:false}));}}]);return ServerLocationsPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */])(state),globalSettings:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["I" /* getGlobalSettings */])(state),loggingConfig:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["_5" /* getLoggingConfig */])(state),serverStatus:Object(__WEBPACK_IMPORTED_MODULE_8_state_selectors__["_27" /* getServerStatus */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getActivePanelId:__WEBPACK_IMPORTED_MODULE_8_state_selectors__["c" /* getActivePanelId */],setGlobalSettings:__WEBPACK_IMPORTED_MODULE_10_state_commands_adminPropertiesCommands__["l" /* setGlobalSettings */],setLoggingConfig:__WEBPACK_IMPORTED_MODULE_10_state_commands_adminPropertiesCommands__["m" /* setLoggingConfig */],showDialogPanel:__WEBPACK_IMPORTED_MODULE_9_state_commands_dialogPanelCommands__["b" /* showDialogPanel */],showModalPrompt:showModalPrompt});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(ServerLocationsPage)));

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServerLocationRow=function(_Component){_inherits(ServerLocationRow,_Component);function ServerLocationRow(){_classCallCheck(this,ServerLocationRow);var _this=_possibleConstructorReturn(this,(ServerLocationRow.__proto__||Object.getPrototypeOf(ServerLocationRow)).call(this));_this.handleClickBrowse=function(event){_this.props.handleChangeLocation(event,_this.props.folderKey);};_this.handleClickCheckbox=function(event){if(_this.props.handleToggleCheckbox){_this.props.handleToggleCheckbox(event,_this.props.checkboxKey);}};_this.handleClickBrowse=_this.handleClickBrowse.bind(_this);_this.handleClickCheckbox=_this.handleClickCheckbox.bind(_this);return _this;}_createClass(ServerLocationRow,[{key:'render',value:function render(){var _props=this.props,checkboxChecked=_props.checkboxChecked,checkboxKey=_props.checkboxKey,defaultPath=_props.defaultPath,_props$disabled=_props.disabled,disabled=_props$disabled===undefined?false:_props$disabled,folderKey=_props.folderKey,formatMessage=_props.intl.formatMessage,label=_props.label,path=_props.path,_props$showCheckbox=_props.showCheckbox,showCheckbox=_props$showCheckbox===undefined?false:_props$showCheckbox;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field',style:{display:'flex',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,showCheckbox&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:checkboxChecked,className:'is-checkradio is-medium',id:checkboxKey,onChange:this.handleClickCheckbox,name:checkboxKey,type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium',htmlFor:checkboxKey},formatMessage(label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button',disabled:disabled,onClick:this.handleClickBrowse,'data-test-name':folderKey},formatMessage(__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].CHANGE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-indented-large has-text-black'},path))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'help is-indented-large'},disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE),defaultPath&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].SERVER_DATA_DEFAULT_VAULT_LOCATION_IS),'\xA0 ',defaultPath)));}}]);return ServerLocationRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(ServerLocationRow));

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_types__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_state_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_serverUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_commands_ssoCommands__ = __webpack_require__(1004);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SingleSignOnCredsPage=function(_Component){_inherits(SingleSignOnCredsPage,_Component);function SingleSignOnCredsPage(){_classCallCheck(this,SingleSignOnCredsPage);var _this=_possibleConstructorReturn(this,(SingleSignOnCredsPage.__proto__||Object.getPrototypeOf(SingleSignOnCredsPage)).call(this));_this.submit=_this.submit.bind(_this);return _this;}_createClass(SingleSignOnCredsPage,[{key:'submit',value:function submit(values){var setSingleSignOnCredentials=this.props.setSingleSignOnCredentials;var username=values.username,password=values.password;setSingleSignOnCredentials(username,password);}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,formatMessage=_props.intl.formatMessage,invalid=_props.invalid,pristine=_props.pristine,reset=_props.reset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents','data-test-name':'sso-credentials-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_SSO_CREDENTIALS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit(this.submit),style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_LabeledField__["a" /* default */],{labelClassName:'is-medium',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].USER_ACCOUNT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{autoComplete:'new-password',className:'input is-medium',component:'input',id:'username',name:'username',type:'string','data-test-name':'sso-credential'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_view_Forms_LabeledField__["a" /* default */],{labelClassName:'is-medium',label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].PASSWORD)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{autoComplete:'new-password',className:'input is-medium',component:'input',id:'password',name:'password',type:'password','data-test-name':'sso-password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:pristine,onClick:reset,type:'button','data-test-name':'sso-revert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary',type:'submit',disabled:pristine||invalid,'data-test-name':'sso-apply'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].APPLY)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'})))));}}]);return SingleSignOnCredsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};if(!data.username){errors.username='Required';}if(!data.password){errors.password='Required';}return errors;}var ssoCredentialsForm=Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["k" /* reduxForm */])({form:'Single Sign On Credentials Form',validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(SingleSignOnCredsPage));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{globalSettings:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["I" /* getGlobalSettings */])(state),initialValues:{username:Object(__WEBPACK_IMPORTED_MODULE_7_state_selectors__["I" /* getGlobalSettings */])(state)[__WEBPACK_IMPORTED_MODULE_9_util_serverUtils__["a" /* GLOBAL_SETTING */].SSO_PRINCIPAL]}};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getGlobalSettings:__WEBPACK_IMPORTED_MODULE_7_state_selectors__["I" /* getGlobalSettings */],setSingleSignOnCredentials:__WEBPACK_IMPORTED_MODULE_10_state_commands_ssoCommands__["a" /* setSingleSignOnCredentials */]});})(ssoCredentialsForm));

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setSingleSignOnCredentials;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_serverUtils__ = __webpack_require__(37);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var setSingleSignOnCredentialsAction=__WEBPACK_IMPORTED_MODULE_1_state_reducers_serverReducer__["a" /* actions */].setSingleSignOnCredentials;var showModalPrompt=__WEBPACK_IMPORTED_MODULE_6_portfolio_shared_state_reducers_modalPromptReducer__["a" /* actions */].showModalPrompt;var getPublicKeyInfo=__WEBPACK_IMPORTED_MODULE_2_state_reducers_authReducer__["a" /* actions */].getPublicKeyInfo;function setSingleSignOnCredentials(username,unencryptedPassword){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var identitySession,publicKeyInfoResult,encryptedPassword,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:identitySession=Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["L" /* getIdentitySession */])(getState());_context.next=3;return dispatch(getPublicKeyInfo());case 3:publicKeyInfoResult=_context.sent;encryptedPassword=void 0;encryptedPassword=Object(__WEBPACK_IMPORTED_MODULE_7_util_serverUtils__["b" /* encrypt */])(unencryptedPassword,publicKeyInfoResult.payload);if(!identitySession){_context.next=11;break;}error=void 0;_context.next=10;return dispatch(setSingleSignOnCredentialsAction(identitySession,username,encryptedPassword)).catch(function(e){error=e;});case 10:if(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["c" /* addNotification */])(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].NOTIFICATION_FAILURE_UPDATE,__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_state_commands_globalNotificationsCommands__["a" /* ERROR_LEVEL */]));}else{dispatch(showModalPrompt({dataTestName:'sso-config-success',message:__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].SERVER_RESTART_REQUIRED}));}case 11:case'end':return _context.stop();}}},_callee,this);}));function setSingleSignOnCredentials(_x,_x2){return _ref.apply(this,arguments);}return setSingleSignOnCredentials;}();}

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_emailUtils__ = __webpack_require__(400);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmailNotificationsPage=function(_Component){_inherits(EmailNotificationsPage,_Component);function EmailNotificationsPage(){_classCallCheck(this,EmailNotificationsPage);var _this=_possibleConstructorReturn(this,(EmailNotificationsPage.__proto__||Object.getPrototypeOf(EmailNotificationsPage)).call(this));_this.submit=_this.submit.bind(_this);_this.validateConfig=_this.validateConfig.bind(_this);return _this;}_createClass(EmailNotificationsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getAdminProperties([__WEBPACK_IMPORTED_MODULE_6_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].emailServerConfiguration]);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.emailServerConfiguration!==nextProps.emailServerConfiguration&&nextProps.emailServerConfiguration.emailEnabled){this.initializeFields(nextProps.emailServerConfiguration);}}},{key:'initializeFields',value:function initializeFields(emailServerConfiguration){this.props.initialize(emailServerConfiguration);}},{key:'submit',value:function submit(values,dispatch,props){var setEmailServerConfig=this.props.setEmailServerConfig;var config=Object.assign({},values);setEmailServerConfig(config);}},{key:'validateConfig',value:function validateConfig(){var _props=this.props,validateEmailServerConfig=_props.validateEmailServerConfig,emailServerAddress=_props.emailServerAddress,emailServerPort=_props.emailServerPort,emailUseSSLTLS=_props.emailUseSSLTLS,emailUseSMTP=_props.emailUseSMTP,emailUsername=_props.emailUsername,emailPassword=_props.emailPassword;var config={emailServerAddress:emailServerAddress,emailServerPort:emailServerPort,emailUseSSLTLS:emailUseSSLTLS,emailUseSMTP:emailUseSMTP,emailUsername:emailUsername,emailPassword:emailPassword};validateEmailServerConfig(config);}},{key:'render',value:function render(){var _props2=this.props,emailServerAddress=_props2.emailServerAddress,emailUsername=_props2.emailUsername,emailPassword=_props2.emailPassword,emailUseSMTP=_props2.emailUseSMTP,handleSubmit=_props2.handleSubmit,formatMessage=_props2.intl.formatMessage,isValidationPending=_props2.isValidationPending,invalid=_props2.invalid,pristine=_props2.pristine,reset=_props2.reset;var validateEnabled=emailServerAddress&&(!emailUseSMTP||emailUsername&&emailPassword);var validateButtonClassName='button '+(isValidationPending?' is-loading':'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents','data-test-name':'email-config-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_EMAIL_CONFIGURATION)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit(this.submit),style:{width:'510px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'email-notifications-form-field-xsmall-width is-checkradio is-medium',component:__WEBPACK_IMPORTED_MODULE_9_view_Forms_BulmaCheckRadio__["a" /* default */],id:'emailEnabled',name:'emailEnabled',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium email-config-enabled-label','data-test-name':'email-config-enabled-checkbox',htmlFor:'emailEnabled'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_ENABLED))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_MESSAGE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_SERVER_ADDRESS))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input email-notifications-form-field-medium-width',component:'input','data-test-name':'email-config-server-address',id:'emailServerAddress',name:'emailServerAddress',type:'input'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_SERVER_PORT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input email-notifications-form-field-small-width',component:'input','data-test-name':'email-config-server-port',id:'emailServerPort',max:65535,min:0,name:'emailServerPort',type:'number'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width','data-test-name':'email-config-use-ssltls',htmlFor:'emailUseSSLTLS'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_USE_SSL_TLS))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'email-notifications-form-field-medium-width',component:__WEBPACK_IMPORTED_MODULE_9_view_Forms_BulmaCheckRadio__["a" /* default */],id:'emailUseSSLTLS',name:'emailUseSSLTLS',type:'checkbox'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width','data-test-name':'email-config-use-smpt',htmlFor:'emailUseSMTP'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_USE_SMTP_AUTH))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'email-notifications-form-field-medium-width',component:__WEBPACK_IMPORTED_MODULE_9_view_Forms_BulmaCheckRadio__["a" /* default */],id:'emailUseSMTP',name:'emailUseSMTP',type:'checkbox'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_AUTH_USERNAME))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input email-notifications-form-field-medium-width',component:'input','data-test-name':'email-config-username',id:'emailUsername',name:'emailUsername',type:'input'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_AUTH_PASSWORD))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{autoComplete:'new-password',className:'input email-notifications-form-field-medium-width',component:'input','data-test-name':'email-config-password',id:'emailPassword',name:'emailPassword',type:'password'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label email-notifications-form-label-width'},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:validateButtonClassName,'data-test-name':'email-config-validate-button',disabled:!validateEnabled,onClick:this.validateConfig,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_VALIDATE))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label email-notifications-form-label-width'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].EMAIL_CONFIG_FROM_ADDRESS))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input email-notifications-form-field-medium-width',component:'input','data-test-name':'email-config-from-address',id:'emailFromAddress',name:'emailFromAddress',type:'input'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined','data-test-name':'email-config-revert-button',disabled:pristine,onClick:reset,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary','data-test-name':'email-config-submit-button',type:'submit',disabled:pristine|invalid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].APPLY))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'}))));}}]);return EmailNotificationsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};if(!data.emailServerAddress){errors.emailServerAddress='Required';}if(!data.emailServerPort){errors.emailServerPort='Required';}if(!data.emailFromAddress){errors.emailFromAddress='Required';}if(!Object(__WEBPACK_IMPORTED_MODULE_11_util_emailUtils__["a" /* isEmailLegal */])(data.emailFromAddress)){errors.emailFromAddress='Invalid';}return errors;}var emailNotificationsForm=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({destroyOnUnmount:false,form:__WEBPACK_IMPORTED_MODULE_10_util_constants__["I" /* EMAIL_CONFIG_FORM */],validate:validate})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(EmailNotificationsPage));var selector=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_10_util_constants__["I" /* EMAIL_CONFIG_FORM */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{emailServerConfiguration:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["C" /* getEmailServerConfiguration */])(state),emailServerAddress:selector(state,'emailServerAddress'),emailServerPort:selector(state,'emailServerPort'),emailUseSSLTLS:selector(state,'emailUseSSLTLS'),emailUseSMTP:selector(state,'emailUseSMTP'),emailUsername:selector(state,'emailUsername'),emailPassword:selector(state,'emailPassword'),isValidationPending:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["S" /* getIsEmailServerConfigPendingValidation */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({formValueSelector:__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */],getAdminProperties:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["e" /* getAdminProperties */],setEmailServerConfig:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["k" /* setEmailServerConfig */],validateEmailServerConfig:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["s" /* validateEmailServerConfig */]});})(emailNotificationsForm));

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageHeader__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaEngineRow__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateMediaEngineDialog__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_dialogPanelReducer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_commands_mediaEngineCommands__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portfolio_shared_state_reducers_modalPromptReducer__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var showDialogPanel=__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_state_reducers_dialogPanelReducer__["a" /* actions */].showDialogPanel;var MediaEnginesPage=function(_Component){_inherits(MediaEnginesPage,_Component);function MediaEnginesPage(){_classCallCheck(this,MediaEnginesPage);var _this=_possibleConstructorReturn(this,(MediaEnginesPage.__proto__||Object.getPrototypeOf(MediaEnginesPage)).call(this));_this.state={selectedMediaEngine:undefined};_this.handleClickActive=_this.handleClickActive.bind(_this);_this.handleClickAdd=_this.handleClickAdd.bind(_this);_this.handleClickDelete=_this.handleClickDelete.bind(_this);_this.handleSelectRow=_this.handleSelectRow.bind(_this);_this.handleTest=_this.handleTest.bind(_this);return _this;}_createClass(MediaEnginesPage,[{key:'handleSelectRow',value:function handleSelectRow(e,index){this.setState({selectedMediaEngine:this.props.mediaEngines[index]});}},{key:'handleClickActive',value:function handleClickActive(me){var _props=this.props,mediaEngines=_props.mediaEngines,mediaEngineTotalSeatCount=_props.mediaEngineTotalSeatCount;var enabledMEs=mediaEngines.filter(function(me){return me.enabled;});if(!me.enabled){// disallow enabling more than the seat count
if(enabledMEs.length>=mediaEngineTotalSeatCount){return;}}else{// show an alert if user has disabled all MEs
if(enabledMEs.length===1){this.props.showSingleButtonAlert(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE);}}var errorMsg=this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINE_NOT_OPERATIONAL);this.props.updateMediaEngine(Object.assign({},me,{enabled:!me.enabled}),errorMsg);}},{key:'handleClickAdd',value:function handleClickAdd(){this.props.showDialogPanel(__WEBPACK_IMPORTED_MODULE_9_util_constants__["x" /* CREATE_MEDIA_ENGINE_PANEL_ID */]);}},{key:'handleClickDelete',value:function handleClickDelete(){var me=this.state.selectedMediaEngine;if(me){this.props.deleteMediaEngine(me.id);}}},{key:'handleTest',value:function handleTest(me){this.props.testMediaEngine(me,this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINE_OPERATIONAL),this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINE_NOT_OPERATIONAL));}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,activePanelId=_props2.activePanelId,enabledMediaEnginesCount=_props2.enabledMediaEnginesCount,intl=_props2.intl,isMediaEngineTestPending=_props2.isMediaEngineTestPending,mediaEngines=_props2.mediaEngines,mediaEngineTotalSeatCount=_props2.mediaEngineTotalSeatCount;var selectedMediaEngine=this.state.selectedMediaEngine;var deleteDisabled=!this.state.selectedMediaEngine||this.state.selectedMediaEngine.type===__WEBPACK_IMPORTED_MODULE_9_util_constants__["Q" /* MEDIA_ENGINE_TYPE_BUILT_IN */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page','data-test-name':'media-engines-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PageHeader__["a" /* default */],{deleteDisabled:deleteDisabled,onClickAdd:this.handleClickAdd,onClickDelete:this.handleClickDelete,title:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].NAV_MEDIA_ENGINES)+' ('+enabledMediaEnginesCount+'/'+mediaEngineTotalSeatCount+')'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-hoverable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_ACTIVE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_ADDRESS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_TEST))),mediaEngines.map(function(me,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MediaEngineRow__["a" /* default */],{key:me.id,index:index,intl:intl,isMediaEngineTestPending:isMediaEngineTestPending,isSelected:!!(selectedMediaEngine&&selectedMediaEngine.id===me.id),mediaEngine:me,onClickRow:_this2.handleSelectRow,onClickActive:_this2.handleClickActive,onClickTest:_this2.handleTest});})))),activePanelId===__WEBPACK_IMPORTED_MODULE_9_util_constants__["x" /* CREATE_MEDIA_ENGINE_PANEL_ID */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CreateMediaEngineDialog__["a" /* default */],{allActivationsUsed:enabledMediaEnginesCount>=mediaEngineTotalSeatCount}));}}]);return MediaEnginesPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["c" /* getActivePanelId */])(state),enabledMediaEnginesCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["D" /* getEnabledMediaEnginesCount */])(state),isMediaEngineTestPending:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["V" /* getIsMediaEngineTestPending */])(state),mediaEngines:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_8" /* getMediaEngines */])(state),mediaEngineTotalSeatCount:Object(__WEBPACK_IMPORTED_MODULE_3_state_selectors__["_7" /* getMediaEngineTotalSeatCount */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({deleteMediaEngine:__WEBPACK_IMPORTED_MODULE_11_state_commands_mediaEngineCommands__["b" /* deleteMediaEngine */],showDialogPanel:showDialogPanel,showSingleButtonAlert:__WEBPACK_IMPORTED_MODULE_12_portfolio_shared_state_reducers_modalPromptReducer__["d" /* showSingleButtonAlert */],testMediaEngine:__WEBPACK_IMPORTED_MODULE_11_state_commands_mediaEngineCommands__["c" /* testMediaEngine */],updateMediaEngine:__WEBPACK_IMPORTED_MODULE_11_state_commands_mediaEngineCommands__["d" /* updateMediaEngine */]});})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(MediaEnginesPage)));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MediaEngineRow=function(_Component){_inherits(MediaEngineRow,_Component);function MediaEngineRow(){_classCallCheck(this,MediaEngineRow);var _this=_possibleConstructorReturn(this,(MediaEngineRow.__proto__||Object.getPrototypeOf(MediaEngineRow)).call(this));_this.handleClickActive=_this.handleClickActive.bind(_this);_this.handleClickRow=_this.handleClickRow.bind(_this);_this.handleClickTest=_this.handleClickTest.bind(_this);return _this;}_createClass(MediaEngineRow,[{key:'handleClickRow',value:function handleClickRow(e){this.props.onClickRow(e,this.props.index);}},{key:'handleClickActive',value:function handleClickActive(){this.props.onClickActive(this.props.mediaEngine);}},{key:'handleClickTest',value:function handleClickTest(){this.props.onClickTest(this.props.mediaEngine);}},{key:'render',value:function render(){var _props=this.props,isMediaEngineTestPending=_props.isMediaEngineTestPending,isSelected=_props.isSelected,mediaEngine=_props.mediaEngine;var rowClassName='has-pointer '+(isSelected?'is-selected':'');var radioClassName='is-checkradio is-medium '+(isSelected?' has-background-color is-white':'');var testClassName='button is-small '+(isMediaEngineTestPending&&isSelected?'is-loading':'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:rowClassName,onClick:this.handleClickRow,style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:radioClassName,'data-test-name':'me-active-checkbox-'+mediaEngine.id,id:'active-'+mediaEngine.id,type:'checkbox',checked:mediaEngine.enabled,onChange:this.handleClickActive}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'active-'+mediaEngine.id})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'},'data-test-name':'me-address-'+mediaEngine.id},mediaEngine.address,':',mediaEngine.port),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:testClassName,'data-test-name':'me-test-'+mediaEngine.id,disabled:isMediaEngineTestPending,onClick:this.handleClickTest},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_TEST))));}}]);return MediaEngineRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MediaEngineRow);

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_commands_mediaEngineCommands__ = __webpack_require__(404);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateMediaEngineDialog=function(_Component){_inherits(CreateMediaEngineDialog,_Component);function CreateMediaEngineDialog(){_classCallCheck(this,CreateMediaEngineDialog);var _this=_possibleConstructorReturn(this,(CreateMediaEngineDialog.__proto__||Object.getPrototypeOf(CreateMediaEngineDialog)).call(this));_this.isOkEnabled=_this.isOkEnabled.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(CreateMediaEngineDialog,[{key:'isOkEnabled',value:function isOkEnabled(){return this.props.valid;}},{key:'submit',value:function submit(data,props){var me={enabled:data.isActive,address:data.address,port:data.port,type:''};this.props.createMediaEngine(me);}},{key:'render',value:function render(){var _props=this.props,activePanelId=_props.activePanelId,allActivationsUsed=_props.allActivationsUsed,handleSubmit=_props.handleSubmit,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_view_App_DialogPanels_DialogPanel__["a" /* default */],{activePanelId:activePanelId,contentStyle:{width:'600px',height:null},customButtonText:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].ADD),dialogFocusId:'address',hideDialogPanel:this.props.hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:handleSubmit(this.submit),panelId:__WEBPACK_IMPORTED_MODULE_7_util_constants__["x" /* CREATE_MEDIA_ENGINE_PANEL_ID */],panelTitle:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_ACTION_ADD),showCancel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_ACTIVE)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_11_view_Forms_BulmaCheckRadio__["a" /* default */],disabled:allActivationsUsed,id:'isActive',name:'isActive',type:'checkbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_ADDRESS)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'input',component:'input',id:'address',name:'address',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].MEDIA_ENGINES_COLUMN_PORT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{className:'input dir-svc-desc-form-field-small-width',component:'input',id:'port',max:65535,min:0,name:'port',type:'number'}))));}}]);return CreateMediaEngineDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function validate(data,props){var errors={};if(!data.address){errors.address='Required';}if(!data.port){errors.port='Required';}return errors;}var form=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reduxForm */])({form:__WEBPACK_IMPORTED_MODULE_7_util_constants__["x" /* CREATE_MEDIA_ENGINE_PANEL_ID */],validate:validate})(CreateMediaEngineDialog);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{activePanelId:Object(__WEBPACK_IMPORTED_MODULE_9_state_selectors__["c" /* getActivePanelId */])(state),initialValues:{port:__WEBPACK_IMPORTED_MODULE_7_util_constants__["P" /* MEDIA_ENGINE_DEFAULT_PORT */]}};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_util_safeDispatch__["a" /* bindActionCreatorsForm */])({createMediaEngine:__WEBPACK_IMPORTED_MODULE_12_state_commands_mediaEngineCommands__["a" /* createMediaEngine */],hideDialogPanel:__WEBPACK_IMPORTED_MODULE_5_state_commands_dialogPanelCommands__["a" /* hideDialogPanel */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(form)));

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_view_Forms_BulmaCheckRadio__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_color__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_constants__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginCustomizationPage=function(_Component){_inherits(LoginCustomizationPage,_Component);function LoginCustomizationPage(){_classCallCheck(this,LoginCustomizationPage);var _this=_possibleConstructorReturn(this,(LoginCustomizationPage.__proto__||Object.getPrototypeOf(LoginCustomizationPage)).call(this));_this.state={backgroundColorChanged:false,newBackgroundColor:'',customImageChanged:false,imageUpload:undefined};_this.submit=_this.submit.bind(_this);_this.onImageSelected=_this.onImageSelected.bind(_this);_this.onColorChangeComplete=_this.onColorChangeComplete.bind(_this);_this.onRemoveImage=_this.onRemoveImage.bind(_this);_this.state.backgroundColorChanged=false;return _this;}_createClass(LoginCustomizationPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getAdminProperties([__WEBPACK_IMPORTED_MODULE_5_util_AdminProperties__["a" /* ADMIN_PROPERTIES */].brandingSettings]);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.brandingSettings!==nextProps.brandingSettings){this.initializeFields(nextProps.brandingSettings);}}},{key:'initializeFields',value:function initializeFields(brandingSettings){if(brandingSettings.useCustomBranding)this.props.initialize(brandingSettings);}},{key:'onImageSelected',value:function onImageSelected(e){var brandingSettings=this.props.brandingSettings;this.setState({imageUpload:e.target.files[0]});brandingSettings.customImageFilename=e.target.files[0].name;this.setState({customImageChanged:true});this.forceUpdate();}},{key:'onRemoveImage',value:function onRemoveImage(){this.props.brandingSettings.customImageFilename='';this.props.brandingSettings.useCustomImage=false;this.setState({customImageChanged:true,imageUpload:undefined});}},{key:'onColorChangeComplete',value:function onColorChangeComplete(color){this.setState({newBackgroundColor:color.hex});this.setState({backgroundColorChanged:true});}},{key:'isSubmitDisabled',value:function isSubmitDisabled(formIsPristine){if(this.state.backgroundColorChanged)return false;if(this.state.customImageChanged)return false;if(formIsPristine)return true;}},{key:'submit',value:function submit(values,dispatch,props){var setBrandingSettings=this.props.setBrandingSettings;var _state=this.state,imageUpload=_state.imageUpload,newBackgroundColor=_state.newBackgroundColor;var settings=Object.assign({},values,{customBackgroundColor:newBackgroundColor.replace('#','')// get rid of the leading #
});var imageData={};imageData.file=imageUpload;setBrandingSettings(settings,imageData);this.setState({customImageChanged:false});}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,pristine=_props.pristine,reset=_props.reset,brandingSettings=_props.brandingSettings,formatMessage=_props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents-textured','data-test-name':'login-customization-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit(this.submit),style:{maxWidth:'700px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'login-customization-field-xsmall-width is-checkradio is-medium',component:__WEBPACK_IMPORTED_MODULE_9_view_Forms_BulmaCheckRadio__["a" /* default */],id:'useCustomBranding',name:'useCustomBranding',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label is-medium login-customization-enabled-label',htmlFor:'useCustomBranding'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CUSTOM_IMAGE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file is-right is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'file-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'file-input',type:'file',name:'imageUpload',accept:'.png,.jpg,.jpeg',onChange:this.onImageSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-cta'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-label'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CHOOSE_FILE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-name'},brandingSettings.customImageFilename?brandingSettings.customImageFilename:formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].NO_FILE_SELECTED))),brandingSettings.customImageFilename&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delete',onClick:this.onRemoveImage,style:{margin:'8px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'help is-indented'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_CUSTOM_TITLE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input',component:'input',id:'customTitle',name:'customTitle',type:'input'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_IMAGE_URL))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{className:'input',component:'input',id:'customURL',name:'customURL',type:'input'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-label is-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},formatMessage(__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].GLOBAL_SETTINGS_BACKGROUND_COLOR))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_color__["a" /* CompactPicker */],{color:this.state.newBackgroundColor?this.state.newBackgroundColor:brandingSettings.customBackgroundColor,onChangeComplete:this.onColorChangeComplete})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-dark is-outlined',disabled:pristine,onClick:reset,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].REVERT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary',type:'submit',disabled:this.isSubmitDisabled(pristine)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8_util_localizedStrings__["a" /* default */].APPLY)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-spacer-xlarge'})))));}}]);return LoginCustomizationPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var loginCustomizationForm=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reduxForm */])({destroyOnUnmount:false,form:__WEBPACK_IMPORTED_MODULE_11_util_constants__["i" /* BRANDING_SETTINGS_FORM */]})(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(LoginCustomizationPage));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{brandingSettings:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["i" /* getBrandingSettings */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_util_safeDispatch__["a" /* bindActionCreatorsForm */])({getAdminProperties:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["e" /* getAdminProperties */],setBrandingSettings:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["j" /* setBrandingSettings */]});})(loginCustomizationForm));

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_alpha_Alpha__ = __webpack_require__(1011);
/* unused harmony reexport AlphaPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_block_Block__ = __webpack_require__(1141);
/* unused harmony reexport BlockPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_circle_Circle__ = __webpack_require__(1144);
/* unused harmony reexport CirclePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chrome_Chrome__ = __webpack_require__(434);
/* unused harmony reexport default */
/* unused harmony reexport ChromePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_compact_Compact__ = __webpack_require__(1151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__components_compact_Compact__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_github_Github__ = __webpack_require__(1154);
/* unused harmony reexport GithubPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_hue_Hue__ = __webpack_require__(1156);
/* unused harmony reexport HuePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_material_Material__ = __webpack_require__(1158);
/* unused harmony reexport MaterialPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_photoshop_Photoshop__ = __webpack_require__(1159);
/* unused harmony reexport PhotoshopPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sketch_Sketch__ = __webpack_require__(1165);
/* unused harmony reexport SketchPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_slider_Slider__ = __webpack_require__(1168);
/* unused harmony reexport SliderPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_swatches_Swatches__ = __webpack_require__(1172);
/* unused harmony reexport SwatchesPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_twitter_Twitter__ = __webpack_require__(1176);
/* unused harmony reexport TwitterPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_google_Google__ = __webpack_require__(1177);
/* unused harmony reexport GooglePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_ColorWrap__ = __webpack_require__(431);
/* unused harmony reexport CustomPicker */



















/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AlphaPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlphaPointer__ = __webpack_require__(1140);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* Alpha */], _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: __WEBPACK_IMPORTED_MODULE_3__AlphaPointer__["a" /* default */]
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* ColorWrap */])(AlphaPicker));

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(1013);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(231);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(1025);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(1026);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70),
    isArray = __webpack_require__(44),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1017);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70),
    isLength = __webpack_require__(233),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(236),
    nativeKeys = __webpack_require__(1023);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(411);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(413);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70),
    getPrototype = __webpack_require__(237),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(414),
    baseIteratee = __webpack_require__(1027),
    baseMap = __webpack_require__(1085),
    isArray = __webpack_require__(44);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1028),
    baseMatchesProperty = __webpack_require__(1072),
    identity = __webpack_require__(413),
    isArray = __webpack_require__(44),
    property = __webpack_require__(1082);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1029),
    getMatchData = __webpack_require__(1071),
    matchesStrictComparable = __webpack_require__(424);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(238),
    baseIsEqual = __webpack_require__(416);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(157);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(157),
    Map = __webpack_require__(240),
    MapCache = __webpack_require__(241);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(412),
    isMasked = __webpack_require__(1041),
    isObject = __webpack_require__(89),
    toSource = __webpack_require__(415);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1042);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1045),
    ListCache = __webpack_require__(157),
    Map = __webpack_require__(240);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1046),
    hashDelete = __webpack_require__(1047),
    hashGet = __webpack_require__(1048),
    hashHas = __webpack_require__(1049),
    hashSet = __webpack_require__(1050);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(238),
    equalArrays = __webpack_require__(417),
    equalByTag = __webpack_require__(1062),
    equalObjects = __webpack_require__(1065),
    getTag = __webpack_require__(161),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(232),
    isTypedArray = __webpack_require__(410);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(241),
    setCacheAdd = __webpack_require__(1058),
    setCacheHas = __webpack_require__(1059);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1060 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    Uint8Array = __webpack_require__(418),
    eq = __webpack_require__(239),
    equalArrays = __webpack_require__(417),
    mapToArray = __webpack_require__(1063),
    setToArray = __webpack_require__(1064);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(419);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(423),
    keys = __webpack_require__(113);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(416),
    get = __webpack_require__(1073),
    hasIn = __webpack_require__(1079),
    isKey = __webpack_require__(243),
    isStrictComparable = __webpack_require__(423),
    matchesStrictComparable = __webpack_require__(424),
    toKey = __webpack_require__(162);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(425);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1075);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1076);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(241);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1078);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    arrayMap = __webpack_require__(414),
    isArray = __webpack_require__(44),
    isSymbol = __webpack_require__(244);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1080),
    hasPath = __webpack_require__(1081);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1080 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(426),
    isArguments = __webpack_require__(408),
    isArray = __webpack_require__(44),
    isIndex = __webpack_require__(409),
    isLength = __webpack_require__(233),
    toKey = __webpack_require__(162);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1083),
    basePropertyDeep = __webpack_require__(1084),
    isKey = __webpack_require__(243),
    toKey = __webpack_require__(162);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(425);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1086),
    isArrayLike = __webpack_require__(156);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(406),
    createBaseEach = __webpack_require__(1087);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(156);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(231);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(1089);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(1090);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(238),
    arrayEach = __webpack_require__(1091),
    assignValue = __webpack_require__(427),
    baseAssign = __webpack_require__(1093),
    baseAssignIn = __webpack_require__(1094),
    cloneBuffer = __webpack_require__(1097),
    copyArray = __webpack_require__(1098),
    copySymbols = __webpack_require__(1099),
    copySymbolsIn = __webpack_require__(1100),
    getAllKeys = __webpack_require__(419),
    getAllKeysIn = __webpack_require__(1101),
    getTag = __webpack_require__(161),
    initCloneArray = __webpack_require__(1102),
    initCloneByTag = __webpack_require__(1103),
    initCloneObject = __webpack_require__(1108),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(232),
    isMap = __webpack_require__(1110),
    isObject = __webpack_require__(89),
    isSet = __webpack_require__(1112),
    keys = __webpack_require__(113),
    keysIn = __webpack_require__(245);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(163),
    keys = __webpack_require__(113);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(163),
    keysIn = __webpack_require__(245);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isPrototype = __webpack_require__(236),
    nativeKeysIn = __webpack_require__(1096);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1096 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(52);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(163),
    getSymbols = __webpack_require__(242);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(163),
    getSymbolsIn = __webpack_require__(429);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(420),
    getSymbolsIn = __webpack_require__(429),
    keysIn = __webpack_require__(245);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(246),
    cloneDataView = __webpack_require__(1104),
    cloneRegExp = __webpack_require__(1105),
    cloneSymbol = __webpack_require__(1106),
    cloneTypedArray = __webpack_require__(1107);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(246);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(246);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1109),
    getPrototype = __webpack_require__(237),
    isPrototype = __webpack_require__(236);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1111),
    baseUnary = __webpack_require__(234),
    nodeUtil = __webpack_require__(235);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(161),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1113),
    baseUnary = __webpack_require__(234),
    nodeUtil = __webpack_require__(235);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(161),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(231);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alpha */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_alpha__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Checkboard__ = __webpack_require__(247);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = __WEBPACK_IMPORTED_MODULE_2__helpers_alpha__["a" /* calculateChange */](e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.alpha },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.checkboard },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Checkboard__["a" /* default */], { renderers: this.props.renderers })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.gradient }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.pointer, this.props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"] || __WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Alpha);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateChange; });
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export render */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
var checkboardCache = {};

var render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditableInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.wrap },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"] || __WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EditableInput);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_hue__ = __webpack_require__(1123);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = __WEBPACK_IMPORTED_MODULE_2__helpers_hue__["a" /* calculateChange */](e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.hue },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.pointer, this.props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"] || __WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Hue);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateChange; });
var calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Raised */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);





var Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.wrap },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.bg }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([0, 1, 2, 3, 4, 5]),
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

/* harmony default export */ __webpack_exports__["a"] = (Raised);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Saturation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_throttle__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_saturation__ = __webpack_require__(1131);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, __WEBPACK_IMPORTED_MODULE_3__helpers_saturation__["a" /* calculateChange */](e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_throttle__["a" /* default */])(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.black, className: 'saturation-black' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.pointer, this.props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"] || __WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Saturation);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debounce_js__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(41);



/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__debounce_js__["a" /* default */])(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ __webpack_exports__["a"] = (throttle);


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(40);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTrim_js__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isSymbol_js__ = __webpack_require__(94);




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = Object(__WEBPACK_IMPORTED_MODULE_0__baseTrim_js__["a" /* default */])(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trimmedEndIndex_js__ = __webpack_require__(1130);


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, Object(__WEBPACK_IMPORTED_MODULE_0__trimmedEndIndex_js__["a" /* default */])(string) + 1).replace(reTrimStart, '')
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTrim);


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (trimmedEndIndex);


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateChange; });
var calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forEach_js__ = __webpack_require__(1133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__forEach_js__["a"]; });



/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEach_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castFunction_js__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(35);





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseEach_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__castFunction_js__["a" /* default */])(iteratee));
}

/* harmony default export */ __webpack_exports__["a"] = (forEach);


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(62);


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseEach);


/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(130);


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (castFunction);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated. It's used to publish CJS to npm.
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Swatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_interaction__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Checkboard__ = __webpack_require__(247);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var ENTER = 13;

var Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Checkboard__["a" /* default */], {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_interaction__["a" /* handleFocus */])(Swatch));

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleFocus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-invalid-this */


var handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
};

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AlphaPointer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

/* harmony default export */ __webpack_exports__["a"] = (AlphaPointer);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Block */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BlockSwatches__ = __webpack_require__(1142);









var Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    __WEBPACK_IMPORTED_MODULE_4__helpers_color__["b" /* isValidHex */](hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: __WEBPACK_IMPORTED_MODULE_4__helpers_color__["a" /* getContrastingColor */](hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.triangle }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.head },
      transparent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* Checkboard */], { borderRadius: '6px 6px 0 0' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.body },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BlockSwatches__["a" /* default */], { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["d" /* EditableInput */], {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  triangle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'hide']),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__common__["c" /* ColorWrap */])(Block));

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BlockSwatches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);






var BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.swatches },
    Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(colors, function (c) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["h" /* Swatch */], {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.clear })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BlockSwatches);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(62);



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? Array(collection.length) : [];

  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseMap);


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Circle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_colors__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CircleSwatch__ = __webpack_require__(1145);










var Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__["a" /* default */])({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(colors, function (c) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CircleSwatch__["a" /* default */], {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  circleSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  circleSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [__WEBPACK_IMPORTED_MODULE_5_material_colors__["p" /* red */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["n" /* pink */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["o" /* purple */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["g" /* deepPurple */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["i" /* indigo */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["b" /* blue */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["j" /* lightBlue */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["e" /* cyan */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["q" /* teal */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["h" /* green */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["k" /* lightGreen */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["l" /* lime */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["r" /* yellow */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["a" /* amber */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["m" /* orange */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["f" /* deepOrange */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["d" /* brown */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["c" /* blueGrey */]['500']],
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* ColorWrap */])(Circle));

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CircleSwatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(14);





var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.swatch },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["h" /* Swatch */], {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_reactcss__["handleHover"])(CircleSwatch));

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChromeFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_material_UnfoldMoreHorizontalIcon__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_material_UnfoldMoreHorizontalIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__icons_material_UnfoldMoreHorizontalIcon__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-did-mount-set-state, no-param-reassign */









var ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck(this, ChromeFields);

    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_color__["b" /* isValidHex */](data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__["a" /* default */])(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__["a" /* default */])(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.alpha },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.field },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.alpha },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.toggle },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons_material_UnfoldMoreHorizontalIcon___default.a, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

/* harmony default export */ __webpack_exports__["a"] = (ChromeFields);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChromePointer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var ChromePointer = function ChromePointer() {
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

/* harmony default export */ __webpack_exports__["a"] = (ChromePointer);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChromePointerCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var ChromePointerCircle = function ChromePointerCircle() {
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

/* harmony default export */ __webpack_exports__["a"] = (ChromePointerCircle);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Compact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CompactColor__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CompactFields__ = __webpack_require__(1153);











var Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__["a" /* default */])({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      __WEBPACK_IMPORTED_MODULE_5__helpers_color__["b" /* isValidHex */](data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__common__["f" /* Raised */],
    { style: styles.Compact, styles: passedStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(colors, function (c) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CompactColor__["a" /* default */], {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.clear })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CompactFields__["a" /* default */], { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* ColorWrap */])(Compact));

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompactColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);






var CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: __WEBPACK_IMPORTED_MODULE_2__helpers_color__["a" /* getContrastingColor */](color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common__["h" /* Swatch */],
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.dot })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CompactColor);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompactFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(14);





var CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.active }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["d" /* EditableInput */], {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CompactFields);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Github */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GithubSwatch__ = __webpack_require__(1155);









var Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__["a" /* default */])({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.triangleShadow }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.triangle }),
    Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(colors, function (c) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__GithubSwatch__["a" /* default */], {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  triangle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__common__["c" /* ColorWrap */])(Github));

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GithubSwatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(14);





var GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.swatch },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["h" /* Swatch */], {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_reactcss__["handleHover"])(GithubSwatch));

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HuePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HuePointer__ = __webpack_require__(1157);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* Hue */], _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: __WEBPACK_IMPORTED_MODULE_5__HuePointer__["a" /* default */],
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(HuePicker));

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SliderPointer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

/* harmony default export */ __webpack_exports__["a"] = (SliderPointer);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Material */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);







var Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_merge__["a" /* default */])({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      __WEBPACK_IMPORTED_MODULE_3__helpers_color__["b" /* isValidHex */](data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__common__["f" /* Raised */],
    { styles: passedStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.third },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.third },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.third },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* EditableInput */], {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(Material));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Photoshop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PhotoshopFields__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PhotoshopPointerCircle__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PhotoshopPointer__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PhotoshopButton__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PhotoshopPreviews__ = __webpack_require__(1164);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.saturation },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["g" /* Saturation */], {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: __WEBPACK_IMPORTED_MODULE_6__PhotoshopPointerCircle__["a" /* default */],
              onChange: this.props.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.hue },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* Hue */], {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: __WEBPACK_IMPORTED_MODULE_7__PhotoshopPointer__["a" /* default */],
              onChange: this.props.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.controls },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.previews },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PhotoshopPreviews__["a" /* default */], {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.actions },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PhotoshopButton__["a" /* default */], { label: 'OK', onClick: this.props.onAccept, active: true }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PhotoshopButton__["a" /* default */], { label: 'Cancel', onClick: this.props.onCancel }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PhotoshopFields__["a" /* default */], {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Photoshop.propTypes = {
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(Photoshop));

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhotoshopPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);






var PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      __WEBPACK_IMPORTED_MODULE_2__helpers_color__["b" /* isValidHex */](data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.fields },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.divider }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.divider }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.fieldSymbols },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PhotoshopPicker);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhotoshopPointerCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

/* harmony default export */ __webpack_exports__["a"] = (PhotoshopPointerCircle);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhotoshopPointerCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.pointer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.left },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.leftInside })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.right },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.rightInside })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PhotoshopPointerCircle);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhotoshopButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PhotoshopButton);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhotoshopPreviews */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatches },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.new }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.current })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PhotoshopPreviews);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sketch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SketchFields__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SketchPresetColors__ = __webpack_require__(1167);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': _extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.saturation },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["g" /* Saturation */], {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.sliders },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.hue },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* Hue */], {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.alpha },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Alpha */], {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.color },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["b" /* Checkboard */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.activeColor })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SketchFields__["a" /* default */], {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SketchPresetColors__["a" /* default */], {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(Sketch));

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SketchFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);
/* eslint-disable no-param-reassign */







var SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      __WEBPACK_IMPORTED_MODULE_2__helpers_color__["b" /* isValidHex */](data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.double },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.single },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.single },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.single },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.alpha },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SketchFields);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SketchPresetColors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["h" /* Swatch */], _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })])).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SketchPresetColors);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SliderSwatches__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SliderPointer__ = __webpack_require__(1171);









var Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.hue },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* Hue */], {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatches },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SliderSwatches__["a" /* default */], { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Slider.defaultProps = {
  pointer: __WEBPACK_IMPORTED_MODULE_6__SliderPointer__["a" /* default */],
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(Slider));

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SliderSwatches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SliderSwatch__ = __webpack_require__(1170);





var SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.swatches },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatch },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SliderSwatch__["a" /* default */], {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatch },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SliderSwatch__["a" /* default */], {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatch },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SliderSwatch__["a" /* default */], {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatch },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SliderSwatch__["a" /* default */], {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.swatch },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SliderSwatch__["a" /* default */], {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.clear })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SliderSwatches);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SliderSwatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.swatch, onClick: handleClick });
};

/* harmony default export */ __webpack_exports__["a"] = (SliderSwatch);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SliderPointer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);



var SliderPointer = function SliderPointer() {
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

/* harmony default export */ __webpack_exports__["a"] = (SliderPointer);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Swatches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_colors__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SwatchesGroup__ = __webpack_require__(1173);










var Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__["a" /* default */])({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__common__["f" /* Raised */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.overflow },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.body },
          Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(colors, function (group) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SwatchesGroup__["a" /* default */], {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[__WEBPACK_IMPORTED_MODULE_5_material_colors__["p" /* red */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["p" /* red */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["p" /* red */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["p" /* red */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["p" /* red */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["n" /* pink */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["n" /* pink */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["n" /* pink */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["n" /* pink */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["n" /* pink */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["o" /* purple */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["o" /* purple */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["o" /* purple */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["o" /* purple */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["o" /* purple */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["g" /* deepPurple */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["g" /* deepPurple */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["g" /* deepPurple */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["g" /* deepPurple */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["g" /* deepPurple */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["i" /* indigo */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["i" /* indigo */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["i" /* indigo */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["i" /* indigo */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["i" /* indigo */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["b" /* blue */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["b" /* blue */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["b" /* blue */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["b" /* blue */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["b" /* blue */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["j" /* lightBlue */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["j" /* lightBlue */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["j" /* lightBlue */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["j" /* lightBlue */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["j" /* lightBlue */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["e" /* cyan */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["e" /* cyan */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["e" /* cyan */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["e" /* cyan */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["e" /* cyan */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["q" /* teal */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["q" /* teal */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["q" /* teal */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["q" /* teal */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["q" /* teal */]['100']], ['#194D33', __WEBPACK_IMPORTED_MODULE_5_material_colors__["h" /* green */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["h" /* green */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["h" /* green */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["h" /* green */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["k" /* lightGreen */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["k" /* lightGreen */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["k" /* lightGreen */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["k" /* lightGreen */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["k" /* lightGreen */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["l" /* lime */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["l" /* lime */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["l" /* lime */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["l" /* lime */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["l" /* lime */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["r" /* yellow */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["r" /* yellow */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["r" /* yellow */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["r" /* yellow */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["r" /* yellow */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["a" /* amber */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["a" /* amber */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["a" /* amber */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["a" /* amber */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["a" /* amber */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["m" /* orange */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["m" /* orange */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["m" /* orange */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["m" /* orange */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["m" /* orange */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["f" /* deepOrange */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["f" /* deepOrange */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["f" /* deepOrange */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["f" /* deepOrange */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["f" /* deepOrange */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["d" /* brown */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["d" /* brown */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["d" /* brown */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["d" /* brown */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["d" /* brown */]['100']], [__WEBPACK_IMPORTED_MODULE_5_material_colors__["c" /* blueGrey */]['900'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["c" /* blueGrey */]['700'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["c" /* blueGrey */]['500'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["c" /* blueGrey */]['300'], __WEBPACK_IMPORTED_MODULE_5_material_colors__["c" /* blueGrey */]['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* ColorWrap */])(Swatches));

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwatchesGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SwatchesColor__ = __webpack_require__(1174);






var SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.group },
    Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(group, function (color, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SwatchesColor__["a" /* default */], {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SwatchesGroup);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwatchesColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_material_CheckIcon__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_material_CheckIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__icons_material_CheckIcon__);







var SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: __WEBPACK_IMPORTED_MODULE_2__helpers_color__["a" /* getContrastingColor */](color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common__["h" /* Swatch */],
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.check },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icons_material_CheckIcon___default.a, null)
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SwatchesColor);

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Twitter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(14);









var Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_merge__["a" /* default */])({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    __WEBPACK_IMPORTED_MODULE_5__helpers_color__["b" /* isValidHex */](hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.triangleShadow }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.triangle }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.body },
      Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(colors, function (c, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* Swatch */], {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["d" /* EditableInput */], {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  triangle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hide', 'top-left', 'top-right']),
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* ColorWrap */])(Twitter));

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Google */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GooglePointerCircle__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GooglePointer__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GoogleFields__ = __webpack_require__(1180);










var Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = __WEBPACK_IMPORTED_MODULE_2_reactcss___default()(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_merge__["a" /* default */])({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.picker, className: 'google-picker ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.head },
      header
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.swatch }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.saturation },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["g" /* Saturation */], {
        hsl: hsl,
        hsv: hsv,
        pointer: __WEBPACK_IMPORTED_MODULE_5__GooglePointerCircle__["a" /* default */],
        onChange: onChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.body },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.hue },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* Hue */], {
            style: styles.Hue,
            hsl: hsl,
            radius: '4px',
            pointer: __WEBPACK_IMPORTED_MODULE_6__GooglePointer__["a" /* default */],
            onChange: onChange
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GoogleFields__["a" /* default */], {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
      })
    )
  );
};

Google.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string

};

Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* ColorWrap */])(Google));

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GooglePointerCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




var GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

GooglePointerCircle.propTypes = {
  hsl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    h: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    s: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    l: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    a: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })
};

GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

/* harmony default export */ __webpack_exports__["a"] = (GooglePointerCircle);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GooglePointer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




var GooglePointer = function GooglePointer(props) {
  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.picker });
};

GooglePointer.propTypes = {
  hsl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    h: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    s: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    l: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    a: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })
};

GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

/* harmony default export */ __webpack_exports__["a"] = (GooglePointer);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GoogleFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reactcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_color__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(14);





var GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;


  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      __WEBPACK_IMPORTED_MODULE_2__helpers_color__["b" /* isValidHex */](data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      __WEBPACK_IMPORTED_MODULE_2__helpers_color__["c" /* isvalidColorString */](data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');
      if (__WEBPACK_IMPORTED_MODULE_2__helpers_color__["c" /* isvalidColorString */](data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');
      if (__WEBPACK_IMPORTED_MODULE_2__helpers_color__["c" /* isvalidColorString */](data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = __WEBPACK_IMPORTED_MODULE_1_reactcss___default()({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      double: {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });

  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: styles.wrap, className: 'flexbox-fix' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: styles.fields },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.double },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
          style: { input: styles.input, label: styles.label },
          label: 'hex',
          value: hex,
          onChange: handleChange
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.column },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.single },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
            style: { input: styles.input2, label: styles.label2 },
            label: 'rgb',
            value: rgbValue,
            onChange: handleChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.single },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsv',
            value: hsvValue,
            onChange: handleChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.single },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* EditableInput */], {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsl',
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GoogleFields);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortsRow__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PortsPage=function(_Component){_inherits(PortsPage,_Component);function PortsPage(){_classCallCheck(this,PortsPage);var _this=_possibleConstructorReturn(this,(PortsPage.__proto__||Object.getPrototypeOf(PortsPage)).call(this));_this.handlePortChanged=_this.handlePortChanged.bind(_this);_this.handleRestartServer=_this.handleRestartServer.bind(_this);_this.state={dirty:false};return _this;}_createClass(PortsPage,[{key:'handleRestartServer',value:function handleRestartServer(){this.props.history.replace('/status');this.props.restartServer();}},{key:'handlePortChanged',value:function handlePortChanged(){this.setState({dirty:true});}},{key:'render',value:function render(){var formatMessage=this.props.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-contents columns is-gapless','data-test-name':'ports-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PORT_TITLE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section page-contents-textured portfolio-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortsRow__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].ESP_PORT_ADMIN_WEB_APP,onPortChanged:this.handlePortChanged,portKey:'esp.port.admin-web-app',defaultPort:'8091'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortsRow__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].ESP_PORT_ADMIN_WEB_APP_SSL,onPortChanged:this.handlePortChanged,portKey:'esp.port.admin-web-app-ssl',defaultPort:'9453'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortsRow__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].ESP_PORT_HTTP,onPortChanged:this.handlePortChanged,portKey:'esp.port.http',defaultPort:'8090'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortsRow__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].ESP_PORT_SSL,onPortChanged:this.handlePortChanged,portKey:'esp.port.https',defaultPort:'9443'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ports-restart-area'},formatMessage(__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].PORT_RESTART_NOTICE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-outlined',disabled:!this.state.dirty,'data-test-name':'restart-server',onClick:this.handleRestartServer,style:{marginLeft:'32px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-repeat fa-rotate-270'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5_util_localizedStrings__["a" /* default */].STATUS_RESTART_SERVER)))))));}}]);return PortsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({restartServer:__WEBPACK_IMPORTED_MODULE_7_state_commands_adminPropertiesCommands__["f" /* restartServer */]});})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(PortsPage))));

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PortsRow=function(_Component){_inherits(PortsRow,_Component);function PortsRow(){_classCallCheck(this,PortsRow);var _this=_possibleConstructorReturn(this,(PortsRow.__proto__||Object.getPrototypeOf(PortsRow)).call(this));_this.handleButtonClick=function(event){var key=event.target.id;if(_this.state.newPort===-1){_this.setState({disabled:false});}else{_this.updatePorts(_defineProperty({},key,_this.state.newPort));}};_this.handleCancel=function(event){_this.setState({disabled:true,newPort:-1});};_this.handleChangeInput=function(event){var newValue=parseInt(event.target.value,10);if(newValue>65535){newValue=65535;}if(newValue<0){newValue=0;}_this.setState({newPort:newValue});};_this.state={disabled:true,newPort:-1};_this.handleButtonClick=_this.handleButtonClick.bind(_this);_this.updatePorts=_this.updatePorts.bind(_this);return _this;}_createClass(PortsRow,[{key:'updatePorts',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ports){var _props,onPortChanged,setPorts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,onPortChanged=_props.onPortChanged,setPorts=_props.setPorts;_context.next=3;return setPorts(ports);case 3:this.setState({disabled:true,newPort:-1});onPortChanged();case 5:case'end':return _context.stop();}}},_callee,this);}));function updatePorts(_x){return _ref.apply(this,arguments);}return updatePorts;}()},{key:'render',value:function render(){var _props2=this.props,formatMessage=_props2.intl.formatMessage,label=_props2.label,portKey=_props2.portKey,serverPorts=_props2.serverPorts,defaultPort=_props2.defaultPort;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column is-two-fifths'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'is-block'},formatMessage(label)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'help is-indented'},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].PORT_DEFAULT),' ',defaultPort)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column is-one-fifth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'input '+(this.state.disabled?'is-static':''),'data-test-name':portKey+'-value',maxLength:'5',value:this.state.newPort===-1?serverPorts[portKey]:this.state.newPort,onChange:this.handleChangeInput,type:'number',disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column has-text-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.disabled?'button':'button is-primary is-outlined',id:portKey,'data-test-name':portKey,onClick:this.handleButtonClick},this.state.disabled?formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CHANGE):formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].SAVE)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.disabled?'is-hidden':'button is-indented is-dark is-outlined',id:'cancel','data-test-name':portKey+'-cancel',onClick:this.handleCancel},formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].CANCEL))));}}]);return PortsRow;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{serverPorts:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_13" /* getPorts */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({setPorts:__WEBPACK_IMPORTED_MODULE_6_state_commands_adminPropertiesCommands__["o" /* setPorts */]});})(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* injectIntl */])(PortsRow)));

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_view_Forms_LabeledField__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOGGING_LEVELS=['DEBUG','INFO','ERROR'];var LOGGING_RETAIN_COUNT=[1,2,3,5,10,15,20,25];var LoggingControls=function(_Component){_inherits(LoggingControls,_Component);function LoggingControls(){_classCallCheck(this,LoggingControls);var _this=_possibleConstructorReturn(this,(LoggingControls.__proto__||Object.getPrototypeOf(LoggingControls)).call(this));_this.onChangeLogConfig=_this.onChangeLogConfig.bind(_this);return _this;}_createClass(LoggingControls,[{key:'onChangeLogConfig',value:function onChangeLogConfig(event,fieldName){var _Object$assign;var setLoggingConfig=this.props.setLoggingConfig;setLoggingConfig(Object.assign({},this.props.loggingConfig,(_Object$assign={},_defineProperty(_Object$assign,fieldName,event.target.value),_defineProperty(_Object$assign,'logDirectory',null),_Object$assign)));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,formatMessage=_props.intl.formatMessage,loggingConfig=_props.loggingConfig;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page page-contents-textured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LOGGING_CONFIGURATION)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portfolio-form-container','data-test-name':'logging-config-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LOGGING_LOG_LEVEL)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'logLevel','data-test-name':'log-level',value:loggingConfig.logLevel,onChange:function onChange(e){return _this2.onChangeLogConfig(e,'logLevel');},style:{width:'140px'}},LOGGING_LEVELS.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt,value:opt},opt);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_view_Forms_LabeledField__["a" /* default */],{label:formatMessage(__WEBPACK_IMPORTED_MODULE_7_util_localizedStrings__["a" /* default */].LOGGING_NUM_LOGS_TO_RETAIN)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'retainCount','data-test-name':'retain-count',value:loggingConfig.retainCount,onChange:function onChange(e){return _this2.onChangeLogConfig(e,'retainCount');},style:{width:'140px'}},LOGGING_RETAIN_COUNT.includes(loggingConfig.retainCount)||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:loggingConfig.retainCount,value:loggingConfig.retainCount},loggingConfig.retainCount),LOGGING_RETAIN_COUNT.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt,value:opt},opt);})))))));}}]);return LoggingControls;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* injectIntl */])(LoggingControls);/* harmony default export */ __webpack_exports__["a"] = (wrappedForm=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{loggingConfig:Object(__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_5" /* getLoggingConfig */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_util_safeDispatch__["b" /* bindActionCreatorsSafe */])({getLoggingConfig:__WEBPACK_IMPORTED_MODULE_5_state_selectors__["_5" /* getLoggingConfig */],setLoggingConfig:__WEBPACK_IMPORTED_MODULE_4_state_commands_adminPropertiesCommands__["m" /* setLoggingConfig */]});})(wrappedForm));

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVZJREFUeNrsVjFuwzAMtIM8wGMyRU/IE5Q1Hdq1U/wEP8FP8BPcqbN/0Cc0P1Cnru4LFBK4gWGtWJaLBgFM4ABSkkmTR9PKvffZPWSV3UkeKnBBqAk9UGNtmjDHkbCEhtD73+KwZ2P95RHNxdl8EnaRuXwR9qhGUNYRjl4Ggr4RHHQO8iz2dnimnctxKfQz4Qm6BXqsnQPPJHFsBI/M7THA8dBeccv3WOBWOOLm+RA267WyG2G3qYGNysoqWwceOmNC/m9xbALrzOWBUKGBDmg2lo06a1M5duLtS8WhzrjHGfltZykZZ8hKdmqjvm9ZlUZ1cz13csmsK9VwspEqlf3sycU8noTdEd4JW9jfhFc1RDoMkVkZ7/10Kcf8xv4gSlXykDiUvPiLUl8VaGQ/X24gS+CHDvwD/GvgDnPaQJ8uE26ZBQaEDdxAXczgSB0gS1cny0WAAQDlKbXygwQUbQAAAABJRU5ErkJggg=="

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageRoute=function(_Component){_inherits(PageRoute,_Component);function PageRoute(){_classCallCheck(this,PageRoute);var _this=_possibleConstructorReturn(this,(PageRoute.__proto__||Object.getPrototypeOf(PageRoute)).call(this));_this.renderPage=_this.renderPage.bind(_this);return _this;}_createClass(PageRoute,[{key:'renderPage',value:function renderPage(){var _props=this.props,isFullAdmin=_props.isFullAdmin,hasIdentityService=_props.hasIdentityService,page=_props.page;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(page.component,{contents:page.contents,hasIdentityService:hasIdentityService,isFullAdmin:isFullAdmin,title:page.label,dataTestName:page.dataTestName});}},{key:'render',value:function render(){var page=this.props.page;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:page.route,render:this.renderPage});}}]);return PageRoute;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PageRoute);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationDisplay__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_portfolio_shared_state_commands_globalNotificationsCommands__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_selectors__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GlobalNotifications=function(_Component){_inherits(GlobalNotifications,_Component);function GlobalNotifications(){_classCallCheck(this,GlobalNotifications);return _possibleConstructorReturn(this,(GlobalNotifications.__proto__||Object.getPrototypeOf(GlobalNotifications)).apply(this,arguments));}_createClass(GlobalNotifications,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotificationDisplay__["a" /* default */],{notifications:this.props.notifications,onRemoveNotification:this.props.removeNotification});}}]);return GlobalNotifications;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);GlobalNotifications.propTypes={notifications:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,removeNotification:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{notifications:Object(__WEBPACK_IMPORTED_MODULE_6_state_selectors__["_12" /* getNotifications */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({removeNotification:__WEBPACK_IMPORTED_MODULE_5_portfolio_shared_state_commands_globalNotificationsCommands__["d" /* removeNotification */]},dispatch);})(GlobalNotifications));

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__react_notification_system_NotificationSystem__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationsDisplay=function(_Component){_inherits(NotificationsDisplay,_Component);function NotificationsDisplay(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NotificationsDisplay);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotificationsDisplay.__proto__||Object.getPrototypeOf(NotificationsDisplay)).call.apply(_ref,[this].concat(args))),_this),_this._notificationSystem=null,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotificationsDisplay,[{key:'componentDidMount',value:function componentDidMount(){this._notificationSystem=this.notificationSystem;this._showNotifications(this.props);}},{key:'_showNotifications',value:function _showNotifications(props){var notifs=props.notifications;if(notifs.length>0){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=notifs[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var notif=_step.value;// TODO - This is hella confusing. The message of the message of the notification. Argg
// The message of the notif is actually the notification that you originally dispatched.
// Urg.
var message=notif.message;if(message.hasOwnProperty('message')){message=this.props.intl.formatMessage(message.message,message.params);}else if(message.hasOwnProperty('id')&&message.hasOwnProperty('defaultMessage')){message=this.props.intl.formatMessage(message);}else{message=message.toString();}if(!message||!notif.uid){continue;}var reactNotification={uid:notif.uid,message:message,level:notif.type,position:'tc',onRemove:function onRemove(notification){return props.onRemoveNotification(notification.uid);},action:notif.message.action,dismissible:notif.message.hasOwnProperty('dismissible')?notif.message.dismissible:true,dataTestName:notif.dataTestName};if(notif.message.hasOwnProperty('autoDismiss')){reactNotification.autoDismiss=notif.message.autoDismiss;}this._notificationSystem.addNotification(reactNotification);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}else{this._notificationSystem.clearNotifications();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this._showNotifications(nextProps);}},{key:'render',value:function render(){var _this2=this;var notificationStyle={Containers:{DefaultStyle:{width:450}},NotificationItem:{DefaultStyle:{padding:'20px',fontSize:'18px',borderTop:'none',borderRadius:'2px',textAlign:'center',wordWrap:'break-word'},success:{backgroundColor:'var(--accentColor)',color:'white',stroke:'var(--accentColor)',fill:'white'},error:{backgroundColor:'#ff3860',color:'white',stroke:'#ff3860',strokeLinecap:'square',fill:'white'},warning:{backgroundColor:'#ffdd57',color:'#2b2b2b',stroke:'white',fill:'#cda300'},info:{backgroundColor:'#209cee',color:'white',stroke:'white',fill:'#0b598e'}},Dismiss:{DefaultStyle:{width:'25px',height:'25px'}},Action:{DefaultStyle:{borderRadius:'4px',padding:'10px 20px',fontSize:'12px'},success:{backgroundColor:'#0f5041'},error:{backgroundColor:'#d9534f'},warning:{backgroundColor:'#cda300'},info:{backgroundColor:'#0b598e'}},ActionWrapper:{DefaultStyle:{textAlign:'center'}}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__react_notification_system_NotificationSystem__["a" /* default */],{style:notificationStyle,ref:function ref(input){_this2.notificationSystem=input;}});}}]);return NotificationsDisplay;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);NotificationsDisplay.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* intlShape */].isRequired,notifications:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,onRemoveNotification:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* injectIntl */])(NotificationsDisplay));

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PropTypes=__webpack_require__(1);var React=__webpack_require__(0);var createReactClass=__webpack_require__(248);var merge=__webpack_require__(73);var NotificationContainer=__webpack_require__(1192);var Constants=__webpack_require__(249);var Styles=__webpack_require__(1195);var NotificationSystem=createReactClass({displayName:'NotificationSystem',uid:3400,_getStyles:{overrideStyle:{},overrideWidth:null,setOverrideStyle:function setOverrideStyle(style){this.overrideStyle=style;},wrapper:function wrapper(){if(!this.overrideStyle)return{};return merge({},Styles.Wrapper,this.overrideStyle.Wrapper);},container:function container(position){var override=this.overrideStyle.Containers||{};if(!this.overrideStyle)return{};this.overrideWidth=Styles.Containers.DefaultStyle.width;if(override.DefaultStyle&&override.DefaultStyle.width){this.overrideWidth=override.DefaultStyle.width;}if(override[position]&&override[position].width){this.overrideWidth=override[position].width;}return merge({},Styles.Containers.DefaultStyle,Styles.Containers[position],override.DefaultStyle,override[position]);},elements:{notification:'NotificationItem',title:'Title',messageWrapper:'MessageWrapper',dismiss:'Dismiss',action:'Action',actionWrapper:'ActionWrapper'},byElement:function byElement(element){var self=this;return function(level){var _element=self.elements[element];var override=self.overrideStyle[_element]||{};if(!self.overrideStyle)return{};return merge({},Styles[_element].DefaultStyle,Styles[_element][level],override.DefaultStyle,override[level]);};}},_didNotificationRemoved:function _didNotificationRemoved(uid){var notification;var notifications=this.state.notifications.filter(function(toCheck){if(toCheck.uid===uid){notification=toCheck;}return toCheck.uid!==uid;});if(notification&&notification.onRemove){notification.onRemove(notification);}this.setState({notifications:notifications});},getInitialState:function getInitialState(){return{notifications:[]};},propTypes:{style:PropTypes.oneOfType([PropTypes.bool,PropTypes.object]),noAnimation:PropTypes.bool,allowHTML:PropTypes.bool},getDefaultProps:function getDefaultProps(){return{style:{},noAnimation:false,allowHTML:false};},addNotification:function addNotification(notification){var _notification=merge({},Constants.notification,notification);var notifications=this.state.notifications;var i;if(!_notification.level){throw new Error('notification level is required.');}if(Object.keys(Constants.levels).indexOf(_notification.level)===-1){throw new Error("'"+_notification.level+"' is not a valid level.");}if(isNaN(_notification.autoDismiss)){throw new Error("'autoDismiss' must be a number.");}if(Object.keys(Constants.positions).indexOf(_notification.position)===-1){throw new Error("'"+_notification.position+"' is not a valid position.");}// Some preparations
_notification.position=_notification.position.toLowerCase();_notification.level=_notification.level.toLowerCase();_notification.autoDismiss=parseInt(_notification.autoDismiss,10);_notification.uid=_notification.uid||this.uid;_notification.ref='notification-'+_notification.uid;this.uid+=1;// do not add if the notification already exists based on supplied uid
for(i=0;i<notifications.length;i++){if(notifications[i].uid===_notification.uid){return false;}}notifications.push(_notification);if(typeof _notification.onAdd==='function'){notification.onAdd(_notification);}this.setState({notifications:notifications});return _notification;},removeNotification:function removeNotification(notification){var self=this;Object.keys(this.refs).forEach(function(container){if(container.indexOf('container')>-1){Object.keys(self.refs[container].refs).forEach(function(_notification){var uid=notification.uid?notification.uid:notification;if(_notification==='notification-'+uid){self.refs[container].refs[_notification]._hideNotification();}});}});},clearNotifications:function clearNotifications(){this.setState({notifications:[]});},componentDidMount:function componentDidMount(){this._getStyles.setOverrideStyle(this.props.style);},render:function render(){var self=this;var containers=null;var notifications=this.state.notifications;if(notifications.length){containers=Object.keys(Constants.positions).map(function(position){var _notifications=notifications.filter(function(notification){return position===notification.position;});if(_notifications.length){return React.createElement(NotificationContainer,{ref:'container-'+position,key:position,position:position,notifications:_notifications,getStyles:self._getStyles,onRemove:self._didNotificationRemoved,noAnimation:self.props.noAnimation,allowHTML:self.props.allowHTML});}else{return undefined;}});}return React.createElement('div',{className:'notifications-wrapper',style:this._getStyles.wrapper()},containers);}});/* harmony default export */ __webpack_exports__["a"] = (NotificationSystem);

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(73);

var emptyObject = __webpack_require__(1190);
var _invariant = __webpack_require__(1191);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var PropTypes=__webpack_require__(1);var React=__webpack_require__(0);var createReactClass=__webpack_require__(248);var NotificationItem=__webpack_require__(1193);var Constants=__webpack_require__(249);var NotificationContainer=createReactClass({displayName:'NotificationContainer',propTypes:{position:PropTypes.string.isRequired,notifications:PropTypes.array.isRequired,getStyles:PropTypes.object},_style:{},componentWillMount:function componentWillMount(){// Fix position if width is overrided
this._style=this.props.getStyles.container(this.props.position);if(this.props.getStyles.overrideWidth&&(this.props.position===Constants.positions.tc||this.props.position===Constants.positions.bc)){this._style.marginLeft=-(this.props.getStyles.overrideWidth/2);}},render:function render(){var self=this;var notifications;if([Constants.positions.bl,Constants.positions.br,Constants.positions.bc].indexOf(this.props.position)>-1){this.props.notifications.reverse();}notifications=this.props.notifications.map(function(notification){return React.createElement(NotificationItem,{ref:'notification-'+notification.uid,key:notification.uid,notification:notification,getStyles:self.props.getStyles,onRemove:self.props.onRemove,noAnimation:self.props.noAnimation,allowHTML:self.props.allowHTML,dataTestName:notification.dataTestName});});return React.createElement('div',{className:'notifications-'+this.props.position,style:this._style},notifications);}});module.exports=NotificationContainer;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PropTypes=__webpack_require__(1);var React=__webpack_require__(0);var createReactClass=__webpack_require__(248);var ReactDOM=__webpack_require__(46);var Constants=__webpack_require__(249);var Helpers=__webpack_require__(1194);var merge=__webpack_require__(73);/* From Modernizr */var whichTransitionEvent=function whichTransitionEvent(){var t;var el=document.createElement('fakeelement');var transitions={transition:'transitionend',OTransition:'oTransitionEnd',MozTransition:'transitionend',WebkitTransition:'webkitTransitionEnd'};for(t in transitions){if(el.style[t]!==undefined){return transitions[t];}}};var NotificationItem=createReactClass({displayName:'NotificationItem',propTypes:{notification:PropTypes.object,getStyles:PropTypes.object,onRemove:PropTypes.func,allowHTML:PropTypes.bool,noAnimation:PropTypes.bool,dataTestName:PropTypes.string},getDefaultProps:function getDefaultProps(){return{noAnimation:false,onRemove:function onRemove(){},allowHTML:false};},getInitialState:function getInitialState(){return{visible:false,removed:false};},componentWillMount:function componentWillMount(){var getStyles=this.props.getStyles;var level=this.props.notification.level;this._noAnimation=this.props.noAnimation;this._styles={notification:getStyles.byElement('notification')(level),title:getStyles.byElement('title')(level),dismiss:getStyles.byElement('dismiss')(level),messageWrapper:getStyles.byElement('messageWrapper')(level),actionWrapper:getStyles.byElement('actionWrapper')(level),action:getStyles.byElement('action')(level)};if(!this.props.notification.dismissible){this._styles.notification.cursor='default';}},_styles:{},_notificationTimer:null,_height:0,_noAnimation:null,_isMounted:false,_removeCount:0,_getCssPropertyByPosition:function _getCssPropertyByPosition(){var position=this.props.notification.position;var css={};switch(position){case Constants.positions.tl:case Constants.positions.bl:css={property:'left',value:-200};break;case Constants.positions.tr:case Constants.positions.br:css={property:'right',value:-200};break;case Constants.positions.tc:css={property:'top',value:-100};break;case Constants.positions.bc:css={property:'bottom',value:-100};break;default:}return css;},_defaultAction:function _defaultAction(event){var notification=this.props.notification;event.preventDefault();this._hideNotification();if(typeof notification.action.callback==='function'){notification.action.callback();}},_hideNotification:function _hideNotification(){if(this._notificationTimer){this._notificationTimer.clear();}if(this._isMounted){this.setState({visible:false,removed:true});}if(this._noAnimation){this._removeNotification();}},_removeNotification:function _removeNotification(){this.props.onRemove(this.props.notification.uid);},_dismiss:function _dismiss(){if(!this.props.notification.dismissible){return;}this._hideNotification();},_showNotification:function _showNotification(){var self=this;setTimeout(function(){if(self._isMounted){self.setState({visible:true});}},50);},_onTransitionEnd:function _onTransitionEnd(){if(this._removeCount>0)return;if(this.state.removed){this._removeCount++;this._removeNotification();}},componentDidMount:function componentDidMount(){var self=this;var transitionEvent=whichTransitionEvent();var notification=this.props.notification;var element=ReactDOM.findDOMNode(this);this._height=element.offsetHeight;this._isMounted=true;// Watch for transition end
if(!this._noAnimation){if(transitionEvent){element.addEventListener(transitionEvent,this._onTransitionEnd);}else{this._noAnimation=true;}}if(notification.autoDismiss){this._notificationTimer=new Helpers.Timer(function(){self._hideNotification();},notification.autoDismiss*1000);}this._showNotification();},_handleMouseEnter:function _handleMouseEnter(){var notification=this.props.notification;if(notification.autoDismiss){this._notificationTimer.pause();}},_handleMouseLeave:function _handleMouseLeave(){var notification=this.props.notification;if(notification.autoDismiss){this._notificationTimer.resume();}},componentWillUnmount:function componentWillUnmount(){var element=ReactDOM.findDOMNode(this);var transitionEvent=whichTransitionEvent();element.removeEventListener(transitionEvent,this._onTransitionEnd);this._isMounted=false;},_allowHTML:function _allowHTML(string){return{__html:string};},render:function render(){var notification=this.props.notification;var className='notification notification-'+notification.level;var notificationStyle=merge({},this._styles.notification);var cssByPos=this._getCssPropertyByPosition();var dismiss=null;var actionButton=null;var title=null;var message=null;if(this.state.visible){className=className+' notification-visible';}else{className=className+' notification-hidden';}if(!notification.dismissible){className=className+' notification-not-dismissible';}if(this.props.getStyles.overrideStyle){if(!this.state.visible&&!this.state.removed){notificationStyle[cssByPos.property]=cssByPos.value;}if(this.state.visible&&!this.state.removed){notificationStyle.height=this._height;notificationStyle[cssByPos.property]=0;}if(this.state.removed){notificationStyle.overlay='hidden';notificationStyle.height=0;notificationStyle.marginTop=0;notificationStyle.paddingTop=0;notificationStyle.paddingBottom=0;}notificationStyle.opacity=this.state.visible?this._styles.notification.isVisible.opacity:this._styles.notification.isHidden.opacity;}if(notification.title){title=React.createElement('h4',{className:'notification-title',style:this._styles.title},notification.title);}if(notification.message){if(this.props.allowHTML){message=React.createElement('div',{className:'notification-message',style:this._styles.messageWrapper,dangerouslySetInnerHTML:this._allowHTML(notification.message)});}else{message=React.createElement('div',{className:'notification-message',style:this._styles.messageWrapper},notification.message);}}if(notification.dismissible){dismiss=React.createElement('span',{className:'notification-dismiss',style:this._styles.dismiss},React.createElement(IconX,{size:Constants.iconSize}));}if(notification.action){actionButton=React.createElement('div',{className:'notification-action-wrapper',style:this._styles.actionWrapper},React.createElement('button',{className:'notification-action-button',onClick:this._defaultAction,style:this._styles.action},notification.action.label));}return React.createElement('div',{className:className,onClick:this._dismiss,onMouseEnter:this._handleMouseEnter,onMouseLeave:this._handleMouseLeave,style:notificationStyle,'data-test-name':this.props.dataTestName},title,message,dismiss,actionButton);}});var IconX=function(_React$Component){_inherits(IconX,_React$Component);function IconX(){_classCallCheck(this,IconX);return _possibleConstructorReturn(this,(IconX.__proto__||Object.getPrototypeOf(IconX)).apply(this,arguments));}_createClass(IconX,[{key:'render',value:function render(){var size=this.props.size;var leftMargin=size*0.33;var rightMargin=size-leftMargin;var topMargin=leftMargin;var bottomMargin=rightMargin;return React.createElement('svg',null,React.createElement('circle',{cx:size/2,cy:size/2,r:size/2,strokeWidth:0}),React.createElement('path',{strokeWidth:2,strokeLinecap:'square',d:'M'+leftMargin+','+topMargin+' L'+rightMargin+','+bottomMargin+' M'+rightMargin+','+topMargin+' L'+leftMargin+','+bottomMargin}));}}]);return IconX;}(React.Component);module.exports=NotificationItem;

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

var Helpers={Timer:function Timer(callback,delay){var timerId;var start;var remaining=delay;this.pause=function(){clearTimeout(timerId);remaining-=new Date()-start;};this.resume=function(){start=new Date();clearTimeout(timerId);timerId=setTimeout(callback,remaining);};this.clear=function(){clearTimeout(timerId);};this.resume();}};module.exports=Helpers;

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// Used for calculations
var defaultWidth=320;var defaultColors={success:{rgb:'94, 164, 0',hex:'#5ea400'},error:{rgb:'236, 61, 61',hex:'#ec3d3d'},warning:{rgb:'235, 173, 23',hex:'#ebad1a'},info:{rgb:'54, 156, 199',hex:'#369cc7'}};var defaultShadowOpacity='0.9';var STYLES={Wrapper:{},Containers:{DefaultStyle:{fontFamily:'inherit',position:'fixed',width:defaultWidth,padding:'0 10px 10px 10px',zIndex:9998,WebkitBoxSizing:'border-box',MozBoxSizing:'border-box',boxSizing:'border-box',height:'auto'},tl:{top:'0px',bottom:'auto',left:'0px',right:'auto'},tr:{top:'0px',bottom:'auto',left:'auto',right:'0px'},tc:{top:'0px',bottom:'auto',margin:'0 auto',left:'50%',marginLeft:-(defaultWidth/2)},bl:{top:'auto',bottom:'0px',left:'0px',right:'auto'},br:{top:'auto',bottom:'0px',left:'auto',right:'0px'},bc:{top:'auto',bottom:'0px',margin:'0 auto',left:'50%',marginLeft:-(defaultWidth/2)}},NotificationItem:{DefaultStyle:{position:'relative',width:'100%',cursor:'pointer',borderRadius:'2px',fontSize:'13px',margin:'10px 0 0',padding:'10px',display:'block',WebkitBoxSizing:'border-box',MozBoxSizing:'border-box',boxSizing:'border-box',opacity:0,transition:'0.3s ease-in-out',isHidden:{opacity:0},isVisible:{opacity:1}},success:{borderTop:'2px solid '+defaultColors.success.hex,backgroundColor:'#f0f5ea',color:'#4b583a',WebkitBoxShadow:'0 0 1px rgba('+defaultColors.success.rgb+','+defaultShadowOpacity+')',MozBoxShadow:'0 0 1px rgba('+defaultColors.success.rgb+','+defaultShadowOpacity+')',boxShadow:'0 0 1px rgba('+defaultColors.success.rgb+','+defaultShadowOpacity+')'},error:{borderTop:'2px solid '+defaultColors.error.hex,backgroundColor:'#f4e9e9',color:'#412f2f',WebkitBoxShadow:'0 0 1px rgba('+defaultColors.error.rgb+','+defaultShadowOpacity+')',MozBoxShadow:'0 0 1px rgba('+defaultColors.error.rgb+','+defaultShadowOpacity+')',boxShadow:'0 0 1px rgba('+defaultColors.error.rgb+','+defaultShadowOpacity+')'},warning:{borderTop:'2px solid '+defaultColors.warning.hex,backgroundColor:'#f9f6f0',color:'#5a5343',WebkitBoxShadow:'0 0 1px rgba('+defaultColors.warning.rgb+','+defaultShadowOpacity+')',MozBoxShadow:'0 0 1px rgba('+defaultColors.warning.rgb+','+defaultShadowOpacity+')',boxShadow:'0 0 1px rgba('+defaultColors.warning.rgb+','+defaultShadowOpacity+')'},info:{borderTop:'2px solid '+defaultColors.info.hex,backgroundColor:'#e8f0f4',color:'#41555d',WebkitBoxShadow:'0 0 1px rgba('+defaultColors.info.rgb+','+defaultShadowOpacity+')',MozBoxShadow:'0 0 1px rgba('+defaultColors.info.rgb+','+defaultShadowOpacity+')',boxShadow:'0 0 1px rgba('+defaultColors.info.rgb+','+defaultShadowOpacity+')'}},Title:{DefaultStyle:{fontSize:'14px',margin:'0 0 5px 0',padding:0,fontWeight:'bold'},success:{color:defaultColors.success.hex},error:{color:defaultColors.error.hex},warning:{color:defaultColors.warning.hex},info:{color:defaultColors.info.hex}},MessageWrapper:{DefaultStyle:{margin:0,padding:0}},Dismiss:{DefaultStyle:{fontFamily:'Arial',fontSize:'17px',position:'absolute',top:'4px',right:'5px',lineHeight:'15px',backgroundColor:'#dededf',color:'#ffffff',borderRadius:'50%',width:'14px',height:'14px',fontWeight:'bold',textAlign:'center'},success:{color:'#f0f5ea',backgroundColor:'#b0ca92'},error:{color:'#f4e9e9',backgroundColor:'#e4bebe'},warning:{color:'#f9f6f0',backgroundColor:'#e1cfac'},info:{color:'#e8f0f4',backgroundColor:'#a4becb'}},Action:{DefaultStyle:{background:'#ffffff',borderRadius:'2px',padding:'6px 20px',fontWeight:'bold',margin:'10px 0 0 0',border:0},success:{backgroundColor:defaultColors.success.hex,color:'#ffffff'},error:{backgroundColor:defaultColors.error.hex,color:'#ffffff'},warning:{backgroundColor:defaultColors.warning.hex,color:'#ffffff'},info:{backgroundColor:defaultColors.info.hex,color:'#ffffff'}},ActionWrapper:{DefaultStyle:{margin:0,padding:0}}};module.exports=STYLES;

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_view_DialogPanel_DialogPanel__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_commands_dialogPanelCommands__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_types__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_state_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_backupUtils__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_commands_adminPropertiesCommands__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portfolio_shared_util_logging__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BackupRestoreProgressDialog=function(_Component){_inherits(BackupRestoreProgressDialog,_Component);function BackupRestoreProgressDialog(){_classCallCheck(this,BackupRestoreProgressDialog);var _this=_possibleConstructorReturn(this,(BackupRestoreProgressDialog.__proto__||Object.getPrototypeOf(BackupRestoreProgressDialog)).call(this));_this.state={isCancelling:false};_this.handleCloseButton=_this.handleCloseButton.bind(_this);_this.isOkEnabled=_this.isOkEnabled.bind(_this);return _this;}_createClass(BackupRestoreProgressDialog,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.backupRestoreStatus!==this.props.backupRestoreStatus){if(Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["e" /* isBackupRestoreCancelled */])(this.props.backupRestoreStatus)){this.setState({isCancelling:false});}}}},{key:'getButtonText',value:function getButtonText(){var _props=this.props,backupRestoreStatus=_props.backupRestoreStatus,formatMessage=_props.intl.formatMessage;return Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["d" /* isBackupRestoreBusy */])(backupRestoreStatus)?formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].CANCEL):formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].OK);}},{key:'getDialogTitle',value:function getDialogTitle(){var _props2=this.props,backupRestoreStatus=_props2.backupRestoreStatus,formatMessage=_props2.intl.formatMessage;if(backupRestoreStatus){switch(backupRestoreStatus.currentOperationState){case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_PREFLIGHT:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_PREFLIGHT);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_SHUTTING_DOWN_SERVER:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_BACKING_UP_DATA:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_RESTARTING_SERVER:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_BACKING_UP);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_COMPLETE:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_BACKUP_SUCCESSFUL);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_FAILED:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_BACKUP_FAILED);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_SHUTTING_DOWN_SERVER:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTORE_DATA:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTARTING_SERVER:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_RESTORING);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_COMPLETE:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_RESTORE_SUCCESSFUL);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_FAILED:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_RESTORE_FAILED);default:return'Unknown Backup Restore Status: '+backupRestoreStatus.currentOperationState;}}}},{key:'getDetailString',value:function getDetailString(){var _props3=this.props,backupRestoreStatus=_props3.backupRestoreStatus,formatMessage=_props3.intl.formatMessage;if(backupRestoreStatus){switch(backupRestoreStatus.currentOperationState){case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_PREFLIGHT:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_PREFLIGHT);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_SHUTTING_DOWN_SERVER:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_SHUTTING_DOWN_SERVER:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_SHUTTING_DOWN);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_BACKING_UP_DATA:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_BACKING_UP_DATA);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTORE_DATA:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_RESTORING_DATA);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_RESTARTING_SERVER:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTARTING_SERVER:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_PROGRESS_RESTARTING);default:return undefined;}}}},{key:'getProgressValue',value:function getProgressValue(){var backupRestoreStatus=this.props.backupRestoreStatus;if(backupRestoreStatus){switch(backupRestoreStatus.currentOperationState){case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_PREFLIGHT:return 1;case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_SHUTTING_DOWN_SERVER:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_SHUTTING_DOWN_SERVER:return 2;case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_BACKING_UP_DATA:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTORE_DATA:return 3;case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].BACKUP_RESTARTING_SERVER:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["b" /* BACKUP_OPERATION_STATE */].RESTORE_RESTARTING_SERVER:return 4;default:return 0;}}}},{key:'getErrorDetail',value:function getErrorDetail(){var _props4=this.props,backupRestoreStatus=_props4.backupRestoreStatus,formatMessage=_props4.intl.formatMessage;if(backupRestoreStatus){switch(backupRestoreStatus.faultCode){case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["c" /* BACKUP_RESTORE_FAULT_CODE */].INTERNAL_ERROR:case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["c" /* BACKUP_RESTORE_FAULT_CODE */].LIFECYCLE_ERROR:return Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["c" /* isBackupOperation */])(backupRestoreStatus)?formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP):formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["c" /* BACKUP_RESTORE_FAULT_CODE */].BAD_ARCHIVE:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE);case __WEBPACK_IMPORTED_MODULE_7_util_AdminProperties__["c" /* BACKUP_RESTORE_FAULT_CODE */].INSUFFICIENT_SPACE:return formatMessage(__WEBPACK_IMPORTED_MODULE_6_util_localizedStrings__["a" /* default */].BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE,{requiredSpace:Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["a" /* bytesToString */])(backupRestoreStatus.spaceRequired),availableSpace:Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["a" /* bytesToString */])(backupRestoreStatus.spaceAvailable)});default:__WEBPACK_IMPORTED_MODULE_10_portfolio_shared_util_logging__["a" /* default */].error('Unknown Backup Restore Fault Code: '+(backupRestoreStatus.faultCode||'<undefined>'));}}}},{key:'renderProgress',value:function renderProgress(){var backupRestoreStatus=this.props.backupRestoreStatus;if(Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["d" /* isBackupRestoreBusy */])(backupRestoreStatus)){if(this.getProgressValue()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('progress',{className:'progress is-primary','data-test-name':'backup-restore-current-progress',value:this.getProgressValue(),max:'4',style:{width:'50%'}});}}else if(Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["g" /* isBackupRestoreSuccessful */])(backupRestoreStatus)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check fa-5x fa-fw has-text-primary'});}else if(Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["f" /* isBackupRestoreFailed */])(backupRestoreStatus)){return this.getErrorDetail();}}},{key:'handleCloseButton',value:function handleCloseButton(){var _props5=this.props,backupRestoreStatus=_props5.backupRestoreStatus,cancelBackup=_props5.cancelBackup,hideDialogPanel=_props5.hideDialogPanel;if(Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["d" /* isBackupRestoreBusy */])(backupRestoreStatus)){cancelBackup();this.setState({isCancelling:true});}else{this.setState({isCancelling:false});hideDialogPanel();}}},{key:'isOkEnabled',value:function isOkEnabled(){return!this.state.isCancelling&&!Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["h" /* isRestoring */])(this.props.backupRestoreStatus);}},{key:'render',value:function render(){var _props6=this.props,activePanelId=_props6.activePanelId,backupRestoreStatus=_props6.backupRestoreStatus,hideDialogPanel=_props6.hideDialogPanel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_portfolio_shared_view_DialogPanel_DialogPanel__["b" /* default */],{activePanelId:activePanelId,closeAfterSave:false,contentStyle:{width:600,height:375},customButtonText:this.getButtonText(),dataTestName:'backup-restore-progress-dialog',hideDialogPanel:hideDialogPanel,isOkEnabled:this.isOkEnabled,onSave:this.handleCloseButton,panelId:__WEBPACK_IMPORTED_MODULE_4_util_constants__["h" /* BACKUP_RESTORE_PROGRESS_PANEL_ID */],panelTitle:this.getDialogTitle(),showCancel:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',style:{paddingTop:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},Object(__WEBPACK_IMPORTED_MODULE_8_util_backupUtils__["d" /* isBackupRestoreBusy */])(backupRestoreStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle-o-notch fa-spin fa-3x fa-fw has-text-primary'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item','data-test-name':'backup-restore-detail-string'},this.getDetailString())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},this.renderProgress()))));}}]);return BackupRestoreProgressDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* injectIntl */])(BackupRestoreProgressDialog));

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = initStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middleware_thunkMiddleware__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middleware_clientMiddleware__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middleware_resourceMiddleware__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_ApiClient__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_browserUtils__ = __webpack_require__(98);
// NOTE: uncomment block below if you want logging during dev
/* eslint-disable no-unused-vars */var addLoggingToDispatch=function addLoggingToDispatch(store){/* eslint-enable no-unused-vars *//* eslint-disable no-console */var rawDispatch=store.dispatch;if(!console.group){return rawDispatch;}return function(action){console.group(action.type);console.log('%c prev state','color: gray',store.getState());console.log('%c action','color: blue',action);var returnValue=rawDispatch(action);console.log('%c next state','color: green',store.getState());console.groupEnd(action.type);return returnValue;};/* eslint-enable no-console */};function initStore(initialState,cookie){var resources={PERSISTENCE_RESOURCE:function PERSISTENCE_RESOURCE(){},ADMIN_PROPERTIES_INTERVAL_RESOURCE:function ADMIN_PROPERTIES_INTERVAL_RESOURCE(){}};var createApiClient=function createApiClient(getState){return new __WEBPACK_IMPORTED_MODULE_5_util_ApiClient__["a" /* default */](getState,cookie);};var middleware=[__WEBPACK_IMPORTED_MODULE_1__middleware_thunkMiddleware__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_2__middleware_clientMiddleware__["a" /* default */])(createApiClient),Object(__WEBPACK_IMPORTED_MODULE_3__middleware_resourceMiddleware__["a" /* default */])(resources)];var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_4__reducers__["default"],initialState,composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,middleware)));// if (process.env.NODE_ENV !== 'production') {
//   store.dispatch = addLoggingToDispatch(store);
// }
if(Object(__WEBPACK_IMPORTED_MODULE_6_util_browserUtils__["b" /* isDevEnv */])()&&module.hot){// hot module replacement for reducers
module.hot.accept('../reducers',function(){var nextRootReducer=__webpack_require__(435);store.replaceReducer(nextRootReducer);});}return Object.assign({},store);}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(75)(module)))

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = thunkMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_browserUtils__ = __webpack_require__(98);
function thunkMiddleware(_ref){var dispatch=_ref.dispatch,getState=_ref.getState;return function(next){return function(action){if(typeof action==='function'){if(Object(__WEBPACK_IMPORTED_MODULE_0_util_browserUtils__["b" /* isDevEnv */])()){var name=action.name||'Anonymous';dispatch({type:'admin/COMMAND/'+name,_name:name});}return action(dispatch,getState);}return next(action);};};}

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_logging__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function clientMiddleware(createClient){return function(_ref){var dispatch=_ref.dispatch,getState=_ref.getState;var client=createClient(getState);return function(next){return function(action){var promise=action.promise,types=action.types,rest=_objectWithoutProperties(action,['promise','types']);if(!promise){return next(action);}rest._origPayload=rest.payload;var _types=_slicedToArray(types,4),REQUEST=_types[0],SUCCESS=_types[1],FAILURE=_types[2],ALWAYS=_types[3];next(Object.assign({},rest,{type:REQUEST}));return promise(client,getState).then(function(result){var succ=dispatch(Object.assign({},rest,{payload:result,type:SUCCESS}));if(ALWAYS){dispatch(Object.assign({},rest,{payload:result,type:ALWAYS}));}return succ;},function(error){dispatch(Object.assign({},rest,{error:error,type:FAILURE}));__WEBPACK_IMPORTED_MODULE_0_portfolio_shared_util_logging__["a" /* default */].error(error?error.message:error);if(ALWAYS){dispatch(Object.assign({},rest,{error:error,type:ALWAYS}));}return Promise.reject(error);});};};};}

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createResourceMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function createResourceMiddleware(){var _this=this;var resources=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return function(_ref){var dispatch=_ref.dispatch,getState=_ref.getState;return function(next){return function(action){var getResource=resources[action.resource];if(getResource&&typeof action.payload==='function'){var result=action.payload(dispatch,getState,getResource());// Pass through a simple action, useful for state tracking
dispatch({type:action.type});return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.t0=resolve;_context.next=4;return result;case 4:_context.t1=_context.sent;(0,_context.t0)(_context.t1);_context.next=11;break;case 8:_context.prev=8;_context.t2=_context['catch'](0);reject(_context.t2);case 11:case'end':return _context.stop();}}},_callee,_this,[[0,8]]);}));return function(_x2,_x3){return _ref2.apply(this,arguments);};}());}else if(action.resource){// NOTE: do we need payload here?
var payload=action.payload,newAction=_objectWithoutProperties(action,['payload']);// eslint-disable-line no-unused-vars
newAction.meta='Resource not available';return next(newAction);}return next(action);};};};}

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* unused harmony export actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_constants__ = __webpack_require__(4);
var initialState={rtiEnabled:false};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["c" /* RTI_STATUS_SUCCESS */]:return Object.assign({},state,{rtiEnabled:action.payload.isEnabled});default:return state;}}function rtiToggle(session,value){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["d" /* RTI_TOGGLE */],__WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["f" /* RTI_TOGGLE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["e" /* RTI_TOGGLE_FAIL */]],promise:function promise(client,getState){return client.post(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/rti/enabled/'+value.toString(),{params:{session:session}});}};}function getRTI(session){return{types:[__WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["a" /* RTI_STATUS */],__WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["c" /* RTI_STATUS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_0_state_types_rtiTypes__["b" /* RTI_STATUS_FAIL */]],promise:function promise(client,getState){return client.get(__WEBPACK_IMPORTED_MODULE_1_util_constants__["f" /* API */]+'/rti/enabled',{params:{session:session}});}};}var actions={getRTI:getRTI,rtiToggle:rtiToggle};

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RTI_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RTI_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RTI_STATUS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RTI_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RTI_TOGGLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RTI_TOGGLE_FAIL; });
var RTI_STATUS='admin/rti/RTI_STATUS';var RTI_STATUS_FAIL='admin/rti/RTI_STATUS_FAIL';var RTI_STATUS_SUCCESS='admin/rti/RTI_STATUS_SUCCESS';var RTI_TOGGLE='admin/rti/RTI_TOGGLE';var RTI_TOGGLE_FAIL='admin/rti/RTI_TOGGLE_FAIL';var RTI_TOGGLE_SUCCESS='admin/rti/RTI_TOGGLE_SUCCESS';

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_PortfolioError__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _getQueryParamString(params){return __WEBPACK_IMPORTED_MODULE_1_url___default.a.format({query:params});}function _createRequest(path,params,properties){try{return new Request(path+_getQueryParamString(params),properties);}catch(e){__WEBPACK_IMPORTED_MODULE_4_portfolio_shared_util_logging__["a" /* default */].error('error creating request',path,params,properties);throw e;}}// Underscore naming due to some weird Babel bug
var _ApiClient=function _ApiClient(getState,cookie){var _this=this;_classCallCheck(this,_ApiClient);['get','post','put','patch','delete'].forEach(function(method){_this[method]=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(path){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var data,params,formData,serverAddress,adjustedPath,resolvedPath,bodyData,headers,_tempFormData,requestProperties,req,error,response,result,json,context;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=query.data;params=query.params;formData=query.formData;// prepend the user-provided serverAddress path to the API request
// e.g. /catalog/assets => http://server:8090/catalog/assets
serverAddress=getState().auth.serverAddress;serverAddress=serverAddress?serverAddress.toLowerCase():'';adjustedPath=path[0]!=='/'?'/'+path:path;resolvedPath=serverAddress+adjustedPath;if(resolvedPath){_context.next=9;break;}throw new Error('API path not available. Perhaps the user did not supply?');case 9:bodyData=void 0;// must be undefined or edge will throw exceptions for GET and HEAD requests.
headers=new Headers({});if(formData){_tempFormData=new FormData();Object.entries(formData).forEach(function(_ref2){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],value=_ref3[1];return _tempFormData.append(key,value);});bodyData=_tempFormData;}else{// The reason for this else statement is that we need this content-type
// NOT to be set when we have FormData attached, so that it generates
// the correct multipart boundry header via fetch. All other portfolio
// API calls require the json content type to be present.
headers=new Headers({'Content-type':'application/json'});}if(data){bodyData=JSON.stringify(data);}requestProperties={method:method,headers:headers,mode:'same-origin',body:bodyData};req=_createRequest(resolvedPath,params,requestProperties);error=void 0;_context.next=18;return fetch(req).catch(function(e){error=new __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_PortfolioError__["a" /* default */]('network error',__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["e" /* FC_SERVER_UNREACHABLE */],{method:req.method,url:resolvedPath});});case 18:response=_context.sent;if(!error){_context.next=21;break;}throw error;case 21:result=null;_context.prev=22;_context.next=25;return response.json();case 25:result=_context.sent;_context.next=30;break;case 28:_context.prev=28;_context.t0=_context['catch'](22);case 30:if(response.ok){_context.next=34;break;}json=Object.assign({faultCode:result?result.faultCode||__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["f" /* FC_UNEXPECTED_ERROR */]:__WEBPACK_IMPORTED_MODULE_3_portfolio_shared_util_faultCode__["f" /* FC_UNEXPECTED_ERROR */]},result);context={method:req.method,httpStatus:response.status,url:response.url};throw new __WEBPACK_IMPORTED_MODULE_2_portfolio_shared_util_PortfolioError__["a" /* default */](json.message,json.faultCode,context);case 34:return _context.abrupt('return',result);case 35:case'end':return _context.stop();}}},_callee,_this,[[22,28]]);}));return function(_x2){return _ref.apply(this,arguments);};}();});};/* harmony default export */ __webpack_exports__["a"] = (_ApiClient);

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__(1205);

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(1206);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module), __webpack_require__(32)))

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1207);
var parse = __webpack_require__(1235);
var formats = __webpack_require__(252);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(436);
var utils = __webpack_require__(445);
var formats = __webpack_require__(252);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(164);

var $TypeError = __webpack_require__(90);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(1223);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(1227);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(440);
var originalGetProto = __webpack_require__(441);

var getDunderProto = __webpack_require__(1229);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(442);
var gOPD = __webpack_require__(439);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(165);

var $apply = __webpack_require__(443);
var $call = __webpack_require__(251);
var $reflectApply = __webpack_require__(1232);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(165);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(250);
var callBound = __webpack_require__(444);
var inspect = __webpack_require__(164);
var getSideChannelMap = __webpack_require__(437);

var $TypeError = __webpack_require__(90);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(445);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    var keys = [];

    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = parent;
    }

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;

        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = segment[1];
    }

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }

    return keys;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c800f3a6.js